//2nd map

import { useEffect } from 'react'

export default function Map() {
  useEffect(() => {
    window.PLOTLYENV = window.PLOTLYENV || {}
    if (document.getElementById('ddb7bfd3-dc2d-4842-be76-1982c0703c4d')) {
      window.Plotly.newPlot(
        'ddb7bfd3-dc2d-4842-be76-1982c0703c4d',
        [
          {
            coloraxis: 'coloraxis',
            customdata: [
              [
                'Afghanistan',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Balkh solar farm',
                'Unknown',
                'Da Afghanistan Breshna Sherkat (DABS)',
              ],
              [
                'Afghanistan',
                25,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Herat',
                'Herat (DABS) solar farm',
                'Unknown',
                'Da Afghanistan Breshna Sherkat (DABS)',
              ],
              [
                'Afghanistan',
                50,
                'Asia',
                'Unavailable',
                'Guzara',
                'Guzara',
                'Herat (Guzara) solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Afghanistan',
                40,
                'Asia',
                'Unavailable',
                'Hishar-E-Shahi Industrial Park',
                'Unavailable',
                'Hisar-E-Shahi Industrial Park solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Afghanistan',
                30,
                'Asia',
                'Unavailable',
                'Daman',
                'Unavailable',
                'Kandahar solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Afghanistan',
                50,
                'Asia',
                'Unavailable',
                'Pul-e Khumri',
                'Unavailable',
                'Mazar solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Afghanistan',
                20,
                'Asia',
                'Unavailable',
                'Naghlu Dam Resevoir',
                'Kabul Surobi',
                'Naghlu solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Afghanistan',
                3000,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shahristan',
                'Dab Pal 4 solar farm',
                'Unknown',
                'Da Afghanistan Breshna Sherkat (DABS); Pal 4 Energie Solaire',
              ],
              [
                'Albania',
                50,
                'Europe',
                'Unavailable',
                'Fier Municipality',
                'Fier County',
                'SVP Blue 2 solar farm',
                'SVP Blue 2',
                'Blessed Investment; Matrix Konstruksion',
              ],
              [
                'Albania',
                100,
                'Europe',
                'Spitall\u00eb',
                'Durr\u00ebs Municipality',
                'Durr\u00ebs County',
                'Spitall\u00eb solar farm',
                'Voltalia',
                'Voltalia',
              ],
              [
                'Albania',
                50,
                'Europe',
                'Libofsh\u00eb',
                'Fier Municipality',
                'Fier County',
                'Libofsh\u00eb solar farm',
                'Unknown',
                'Info-Telecom',
              ],
              [
                'Albania',
                50,
                'Europe',
                'Unavailable',
                'Fier Municipality',
                'Fier County',
                'SVP Blue 1 solar farm',
                'SVP Blue 1',
                'Blessed Investment; Matrix Konstruksion',
              ],
              [
                'Albania',
                150,
                'Europe',
                'Darzez\u00eb e Re',
                'Fier Municipality',
                'Fier County',
                'Darzez\u00eb E Re solar farm',
                'Unknown',
                'AGA-SOLAR',
              ],
              [
                'Albania',
                50,
                'Europe',
                'Akerni',
                'Vlor\u00eb Municipality',
                'Vlor\u00eb County',
                'Akerni solar farm',
                'Unknown',
                'India Power Corporation; Mining Resources FZE; Midami Limited',
              ],
              [
                'Albania',
                50,
                'Europe',
                'Akerni',
                'Vlor\u00eb Municipality',
                'Vlor\u00eb County',
                'Akerni solar farm',
                'Unknown',
                'India Power Corporation; Mining Resources FZE; Midami Limited',
              ],
              [
                'Albania',
                140,
                'Europe',
                'Fier County',
                'Fier County',
                'Unavailable',
                'Karavasta solar farm',
                'Voltalia',
                'Voltalia',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                11,
                'Africa',
                'Tindouf',
                'Tindouf',
                'Tindouf',
                'Tindouf Solar Hybrid Plant',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                12,
                'Africa',
                'Telagh',
                'Telagh District',
                'Unavailable',
                'Telagh solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Sonelgaz',
              ],
              [
                'Algeria',
                13,
                'Africa',
                'Tamanrasset',
                'de Tamanrasset District',
                'Unavailable',
                'Tamanrasset solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                11,
                'Africa',
                'Talmine',
                'Charouine District',
                'Sahara central',
                'Talmine Solar Hybrid Plant',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                4000,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Tafouk1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Souk Ahras',
                'Souk Ahras District',
                'Hauts plateaux east',
                'Souk Ahras solar farm',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                50,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                50,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Adrar',
                'Adrar District',
                'Unavailable',
                'Adrar Solar Plant',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                23,
                'Africa',
                'El Abiodh Sidi Cheikh',
                'El Abiodh Sidi Cheikh District',
                'Unavailable',
                'El-Abiodh solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                40,
                'Africa',
                'Laghouat',
                'A\u00efn Madhi District',
                'Unavailable',
                'El Kheneg solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM); China Hydropower Engineering Consulting Group; Sinohydro and Yingli Green Energy Holding',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Laghouat',
                'A\u00efn Madhi District',
                'Unavailable',
                'El Kheneg solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM); China Hydropower Engineering Consulting Group; Sinohydro and Yingli Green Energy Holding',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Chelghoum La\u00efd',
                'Chelghoum Laid District',
                'Unavailable',
                "Chelghoum El Aid -M'Sila-Solar Plant",
                'Unknown',
                'Unknown',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Hauts plateaux east',
                'Borg Bouarreridj solar farm',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                12,
                'Africa',
                'Bordj Badji Mokhtar',
                'Bordj Badji Mokhtar',
                'Bordj Badji Mokhtar',
                'Bordj Badji Mokhtar Solar Hybrid Plant',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                10,
                'Africa',
                'Bir Rebaa North',
                'El Borma',
                'Ouargla',
                'Bir Rebaa Solar PV Plant',
                'Eni; Sonatrach',
                'Eni [50%]; Sonatrach',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Unavailable',
                'Batna district',
                'Hauts plateaux east',
                'Batna solar farm',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                10,
                'Africa',
                'Hassi Berkine basin',
                'Hassi Messaoud District',
                'Unavailable',
                'Hassi Berkine Solar Plant',
                'Sonatrach',
                'Sonatrach',
              ],
              [
                'Algeria',
                53,
                'Africa',
                'Adrar',
                'Adrar District',
                'Unavailable',
                'Algerie Sud-Ouest solar farm',
                'Unknown',
                'Yingli China; Sinohydro; Hydrochina',
              ],
              [
                'Algeria',
                30,
                'Africa',
                'Ain Sekhouna',
                'El Hessasna District',
                'Unavailable',
                'Ain Skhouna Solar',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Ain El Mehl',
                'A\u00efn El Melh District',
                'Unavailable',
                'Ain El Mehl Solar',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Ain El Ibel',
                'A\u00efn El Ibel District',
                'Unavailable',
                'Ain El Ibel Solar',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Ain Azel',
                'Ain Arnat',
                'Unavailable',
                'Ain Azel solar farm',
                'Unknown',
                'Sonelgaz',
              ],
              [
                'Algeria',
                33,
                'Africa',
                'Ain El Ibel',
                'A\u00efn El Ibel District',
                'Unavailable',
                'Ain El Ibel Solar',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Unavailable',
                'Setif',
                'Hauts plateaux east',
                'Setif solar farm',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                100,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                50,
                'Africa',
                'Unavailable',
                "d'In Salah District",
                'Unavailable',
                'Solar 1000',
                'Shaems',
                'Shaems',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Na\u00e2ma',
                'Na\u00e2ma District',
                'Hauts plateaux west',
                'Sedrate Leghzal Solar',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Sonelgaz',
              ],
              [
                'Algeria',
                20,
                'Africa',
                'Ras El Oued',
                "d'In Salah District",
                'Bordj Bou Arreridj',
                'Ras El Oued solar farm',
                'y Sino-Hydro',
                'Unknown',
              ],
              [
                'Algeria',
                30,
                'Africa',
                'El Hadjira',
                'El Hadjira',
                'Hauts plateaux central',
                'HPC Ouargla solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Sonelgaz',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Unavailable',
                'Chelghoum Laid District',
                'Hauts plateaux east',
                'Mila solar farm',
                'Unknown',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Algeria',
                15,
                'Africa',
                'Oued El Kebrit',
                'Oum El Adhaim District',
                'Unavailable',
                'Oued El Kebrit solar farm',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
                'Shariket Kahraba wa Taket Moutadjadida (SKTM)',
              ],
              [
                'Angola',
                27,
                'Africa',
                'Saurimo',
                'Unavailable',
                'Unavailable',
                'Saurimo Solar',
                'Unknown',
                'Sun Africa',
              ],
              [
                'Angola',
                25,
                'Africa',
                'Caraculo',
                'Unavailable',
                'Unavailable',
                'Solenova Namibe solar farm',
                'Unknown',
                'Eni; Solenova',
              ],
              [
                'Angola',
                189,
                'Africa',
                'Bi\u00f3pio',
                'Unavailable',
                'Unavailable',
                'Bi\u00f3pio solar farm',
                'Unknown',
                'Sun Africa',
              ],
              [
                'Angola',
                35,
                'Africa',
                'Lubango',
                'Unavailable',
                'Unavailable',
                'Lubango Solar',
                'Total Eren; Greentech',
                'Total Eren [75%]; Greentech [25%]',
              ],
              [
                'Angola',
                27,
                'Africa',
                'Luena',
                'Unavailable',
                'Unavailable',
                'Luena solar farm',
                'Unknown',
                'Sun Africa',
              ],
              [
                'Angola',
                35,
                'Africa',
                'Lubango',
                'Unavailable',
                'Unavailable',
                'Quilemba solar farm',
                'Unknown',
                'Sonangol [30%]; Total Eren [51%]; Greentech [19%]',
              ],
              [
                'Angola',
                25,
                'Africa',
                'Caraculo',
                'Unavailable',
                'Unavailable',
                'Solenova Namibe solar farm',
                'Unknown',
                'Eni; Solenova',
              ],
              [
                'Angola',
                97,
                'Africa',
                'Benguela',
                'Unavailable',
                'Unavailable',
                'Benguela solar farm',
                'Unknown',
                'Sun Africa',
              ],
              [
                'Argentina',
                105,
                'South America',
                'Unavailable',
                'Cauchari',
                'Susques Department',
                'Cauchari Solar Power Complex',
                'Jujuy Energ\u00eda y Miner\u00eda Sociedad Estatal (JEMSE)',
                'Jujuy Energia Mineria Soc Est',
              ],
              [
                'Argentina',
                208,
                'South America',
                'Salta',
                'Unavailable',
                'Los Andes',
                'Altiplano 200 Solar Power Plant',
                'Unknown',
                'Neoen',
              ],
              [
                'Argentina',
                21,
                'South America',
                'Unavailable',
                'Anchoris',
                'Departamento Tupungato',
                'Anchoris solar farm',
                'La Empresa Mendocina de Energ\u00eda (EMESA)',
                'La Empresa Mendocina de Energ\u00eda (EMESA)',
              ],
              [
                'Argentina',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Chos Malal District',
                'Antu Newen solar farm',
                'Ente Provincial de Energia del Neuquen',
                'Ente Provincial de Energia del Neuquen',
              ],
              [
                'Argentina',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cafayate',
                'Cafayate Solar Plant',
                'Canadian Solar',
                'Canadian Solar',
              ],
              [
                'Argentina',
                30,
                'South America',
                'San Luis',
                'Unavailable',
                'Juan Mart\u00edn de Pueyrred\u00f3n',
                'Caldenes Del Oeste solar farm',
                'Total Eren Sa',
                'Total Eren Sa',
              ],
              [
                'Argentina',
                105,
                'South America',
                'Unavailable',
                'Cauchari',
                'Departamento Susques',
                'Cauchari Solar Power Complex',
                'Jujuy Energ\u00eda y Miner\u00eda Sociedad Estatal (JEMSE)',
                'Jujuy Energia Mineria Soc Est',
              ],
              [
                'Argentina',
                105,
                'South America',
                'Unavailable',
                'Cauchari',
                'Susques Department',
                'Cauchari Solar Power Complex',
                'Jujuy Energ\u00eda y Miner\u00eda Sociedad Estatal (JEMSE)',
                'Jujuy Energia Mineria Soc Est',
              ],
              [
                'Argentina',
                200,
                'South America',
                'Unavailable',
                'Cauchari',
                'Susques Department',
                'Cauchari Solar Power Complex',
                'Jujuy Energ\u00eda y Miner\u00eda Sociedad Estatal (JEMSE)',
                'Jujuy Energia Mineria Soc Est',
              ],
              [
                'Argentina',
                22,
                'South America',
                'Unavailable',
                'Luj\u00e1n de Cuyo',
                'Unavailable',
                'Luj\u00e1n De Cuyo solar farm',
                'La Empresa Mendocina de Energ\u00eda (EMESA)',
                'La Empresa Mendocina de Energ\u00eda (EMESA)',
              ],
              [
                'Argentina',
                80,
                'South America',
                'Unavailable',
                'Unavailable',
                'Iglesia',
                'Gua\u00f1izuil solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Argentina',
                117,
                'South America',
                'Unavailable',
                'Unavailable',
                'Iglesia',
                'Gua\u00f1izuil Solar Power Plant',
                'Scatec',
                'Scatec; Equinor',
              ],
              [
                'Argentina',
                42,
                'South America',
                'Unavailable',
                'Unavailable',
                'Departamento Chilecito',
                'Nonogasta Solar Park',
                '360Energy Sa',
                '360Energy Sa',
              ],
              [
                'Argentina',
                27,
                'South America',
                'Unavailable',
                'Unavailable',
                'Departamento Pom\u00e1n',
                'Saujil Photovoltaic Solar Park',
                '360Energy Sa',
                '360Energy Sa',
              ],
              [
                'Argentina',
                25,
                'South America',
                'Unavailable',
                'Unavailable',
                'Ull\u00fam',
                'Ullum Photovoltaic Solar Park',
                'Genneia Sa',
                'Genneia Sa',
              ],
              [
                'Argentina',
                25,
                'South America',
                'Unavailable',
                'Unavailable',
                'Ull\u00fam',
                'Ullum Photovoltaic Solar Park',
                'Genneia Sa',
                'Genneia Sa',
              ],
              [
                'Argentina',
                32,
                'South America',
                'Unavailable',
                'Unavailable',
                'Ull\u00fam',
                'Ullum Photovoltaic Solar Park',
                'Genneia Sa',
                'Genneia Sa',
              ],
              [
                'Argentina',
                100,
                'South America',
                'Unavailable',
                'General Alvear',
                'General Alvear',
                'General Alvear Solar',
                'Gigawatt Global',
                'Gigawatt Global',
              ],
              [
                'Armenia',
                55,
                'Eurasia',
                'Mets Masrik',
                'Unavailable',
                'Vardenis region',
                'Masrik solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures (FRV)',
              ],
              [
                'Armenia',
                200,
                'Eurasia',
                'Talin',
                'Unavailable',
                'Talin region',
                'Ayg-1 solar farm',
                'Masdar',
                'Masdar [75%]; Armenian National Interest Fund CJSC (ANIF) [15%]',
              ],
              [
                'Australia',
                107,
                'Oceania',
                'Port Augusta',
                'Port Augusta City Council',
                'Unavailable',
                'Port Augusta Renewable Energy Park solar farm',
                'Unknown',
                'Iberdrola',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Parkes Solar',
                'ENcome',
                'Neoen; Australian Renewable Energy Agency (ARENA)',
              ],
              [
                'Australia',
                142,
                'Oceania',
                'The Rural City of Murray Bridge',
                'The Rural City of Murray Bridge',
                'Unavailable',
                'Pallamana Solar',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Oakey solar farm',
                'Unknown',
                'Foresight Group',
              ],
              [
                'Australia',
                110,
                'Oceania',
                'Gunnedah',
                'Unavailable',
                'Unavailable',
                'Orange Grove solar farm (Australia)',
                'Unknown',
                'Overland Sun Farming',
              ],
              [
                'Australia',
                20000,
                'Oceania',
                'Elliott',
                'Barkly Region',
                'Barkley',
                'Powell Creek solar farm',
                'Unknown',
                'Sun Cable; Andrew Forrest; Mike Cannon-Brookes',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Oakey solar farm',
                'Unknown',
                'ARENA; Clean Energy Finance Corp. (CEFC); Foresight Group',
              ],
              [
                'Australia',
                102,
                'Oceania',
                'Bogan Shire Council',
                'Bogan Shire Council',
                'Unavailable',
                'Nyngan Solar Plant',
                'First Solar',
                'AGL',
              ],
              [
                'Australia',
                74,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Numurkah Solar',
                'Downer',
                'Neoen',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Paget solar farm',
                'Unknown',
                'BOMA Group',
              ],
              [
                'Australia',
                240,
                'Oceania',
                'Unavailable',
                'Mitiamo',
                'Loddon Shire',
                'Prairie solar farm',
                'Pacific Hydro',
                'Unknown',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Yoogali',
                'Unavailable',
                'Unavailable',
                'Riverina Solar',
                'Unknown',
                'Suntech Power',
              ],
              [
                'Australia',
                300,
                'Oceania',
                'Port of Gladstone',
                'Raglan',
                'Unavailable',
                'Raglan Solar Park',
                'Unknown',
                'Eco Energy World',
              ],
              [
                'Australia',
                71,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Red Cliffs solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                400,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Richmond Valley solar farm',
                'Unknown',
                'Epuron',
              ],
              [
                'Australia',
                330,
                'Oceania',
                'Unavailable',
                'Mid Murray Council',
                'Unavailable',
                'Riverland Solar',
                'Unknown',
                'Lyon Infrastructure; JERA; Fluence',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Robertson solar farm',
                'Unknown',
                'AMP Energy',
              ],
              [
                'Australia',
                300,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rodds Bay solar farm',
                'Unknown',
                'Renew Estate; United Green',
              ],
              [
                'Australia',
                90,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rollestone solar farm',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                110,
                'Oceania',
                'Balgal Beach',
                'Unavailable',
                'Unavailable',
                'Rollingstone solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                128,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ross River solar farm',
                'Downer',
                'Palisade Investment Partners',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Royalla solar farm',
                'Unknown',
                'Dutch Infrasture Fund (DIF)',
              ],
              [
                'Australia',
                83,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rugby Run solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'Australia',
                253,
                'Oceania',
                'Mildura',
                'Unavailable',
                'Unavailable',
                'Nowingi Solar',
                'Unknown',
                'Lyon Infrastructure; JERA; Fluence',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Project Neo solar farm',
                'Unknown',
                'Infinite Blue Energy',
              ],
              [
                'Australia',
                27,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Goldfields',
                'Northern Goldfields Solar Project',
                'TransAlta',
                'TransAlta',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Maryrorough solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'New England solar farm',
                'UPC Renewables Australia',
                'UPC\\AC Renewables Australia',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Bogan Shire Council',
                'Southern Tablelands Region',
                'Marulan solar farm',
                'Unknown',
                'Terrain Solar',
              ],
              [
                'Australia',
                105,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rugby Run solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'Australia',
                160,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Maryvale solar farm',
                'Unknown',
                'Photon Energy',
              ],
              [
                'Australia',
                28,
                'Oceania',
                'Melbourne',
                'Unavailable',
                'Springvale South',
                'Melbourne solar farm',
                'Unknown',
                'Progress Power',
              ],
              [
                'Australia',
                132,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Merredin solar farm',
                'Risen Energy',
                'Risen Energy',
              ],
              [
                'Australia',
                115,
                'Oceania',
                'Armidale',
                'Unavailable',
                'Unavailable',
                'Metz Solar',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Middlemount solar farm',
                'Unknown',
                'SUSI Partners AG',
              ],
              [
                'Australia',
                60,
                'Oceania',
                'Mackey',
                'Unavailable',
                'Unavailable',
                'Mirani solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Rockhampton',
                'Unavailable',
                'Unavailable',
                'Moah Creek Renewable Energy Project solar farm',
                'Unknown',
                'Renewable Energy Partners; Energy Estate',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Moama',
                'Unavailable',
                'Unavailable',
                'Moama solar farm',
                'Metka EGN',
                'Metka EGN',
              ],
              [
                'Australia',
                36,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Molong Solar',
                'AMP',
                'Gransolar Group',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Caboolture',
                'Unavailable',
                'Unavailable',
                'Ningi solar farm',
                'Unknown',
                'Southern Pacific Sands',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Monaro Region',
                'Monaro solar farm',
                'Unknown',
                'Terrain Solar',
              ],
              [
                'Australia',
                60,
                'Oceania',
                'Mount Isa',
                'Unavailable',
                'Unavailable',
                'Mount Isa Hybrid solar farm',
                'Unknown',
                'Vast Solar; Stanwell',
              ],
              [
                'Australia',
                110,
                'Oceania',
                'Banana',
                'Unavailable',
                'Unavailable',
                'Moura solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                80,
                'Oceania',
                'Mulwala',
                'Unavailable',
                'Unavailable',
                'Mulwala solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Mumbil',
                'Unavailable',
                'Unavailable',
                'Mumbil solar farm',
                'Unknown',
                'Epuron',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Kalgoorlie',
                'Unavailable',
                'Unavailable',
                'Mungari solar farm',
                'Unknown',
                'Investec',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Munna Creek solar farm',
                'Unknown',
                'REST Energy',
              ],
              [
                'Australia',
                2500,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Murchinson Renewable Hydrogen Project solar farm',
                'Unknown',
                'Hydrogen Renewables Australia (HRA)',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Richmond Valley',
                'Myrtle Creek solar farm',
                'Unknown',
                'Terrain Solar',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Narrabri solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                132,
                'Oceania',
                'Warren Shire Council',
                'Warren Shire Council',
                'Unavailable',
                'Nevertire Solar',
                'Biosar',
                'Elliot Green Power',
              ],
              [
                'Australia',
                220,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'New England solar farm',
                'UPC Renewables Australia',
                'UPC\\AC Renewables Australia',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Moree solar farm',
                'Fotowatio Renewable Ventures',
                'Fotowatio Renewable Ventures; Australian Renewable Energy Agency (ARENA); Clean Energy Finance Corporation (CEFC)',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Narrandera',
                'Unavailable',
                'Unavailable',
                'Sandigo solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                22,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Wagga North solar farm',
                'Unknown',
                'Mytilineos',
              ],
              [
                'Australia',
                109,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sebastopol Solar',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                78,
                'Oceania',
                'Warwick',
                'Sladevale',
                'Southern Downs',
                'Warwick Solar',
                'University of Queensland',
                'University of Queensland',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Wee Waa',
                'Unavailable',
                'Unavailable',
                'Wee Waa solar farm',
                'Unknown',
                'Overland Sun Farming',
              ],
              [
                'Australia',
                400,
                'Oceania',
                'Wellington',
                'Wuuluman',
                'Unavailable',
                'Wellington North solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Australia',
                216,
                'Oceania',
                'Wellington',
                'Wuuluman',
                'Unavailable',
                'Wellington solar farm',
                'Unknown',
                'Lightsource BP; Dutch bank ING; Export Development Canada (EDC)',
              ],
              [
                'Australia',
                97,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Wemen solar farm',
                'WIRSOL',
                'Clean Energy Finance Corporation',
              ],
              [
                'Australia',
                107,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'West Wyalong solar farm',
                'LIghtsource BP',
                'Lightsource BP',
              ],
              [
                'Australia',
                460,
                'Oceania',
                'Chinchilla',
                'Unavailable',
                'Western Downs',
                'Western Downs (Neoen) solar farm',
                'Unknown',
                'Neoen',
              ],
              [
                'Australia',
                250,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Western Downs (Tilt Renewables) Solar Farm',
                'Tilt Renewables',
                'Yellow Solar; Tilt Renewables',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'White Rock solar farm',
                'Unknown',
                'Goldwind; ARENA',
              ],
              [
                'Australia',
                57,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Whitsunday Solar',
                'Unknown',
                'WIRSOL [94.9%]; Edify Energy [5.1%]',
              ],
              [
                'Australia',
                140,
                'Oceania',
                'Adelaide',
                'Adelaide City Council',
                'Unavailable',
                'Whyalla solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Wide Bay-Burret',
                'Wide Bay Solar',
                'Unknown',
                'Denzo Group; Natcore',
              ],
              [
                'Australia',
                85,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Winton solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures; ING; ABN AMRO',
              ],
              [
                'Australia',
                290,
                'Oceania',
                'Mudgee',
                'Wollar Village',
                'Unavailable',
                'Wollar Solar',
                'Wollar Solar',
                'Wollar Solar',
              ],
              [
                'Australia',
                60,
                'Oceania',
                'Bendigo',
                'Unavailable',
                'Unavailable',
                'Woodvale Evaporation Pond Complex solar farm',
                'Unknown',
                'GBM Gold',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Woolooga solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Lower Wonga',
                'Unavailable',
                'Unavailable',
                'Woolooga solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Lower Wonga',
                'Unavailable',
                'Unavailable',
                'Woolooga solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Australia',
                96,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Wunghnu solar farm',
                'Unknown',
                'X-Elio',
              ],
              [
                'Australia',
                75,
                'Oceania',
                'Wyalong',
                'Unavailable',
                'Unavailable',
                'Wyalong Solar',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                108,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Yabula solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Yarranlea solar farm',
                'Renewable Energy Systems (RES)',
                'Risen Energy',
              ],
              [
                'Australia',
                32,
                'Oceania',
                'Gladstone',
                'Unavailable',
                'Unavailable',
                'Yarwun Solar',
                'Unknown',
                'Renew Estate',
              ],
              [
                'Australia',
                106,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Yatpool solar farm',
                'Bay Wa r.e',
                'Bay Wa r.e',
              ],
              [
                'Australia',
                400,
                'Oceania',
                'Pastoral Unincorporated Area',
                'Pastoral Unincorporated Area',
                'Unavailable',
                'Yoorndoo solar farm',
                'Unknown',
                'AMP Energy',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Miles',
                'Unavailable',
                'Unavailable',
                'Warhook solar farm',
                'Engie',
                'Engie',
              ],
              [
                'Australia',
                180,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sapphire solar farm',
                'CWP Renewables',
                'CWP Renewables',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Wangaratta',
                'Unavailable',
                'Unavailable',
                'Wangaratta solar farm',
                'Unknown',
                'Energy Estate; CleanPeak Energy',
              ],
              [
                'Australia',
                330,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Walla Walla solar farm',
                'Unknown',
                'Fotowatio Renewables Ventures',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Narrabri',
                'Unavailable',
                'Unavailable',
                'Silverleaf solar farm',
                'Engie',
                'Engie',
              ],
              [
                'Australia',
                540,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Smoky Creek solar farm',
                'Unknown',
                'Edify Energy',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Snowtown',
                'Unavailable',
                'Unavailable',
                'Snowtown solar farm',
                'Tilt Renewables',
                'Tilt Renewables',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Roberstown',
                'Unavailable',
                'Unavailable',
                'Solar River Project',
                'Unknown',
                'Georgetown Hills Renewable Energy; Macquarie Capital; Siemens Gamesa',
              ],
              [
                'Australia',
                400,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Stubbo solar farm',
                'Unknown',
                'UPC\\AC Renewables Australia',
              ],
              [
                'Australia',
                117,
                'Oceania',
                'Townsville',
                'Unavailable',
                'Unavailable',
                'Sun Metals Solar',
                'Unknown',
                'Sun Metals',
              ],
              [
                'Australia',
                228,
                'Oceania',
                'Balranald Shire Council',
                'Balranald Shire Council',
                'Unavailable',
                'Sunraysia solar farm',
                'Decmil',
                'Maoneng Group [9.9%]; John Laing [90.1%]',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Brisbane',
                'Unavailable',
                'Unavailable',
                'Sunshine Harlin solar farm',
                'Unknown',
                'Sunshine Energy [55%]; Keppel Renewable Energy [45%]',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Brisbane',
                'Unavailable',
                'Unavailable',
                'Sunshine Harlin solar farm',
                'Unknown',
                'Sunshine Energy [55%]; Keppel Renewable Energy [45%]',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Brisbane',
                'Unavailable',
                'Unavailable',
                'Sunshine Harlin solar farm',
                'Unknown',
                'Sunshine Energy [55%]; Keppel Renewable Energy [45%]',
              ],
              [
                'Australia',
                189,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Suntop Solar',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'Australia',
                85,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Susan River Solar',
                'Biosar',
                'Elliot Green Power',
              ],
              [
                'Australia',
                108,
                'Oceania',
                'Coorong District Council',
                'Coorong District Council',
                'Unavailable',
                'Tailem Bend solar farm',
                'Vena Energy',
                'Global Infrastructure Partner',
              ],
              [
                'Australia',
                65,
                'Oceania',
                'Tamworth',
                'Unavailable',
                'New England',
                'Tamworth solar farm',
                'Unknown',
                'Oriens Energy',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Deniliquin',
                'Unavailable',
                'Edward River',
                'Tarleigh Park solar farm',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                52,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Tatura East solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                53,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Fraser Coast',
                'Teebar Solar',
                'Unknown',
                'Teebar Clean Energy',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Bundaberg',
                'Bundaberg Region',
                'Unavailable',
                'Three Chain solar farm',
                'Unknown',
                'Enertech PV Australia',
              ],
              [
                'Australia',
                36,
                'Oceania',
                'Bundaberg Region',
                'Bundaberg Region',
                'Unavailable',
                'Three Chain solar farm',
                'Unknown',
                'Enertech PV Australia',
              ],
              [
                'Australia',
                96,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Tieri solar farm',
                'Unknown',
                'FRV Services Australia Pty Ltd',
              ],
              [
                'Australia',
                1300,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Urannah Renewable Energy Hub solar farm',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Dandaragan',
                'Unavailable',
                'Unavailable',
                'Waddi Wind & Solar',
                'Tilt Renewables',
                'PowAR; Mercury NZ',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Wagga Wagga City Council',
                'Unavailable',
                'Unavailable',
                'Wagga North solar farm',
                'Unknown',
                'Mytilineos',
              ],
              [
                'Australia',
                72,
                'Oceania',
                'Mareeba',
                'Lockwood Rd',
                'Unavailable',
                'Mareeba solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                32,
                'Oceania',
                'Walgett',
                'Walgett Shire Council',
                'Unavailable',
                'Walgett Solar',
                'Unknown',
                'Epuron',
              ],
              [
                'Australia',
                650,
                'Oceania',
                'Brisbane',
                'Wandoan',
                'Unavailable',
                'Wandoan South Solar Project',
                'Unknown',
                'Vena Energy; ING',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Manildra solar farm',
                'Unknown',
                'ARENA; Banpu',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Kyabram',
                'Unavailable',
                'Unavailable',
                'Lancaster solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Unavailable',
                'Bogan Shire Council',
                'Upper Hunter Valley',
                'Malabar solar farm',
                'Unknown',
                'Malabar Resources; EDF Renewables',
              ],
              [
                'Australia',
                64,
                'Oceania',
                'Bundaberg Region',
                'Bundaberg Region',
                'Unavailable',
                'Childers (Elliot Green) Solar Farm',
                'Biosar',
                'Elliot Green Power',
              ],
              [
                'Australia',
                42,
                'Oceania',
                'Bundaberg Region',
                'Bundaberg Region',
                'Unavailable',
                'Childers (DDN) Solar Farm',
                'Unknown',
                'DDN Green',
              ],
              [
                'Australia',
                75,
                'Oceania',
                'Mareeba',
                'Unavailable',
                'Unavailable',
                'Chewko solar farm',
                'Unknown',
                'Tilt Renewables',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Geraldton',
                'Unavailable',
                'Unavailable',
                'Chapman Hybrid solar farm',
                'Unknown',
                'Investec',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Chances Plain solar farm',
                'Unknown',
                'Juwi Renewable Energy Pty Ltd',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Chaff Mill solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Chinchilla solar farm',
                'Unknown',
                'First Solar',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Cooktown',
                'Unavailable',
                'Unavailable',
                'Cape York Solar',
                'Unknown',
                'Lyon Infrastructure; JERA; Fluence',
              ],
              [
                'Australia',
                129,
                'Oceania',
                'Burdekin Shire Council',
                'Unavailable',
                'Unavailable',
                'Burdekin solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                280,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bungama solar farm',
                'Unknown',
                'AMP Energy',
              ],
              [
                'Australia',
                138,
                'Oceania',
                'Port Augusta City Council',
                'Port Augusta City Council',
                'Unavailable',
                'Bungala Two solar farm',
                'Unknown',
                'Enel Green Power [50%]; Dutch Infrastructure Funds [50%]',
              ],
              [
                'Australia',
                138,
                'Oceania',
                'Port Augusta City Council',
                'Port Augusta City Council',
                'Unavailable',
                'Bungala One solar farm',
                'Unknown',
                'Enel Green Power [50%]; Dutch Infrastructure Funds [50%]',
              ],
              [
                'Australia',
                92,
                'Oceania',
                'Bundaberg',
                'Bundaberg Region',
                'Unavailable',
                'Bundaberg (Ewia) Solar Farm',
                'Unknown',
                'EWIA Group',
              ],
              [
                'Australia',
                58,
                'Oceania',
                'Bundaberg',
                'Bundaberg Region',
                'Unavailable',
                'Bundaberg (Denzo) solar farm',
                'Unknown',
                'Denzo Group',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Berth',
                'Unavailable',
                'Unavailable',
                'Byford Solar',
                'Unknown',
                'WestGen',
              ],
              [
                'Australia',
                125,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Clare solar farm',
                'Unknown',
                'Lighthouse Infrastructure [50%]; DIF [50%]',
              ],
              [
                'Australia',
                400,
                'Oceania',
                'Unavailable',
                'Isaac Shire',
                'Unavailable',
                'Clarke (Lacour) Creek Solar Farm',
                'Unknown',
                'Lacour Energy',
              ],
              [
                'Australia',
                315,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Clarke Creek (Pacific Hydro) Solar Farm',
                'Unknown',
                'Pacific Hydro',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dalby solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                175,
                'Oceania',
                'Deniliquin',
                'Unavailable',
                'Unavailable',
                'Currawarra solar farm',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                128,
                'Oceania',
                'Cunderdin',
                'Unavailable',
                'Unavailable',
                'Cunderdin solar farm',
                'Unknown',
                'Minderoo; Sun Brilliance',
              ],
              [
                'Australia',
                280,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cultana solar farm',
                'Unknown',
                'Sanjeev Gupta',
              ],
              [
                'Australia',
                350,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Culcairn solar farm',
                'Unknown',
                'Neoen',
              ],
              [
                'Australia',
                110,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Crystal Brook Energy Park solar farm',
                'Neoen',
                'Neoen',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Crinum Creek solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Corowa solar farm',
                'Metka EGN',
                'Metka EGN',
              ],
              [
                'Australia',
                309,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Comet solar farm',
                'Unknown',
                'Hadstone Energy',
              ],
              [
                'Australia',
                203,
                'Oceania',
                'Western Downes',
                'Unavailable',
                'Unavailable',
                'Columboola Solar',
                'Sterling & Wilson',
                'Korea East-West Power; Hana Financial Investment; Samchully Assest Management',
              ],
              [
                'Australia',
                42,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Collinsville Solar',
                'Unknown',
                'ARENA; RATCH Australia',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Bowen',
                'Collinsville',
                'Unavailable',
                'Collinsville North Solar Project',
                'Unknown',
                'Vena Energy',
              ],
              [
                'Australia',
                180,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Coleambally solar farm',
                'Bouygues-Construction',
                'Neoen',
              ],
              [
                'Australia',
                34,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cohuna solar farm',
                'Unknown',
                'Enel Green Power',
              ],
              [
                'Australia',
                92,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Clermont solar farm',
                'WIRSOL',
                'Clean Energy Finance Corporation',
              ],
              [
                'Australia',
                109,
                'Oceania',
                'Bundaberg Region',
                'Bundaberg Region',
                'Unavailable',
                'Bullyard solar farm',
                'Unknown',
                'Enertech PV Australia',
              ],
              [
                'Australia',
                180,
                'Oceania',
                'Mildura',
                'Unavailable',
                'Unavailable',
                'Mallee Solar Park',
                'Unknown',
                'TRUenergy',
              ],
              [
                'Australia',
                125,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bulli Creek solar farm',
                'Unknown',
                'Solar Choice',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bulli Creek solar farm',
                'Unknown',
                'Solar Choice',
              ],
              [
                'Australia',
                85,
                'Oceania',
                'Wodonga',
                'Unavailable',
                'Unavailable',
                'Barnawartha solar farm',
                'Unknown',
                'Wirsol; ARP Australian Solar',
              ],
              [
                'Australia',
                76,
                'Oceania',
                'Unavailable',
                'Baringhup',
                'Unavailable',
                'Baringhup solar farm',
                'Unknown',
                'Renewable Energy Partners',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Barcaldine Remote Community solar farm',
                'Unknown',
                'Elecnor',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Barcaldine Remote Community solar farm',
                'Unknown',
                'Foresight Group',
              ],
              [
                'Australia',
                115,
                'Oceania',
                'Baralaba',
                'Unavailable',
                'Unavailable',
                'Baralaba solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bannerton solar farm',
                'Unknown',
                'Foresight Group',
              ],
              [
                'Australia',
                85,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Barrunggam solar farm',
                'Unknown',
                'Ubergy',
              ],
              [
                'Australia',
                160,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Axedale solar farm',
                'Unknown',
                'UPC\\AC Renewables Australia',
              ],
              [
                'Australia',
                70,
                'Oceania',
                'Port Augusta',
                'Port Augusta City Council',
                'Unavailable',
                'Aurora Energy Project solar farm',
                'Unknown',
                '1414 Degrees',
              ],
              [
                'Australia',
                81,
                'Oceania',
                'Tolga',
                'Rocky Creek',
                'Unavailable',
                'Atherton solar farm',
                'Atherton Solar Farm',
                'Qingdao New Energy Solutions',
              ],
              [
                'Australia',
                130,
                'Oceania',
                'Aramara',
                'Unavailable',
                'Unavailable',
                'Aramara Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Australia',
                285,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Aldoga Solar',
                'Acciona',
                'Acciona',
              ],
              [
                'Australia',
                315,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Aldoga Solar',
                'Acciona',
                'Acciona',
              ],
              [
                'Australia',
                140,
                'Oceania',
                'Whyalla',
                'Unavailable',
                'Unavailable',
                'Adani Whyalla solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'Australia',
                245,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Avonlie Solar',
                'Unknown',
                'Iberdrola',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Beelbee solar farm',
                'Unknown',
                'APA Group; ARENA',
              ],
              [
                'Australia',
                98,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Beryl solar farm',
                'Unknown',
                'Banpu',
              ],
              [
                'Australia',
                600,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Birriwa solar farm',
                'Unknown',
                'UPC\\AC Renewables Australia',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bulli Creek solar farm',
                'Unknown',
                'Solar Choice',
              ],
              [
                'Australia',
                475,
                'Oceania',
                'Toowoomba',
                'Unavailable',
                'Unavailable',
                'Bulli Creek solar farm',
                'Unknown',
                'Solar Choice',
              ],
              [
                'Australia',
                27,
                'Oceania',
                'Broken Hill',
                'Unincorporated Area',
                'Unavailable',
                'Broken Hill solar farm',
                'Powering Australian Renewables Fund (PARF)',
                'Powering Australian Renewables Fund (PARF)',
              ],
              [
                'Australia',
                385,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Broadsound solar farm',
                'Unknown',
                'Hadstone Energy',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Broadlea solar farm',
                'Unknown',
                'Adiant Capital Partners',
              ],
              [
                'Australia',
                60,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bowen solar farm',
                'Unknown',
                'Infigen Energy',
              ],
              [
                'Australia',
                280,
                'Oceania',
                'Bouldercombe',
                'Unavailable',
                'Unavailable',
                'Bouldercombe solar farm',
                'Unknown',
                'Eco Energy World',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Bonshaw',
                'Inverell',
                'Unavailable',
                'Bonshaw solar farm',
                'Unknown',
                'GAIA Australia',
              ],
              [
                'Australia',
                121,
                'Oceania',
                'Wagga Wagga City Council',
                'Unavailable',
                'Unavailable',
                'Bomen solar farm',
                'Spark Renewables',
                'Spark Renewables',
              ],
              [
                'Australia',
                125,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bluff solar farm',
                'Unknown',
                'Infigen Energy',
              ],
              [
                'Australia',
                125,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bluff solar farm',
                'Unknown',
                'Infigen Energy',
              ],
              [
                'Australia',
                80,
                'Oceania',
                'Bluewater',
                'Unavailable',
                'Unavailable',
                'Bluewater solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Blue Grass Solar',
                'Unknown',
                'X-Elio',
              ],
              [
                'Australia',
                60,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Blair Athol Solar Farms',
                'Unknown',
                'TerraCom',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Blackwater solar farm',
                'Unknown',
                'Renewable Energy Developments',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bulli Creek solar farm',
                'Unknown',
                'Solar Choice',
              ],
              [
                'Australia',
                324,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Darlington Point Solar',
                'Canadian Solar',
                'Edify Energy; Octopus Investments',
              ],
              [
                'Australia',
                121,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Darling Downs solar farm',
                'Unknown',
                'APA Group',
              ],
              [
                'Australia',
                79,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Daydream Solar',
                'Unknown',
                'BlackRock; Edify',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Juncee solar farm',
                'Metka EGN',
                'Metka EGN',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Jindera Solar',
                'Green Switch',
                'Green Switch',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Jemalong Solar',
                'Beon Energy Solutions',
                'Genex Power',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Surf Coast Shire',
                'Inverleigh',
                'Unavailable',
                'Inverleigh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Bundaberg Region',
                'Bundaberg Region',
                'Unavailable',
                'Innes Park solar farm',
                'Unknown',
                'Enerparc Australia',
              ],
              [
                'Australia',
                80,
                'Oceania',
                'Wagga Wagga',
                'Illabo',
                'Unavailable',
                'Illabo solar farm',
                'Tilt Renewables',
                'Tilt Renewables',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Karrabin',
                'Unavailable',
                'Unavailable',
                'Karrabin solar farm',
                'Unknown',
                'EWIA Group',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Hughenden',
                'Unavailable',
                'Unavailable',
                'Hughendon solar farm',
                'Bay Wa r.e',
                'Lighthouse Infrastructure',
              ],
              [
                'Australia',
                119,
                'Oceania',
                'Carrathool Shire Council',
                'Carrathool Shire Council',
                'Unavailable',
                'Hillston Sun Farm solar farm',
                'Unknown',
                'AMP Power',
              ],
              [
                'Australia',
                57,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Hayman Solar',
                'Unknown',
                'BlackRock; Edify',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Hay Shire Council',
                'Hay Shire Council',
                'Unavailable',
                'Hay Sun Farm solar farm',
                'Unknown',
                'Overland Sun Farming; Island Green Power',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Burdekin Shire',
                'Dry Tropics',
                'Haughton solar farm',
                'RCR Tomlinson',
                'Pacific Hydro',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Haughton solar farm',
                'RCR Tomlinson',
                'Pacific Hydro',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Burdekin Shire',
                'Dry Tropics',
                'Haughton solar farm',
                'RCR Tomlinson',
                'Pacific Hydro',
              ],
              [
                'Australia',
                130,
                'Oceania',
                'Horsham',
                'Unavailable',
                'Unavailable',
                'Horsham solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                34,
                'Oceania',
                'Katherine',
                'Town of Katherine',
                'Unavailable',
                'Katherine Solar',
                'Epuron',
                'Eni; Epuron; Island Green Power',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Kelsey Creek',
                'Unavailable',
                'Unavailable',
                'Kelsey Creek Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Gannawarra Shire',
                'Kerang (Acciona) Solar',
                'Unknown',
                'Acciona',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Majors Creek Solar Power Station',
                'Unknown',
                'Edify; City of Townsville',
              ],
              [
                'Australia',
                277,
                'Oceania',
                'The District Council of Loxton Waikerie',
                'The District Council of Loxton Waikerie',
                'Unavailable',
                'Loxton solar farm',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                800,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lower Wonga solar farm',
                'Unknown',
                'Solar Q',
              ],
              [
                'Australia',
                350,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lower Wonga solar farm',
                'Unknown',
                'Solar Q',
              ],
              [
                'Australia',
                349,
                'Oceania',
                'Balranald Shire Council',
                'Balranald Shire Council',
                'Unavailable',
                'Limondale solar farm',
                'Belectric',
                'RWE AG',
              ],
              [
                'Australia',
                125,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lilyvale solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures; Australia Banking Group; New Zealand Banking Group; Tokyo-Mitsubishi UFJ; Sumitomo Mitsui Banking Corp',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kondinin solar farm',
                'Unknown',
                'Lacour Energy',
              ],
              [
                'Australia',
                55,
                'Oceania',
                'Burdekin Shire',
                'Unavailable',
                'Unavailable',
                'Koberinga solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Roxby Downs',
                'Municipal Council of Roxby Downs',
                'Unavailable',
                'Kingfisher Solar Storage',
                'First Solar',
                'Lyon Infrastructure; JERA; Fluence',
              ],
              [
                'Australia',
                40,
                'Oceania',
                'Kingaroy',
                'Unavailable',
                'Unavailable',
                'Kingaroy solar farm',
                'Metka EGN',
                'Metka EGN',
              ],
              [
                'Australia',
                270,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kidston Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Australia',
                50,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kidston Solar',
                'CIMIC Group',
                'ARENA; Genex Power',
              ],
              [
                'Australia',
                194,
                'Oceania',
                'Mildura',
                'Unavailable',
                'Unavailable',
                'Kiamal Solar',
                'Total Eren SA',
                'Total Eren SA',
              ],
              [
                'Australia',
                256,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kiamal Solar',
                'Total Eren SA',
                'Total Eren SA',
              ],
              [
                'Australia',
                140,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kerang (ACE Power) Solar',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Forbes',
                'Unavailable',
                'Unavailable',
                'Daroobalgie solar farm',
                'Unknown',
                'Pacific Hydro',
              ],
              [
                'Australia',
                500,
                'Oceania',
                'Harlin',
                'Unavailable',
                'Unavailable',
                'Harlin Solar',
                'Keppel Renewable Energy',
                'Keppel Renewable Energy',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Burdekin Shire',
                'Dry Tropics',
                'Haughton solar farm',
                'RCR Tomlinson',
                'Pacific Hydro',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Collie',
                'Unavailable',
                'Unavailable',
                'Hadouken Collie solar farm',
                'Unknown',
                'Hadouken Pty',
              ],
              [
                'Australia',
                120,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Forrest Glen solar farm',
                'Unknown',
                'X-Elio',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Forbes Solar Farms',
                'Unknown',
                'ACE Power',
              ],
              [
                'Australia',
                162,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Finley solar farm',
                'Signal Energy',
                'John Laing; Westpac Banking Corporation (Westpac); New Zealand Banking Group (ANZ)',
              ],
              [
                'Australia',
                150,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ewerleigh Solar Park',
                'Unknown',
                'Ewerleigh Solar Park Pty Ltd; DPI Group',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Badgingarra',
                'Unavailable',
                'Unavailable',
                'Emu Downs solar farm',
                'Unknown',
                'APA Group; ARENA',
              ],
              [
                'Australia',
                88,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Emerald Solar Park',
                'Renewable Energy Systems (RES)',
                'Lighthouse Infrastructure',
              ],
              [
                'Australia',
                119,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gangarri solar farm',
                'Shell Energy',
                'Shell Energy',
              ],
              [
                'Australia',
                204,
                'Oceania',
                'Chinchilla',
                'Unavailable',
                'Western Downes',
                'Edenvale Solar Park',
                'Unknown',
                'Sojitz Corporation [50%]; Eneos Corporation [50%]',
              ],
              [
                'Australia',
                142,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dysart (Sun Farms) Solar Farm',
                'Unknown',
                'Sun Farms',
              ],
              [
                'Australia',
                210,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dyno Nobel Moranbah Renewable Hydrogen solar farm',
                'Unknown',
                'ARENA; Dyno Noble',
              ],
              [
                'Australia',
                85,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dingo solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                1250,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dinawan Energy Hub solar farm',
                'Unknown',
                'Spark Renewables',
              ],
              [
                'Australia',
                250,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Desailly Renewable Energy Park solar farm',
                'Unknown',
                'DP Energy',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Daystar Energy solar farm',
                'Unknown',
                'Daystar Energy',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Mackey',
                'Unavailable',
                'Unavailable',
                'Dysart (Tilt Renewables) Solar Farm',
                'Unknown',
                'Tilt Renewables',
              ],
              [
                'Australia',
                57,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Hamilton solar farm',
                'Unknown',
                'WIRSOL [94.9%]; Edify Energy [5.1%]',
              ],
              [
                'Australia',
                25,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gannawarra solar farm',
                'Unknown',
                'WIRSOL [94.9%]; Edify Energy [5.1%]',
              ],
              [
                'Australia',
                104,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Karadoc solar farm',
                'Bay Wa r.e',
                'Bay Wa r.e',
              ],
              [
                'Australia',
                144,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gunnedah (Canadian Solar) Solar',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'Australia',
                20,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gumlu solar farm',
                'Unknown',
                'RJ Gordon Solar Consultants',
              ],
              [
                'Australia',
                34,
                'Oceania',
                'Unavailable',
                'Tom Price',
                'Unavailable',
                'Gudai-Darri solar farm',
                'Unknown',
                'RioTinto',
              ],
              [
                'Australia',
                27,
                'Oceania',
                'Griffith',
                'Unavailable',
                'Unavailable',
                'Griffith Solar',
                'ENcome',
                'Neoen',
              ],
              [
                'Australia',
                215,
                'Oceania',
                'Emerald',
                'Unavailable',
                'Unavailable',
                'Gregory solar farm',
                'Unknown',
                'Engie',
              ],
              [
                'Australia',
                78,
                'Oceania',
                'Gladstone',
                'Unavailable',
                'Unavailable',
                'Gladstone Abattoir solar farm',
                'Unknown',
                'Asia Pacific Agri-Corp',
              ],
              [
                'Australia',
                100,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gunsynd Solar',
                'Unknown',
                'Skylab Australia',
              ],
              [
                'Australia',
                47,
                'Oceania',
                'Wagga Wagga',
                'Unavailable',
                'Unavailable',
                'Gregadoo Solar',
                'Unknown',
                'Green Switch',
              ],
              [
                'Australia',
                30,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Greenough River solar farm',
                'Unknown',
                'Bright Energy Investments; Dutch Infrastructure Partners; CBus',
              ],
              [
                'Australia',
                520,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Goulburn River solar farm',
                'Lightsource BP',
                'Lightsource BP',
              ],
              [
                'Australia',
                84,
                'Oceania',
                'Syndney',
                'Parkes',
                'Unavailable',
                'Goonumbla solar farm',
                'Unknown',
                'Fotowatio Renewables Ventures; DZ Bank; ING',
              ],
              [
                'Australia',
                33,
                'Oceania',
                'Gold Coast',
                'Unavailable',
                'Unavailable',
                'Gold Coast solar farm',
                'Unknown',
                'Ormed Investments',
              ],
              [
                'Australia',
                149,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Glenrowan West solar farm',
                'Unknown',
                'Wirtgen Invest',
              ],
              [
                'Australia',
                140,
                'Oceania',
                'Glenrowan',
                'Unavailable',
                'Unavailable',
                'Glenrowan (ESCO Pacific) solar farm',
                'Unknown',
                'ESCO Pacific',
              ],
              [
                'Australia',
                200,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Glenellen solar farm',
                'Unknown',
                'Trina Solar',
              ],
              [
                'Australia',
                27,
                'Oceania',
                'Gunnedah',
                'Unavailable',
                'Unavailable',
                'Gunnedah (Ironbark) Solar Farm',
                'Unknown',
                'Ironbark Energy',
              ],
              [
                'Australia',
                220,
                'Oceania',
                'Gunning',
                'Lade Vale',
                'Unavailable',
                'Gunning Solar',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'Austria',
                24,
                'Europe',
                'Schwecha',
                'Bruck an der Leitha District',
                'Unavailable',
                'Vienna International Airport solar farm',
                'Unknown',
                'Wien AG',
              ],
              [
                'Azerbaijan',
                20,
                'Eurasia',
                'Unavailable',
                'Unavailable',
                'Babek District',
                'Nakhchivan Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Azerbaijan',
                230,
                'Eurasia',
                'Unavailable',
                'Alat',
                'Baku',
                'Garadagh Solar PV Plant',
                'Unknown',
                'Masdar',
              ],
              [
                'Bahrain',
                100,
                'Middle East',
                'Askar',
                'Askar Landfill',
                'Madinat Khalifa',
                'Al Askar IPP solar farm',
                'NOMAC',
                'ACWA Power [60%]; Mitsui [30%]; Almoayyed Contracting Group WLL [10%]',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Pabna',
                'Pabna',
                'Pabna district',
                'Pabna (Shapoorji Pallonji Infrastructure) solar farm',
                'Unknown',
                'Shapoorji Pallonji Infrastructure Capital Company Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Mymensingh District',
                'Mymensingh solar farm',
                'Unknown',
                'Sinenergy Holdings Private Limited; Ditrolic Solar',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Netrokona',
                'Unavailable',
                'Netrokona District',
                'Netrokona solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Nilphamari District',
                'Nilphamari (Scatec) solar farm',
                'Scatec',
                'Bangla Sun Solar Limited (BSSL)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Nilphamari Sadar Upazila',
                'Nilphamari',
                'Nilphamari (Zhejiang Dunan) solar farm',
                'Zhejiang DunAn New Energy Company; China National Machinery Import and Export Corporation; Solar Tech Power; Amity Solar',
                'Zhejiang DunAn New Energy Company; China National Machinery Import and Export Corporation; Solar Tech Power; Amity Solar',
              ],
              [
                'Bangladesh',
                84,
                'Asia',
                'Bera',
                'Bera',
                'Pabna district',
                'Pabna (BCPCL) solar farm',
                'Unknown',
                'Bangladesh China Renewable Energy Company Limited (BCPCL)',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Debiganj Upazila',
                'Debiganj Upazila',
                'Panchagarh District',
                'Panchagarh (8Minutenergy) solar farm',
                'Unknown',
                '8minutenergy Singapore Holdings Private Limited (8minutenergy)',
              ],
              [
                'Bangladesh',
                30,
                'Asia',
                'Tetulia',
                'Tetulia',
                'Panchagarh District',
                'Panchagarh (Beximco) solar farm',
                'Unknown',
                'Beximco Power Company Limited [80%]; Jiangsu Zhongtian Technology Company Limited [20%]',
              ],
              [
                'Bangladesh',
                47,
                'Asia',
                'Unavailable',
                'Panchagarh Sadar',
                'Panchagarh',
                'Panchagarh (IB Vogt) solar farm',
                'Unknown',
                'IB Voght GmbH; Milner Vermogensverwaltungs GmbH; Fu-Wang Bowling and Service Limited',
              ],
              [
                'Bangladesh',
                20,
                'Asia',
                'Debiganj Upazila',
                'Debiganj Upazila',
                'Panchagarh District',
                'Panchagarh (Rahimafrooz) solar farm',
                'Rahimafrooz Renewable Energy Limited; Shunfeng Investments Limited',
                'Rahimafrooz Renewable Energy Limited; Shunfeng Investments Limited',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Bagerhat',
                'Bagerhat Sadar Subdistrict',
                'Bagerhat',
                'Mongla solar farm',
                'Unknown',
                'Energon Technologies FZE; China Sunergy Company Limited (ESUN)',
              ],
              [
                'Bangladesh',
                30,
                'Asia',
                'Boda',
                'Boda',
                'Panchagarh District',
                'Panchagarh (RPCL) solar farm',
                'Unknown',
                'Rural Power Company Limted (RPCL)',
              ],
              [
                'Bangladesh',
                90,
                'Asia',
                'Gangachhara',
                'Gangachhara',
                'Rangpur district',
                'Rangpur (BPDB) solar farm',
                'Unknown',
                'Bangladesh Power Development Board (BPDB)',
              ],
              [
                'Bangladesh',
                30,
                'Asia',
                'Gangachhara',
                'Gangachhara',
                'Rangpur district',
                'Rangpur (Intraco) solar farm',
                'Unknown',
                'Intraco Solar Power Limited (ISPL); Juli New Energy Company Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Chattogram District',
                'Rangunia solar farm',
                'Metito; JinkoSolar; Aljomaih Energy and Water (AEW)',
                'Metito; JinkoSolar; Aljomaih Energy and Water (AEW)',
              ],
              [
                'Bangladesh',
                89,
                'Asia',
                'Sirajganj',
                'Unavailable',
                'Sirajganj District',
                'Sirajganji solar farm',
                'Unknown',
                'Bangladesh China Renewable Energy Company Limited (BCPCL)',
              ],
              [
                'Bangladesh',
                110,
                'Asia',
                'Feni',
                'Sonagazi',
                'Feni District',
                'Sonagazi (BPDB) solar farm',
                'Unknown',
                'Bangladesh Power Development Board (BPDB)',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Sonagazi',
                'Sonagazi',
                'Feni District',
                'Sonagazi (EGCB) solar farm',
                'Unknown',
                'Electricity Generation Company of Bangladesh (EGCB)',
              ],
              [
                'Bangladesh',
                60,
                'Asia',
                'Unavailable',
                'Sujanagar',
                'Pabna',
                'Sujanagar solar farm',
                'Unknown',
                'Cyclect Energy Private Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Mymensingh',
                'Mymensingh',
                'Mymensingh District',
                'Sutiakhali solar farm',
                'HDFC Sinpower Limited',
                'HDFC Sinpower Limited',
              ],
              [
                'Bangladesh',
                200,
                'Asia',
                'Unavailable',
                'Teknaf',
                "Cox's Bazar District",
                'Teknaf (Sunedison) solar farm',
                'Unknown',
                'SunEdison Incorporated',
              ],
              [
                'Bangladesh',
                280,
                'Asia',
                'Unavailable',
                'Sandarganj',
                'Gaibandha',
                'Rangpur (Beximco) solar farm',
                'Rays Power Infra Private Limited; Zetwerk Manufacturing Business Private Limited',
                'Bangladesh Export Import Company Limited (Beximco Limited)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Dacope',
                'Dacope',
                'Khulna District',
                'Mollahat solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                "Cox's Bazar District",
                "Cox's Bazar District",
                'Matarbari solar farm',
                'Unknown',
                'Coal Power Generation Company Bangladesh Limited (CPGCBL)',
              ],
              [
                'Bangladesh',
                35,
                'Asia',
                'Unavailable',
                'Shibaloy',
                'Manikgonj',
                'Manikganj solar farm',
                'Spectra Solar Park Limited (SSPL)',
                'Spectra Engineers Limited; Shunfeng Investments Limited',
              ],
              [
                'Bangladesh',
                32,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sunamganj District',
                'Dharmapasa solar farm',
                'Unknown',
                'Edison-Power Point; Haor Bangla-Korea Green Energy Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Dhaka District',
                'Dhaka solar farm',
                'Unknown',
                'IB Voght GmbH; AG Agro Industries Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Chuadanga',
                'Chuadanga',
                'Chuadanga District',
                'Chauadanga solar farm',
                'Unknown',
                'Cyclect Energy Private Limited',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Shaharasti Upazila',
                'Chandpur',
                'Chandpur solar farm',
                'Unknown',
                'Joules Power Limited (JPL)',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Mirsharai',
                'Mirsharai',
                'Chattogram District',
                'Baraiyarhat solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Mymensingh',
                'Jamalpur',
                'Mymensingh',
                'Ashuganj solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Sonagazi',
                'Sonagazi',
                'Feni District',
                'Feni solar farm',
                'Unknown',
                'Electricity Generation Company of Bangladesh (EGCB)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Chauddagram',
                'Feni',
                'Feni solar farm',
                'Unknown',
                'Electricity Generation Company of Bangladesh (EGCB)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Chauddagram',
                'Feni',
                'Feni solar farm',
                'Unknown',
                'Electricity Generation Company of Bangladesh (EGCB)',
              ],
              [
                'Bangladesh',
                200,
                'Asia',
                'Gaibandha',
                'Unavailable',
                'Gaibandha district',
                'Gaibandha Beximco solar farm',
                'Unknown',
                'Beximco Power Company Limited',
              ],
              [
                'Bangladesh',
                40,
                'Asia',
                'Unavailable',
                'Gangachara',
                'Rangpur',
                'Gangachara (Intraco) solar farm',
                'Unknown',
                'Intraco Solar Power Limited (ISPL)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Gangachara',
                'Rangpur',
                'Gangachara (OCK) solar farm',
                'Unknown',
                'OCK Group Berhad; Anando Agro Group',
              ],
              [
                'Bangladesh',
                73,
                'Asia',
                'Unavailable',
                'Gauripur',
                'Mymensingh',
                'Gauripur solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Ghosh Para',
                'Tangail',
                'Ghosh Para solar farm',
                'Unknown',
                'Hanwha 63 City Company; BJ Power Company; Solar City Bangladesh Power Company',
              ],
              [
                'Bangladesh',
                125,
                'Asia',
                'Unavailable',
                'Jamuna',
                'Dhaka District',
                'Jamuna solar farm',
                'Unknown',
                'Bangladesh China Renewable Energy Company Limited (BCPCL)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Madarganj',
                'Jamalpur',
                'Kaijer Char solar farm',
                'Unknown',
                'B-R Powergen Limited',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Kaptai',
                'Rangamati Hill District',
                'Kaptai Lake solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Khulna',
                'Khulna solar farm',
                'Unknown',
                'Hero Future Energies Asia Private Limited',
              ],
              [
                'Bangladesh',
                35,
                'Asia',
                'Unavailable',
                'Bheramara Upazila',
                'Kushtia',
                'Kushtia solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jamalpur District',
                'Madargonj (B-R Powergen) solar farm',
                'Unknown',
                'B-R Powergen Limited',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jamalpur District',
                'Madargonj (RPCL) solar farm',
                'Unknown',
                'Rural Power Company Limted (RPCL)',
              ],
              [
                'Bangladesh',
                20,
                'Asia',
                'Unavailable',
                "Cox's Bazar District",
                "Cox's Bazar District",
                'Teknaf (Tsel) solar farm',
                'Unknown',
                'Joules Power Limited (JPL)',
              ],
              [
                'Bangladesh',
                30,
                'Asia',
                'Unavailable',
                'Dhorola',
                'Kurigram',
                'Dhorola solar farm',
                'Unknown',
                'Bangladesh Power Development Board (BPDB)',
              ],
              [
                'Bangladesh',
                100,
                'Asia',
                'Faridpur',
                'Faridpur Sadar',
                'Faridpur District',
                'Faridpur solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Barbados',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Saint Michael',
                'Waterford',
                'Waterford Plantation solar farm',
                'Deltro Group',
                'Deltro Group',
              ],
              [
                'Belarus',
                55,
                'Europe',
                'Unavailable',
                'Rechitsa District',
                'Unavailable',
                'Rechitsa solar farm',
                'Unknown',
                'Belorusneft',
              ],
              [
                'Belarus',
                130,
                'Europe',
                'Unavailable',
                'Cherikov District',
                'Unavailable',
                'Cherikov solar farm',
                'Unknown',
                'Solar Land',
              ],
              [
                'Belgium',
                100,
                'Europe',
                'Maaseik',
                'Maaseik',
                'Unavailable',
                'Kristal solar farm',
                'Engie',
                'Limburgse investeringsmaatschappij',
              ],
              [
                'Belgium',
                20,
                'Europe',
                'Ath',
                'Ath',
                'Unavailable',
                'Pairi Daiza Zoo solar farm',
                'Unknown',
                'Pairi Daiza Zoo',
              ],
              [
                'Belgium',
                40,
                'Europe',
                'Sint-Niklaas',
                'Sint-Niklaas',
                'Unavailable',
                'Kateon Natie solar farm',
                'Unknown',
                'Katoen Natie',
              ],
              [
                'Belgium',
                23,
                'Europe',
                'Loghidden City',
                'Antewerp',
                'Antewerp',
                'Kallo Terminal solar farm',
                'Unknown',
                'Katoen Natie',
              ],
              [
                'Belgium',
                50,
                'Europe',
                'Eeklo',
                'Eeklo',
                'Unavailable',
                'Arcelormittal solar farm',
                'Unknown',
                'ArcelorMittal',
              ],
              [
                'Benin',
                25,
                'Africa',
                'Pob\u00e8',
                'Unavailable',
                'Unavailable',
                'Illoulofin Solar',
                'Unknown',
                'Eiffage',
              ],
              [
                'Benin',
                25,
                'Africa',
                'Pob\u00e8',
                'Unavailable',
                'Unavailable',
                'Illoulofin Solar',
                'Unknown',
                'Eiffage',
              ],
              [
                'Bhutan',
                30,
                'Asia',
                'Unavailable',
                'Shingkhar',
                'Bumthang',
                'Shingkhar solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bhutan',
                32,
                'Asia',
                'Unavailable',
                'Doongmanma',
                'Trashigang',
                'Doongmanma solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bhutan',
                65,
                'Asia',
                'Gogona',
                'Nubi Gewog',
                'Wangduephodrang',
                'Gogona solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bhutan',
                92,
                'Asia',
                'Unavailable',
                'Tang',
                'Bumthang',
                'Tang solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bhutan',
                59,
                'Asia',
                'Unavailable',
                'Tenchekha',
                'Thimphu',
                'Tenchekha solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bhutan',
                42,
                'Asia',
                'Unavailable',
                'Chumey',
                'Bumthang',
                'Chumey solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bolivia',
                50,
                'South America',
                'Municipio Caracollo',
                'Provincia Cercado',
                'Caracollo',
                'Oruru Photovoltaic Solar Plant',
                'Empresa Nacional de Electricidad (ENDE)',
                'Empresa Nacional de Electricidad (ENDE)',
              ],
              [
                'Bolivia',
                50,
                'South America',
                'Municipio Caracollo',
                'Provincia Cercado',
                'Caracollo',
                'Oruru Photovoltaic Solar Plant',
                'Empresa Nacional de Electricidad (ENDE)',
                'Empresa Nacional de Electricidad (ENDE)',
              ],
              [
                'Bolivia',
                60,
                'South America',
                'Uyuni',
                'Antonio Quijarro',
                'Unavailable',
                'Uyuni PV Solar Plant',
                'Empresa Nacional de Electricidad (ENDE)',
                'Empresa Nacional de Electricidad (ENDE)',
              ],
              [
                'Bosnia and Herzegovina',
                30,
                'Europe',
                'Podvele\u017e',
                'Mostar Municipality',
                'Herzegovina-Neretva Canton',
                'Podvele\u017eje solar farm',
                'Unknown',
                'Elektroprivreda Bosne i Hercegovine (EPBiH)',
              ],
              [
                'Bosnia and Herzegovina',
                60,
                'Europe',
                'Nevesinje',
                'Nevesinje Muncipality',
                'Sarajevo Canton',
                'Nevesinje solar farm',
                'Unknown',
                'Etmax',
              ],
              [
                'Bosnia and Herzegovina',
                65,
                'Europe',
                'Ljubinje',
                'Ljubinje Muncipalty',
                'Sarajevo Canton',
                'Ljubinje solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bosnia and Herzegovina',
                28,
                'Europe',
                'Tuzla',
                'Tuzla Municipality',
                'Tuzla Canton',
                'Divkovi\u0107i solar farm',
                'Unknown',
                'Elektroprivreda Bosne i Hercegovine (EPBiH)',
              ],
              [
                'Bosnia and Herzegovina',
                47,
                'Europe',
                'Bosanski Petrovac',
                'Bosanski Petrovac Muncipalty',
                'Una-Sana Canton',
                'Bosanski Petrovac (RSV Energy) solar farm',
                'Unknown',
                'RSV Energy',
              ],
              [
                'Bosnia and Herzegovina',
                89,
                'Europe',
                'Bosanski Petrovac',
                'Bosanski Petrovac Muncipalty',
                'Una-Sana Canton',
                'Bosanski Petrovac (Promondis Energy) solar farm',
                'Unknown',
                'Promondis Energy',
              ],
              [
                'Bosnia and Herzegovina',
                60,
                'Europe',
                'Bile\u0107a',
                'Bile\u0107a Muncipality',
                'Sarajevo Canton',
                'Bile\u0107a solar farm',
                'Unknown',
                'EFT International Investments Holding',
              ],
              [
                'Bosnia and Herzegovina',
                25,
                'Europe',
                '\u010citluk',
                'Posu\u0161je Municipalty',
                'West Herzegovina Canton',
                'Posu\u0161je solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bosnia and Herzegovina',
                28,
                'Europe',
                'Tuzla',
                'Tuzla Municipality',
                'Tuzla Canton',
                'Divkovi\u0107i solar farm',
                'Unknown',
                'Elektroprivreda Bosne i Hercegovine (EPBiH)',
              ],
              [
                'Bosnia and Herzegovina',
                150,
                'Europe',
                'Unavailable',
                'Stolac Municapality',
                'Herzegovina-Neretva Canton',
                'Stolac solar farm',
                'Unknown',
                'Eco-Wat',
              ],
              [
                'Bosnia and Herzegovina',
                55,
                'Europe',
                'Trebinje',
                'Trebinje Municipality',
                'Sarajevo Canton',
                'Trebinje 3 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bosnia and Herzegovina',
                55,
                'Europe',
                'Trebinje',
                'Trebinje Municipality',
                'Sarajevo Canton',
                'Trebinje 2 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bosnia and Herzegovina',
                23,
                'Europe',
                'Tomislavgrad',
                'Tomislavgrad Municipality',
                'Canton 10',
                'Zvizdan solar farm',
                'Unknown',
                'F. L. Wind',
              ],
              [
                'Bosnia and Herzegovina',
                71,
                'Europe',
                'Trebinje',
                'Trebinje Municipality',
                'Sarajevo Canton',
                'Trebinje 1 solar farm',
                'Unknown',
                'Elektroprivreda Republike Srpske (ERS)',
              ],
              [
                'Botswana',
                50,
                'Africa',
                'Jwaneng',
                'Unavailable',
                'Unavailable',
                'Jwaneng solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Botswana',
                50,
                'Africa',
                'Selebi-Phikwe',
                'Unavailable',
                'Unavailable',
                'Selebi-Phikwe solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Botswana',
                50,
                'Africa',
                'Francistown',
                'Unavailable',
                'Unavailable',
                'Tati solar farm',
                'Unknown',
                'Solarcentury Africa; Shumba Energy',
              ],
              [
                'Botswana',
                50,
                'Africa',
                'Francistown',
                'Unavailable',
                'Unavailable',
                'Tati solar farm',
                'Unknown',
                'Solarcentury Africa; Shumba Energy',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                112,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Pirapora Solar Complex',
                'EDF Renewables',
                'EDF Renewables; Omega Gera\u00e7\u00e3o',
              ],
              [
                'Brazil',
                92,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Pirapora Solar Complex',
                'EDF Renewables',
                'EDF Renewables; Omega Gera\u00e7\u00e3o',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Aracati',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Pitombeira PV Solar Plant',
                'Alupar Investimento',
                'Alupar Investimento',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Presidente Juscelino',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Belo Horizonte',
                'Presidente Juscelino PV Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Presidente Juscelino',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Belo Horizonte',
                'Presidente Juscelino PV Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Raios Do Parana\u00edba PV Solar Plant',
                'Usina Geradora de Energia Solar Raios do Parana\u00edba',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Lagoa Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Caic\u00f3',
                'Raios Do Poeta Solar Plant',
                'Raios do Poeta Usina Geradora SPE Ltda (PIE)',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Lagoa Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Caic\u00f3',
                'Raios Do Poeta Solar Plant',
                'Raios do Poeta Usina Geradora SPE Ltda (PIE)',
                'Unknown',
              ],
              [
                'Brazil',
                65,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Riacho Da Serra PV Solar Complex',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Riacho Da Serra PV Solar Complex',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Riacho Da Serra PV Solar Complex',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                26,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Riacho Da Serra PV Solar Complex',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Riacho Da Serra PV Solar Complex',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeiro Gon\u00e7alves',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Floriano',
                'Ribeiro Gon\u00e7alves Solar Plant',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
                'Ribeiro Gon\u00e7alves Energia Solar SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                192,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Pirapora Solar Complex',
                'EDF Renewables',
                'EDF Renewables; Omega Gera\u00e7\u00e3o',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Malta',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Photovoltaic Solar Complex Of Angico And Malta',
                'Proton Energy',
                'Proton Energy',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Malta',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Photovoltaic Solar Complex Of Angico And Malta',
                'Proton Energy',
                'Proton Energy',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Pereira Barreto',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Pereira Barreto Solar Plant',
                'EDP Renov\u00e1veis Brasil; S.A. (EDPR Brasil)',
                'EDP Renov\u00e1veis, S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Unavailable',
                'Paracatu',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Unavailable',
                'Paracatu',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Unavailable',
                'Paracatu',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Unavailable',
                'Paracatu',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Solar Plant',
                'Engie Brasil Energia Sa',
                'Engie Brasil Energia Sa',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Solar Plant',
                'Engie Brasil Energia Sa',
                'Engie Brasil Energia Sa',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Solar Plant',
                'Engie Brasil Energia Sa',
                'Engie Brasil Energia Sa',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Paracatu Solar Plant',
                'Engie Brasil Energia Sa',
                'Engie Brasil Energia Sa',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Panat\u00ed Solar Plant',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                55,
                'South America',
                'Paratinga',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Paratinga PV Solar Plant',
                'Lagedo Alto Energia Ltda.',
                'Lagedo Alto Energia Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Paratinga',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Paratinga PV Solar Plant',
                'Lagedo Alto Energia Ltda.',
                'Lagedo Alto Energia Ltda.',
              ],
              [
                'Brazil',
                55,
                'South America',
                'Paratinga',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Paratinga PV Solar Plant',
                'Lagedo Alto Energia Ltda.',
                'Lagedo Alto Energia Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Paratinga',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Paratinga PV Solar Plant',
                'Lagedo Alto Energia Ltda.',
                'Lagedo Alto Energia Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Pedran\u00f3polis',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                'Pedran\u00f3polis PV Solar Complex',
                'Usina de Energia Fotovoltaica Pedran\u00f3polis S.A.',
                'Soltec Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Pedran\u00f3polis',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                'Pedran\u00f3polis PV Solar Complex',
                'Usina de Energia Fotovoltaica Pedran\u00f3polis S.A.',
                'Soltec Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Pedran\u00f3polis',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                'Pedran\u00f3polis PV Solar Complex',
                'Usina de Energia Fotovoltaica Pedran\u00f3polis S.A.',
                'Soltec Brasil Ltda.',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Pereira Barreto',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Pereira Barreto Solar Plant',
                'EDP Renov\u00e1veis Brasil; S.A. (EDPR Brasil)',
                'EDP Renov\u00e1veis, S.A.',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Pereira Barreto',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Pereira Barreto Solar Plant',
                'EDP Renov\u00e1veis Brasil; S.A. (EDPR Brasil)',
                'EDP Renov\u00e1veis, S.A.',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Pereira Barreto',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Pereira Barreto Solar Plant',
                'EDP Renov\u00e1veis Brasil; S.A. (EDPR Brasil)',
                'EDP Renov\u00e1veis, S.A.',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Pereira Barreto',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Pereira Barreto Solar Plant',
                'EDP Renov\u00e1veis Brasil; S.A. (EDPR Brasil)',
                'EDP Renov\u00e1veis, S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Parana\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Parana\u00edba Solar Project',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
                'Parana\u00edba I Projetos de Energia Solar Ltda. (PIE)',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra Talhada',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Zimba Envolvere Photovoltaic Solar Plant',
                'Serra Talhada I Energia',
                'Serra Talhada I Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Mauriti',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Mauriti Solar Plant',
                'Sunco Energy Brasil',
                'Sunco Energy Brasil',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Brasileira',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Parna\u00edba',
                'Marangatu PV Solar Complex',
                'Complexo Fotovoltaico Marangatu Solar SPE',
                'Interalli Group',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                700,
                'South America',
                'Luzi\u00e2nia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Luzi\u00e2nia Solar Power Plant',
                'Voltalia Energia do Brasil',
                'Unknown',
              ],
              [
                'Brazil',
                60,
                'South America',
                'Santa Luzia',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Luzia Solar Park',
                'Neoenergia Renov\u00e1veis',
                'Neoenergia Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                26,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                60,
                'South America',
                'Santa Luzia',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Luzia Solar Park',
                'Neoenergia Renov\u00e1veis',
                'Neoenergia Renov\u00e1veis',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Caucaia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Lavras Solar Project',
                'Lavras Geracao De Energia Electrica',
                'Canadian Solar',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Luiz Gonzaga Solar Plant',
                'Enercom Energias Renov\u00e1veis Ltda.',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Luiz Gonzaga Solar Plant',
                'Enercom Energias Renov\u00e1veis Ltda.',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                22,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Luzeiro PV Solar Generator Plant',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
                'Bom Jesus Investimentos Fotovoltaicos S.A.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Luiz Gonzaga Solar Plant',
                'Enercom Energias Renov\u00e1veis Ltda.',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ourol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Feira de Santana',
                'Ouro Solar Complex',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
                'Ourol\u00e2ndia Energia Renov\u00e1vel Sociedade Unipessoal SPE Ltda.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Lajes',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Luzi\u00e2nia',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Morada Do Sol Solar Complex',
                'Enercom Energias Renov\u00e1veis',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                44,
                'South America',
                'S\u00e3o Gon\u00e7alo do Amarante',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Mundo Novo Solar Plant',
                'Usina Geradora de Energia SGA Ltda.',
                'Usina Geradora de Energia SGA Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jo\u00e3o do Rio do Peixe',
                'Regi\u00e3o Metropolitana de Cajazeiras',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Sousa-Cajazeiras',
                'Rio Do Peixe Solar Plant',
                'Energisa Gera\u00e7\u00e3o Central Solar Rio do Peixe',
                'Energisa',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Amarante',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Mundo Novo Solar Plant',
                'Usina Geradora de Energia SGA Ltda.',
                'Usina Geradora de Energia SGA Ltda.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Amarante',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Mundo Novo Solar Plant',
                'Usina Geradora de Energia SGA Ltda.',
                'Usina Geradora de Energia SGA Ltda.',
              ],
              [
                'Brazil',
                292,
                'South America',
                'Unavailable',
                'Ribeira do Piau\u00ed',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ribeira do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Nova Olinda Solar Power Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Amarante',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Mundo Novo Solar Plant',
                'Usina Geradora de Energia SGA Ltda.',
                'Usina Geradora de Energia SGA Ltda.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Janda\u00edra',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Janda\u00edra',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                32,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                32,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                32,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                23,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                55,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                28,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Pedro Avelino',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Mendubim Solar Project',
                'Mendubim Gera\u00e7\u00e3o de Energia Ltda.',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Abaiara',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Milagres Solar Park',
                'LSBP Enerlife',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Abaiara',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Milagres Solar Park',
                'LSBP Enerlife',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Abaiara',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Milagres Solar Park',
                'LSBP Enerlife',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Abaiara',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Milagres Solar Park',
                'LSBP Enerlife',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                152,
                'South America',
                'Unavailable',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Pouso Alegre',
                'Minas Norte PV solar farm',
                'Braskem',
                'Braskem; Canadian Solar',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Lajes',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Janda\u00edra',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Janda\u00edra',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Natal',
                'Monte Verde Solar Project',
                'EDP Renov\u00e1veis Brasil S.A.',
                'EDP Renov\u00e1veis Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Abaiara',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Milagres Solar Park',
                'LSBP Enerlife',
                'Enerlife Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                36,
                'South America',
                'S\u00e3o Jo\u00e3o do Rio do Peixe',
                'Regi\u00e3o Metropolitana de Cajazeiras',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Sousa-Cajazeiras',
                'Rio Do Peixe Solar Plant',
                'Energisa Gera\u00e7\u00e3o Central Solar Rio do Peixe',
                'Energisa',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Francisco S\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'RQL solar farm',
                'Norsol Norte Energia Solar Ltd.',
                'Unknown',
              ],
              [
                'Brazil',
                54,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                75,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                80,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                80,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'N\u00e3o Informado',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                95,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Sol Do Sert\u00e3o Solar Complex',
                'Essentia Energia',
                'Essentia Energia',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Sento S\u00e9',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Sol Do S\u00e3o Francisco solar farm',
                'Unknown',
                'Brennand Energia',
              ],
              [
                'Brazil',
                68,
                'South America',
                'Curral Novo do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Picos',
                'Sol Do Piau\u00ed PV Solar Plant',
                'VTRM Energia e Participa\u00e7\u00f5es SA',
                'Votorantim Gera\u00e7\u00e3o de Energia SA; Canada Pension Plan Investment Board',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Aquiraz',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Sol Do Futuro Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Aquiraz',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Sol Do Futuro Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Aquiraz',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Sol Do Futuro Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Solid\u00e3o Solar Plant',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
                'Sol Energia Master Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1reza solar farm',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1reza solar farm',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1reza solar farm',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea de Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1rzea PV Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea de Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1rzea PV Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Xaxado Photovoltaic Solar Plant',
                'Ciranda Energias Renov\u00e1veis',
                'Ciranda Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Xaxado Photovoltaic Solar Plant',
                'Ciranda Energias Renov\u00e1veis',
                'Ciranda Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Xaxado Photovoltaic Solar Plant',
                'Ciranda Energias Renov\u00e1veis',
                'Ciranda Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                45,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'V\u00e1reza solar farm',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                45,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                42,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra Talhada',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Zimba Envolvere Photovoltaic Solar Plant',
                'Serra Talhada I Energia',
                'Serra Talhada I Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Serra Talhada',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Zimba Envolvere Photovoltaic Solar Plant',
                'Serra Talhada I Energia',
                'Serra Talhada I Energia',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Delmiro Gouveia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Arapiraca',
                'Zebu solar farm',
                'Central Geradora Fotovoltaica Zebu Ltda.',
                'Unknown',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Sol Do Cerrado Solar Project',
                'Vale S.A.',
                'Vale S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Terra Do Sol Solar Development',
                'Ecoluz',
                'Ecoluz',
              ],
              [
                'Brazil',
                91,
                'South America',
                'Tacaimb\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Caruaru',
                'Tacaimb\u00f3 solar farm',
                'AES Tiet\u00ea',
                'AES Group',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                54,
                'South America',
                'Oliveira dos Brejinhos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Terra Do Sol Solar Development',
                'Ecoluz',
                'Ecoluz',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Taboleiro Do Meio Solar Plant',
                'Brilhante Projetos SPE Ltda. (PIE)',
                'Brilhante Projetos SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Taboleiro Do Meio Solar Plant',
                'Unknown',
                'Brilhante Projetos SPE Ltda.',
              ],
              [
                'Brazil',
                22,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Taboleiro Do Meio Solar Plant',
                'Unknown',
                'Brilhante Projetos SPE Ltda.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Taboleiro Do Meio Solar Plant',
                'Unknown',
                'Brilhante Projetos SPE Ltda.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Taboleiro Do Meio Solar Plant',
                'Unknown',
                'Brilhante Projetos SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Surubim Solar Project',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda. (PIE)',
              ],
              [
                'Brazil',
                90,
                'South America',
                'Sobral',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Sobral',
                'Sobral solar farm',
                'Usina Fotovoltaica Sobral I Spe Ltda',
                'Unknown',
              ],
              [
                'Brazil',
                35,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Sobral Photovoltaic Solar Power Plant',
                'Sobral I Solar Energia SPE Ltda (PIE)',
                'Naturgy',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Casa Nova',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Sobrado solar farm',
                'Proton Energy Participa\u00e7\u00f5es S.A.',
                'Proton Energy Participa\u00e7\u00f5es S.A.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Flores',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'S\u00e3o Pedro E Paulo solar farm',
                'S\u00e3o Pedro e Paulo Energia SPE S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Flores',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'S\u00e3o Pedro E Paulo solar farm',
                'S\u00e3o Pedro e Paulo Energia SPE S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'S\u00e3o Jo\u00e3o Photovoltaic Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                23,
                'South America',
                'Flores',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'S\u00e3o Pedro E Paulo solar farm',
                'S\u00e3o Pedro e Paulo Energia SPE S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'S\u00e3o Pedro Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Trairi',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Serra Do Mato Solar Park',
                'Usina Fotovoltaica Serra do Mato',
                'Unknown',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Trairi',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Serra Do Mato Solar Park',
                'Usina Fotovoltaica Serra do Mato',
                'Unknown',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Trairi',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Serra Do Mato Solar Park',
                'Usina Fotovoltaica Serra do Mato',
                'Unknown',
              ],
              [
                'Brazil',
                54,
                'South America',
                'Trairi',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Fortaleza',
                'Serra Do Mato Solar Park',
                'Usina Fotovoltaica Serra do Mato',
                'Unknown',
              ],
              [
                'Brazil',
                60,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                210,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                34,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'S\u00e3o Pedro Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                43,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Salgueiro Solar Park',
                'Canadian Solar',
                'Canadian Solar',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Salgueiro Solar Park',
                'Canadian Solar',
                'Canadian Solar',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Terra Nova',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Salgueiro Solar Park',
                'Canadian Solar',
                'Canadian Solar',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                46,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                35,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                35,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                35,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                43,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                43,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                43,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                43,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                35,
                'South America',
                'S\u00e3o Gon\u00e7alo do Gurgu\u00e9ia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'S\u00e3o Gon\u00e7alo Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                836,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Rosa De Jeric\u00f3 Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Serrita',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Serrita solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sky Arinos Solar Project',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
                'Sky Energy Arinos Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Siti\u00e1 solar farm',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'S\u00e3o Mamede',
                'Regi\u00e3o Metropolitana de Patos',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Sky S\u00e3o Mamede Solar Project',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
                'Sky Energy S\u00e3o Mamede Projeto Solar SPE Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Serra do Mel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Serra Do Mel Solar Plant',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Jaguaretama',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Siti\u00e1 solar farm',
                'Ser Sistemas de Energia Renovavel Ltda.',
                'Ser Sistemas de Energia Renovavel Ltda.',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Serrita',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Petrolina',
                'Serrita solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                117,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Sert\u00e3o Solar Barreiras Complex',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Jo\u00e3o Costa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Sert\u00e3o solar farm',
                'Global Power Generation (GPG)',
                'Naturgy',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                38,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                41,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Sert\u00e3o Veredas Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Francisco S\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'RQL solar farm',
                'Norsol Norte Energia Solar Ltd.',
                'Unknown',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                25,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                330,
                'South America',
                'Unavailable',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Pouso Alegre',
                'Casablanca PV solar farm',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Cassil\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Cassil\u00e2ndia Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Cassil\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Cassil\u00e2ndia Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Cassil\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Cassil\u00e2ndia Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Cassil\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Cassil\u00e2ndia Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                49,
                'South America',
                'Cassil\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Campo Grande',
                'Cassil\u00e2ndia Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Castilho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Castilho Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Castilho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Castilho Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Castilho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Castilho Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Castilho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Ara\u00e7atuba',
                'Castilho Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'BRX Jana\u00faba Solar Plant',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
                'Brenergy Brasil Energia Sustent\u00e1vel Ambiental Ltda. (PIE)',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                24,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Bom Jesus Da Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Bom Jesus Da Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                24,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Bom Jesus Da Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Bom Jesus Da Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                35,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                190,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Ciranda Solar Plant',
                'Copel',
                'Copel',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Bom Nome Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Bom Nome Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Boqueir\u00e3o Solar Complex',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Boqueir\u00e3o Solar Complex',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Boqueir\u00e3o Solar Complex',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Boqueir\u00e3o Solar Complex',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
                'Motrice Solu\u00e7\u00f5es em Energia Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Br\u00edgida Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                40,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Br\u00edgida Solar Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                36,
                'South America',
                'Ic\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Iguatu',
                'Bom Lugar Solar Park',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
                'Lightsource Bom Lugar Gera\u00e7\u00e3o de Energia Ltda.',
              ],
              [
                'Brazil',
                61,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Ciranda Solar Plant',
                'Copel',
                'Copel',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Rio Alto Energia; Nordic Power Partners',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Rio Alto Energia; Nordic Power Partners',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Petrol\u00e2ndia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Dracena',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Presidente Prudente',
                'Dracena PV Solar Power Plant',
                'Total Eren',
                'Total S.A.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Dracena',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Presidente Prudente',
                'Dracena PV Solar Power Plant',
                'Total Eren',
                'Total S.A.',
              ],
              [
                'Brazil',
                85,
                'South America',
                'Casa Nova',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Emtep solar farm',
                'Unknown',
                'EMTEP Servi\u00e7os T\u00e9cnicos de Petr\u00f3leo Ltda',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 17 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 18 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 19 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                29,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 20 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                29,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 21 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                32,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'ETESA 22 solar farm',
                'Celeo S\u00e3o Jo\u00e3o do Piau\u00ed S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Dracena',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Presidente Prudente',
                'Dracena PV Solar Power Plant',
                'Total Eren',
                'Total S.A.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Rio Alto Energia; Nordic Power Partners',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
              ],
              [
                'Brazil',
                27,
                'South America',
                'Coremas',
                'Regi\u00e3o Metropolitana do Vale do Pianc\u00f3',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos',
                'Coremas Solar Complex',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
                'Coremas Gera\u00e7\u00e3o de Energia SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Coromandel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Coromandel solar farm',
                'Usina de Energia Fotovoltaica de Coromandel S.A. (PIE)',
                'Usina de Energia Fotovoltaica de Coromandel S.A. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Coromandel',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Coromandel solar farm',
                'Usina de Energia Fotovoltaica de Coromandel S.A. (PIE)',
                'Usina de Energia Fotovoltaica de Coromandel S.A. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Xique',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Cristais PV Solar Generator',
                'CPFL Energias Renov\u00e1veis S.A.',
                'CPFL Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Cristalina',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Cristalina solar farm',
                'Enercom Renov\u00e1veis',
                'Enercom Goi\u00e1s Gera\u00e7\u00e3o Energia LTDA',
              ],
              [
                'Brazil',
                81,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Delio Bernardino PV Solar Plant',
                'Delio Bernardino Holdings SA',
                'GDE Energia',
              ],
              [
                'Brazil',
                309,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Delio Bernardino PV Solar Plant',
                'Nena Bernardino Holdings SA',
                'GDE Energia',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Floresta',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Dourado PV Solar Complex',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
                'Geradora de Energia Quinturar\u00e9 SPE Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Cristalina',
                'Regi\u00e3o Integrada de Desenvolvimento do Distrito Federal e Entorno',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Luzi\u00e2nia-\u00c1guas Lindas de Goi\u00e1s',
                'Cristalina solar farm',
                'Enercom Renov\u00e1veis',
                'Enercom Goi\u00e1s Gera\u00e7\u00e3o Energia LTDA',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Quixer\u00e9',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Apodi solar farm',
                'Scatec Solar',
                'Scatec Solar; Equinor',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Quixer\u00e9',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Apodi solar farm',
                'Scatec Solar',
                'Scatec Solar; Equinor',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Quixer\u00e9',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Apodi solar farm',
                'Scatec Solar',
                'Scatec Solar; Equinor',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Quixer\u00e9',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Apodi solar farm',
                'Scatec Solar',
                'Scatec Solar; Equinor',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Aratinga solar farm',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Aratinga solar farm',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Aratinga solar farm',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Aratinga solar farm',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
              ],
              [
                'Brazil',
                45,
                'South America',
                'Arax\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Uberaba',
                'Arax\u00e1 solar farm',
                'Usina de Energia Fotovoltaica Arax\u00e1 S.A.',
                'Usina de Energia Fotovoltaica Arax\u00e1 S.A.',
              ],
              [
                'Brazil',
                45,
                'South America',
                'Arax\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Uberaba',
                'Arax\u00e1 solar farm',
                'Usina de Energia Fotovoltaica Arax\u00e1 S.A.',
                'Usina de Energia Fotovoltaica Arax\u00e1 S.A.',
              ],
              [
                'Brazil',
                337,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos PV Solar Power Plant',
                'Voltalia Energia do Brasil',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Aratinga solar farm',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
                'Aratinga Gera\u00e7\u00e3o Solar Energia Ltda. (PIE)',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Currais Novos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Caic\u00f3',
                'Acau\u00e3 PV Solar Power Plant',
                'Acau\u00e3 Solar Energia SPE Ltda.',
                'Acau\u00e3 Solar Energia SPE Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ouroeste',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                '\u00c1gua Vermelha solar farm',
                'AGV Solar Geradora de Energia S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Ouroeste',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                '\u00c1gua Vermelha solar farm',
                'AGV Solar Geradora de Energia S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Tabuleiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Limoeiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Tabuleiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Limoeiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Tabuleiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Limoeiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Limoeiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Limoeiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                46,
                'South America',
                'Parnagu\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Corrente-Bom Jesus',
                'Altitude PV Solar Plant',
                'Riacho da Serra Energia S.A.',
                'Riacho da Serra Energia S.A.',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Tabuleiro do Norte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Alex Solar Complex',
                'Elera Renov\u00e1veis',
                'Elera Renovaveis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Batalha Photovoltaic Solar Plant',
                'Engie Brasil Energia Sa',
                'Engie Brasil Energia Sa',
              ],
              [
                'Brazil',
                25,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                25,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                45,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Belvedere PV Solar Power Plant',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
              ],
              [
                'Brazil',
                45,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Belvedere PV Solar Power Plant',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Belvedere PV Solar Power Plant',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
                'Usina de Energia Fotovoltaica Belvedere SPE Ltda.',
              ],
              [
                'Brazil',
                5700,
                'South America',
                'Unavailable',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ber\u00e7o Das Gerais Solar Park',
                'Aurora Energias Renov\u00e1veis',
                'Aurora Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                23,
                'South America',
                'Ouroeste',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Uberaba',
                'Boa Hora Solar Plant',
                'AES Tiet\u00ea',
                'AES Brasil',
              ],
              [
                'Brazil',
                23,
                'South America',
                'Ouroeste',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                'Boa Hora Solar Plant',
                'AES Tiet\u00ea',
                'AES Brasil',
              ],
              [
                'Brazil',
                23,
                'South America',
                'Ouroeste',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Jos\u00e9 do Rio Preto',
                'Boa Hora Solar Plant',
                'AES Tiet\u00ea',
                'AES Brasil',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Paracatu',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Boa Sorte Solar Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                65,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Belmonte Solar Project',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'A\u00e7u',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Ass\u00fa Solar Farm (Brazil)',
                'Unknown',
                'Central Fotovoltaica Assu S.A.',
              ],
              [
                'Brazil',
                37,
                'South America',
                'Itagua\u00e7u da Bahia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Assuru\u00e1 Ps Solar Plant',
                'SPE Assuru\u00e1 Geradora de Energia Solar',
                'SPE Assuru\u00e1 Geradora de Energia Solar',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Banabui\u00fa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Quixad\u00e1',
                'Banabui\u00fa solar farm',
                'FRV Brasil',
                'Unknown',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Barreiras',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Barreiras Solar Complex',
                'Celeo Redes Brasil S.A.',
                'Celeo Redes Brasil S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Arinos',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Arinos Solar Complex',
                'Voltalia Energia do Brasil Ltda.',
                'Voltalia Energia do Brasil Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                61,
                'South America',
                'S\u00e3o Jos\u00e9 do Belmonte',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Serra Talhada',
                'Ciranda Solar Plant',
                'Copel',
                'Copel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                60,
                'South America',
                'Jo\u00e3o Dourado',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Irec\u00ea Solar Project',
                'Iresol Energia Solar',
                'Unknown',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'CEI Solar Empreendimentos Energ\u00e9ticos SA',
                'Canadian Solar',
              ],
              [
                'Brazil',
                74,
                'South America',
                'Jo\u00e3o Dourado',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Irec\u00ea',
                'Irec\u00ea Solar Project',
                'Iresol Energia Solar',
                'Unknown',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'CEI Solar Empreendimentos Energ\u00e9ticos SA',
                'Canadian Solar',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                22,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'CEI Solar Empreendimentos Energ\u00e9ticos SA',
                'Canadian Solar',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Guimar\u00e2nia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Guimarania Solar Plant',
                'Global Power Generation (GPG)',
                'Naturgy',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Mossor\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Guzer\u00e1 solar farm',
                'Guzer\u00e1 Solar Energia Ltda.',
                'Guzer\u00e1 Solar Energia Ltda.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Mossor\u00f3',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Guzer\u00e1 solar farm',
                'Guzer\u00e1 Solar Energia Ltda.',
                'Guzer\u00e1 Solar Energia Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                29,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Horizonte Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                29,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Horizonte Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Horizonte Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                48,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Irapuru Solar PV Plant',
                'Solar Irapuru Geracao e Comercializacao de Energia Eletrica',
                'Unknown',
              ],
              [
                'Brazil',
                50,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'H\u00e9lio Valgas Solar Power Plant',
                'Solatio Brasil',
                'Solatio Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Guimar\u00e2nia',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Patos de Minas',
                'Guimarania Solar Plant',
                'Global Power Generation (GPG)',
                'Naturgy',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Juazeiro',
                'BR',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Juazeiro',
                'BR',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Juazeiro',
                'BR',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Juazeiro',
                'BR',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                47,
                'South America',
                'Juazeiro',
                'BR',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Juazeiro Solar PV Plant',
                'Atlas Brasil Comercializadora de Energia LTDA.',
                'Atlas Brasil Comercializadora de Energia LTDA.',
              ],
              [
                'Brazil',
                44,
                'South America',
                'Guanambi',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Lagedo Alto solar farm',
                'Lagedo Alto Energia Ltda.',
                'Lagedo Alto Energia Ltda.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 da Lagoa Tapada',
                'Regi\u00e3o Metropolitana de Sousa',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Sousa-Cajazeiras',
                'Lagoa Solar Park',
                'Central Solar Lagoa S.A.',
                'EDP Renov\u00e1veis',
              ],
              [
                'Brazil',
                39,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Lapa Solar Park',
                'Enel Green Power Nova Lapa Solar S.A',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
              ],
              [
                'Brazil',
                39,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Lapa Solar Park',
                'Enel Green Power Nova Lapa Solar S.A',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Bom Jesus da Lapa',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Guanambi',
                'Lapa Solar Park',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Pirapora',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Lar Do Sol Solar Plant',
                'Solatio Energia',
                'Solatio Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'S\u00e3o Jos\u00e9 da Lagoa Tapada',
                'Regi\u00e3o Metropolitana de Sousa',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Sousa-Cajazeiras',
                'Lagoa Solar Park',
                'Central Solar Lagoa S.A.',
                'EDP Renov\u00e1veis',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                20,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                40,
                'South America',
                'Ja\u00edba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Ja\u00edba PV Solar Plant',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
                'Ja\u00edba C Energias Renov\u00e1veis S.A.',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                50,
                'South America',
                'Jana\u00faba',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Jana\u00faba Solar Complex',
                'Elera Renov\u00e1veis',
                'Brookfield Asset Mgmt Inc',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Guaimb\u00ea',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mar\u00edlia',
                'Guaimb\u00e9 Solar Park',
                'Guaimbe Solar Holding SA',
                'AES Brasil',
              ],
              [
                'Brazil',
                28,
                'South America',
                'Tabocas do Brejo Velho',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Barreiras',
                'Ituverava Solar Plant',
                'Enel Green Power Brasil Participa\u00e7\u00f5es (EGPB)',
                'Enel',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Guaimb\u00ea',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mar\u00edlia',
                'Guaimb\u00e9 Solar Park',
                'Guaimbe Solar Holding SA',
                'AES Brasil',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Guaimb\u00ea',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mar\u00edlia',
                'Guaimb\u00e9 Solar Park',
                'Guaimbe Solar Holding SA',
                'AES Brasil',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Francisco S\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Francisco S\u00e1 solar farm',
                'Solatio Brasil Gest\u00e3o de Projetos Ltda.',
                'Solatio Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Francisco S\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Francisco S\u00e1 solar farm',
                'Solatio Brasil Gest\u00e3o de Projetos Ltda.',
                'Solatio Energia',
              ],
              [
                'Brazil',
                22,
                'South America',
                'Areia Branca',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Floresta Photovoltaic Solar Power Plant',
                'STEAG Energy Services do Brasil',
                'Solairedirect',
              ],
              [
                'Brazil',
                32,
                'South America',
                'Areia Branca',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Floresta Photovoltaic Solar Power Plant',
                'STEAG Energy Services do Brasil',
                'Solairedirect',
              ],
              [
                'Brazil',
                32,
                'South America',
                'Areia Branca',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mossor\u00f3',
                'Floresta Photovoltaic Solar Power Plant',
                'STEAG Energy Services do Brasil',
                'Solairedirect',
              ],
              [
                'Brazil',
                29,
                'South America',
                'Agrestina',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Caruaru',
                'Fazenda Esmeralda solar farm',
                'Esmeralda Energias Renov\u00e1veis S.A.',
                'Proton Energy',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Sobradinho',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Fazenda Boa Esperan\u00e7a PV solar farm',
                'Enercom Energias Renov\u00e1veis Ltda. (PIE)',
                'Enercom Energias Renov\u00e1veis',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Francisco S\u00e1',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Francisco S\u00e1 solar farm',
                'Solatio Brasil Gest\u00e3o de Projetos Ltda.',
                'Solatio Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Gameleira PV solar farm',
                'Gameleira Energias Renovaveis S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Gameleira PV solar farm',
                'Gameleira Energias Renovaveis S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Gameleira PV solar farm',
                'Gameleira Energias Renovaveis S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                33,
                'South America',
                'Milagres',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro do Norte',
                'Gameleira PV solar farm',
                'Gameleira Energias Renovaveis S.A.',
                'Unknown',
              ],
              [
                'Brazil',
                75,
                'South America',
                'S\u00e3o Jos\u00e9 do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Graviola Solar Plant',
                'Graviola Consortium',
                'Powertis',
              ],
              [
                'Brazil',
                75,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Graviola Solar Plant',
                'Graviola Consortium',
                'Powertis',
              ],
              [
                'Brazil',
                75,
                'South America',
                'S\u00e3o Jo\u00e3o do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Graviola Solar Plant',
                'Graviola Consortium',
                'Powertis',
              ],
              [
                'Brazil',
                25,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Gsii Solar Plant',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
              ],
              [
                'Brazil',
                25,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Gsii Solar Plant',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
              ],
              [
                'Brazil',
                30,
                'South America',
                'V\u00e1rzea da Palma',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Montes Claros',
                'Gsii Solar Plant',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
                'Grande Sert\u00e3o de Energia Fotovoltaica II Ltda',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Guaimb\u00ea',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mar\u00edlia',
                'Guaimb\u00e9 Solar Park',
                'Guaimbe Solar Holding SA',
                'AES Brasil',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                75,
                'South America',
                'S\u00e3o Jos\u00e9 do Piau\u00ed',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de S\u00e3o Raimundo Nonato',
                'Graviola Solar Plant',
                'Graviola Consortium',
                'Powertis',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brazil',
                30,
                'South America',
                'Guaimb\u00ea',
                'Unavailable',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Mar\u00edlia',
                'Guaimb\u00e9 Solar Park',
                'Guaimbe Solar Holding SA',
                'AES Brasil',
              ],
              [
                'Brazil',
                31,
                'South America',
                'Juazeiro',
                'Regi\u00e3o Administrativa Integrada de Desenvolvimento do Polo Petrolina e Juazeiro',
                'Regi\u00e3o Geogr\u00e1fica Intermedi\u00e1ria de Juazeiro',
                'Futura Solar Complex',
                'Focus Energia',
                'Focus Energia',
              ],
              [
                'Brunei',
                30,
                'Asia',
                'Kampong Sungai Akar',
                'Unavailable',
                'Brunei-Muara',
                'Kampung Sungai Akar solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bulgaria',
                110,
                'Europe',
                'Devnya',
                'Devnya Municipality',
                'Unavailable',
                'Devnya solar farm',
                'Unknown',
                '4B Solar',
              ],
              [
                'Bulgaria',
                150,
                'Europe',
                'Apriltsi',
                'Pazardjik Municipality',
                'Unavailable',
                'Apriltsi Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Bulgaria',
                21,
                'Europe',
                'Veliko Tarnovo',
                'Veliko Tarnovo',
                'Unavailable',
                'ASM PV solar farm',
                'SDN Company Ltd. [50%]; Korea South East Power Co. [50%]',
                'SDN Company Ltd. [50%]; Korea South East Power Co. [50%]',
              ],
              [
                'Bulgaria',
                30,
                'Europe',
                'Stara Zagora',
                'Stara Zagora',
                'Unavailable',
                'Cherganovo solar farm',
                'ABB',
                'Haeron Solar',
              ],
              [
                'Bulgaria',
                65,
                'Europe',
                'Devnya',
                'Devnya Municipality',
                'Unavailable',
                'Devnya solar farm',
                'Unknown',
                '4B Solar',
              ],
              [
                'Bulgaria',
                65,
                'Europe',
                'Dimitrovgrad',
                'Dimitrovgrad Municipality',
                'Unavailable',
                'Dimitrovgrad solar farm',
                'Unknown',
                'Enery Development',
              ],
              [
                'Bulgaria',
                21,
                'Europe',
                'Unavailable',
                'Elhovo Municipality',
                'Unavailable',
                'Granitovo solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'Bulgaria',
                400,
                'Europe',
                '\u041an\u0456zh\u043evn\u0456k',
                'Haskovo municipality',
                'Unavailable',
                'Haskovo solar farm',
                'Unknown',
                'Enery BG 1',
              ],
              [
                'Bulgaria',
                60,
                'Europe',
                'Plovdiv',
                'Plovdiv',
                'Unavailable',
                'Karadzhalovo solar farm',
                'NOMAC Bulgaria',
                'Enery Development',
              ],
              [
                'Bulgaria',
                25,
                'Europe',
                'Golyamo Dryanovo',
                'Kazanlak Municipality',
                'Unavailable',
                'Kazanlak solar farm',
                'BCI JSC',
                'BCI JSC',
              ],
              [
                'Bulgaria',
                21,
                'Europe',
                'Veliko Tarnovo',
                'Veliko Tarnovo',
                'Unavailable',
                'PES PV solar farm',
                'RES',
                'SDN Company Ltd. [50%]; Korea South East Power Co. [50%]',
              ],
              [
                'Bulgaria',
                51,
                'Europe',
                'Pleven',
                'Pleven',
                'Unavailable',
                'Pobeda solar farm',
                'ABB',
                'Haeron Solar',
              ],
              [
                'Bulgaria',
                26,
                'Europe',
                'Golyamo Dryanovo',
                'Kazanlak Municipality',
                'Unavailable',
                'Kazanlak solar farm',
                'BCI JSC',
                'BCI JSC',
              ],
              [
                'Bulgaria',
                250,
                'Europe',
                'Tenovo',
                'Tundja Municipality',
                'Unavailable',
                'Tenovo solar farm',
                'Unknown',
                'EURA Energy',
              ],
              [
                'Bulgaria',
                80,
                'Europe',
                'Silistra',
                'Silistra Municipality',
                'Unavailable',
                'Silistra solar farm',
                'Unknown',
                'AES Solar',
              ],
              [
                'Burkina Faso',
                20,
                'Africa',
                'Kondougou',
                'Unavailable',
                'Unavailable',
                'Koudougou solar farm',
                'Unknown',
                'Burkina Faso Ministry of Energy',
              ],
              [
                'Burkina Faso',
                38,
                'Africa',
                'Bobo-Dioulasso',
                'Unavailable',
                'Unavailable',
                'Kodeni solar farm',
                'Engie',
                'Africa REN',
              ],
              [
                'Burkina Faso',
                30,
                'Africa',
                'Nagr\u00e9ongo',
                'Unavailable',
                'Unavailable',
                'Nagr\u00e9ongo solar farm',
                'GreenYellow',
                'GreenYellow S.A.S. [95%]; Africa Energy Company [5%]',
              ],
              [
                'Burkina Faso',
                30,
                'Africa',
                'P\u00e2',
                'Unavailable',
                'P\u00e2 Department',
                'P\u00e2 Solar Mouhon solar farm',
                'Unknown',
                'Urbasolar',
              ],
              [
                'Burkina Faso',
                42,
                'Africa',
                'Ouagadougou',
                'Unavailable',
                'Unavailable',
                'Yaleen solar farm',
                'Unknown',
                'Burkina Faso Ministry of Energy',
              ],
              [
                'Burkina Faso',
                24,
                'Africa',
                'Tenkodogo',
                'Unavailable',
                'Tenkodogo Deaprtment',
                'Tenkodogo solar farm',
                'Elsewedy Electric',
                'MIHIA Holding [70%]; SYSCOM Network [30%]',
              ],
              [
                'Burkina Faso',
                24,
                'Africa',
                'Zano',
                'Unavailable',
                'Tenkodogo Department',
                'Zano solar farm',
                'Unknown',
                'Quadran Burkina Faso S.A',
              ],
              [
                'Burkina Faso',
                23,
                'Africa',
                'Ouarkay',
                'Unavailable',
                'Unavailable',
                'Zina solar farm',
                'Zina Solaire S.A.',
                'Windinga S.A',
              ],
              [
                'Burkina Faso',
                33,
                'Africa',
                'Ouagadougou',
                'Unavailable',
                'Unavailable',
                'Zagtouli Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Cambodia',
                20,
                'Asia',
                'Bavet City',
                'Unavailable',
                'Unavailable',
                'Bavet solar farm',
                'Green Sustainable Ventures (Cambodia) Company Limited (GSV)',
                'Green Sustainable Ventures (Cambodia) Company Limited (GSV)',
              ],
              [
                'Cambodia',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cambodia National Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Cambodia',
                80,
                'Asia',
                'Unavailable',
                'Odongk',
                'Oudong',
                'Kampong Speu solar farm',
                'Unknown',
                'JinkoSolar; SchneiTec Renewables Company Limited',
              ],
              [
                'Cambodia',
                20,
                'Asia',
                'Unavailable',
                'Odongk',
                'Oudong',
                'Kampong Speu solar farm',
                'Unknown',
                'SchneiTec Renewables Company Limited',
              ],
              [
                'Cambodia',
                150,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Koh Kong solar farm',
                'Unknown',
                'Omni Navitas',
              ],
              [
                'Cambodia',
                20,
                'Asia',
                'Unavailable',
                'Monorom',
                'Svay Teap',
                'Monorom solar farm',
                'Unknown',
                'Green Sustainable Ventures (Cambodia) Company Limited (GSV)',
              ],
              [
                'Cambodia',
                30,
                'Asia',
                'Ansar Kdam',
                'Sna Ansa',
                'Krakor',
                'Pursat solar farm',
                'Unknown',
                'SchneiTec Renewables Company Limited',
              ],
              [
                'Cambodia',
                30,
                'Asia',
                'Ansar Kdam',
                'Sna Ansa',
                'Krakor',
                'Pursat solar farm',
                'Unknown',
                'SchneiTec Renewables Company Limited',
              ],
              [
                'Cambodia',
                60,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cambodia National Solar Park',
                'Prime Road Alternative (Cambodia) Company Limited (PRAC)',
                'Prime Road Power PCL (Prime Road)',
              ],
              [
                'Cambodia',
                26,
                'Asia',
                'Bavet City',
                'Unavailable',
                'Unavailable',
                'Svay Rieng solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Cambodia',
                60,
                'Asia',
                'Unavailable',
                'Taing Krasaing',
                'Toek Phos',
                'Toek Phos solar farm',
                'SchneiTec Renewables Company Limited',
                'SchneiTec Renewables Company Limited',
              ],
              [
                'Cambodia',
                39,
                'Asia',
                'Sisophon',
                'Unavailable',
                'Unavailable',
                'Serie Saophoan solar farm',
                'Unknown',
                'B.Grimm Solar Power',
              ],
              [
                'Cambodia',
                60,
                'Asia',
                'Unavailable',
                'Anlong Run',
                'Thma Koul',
                'Battambang solar farm',
                'Risen Energy Company Limited',
                'Total Eren',
              ],
              [
                'Cameroon',
                72,
                'Africa',
                'Mbalmayo',
                'Mbam-et-Kim',
                "Nyong-et-So'o Department",
                'South Grid solar farm',
                'JCM Greenquest Corporation',
                'JCM Greenquest Corporation',
              ],
              [
                'Cameroon',
                20,
                'Africa',
                'Lagdo',
                'Mayo-Rey',
                'B\u00e9nou\u00e9 Department',
                'Lagdo solar farm',
                'Sinohydro',
                'Sinohydro',
              ],
              [
                'Cameroon',
                30,
                'Africa',
                'Garoua',
                'B\u00e9nou\u00e9',
                'B\u00e9nou\u00e9 Department',
                'Garoua solar farm',
                'Unknown',
                'EB Solaire',
              ],
              [
                'Canada',
                50,
                'North America',
                'Windsor',
                'Windsor',
                'Southwestern Ontario',
                'Windsor Solar Project',
                'Samsung Renewable Energy',
                'Samsung Renewable Energy; Connor, Clark & Lunn Infrastructure',
              ],
              [
                'Canada',
                20,
                'North America',
                'County of Warner',
                'County of Warner',
                'Unavailable',
                'Wrentham Solar Project',
                'Solar Krafte',
                'Solar Krafte',
              ],
              [
                'Canada',
                20,
                'North America',
                'County of Warner',
                'County of Warner',
                'Unavailable',
                'Wrentham Solar Project',
                'Solar Krafte',
                'Solar Krafte',
              ],
              [
                'Canada',
                465,
                'North America',
                'Lomond',
                'Vulcan County',
                'Unavailable',
                'Travers Solar',
                'Greengate Power Corporation',
                'Copenhagen Infrastructure Partners; Greengate Power',
              ],
              [
                'Canada',
                23,
                'North America',
                'County of Newell',
                'County of Newell',
                'Unavailable',
                'Suffield Cypress solar farm',
                'BluEarth Renewables',
                'BluEarth Renewables',
              ],
              [
                'Canada',
                55,
                'North America',
                'Lethbridge County',
                'Lethbridge County',
                'Unavailable',
                'Vulcan Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Canada',
                25,
                'North America',
                'Kneehill County',
                'Kneehill County',
                'Unavailable',
                'Kneehill Solar Generation Facility',
                'Capstone',
                'Capstone',
              ],
              [
                'Canada',
                22,
                'North America',
                'Lethbridge County',
                'Lethbridge County',
                'Unavailable',
                'Vulcan Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Canada',
                29,
                'North America',
                'Metiskow',
                'Town of Provost',
                'Unavailable',
                'Metiskow Solar Park',
                'Aura Power',
                'Aura Power',
              ],
              [
                'Canada',
                25,
                'North America',
                'Starland County',
                'Starland County',
                'Unavailable',
                'Michichi Solar',
                'Capstone',
                'Capstone',
              ],
              [
                'Canada',
                51,
                'North America',
                'Consort',
                'Special Area No. 4',
                'Unavailable',
                'Monitor Solar Park',
                'Aura Power',
                'Aura Power',
              ],
              [
                'Canada',
                20,
                'North America',
                'St. Clair',
                'Lambton County',
                'Southwestern Ontario',
                'Moore Solar',
                'NextEra Energy Canadian Operating Services',
                'Cordelio Power [51%]; Axium Infrastructure [49%]',
              ],
              [
                'Canada',
                44,
                'North America',
                'Nanticoke',
                'Haldimand County',
                'Southwestern Ontario',
                'Nanticoke solar farm',
                'Ontario Power Generation; Six Nations of the Grand River Development Corporation; Mississaugas of the Credit First Nation',
                'Ontario Power Generation; Six Nations of the Grand River Development Corporation; Mississaugas of the Credit First Nation',
              ],
              [
                'Canada',
                300,
                'North America',
                'Medicine Hat',
                'Medicine Hat (city)',
                'Unavailable',
                'Saamis Solar',
                'DP Energy',
                'DP Energy',
              ],
              [
                'Canada',
                80,
                'North America',
                'Sarnia',
                'Lambton County',
                'Southwestern Ontario',
                'Sarnia Solar',
                'First Solar',
                'Enbridge [51%]; First Solar [49%]',
              ],
              [
                'Canada',
                25,
                'North America',
                'Mono',
                'Dufferin County',
                'Central Ontario',
                'Sheldon Solar',
                'Suncor; Canadian Solar',
                'Suncor; Canadian Solar',
              ],
              [
                'Canada',
                23,
                'North America',
                'Sault Ste. Marie',
                'Algoma District',
                'Northeastern Ontario',
                'Solar Sault Ste. Marie',
                'EDF Renewables',
                'Fengate Real Asset',
              ],
              [
                'Canada',
                35,
                'North America',
                'Sault Ste. Marie',
                'Algoma District',
                'Northeastern Ontario',
                'Solar Sault Ste. Marie',
                'EDF Renewables',
                'Fengate Real Asset',
              ],
              [
                'Canada',
                20,
                'North America',
                'St. Clair',
                'Lambton County',
                'Southwestern Ontario',
                'Sombra Solar Energy Centre',
                'NextEra Energy Canadian Operating Services',
                'Cordelio Power [51%]; Axium Infrastructure [49%]',
              ],
              [
                'Canada',
                50,
                'North America',
                'Southgate',
                'Grey County',
                'Southwestern Ontario',
                'Southgate Solar',
                'Samsung Renewable Energy',
                'Samsung Renewable Energy; Connor, Clark & Lunn Infrastructure',
              ],
              [
                'Canada',
                30,
                'North America',
                'Cardston County',
                'Cardston County',
                'Unavailable',
                'Spring Coulee Solar Project',
                'Solar Krafte',
                'Solar Krafte',
              ],
              [
                'Canada',
                33,
                'North America',
                'East Hawkesbury',
                'Prescott and Russell Counties',
                'Eastern Ontario',
                'Stardale solar farm',
                'Innergex',
                'Innergex',
              ],
              [
                'Canada',
                41,
                'North America',
                'Unavailable',
                'Strathmore (town)',
                'Unavailable',
                'Strathmore Solar',
                'Capital Power',
                'Capital Power',
              ],
              [
                'Canada',
                100,
                'North America',
                'Loyalist',
                'Lennox and Addington County',
                'Eastern Ontario',
                'Kingston Solar',
                'Samsung Renewable Energy; Six Nations of the Grand River',
                'Samsung Renewable Energy [50%]; Connor, Clark & Lunn Infrasture [50%]',
              ],
              [
                'Canada',
                29,
                'North America',
                'Chauvin',
                'Municipal District of Wainwright',
                'Unavailable',
                'Kilarney Lake Solar Park',
                'Aura Power',
                'Aura Power',
              ],
              [
                'Canada',
                54,
                'North America',
                'Stone Mills',
                'Lennox and Addington County',
                'Eastern Ontario',
                'Loyalist Solar',
                'BluEarth Renewables',
                'BluEarth Renewables; Mohawks of the Bay of Quinte',
              ],
              [
                'Canada',
                25,
                'North America',
                'Red Deer County',
                'Red Deer County',
                'Unavailable',
                'Innisfail Solar',
                'Elemental Energy',
                'Elemental Energy',
              ],
              [
                'Canada',
                20,
                'North America',
                'London',
                'Middlesex County',
                'Southwestern Ontario',
                'Abw Solar Belmont',
                'First Solar',
                'ABW Partnership',
              ],
              [
                'Canada',
                20,
                'North America',
                'Walpole',
                'Haldimand County',
                'Southwestern Ontario',
                'Abw Solar Walpole',
                'First Solar',
                'ABW Partnership',
              ],
              [
                'Canada',
                120,
                'North America',
                'Leduc County',
                'Leduc County',
                'Unavailable',
                'Airport City Solar Project',
                'Alpin Sun',
                'Alpin Solar',
              ],
              [
                'Canada',
                20,
                'North America',
                'Essex County',
                'Essex County',
                'Southwestern Ontario',
                'Amherstburg Solar Park',
                'Capstone',
                'Capstone',
              ],
              [
                'Canada',
                23,
                'North America',
                'West Carleton',
                'Ottawa',
                'Eastern Ontario',
                'Arnprior solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Canada',
                78,
                'North America',
                'Taber',
                'Municipal District of Taber',
                'Unavailable',
                'Big Bend Solar Park',
                'Aura Power',
                'Aura Power; IB Vogt',
              ],
              [
                'Canada',
                39,
                'North America',
                'County of Forty Mile',
                'County of Forty Mile',
                'Unavailable',
                'Burdett Solar',
                'BluEarth Renewables',
                'BluEarth Renewables',
              ],
              [
                'Canada',
                25,
                'North America',
                'Taber',
                'Municipal District of Taber',
                'Unavailable',
                'Canadian Hull solar farm',
                'RWE Renewables',
                'RWE Renewables',
              ],
              [
                'Canada',
                22,
                'North America',
                'Taber',
                'Municipal District of Taber',
                'Vauxhall',
                'Canadian Vauxhall solar farm',
                'RWE Renewables',
                'RWE Renewables',
              ],
              [
                'Canada',
                132,
                'North America',
                'Municipal District of Willow Creek',
                'Municipal District of Willow Creek',
                'Unavailable',
                'Claresholm Solar',
                'Capstone',
                'Capstone [51%]; Obton A/S [49%]',
              ],
              [
                'Canada',
                31,
                'North America',
                'Special Area No. 2',
                'Special Area No. 2',
                'Unavailable',
                'Jenner Solar',
                'BluEarth Renewables',
                'BluEarth Renewables',
              ],
              [
                'Canada',
                27,
                'North America',
                'Calgary',
                'Southeast Calgary',
                'Unavailable',
                'Barlow Trail solar farm',
                'DP Energy',
                'DP Energy',
              ],
              [
                'Canada',
                37,
                'North America',
                'Calgary',
                'Unavailable',
                'Unavailable',
                'Deerfoot Solar Park',
                'DP Energy',
                'DP Energy',
              ],
              [
                'Canada',
                21,
                'North America',
                'Calagary',
                'Wheatland County',
                'Unavailable',
                'East Strathmore Solar',
                'Elemental Energy',
                'Elemental Energy',
              ],
              [
                'Canada',
                24,
                'North America',
                'Rideau Lakes',
                'Leeds and Grenville Counties',
                'Eastern Ontario',
                'Elmsley East / West solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Canada',
                50,
                'North America',
                'Empress',
                'Cypress County',
                'Unavailable',
                'Empress Solar Park',
                'ATCO',
                'ATCO',
              ],
              [
                'Canada',
                75,
                'North America',
                'Muson',
                'Starland County',
                'Unavailable',
                'Fox Coulee Solar Park',
                'Aura Power',
                'Aura Power',
              ],
              [
                'Canada',
                100,
                'North America',
                'Nelles Corners',
                'Haldimand County',
                'Southwestern Ontario',
                'Grand Renewable Solar',
                'Samsung Renewable Energy; Six Nations of the Grand River',
                'Samsung Renewable Energy; Connor, Clark & Lunn Infrastructure; Six Nations of the Grand River',
              ],
              [
                'Canada',
                31,
                'North America',
                'Municipal District of Taber',
                'Municipal District of Taber',
                'Unavailable',
                'Hays Taber solar farm',
                'BluEarth Renewables',
                'BluEarth Renewables',
              ],
              [
                'Central African Republic',
                25,
                'Africa',
                'Danzi',
                'Unavailable',
                'Unavailable',
                'Enerca Danzi solar farm',
                'Unknown',
                '\u00c9nergie Centrafricaine',
              ],
              [
                'Chad',
                60,
                'Africa',
                'N\u2019Djamena',
                'Unavailable',
                'Unavailable',
                "Amea N'Djamena solar farm",
                'Unknown',
                'Amea Power',
              ],
              [
                'Chad',
                30,
                'Africa',
                'Sarh',
                'Unavailable',
                'Unavailable',
                'Sarh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Chad',
                60,
                'Africa',
                'N\u2019Djamena',
                'Unavailable',
                'Unavailable',
                "Amea N'Djamena solar farm",
                'Unknown',
                'Amea Power',
              ],
              [
                'Chad',
                32,
                'Africa',
                'Djermaya',
                'Unavailable',
                'Unavailable',
                'Djermaya solar farm',
                'Unknown',
                'Aldwich International; Smart Energies; Infraco Africa',
              ],
              [
                'Chad',
                50,
                'Africa',
                'Gaoui',
                'Unavailable',
                'Unavailable',
                'Gaoui solar farm',
                'Unknown',
                'Merl Solar Technologies',
              ],
              [
                'Chad',
                200,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Almaden solar farm',
                'Unknown',
                'Almaden Emirates Fortune Power LLC',
              ],
              [
                'Chad',
                200,
                'Africa',
                'Gassi',
                'Unavailable',
                'Unavailable',
                'Alcaal Gassi solar farm',
                'Unknown',
                'Alcaal Renovables S.R.L.',
              ],
              [
                'Chad',
                28,
                'Africa',
                'Djermaya',
                'Unavailable',
                'Unavailable',
                'Djermaya solar farm',
                'Unknown',
                'Aldwich International; Smart Energies; Infraco Africa',
              ],
              [
                'Chad',
                50,
                'Africa',
                'Gaoui',
                'Unavailable',
                'Unavailable',
                'Gaoui solar farm',
                'Unknown',
                'Merl Solar Technologies',
              ],
              [
                'Chad',
                32,
                'Africa',
                'N\u2019Djamena',
                'Unavailable',
                'Unavailable',
                'Starsol solar farm',
                'Unknown',
                'NewSolar Invest; CIEC Monaco; Arborescence Capital',
              ],
              [
                'Chile',
                70,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Pedernales Almagro PV solar farm',
                'AR Energ\u00eda',
                'Unknown',
              ],
              [
                'Chile',
                192,
                'South America',
                'Unavailable',
                'Mar\u00eda Elena',
                'Tocopilla',
                'Sol Del Loa Solar Plant Optimization Project',
                'Andes Mining & Energy Corp. S.A. (AME)',
                'Unknown',
              ],
              [
                'Chile',
                448,
                'South America',
                'Unavailable',
                'Mar\u00eda Elena',
                'Tocopilla',
                'Sol Del Loa Solar Plant Optimization Project',
                'Andes Mining & Energy Corp. S.A. (AME)',
                'Unknown',
              ],
              [
                'Chile',
                230,
                'South America',
                'Unavailable',
                'Provincia de Tocopilla',
                'Maria Elena',
                'Sol Del Desierto Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Chile',
                180,
                'South America',
                'Unavailable',
                'Provincia del Tamarugal',
                'La Tirana',
                'Sol De Tarapac\u00e1 solar farm',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                104,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Sol De Los Andes PV Solar Plant',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Chile',
                163,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Sol De Lila Photovoltaic Solar Project',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                707,
                'South America',
                'Unavailable',
                'Provincia de El Loa',
                'Calama',
                'Seongnam Solar Project',
                'Andes Green Energy SA',
                'Korean Capital Company',
              ],
              [
                'Chile',
                57,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Santa Sofia solar farm',
                'Colbun',
                'Colbun SA',
              ],
              [
                'Chile',
                110,
                'South America',
                'Unavailable',
                'Provincia de Colchagua',
                'Los Maitenes',
                'Santa Marta De Marchig\u00fce Solar Project',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                55,
                'South America',
                'Unavailable',
                'Provincia de El Loa',
                'Calama',
                'San Pedro Solar Photovoltaic Farm',
                'Global Power Generation (GPG)',
                'Global Power Generation',
              ],
              [
                'Chile',
                317,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Taltal',
                'Taltal PV Solar Project',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                50,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'San Andres Solar Park',
                'SunEdison Chile',
                'Unknown',
              ],
              [
                'Chile',
                116,
                'South America',
                'Unavailable',
                'Provincia de Chacabuco',
                'Til-Til',
                'Samantha Optimization Solar Park',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                68,
                'South America',
                'Provincia de Cha\u00f1aral',
                'Provincia de Cha\u00f1aral',
                'Unavailable',
                'Salvador PV Solar Project',
                'Solventus Chile',
                'Solventus Chile',
              ],
              [
                'Chile',
                98,
                'South America',
                'Unavailable',
                'Pozo Almonte',
                'Tamarugal',
                'S4 Solar Power Plant',
                'Sojitz Corp.',
                'Sojitz Corp.',
              ],
              [
                'Chile',
                145,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Rio Escondido Solar Park',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                37,
                'South America',
                'Unavailable',
                'Provincia de Valpara\u00edso',
                'Puchuncavi',
                'Ravsoe Photovoltaic Solar Power Plant',
                '8I',
                '8I',
              ],
              [
                'Chile',
                127,
                'South America',
                'Colina',
                'Provincia de Chacabuco',
                'Colina',
                'Quilapilun Solar Plant',
                'Atlas Renewable Energy',
                'Actis Group',
              ],
              [
                'Chile',
                145,
                'South America',
                'Unavailable',
                'Provincia de Concepci\u00f3n',
                'Unavailable',
                'Punta Del Viento PV Solar Project',
                'Frv-Fotowatio Renewable Vent',
                'Frv-Fotowatio Renewable Vent',
              ],
              [
                'Chile',
                55,
                'South America',
                'Calama',
                'Provincia de El Loa',
                'Calama',
                'San Pedro Solar Photovoltaic Farm',
                'Global Power Generation (GPG)',
                'Global Power Generation',
              ],
              [
                'Chile',
                175,
                'South America',
                'Unavailable',
                'Provincia de Cachapoal',
                'Pelequen',
                'Pelequ\u00e9n Solar Park',
                'Sonnedix Chile Holding Spa',
                'Sonnedix Power Holdings Ltd',
              ],
              [
                'Chile',
                128,
                'South America',
                'Unavailable',
                'Easter Island Province',
                'Hanga Roa',
                "Tama Te Ra'A Photovoltaic Solar Plant",
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                127,
                'South America',
                'Unavailable',
                'Provincia de Choapa',
                'Unavailable',
                'Tata Inti solar farm',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                390,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Sierra Gorda',
                'Pampa Uni\u00f3n Solar Plant',
                'EIG Global Energy Partners',
                'EIG Global Energy Partners',
              ],
              [
                'Chile',
                210,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Sierra Gorda',
                'Pampa Uni\u00f3n Solar Plant',
                'EIG Global Energy Partners',
                'EIG Global Energy Partners',
              ],
              [
                'Chile',
                100,
                'South America',
                'Antofagasta',
                'Provincia de El Loa',
                'Unavailable',
                'Pampa Tigre Solar PV Project',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                86,
                'South America',
                'Provincia de Antofagasta',
                'Provincia de Antofagasta',
                'Taltal',
                'Pampa Sur PV Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Chile',
                80,
                'South America',
                'Provincia de Antofagasta',
                'Provincia de Antofagasta',
                'Taltal',
                'Pampa Norte PV Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                45,
                'South America',
                'Unavailable',
                'Provincia de Iquique',
                'Unavailable',
                'Pampa Dos Cruces solar farm',
                'Sky Solar Holdings Ltd.',
                'Unknown',
              ],
              [
                'Chile',
                145,
                'South America',
                'Unavailable',
                'Provincia de Marga Marga',
                'Olmue',
                'Olmue Solar Project',
                'Colbun',
                'Colbun SA',
              ],
              [
                'Chile',
                115,
                'South America',
                'Unavailable',
                'Provincia de Chacabuco',
                'Til-TIl',
                'Metropolitana solar farm',
                'EDF Energie Nouvelles',
                'EDF Energie Nouvelles; Andes Mining Energy (AME)',
              ],
              [
                'Chile',
                160,
                'South America',
                'Unavailable',
                'Provincia de Los Andes',
                'Calle Larga',
                'Meseta Los Andes solar farm',
                'Sonnedix Chile Holding Spa',
                'Sonnedix Power Holdings Ltd',
              ],
              [
                'Chile',
                110,
                'South America',
                'Provincia de Elqui',
                'Provincia de Elqui',
                'Unavailable',
                'Mar\u00eda Elena solar farm',
                'El Pelicano Solar Company SpA',
                'Actis Group',
              ],
              [
                'Chile',
                30,
                'South America',
                'La Tirana',
                'Pica',
                'Unavailable',
                'Pica solar farm',
                'Element Power Chile',
                'Element Power',
              ],
              [
                'Chile',
                73,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Maria Elena PV Solar Park',
                'SunEdison Chile',
                'Unknown',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Pica',
                'Unavailable',
                'Pintados solar farm',
                'Element Power Chile',
                'Element Power',
              ],
              [
                'Chile',
                109,
                'South America',
                'Unavailable',
                'Provincia de Magallanes',
                'Arica',
                'Willka PV Solar Park',
                'Desarrollos Foto Chile (Dfc)',
                'Desarrollos Foto Chile (Dfc)',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Provincia de Huasco',
                'Vallenar',
                'Valleland Solar Project',
                'Developer Valleland SpA',
                'Unknown',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Provincia de Huasco',
                'Vallenar',
                'Valleland Solar Project',
                'Developer Valleland SpA',
                'Unknown',
              ],
              [
                'Chile',
                105,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Valle Escondido Solar PV Farm',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                64,
                'South America',
                'Calama',
                'Provincia de El Loa',
                'Calama',
                'Usya Photovoltaic Solar Plant',
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                57,
                'South America',
                'Antofagasta',
                'Provincia de Antofagasta',
                'Unavailable',
                'Uribe Solar Power Plant',
                'X-Elio',
                'X-Elio',
              ],
              [
                'Chile',
                150,
                'South America',
                'Unavailable',
                'Provincia de Choapa',
                'Unavailable',
                'Tres Cruces Solar PV Project',
                'Sonnedix Chile Holding Spa',
                'Sonnedix Power Holdings Ltd',
              ],
              [
                'Chile',
                513,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Taltal',
                'Terra Energia Renewables Solar Park',
                'AES Chile',
                'AES Gener SA',
              ],
              [
                'Chile',
                120,
                'South America',
                'Unavailable',
                'Barriles',
                'Tocopilla',
                'Tamaya solar farm',
                'Engie Energia Chile SA',
                'Engie',
              ],
              [
                'Chile',
                70,
                'South America',
                'Provincia de Cha\u00f1aral',
                'Provincia de Cha\u00f1aral',
                'Unavailable',
                'PV Salvador Solar Project',
                'Etrion Corporation',
                'Etrion Corporation; Total; Solventus',
              ],
              [
                'Chile',
                57,
                'South America',
                'Calama',
                'Provincia de El Loa',
                'Calama',
                'Jama Solar Plant',
                'Rijn Capital',
                'Rijn Capital',
              ],
              [
                'Chile',
                119,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Malgarida PV Solar Project',
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                50,
                'South America',
                'Provincia de Tocopilla',
                'Provincia de Tocopilla',
                'Tocopilla',
                'Coya PV Solar Project',
                'Solventus Chile',
                'Solventus Chile',
              ],
              [
                'Chile',
                130,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Tocopilla',
                'Coya PV Solar Project',
                'Solventus Chile',
                'Solventus Chile',
              ],
              [
                'Chile',
                130,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Copiapo Tower Solar Project',
                'Solarreserve Chile',
                'Solarreserve Llc',
              ],
              [
                'Chile',
                130,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Copiapo Tower Solar Project',
                'Solarreserve Chile',
                'Solarreserve Llc',
              ],
              [
                'Chile',
                122,
                'South America',
                'Provincia de Antofagasta',
                'Provincia de Antofagasta',
                'Taltal',
                'Conejo solar farm',
                'Pattern Energy Group LP',
                'Pattern Energy Group LP',
              ],
              [
                'Chile',
                600,
                'South America',
                'Unavailable',
                'Pintados',
                'Unavailable',
                'Cielos De Tarapac\u00e1 Solar Project',
                'Valhalla Energ\u00eda',
                'Valhalla Energ\u00eda',
              ],
              [
                'Chile',
                232,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Mejillones',
                'Changos Solar Plant',
                'AR Energ\u00eda Chile',
                'AR Energ\u00eda Chile',
              ],
              [
                'Chile',
                232,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Mejillones',
                'Changos Solar Plant',
                'AR Energ\u00eda Chile',
                'AR Energ\u00eda Chile',
              ],
              [
                'Chile',
                40,
                'South America',
                'Unavailable',
                'Provincia de Cha\u00f1aral',
                'Unavailable',
                'Cha\u00f1ares Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                110,
                'South America',
                'Provincia de Tocopilla',
                'Provincia de Tocopilla',
                'Maria Elena',
                'Cerro Dominador Solar Complex',
                'EIG Global Energy Partners',
                'EIG Global Energy Partners',
              ],
              [
                'Chile',
                100,
                'South America',
                'Provincia de Tocopilla',
                'Provincia de Tocopilla',
                'Maria Elena',
                'Cerro Dominador Solar Complex',
                'EIG Global Energy Partners',
                'EIG Global Energy Partners',
              ],
              [
                'Chile',
                97,
                'South America',
                'Copiap\u00f3',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Carrera Pinto solar farm',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                97,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Capricornio PV Solar Park',
                'Engie Chile',
                'Engie',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Provincia de Huasco',
                'Vallenar',
                'Denersol Solar Project',
                'Solairedirect Generacion VI SpA',
                'Solairedirect',
              ],
              [
                'Chile',
                47,
                'South America',
                'Unavailable',
                'Provincia de Huasco',
                'Vallenar',
                'Canto Del Agua solar farm',
                'Solairedirect Generacion VI SpA',
                'Solairedirect',
              ],
              [
                'Chile',
                146,
                'South America',
                'Provincia de Antofagasta',
                'Provincia de Antofagasta',
                'Sierra Gorda',
                'Bolero solar farm',
                'EDF EN Chile',
                'EDF Energies Nouvelles; Marubeni',
              ],
              [
                'Chile',
                104,
                'South America',
                'Unavailable',
                'Provincia de Magallanes',
                'Unavailable',
                'Azapa Photovoltaic Solar Park',
                'Mainstream Renewable Power',
                'Mainstream Renewable Power',
              ],
              [
                'Chile',
                170,
                'South America',
                'Unavailable',
                'Pica',
                'Tamarugal',
                'Atacama Solar Project',
                'Sonnedix Chile Holding Spa',
                'Sonnedix Power Holdings Ltd',
              ],
              [
                'Chile',
                160,
                'South America',
                'Unavailable',
                'Provincia de Cachapoal',
                'Las Cabras',
                'Andino Occidente Solar Project',
                'Sonnedix Chile Holding Spa',
                'Sonnedix Power Holdings Ltd',
              ],
              [
                'Chile',
                180,
                'South America',
                'Unavailable',
                'Pan de Azucar',
                'Unavailable',
                'Andes Solar Park',
                'AES Chile',
                'AES Gener SA',
              ],
              [
                'Chile',
                80,
                'South America',
                'Unavailable',
                'Pan de Azucar',
                'Unavailable',
                'Andes Solar Park',
                'AES Chile',
                'AES Gener SA',
              ],
              [
                'Chile',
                23,
                'South America',
                'Antofagasta',
                'Provincia de Antofagasta',
                'Unavailable',
                'Andes Solar Park',
                'AES Chile',
                'AES Gener SA',
              ],
              [
                'Chile',
                100,
                'South America',
                'Copiap\u00f3',
                'Provincia de Copiap\u00f3',
                'Unavailable',
                'Amanecer Solar Cap Power Plant',
                'SunEdison Inc.',
                'SunEdison Inc.',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Pica',
                'Unavailable',
                'Altos De Pica solar farm',
                'Element Power Chile',
                'Element Power',
              ],
              [
                'Chile',
                62,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Unavailable',
                'Almeyda Solar Plant',
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                32,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Aguas Blancas solar farm',
                'Etrion Corporation',
                'Etrion Corporation',
              ],
              [
                'Chile',
                24,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Aguas Blancas solar farm',
                'Etrion Corporation',
                'Etrion Corporation',
              ],
              [
                'Chile',
                119,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Malgarida PV Solar Project',
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                382,
                'South America',
                'Unavailable',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Campos Del Sol Photovoltaic Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                36,
                'South America',
                'Provincia de Cha\u00f1aral',
                'Provincia de Cha\u00f1aral',
                'Unavailable',
                'Diego De Almagro Photovoltaic Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                61,
                'South America',
                'Unavailable',
                'Provincia de El Loa',
                'Calama',
                'Azabache Photovoltaic Solar Park',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                115,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Diego De Almagro Sur Solar Project',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                141,
                'South America',
                'Copiap\u00f3',
                'Provincia de Copiap\u00f3',
                'Copiap\u00f3',
                'Luz Del Norte Solar Project',
                'First Solar',
                'First Solar',
              ],
              [
                'Chile',
                115,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Unavailable',
                'Diego De Almagro Sur Solar Project',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                55,
                'South America',
                'Provincia de Copiap\u00f3',
                'Provincia de Copiap\u00f3',
                'Tierra Amarilla',
                'Los Loros PV Solar Park',
                'Engie Energia Chile SA',
                'Engie',
              ],
              [
                'Chile',
                105,
                'South America',
                'Unavailable',
                'Provincia de Magallanes',
                'Arica',
                'Los Camarones Solar Project',
                'Elecnor Celeo Energy',
                'Unknown',
              ],
              [
                'Chile',
                93,
                'South America',
                'Provincia de Chacabuco',
                'Provincia de Chacabuco',
                'Til-Til',
                'Los Aromos PV Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Chile',
                100,
                'South America',
                'Copiap\u00f3',
                'Provincia de Copiap\u00f3',
                'Unavailable',
                'Llano De Llampos Solar Project',
                'Sunedison',
                'Unknown',
              ],
              [
                'Chile',
                600,
                'South America',
                'Unavailable',
                'Provincia de El Loa',
                'Calama',
                'Likana Solar Project',
                'EIG Global Energy Partners',
                'EIG Global Energy Partners',
              ],
              [
                'Chile',
                181,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Taltal',
                'Lalackama Solar Complex',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                60,
                'South America',
                'Provincia de Antofagasta',
                'Provincia de Antofagasta',
                'Unavailable',
                'Lalackama Solar Complex',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                30,
                'South America',
                'Provincia del Tamarugal',
                'Provincia del Tamarugal',
                'Tamarugal',
                'La Tirana solar farm',
                'Solar Chile',
                'Unknown',
              ],
              [
                'Chile',
                200,
                'South America',
                'Unavailable',
                'Mar\u00eda Elena',
                'Tocopilla',
                'La Pampina Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Pozo Almonte',
                'Tamarugal',
                'La Huayca solar farm',
                'Saferay Gmbh',
                'Saferay Gmbh',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Pozo Almonte',
                'Tamarugal',
                'La Huayca solar farm',
                'Saferay Gmbh',
                'Saferay Gmbh',
              ],
              [
                'Chile',
                181,
                'South America',
                'Unavailable',
                'La Granja',
                'Pozo Almonte',
                'La Granja Solar Plant',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Chile',
                26,
                'South America',
                'Unavailable',
                'Provincia de Antofagasta',
                'Taltal',
                'Las Luces PV Solar Project',
                'Etrion Corporation',
                'Etrion',
              ],
              [
                'Chile',
                537,
                'South America',
                'Unavailable',
                'Pozo Almonte',
                'Tamarugal',
                'Jardin solar farm',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                90,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Don Humberto Solar Park',
                'EBCO',
                'Unknown',
              ],
              [
                'Chile',
                70,
                'South America',
                'Unavailable',
                'Diego de Almagro',
                'Cha\u00f1aral',
                'Javiera Solar Plant',
                'Atlas Renewable Energy',
                'Atlas Renewable Energy',
              ],
              [
                'Chile',
                47,
                'South America',
                'Unavailable',
                'La Ligua',
                'Petorca',
                'Don Sebastian Solar Park',
                'Inkia Energy Chile',
                'Inkia Energy Chile',
              ],
              [
                'Chile',
                40,
                'South America',
                'La Ligua',
                'Provincia de Petorca',
                'Petorca',
                'Do\u00f1a Carmen PV solar farm',
                'Energ\u00eda Cerro El Morado S.A',
                'Unknown',
              ],
              [
                'Chile',
                30,
                'South America',
                'Unavailable',
                'Parinacota',
                'Arica',
                'Dos Cruces PV Solar Project',
                'Solventus Chile',
                'Solventus Chile',
              ],
              [
                'Chile',
                204,
                'South America',
                'Unavailable',
                'Provincia de Santiago',
                'Unavailable',
                'Domeyko Solar Park',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                160,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Unavailable',
                'Finis Terrae Photovoltaic Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                246,
                'South America',
                'Vallenar',
                'Provincia de Huasco',
                'Vallenar',
                'El Romero PV solar farm',
                'Acciona Energia Chile',
                'Acciona Sa',
              ],
              [
                'Chile',
                126,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Unavailable',
                'Finis Terrae Photovoltaic Solar Plant',
                'Enel Green Power Chile (EGPC)',
                'Enel Chile',
              ],
              [
                'Chile',
                220,
                'South America',
                'Unavailable',
                'Provincia de Choapa',
                'Unavailable',
                'Gabriela Photovoltaic Solar Park',
                'Grenergy',
                'Grenergy',
              ],
              [
                'Chile',
                709,
                'South America',
                'Unavailable',
                'Provincia de Choapa',
                'Unavailable',
                'Ghungnam Solar Project',
                'Andes Green Energy SA',
                'Korean Capital Company',
              ],
              [
                'Chile',
                267,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Tocopilla',
                'Inti Pacha Solar Complex',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                308,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Tocopilla',
                'Inti Pacha Solar Complex',
                'Colbun',
                'Engie',
              ],
              [
                'Chile',
                350,
                'South America',
                'Unavailable',
                'Maria Elena',
                'Tocopilla',
                'Inti Pacha Solar Complex',
                'Colbun',
                'Engie',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengmao Town',
                'Shanting District',
                'Zaozhuang',
                'Shandong Ouyu Luneng solar farm',
                'Shandong Zaozhuang Luneng New Energy Co., Ltd.',
                'Luneng New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Pingyi County',
                'Linyi',
                'Shandong Pingyi Jincheng solar farm',
                'Pingyi Jincheng Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu SUMEC New Energy Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Pingyuan',
                'Dezhou',
                'Shandong Pingyuan Xiehe solar farm',
                'Pingyuan Xiehe Solar Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dingzhuang Town',
                'Lingcheng Distict',
                'Dezhou',
                'Shandong Province Dezhou Dingzhuang solar farm',
                'Huaneng Shandong Power Co., Ltd.',
                'Huaneng Power International, Inc.[80%]; China Huaneng Group[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Dingzhuang Town',
                'Lingcheng Distict',
                'Dezhou',
                'Shandong Province Dezhou Dingzhuang solar farm',
                'Huaneng Shandong Power Co., Ltd.',
                'Huaneng Power International, Inc.[80%]; China Huaneng Group[20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Liuyu Town',
                'Pingyi County',
                'Linyi',
                'Shandong Pingyi Fuxiang Liuyuzhen solar farm',
                'Pingyi Fuxiang Photovoltaic Power Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Dongying',
                'Shandong Province Dongying Linuo solar farm',
                'Dongying Sanli Photovoltaic Power Co., Ltd.',
                'Shandong Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huancheng Town',
                'Weishan Xian',
                'Jining',
                'Shandong Province Jining Weishan Huanchengzhen Guoyang " Front Runner" solar farm',
                'Weishan Guoyang New Energy Power Generation Co., Ltd.',
                'Hefei Yunzhou New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Ershilidian Town',
                'Haiyang',
                'Yantai',
                'Shandong Province Haiyang Xinshunfeng solar farm',
                'Haiyang Xinshunfeng Photoelectric Technology Co., Ltd.',
                'Changzhou Zhaolian Lvfu New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Ershilidian Town',
                'Haiyang',
                'Yantai',
                'Shandong Province Haiyang Xinshunfeng solar farm',
                'Haiyang Xinshunfeng Photoelectric Technology Co., Ltd.',
                'Changzhou Zhaolian Lvfu New Energy Co., Ltd.',
              ],
              [
                'China',
                22,
                'Asia',
                'Unavailable',
                'Rencheng District',
                'Jining',
                'Shandong Province Jining Rencheng Huahuan solar farm',
                'Jining Huahan Photovoltaic Energy Co., Ltd.',
                'Huahong (Shandong) Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fucun Town',
                'Weishan Xian',
                'Jining',
                'Shandong Province Jining Weishan Fucunzhen " Front Runner" solar farm',
                'Beijing Enterprises Clean Energy Group Limited',
                'Beijing Enterprises Clean Energy Group Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Huancheng Town',
                'Weishan Xian',
                'Jining',
                'Shandong Province Jining Weishan Huanchengzhen Huaneng " Front Runner" solar farm',
                'Huaneng Weishan New Energy Co., Ltd.',
                'Huaneng Shandong Ruyi Coal and Electricity Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Huancheng Town',
                'Weishan Xian',
                'Jining',
                'Shandong Province Jining Weishan Huanchengzhen Jinko " Front Runner" solar farm',
                'Jinko Power Technology Co., Ltd.',
                'Jinko Power Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fushan Town',
                'Ningyang County',
                "Tai'an",
                'Shandong Ningyang Fushanzhen solar farm',
                'Ningyang Baier New Energy Technology Co., Ltd.',
                'Beijing BOE Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Guolou Town',
                'Wenshang Xian',
                'Jining',
                'Shandong Province Jining Wenshang "Front Runner" solar farm',
                'Huadian Shandong New Energy Co., Ltd.Huadian Shandong New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Dongying',
                'Shandong Province Dongying Tongwei Fishery and Light integrated solar farm',
                'Tongwei New Energy Co., Ltd.',
                'Tongwei Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhulou Township',
                'Cao County',
                'Heze',
                'Shandong Nanyuan Changguang solar farm',
                'Caoxian Changguang New Energy Co., Ltd.',
                'Heze Zhenyuan Leasing Co., Ltd. [70.00%]; Chen Sen [30.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Penglou Town',
                'Juancheng County',
                'Heze',
                'Shandong Juancheng Shangxin solar farm',
                'Juancheng Shangxin Photovoltaic Power Generation Co., Ltd.',
                'Changshu Chuangzhan Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'ShatuTown',
                'Mudan District',
                'Heze',
                'Shandong Mudan Wuliang solar farm',
                'Heze Wuliang Photovoltaic Power Generation Co., Ltd.',
                'Li Fengqi',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zoucheng',
                'Jining',
                'Shandong Province Jining Zoucheng Huahuan solar farm',
                'Jining Huahan Photovoltaic Energy Co., Ltd.',
                'Huahong (Shandong) Energy Investment Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Huairen Town',
                'Shanghe County',
                'Jinan',
                'Shandong Jinan Huairenzhen solar farm',
                'Jinan Zhongsheng New Energy Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baishi Town',
                'Wenshang County',
                'Jining',
                'Shandong Jining Baishizhen solar farm',
                'Jining Xuanzhui New Energy Technology Co., Ltd.',
                'East Modern Agricultural Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Xinyan Town',
                'Yanzhou District',
                'Yanzhou',
                'Shandong Jining Huaqin Rubber Industry Group solar farm',
                'Jining Huaxi New Energy Technology Co., Ltd.',
                'Zhejiang Hongxi Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhongce Town',
                'Sishui County',
                'Jining',
                'Shandong Jining Sishui Huaheng solar farm',
                'Sishui Huaheng Energy Technology Co., Ltd.',
                'State Power Investment Corporation Northeast Electric Power Development Co., Ltd. [70.00%]; Shandong Fanghualiheng Energy Technology Co., Ltd. [30.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Huayu Town',
                'Jinxian County',
                'Jining',
                'Shandong Jining Yaosheng solar farm',
                'Jining Yaosheng Photovoltaic Power Co., Ltd.',
                'Xiamen Kehua Hengsheng Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qishan Town',
                'Ju County',
                'Rizhao',
                'Shandong Juxian Huaheng Maobu solar farm',
                'Juxian Huaheng Energy Technology Co., Ltd.',
                'Shandong Huaheng Photovoltaic Technology Co., Ltd. [51.00%]; Ji Yingshang [49.00%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Dongji',
                'Kenli',
                'Dongying',
                'Shandong Kenli Dongji Hengtai solar farm',
                'Dongying City Kenli Hengtai New Energy Company Limited',
                'China Cube Solar Limited [74.8%]; Xiamen Qifang Equity Investment Co., Ltd. [25.2%]',
              ],
              [
                'China',
                21,
                'Asia',
                'Unavailable',
                'Juye County',
                'Heze',
                'Shandong Nancao Dinghao solar farm',
                'Juye Dinghao New Energy Co., Ltd.',
                'Chongqing Qinghui New Energy Co., Ltd. [59.60%]; Juye Liwei Investment Co., Ltd. [40.40%]',
              ],
              [
                'China',
                40,
                'Asia',
                "Yong'an Town",
                'Kenli County',
                'Dongying',
                "Shandong Kenli Yong'an Guangda solar farm",
                'Kenli Guangda New Energy Co., Ltd.',
                'China Cube Solar Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Kou Town',
                'Laiwu District',
                'Jinan',
                'Shandong Laiwu Kouzhen Taohuayu solar farm',
                'Laiwu Jinneng New Energy Co., Ltd.',
                'Shandong Higgse New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Miaoshan Town',
                'Laiwu District',
                'Jinan',
                'Shandong Laiwu Miaoshan solar farm',
                'Shandong Laiwu Dongxin New Energy Co., Ltd.',
                'Janghe Electromechanical Equipment Engineering Co., Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Tushan Town',
                'Laizhou',
                'Yantai',
                'Shandong Laizhou Tushanzhen solar farm',
                'Laizhou Shengyang New Energy Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jinling Town',
                'Lanling County',
                'Linyi',
                'Shandong Lanling Shuangneng solar farm',
                'Lanling Shuangneng New Energy Technology Co., Ltd.',
                'Chi Changshuang [85.00%]; Shanghai Ruisheng Power Development Co., Ltd. [10.00%]; Huang Yitang [5.00%]',
              ],
              [
                'China',
                40,
                'Asia',
                "Yong'an Town",
                'Kenli County',
                'Dongying',
                "Shandong Lenli Yong'an Shenzhou New Energy solar farm",
                'Kenli Shenzhou New Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wujing Town',
                'Linqu County',
                'Weifang',
                'Shandong Linqu Wujingzhen Tianneng solar farm',
                'Linqu Tianneng Photovoltaic New Energy Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Changlu Town',
                'Mengyin County',
                'Linyi',
                'Shandong Mengyin Changluzhen Dongda solar farm',
                'Mengyin Dongda New Energy Co., Ltd.',
                'Huadian Fuxin Energy Corp. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xuzhuang Town',
                'Shanting District',
                'Zaozhuang',
                'Shandong Mishan Star solar farm',
                'Shandong Star Business Incubation Co., Ltd.',
                'Shanghai Huaming Power Equipment Engineering Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaozhuang Sub-district Office',
                'Laicheng District',
                'Laiwu',
                'Shandong Laiwu Gaozhuang solar farm',
                'Huaneng Laiwu New Energy Co., Ltd.',
                'Huaneng Shandong Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaozhuang Jiedao',
                'Laiwu Shi',
                'Jinan',
                'Shandong Province Laiwu Yangjiayu CNNC solar farm',
                'Laiwu CNNC Guolan New Energy Co., Ltd.',
                'Beijing Jiucheng Xinyuan Consulting Service Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tuhai River',
                'Shen County',
                'Liaocheng',
                'Shandong Shenxian Tuhaihe solar farm',
                'Shenxian Oasis Solar Energy Technology Co., Ltd.',
                'Jianghe Machinery & Electrical Equipment Engineering Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Guan Xian',
                'Liaocheng',
                'Shandong Province Liaocheng Guanxian High-efficiency Agricultural solar farm',
                'Shandong Guanfeng High-efficiency Agricultural Photovoltaic Co., Ltd.',
                'Guanxian Guanhong Asset Management Co., Ltd.[51%]; Guanxian State-owned Assets Management Co., Ltd.[49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Kushan Township',
                'Ju County',
                'Rizhao',
                'Shandong Rizhao Juxian Kushanxiang solar farm',
                'Rizhao Dongxu Guoshan New Energy Technology Co., Ltd.',
                'Tunghsu New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sanzhuang Town',
                'Donggang District',
                'Rizhao',
                'Shandong Rizhao Xindonggang Banshi solar farm',
                'Rizhao New Donggang Agricultural Development Co., Ltd.',
                'Rizhao Donggang Agricultural Development Group Co., Ltd. [83.3333%]; Jinan Caijin Puyin Investment Management Partnership (Limited Partnership) [16.6667%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Sanzhuang Town',
                'Donggang District',
                'Rizhao',
                'Shandong Rizhao Xindonggang Banshi solar farm',
                'Rizhao New Donggang Agricultural Development Co., Ltd.',
                'Rizhao Donggang Agricultural Development Group Co., Ltd. [83.3333%]; Jinan Caijin Puyin Investment Management Partnership (Limited Partnership) [16.6667%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Shuiquan Town',
                'Shanting District',
                'Zaozhuang',
                'Shandong Shangting Shuiquanzhen Chengshang solar farm',
                'Shandong Chengshan Energy Co., Ltd.',
                'Fuyang New Energy Technology [Nanyang] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beizhuang',
                'Shanting',
                'Zaozhuang',
                'Shandong Shanting Beizhuang Guangyang solar farm',
                'Zaozhuang Guangyang Solar Power Generation Co., Ltd.',
                'China Cube Solar Limited [52.9%]; Xiamen Qifang Equity Investment Co., Ltd. [47.1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiji',
                'Shanting',
                'Zaozhuang',
                'Shandong Shanting Xiji Yizhao solar farm',
                'Shandong Yizhao Energy Co., Ltd.',
                'Gao He [70%]; Wang Mingfang [29%]; others [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Guide Town',
                'Changqing District',
                'Jinan',
                'Shandong Jinan Changqing solar farm',
                'Jinan Changxia New Energy Co., Ltd.',
                'Tianjin Fuyi Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangzhuangji Town',
                'Shen County',
                'Liaocheng',
                'Shandong Shenxian Wangzhuangji Zhongshen solar farm',
                'Shenxian Zhongsheng Photovoltaic Agricultural Technology Co., Ltd.',
                'Zibo Changsheng Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shuangwangcheng',
                'Shouguang',
                'Weifang',
                'Shandong Shouguang Changsheng Ridian Shuangwangcheng solar farm',
                'Shouguang Changsheng Ridian Solar Technology Co., Ltd.',
                'Wuxue City Chengsheng New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shuangwangcheng',
                'Shouguang',
                'Weifang',
                'Shandong Shouguang Jingshiqian Shuangwangcheng solar farm',
                'Shouguang Jingshiqian Solar Energy Co., Ltd.',
                'Weifang Jingshiqian Holdings Co., Ltd. [96.7742%]; others [3.2258%]',
              ],
              [
                'China',
                35,
                'Asia',
                'Yangkou Town',
                'Shouguang County',
                'Weifang',
                'Shandong Shouguang Yangkouzhen Wanhai solar farm',
                'Shandong Wanhai Electric Power Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                49,
                'Asia',
                'Xinhu Town',
                'Hekou District',
                'Dongying',
                'Shandong Shuguang Huitai solar farm',
                'Dongying Shuguang Solar Energy Co., Ltd.',
                'Jiangsu SUMEC New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dahuanggou Town',
                'Sishui County',
                'Jining',
                'Shandong Sishui Dahuanggouxiang solar farm',
                'Huaneng Shandong Sishui New Energy Co., Ltd.',
                'Huaneng Shandong Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaoyu',
                'Sishui',
                'Jining',
                'Shandong Sishui Gaoyu Qifang solar farm',
                'Jining Qifang Photovoltaic Power Generation Co., Ltd.',
                'China Cube Solar Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Xincun Town',
                'Sishui County',
                'Jining',
                'Shandong Sishui Xinhui Xingcunzhen solar farm',
                'Surabaya Xinhui Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongguo Town',
                'Tengzhou',
                'Zaozhuang',
                'Shandong Tengzhou Dongguo Shenneng solar farm',
                'Shenneng (Tengzhou) Energy Co., Ltd.',
                'Shenneng Nanjing Energy Holding Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fucun Street',
                'Weishan County',
                'Jining',
                'Shandong Three Gorges New Energy Weishan solar farm',
                'Three Gorges New Energy Weishan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Qingdao',
                'Shandong Qingdao CECEP solar farm',
                'CECEP (Shandong) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Economic Development Zone',
                'Qihe County',
                'Dezhou',
                'Shandong Qihe Economic Development Zone solar farm',
                'Qihe Blue Light Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qinghu Lake',
                'Dianhuaqu',
                'Binzhou',
                'Shandong Province Zhanhua Qingfenghu Poverty Alleviation solar farm',
                'China Huaneng Group',
                'China Huaneng Group',
              ],
              [
                'China',
                20,
                'Asia',
                'Andi Town',
                'Yinan Xian',
                'Linyi',
                'Shandong Province Yinan Chinese Medicinal Herbs solar farm',
                'Yinan Lino Solar Power Engineering Co., Ltd.',
                'Shandong Shuifa Integrated Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tanbu',
                'Mengyin Xian',
                'Linyi',
                'Shandong Province Mengyin Three Gorges solar farm',
                'Three Gorges New Energy Mengyin Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tanbu',
                'Mengyin Xian',
                'Linyi',
                'Shandong Province Mengyin Three Gorges solar farm',
                'Three Gorges New Energy Mengyin Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Houjiatun',
                'Jimo',
                'Qingdao',
                'Shandong Province Qingdao Jimo Agricultural solar farm',
                'Qingdao Chengsheng Solar Energy Town Agricultural Development Co., Ltd.',
                'Qingdao Chengtou Clean Energy Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Houjiatun',
                'Jimo',
                'Qingdao',
                'Shandong Province Qingdao Jimo Agricultural solar farm',
                'Qingdao Chengsheng Solar Energy Town Agricultural Development Co., Ltd.',
                'Qingdao Chengtou Clean Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Yingli Town',
                'Shouguang',
                'Weifang',
                'Shandong Province Shouguang Yingli SPIC solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhai Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Beikong solar farm",
                'Beijing Enterprises Clean Energy Group Limited',
                'Beijing Enterprises Clean Energy Group Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhai Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Dongxu solar farm",
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhai Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Huaneng solar farm",
                'Huaneng Shandong Power Co., Ltd.',
                'Huaneng Power International, Inc.[80%]; China Huaneng Group[20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaozhuang Jiedao',
                'Laiwu Shi',
                'Jinan',
                'Shandong Province Laiwu Yangjiayu CNNC solar farm',
                'Laiwu CNNC Guolan New Energy Co., Ltd.',
                'Beijing Jiucheng Xinyuan Consulting Service Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Quangou Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Jinko solar farm",
                'Jinko Power Co., Ltd.',
                'Jinko Power Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xizhangzhuang Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Xizhangzhuang solar farm",
                'Huaneng Taishan New Energy Co., Ltd.',
                'Huaneng Taishan Electric Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhai Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Zhaizhen solar farm",
                'Huaneng Taishan New Energy Co., Ltd.',
                'Huaneng Taishan Electric Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhai Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area Zhongdian solar farm",
                'Xintai Zhongdian Photovoltaic Power Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xizhangzhuang Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Huaneng solar farm",
                'Huaneng Taishan New Energy Co., Ltd.',
                'Huaneng Taishan Electric Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yangliu Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Three Gorges solar farm",
                'Three Gorges New Energy Xintai Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huiqu Town',
                'Anqiu',
                'Weifang',
                'Shandong Province Weifang Ronghui Agricultural solar farm',
                'Weifang Tian\u2018en Ronghui Comprehensive Energy Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy (Shanghai) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fucun Town',
                'Weishan Xian',
                'Jining',
                'Shandong Province Weishan Xiaobuwan Three Gorges solar farm',
                'Three Gorges New Energy Weishan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Tushan Town',
                'Laizhou Shi',
                'Yantai',
                'Shandong Province Yantai Laizhou Tushanzhen solar and storage project',
                'Sungrow Power Supply Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xizhangzhuang Town',
                'Xintai Shi',
                "Tai'an",
                "Shandong Province Tai'an Xintai Coal Mining Subsidence Area TBEA solar farm",
                'TBEA Xinjiang New Energy Co., Ltd.',
                'TBEA [32%]; Xinjiang Uygur Autonomous Region Investment Company [20%]; Beijing Tsinghua University Enterprise Group [20%]; Changji Special Transformer Factory [10%]; Beijing Qingyuan Defeng Investment Management Co., Ltd. [5%]; Others [13%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhifang',
                'Jiaxiang',
                'Jining',
                'Shandong Jiaxiang Zhifang Jianeng solar farm',
                'Shandong Jianeng Solar Energy Technology Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang Qu',
                'Yulin',
                'Shaaxi Province Yuyang Xiehe solar farm',
                'Yulin Xiehe Solar Power Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Huancheng Town',
                'Weishan County',
                'Jining',
                'Shandong Huaneng Weishan Huachengzhen solar farm',
                'Huaneng Weishan New Energy Co., Ltd.',
                'Huaneng Shandong Ruyi Coal and Electricity Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Unavailable',
                'Yijun County',
                'Tongchuan',
                'Shaanxi Tongchuan "Front Runner" Xiaguang solar farm',
                'Tongchuan Xiaguang New Energy Power Generation Co., Ltd.',
                "Xi'an Lvsheng Clean Energy Co., Ltd. [51%]; China Three Gorges New Energy [Group] Co., Ltd. [49%]",
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yaozhou District',
                'Tongchuan',
                'Shaanxi Tongchuan Yaozhou Zhongguang solar farm',
                'Tongchuan Zhongguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yaozhou District',
                'Tongchuan',
                'Shaanxi Tongchuan Yaozhou Zhongguang solar farm',
                'Tongchuan Zhongguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yintai County',
                'Tongchuan',
                'Shaanxi Tongchuan Yintai Juguang solar farm',
                'Tongchuan Juguang Photovoltaic Power Generation Co., Ltd.',
                'Hou Kangqiang[55%]; Li Yongzhong[45%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Chengcheng County',
                'Weinan',
                'Shaanxi Tuori Chengcheng solar farm',
                'Shaanxi Tuori New Energy Technology Co., Ltd.',
                'Shenzhen Topraysolar Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Caozhuangcun',
                'Chengcheng County',
                'Weinan',
                'Shaanxi Weinan "Front Runner Chengcheng Caozhuang solar farm',
                'Chengcheng Shengbu Photovoltaic Power Co., Ltd.',
                'Hengfeng County Jinghong Electric Power Co., Ltd. [90%]; Shaanxi Chemical Industry Group Co., Ltd. [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Leijiawa Town',
                'Chengcheng County',
                'Weinan',
                'Shaanxi Weinan "Front Runner Chengcheng Zhuangtouzhen solar farm',
                'State Power Investment Group Chengcheng New Energy Power Generation Co., Ltd.',
                'State Power Investment Corporation Shaanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hejiazhuang Town',
                'Heyang County',
                'Weinan',
                'Shaanxi Weinan "Front Runner Heyang Hejiazhuang solar farm',
                'Heyang Shengyao Photovoltaic Power Co., Ltd.',
                'Hengfeng County Jingfu Electric Power Co., Ltd. [90%]; Shaanxi Chemical Industry Group Co., Ltd. [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinyu Town',
                'Heyang County',
                'Weinan',
                'Shaanxi Weinan "Front Runner Heyang Jinyuzhen solar farm',
                'Weinan Xiayang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Wangcun Town',
                'Heyang County',
                'Weinan',
                'Shaanxi Weinan "Front Runner Heyang Wangcunzhen solar farm',
                'State Power Investment Group Heyang New Energy Power Generation Co., Ltd.',
                'State Power Investment Corporation Shaanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Xiahaotu Longyuan solar farm',
                'Yulin Longyuan Photovoltaic Power Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Xiaohaotu Jiangshan Yongchen solar farm',
                'Yulin Jiangshan Yongchen New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Chenlu',
                'Yintai',
                'Tongchuan',
                'Shaanxi Yintai Chenlu Meiguang solar farm',
                'Tongchuan Meiguang Solar Power Co., Ltd.',
                'State Power Investment Group Shaanxi New Energy Co., Ltd. [70%]; Shaanxi Huaping New Energy Technology Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Baijie Town',
                'Hengshan District',
                'Yulin',
                'Shaanxi Yulin High Tech Zone Dingrun solar farm',
                'Yulin High Tech Zone Dingrun New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd. [51%]; Central SOE Poverty Area [Shaanxi] Industrial Investment Fund Partnership [Limited Partnership] [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Baijie Town',
                'Hengshan District',
                'Yulin',
                'Shaanxi Yulin High Tech Zone Dingsheng solar farm',
                'Yulin High Tech Zone Dingsheng New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd. [51%]; Central SOE Poverty Area [Shaanxi] Industrial Investment Fund Partnership [Limited Partnership] [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Boluo Town',
                'Hengshan District',
                'Yulin',
                'Shaanxi Yulin High Tech Zone Jinghui solar farm',
                'Yulin High Tech Zone Jinghui New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd. [51%]; Central SOE Poverty Area [Shaanxi] Industrial Investment Fund Partnership [Limited Partnership] [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Boluo Town',
                'Hengshan District',
                'Yulin',
                'Shaanxi Yulin High Tech Zone Xinhui solar farm',
                'Yulin High Tech Zone Xinhui New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd. [51%]; Central SOE Poverty Area [Shaanxi] Industrial Investment Fund Partnership [Limited Partnership] [49%]',
              ],
              [
                'China',
                250,
                'Asia',
                'Unavailable',
                'Yijun County',
                'Tongchuan',
                'Shaanxi Tongchuan "Front Runner" Tianxing solar farm',
                'Yijun Tianxing New Energy Co., Ltd.',
                'Changzhou Zhuohui New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Zhongjiu solar farm',
                'Shenmu Lvyuan New Energy Power Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhongji',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Zhongji Lvyuan solar farm',
                'Shenmu Lvyuan New Energy Power Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Yuanhang solar farm',
                'Shenmu Yuanhang New Energy Development Co., Ltd.',
                'Hefei Qinyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Dongtou solar farm',
                'Shenmu Jingdeng Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an Xiexin New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Guangneng Technology solar farm',
                'Shenmu Zhongjiu Agricultural Development Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jinjie Town',
                'Shenmu County',
                'Yulin',
                'Shaanxi Shenmu Guotai Distributed solar farm',
                'Shenmu Guotai Agriculture and Animal Husbandry Development Co., Ltd.',
                'Changan Huitong Asset Management Co., Ltd. [51%]; Shenmu Jingyuan Holding Group Co., Ltd. [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jiajialiang Guohua solar farm',
                'Guohua (Shenmu) New Energy Co., Ltd. \uff08',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu County',
                'Yulin',
                'Shaanxi Shenmu Jiaming solar farm',
                'Shenmu Jiaming New Energy Co., Ltd.',
                'Wang Jiayin',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jingdeng solar farm',
                'Shenmu Jingdeng Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an Xiexin New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jingdeng solar farm',
                'Shenmu Jingpu Electric Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an Xiexin New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu County',
                'Yulin',
                'Shaanxi Shenmu Jingpu Distributed solar farm',
                'Shenmu Jingpu Electric Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an GCL New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jingbian',
                'Yulin',
                'Shaanxi Yulin Jingbian Guohua solar farm',
                'Guohua (Yulin) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jingpu solar farm',
                'Shenmu Jingpu Electric Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an Xiexin New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                50,
                'Asia',
                'Jinjie',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jinjie Pingyuan solar farm',
                'Shenmu Pingyuan Power Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd. [90%]; Suzhou Xiexin New Energy Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jinluyuan solar farm',
                'Shenmu Jinluyuan Modern Agriculture Development Co., Ltd.',
                'Shenmu County Jingyuan Cleaning Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Lvyuan solar farm',
                'Shenmu Jingfu Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an Xiexin New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Pingxi solar farm',
                'Shenmu Dongsheng Technology Development Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu County',
                'Yulin',
                'Shaanxi Shenmu Putian solar farm',
                'Shenmu Putian New Energy Co., Ltd.',
                'Fu Yuexia',
              ],
              [
                'China',
                40,
                'Asia',
                'Gaojiabao Town',
                'Shenmu County',
                'Yulin',
                'Shaanxi Shenmu Shunli solar farm',
                'Shenmu Shunli New Energy Co., Ltd.',
                'Shaanxi Jinyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sunjiacha',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Tengcheng solar farm',
                'Shenmu Tengcheng Agriculture Co., Ltd.',
                'Shenmu Jingyuan Holding Group Co., Ltd. [95%]; Shanghai Lvjing Industrial Development Co., Ltd. [5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Sunjiacha',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Tianrun solar farm',
                'Shenmu Tianrun Agricultural Development Co., Ltd.',
                'Shenmu Jingyuan Holding Group Co., Ltd. [95%]; Shanghai Lvjing Industrial Development Co., Ltd. [5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Jinjie',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Jinjie Jingfu solar farm',
                'Shenmu Pingxi Electric Power Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd. [90%]; Suzhou Xiexin New Energy Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xindian Town',
                'Huimin County',
                'Binzhou',
                'Shandong Huimin Xindian solar farm',
                'Shandong Huimin Hengzhen Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yangjiapan Town',
                'Jingbian County',
                'Yulin',
                'Shaanxi Yulin Jingbian Jiulitan solar farm',
                'Shaanxi Photovoltaic Industry Co., Ltd.',
                'Shaanxi Electronic Information Group Co.,Ltd[50%]; Shaanxi Yanchang Petroleum Mining Co., Ltd.[50%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Dabaodang Town',
                'Shenmu County',
                'Yulin',
                'Shaanxi Yulin Yushen Jinyang solar farm',
                'Yulin Yushen Industrial Zone Jinyang Photovoltaic Power Co., Ltd.',
                'Huaneng International Power Development Corporation',
              ],
              [
                'China',
                22,
                'Asia',
                'Dongguantun Town',
                'Juye County',
                'Heze',
                'Shandong Cuige Mingsheng solar farm',
                'Juye Mingsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd. [60.00%]; Qingdao Changsheng Ridian Solar Technology Co., Ltd. [40.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaizhen Town',
                'Xintai',
                "Tai'an",
                'Shandong Dagang Xintai Zhongdian solar farm',
                'Xintai Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhengjiazhai Town',
                'Lingchen District',
                'Dezhou',
                'Shandong Dezhou Lingchenqu Zhengjiazhai solar farm',
                'Dezhou Lingcheng Qianchao Brothers Energy Technology Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jieshan Town',
                'Dongping Town',
                "Tai'an",
                'Shandong Dongping Jieshanzhen solar farm',
                'Dongping Haoyuan Photovoltaic Power Generation Co., Ltd.',
                'Wanbu New Energy Investment (China) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinhu Town',
                'Hekou District',
                'Dongying',
                'Shandong Dongying Xinhuxiang solar farm',
                'Dongying Shuguang Solar Energy Co., Ltd.',
                'Jiangsu SUMEC New Energy Development Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                "Yong'an Town",
                'Kenli District',
                'Dongying',
                "Shandong Dongying Yong'anzhen solar farm",
                'Dongying Tianze New Energy Technology Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd. [68.00%]; Shandong Landi New Energy Co., Ltd. [15.00%]; Shandong Tianrong Ruilin New Energy Co., Ltd. [15.00%]; others [2.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Anlinzhan Town',
                'Feicheng',
                "Tai'an",
                'Shandong Feicheng Anlinzhan Tiancheng solar farm',
                'Feicheng Tianchen Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangzhuang Town',
                'Feicheng',
                "Tai'an",
                'Shandong Feicheng Shengyang solar farm',
                'Feicheng Shengyang New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.[80%]; Ningbo Free Trade Zone Hongxin New Energy Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Gaotang',
                'Gaotang County',
                'Liaocheng',
                'Shandong Gaotang Guguantun GCL solar farm',
                'Gaotang GCL Jinghui Photovoltaic Co., Ltd.',
                'Suzhou Xiexin New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Jiangdian Town',
                'Gaotang County',
                'Liaocheng',
                'Shandong Gaotang Jiangdianzhen solar farm',
                'Gaotang Qisheng New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingshui Town',
                'Guan County',
                'Liaocheng',
                'Shandong Guanxian Qingshuizhen Zhongguang solar farm',
                'Guanxian Zhongguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                53,
                'Asia',
                'Wanshan Township',
                'Guan County',
                'Liaocheng',
                'Shandong Guanxian Wanshan solar farm',
                'Guanxian Huabo Agricultural Technology Co., Ltd.',
                'Shandong Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Xiedian Township',
                'Guanxian County',
                'Liaocheng',
                'Shandong Guanxian Xiedian solar farm',
                'Guanxian Minghui Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Binhai Economic Development Zone',
                'Hanting',
                'Weifang',
                'Shandong Hanting Binhai Economic Development Zone Jingshiqian solar farm',
                'Weifang Jingshiqian Solar Energy Co., Ltd.',
                'Weifang Jinghong Power Engineering Construction Co., Ltd. [51.6%]; Shandong Seaview New Energy Group Co., Ltd. [48.4%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hedong',
                'Linyi',
                'Shandong Hedong Cecep solar farm',
                'CECEP (Linyi) Photovoltaic Agricultural Technology Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd. [90%]; Qingdao Changsheng Electric Solar Polytron Technologies Inc [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaizhen Town',
                'Xintai',
                "Tai'an",
                'Shandong Houyang Beikong solar farm',
                'Xintai Beikong Clean Energy Co., Ltd.',
                'Tianjin Beiqing Electric Power Smart Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Guolou Town',
                'Wenshang County',
                'Jining',
                'Shandong Huadian Wenshang Guolouzhen solar farm',
                'Huadian Shandong New Energy Co., Ltd. Wenshang Branch',
                'Huadian Shandong New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Shandong China Energy Conservation and Environmental Protection Group Xintai solar farm',
                'China Energy Conservation and Environmental Protection Group (Xintai) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.[83.4821%]; China Energy Conservation and Environmental Protection Group Solar Energy Hong Kong Co., Ltd. [16.5179%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhai Town',
                'Xintai',
                "Tai'an",
                'Shandong China Energy Conservation and Environmental Protection Group Xintai solar farm',
                'China Energy Conservation and Environmental Protection Group (Xintai) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.[83.4821%]; China Energy Conservation and Environmental Protection Group Solar Energy Hong Kong Co., Ltd. [16.5179%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiunvji Town',
                'Chengwu County',
                'Heze',
                'Shandong Chengwu Jiunvjizhen Zhongsheng solar farm',
                'Chengwu Zhongsheng Photovoltaic Agricultural Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mashanzi Town',
                'Beihai Economic Development Zone',
                'Binzhou',
                'Shandong Changsheng Beihai Economic Development Zone solar farm',
                'Binzhou Changsheng Ridian Solar Technology Co., Ltd.',
                'Shandong Beihai Changsheng Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yulin Yuyang District Fengguang solar farm',
                'Yulin Fengguang New Energy Development Co., Ltd.',
                'Huayu Smart Energy Group Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Dabaodang Town',
                'Shenmu',
                'Yulin',
                'Shaanxi Yushen Shaqiu solar farm',
                'Yulin Yellow River Energy Co., Ltd.',
                'Shaanxi Yellow River Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang Aoteng solar farm',
                'Shaanxi Aoteng Photovoltaic Power Generation Co., Ltd.',
                'Shaanxi Photovoltaic Industry Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dabaodang',
                'Yuyang',
                'Yulin',
                'Shaanxi Yuyang Dabaodang Dongtou solar farm',
                'Yulin Yushen Industrial Zone Dongtou Energy Co., Ltd.',
                'Beijing Zhongshui Investment Management Center',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang District Yanglaoda solar farm',
                'Yulin Yuyang Yanglaoda New Energy Co., Ltd.',
                'Shaanxi Huadian New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang Huadian solar farm',
                'Shaanxi Huadian Yuyang New Energy Co., Ltd.',
                'Shaanxi Huadian New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang Huiteng solar farm',
                'Shaanxi Yulin Yuneng Huiteng New Energy Development Co., Ltd.',
                'Shaanxi Yulin Energy Group New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Mengjiawan Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang Mengjiawan Xuguang solar farm',
                'Shaanxi Xuguang New Energy Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Dabancheng Wind Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian County',
                'Yulin',
                'Shaanxi Yulin Taike solar farm',
                'Yulin Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Balasu Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Yuyang Xinjing solar farm',
                'Yulin Xinjing Solar Power Generation Co., Ltd.',
                "Xi'an Huanghe Photovoltaic Technology Co., Ltd.",
              ],
              [
                'China',
                30,
                'Asia',
                'Yunshan Town',
                'Anqiu',
                'Weifang',
                'Shandong Weifang Anqiu Yunshanzhen solar farm',
                'Weifang Tianen Jinshan Integrated Energy Co., Ltd.',
                'Wanbu New Energy Investment (China) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dasheng Town',
                'Anqiu',
                'Weifang',
                'Shandong Anqiu Dashengzhen solar farm',
                "Anqiu Hui'en Photovoltaic Technology Co., Ltd.",
                'Wanbu New Energy Investment (China) Co., Ltd.',
              ],
              [
                'China',
                43,
                'Asia',
                'Shibuzi Town',
                'Anqiu',
                'Weifang',
                'Shandong Anqiu Shibuzizhen solar farm',
                'Anqiu Huiyong Photovoltaic Technology Co., Ltd.',
                'Anqiu Jingxin Photovoltaic Technology Co., Ltd. [50.00%]; Anqiu Puhui Photovoltaic Energy Co., Ltd. [50.00%]',
              ],
              [
                'China',
                80,
                'Asia',
                'Zheshan Town',
                'Anqiu',
                'Weifang',
                'Shandong Anqiu Zheshanzhen solar farm',
                'Anqiu Huili Photovoltaic Technology Co., Ltd.',
                'Anqiu Puhui Photovoltaic Energy Co., Ltd. [50.00%]; Anqiu Jingyuan New Energy Co., Ltd. [50.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shejia Town',
                'Wudi County',
                'Binzou',
                'Shandong Binzhou Tianhao Agricultural Science and Technology Park solar farm',
                'Binzhou Tianhao Power Generation Co., Ltd.',
                'Shunyu Clean Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhulou Township',
                'Cao County',
                'Heze',
                'Shandong Caoxian Nanyuan Zhongsheng solar farm',
                'Caoxian Zhongsheng Solar Power Generation Co., Ltd.',
                'Caoxian Changguang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Taida',
                'Caoxian',
                'Heze',
                'Shandong Caoxian Taida High-efficiency Ecological Breeding solar farm',
                'Caoxian Taida New Energy Co., Ltd.',
                'China Cube Solar Limited [56.7%]; Xiamen Qifang Equity Investment Co., Ltd. [43.3%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Beihai 2nd Road',
                'Beihai Economic Development Zone',
                'Binzhou',
                'Shandong Changsheng Beihai Economic Development Zone Greenhouse solar farm',
                'Shandong Beihai Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang Qu',
                'Yulin',
                'Shaaxi Province Yuyang Xiehe solar farm',
                'Yulin Xiehe Solar Power Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaying Town',
                'Changyi County',
                'Weifang',
                'Shandong Weifang Binhai solar farm',
                'Weifang Tianen Binhai New Energy Co., Ltd.',
                'Shenzhen Huiyang New Energy Investment Consulting Co., Ltd.',
              ],
              [
                'China',
                23,
                'Asia',
                "E'shan Town",
                'Yicheng District',
                'Zaozhuang',
                'Shandong Zaozhuang Luoteng Fengyuan solar farm',
                'Zaozhuang Fengyuan Photovoltaic Power Generation Co., Ltd.',
                'Shandong Fengyuan Biomass Power Generation Co., Ltd. [51.1111%]; Shandong Hongda Urban Development Investment Co., Ltd. [48.8889%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lingang Economic and Technological Development Zone',
                'Weihai',
                'Shandong Weihai Shangshantang Agricultural Greenhouse solar farm',
                'Weihai Shantang Agricultural Development Co., Ltd.',
                'Sun Yichen[60%]; Li Liqi[40%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Gaoshan Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Yungang Xinwangzhuang solar farm',
                'Datong CGN Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jiajiazhuang Town',
                'Fenyang Shi',
                'L\u00fcliang',
                'Shanxi Province Fenyang Jiajiazhuang solar farm',
                'CECEP (Fenyang) Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fancun',
                'Hejin',
                'Yuncheng',
                "Shanxi Province Hejin Lu'an solar farm",
                "Hejin Lu'an Photovoltaic Power Generation Co., Ltd.",
                "Shanxi Lu'an Photovoltaic Power Generation Co., Ltd.",
              ],
              [
                'China',
                100,
                'Asia',
                'Huairen City',
                'Huairen Shi',
                'Jinzhong',
                'Shanxi Province Huairen Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Shuitou',
                'Jiaokou Xian',
                'L\u00fcliang',
                'Shanxi Province Jiaokou Shuitouzhen solar farm',
                'Jiaokou County Guangyu Photovoltaic Power Co., Ltd.',
                "Xi'an Minghui Guangsheng Power Generation Co., Ltd.",
              ],
              [
                'China',
                100,
                'Asia',
                'Songta Town',
                'Shouyang Xian',
                'Jinzhong',
                'Shanxi Province Jinzhong Shouyang Area 1 solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Songta Town',
                'Shouyang Xian',
                'Jinzhong',
                'Shanxi Province Jinzhong Shouyang Area 2 solar farm',
                'Shouyang Guoke New Energy Technology Co., Ltd.',
                'Hengfeng County Jingjia Power Co., Ltd.[70%]; China Development New Energy Technology Co., Ltd.[30%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xiluo Town',
                'Shouyang County',
                'Jinzhong',
                'Shanxi Province Jinzhong Shouyang Area 3 solar farm',
                'Shouyang Jingshou Photovoltaic Power Co., Ltd.',
                'Hengfeng County Jingneng Electric Power Co., Ltd.[51%]; Beijing Jingneng Clean Energy Power Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'XiluoTown',
                'Shouyang Xian',
                'Jinzhong',
                'Shanxi Province Jinzhong Shouyang Area 4 solar farm',
                'Shouyang Guoke New Energy Technology Co., Ltd.',
                'Hengfeng County Jingjia Power Co., Ltd.[70%]; China Development New Energy Technology Co., Ltd.[30%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Yangtouya Town',
                'Shouyang Xian',
                'Jinzhong',
                'Shanxi Province Jinzhong Shouyang Area 5 solar farm',
                'Beijing Enterprises Clean Energy Group Limited',
                'Beijing Enterprises Clean Energy Group Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Mayingzhuang Town',
                'Shanyin Xian',
                'Shuozhou',
                'Shanxi Province Shanyin Mayingzhuang solar farm',
                'State Power Investment Corporation Shanyin County Yuyuantai Photovoltaic Power Co., Ltd.',
                'State Power Investment Corporation Shanxi New Energy Co., Ltd.[60%]; Shanxi Yuyuantai Investment Consulting Co., Ltd.[40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Niuxinbao Town',
                'Youyu Xian',
                'Shuozhou',
                'Shanxi Province Shuozhou Youyu solar farm',
                'Shanxi Tongmei Hexu New Energy Industry Co., Ltd.',
                'Shuozhou Coal Power Co., Ltd., Datong Coal Mine Group',
              ],
              [
                'China',
                50,
                'Asia',
                'Niuxinbao Town',
                'Youyu Xian',
                'Shuozhou',
                'Shanxi Province Shuozhou Youyu solar farm',
                'Shuozhou Coal Power Co., Ltd., Datong Coal Mine Group',
                'Datong Coal Mining Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Lingjingdian Town',
                'Yangqu Xian',
                'Taiyuan',
                'Shanxi Province Taiyuan Yangqu solar farm',
                'Yangqu County Yangrui New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                65,
                'Asia',
                'Guqianbao Town',
                'Tianzhen Xian',
                'Datong',
                'Shanxi Province Tianzhen Shatunpu solar farm',
                'Jinneng Clean Energy Photovoltaic Power Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Guqianbao Town',
                'Tianzhen Xian',
                'Datong',
                'Shanxi Province Tianzhen Shuimokou solar farm',
                'Jinneng Clean Energy Photovoltaic Power Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shangshenjian',
                'Xinrong District',
                'Datong',
                'Shanxi Province Xinrong District Datang solar farm',
                'Datong Xinrong District Oulong Clean Energy Co., Ltd.',
                "Xi'an Shenglong New Energy Co., Ltd.",
              ],
              [
                'China',
                50,
                'Asia',
                'Yungang Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Yungang Wutaiwan solar farm',
                'Datong JA Solar Power Generation Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                600,
                'Asia',
                'Shangshenjian',
                'Xinrong District',
                'Datong',
                'Shanxi Province Xinrong District Datang solar farm',
                'Datong Xinrong District Oulong Clean Energy Co., Ltd.',
                "Xi'an Shenglong New Energy Co., Ltd.",
              ],
              [
                'China',
                50,
                'Asia',
                'Yungang Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Yungang Sandaogou solar farm',
                'Datong Li Innovative Photovoltaic Power Co., Ltd.',
                'Inner Mongolia Lichuang Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Gaoshan Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Yungang Gaoshan Nanyanglu solar farm',
                'Datong Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Laoying Town',
                'Pianguan County',
                'Xinzhou',
                'Shanxi Pianguan Mule Sitong solar farm',
                'Pianguan Mule Sitong Photovoltaic Power Generation Co., Ltd.',
                'Pianguan Zhongnengxin Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yexi Town',
                'Pingding County',
                'Yangquan',
                'Shanxi Pingding "Front Runner" Jingke solar farm',
                'Pingding Jingke Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jucheng Town',
                'Pingding County',
                'Yangquan',
                'Shanxi Pingding Jucheng Zhongmin solar farm',
                'Zhongmin Xinneng Pingding Photovoltaic Power Generation Co., Ltd.',
                'Zhongmin Energy Control Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shimenkou Town',
                'Pingding County',
                'Yangquan',
                'Shanxi Pingding Shimenkou Three Gorges solar farm',
                'Three Gorges New Energy Pingding Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Souhuang Town',
                'Pingding County',
                'Yangquan',
                'Shanxi Pingding Yuhuangding SPIC solar farm',
                'State Power Investment Group Pingding Dongfang New Energy Power Generation Co., Ltd.',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Souhuang Town',
                'Pingding County',
                'Yangquan',
                'Shanxi Pingding Yuhuangding SPIC solar farm',
                'State Power Investment Group Pingding Dongfang New Energy Power Generation Co., Ltd.',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fenghuangcheng Town',
                'Pinglu District',
                'Shuozhou',
                'Shanxi Pinglu Fenghuangcheng Jingwo solar farm',
                'Shuozhou (Pinglu) Jingwo Photoelectric Technology Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Longxi Town',
                'Pingshun County',
                'Changzhi',
                'Shanxi Pingshun Longxi Zhangze solar farm',
                'Zhangze Power Pingshun New Energy Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Unavailable',
                'Licheng Xian',
                'Changzhi',
                'Shanxi Province Changzhi Licheng "Front Runner" solar farm',
                'not found',
                'LONGi Green Energy Technology Co.,Ltd [51%]; Lianhe Photovoltaic [Changzhou] Investment Group Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Machang Town',
                'Luzhou',
                'Changzhi',
                "Shanxi Province Changzhi Machangzhen Lu'an solar farm",
                "CECEP Shanxi Lu'an Photovoltaic Agricultural Technology Co., Ltd.",
                "CECEP Solar Energy Technology Co., Ltd.[60%]; Shanxi Lu'an Photovoltaic Power Generation Co., Ltd.[40%]",
              ],
              [
                'China',
                250,
                'Asia',
                'Qingyang Town',
                'Pingshun Xian',
                'Changzhi',
                'Shanxi Province Changzhi Pingshun "Front Runner" solar farm',
                'not found',
                'Trina Photosynthetic [51%]; CDB New Energy [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Dangliuzhuang Town',
                'Datong Xian',
                'Datong',
                'Shanxi Province Datong Dangliuzhuang Xiexin solar farm',
                'Datong County GCL Photovoltaic Power Co., Ltd.',
                'Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Gaoshan Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Gaoshanzhen solar project',
                'Datong Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Gaoshan Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Gaoshanzhen Xiaoyaotou solar farm',
                'Datong Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Caicun Town',
                'Hunyuan Xian',
                'Datong',
                'Shanxi Province Datong Hunyuan Caicunzhen solar farm',
                'Hunyuan Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Limited',
              ],
              [
                'China',
                300,
                'Asia',
                'Hunyuan County',
                'Hunyuan Xian',
                'Datong',
                'Shanxi Province Datong Hunyuan solar farm',
                'Datong Guotou Investment Fund Management Co., Ltd.',
                'Datong Guotou Investment Fund Management Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yaerya Town',
                'Southern Suburbs District',
                'Datong',
                "Shanxi Province Datong Southern Suburb Ya'erya solar farm",
                'China Power International Development Co., Ltd.',
                'China Power International Development Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Yungang Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Province Datong Yungang Mayingwa solar farm',
                'Datong Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jinshan Industrial Estate',
                'Xinfu Qu',
                'Xinzhou',
                'Shanxi Province Xinzhou Xinfu District Jinshan Industrial Park Hengneng solar farm',
                'Xinzhou Hengneng Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Caozhang Town',
                'Xinfu Qu',
                'Xinzhou',
                'Shanxi Province Xinzhou Xinfu District Taike solar farm',
                'Xinzhou Taike Photovoltaic Power Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Longquan Town',
                'Yanggao Xian',
                'Datong',
                'Shanxi Province Yanggao Longquan solar farm',
                'Datong Asite New Energy Development Co., Ltd.',
                'Shenneng Nanjing Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dianwan Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Tashan Jiajiagou solar farm',
                'Datong Coal Mine Group Tashan Photovoltaic Power Generation Co., Ltd.',
                'Jinneng Holdings Coal Industry Group Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Dangliuzhuang Town',
                'Datong Xian',
                'Datong',
                'Shanxi Provvince Datong Dangliuxiang Xiexin solar farm',
                'Datong County GCL Photovoltaic Power Co., Ltd.',
                'Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Duanshi Town',
                'Qinshui County',
                'Jincheng',
                'Shanxi Qinshui Duanshi SPIC solar farm',
                'State Power Investment Group Shanxi New Energy Co., Ltd. Qinshui Company',
                'State Power Investment Group Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanghe Town',
                'Qinyuan County',
                'Changzhi',
                'Shanxi Qinyuan Wanghezhen Lianhong solar farm',
                'Qinyuan Lianhong New Energy Co., Ltd.',
                'Shanxi Xinhezhong New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dawang Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" CECEP solar farm',
                'CECEP (Yuncheng) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Duzhuang Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" Dongyao solar farm',
                'Ruicheng Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Xuezhang Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" East Shuiyu Zhongdian solar farm',
                'Ruicheng Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Guwei Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" Huadian solar farm',
                'Shanxi Ruicheng Huadian Fuxin Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xuezhang Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" West Shuiyu solar farm',
                'Ruicheng GCL Photovoltaic Power Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd. [30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangcheng Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng "Front Runner" Xiyao TBEA solar farm',
                'Ruicheng Huiyuan Power Generation Co., Ltd.',
                'Urumqi Huahui Guangsheng Power Generation Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Monan Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng Monanzhen Huaneng solar farm',
                'Huaneng Ruicheng Comprehensive Energy Co., Ltd.',
                'Huaneng Shanxi Comprehensive Energy Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Monan Town',
                'Ruicheng County',
                'Yuncheng',
                'Shanxi Ruicheng Ningsheng solar farm',
                'Ruicheng Ningsheng New Energy Co., Ltd.',
                'Ruicheng Yaosheng Electric Power Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Heshengbao Town',
                'Shanyin County',
                'Shuozhou',
                'Shanxi Shanyin Heshengbao Zhongdian solar farm',
                'Shanyin Zhongdian New Energy Co., Ltd.',
                'State Power Investment Group Shanxi Renewable Energy Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Gucheng Town',
                'Shanyin County',
                'Shuozhou',
                'Shanxi Shanyin Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation (Shanyin) Co., Ltd.',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Longquan Town',
                'Shenchi County',
                'Xinzhou',
                'Shanxi Shenchi Chuankou Guxin solar farm',
                'Shenchi Guxin New Energy Co., Ltd.',
                'Qingdao Chengtou Clean Energy Co., Ltd. [90%]; Qingdao University Information Industry Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Deyu solar farm',
                'Shenmu Deyu Electric Power Co., Ltd.',
                'Shenmu Jingyuan Holding Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Peigou Town',
                'Shilou County',
                'Lvliang',
                'Shanxi Shilou Peigouxiang Atsi solar farm',
                'Shilou Atsi New Energy Co., Ltd.',
                'Shanxi International Energy Group New Energy Investment Management Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuiyao Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Shuiyao solar farm',
                'Three Gorges New Energy (Zuoyun) Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dianwan Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Qinjiashan solar farm',
                'Huadian Datong New Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dianwan Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Mingyang solar farm',
                'Zuoyun Mingyang New Energy Power Generation Co., Ltd.',
                'Sungrow Renewables Development Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Madaotou Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Madaotou solar farm',
                'Zuoyun Zhongdian Photovoltaic Power Co., Ltd.',
                'China Power International Development Limited',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Yanggao Xian',
                'Datong',
                'Shanxi Province Yanggao Shanxi Aoshixiang solar farm',
                'Jinneng Clean Energy Co., Ltd.',
                'Shanxi International Power Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hedi Town',
                'Jiao Qu',
                'Yangquan',
                'Shanxi Province Yangquan Hedizhen Xiaogou solar farm',
                'Yangquan China Guangdong Nuclear Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hedi Town',
                'Jiao Qu',
                'Yangquan',
                'Shanxi Province Yangquan Hedizhen Xiaoxizhuang solar farm',
                'Datong Zhangze Power Yuxian Photovoltaic Power Generation Co., Ltd.',
                'Datong Coal Group Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baijing Town',
                'Pingding Xian',
                'Yangquan',
                'Shanxi Province Yangquan Pingding Jinko solar farm',
                'Pingding Jingko Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jucheng Town',
                'Pingding Xian',
                'Yangquan',
                'Shanxi Province Yangquan Pingding Longzhuang solar farm',
                'Zhongmin New Energy Pingding Photovoltaic Power Co., Ltd.',
                'Zhongmin Energy Control Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shimenkou Town',
                'Pingding Xian',
                'Yangquan',
                'Shanxi Province Yangquan Pingding Shimenkou solar farm',
                'China Three Gorges Corporation',
                'China Three Gorges Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Pingtan Town',
                'Jiao Qu',
                'Yangquan',
                'Shanxi Province Yangquan Pingtanzhen solar farm',
                'Shanghai Aerospace Automobile Electromechanical Co.,Ltd.',
                'Shanghai Aerospace Automobile Electromechanical Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yijing Town',
                'Jiao Qu',
                'Yangquan',
                'Shanxi Province Yangquan Yijingzhen solar farm',
                'Sungrow Power Supply Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Heijiazhuang',
                'Pianguan County',
                'Xinzhou',
                'Shanxi Pianguan Heijiazhuang Huaneng solar farm',
                'Huaneng Xinzhou New Energy Power Generation Co., Ltd. Pianguan Branch',
                'Huaneng Xinzhou New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Lujiacun Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yangquan Yuxian Jiajianao - Zhaojianao solar farm',
                'TBEA Xinjiang New Energy Co., Ltd.',
                'TBEA[32%]; Xinjiang Uygur Autonomous Region Investment Company[20%]; Beijing Tsinghua University Enterprise Group[20%]; Changji Special Transformer Factory[10%]; Others[18%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xishe Town',
                'Jishan Xian',
                'Yuncheng',
                'Shanxi Province Yuncheng Jishan Chaijiazhuang solar farm',
                'State Power Investment Group Jishan Zhongnengda Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Jinghe New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Niucun Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yuxian Niucunzhen solar farm',
                'Yuxian Jinyang New Energy Power Generation Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Niucun Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yuxian Niucunzhen solar farm',
                'Yuxian Jinyang New Energy Power Generation Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Sunjiazhuang Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yuxian Sunjiazhuang Liujiapo solar farm',
                'State Power Investment Corporation Dongfang New Energy Co., Ltd.',
                'State Power Investment Corporation Dongfang New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xianren Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yuxian Xianrenxiang Donghuili solar farm',
                'CECEP (Yangquan) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Beixiazhuang Town',
                'Yu Xian',
                'Yangquan',
                "Shanxi Province Yuxian Zhang'erping solar farm",
                'Trina Solar Co., Ltd.',
                'Trina Solar Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dianwan Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Caojiagou solar farm',
                'Datong Lianhe Photovoltaic New Energy Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dianwan Town',
                'Zuoyun Xian',
                'Datong',
                'Shanxi Province Zuoyun Dianwanzhen Dongtiaojian solar farm',
                'Zuoyun Jinko Power Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Beixiazhuang Town',
                'Yu Xian',
                'Yangquan',
                'Shanxi Province Yangquan Yuxian Xiazhuangxiang solar farm',
                'GCL New Energy Holdings Limited',
                'GCL New Energy Holdings Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Yangjiayao',
                'Nanjiao',
                'Datong',
                'Shanxi Nanjiao Yangjiayao Tashan solar farm',
                'Tashan Photovoltaic Power Generation Co., Ltd. of Datong Coal Mine Group',
                'Datong Coal Mining Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dianshang Town',
                'Lucheng District',
                'Changzhi',
                'Shanxi Lucheng Shengyang solar farm',
                'Lucheng Shengyang Energy Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dianshang Town',
                'Lucheng District',
                'Changzhi',
                'Shanxi Lucheng Shengyang solar farm',
                'Lucheng Shengyang Energy Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dazhangzhuang Town',
                'Yiyuan County',
                'Zibo',
                'Shandong Yiyuan Dazhangzhuangzhen solar farm',
                'Yiyuan Zhongneng Huachen New Energy Co., Ltd.',
                'East Group Co.,Ltd',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuezhuang Town',
                'Yiyuan County',
                'Zibo',
                'Shandong Yiyuan Yanyazhen solar farm',
                'Yiyuan Fuxiang Photovoltaic Power Co., Ltd.',
                'Shandong Fuxiang Group Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Fangsi Town',
                'Yucheng',
                'Dezhou',
                'Shandong Yucheng Fangsi Hanneng solar farm',
                'Hanneng Dezhou Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Shide Real Estate Co., Ltd.',
              ],
              [
                'China',
                21,
                'Asia',
                'Unavailable',
                'Yuncheng County',
                'Heze',
                'Shandong Yuncheng Dongyin Ruiming solar farm',
                'Shandong Yuncheng Ruiming Energy Technology Co., Ltd.',
                'Yuncheng Yingguang Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                29,
                'Asia',
                'Houyanji Town',
                'Yuncheng County',
                'Heze',
                'Shandong Yuncheng Houyanji solar farm',
                'Yuncheng Xinhua Energy Development Co., Ltd.',
                'Shandong GCL New Energy Co., Ltd. [51.00%]; Yuncheng Water Margin Urban Construction Investment Co., Ltd. [49.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengmao Town',
                'Shanting District',
                'Zaozhuang',
                'Shandong Zaozhuang Fengmaozhen Haichuan solar farm',
                'Zaozhuang Haichuan Industrial Co., Ltd.',
                'Zhongmin Xinneng [Beijing] New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liuyuan Town',
                'Yicheng District',
                'Zaozhuang',
                'Shandong Zaozhuang Wangma Puzhao solar farm',
                'Shandong Puzhao Energy Co., Ltd.',
                'Han Meixiao[70.00%]; Song Xiushen[30.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Fucheng Town',
                'Shanting District',
                'Zaozhuang',
                'Shandong Zaozhuang Zhangzhuang Qianshan solar farm',
                'Zaozhuang Qianshan Photovoltaic Energy Co., Ltd.',
                'Beijing Junhui New Energy Technology[95.00%]; Xiao Hongming[5.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaizhen Town',
                'Xintai',
                "Tai'an",
                'Shandong Zhainan Huaneng solar farm',
                'Huaneng Shandong Taifeng New Energy Co., Ltd.',
                'Huaneng Taishan Electric Power Co., Ltd. [82.2223%]; Shandong Taifeng Holding Group Co., Ltd. [13.3333%]; others [4.4444%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Qingfeng Lake',
                'Zhanhua District',
                'Binzhou',
                'Shandong Zhanhua Qingfenghu solar farm',
                'Huaneng Zhanhua Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Zhanhua New Energy Co., Ltd. [58.00%]; Zhanhua Guanghui Agricultural Development Co., Ltd. [42.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gaoqing County',
                'Zibo',
                'Shandong Zibo Gaoqing Guodian Investment solar farm',
                'Shandong Guodian Investment New Energy Co., Ltd.',
                'SDIC Henan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Kunlun Town',
                'Zichuan District',
                'Zibo',
                'Shandong Zibo Kunlunzhen solar farm',
                'Zibo Guanghe New Energy Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Luhu Street',
                'Gaoqing County',
                'Zibo',
                'Shandong Zibo Luhu solar farm',
                'Zibo Huixiang New Energy Co., Ltd.',
                'Tongwei Holdings Pte Ltd [81.8182%]; Tongwei New Energy (Shenzhen) Co., Ltd. [18.1818%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhaili Town',
                'Zichuan District',
                'Zibo',
                'Shandong Zibo Zhaili Zhongyang solar farm',
                'Zibo Zhongyang Solar Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Guoli',
                'Zoucheng',
                'Jining',
                'Shandong Zoucheng Guoli Huahan solar farm',
                'Zoucheng Branch of Jining Huahan Photovoltaic Energy Co., Ltd.',
                'Jining Huahan Photovoltaic Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beisu Town',
                'Zoucheng',
                'Jining',
                'Shandong Zoucheng Saiwei solar farm',
                'Zoucheng Saiwei Solar Energy Ecological Park Development Co., Ltd.',
                'Hou Xiaofeng [28.5714%]; Shandong Zhengfang Holding Group Co., Ltd. [28.5714%]; Hou Qian [21.4286%]; Liu Hongjian [21.4286%]',
              ],
              [
                'China',
                47,
                'Asia',
                'Shijing Town',
                'Fei County',
                'Linyi',
                'Shandongf Feixian Shijingzhen Yifeng solar farm',
                'Shandong Yifeng Light Energy Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                23,
                'Asia',
                'Unavailable',
                'Haiyang',
                'Yantai',
                'Shandong Yantai Xinbao New Energy Co., Ltd. solar farm',
                'Yantai Xinbao New Energy Co., Ltd.',
                'Shanghai Shangdian Xinda New Energy Technology Co., Ltd. [80.00%]; Yantai Balifang New Energy Co., Ltd. [20.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Guanshui Town',
                'Muping District',
                'Yantai',
                'Shandong Yantai Guanshuizhen Delian solar farm',
                'Yantai Delian New Energy Co., Ltd.',
                'Jiangsu Delian Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhai Town',
                'Xintai County',
                "Tai'an",
                'Shandong Xintai Zhaizhen CECEP solar farm',
                'CECEP (Xintai) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd. [83%]; CECEP Solar Energy Hong Kong Co., Ltd. [17%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xizhangzhuang Town',
                'Xintai',
                "Tai'an",
                'Shandong Xintai Sihuai solar farm',
                'Xintai Guanghua Photovoltaic Power Generation Co., Ltd.',
                'Urumqi Mingrui Guangsheng Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lingang Economic and Technological Development Zone',
                'Weihai',
                'Shandong Weihai Shangshantang Agricultural Greenhouse solar farm',
                'Weihai Shantang Agricultural Development Co., Ltd.',
                'Sun Yichen[60%]; Li Liqi[40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Cunzhen Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Coal Mining Subsidence Area solar farm',
                'Weishan Zhongsheng Clean Energy Co., Ltd.',
                'Beijing Beikong Photovoltaic Technology Development Co., Ltd. [90.00%]; Shandong Weisheng New Energy Development Co., Ltd. [10.00%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Huancheng Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Guoyang New Energy Huancheng solar farm',
                'Weishan Guoyang New Energy Power Generation Co., Ltd.',
                'Hefei Yunzhou New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Huancheng Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Huancheng solar farm',
                'Weishan Jingke Power Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangcheng Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Liangchen Zhongguang solar farm',
                'Weishan Zhongguang New Energy Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Liuzhuang',
                'Weishan',
                'Jining',
                'Shandong Weishan Liuzhuang Zhongguang solar farm',
                'Jining Zhongguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fucun Street',
                'Weishan County',
                'Jining',
                'Shandong Weishan Xinneng solar farm',
                'Weishan Xinneng Photovoltaic Power Co., Ltd.',
                'Shandong GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaolou Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Xuri Gaolou solar farm',
                'Weishan Xuri New Energy Co., Ltd.',
                'Shandong Fenghui Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fangzi Township',
                'Pingyuan County',
                'Dezhou',
                'Shangdong China Energy Conservation and Environmental Protection Group Pingyuan solar farm',
                'China Energy Conservation and Environmental Protection Group (Pingyuan) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaolou Town',
                'Weishan County',
                'Jining',
                'Shandong Weishan Xuri Gaolou solar farm',
                'Weishan Xuri New Energy Co., Ltd.',
                'Shandong Fenghui Investment Co., Ltd.',
              ],
              [
                'China',
                29,
                'Asia',
                'Xixiaowang Town',
                'Wudi County',
                'Binzhou',
                'Shandong Wudi Aikang solar farm',
                'Wudi Aikang Power Development Co., Ltd.',
                'Chongqing Changsheng Xinneng Private Equity Investment Fund Partnership (Limited Partnership) [88.7979%]; Yellow River Delta Rongxin Group Co., Ltd. [11.1021%]; Others [0.1000%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xixiaowang Town',
                'Wudi County',
                'Binzhou',
                'Shandong Wudi Aikang solar farm',
                'Wudi Aikang Power Development Co., Ltd.',
                'Chongqing Changsheng Xinneng Private Equity Investment Fund Partnership (Limited Partnership) [88.7979%]; Yellow River Delta Rongxin Group Co., Ltd. [11.1021%]; Others [0.1000%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Liubao Town',
                'Wudi County',
                'Binzhou',
                'Shandong Wudi Liubao solar farm',
                'Wudi Qingneng New Energy Co., Ltd.',
                'Nanjing Qingneng New Energy Development Co., Ltd.',
              ],
              [
                'China',
                29,
                'Asia',
                'Binzhou Port Westport Economic Park',
                'Wudi County',
                'Binzhou',
                'Shandong Wudi Youfa solar farm',
                'Wudi China Power Construction New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [55.00%]; Yellow River Delta Rongxin Group Co., Ltd. [45.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhongzhi Town',
                'Wulian County',
                'Rizhao',
                'Shandong Wulian Zhongzhi solar farm',
                'Wulian Jingke Photovoltaic Power Generation Co., Ltd.',
                'Hubei Lanfeng Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xizhangzhuang Town',
                'Xintai',
                "Tai'an",
                'Shandong Xihan Xintai Xulan solar farm',
                'Xintai Xulan Energy Technology Co., Ltd.',
                'China Resources Shenzhen International Investment Trust Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Quangou Town',
                'Xintai',
                "Tai'an",
                'Shandong Xintai Agriculture-Light Complementary solar farm',
                "Tai'an Jingneng Photovoltaic Power Co., Ltd.",
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Delou Town',
                'Xintai County',
                "Tai'an",
                'Shandong Xintai Delou Jiayang solar farm',
                'Shandong Xintai Delou Jiayang Photovoltaic Power Generation Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Luquantun Town',
                'Wucheng County',
                'Dezhou',
                'Shandong Wucheng Yaosheng Poverty Alleviation solar farm',
                'Wucheng Yaosheng Solar Energy Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd. [51.00%]; Wucheng County Caijin Development Co., Ltd. [49.00%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Yingli Town',
                'Shouguang',
                'Weifang',
                'Shandong Weifang Yangkouzhen solar farm',
                'Shouguang Honghai Power Co., Ltd.',
                'Weifang Yuyong Agricultural Development Co., Ltd.',
              ],
              [
                'China',
                110,
                'Asia',
                'Chenjia Town',
                'Chongming Qu',
                'Shanghai',
                'Shanghai Chongming District Chenjiazhen _x0008_Fishery-Solar Hybrid Project',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Sanduo Town',
                'Daning County',
                'Linfen',
                'Shanxi Daning Sanduoxiang Poverty Alleviation solar farm',
                'Daning Midday Solar Energy Technology Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shencun',
                'Fenxian',
                'Linfen',
                'Shanxi Fenxi Shencun GCL Poverty Alleviation solar farm',
                'Fenxi GCL Photovoltaic Power Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd. [30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Jiajiazhuang Town',
                'Fenyang',
                'Lvliang',
                'Shanxi Fenyang CECEP solar farm',
                'CECEP (Fenyang) Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuancun Town',
                'Gaoping County',
                'Jincheng',
                'Shanxi Gaoping Yuancunxiang Roof Distributed solar farm',
                'Gaoping Xinshi Yangtian Photovoltaic Power Generation Co., Ltd.',
                "Shanxi Shan'an Maode Distributed Energy Technology Co., Ltd.",
              ],
              [
                'China',
                30,
                'Asia',
                'Yueyang Town',
                'Gu County',
                'Linfen',
                'Shanxi Guxian Jiasheng solar farm',
                'Guxian Jiasheng Energy Co., Ltd.',
                'Kelin Environmental Protection Equipment,Inc.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaoliang Town',
                'Hejin',
                'Yuncheng',
                'Shanxi Hejin Xiaoliangxiang Guochang solar farm',
                'Hejin Guochang New Energy Co., Ltd.',
                'Yuncheng Guochang New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xunzhen Town',
                'Hequ County',
                'Xinzhou',
                'Shanxi Hequ Quyucun Zhangze solar farm',
                'Shanxi Zhangze Electric Power Hequ New Energy Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Unavailable',
                'Heshun County',
                'Jinzhong',
                'Shanxi Heshun Shunli Poverty Alleviation solar farm',
                'Heshun Shunli Photovoltaic Poverty Alleviation Co., Ltd.',
                'Heshun Yingli New Energy Co., Ltd. [50%]; Heshun County Photovoltaic Poverty Alleviation Development Investment Co., Ltd. [50%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Gujiang Town',
                'Jiang County',
                'Yuncheng',
                'Shanxi Jiangxian Gujiangzhen Lanzhou Xinsheng solar farm',
                'Shanxi Guohong New Energy Co., Ltd.',
                'Lanzhou Xinsheng Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Tianning Town',
                'Jiaocheng County',
                'Lvliang',
                'Shanxi Jiaocheng Mingke solar farm',
                'Jiaocheng Mingke Photoelectric Technology Co., Ltd.',
                "Xi'an Mingke Photoelectric New Energy Technology Co., Ltd.",
              ],
              [
                'China',
                100,
                'Asia',
                'Taohongpo Town',
                'Jiaokou County',
                'Lvliang',
                'Shanxi Jiaokou Taohongpo Zhuyang solar farm',
                'Jiaokou Zhuyang Energy Co., Ltd.',
                'Hefei Senyang New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shuixiu Town',
                'Taigu District',
                'Jinzhong',
                'Shanxi Jinzhong Taigu solar farm',
                'Taigu Fenghuang Power Generation Co., Ltd.',
                'Shanxi GCL New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Liangjiazhuang Town',
                'Lan County',
                'Lvliang',
                'Shanxi Lanxian Chunhui Rundian solar farm',
                'Lanxian Rundian New Energy Co., Ltd.',
                'China Resources Power Engineering Services Co., Ltd. [51%]; Lanxian Poverty Alleviation and Development Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongjingxiang',
                'Licheng',
                'Changzhi',
                'Shanxi Licheng Hongjingxiang GCL solar farm',
                'Licheng GCL Photovoltaic Power Co., Ltd.',
                'Shanxi GCL New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Guxian',
                'Linfen',
                'Shanxi Linfen Guxian Jiasheng solar farm',
                'Shanxi Jiasheng Energy Co., Ltd.',
                'Shanxi GCL New Energy Technology Co., Ltd. [96%]; Suzhou Xiexin New Energy Investment Co., Ltd.[4%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Duyu Town',
                'Lingqiu County',
                'Datong',
                'Shanxi Lingqiu Bixing solar farm',
                'Shanmei Lingqiu Bixing Industrial Development Co., Ltd.',
                'Shanxi Coking Coal Group New Energy Co., Ltd. [60%]; Beijing Qixing Huadian Technology Group Co., Ltd. [20%]; BYD Automobile Industry Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Lingqiu County',
                'Datong',
                'Shanxi Lingqiu Shanmei solar farm',
                'Shanxi Shanmei New Energy Lingqiu Photovoltaic Development Co., Ltd.',
                'Shanxi Coking Coal Group New Energy Co., Ltd. [45%]; Shanxi Coal Agricultural Development Co., Ltd. [45%]; Lingqiu County Economic Construction Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Lin County',
                'Lvliang',
                'Shanxi Linxian Yulin Mountain Forest Ranch solar farm',
                'Linxian China Power Investment New Energy Power Generation Co., Ltd.',
                'Shanghai Energy Technology Development Co., Ltd. [51%]; Linxian Poverty Alleviation and Development Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Fanshi County',
                'Xinzhou',
                'Shanxi Fanshi Baiyu Poverty Alleviation solar farm',
                'Fanshi Runhong Power Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Sunjiashan',
                'Fangshan County',
                'Lvliang',
                'Shanxi Fangshan Sunjiashan Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation (Fangshan) Co., Ltd.',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd. [51%]; Fangshan County Poverty Alleviation and Development Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Yungang Town',
                'Southern Suburbs District',
                'Datong',
                'Shanxi Datong Yungang Coal Subsidence Area solar farm',
                'CECEP Solar Energy Co., Ltd.',
                'CECEP Solar Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Xinrong District',
                'Datong',
                'Shanxi Datong Xinrong Huarun solar farm',
                'China Resources New Energy (Xinrong) Co., Ltd.',
                'China Resources New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner " Jingneng solar farm',
                'Datong Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Nanjiao Aoneng solar farm',
                'Datong JA Solar Power Generation Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Nanjiao CECEP solar farm',
                'CECEP (Datong) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Nanjiao Heguang solar farm',
                'Datong CGN Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Nanjiao Liguang solar farm',
                'Datong Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Nanjiao Zhengtai solar farm',
                'Datong Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yungang Town',
                'Nanjiao',
                'Datong',
                'Shanxi Datong "Front Runner" Yingli solar farm',
                'Datong Lichuang New Energy Photovoltaic Power Co., Ltd.',
                'nner Mongolia Lichuang Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Datong',
                'Shanxi Datong "Front Runner" Zhongdian solar farm',
                'Datong Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Yanmenguan Town',
                'Dai County',
                'Xinzhou',
                'Shanxi Daixian Baotong solar farm',
                'Daixian Baotong New Energy Technology Co., Ltd.',
                'Liang Zejiang[40%]; Wang Husheng[35%]; Wu Cuilian[25%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Changlian solar farm',
                'Datong United Photovoltaic New Energy Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Jianyuan solar farm',
                'Zuoyun Mingyang New Energy Power Generation Co., Ltd.',
                'Sungrow Renewables Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Kedian solar farm',
                'Zuoyun Jingke Electric Power Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Lanling solar farm',
                'Tashan Photovoltaic Power Generation Co., Ltd. of Datong Coal Mine Group',
                'Jinneng Holding Coal Industry Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Wanhua solar farm',
                'Huadian Datong New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Xiadian solar farm',
                'Three Gorges New Energy (Zuoyun) Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Duzhuang Town',
                'Yunzhou District',
                'Datong',
                'Shanxi Datong Jingneng Panda solar farm',
                'Datong Panda Photovoltaic Power Generation Co., Ltd.',
                'Changzhou Zhaolian Green New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Tianzhen County',
                'Datong',
                'Shanxi Datong Tianzhen Kunpeng solar farm',
                'Shanxi International Energy Group New Energy Investment Management Co., Ltd.',
                'Gemeng International Energy Co., Ltd. [80%]; Shanxi International Energy Group Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Datong',
                'Datong',
                'Shanxi Datong Xinneng solar farm',
                'Datong Xinneng Photovoltaic Power Co., Ltd.',
                'Datong GCL Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zuoyun County',
                'Datong',
                'Shanxi Datong "Front Runner" Zuoyun Haoyun solar farm',
                'Zuoyun Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Chunhua solar farm',
                'Shenmu Guangneng Technology Development Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ruoqiang County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Ruoqiang Guoxin solar farm',
                'Ruoqiang County Guoxin Sun Power Co., Ltd.',
                'KuangDa New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caijiapo Town',
                'Qishan County',
                'Baoji',
                'Shaanxi Qishan Changneng solar farm',
                'Qishan Changneng Solar Power Generation Co., Ltd.',
                'Shaanxi Changling Electric Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hualong County',
                'Haidong',
                'Qinghai Haidong Hualong Yuantong solar farm',
                'Haidong Yuantong Photovoltaic Power Generation Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongshui Town',
                'Ledu District',
                'Haidong',
                'Qinghai Haidong Ledu CGN solar farm',
                'CGN New Energy (Ledu) Co., Ltd.',
                'CGN New Energy Investment (Shenzhen) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ledu County',
                'Haidong',
                'Qinghai Haidong Ledu Chuanghui solar farm',
                'Qinghai Chuanghui New Energy Co., Ltd.',
                'Qinghai Tuori New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaying Town',
                'Ledu District',
                'Haidong',
                'Qinghai Haidong Ledu Ruide Xingyang solar farm',
                'Haidong Ruide Xingyang New Energy Technology Co., Ltd.',
                'Jiangsu Zhongxinneng Power Technology Group Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Yurun Town',
                'Ledu District',
                'Haidong',
                'Qinghai Haidong Zhongxinneng solar farm',
                'Haidong Zhongxinneng Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Zhongli Tenghui New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan',
                'Qinghai Hainan Gonghe Guangheng solar farm',
                'Qinghai Guangheng New Energy Co., Ltd.',
                'Luneng New Energy [Group] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainan Gonghe Juya solar farm',
                'Hainan Juya New Energy Co., Ltd.',
                'Asia Silicon (Qinghai) New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan',
                'Qinghai Hainan Gonghe Zhonghui solar farm',
                'Hainan Zhonghui New Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Talatan',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Hainan Prefecture Qingshui solar farm',
                'Hainan Qingshui Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Huangdian Siwei New Energy Management Co., Ltd.; Qinghai Water Resources and Hydropower (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainan State Solar Power Industrial Park solar farm',
                'Gonghe Photovoltaic Power Generation Co., Ltd. of Qinghai Water Resources and Hydropower Group',
                'Qinghai Huangdian Siwei New Energy Management Co., Ltd. [70%]; Qinghai Water Resources and Hydropower (Group) Co., Ltd. [30%]',
              ],
              [
                'China',
                1000,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainan Talatan 1 solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainan Talatan 3 solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainan Talatan 5 solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hainan Prefecture Solar Ecological Power Generation Industrial Park',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-10 Plot solar farm',
                'Huaneng Hainan New Energy Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hainan Prefecture Solar Ecological Power Generation Industrial Park',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-11 Plot solar farm',
                'Huaneng Hainan New Energy Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hainan Prefecture Solar Ecological Power Generation Industrial Park',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-12 Plot solar farm',
                'Huaneng Hainan New Energy Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Photovoltaic Park',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-13 Plot solar farm',
                'Trina Solar Co., Ltd.',
                'Trina Solar Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Dehenglong Town',
                'Hualong County',
                'Donghai',
                'Qinghai Haidong Hualong Yagui solar farm',
                'Haidong Asia Silicon New Energy Development Co., Ltd.',
                'Asia Silicon Industry (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Longyangxia Reservoir Area',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-14 Plot solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Ground Centralized Poverty Alleviation solar farm',
                'Qinghai Poverty Relief Photovoltaic New Energy Co., Ltd.',
                'Shenzhen Nanguo Energy Co., Ltd. [60%]; Qinghai Provincial Poverty Alleviation and Development Investment Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Zhongli Tenghui solar farm',
                'Zhongli Tenghui Hainan Electric Power Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Golmud Sunshine Qiheng solar farm',
                'Golmud Sunshine Qiheng New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud Yagui solar farm',
                'Golmud ASI New Energy Co., Ltd.',
                'Asia Silicon Industry (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Chaidamu solar farm',
                'Gonghe Chaidamu Energy Development Co., Ltd.',
                'Qinghai Chaidamu Energy Investment Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Datang solar farm',
                'Qinghai Datang International Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Datang International New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Gonghe Huadian solar farm',
                'Huadian Gonghe Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Huadian solar farm',
                'Huadian Gonghe Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Huaneng solar farm',
                'Gonghe Huaneng Solar Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Lantian solar farm',
                'Hainan Lantian New Energy Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Minghui solar farm',
                'Hainan Minghui New Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Gonghe National Level Photovoltaic Solar Testing and Proving Base',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd. Xining Solar Power Branch',
                'Qinghai Yellow River Upstream Hydro Development Company Ltd. [State Power Investent Group]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan',
                'Qinghai Gonghe National Photovoltaic Power Generation Test Base solar farm',
                'Photovoltaic Industry Technology Branch of Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Gonghe',
                'Hainan',
                'Qinghai Gonghe Putian solar farm',
                'Hainan Putian New Energy Power Co., Ltd.',
                'East China Xinhua Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan',
                'Qinghai Gonghe Quansheng solar farm',
                'Hainan Quansheng Photovoltaic Co., Ltd.',
                'Bao Quanjun[25%]; Luo Gan[25%]; Xia Kai[25%]; Wang Kai[25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Gonghe Tiancheng solar farm',
                'Gonghe Tiancheng New Energy Co., Ltd.',
                'Qinghai Tuori New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe',
                'Hainan',
                'Qinghai Gonghe Xinte solar farm',
                'Gonghe Xinte Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Chongqing Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe',
                'Hainan',
                'Qinghai Gonghe Zhengtai solar farm',
                'Gonghe Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Chongqing Electric Power Co., Ltd. [70%]; Zhejiang Chint New Energy Development Co., Ltd. [30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                "Qinghai Gonghe Zhong'an Yongtai solar farm",
                "Zhong'an Yongtai (Qinghai) Economic and Technological Cooperation Co., Ltd.",
                'Zhong An Yongtai Economic and Technical Cooperation Co., Ltd. [90%]; Wang Dong [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Gonghe',
                'Hainan',
                'Qinghai Gonghe Zhuma solar farm',
                'Hainan Zhuma New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [99.9%]; Qinghai Zhuma Sapphire Crystal Co., Ltd. [0.1%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Longyangxia Reservoir Area',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-15 Plot solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Longyangxia Reservoir Area',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-16 Plot solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hainan Prefecture Solar Ecological Power Generation Industrial Park',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-2 Plot solar farm',
                'Three Gorges New Energy Gonghe Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha "Front Runner" solar farm',
                'Qinghai SDN Corporation and GCL Group Unite',
                'Qinghai State-owned Assets Investment Management Co., Ltd. [60%]; GCL Group Co., Ltd. [40%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha "Front Runner" solar farm',
                'Qinghai SDN Corporation and GCL Group Unite',
                'Qinghai State-owned Assets Investment Management Co., Ltd. [60%]; GCL Group Co., Ltd. [40%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha "Front Runner" solar farm',
                'Huaneng Group and Shen Tuo Ri New Energy Company Unite',
                'China Huaneng Group Co., Ltd. [90%]; Shenzhen Topsun New Energy Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha "Front Runner" solar farm',
                'China Cantonese Nuclear Group and Haixi State Investment Company Unite',
                'China Guangdong Nuclear Power Development Co., Ltd. [80%]; Haixi Development Investment Green Energy Photovoltaic Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Keluke Town',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha Bailu solar farm',
                'Delingha Bailu Photovoltaic Power Co., Ltd.',
                'Jinxin Century New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Zhou',
                'Qinghai Province Delingha Datang solar farm',
                'Datang Delingha New Energy Co., Ltd.',
                'China Datang Corporation Renewable Power Co.,Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Zhou',
                'Qinghai Province Delingha Datang solar farm',
                'Datang Delingha New Energy Co., Ltd.',
                'China Datang Corporation Renewable Power Co.,Limited',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Zhou',
                'Qinghai Province Delingha Huanghe Medium Hydropower solar farm',
                'Qinghai Yellow River Medium Type Hydropower Development Co., Ltd.',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha Linuo solar farm',
                'Qinghai Linuo Solar Power Engineering Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha Linuo solar farm',
                'Qinghai Linuo Solar Power Engineering Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha Supcon solar farm',
                'Qinghai Supcon Solar Power Co., Ltd.',
                'Zhejiang Kesheng Technology Co., Ltd. [51%]; Zhejiang Zhongguang New Energy Technology Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha Three Gorges solar farm',
                'Three Gorges New Energy Delingha Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha City',
                'Haixi Zhou',
                'Qinghai Province Delingha Xiehe solar farm',
                'Delingha Xiehe Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha City',
                'Haixi Zhou',
                'Qinghai Province Delingha Xiehe solar farm',
                'Delingha Xiehe Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Beikong Grid-Connected solar farm',
                'Beijing Enterprises Green Production (Qinghai) New Energy Co., Ltd.',
                'Beijing Instrument Industry Group Co., Ltd.[85%]; Beijing Enterprises Green Industrial Investments Limited[15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Beikong Grid-Connected solar farm',
                'Beijing Enterprises Green Production (Qinghai) New Energy Co., Ltd.',
                'Beijing Instrument Industry Group Co., Ltd.[85%]; Beijing Enterprises Green Industrial Investments Limited[15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Beikong Grid-Connected solar farm',
                'Beijing Enterprises Green Production (Qinghai) New Energy Co., Ltd.',
                'Beijing Instrument Industry Group Co., Ltd.[85%]; Beijing Enterprises Green Industrial Investments Limited[15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha Shi',
                'Haixi Zhou',
                'Qinghai Province Delingha "Front Runner" solar farm',
                'Qinghai SDN Corporation and GCL Group Unite',
                'Qinghai State-owned Assets Investment Management Co., Ltd. [60%]; GCL Group Co., Ltd. [40%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Xitieshan Town',
                'Dachaidan Weiyuanhui',
                'Haixi Zhou',
                'Qinghai Province Dachaidan Xitieshan CGN Grid-Connected solar farm',
                'CGN Solar Energy (Dachaidan) Development Co., Ltd.',
                'CGN New Energy Investment [Shenzhen] Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xitieshan Town',
                'Dachaidan Weiyuanhui',
                'Haixi Zhou',
                'Qinghai Province Dachaidan Xitieshan CGN Grid-Connected solar farm',
                'CGN Solar Energy (Dachaidan) Development Co., Ltd.',
                'CGN New Energy Investment [Shenzhen] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xitieshan Town',
                'Dachaidan Weiyuanhui',
                'Haixi Zhou',
                'Qinghai Province Dachaidan Xitieshan CECEP Grid-Connected solar farm',
                'CECEP Qinghai Dachaidan Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tala Beach',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-7 Plot solar farm',
                'China Energy Construction Group Investment Co., Ltd.',
                'China Energy Construction Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-8 Plot solar farm',
                'CNNC Shandong Energy Co., Ltd.',
                'China National Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Gonghe County',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou 2020-9 Plot solar farm',
                'CNNC Shandong Energy Co., Ltd.',
                'China National Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Hainanzhou Energy Storage Demonstration solar farm',
                'Photovoltaic Industry Technology Branch of Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Prefecture',
                'Qinghai Hainanzhou Gonghe Juya solar farm',
                'Hainan Juya New Energy Co., Ltd.',
                'Asia Silicon Industry (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan',
                'Qinghai Hainanzhou Solar Ecological Power Generation Industrial Park 2016-1 Lot solar farm',
                'Yellow River Hydropower Gonghe Solar Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Haixi Delingha Ruiqida solar farm',
                'Beijing Ruiqida Delingha Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd. [89%]; Qinghai Ruiqida New Energy Technology Development Co., Ltd. [11%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Haixi Wutumeiren 2 solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud City',
                'Golmud',
                'Qinghai Golmud Photovoltaic Power Generation Industrial Park 2016-8 solar farm',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd. Golmud Solar Power Generation Branch',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Haixi Wutumeiren 3 solar farm',
                'Qinghai Huangdian Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hualong County',
                'Haidong',
                'Qinghai Hualong Chaidamu solar farm',
                'Hualong Chaidamu Energy Development Co., Ltd.',
                'Qinghai Chaidamu Energy Investment Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hualong County',
                'Haidong',
                'Qinghai Hualong Ruiqida solar farm',
                'Hualong Ruiqida New Energy Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dehenglong Town',
                'Hualong County',
                'Haidong',
                'Qinghai Hualong Xiehe solar farm',
                'Hualong Xiehe Solar Power Co., Ltd.',
                'Qinghai GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'https://www.qcc.com/firm/3fe92e419a320c6df8ef9d929d192b56.html',
                'Dachaidan',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Huzhu CECEP solar farm',
                'CECEP Qinghai Dachaidan Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Hongyazigou Town',
                'Huzhu County',
                'Haidong',
                'Qinghai Huzhu Haoyang solar farm',
                'Huzhu Haoyang Photovoltaic Power Generation Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Hongyazigou Town',
                'Huzhu County',
                'Haidong',
                'Qinghai Huzhu Zhongxinneng solar farm',
                'Huzhu Zhongxinneng Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Zhongli Tenghui New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jianzhatan Town',
                'Jianzha County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Jianzha Huatuo solar farm',
                'Qinghai Huatuo New Energy Co., Ltd.',
                'Qinghai Zhexineng Qingfa Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xitieshan Town',
                'Dachaidan Weiyuanhui',
                'Haixi Zhou',
                'Qinghai Province Dachaidan Xitieshan CECEP Grid-Connected solar farm',
                'CECEP Qinghai Dachaidan Solar Power Generation Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Haixizhou Delingha Yagui solar farm',
                'Haixi ASI New Energy Development Co., Ltd.',
                'Asia Silicon Industry (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud City',
                'Golmud',
                'Qinghai Golmud Northwest Hydropower solar farm',
                'Golmud Northwest Hydropower New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [70%]; China Power Construction Group Qinghai Electric Power Design Institute Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud Luneng solar farm',
                'Qinghai Golmud Luneng New Energy Co., Ltd.',
                'Luneng New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud Huazhi solar farm',
                'Qinghai Huazhi New Energy Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd. [75%]; Qinghai Tuori New Energy Technology Co., Ltd. [20%]; Qinghai Provincial Development Investment Co., Ltd. [5%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Hengyang solar farm',
                'Ningxia Hengyang New Energy Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd. [80%]; Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Huaneng solar farm',
                'Huaneng Ningxia Energy Co., Ltd.',
                'China Huaneng Group',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Jingneng solar farm',
                'Ningxia Jingneng Zhongwei New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Jinli Agricultural solar farm',
                'Ningxia Jinli Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Jinxin Agricultural solar farm',
                'Ningxia Jinxin Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Shengyang Grid-Connected solar farm',
                'Ningxia Shengyang New Energy Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Taike solar farm',
                'Ningxia Zhongwei Taike Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy (Shanghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongning',
                'Ningxia Zhongwei Shapotou Zhenfa solar farm',
                'Zhongwei Zhenfa Desert Photovoltaic Power Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Zhenfa solar farm',
                'Zhongwei Zhenfa Desert Photovoltaic Power Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Zhenfa solar farm',
                'Ningxia Jinyang New Energy Co., Ltd.',
                'Zhenfa Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Zhenyang solar farm',
                'Ningxia Zhenyang New Energy Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Zhongye Meiliyun solar farm',
                'Ningxia Zhongye Meiliyun New Energy Co., Ltd.',
                'MCC Meiliyun Industrial Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sikouzi',
                'Zhongwei',
                'Ningxia Zhongwei Sikouzi Ningdian solar farm',
                'Zhongwei Ningdian New Energy Co., Ltd.',
                'China Aluminum Ningxia Energy Group Co., Ltd.[89.5%]; Zhongwei State-owned Capital Operation Co., Ltd.[10.5%]',
              ],
              [
                'China',
                130,
                'Asia',
                'Unavailable',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Tianyun Cloud Base solar farm',
                'Zhongwei Tianyun New Energy Technology Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Weigang Ground solar farm',
                'Ningxia Weigang New Energy Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [100%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Yingshuiqiao Qingyang solar farm',
                'Ningxia Qingyang New Energy Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd. [80%]; Jiawei (Shanghai) Photovoltaic Power Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Yinyang Agricultural solar farm',
                'Ningxia Yinyang Solar Power Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Hengji Weiye solar farm',
                'Zhongwei Hengji Weiye Photovoltaic Power Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Hengji Weiye solar farm',
                'Zhongwei Hengji Weiye Photovoltaic Power Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yuanhe Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou Enfi Grid-Connected solar farm',
                'ENFI New Energy (Zhongwei) Co., Ltd.',
                'China Enfi Engineering Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou CGN Suobao solar farm',
                'Ningxia Suo Bao New Energy Technology Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                44,
                'Asia',
                'Peigou Town',
                'Shilou County',
                'Lvliang',
                'Shanxi Shilou Peigouxiang Atsi solar farm',
                'Shilou Atsi New Energy Co., Ltd.',
                'Shanxi International Energy Group New Energy Investment Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Pengpu Town',
                'Yuanzhou District',
                'Guyuan',
                'Ningxia Yuanzhou District CECEP Zhenfa solar farm',
                'Guyuan Zhongneng Zhenlv Power Generation Co., Ltd.',
                'CECEP Solar Technology (Zhenjiang) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Pengpu',
                'Yuanzhou',
                'Guyuan',
                'Ningxia Yuanzhou Pengpu Zhenfa solar farm',
                'Guyuan Zhongneng Zhenlv Power Generation Co., Ltd.',
                'Cecep Solar Energy Technology (Zhenjiang) Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Hanshui Town',
                'Zhongning County',
                'Zhongwei',
                'Ningxia Zhongning Hanjiaoshui Longji solar farm',
                'Zhongning Longji Photovoltaic New Energy Co., Ltd.',
                "Wuling Power Co., Ltd. [70%]; Xi'an LONGi Clean Energy Co., Ltd. [30%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Yuding Town',
                'Zhongning County',
                'Zhongwei',
                'Ningxia Zhongning Longji Tianhua Ground solar farm',
                'Zhongning Longji Tianhua New Energy Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [51%]; Ningxia LONGi Silicon Materials Co., Ltd. [49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Shikong',
                'Zhongning Xian',
                'Zhongwei',
                'Ningxia Zhongning Photovoltaic Estate solar farm',
                'Enfi New Energy (Zhongning) Co., Ltd.',
                'Sumec Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zhongning County',
                'Zhongwei',
                'Ningxia Zhongning Xingye Jinxiu solar farm',
                'Zhongning Xingye Jinxiu New Energy Co., Ltd.',
                'Ningxia Jinxiu Longteng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuding',
                'Zhongning',
                'Zhongwei',
                'Ningxia Zhongning Yuding Longji Tianhua solar farm',
                'Zhongning Longji Tianhua New Energy Co., Ltd.',
                'CDB New Energy Technology Co., Ltd. [51%]; Ningxia Longji Silicon Material Co., Ltd. [49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Yinyang solar farm',
                'Ningxia Baiming Photovoltaic Power Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Zhongning County',
                'Zhongwei',
                'Ningxia Zhongning Zhongmei Ward solar farm',
                'Ningxia Zhongmei Ward New Energy Co., Ltd.',
                'Shanxi Golden Ocean Investment Co., Ltd. [40%]; Beijing World Financial Investment Holdings Co., Ltd. [30%]; Hong Kong Amazon Financing Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Changle Town',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Changle Huihe Fengguang solar farm',
                'Ningxia Huihe Fengguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei GCL solar farm',
                'Ningxia Zhongwei GCL Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Zhongwei',
                'Ningxia Zhongwei Guodian solar farm',
                'Ningxia Guodian Atlas New Energy Development Co., Ltd.',
                'Guodian Power Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Zhongning Shi',
                'Zhongwei',
                'Ningxia Zhongwei Jinyang New Energy solar farm',
                'Ningxia Jinyang New Energy Co., Ltd.',
                'Zhenfa Energy Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shapotou District',
                'Zhongwei',
                'Ningxia Zhongwei Ningqing solar farm',
                'Ningxia Zhongwei Ningqing Photovoltaic Power Co., Ltd.',
                'Ningxia Hui Autonomous Region Electric Power Design Institute Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou CECEP solar farm',
                'CECEP Zhongwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou CECEP solar farm',
                'CECEP Zhongwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Shapotou CGN Suobao solar farm',
                'Ningxia Suo Bao New Energy Technology Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao Town',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Changhe solar farm',
                'Ningxia Zhongwei Changhe New Energy Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.[86%]; Ningxia Haoneng New Energy Co., Ltd.[14%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Beikong Grid-Connected solar farm',
                'Beijing Enterprises Green Production (Qinghai) New Energy Co., Ltd.',
                'Beijing Instrument Industry Group Co., Ltd.[85%]; Beijing Enterprises Green Industrial Investments Limited[15%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shapotou Qu',
                'Zhongwei',
                'Ningxia Zhongwei Yuantu Agricultural solar farm',
                'Ningxia Yuantu Solar Power Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zaoyuan',
                'Zhongning',
                'Zhongwei',
                'Ningxia Zhongwei Zhongning Yinxin solar farm',
                'Ningxia Yinxing Energy Co.,Ltd.',
                'Ningxia Yinxing Energy Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Delingha Xiayang solar farm',
                'Delingha Xiayang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha Zhongkong solar farm',
                'Qinghai Zhongkong Solar Power Generation Co., Ltd.',
                'Zhejiang Kesheng Technology Co., Ltd. [51%]; Zhejiang Zhongguang New Energy Technology Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gangcha County',
                'Haibei',
                'Qinghai Gangcha Yizhao solar farm',
                'Gangcha Yizhao New Energy Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Goldmud TEBA solar farm',
                'Golmud TBEA New Energy Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud "Front Runner" Three Gorges No.1 solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud "Front Runner" Three Gorges No.2 solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud "Front Runner" Three Gorges No.3 solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud "Front Runner" Three Gorges No.4 solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud "Front Runner" Three Gorges No.5 solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud City',
                'Golmud',
                'Qinghai Golmud Guangke solar farm',
                'Golmud Guangke Photovoltaic New Energy Co., Ltd.',
                'Hainan Guangke Photovoltaic New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi',
                'Qinghai Golmud Guodian solar farm',
                'National Energy Group Golmud Photovoltaic Power Generation Co., Ltd.',
                'National Energy Investment Group Co., Ltd. [60%]; Kunshan Runbow Supply Chain Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Golmud HHSD Newly Added solar farm',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd. Golmud Solar Power Generation Branch',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Golmud HHSD solar farm',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd. Golmud Solar Power Generation Branch',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Golmud Huaheng solar farm',
                'Qinghai Huaheng New Energy Co., Ltd',
                'Qinghai Zhexineng Qingfa Energy Co., Ltd.',
              ],
              [
                'China',
                65,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi',
                'Qinghai Golmud Huaneng 65MW solar farm',
                'Huaneng Gomud Pv Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                45,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi',
                'Qinghai Golmud Huaneng solar farm',
                'Golmud Huaneng Solar Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi',
                'Qinghai Golmud Huaneng Tuori solar farm',
                'Golmud Huaneng Tuori New Energy Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd. [60%]; Qinghai Tuori New Energy Technology Co., Ltd. [30%]; Qinghai Baineng Huitong New Energy Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Delingha Three Gorges solar farm',
                'Three Gorges New Energy Delingha Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai Delingha Shidai solar farm',
                'Delingha Times New Energy Power Generation Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai Delingha Ruide Xingyang solar farm',
                'Qinghai Ruidexingyang New Energy Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai Delingha Ruide Xingyang solar farm',
                'Qinghai Ruidexingyang New Energy Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                115,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Hainan Gonghe County Yellow River Upstream solar farm',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd. Xining Solar Power Branch',
                'Qinghai Yellow River Upstream Hydro Development Company Ltd. [State Power Investent Group]',
              ],
              [
                'China',
                500,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Hainan Gonghe Photovoltaic/Wind/Hydro solar farm',
                'Yellow River Hydropower Xining Solar Power Co., Ltd.',
                'Qinghai Yellow River Upstream Hydro Development Company Ltd. [State Power Investent Group]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai CGN Solar Delingha solar farm',
                'CGN Solar (Delingha) Photovoltaic Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jianzhatan Town',
                'Jianzha County',
                'Unavailable',
                'Qinghai Conservancy and Hydropower Group Jianzha solar farm',
                'Qinghai Conservancy and Hydropower Group Jianzha Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Huangdian Siwei New Energy Management Co., Ltd.; Qinghai Water Resources and Hydropower (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha "Front Runner" CGN solar farm',
                'CGN Haixi Solar Energy Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd. [80%]; Haixi SDIC Green Energy Photovoltaic Co., Ltd. [20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha "Front Runner" Huaneng Tuori solar farm',
                'Delingha Huaneng Tuori New Energy Power Generation Co., Ltd.',
                'Huaneng Qinghai Power Generation Co., Ltd. [99.97%]; Haixi Breit New Energy Technology Co., Ltd. [0.03%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha "Front Runner" Huawo solar farm',
                'Qinghai Huawo New Energy Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd. [60%]; Qinghai Xieyang Solar Power Co., Ltd. [40%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha "Front Runner" Xiechen solar farm',
                'Delingha Xiechen Photovoltaic Power Co., Ltd.',
                'Qinghai Xiechen Photovoltaic Power Co., Ltd. [60%]; Qinghai Green Power Generation Group Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zhongning Xian',
                'Zhongwei',
                'Ningxia Zhongwei Zhongning Jingneng solar farm',
                'Ningxia Zhongning Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha "Front Runner" Xieyue solar farm',
                'Delingha Xieyue Photovoltaic Power Co., Ltd.',
                'Qinghai Xieyue Photovoltaic Power Co., Ltd. [60%]; Qinghai Green Power Group Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha CGN solar farm',
                'CGN Delingha Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai Delingha Huadian solar farm',
                'Huadian Delingha Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd. [80%]; Lianyungang Shenzhou New Energy Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha Huarun solar farm',
                'China Resources New Energy Photovoltaic Power Generation (Delingha) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha Juguang solar farm',
                'Haixi Juguang Photovoltaic Power Station Co., Ltd.',
                'Xining National Low Carbon Industry Fund Investment Management Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi',
                'Qinghai Delingha Juneng solar farm',
                'Delingha Juneng Power New Energy Co., Ltd.',
                'Qinghai Huangdian Siwei New Energy Management Co., Ltd. [70%]; Qinghai Water Resources and Hydropower (Group) Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Prefecture',
                'Qinghai Delingha Longguang solar farm',
                'Delingha Longguang Energy Co., Ltd.',
                'Asia Silicon Industry (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Delingha',
                'Qinghai Delingha Northwest Hydropower solar farm',
                'Delingha Northwest Hydropower New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Delingha Rijing solar farm',
                'Delingha Rijing New Energy Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Delingha',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Delingha Baike Guangdian solar farm',
                'Qinghai Encyclopedia Photoelectric Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Beikong Grid-Connected solar farm',
                'Beijing Enterprises Green Production (Qinghai) New Energy Co., Ltd.',
                'Beijing Instrument Industry Group Co., Ltd.[85%]; Beijing Enterprises Green Industrial Investments Limited[15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud',
                'Haixi Zhou',
                'Qinghai Province Golmud Datang Grid-Connected solar farm',
                'Datang Golmud Solar Power Co., Ltd.',
                'Datang Qinghai Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud',
                'Haixi Zhou',
                'Qinghai Province Golmud Datang International solar farm',
                'Qinghai Datang International Golmud Photovoltaic Power Generation Co., Ltd.',
                'Datang International Power Generation Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Zhengxin solar farm',
                'Yulin Zhengxin Electric Power Construction Co., Ltd.',
                'Shanghai Electric Engineering Design Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Zhixinda solar farm',
                'Dingbian Zhixinda New Energy Co., Ltd.',
                'Changshu Honglue Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhuanjing Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Zhuanjingzhen solar farm',
                'Shaanxi Dingbian Clean Energy Power Generation Co., Ltd.',
                'Jilin Electric Power Co., Ltd. [72%]; Bank of Communications Financial Assets Investment Co., Ltd. [28%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fengxiang',
                'Baoji',
                'Shaanxi Fengxiang Fengming solar farm',
                'Fengxiang Fengming Photovoltaic Power Co., Ltd.',
                'Zhenfa Energy Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liuji Town',
                'Fuping County',
                'Weinan',
                'Shaanxi Fuping Yaosheng solar farm',
                'Fuping Yaosheng Photoelectric Technology Co., Ltd.',
                'Shaanxi Yaosheng Optoelectronics Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hengshan District',
                'Yulin',
                'Shaanxi Hengshan Jiangshan solar farm',
                'Hengshan Jiangshan New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Heyang',
                'Weinan',
                'Shaanxi Heyang Guihua solar farm',
                'Shaanxi Heyang Guihua Clean Energy Co., Ltd.',
                'Shaanxi Guihua Clean Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Lujing',
                'Heyang',
                'Weinan',
                'Shaanxi Heyang Lujing Guihua solar farm',
                'Shaanxi Heyang Guihua Clean Energy Co., Ltd.',
                'Shaanxi Guihua Clean Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Huanglong County',
                "Yan'an",
                'Shaanxi Huanglong Dongze solar farm',
                'Huanglong Dongze New Energy Development Co., Ltd.',
                'Zhejiang Aifeisheng Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huanglong County',
                "Yan'an",
                'Shaanxi Huanglong Longji solar farm',
                'Huanglong Longfu Clean Energy Co., Ltd.',
                'Shaanxi Water Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Huanglong County',
                "Yan'an",
                'Shaanxi Huanglong Longrun solar farm',
                'Shaanxi Huanglong Longrun New Energy Investment Co., Ltd.',
                'Beijing Guorun Tianneng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Jingbian',
                'Yulin',
                'Shaanxi Jingbian Cecep solar farm',
                'Huaneng Shaanxi Jingbian Electric Power Co., Ltd.',
                'Huaneng Shaanxi Power Generation Co., Ltd.',
              ],
              [
                'China',
                45,
                'Asia',
                'Unavailable',
                'Jingbian',
                'Yulin',
                'Shaanxi Jingbian Jingbian solar farm',
                'Huaneng Shaanxi Jingbian Electric Power Co., Ltd.',
                'Huaneng Shaanxi Power Generation Co., Ltd.',
              ],
              [
                'China',
                38,
                'Asia',
                'Shangqianjing',
                'Jingbian County',
                'Yulin',
                'Shaanxi Jingbian Shangqianjing solar farm',
                'Shaanxi Photovoltaic Solar Power Generation Co., Ltd.',
                'Shaanxi Photovoltaic Industry Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Jingbian',
                'Yulin',
                'Shaanxi Jingbian Shunfeng solar farm',
                'Jingbian Shunfeng New Energy Co., Ltd.',
                'Beijing Zhongshui Investment Management Center [99.6%]; Suzhou Xiexin New Energy Investment Co., Ltd. [0.4%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangqiaopan',
                'Jingbian County',
                'Yulin',
                'Shaanxi Jingbian Yangqiaopan Dongtou solar farm',
                'Jingbian Dongtou Energy Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Linyou',
                'Baoji',
                'Shaanxi Linyou Changsheng solar farm',
                'Linyou Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Zhengxin solar farm',
                'Yulin Zhengxin Electric Power Co., Ltd.',
                'Jiangshan Yongtai Investment Holdings Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Yueliangwan Huaneng solar farm',
                'Huaneng Shaanxi Dingbian Electric Power Co., Ltd.',
                'Huaneng Shaanxi Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Zhuanjing Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Xiongfeng solar farm',
                'Shaanxi Xiongfeng New Energy Co., Ltd.',
                'Jinneng Holding Shanxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Wanheshun solar farm',
                'Dingbian Wanheshun New Energy Power Generation Co., Ltd.',
                'Changzhou Jintan District Tianhao New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wulan Xian',
                'Haixi Zhou',
                'Qinghai Province Wulan Yuhui Grid-Connected solar farm',
                'Qinghai Yuhui New Energy Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wulan Xian',
                'Haixi Zhou',
                'Qinghai Province Wulan Yuhui Grid-Connected solar farm',
                'Qinghai Yuhui New Energy Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ulan',
                'Haixi',
                'Qinghai Ulan Yiduo solar farm',
                'Ulan Yiduo New Energy Co., Ltd.',
                'Qinghai Zhineng Xiangying New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                1000,
                'Asia',
                'Wutumeiren Town',
                'Golmud',
                'Haixi Mongol and Tibetan Autonomous Prefecture',
                'Qinghai Wutumeiren solar farm',
                'Qinghai Shanmei New Energy Technology Co., Ltd.',
                'Shaanxi Coal and Chemical Industry Group Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Gonghe County',
                'Hainan Tibetan Autonomous Prefecture',
                'Qinghai Yellow River Hydropower Gonghe solar farm',
                'Yellow River Hydropower Gonghe Solar Power Generation Co., Ltd.',
                'Qinghai Upper Yellow River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Baishui County',
                'Weinan',
                'Shaanxi Baishui Dingxin solar farm',
                'Baishui Dingxin Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu Zhongxinneng Power Technology Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Baishui County',
                'Weinan',
                'Shaanxi Baishui Xindahang solar farm',
                'Baishui Xindahang Energy Technology Co., Ltd.',
                'Jiangsu Zhongxinneng Power Technology Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Baishui',
                'Weinan',
                'Shaanxi Baishui Zhongdi solar farm',
                'Shaanxi Zhongdi Energy Development and Construction Co., Ltd. Baishui Company',
                'Shaanxi Zhongdi Energy Development & Construction Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yaolingzi',
                'Long County',
                'Baoji',
                'Shaanxi Longxian Yaolingzi solar farm',
                'Baoji Risheng Ruineng Photovoltaic Agricultural Technology Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Anli Town',
                'Chengcheng',
                'Weinan',
                'Shaanxi Chengcheng Anlizhen Changsheng solar farm',
                'Chengcheng Changsheng Solar Energy Technology Co., Ltd.',
                'Bayannaoer Xinsheng Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dali',
                'Weinan',
                'Shaanxi Dali Guoneng solar farm',
                'Dali Zhongdian Guoneng New Energy Development Co., Ltd.',
                'Huarun Shenguotou Trust Co., Ltd.',
              ],
              [
                'China',
                22,
                'Asia',
                'Xuzhuang',
                'Dali',
                'Weinan',
                'Shaanxi Dali Xuzhuang Cecep solar farm',
                'CECEP Dali Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dingbian Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Huahui solar farm',
                'Dingbian Huahui New Energy Co., Ltd.',
                "Xi'an Huitai New Energy Development Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Dingbian Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Huahui solar farm',
                'Dingbian Huahui New Energy Co., Ltd.',
                "Xi'an Huitai New Energy Development Co., Ltd.",
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Huanghe 50MW solar farm',
                "Xi'an Huanghe Photovoltaic Technology Co., Ltd.",
                'Shaanxi Huanghe Group Co., Ltd. [79.5%]; Xi\u2018an Investment Holding Co., Ltd. [18.2%]; others [2.3%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhuanjing Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Huanghe solar farm',
                'Dingbian Huanghe Solar Power Generation Co., Ltd.',
                'Shaanxi Jidian Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yanchangpu Town',
                'Dingbian County',
                'Yulin',
                'Shaanxi Dingbian Huayang Jiahe solar farm',
                'Dingbian Huayang Jiahe New Energy Co., Ltd.',
                'Yulin Huayang Jiahe New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dingbian',
                'Yulin',
                'Shaanxi Dingbian Jingyang solar farm',
                'Dingbian Jingyang Electric Power Co., Ltd.',
                'Changshu Honglue Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Chunhua',
                'Xianyang',
                'Shaanxi Chunhua Chunhua solar farm',
                'Zhongmin Xinneng Chunhua Power Co., Ltd.',
                'Zhongmin Energy Control Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Ulan County',
                'Wulan Xian',
                'Haixi Zhou',
                'Qinghai Province Wulan Chaidamu Energy Grid-Connected solar farm',
                'Qinghai Chaidamu Energy Investment Development Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd. [69%]; Xining Urban Investment Management Co., Ltd.[23%]; Qinghai Rongxin Industrial Development Co., Ltd.[8%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Luonan County',
                'Shangluo',
                'Shaanxi Luonan Weidong Zhongtian Jiayang solar farm',
                'Shaanxi Zhongtian Jiayang New Energy Development Co., Ltd.',
                'Suzhou GCL Clean Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'ShiliyuanTown',
                'Chunhua',
                'Xianyang',
                'Shaanxi Province Chunhua Shiliyuan solar farm',
                'Chunhua Three Gorges New Energy Xiatang Power Generation Co., Ltd.',
                "China Three Gorges New Energy (Group) Co., Ltd.[90%]; Xi'an Xidian New Energy Co., Ltd.[10%]",
              ],
              [
                'China',
                100,
                'Asia',
                'Hejiazhuang Town',
                'Heyang Xian',
                'Weinan',
                'Shaanxi Province Weinan "Front Runner" Hejiazhuang solar farm',
                'Heyang Shengyao Photovoltaic Power Co., Ltd.',
                'Hengfeng County Jingfu Electric Power Co., Ltd. [90%]; Shaanxi Chemical Industry Group Co., Ltd. [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinyu Town',
                'Heyang Xian',
                'Weinan',
                'Shaanxi Province Weinan "Front Runner" Jinyuzhen solar farm',
                'Weinan Xiayang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [85%]; Sungrow Power Co., Ltd. [15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhuangtou Town',
                'Chengcheng Xian',
                'Weinan',
                'Shaanxi Province Weinan "Front Runner" Leijiawa solar farm',
                'State Power Investment Group Chengcheng New Energy Power Generation Co., Ltd.',
                'State Power Investment Corporation Shaanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wangcun Town',
                'Heyang Xian',
                'Weinan',
                'Shaanxi Province Weinan "Front Runner" Zhangjiahe solar farm',
                'State Power Investment Group Heyang New Energy Power Generation Co., Ltd.',
                'State Power Investment Corporation Shaanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Lujing Town',
                'Heyang Xian',
                'Weinan',
                'Shaanxi Province Weinan Heyang County Guihua solar farm',
                'Shaanxi Heyang Guihua Clean Energy Co., Ltd.',
                'Shaanxi Guihua Clean Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Wangcun Town',
                'Heyang Xian',
                'Weinan',
                'Shaanxi Province Weinan Heyang County Zhiyuan solar farm',
                'Heyang Zhiyuan New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Wolong',
                "Xi'an",
                'Shaanxi Province Wolong Guoneng solar farm',
                'National Energy Investment Group Co., Ltd.',
                'National Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Yongshou Xian',
                'Xianyang',
                'Shaanxi Province Xianyang Yongshou CGN solar farm',
                'Hengshan Yulong New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Balasu Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Aoteng solar farm',
                'Shaanxi Aoteng Photovoltaic Power Generation Co., Ltd.',
                'Shaanxi Photovoltaic Industry Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Mahuangliang Town',
                'Yuyang District',
                'Yulin',
                'Shaanxi Province Yuyang District Shenshupan solar farm',
                'Yulin Zhiguang New Energy Co., Ltd.',
                'Yulin Ruiyite New Energy Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Mahuangliang Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Huaneng Unsubsidized solar farm',
                'Huaneng Shaanxi Power Generation Co., Ltd.',
                'China Huaneng Group',
              ],
              [
                'China',
                300,
                'Asia',
                'Xiaohaotu Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Jiangshan Yongchen solar farm',
                'Yulin Jiangshan Yongchen New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jinjitan Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Kuangda solar farm',
                'Yulin Kuangda Photovoltaic Power Generation Co., Ltd.',
                'Changzhou Kuangda Sunshine Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Balasu Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Xinjing solar farm',
                'Yulin Xinjing Solar Power Generation Co., Ltd.',
                "Xi'an Huanghe Photovoltaic Technology Co., Ltd.",
              ],
              [
                'China',
                300,
                'Asia',
                'Mahuangliang Town',
                'Yuyang Qu',
                'Yulin',
                'Shaanxi Province Yuyang Yuneng "Unsubsidized " solar farm',
                'Shaanxi Yuneng Changxing New Energy Co., Ltd.',
                'Shaanxi Yulin Energy Group New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caobi Town',
                'Qianyang County',
                'Baoji',
                'Shaanxi Qianyang Caobizhen Baoyuan solar farm',
                'Qianyang Baoyuan Photovoltaic Power Development Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caijiapo',
                'Qishan',
                'Baoji',
                'Shaanxi Qishan Caijiapo Changxing solar farm',
                'Shanxi Changxing Photovoltaic Technology Co., Ltd.',
                'Guangxi Guidong Electric Power Co., Ltd. [90%]; Others [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhuangtou Town',
                'Chengcheng Xian',
                'Weinan',
                'Shaanxi Province Weinan "Front Runner" Caozhuangcun solar farm',
                'Chengcheng Shengbu Photovoltaic Power Co., Ltd.',
                'Hengfeng County Jinghong Electric Power Co., Ltd. [90%]; Shaanxi Chemical Industry Group Co., Ltd. [10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yaozhou District',
                'Tongchuan',
                'Shaanxi Province Tongchuan Yaozhou District Agriculture solar farm',
                'Tongchuan Zhongguang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Yunmeng Town',
                'Yijun Xian',
                'Tongchuan',
                'Shaanxi Province Tongchuan "Front Runner" Yijun County solar farm',
                'Tongchuan Xiaguang New Energy Power Generation Co., Ltd.',
                "Xi'an Lvsheng Clean Energy Co., Ltd. [51%]; China Three Gorges New Energy [Group] Co., Ltd. [49%]",
              ],
              [
                'China',
                250,
                'Asia',
                'Yaosheng Town',
                'Yijun Xian',
                'Tongchuan',
                'Shaanxi Province Tongchuan "Front Runner" Trina solar farm',
                'Tianhe Light Energy',
                'Trina Solar Co., Ltd.[51%]; Hunan Xingye Green Energy Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhuanjing Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Angli solar farm',
                'Dingbian Angli Photovoltaic Technology Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Clean Energy solar farm',
                'Shaanxi Dingbian Clean Energy Power Generation Co., Ltd.',
                'Jilin Electric Power Co., Ltd. [72%]; Bank of Communications Financial Assets Investment Co., Ltd. [28%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian County Zhenbian solar farm',
                'Dingbian Zhenbian Photovoltaic Technology Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Yanchangbao Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Fengwan solar farm',
                "Chang'an Power (Shaanxi) New Energy Technology Co., Ltd.",
                'Shaanxi Coal Industry Chemical Group Fugu Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Bainijing',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Gaoheng solar farm',
                'Dingbian Gaoheng New Energy Co., Ltd.',
                "Xi'an Lanheng New Energy Co., Ltd.",
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Guangneng solar farm',
                'Shaanxi Dingbian Guangneng Power Co., Ltd.',
                'Jilin Electric Power Co., Ltd.[67.12%]; Bank of Communications Financial Assets Investment Co., Ltd.[32.88%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Changcheng Forest Farm',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Huanghe solar farm',
                "Xi'an Huanghe Photovoltaic Technology Co., Ltd.",
                'Shaanxi Huanghe Group Co., Ltd.[79.5%]; Xi\u2018an Investment Holding Co., Ltd.[18.2%]; other[2.3%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Hequan Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian solar farm',
                'Shaanxi Dingbian Solar Power Co., Ltd.',
                'Shaanxi Photovoltaic Industry Co., Ltd.',
              ],
              [
                'China',
                99,
                'Asia',
                'Xigu Town',
                'Baishui County',
                'Weinan',
                'Shaanxi Province Baishui Guxi Datang solar farm',
                'China Datang Group Solar Energy Industry Co., Ltd.',
                'China Datang Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Yanchangbao Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Topray Grid-Connected solar farm',
                'Dingbian Topray Modern Agriculture Co., Ltd.',
                'Shaanxi Topray Solar Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yanchangbao Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Wochi Unsubsidized solar farm',
                'Dingbian Wochi New Energy Co., Ltd.',
                "Xi'an Jianrui New Energy Co., Ltd.",
              ],
              [
                'China',
                100,
                'Asia',
                'Dongkeng Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dongkeng Yidangwan Huaneng solar farm',
                'Huaneng Shaanxi Jingbian Electric Power Co., Ltd.',
                'Huaneng Shaanxi Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Tawan Town',
                'Hengshan Xian',
                'Yulin',
                'Shaanxi Province Hengshan Jinghe solar farm',
                'Hengshan Jinghe Solar Energy Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd. [80%]; Suzhou GCL New Energy Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Tawan Town',
                'Hengshan Xian',
                'Yulin',
                'Shaanxi Province Hengshan Jinghe solar farm',
                'Hengshan Jinghe Solar Energy Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd. [80%]; Suzhou GCL New Energy Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Jingbian County',
                'Jingbian Xian',
                'Yulin',
                'Shaanxi Province Jingbian Zhiguang solar farm',
                'Jingbian County Zhiguang New Energy Development Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinjie Industrial Park',
                'Shenmu Shi',
                'Yulin',
                'Shaanxi Province Shenmu Jingdeng solar farm',
                'Shenmu County Jingdeng Electric Power Co., Ltd.',
                "Ningxia Hanguang New Energy Co., Ltd. [90%]; Xi'an GCL New Energy Management Co., Ltd. [10%]",
              ],
              [
                'China',
                200,
                'Asia',
                'Dabaodang Town',
                'Shenmu Shi',
                'Yulin',
                'Shaanxi Province Shenmu Yushen solar farm',
                'Yulin Xiehe Ecological New Energy Co., Ltd.',
                'Shaanxi Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shenmu Shi',
                'Yulin',
                'Shaanxi Province Shenmu Zixu solar farm',
                'Shenmu Zixu New Energy Co., Ltd.',
                'Jianghe Mechanical and Electrical Equipment Engineering Co., Ltd.[80%]; Suzhou Industrial Park Zhongfu Photovoltaic Technology Co., Ltd.[20%]',
              ],
              [
                'China',
                110,
                'Asia',
                'Yanchangbao Town',
                'Dingbian Xian',
                'Yulin',
                'Shaanxi Province Dingbian Topray solar farm',
                'Shaanxi Topray (Dingbian) New Energy Technology Co., Ltd.:',
                'Shaanxi Topray New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shenmu',
                'Yulin',
                'Shaanxi Shenmu Changyi solar farm',
                'Shenmu Changyi Agricultural Development Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wulan Xian',
                'Haixi Zhou',
                'Qinghai Province Wulan Chaidamu Energy Grid-Connected solar farm',
                'Qinghai Chaidamu Energy Investment Development Co., Ltd.',
                'Qinghai Green Power Generation Group Co., Ltd. [69%]; Xining Urban Investment Management Co., Ltd.[23%]; Qinghai Rongxin Industrial Development Co., Ltd.[8%]',
              ],
              [
                'China',
                20,
                'Asia',
                'YouganningTown',
                'Henan Mongol Autonomous County',
                'Huangnan Tibetan Autonomous Prefecture',
                'Qinghai Province Henan Huanghe Hydropower Grid-Connected solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Longyuan Grid-Connected solar farm',
                'Longyuan Golmud New Energy Development Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Longyuan Grid-Connected solar farm',
                'Longyuan Golmud New Energy Development Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Qinghai Hydropower Grid-Connected solar farm',
                'Qinghai Water Conservancy & Hydroelectric (Group) Golmud Photovoltaic Power Co., Ltd.',
                'Qinghai Water Conservancy and Hydropower (Group) Co., Ltd.; Qinghai Huangdian Siwei New Energy Management Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Qinghai Hydropower Grid-Connected solar farm',
                'Qinghai Water Conservancy & Hydroelectric (Group) Golmud Photovoltaic Power Co., Ltd.',
                'Qinghai Water Conservancy and Hydropower (Group) Co., Ltd.; Qinghai Huangdian Siwei New Energy Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Qinghai Hydropower Grid-Connected solar farm',
                'Qinghai Water Conservancy & Hydroelectric (Group) Golmud Photovoltaic Power Co., Ltd.',
                'Qinghai Water Conservancy and Hydropower (Group) Co., Ltd.; Qinghai Huangdian Siwei New Energy Management Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Qinghai Hydropower Grid-Connected solar farm',
                'Qinghai Water Conservancy & Hydroelectric (Group) Golmud Photovoltaic Power Co., Ltd.',
                'Qinghai Water Conservancy and Hydropower (Group) Co., Ltd.; Qinghai Huangdian Siwei New Energy Management Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Rixin Grid-Connected solar farm',
                'Qinghai Rixin Energy Co., Ltd.',
                "Fujian San'an Group Co., Ltd.",
              ],
              [
                'China',
                21,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Rixin Grid-Connected solar farm',
                'Qinghai Rixin Energy Co., Ltd.',
                "Fujian San'an Group Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Shanyizhong Grid-Connected solar farm',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
                'Inner Mongolia Shanlu Enercy Company Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Shanyizhong Grid-Connected solar farm',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
                'Inner Mongolia Shanlu Enercy Company Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Shengguang Grid-Connected solar farm',
                'Golmud Shenguang New Energy Co., Ltd.',
                'Lingda Group Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud SPIC Huanghe Hydropower Grid-Connected solar farm',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd.',
                'State Power Investment Corporation Limited[94%]; other [6%]',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Sunshine Energy Grid-Connected solar farm',
                'Sunshine Energy (Qinghai) Co., Ltd.',
                'Luo Qian[75%]; Bao Quanjun[25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Sunshine Energy solar farm',
                'Sunshine Energy (Qinghai) Co., Ltd.',
                'Luo Qian[75%]; Bao Quanjun[25%]',
              ],
              [
                'China',
                30,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Sunshine Qiheng Grid-Connected solar farm',
                'Golmud Sunshine Qiheng New Energy Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Three Gorges "Front-Runner" Grid-Connected solar farm',
                'Three Gorges New Energy Golmud Qingneng Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.[85%]; Sungrow Power Supply Co., Ltd.[15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Three Gorges Grid-Connected solar farm',
                'Three Gorges New Energy Golmud Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Longyuan Grid-Connected solar farm',
                'Longyuan Golmud New Energy Development Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Longyuan Grid-Connected solar farm',
                'Longyuan Golmud New Energy Development Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Liteng Grid-Connected solar farm',
                'Qinghai Liteng New Energy Investment Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Liteng Grid-Connected solar farm',
                'Qinghai Liteng New Energy Investment Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud',
                'Haixi Zhou',
                'Qinghai Province Golmud Datang International solar farm',
                'Qinghai Datang International Golmud Photovoltaic Power Generation Co., Ltd.',
                'Datang International Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Golmud',
                'Haixi Prefecture',
                'Qinghai Province Golmud Datang International solar farm',
                'Qinghai Datang International Golmud Photovoltaic Power Generation Co., Ltd.',
                'Datang International Power Generation Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Guodian Grid-Connected solar farm',
                'National Energy Group Golmud Photovoltaic Power Generation Co., Ltd.',
                'National Energy Investment Group Co., Ltd. [60%]; Kunshan Runbow Supply Chain Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Guodian Grid-Connected solar farm',
                'National Energy Group Golmud Photovoltaic Power Generation Co., Ltd.',
                'National Energy Investment Group Co., Ltd. [60%]; Kunshan Runbow Supply Chain Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Guodian Grid-Connected solar farm',
                'National Energy Group Golmud Photovoltaic Power Generation Co., Ltd.',
                'National Energy Investment Group Co., Ltd. [60%]; Kunshan Runbow Supply Chain Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huadian Grid-Connected solar farm',
                'Huadian Golmud Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huaneng Grid-Connected solar farm',
                'Huaneng Geermu Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huaneng Grid-Connected solar farm',
                'Huaneng Geermu Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Three Gorges Grid-Connected solar farm',
                'Three Gorges New Energy Golmud Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huaneng Grid-Connected solar farm',
                'Huaneng Geermu Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huanghe Hydropower Grid-Connected solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                150,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huanghe Hydropower Grid-Connected solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                50,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huanghe Medium Type Hydropower Grid-Connected solar farm',
                'Qinghai Yellow River Medium Type Hydro Power Development Co., Ltd.',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Golmud City',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Jingneng Grid-Connected solar farm',
                'Qinghai Jingneng Construction Investment Co., Ltd.',
                'Beijing Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Golmud City',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Jingneng Grid-Connected solar farm',
                'Golmud Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Jingneng Grid-Connected solar farm',
                'Golmud Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Jingneng Grid-Connected solar farm',
                'Golmud Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Liteng Grid-Connected solar farm',
                'Qinghai Liteng New Energy Investment Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Huanghe Hydropower Grid-Connected solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Ulan County',
                'Wulan Xian',
                'Haixi Zhou',
                'Qinghai Province Wulan CGN Grid-Connected solar farm',
                'CGN Solar Wulan Co., Ltd.',
                'CGN New Energy Investment (Shenzhen)Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Three Gorges Grid-Connected solar farm',
                'Three Gorges New Energy Golmud Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Zhongdiantou Grid-Connected solar farm',
                'Qinghai China Power Investment Jidian New Energy Co., Ltd.',
                'Jilin Electric Power Co., Ltd.[66.9%]; Bank of Communications Financial Assets Investment Co., Ltd.[33.1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gangcha Xian',
                'Haibei Zhou',
                'Qinghai Province Haibei Gangcha Wuxian Grid-Connected solar farm',
                'Gangcha Infinite Energy Power Co., Ltd.',
                'Qinghai Hongrun New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gangca County',
                'Gangcha Xian',
                'Haibei Zhou',
                'Qinghai Province Haibei Gangcha Yizhao Grid-Connected solar farm',
                'Qinghai Development Investment Co., Ltd.',
                'Qinghai Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Beixiang Grid-Connected solar farm',
                'Qinghai Beixiang Renewable Energy Development Co., Ltd.',
                'Information Industry Electronics Eleventh Design and Research Institute Technology Engineering Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Beixiang Grid-Connected solar farm',
                'Qinghai Beixiang Renewable Energy Development Co., Ltd.',
                'Information Industry Electronics Eleventh Design and Research Institute Technology Engineering Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Datang Grid-Connected solar farm',
                'Qinghai Datang International Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Datang International New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Datang Grid-Connected solar farm',
                'Qinghai Datang International Gonghe Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Datang International New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Guangke Grid-Connected solar farm',
                'Hainan Guangke Photovoltaic New Energy Co., Ltd.',
                'Qinghai Xinpu Guangke Investment Center (Limited Partnership)',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Hanergy Grid-Connected solar farm',
                'Hanergy Hainazhou Photovoltaic Power Generation Co., Ltd.',
                'Beijing Zhilan Photovoltaic Power Generation Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Hanergy Grid-Connected solar farm',
                'Qinghai Hanergy Thin Film Solar Energy Power Generation Co., Ltd.',
                'Qinghai Hanyuan Industrial Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Hanergy Grid-Connected solar farm',
                'Qinghai Hanergy Thin Film Solar Energy Power Generation Co., Ltd.',
                'Qinghai Hanyuan Industrial Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Hengji Grid-Connected solar farm',
                'Hainan Hengji Weiye Photovoltaic Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Hengji Grid-Connected solar farm',
                'Hainan Hengji Weiye Photovoltaic Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Huaneng Grid-Connected solar farm',
                'Huaneng Gonghe Photovoltaic Power Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Huaneng Grid-Connected solar farm',
                'Huaneng Gonghe Photovoltaic Power Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Huaneng Grid-Connected solar farm',
                'Huaneng Gonghe Photovoltaic Power Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Gonghe Zhongdianjian Grid-Connected solar farm',
                'not found',
                'not found',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Hainanzhou Talatan Grid-Connected solar farm',
                'not found',
                'CGN Power Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gangcha Xian',
                'Haibei Zhou',
                'Qinghai Province Haibei Gangcha Wuxian Grid-Connected solar farm',
                'Gangcha Infinite Energy Power Co., Ltd.',
                'Qinghai Hongrun New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Zhongli Talesun solar farm',
                'Zhongli Talesun Gonghe New Energy Co., Ltd.',
                'Changzhou Dinghui New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Zhongli Talesun solar farm',
                'Zhongli Talesun Gonghe New Energy Co., Ltd.',
                'Changzhou Dinghui New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Zhongli Talesun solar farm',
                'Zhongli Talesun Gonghe New Energy Co., Ltd.',
                'Changzhou Dinghui New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Zhongdiantou Grid-Connected solar farm',
                'Qinghai China Power Investment Jidian New Energy Co., Ltd.',
                'Jilin Electric Power Co., Ltd.[66.9%]; Bank of Communications Financial Assets Investment Co., Ltd.[33.1%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gongh Poverty Alleviation solar farm',
                'Qinghai Poverty Relief Photovoltaic New Energy Co., Ltd.',
                'Shenzhen Nanguo Energy Co., Ltd. [60%]; Qinghai Provincial Poverty Alleviation and Development Investment Co., Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Huacheng Grid-Connected solar farm',
                'Qinghai Development Investment Co., Ltd.',
                'Qinghai Development Investment Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Huanghe Hydropower solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                150,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Huanghe Hydropower solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                200,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Huanghe Hydropower solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                320,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Longyangxia Huanghe Hydropower solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                530,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Longyangxia Huanghe Hydropower solar farm',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd. [65%]; China Life Insurance Company Limited[13%]; ICBC Financial Assets Investment Co., Ltd.[9%]; other[13%]',
              ],
              [
                'China',
                20,
                'Asia',
                'East Exit Photovoltaic Industrial Park',
                'Golmud Shi',
                'Haixi Zhou',
                'Qinghai Province Golmud Zhengtai Grid-Connected solar farm',
                'Qinghai Golmud Zhengtai New Energy Development Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Qinghai Hydropower Grid-Connected solar farm',
                'Qinghai Hydropower(group) Co., Ltd.',
                'Qinghai Province State-owned Assets Investment Management Co., Ltd.[74%]; China Three Gorges Renewables [Group] Co.,Ltd.[26%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe SPIC Huanghe Hydropower solar farm',
                'State Power Investment Group Upper Yellow River Hydropower Development Co., Ltd.',
                'State Power Investment Corporation Limited[94%]; other [6%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe SPIC Huanghe Medium Hydropower solar farm',
                'Qinghai Yellow River Medium Type Hydropower Development Co., Ltd.',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Three Gorges Zhuma Grid-Connected solar farm',
                'Hainan Zhuma Solar New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [99.9%]; Qinghai Zhuma Sapphire Crystal Co., Ltd. [0.1%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Tianhua Grid-Connected solar farm',
                'Gonghe Tianhua New Energy Power Co., Ltd.',
                'Shanghai Yangwang Investment Development Co., Ltd.[30.58%]; Shanghai Fengxian No.2 Construction Co., Ltd.[26.14%]; Tang Qiurong[19.86%];Shanghai Yesheng Real Estate Purchasing Co., Ltd.[16.97%]; Shanghai Jianghai Property Co., Ltd.[6.45%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Xinsheng Grid-Connected solar farm',
                'Hainan Xinsheng New Energy Technology Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd. [90%]; Changzhou Yixin New Energy Technology Co., Ltd.[10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Yahui Grid-Connected solar farm',
                'Hainan Yahui New Energy Power Co., Ltd.',
                'Yin Guoqing[95%]; Wang Yaxian[5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Zhongli Talesun solar farm',
                'Zhongli Talesun Gonghe New Energy Co., Ltd.',
                'Changzhou Dinghui New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Zhongli Talesun solar farm',
                'Zhongli Talesun Gonghe New Energy Co., Ltd.',
                'Changzhou Dinghui New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiabuqia Town',
                'Gonghe Xian',
                'Hainan Zhou',
                'Qinghai Province Gonghe Shineng Grid-Connected solar farm',
                'Hainan Shineng Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin)Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xiluo Town',
                'Shouyang County',
                'Jinzhong',
                'Shanxi Shouyang "Front Runner " Xiluo solar farm',
                'Shouyang Jingshou Photovoltaic Power Generation Co., Ltd.',
                'Hengfeng County Jingneng Power Co., Ltd. [51%]; Beijing Jingneng Clean Energy Power Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Turpan',
                'Xinjiang Turpan Xiehe solar farm',
                'Turpan Xiehe Solar Power Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shanghu Town',
                'Shouyang County',
                'Jinzhong',
                'Shanxi Shouyang "Front Runner" Guoke No.4 solar farm',
                'Shouyang Guoke New Energy Technology Co., Ltd.',
                'Hengfeng County Jingjia Electric Power Co., Ltd. [70%]; Jinkai New Energy Technology Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Dabanshan Zhengguo solar farm',
                'Tumushuk Zhengguo Electric Power Co., Ltd.',
                'Shanghai Kangding Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Tumushuke Dongrun Huanneng solar farm',
                'Tumushuke Dongrun Huanneng Photovoltaic Power Generation Co., Ltd.',
                'TBEA Xinjiang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuepuhu County',
                'Kashgar Prefecture',
                'Xinjiang Tumushuke Hiatianda solar farm',
                'Tumushuke Haitianda New Energy Co., Ltd. Yuepuhu Branch',
                'Tumushuk Haitianda New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Jiashi Jintaiyang solar farm',
                'Tumushuk Golden Sun Power Co., Ltd.',
                'Jiangsu Golden Sun Power Co., Ltd. [75%]; Sunedison Solar Holdings 1 (Hong Kong) Limited [25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Sitong solar farm',
                'Tumushuke Sitong New Energy Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Xinsheng solar farm',
                'Tumushuke Xinsheng New Energy Investment Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Zhengtai solar farm',
                'Tumushuke Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Zhengtai solar farm',
                'Tumushuke Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan CPI Special Permit solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Turpan',
                'Xinjiang Turpan Datang solar farm',
                'Datang Turpan Clean Energy Co., Ltd.',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Turpan',
                'Xinjiang Turpan Lianxing solar farm',
                'Turpan Lianxing New Energy Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Haixin solar farm',
                'Turpan Haixin Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Huabei Tenghui solar farm',
                'Turpan North China Tenghui Photovoltaic Power Generation Co., Ltd.',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Huaguang solar farm',
                'Turpan Huaguang Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Dabanshan CGN solar farm',
                'CGN Solar Tumushuk Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu Town',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongfuwang solar farm',
                'Turpan Zhongfuwang Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke',
                'Xinjiang Tumushuke Atlas solar farm',
                'Tumushuk Atlas New Energy Development Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Toksun County',
                'Turpan',
                'Xinjiang Toksun Golden Sunsolar Project',
                'Toksun County Golden Sun Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Jiahua Energy Chemical Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qiemo',
                'Bayingolin',
                'Xinjiang Qiemo Tongwei solar farm',
                'Tongwei Solar Energy Co., Ltd.',
                'Shanghai Shunneng Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu',
                'Gaochang District',
                'Turpan',
                'Xinjiang Qiquanhu Ziran Tiancheng solar farm',
                'Turpan Ziran Tiancheng Energy Development Co., Ltd.',
                'Zhejiang Liansheng Hezhong New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qitai',
                'Changji',
                'Xinjiang Qitai Juyang solar farm',
                'Xinjiang JuYang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Shanshan Anpeiqi solar farm',
                'Shanshan Anpeiqi Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan',
                'Turpan',
                'Xinjiang Shanshan Lino solar farm',
                'Hami Lino Solar Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                51,
                'Asia',
                'Unavailable',
                'Eighth Division 136 Regiment',
                'Shihezi',
                'Xinjiang Shihezi Eighth Division 51 MW Demonstration solar farm',
                'Shihezi Jingshang Huineng Power Generation Co., Ltd.',
                'Urumqi Haoneng Guangyang Power Generation Co., Ltd.',
              ],
              [
                'China',
                69,
                'Asia',
                'Unavailable',
                'Eighth Division 136 Regiment',
                'Shihezi',
                'Xinjiang Shihezi Eighth Division 69 MW Demonstration solar farm',
                'Shihezi Bingyang Photovoltaic Power Generation Co., Ltd.',
                'Urumqi Haoneng Guangyang Power Generation Co., Ltd.',
              ],
              [
                'China',
                72,
                'Asia',
                'Unavailable',
                'Eighth Division 136 Regiment',
                'Shihezi',
                'Xinjiang Shihezi Eighth Division 72 MW Demonstration solar farm',
                'Shihezi Jinghao Photovoltaic Power Generation Co., Ltd.',
                'Urumqi Haoneng Guangyang Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                '\u77f3\u6cb3\u5b50\u5e02',
                '\u77f3\u6cb3\u5b50\u5e02',
                'Shihezi',
                'Xinjiang Shihezi PLA Corps 8th Division 148 Brigade Lantian solar farm',
                'Shihezi Lantian New Energy Technology Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                '\u77f3\u6cb3\u5b50\u5e02',
                'Shihezi',
                'Xinjiang Shihezi Tianfu Jinyang solar farm',
                'Xinjiang Tianfu Jinyang New Energy Co., Ltd.',
                'Xinjiang Tianfu Energy Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shufu',
                'Kashgar',
                'Xinjiang Shufu Junxin solar farm',
                'Shufu Junxin Technology Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shufu',
                'Kashgar',
                'Xinjiang Shufu TBEA solar farm',
                'TBEA Shufu New Energy Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shufu',
                'Kashgar',
                'Xinjiang Shufu Zhongjiancai solar farm',
                'Shufu Zhongjiancai New Energy Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Tacheng Mohetai Guohua solar farm',
                'Guohua (Mohetai) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tianshan',
                'Urumqi',
                'Xinjiang Tianshan High Tech solar farm',
                'Yuepuhu High Tech New Energy Power Generation Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shuangfeng',
                'Tiemenguan',
                'Unavailable',
                'Xinjiang Tiemenguan Shuangfeng Xinke solar farm',
                'Korla Xinke Solar Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kuerle',
                'Bazhou',
                'Xinjiang Tiemenguan Xinjing 2 Division 29 Regiment solar farm',
                'Tiemenguan Xinjing New Energy Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Boundary Maralbeshi - Kashgar',
                'Tumushuke County',
                'Kashgar',
                'Xinjiang Tumushuke 3rd Division 42nd Brigade SPIC solar farm',
                'Tumushuke Mengxin Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongli Tenghui solar farm',
                'Turpan Zhongli Tenghui Photovoltaic Power Co., Ltd.',
                'Lvlian New Energy (Changzhou) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gaochang District',
                'Turpan',
                'Xinjiang Turpan Qiquanhu Zhongli Tenghui solar farm',
                'Turpan Zhongli Tenghui Photovoltaic Power Co., Ltd.',
                'Lvlian New Energy (Changzhou) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan CECEP Grid-Connected solar farm',
                'CECEP Solar Shanshan Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                '6th Corps Fangcaohu Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu 6th Division Fangcaohu Farm Lishang solar farm',
                'Wujiaqu Lishang Photovoltaic Power Co., Ltd.',
                'Changzhou Xinguang New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                '6th Corps Beitashan Animal Husbandry Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu Beitashan Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Beitashan Pasture',
                'Qitai County',
                'Changji',
                'Xinjiang Wujiaqu Beitashan Ranch Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd. Qitai Branch',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Beitashan Pasture',
                'Qitai County',
                'Changji',
                'Xinjiang Wujiaqu Beitashan Ranch Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd. Qitai Branch',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Beitashan Pasture',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu Beitashan Ranch Yue Hydropower solar farm',
                'Wujiaqu Yue Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                '106th Regiment',
                'Hutubi County',
                'Changji',
                'Xinjiang Wujiaqu Juneng Weiye solar farm',
                'Wujiaqu Juneng Weiye New Energy Investment Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                '6th Corps Beitashan Animal Husbandry Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu PLA Corps Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                '6th Corps Beitashan Animal Husbandry Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu PLA Corps Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                '6th Corps Beitashan Animal Husbandry Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu PLA Corps Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                '6th Corps Beitashan Animal Husbandry Farm',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu PLA Corps Jingneng solar farm',
                'Wujiaqu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Qitai Farm',
                'Qitai County',
                'Changji',
                'Xinjiang Wujiaqu Qitai Farm Aikang solar farm',
                'Wujiaqu Aikang Power Development Co., Ltd.',
                'Chongqing Changsheng New Energy Private Equity Investment Fund Partnership (Limited Partnership) [100%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qitai Farm',
                'Qitai County',
                'Changji',
                'Xinjiang Wujiaqu Qitai Farm Liyuan Xinhui solar farm',
                'Xinjiang Liyuan Xinhui Energy Technology Co., Ltd.',
                'Chongqing Changsheng New Energy Private Equity Investment Fund Partnership (Limited Partnership) [100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qitai',
                'Wujiaqu',
                'Unavailable',
                'Xinjiang Wujiaqu Qitai TBEA solar farm',
                'Hongqi Farm Branch of Wujiaqu Xinte Energy Co., Ltd.',
                'Wujiaqu Xinte Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hutubi County',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu Tudunzi PLA Corps TBEA solar farm',
                'Wujiaqu Tebian Electrotechnical Optoelectronics Technology Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd. [60%]; Jiangsu Yanshan Photovoltaic Equipment Co., Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wujiaqu',
                'Wujiaqu',
                'Unavailable',
                'Xinjiang Wujiaqu Wujiaqu TBEA solar farm',
                'Fukang Tudunzi Farm Branch of Wujiaqu TBEA Photoelectric Technology Co., Ltd.',
                'Wujiaqu TBEA Photoelectric Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hutubi County',
                'Changji',
                'Xinjiang Wujiaqu Zhenfa New Energy solar farm',
                'Wujiaqu Zhenfa New Energy Technology Co., Ltd. Hutubi Branch',
                'Wujiaqu Zhenfa New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wuqia',
                'Kizilsu',
                'Xinjiang Wuqia Kezhou solar farm',
                'Variety Show (Kezhou) New Energy Co., Ltd.',
                'Jiangsu Zongyi Solar Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu 102nd Brigade Puxin Chengda solar farm',
                'Xinjiang Puxin Chengda Energy Technology Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu 102nd Brigade Puxin Chengda solar farm',
                'Xinjiang Puxin Chengda Energy Technology Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Wujiaqu City',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Wujiaqu 102nd Brigade Puxin Chengda solar farm',
                'Xinjiang Puxin Chengda Energy Technology Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Urumqi',
                'Xinjiang Urumqi Zhonghui solar farm',
                'Turpan Zhonghui Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan CECEP Grid-Connected solar farm',
                'CECEP Solar Shanshan Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan CECEP solar farm',
                'CECEP Solar Shanshan Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Hailin Grid-Connected solar farm',
                'Shanshan Hailin Photovoltaic Technology Co., Ltd.',
                'Jiangsu Greao Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Huadian Grid-Connected solar farm',
                'Xinjiang Huadian Shanshan Solar Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Huaneng Grid-Connected solar farm',
                'Huaneng Shanshan Power Generation Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Huaneng Grid-Connected solar farm',
                'Huaneng Shanshan Power Generation Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Linuo Grid-Connected solar farm',
                'Shanshan Lino Solar Power Co., Ltd.',
                'Linuo Power Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Three Gorges Grid-Connected solar farm',
                'CTGNE Shanshan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pishan Farm',
                'Pishan County',
                'Hetian',
                'Xinjiang Pishan Farm Risheng solar farm',
                'Pishan Risheng Power Development Co., Ltd.',
                'Xinjiang Wind Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Tianli Enze Grid-Connected solar farm',
                'Xinjiang Tianli Enze Solar Energy Technology Co., Ltd.',
                'Shunfeng Photovoltaic Investment (China) Co., Ltd.[95%]; Hunan Tianli Enze Solar Energy Technology Co., Ltd.[5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Shanshan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Shanshan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanshan County',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan Shanshan Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Shanshan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shanshan County',
                'Turpan',
                'Xinjiang Turpan TBEA Turpan wind and solar hybrid project',
                'Turpan TBEA New Energy Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd. [52%];Jiangsu Yanshan Photovoltaic Equipment Co., Ltd.[48%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Turpan',
                'Xinjiang Turpan Three Gorges solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                90,
                'Asia',
                'Kumishi Town',
                'Tokesun Xian',
                'Turpan',
                'Xinjiang Turpan Toksun Tianhe Grid-Connected solar farm',
                'Toksun Tianhe Solar Energy Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                50,
                'Asia',
                'Kumishi Town',
                'Tokesun County',
                'Turpan',
                'Xinjiang Turpan Toksun Tianhe Grid-Connected solar farm',
                'Toksun Tianhe Solar Energy Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yuanzhou District',
                'Guyuan',
                'Ningxia Yuanzhou District CECEP Zhenfa solar farm',
                'CECEP Solar Energy Technology (Zhenjiang) Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd. [94%]; Jiangsu Dagang Co., Ltd. [6%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Turpan',
                'Xinjiang Turpan Shanshan Xiehe solar farm',
                'Shanshan Xiehe Solar Energy Electric Power Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pishan Farm',
                'Pishan County',
                'Hetian',
                'Xinjiang Pishan Farm Qingyuan solar farm',
                'Pishan Qingyuan New Energy Co., Ltd.',
                'Qingyuan Technology (Xiamen) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Tianhui solar farm',
                'Mulei Tianhui Photovoltaic Power Generation Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Kaisheng solar farm',
                'Mulei Kaisheng New Energy Development Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinghe',
                'Bortala',
                'Xinjiang Jinghe Hairun solar farm',
                'Jinghe Hailun Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinghe County',
                'Bozhou',
                'Xinjiang Jinghe Zhongdiantou 5 Division 91 Regiment solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Fifth Division Co., Ltd.',
                'Xinjiang Ili Kukesu River Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Jingxia TBEA solar farm',
                'Hami Huaguang Power Generation Co., Ltd.',
                'Shenergy New Energy (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Kaisheng Mulei solar farm',
                'Mulei Kaisheng New Energy Development Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kalpin',
                'Aksu',
                'Xinjiang Kalpin Hairun solar farm',
                'Keping Hairun Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qilang',
                'Kalpin',
                'Aksu',
                'Xinjiang Kalpin Qilang CPI solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qilang',
                'Kalpin',
                'Aksu',
                'Xinjiang Kalpin Qilang SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Karakax (Moyu)',
                'Hotan',
                'Xinjiang Karakax (Moyu) Huineng solar farm',
                'Moyu Xinte Huineng Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Kuitun',
                'Karamay',
                'Xinjiang Karamay Kuitun Tianhua solar farm',
                'Karamay Tianhua New Energy Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Kuitun',
                'Karamay',
                'Xinjiang Karamay Kuitun Tianhua solar farm',
                'Karamay Tianhua New Energy Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wuerhe Qu',
                'Karamay',
                "Xinjiang Karamay Wu'erhe TBEA Grid-Connected solar farm",
                'Karamay Xinte Huaguang Power Generation Co., Ltd.',
                'Shenergy New Energy (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kargilik (Yecheng)',
                'Kashgar',
                'Xinjiang Kargilik (Yecheng) Fenglin solar farm',
                'Yecheng Fenglin Power Technology Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Photovoltaic Industrial Park',
                'Maralbexi County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Bachu Huaguang Grid-Connected solar farm',
                'Bachu Huaguang Power Generation Co., Ltd.',
                'Jiangsu Trina Solar Power Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Photovoltaic Industrial Park',
                'Maralbexi County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Bachu Huaguang Grid-Connected solar farm',
                'Bachu Huaguang Power Generation Co., Ltd.',
                'Jiangsu Trina Solar Power Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Maigaiti County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Maigaiti Jintan Zhengxin solar farm',
                'Maigaiti Jintan Zhengxin New Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiyitidun Town',
                'Maigaiti County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Maigaiti Linuo solar farm',
                'Maigaiti Linuo Solar Power Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Akto County',
                'Kashgar',
                'Xinjiang Kashgar Ruicheng Grid-Connected solar farm',
                'Kashgar Ruicheng New Energy Technology Co., Ltd.',
                'Shenzhen Topraysolar Co., Ltd.[99%]; Shaanxi Topray Solar Co., Ltd.[1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jimunai County',
                'Altay Prefecture',
                'Xinjiang Jimunai Haijin solar farm',
                'Jimunai Haijin New Energy Technology Development Co., Ltd.',
                'Zhejiang Jiahua Energy Chemical Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Laotai Town',
                'Jimsar County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Jimsar Xinfeng solar farm',
                'Jimsar Xinfeng New Energy Co., Ltd.',
                'Xinjiang Lixin Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jiashi',
                'Kashgar',
                'Xinjiang Jiashi Jiutai Hesheng solar farm',
                'Jiashi Jiutai Hesheng Photovoltaic Technology Co., Ltd.',
                'Realforce Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Ili',
                'Xinjiang Ili Tukai solar farm',
                'Huocheng Tukai New Energy Technology Development Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd. [51%]; Jiangsu Zhenfa New Energy Technology Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Buzhake Town',
                'Hetian Xian',
                'Hetian District',
                'Xinjiang Hetian Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Buzhake Town',
                'Hetian Xian',
                'Hetian District',
                'Xinjiang Hetian Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Buzhake Town',
                'Hetian Xian',
                'Hetian District',
                'Xinjiang Hetian Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Buzhake Town',
                'Hetian Xian',
                'Hetian District',
                'Xinjiang Hetian Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Pishan Farm',
                'Pishan County',
                'Hetian',
                'Xinjiang Hewei Saiwei 14 Division Pishan Farm solar farm',
                'Hetian Saiwei Photovoltaic Technology Co., Ltd.',
                'Shaanxi Jidian Energy Co., Ltd. [100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hoboksar County',
                'Tacheng Prefecture',
                'Xinjiang Hoboksar Beitun Lantian solar farm',
                'Beitun Lantian New Energy Technology Co., Ltd. Hoboksar County Branch',
                'Beitun Lantian New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Heshituogai Town',
                'Hoboksar County',
                'Tacheng Prefecture',
                'Xinjiang Hoboksar Huaguang solar farm',
                'Hoboksar Mongolia Autonomous County Huaguang New Energy Co., Ltd.',
                'Urumqi Huarui Guangsheng Power Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hoboksar County',
                'Tacheng Prefecture',
                'Xinjiang Hoboksar Yue Hydropower solar farm',
                'Hebukesaer Mongolia Autonomous County Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kashgar',
                'Kashgar',
                'Xinjiang Kashgar Ruicheng solar farm',
                'Kashi Ruicheng New Energy Technology Co., Ltd.',
                'Shenzhen Topraysolar Co., Ltd.[99%]; Shaanxi Topray Solar Co., Ltd.[1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Heshituoluogai Town',
                'Hoboksar Mongol Autonomous County',
                'Tacheng Prefecture',
                'Xinjiang Hoboksar Zhonghe solar farm',
                'Hoboksar Mongolia Autonomous County China Nuclear New Energy Co., Ltd.',
                'Nuclear Industry 216 Brigade',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Horgos PLA Corps CECEP solar farm',
                'CECEP Solar Technology Horgos Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hotan County',
                'Hotan',
                'Xinjiang Hotan CPI solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hotan County',
                'Hotan',
                'Xinjiang Hotan CPI solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hotan',
                'Hotan',
                'Xinjiang Hotan Xinhua solar farm',
                'Xinjiang Xinhua Photovoltaic Power Generation Development Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hoxud',
                'Bayingolin',
                'Xinjiang Hoxud Guohua solar farm',
                'Guohua (Heshuo) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hoxud',
                'Bayingolin',
                'Xinjiang Hoxud Hengxin solar farm',
                'Heshuo Hengxin New Energy Technology Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Huocheng County',
                'Ili',
                'Xinjiang Huocheng Huaguang solar farm',
                'Huocheng Huaguang Power Generation Co., Ltd.',
                'Shaanxi Jidian Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Huocheng County',
                'Ili',
                'Xinjiang Huocheng Tuhao solar farm',
                'Huocheng Tuhao New Energy Technology Development Co., Ltd.',
                'Zhenfa Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                '4th Corps',
                'Huocheng Xian',
                'Yili Zhou',
                'Xinjiang Horgos PLA Corps CECEP solar farm',
                'CECEP Solar Technology Horgos Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Aheya Town',
                'Wushi County',
                'Aksu Prefecture',
                'Xinjiang Wushi Jinhua solar farm',
                'Wushi Jinhua Electric Power Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Mulei New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shache County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Shache Taike solar farm',
                'Kashi Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Aerospace Automobile Electromechanical Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sayibage Town',
                'Shufu County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Shufu Zhongjiancai solar farm',
                'Shufu County Zhongjiancai New Energy Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Kuytun City',
                'Kuitun Shi',
                'Yili Zhou',
                'Xinjiang Kuitun 7th Division 131st Brigade Lvneng solar farm',
                'Kuitun Green Energy Solar Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                '7th Corps',
                'Kuitun Shi',
                'Yili Zhou',
                'Xinjiang Kuitun 7th Division Jintaiyang solar farm',
                'Kuitun Jintaiyang Power Co., Ltd.',
                'Xinjiang Xinfeng Hanhong Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lop',
                'Hotan',
                'Xinjiang Lop CPI solar farm',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd. Luopu Photovoltaic Power Station',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lop',
                'Hotan',
                'Xinjiang Lop CPI solar farm',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd. Luopu Photovoltaic Power Station',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lop',
                'Hotan',
                'Xinjiang Lop CPI solar farm',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd. Luopu Photovoltaic Power Station',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lop',
                'Hotan',
                'Xinjiang Lop SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Maigaiti County',
                'Kashgar Prefecture',
                'Xinjiang Maigaiti Hengji Weiye solar farm',
                'Maigaiti Hengji Weiye Photovoltaic Power Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Makit',
                'Kashgar',
                'Xinjiang Makit Zhengxin solar farm',
                'Maigaiti Jintan Zhengxin New Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Manas',
                'Changji',
                'Xinjiang Manas Tianfu solar farm',
                'Xinjiang Tianfu Energy Co., Ltd.',
                'Xinjiang Tianfu Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Minfeng',
                'Hotan',
                'Xinjiang Minfeng Angli solar farm',
                'Minfeng Angli Photovoltaic Technology Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd. [91%]; Zhengxin Optoelectronics Technology Co., Ltd.[9%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Minle',
                'Zhangye',
                'Xinjiang Minle Energy Chemical Industry solar farm',
                'Gansu Huadian Fuxin Energy Co., Ltd. Minle Branch',
                'Gansu Huadian Fuxin Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Mori',
                'Changji',
                'Xinjiang Mori Huadian solar farm',
                'Huadian Fuxin Xinjiang Mulei Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Caitian Silk Road solar farm',
                'Mulei Caitian Silk Road Solar Power Generation Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Changsheng Ridian solar farm',
                'Mulei Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd. [51%]; Qingdao Chengtou New Energy Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Hengdong solar farm',
                'Xinjiang Hengdong Wind Energy Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Jiarui Guangsheng solar farm',
                'Mulei County Jiarui Guangsheng Power Generation Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji',
                'Xinjiang Mulei Jingheng solar farm',
                'Mulei Jingheng New Energy Development Co., Ltd.',
                'Bairui Trust Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Korla',
                'Bayingolin',
                'Xinjiang Korla Huaneng solar farm',
                'Bazhou Huaneng Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Akto County',
                'Kizilsu',
                'Xinjiang Kizilsu Xinte solar farm',
                'Atushi Xinte Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wuqia Town',
                'Wuqia County',
                'Kezhou',
                'Xinjiang Kezhou Xinlong solar farm',
                'Kezhou Xinlong Energy Development Co., Ltd.',
                'China Power Construction Hydropower Development Group Co., Ltd. [70%]; China Water Resources and Hydropower Sixth Engineering Bureau Co., Ltd. [30%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Atushi',
                'Kezhou',
                'Xinjiang Kezhou Atushi Zhongxing solar farm',
                'Atushi Yuanguang Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shule County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Shule Lineng solar farm',
                'Shule County Lineng Photovoltaic Power Generation Co., Ltd.',
                'Henan Zhongyuan Golden Sun Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shule County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Shule Tengsheng solar farm',
                'Shule Shengteng Photovoltaic Power Co., Ltd.',
                'East Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Taheman Town',
                'Tashikuergan County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Tashitkuer Zhongke Hengyuan solar farm',
                'Kashgar Guoxin Electric Power Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yecheng County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Yecheng Fenglin solar farm',
                'Yecheng Fenglin Power Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yecheng County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Yecheng Yuanguang solar farm',
                'Yecheng Yuanguang Energy Co., Ltd.',
                'Xinjiang Silk Road Zeyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingjisha County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Yingjisha CGN solar farm',
                'CGN Solar Yingjisha Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingjisha County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Yingjisha Rongxintianhe solar farm',
                'Yingjisha Rongxintianhe New Energy Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingjisha County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Yingjisha Tianhua Weiye solar farm',
                'Yingjisha Tianhua Weiye Solar Energy Technology Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sayibage Town',
                'Shufu County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Shufu Junxin solar farm',
                'Shufu County Junxin Technology Photovoltaic Power Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuepuhu County',
                'Kashgar Prefecture',
                'Xinjiang Kashgar Yuepuhu Ruicheng solar farm',
                'Yuepu Lake Ruicheng New Energy Technology Co., Ltd.',
                'Kashi Ruicheng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yecheng County',
                'Kashgar Prefecture',
                'Xinjiang Kashi Yecheng Zhongxing solar farm',
                'Yecheng Yuanxing Energy Co., Ltd.',
                'Xingshu Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Wuerhe District',
                'Karamay',
                'Xinjiang Kelamayi Shenneng solar farm',
                'Xinjiang Shenneng Investment Co., Ltd.',
                'Lin Jianyi[90%]; Li Chunhui[10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Keping County',
                'Aksu Prefecture',
                'Xinjiang Keping CECEP solar farm',
                'CECEP Solar Technology Keping Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qilang Town',
                'Keping County',
                'Aksu Prefecture',
                'Xinjiang Keping Tianhua solar farm',
                'Keping Tianhua New Energy Power Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Akto County',
                'Aketao',
                'Kezhou',
                'Xinjiang Kezhou Akto Xinte Grid-Connected solar farm',
                'Akto County Xinte Photovoltaic Power Generation Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Artux City',
                'Artux',
                "Kezilesuke'er (Qizilsu) Zhou",
                'Xinjiang Kezhou Artux Baiside Grid-Connected solar farm',
                'Kezhou Baiside New Energy Development Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Artux City',
                'Artux',
                "Kezilesuke'er (Qizilsu) Zhou",
                'Xinjiang Kezhou Artux Baiside Grid-Connected solar farm',
                'Kezhou Baiside New Energy Development Co., Ltd.',
                'Jiangxi Shunfeng Photoelectric Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Artux',
                "Kezilesuke'er (Qizilsu) Zhou",
                'Xinjiang Kezhou Artux Huaguang Grid-Connected solar farm',
                'Artux Huaguang Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yopurga County',
                'Yuepuhu County',
                'Kashgar Diqu',
                'Xinjiang Kashgar Yupuhu Zhenfa solar farm',
                'Yuepuhu Zhenfa New Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hotan County',
                'Hetian',
                'Xinjiang Hetian Xinrun 42 Division Pishan Farm solar farm',
                'Hotan Xinrun Photovoltaic Power Generation Co., Ltd.',
                'Xue Xiuyu[100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wushi Town',
                'Wushi County',
                'Aksu Prefecture',
                'Xinjiang Wushi Longbai solar farm',
                'Wushi Longbai Power Investment Co., Ltd.',
                'Xinjiang Silk Road Zeyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou District',
                'Hami',
                'Xinjiang Xikanyuan Shichengzi solar farm',
                'Sinohydro Hami New Energy Development Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hepu Town',
                'Xiangshan County',
                'Ningbo Municipality',
                'Zhejiang Ningbo Hongweitang Photovoltaic solar farm',
                'Ningbo Huineng Energy Co. Ltd.',
                'China Nuclear Huihai Windpower Investment Co. Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Tuci Town',
                'Xiangshan County',
                'Ningbo Municipality',
                'Zhejiang Ningbo Huangshatang Photovoltaic solar farm',
                'Ningbo Chengxin Energy Technology Co. Ltd.',
                'Zhejiang Clean Energy Development Co. Ltd.',
              ],
              [
                'China',
                22,
                'Asia',
                'Changjie Town',
                'Ninghai County',
                'Ningbo Municipality',
                'Zhejiang Ninghai Chengtang fisheries Photovoltaic solar farm',
                'Ninghai Juhe Photovoltaic Engineering Co. Ltd.',
                'Ningbo Juhe New Energy Development Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongxingqiao',
                'Changxing',
                'Huzhou',
                'Zhejiang Province Changxing Hongxingqiao solar farm',
                'Huzhou Dongsheng Photovoltaic Agricultural Technology Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huangwan Town',
                'Haining Shi',
                'Jiaxing',
                'Zhejiang Province Haining Jianshan solar farm',
                'Zhejiang Xuhui New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shanlian Town',
                'Nanxun Qu',
                'Huzhou',
                'Zhejiang Province Huzhou Nanxun Nancun Agricultural solar farm',
                'Huzhou Nanxun Wantou Solar Power Co., Ltd.',
                'Jinxin Century New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Nanxun Qu',
                'Huzhou',
                'Zhejiang Province Huzhou Nanxun Xianghui Fishing and Light Complementary solar farm',
                'Huzhou Xianghui Photovoltaic Power Generation Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                200,
                'Asia',
                'Fenglin Town',
                'Jiangshan Shi',
                'Quzhou',
                'Zhejiang Province Jiangshan Zhengtai Forest, Agriculture and Light Complementary solar farm',
                'Jiangshan Zhengtai Forestry Agriculture Photovoltaic Development Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.[51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                99,
                'Asia',
                'Binhai New District',
                'Ninghai Xian',
                'Ningbo',
                'Zhejiang Province Ningbo Binhai Shepantu Fishing and Light Complementary solar farm',
                'Ninghai Xindian Power Development Co., Ltd.',
                'Hubei Lanfeng Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Cixi Shi',
                'Ningbo',
                'Zhejiang Province Ningbo Cixi Changhe Reservoir solar farm',
                'Cixi Fengling New Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Cixi Shi',
                'Ningbo',
                'Zhejiang Province Ningbo Cixi Zhouxiang Reservoir solar farm',
                'Cixi Shuneng New Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qinggang',
                'Unavailable',
                'Yuhuan',
                'Zhejiang Province Qinggang Taishan solar farm',
                'China Huaneng Group Co., Ltd. Zhejiang Branch',
                'China Huaneng Group',
              ],
              [
                'China',
                45,
                'Asia',
                'Shilifeng Farm',
                'Qujiang District',
                'Quzhou',
                'Zhejiang Province Quzhou Qujiang solar farm',
                'Quzhou Tianhua New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd.',
              ],
              [
                'China',
                160,
                'Asia',
                'Jiuhua Town',
                'Kecheng District',
                'Quzhou',
                'Zhejiang Province Quzhou Qujiang Zhengtai solar farm',
                'Quzhou Hangtai Photovoltaic Power Co., Ltd.',
                'Huadian New Energy Group Co., Ltd. [70%]; Zhejiang Chint New Energy Development Co., Ltd. [30%]',
              ],
              [
                'China',
                550,
                'Asia',
                'Unavailable',
                'Oufei Encircled Area',
                'Wenzhou',
                'Zhejiang Province Wenzhou Zhengtai Taihan solar farm',
                'Zhejiang Chint New Energy Development Co., Ltd.',
                'Zhejiang Chint Electrics Co., Ltd.[92%]; other[8%]',
              ],
              [
                'China',
                82,
                'Asia',
                'Unavailable',
                'Shaoshan District',
                'Hangzhou',
                'Zhejiang Province Xiaoshan Shuneng Fishing and Light Complementary solar farm',
                'Hangzhou Shuneng Power Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Lecheng Town',
                'Yueqing Shi',
                'Wenzhou',
                'Zhejiang Province Yueqing Zhengtai Agriculture Light Complementary solar farm',
                'Leqing Chint Photovoltaic Power Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.[51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Shanlian Town',
                'Nanxun District',
                'Huzhou Municipality',
                'Zhejiang Nanxun Shanlian Photovoltaic solar farm',
                'Huzhou Nanxun Wantou Solar Energy Co. Ltd.',
                'Jinxin Century New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Longxi Town',
                'Yuhuan Shi',
                'Taizhou',
                'Zhejiang Province Yuhuan Xuanmenwan Agriculture and Light Complementary solar farm',
                'Yuhuan Jingneng Power Co., Ltd.',
                'State Power Investment Corporation Zhejiang New Energy Co., Ltd. [51%]; Jinko Power Co., Ltd. [49%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Nanxun District',
                'Huzhou Municipality',
                'Zhejiang Nanxun Hefu (Shenglin) Photovoltaic solar farm',
                'Huzhou Nanxun Shenglin New Energy Co. Ltd.',
                'Shandong Xuteng New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hefu Town',
                'Nanxun District',
                'Huzhou Municipality',
                'Zhejiang Nanxun Hefu (Honghui) Photovoltaic solar farm',
                'Huzhou Honghui Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Shangdian (Shanghai Power) Xinda New Energy Technology Co. Ltd. [81%]; Suzhou Industrial Park Zhongfu Photovoltaic Technology Co. Ltd. [19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Tianning Tiwn',
                'Jiashan County',
                'Jiaxing Municipality',
                'Zhejiang Jiashan Tianningzhen Liubaimudang fisheries Photovoltaic solar farm',
                'Jiashan Fengling New Energy Technology Co. Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yaozhuang Town',
                'Jiaxi County',
                'Jiaxing Municipality',
                'Zhejiang Jiashan Yaozhuangzhen Baiyutang fisheries Photovoltaic solar farm',
                'Jiaxing Deyuan Energy Conservation Technology Co. Ltd.',
                'Wanbu New Energy Investment (China) Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Zheneng Jiaxing thermal power plant',
                'Pinghu Municipality',
                'Jiaxing Municipality',
                'Zhejiang Jiaxing thermal power plant Photovoltaic solar facility',
                'Zhejiang Zheneng Jiaxing Electricity Generation Co. Ltd.',
                'Zhejiang Zheneng Electric Power Co., Ltd. [70.0012%]; Jineng Electric Power Group Co., Ltd. [29.9988%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Youchegang Town',
                'Xiuzhou District',
                'Jiaxing',
                'Zhejiang Jiaxing Xiuzhouqu Beiguandang CECEP solar farm',
                'CECEP Zhejiang Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                21,
                'Asia',
                'Huzhen Town',
                'Jinyun County',
                'Lishui Municipality',
                'Zhejiang Jingyun Beitai Photovoltaic solar farm',
                'Jinyun Beitai Energy Co. Ltd.',
                'Yan Lihui [an individual, 60%]; Zhejiang Huanneng Energy Technology Co. Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinbi Town',
                'Jinyun County',
                'Lishui',
                'Zhejiang Jinyun Jingke solar farm',
                'Jinyun Jingke Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Zhejiang New Energy Co., Ltd. [70%]; Jinko Power Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Hangbu Town',
                'Kecheng District',
                'Quzhou',
                'Zhejiang Kecheng Hangbu Tongjing solar farm',
                'Quzhou Tongjing New Energy Co., Ltd.',
                'Zhejiang Tongjing New Energy Group Co., Ltd. [51%]; State-owned Assets Management Service Center in Kecheng District, Quzhou City [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yongchang Neighborhood',
                'Lanxi Municipality',
                'Jinhua Municipality',
                'Zhejiang Lanxi L\u00fcneng Photovoltaic solar farm',
                'Lanxi Green Energy Solar Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yongchang Neighborhood',
                'Lanxi Municipality',
                'Jinhua Municipality',
                'Zhejiang Lanxi L\u00fcneng Photovoltaic solar farm',
                'Lanxi Green Energy Solar Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yongchang Neighborhood',
                'Lanxi Municipality',
                'Jinhua Municipality',
                'Zhejiang Lanxi L\u00fcneng Photovoltaic solar farm',
                'Lanxi Green Energy Solar Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Meijiang Town',
                'Lanxi Municipality',
                'Jinhua Municipality',
                'Zhejiang Lanxi Meijiang Photovoltaic solar farm',
                'Lanxi Municipality Jinko Power Co. Ltd.',
                'Jinko Power Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Yongchang Neighborhood',
                'Lanxi Municipality',
                'Jinhua Municipality',
                'Zhejiang Lanxi Yongchan (Jinrui) Photovoltaic solar farm',
                'Lanxi Jinrui Solar Energy and Power Co. Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Daotai Town',
                'Longquan Municipality',
                'Lishui Municipality',
                'Zhejiang Longquan Fengpingyan Photovoltaic solar farm',
                'Longquan Municipal Xuquan Solar Energy Development Co. Ltd.',
                'Dongxu New Energy Investment Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Zhanjia Town',
                'Longyou County',
                'Quzhou Municipality',
                'Zhejiang Longyou Agricultural solar farm',
                'China Guoneng Longyou Photovoltaic Power Generation Co., Ltd.',
                'China Sinogy Electric Group Co. Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Xiaonanhai Town',
                'Longyou County',
                'Quzhou Municipality',
                'Zhejiang Longyou County Bentang Xiaokang Photovoltaic solar farm',
                'Longyu County Benkang New Energy Co. Ltd.',
                'Longyou County Benkang Investment Group Co. Ltd. [64.3289%]; Sungrow Power Source Shareholding Co. Ltd. [30%]; Zhejiang Longyou Bofeite Energy Co. Ltd. [5.6711%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Huzhen Town',
                'Longyou County',
                'Quzhou Municipality',
                'Zhejiang Longyou Hezhen Photovoltaic solar farm',
                'China Sinogy Electric Longxi New Energy Co. Ltd.',
                'Zhejiang Clean Energy Co. Ltd. [90%]; China Sinogy Electric Group Co. Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiaonanhai Town',
                'Longyou County',
                'Quzhou Municipality',
                'Zhejiang Longyou Xiaokang Kangxian Photovoltaic solar farm',
                'Longyuan County Benkang New Energy Co. Ltd.',
                'Longyou county Benkang Investment Group Co. Ltd. [64.3289%]; Sungrow Power Source Shareholding Co. Ltd. [30%]; Zhejiang Longyou Bofeite Energy Co. Ltd. [5.6711%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Hefu Town',
                'Nanxun District',
                'Huzhou Municipality',
                'Zhejiang Nanxun Hefu (Honghui) Photovoltaic solar farm',
                'Huzhou Honghui Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Shangdian (Shanghai Power) Xinda New Energy Technology Co. Ltd. [81%]; Suzhou Industrial Park Zhongfu Photovoltaic Technology Co. Ltd. [19%]',
              ],
              [
                'China',
                120,
                'Asia',
                'Longxi Town',
                'Yuhuan Shi',
                'Taizhou',
                'Zhejiang Province Yuhuan Xuanmenwan Agriculture and Light Complementary solar farm',
                'Yuhuan Jingneng Power Co., Ltd.',
                'State Power Investment Corporation Zhejiang New Energy Co., Ltd. [51%]; Jinko Power Co., Ltd. [49%]',
              ],
              [
                'China',
                26,
                'Asia',
                'Fangshan Town',
                'Qingtian County',
                'Lishui Municipality',
                "Zhejiang Qingtian Bei'an Photovoltaic solar farm",
                "Qingtian Bei'an New Energy Technology Co. Ltd.",
                'State Power Investment Group Zhejiang New Energy Co. Ltd. [70%]; Qingtian Dasheng Agricultural Investment Co. Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Duze Town',
                'Qujiang District',
                'Quzhou Municipality',
                'Zhejiang Qujiang District Duze Xiaokang Photovoltaic solar farm',
                'Quzhou Municipality Qujiang District Hehe New Energy Co. Ltd.',
                'State Power Investment Group Heilongjiang L\u00fctuo New Energy Co. Ltd. [55.88%]; Quzhou Municipality Qujiang District New Agriculture Investment Co. Ltd. [44.12%]',
              ],
              [
                'China',
                33,
                'Asia',
                'Liuheng thermal power plant',
                'Putuo District',
                'Zhoushan Municipality',
                'Zhejiang Zhoushan Liuheng solar Photovoltaic power plant',
                'Zhejiang Energy China Coal Zhoushan Coal and Electricity Co. Ltd.',
                'Zhejiang Zheneng (Zhejiang Energy) Electricity Shareholding Co. Ltd. [63%]; China Zhongmei (China Coal) Shareholding Co. Ltd. [27%]; Sanlin Wanye (Shanghai) Enterprises Group Co. Ltd. [10%]',
              ],
              [
                'China',
                31,
                'Asia',
                'Longqingxia',
                'Yanqing District',
                'Beijing',
                'Beijing Yanqing Longqingxia solar farm',
                'Yanqing Photovoltaic Power Generation Branch of Beijing Jingneng Clean Energy Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Binhai New District',
                'Tianjin',
                'Tianjin Binhai New District Zhonghe Agriculture solar farm',
                'Tianjin Zhonghe Zuobiao New Energy Technology Development Co., Ltd',
                'Xinli Times Energy Technology Co., Ltd.[95%]; Shanghai Jolywood New Energy Co., Ltd.[5%]',
              ],
              [
                'China',
                174,
                'Asia',
                'Huanggang',
                'Binhai New District',
                'Tianjin',
                'Tianjin Huanggang Pianqu Grid-connected solar farm',
                'Xinyi Photovoltaic (Tianjin) Co . Ltd.',
                'Glory City International Limited',
              ],
              [
                'China',
                94,
                'Asia',
                'Jinghai Town',
                'Jinghai District',
                'Tianjin',
                'Tianjin Jinghai Houyangzhuang Yulong solar farm',
                'Tianjin Tuanbo Yulong Photovoltaic Technology Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinghai District',
                'Tianjin',
                'Tianjin Jinghai Saiert Rooftop solar farm',
                'Tianjin Yangdong New Energy Power Generation Technology Co., Ltd.',
                'Hefei Zhuoyou New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jingwu Town',
                'Xiqing District',
                'Tianjin',
                'Tianjin Jingwuzhen Changsheng solar farm',
                'Tianjin Changsheng Solar Energy Technology Co., Ltd.',
                'Ordos Changsheng Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jingwu Town',
                'Xiqing District',
                'Tianjin',
                'Tianjin Jingwuzhen Yudian solar farm',
                'Tianjin Yudian Solar Energy Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd. [51%]; Qingdao Chengtou New Energy Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Xiaowangzhuang Town',
                'Binhai New District',
                'Tianjin',
                'Tianjin Liugangzhuang Huadian Beichen solar farm',
                'Tianjin Huadian Beichen Distributed Energy Co., Ltd.',
                'Huadian Fuxin Energy Co., Ltd. [80%]; Tianjin Beichen Science and Technology Park Management Co., Ltd. [14%]; Hebei Yuanchen Industrial Group Co., Ltd. [6%]',
              ],
              [
                'China',
                80,
                'Asia',
                'Unavailable',
                'Ninghe District',
                'Tianjin',
                'Tianjin Ninghe District Dayuehe Yongneng solar farm',
                'Tianjin Yongneng Photovoltaic Power Generation Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Panzhuang Town',
                'Ninghe District',
                'Tianjin',
                'Tianjin Ninghe District Ningxin solar farm',
                'Tianjin Ningxin Energy Saving and Environmental Protection Technology Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Panzhuang Town',
                'Ninghe District',
                'Tianjin',
                'Tianjin Ninghe District Panzhuang Xinli solar farm',
                'Tianjin Xinli Photovoltaic Power Station Technology Development Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                95,
                'Asia',
                'Taiping Town',
                'Binhai District',
                'Tianjin',
                'Tianjin Taipingzhen Zhongdian Shengfa solar farm',
                'Tianjin Zhongdian Shengfa Photovoltaic Power Generation Co., Ltd.',
                'SDIC [Tianjin] Distributed Energy Co., Ltd. [70%]; Sogreen Solar [Tianjin] Co., Ltd.[30%]',
              ],
              [
                'China',
                65,
                'Asia',
                'Taiping Town',
                'Binhai District',
                'Tianjin',
                'Tianjin Taipingzhen Zhongdian Shengfa solar farm',
                'Tianjin Zhongdian Shengfa Photovoltaic Power Generation Co., Ltd.',
                'SDIC [Tianjin] Distributed Energy Co., Ltd. [70%]; Sogreen Solar [Tianjin] Co., Ltd.[30%]',
              ],
              [
                'China',
                24,
                'Asia',
                'Tuanbo Town',
                'Jinghai District',
                'Tianjin',
                'Tianjin Tuanbo Mengjiafangzi Mingrui solar farm',
                'Tianjin Tuanbo Mingrui New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                31,
                'Asia',
                'Tuanbo Town',
                'Jinghai District',
                'Tianjin',
                'Tianjin Tuanbo Mengjiafangzi Yuhe solar farm',
                'Tianjin Tuanbo Yuhe Photovoltaic Technology Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                78,
                'Asia',
                'Tuanbo Town',
                'Jinghai District',
                'Tianjin',
                'Tianjin Tuanbo Mengjiafangzi Yuhong solar farm',
                'Tianjin Tuanbo Yuhong Photovoltaic Technology Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Gangshan Reservoir',
                'Zhenhai District',
                'Ningbo',
                'Zhejiang Zhenhai Lingguang Photovoltaic solar farm',
                'Ningbo Zhenhai Lingguang New Energy Technology Co. Ltd.',
                'China Energy conservation Solar Energy Technology Co. Ltd.',
              ],
              [
                'China',
                110,
                'Asia',
                'Xiepu Town',
                'Zhenhai District',
                'Ningbo Municipality',
                'Zhejiang Zhenhai Gangshan Reservoir fisheries solar Photovoltaic power plant',
                'Ningbo Zhenhai Gangneng New Energy Technology Co. Ltd.',
                'China Energy Conservation Solar Technology Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baoshan Village',
                'Yunhe County',
                'Lishui Municipality',
                "Zhejiang Yunhe Baoshan 'forestry-agricultural' Photovoltaic solar farm",
                'Yunhe County Zhongy Energy Co. Ltd.',
                'State Power Investment Group Heilongjiang L\u00fctuo New Energy Co. Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Qinggang Town',
                'Yuhuan Municipality',
                'Taizhou Municipality',
                "Zhejiang Yuhuan Qinggang 'fisheries' Photovoltaic solar farm",
                'China Huaneng Group Co., Ltd. Yuhuan Power Plant',
                'China Huaneng Group Co. Ltd.',
              ],
              [
                'China',
                65,
                'Asia',
                'Hunan Town',
                'Qujiang District',
                'Quzhou Municipality',
                'Zhejiang Qujiang District Hunan Xiaokang Photovoltaic solar farm',
                'Quzhou Municipality Qujiang District Hehe New Energy Co. Ltd.',
                'State Power Investment Group Heilongjiang L\u00fctuo New Energy Co. Ltd. [55.88%]; Quzhou Municipality Qujiang District New Agriculture Investment Co. Ltd. [44.12%]',
              ],
              [
                'China',
                46,
                'Asia',
                'Nianli',
                'Qujiang',
                'Quzhou',
                'Zhejiang Qujiang Nianli Guangsheng solar farm',
                'Zhejiang Guangsheng New Energy Co., Ltd.',
                'Zhejiang Guangsheng Group Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Jiuhua Town',
                'Kecheng District',
                'Quzhou Municipality',
                'Zhejiang Quzhou Hangtai Photovoltaic solar farm',
                'Quzhou Hangtai Photovoltaic Power Generation Co. Ltd.',
                'Huadian New Energy Group Co., Ltd. [70%]; Zhejiang Chint New Energy Development Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Hangbu Town',
                'Kecheng District',
                'Quzhou Municipality',
                "Zhejiang Quzhou Kecheng 'agricultural' solar farm",
                'Quzhou Linuo Tianyu Yangguang New Energy Co. Ltd.',
                'Zhejiang Clean Energy Development Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dazhou Town',
                'Qujiang District',
                'Quzhou',
                'Zhejiang Quzhou Qujiang Hangkai solar farm',
                'Quzhou Hangkai New Energy Technology Co., Ltd.',
                'State Power Investment Group Heilongjiang Lutuo New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Kexiang Industrial Park',
                "Rui'an Municipality",
                'Wenzhou Municipality',
                "Zhejiang Rui'an (Huabo) Photovoltaic solar power project",
                "Rui'an Municipality Haobo New Energy Co. Ltd.",
                'Hangzhou Kaike Power Technology Co. Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Chishou Town',
                'Songyang County',
                'Lishui Municipality',
                "Zhejiang Songyang 'agricultural' solar farm",
                'Zhejiang Energy Huanya Songyang Photovoltaic Power Co. Ltd.',
                'Zhejiang Clean Energy Development Co. Ltd. [60%]; Zhejiang Huanya Energy Technology Co. Ltd. [40%]',
              ],
              [
                'China',
                32,
                'Asia',
                'Yunfeng Neighborhood',
                'Suichang County',
                'Lishui Municipality',
                'Zhejiang Suichang County Yunfeng Xiaokang Photovoltaic solar farm',
                'Suichang County Jinghe New Energy Technology Co. Ltd.',
                'State Power Investment Group Heilongjiang L\u00fctuo New Energy Co. Ltd. [55%]; Suichang County Jinkong Investment Management Co. Ltd. [45%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Taozhuang Town',
                'Jiashan County',
                'Jiaxing Municipality',
                'Zhejiang Jiashan Taozhuangzhen Xiamudang fisheries Photovoltaic solar farm',
                'Jiashan Shuneng New Energy Technology Co. Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                32,
                'Asia',
                'On grounds of Taizhou #2 powerplant in Caotou Village on south side of Jiantiao Harbor',
                'Sanmen County',
                'Taizhou Municipality',
                'Zhejiang Taizhou thermal power plant 2 solar farm',
                'Zhejiang Energy Taizhou #2 Power Generation Co. Ltd.',
                'Zhejiang Zheneng (Zhejiang Energy) Shareholding Co. Ltd. [94.0002%]; Sanmen County Resources and Energy Group Co. Ltd. [4.99987%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhouquan Town',
                'Tongxiang',
                'Jiaxing',
                'Zhejiang Tongxiang Zhouquan Zhongdianjian solar farm',
                'China Power Construction (Tongxiang) Photovoltaic Power Generation Co., Ltd.',
                'China Hydropower Construction Group New Energy Development Co., Ltd.; Tongxiang City Linhang Economic Zone Xinshi Town Development and Construction Co., Ltd.',
              ],
              [
                'China',
                23,
                'Asia',
                'Eryuan Town',
                'Wencheng',
                'Wenzhou',
                'Zhejiang Wencheng Eryuan Photovoltaic solar farm',
                'Wencheng Datang New Energy Co. Ltd.',
                'Datang International Power Shareholding Co. Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Daixi Town',
                'Wuxing District',
                'Huzhou Municipality',
                'Zhejiang Wuxing Daixi Photovoltaic solar farm',
                'Zhejiang Apoxilun Photovoltaic Technology Co. Ltd.',
                'Beijing United Rongbang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Donglin Town',
                'Wuxing District',
                'Huzhou Municipality',
                'Zhejiang Wuxing Donglin Photovoltaic solar farm',
                'Huzhou Wuxing Shenglin Power Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Miaoxi Town',
                'Wuxing District',
                'Huzhou Municipality',
                'Zhejiang Wuxing Miaoxi Photovoltaic solar farm',
                'Huzhou Wuxing Beineng New Energy Co., Ltd.',
                'Zhejiang Beineng New Energy Development Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaotangdao Town',
                'Xiangshan County',
                'Ningbo Municipality',
                "Zhejiang Xiangshan Zhiluo'ao Photovoltaic solar farm",
                'Xiangshan Nanridao New Energy Co. Ltd.',
                'Hong Kong Baofenghang Investment Co. Ltd. [35%]; Hong Kong Zhongguan Co. Ltd. [25%]; Ningbo Qijifeng Enterprises Investment Co. Ltd. [20%]; Zhejiang Wanli Investment Co. Ltd. [13%];',
              ],
              [
                'China',
                25,
                'Asia',
                'Nanqiu Town',
                'Yueqing Municipality',
                'Wenzhou Municipality',
                'Zhejiang Yueqing Nanqiu Photovoltaic solar farm',
                'Zhejiang Energy Yueqing Power Generation Co. Ltd.',
                'Zhejiang Energy Shareholding Co. Ltd. [51%]; Beijing Guodian Power Co. Ltd. [23%]; Wenzhou Electricity Investment Co. Ltd. [10%]; Wenzhou Municipal Industry and Energy Development Group Co. Ltd. [9%]; Huafeng Group Co. Ltd. [7%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Ganjiang Town',
                'Yuhuan Municipality',
                'Taizhou Municipality',
                'Zhejiang Yuhuan Hongdi Beachfront distributed solar Photovoltaic power plant',
                'Taizhou Hongdi New Energy Co. Ltd.',
                'State Power Investment Group Qingyuan Hefeng New Energy Co. Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Baihe Town',
                'Tiantai County',
                'Taizhou Municipality',
                "Zhejiang Tiantai County 'fisheries' solar farm",
                'Tiantai China Power Construction New Energy Co. Ltd.',
                'China Power Construction New Energy Group Co. Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Taozhuang Town',
                'Jiashan County',
                'Jiaxing Municipality',
                'Zhejiang Jiashan South Taozhuangzhen Xiamudang fisheries Photovoltaic solar farm',
                'Jiashan Fengling New Energy Technology Co. Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Tianning Town',
                'Jiashan County',
                'Jiaxing',
                'Zhejiang Jiashan Fengling solar farm',
                'Jiashan Fengling New Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shangyu Town',
                'Jiangshan Municipality',
                'Quzhou Municipality',
                'Zhejiang Jiangshan Shangyu fisheries Photovoltaic solar farm',
                'State Power Investment Group Fujian Power Investment Co. Ltd. Jiangshan New Energy Branch',
                'State Power Investment Group Fujian Power Investment Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bazhou',
                'Xinjiang Yuli Zhongjiancai Junxin solar farm',
                'Yuli Zhongjiancai Junxin Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bazhou',
                'Xinjiang Yuli Zhongjiancai Junxin solar farm',
                'Yuli Zhongjiancai Junxin Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yutian',
                'Hotan',
                'Xinjiang Yutian Xinfeng solar farm',
                'Xinjiang Yutian Xinfeng Power Generation Co., Ltd.',
                'Xinjiang Wind ENERGY Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Agricultural 4th division 61 group',
                'Yili Zhou',
                'Yili Xinjiang PLA Corps Ximeishi 100 MW Solar',
                'Yili Simeishi New Energy Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Binju',
                'Binchuan',
                'Dali',
                'Yunnan Binchuan Binju Juneng solar farm',
                'Dali Juneng Investment Co., Ltd. of the 14th Hydropower Bureau',
                'Sinohydro Renewable Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Binchuan',
                'Dali',
                'Yunnan Binchuan CLP solar farm',
                'CLP Dali (Xicun) Photovoltaic Power Generation Co., Ltd.',
                'CLP Power China Solar Power (West) Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Daying',
                'Binchuan',
                'Dali',
                'Yunnan Binchuan Daying Datang solar farm',
                'Yunnan Datang International Binchuan New Energy Co., Ltd.',
                'Yunnan Datang International Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Daying Town',
                'Binchuan County',
                'Dali',
                'Yunnan Binchuan Dayingzhen Bainigou solar farm',
                'Yunnan Datang International Binchuan New Energy Co., Ltd.',
                'Yunnan Datang International Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Binchuan',
                'Dali',
                'Yunnan Binchuan Three Gorges solar farm',
                'Three Gorges New Energy Binchuan Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinjie Town',
                'Dayao County',
                'Chuxiong',
                'Yunnan Dayao Daguya Sinohydro solar farm',
                'Sinohydro Dayao New Energy Development Co., Ltd.',
                'Sinohydro Renewable Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dafoshan',
                'Eryuan',
                'Dali',
                'Yunnan Eryuan Dafoshan Xiehe solar farm',
                'Eryuan Xiehe Solar Power Generation Co., Ltd.',
                'Xiehe Wind Power Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dazhuang Town',
                'Kaiyuan',
                'Honghezhou',
                'Yunnan Kaiyuan Dazhuangxiang Zhumashao Zhongneng solar farm',
                'Kaiyuan Zhongneng New Energy Co., Ltd.',
                'Beijing Jianneng Shangjie Technology Co., Ltd.',
              ],
              [
                'China',
                33,
                'Asia',
                'Unavailable',
                'Kaiyuan',
                'Honghezhou',
                'Yunnan Kaiyuan Qingtangzi Hongyu solar farm',
                'Kaiyuan Hongyu Sunshine New Energy Power Generation Co., Ltd.',
                'China Three Gorges Renewables [Group] Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Menghun Town',
                'Menghai County',
                'Xishuangbanna',
                'Yunnan Menghai Menghun Hengding solar farm',
                'Xishuangbanna Hengding New Energy Development Co., Ltd.',
                'Tang Xiaoyan',
              ],
              [
                'China',
                40,
                'Asia',
                'Xibeile Town',
                'Mengzi',
                'Honghezhou',
                'Yunnan Mengzi Xibeile Luogedi solar farm',
                'Mengzi Otesville Photovoltaic Power Generation Co., Ltd.',
                'Honghe Huajun Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Daying',
                'Binchuan',
                'Dali',
                'Yunnan Province Binchuan Xicun Grid-Connected solar farm',
                'CLP Dali (Xicun) Photovoltaic Power Co., Ltd.',
                'CLP Power China Solar Power (West) Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Daying',
                'Binchuan',
                'Dali',
                'Yunnan Province Binchuan Xicun Grid-Connected solar farm',
                'CLP Dali (Xicun) Photovoltaic Power Co., Ltd.',
                'CLP Power China Solar Power (West) Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Talimu',
                'Yuli',
                'Bayingolin',
                'Xinjiang Yuli Talimu Xingye solar farm',
                'Xinjiang Xingye New Energy Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli',
                'Bayingolin',
                'Xinjiang Yuli Jiangyin Junxin solar farm',
                'Yuli Jiangyin Junxin Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuepuhu County',
                'Kashgar Prefecture',
                'Xinjiang Yuepuhu Xinrong solar farm',
                'Tumshuke Xinrong New Energy Technology Co., Ltd. Yuepu Lake Branch',
                'Tumushuke Xinrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yopurga County',
                'Yuepuhu County',
                'Xinjiang Yuepuhu Hi-tech solar farm',
                'Yuepuhu High Tech New Energy Power Generation Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bazhou',
                'Xinjiang Xingye Second Division 33 Regiment solar farm',
                'Xinjiang Xingye New Energy Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'No.12 Division No.104 Corps',
                'Shuimogou District',
                'Urumqi',
                'Xinjiang Xiwang Chuangmei solar farm',
                'Xinjiang Hope Chuangmei Photoelectric Engineering Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yanqi',
                'Bayingolin',
                "Xinjiang Yanqi Xin'ao solar farm",
                "Yanqi Xin'ao Solar Energy Co., Ltd.",
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wuxiabashi Town',
                'Yecheng County',
                'Kashgar Prefecture',
                'Xinjiang Yecheng Ruicheng solar farm',
                'Yecheng Ruicheng New Energy Technology Co., Ltd.',
                'Kashi Ruicheng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                '4th Corps',
                'Gongliu Xian',
                'Yili Zhou',
                'Xinjiang Yili 73rd Brigade Yiyang solar farm',
                'Xinjiang Yiyang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sunzhaqiniulu Town',
                'Chabuchaer (Qaqpal) Xian',
                'Yili Zhou',
                'Xinjiang Yili Chabuchar TBEA Grid-Connected solar farm',
                'Chabuchar Huaguang Power Generation Co., Ltd.',
                'Shaanxi Jidian Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Khorgas',
                'Yili',
                'Xinjiang Yili GCL Energy solar farm',
                'Yili GCL Energy Co., Ltd.',
                'Xinjiang Production and Construction Corps Investment Co., Ltd. [43%]; Huaneng Gongrong No. 1 [Tianjin] Equity Investment Fund Partnership [Limited Partnership] [34%]; Huaneng Gongrong No. 2 [Tianjin] Equity Investment Fund Partnership [Limited] Partnership] [23%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Nilka County',
                'Yili',
                'Xinjiang Yili Nileke Zhongli Tenghui solar farm',
                'Nilek Zhongli Tenghui Photovoltaic Power Generation Co., Ltd.',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Ganbala',
                'Yongren',
                'Chuxiong Yi Autonomous Prefecture',
                'Yunnan Province Chuxiong Ganbala Grid-Connected solar farm',
                'Yongren Xiehe Solar Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tekesi Xian',
                'Yili Zhou',
                'Xinjiang Yili Tekesi Yuhui Grid-Connected solar farm',
                'Tekesi Yuhui Solar Energy Development Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingjisha',
                'Kashgar Prefecture',
                'Xinjiang Yingjisha Baode solar farm',
                'Yingjisha Baode Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yiwu',
                'Hami',
                'Xinjiang Yiwu Taike solar farm',
                'Yiwu Taike Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy (Shanghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou',
                'Hami',
                'Xinjiang Yizhou Hengxin solar farm',
                'Hami Hengxin New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Yizhou Shichengzi Chaoxiang solar farm',
                'Hami Chaoxiang New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Yizhou Shichengzi CPI solar farm',
                'Three Gorges New Energy Hami Wind Power Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Yizhou Shichengzi Jialing solar farm',
                'Hami Jialing Photoelectric Technology Co., Ltd.',
                'China Power Investment Xinjiang Energy and Chemical Industry Group Hami Co., Ltd. [75%]; Sichuan Jialing Electrical Co., Ltd. [22.5%]; Wu Miao [7%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Yizhou Shichengzi Three Gorges solar farm',
                'Three Gorges New Energy Hami Wind Power Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yopurga',
                'Kashgar',
                'Xinjiang Yopurga Hairun solar farm',
                'Yuepuhu Hairun Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu Sunshine Group Co., Ltd. [99%]; Others [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Khorgas',
                'Yili',
                'Xinjiang Yili Xinhui solar farm',
                'Yili Xinhui Photovoltaic Power Generation Co., Ltd.',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wusu',
                'Tacheng',
                'Xinjiang Wusu Zhongjing solar farm',
                'Wusu Zhongjing Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Weide Town',
                'Yongren',
                'Chuxiong Yi Autonomous Prefecture',
                'Yunnan Province Chuxiong Yongren Weide Grid-Connected solar farm',
                'Yunnan Huadian Weidi Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Corp. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Kuanzhuang',
                'Fumin',
                'Kunming',
                'Yunnan Province Fumin County Baishiya Agriculture-Light Complementary solar farm',
                'Lvqingneng (Fumin) Solar Energy Technology Co., Ltd.',
                'JME Engineering Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pingtian',
                'Yuanmou',
                'Chuxiong',
                'Yunnan Yuanmou Pingtian Three Gorges solar farm',
                'Three Gorges New Energy Yuanmou Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuanmou',
                'Chuxiong',
                'Yunnan Yuanmou Zhongdian solar farm',
                'Yuanmou Zhongdian Electric Photovoltaic Power Generation Co., Ltd.',
                'Zhongdiantou Yunnan Hydropower Development Co., Ltd. [75%]; Jingdezhen Coking Industry Group Co., Ltd. [15%]; Zhang Zeshun [10%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Yinyuan Town',
                'Yuanjiang County',
                'Yuxi',
                'Yunnsn Yuanjiang Beizeba Zhongsheng solar farm',
                'Yuanjiang Zhongsheng Solar Energy Technology Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Meixi Town',
                'Anji County',
                'Huzhou Municipality',
                'Zhejiang Anji Meixi China Guoneng Photovoltaic solar farm',
                "China Sinogy Electric Ji'am Photovoltaic Power Co. Ltd.",
                'Zhongqing Energy (Hangzhou) Co. Ltd. [95%]; China Energy Engineering Group (Shanghai) Environmental Technology Co. Ltd. [5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Meixi Town',
                'Anji County',
                'Huzhou Municipality',
                'Zhejiang Anji Meixizhen Caodanghu "fisheries" Photovoltaic solar farm',
                'State Power Investment Group Sangni Anji New Energy Co. Ltd.',
                'State Power Investment Group Zhejiang New Energy Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Changshan County',
                'Quzhou',
                'Zhejiang Changshan Tongking solar farm',
                'Changshan Tongking New Energy Co., Ltd.',
                'Zhejiang Tonking New Energy Group Co., Ltd.',
              ],
              [
                'China',
                21,
                'Asia',
                'Huibu Town',
                'Changshan County',
                'Quzhou Municipality',
                'Zhejiang Changshan Xiaokang solar farm',
                'Changshan County Village Investment Group Co. Ltd.',
                'Changshan State Asset Investment and Operating Co. Ltd. [95%]; China Agricultural Development Key Construction Fund Co. Ltd. [5%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongqiao Town',
                'Changxing County',
                'Huzhou Municipality',
                'Zhejiang Changxing Hongqiao (China Power Construction) Photovoltaic solar farm',
                'China Power Construction (Changxing) Photovoltaic Power Co. Ltd.',
                'China Power Construction New Energy Group Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongqiao Town',
                'Changxing County',
                'Huzhou Municipality',
                'Zhejiang Changxing Hongqiao (Huaneng) Photovoltaic solar farm',
                'Huaneng Changxing Photovoltaic Power Co. Ltd.',
                'Huaneng (Zhejiang) Energy Development Co. Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'L\u00fcshan Town',
                'Changxing County',
                'Huzhou Municipality',
                'Zhejiang Changxing L\u00fcshan Photovoltaic solar farm',
                'CECEP (Changxing) Solar Energy Technology Co., Ltd.',
                'China Energy Conservation Solar Technology Co. Ltd.',
              ],
              [
                'China',
                79,
                'Asia',
                "Si'an Town",
                'Changxing County',
                'Huzhou Municipality',
                "Zhejiang Changxing Si'an Photovoltaic solar farm",
                'Zhejaing Energy Changxing New Energy Co. Ltd.',
                'Zhejiang Clean Energy Development Co. Ltd.',
              ],
              [
                'China',
                110,
                'Asia',
                'Longshan Town',
                'Cixi County',
                'NIngbo Municipality',
                'Zhejiang Cixi fisheries (Baiyi) Photovoltaic solar farm',
                'Cixi Baiyi New Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                110,
                'Asia',
                'Longshan Town',
                'Cixi County',
                'NIngbo Municipality',
                'Zhejiang Cixi fisheries (Xieneng) Photovoltaic solar farm',
                'Cixi Xieneng New Energy Technology Co. Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Lvshan Town',
                'Changxing County',
                'Huzhou',
                'Zhejiang Fudan Changxing CECEP solar farm',
                'CECEP (Changxing) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sandu Town',
                'Jiande Municipality',
                'Hangzhou Municipality',
                'Zhejiang Jiande (China Power Construction) solar farm',
                'Jiande China Power Construction New Energy Co. Ltd.',
                'China Power Construction New Energy Group Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shouchang Town',
                'Jiande',
                'Hangzhou',
                'Zhejiang Jiande Jingke solar farm',
                'Jiande Jingke Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Zhejiang New Energy Co., Ltd. [70%]; Jinko Power Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Fenglin',
                'Jiangshan',
                'Quzhou',
                'Zhejiang Jiangshan Fenglin Tonking solar farm',
                'Zhejiang Tonking New Energy Group Co., Ltd.',
                'Wu Jiannong [97%]; Others [3%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Ganzhuang',
                'Yuanjiang County',
                'Yuxi',
                'Yunnan Yuanjiang Ganzhuang Zhongdian solar farm',
                'Yuanjiang Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Power International New Energy Holding Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Sijiao Mountain',
                'Yongsheng County',
                'Lijiang',
                'Yunnan Yongsheng Sijiaoshan solar farm',
                'China Energy Construction Group Yongsheng New Energy Co., Ltd.',
                'China Energy Construction Group Investment Co., Ltd. [90%]; China Energy Construction Group Yunnan Electric Power Design Institute Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yongren',
                'Chuxiong',
                'Yunnan Yongren SPIC solar farm',
                'Zhongdiantou Yunnan Hydropower Development Co., Ltd.',
                'SPIC Yunnan International Power Investment Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Lianche Town',
                'Yongren County',
                'Chuxiong',
                'Yunnan Yongren Banxing Huiguang solar farm',
                'Yongren Huiguang Photovoltaic Power Generation Co., Ltd.',
                'Changzhou Xinguang New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Kuanzhuang',
                'Fumin',
                'Kunming',
                'Yunnan Province Fumin County Baishiya Agriculture-Light Complementary solar farm',
                'Lvqingneng (Fumin) Solar Energy Technology Co., Ltd.',
                'JME Engineering Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Kuanzhuang',
                'Fumin',
                'Kunming',
                'Yunnan Province Fumin County Baishiya Agriculture-Light Complementary solar farm',
                'Lvqingneng (Fumin) Solar Energy Technology Co., Ltd.',
                'JME Engineering Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xingquan',
                'Huaping',
                'Lijiang',
                'Yunnan Province Huaping County Ganqing Grid-Connected solar farm',
                'Huaping Xiehe Solar Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huaping',
                'Lijiang',
                'Yunnan Province Huaping County Miluocaozi solar farm',
                'Three Gorges New Energy Huaping Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Nanzhuang Town',
                'Jianshui Xian',
                'Honghezhou',
                'Yunnan Province Jianshui County Nanzhuang Grid-Connected solar farm',
                'SDIC New Energy (Honghe) Co., Ltd.',
                'SDIC Power Holdings CO., LTD.[90%]; SDIC Dingshi Overseas Investment Management Co., Ltd.[10%]',
              ],
              [
                'China',
                66,
                'Asia',
                'Shilin',
                'Shilin',
                'Kunming',
                'Yunnan Province Kunming Shilin Grid-Connected solar farm',
                'Shilin Yundiantou New Energy Development Co., Ltd.',
                'Yunnan Energy Investment New Energy Investment Development Co., Ltd.[76%]; Inner Mongolia Shanlu Energy Group Co., Ltd.[24%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiyi Town',
                'Longyang District',
                'Baoshan',
                'Yunnan Province Longyang District Changshan Grid-Connected solar farm',
                'Baoshan Changshan Shunfeng Shangde New Energy Co., Ltd.',
                'Shanghai Shunneng Investment Co., Ltd. [99.9%];Shenzhen Suntech Power Co., Ltd.[0.1%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Xijiekou',
                'Shilin',
                'Kunming',
                'Yunnan Province Shilin Beidacun Agricultural Grid-Connected solar farm',
                'Shilin Zhongyun Power New Energy Co., Ltd.',
                'Yunnan Dianneng Smart Energy Co., Ltd.',
              ],
              [
                'China',
                46,
                'Asia',
                'Dalongtan Wind Farm',
                'Eryuan',
                'Dali',
                'Yunnan Province Dalongtan Wind-Solar Complementary Project',
                'Huaneng Eryuan Wind Power Co., Ltd.',
                'China Huaneng Group [95%]; Huaneng Capital Services Co., Ltd. [5%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Xijiekou',
                'Shilin',
                'Kunming',
                'Yunnan Province Shilin Beidacun Agricultural Grid-Connected solar farm',
                'Shilin Zhongyun Power New Energy Co., Ltd.',
                'Yunnan Dianneng Smart Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hewai',
                'Yuanmou',
                'Chuxiong Yi Autonomous Prefecture',
                'Yunnan Province Yuanmou County Hewai Grid-Connected solar farm',
                'Yuanmou Green Power New Energy Development Co., Ltd.',
                'Guizhou Xiwei New Energy Co., Ltd. [80%]; Kunming Rongcui Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Dazhaizi Town',
                'Zhaoyang District',
                'Zhaotong',
                'Yunnan Province Zhaotong Zhaoyang Ningbian solar farm',
                'China Resources New Energy Photovoltaic Power Generation (Zhaotong) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Heyuan Town',
                'Shidian County',
                'Baoshan',
                'Yunnan Shidian Daposhan Kuangda Guoxin solar farm',
                'Shidian Kuangda Guoxin Guangfu Technology Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Muguashan',
                'Shidian',
                'Baoshan',
                'Yunnan Shidian Muguashan Sunshine solar farm',
                'Shidian Sunshine Energy Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Xijiekou Town',
                'Shilin County',
                'Kunming',
                'Yunnan Shilin Xijiekou Huaneng solar farm',
                'Huaneng Kunming Wind Power Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                27,
                'Asia',
                'Dazhuang Town',
                'Shuangbai County',
                'Chuxiong',
                'Yunnan Shuangbai Dazhuang Sinohydro solar farm',
                'Sinohydro Shuangbai Development Co., Ltd.',
                'China Hydropower Engineering Consulting Group Co., Ltd. [80%]; PowerChina Kunming Survey and Design Research Institute Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Pingyuan Town',
                'Yanshan County',
                'Wenshanzhou',
                'Yunnan Yanshan Taike solar farm',
                'Yanshan Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Pingyuan Town',
                'Yanshan County',
                'Wenshanzhou',
                'Yunnan Yanshan Taike solar farm',
                'Yanshan Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiutian',
                'Yongren',
                'Chuxiong Yi Autonomous Prefecture',
                'Yunnan Province Yongren County Xiutian Grid-Connected solar farm',
                'Yunnan Dianneng Smart Energy Co., Ltd.',
                'Power Investment Qingneng Phase I Carbon Neutral Equity Investment (Tianjin) Partnership (Limited Partnership) [51%]; State Power Investment Corporation Yunnan International Power Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Songta Town',
                'Shouyang County',
                'Jinzhong',
                'Shanxi Shouyang "Front Runner" Guoke No.2 solar farm',
                'Shouyang Guoke New Energy Technology Co., Ltd.',
                'Hengfeng County Jingjia Electric Power Co., Ltd. [70%]; Jinkai New Energy Technology Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hotan County',
                'Hetian',
                'Xinjiang Hetian Xiexin 14 Division 224 Regiment solar farm',
                'Hetian GCL Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Minfeng County',
                'Hetian District',
                'Xinjiang Hetian Minfeng Angli Grid-Connected solar farm',
                'Minfeng Angli Photovoltaic Technology Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd. [91%]; Zhengxin Optoelectronics Technology Co., Ltd.[9%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Beila Town',
                'Bange County',
                'Naqu',
                'Tibet Bange Jinkai solar farm',
                'Tibet Jinkai New Energy Co., Ltd.',
                'Tibet Jinkai New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Baxoi',
                'Chamdo',
                'Tibet Baxoi Changxin solar farm',
                'Changdu Changxin Solar Power Generation Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Baxoi',
                'Chamdo',
                'Tibet Baxoi Guozha solar farm',
                'Changdu Guozha Solar Energy Co., Ltd.',
                'Shanghai Hetasite New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Comai',
                'Shannan',
                'Tibet Comai Xiehe solar farm',
                'Cuomei Xiehe Solar Power Co., Ltd.',
                'Yinhua Xiehe New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dagze',
                'Lhasa',
                'Tibet Dagze Yungao solar farm',
                'Tibet Yungao Renewable Energy Co., Ltd.',
                'Wonderful Century Limited [78.1%]; Tibet Ruiding Venture Capital Management Partnership (Limited Partnership) [5.1%]; Others [16.8%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Geda',
                'Damxung',
                'Lhasa',
                'Tibet Damxung Geda Jiatian solar farm',
                'Tibet Jiatian New Energy Investment and Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd. [80%]; Tibet Hengtong Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yangbajing Town',
                'Dangxiong County',
                'Lasa',
                'Tibet Dangxiong Yangbajing solar farm',
                'Longyuan Tibet New Energy Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gyantse',
                'Shigatse',
                'Tibet Gyantse Huarun solar farm',
                'Huarun New Energy Photovoltaic Power Generation (Jiangzi) Co., Ltd.',
                'Huarun Power New Energy Investment Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'JiamaTown',
                'Mozhugongka County',
                'Lhasa',
                'Tibet Jiamaxiang Huatailong solar farm',
                'Tibet Huatailong Minerals Exploration Ltd.',
                'Tibet Jiaertong Mining Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kamba',
                'Shigatse',
                'Tibet Kamba Development and Investment Group solar farm',
                'Gangba Photovoltaic Thermal Power Generation Branch of Tibet Development and Investment Group Co., Ltd.',
                'Tibet Development Investment Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Langkazi Town',
                'Langkazi County',
                'Shannan',
                'Tibet Langkazi Dayou solar farm',
                'Langkazi County Dayou New Energy Development Co., Ltd.',
                'Shannan Dayou New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bangdui Town',
                'Dazi County',
                'Lhasa',
                'Tibet Lhasa Dazi Yungao solar farm',
                'Tibet Yungao New Energy Co., Ltd.',
                'Yungao Century Co., Ltd.[78%]; Tibet Ruiding Venture Capital Management Partnership (Limited Partnership)[5%]; Others[17%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Bangdui Town',
                'Dazi County',
                'Lhasa',
                'Tibet Lhasa Dazi Yungao solar farm',
                'Tibet Yungao New Energy Co., Ltd.',
                'Yungao Century Co., Ltd.[78%]; Tibet Ruiding Venture Capital Management Partnership (Limited Partnership)[5%]; Others[17%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lhatse',
                'Shigatse',
                'Tibet Lhatse Baike solar farm',
                'Lazi Baike New Energy Technology Co., Ltd.',
                'Yingke New Energy Technology Development Co., Ltd. of Lhasa Economic and Technological Development Zone',
              ],
              [
                'China',
                20,
                'Asia',
                'Chawu',
                'Lhatse',
                'Shigatse',
                'Tibet Lhatse Chawu CGN solar farm',
                'Lazi CGN Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lhunze',
                'Shannan',
                'Tibet Lhunze Zhongfuyuan solar farm',
                'Tibet Shannan Longzi Zhongfuyuan New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiangrexia Town',
                'Linzhou County',
                'Lhasa',
                'Tibet Linzhou Zangdian solar farm',
                'Linzhou Zangdian Development Co., Ltd.',
                'Tibet Zhongzi New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mianya Town',
                'Yanyuan County',
                'Liangshan',
                'Sichuan Yanyuan Tangniwan Fengguang solar farm',
                'Yanyuan Fengguang New Energy Co., Ltd.',
                'Sichuan Xichang Electric Power Co., Ltd. [90%]; Yanyuan County Gold Iron Mining Group Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Nedong',
                'Shannan',
                'Tibet Nedong Xiehe solar farm',
                'Naidong Xiehe Solar Power Generation Co., Ltd.',
                'Xiehe Wind Power Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mianya Town',
                'Yanyuan County',
                'Liangshan',
                'Sichuan Yanyuan Tangniwan Fengguang solar farm',
                'Yanyuan Fengguang New Energy Co., Ltd.',
                'Sichuan Xichang Electric Power Co., Ltd. [90%]; Yanyuan County Gold Iron Mining Group Co., Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Weicheng Town',
                'Yanyuan County',
                'Liangshan',
                'Sichuan Yanyuan Hunshuitang Jingyuan solar farm',
                'Sichuan Jingyuan Electric Power Development Co., Ltd.',
                'Powerchina Hydropower Development Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dabaoding',
                'Renhe District',
                'Panzhihua',
                'Sichuan Panzhihua Renhe District Baoding solar farm',
                'Panzhihua Baoding New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [40%]; Panzhihua Coal Industry (Group) Co., Ltd. [35%]; Sichuan Electric Power Design Consulting Co., Ltd. [25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Taiping Town',
                'Renhe District',
                'Panzhihua',
                'Sichuan Panzhihua Renhe District Taipingxiang solar farm',
                'Panzhihua Pude New Energy Development Co., Ltd.',
                'Sichuan Yanyuan Huadian New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Renhe District',
                'Panzhihua',
                'Sichuan Panzhihua Renhe Jieyuan solar farm',
                'Panzhihua Renhe Jieyuan New Energy Co., Ltd.',
                'State Power Investment Corporation Sichuan Electric Power Co., Ltd. [90%]; Beijing Jieyuan New Energy Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Geliping Town',
                'Xi District',
                'Panzhihua',
                'Sichuan Panzhihua West District Zhulinpo solar farm',
                'Panzhihua Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'Tianxin Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hongge Town',
                'Yanbian County',
                'Panzhihua',
                'Sichuan Panzhihua Yanbian Hongge solar farm',
                'Sichuan Nengtou Yanbian New Energy Development Co., Ltd.',
                'Sichuan Energy Investment Wind Power Development Co., Ltd. [95%]; Chengdu Mingyong Investment Co., Ltd. [5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Meixing Town',
                'Xiaojin County',
                'Abazhou',
                'Sichuan Provinc Xiaojin County Meixing solar farm',
                'China Nuclear Xiaojin New Energy Development Co., Ltd.',
                'Sichuan CNNC Southwest New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                "Si'e",
                'Ganzi',
                'Ganzizhou',
                'Sichuan Province Ganzi Huogulongcun solar farm',
                'Sichuan Ganzi Datang International New Energy Co., Ltd.',
                'Tbea Xinjiang Sunoasis Co., Ltd.[50%]; Sichuan Datang International New Energy Co., Ltd. [50%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Gongtanggang',
                'Luhuo Xian',
                'Ganzizhou',
                'Sichuan Province Ganzi Luhuo County Gongtanggang solar farm',
                'China Power Construction Group Luhuo New Energy Development Co., Ltd.',
                'Sinohydro Renewable Energy Co., Ltd.[51%]; Sichuan Electric Power Design & Consulting Co., Ltd.[30%]; Sinohydro Engineering BUREAU 5 Limited Corporation[19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shubao Town',
                'Huili',
                'Liangshan',
                'Sichuan Province Liangshan Shubaoxiang Three Gorges solar farm',
                'Three Gorges New Energy Huili Zhongyi Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shubao Town',
                'Huili',
                'Liangshan',
                'Sichuan Province Liangshan Shubaoxiang Three Gorges solar farm',
                'Three Gorges New Energy Huili Zhongyi Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Tongzilin',
                'Yanbian',
                'Panzhihua',
                'Sichuan Province Panzhihua Yanbian Wanjiashan solar farm',
                'China Power Construction Group Panzhihua New Energy Development Co., Ltd.',
                'Sinohydro Renewable Energy Co., Ltd.[51%]; Powerchina Chengdu Engineering Corporation Limited[30%]; Sinohydro Bureau No.7 Co., Ltd.[19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Mianya Town',
                'Yanyuan',
                'Liangshan',
                'Sichuan Province Yanyuan County Tangniwan solar farm',
                'Yanyuan Fengguang New Energy Co., Ltd.',
                'Sichuan Xichang Electric Power Co., Ltd. [90%]; Yanyuan County Gold Iron Mining Group Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Mianya Town',
                'Yanyuan',
                'Liangshan',
                'Sichuan Province Yanyuan County Tangniwan solar farm',
                'Yanyuan Fengguang New Energy Co., Ltd.',
                'Sichuan Xichang Electric Power Co., Ltd. [90%]; Yanyuan County Gold Iron Mining Group Co., Ltd. [10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Baiwu',
                'Yanyuan',
                'Liangshan',
                'Sichuan Province Yanyuan Sankeshu solar farm',
                'Yanyuan County Baiwu New Energy Technology Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Electric Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baiwu',
                'Yanyuan',
                'Liangshan',
                'Sichuan Province Yanyuan Sankeshu solar farm',
                'Yanyuan County Zhongwei New Energy Technology Co., Ltd.',
                'Sichuan Railway Investment Huanlian Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baiwu',
                'Yanyuan',
                'Liangshan',
                'Sichuan Province Yanyuan Sankeshu solar farm',
                'Yanyuan Huanlian Juneng Power Development Co., Ltd.',
                'Sichuan Railway Investment Huanlian Energy Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Hongge',
                'Yanbian',
                'Panzhihua',
                'Sichuan Yanbian Hongge Xinneng solar farm',
                'Yanbian Xinneng Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Mianya Town',
                'Yanyuan County',
                'Liangshan',
                'Sichuan Yanyuan Mianyaxiang Hetaoyuan CGN solar farm',
                'CGN Yanyuan Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qusum',
                'Shannan',
                'Tibet Qusum Xiexin solar farm',
                'Qusong Xiexin Solar Power Generation Co., Ltd.',
                'Shanxi Zhangze Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Quxu',
                'Lhasa',
                'Tibet Quxu Maochang solar farm',
                'Qushui Maochang Photovoltaic Industry Development Co., Ltd.',
                'Tibet Zhongzi New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Rinbung',
                'Shigatse',
                'Tibet Rinbung Xiexin solar farm',
                'Renbu Xiexin Solar Power Generation Co., Ltd.',
                'Shanghai Dingji Mechanical Engineering Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qilang Town',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping Hairun solar farm',
                'Keping Haixin Photovoltaic Power Generation Co., Ltd.',
                'Hefei Hairun Power Technology Co., Ltd. [50%]; Hareon Solar [Shanghai] Co., Ltd.[50%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Kalpin County',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping Jiasheng Sunshine solar farm',
                'Keping Jiasheng Sunshine Power Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Akesu Keping SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Kalpin County',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Kalpin County',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Akesu Keping SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Akesu Keping SPIC solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qilang Town',
                'Keping County',
                'Aksu Prefecture',
                'Xinjiang Akesu Keping Zhongjiancai solar farm',
                'Keping Zhongjiancai Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Economic and Technical Development Zone',
                'Akesu City',
                'Akesu Prefecture',
                'Xinjiang Akesu Rongchuang Grid-Connected solar farm',
                'Aksu Rongchuang Photoelectric Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Economic and Technical Development Zone',
                'Akesu City',
                'Akesu Prefecture',
                'Xinjiang Akesu Rongchuang Grid-Connected solar farm',
                'Aksu Rongchuang Photoelectric Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xayar County',
                'Shaya County',
                'Akesu Prefecture',
                'Xinjiang Akesu Shaya Jingxin solar farm',
                'Shaya Jingxin Technology Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tuoyibaoledi Town',
                'Shaya County',
                'Akesu Prefecture',
                'Xinjiang Akesu Shaya Jingxin solar farm',
                'Shaya Jingxin Technology Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Economic and Technical Development Zone',
                'Akesu City',
                'Akesu Prefecture',
                'Xinjiang Akesu Shuqimeng Grid-Connected solar farm',
                'Zhejiang Shuqimeng Energy Technology Co., Ltd.',
                'Hangzhou Shu Qimeng Investment Co., Ltd. [67.8%]; Cao Yongming [22%]; Cao Feifei [9.8%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Economic and Technical Development Zone',
                'Akesu City',
                'Akesu Prefecture',
                'Xinjiang Akesu Shuqimeng Grid-Connected solar farm',
                'Zhejiang Shuqimeng Energy Technology Co., Ltd.',
                'Hangzhou Shu Qimeng Investment Co., Ltd. [67.8%]; Cao Yongming [22%]; Cao Feifei [9.8%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Aksu Prefecture',
                'Xinjiang Akesu Shuqimeng solar farm',
                'Akesu Shuqimeng Photovoltaic Power Generation Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Aksu Prefecture',
                'Xinjiang Akesu Shuqimeng solar farm',
                'Akesu Shuqimeng Photovoltaic Power Generation Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wensu County',
                'Wensu County',
                'Akesu Prefecture',
                'Xinjiang Akesu Wensu Riyuehui solar farm',
                'Wensu Riyuehui New Energy Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping Guangdong Hydropower solar farm',
                'Keping Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Keping County',
                'Akesu Prefecture',
                'Xinjiang Akesu Keping Guangdong Hydropower solar farm',
                'Keping Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Aksu Prefecture',
                'Xinjiang Akesu Datang solar farm',
                'Aksu Datang New Energy Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mijike Town',
                'Baicheng Xian',
                'Akesu Prefecture',
                'Xinjiang Akesu Baicheng Zhengtai (Chint) solar farm',
                'Baicheng Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Samzhubze',
                'Shigatse',
                'Tibet Samzhubze Deqin solar farm',
                'Sangzhuzi Deqin New Energy Technology Co., Ltd.',
                'Tibet Deqin New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Samzhubze',
                'Shigatse',
                'Tibet Samzhubze Longyuan solar farm',
                'Longyuan Xigaze New Energy Co., Ltd.',
                'China Longyuan Power Group Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Sangri County',
                'Sangri',
                'Unavailable',
                'Tibet Sangri Shannan Grid-Connected solar farm',
                'CGN Solar Energy (Sangri) Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Xaitongmoin',
                'Shigatse',
                'Tibet Xaitongmoin SPIC solar farm',
                'State Power Investment Group Shigatse Energy Co., Ltd.',
                'State Power Investment Group Tibet Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Economic and Technical Development Zone',
                'Akesu City',
                'Akesu Prefecture',
                'Xinjiang Akesu Rongchuang Grid-Connected solar farm',
                'Aksu Rongchuang Photoelectric Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fuhai Town',
                'Fuhai County',
                'Altay Prefecture',
                'Xijiang Altay Fuhai CLP solar farm',
                'CLP Fuhai Solar Energy Co., Ltd.',
                'SEPCOIII Electric Power Construction Corporation',
              ],
              [
                'China',
                20,
                'Asia',
                'Hotan County',
                'Luopu Xian',
                'Hetian District',
                'Xingjiang Hetian Luopu Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hotan County',
                'Luopu Xian',
                'Hetian District',
                'Xingjiang Hetian Luopu Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Hotan Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Buyue Town',
                'Zhaojue County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Zhaojue Buyuexiang solar farm',
                'Zhaojue Shengzhao New Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd. [75%]; Zhaojue County State-owned Investment Development Co., Ltd. [25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Muoyu County',
                'Hetian District',
                'Xingjiang Hetian Moyu Xinhua Grid-Connected solar farm',
                'Xinjiang Xinhua Shengshu Photovoltaic Power Generation Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pishan County',
                'Pishan Xian',
                'Hetian District',
                'Xingjiang Hetian Pishan Three Gorges Grid-Connected solar farm',
                'Three Gorges New Energy Pishan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pishan County',
                'Pishan County',
                'Hetian District',
                'Xingjiang Hetian Pishan Three Gorges Grid-Connected solar farm',
                'Three Gorges New Energy Pishan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Awati County',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati Guangdong Hydropower solar farm',
                'Awati Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Awati County',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati Guangdong Hydropower solar farm',
                'Awati Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Awati County',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati Guangdong Hydropower solar farm',
                'Awati Guangdong Hydropower Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Awat County',
                'Awati Xian',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati TBEA solar farm',
                'TBEA Awati County New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Awat County',
                'Awati Xian',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati TBEA solar farm',
                'TBEA Awati County New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Awat County',
                'Awati Xian',
                'Akesu Prefecture',
                'Xinjiang Akesu Awati TBEA solar farm',
                'TBEA Awati County New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Unavailable',
                'Muoyu County',
                'Hetian District',
                'Xingjiang Hetian Moyu Xinhua Grid-Connected solar farm',
                'Xinjiang Xinhua Shengshu Photovoltaic Power Generation Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Buyue Town',
                'Zhaojue County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Zhaojue Buyuexiang solar farm',
                'Zhaojue Shengzhao New Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd. [75%]; Zhaojue County State-owned Investment Development Co., Ltd. [25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Mianya Town',
                'Yanyuan County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Yanyuan Mianya solar farm',
                'CGN Yanyuan Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dahe Town',
                'Yanyuan County',
                'Liangshan',
                'Sichuan Liangshan Yanyuan Dahexiang solar farm',
                'Yanyuan Xiehe Photovoltaic Power Generation Co., Ltd.',
                'Yinhua Xiehe New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Xiaobao',
                'Yanggao County',
                'Datong',
                'Shanxi Yanggao Weijiabao Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayu Town',
                'Yangqu County',
                'Taiyuan',
                'Shanxi Yangqu Dayu Longyongtai solar farm',
                'Shanxi Longyongtai Materials Co., Ltd.',
                'Jinneng Holding Shanxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yangqu County',
                'Taiyuan',
                'Shanxi Yangqu Nengtou solar farm',
                'Shanxi Nengtou Photovoltaic Agricultural Development Co., Ltd.',
                'Shanxi Energy Investment International Trading Co., Ltd. [51%]; Shanxi Huinong Technology Co., Ltd. [49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Hedi Town',
                'Jiaoqu',
                'Yangquan',
                'Shanxi Yangquan Hedi CGN solar farm',
                'Yangquan CGN Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yinying Town',
                'Jiaoqu',
                'Yangquan',
                'Shanxi Yangquan Qianmuping Changsheng solar farm',
                'Yangquan Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Anying',
                'Yingxian',
                'Shuozhou',
                'Shanxi Yingxian Anying Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Daliuzhuang',
                'Yingxian',
                'Shuozhou',
                'Shanxi Yingxian Daliuzhuang Jinneng solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xincheng Town',
                'Youyu County',
                'Shuozhou',
                'Shanxi Youyu Huayi Zhongtai solar farm',
                'Youyu Huayi Zhongtai New Energy Co., Ltd.',
                'Datong Huayi Zhongtai New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Niuxinbao Town',
                'Youyu County',
                'Shuozhou',
                'Shanxi Youyu Niuxinbao Tongmei solar farm',
                'Shanxi Tongmei Hexu New Energy Industry Co., Ltd.',
                'Jinneng Holding Coal Industry Group Shuozhou Coal and Electricity Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Niuxinbao Town',
                'Youyu County',
                'Shuozhou',
                'Shanxi Youyu Niuxinbao Tongmei solar farm',
                'Shanxi Tongmei Hexu New Energy Industry Co., Ltd.',
                'Jinneng Holding Coal Industry Group Shuozhou Coal and Electricity Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangqianhe Town',
                'Youyu County',
                'Shuozhou',
                'Shanxi Youyu Yangqianhe Huaguang solar farm',
                'Youyu Huaguang Power Generation Co., Ltd.',
                'State Power Investment Corporation Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Yangqianhe Town',
                'Youyu County',
                'Shuozhou',
                'Shanxi Youyu Yangqianhe solar farm',
                'CGN (Youyu) Wind Power Generation Co., Ltd.',
                'CGN Wind Energy Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Jicheng Town',
                'Yushe County',
                'Jinzhong',
                'Shanxi Yushe Huadian zhongguang solar farm',
                'Shanxi Yushe Huadian Zhongguang Solar Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Haobei Town',
                'Yushe County',
                'Jinzhong',
                'Shanxi Yushe Huaneng solar farm',
                'Huaneng Shanxi Comprehensive Energy Co., Ltd. Yushe Photovoltaic Power Station',
                'Huaneng Shanxi Comprehensive Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Haobei Town',
                'Yushe County',
                'Jinzhong',
                'Shanxi Yushe Huaneng solar farm',
                'Huaneng Shanxi Comprehensive Energy Co., Ltd. Yushe Photovoltaic Power Station',
                'Huaneng Shanxi Comprehensive Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jicheng Town',
                'Yushe County',
                'Jinzhong',
                'Shanxi Yushe Jichengzhen Qiyang solar farm',
                'Jinzhong Qiyang New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Beixiazhuang Town',
                'Yu County',
                'Yangquan',
                'Shanxi Yuxian Liujiapo SPIC solar farm',
                'Yuxian Dongfang New Energy Power Generation Co., Ltd. of State Power Investment Group',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Liujiahe',
                'Yangcheng County',
                'Jincheng',
                'Shanxi Yangcheng Liujiahe Datang solar farm',
                'Yangcheng International Power Generating Company Limited',
                'Datang Shanxi Power Generation Co., Ltd. [39%]; Jiangsu Guoxin Group Co., Ltd. [27%]; Gemeng International Energy Co., Ltd. [21%]; China Energy Construction Group Co., Ltd. [7%]; China Power Construction Group Co., Ltd.[7%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Zhanshang Town',
                'Xiyang County',
                'Jinzhong',
                'Shanxi Xiyang Hufeng Sineng solar farm',
                'Xiyang County Sineng Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables [Group] Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongyetou Town',
                'Xiyang County',
                'Jinzhong',
                "Shanxi Xiyang Dongyetouzhen Zhuo'er solar farm",
                "Xiyang Zhuo'er New Energy Development Co., Ltd.",
                'Shanxi Guoyuan Shengshi Electric Power Design Consulting Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangtu Town',
                'Xi County',
                'Linfen',
                'Shanxi Xixian Huangtuzhen Changsheng Oriental solar farm',
                'Xixian Changsheng Oriental Solar Energy Technology Co., Ltd.',
                'Fanshi Runhong Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jingshang Town',
                'Shouyang County',
                'Jinzhong',
                'Shanxi Shouyang Jingshang solar farm',
                'Shouyang Shiji Huazhong New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Limin Town',
                'Shuocheng District',
                'Shuozhou',
                'Shanxi Shuozhou Liminzhen Datang solar farm',
                'Datang New Energy Shuozhou Wind Power Co., Ltd.',
                'China Datang Group New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shentou Town',
                'Shoucheng District',
                'Shuozhou',
                'Shanxi Shuozhou Shentou solar farm',
                'Shanxi Shentou Electric Power Company Limited',
                'China Power International Development Co., Ltd. [87%]; Tianze Development Co., Ltd. [13%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Taiyuan',
                'Shanxi Taiyuan Taigangyuan solar farm',
                'Taiyuan Zhongneng Jingyang Photovoltaic Technology Co., Ltd.',
                'Shanxi Energy Industry Group Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Guqianpu Town',
                'Tianzhen County',
                'Datong',
                'Shanxi Tianzhen Guqianpu Poverty Alleviation solar farm',
                'Jinneng Clean Energy Photovoltaic Power Generation Co., Ltd.',
                'Jinneng Holding Power Group Clean Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tianzhen County',
                'Datong',
                'Shanxi Tianzhen Huarun solar farm',
                'China Resources New Energy (Datong) Wind Power Co., Ltd.',
                'China Resources New Energy Eleventh Wind Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Lujiawan Town',
                'Tianzhen County',
                'Datong',
                'Shanxi Tianzhen solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'China',
                100,
                'Asia',
                'Lujiawan Town',
                'Tianzhen County',
                'Datong',
                'Shanxi Tianzhen solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Yu County',
                'Yangquan',
                'Shanxi Yuxian Lujiacun TBEA solar farm',
                'Yuxian Huaguang Photovoltaic Power Generation Co., Ltd.',
                'Urumqi Mingyu Guangsheng Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Tianzheng',
                'Datong',
                'Shanxi Tianzheng Datang solar farm',
                'Datang Shanxi Power Generation Co., Ltd.',
                'China Datang Corporation',
              ],
              [
                'China',
                100,
                'Asia',
                'Guojiazhuang Town',
                'Wenxi County',
                'Yuncheng',
                'Shanxi Wenxi SPIC solar farm',
                'State Power Investment Group Shanxi New Energy Co., Ltd.',
                'State Power Investment Group Beijing Electric Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Sancha Town',
                'Wuzhai County',
                'Xinzhou',
                'Shanxi Wuzhai Dongzhai Zhongshun solar farm',
                'Wuzhai Zhongshun New Energy Development Co., Ltd.',
                'Sichuan Zhongshun Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beidi Town',
                'Xiangyuan County',
                'Changzhi',
                'Shanxi Xiangyuan Beidi Longwei solar farm',
                'Xiangyuan Longwei New Energy Co., Ltd.',
                'Nanjing Meiheng Investment Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qicun Town',
                'Xinfu District',
                'Xinzhou',
                'Shanxi Xinfu Baicao Mountain Yaoneng solar farm',
                'Xinzhou Yaoneng Photovoltaic Power Co., Ltd.',
                'Shanxi Guokai Ruiguang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Buziwan Town',
                'Xinrong District',
                'Datong',
                'Shanxi Xinrong District Buziwanxiang Zhongneng Huatai solar farm',
                'Datong Xinrong Zhongneng Huatai Technology Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yuzhuang Town',
                'Ningwu County',
                'Xinzhou',
                'Shanxi Xinzhou Ningwu CGN solar farm',
                'CGN Ningwu Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dietaisi Town',
                'Ningwu County',
                'Xinzhou',
                'Shanxi Xinzhou Ningwu Shuojing solar farm',
                'Ningwu Shuojing Energy Technology Co., Ltd.',
                'Nanjing Shuoxi Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Doucun Town',
                'Wutai County',
                'Xinzhou',
                'Shanxi Xinzhou Wutai Yingli solar farm',
                'Wutai Yingli New Energy Co., Ltd.',
                'Qingdao Yonghui Xinneng Equity Investment Management Enterprise [Limited Partnership]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wujiashan',
                'Tianzheng',
                'Datong',
                'Shanxi Tianzheng Wujiashan Huaneng solar farm',
                'Huaneng Tianzhen Wind Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Uqturpan County',
                'Wushi County',
                'Akesu Prefecture',
                'Xinjiang Akesu Wushi Fengling Grid-Connected solar farm',
                'Wushi Fengling Power Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Shanxi Yuxian Sunjiazhuang GCL solar farm',
                'Yuxian GCL Photovoltaic Power Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd. [30%]',
              ],
              [
                'China',
                120,
                'Asia',
                'Guwei Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Changpo "Front Runner" solar farm',
                'Shanxi Ruicheng Huadian Fuxin Solar Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiongxi Town',
                'Hongyuan County',
                'Aba',
                'Sichuan Hongyuan Qiongxi solar farm',
                'Aba Hongyuan Huanju Ecological Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.[56%]; WORLD FOODS[44%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Haiba',
                'Huidong',
                'Liangshan',
                'Sichuan Huidong Haiba Xinneng solar farm',
                'Huidong Kehua Xinneng Investment Co., Ltd.',
                'Sichuan Machinery & Equipment Import & Export Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Longquan Town',
                'Huili County',
                'Liangshan',
                'Sichuan Huili Longquan Zhaoguang solar farm',
                'Huili Zhaoguang New Energy Co., Ltd.',
                'China Three Gorges Renewables [Group] Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhangguan Town',
                'Huili County',
                'Liangshan',
                'Sichuan Huili Zhangguanzhen Tianjian solar farm',
                'Huili Tianjian New Energy Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baoguping Town',
                'Butuo County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Butuo Baoguping solar farm',
                'Butuo Zhongtian New Energy Development Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hejing Town',
                'Butuo County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Butuo Junsheng solar farm',
                'Butuo Junsheng New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dezhou Town',
                'Dechang County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Dechang Changsheng solar farm',
                'Dechang Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huidong County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Huidong Huiming solar farm',
                'Huidong Derun New Energy Development Co., Ltd.',
                'Chengdu Haorun New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huidong County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Huidong Huiming solar farm',
                'Huidong Derun New Energy Development Co., Ltd.',
                'Chengdu Haorun New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Pulong Town',
                'Huili County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Huili Pulongcun solar farm',
                'Huili Hongji New Energy Technology Co., Ltd.',
                'Tunghsu New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gantiandi Town',
                'Puge County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Puge Gantiandi solar farm',
                'Puge Haide New Energy Co., Ltd.',
                'Wang Dehui[99%]; Wu Xinghai[1%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Gantiandi Town',
                'Puge County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Puge Ziyue solar farm',
                'Puge Ziyue New Energy Power Generation Co., Ltd.',
                'Hefei Bomao New Energy Technology Co., Ltd. [70%]; Puge County Agricultural Investment and Development Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Gantiandi Town',
                'Puge County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Puge Ziyue solar farm',
                'Puge Ziyue New Energy Power Generation Co., Ltd.',
                'Hefei Bomao New Energy Technology Co., Ltd. [70%]; Puge County Agricultural Investment and Development Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Luowugou Town',
                'Puge County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Puhe Jiliuxiu solar farm',
                'Three Gorges New Energy Puge Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Lianghekou Town',
                'Xide County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Xide Poverty Alleviation solar farm',
                'Xide Tongwei Huijin New Energy Co., Ltd.',
                'Tongwei Huijin New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Lianghekou Town',
                'Xide County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Xide Poverty Alleviation solar farm',
                'Xide Tongwei Huijin New Energy Co., Ltd.',
                'Tongwei Huijin New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yanyuan County',
                'Liangshan Yi Autonomous Prefecture',
                'Sichuan Liangshan Yanyuan Baiwu solar farm',
                'Yanyuan Huanlian Juneng Power Development Co., Ltd.',
                'Sichuan Railway Investment Huanlian Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xinlong County',
                'Ganzi',
                'Sichuan Ganzi Xinlong Poverty Alleviation solar farm',
                'Xiangcheng Xinneng Photovoltaic Development Co., Ltd.',
                'State Power Investment Corporation Sichuan Electric Power Co., Ltd. [75%]; Ganzi Tongpu New Energy Development Co., Ltd. [25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhengdou Town',
                'Xiangcheng County',
                'Ganzi',
                'Sichuan Ganzi Xiangcheng Zhengdouxiang solar farm',
                'Ganzi Zhengwu Photovoltaic Development Co., Ltd.',
                'State Power Investment Group Ganzi State New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shiqu County',
                'Ganzi',
                'Sichuan Ganzi Shiqu Poverty Alleviation solar farm',
                'Xiangcheng Xinneng Photovoltaic Development Co., Ltd.',
                'State Power Investment Corporation Sichuan Electric Power Co., Ltd. [75%]; Ganzi Tongpu New Energy Development Co., Ltd. [25%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Seda County',
                'Ganzi',
                'Sichuan Ganzi Seda Poverty Alleviation solar farm',
                'Xiangcheng Xinneng Photovoltaic Development Co., Ltd.',
                'State Power Investment Corporation Sichuan Electric Power Co., Ltd. [75%]; Ganzi Tongpu New Energy Development Co., Ltd. [25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dawang Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Dawangzhen "Front Runner" solar farm',
                'Ruicheng County Jinko Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Monan Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Monanzhen "Front Runner" solar farm',
                'Beijing Fortune Cube Investment Co., Ltd.',
                'Beijing Fortune Cube Investment Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Monan Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Monanzhen Huaneng "Front Runner" solar farm',
                'China Huaneng Group',
                'China Huaneng Group',
              ],
              [
                'China',
                150,
                'Asia',
                'Nanwei Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Nanweixiang "Front Runner" solar farm',
                'Longi Green Energy Technology Co.',
                'Longi Green Energy Technology Co.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xuezhang Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Shenxi "Front Runner" solar farm',
                'Ruicheng Baosheng Electric Power Development Co., Ltd.',
                'Shenzhen Shenran Clean Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dawang Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Xiepo "Front Runner" solar farm',
                'CECEP (Yuncheng) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Ximo Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Ximo " Front Runner" solar farm',
                'Risen Energy Co., Ltd.',
                'Risen Energy Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Xuezhang Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Xingquanzhuang " Front Runner" solar farm',
                'China Power International Development Co., Ltd.',
                'China Power International Development Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Shixia Town',
                'Zuoquan County',
                'Jinzhong',
                'Shanxi Zuoquan Shixia solar farm',
                'Shanxi International Energy Group New Energy Investment Management Co., Ltd.',
                'Gemeng International Energy Co., Ltd. [80%]; Shanxi International Energy Group Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangcheng Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Xiyao "Front Runner" solar farm',
                'TBEA Xinjiang New Energy Co., Ltd.',
                'TBEA [32%]; Xinjiang Uygur Autonomous Region Investment Company [20%]; Beijing Tsinghua University Enterprise Group [20%]; Changji Special Transformer Factory [10%]; Beijing Qingyuan Defeng Investment Management Co., Ltd. [5%]; Others [13%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xuezhang Town',
                'Ruicheng County',
                'Yuncheng',
                'Zhejiang Province Huzhou Nanxun Nancun Agricultural solar proejct',
                'Ruicheng Baosheng Electric Power Development Co., Ltd.',
                'Shenzhen Shenran Clean Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                "Mai'erma Town",
                'Ngawa County',
                'Aba',
                "Sichuan Aba Mai'erma CNNC solar farm",
                'China Nuclear Power Aba New Energy Development Co., Ltd.',
                'Sichuan CNNC Southwest New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ruoergai County',
                'Aba',
                'Sichuan Aba Ruoergai Zhuokun solar farm',
                'Aba Ruoergai Huanju Ecological Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.[56%]; WORLD FOODS[44%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Axi Town',
                'Ruoergai County',
                'Ngawa Tibetan and Qiang Autonomous Prefecture',
                'Sichuan Abazhou Ruoergai Zhuokun solar farm',
                'Aba Ruoergai Huanju Ecological Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd. [56%]; Apple Operations Co., Ltd. [44%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Axi Town',
                'Ruoergai County',
                'Ngawa Tibetan and Qiang Autonomous Prefecture',
                'Sichuan Abazhou Ruoergai Zhuokun solar farm',
                'Aba Ruoergai Huanju Ecological Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd. [56%]; Apple Operations Co., Ltd. [44%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Axi Town',
                'Ruoergai County',
                'Ngawa Tibetan and Qiang Autonomous Prefecture',
                'Sichuan Abazhou Ruoergai Zhuokun solar farm',
                'Aba Ruoergai Huanju Ecological Energy Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd. [56%]; Apple Operations Co., Ltd. [44%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Xiaojin County',
                'Ngawa Tibetan and Qiang Autonomous Prefecture',
                'Sichuan Abazhou Xiaojin County Dabakou solar farm',
                'Xiaojin Dabakou Photovoltaic Power Generation Co., Ltd.',
                'CNNC Xiaojin County New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dege County',
                'Ganzi',
                'Sichuan Ganzi Dege Poverty Alleviation solar farm',
                'Xiangcheng Tongwei Huijin New Energy Co., Ltd.',
                'Wanhuitong Energy Technology Co., Ltd. [75%]; Ganzi State Tongpu New Energy Development Co., Ltd. [25%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xuezhang Town',
                'Ruicheng Xian',
                'Yuncheng',
                'Yuncheng Ruicheng Xuezhangxiang " Front Runner" solar farm',
                'Ruicheng GCL Photovoltaic Power Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou GCL New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                130,
                'Asia',
                'Unavailable',
                'Moyu County',
                'Hetian Prefecture',
                'Xinjiang Hetian Moyu Xinhua solar farm',
                'Xinjiang Xinhua Shengshu Photovoltaic Power Generation Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wushi County',
                'Akesu Prefecture',
                'Xinjiang Akesu Wushi Fengling Grid-Connected solar farm',
                'Wushi Fengling Power Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wushi County',
                'Akesu Prefecture',
                'Xinjiang Akesu Wushi TBEA Grid-Connected solar farm',
                'Wushi Huaguang Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Red Star 2nd Field',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 2 Farm Shangde solar farm',
                'Suntech (Hami) Solar Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                '13th Corps',
                'Hami',
                'Xinjiang Hami Hongxing 2 Farm Xinfengguang solar farm',
                'Hami Xinfengguang Power Generation Co., Ltd.',
                'Xinjiang Xinfeng Hanhong Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                '\u7b2c\u5341\u4e09\u5e08',
                '13th Corps',
                'Hami',
                'Xinjiang Hami Hongxing 2 Farm Xuanli solar farm',
                'Hami Xuanli Photovoltaic Technology Development Co., Ltd.',
                'Hami Tianxingjian New Energy Investment Co., Ltd. [99%]; Beijing Tianxingjian Investment Management Co., Ltd. [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Red Star 2nd Field',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 2 Farm Zhongmin solar farm',
                'Zhongmin (Hami) Energy Co., Ltd.',
                'Fujian Zhongmin Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 4 Farm Changhui solar farm',
                'Hami Changhui Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 4 Farm Huiteng solar farm',
                'Hami Huiteng Photovoltaic Power Co., Ltd.',
                'Changzhou Guangyu New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 4 Farm Huiteng solar farm',
                'Hami Huiteng Photovoltaic Power Co., Ltd.',
                'Changzhou Guangyu New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 4 Farm Tianhong Yangguang solar farm',
                'Hami Tianhong Solar Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Agricultural 13th Division',
                'Hami',
                'Xinjiang Hami Hongxing 4 Farm Tianhong Yangguang solar farm',
                'Hami Tianhong Solar Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hongxing No.2 Farm',
                'Hami',
                'Xinjiang Hami Hongxing No.2 Farm Tianxingjian solar farm',
                'Hami Tianxingjian New Energy Investment Co., Ltd.',
                'CPI Xinjiang New Energy Chemical Group Hami Co., Ltd. [99.7%]; other[0.3%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Huadian 40MW Grid-Connected solar farm',
                'Xinjiang Huadian Kushui Wind Power Co.,Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Huadian Kushui Grid-Connected solar farm',
                'Xinjiang Huadian Kushui Wind Power Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Huaneng Grid-Connected solar farm',
                'Huaneng Hami Wind Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Jiingxia Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy and Chemical Industry Group Hami Co., Ltd.',
                'CPI Xinjiang Energy Chemical Group Co., Ltd. [60%]; ICBC Financial Assets Investment Co., Ltd. [21%]; Bank of Communications Financial Assets Investment Co., Ltd. [19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Jincheng solar farm',
                'Hami Jincheng New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Jingxia CECEP solar farm',
                'CECEP Solar Energy Technology Hami Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Jingxia solar farm',
                'Guohua (Hami) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Hongxing No.2 Farm',
                'Hami',
                'Xinjiang Hami Hongxing 2 Farm Guohua solar farm',
                'Guohua (Hami Hongxing Field 2) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Junxin solar farm',
                'Hami Junxin Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Guohua solar farm',
                'Guohua (Hami) New Energy Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Guodian Grid-Connected solar farm',
                'Guodian Hami Energy Development Co., Ltd.',
                'Guodian Power Xinjiang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qiquanhu',
                'Gaochang',
                'Turpan',
                'Xinjiang Gaochang Qiquanhu Yuze solar farm',
                'Turpan Yuze Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                '13th Division of the Production and Construction Corps',
                'Hami',
                'Xinjiang Hami 13th Division Liushuquan Farm Orui solar farm',
                'Hami Orui Photovoltaic Power Generation Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                '13th Division of the Production and Construction Corps',
                'Hami',
                'Xinjiang Hami 13th Division Liushuquan Farm Yaohui solar farm',
                'Hami Yaohui Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                100,
                'Asia',
                '\u7b2c\u5341\u4e09\u5e08',
                '13th Division of the Production and Construction Corps',
                'Hami',
                'Xinjiang Hami 13th Division Liushuquan Farm Yuanhe solar farm',
                'Hami Yuanhe Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongxing No.4 Farm',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami 13th DivisionHongxing Farm solar farm',
                'Hami Guodian Dongyi Photovoltaic Power Generation Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Hami Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami China Power Construction solar farm',
                'Sinohydro Hami New Energy Development Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami CPI solar farm',
                'China Power Investment Xinjiang Energy and Chemical Industry Group Hami Co., Ltd.',
                'CPI Xinjiang Energy Chemical Group Co., Ltd. [60%]; ICBC Financial Assets Investment Co., Ltd. [21%]; Bank of Communications Financial Assets Investment Co., Ltd. [19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Datang Grid-Connected solar farm',
                'Datang Hami Wind Power Development Co., Ltd.',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Datang Grid-Connected solar farm',
                'Datang Hami Wind Power Development Co., Ltd.',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Datang solar farm',
                'Datang Hami Wind Power Development Co., Ltd.',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Dongfang Minsheng Grid-Connected solar farm',
                'Hami Dongfang Minsheng Solar Energy Development Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Dongfang Minsheng Grid-Connected solar farm',
                'Hami Dongfang Minsheng Solar Energy Development Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Focusic solar farm',
                'Hami Fuguang Solar Energy Co., Ltd.',
                'Hami Tongfeng Environmental Protection Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Fuguang Grid-Connected solar farm',
                'Hami Fuguang Solar Energy Co., Ltd.',
                'Hami Tongfeng Environmental Protection Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Guangyuan solar farm',
                'Hami Light Source Power Generation Co., Ltd.',
                'Huadian Fuxin Xinjiang Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Guodian Power Grid-Connected solar farm',
                'Guodian Power Hami Photovoltaic Power Co., Ltd.',
                'Guodian Power Xinjiang New Energy Development Co., Ltd. [65%]; Hareon Solar Technology Co., Ltd.[35%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Liushuquan Farm',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Liurui 13 Division Liushuquan Farm solar farm',
                'Hami Liurui New Energy Development Co., Ltd.',
                "Xi'an LONGi Clean Energy Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Liushuquan Farm',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Liushuquan Farm Xuanli solar farm',
                'Hami Liushuquan Xuanli Photovoltaic Power Generation Co., Ltd.',
                "Xi'an LONGi Clean Energy Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Liushuquan Farm',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Liuyang 13 Division Liushuquan Farm solar farm',
                'Hami Liuyang Photovoltaic Technology Development Co., Ltd.',
                "Xi'an LONGi Clean Energy Co., Ltd.",
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Hami',
                'Xinjiang Hami Yandun Huadian solar farm',
                'Huadian Fuxin Xinjiang Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Yizhou Qu',
                'Hami',
                'Xinjiang Hami Yandun Xinjiang Energy solar farm',
                'Xinjiang Energy (Group) Hami Clean Energy Co., Ltd.',
                'Xinjiang Energy (Group) Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Yixin solar farm',
                'Hami Yixin New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hongxing No.1 Farm',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Yuancheng Power Investment solar farm',
                'Hami Yuancheng Power Investment Co., Ltd.',
                'Shaanxi Jidian Energy Co., Ltd. [70%]; Song Wei [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Corporation Xinjiang Energy and Chemical Group Hami Co., Ltd.',
                'State Power Investment Corporation Xinjiang Energy Chemical Co., Ltd.[60%]; ICBC Financial Assets Investment Co., Ltd.[21%]; Bank of Communications Financial Assets Investment Co., Ltd.[19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Corporation Xinjiang Energy and Chemical Group Hami Co., Ltd.',
                'State Power Investment Corporation Xinjiang Energy Chemical Co., Ltd.[60%]; ICBC Financial Assets Investment Co., Ltd.[21%]; Bank of Communications Financial Assets Investment Co., Ltd.[19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Zhongdiantou Grid-Connected solar farm',
                'China Power Investment Corporation Xinjiang Energy and Chemical Group Hami Co., Ltd.',
                'State Power Investment Corporation Xinjiang Energy Chemical Co., Ltd.[60%]; ICBC Financial Assets Investment Co., Ltd.[21%]; Bank of Communications Financial Assets Investment Co., Ltd.[19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi Solar Industrial Zone',
                'Yizhou',
                'Hami',
                'Xinjiang Hami Zhongdiantou Jianye solar farm',
                'CPI Xinjiang Energy and Chemical Group Hami Alkali Power Generation Co., Ltd.',
                'State Power Investment Group Xinjiang Energy Chemical Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hoboksar County',
                'Tacheng Prefecture',
                'Xinjiang Hebuxer Haitianda solar farm',
                'Hebuxer Mongolia Autonomous County Haitianda Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiazigai Town',
                'Hoboksar County',
                'Tacheng Prefecture',
                'Xinjiang Hebuxer Meiheng Hefeng solar farm',
                'Hebuxer Mongolia Autonomous County Meiheng Photovoltaic Power Generation Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Dabancheng Wind Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing',
                'Bayingolin',
                'Xinjiang Hejing Double Solar solar farm',
                'Hejingxu Double Solar Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing',
                'Bayingolin',
                'Xinjiang Hejing Zhengxin solar farm',
                'Hejing Zhengxin Photovoltaic Electronics Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                32,
                'Asia',
                'Wushitla Town',
                'Heshuo County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Heshuo Hengxin solar farm',
                'Heshuo Hengxin New Energy Technology Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Hetian',
                'Xinjiang Hetia CPI Special Permit solar farm',
                'CPI Xinjiang Energy and Chemical Group Hetian Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Langru Town',
                'Hetian County',
                'Hetian District',
                'Xinjiang Hetian Bobona Xinhua Grid-Connected solar farm',
                'Xinjiang Xinhua Photovoltaic Power Generation Development Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Cele Xian',
                'Hetian District',
                'Xinjiang Hetian Huadian Cele Grid-Connected solar farm',
                'Xinjiang Huadian Hetian Photovoltaic Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Cele Xian',
                'Hetian District',
                'Xinjiang Hetian Huadian Cele Grid-Connected solar farm',
                'Xinjiang Huadian Hetian Photovoltaic Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Liushuquan Farm',
                'Hami',
                'Xinjiang Hami Xinte Liuquanshu Farm solar farm',
                'Hami Xinte Solar Energy Co., Ltd.',
                'Shenergy New Energy (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Tianrun solar farm',
                'Hami Tianrun Solar Energy Co., Ltd.',
                'Tianrun Muyang New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Hami Tianli Enze solar farm',
                'Hami Tianli Enze Solar Energy Technology Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Hami Co., Ltd. [60%]; Hunan Tianli Enze Solar Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami TBEA Grid-Connected solar farm',
                'TBEA Hami New Energy Co., Ltd.',
                'China Power Investment Corporation Xinjiang Energy and Chemical Group Hami Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Naomaohu Town',
                'Yiwu Xian',
                'Hami',
                'Xinjiang Hami Molten Salt Tower solar farm',
                'China Power Engineering Consulting Group Co., Ltd.',
                'China Energy Construction Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Rongxin Grid-Connected solar farm',
                'Hami Rongxin New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [80%]; Montnets Cloud Technology Group Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Rongxin Grid-Connected solar farm',
                'Hami Rongxin New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [80%]; Montnets Cloud Technology Group Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Rongxin solar farm',
                'Hami Rongxin New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [80%]; Montnets Cloud Technology Group Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Hami',
                'Xinjiang Hami Shankou Guotou solar farm',
                'Hami SDIC Xinguang Power Generation Co., Ltd.',
                'Xinjiang Fresh Air Hanhong Energy Co., Ltd. [85%]; Xinjiang Lixin Energy Co., Ltd. [15%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Hami Shankou Rongxin solar farm',
                'Hami Rongxin New Energy Co., Ltd.',
                'China Power Construction New Energy Group Co., Ltd. [80%]; Montnets Cloud Technology Group Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Shichengzi Atesi solar farm',
                'Hami Atesi New Energy Development Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Hami Shichengzi CECEP solar farm',
                'CECEP Solar Energy Technology Hami Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fuyun County',
                'Altay Prefecture',
                'Xinjiang Fuyun Wuling Qinghe solar farm',
                'Wuling Qinghe Electric Power Co., Ltd.',
                'Wuling Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Shichengzi CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Shichengzi CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Shichengzi CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shichengzi',
                'Hami',
                'Xinjiang Hami Shichengzi Guotou solar farm',
                'Hami Guotou Shichengzi Photovoltaic Power Generation Co., Ltd.',
                'Hami State Investment New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shichengzi',
                'Yizhou',
                'Hami',
                'Xinjiang Hami Sinohydro solar farm',
                'China Hydropower Consulting Group Hami New Energy Development Co., Ltd.',
                'China Hydropower Construction Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Hami',
                'Xinjiang Hami Southeast Datang solar farm',
                'Datang Hami Wind Power Development Co., Ltd',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Southeast Shankou CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Southeast Shankou Huafeng solar farm',
                'Hami Huafeng New Energy Power Generation Co., Ltd.',
                'TBEA Xinjiang New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Southeast Shankou Huaneng solar farm',
                'Huaneng Xinjiang Santanghu Wind Power Generation Co., Ltd. Hami Branch',
                'Huaneng Xinjiang Santanghu Wind Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yizhou District',
                'Hami',
                'Xinjiang Hami Shichengzi CGN solar farm',
                'CGN Solar Hami Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Ziniquanzi',
                'Fukang',
                'Changji',
                'Xinjiang Fukang Ziniquanzi Xinfeng solar farm',
                'Fukang Xinfeng New Energy Co., Ltd.',
                'Xinjiang Xinfeng Hanhong Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fuhai',
                'Altay',
                'Xinjiang Fuhai Hanneng solar farm',
                'Fuhai Hanneng Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Haoyuan Hengxiang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Emin County',
                'Emin County',
                'Tacheng Prefecture',
                'Xinjiang Emin 9th Corps 170th Brigade Haitianda solar farm',
                'Emin Haitianda Optoelectronics Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd. [70%]; Xinjiang Haitianda Investment Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bayingolin',
                'Xinjiang Bayingolin Hanneng solar farm',
                'Korla Hanneng Solar Power Co., Ltd.',
                'Xinjiang Hanyuan Hengtai Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bositenghu Town',
                'Bohu County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bayinguoleng Bohu CSIC Grid-Connected solar farm',
                'Bazhou Haiwei New Energy Co., Ltd.',
                'CSIC Haiwei [Xinjiang] New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing Xian',
                'Bayinguoleng Zhou',
                'Xinjiang Bayinguoleng Hejing 2nd Division 21st Brigade solar farm',
                'Hejing Golden Sun Power Generation Co., Ltd.',
                'Zhejiang Jiahua Energy Chemical Industry Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tiemenguan',
                'Kuerle Shi',
                'Bayinguoleng Zhou',
                'Xinjiang Bayinguoleng Yingli 2nd Division 29th Brigade solar farm',
                'Xinjiang Yingli New Energy Co., Ltd.',
                'Yingli Energy (Beijing) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bagrax County',
                'Bohu County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Bohu Datang Grid-Connected solar farm',
                'Datang Bohu New Energy Co., Ltd.',
                'Datang Xinjiang Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Tianhong Sunshine Grid-Connected solar farm',
                'Hejing Tianhong Sunshine Solar Technology Co., Ltd.',
                'Xinjiang Silk Road Qianyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Xintian Sunshine Grid-Connected solar farm',
                'Hejing Xintian Green Energy Co., Ltd.',
                'Shenzhen Xintian Green Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Xushuang Grid-Connected solar farm',
                'Hejing Xushuang Solar Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Yixin Grid-Connected solar farm',
                'Hejing Yixin New Energy Technology Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Jejing County',
                'Bazhou',
                'Xinjiang Bazhou Hejing Yixinsheng solar farm',
                'Hejing Yixinsheng New Energy Technology Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Zhengxin Grid-Connected solar farm',
                'Hejing Zhengxin Photovoltaic Electronics Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hejing County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Hejing Zhenhe Grid-Connected solar farm',
                'Hejing Zhenhe New Energy Technology Co., Ltd.',
                'China Power Investment Xinjiang Energy Chemical Industry Group Aksu Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Korla',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Korla CECEP Grid-Connected solar farm',
                'CECEP Solar Energy Technology Korla Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Korla',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Korla Hanneng Grid-Connected solar farm',
                'Korla Hanneng Solar Power Co., Ltd.',
                'Xinjiang Hanyuan Hengtai Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Korla',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Korla Xinte Huineng Grid-Connected solar farm',
                'Korla Xinte Huineng Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Luntai County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Luntai CECEP Grid-Connected solar farm',
                'CECEP Solar Technology Luntai Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Bazhou Luntai CECEP Grid-Connected solar farm',
                'CECEP Solar Technology Wheel Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bayingolin',
                'Xinjiang Bayingolin Guangrun solar farm',
                'Yanqi Guangrun New Energy Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd. [70%]; Jiangsu King Sun Power Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Santanghu Town',
                'Balikun County',
                'Hami',
                'Xinjiang Balikun Santanghuxiang Shangfeng solar farm',
                'Balikun Shangfeng New Energy Investment Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Awat',
                'Aksu',
                'Xinjiang Awat Tianhua solar farm',
                'Awati Tianhua New Energy Power Co., Ltd.',
                'Dincen Electric Equipment Sales (Tianjin) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qinghe County',
                'Qinghe County',
                'Altay Prefecture',
                'Xinjiang Altay Qinghe CGN solar farm',
                'CGN Qinghe Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xinhe County',
                'Akesu Prefecture',
                'Xinjiang Akesu Xinhe Hanergy Grid-Connected solar farm',
                'Hanergy Aksu Photovoltaic Power Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Aketao County',
                'Kezhou',
                'Xinjiang Aketao Oytak Changsheng solar farm',
                'Aketao Changsheng New Energy Development Co., Ltd.',
                'Xinjiang Silk Road Zeyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Oytak Town',
                'Aketao County',
                'Kizilsu Kyrgyz Autonomous Prefecture',
                'Xinjiang Aketao Oytak Yixin solar farm',
                'Aketao Yixin New Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Aketao County',
                'Kizilsu Kyrgyz Autonomous Prefecture',
                'Xinjiang Aketao Xinte solar farm',
                'Aketao Xinte Photovoltaic Power Generation Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Aksay',
                'Jiuquan',
                'Xinjiang Aksay Huadian solar farm',
                'Gansu Huadian Fuxin Energy Co., Ltd. Aksai Branch',
                'Gansu Huadian Fuxin Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Aksu',
                'Xinjiang Aksu Datang solar farm',
                'Aksu Datang New Energy Co., Ltd.',
                'Hangzhou Taijing Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yaha Town',
                'Kuqa County',
                'Aksu Prefecture',
                'Xinjiang Aksu Kuqa Tianhua solar farm',
                'Kuqa Tianhua New Energy Power Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Aketuohai Town',
                'Wushi County',
                'Aksu Prefecture',
                'Xinjiang Aksu Wushi Huayang Weiye solar farm',
                'Wushi Huayang Weiye Solar Energy Technology Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ruoqiang County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Ruoqiang Haiwei Grid-Connected solar farm',
                'Ruoqiang Haiwei New Energy Co., Ltd.',
                'CSIC Haiwei (Xinjiang) New Energy Co., Ltd.[55%]; Xinjiang Survey and Destgn Institute of Water Resources and Hydropower Ministry of Water Resources[45%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Aksu',
                'Xinjiang Aksu Zhengtai solar farm',
                'Baicheng Zhengtai Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Aimaiti Nengtuo Pugelake Town',
                'Alar',
                'Akesu Diqu',
                'Xinjiang Alar Jinko Grid-Connected solar farm',
                'Alar Jinko Energy Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Alar',
                'Akesu Diqu',
                'Xinjiang Alar Tianhua Sunshine Grid-Connected solar farm',
                'Alar Tianhua Sunshine New Energy Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Alar',
                'Akesu Diqu',
                'Xinjiang Alar Tianhua Sunshine Grid-Connected solar farm',
                'Alar Tianhua Sunshine New Energy Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fuhai County',
                'Altay Prefecture',
                'Xinjiang Altay Fuhai Efisheng solar farm',
                'Fuhai Efisheng Energy Development Co., Ltd.',
                'China Power Investment Xinjiang Energy Chemical Industry Group Turpan Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fuhai County',
                'Altay Prefecture',
                'Xinjiang Altay Fuhai Hanneng Grid-Connected solar farm',
                'Fuhai Hanneng Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Haoyuan Hengxiang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fuhai County',
                'Fuhai County',
                'Altay Prefecture',
                'Xinjiang Altay Fuhai Hengcan Grid-Connected solar farm',
                'Xinjiang Hengcan Photovoltaic Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                "Qiaku'ertu Town",
                'Fuyun County',
                'Altay Prefecture',
                'Xinjiang Altay Fuyun Guolian Sunshine Grid-Connected solar farm',
                'Fuyun Guolian Sunshine Power Generation Co., Ltd.',
                'Kuangda New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qinghe County',
                'Altay Prefecture',
                'Xinjiang Altay Qinghe CGN solar farm',
                'CGN Qinghe Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Aimaiti Nengtuo Pugelake Town',
                'Alar',
                'Akesu Diqu',
                'Xinjiang Alar Jinko Grid-Connected solar farm',
                'Alar Jinko Energy Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wushi County',
                'Akesu Prefecture',
                'Xinjiang Akesu Wushi TBEA Grid-Connected solar farm',
                'Wushi Huaguang Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Ruoqiang',
                'Ruoqiang Xian',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Ruoqiang Haiwei Grid-Connected solar farm',
                'Ruoqiang Haiwei New Energy Co., Ltd.',
                'CSIC Haiwei [Xinjiang] New Energy Co., Ltd.[55%]; Xinjiang Survey and Destgn Institute of Water Resources and Hydropower Ministry of Water Resources[45%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yanqi County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Yanqi Huaguang Grid-Connected solar farm',
                'Yanqi Huaguang Power Generation Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Alashankou Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Yuli Alashankou Dongbei Grid-Connected solar farm',
                'Alashankou Dongbei Clean Energy Co., Ltd.',
                'Wuhu Abaur Mechanical & Electrical Co.,limited.[80%]; Huangshi Jingbei New Energy Co., Ltd.[20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Bozhou',
                'Xinjiang Bozhou Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Bozhou Co., Ltd.',
                'State Power Investment Group Xinjiang Energy Chemical Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Chabuchaer County',
                'Ili',
                'Xinjiang Chabuchaer Kelu solar farm',
                'Qabchar Xibe Autonomous County Kelu Electronic Technology Co., Ltd.',
                'China Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingyanghu Town',
                'Jimsar County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Jimusaer Hanneng Grid-Connected solar farm',
                'Jimusaer Hanneng Solar Power Generation Co., Ltd.',
                'Xinjiang Haoyuan Hengxiang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jimsar County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Jimusaer Xinfeng Grid-Connected solar farm',
                'Jimusaer Xinfeng New Energy Co., Ltd.',
                'Xinjiang Lixin Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Mulei Huadian Fuxin Grid-Connected solar farm',
                'Huadian Fuxin Xinjiang Mulei Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Mulei County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Mulei Huarui solar farm',
                'Xinjiang Huarui New Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhaobishan Town',
                'Mulei County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Mulei Tebian Grid-Connected solar farm',
                'Mulei Xinte Photovoltaic Energy Co., Ltd.',
                'Huadian Fuxin Energy Corp. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mori Kazakh Autonomous County',
                'Mulei County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Mulei Tebian Grid-Connected solar farm',
                'Mulei County Huaguang Power Generation Co., Ltd.',
                'Shenergy New Energy (Qinghai) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mori Kazakh Autonomous County',
                'Mulei County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Mulei Xinte Grid-Connected solar farm',
                'Mulei Xinte Photovoltaic Energy Co., Ltd.',
                'Huadian Fuxin Energy Corp. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qitai County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Qitai Juyang Grid-Connected solar farm',
                'Xinjiang Juyang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qitai County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Qitai Juyang Grid-Connected solar farm',
                'Xinjiang Juyang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qitai County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Qitai Juyang solar farm',
                'Xinjiang Juyang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qitai County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Qitai Juyang solar farm',
                'Xinjiang Juyang Energy Technology Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qitai County',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Changji Qitai TBEA solar farm',
                'Qitai Xinte Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Emin County',
                'Emin County',
                'Tacheng Prefecture',
                'Xinjiang Emin 9th Corps 170th Brigade Fengyang solar farm',
                'Emin County Fengyang Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd. [75%]; Xinjiang Haitianda Investment Co., Ltd. [25%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Emin County',
                'Emin County',
                'Tacheng Prefecture',
                'Xinjiang Emin 9th Corps 170th Brigade Haitianda solar farm',
                'Emin Haitianda Optoelectronics Co., Ltd.',
                'State Power Investment Group Inner Mongolia New Energy Co., Ltd. [70%]; Xinjiang Haitianda Investment Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Wenquan County',
                'Wenquan County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Wenquan Guosheng Grid-Connected solar farm',
                'Wenquan Guosheng Yangguang Power Generation Co., Ltd.',
                'Kuangda New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinghe County',
                'Bozhou',
                'Xinjiang Bozhou Jinghe Fenghua solar farm',
                'Jinghe Fenghua New Energy Development Co., Ltd.',
                'Fenghua Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jinghe County',
                'Jinghe County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Jinghe Fenghua Grid-Connected solar farm',
                'Jinghe Zumudun Solar Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mangding Town',
                'Jinghe County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Jinghe Aikang Grid-Connected solar farm',
                'Xinjiang Aikang Power Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yanqi County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Yanqi Huaneng Grid-Connected solar farm',
                'Yanqi Huaneng Photovoltaic Power Co., Ltd.',
                'Huaneng Xinjiang Energy Develop Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yanqi County',
                'Bayingolin Mongol Autonomous Prefecture',
                "Xinjiang Bazhou Yanqi Xin'ao Grid-Connected solar farm",
                "Yanqi Xin'ao Solar Energy Co., Ltd.",
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuli County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Yuli Haiwei Grid-Connected solar farm',
                'Yuli Haiwei New Energy Co., Ltd.',
                'CSIC Haiwei (Xinjiang) New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Beitashan Pasture',
                'Changji Hui Autonomous Prefecture',
                'Xinjiang Beitashan Ranch Three Gorges solar farm',
                'Three Gorges New Energy Wujiaqu Power Generation Co., Ltd. Qitai Branch',
                'Three Gorges New Energy Wujiaqu Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bark\u00f6l Kazakh Autonomous County',
                'Unavailable',
                'Xinjiang Beitun Haitianda solar farm',
                'Beitun Haitianda Photovoltaic Power Generation Co., Ltd. 184th Group Branch',
                'Beitun Haitianda Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bohu County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bohu Jingjia Grid-Connected solar farm',
                'Bohu Jingjia Sunshine Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bohu County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bohu Zhaowa solar farm',
                'Bohu Megawatt Energy Technology Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Hami Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Bole',
                'Bozhou',
                'Xinjiang Bozhou 5 Division 83 Regiment Zhongdiantou solar farm',
                'China Power Investment Xinjiang Energy Chemical Industry Group Bozhou Co., Ltd.',
                'State Power Investment Group Xinjiang Energy Chemical Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qigexing Town',
                'Yanqi County',
                'Bayingolin Mongol Autonomous Prefecture',
                'Xinjiang Bazhou Yanqi Huadian Grid-Connected solar farm',
                'Xinjiang Huadian Yanqi Solar Power Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Bole City',
                'Bozhou',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Xinjiang Jiuzhou Fangyuan New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mangding Town',
                'Jinghe County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Jinghe Aikang Grid-Connected solar farm',
                'Xinjiang Aikang Power Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mangding Town',
                'Jinghe County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Jinghe Aikang Grid-Connected solar farm',
                'Xinjiang Aikang Power Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Mangding Town',
                'Jinghe County',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Jinghe Aikang Grid-Connected solar farm',
                'Xinjiang Aikang Power Development Co., Ltd.',
                'Zhejiang Ruixu Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingdeli Town',
                'Bole City',
                'Bortala Mongol Autonomous Prefecture',
                'Xinjiang Bozhou Bole Jiuzhou Fangyuan Grid-Connected solar farm',
                'Jiuzhou Fangyuan Bole New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [70%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Minning Town',
                'Yongning County',
                'Yinchuan',
                'Ningxia Yongning Minningzhen Shengjing Agriculture solar farm',
                'Ningxia Shengjing Solar Energy Technology Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd. [90%]; Qingdao Changsheng Ridian Solar Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                '\u7b2c\u5341\u4e09\u5e08',
                '13th Division of the Production and Construction Corps',
                'Hami',
                'Xinjiang Hami 13th Division Liushuquan Farm Yaohui solar farm',
                'Hami Yaohui Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership)[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Ningdong Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Yinchuan Ningdong Shanghai Aerospace Machinery solar farm',
                'Ningxia Ningdong Shenzhou Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Xiaosigou Town',
                'Pingquan County',
                'Chengde',
                'Hebei Pingquan Xiaosigou solar farm',
                'Pingquan County Advanced Photovoltaic Power Generation Co., Ltd.',
                'Wen Xiuyan[40%]; Liao Qingshan[40%]; Liao Xiangbao[20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Yangshuling',
                'Pingquan',
                'Chengde',
                'Hebei Pingquan Yangshuling Three Gorges solar farm',
                'China Three Gorges New Energy (Group) Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Gangnan',
                'Pingshan',
                'Shijiazhuang',
                'Hebei Pingshan Gangnan Hongrun solar farm',
                'Pingshan Hongrun Solar Power Generation Co., Ltd.',
                'Jme Engineering Co., Ltd. [80%]; Dongying Yuhaolong Energy Saving Equipment Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Donghuishe Town',
                'Pingshan County',
                'Shijiazhuang',
                'Hebei Pingshan Shineneg solar farm',
                'Shineng Pingshan Photovoltaic Power Development Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sujiazhuang Town',
                'Pingshan County',
                'Shijiazhuang',
                'Hebei Pingshan Sujiazhuang CGN solar farm',
                'CGN Pingshan Solar Power Generation Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'China - Czech Industrial Estate',
                'Bohai New Area',
                'Cangzhou',
                'Hebei Province Cangzhou Bohai SPIC solar farm',
                'China Power Investment Corporation Cangzhou Bohai New Area New Energy Power Co., Ltd.',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                145,
                'Asia',
                'Suji Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Cangzhou Haixing "Front Runner" Area 1 solar farm',
                'Beikong Clean Energy (Haixing) Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jingoutun',
                'Luanping Xian',
                'Chengde',
                'Hebei Province Chengde Luanping Agricultural solar farm',
                'Chengde Fengcheng Photovoltaic Power Generation Co., Ltd.',
                'Beijing Zhenfa New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sangou Town',
                'Chengde Xian',
                'Chengde',
                'Hebei Province Chengde SPIC New Energy solar farm',
                'State Power Investment Group Chengde New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [54%]; CCB Financial Assets Investment Co., Ltd. [46%]',
              ],
              [
                'China',
                80,
                'Asia',
                'Sangou Town',
                'Chengde Xian',
                'Chengde',
                'Hebei Province Chengde SPIC New Energy solar farm',
                'State Power Investment Group Chengde New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [54%]; CCB Financial Assets Investment Co., Ltd. [46%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongzhangmeng Town',
                'Guangping Xian',
                'Handan',
                'Hebei Province Guangping Yingli Grid-Connected solar farm',
                'Hanneng Guangping County Photovoltaic Power Development Co., Ltd.',
                'Yunnan Rongyao New Energy Co., Ltd. [70%]; Suzhou Xiexin New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Gaoshenbao Town',
                'Guyuan Xian',
                'Zhangjiakou',
                'Hebei Province Guyuan Gaoshanbu solar farm',
                'Guyuan Guanghui New Energy Power Generation Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huanggainao Town',
                'Guyuan Xian',
                'Zhangjiakou',
                'Hebei Province Guyuan Huanggainao Dagouying solar farm',
                'Three Gorges New Energy Guyuan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                145,
                'Asia',
                'Suji Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing "Front Runner" solar farm',
                'Beikong Clean Energy (Haixing) Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                115,
                'Asia',
                'Zhaomaotao Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing "Front Runner" solar farm',
                'Unknown',
                'State Power Investment Group Co. Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Xiaoshan Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing "Front Runner" solar farm',
                'Unknown',
                'State Power Investment Group Co. Ltd.',
              ],
              [
                'China',
                110,
                'Asia',
                'Xiaoshan Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing "Front Runner" solar farm',
                'Unknown',
                'Jinko Power Technology Co., Ltd.[51%]; Beijing Jingneng Clean Energy Co., Limited[49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangtuliangzi',
                'Pingquan',
                'Chengde',
                'Hebei Pingquan Huangtuliangzi Huiyong solar farm',
                'Pingquan Huiyong New Energy Co., Ltd.',
                'Bg Green Industry(qing Hai)new Energy Co.,Ltd. [87.5]; Cui Zhenhu [12.5]',
              ],
              [
                'China',
                50,
                'Asia',
                'Gaowan Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing Poverty Alleviation solar farm',
                'Shandong Guoxin Eco Energy Group Co., Ltd',
                'Liu Fudong[29.85%]; Ningbo Hengshun Enterprise Management Consulting Co., Ltd. [16.14%]; Nanjing Kisen International Engineering Co., Ltd.[15%]; Li Ping[12.54%]; China Water Investment Co., Ltd.[10%]; Others[16.47%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Beiwushijiazi',
                'Pingquan',
                'Chengde',
                'Hebei Pingquan Beiwushijiazi SPIC solar farm',
                'State Power Investment Group Pingquan New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Minghua Town',
                'Nangong County',
                'Xingtai',
                'Hebei Nangong Jieyuan Vegetable Greenhouse solar farm',
                'Hebei Jieyuan Vegetable Planting Co., Ltd.',
                'Huaneng Hebei Clean Energy Co., Ltd.',
              ],
              [
                'China',
                21,
                'Asia',
                'Guanyinzhai Town',
                'Julu County',
                'Xingtai',
                'Hebei Julu Guanyinzhai solar farm',
                'Julu Minghui Solar Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Kangbao County',
                'Zhangjiakou',
                'Hebei Kangbao Naobaotu solar farm',
                'Hebei Huadian Kangbao Wind Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Weizigou Town',
                'Kuancheng County',
                'Chengde',
                'Hebei Kuancheng Weizigou solar farm',
                'Kuancheng Efisheng Solar Power Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shuipu Town',
                'Laiyuan County',
                'Baoding',
                'Hebei Laiyuan Qijiayu SPIC solar farm',
                'State Power Investment Group Laiyuan Dongfang New Energy Power Generation Co., Ltd.',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shidaogou',
                'Laiyuan',
                'Baoding',
                'Hebei Laiyuan Shidaogou Three Gorges solar farm',
                'China Three Gorges New Energy (Group) Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yanmeidong Town',
                'Laiyuan County',
                'Baoding',
                'Hebei Laiyuan Yanmeidong Lijiazhuang solar farm',
                'Laiyuan Qianyu New Energy Technology Co., Ltd.',
                'Beijing Jurui Energy Technology Co., Ltd. [80%]; Sun Yanwei[20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Laiyuan',
                'Baoding',
                'Hebei Laiyuan Yingli solar farm',
                'Laiyuan Yingli Photovoltaic Power Development Co., Ltd.',
                'Jinkai Qiyu (Beijing) Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jinjiajing Town',
                'Laiyuan County',
                'Baoding',
                'Hebei Laiyuan Yingli solar farm',
                'Laiyuan Yingli Photovoltaic Power Development Co., Ltd.',
                'Jinkai Qiyu (Beijing) Technology Co., Ltd.',
              ],
              [
                'China',
                28,
                'Asia',
                'Heicheng Town',
                'Lincheng County',
                'Xingtai',
                'Hebei Lincheng Liujiadong GCL solar farm',
                'Lincheng GCL Photovoltaic Power Generation Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                42,
                'Asia',
                'Xishu Town',
                'Lincheng',
                'Xingtai',
                'Hebei Lincheng Xiayu JA solar farm',
                'Lincheng Jingneng New Energy Development Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                42,
                'Asia',
                'Unavailable',
                'Lincheng County',
                'Xingtai',
                'Hebei Lincheng Xiayu Jingneng solar farm',
                'Lincheng Jingneng New Energy Development Co., Ltd.',
                "Jing'ao Solar Energy Investment [China] Co., Ltd.",
              ],
              [
                'China',
                30,
                'Asia',
                'Chatou Town',
                'Lingshou County',
                'Shijiazhuang',
                'Hebei Lingshou Changsheng Ridian solar farm',
                'Lingshou Changsheng Solar Energy Technology Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bugugou Town',
                'Longhua County',
                'Chengde',
                'Hebei Longhua Bugugou solar farm',
                'Zhongneng Hexin Longhua Solar Power Co., Ltd.',
                'Beijing Zhongneng Hexin Optoelectronic Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Zhangbaiwan Town',
                'Luanping',
                'Chengde',
                'Hebei Luanping Huitong solar farm',
                'Luanping Huitong Photovoltaic Power Generation Co., Ltd.',
                'Beijing Ruizhong Jiacheng Trade Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaoying Town',
                'Luanping',
                'Chengde',
                'Hebei Luanping Jietong solar farm',
                'Luanping Jietong Photovoltaic Power Generation Co., Ltd.',
                'Beijing Ruizhong Jiacheng Trade Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Pingfang Town',
                'Luanping County',
                'Chengde',
                'Hebei Luanping Pingfangxiang Jingrun solar farm',
                'Luanping Jingrun Energy Technology Co., Ltd.',
                'Beijing Zhongke Xinrun Energy Technology Co., Ltd. [90%]; Luanping Ruifeng Agricultural Technology Development Co., Ltd.[10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shimen Town',
                'Lulong County',
                'Qinhuangdao',
                'Hebei Lulong Liuyin solar farm',
                'Lulong Liuyin Photovoltaic Power Co., Ltd.',
                'Xintian Hebei Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liulin Town',
                'Neiqiu County',
                'Xingtai',
                'Hebei Neiqiu Liulin Xingqiao solar farm',
                'Xingtai Xingqiao Energy Technology Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaoshan Town',
                'Haixing Xian',
                'Cangzhou',
                'Hebei Province Haixing Xiaoshan solar farm',
                'Haixing County Xiaoshan Photovoltaic Power Co., Ltd.',
                'Shandong Dade Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Laiyuan Town',
                'Laiyuan',
                'Baoding',
                'Hebei Province Laiyuan Qucun solar farm',
                'Laiyuan Kerui New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xili Town',
                'Lincheng Xian',
                'Xingtai',
                'Hebei Province Lincheng Lijiacun solar farm',
                'Lincheng JA Photovoltaic Power Co., Ltd.',
                "China Nuclear Huihai Wind Power Investment Co., Ltd.[80%]; Jing'ao Solar Energy Investment [China] Co., Ltd.[20%]",
              ],
              [
                'China',
                49,
                'Asia',
                'JuluTown',
                'Julu Xian',
                'Xingtai',
                'Hebei Province Xintai Julu Eco-agriculture solar farm',
                'Julu County Yangpu New Energy Technology Co., Ltd.',
                'Zhongyuan Xinhua Water Conservancy and Hydropower Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shenjing Town',
                'Xuanhua Qu',
                'Zhangjiakou',
                'Hebei Province Xuanhua Zhongdiantou solar farm',
                'China Power Investment Xuanhua New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [60.82%]; State Power Investment Group Hebei Electric Power Co., Ltd.[39.18%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Shenjing Town',
                'Xuanhua Qu',
                'Zhangjiakou',
                'Hebei Province Xuanhua Zhongdiantou solar farm',
                'China Power Investment Xuanhua New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [60.82%]; State Power Investment Group Hebei Electric Power Co., Ltd.[39.18%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Gaoqiang Town',
                'Yangyuan Xian',
                'Zhangjiakou',
                'Hebei Province Yangyuan Daheigou Dongrun solar farm',
                'Yangyuan Dongrun New Energy Development Co., Ltd.',
                'Huayuan Electric Power Co.',
              ],
              [
                'China',
                100,
                'Asia',
                'Dongcheng Town',
                'Yangyuan Xian',
                'Zhangjiakou',
                'Hebei Province Yangyuan Qianjiaying Dongrun solar farm',
                'Yangyuan Dongrun New Energy Development Co., Ltd.',
                'Huayuan Electric Power Co.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yaojiazhuang Town',
                'Yangyuan Xian',
                'Zhangjiakou',
                'Hebei Province Yangyuan Yaojiazhuang Zhongjiu solar farm',
                'Yangyuan Zhongjiu Energy Development Technology Co., Ltd.',
                'Changzhou Xinguang New Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Yudaokou State Pasture Farm',
                'Weichangxian',
                'Chengde',
                'Hebei Province Yudaokou Herding Farm "Unsubsidized " solar farm',
                'Chengde Weikou Photovoltaic Power Generation Co., Ltd.',
                'Shijiazhuang Weikou New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yutian',
                'Tangshan',
                'Hebei Province Yutian Haitai solar farm',
                'Tangshan Haitai New Energy Technology CO.,Ltd.',
                'Tangshan Haitai New Energy Technology CO.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hailiutu Town',
                'Zhangbei Xian',
                'Zhangjiakou',
                'Hebei Province Zhangbei Hailiutu solar farm',
                'hangbei Tianhong Solar Power Technology Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd.[70%]; Tianhong Sunshine New Energy Co., Ltd.[30%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Dahe Town',
                'Zhangbei Xian',
                'Zhangjiakou',
                'Hebei Province Zhangjiakou Dahezhen solar farm',
                'State Grid Jibei Zhangjiakou Wind Energy Storage and Transportation New Energy Co., Ltd.',
                'State Grid Jibei Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gonghui Town',
                'Zhangbei Xian',
                'Zhangjiakou',
                'Hebei Province Zhangjiakou Zhangbei Caojiaying solar station',
                'Hebei Sulong Photovoltaic Power Co., Ltd.',
                'Jiangsu Changshun Xinhe New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qicun Town',
                'Quyang Xian',
                'Baoding',
                'Hebei Provincw Baoding Quyang Three Gorges solar farm',
                'Three Gorges New Energy Quyang Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Taipingzhuang Town',
                "Qian'an",
                'Tangshan',
                "Hebei Qian'an Taipingzhuang Chongjiayu Ruiguang solar farm",
                "Qian'an Ruiguang Energy Technology Co., Ltd.",
                'Shanghai Jiuzhen Investment Partnership [limited Partnership][90%]; Xia Qian[10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xingcheng Town',
                'Qianxi County',
                'Tangshan',
                'Hebei Qianxi Xingcheng Zhonghe solar farm',
                'Qianxi Zhonghe Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Huihai Wind Power Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Lianzhuang Town',
                'Qinghe County',
                'Xingtai',
                'Hebei Qinghe Lianzhuangzhen CGN solar farm',
                'CGN Qinghe Photovoltaic Power Generation Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gehetou Town',
                'Qinglong Manchu Autonomous County',
                'Qinghuangdao',
                'Hebei Qinghuangdao Gehetou solar farm',
                'Qinhuangdao Gehetou Solar Energy Co., Ltd.',
                'Hou Feng[55%]; Chen Zhu[45%]',
              ],
              [
                'China',
                35,
                'Asia',
                'Daohugou Town',
                'Pingquan County',
                'Chengde',
                'Hebei Qingquan Qingda Daohugou solar farm',
                'Pingquan Ruida Photovoltaic Power Generation Co., Ltd.',
                'Pingquan Qingda Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yantuan Town',
                'Julu Xian',
                'Xingtai',
                'Hebei Province Xintai Julu Eco-agriculture solar farm',
                'Julu County Yangpu New Energy Technology Co., Ltd.',
                'Zhongyuan Xinhua Water Conservancy and Hydropower Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Koutou Town',
                'Xingtang Xian',
                'Shijiazhuang',
                'Hebei Province Xingtang County Guowei solar farm',
                'Hebei Guowei New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Taizijing Town',
                'Xingtai Xian',
                'Xingtai City',
                'Hebei Province Xingtai Taizijingxiang solar farm',
                'Xingtai County Yonglian Photovoltaic Power Development Co., Ltd.',
                'Shenneng Nanjing Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangsi Town',
                'Unavailable',
                'Xingtai City',
                'Hebei Province Xingtai Huangsi SPIC solar farm',
                'State Power Investment Corporation Xingtai New Energy Power Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd. [60.82%]; State Power Investment Group Hebei Electric Power Co., Ltd.[39.18%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Linxi',
                'Xingtai',
                'Hebei Province Linxi Langyuan solar farm',
                'Linxi County Langyuan Solar Power Technology Co., Ltd.',
                'Jiangsu Langhe Nongguang Juhe Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Nansai Town',
                'Neiqiu Xian',
                'Xingtai',
                'Hebei Province Neiqiu Nansaixiang Jishangsai solar farm',
                'Hebei Zhongsai Photovoltaic Power Generation Co., Ltd.',
                'Dalian Taishan Thermal Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qicun Town',
                'Quyang Xian',
                'Baoding',
                'Hebei Province Quyang Qicunxiang Three Gorges solar farm',
                'Three Gorges New Energy Quyang Electricity Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qicun Town',
                'Quyang',
                'Baoding',
                'Hebei Province Quyang Qicunxiang Three Gorges solar farm',
                'Three Gorges New Energy Quyang Electricity Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qicun Town',
                'Quyang Xian',
                'Baoding',
                'Hebei Province Quyang Qicunxiang Three Gorges solar farm',
                'Three Gorges New Energy Quyang Electricity Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qicun Town',
                'Quyang Xian',
                'Baoding',
                'Hebei Province Quyang Qicunxiang Three Gorges solar farm',
                'Three Gorges New Energy Quyang Electricity Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xiaomu Town',
                'Quyang',
                'Baoding',
                'Hebei Province Quyang Xiaomu Zhongdiantou solar farm',
                'State Power Investment Corporation Quyang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd. [55.86%]; Bank of Communications Financial Assets Investment Co., Ltd.[44.14%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiaomu Town',
                'Quyang',
                'Baoding',
                'Hebei Province Quyang Xiaomu Zhongdiantou solar farm',
                'State Power Investment Corporation Quyang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd. [55.86%]; Bank of Communications Financial Assets Investment Co., Ltd.[44.14%]',
              ],
              [
                'China',
                49,
                'Asia',
                'Daliuzhuang Town',
                'Julu County',
                'Xingtai',
                'Hebei Julu Daliuzhuang Yangpu solar farm',
                'Julu Yangpu New Energy Technology Co., Ltd.',
                'Zhongyuan Xinhua Water Resources and Hydropower Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dayingpan Town',
                'Shangyi Xian',
                'Zhangjiakou',
                'Hebei Province Shangyi Dayingpan Ergongdi solar farm',
                'Shangyi Yuanchen New Energy Development Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shijing Town',
                'Shangyi Xian',
                'Zhangjiakou',
                'Hebei Province Shangyi Shunfeng solar farm',
                'Shunfeng Photovoltaic Investment(China) Co., Ltd.',
                'Shunfeng Photovoltaic Holdings Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shangyi Xian',
                'Zhangjiakou',
                'Hebei Province Shangyi Taike solar farm',
                'Shangyi Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhoujiazhuangcun',
                'Gaocheng Qu',
                'Shijiazhuang',
                'Hebei Province Shijiazhuang Haosheng Grid-Connected solar farm',
                'Shijiazhuang Haosheng Solar Energy Technology Co., Ltd.',
                'Qingdao Hongsheng Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiaojue Town',
                'Pingshan Xian',
                'Shijiazhuang',
                'Hebei Province Shijiazhuang Xiaojue Shijing solar farm',
                'Pingshan Shijing New Energy Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangzhuangke Town',
                'Weixian',
                'Zhangjiakou',
                'Hebei Province Weixian Yangzhuangke Beikong solar farm',
                'Yuxian Beikong New Energy Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangsi Town',
                'Xingtai County',
                'Xingtai City',
                'Hebei Province Xingtai Huangsi solar farm',
                'State Power Investment Corporation Hebei Electric Power Co., Ltd.',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangsi Town',
                'Xingtai County',
                'Xingtai City',
                'Hebei Province Xingtai Huangsi solar farm',
                'State Power Investment Corporation Hebei Electric Power Co., Ltd.',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangsi Town',
                'Unavailable',
                'Xingtai City',
                'Hebei Province Xingtai Huangsi SPIC solar farm',
                'State Power Investment Corporation Xingtai New Energy Power Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd. [60.82%]; State Power Investment Group Hebei Electric Power Co., Ltd.[39.18%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dayingpan Town',
                'Shangyi Xian',
                'Zhangjiakou',
                'Hebei Province Shangyi Ergongdi solar farm',
                'Shangyi Yuanchen New Energy Development Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Weizhou Town',
                'Jingxing County',
                'Shijiazhuang',
                'Hebei Jingxing Weizhou solar farm',
                'Jingxing Yiyang Photovoltaic Technology Co., Ltd.',
                'Shijiazhuang Longneng Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Jingxing',
                'Shijiazhuang',
                'Hebei Jingxing Taike solar farm',
                'Jingxing Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Hangrong New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Huanghua',
                'Cangzhou',
                'Hebei Huanghua SPIC solar farm',
                'Zhongdiantou Cangzhou Bohai New Area New Energy Generate Electricity Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhilong State Farm',
                'Yangxi Xian',
                'Yangjiang',
                'Guangdong Province Yangxi County Zhilong State Farm solar farm',
                'Guangdong Yudean Yangxi New Energy Co., Ltd.',
                'Guangdong Electric Power Development Company',
              ],
              [
                'China',
                100,
                'Asia',
                'Dongshan Jiedao',
                'Mazhang Qu Donghaidao',
                'Zhanjiang',
                'Guangdong Province Zhanjiang Dingrui Fishing and Light Complementary solar farm',
                'Zhanjiang Dingrui Solar Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                60,
                'Asia',
                'Leigao Town',
                'Leizhou Shi',
                'Zhanjiang',
                'Guangdong Province Zhanjiang Leizhou Fishing and Light Complementary solar farm',
                'Leizhou Jingke Power Co., Ltd.',
                'Jinko Power Co., Ltd.[95%]; Haining Shengbu Solar Power Co., Ltd.[5%]',
              ],
              [
                'China',
                120,
                'Asia',
                'Longtou Town',
                'Potou Qu',
                'Zhanjiang',
                'Guangdong Province Zhanjiang Potou Fishing and Light Complementary solar farm',
                'Guangzhou Development New Energy Co., Ltd.',
                'Guangzhou Development Group Incorporated[90%]; Guangzhou Development Assets Management Co., Ltd.[10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Guantian Reservoir',
                'Suixi',
                'Zhanjiang',
                'Guangdong Province Zhanjiang Suixi solar farm',
                'Suixi Yuehe Hydropower Energy Co., Ltd.',
                'Southeast Guangdong Hydropower Investment Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Dongtang Town',
                'Renhua Xian',
                'Shaoguan',
                'Guangdong Renhua Dongtangzhen solar farm',
                'Renhua County Jinze New Energy Power Generation Co., Ltd.',
                'Wangqing Jidian Energy Co., Ltd.',
              ],
              [
                'China',
                400,
                'Asia',
                'Nnazhongwei',
                'Chaonan District',
                'Shantou',
                'Guangdong Shantou Chaonan District Hengpeng solar farm',
                'Shantou Hengpeng New Energy Co., Ltd.',
                'Guangzhou Hengyun Enterprise Group Co., Ltd. [75%]; Shantou Xinpeng Investment Co., Ltd. [25%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Yanggan Town',
                'Suixi',
                'Zhanjiang',
                'Guangdong Suixi Yangganzhen solar farm',
                'Zhanjiang Quanrun New Energy Co., Ltd.',
                'Guangdong Shengtian New Energy Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Haiyan Town',
                'Taishan',
                'Jiangmen',
                'Guangdong Taishan Haiyan Huaqiao Farm solar farm',
                'Guangdong Jiangmen Hengguang Phase II New Energy Co., Ltd.',
                'Guangzhou Hengyun Enterprise Group Co., Ltd. [55%]; China Energy Construction Group Guangdong Electric Power Design and Research Institute Co., Ltd. [35%]; Guangdong Yide New Energy Development Co., Ltd. [10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Shenjing Town',
                'Taishan',
                'Jiangmen',
                'Guangdong Taishan Shenjing CGN solar farm',
                'CGN Taishan Wind Power Co., Ltd.',
                'CGN Wind Power Company Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Shenjing Town',
                'Taishan',
                'Jiangmen',
                'Guangdong Taishan Shenjing CGN solar farm',
                'CGN Taishan Wind Power Co., Ltd.',
                'CGN Wind Power Company Limited',
              ],
              [
                'China',
                300,
                'Asia',
                'Wencun Town',
                'Taishan',
                'Jiangmen',
                'Guangdong Taishan Wencun Fishery solar farm',
                'Jiangmen Guangfa Fishery Photovoltaic Co., Ltd.',
                'Guangzhou Development New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinxu Town',
                'Yangxi County',
                'Yangjiang',
                'Guangdong Yangjiang Yinshan Southern Medicine Base solar farm',
                'Yangxi Huaxin Agricultural Technology Co., Ltd.',
                'Guangdong Zhongguang Energy Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Luocheng Mulao Autonomous County',
                'Luocheng',
                'Guangxi Luocheng solar farm',
                'TBEA Co., Ltd.',
                'TBEA Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                "Long'an County",
                "Long'an Xian",
                'Nanning',
                "Guangxi Province Long'an Ecological Agriculture Park solar farm",
                "Long'an Yingli Photovoltaic Power Development Co., Ltd.",
                'China Resources Shenzhen International Investment Trust Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangming Farm',
                'Jiangnan District',
                'Nanning',
                'Guangxi Province Nanning Yangming Farm solar farm',
                'Guangxi Dingxu Tonghui Agricultural Investment Co., Ltd.',
                'Guangxi Hanggui Industrial Co., Ltd.[84.7%]; Guangxi Xuneng Investment Co., Ltd. [15.3%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Yashan Town',
                'Bobai Xian',
                'Yulin',
                'Guangxi Province Yulin Bobai Bobai Agricultural Greenhouse solar farm',
                'Baili Forest',
                'Unknown',
              ],
              [
                'China',
                65,
                'Asia',
                'Zhilong State Farm',
                'Yangxi Xian',
                'Yangjiang',
                'Guangdong Province Yangxi County Zhilong State Farm solar farm',
                'Guangdong Yudean Yangxi New Energy Co., Ltd.',
                'Guangdong Electric Power Development Company',
              ],
              [
                'China',
                100,
                'Asia',
                'Changjiao Reservoir',
                'Yangxi Xian',
                'Yangjiang',
                'Guangdong Province Yangjiang Saltfield Salt and Light Complementary solar farm',
                'Guangdong Yudean Yangxi Shuangyu New Energy Co., Ltd.',
                'Guangdong Electric Power Development Company[78.91%]; Yangxi County Huinong Poverty Alleviation Asset Development Co., Ltd.[21.09%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dagou Town',
                'Yangdong Xian',
                'Yangjiang',
                'Guangdong Province Yangdong Dagouzhen Agriculture and Tourism solar farm',
                'Yangjiang Xinye Green Energy Technology Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yetang Town',
                'Xingning Shi',
                'Meizhou',
                'Guangdong Province Xingning Yetangzhen Agriculture and Light Complementary solar farm',
                'Xingning Yangchen New Energy Power Generation Co., Ltd.',
                'Sunshine New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Jiuquan Dunhuang Tower-Style Demonstration Solar Thermal Power Plant',
                'Shouhang High-Tech Energy Co., Ltd',
                'Shouhang High-Tech Energy Co., Ltd',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Taishan',
                'Jiangmen',
                'Guangdong Jiangmen Taishan Haoxin solar farm',
                'Taishan Xinhao New Energy Co., Ltd.',
                'Feng Caiqin',
              ],
              [
                'China',
                30,
                'Asia',
                'Huoju State Farm',
                'Leizhou Shi',
                'Zhanjiang',
                'Guangdong Probvinc Leizhou Huoju Farm solar farm',
                'Guangdong Yudean Group Co., Ltd.',
                'Guangdong Hengjian Investment Holding Co., Ltd. [76%]; China Huaneng Group[24%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Huoju State Farm',
                'Leizhou Shi',
                'Zhanjiang',
                'Guangdong Probvince Leizhou Huoju Farm solar farm',
                'Guangdong Yudean Group Co., Ltd.',
                'Guangdong Hengjian Investment Holding Co., Ltd. [76%]; China Huaneng Group[24%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Guanyinge Town',
                'Bolo Xian',
                'Huizhou',
                'Guangdong Province Huizhou Bolo Guanyinge Township solar farm',
                'Guangdong Yudean Group Co., Ltd.',
                'Guangdong Hengjian Investment Holding Co., Ltd.[76%]; China Huaneng Group[24%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Ruhu Town',
                'Huicheng Qu',
                'Huizhou',
                'Guangdong Province Huizhou Huicheng Ruhu Township solar farm',
                'Guangdong Yudean Group Co., Ltd.',
                'Guangdong Hengjian Investment Holding Co., Ltd.[76%]; China Huaneng Group[24%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Municipal Economic Development Zone',
                'Mazhang Qu Donghaidao',
                'Zhanjiang',
                'Guangdong Province L\u00fclong Zhongji Fishing and Light Complementary solar farm',
                'Guangdong Yuanyi Energy Co., Ltd.',
                'Guangzhou Yuanneng Wanhe Investment Partnership Enterprise (Limited Partnership)[31%]; other[69%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jintang Town',
                'Maonan Qu',
                'Maoming',
                'Guangdong Province Maoming Open-Pit Mine Forestry and Light Complementary solar farm',
                'Guangdong Yuedian Maoming New Energy Co., Ltd.',
                'Guangdong Electric Power Development Company',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Tianyang District',
                'Baise Municipality',
                'Guangxi Tianyang District Ecological Township solar Photovoltaic project',
                'China Resources Electricity Investment Co. Ltd.',
                'China Resources Power Holdings Limited',
              ],
              [
                'China',
                200,
                'Asia',
                'Xingzi Town',
                'Lianzhou Shi',
                'Qingyuan',
                'Guangdong Province Qingyuan Lianzhou Xingzi Agriculture and Light Complementary solar farm',
                'Guangzhou Development New Energy Co., Ltd.',
                'Guangzhou Development Group Incorporated[90%]; Guangzhou Development Assets Management Co., Ltd.[10%]',
              ],
              [
                'China',
                37,
                'Asia',
                'Wushi Town',
                'Qujiang Qu',
                'Shaoguan',
                'Guangdong Province Shaoguan Power Plant Ash Site solar farm',
                'Guangdong Electric Power Development Company',
                'Guangdong Yudean Group Co., Ltd.',
              ],
              [
                'China',
                23,
                'Asia',
                'Wushi Town',
                'Qujiang Qu',
                'Shaoguan',
                'Guangdong Province Shaoguan Power Plant Ash Site solar farm',
                'Guangdong Electric Power Development Company',
                'Guangdong Yudean Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Wencun Town',
                'Taishan Shi',
                'Jiangmen',
                'Guangdong Province Taishan Fishing and Light Complementary solar farm',
                'Jiangmen Guangfa Fishery Photovoltaic Co., Ltd.',
                'Guangzhou Development New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Wencun Town',
                'Taishan Shi',
                'Jiangmen',
                'Guangdong Province Taishan Fishing and Light Complementary solar farm',
                'Jiangmen Guangfa Fishery Photovoltaic Co., Ltd.',
                'Guangzhou Development New Energy Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Unavailable',
                'Taishan Shi',
                'Jiangmen',
                'Guangdong Province Taishan Fishing and Light Complementary solar farm',
                'Jiangmen Guangfa Fishery Photovoltaic Co., Ltd.',
                'Guangzhou Development New Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Taishan Shi',
                'Jiangmen',
                'Guangdong Province Taishan Fishing and Light Complementary solar farm',
                'Jiangmen Guangfa Fishery Photovoltaic Co., Ltd.',
                'Guangzhou Development New Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Haiyan Town',
                'Taishan Shi',
                'Jiangmen',
                'Guangdong Province Taishan Haiyanzhen Fishing and Light Complementary solar farm',
                'Guangdong Jiangmen Hengguang New Energy Co., Ltd.',
                'Guangzhou Hengyun Enterprises Holdings Ltd.[60%]; China Energy Engineering Group Guangdong Electric Power Design Institute Co., Ltd.[40%]',
              ],
              [
                'China',
                200,
                'Asia',
                'Longtian Town',
                'Xingning Shi',
                'Meizhou',
                'Guangdong Province Xingning Yangxing Agriculture and Light Complementary solar farm',
                'Xingning Yangxing Solar Power Co., Ltd.',
                'State Power Investment Corporation Guizhou Jinyuan Weining Energy Co., Ltd.[70%]; Hefei Huaigui New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Gongping Town',
                'Haifeng County',
                'Shanwei',
                'Guangdong Province Shanwei Haifeng Agriculture and Light Complementary solar farm',
                'Haifeng GCL Photovoltaic Power Co., Ltd.',
                'Suzhou Xiexin New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qiu County',
                'Handan',
                'Hebei Qiuxian Huangming Distributed Agricultural solar farm',
                'Qiuxian Huangming New Energy Hi Tech Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Shuoliu Reservoir',
                'Tianyang District',
                'Baise Municipality',
                'Guangxi Tianyang District Reservoir Photovoltaic solar farm',
                'China Resources Electricity Investment Co. Ltd.',
                'China Resources Power Holdings Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Wuligang',
                'Weining Yi Autonomous County',
                'Bijie',
                'Guizhou Province Bijie Xiajiapingzi solar farm',
                'State Power Investment Corporation Guizhou Jinyuan Weining Energy Co., Ltd.',
                'State Power Investment Corporation Guizhou Jinyuan Weining Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wanshengyong Town',
                'Fengning County',
                'Chengde',
                'Hebei Fengning (Three Gorges) unsubsidized Photovoltaic solar farm',
                'China Three Gorges New Energy (Group) Shareholding Co. Ltd.',
                'China Three Gorges New Energy (Group) Shareholding Co. Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Wanshengyong Town',
                'Fengning Manchu Autonomous County',
                'Chengde',
                'Hebei Fengning Wanshengyongxiang Shunqi solar farm',
                'Fengning Manchu Autonomous County Shunqi Solar Power Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Pingyang',
                'Fuping',
                'Baoding',
                'Hebei Fuping Pingyang SPIC solar farm',
                'State Power Investment Group Fuping New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Chengnanzhuang Town',
                'Fuping County',
                'Baoding',
                'Hebei Fuping Zhongmin solar farm',
                'Fuping Zhongmin 11 New Energy Co., Ltd.',
                'Information Industry Electronics Eleventh Design and Research Institute Technology Engineering Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huanggainao Town',
                'Guyuan County',
                'Zhangjiakou',
                'Hebei Guyuan Dagouying Three Gorges solar farm',
                'Three Gorges New Energy Guyuan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Zhaomaotao Town',
                'Haixing County',
                'Cangzhou',
                'Hebei Haixing Dongfang solar farm',
                'Haixing Dongfang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [58%]; Bank of Communications Financial Assets Investment Co., Ltd.[42%]',
              ],
              [
                'China',
                110,
                'Asia',
                'Xiaoshan Town',
                'Haixing County',
                'Cangzhou',
                'Hebei Haixing Jingxing New Energy solar farm',
                'Haixing Jingxing New Energy Co., Ltd.',
                'Hengfeng County Jingtai Power Co., Ltd. [51%]; Beijing Jingneng Clean Energy Power Co., Ltd. [49%]',
              ],
              [
                'China',
                115,
                'Asia',
                'Xiaoshan Town',
                'Haixing County',
                'Cangzhou',
                'Hebei Haixing Xiaoshanxiang Dongfang solar farm',
                'Haixing Dongfang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [58%]; Bank of Communications Financial Assets Investment Co., Ltd.[42%]',
              ],
              [
                'China',
                145,
                'Asia',
                'Xinji Town',
                'Haixing County',
                'Cangzhou',
                'Hebei Haixing Xinji Beikong solar farm',
                'Beikong Clean Energy (Haixing) Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Gaowan Town',
                'Haixing County',
                'Cangzhou',
                'Hebei Haixing Xionghui solar farm',
                'Haixing Xionghui Energy Co., Ltd.',
                'Jiangxi Shuitou Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Longhu Town',
                'She County',
                'Handan',
                'Hebei Handan Shexian Hanneng solar farm',
                'Hanneng Shexian Photovoltaic Power Development Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Tumu Town',
                'Huailai County',
                'Zhangjiakou',
                'Hebei Huai Tumuzhen CECEP solar farm',
                'CECEP (Huailai) Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dukoubao Town',
                "Huai'an",
                'Zhangjiakou',
                "Hebei Huai'an Dukoubai Meiheng solar farm",
                'Huaian Meiheng Photovoltaic Power Generation Co., Ltd.',
                'Nanjing Cangmei Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Taipingzhuang Town',
                "Huai'an",
                'Zhangjiakou',
                "Hebei Huai'an Taipingzhuang Haoming solar farm",
                'Huaian Haoming New Energy Co., Ltd.',
                'Jiangsu SUMEC Group Co., Ltd. [93%]; Jiangsu SUMEC New Energy Development Co., Ltd. [7%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Taipingzhuang Town',
                "Huai'an County",
                'Zhangjiakou',
                "Hebei Huai'an Taipingzhuang Huanda solar farm",
                'Hebei Huanda Trading Co., Ltd.',
                'Changshu Zhonghui Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                88,
                'Asia',
                'Lvqiao Town',
                'Huanghua',
                'Cangzhou',
                'Hebei Huanghua Lvqiaozhen solar farm',
                'Guodian Investment (Huanghua) New Energy Co., Ltd.',
                'State Power Investment (Tianjin) Distributed Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Nandagang',
                'Huanghua',
                'Cangzhou',
                'Hebei Huanghua Nandagang Zhongke Suneng solar farm',
                'Cangzhou Nandagang Management Zone Zhongke Suneng Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd. [90%]; Yang Zhidian [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Longwangmiao Town',
                'Daming County',
                'Handan',
                'Hebei Daming Changsheng solar farm',
                'Daming Changsheng Solar Energy Technology Co., Ltd.',
                'Lingshou Changsheng Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Beijiabi Town',
                'Ci County',
                'Handan',
                'Hebei Cixian Muxing Rooftop solar farm',
                'Cixian Muxing New Energy Development Co., Ltd.',
                'Shanxi Jingtian Hechuang Cloud Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Paoliang Town',
                'Chicheng County',
                'Zhangjiakou',
                'Hebei Chicheng Quegou Jinkai Xinneng solar farm',
                'Jinkai Xinneng (Chicheng) Photovoltaic Power Generation Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Longguan Town',
                'Chicheng County',
                'Zhangjiakou',
                'Hebei Chicheng Longguanzhen Guangshuo solar farm',
                'Chicheng Guangshuo New Energy Co., Ltd.',
                'Hebei LongQin Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Longjie Town',
                'Weining',
                'Bijie',
                'Guizhou Province Bijie Xiushui Delaidong solar farm',
                'State Nuclear Power Plant Service Co., Ltd.',
                'National Nuclear Power Technology Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Gangwu Town',
                'Guanling Xian',
                'Anshun',
                'Guizhou Province Guanling County Gangwu Zhuoyang solar farm',
                'Shanghai ZOESOLAR Energy Technology Co., Ltd.',
                'Yan Juan[60%]; Huangjun[40%]',
              ],
              [
                'China',
                170,
                'Asia',
                'Gangwu Town',
                'Guanling Xian',
                'Anshun',
                'Guizhou Province Guanling County Nabu Forestry solar farm',
                'CGN Guizhou Anshun Guanling New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Puli Town',
                'Guanling Xian',
                'Anshun',
                'Guizhou Province Guanling County Puli Agriculture and Light Complementary solar farm',
                'CECEP Solar Guanling Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baotian Town',
                'Panzhou Shi',
                'Liupanshui',
                'Guizhou Province Panzhou Emaozhai Agricultural solar farm',
                'Guizhou Panzhou Shengyousheng New Energy Co., Ltd.',
                'China Southern Power Grid Energy Efficiency&Clean Energy Co.,Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baotian Town',
                'Panzhou Shi',
                'Liupanshui',
                'Guizhou Province Panzhou Emaozhai Agricultural solar farm',
                'Guizhou Panzhou Shengyousheng New Energy Co., Ltd.',
                'China Southern Power Grid Energy Efficiency&Clean Energy Co.,Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Baotian Town',
                'Panzhou Shi',
                'Liupanshui',
                'Guizhou Province Panzhou Emaozhai Agricultural solar farm',
                'Guizhou Panzhou Shengyousheng New Energy Co., Ltd.',
                'China Southern Power Grid Energy Efficiency&Clean Energy Co.,Ltd.',
              ],
              [
                'China',
                67,
                'Asia',
                'Haila Town',
                'Weining',
                'Bijie',
                'Guizhou Province Weining Haila Zhongliangzi solar farm',
                'State Power Investment Corporation Guizhou Jinyuan Weining Energy Development Co., Ltd.',
                'State Power Investment Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Puli Town',
                'Guanling County',
                'Anshun',
                'Guizhou Guanling Puli solar farm',
                'CECEP Solar Guanling Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Qinglin Town',
                'Zhongshan District',
                'Liupanshui',
                'Guizhou Provine Liupanshui Zhongshan Haifa solar farm',
                'Datang Guizhou Zhongshan New Energy Co., Ltd.',
                'China Datang Group New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Chahe',
                'Weining',
                'Bijie',
                'Guizhou Weining Chahe SPIC solar farm',
                'State Power Investment Group Guizhou Jinyuan Weining Energy Co., Ltd.',
                'State Power Investment Group Guizhou Jinyuan Weining Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Chengmai County',
                'Chengmai County',
                'Haikou',
                'Guangdong Province Haikou Power Plant Ash Disposal Site solar farm',
                'China Huaneng Group',
                'China Huaneng Group',
              ],
              [
                'China',
                25,
                'Asia',
                'Banqiao Town',
                'Unavailable',
                'Dongfang',
                'Hainan Dongfang Yisheng solar farm',
                'Hainan Yisheng New Energy Co., Ltd.',
                'Guangdong Jinyuan New Energy Co., Ltd. [88%]; Chen Naiping [9%]; Sun Jianwen [3%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Tiaolou Town',
                'Lingao',
                'Lingao',
                'Hainan Lingao Tiaolouzhen solar farm',
                'National Energy Group Hainan Electric Power Co., Ltd.',
                'National Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Wumaying Town',
                'Nanpi County',
                'Cangzhou',
                'Hebei Cangzhou Nanpi Xintuo solar farm',
                'Nanpi Xintuo Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                170,
                'Asia',
                'Unavailable',
                'Fengning County',
                'Chengde',
                'Hebei Chengde Dayuan solar farm',
                'Chengde Dayuan New Energy Co., Ltd.',
                'Fengning Manchu Autonomous County Dayuan State Holding Co., Ltd. [51%]; Xintian Green Energy Co., Ltd. [49%]',
              ],
              [
                'China',
                80,
                'Asia',
                'Sangou',
                'Chengde',
                'Chengde',
                'Hebei Chengde Sangou SPIC 80MW solar farm',
                'State Power Investment Group Chengde New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sangou',
                'Chengde',
                'Chengde',
                'Hebei Chengde Sangou SPIC solar farm',
                'State Power Investment Group Chengde New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Sujiatun',
                'Qinglong County',
                'Qianxi',
                'Guizhou Qinglong Sujiatun solar farm',
                'not found',
                'not found',
              ],
              [
                'China',
                20,
                'Asia',
                'Shilidun',
                'Zhenyuan County',
                'Qingyang',
                'Gansu Zhenyuan Xuyaong solar farm',
                'Zhenyuan Xuyang New Energy Technology Co., Ltd.',
                'Xinjiang Silk Road Tianyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Lingshan Town',
                'Quyang County',
                'Baoding',
                'Hebei Quyang Jingtou New Energy solar farm',
                'Quyang Jingtou New Energy Technology Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qiuling',
                'Quyang',
                'Baoding',
                'Hebei Quyang Qiuling Three Gorges solar farm',
                'China Three Gorges New Energy (Group) Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuwangtai District',
                'Kaifeng',
                'Henan Kaifen GCL Agriculture-Light Complementary solar farm',
                'Kaifeng Huaxin New Energy Development Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Lankao',
                'Kaifeng',
                'Henan Lankao Senyuan solar farm',
                'Henan Senyuan New Energy Power Generation Co., Ltd.',
                'Henan Senyuan Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caisang Town',
                'Linzhou',
                'Anyang',
                'Henan Linzhou Caisangzhen solar farm',
                "Linzhou Jing'ao Photovoltaic Power Generation Co., Ltd.",
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhaobao Town',
                'Yiyang County',
                'Luoyang',
                'Henan Luoyang Zhaobao solar farm',
                'Luoyang Huamei Electric Power Co., Ltd.',
                'Wuling Power Co., Ltd. [70.00%]; Yang Guochen [15.30%]; Ren Yingying [14.70%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lushan County',
                'Pingdingshan',
                'Henan Lushan Gunziying solar farm',
                'Zhongmin Xinneng (Lushan) Electric Power Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangwa Town',
                'Lushan County',
                'Pingdingshan',
                'Henan Lushan Liangwa Zhongmin Xinneng solar farm',
                'Zhongmin Xinneng (Lushan) Electric Power Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Malou Town',
                'Lushan County',
                'Pingdingshan',
                'Henan Lushan Malou Zhongmin Xinneng solar farm',
                'Zhongmin Xinneng (Lushan) Electric Power Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuancun',
                'Nanle',
                'Puyang',
                'Henan Nanle Yuancun Zhonghao solar farm',
                'Nanle Zhonghao New Energy Co., Ltd.',
                'Tianjin Qidi Qingyun New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yahe Industrial Area',
                'Nanyang',
                'Henan Nanyang Yahe Industrial Area Barren Mountain solar farm',
                'Nanyang Fuda Yahe Barren Mountain Photovoltaic Power Station Co., Ltd.',
                'Yunnan Xinhua Water Resources and Hydropower Investment Co., Ltd. [90.00%]; Suzhou GCL Clean Energy Development Co., Ltd. [10.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yahe Industrial Area',
                'Nanyang',
                'Henan Nanyang Yahe Industrial Area Mudflat solar farm',
                'Nanyang Fuda Yahetan Photovoltaic Power Station Co., Ltd.',
                'Yunnan Xinhua Water Resources and Hydropower Investment Co., Ltd. [90.00%]; Suzhou GCL Clean Energy Development Co., Ltd. [10.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaoqiu Town',
                'Zhenping County',
                'Nanyang',
                'Henan Nanyang Zhenpingxian solar farm',
                'Nanyang Jingko Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaodian Township',
                'Nanzhao County',
                'Nanyang',
                'Henan Nanzhaoxian Xiaodian 1 solar farm',
                'Nanzhao Zhongji Guoneng Power Co., Ltd.',
                'Chongqing Changsheng New Energy Private Equity Investment Fund Partnership (Limited Partnership) [88.3174%]; Nanzhao County Jinfu Photovoltaic Service Co., Ltd. [11.5826%]; Others [0.1000%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Lucun',
                'Neihuang',
                'Anyang',
                'Henan Neihuang Lucun Haocheng solar farm',
                'Neihuang Changjiang Haocheng Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mashang',
                'Neihuang',
                'Anyang',
                'Henan Neihuang Mashang Hongan Haoyue solar farm',
                'Henan Hongan Haoyue Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Xinji Township',
                'Lushan County',
                'Pingdingshan',
                'Henan Pingdianshan Lushan solar farm',
                'Pingdingshan Junhao Electric Power Co., Ltd.',
                'Li Jianan[70.00%]; Yue Jie[30.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Mashang Town',
                'Neihuang Xian',
                'Anyang',
                'Henan Province Anyang Ecological Agriculture Greenhouse solar farm',
                'Neihuang Changjiang Haocheng Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuiye Town',
                'Anyang Xian',
                'Anyang',
                'Henan Province Anyang Hanlin Agricultural solar farm',
                'Anyang Hanlin Photovoltaic Power Co., Ltd.',
                'Shanghai Electric Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayu Town',
                'Jiyuan',
                'Unavailable',
                'Henan Jiyuan Dayu solar farm',
                'Jiyuan Dayu Jiangshan Photovoltaic Power Generation Co., Ltd.',
                'Jiangshan Yongtai Investment Holdings Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Lunzhang Town',
                'Anyang Xian',
                'Anyang',
                'Henan Province Anyang Lunzhangzhen Yongge solar farm',
                'Anyang Yongge Photovoltaic Power Generation Co., Ltd.',
                'Henan Xuguang Trading Company',
              ],
              [
                'China',
                20,
                'Asia',
                'Ciba Town',
                'Jia County',
                'Pingdingshan',
                'Henan Jiaxian Cibazhen solar farm',
                'Pingdingshan Jingko Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaozhuang Town',
                'Hui County',
                'Xinxiang',
                'Henan Huixian GCL Distributed solar farm',
                'Huixian GCL Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No. 1 [Tianjin] Equity Investment Fund Partnership [Limited Partnership] [60%]; Huaneng Gongrong No. 2 [Tianjin] Equity Investment Fund Partnership [Limited Partnership] [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tiefeng',
                'Qiqihar',
                'Heilongjiang Tiefeng Xianghe solar farm',
                'Heilongjiang Xianghe New Energy Co., Ltd.',
                'Heilongjiang Dongfang Wind Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shangjia',
                'Zhaodong',
                'Suihua',
                'Heilongjiang Zhaodong Shangjia CGN solar farm',
                'Zhaodong CGN New Energy Technology Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zhaoyuan',
                'Daqing',
                'Heilongjiang Zhaoyuan Lantian Aobaogangtun solar farm',
                'Zhaoyuan Lantian Solar Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zhaoyuan',
                'Daqing',
                'Heilongjiang Zhaoyuan Lantian Heiliantun solar farm',
                'Zhaoyuan Lantian Solar Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Duli Town',
                'Anyang County',
                'Anyang',
                'Henan Anyang Dulizhen solar farm',
                'Anyang Meiliang Photovoltaic Power Co., Ltd.',
                'Shanghai Hongren New Energy Investment Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Anyang',
                'Anyang',
                'Henan Anyang Notting solar farm',
                'Anyang Notting Solar Power Co., Ltd.',
                'Nanjing Notting New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Anyang',
                'Anyang',
                'Henan Anyang Yongge solar farm',
                'Anyang Yongge Photovoltaic Power Generation Co., Ltd.',
                'Henan Xuguang Trading Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Anyang',
                'Anyang',
                'Henan Anyang Zhonghao solar farm',
                'Anyang Zhonghao Photovoltaic Power Co., Ltd.',
                'CGN Wind Energy Ltd',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Anyang County',
                'Anyang',
                'Henan Anyangxian Shanyingzhen solar farm',
                'Anyang Zhongsheng Photovoltaic Power Co., Ltd.',
                'Jinan Strait Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Baofeng',
                'Pingding',
                'Henan Baofeng Xintai solar farm',
                'Baofeng Xintai Photovoltaic Power Technology Development Co., Ltd.',
                'Baofeng Baoxin Industrial Co., Ltd. [50%]; Jiangshan Yongtai Investment Holdings Co., Ltd. [50%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Changyuan County',
                'Xinxiang',
                'Henan Changyuan China Guangdong Nuclear Solar Project',
                'Changyuan China Guangdong Nuclear Solar Energy Co., Ltd.',
                'China Guangdong Nuclear Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhangcun Town',
                'Dengzhou',
                'Nanyang',
                'Henan Dengzhou Zhangcunzhen Distributed solar farm',
                'Dengzhou Zhongneng Zhonghe Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jiuyuan Town',
                'Fugou County',
                'Zhoukou',
                'Henan Fugouxian Agricultural Ecological Greenhouse solar farm',
                'Henan Ziyuan Energy Technology Co., Ltd. Fugou Branch',
                'Henan Ziyuan Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Dayugou',
                'Gongyi',
                'Zhengzhou',
                'Henan Gongyi Dayugou Xingyuan solar farm',
                'Gongyi Xingyuan New Energy Technology Co., Ltd.',
                'The IT Electronics Eleventh Design & Research Institute Scientific and Technological Engineering Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yanhe Township',
                'Guangshan County',
                'Xinyang',
                'Henan Guangshanxian Yanhe solar farm',
                'Guangshan Huanya New Energy Technology Co., Ltd.',
                'SDIC Qingneng No. 2 Equity Investment Fund (Tianjin) Partnership (Limited Partnership) [99.00%]; Others [1.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Hebiji Town',
                'Heshan District',
                'Hebi',
                'Henan Hebi Shengbu Distributed solar farm',
                'Hebi Shengbu Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Sijianfang Township',
                'Hua County',
                'Anyang',
                'Henan Huaxian Agricultural Complex solar farm',
                'Huaxian Changsheng Ridian Solar Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yanma Street',
                'Macun District',
                'Jiaozuo',
                'Henan Jiaozuo Macunqu Agricultural Science and Technology Greenhouse solar farm',
                'Jiaozuo Changsheng Solar Energy Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd. [51.00%]; Qingdao Chengtou New Energy Investment Co., Ltd. [49.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Hanzhuang Town',
                'Tangyin Xian',
                'Anyang',
                'Henan Province Anyang Tangyin Eco-Agriculture Greenhouse solar farm',
                'Anyang Zhongguang Haocheng Power Co., Ltd.',
                'Henan Honsun Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Hengshui Town',
                'Linzhou',
                'Anyang',
                'Henan Province Linzhou Hengshuizhen solar farm',
                'Linzhou Xinchuang Solar Energy Co., Ltd.',
                'China Guangdong Nuclear Power Development Co., Ltd.[80%]; Henan GCL New Energy Investment Co., Ltd.[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Guanyintang Forestry Work Station',
                'Baofeng Xian',
                'Pingdingshan',
                'Henan Province Pingdingshan Baofeng County Poverty Alleviation solar farm',
                'Baofeng Xintai Photovoltaic Power Technology Development Co., Ltd.',
                'Baofeng Baoxin Industrial Co., Ltd. [50%]; Jiangshan Yongtai Investment Holdings Co., Ltd. [50%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Houmiao Town',
                'Taiqian County',
                'Puyang',
                'Henan Taiqian Huadian Poverty Alleviation solar farm',
                'Huadian Taiqian Photovoltaic Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd. [50.00%]; Taiqian Investment Group Co., Ltd. [50.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Hanzhuang Town',
                'Tangyin County',
                'Anyang',
                'Henan Tangyin Zhongguang Haocheng Ecological Agriculture solar farm',
                'Anyang Zhongguang Haocheng Power Co., Ltd.',
                'Henan Honsun Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiangdian',
                'Wuyang',
                'Luohe',
                'Henan Wuyang Jiangdian Zhenfa solar farm',
                'Wuyang Zhenfa New Energy Technology Co., Ltd.',
                'Zhenfa Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Boahe Town',
                'Wuyang County',
                'Luohe',
                'Henan Wuyang Zhonghui solar farm',
                'Wuyang Zhonghui Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huodian Town',
                'Xiayi County',
                'Shangqiu',
                'Henan Xiayi Huodianzhen solar farm',
                'Xiayi Zhenhua New Energy Technology Co., Ltd.',
                'Hainan Silan Low Carbon Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Cangtou Town',
                "Xin'an County",
                'Luoyang',
                "Henan Xin'anxian GCL solar farm",
                "Xin'an GCL Photovoltaic Power Co., Ltd.",
                'Wuling Power Co., Ltd. [55.00%]; Suzhou GCL New Energy Investment Co., Ltd. [45.00%]',
              ],
              [
                'China',
                40,
                'Asia',
                "Bao'an Town",
                'Ye County',
                'Pingdingshan',
                'Henan Yexian China Pingmei Shenma solar farm',
                'China Pingmei Shenma Group Tianyuan New Energy Co., Ltd.',
                'China Pingmei Shenma Energy and Chemical Group Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                "Bao'an Town",
                'Ye County',
                'Pingdingshan',
                'Henan Yexian China Pingmei Shenma solar farm',
                'China Pingmei Shenma Group Tianyuan New Energy Co., Ltd.',
                'China Pingmei Shenma Energy and Chemical Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baisha Town',
                'Yichuan County',
                'Luoyang',
                'Henan Yichuanxian Dayushan solar famr',
                'Luoyang Guanglonggui Technology Co., Ltd.',
                'Juneng (Luoyang) New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fancun Town',
                'Yiyang County',
                'Luoyang',
                'Henan Yiyang Humiaoshan Hongju solar farm',
                'Yiyang Hongju Photovoltaic Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fancun Town',
                'Yiyang County',
                'Luoyang',
                'Henan Yiyang Qianyangpo Hongju solar farm',
                'Yiyang Hongju Photovoltaic Power Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Liuhe',
                'Yongcheng',
                'Shangqiu',
                'Henan Yongcheng Liuhe Xinneng solar farm',
                'Yongcheng Xinneng Photovoltaic Power Co., Ltd.',
                'Chongqing Qingdian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qiaoji',
                'Yucheng',
                'Shangqiu',
                'Henan Yucheng Qiaoji Artes solar farm',
                'Yucheng Artes New Energy Development Co., Ltd.',
                'Shanxi International Energy Group New Energy Investment Management Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhangji Town',
                'Yucheng County',
                'Shangqiu',
                'Henan Yucheng Zhangjizhen solar farm',
                'Yucheng Huayuan Photovoltaic Power Generation Co., Ltd.',
                'Hainan Silan Low Carbon Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mojie Township',
                'Yuzhou',
                'Xuchang',
                'Henan Yuzhou Mojiexiang solar farm',
                'Yuzhou Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongchang Town',
                'Yuzhou',
                'Xuchang',
                'Henan Yuzhou Yuke Photovoltaic Power Co., Ltd. solar farm',
                'Yuzhou Yuke Photovoltaic Power Co., Ltd.',
                'Shenzhen Xinwangda Integrated Energy Service Co., Ltd. [90.00%]; Jiangsu Xuyuan Technology Co., Ltd. [10.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Tanzhuang Town',
                'Shangshui County',
                'Zhoukou',
                'Henan Yuzhou Yuke Photovoltaic Power Co., Ltd. solar farm',
                'Shangshui GCL Photovoltaic Power Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Suiping',
                'Zhumadian',
                'Henan Suiping Xietong solar farm',
                'Henan Xietong New Energy Development Co., Ltd.',
                'Tianjin Zeyu Energy Management Co., Ltd.',
              ],
              [
                'China',
                130,
                'Asia',
                'Fengminggu Scenic Area',
                'Suiping',
                'Zhumadian',
                'Henan Suiping Agricultural Industrial Park solar farm',
                'Xinyi Light Energy (Suiping) Co., Ltd.',
                'Tianteng Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhangmao Township',
                'Shanzhou District',
                'Sanmenxia',
                'Henan Shanxian Zhangmaoxiang solar farm',
                'Sanmenxia Ruiguang Solar Power Generation Co., Ltd.',
                'Hairun Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liukou Town',
                'Liangyuan District',
                'Shangqiu',
                'Henan Shangqiu Liukouxiang solar farm',
                'Shangqiu Xinyan New Energy Development Co., Ltd.',
                'Hubei Lvhe New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Miaokou Town',
                'Qi Xian',
                'Hebi',
                'Henan Province Qixian Baisicun "Mountain Wilderness" solar farm',
                'Qixian Zhongguang Solar Energy Co., Ltd.',
                'Henan Xuguang Trading Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Chengguan Town',
                'Ruyang',
                'Luoyang',
                'Henan Province Ruyang Xiexin solar farm',
                'Ruyang GCL New Energy Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60.00%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Tanzhuang Town',
                'Shangshui Xian',
                'Zhoukou',
                'Henan Province Shangshui Xiexin Agriculture and Light Complementary solar farm',
                'Shangshui GCL Photovoltaic Power Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                140,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Henan Province Tanghe Shenneng solar farm',
                'Shenneng Nanjing Energy Holdings Co., Ltd.',
                'Shenzhen Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baigang Township',
                'Puyang County',
                'Puyang',
                'Henan Puyang Baigang solar farm',
                'Puyang Zhongjian New Energy Technology Development Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bagongqiao Town',
                'Puyang County',
                'Puyang',
                'Henan Puyang Xicheng (Bagongqiao South) solar farm',
                'Puyang Zhongjian New Energy Technology Development Co., Ltd.',
                'State Power Investment Corporation Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Miaokou',
                'Qi',
                'Hebi',
                'Henan Qi Miaokou Zhongguang solar farm',
                'Qixian Zhongguang Solar Energy Co., Ltd.',
                'Henan Xuguang Trading Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Qi',
                'Hebi',
                'Henan Qi Risheng solar farm',
                'Henan Risheng Photovoltaic Power Development Co., Ltd.',
                'Tianjin Fuhua Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Ningjiang Town',
                'Tailai County',
                'Qiqihaer Municipality',
                'Heilongjiang Tailai Shuangsheng Photovoltaic solar farm',
                'Tailai Xintian Green Energy Co., Ltd.',
                'Heilongjiang Xintian Harbin Electric New Energy Investment Co. Ltd. [majority]',
              ],
              [
                'China',
                50,
                'Asia',
                'Miaokou Town',
                'Qi County',
                'Hebi',
                'Henan Qixian GCL solar farm',
                'Qixian GCL New Energy Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60.00%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40.00%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Chengguan Town',
                'Ruyang County',
                'Luoyang',
                'Henan Ruyang GCL solar farm',
                'Ruyang GCL New Energy Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60.00%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40.00%]',
              ],
              [
                'China',
                80,
                'Asia',
                'Wangzhai Township',
                'Ruzhou',
                'Pingdingshan',
                'Henan Ruzhou GCL solar farm',
                'Ruzhou GCL Photovoltaic Power Co., Ltd.',
                'Wuling Power Corporation [55.00%]; Henan GCL New Energy Investment Co., Ltd. [45.00%]',
              ],
              [
                'China',
                32,
                'Asia',
                'Lingtou Town',
                'Ruzhou',
                'Pingdingshan',
                'Henan Ruzhou Lingtou solar farm',
                'Henan Furun New Energy Co., Ltd.',
                'Pingmei Shenma (Ruzhou) Huirun New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mangchuan Town',
                'Ruzhou',
                'Pingdingshan',
                'Henan Ruzhou Mangchuanzhen Banxicun solar farm',
                'Ruzhou Xintai Photovoltaic Power Technology Development Co., Ltd.',
                'Zhengzhou Qingneng Hefeng New Energy Co., Ltd. [51.00%]; Beijing Hengyu New Energy Development Co., Ltd. [49.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xilicun Town',
                'Shanzhou District',
                'Sanmenxia',
                'Henan Sanmenxia Shanzhou Xiongershan solar farm',
                'Sanmenxia Penghui New Energy Co., Ltd.',
                'Jiangsu SUMEC New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Cizhong Township',
                'Hubin District',
                'Sanmenxia',
                'Henan Sanmenxia Xieli solar farm',
                'Sanmenxia Xieli Photovoltaic Power Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Shangcai',
                'Zhumadian',
                'Henan Shangcai Xinguang solar farm',
                'Shangcai Xinguang New Energy Technology Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liukou Town',
                'Liangyuan District',
                'Shangqiu',
                'Henan Shangqiu Liukouxiang solar farm',
                'Shangqiu Xinyan New Energy Development Co., Ltd.',
                'Hubei Lvhe New Energy Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Zhugou Town',
                'Queshan County',
                'Zhumadian',
                'Henan Queshan Sikeshucun solar farm',
                'Queshan Zhuiri New Energy Power Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tailai County',
                'Qiqihar',
                'Heilongjiang Tailai Huarun solar farm',
                'China Resources New Energy Photovoltaic Power Generation (Tailai) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                24,
                'Asia',
                'Unavailable',
                'Tailai County',
                'Qiqihaer Municipality',
                'Heilongjiang Tailai Haoxin Photovoltaic solar farm',
                'Tailai Haoxin Photovoltaic Power Co. Ltd.',
                'State Power Investment Group Heilongjiang New Energy Co. Ltd. [majority]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sartu',
                'Daqing',
                'Heilongjiang Sartu Jiyuan Xinyang solar farm',
                'Daqing Jiyuan Xinyang Solar Energy Development Co., Ltd.',
                'Nanjing Xinlanyang New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Juncheng Town',
                'Tang County',
                'Baoding',
                'Hebei Tangxian Suotou solar farm',
                'Tangxian Senxing New Energy Development Co., Ltd.',
                'Tianjin Fuyi Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhanghezhuang Town',
                'Tang County',
                'Baoding',
                'Hebei Tangxian Zhanghezhuang Senxing solar farm',
                'Tangxian Senxing New Energy Development Co., Ltd.',
                'Tianjin Fuyi Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yudaokou',
                'Weichang Manchu and Mongol Autonomous County',
                'Chengde',
                'Hebei Weichang Yudaokou Hebal Medicine solar farm',
                'Weichang Manchu Mongolian Autonomous County Shengkunrenhe Photovoltaic Power Co., Ltd.',
                'Tianjin Zeyu Energy Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Zhangjiawan',
                'Weichang',
                'Chengde',
                'Hebei Weichang Zhangjiawan Yongri solar farm',
                'Weichang Manchu and Mongolian Autonomous County Yongri Photovoltaic Power Generation Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                88,
                'Asia',
                'Guxian Township',
                'Wei County',
                'Xingtai',
                'Hebei Weixian Agriculture-Light Complementary solar farm',
                'Weixian Ze\u2019en Vegetable Planting Co., Ltd.',
                'Huaneng Hebei Clean Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Wei County',
                'Xingtai',
                'Hebei Weixian Tianhai solar farm',
                'Weixian Tianhai Photovoltaic Power Generation Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                "Wen'an County",
                'Langfang',
                "Hebei Wen'an Xiaowucun Yongxin solar farm",
                'Langfang Yongxin New Energy Technology Co., Ltd.',
                'Jiangxi Tongli Risheng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hejin Town',
                "Wu'an",
                'Handan',
                "Hebei Wu'an Hejinzhen solar farm",
                "Wu'an Shengying Environmental Protection Technology Service Co., Ltd.",
                'Huaxin Real Estate (Taicang) Co., Ltd. [80%]; Wuxi Dongyi Photoelectric Technology Co., Ltd.[20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangsi',
                'Xingtai',
                'Xingtai',
                'Hebei Xingtai Huangsi SPIC solar farm',
                'State Power Investment Group Xingtai New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangsi',
                'Xingtai',
                'Xingtai',
                'Hebei Xingtai Huangsi SPIC solar farm',
                'State Power Investment Group Xingtai New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gengzhuangqiao',
                'Ningjin County',
                'Xingtai',
                'Hebei Xingtai Ningjin CGN solar farm',
                'CGN Ningjin Photovoltaic Power Generation Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Xingtai',
                'Xingtai',
                'Hebei Xingtai Wanyang solar farm',
                'Xingtai Wanyang New Energy Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xihuangcun Town',
                'Xingtai County',
                'Xingtai',
                'Hebei Xingtai Xihuangcun China Nuclear Power Cable solar farm',
                'China Nuclear Power Cable New Energy Xingtai Co., Ltd.',
                'Hebei Wantai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Beihe Township',
                'Xingtang County',
                'Shijiazhuang',
                'Hebei Xingtang Guowei solar farm',
                'Xingtang Guowei Photovoltaic Power Generation Co., Ltd.',
                'Xingtang Shiqiu Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shenjing',
                'Xuanhua',
                'Zhangjiakou',
                'Hebei Xuanhua Shenjing SPIC solar farm',
                'Xuanhua Longdongshan Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Hebei Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Peishan',
                'Yi',
                'Baoding',
                'Hebei Yi Peishan SPIC solar farm',
                'State Power Investment Group Yixian New Energy Power Generation Co., Ltd.',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Pocang Town',
                'Yi County',
                'Baoding',
                'Hebei Yixian CGN solar farm',
                'CGN New Energy Yixian Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Luozhuang Town',
                'Tang County',
                'Baoding',
                'Hebei Tangxian Luozhuangxiang Xiyang solar farm',
                'Hebei Xiyang New Energy Development Co., Ltd.',
                'Guoxian Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Tang County',
                'Baoding',
                'Hebei Tangxian Gudongcun Kechuang solar farm',
                'Tangxian Kechuang New Energy Development Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beiluo Town',
                'Tang County',
                'Baoding',
                'Hebei Tangxian Beiluozhen Xixiasu Xintang solar farm',
                'Hebei Xintang New Energy Power Generation Co., Ltd.',
                "Langfang Xin'ao Photovoltaic Integration Co., Ltd.",
              ],
              [
                'China',
                30,
                'Asia',
                'Shennan Town',
                'Shunping County',
                'Baoding',
                'Hebei Shunping Shennan Taixin solar farm',
                'Shunping Taixin New Energy Development Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Quyang',
                'Baoding',
                'Hebei Quyang SPIC solar farm',
                'State Power Investment Group Quyang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [55.86%]; Bank of Communications Financial Assets Investment Co., Ltd. [44.14%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiaomu',
                'Quyang',
                'Baoding',
                'Hebei Quyang Xiaomu SPIC solar farm',
                'State Power Investment Group Quyang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom (Hebei) New Energy Co., Ltd. [55.86%]; Bank of Communications Financial Assets Investment Co., Ltd. [44.14%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiaomu Town',
                'Quyang County',
                'Baoding',
                'Hebei Quyang Xiaomu Three Gorges solar farm',
                'Three Gorges New Energy Quyang Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhuangke Town',
                'Quyang County',
                'Baoding',
                'Hebei Quyang Zhuangke Baoneng solar farm',
                'Baoneng Quyang Photovoltaic Power Development Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Zhuangke Town',
                'Quyang County',
                'Baoding',
                'Hebei Quyang Zhuangke SPIC solar farm',
                'State Power Investment Group Quyang New Energy Power Generation Co., Ltd.',
                'Oriental Wisdom [Hebei] New Energy Co., Ltd. [56%]; Bank of Communications Financial Assets Investment Co., Ltd.[44%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yizhuang Town',
                'Quzhou County',
                'Handan',
                'Hebei Quzhou Yizhuangxiang Lusheng solar farm',
                'Quzhou Lusheng Solar Energy Technology Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Datun',
                'Ren County',
                'Xingtai',
                'Hebei Renxian Datun solar farm',
                'Renxian Jingneng New Energy Development Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'ChaiguanTown',
                'Shahe',
                'Xingtai',
                'Hebei Shahe Zhongneng Lvdian solar farm',
                'Shahe Zhongneng Lvdian New Energy Co., Ltd.',
                'China Electric Power Engineering Consulting Group Co., Ltd. [90%]; China Electric Power Engineering Consulting Group North China Electric Power Design Institute Co., Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Tanghu Town',
                'Yi County',
                'Baoding',
                'Hebei Yixian Guangyuan solar farm',
                'Yixian Guangyuan New Energy Technology Co., Ltd.',
                'Yixian Mingchuan Land Consolidation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shangyi CNNC National Cable solar farm',
                'Shangyi County CNNC National Cable New Energy Co., Ltd.',
                'Beijing CNNC National Cable New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayingpan Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shangyi Ergongdi solar farm',
                'Hebei Huadian Shangyi Wind Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd. [70%]; Hebei Yuanchen Industrial Group Co., Ltd. [30%]',
              ],
              [
                'China',
                28,
                'Asia',
                'Nanhaoqian Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shangyi GCL solar farm',
                'Shangyi GCL Photovoltaic Power Development Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shijing Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shangyi Shunneng solar farm',
                'Shangyi Shunneng Photovoltaic Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shijing Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shanyi Sanlong solar farm',
                'Hebei Sanlong Electric Power Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Longhu Town',
                'She County',
                'Handan',
                'Hebei Shexian Hanneng solar farm',
                'Heneng Shexian Photovoltaic Power Development Co., Ltd.',
                'Guokai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mujing Town',
                'She County',
                'Handan',
                "Hebei Shexian Jing'ao solar farm",
                "Shexian Jing'ao Photovoltaic Power Generation Co., Ltd.",
                "Jing'ao Solar Energy Investment [China] Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Jingdian Town',
                'She County',
                'Handan',
                'Hebei Shexian Jingdian Guoyuan solar farm',
                'Handan Guoyuan Electric Power Co., Ltd.',
                'Zhengzhou Qingneng Hefeng New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Jingdian Town',
                'She County',
                'Handan',
                'Hebei Shexian Jingdian Guoyuan solar farm',
                'Handan Guoyuan Electric Power Co., Ltd.',
                'Zhengzhou Qingneng Hefeng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayingpan Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Shangyi Dongrun solar farm',
                'Shangyi Dongrun Photovoltaic Power Generation Co., Ltd.',
                'Jinkong Power Shanxi New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangjiazhuang Town',
                'Quyang County',
                'Baoding',
                'Hebei Quyang Langjiazhuang Baoneng solar farm',
                'Baoneng Quyang Photovoltaic Power Development Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Peishan',
                'Yixian',
                'Baoding',
                'Hebei Yixian Peishan SPIC solar farm',
                'Yixian New Energy Power Generation Co., Ltd. of State Power Investment Group',
                'Hebei Lvdong Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baishu Town',
                'Yuxian',
                'Zhangjiakou',
                'Hebei Yuxian Baishuxiang solar farm',
                'Yuxian Tengyuan New Energy Development Co., Ltd.',
                'Yangyuan Dongrun New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gudahu Town',
                'Anda Municipality',
                'Suihua Municipality',
                'Heilongjiang Anda Qingkenbaoxiang Photovoltaic solar farm',
                'Anda Municipality Shenghui New Energy Technology Co., Ltd.',
                'Ronghe Power Investment #1 (Jiaxing) Enterprise Investment Partnership; Ronghe Power Investment #3 (Jiaxing) Enterprise Investment Partnership',
              ],
              [
                'China',
                20,
                'Asia',
                'Xingshugang Town',
                'Honggang District',
                'Daqing Municipality',
                'Heilongjiang Daqing Honggang District Station B Photovoltaic solar farm',
                'Daqing China Clean Energy Solar Technology Co. Ltd.',
                'Jianghe Mechanical and Electrical Equipment Engineering Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xingshugang Town',
                'Honggang District',
                'Daqing Municipality',
                'Heilongjiang Daqing Honggang District Station B Photovoltaic solar farm',
                'Daqing Yuanneng Technology Co. Ltd.',
                'Jianghe Mechanical and Electrical Equipment Engineering Co. Ltd. [majority]',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongjiajiang',
                'Ranghulu District',
                'Daqing',
                'Heilongjiang Daqing Jingneng solar farm',
                'Daqing Jingneng Solar Power Generation Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Datong',
                'Daqing',
                'Heilongjiang Datong Huiqing solar farm',
                'Daqing Huiqing New Energy Co., Ltd.',
                "China Power Shenyang Energy Investment Limited [70%]; Xi'an Longi Clean Energy Co., Ltd. [30%]",
              ],
              [
                'China',
                40,
                'Asia',
                'Laoshantou',
                'Datong',
                'Daqing',
                'Heilongjiang Datong Laoshantou Huiqing solar farm',
                'Daqing Huiqing New Energy Co., Ltd.',
                "China Power Shenyang Energy Investment Limited [70%]; Xi'an Longi Clean Energy Co., Ltd. [30%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Gannan',
                'Qiqihar',
                'Heilongjiang Gannan Longyang solar farm',
                'Gannan Longyang New Energy Co., Ltd.',
                'Shanghai Galaxy Investment Co., Ltd. [80%]; Boer Energy Jiangsu Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Honggang',
                'Daqing',
                'Heilongjiang Honggang Zhongqingneng solar farm',
                'Daqing Zhongqingneng Solar Energy Technology Co., Ltd.',
                'Jianghe Mechanical and Electrical Equipment Engineering Co. Ltd. [majority]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Honggang',
                'Daqing',
                'Heilongjiang Honggang Zhongqingneng solar farm',
                'Daqing Zhongqingneng Solar Energy Technology Co., Ltd.',
                'Jianghe Mechanical and Electrical Equipment Engineering Co. Ltd. [majority]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shanquan Town',
                'Longjiang',
                'Qiqihar',
                'Heilongjiang Longjiang Sungrow solar farm',
                'Sungrow Renewables Development Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.[77%]; Cao Renxian[4%]; Other[19%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Nehe',
                'Qiqihar',
                'Heilongjiang Nehe Jinyang solar farm',
                'Nehe Jinyang Photovoltaic Power Development Co., Ltd.',
                'Gaoguang Zhonghe Zhangjiakou New Energy Co., Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'Shengping Town',
                'Anda',
                'Suihua',
                'Heilongjiang Province Anda "Unsubsidized" solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                200,
                'Asia',
                'Shengping Town',
                'Anda',
                'Suihua',
                'Heilongjiang Province Anda "Unsubsidized" solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Anda Pasture Farm',
                'Anda',
                'Suihua',
                'Heilongjiang Province Anda Pastoral Farm Grid-Connected "Unsubsidized" solar farm',
                "Bo'er Energy Jiangsu Co., Ltd.",
                "Bo'er [Wuxi] Power Complete Set Equipment Co., Ltd.[60%]; Wuxi Tianshan Investment Co., Ltd. [35%], other[5%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zhaoyuan County',
                'Daqing Municipality',
                'Heilongjiang Qingyuan Lantian Heiliantun Area A Photovoltaic solar farm area A',
                'Zhaoyuan Lantian Solar Energy and Power Co. Ltd.',
                'Jiangsu Lantian Photovoltaic Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ranghulu',
                'Daqing',
                'Heilongjiang Ranghulu Hongji solar farm',
                'Daqing Hongji Wind Power Co., Ltd.',
                'Heilongjiang Dongfang Wind Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sartu',
                'Daqing',
                'Heilongjiang Sartu Chenrui Xinyang solar farm',
                'Daqing Chenruixinyang Solar Energy Development Co., Ltd.',
                'Nanjing Xinlanyang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gudahu Town',
                'Anda Municipality',
                'Suihua Municipality',
                'Heilongjiang Anda Qingkenbaoxiang Photovoltaic solar farm',
                'Anda Municipality Shenghui New Energy Technology Co., Ltd.',
                'Ronghe Power Investment #1 (Jiaxing) Enterprise Investment Partnership; Ronghe Power Investment #3 (Jiaxing) Enterprise Investment Partnership',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Anda',
                'Suihua',
                'Heilongjiang Anda Huarun solar farm',
                'China Resources New Energy (Anda) Co., Ltd.',
                'Huarun New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Anda',
                'Suihua',
                'Heilongjiang Anda Huarun solar farm',
                'China Resources New Energy (Anda) Co., Ltd.',
                'Huarun New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Anda',
                'Suihua',
                'Heilongjiang Anda Guokai solar farm',
                'Anda Jinkai New Energy Photovoltaic Power Development Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yuzhou Town',
                'Yu County',
                'Zhangjiakou',
                'Hebei Yuxian Nankangzhuang Tengyuan solar farm',
                'Yuxian Tengyuan New Energy Development Co., Lt',
                'Yangyuan Dongrun New Energy Development Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Xuting Township',
                'Zanhuang County',
                'Shijiazhuang',
                'Hebei Zanhuang Huadian solar farm',
                'Hebei Huadian Hybrid Energy Storage Hydropower Co., Ltd. Zanhuang New Energy Branch',
                'Hebei Huadian Hybrid Storage Hydropower Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangbei Hongji Qicheqiao solar farm',
                'Zhangbei Hongji New Energy Technology Co., Ltd.',
                'Tunghsu New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                240,
                'Asia',
                'Erquanjing Town',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangbei Internet Smart Energy Demonstration solar farm',
                'Zhangbei Horun Energy Co., Ltd. \uff08',
                'Beijing Jineng New Energy Technology Co., Ltd. [51%]; Hainan Silan Low Carbon Investment Co., Ltd. [29%]; Shenzhen Herun Energy Co., Ltd. [10%]; Zhangbei County Darong New Energy Development Co., Ltd. [10 %]',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangbei Nenghuan solar farm',
                'Zhangbei Nenghuan New Energy Co., Ltd.',
                'Shijiazhuang Shilei New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangbei Poverty Alleviation solar farm',
                'Zhangjiakou Yiyuan New Energy Development Co., Ltd.',
                'Bairui Trust Co., Ltd',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangbei Xinlongwacun solar farm',
                'Hebei Runyang Solar Power Generation Co., Ltd.',
                'Beijing BOE Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Gaojiaying Town',
                'Chongli District',
                'Zhangjiakou',
                'Hebei Zhangjiakou Chongli Zhonghuan solar farm',
                'Zhangjiakou Shengyuan New Energy Co., Ltd.',
                'Zhangjiakou Zhonghuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Dalonghua Town',
                'Yi County',
                'Baoding',
                'Hebei Yixian Yiyuan solar farm',
                'Yixian Yiyuan Photovoltaic Power Development Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [95%]; Hebei Yingli New Energy Technology Co., Ltd. [5%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Dapanying Town',
                'Shangyi County',
                'Zhangjiakou',
                'Hebei Zhangjiakou Shangyi Yuanchen solar farm',
                'Shangyi Yuanchen New Energy Development Co., Ltd.',
                'Hebei GCL New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tuchengzi Town',
                'Kangbao County',
                'Zhangjiakou',
                'Hebei Zhangjiakou Tuchengzi solar farm',
                'Kangbao Huanju New Energy Co., Ltd.',
                'Zhangjiakou Zhonghuan Energy Co., Ltd. [70%]; Apple South Asia Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yangyuan County',
                'Zhangjiakou',
                'Hebei Zhangjiakou Yangyuan Hengbo solar farm',
                'Yangyuan Hengbo New Energy Technology Co., Ltd.',
                'Hebei Hengbo New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Suobao Town',
                'She Xian',
                'Handan',
                'Hubei Handan Shexian 30 MW Solar',
                'China Power Investment Shexian Photovoltaic Power Co., Ltd.',
                'Inner Mongolia Jinghe New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xili Town',
                'Lincheng Xian',
                'Xingtai',
                "Inner Mongolia Lincheng Jing'ao solar farm",
                'Lincheng JA Photovoltaic Power Co., Ltd.',
                "China Nuclear Huihai Wind Power Investment Co., Ltd.[80%]; Jing'ao Solar Energy Investment [China] Co., Ltd.[20%]",
              ],
              [
                'China',
                50,
                'Asia',
                'Xili Town',
                'Lincheng Xian',
                'Xingtai',
                "Inner Mongolia Lincheng Jing'ao solar farm",
                'Lincheng JA Photovoltaic Power Co., Ltd.',
                "China Nuclear Huihai Wind Power Investment Co., Ltd.[80%]; Jing'ao Solar Energy Investment [China] Co., Ltd.[20%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Anda',
                'Suihua',
                'Heilongjiang Anda CGN solar farm',
                'Anda CGN Solar Technology Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Changde Town',
                'Anda',
                'Suihua',
                'Heilongjiang Anda Changde solar farm',
                'Anda Jinkai New Energy Photovoltaic Power Development Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd. [100%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Anda',
                'Suihua',
                'Heilongjiang Anda Guokai solar farm',
                'Anda Jinkai New Energy Photovoltaic Power Development Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shagou Town',
                'Zhangbei County',
                'Zhangjiakou',
                'Hebei Zhangjiakou Shaogouzhen Jingke solar farm',
                'Zhangjiakou Jingke New Energy Co., Ltd.',
                'SDIC Power Holdings CO., LTD.',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Zhongmu',
                'Zhengzhou',
                'Henan Zhongmu Hangjia solar farm',
                'Zhengzhou Hangjia New Energy Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [70%]; Ningbo One Innovation Energy Co., Ltd. [30%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Ganzhou District',
                'Zhangye',
                'Gansu Zhangye Ganzhou Heihe solar farm',
                'Gansu Heihe Hydropower New Energy Development Co., Ltd.',
                'Gansu Heihe Hydropower Industry Investment Co., Ltd. [54%]; Gansu Zhangye Zhaohui Real Estate Co., Ltd. [46%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Yumengdong Town',
                'Yumen',
                'Jiuquan',
                'Gansu Yumendong Zhongli Tenghui solar farm',
                'Yumen Zhongli Tenghui New Energy Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Zhuxianzhuang Town',
                'Yongqiao Qu',
                'Suzhou',
                'Anhui Province Suzhou Yongqiao Zhuxianzhuang "Front Runner Plan" solar farm',
                'CECEP Solar Energy Technology (Anhui) Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Renheji Town',
                'Tianchang',
                'Chuzhou',
                'Anhui Province Tianchang Huahui solar farm',
                'Tianchang Huahui Photovoltaic Power Co., Ltd.',
                'Nanjing Yingfa Ruineng Technology Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Renheji Town',
                'Tianchang',
                'Chuzhou',
                'Anhui Province Tianchang Huahui solar farm',
                'Tianchang Huahui Photovoltaic Power Co., Ltd.',
                'Nanjing Yingfa Ruineng Technology Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Renheji Town',
                'Tianchang',
                'Chuzhou',
                'Anhui Province Tianchang Huahui solar farm',
                'Tianchang Huahui Photovoltaic Power Co., Ltd.',
                'Nanjing Yingfa Ruineng Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yanqiao Town',
                'Wuwei Shi',
                'Wuhu',
                'Anhui Province Wuhu Wuwei Yanqiaozhen solar farm',
                'Xinyi Solar (Wuhu) Co., Ltd.',
                'WISE REGAL INVESTMENTS LIMITED',
              ],
              [
                'China',
                100,
                'Asia',
                'Eqiao Town',
                'Sanshan Qu',
                'Wuhu',
                'Anhui Province Wuhu Xinyi Sanshan solar farm',
                'Wuhu Xinyi New Energy Management Co., Ltd.',
                'Xinyi Solar (Wuhu) Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Niubu Town',
                'Wuwei Shi',
                'Wuhu',
                'Anhui Province Wuwei Niubuzhen Xinyi Fishing and Light Complementary solar farm',
                'Xinyi Photovoltaic Industry (Anhui) Holdings Co., Ltd.',
                'XINYI SOLAR [HONG KONG] LIMITED',
              ],
              [
                'China',
                30,
                'Asia',
                'Niubu Town',
                'Wuwei County',
                'Wuhu Municipality',
                'Anhui Province Wuwei Niubuzhen Xinyi Fishing and Light Complementary solar farm',
                'Wuwei Xinchuang New Energy Co. Ltd.',
                'Xinyi Light Energy (Wuhu) Co. Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Gucheng Town',
                'Yingshang Xian',
                'Fuyang',
                'Anhui Province Yingshang Gucheng "Front Runner Plan" solar farm',
                'Yingshang County Runneng New Energy Co. Ltd.',
                'Jiangsu Tiansai New Energy Development Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Hengbu Town',
                'Zongyang Xian',
                'Suzhou',
                'Anhui Province Zongyang Hengbu Fishing and Light Complementary solar farm',
                'Zongyang County Chenhua New Energy Power Generation Co., Ltd.',
                "Xi'an Leichuang Haomai Wind Power Co., Ltd.",
              ],
              [
                'China',
                260,
                'Asia',
                'Tanggou Town',
                'Zongyang Xian',
                'Tongling',
                'Anhui Province Zongyang Tanggou Fishing and Light Complementary solar farm',
                'Sungrow Power Supply Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Guzhing Town',
                'Qiaocheng District',
                'Bozhou Municipality',
                'Anhui Qiaocheng Gujing Photovoltaic solar farm',
                'Bozhou Qiaosheng Solar Energy Technology Co. Ltd.',
                'Qingdao Changshengridian Solar Technology Shareholding Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Guzhing Town',
                'Qiaocheng District',
                'Bozhou Municipality',
                'Anhui Qiaocheng Gujing Photovoltaic solar farm',
                'Bozhou Qiaosheng Solar Energy Technology Co. Ltd.',
                'Qingdao Changshengridian Solar Technology Shareholding Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xinhe Town',
                'Qingyang County',
                'Chizhou Municipality',
                'Anhui Qingyang Xinhezhen Wulongcun fisheries solar farm',
                'Qingyang County Xingong New Enewrgy Power Generation Co. Ltd.',
                'Anhui Jilin Power New Energy Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xinhe Town',
                'Qingyang County',
                'Chizhou Municipality',
                'Anhui Qingyang Xinhezhen Xiangyangcun fisheries solar farm',
                'Qingyang County ChangyangNew Energy Power Generation Co. Ltd.',
                'Anhui Jilin Power New Energy Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anfeng Town',
                'Shouxian County',
                'Huainan',
                'Anhui Shouxian Anfengzhen solar farm',
                'Xinyi New Energy (Shouxian) Co., Ltd.',
                'Huizhuo Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anfeng Town',
                'Shouxian County',
                'Huainan',
                'Anhui Shouxian Dongdaxu solar farm',
                'Xinyi New Energy (Shouxian) Co., Ltd.',
                'Huizhuo Development Co., Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Chaoyang Town',
                'Lingbi Xian',
                'Suzhou',
                'Anhui Province Suzhou Lingbi Qingyang solar farm',
                'Lingbi County Qingyang New Energy Power Generation Co., Ltd.',
                'Sunshine New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shuangmiaoji Town',
                'Shouxian County',
                'Huainan Municipality',
                'Anhui Shouxian Shuangmiaoji Town agricultural solar power plang',
                'Shouxian Xinyuan Photovoltaic Power Generation Co. Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fuli Town',
                'Yongqiao Qu',
                'Suzhou',
                'Anhui Province Suzhou Fuyang Yongqiao Fuli solar farm',
                'Suzhou Fuyang Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anfeng Town',
                'Shou Xian',
                'Huainan',
                'Anhui Province Shouxian Anfengzhen Xinyi Guangneng Fishing and Light Complementary solar farm',
                'Xinyi Solar (Shou County) Co., Ltd.',
                'FULL WISDOM DEVELOPMENT LIMITED',
              ],
              [
                'China',
                260,
                'Asia',
                'Dalong Town',
                'Dangtu Xian',
                'Maanshan',
                'Anhui Province Dangtu Fishing and Light Complementary solar farm',
                'China Guangdong Nuclear Power Group Co., Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Liangyuan Town',
                'Feidong Xian',
                'Hefei',
                'Anhui Province Feidong Liangyuan Fishing and Light Complementary solar farm',
                'Feidong Jinyang New Energy Power Generation Co., Ltd.',
                'Sungrow Renewables Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shitang Town',
                'Feidong',
                'Hefei',
                'Anhui Province Feidong Shitang solar farm',
                'Feidong Hongri New Energy Power Generation Co., Ltd.',
                'Sumec Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shitang Town',
                'Feidong',
                'Hefei',
                'Anhui Province Feidong Shitang solar farm',
                'Feidong Hongri New Energy Power Generation Co., Ltd.',
                'Sumec Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hancun Town',
                'Suixi Xian',
                'Huaibei',
                'Anhui Province Huaibei Suixi Hancunzhen "Front Runner Plan" solar farm',
                'Xinyi New Energy (Huaibei) Co., Ltd.',
                'Shengli Investment Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liuqiao Town',
                'Suixi Xian',
                'Huaibei',
                'Anhui Province Huaibei Suixi Liuqiaozhen "Front Runner Plan" solar farm',
                'Suixi County Yongrui Modern Agricultural Technology Co. Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Nanping Town',
                'Suixi Xian',
                'Huaibei',
                'Anhui Province Huaibei Suixi Nanpingzhen "Front Runner Plan" Tianhe solar farm',
                'Suixi County Tianhuai New Energy Co. Ltd.',
                'Changzhou Tiansui New Energy Co. Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Nanping Town',
                'Suixi Xian',
                'Huaibei',
                'Anhui Province Huaibei Suixi Nanpingzhen "Front Runner Plan" Xiexin solar farm',
                'Huaibei Xinneng Photovoltaic Power Co. Ltd.',
                'Nanjing GCL New Energy Development Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Guqiao Town',
                'Fengtai Xian',
                'Huianan',
                'Anhui Province Huainan Fengtai Guqiaozhen "Front Runner Plan" solar farm',
                'Fengtai County Chengyang New Energy Co. Ltd.',
                'Hefei Qianhe New Energy Investment Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Guqiao Town',
                'Fengtai Xian',
                'Huianan',
                'Anhui Province Huainan Fengtai Xinji "Front Runner Plan" solar farm',
                'Anhui Zhaolian Clean Energy Co., Ltd.',
                'Changzhou Zhaolian Luhui New Energy Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Nihe Town',
                'Panji Mining Area',
                'Huainan',
                'Anhui Province Huainan Panji "Front Runner Plan" solar farm',
                'Three Gorges New Energy Huainan Photovoltaic Power Generation Co. Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Baitafan Town',
                'Jinzhai Xian',
                "Liu'an",
                "Anhui Province Liu'an Jinzhai Baitafan solar farm",
                "Xinyi Solar (Liu'an) Co., Ltd.",
                'SUN WISDOM DEVELOPMENT LIMITED[50%]; Shenzhen Ruihe Star Technology Development Co., Ltd. [50%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Meishan Town',
                'Jinzhai Xian',
                "Liu'an",
                "Anhui Province Liu'an Jinzhai Huijin Poverty Alleviation solar farm",
                'Jinzhai Huijin Investment Co. Ltd.',
                "Jinzhai People's Government State-Owned Assets Management Commission [74.2587%]; Anhui Province Trust and Credit Guarantee Group Co. Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinzhai County',
                "Lu'an",
                "Anhui Province Liu'an Jinzhai Xinrui solar farm",
                'Jinzhai Jinrui Solar Electricity Generation Co. Ltd.',
                'State Power Investment Group #2 Clean Energy Shareholdiing Investment Fund (Tianjin) Partnership [99%] ; Suzhou GCL Clean Energy Development Co., Ltd. [1%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Baitafan Town',
                'Jinzhai Xian',
                "Liu'an",
                "Anhui Province Liu'an Jinzhai Xinrui solar farm",
                'Jinzhai Jinrui Solar Electricity Generation Co. Ltd.',
                'State Power Investment Group #2 Clean Energy Shareholdiing Investment Fund (Tianjin) Partnership [99%] ; Suzhou GCL Clean Energy Development Co., Ltd. [1%]',
              ],
              [
                'China',
                150,
                'Asia',
                'Jinzhai Modern Industry Estate',
                'Jinzhai Xian',
                "Liu'an",
                "Anhui Province Liu'an Xinyi Jinzhai solar farm",
                "Liu'an Xinyi New Energy Management Co., Ltd.",
                'Xinyi Solar (Wuhu) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Luohe Town',
                'Lujiang',
                'Hefei',
                'Anhui Province Lujiang Dongsheng solar farm',
                'Lujiang Dongsheng Solar Energy Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anfeng Town',
                'Shou Xian',
                'Huainan',
                'Anhui Province Shouxian Anfengzhen Xinyi New Energy Fishing and Light Complementary solar farm',
                'Xinyi New Energy (Shouxian) Co., Ltd.',
                'Huizhuo Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhengyanguan Town',
                'Shou County',
                'Huainan',
                'Anhui Shouxian Zhengyangguan CECEP solar farm',
                'CECEP Solar Technology Shou County Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Heita Town',
                'Sixian County',
                'Suzhou Municipality',
                'Anhui Sixian County Zhushan Photovoltaic solar farm',
                'Sixian Shenneng (Shenzhen Energy) Energy Investment Co. Ltd.',
                'Shenzhen Energy Nanjing Energy Holdings Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Heita Town',
                'Sixian County',
                'Suzhou Municipality',
                'Anhui Sixian County Zhushan Photovoltaic solar farm',
                'Sixian Shenneng (Shenzhen Energy) Energy Investment Co. Ltd.',
                'Shenzhen Energy Nanjing Energy Holdings Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Daying Town',
                'Yongqiao District',
                'Suzhou Municipality',
                'Anhui Yongqiao District Daying Photovoltaic solar farm',
                'Suzhou Jinghai Photovoltaic Power Generation Co. Ltd.',
                'Hubei Energy Group New Energy Development Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qixian Town',
                'Yongqiao District',
                'Suzhou Municipality',
                'Anhui Yongqiao District Qixian Shengbu Photovoltaic solar farm',
                'Suzhou Shengbu Photovoltaic Power Generation Co. Ltd.',
                'Hubei Energy Group New Energy Development Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fuhu Modern Agricultural Demonstration Estate',
                'Yongqiao District',
                'Suzhou Municipality',
                'Anhui Yongqiao Huigu agricultural Photovoltaic solar farm',
                'Suzhou Xiexin Photovoltaic Power Co. Ltd.',
                'Suzhou Xieixin Agricultural Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fuhu Modern Agricultural Demonstration Estate',
                'Yongqiao District',
                'Suzhou Municipality',
                'Anhui Yongqiao Huigu agricultural Photovoltaic solar farm',
                'Suzhou Xiexin Photovoltaic Power Co. Ltd.',
                'Suzhou Xieixin Agricultural Technology Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qixian Mining Area',
                'Yongqiao District',
                'Suzhou Municipality',
                'Anhui Yongqiao Qixian Mined Out Area solar farm',
                'Suzhou Municipality Huayang New Energy Co. Ltd.',
                'Hefei Taitong New Energy Investment Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiangjiadian Town',
                "Yu'an District",
                "Lu'an",
                "Anhui Yu'an Jiangjiadianzhen solar farm",
                "Lu'an Xuqiang New Energy Engineering Co., Ltd.",
                'Changshu Honglue Photovoltaic Power Plant Development Co., Ltd.',
              ],
              [
                'China',
                75,
                'Asia',
                'Jinzhai Modern Industry Park',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhuii Jinzhai Zaochong Photovoltaic solar farm',
                'Anhui Keshida Photovoltaic Co. Ltd.',
                'Shenzhen Keshida Technology Shareholding Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hedian Town',
                'Wuwei Municipality',
                'Wuhu Municipality',
                'Anwei Wuwei Sutang Reservoir fisheries solar farm',
                'Wuwei Rihao New Energy Co. Ltd.',
                'Xinyi Light Energy (Wuhu) Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jieji Town',
                'Yongqiao District',
                'Suzhou',
                'Zhejiang Suzhou Yunyang New Energy solar farm',
                'Suzhou Yunyang New Energy Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jieji Town',
                'Yongqiao District',
                'Suzhou',
                'Zhejiang Suzhou Yunyang New Energy solar farm',
                'Suzhou Yunyang New Energy Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuanggang Town',
                'Tongcheng Municipality',
                'Anqing Municipality',
                'Tongcheng Shuangangzhen fisheries solar farm',
                'Tongcheng Tongyang New Energy Power Generation Co. Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xitiangezhuang',
                'Miyun',
                'Unavailable',
                'Beijing Miyun Xitiangezhuang Huadian solar farm',
                'Huadian (Beijing) New Energy Development Co., Ltd.',
                'Huadian (Fuqing) Wind Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Qianjiang',
                'Unavailable',
                'Chongqing Qianjiang Tongwei solar farm',
                'Chongqing Tongwei New Energy Co., Ltd.',
                'Tongwei New Energy (Shenzhen) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Epengjiang',
                'Qianjiang Qu',
                'Unavailable',
                'Chongqing Tongwei Qianjiang solar farm',
                'Chongqing Tongwei New Energy Co., Ltd.',
                'Tongwei New Energy (Shenzhen) Co., Ltd.',
              ],
              [
                'China',
                195,
                'Asia',
                'Liangping',
                'Wushan',
                '\u6e1d\u4e1c\u5317\u4e09\u5ce1\u5e93\u533a\u57ce\u9547\u7fa4\u533a\u4f4d',
                'Chongqing Wushan Liangping Chengguang solar farm',
                'Chongqing Wushan Chengguang New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zhong',
                '\u6e1d\u4e1c\u5317\u4e09\u5ce1\u5e93\u533a\u57ce\u9547\u7fa4\u533a\u4f4d',
                'Chongqing Zhong Jidian solar farm',
                'Zhongxian Jidian New Energy Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Chitu Town',
                'Zhangpu Xian',
                'Zhangzhou',
                'Fujian Province Zhangpu solar farm',
                'not found',
                'not found',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangqiao Town',
                'Yingshang County',
                'Fuyang',
                'Anhui Yingshang Huangqiaozhen solar farm',
                'Yingshang Huasheng Agricultural Solar Power Generation Co., Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiaoganghu Lake',
                'Maoji Experimental District',
                'Huainan Municipalituy',
                'Anhui Yingshang County Jiaoganghu Photovoltaic solar farm',
                'Huainan China Power Jiaoganghu Photovoltaic Power Generation Co. Ltd.',
                'China Power International Development Co. Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Jiaogang Lake',
                'Yingshang County',
                'Fuyang Municipality',
                'Anhui Yingshang County Jiaoganghu Photovoltaic solar farm',
                "Yingshang Ju'an Photovoltaic Power Generation Co. Ltd.",
                'Yanfa Beikong Xinneng (Tianjin) Shareholding Investment Partnership [99.9%]; Tianjin Fuyi Enterprise Management Consulting Co. Ltd. [0.1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wuming Town',
                'Yingquan District',
                'Fuyang',
                'Anhui Yingquan District Wumingzhen Fuyang Jinming solar farm',
                'Fuyang Jinming Agricultural Solar Power Generation Co., Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Chengling Town',
                'Susong County',
                'Unavailable',
                'Anhui Susong Poverty alleviation Photovoltaic solar farm',
                'Susong Jinkai Photovoltaic Power Co. Ltd.',
                'Shanghai Nengke Rongchuang New Energy Development Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Heguai Village',
                'Suzhou Economic Development Zone',
                'Suzhou Municipality',
                'Anhui Suzhou Economic Zone Heguai agricultural Photovoltaic solar farm',
                'Suzhou Jinyang New Energy Technology Co. Ltd.',
                'Anhui Linyang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'JInhai Neighborhood',
                'Suzhou Economic Development Zone',
                'Suzhou Municipality',
                'Anhui Suzhou Economic Zone Qiancun agricultural Photovoltaic solar farm',
                'Suzhou Jinyang New Energy Technology Co. Ltd.',
                'Anhui Linyang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaokou Town',
                'Taihe County',
                'Fuyang',
                'Anhui Taihe Dayinzhai solar farm',
                'China Energy Construction Group Taihe New Energy Co., Ltd.',
                'China Energy Construction Group Investment Co., Ltd. [60.00%]; China Energy Construction Group Anhui Electric Power Construction Second Engineering Co., Ltd. [20.00%]; China Energy Construction Group Anhui Electric Power Design Institute Co., Ltd. [20.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiaokou Town',
                'Taihe County',
                'Fuyang Municipality',
                'Anhui Taihe Xiaokouzhen Wangyaocun Agriculturtal solar farm',
                'China Energy Construction Group Taihe New Energy Co., Ltd.',
                'China Energy Construction Group Investment Co., Ltd. [60%]; China Energy Construction Group Anhui Electric Power Construction Second Engineering Co., Ltd. [20%]; China Energy Construction Group Anhui Electric Power Design Institute Co., Ltd. [20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Yangcun Town',
                'Tianchang Municipality',
                'Chuzhou Municipality',
                'Anhui Tianchang Huadongyuan fisheries Photovoltaic solar farm',
                'Tianchang China Power Construction Daqiao New Energy Co. Ltd.',
                'China Power Construction Group East China Survey and Design Institute Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Yangcun Town',
                'Tianchang',
                'Chuzhou',
                'Anhui Tianchang Huadongyuan fisheries Photovoltaic solar farm',
                'Tianchang China Power Construction Bridge New Energy Co., Ltd.',
                'China Power Construction Group East China Survey and Design Research Institute Co., Ltd. [51.00%]; Sichuan Liangshanzhou Bridge Hydropower Development Co., Ltd. [40.00%]; Shangtejie Power Technology Co., Ltd. [9.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qinlan Town',
                'Tianchang Municipality',
                'Chuzhou Municipality',
                'Anhui Tianchang Qinlanzhen Mumahu distributed solar farm',
                'Tianchang Xiexin Photovoltaic Power Co. Ltd.',
                'Xuzhou State Asset Environmental Protection and Energy Co. Ltd. [90%]; Suzhou Xiexin New Energy Investment Co. Ltd. [10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Suwan Town',
                'Chaohu Shi',
                'Hefei',
                'Anhui Province Chaohu Suwan solar farm',
                'Chaohu Jiaoyang New Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xilian Town',
                "Yi'an District",
                'Tongling',
                'Anhui Tongling Xilianzhen solar farm',
                'Tongling Jingneng Photovoltaic Power Co., Ltd.',
                'Hengfeng Jingxiu Electric Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liangquan Township',
                'Wangjiang County',
                'Anqing',
                'Anhui Wangjiang Xinyi Poverty Alleviation solar farm',
                'Xinyi Light Energy (Wangjiang) Co., Ltd.',
                'Junling International Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jiujiang Districty',
                'Wuhu Municipality',
                'Anhui Wuhu Huangnitan Ash Field Photovoltaic solar farm',
                'Wuhu Huangnitan Photovoltaic Electricity Generation Co. Ltd.',
                'State Power Investment (Wuhu) Electricity Sales Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangzhai Town',
                'Xiaoxian County',
                'Suzhou Municipality',
                'Anhui Xiaoxian Wangzhai agricultural distributed solar Photovoltaic power project',
                'Xiaoxian Huayao Agricultural Enterprises Solar Power Co. Ltd.',
                'Anhui Linyang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinzhuang Town',
                'Xiaoxian County',
                'Suzhou Municipality',
                'Anhui Xiaoxian Xinzhuang Photovoltaic solar farm',
                'Xiaoxian Yiguan New Energy Co. Ltd.',
                'Shanghai Yiguan New Energy Co. Ltd.',
              ],
              [
                'China',
                33,
                'Asia',
                'Wangfenggang Town',
                'Xiejiaji District',
                'Huainan Municipality',
                'Anhui Xiejiaji Wangfenggang Mined Out Area Xingang solar farm',
                'Huainan Xinyi New Energy Co. Ltd.',
                'Donglang Investment Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Xinhe Town',
                'Qingyang County',
                'Chizhou Municipality',
                'Anhui Xinyang Count Xinhezhen Hongshancun fisheries solar farm',
                'Qingyang County Xinyang New Energy Power Generation Co. Ltd.',
                'Anhui Jilin Power New Energy Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinwujiang Town',
                'Yingdong District',
                'Fuyang',
                'Anhui Yingdong Xinwujiangzhen Distributed solar farm',
                'Fuyang Yongming Agricultural Solar Power Generation Co., Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingquan District',
                'Fuyang',
                'Anhui Yingquan District Liuxingzhen Jinming solar farm',
                'Fuyang Jinming Agricultural Solar Power Generation Co., Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liangquan Town',
                'Wangjiang County',
                'Anqing Municipality',
                'Anhui Wangjiang Xinyi poverty alleviation solar farm',
                'Xinyi Light Energy (Wangjiang) Co. Ltd.',
                'Junling International Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Langanji Town',
                'Chaohu',
                'Hefei',
                'Anhui Province Chaohu Hongqiaon solar farm',
                'CGN Solar Chaohu Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'BaTown',
                'Chaohu',
                'Hefei',
                'Anhui Province Chaohu Bazhen solar farm',
                'CECEP Solar Technology Chaohu Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'BaTown',
                'Chaohu',
                'Hefei',
                'Anhui Province Chaohu Bazhen solar farm',
                'CECEP Solar Technology Chaohu Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangyuan Town',
                'Feidong County',
                'Hefei',
                'Anhui Feidong Liangyuan Jiuyang solar farm',
                'Hefei Jiuyang New Energy Co., Ltd.',
                'Xuzhou Guotou Environmental Protection Energy Co., Ltd.[90%]; Suzhou GCL New Energy Investment Co., Ltd.[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Liangyuan Town',
                'Feidong County',
                'Hefei',
                'Anhui Feidong Liangyuan Xianhupo Jinyang solar farm',
                'Feidong Jinyang New Energy Power Generation Co., Ltd.',
                'Sungrow Renewables Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Mingchuan Town',
                'Feixi County',
                'Hefei',
                'Anhui Feixi Mingchuan Zhonghui Distributed solar farm',
                'Feixi Zhonghui Photovoltaic Power Generation Co., Ltd.',
                'Jiangshan Yongtai Investment Holdings Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huagang Town',
                'Feixi County',
                'Hefei',
                'Anhui Feixi Yongfeng solar farm',
                'Hefei Lvjuyuan Photovoltaic Power Generation Co., Ltd.',
                'Hefei Liuyuan Photovoltaic Power Generation Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Banqiao Town',
                'Fengyang County',
                'Chuzhou Municipality',
                'Anhui Fengyang Banqaiozhen Xiazhangtang Photovoltaic solar farm',
                'Fengyang Hongyuan Photovoltaic Power Generation Co. Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Banqiao Town',
                'Fengyang County',
                'Chuzhou Municipality',
                'Anhui Fengyang Banqiaozhen Xiexin Photovoltaic solar farm',
                'Fengyang GCL Photovoltaic Power Co. Ltd.',
                'Nanjing Ruimiao New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Banqiao Town',
                'Fengyang County',
                'Chuzhou',
                'Anhui Fengyuan Banqiaozhen Zhetang solar farm',
                'Fengyang Hongyuan Photovoltaic Power Generation Co. Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanghua Town',
                'Funan County',
                'Fuyang Municipality',
                'Anhui Funan County Wanghuazhen Xindi poverty alleviation solar farm',
                'Funan GCL Photovoltaic Power Co. Ltd.',
                'Xuzhou State Asset Environmental Protection and Energy Co. Ltd. [80]; Suzhou Xiexin New Energy Investment Co. Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Wanghua Town',
                'Funan County',
                'Fuyang Municipality',
                'Anhui Funan County Wanghuazhen Xinwang poverty alleviation solar farm',
                'Funan GCL Photovoltaic Power Co. Ltd.',
                'Xuzhou State Asset Environmental Protection and Energy Co. Ltd. [80%]; Suzhou Xiexin New Energy Investment Co. Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yingdong District',
                'Fuyang',
                'Anhui Fuyang Yingdong Lvzhaicun solar farm',
                'Fuyang Hengming Solar Power Co., Ltd.',
                'CNNC (Nanjing) Energy Development Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Gengpeng Town',
                'Yingshang County',
                'Fuyang',
                'Anhui Fuyang Yingshang Gengpengzhen solar farm',
                'Yingshang Yongyang New Energy Technology Co., Ltd.',
                'Anhui Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Wusha Town',
                'Guichi District',
                'Chizhou Municipality',
                'Anhui Guichi Wushazhen Xihu fisheries Photovoltaic solar farm',
                'Chizhou Municipality Xinyang New Energy Co. Ltd.',
                'Anhui Jilin Power New Energy Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Guzhen County',
                'Bengbu Municipality',
                'Anhui Guzhen Diaoyutai Lake Photovoltaic solar farm',
                'Shanghai Electrical Equipment (Guzhen) Photovoltaic Power New Energy Co. Ltd.',
                'Shanghai Electrical Equipment (Anhui) Investment Co. Ltd. [80%]; Shengyi Holdings Investment Co. Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuncao Town',
                'Hanshan County',
                "Ma'anshan",
                'Anhui Hanshan Yuncaozhen solar farm',
                'Hanshan Wanneng Yuncao Photovoltaic Power Generation Co., Ltd.',
                'Anhui Xinneng Venture Capital Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Yijing Town',
                'Changfeng',
                'Hefei',
                'Anhui Hefei Changfeng Dachuan solar farm',
                'Hefei Dachuan New Energy Technology Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Xinzhan District',
                'Hefei',
                'Anhui Hefei Jingshang Commercial City Distributed solar farm',
                'Hefei Yuanjing Photovoltaic Power Co., Ltd.',
                'State Power Investment Corporation Shandong New Energy Co., Ltd',
              ],
              [
                'China',
                20,
                'Asia',
                'Yijing Township',
                'Changfeng County',
                'Hefei',
                'Anhui Hefei Lizhuang Reservoir solar farm',
                'Hefei Dachuan New Energy Technology Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangyuan Town',
                'Feidong County',
                'Hefei',
                'Anhui Feidong Liangyuan Jiannan solar farm',
                'Hefei Jiannan Electric Power Co., Ltd.',
                'Xuzhou Guotou Environmental Protection Energy Co., Ltd.[90%]; Suzhou GCL New Energy Investment Co., Ltd.[10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Pingpu Town',
                'Fanchang Xian',
                'Wuhu',
                'Anhui Fanchang Daihu Xinyi Guangneng solar farm',
                'Xinyi Light Energy (Fanchang) Co., Ltd.',
                'Teng Fu International Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Pingpu Town',
                'Fanchang County',
                'Wuhu',
                'Anhui Fanchang Daihu Xinyi Guangneng solar farm',
                'Xinyi Light Energy (Fanchang) Co., Ltd.',
                'Teng Fu International Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhenlongshan Mountain',
                'Dingyuan County',
                'Chuzhou Municipality',
                'Anhui Dingyuan Yongkangzhen Zhenlongshan solar farm',
                'Dingyuan Haohui Photovoltaic Power Generation Co. Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Minning Town',
                'Yongning County',
                'Yinchuan',
                'Ningxia Yongning Guoguang solar farm',
                'Ningxia Guoguang New Energy Co., Ltd.',
                'Ningxia Ningtong Fuxin Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chengjiaji Town',
                'Lixin County',
                'Bozhou',
                'Anhui Bozhou Lixin Chengjiaji Xinyi solar farm',
                'Xinyi New Energy (Bozhou) Co., Ltd.',
                'Zhixiong Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Kantuan Town',
                'Lixin',
                'Bozhou',
                'Anhui Bozhou Lixin Kantun Xinyi solar farm',
                'Xinyi New Energy (Bozhou) Co., Ltd.',
                'Zhixiong Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Kantuan Town',
                'Lixin County',
                'Bozhou',
                'Anhui Bozhou Lixin Xinyi solar farm',
                'Xinyi New Energy (Bozhou) Co., Ltd.',
                'Zhixiong Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dulongbei Reservoir',
                'Changfeng County',
                'Hefei Municipality',
                'Anhui Changfeng County Dulongbei Reservoir fisheries Photovoltaic solar farm',
                'Hefei Juriyuan Photovoltaic Electricit Generation Co. Ltd.',
                'China Nuclear Huineng Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Weilaohe Reservoir',
                'Changfeng County',
                'Hefei Municipality',
                'Anhui Changfeng County Weilaohe Reservoir solar farm',
                'Hefei Zhongjing New Energy Technology Co. Ltd.',
                'Tianjin Fuhuan Enterprise Management and Consulting Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yijing Town',
                'Changfeng County',
                'Hefei Municipality',
                'Anhui Changfeng County Yijing distributed fisheries solar farm',
                'Hefei Juriyuan Photovoltaic Electricit Generation Co. Ltd.',
                'China Nuclear Huineng Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Duji Town',
                'Changfeng County',
                'Hefei',
                'Anhui Changfeng Jidu Xijia Dam East solar farm',
                'Hefei Huimin New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yijing Township',
                'Changfeng County',
                'Hefei',
                'Anhui Hefei Shengang Reservoir solar farm',
                'Hefei Dachuan New Energy Technology Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Duji Town',
                'Changfeng County',
                'Hefei',
                'Anhui Changfeng Jidu Xijia Dam West solar farm',
                'Hefei Huimin New Energy Technology Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Changfeng County',
                'Hefei Municipality',
                'Anhui Changfeng Wadong Canal Wushanduan Reservoir fisheries solar farm',
                'Hefei Zhongxin New Energy Technology Co. Ltd.',
                'Tianjin Fuhuan Enterprise Management and Consulting Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhuangmu Town',
                'Changfeng County',
                'Hefei',
                'Anhui Changfeng Zhuangmuzhen solar farm',
                'Hefei Jinglvyuan Photovoltaic Power Generation Co., Ltd.',
                'CMEC Guolian Wuxi New Energy Development Co., Ltd. [82%]; Hefei Zhaoke Photovoltaic Power Generation Co., Ltd. [18%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhuxiang Town',
                'Changfeng County',
                'Hefei',
                'Anhui Changfeng Zhuxiangzhen Qilicun solar farm',
                'Hefei Golden Sun Energy Technology Co ., Ltd',
                'Hefei City Construction Investment holding[Group] Co., Ltd.[90%]; Hefei High New Construction Investment Group Corporation[5%]; other[5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Ba Town',
                'Chaohu County',
                'Hefei',
                'Anhui Chaohu Bazhen CGN solar farm',
                'CGN New Energy Chaohu Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Langanji Town',
                'Chaohu Municipality',
                'Hefei Municipality',
                'Anhui Chaohu Langanji "wilderness" Photovoltaic solar farm',
                'Jihu Jiaoyang New Energy Co. Ltd.',
                'China Three Gorges New Energy (Group) Shareholding Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiage Town',
                'Chaohu County',
                'Hefei',
                'Anhui Chaohu Xiagezhen Distributed solar farm',
                'Chaohu Ruige Photovoltaic Power Generation Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caozhuang Town',
                'Dangshan County',
                'Suzhou Municipality',
                'Anhui Dangshan Caozhuang Xihonghe solar farm',
                'Dangshan Xiexin (GCL) Photovoltaic Power Co. Ltd.',
                'Xuzhou State Asset Environmental Protection and Energy Co. Ltd. [90%]; Suzhou Xiexin New Energy Investment Co. Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Qilitang Town',
                'Dingyuan County',
                'Chuzhou Municipality',
                'Anhui Dingyuan Qilitang Town fisheries solar farm',
                'CGN New Energy (Dingyuan) Co., Ltd.',
                'CGN New Energy Investment (Shenzhen) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhuxiang Town',
                'Changfeng County',
                'Hefei',
                'Anhui Changfeng Sanlihe Reservoir solar farm',
                'Hefei Golden Sun Energy Technology Co ., Ltd',
                'Hefei City Construction Investment holding[Group] Co., Ltd.[90%]; Hefei High New Construction Investment Group Corporation[5%]; other[5%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhangpu Salt Field',
                'Zhangpu Xian',
                'Zhangzhou',
                'Fujian Province Zhangpu Zhuyu Fishing and Light Complementary solar farm',
                'Sungrow Power Supply Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Modian Town',
                'Xinzhan District',
                'Hefei',
                'Anhui Hefei Xinzhan District Modian solar farm',
                'Hefei Xinqiyuan Photovoltaic Power Generation Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Maoji Experimental Area',
                'Huainan',
                'Anhui Huainan Jinhui Maoji solar farm',
                'Huainan Jinhui Photovoltaic Technology Co., Ltd.',
                'Yi Yan[70.00%]; Li Xia[30.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Huigou Town',
                'Lingni County',
                'Suzhou',
                'Anhui Lingbi Huigou Lingyang solar farm',
                'Lingbi Lingyang New Energy Technology Co., Ltd. \uff08',
                'Suzhou Jinyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zouzhuang Town',
                'Lingbi County',
                'Suzhou Municipality',
                'Anhui Lingbi Louzhuang Photovoltaic solar farm',
                'Lingbi County Lingneng Photovoltaic Technology Co. Ltd.',
                'Ninghai Zhongji Guoneng New Energy Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Louzhuang Town',
                'Linbgi County',
                'Suzhou Municipality',
                'Anhui Lingbi Louzhuang Photovoltaic solar farm',
                'Lingbi County Lingneng Photovoltaic Technology Co. Ltd.',
                'Ninghai Zhongji Guoneng New Energy Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yugou Town',
                'Lingbi County',
                'Suzhou',
                'Anhui Lingbi Qinyang Yugou solar farm',
                'Lingbi Qingyang New Energy Power Generation Co., Ltd.',
                'Sunshine New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Daliji Town',
                'Lixin County',
                'Bozhou',
                'Anhui Lixin Xinyi solar farm',
                'Xinyi Solar (Bozhou) Co., Ltd.',
                'Huazhi Development Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Subu Town',
                "Yu'an District",
                "Lu'an",
                "Anhui Lu'an Yu'an solar farm",
                "Lu'an Yu'an Urban and Rural Construction Investment Group Co., Ltd.",
                "Finance Bureau of Yu'an District, Lu'an City [83.3333%]; China Agricultural Development Key Construction Fund Co., Ltd. [16.6667%]",
              ],
              [
                'China',
                20,
                'Asia',
                'Baihu Town',
                'Lujiang County',
                'Chaohu',
                'Anhui Lujiang Baihu Shengli Polder Distributed solar farm',
                'Hefei Yongju Solar Power Development Co., Ltd.',
                'Shenzhen Yongsheng New Ennergy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tongda Town',
                'Lujiang County',
                'Hefei',
                'Anhui Lujiang Chuangyuan Xuejiawei Lusheng Distributed solar farm',
                'Hefei Lusheng Solar Energy Technology Co., Ltd.',
                'Qingdao Changsheng Ridian Solar Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baihu Town',
                'Lujiang County',
                'Hefei Municipality',
                'Anhui Lujiang County Baihu Town Huanweihe fisheries solar farm',
                'Hefei Golden Sun Energy Technology Co. Ltd. Lujiang branch',
                'Hefei Golden Sun Energy Technology Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baihu Town',
                'Lujiang County',
                'Hefei Municipality',
                'Anhui Lujiang County Baihu Town Huanweihe fisheries solar farm',
                'Hefei Golden Sun Energy Technology Co. Ltd. Lujiang branch',
                'Hefei Golden Sun Energy Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Luohe Town',
                'Lujiang County',
                'Hefei',
                'Anhui Lujiang Luohe Dongfencun Distributed solar farm',
                'Lujiang Dongsheng Solar Energy Development Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Nihe Town',
                'Lujiang County',
                'Hefei Municipality',
                'Anhui Lujiang Nihezhen Balicun agricultural Photovoltaic solar farm',
                'Lujiang County Jinko Photovoltaic Electricity Generating Co. Ltd.',
                'Jinko Power Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Nihe Town',
                'Lujiang County',
                'Hefei Municipality',
                'Anhui Lujiang Nihezhen Shagangcun agricultural Photovoltaic solar farm',
                'Lujiang County Jinghai Photovoltaic Electricity Generation Co. Ltd.',
                'Jinko Power Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Nihe Town',
                'Lujiang County',
                'Hefei',
                'Anhui Lujiang Nijiangzhen Hongri solar farm',
                'Lujiang Nihe Hongri Photovoltaic Power Generation Co., Ltd.',
                'Hefei Hongri Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fanji Town',
                'Mengcheng County',
                'Bozhou',
                'Anhui Mengcheng Fanji solar farm',
                'Mengcheng Zhongsen Lvneng Solar Energy Technology Co., Ltd.',
                'East Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gugou Hui Township',
                'Panji District',
                'Huainan',
                'Anhui Panji Nihe solar farm',
                'Huainan Panyang Photovoltaic Power Generation Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gugou Hui Township',
                'Panji District',
                'Huainan',
                'Anhui Panji Tianjijiedao solar farm',
                'Huainan Panyang Photovoltaic Power Generation Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huigou Town',
                'Lingbi County',
                'Suzhou',
                'Anhui Lingbi Huigou Fengshan solar farm',
                'Lingbi Huahui New Energy Technology Co., Ltd.',
                'Suzhou Jinyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Feili Town',
                'Langxi County',
                'Xuancheng Municipality',
                'Anhui Langxi Shengshi Feili distributed Photovoltaic solar farm',
                'Langxi County Shengshi Energy Investment and Management Co. Ltd.',
                'China Energy Construction Group Investment Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Langxi County',
                'Xuancheng Municipality',
                'Anhui Langxi Shengshi Feili distributed Photovoltaic solar farm',
                'Langxi County Shengshi Energy Investment and Management Co. Ltd.',
                'China Energy Construction Group Investment Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Nanyi Lake',
                'Langxi County',
                'Xuancheng Municipality',
                'Anhui Langxi (Jinko) Photovoltaic solar farm',
                'Langxi Jinko Photovoltaic Electricity Generation Co. Ltd.',
                'Jinko Power Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gudui Town',
                'Xiejiaji District',
                'Huainan Municipality',
                'Anhui Huainan Xiejiaji fisheries solar farm',
                'Huainan Beixin Energy Technology Co. Ltd.',
                'The three individiuals Cheng Pugui [40%]; Zhu Xinhai [30%]; Dong Xin [30%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Tangshan Town',
                'Xiejiaji District',
                'Huainan',
                'Anhui Huainan Xiejiaji solar farm',
                'Huainan Zhongdian Shijiahu Photovoltaic Power Generation Co., Ltd.',
                'China Power International Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangfenggang Town',
                'Xiejiaji District',
                'Huainan',
                'Anhui Huainan Xiejiaji Wangfenggang Xinyi solar farm',
                'Xinyi Light Energy (Huainan) Co., Ltd.',
                'PROFIT NOBLE DEVELOPMENT LIMITED',
              ],
              [
                'China',
                130,
                'Asia',
                'Yaohe Town',
                'Datong District',
                'Huainan Municipality',
                'Anhui Huainan Yaohe Fishfarm "fisheries" Photovoltaic solar farm',
                'Huainan Municipal State Power Investment New Energy Co. Ltd.',
                'State Power Investment Group Anhui New Energy Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangting Town',
                'Huaining County',
                'Anqing Municipality',
                'Anhui Huaining Liangting Fangjiahu fisheries solar farm',
                'Tongwei Fisheries Solar Integrated Technology (Huaining) Co. Ltd.',
                'Tongwei New Energy Technology (Beijing) Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Changji Town',
                'Huoqiu County',
                "Liu'an Municipality",
                'Anhui Huoqiu Changjizhen agricultural Photovoltaic solar farm',
                'Huoqiu Jinko Power Co. Ltd.',
                'Jinkou Power Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Jinzhai County Modern Industries Park',
                'Jinzhai County',
                'Huainan Municipality',
                'Anhui Jinzhai (Guanggu) agricultural solar Photovoltaic power plant',
                'Jinzhai Guanggu New Energy Co. Ltd.',
                'Nanjing Pengzhicheng Mechanical and Electrical Equipment Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Baitafan Town',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai (Jinzhai Anyang) Solar Power Plant',
                'Jinzhai County Anyang Photovoltaic Power Generation Co. Ltd.',
                'China Three Gorges New Energy (Group) Shareholding Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Modian Town',
                'Xinzhan District',
                'Hefei',
                'Anhui Hefei Xinzhan District Yanhecun solar farm',
                'Hefei Xinqiyuan Photovoltaic Power Generation Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Baitafan Town',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai (Jinzhai Xinhuangming) Photovoltaic solar farm',
                'Jinzhai Xinhuangming Energy Technology Co. Ltd.',
                'Dongxu New Energy Investment Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinzhai Modern Industries Park',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai Fuhe Photovoltaic solar farm',
                'Xinyi Light Energy (Jinzhai) Co. Ltd.',
                'Tianfeng International Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai Jinye "agricultural" solar farm',
                'Jinzhai Jinye Photovoltaic Technology Co. Ltd.',
                'Jinzhai Beikong Clean Energy and Power Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baitafan Town',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai Louchongcun agricultural Photovoltaic solar farm',
                'Jinzhai Huaxi New Energy Development Co. Ltd.',
                'Shanghai Nengke Rongchuang New Energy Development Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Sungang Town',
                'Yeji Districti',
                "Liu'an Municipality",
                'Anhui Jinzhai Modern (Dade) Industrial Park agricultural solar farm',
                'Jinzhai Dade New Energy Co. Ltd.',
                'Jiangxi Province Hydro Investmen Energy Development Co. Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Sanlijing Village',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai Sanlijing Village (Huaxi) solar farm',
                'Jinzhai Huaxi New Energy Development Co. Ltd.',
                'Shanghai Nengke Rongchuang New Energy Development Co. Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Meishan Town',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai Xiwan Photovoltaic solar farm',
                'Anhui Guohua Agricultural Technology Co., Ltd.',
                'China Nuclear Huineng Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhangshan Town',
                "Lai'an County",
                'Chuzhou Municipality',
                "Anhui Lai'an Zhangshanxiang Photovoltaic solar farm",
                "Lai'an County Jinhong New Energy Technology Co. Ltd.",
                'Anhui Jinhe Enterprises Shareholding Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhangshan Town',
                'https://www.ixbang.com/content-966204.html',
                'Chuzhou Municipality',
                "Anhui Lai'an Zhangshanxiang Photovoltaic solar farm",
                "Lai'an County Jinhong New Energy Technology Co. Ltd.",
                'Anhui Jinhe Enterprises Shareholding Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baitafan Town',
                'Jinzhai County',
                "Liu'an Municipality",
                'Anhui Jinzhai (Taike) Photovoltaic solar farm',
                'Jinzhai Taike Photovoltaic Power Co. Ltd.',
                'Shanghai Shenergy New Investment Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Ganzhou District',
                'Zhangye',
                'Gansu Zhangye Ganzhou Heihe solar farm',
                'Gansu Heihe Hydropower New Energy Development Co., Ltd.',
                'Gansu Heihe Hydropower Industry Investment Co., Ltd. [54%]; Gansu Zhangye Zhaohui Real Estate Co., Ltd. [46%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Chengjiao Town',
                'Shaowu',
                'Nanping',
                'Fujian Shaowu Modern Agricultural Greenhouse solar farm',
                'Shaowu Chenghui Power Generation Co., Ltd.',
                'Qingdao Chengtou Clean Energy Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Chitu Township',
                'Zhangpu County',
                'Zhangzhou',
                'Fujian Zhangpu Lvling solar farm',
                'Zhangpu Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'China Electric Power International New Energy Holdings Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'TaipingTown',
                'Jingchuan',
                'Pingliang',
                'Gansu Province Jingchuan Huaneng solar farm',
                'Huaneng Gansu Engery Development Co., Ltd.',
                'China Huaneng Group',
              ],
              [
                'China',
                40,
                'Asia',
                'Hongliuwa Photovoltaic Industrial Park',
                'Jinta',
                'Jiuquan',
                'Gansu Province Jinta Kesheng solar farm',
                'Jinta Kesheng Photovoltaic Power Generation Co., Ltd.',
                'Jiuquan Jingke Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Guazhou County',
                'Jiuquan',
                'Gansu Province Jiuquan CGN solar farm',
                'Gansu China Guangdong Nuclear Power Co., Ltd.',
                'CGN Wind Power Company Limited[75%]; China Guangdong Nuclear Power Co., Ltd.[25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Optoelectronic Industry Park',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang CECEP Grid-Connected solar farm',
                'CECEP Solar (Dunhuang) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Huadian Grid-Connected solar farm',
                'Gansu Dunhuang Huadian Fuxin Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                "Gansu Province Jiuquan Dunhuang Jing'ao Grid-Connected solar farm",
                "Dunhuang Jing'ao Photovoltaic Power Development Co., Ltd.",
                'China Power Investment Northeast New Energy Development Co., Ltd.[50%]; Xinjiang Silk Road Kunyuan Energy Co., Ltd.[50%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                "Gansu Province Jiuquan Dunhuang Jing'ao Grid-Connected solar farm",
                "Dunhuang Jing'ao Photovoltaic Power Development Co., Ltd.",
                'China Power Investment Northeast New Energy Development Co., Ltd.[50%]; Xinjiang Silk Road Kunyuan Energy Co., Ltd.[50%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Linuo Grid-Connected solar farm',
                'Dunhuang Linuo Solar Power Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Linuo Grid-Connected solar farm',
                'Dunhuang Linuo Solar Power Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Tianrun Grid-Connected solar farm',
                'Dunhuang Tianrun New Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.[51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Wanfa Grid-Connected solar farm',
                'Dunhuang Wanfa New Energy Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qili Town',
                'Dunhuang Shi',
                'Jiuquan',
                'Gansu Province Jiuquan Dunhuang Zhengtai Grid-Connected solar farm',
                'Dunhuang Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuangta Town',
                'Guazhou Xian',
                'Jiuquan',
                'Gansu Province Jiuquan Guazhou Grid-Connected solar farm',
                'Three Gorges New Energy Jiuquan Co., Ltd.',
                'China Three Gorges New Energy (Group) Co.,Ltd.[99%]; other[1%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongliuwa Photovoltaic Estate',
                'Jinta Xian',
                'Jiuquan',
                'Gansu Province Jiuquan Jinta Hongliuwa Grid-Connected solar farm',
                'Jinta Yueshui New Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hongliuwa Photovoltaic Estate',
                'Jinta Xian',
                'Jiuquan',
                'Gansu Province Jiuquan Jinta Hongliuwa Wansheng Grid-Connected solar farm',
                'Jinta Wansheng Optoelectronics Co., Ltd.',
                'China Nuclear Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongdongtan',
                'Suzhou Qu',
                'Jiuquan',
                'Gansu Province Jiuquan Suzhou Chaoyang Grid-Connected solar farm',
                'Jiuquan Chaoyang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongdongtan',
                'Suzhou Qu',
                'Jiuquan',
                'Gansu Province Jiuquan Suzhou Sanyang Grid-Connected solar farm',
                'Jiuquan Sanyang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Ningyuanbao',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Zhongke Grid-Connected solar farm',
                'Jinchang Zhongke New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Liangzhou Aotesiwei Grid-Connected solar farm',
                'Weiwu Aotesiwei Photovoltaic Power Co., Ltd.',
                'Jiangsu Sunshine Group Co., Ltd. [99%]; Jiangsu Sunshine Group Investment Co., Ltd. [1%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Zhenxin Xipo Grid-Connected solar farm',
                'Jinchang Zhenxin Xipo Photovoltaic Power Generation Co., Ltd.',
                'Shaanxi Xinhua Water Resources and Hydropower Investment Co., Ltd. [90%]; Jiangsu Huayuan New Energy Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Zhongxin Grid-Connected solar farm',
                'Jinchang Zhongxinneng Power Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchang Huaneng Grid-connected solar farm',
                'Huaneng Renewables Corporation Limited',
                'China Huaneng Group[95%]; Huaneng Capital Service Co., Ltd.[5%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan District Xipo Qingneng Grid-Connected solar farm',
                'Jinchang Qingneng Electric Power Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Suzhou Zhongkang Electric Power Development Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan District Xipo Sinohydro Grid-Connected solar farm',
                'Sinohydro Renewable Energy Co., Ltd.',
                'China Power Construction Corporation [25%]; China Power Construction Group Zhongnan Survey and Design Institute Co., Ltd. [14%]; China Power Construction Group Kunming Survey and Design Institute Co., Ltd. [12%]; China Power Construction Group Guiyang Survey and Design Research Institute Co., Ltd. [12%]; PowerChina East China Survey and Design Research Institute Co., Ltd. [11%]; Others [26%]',
              ],
              [
                'China',
                200,
                'Asia',
                'Dongdatan Area',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Dongdatan Jintai Grid-Connected solar farm',
                'Gansu Jintai Electric Power Co., Ltd.',
                'Jinchuan Machinery Manufacturing Co., Ltd.[40%]; Zhejiang Chint New Energy Development Co., Ltd.[32.78%]; Jinko Power Co., Ltd.[15.22%]; Baye Construction Group Co., Ltd.[12%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongdatan Area',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Jintai Grid-Connected solar farm',
                'Gansu Jintai Electric Power Co., Ltd.',
                'Jinchuan Machinery Manufacturing Co., Ltd.[40%]; Zhejiang Chint New Energy Development Co., Ltd.[32.78%]; Jinko Power Co., Ltd.[15.22%]; Baye Construction Group Co., Ltd.[12%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Beside Jinwu Road',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan New Sunshine Grid-Connected solar farm',
                'Jinchang New Sunshine Photovoltaic Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Taike Grid-Connected solar farm',
                'Jinchang Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Aerospace Automobile Electromechanical Co.,Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Weisheng Grid-Connected solar farm',
                'Jinchang Weisheng Solar Energy Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.[51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Weisheng Grid-Connected solar farm',
                'Jinchang Weisheng Solar Energy Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.[51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Beside Jinwu Road',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xiehe Grid-Connected solar farm',
                'Jinchang Xiehe New Energy Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo CGN Grid-Connected solar farm',
                'CGN Solar Jinchang Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Guoneng Grid-Connected solar farm',
                'Jinchang Guoneng Solar Power Co., Ltd.',
                'East Group Co.,Ltd',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Hengji Weiye Grid-Connected solar farm',
                'Jinchang Hengji Weiye Power Development Co., Ltd.',
                'Henderson Development Group Co., Ltd.[70%]; Zhangjiagang Jiyang New Energy Co., Ltd. [70%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Huaneng Grid-Connected solar farm',
                'Huaneng Jinchang Photovoltaic Power Co., Ltd.',
                'Huaneng Gansu Engery Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Huaneng Grid-Connected solar farm',
                'Huaneng Jinchang Photovoltaic Power Co., Ltd.',
                'Huaneng Gansu Engery Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Jinyao Grid-Connected solar farm',
                'Jinchang Jinyao Power Generation Co., Ltd.',
                'Zheng Yincai[55%]; Jinchang Dongfang Industrial Development Co., Ltd.[40%]; Zhang Shaohe[5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Xipo Junwei Grid-Connected solar farm',
                'Jinchang Junwei New Energy Co., Ltd.',
                'Shanghai Bodao Electromechanical Equipment Co., Ltd.[88%]; Gansu Jintai Power Co., Ltd.[12%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchuan Zhenxin Grid-Connected solar farm',
                'Jinchang Zhenxin Photovoltaic Power Co., Ltd.',
                'CLP Sichuan [Jiangbian] Power Generation Co., Ltd.[51%]; CLP China Solar Power Project Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Liangzhou CECEP Grid-Connected solar farm',
                'CECEP Solar Energy (Wuwei) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Liangzhou CECEP Grid-Connected solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Liangzhou CECEP Grid-Connected solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Yuzhong',
                'Lanzhou',
                'Gansu Province Yuzhong Shengyang solar farm',
                'Tianjin Fanya Yuanhua New Energy Co., Ltd.',
                'Horgos Fanya Yuanhua New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Linze County',
                'Linze Xian',
                'Zhangye',
                'Gansu Province Zhangye Linze Zhongdiantou Grid-Connected solar farm',
                'Gansu China Power Investment Jineng New Energy Co., Ltd.',
                'Jilin Electric Power Co., Ltd. [71.97%]; State Power Investment Corporation Jilin Energy Investment Co., Ltd.[28.03%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Minle County',
                'Minle Xian',
                'Zhangye',
                'Gansu Province Zhangye Minle Huadian Grid-Connected solar farm',
                'Gansu Minle Huadian Fuxin Solar Power Co., Ltd.',
                'Huadian Fuxin Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangmen Town',
                'Qingshui County',
                'Tianshui',
                'Gansu Qingshui Huangmenzhen Lvdong solar farm',
                'Qingshui Lvdong New Energy Co., Ltd.',
                'State Power Investment Group Gansu New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qingyanggou',
                'Subei',
                'Jiuquan',
                'Gansu Subei Qingyanggou Hongyuan solar farm',
                'Gansu Hongyuan Photoelectric Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Suzhou',
                'Jiuquan',
                'Gansu Suzhou Asia New Energy solar farm',
                'Asia New Energy Solar Power (Jiuquan) Co., Ltd.',
                'Catic Trust Inc.,ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongdongtan',
                'Suzhou District',
                'Jiuquan',
                'Gansu Suzhou District Dongdongtan Hairun solar farm',
                'Jiuquan Hairun Photovoltaic Power Generation Co., Ltd.',
                'Jinchang Junwei New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongdong Town',
                'Suzhou District',
                'Jiuquan',
                'Gansu Suzhou District Dongdongtan Jinyige solar farm',
                'Beijing Jinyige (Jiuquan) New Energy Technology Development Co., Ltd.',
                'Jiuquan Jingzhou Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongdongtan',
                'Suzhou',
                'Jiuquan',
                'Gansu Suzhou Dongdongtan Dongfang solar farm',
                'Dongfang Electric (Jiuquan) Solar Power Generation Co., Ltd.',
                'Dongfang Electric Investment Management Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Bangluo Town',
                'Tongwei',
                'Dingxi',
                'Gansu Tongwei Jinghong Poverty Alleviation solar farm',
                'Tongwei Jinghong Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shangchuan Town',
                'Yongdeng County',
                'Lanzhou',
                'Gansu Yongdeng Hongyang solar farm',
                'Yongdeng Hongyang New Energy Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd. [51%]; Three Gorges Asset Management Co., Ltd. [49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Shangchuan',
                'Yongdeng',
                'Lanzhou',
                'Gansu Yongdeng Shangchuan Taike solar farm',
                'Lanzhou Taike Photovoltaic Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yumen Town',
                'Yumen',
                'Jiuquan',
                'Gansu Yumen Changma CECEP solar farm',
                'CECEP Solar (Jiuquan) Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Yumen Town',
                'Yumen',
                'Jiuquan',
                'Gansu Yumen Changma CECEP solar farm',
                'CECEP Solar (Jiuquan) Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yumen',
                'Yumen',
                'Jiuquan',
                'Gansu Yumen Yumen Cecep solar farm',
                'CECEP Solar (Jiuquan) Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yumendong',
                'Yumen',
                'Jiuquan',
                'Gansu Yumen Yumendong Yonglian solar farm',
                'Yumen Yonglian Technology New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yumen',
                'Jiuquan',
                'Gansu Yumen Zhongke Hengyuan solar farm',
                'Zhongke Hengyuan (Yumen) New Energy Technology Co., Ltd.',
                'Zhongke Hengyuan Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yumen City',
                'Yumen',
                'Gansu Province Yumen Huadian solar farm',
                'China Huadian Group Corporation',
                'China Huadian Group Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yumen City',
                'Yumen',
                'Gansu Province Yumen Datang solar farm',
                'China Datang Corporation',
                'China Datang Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yumen City',
                'Yumen',
                'Gansu Province Yumen CNNC solar farm',
                'China National Nuclear Corporation',
                'China National Nuclear Corporation',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Yumen City',
                'Yumen',
                'Gansu Province Yumen CECEP solar farm',
                'China Energy Conservation and Environmental Protection Group Co., Ltd.',
                'China Energy Conservation and Environmental Protection Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Liangzhou Zhongdiantou Grid-Connected solar farm',
                'Gansu China Power Investment New Energy Power Generation Co., Ltd.',
                'Qinghai Huanghe Hydropower Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Nima',
                'Maqu',
                'Gannan Tibetan Autonomous Prefecture',
                'Gansu Province Maqu solar farm',
                'Dongfang Electric Auto Control Engineering Co., Ltd.',
                'Dongfang Electric Corporation Limited[43%]; Dongfang Electric Machinery Company Limited[19.8%]; Dongfang Turbine Co., Ltd.[18.7%]; Dongfang Boiler [Group] Co.,Ltd.[18.7%]; Deyang Economic and Technology Development Area State-Owned Assets Management Co., Ltd.[0.1%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Minghua Town',
                'Gannan Yugu Xian',
                'Zhangye',
                'Gansu Province Sunan Liuguduntan Grid-Connected solar farm',
                'Sunan Yugu Autonomous County Zhongneng Industrial Park Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Wuwei Hongshagang CECEP Grid-Connected solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Wuwei Hongshagang Huineng Grid-Connected solar farm',
                'Gansu Minqin Huineng New Energy Development Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Wuwei Hongshagang Liangzi Grid-Connected solar farm',
                'Minqin Liangzi New Energy Co., Ltd.',
                'Shenzhen Huayi Education Investment Consulting Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Wuwei Hongshagang Rize Grid-Connected solar farm',
                'Wuwei Aerospace Rize New Energy Development Co., Ltd.',
                'Gansu Aerospace New Energy Investment Group Co., Ltd.[42%]; Beijing Rize New Energy Technology Development Co., Ltd.[40%]; Wuwei Aerospace Wanyuan Motor Manufacturing Co., Ltd.[18%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Dongrun Grid-Connected solar farm',
                'Wuwei Dongrun Solar Energy Development Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchang Guoyuan Grid-Connected solar farm',
                'Jinchang Guoyuan Electric Power Co., Ltd.',
                'Shaanxi Xinhua Water Conservancy and Hydropower Investment Co., Ltd.[70%]; Jiawei Renewable Energy Co., Ltd.[30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Huadong Zhonghe Grid-Connected solar farm',
                'Wuwei Huadong Zhonghe New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Runfeng Grid-Connected solar farm',
                'Wuwei Runfeng Electric Power Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Runfeng Grid-Connected solar farm',
                'Wuwei Runfeng Electric Power Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Sinohydro Grid-Connected solar farm',
                'China Hydropower Construction Group Wuwei Photovoltaic Power Co., Ltd.',
                'Sinohydro Guazhou Wind Power Co., Ltd. [80%]; China Hydropower Construction Group New Energy Development Co., Ltd.[20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Hexibao Town',
                'Yongchang Xian',
                'Jinchang',
                'Gansu Province Yongchang Dazhaitan Grid-Conneted solar farm',
                'Three Gorges New Energy Jinchang Wind Power Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hexibao Town',
                'Yongchang Xian',
                'Jinchang',
                'Gansu Province Yongchang Heqingtan Grid-Conneted solar farm',
                'Three Gorges New Energy Jinchang Wind Power Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hexibao Town',
                'Yongchang Xian',
                'Jinchang',
                'Gansu Province Yongchang Xiehe Grid-Conneted solar farm',
                'Yongchang Xiehe Solar Power Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hexibao Town',
                'Yongchang Xian',
                'Jinchang',
                'Gansu Province Yongchang Zhengtai Grid-Conneted solar farm',
                'Yongchang Chint Photovoltaic Power Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Hexibao Town',
                'Yongchang Xian',
                'Jinchang',
                'Gansu Province Yongchang Zhengtai Grid-Conneted solar farm',
                'Yongchang Chint Photovoltaic Power Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Fengle Town',
                'Liangzhou Qu',
                'Wuwei',
                'Gansu Province Wuwei Liangzhou Jiuyuan Grid-Connected solar farm',
                'Wuwei Jiuyuan Metal Components Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xipo Photovoltaic Estate',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchang Guoyuan Grid-Connected solar farm',
                'Jinchang Guoyuan Electric Power Co., Ltd.',
                'Shaanxi Xinhua Water Conservancy and Hydropower Investment Co., Ltd.[70%]; Jiawei Renewable Energy Co., Ltd.[30%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Ningyuanbao Town',
                'Jinchuan District',
                'Jinchang',
                'Gansu Province Jinchang Disheng Grid-Connected solar farm',
                'Jinchang Disheng Solar Power Co., Ltd.',
                'Gansu Jintai Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Province Jiiayuguan Xigebi CGN solar farm',
                'CGN Solar Energy Jiayuguan Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liuyuan Town',
                'Guazhou County',
                'Jiuquan',
                'Gansu Guazhou Liuyuan Guangyuan solar farm',
                'Guazhou Light Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Hongshagang Town',
                'Minqin County',
                'Wuwei',
                'Gansu Guazhou Weiwu Poverty Alleviation solar farm',
                'Wuwei Yineng Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Hongshagang Town',
                'Minqin County',
                'Wuwei',
                'Gansu Guazhou Weiwu Poverty Alleviation solar farm',
                'Wuwei Yineng Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huanghuatan Town',
                'Gulang County',
                'Wuwei',
                'Gansu Gulang Weiwu Taifeng Poverty Alleviation solar farm',
                'Wuwei Taifeng New Energy Co., Ltd.',
                'Wuwei Vocational College',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Jiayuguan Xigebi Xiehe solar farm',
                'Jiayuguan Xiehe New Energy Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Jiayuguan Zhengtai solar farm',
                'Jiayuguan Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Jiayuguan Zhengtai solar farm',
                'Jiayuguan Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jiaxi Photovoltaic Industrial Park',
                'Jiayuguan',
                'Gansu Jiayyuguan Linuo solar farm',
                'Jiayuguan Lino Solar Power Technology Co., Ltd.',
                'Shandong Shuifa Comprehensive Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xipo',
                'Jinchuan District',
                'Jinchang',
                'Gansu Jinchuan District Xipo Zhenxin solar farm',
                'Jinchang Zhenxin Xipo Photovoltaic Power Generation Co., Ltd.',
                'Shaanxi Xinhua Water Resources and Hydropower Investment Co., Ltd. [90%]; Jiangsu Huayuan New Energy Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                25,
                'Asia',
                'Xipo',
                'Jinchuan District',
                'Jinchang',
                'Gansu Jinchuan District Xipo Zhenxin solar farm',
                'Jinchang Zhenxin Xipo Photovoltaic Power Generation Co., Ltd.',
                'Shaanxi Xinhua Water Resources and Hydropower Investment Co., Ltd. [90%]; Jiangsu Huayuan New Energy Technology Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jinchuan',
                'Jinchang',
                'Gansu Jinchuan Huaneng solar farm',
                'Huaneng Gansu Jinchang New Energy Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Jinchuan',
                'Jinchang',
                'Gansu Jinchuan Huaneng solar farm',
                'Huaneng Gansu Jinchang New Energy Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongliuwa Town',
                'Jinta County',
                'Jiuquan',
                'Gansu Jinta Hengyuan solar farm',
                'Hengyuan (Jinta) Golden Sun Power Co., Ltd.',
                'Gansu Huajie Electric Power Installation Engineering Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Hongliuwa',
                'Jinta County',
                'Jiuquan',
                'Gansu Jinta Hongliuwa Yueshuidian solar farm',
                'Jinta Yueshui New Energy Co., Ltd.',
                'Xinjiang Yue Hydropower Energy Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Hongliuwa',
                'Jintai County',
                'Jiuquan',
                'Gansu Jinta Jingri solar farm',
                'Jinta Jingri New Energy Co., Ltd.',
                'State Power Investment Group Gansu New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shangshawo Town',
                'Jingtai County',
                'Baiyin',
                'Gansu Jintai Shangshawozhen solar farm',
                'Jingtai Matrix New Energy Co., Ltd.',
                'Wuxi Dongyi Photoelectric Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Jinta',
                'Jiuquan',
                'Gansu Jiuquan Jinta Chint solar farm',
                'Jinta Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chengguan Town',
                'Gaotai County',
                'Zhangye',
                'Gansu Gaotai Goayazitan Huahao solar farm',
                'Gaotai Huahao Environmental Protection Energy Development Co., Ltd.',
                'Tang Zhiyu',
              ],
              [
                'China',
                40,
                'Asia',
                'Gaoyazitan',
                'Gaotai',
                'Zhangye',
                'Gansu Gaotai Gaoyazitan Gaoshan solar farm',
                'Gansu Gaoshan New Energy Co., Ltd.',
                'Gansu Jintai Power Co., Ltd. [75%]; Jinchang Junwei New Energy Co., Ltd. [25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ganzhou',
                'Zhangye',
                'Gansu Ganzhou Heihe solar farm',
                'Gansu Heihe Hydropower New Energy Development Co., Ltd.',
                'Gansu Heihe Hydropower Industrial Investment Co., Ltd. [53.8%]; Gansu Zhangye Zhaohui Real Estate Co., Ltd. [46.2%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Three Gorges solar farm',
                'Three Gorges New Energy Dunhuang Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Dongping Town',
                'Zhenghe County',
                'Nanping',
                'Fujian Zhenghe Dongping Agricultural Greenhouse solar farm',
                'Zhenghe Donghui Power Generation Co., Ltd.',
                'Shanghai Brilliance New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Aksay',
                'Jiuquan',
                'Gansu Aksay Zhongneng solar farm',
                'Zhongneng Sangpu Aksai County Technology Co., Ltd.',
                'Wuhan Hongjixin Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shawo Town',
                'Jingtai',
                'Baiyin',
                'Gansu Baiying Zhongdian solar farm',
                'Gansu Zhongdian Baiyin Photovoltaic Power Generation Co., Ltd.',
                'China Power (New Energy) Holdings Co., Ltd. [51%]; CLP International New Energy Holdings Co., Ltd. [49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Shawo Town',
                'Jingtai',
                'Baiyin',
                'Gansu Baiying Zhongdian solar farm',
                'Gansu Zhongdian Baiyin Photovoltaic Power Generation Co., Ltd.',
                'China Power (New Energy) Holdings Co., Ltd. [51%]; CLP International New Energy Holdings Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Lujiagou Town',
                'Anding District',
                'Dingxi',
                'Gansu Dingxi Minghui solar farm',
                'Dingxi Minghui New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dunhuang Photoelectricity Park',
                'Dunhuang',
                'Gansu Dunhuan CECEP solar farm',
                'CECEP Solar Energy (Dunhuang) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dunhuang Photoelectricity Park',
                'Dunhuang',
                'Gansu Dunhuan CECEP solar farm',
                'CECEP Solar Energy (Dunhuang) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Anji solar farm',
                'Dunhuang Anjie New Energy Co., Ltd.',
                'Hunan Shuifa Xingye Green Energy Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Dongdong Town',
                'Suzhou District',
                'Jiuquan',
                'Gansu Jiuquan Suzhou District CECEP 25MW solar farm',
                'CECEP Solar Energy (Gansu) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Guangheng solar farm',
                'Gansu Guangheng New Energy Co., Ltd.',
                'Luneng New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Huadian solar farm',
                'Gansu Dunhuang Huadian Fuxin Solar Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Huineng solar farm',
                'Dunhuang Power Construction Huineng New Energy Power Generation Co., Ltd.',
                'Sinohydro Guazhou Wind Power Co., Ltd. [55%]; China Hydropower Construction New Energy Development Co., Ltd. [25%]; Shanghai Electric Power Design Institute Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Qili Town',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Jintai Chengzhi solar farm',
                'Dunhuang Jintai Chengzhi New Energy Co., Ltd.',
                'Dunhuang Yuanshun Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qili Town',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Molten Salt Tower solar farm',
                'Dunhuang Shouhang Energy Saving New Energy Co., Ltd.',
                'Shouhang High-Tech Energy Co., Ltd',
              ],
              [
                'China',
                20,
                'Asia',
                'Qili',
                'Dunhuang',
                'Zhangye',
                'Gansu Dunhuang Qili Asia New Energy solar farm',
                'Asia New Energy (Dunhuang) Solar Power Co., Ltd.',
                'Gansu Smart Energy Development Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Qili Town',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Qilizhen Wanfa solar farm',
                'Dunhuang Wanfa New Energy Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Sinohydro solar farm',
                'Sinohydro Dunhuang Photovoltaic Power Generation Co., Ltd.',
                'Sinohydro Renewable Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Sinohydro solar farm',
                'Sinohydro Dunhuang Photovoltaic Power Generation Co., Ltd.',
                'Sinohydro Renewable Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qili Town',
                'Dunhuang',
                'Jiuquan',
                'Gansu Dunhuang Hande solar farm',
                'Dunhuang Hande Photovoltaic New Energy Co., Ltd.',
                'Jiuquan Tianbao New Energy Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jiuxian Town',
                'Songxi County',
                'Nanping',
                'Fujian Songxi Jiuxian Xiaduan solar farm',
                'Nanping Xinyi New Energy Management Co., Ltd.',
                'CHEER KING INVESTMENTS LIMITED',
              ],
              [
                'China',
                49,
                'Asia',
                'Dongdong Town',
                'Suzhou District',
                'Jiuquan',
                'Gansu Jiuquan Suzhou District CECEP 49MW solar farm',
                'CECEP Solar Energy (Gansu) Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Liangzhou District',
                'Wuwei',
                'Gansu Liangzhou Fengle Chenxu solar farm',
                'Gansu Power Investment Chenxu Liangzhou Solar Power Generation Co., Ltd.',
                'Gansu Jiuquan Huineng Wind Power Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Malutan',
                'Gulang Xian',
                'Wuwei',
                'Gansu Province Gulang Malutan Grid-Connected solar farm',
                'Gulang Lvzhou Photovoltaic Power Co., Ltd.',
                'Shaanxi Xinhua Water Conservancy and Hydropower Investment Co., Ltd.[80%]; Jiawei (Shanghai) Photovoltaic Power Co., Ltd.[20%]',
              ],
              [
                'China',
                350,
                'Asia',
                'Malutan',
                'Gulang Xian',
                'Wuwei',
                'Gansu Province Gulang Malutan Grid-Connected solar farm',
                'Jiangsu Zhenfa Holding Group Co., Ltd.',
                'Zha Zhengfa',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Hezuo City',
                'Hezuo',
                'Gansu Province Hezuo CNOOC solar farm',
                'CNOOC Rongfeng Energy Co., Ltd.',
                'CNOOC (China) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Chint Grid-Connected solar farm',
                'Minqin Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Guoneng Grid-Connected solar farm',
                'Minqin Guoneng Solar Power Co., Ltd.',
                'East Group Co.,Ltd',
              ],
              [
                'China',
                40,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Huadian Grid-Connected solar farm',
                'Gansu Huadian Minqin Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Shenneng Grid-Connected solar farm',
                'Wuwei Shenneng North Energy Development Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Tianhe Grid-Connected solar farm',
                'Wuwei Tianhe Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Yineng Grid-Connected solar farm',
                'Wuwei Yineng Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshagang Town',
                'Minqin Xian',
                'Wuwei',
                'Gansu Province Hongshagang Zhongnengyuan Grid-Connected solar farm',
                'Gansu Zhongneng Power Development Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Jiaxi Photovoltaic Industrial Park',
                'Jiayuguan',
                'Gansu Province Jiayuguan Taike Grid-Connected solar farm',
                'Jiayuguan Taike Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Jiaxi Photovoltaic Industrial Park',
                'Jiayuguan',
                'Gansu Province Jiayuguan Taike Grid-Connected solar farm',
                'Jiayuguan Taike Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Province Jiayuguan Xigebi Guoneng Grid-Connected solar farm',
                'Jiayuguan Guoneng Solar Power Co., Ltd.',
                'East Group Co.,Ltd',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Province Jiayuguan Xigebi Hanji Guoneng solar farm',
                'Jiayuguan Hanji Guoneng New Energy Co., Ltd.',
                'China Power Investment Northeast New Energy Development Co., Ltd.[70%]; Tianhong Sunshine New Energy Investment Co.,Ltd.[30%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Jiayuguan',
                'Gansu Province Jiayuguan Xigebi Huadian Grid-Connected solar farm',
                'Huadian Jiayuguan New Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.[80%]; Shanghai Aerospace Automobile Electromechanical Co.,Ltd.[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Jiaxi Photovoltaic Industrial Park',
                'Jiayuguan',
                'Gansu Province Jiayuguan Zhongli Talesun Grid-Connected solar farm',
                'Zhongli Talesun (Jiayuguan) Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Huida Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Jiaxi Photovoltaic Industrial Park',
                'Jiayuguan',
                'Gansu Province Jiayuguan Zhongli Talesun Grid-Connected solar farm',
                'Zhongli Talesun (Jiayuguan) Photovoltaic Power Generation Co., Ltd.',
                'Qinghai Huida Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Malutan',
                'Gulang Xian',
                'Wuwei',
                'Gansu Province Gulang Malutan Grid-Connected solar farm',
                'Gulang Zhenye Desert Photovoltaic Power Co., Ltd.',
                'Shaanxi Xinhua Water Conservancy and Hydropower Investment Co., Ltd.[80%]; Jiawei [Shanghai] Photovoltaic Power Co., Ltd.[20%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Nanhua Town',
                'Gaotai Xian',
                'Zhangye',
                'Gansu Province Gaotai Gaoyazitan Zhongdiantou Grid-Connected solar farm',
                'Gansu China Power Investment Jiineng New Energy Co., Ltd. Gaotai Branch',
                'Gansu China Power Investment Jineng New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Nanhua Town',
                'Gaotai Xian',
                'Zhangye',
                'Gansu Province Gaotai Gaoyazitan Taike Grid-Connected solar farm',
                'Gaotai Taike Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Nanhua Town',
                'Gaotai Xian',
                'Zhangye',
                'Gansu Province Gaotai Gaoyazitan Huineng Grid-Connected solar farm',
                'Gansu Gaotai Huineng New Energy Development Co., Ltd.',
                'Gansu Jiuquan Huineng Wind Power Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Fengle Town',
                'Liangzhou District',
                'Weiwu',
                'Gansu Liangzhou Lefeng Zhongdian solar farm',
                'Gansu Zhongdian Wuwei Photovoltaic Power Generation Co., Ltd.',
                'China Power (New Energy) Holdings Co., Ltd. [51%]; CLP International New Energy Holdings Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Nandatan',
                'Liangzhou',
                'Weiwu',
                'Gansu Liangzhou Nandatan CECEP solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Liangzhou District',
                'Weiwu',
                'Gansu Liangzhou Nandatan CECEP solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Linze',
                'Zhangye',
                'Gansu Linze Huadian solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Linze',
                'Zhangye',
                'Gansu Linze TBEA solar farm',
                'TBEA Linze New Energy Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Nima Town',
                'Maqu County',
                'Gannan Tibetan Autonomous Prefecture',
                "Gansu Maqu Nimazhen Bai'er solar farm",
                "Maqu Bai'er New Energy Co., Ltd.",
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Minle',
                'Zhangye',
                'Gansu Minle Tianju solar farm',
                'Gansu Tianju Shigangdun Solar Power Generation Co., Ltd.',
                'Hainan Tianju Solar Energy Co., Ltd. [95%]; other [5%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Hongshagang',
                'Minqin',
                'Wuwei',
                'Gansu Minqin Hongshagang Huadian solar farm',
                'Gansu Huadian Minqin Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Liangzhou',
                'Wuwei',
                'Gansu Liangzhou Cecep solar farm',
                'CECEP Gansu Wuwei Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Aksay Kazakh Autonomous County',
                'Jiuquan',
                'Gansu Province Aksai Chint solar farm',
                'Aksai Chint Photovoltaic Power Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Anding District',
                'Dingxi',
                'Gansu Province Dingxi Anding District solar farm',
                'Dingxi CNBM Optoelectronic Materials Co., Ltd.',
                'Dingxi State-owned Investment (Holding) Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Longxi',
                'Dingxi',
                'Gansu Province Dingxi Longxi solar farm',
                'CSCEC Aerospace Hydrogen Energy Industry Investment Holding Group (Dingxi) Co., Ltd.',
                'CSCEC Aerospace Hydrogen Energy Industry Investment Holding Group [Gansu] Co., Ltd.[85%]; Dingxi New Energy Development Co., Ltd.[15%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Tongwei',
                'Dingxi',
                'Gansu Province Dingxi Tongwei solar farm',
                'Dingxi New Energy Development Co., Ltd.',
                'Dingxi State-owned Investment (Holding) Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zhangxian',
                'Dingxi',
                'Gansu Province Dingxi Zhangxian solar farm',
                'Dingxi New Energy Development Co., Ltd.',
                'Dingxi State-owned Investment (Holding) Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongle Town',
                'Shandan Xian',
                'Zhangye',
                'Gansu Province Dongle Beitan Longhui Grid-Connected solar farm',
                'Shandan County Longhui New Energy Investment Co., Ltd.',
                'Aksai Fengdian New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Dongle Town',
                'Shandan Xian',
                'Zhangye',
                'Gansu Province Dongle Beitan Xiehe Grid-Connected solar farm',
                'Shandan Xiehe Solar Power Generation Co., Ltd.',
                'Hainan Tianju Solar Energy Co., Ltd.[95%]; other[5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Ganzhou Qu',
                'Zhangye',
                'Gansu Province Ganzhou Heihe Grid-Connected solar farm',
                'Gansu Heihe Hydropower New Energy Development Co., Ltd.',
                'Gansu Heihe Hydropower Industry Investment Co., Ltd.[54%]; Gansu Zhangye Zhaohui Real Estate Co., Ltd.[46%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Nanhua Town',
                'Gaotai Xian',
                'Zhangye',
                'Gansu Province Gaotai Gaoyazitan Chint Grid-Connected solar farm',
                'Gaotai Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Wuhe Xuiang',
                'Jingyuan Xian',
                'Baiyin',
                'Gansu Province Baiyin Jingyuan solar farm',
                'Gansu Deyou Energy Technology Co., Ltd.',
                'Shanghai Lingyun Industries Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Caisang Town',
                'Unavailable',
                'Linzhou',
                'Hennan Linzhou Caisangzhen JA solar farm',
                "Linzhou Jing'ao Photovoltaic Power Generation Co., Ltd.",
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengle Town',
                'Liangzhou District',
                'Weiwu',
                'Gansu Liangzhou Lefeng Zhongdian Special Permit solar farm',
                'Gansu Zhongdian Wuwei Photovoltaic Power Generation Co., Ltd.',
                'China Power (New Energy) Holdings Co., Ltd. [51%]; CLP International New Energy Holdings Co., Ltd. [49%]',
              ],
              [
                'China',
                90,
                'Asia',
                'Fangfan',
                'Dawu',
                'Xiaogan',
                'Hubei Dawu Fangfan Green Energy solar farm',
                'Dawu Green Energy Industry Development Investment Co., Ltd.',
                'Hubei New Energy Investment Co., Ltd. [51%]; Dawu Xingxin Energy Investment Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Tangzhou Town',
                'Taihe County',
                "Ji'an",
                "Jiangxi Ji'an Taihe Jiangzhou solar farm",
                "Ji'an Jiangtai Photovoltaic Power Generation Co., Ltd.",
                'Chongqing Huizhiyuan Co., Ltd. [70.00%]; Zhejiang Chint New Energy Development Co., Ltd. [30.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Renshou Town',
                "Jing'an County",
                'Yichun',
                "Jiangxi Jing'an Renshou SPIC solar farm",
                "State Power Investment Group Jiangxi Electric Power Co., Ltd. Jing'an Photovoltaic Power Generation Branch",
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Renshou Town',
                "Jing'an County",
                'Yichun',
                "Jiangxi Jing'an solar farm",
                "Jiangxi Electric Power Co., Ltd. of State Power Investment Group Jing'an Photovoltaic Power Generation Branch",
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiabuji Township',
                'Jinxian County',
                'Nanchang',
                'Jiangxi Jinxian Xiabuji solar farm',
                'Jiangxi Chuangxin New Energy Co., Ltd.',
                'Zhao Qi[75.00%]; Hu Yishun[10.00%];Chen Jianhua[10.00%];Tang Mengzhi[5.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yujiang County',
                'Yingtan',
                'Jiangxi Jinyu Power Distributed solar farm',
                'Yujiang Jinyu Electric Power Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Saichenghu Aquatic Farm',
                'Balihu New District',
                'Jiujiang',
                'Jiangxi Jiujiang Jinko Saichenghu solar farm',
                'Jiujiang Balihu New District Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Saichenghu Aquatic Farm',
                'Balihu New District',
                'Jiujiang',
                'Jiangxi Jiujiang Jinko Saichenghu solar farm',
                'Jiujiang Balihu New District Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Madang Town',
                'Pengze County',
                'Jiujiang',
                'Jiangxi Jiujiang Pengze solar farm',
                'Jiangxi Pengze Gan Nuclear Photovoltaic Co., Ltd.',
                'Jiangxi Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Gangkou Town',
                'Jiujiang County',
                'Jiujiang',
                'Jiangxi Jiujiang Saichenghu solar farm',
                'Jiujiang Jinke Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Luci Town',
                'Leping',
                'Jingdezhen',
                'Jiangxi Leping CECEP Photovoltaic Agricultural solar farm',
                'CECEP (Leping) Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Gaojia',
                'Leping',
                'Jingdezhen',
                'Jiangxi Leping Gaojia SPIC solar farm',
                'State Power Investment Group Jiangxi Leping New Energy Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Luci',
                'Leping',
                'Jingdezhen',
                'Jiangxi Leping Luci Cecep solar farm',
                'CECEP (Leping) Photovoltaic Agricultural Technology Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Luci Town',
                'Leping',
                'Jingdezhen',
                'Jiangxi Leping Luci SPIC solar farm',
                'State Power Investment Group Jiangxi Leping New Energy Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xuanfeng Town',
                'Luxi County',
                'Pingxiang',
                'Jiangxi Luxi Xuanfengzhen Distributed solar farm',
                'Pingxiang Fangda Luxin New Energy Co., Ltd.',
                'Shenzhen Fangda New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangma Township',
                'Nanchang County',
                'Nanchang',
                'Jiangxi Nanchang Huangmaxiang solar farm',
                'ongwei Yuguang Integrated Nanchang Co., Ltd.',
                'Tongwei New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Jiangxiang Town',
                'Nanchang County',
                'Nanchang',
                'Jiangxi Nanchang Jiangxiang Sandonghu solar farm',
                'Nanchang Lvchuan New Energy Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Jiangxiang Town',
                'Nanchang County',
                'Nanchang',
                'Jiangxi Nanchang Jiangxiang Sandonghu solar farm',
                'Nanchang Lvchuan New Energy Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhoutian Town',
                'Huichang County',
                'Ganzhou',
                'Jiangxi Huichang Zhoutian solar farm',
                'Huichang Xinhui Energy Co., Ltd.',
                'Huang Lu[65.00%]; Huichang Xinghui Technology Innovation Group Co., Ltd. [33.00%]; Others[2.00%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Ningdong Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Yinchuan Ningdong Shanghai Aerospace Machinery solar farm',
                'Ningxia Ningdong Shenzhou Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yangjia',
                'Hengfeng',
                'Shangrao',
                'Jiangxi Hengfeng Yangjia Jingke solar farm',
                'Hengfeng Jingke Electric Power Co., Ltd.',
                'SDIC Power Holdings CO., LTD. [90%]; Jiangxi Ganneng Co.,Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Liukou Town',
                'Guixi',
                'Yingtan',
                'Jiangxi Guixi Liukouzhen CECEP solar farm',
                'CECEP Guixi Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Youfang Town',
                'Yangzhong Municipality',
                'Zhenjiang Municipality',
                'Jiangsu Zhenjiang Tongwei solar farm',
                'Zhenjiang Tongwei Huantai Huijin New Energy Co. Ltd.',
                'Tongwei Huantai Huijin New Energy Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Taicang Municipality',
                'Changzhou Municipality',
                'Jiangxu Taicang solar Photovoltaic power plant',
                'Huaneng Taicang Power Generation Co., Ltd.',
                'Huaneng International Power Jiangsu Energy Development Co. Ltd. [75%]; Suzhou Industrial Park Area Zhongxin Energy Development Co. Ltd. [10%]; Zhongxin Suzhou Industrial Park Municipal Infrastructure Development Group Co. Ltd. [6%]; Jiangsu Province Guoxin Group Co. Ltd. [5%]; Taicang Municipal Jinkong Development Co. Ltd. [4%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Chenjiagang Town',
                'Xiangshui County',
                'Yancheng Municipality',
                'Jiangxu Xiangshui Hengzhao solar Photovoltaic power plant',
                'Jiangsu Hengzhao New Energy Co., Ltd.',
                'Jiangsu Yinbao Holdings Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Bashan Town',
                'Chongren County',
                'Fuzhou',
                'Jiangxi Chongren Bashan solar farm',
                'Chongren Xiangyang New Energy Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liujiaqiao Township',
                'Chongren County',
                'Fuzhou',
                'Jiangxi Chongren Liujiaqiaoxiang solar farm',
                'Chongren Aikang New Energy Technology Co., Ltd.',
                'State Power Investment Corporation Fujian New Energy Co., Ltd. [60.00%]; Beijing Daxiang Investment Group Co., Ltd. [40.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Mawei Town',
                'Dongxiang County',
                'Fuzhou',
                'Jiangxi Dongxiang Mawei Jingke solar farm',
                'Fuzhou Dongxiang Jingke Electric Power Co., Ltd.',
                'Zhejiang Zhejing Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Zhanxu Town',
                'Dongxiang District',
                'Fuzhou',
                'Jiangxi Dongxiang Zhanyuzhen solar farm',
                'Fuzhou Dongxiang Beilou New Energy Technology Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Duchang Town',
                'Duchang County',
                'Jiujiang',
                'Jiangxi Duchang Jishanhu solar farm',
                'Duchang Longneng Power Development Co., Ltd.',
                'Zhejiang Longneng Electric Power Technology Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Duchang County',
                'Jiujiang',
                'Jiangxi Duchang Jishanhu solar farm',
                'Duchang Longneng Power Development Co., Ltd.',
                'Zhejiang Longneng Electric Power Technology Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Yuejin Reservoir',
                'Fengxin County',
                'Yichun',
                'Jiangxi Fengxin Yuejin Reservior solar farm',
                'Fengxin Taiming Photovoltaic Power Co., Ltd.',
                'Jiangxi Taiming Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengxin County',
                'Fengxin County',
                'Yichun',
                'Jiangxi Fengxin Yuejin Reservior solar farm',
                'Fengxin Taiming Photovoltaic Power Co., Ltd.',
                'Jiangxi Taiming Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Zhanxu Town',
                'Dongxiang District',
                'Fuzhou',
                'Jiangxi Fuzhou Dongxiang District Beilou solar farm',
                'Fuzhou Dongxiang Beilou New Energy Technology Co., Ltd.',
                'Jinkai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wenwuba Town',
                'Huichang County',
                'Ganzhiu',
                'Jiangxi Ganzhou Leixin Distributed solar farm',
                'Ganzhou Leixin Energy Technology Development Co., Ltd.',
                'Shenzhen Leixin Technology Co., Ltd. [65%]; Shenzhen Jinmancheng Technology Co., Ltd. [25%]; Shenzhen Jingong Business Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Jianshan Town',
                "Gao'an",
                'Yichun',
                "Jiangxi Gao'an Jinjian Distributed solar farm",
                "Gao'an Jinjian Power Generation Co., Ltd.",
                'Shanghai Guozhijie Intelligent Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiangcheng Town',
                "Gao'an",
                'Yichun',
                "Jiangxi Gao'an Xiangcheng solar farm",
                'Gaoan Xiangcheng Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Water Investment Energy Development Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Tianlu Town',
                'Guixi',
                'Yingtan',
                'Jiangxi Guixi Binjiangzhen solar farm',
                'Guixi Shenyang New Energy Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liukou Town',
                'Guixi',
                'Yingtan',
                'Jiangxi Guixi Duimenling solar farm',
                'China Energy Conservation and Environmental Protection Group Guixi Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Guixi',
                'Jiangxi Guixi Power Plant Leigongling Ash Field solar farm',
                'CPI Jiangxi Electric Power Co., Ltd. Guixi Photovoltaic Power Generation Branch',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaokeng Town',
                'Anyuan District',
                'Pingxiang',
                'Jiangxi Pingxiang Gaokeng solar farm',
                'Pingxiang JiangNeng Photovoltaic Power Co., Ltd.',
                'Jiangxi Ganzhe Energy Co., Ltd. [65.00%]; Pingxiang Mining Group Co., Ltd. [35.00%]',
              ],
              [
                'China',
                120,
                'Asia',
                'Raofeng Town',
                'Poyang County',
                'Shangrao',
                'Jiangxi Poyang Raofeng Jingke solar farm',
                'Poyang Jinko Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Tianfanjie Town',
                'Poyang County',
                'Shangrao',
                'Jiangxi Poyang Xingyang New Energy solar farm',
                'Poyang Xingyang New Energy Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingqian Town',
                'Shangyou County',
                'Ganzhou',
                'Jiangxi Shangyou Yingqianzhen solar farm',
                'Shangyou Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Qinjiang Town',
                'Shicheng County',
                'Ganzhou',
                'Jiangxi Shicheng Hankeng solar farm',
                'Shicheng GCL Photovoltaic Power Co., Ltd.',
                'Chongqing Lvxin Energy Development Co., Ltd. [70.00%]; Shicheng County Ganjiangyuan Agricultural Development Co., Ltd. [30.00%]',
              ],
              [
                'China',
                21,
                'Asia',
                'Yutian Town',
                'Suichuan County',
                "Ji'an",
                'Jiangxi Suichuan Agriculture-Light Complementary solar farm',
                'Suichuan Xingye Green Energy Technology Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Mashi Town',
                'Taihe County',
                "Ji'an",
                'Jiangxi Taihe Mashizhen solar farm',
                'Taihe Zhanyu Photovoltaic Power Co., Ltd.',
                'State Power Investment Corporation Jiangxi Electric Power Co., Ltd. [70.00%]; Jiangxi Zhanyu New Energy Co., Ltd. [30.00%]',
              ],
              [
                'China',
                22,
                'Asia',
                'Wanhe Town',
                'Taihe County',
                "Ji'an",
                'Jiangxi Taihe Wanhe solar farm',
                'Taihe Chuangneng Photovoltaic Co., Ltd.',
                'Jiangxi Expressway Power Construction New Energy Co., Ltd. [51.00%]; Jiangxi Tongli Risheng New Energy Technology Co., Ltd. [49.00%]',
              ],
              [
                'China',
                35,
                'Asia',
                'Huyun Towship',
                'Wannian County',
                'Shangrao',
                'Jiangxi Wannian Huyun Shangcheng solar farm',
                'Wannian Shangcheng New Energy Power Generation Co., Ltd.',
                'Anhui Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Huyun Township',
                'Wannian County',
                'Shangrao',
                'Jiangxi Wannian Huyun solar farm',
                'China Energy Conservation and Environmental Protection Group Wannian Solar Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huyun Township',
                'Wannian County',
                'Shangrao',
                'Jiangxi Wannian Huyun solar farm',
                'China Energy Conservation and Environmental Protection Group Wannian Solar Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liaonan Township',
                'Lushan',
                'Jiujiang',
                'Jiangxi Xingzixian Shaling solar farm',
                'Jiangxi China Power Investment New Energy Power Co., Ltd.',
                'Jilin Electric Power Co., Ltd. [51%]; State Power Investment Corporation Jiangxi Electric Power Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Songhu Town',
                'Xinjian District',
                'Nanchang',
                'Jiangxi Xinjian Songhuzhen solar farm',
                'State Power Investment Group Songhu New Energy Branch of Jiangxi Electric Power Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bajing Town',
                "Gao'an",
                "Gao'an",
                'Jiangxi Xinyu Bajing Power station solar farm',
                'Xinyu JiangNeng Photovoltaic Power Co., Ltd.',
                'Jiangxi Xinyu Mining Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Fenyi Town',
                'Fenyi County',
                'Xinyu',
                'Jiangxi Xinyu Fenyi Fisheries solar farm',
                'Xinyu Deyou Solar Power Co., Ltd.',
                'Shenzhen Yongsheng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liangshan Town',
                'Yushui District',
                'Xinyu',
                'Jiangxi Xinyu Liangshan SPIC solar farm',
                'State Power Investment Corporation Jiangxi Electric Power Co., Ltd. Xinyu Photovoltaic Power Generation Branch',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Unavailable',
                'Fenyi County',
                'Xinyu',
                'Jiangxi Xinyu Luhui solar farm',
                'Fenyi Luhui Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Water Investment Energy Development Co., Ltd.',
              ],
              [
                'China',
                32,
                'Asia',
                'Unavailable',
                'Fenyi County',
                'Xinyu',
                'Jiangxi Xinyu Luhui solar farm',
                'Fenyi Luhui Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Water Investment Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tangpu Town',
                'Yifeng County',
                'Yichun',
                'Jiangxi Xinyu Tangpu solar farm',
                'Xinyu Jiangneng Photovoltaic Electric Co., Ltd. Tangpu Power Station',
                'Xinyu Jiangneng Photovoltaic Electric Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Wenfeng Township',
                'Xunwu County',
                'Ganzhou',
                'Jiangxi Xuwuxian Wenfengxiang solar farm',
                'Xunwu Aikang New Energy Technology Co., Ltd.',
                'State Power Investment Corporation Fujian New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shaxi Town',
                'Xinzhou District',
                'Shangrao',
                'Jiangxi Shangrao Shaxizhen Longtou solar farm',
                'Shangrao Xinhua New Energy Development Co., Ltd.',
                'Shanghai Nengkerong Innovative Energy Development Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Yaquehu Township',
                'Poyang County',
                'Shangrao',
                'Jiangxi Shangrao Poyang Luohong solar farm',
                'Poyang Luohong Electric Power Co., Ltd.',
                'Shangrao Hongyuan Electric Power Co., Ltd. [51.00%]; Hengfeng County Jingluo Electric Power Co., Ltd. [49.00%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Wujiao Township',
                'Ruichang',
                'Jiujiang',
                'Jiangxi Ruichang Wujiao solar farm',
                'Ruichang Hongyuan Photovoltaic Power Generation Co., Ltd.',
                'Jianghe Energy Co., Ltd. [51.00%]; Hunan Green Energy Investment and Development Co., Ltd. [49.00%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Saihu Farm',
                'Ruichang',
                'Jiujiang',
                'Jiangxi Ruichang Nanhu solar farm',
                'Ruichang Jingke Electric Power Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.[70%]; Jinko Power Co., Ltd.[30%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Zhegang Township',
                'Poyang County',
                'Shangrao',
                'Jiangxi Poyang Zhegang solar farm',
                'Poyang Shengbu Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                80,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Jiangxi Province Cangxian Agricultural and Photovoltaic Complementary solar farm',
                'Jiangxi Shuitou Energy Development Co., Ltd.',
                'Jiangxi Water Conservancy Investment Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hetan Town',
                'Guixi',
                'Yingtan',
                'Jiangxi Province Guixi Zhongyuan solar farm',
                'Guixi Zhongyuan Solar Power Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Leping',
                'Leping',
                'Leping',
                'Jiangxi Province Jingdezhen Leping Agriculture-light Complementary solar farm',
                'Jingdezhen Zhongshe Guolian New Energy Co., Ltd.',
                'CMEC Guolian Wuxi New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Leping',
                'Leping',
                'Leping',
                'Jiangxi Province Jingdezhen Leping Agriculture-light Complementary solar farm',
                'Jingdezhen Zhongshe Guolian New Energy Co., Ltd.',
                'CMEC Guolian Wuxi New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Saihu Farm',
                'Ruichang Shi',
                'Jiujiang',
                'Jiangxi Province Jiujiang Ruichang Jinko solar farm',
                'Ruichang Jingke Electric Power Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.[70%]; Jinko Power Co., Ltd.[30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Liangfang',
                'Lianhua',
                'Pingxiang',
                'Jiangxi Province Pingxiang Lianhua CECEP solar farm',
                'CECEP Lianhua Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                120,
                'Asia',
                'Raofeng Town',
                'Poyang Xian',
                'Shangrao',
                'Jiangxi Province Poyang Raofengzhen Fishing and Light Complementary solar farm',
                'Poyang Jinko Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                87,
                'Asia',
                'Yanggang Town',
                'Yixing Municipality',
                'Wuxi Municipality',
                'Jiangsu Yixing Yanggang solar Photovoltaic power plant',
                'Jiangsu Hanyi Energy Co. Ltd.',
                'Individuals Yang Xiuaoming [53%]; Chu Jianxin (25%); Liu Minxia [22%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Zhegang Town',
                'Poyang Xian',
                'Shangrao',
                'Jiangxi Province Poyang Zhegang Fishing and Light Complementary solar farm',
                'Poyang County Shengbu Photovoltaic Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Youdun Jiedao',
                'Poyang Xian',
                'Shangrao',
                'Jiangxi Province Shangrao Poyang "Front Runner" solar farm',
                'Jinko Power Technology Co., Ltd.',
                'Jinko Power Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Santang Town',
                'Yugan Xian',
                'Shangrao',
                'Jiangxi Province Shangrao Yugan Fishing and Light Complementary solar farm',
                'Yugan County GCL New Energy Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership[60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership[40%]',
              ],
              [
                'China',
                250,
                'Asia',
                'Santang Town',
                'Yugan Xian',
                'Shangrao',
                'Jiangxi Province Shangrao Yugan"Front Runner" solar farm',
                'Yugan County Jingguan Solar Power Co., Ltd.',
                'Ningjin Jingneng New Energy Development Co., Ltd.[90%]; Shaanxi Chemical Group Co., Ltd.[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                "Wan'an",
                "Ji'an",
                "Jiangxi Province Wan'an Three Gorges New Energy solar farm",
                "Three Gorges New Energy Wan'an Power Generation Co., Ltd.",
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                "Wang'er Town",
                'Yanshan Xian',
                'Shangrao',
                'Jiangxi Province Yanshan County Wangerzhen Zhoushangcun solar farm',
                'Yanshan Jingtai Photovoltaic Power Co., Ltd.',
                'State Power Investment Corporation Jiangxi Electric Power Co., Ltd.[70%]; Shangrao Jingtai Power Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Hufang Town',
                'Qianshan County',
                'Shangrao',
                'Jiangxi Qianshan Hufangzhen solar farm',
                'Qianshan Tianhong Honghui Solar Energy Technology Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yanshan County',
                'Qianshan County',
                'Shangrao',
                'Jiangxi Qianshan Yongping Copper Mine solar farm',
                'Jiangxi Copper (Qianshan) Photovoltaic Power Generation Co., Ltd.',
                'Jiangxi Copper Co., Ltd.',
              ],
              [
                'China',
                35,
                'Asia',
                'Fan Town',
                'Ruichang City',
                'Ruichang',
                'Jiangxi Ruichang Fanzhen Taida solar farm',
                'Ruichang Taida New Energy Investment Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Lianhe Town',
                'Hengfeng Xian',
                'Shangrao',
                'Jiangxi Province Shangrao Hengfeng Yangjia Jinko solar farm',
                'Hengfeng Jinko Electric Power Co., Ltd.',
                'SDIC Power Holdings CO., LTD. [90%]; Jiangxi Ganneng Co.,Ltd. [10%]',
              ],
              [
                'China',
                35,
                'Asia',
                'Yanggang Town',
                'Yixing Municipality',
                'Wuxi Municipality',
                'Jiangsu Yixing Pinhe Fisheries Photovoltaic solar farm',
                'Yixing Pinhe Photovoltaic Technology Co. Ltd.',
                'Pinke Power Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xiangshui County',
                'Yancheng',
                'Jiangsu Yancheng Xiangshui Yongneng solar farm',
                'Xiangshui Yongneng Solar Power Generation Co., Ltd.',
                'SDIC Power Holdings Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sheyang County',
                'Yancheng',
                'Jiangsu Yancheng Qianneng solar farm',
                'Yancheng Qianneng Solar Power Generation Co., Ltd.',
                'Jiangsu Yinbao Venture Capital Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Pei County',
                'Xuzhou',
                'Jiangsu Peixian Hongri solar farm',
                'Peixian Hongri Photovoltaic Co., Ltd.',
                'Jiangsu Hongri Photovoltaic Agriculture Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yanzibu Town',
                'Pizhou',
                'Xuzhou',
                'Jiangsu Pizhou Hanergy solar farm',
                'Hanergy Pizhou Solar Power Generation Co., Ltd.',
                'Shenneng Nanjing Energy Holding Co., Ltd.',
              ],
              [
                'China',
                57,
                'Asia',
                'Guangyanghu Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Guangyanghu solar farm',
                'Baoying Beikong Photovoltaic Power Generation Co., Ltd.',
                'Tianjin Beiqing Power Smart Energy Co., Ltd.',
              ],
              [
                'China',
                43,
                'Asia',
                'Guangyanghu Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Guangyanghu solar farm',
                'Baoying Beikong Photovoltaic Power Generation Co., Ltd.',
                'Tianjin Beiqing Power Smart Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Liubao Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Liubao 1 solar farm',
                'CGN Solar Technology Baoying Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Liubao Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Liubao 2 solar farm',
                'Baoying County Hongsheng Photovoltaic Power Co. Ltd.',
                "Hengfeng Jing'an Electric Power Co., Ltd.",
              ],
              [
                'China',
                100,
                'Asia',
                'Sheyanghu Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Sheyanghu 1 solar farm',
                'Baoying County Shanghai Power Investment New Energy Co. Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Sheyanghu Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Sheyanghu 1 solar farm',
                'Baoying County Shanghai Power Investment New Energy Co. Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Sheyanghu Town',
                'Baoying County',
                'Yangzhou',
                'Jiangsu Province Baoying "Front Runner" Sheyanghu 2 solar farm',
                'CGN Solar Energy Baoying Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                108,
                'Asia',
                'Liubao Town',
                'Baoying Xian',
                'Yangzhou',
                'Jiangsu Province Baoying Liubao Modern Fishery Estate solar farm',
                'Yangzhou Yanyangtian New Energy Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.[60%]; Jiangsu Sun Da New Energy Co.,Ltd.[31.2%]; Rugao Shunxin Solar Power Technology Co., Ltd. [8.8%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'South of Zhugang River',
                'Dafeng',
                'Jiangsu Province Dafeng Zhenghui Onland solar farm',
                'Dafeng Zhenghui Solar Power Co., Ltd.',
                'Shenneng Nanjing Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'South of Zhugang River',
                'Dafeng',
                'Jiangsu Province Dafeng Zhenghui Onland solar farm',
                'Dafeng Zhenghui Solar Power Co., Ltd.',
                'Shenneng Nanjing Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Linze Town',
                'Gaoyou Shi',
                'Yangzhou',
                'Jiangsu Province Gaoyou Linze Fishpond Water Surface solar farm',
                'Gaoyou Zhenxing New Energy Technology Co., Ltd.',
                'Shenzhen Shenran Clean Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tugou Town',
                'Jinhu Xian',
                "Huai'an",
                "Jiangsu Province Huai'an Jinhu Zhenghui solar farm",
                'Jinhu Zhenghui Solar Power Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.[84.5%]; Suzhou Xiexin New Energy Investment Co., Ltd.[15.5%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Taji Town',
                'Jinhuxian',
                "Huai'an",
                "Jiangsu Province Huai'an Jinhu Zhenhe solar farm",
                'Jinhu Zhenhe New Energy Power Generation Co., Ltd.',
                'Shanxi Xinhua Water Resources and Hydropower Investment Co. Ltd. [80%]; Jiangsu Huayuan New Energy Technology Co. Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Taji Town',
                'Jinhu Xian',
                "Huai'an",
                "Jiangsu Province Huai'an Jinhu Zhenhe solar farm",
                'Jinhu Zhenhe New Energy Power Generation Co., Ltd.',
                'Shanxi Xinhua Water Resources and Hydropower Investment Co. Ltd. [80%]; Jiangsu Huayuan New Energy Technology Co. Ltd. [20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhixi Town',
                'Jintan Qu',
                'Changzhou',
                'Jiangsu Province Jintan Tianhuang Lake Fishery-Solar Hybrid Project',
                'Changzhou Eging Photovoltaic Technology Co., Ltd.',
                'EGing Photovoltaic Technology Co.,Ltd.[85.7%]; Changzhou Jinsha Technology Investment Co., Ltd.[14.3%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Longpao Neighborhood',
                'Liuhe District',
                'Nanjing Municipality',
                'Jiangsu Nanjing Liuhe Fisheries Park Photovoltaic solar farm',
                'Tongli Yuguang Integrated Technology Nanjing Co., Ltd.',
                'Tongwei New Energy Technology (Beijing) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Longpao Neighborhood',
                'Liuhe District',
                'Nanjing Municipality',
                'Jiangsu Nanjing Liuhe Fisheries Park Photovoltaic solar farm',
                'Tongli Yuguang Integrated Technology Nanjing Co., Ltd.',
                'Tongwei New Energy Technology (Beijing) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Daitou',
                'Liyang County',
                'Changzhou',
                'Jiangsu Liyang Xinhui solar farm',
                'Liyang Xinhui Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Taji Town',
                'Jinhu County',
                "Huai'an Municipality",
                'Jiangsu Jinhu Zhenhe Photovoltaic solar farm',
                'Jinhu Zhenhe New Energy Power Generation Co., Ltd.',
                'Shanxi Xinhua Water Resources and Hydropower Investment Co. Ltd. [80%]; Jiangsu Huayuan New Energy Technology Co. Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Dongtai',
                'Yancheng',
                'Jiangsu Dongtai Sumida solar farm',
                'Sumida Dongtai Power Generation Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [68%]; Sumec Energy Development Co., Ltd. [32%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Liangnanken District',
                'Dongtai',
                'Jiangsu Dontai Tidal Flat solar farm',
                'CECEP Dongtai Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Liangnanken District',
                'Dongtai',
                'Jiangsu Dontai Tidal Flat solar farm',
                'CECEP Dongtai Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shizhai Town',
                'Fengxian County',
                'Xuzhou Municipality',
                'Jiangsu Fengxian Agricultural Photovoltaic solar farm',
                'Sujiaokong New Energy Technology Fengxian Co., Ltd.',
                'Jiangsu Yunsha Clean Energy Investment Holdings Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Luxia Town',
                'Fengxian County',
                'Xuzhou Municipality',
                'Jiangsu Fengxian Yaohui Photovoltaic solar farm',
                'Fengxian Yaohui New Energy Co. Ltd.',
                'Changzhou Yamadun Shareholding Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Chenji',
                'Funing',
                'Yancheng',
                'Jiangsu Funing Chenji Xinneng solar farm',
                'Funing Xinneng Photovoltaic Power Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd. [80%]; Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Ganduo Town',
                'Gaoyou',
                'Yangzhou',
                'Jiangsu Gaoyou Ganduo Zhongdiantou solar farm',
                'China Power Investment Gaoyou New Energy Co., Ltd.',
                'State Power Investment Corporation Jiangsu Electric Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Gaoyou',
                'Jiangsu Gaoyou Taifengcun Jingneng solar farm',
                'Beijing Jingneng International Holding Co., Ltd.',
                'Beijing Energy International Investment Limited',
              ],
              [
                'China',
                80,
                'Asia',
                'Punan Town',
                'Xinpu Qu',
                'Lianyuangang',
                'Jiangsu Province Lianyungang CGN solar farm',
                'CGN Solar Lianyungang Co., Ltd',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                24,
                'Asia',
                'Bailu Town',
                'Guannan County',
                'Lianyungang Municipality',
                'Jiangsu Guannan Bailu Photovoltaic solar farm',
                'Jiangsu Feizhan Energy Technology Co. Ltd.',
                'Jiangsu Linyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Punan',
                'Haizhou',
                'Lianyungang',
                'Jiangsu Haizhou Punan Zhongxiang solar farm',
                'Lianyungang Zhongxiang New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Sanhe Town',
                'Hongze District',
                "Huai'an Municipality",
                'Jiangsu Hongze Kepu Photovoltaic solar farm',
                'Hongze County Huaxi New Energy Development Co. Ltd.',
                'Shanghai Nengke Rongchuang New Energy Development Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jianyang Town',
                'Jianhu County',
                'Yancheng',
                'Jiangsu Jianhu Jianyang Jingneng solar farm',
                'Jianhu Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jianhu County',
                'Yancheng Municipality',
                'Jiangsu Jianhu Photovoltaic solar farm',
                'Jianhu Guoyuan New Energy Development Co., Ltd.',
                'Jiangsu Yancheng Clean Energy Development Shareholding Co. Ltd. [51%]; China Energy Construction Group Jiangsu Design Institute Co. Ltd. [29%]; Jiangsu Medium Voltage Engineering Group Co. Ltd. [21%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jianhu',
                'Yancheng',
                'Jiangsu Jianhu SPIC solar farm',
                'China Power Investment Jianhu Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Jiangsu Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yanhe Town',
                'Jianhu County',
                'Yancheng',
                'Jiangsu Jianhu Xianghe Guoyuan solar farm',
                'Jianhu Guoyuan New Energy Development Co., Ltd.',
                'Jiangsu Yancheng Clean Energy Development Co., Ltd. [51%]; China Energy Construction Group Jiangsu Electric Power Design Institute Co., Ltd. [29%]; Jiangsu Medium Voltage Electrical Engineering Group Co., Ltd. [20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'L\u00fcliang Town',
                'Jinhu County',
                "Huai'an Municipality",
                'Jiangsu Jinhu (Zhaohui) fisheries Photovoltaic solar farm',
                'Jinhu Zhaohui Solar Power Co. Ltd.',
                'Shenzhen Enerygy Nanjing Energy Holdings Co. Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Chenqiao Town',
                'Jinhu County',
                "Huai'an Municipality",
                'Jiangsu Jinhu Chenqiao fisheries Photovoltaic solar farm',
                'Jiangsu Huadian Jinhu Energy Co. Ltd. Chenqiao Photovoltaic Power branch',
                'Jiangsu Huadian Jinhu Energy Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Haian',
                'Nantong',
                'Jiangsu Haian Celan solar farm',
                'Haian Celan Investment Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [75%]; Eleventh Design and Research Institute for Information Industry Electronics Technology Engineering Co., Ltd. [25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaoshi Township',
                'Yongxin County',
                "Ji'an",
                'Jiangxi Yongxin Zhangmushan solar farm',
                'Yongxin Seahawk New Energy Technology Co., Ltd.',
                'Tianjin Zeyu Energy Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Bieqiao Town',
                'Liyang',
                'Changzhou',
                'Jiangsu Province Liyang Bieqiao Fishery-Solar Hybrid Project',
                'Liyang Bieqiao Huapeng Photovoltaic Co., Ltd.',
                'Jiangsu Huapeng Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yanzibu Town',
                'Pizhou Shi',
                'Xuzhou',
                'Jiangsu Province Pizhou Shenneng solar farm',
                'Shenzhen Energy Group Co., Ltd.',
                'Shenzhen Energy Group Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Meihua Town',
                'SIhong County',
                'Suqian Municipality',
                'Jiangsu Sihong Yongle Photovoltaic solar farm',
                'Sihong County Yongle New Energy Technology Co. Ltd.',
                'Jiangsu Linyang New Energy Technology Co. Ltd. [majority]',
              ],
              [
                'China',
                36,
                'Asia',
                'Tianganghu Town',
                'Sihong County',
                'Suqian Municipality',
                'Jiangsu Sihong Yongsheng solar farm',
                'Sihong Yongsheng New Energy Technology Co. Ltd.',
                'Jiangsu Linyang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Chuancheng Town (formerly Zhangjiawei Town)',
                'Siyang County',
                'Suqian Municipality',
                'Jiangsu Siyang Honghui Jiangjiawei solar farm',
                'Siyang Honghui Power Engineering Co., Ltd.',
                'Siyang Green Energy Photovoltaic Power Investment Co. Ltd.',
              ],
              [
                'China',
                31,
                'Asia',
                'Chuanzhen Town',
                'Siyang County',
                'Suqian Municipality',
                'Jiangsu Siyang Photovoltaic solar farm',
                'Siyang Beichuan Power Engineering Co., Ltd.',
                'China Guangdong Nucleara New Energy Investment (Shenzhen) Co. Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shuanggou Town',
                'Suining County',
                'Xuzhou',
                'Jiangsu Suining Atesi agricultural Photovoltaic solar farm',
                'Suining Atlas New Energy Co. Ltd.',
                'Shenzhen Energy Nanjing Energy Holdings Co. Ltd. [majority]',
              ],
              [
                'China',
                31,
                'Asia',
                'Guanmiao Town',
                'Suyu District',
                'Suqian Municipality',
                'Jiangsu Suqian Hongchen Photovoltaic solar farm',
                'Suqian Hongchen Electricity Co. Ltd.',
                'China Guangdong Nuclear Windpwer Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Guanmiao Town',
                'Suyu District',
                'Suqian',
                'Jiangsu Suqian Suyu Guanmiaozhen Zhenghui solar farm',
                'Suqian Zhenghui Solar Power Co., Ltd.',
                'Suqian Sanyou Solar Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gangyang Town',
                'Hailing District',
                'Taizhou',
                'Jiangsu Taizhou Herun solar farm',
                'Taizhou Herun New Energy Co., Ltd.',
                'CNNC [Nanjing] Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gangyang Town',
                'Hailing District',
                'Taizhou Municipality',
                'Jiangsu Taizhou Herun solar farm',
                'Taizhou Herun New Energy Co. Ltd.',
                'CNNC (Nanjing) Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qianhuang Town',
                'Wujin District',
                'Changzhou Municipality',
                'Jiangsu Wujin Qianhuang Photovoltaic solar farm',
                'Changzhou Jiuzhou Yuguang New Energy Co. Ltd.',
                'Changzhou Jiuzhou Investment Group Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Qianhuang Town',
                'Wujin District',
                'Changzhou Municipality',
                'Jiangsu Wujin Qianhuang Photovoltaic solar farm',
                'Changzhou Jiuzhou Yuguang New Energy Co. Ltd.',
                'Changzhou Jiuzhou Investment Group Co. Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Huishan District',
                'Wuxi Municipality',
                'Jiangsu Wuxi Huixi (Guzhuang Innovative) solar farm',
                'Wuxi Guzhuang Innovative Ecological Agriculture Development Co. Ltd.',
                'Ningxia Zhongpeng Energy Co. Ltd. [90%]; Shanghai Yichuang Travel Development Co. Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jiawang District',
                'Xuzhou',
                'Jiangsu Xuzhou Jiawang GCL solar farm',
                'Xuzhou GCL Photovoltaic Power Co., Ltd.',
                'Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd.',
              ],
              [
                'China',
                26,
                'Asia',
                'Bufeng Town',
                'Yancheng Technical and Economic Development Zone',
                'Yancheng Municipality',
                'Jiangsu Yancheng Bufeng agricultural solar Photovoltaic power plant',
                'Yancheng Yunsha Photovoltaic Power Co. Ltd.',
                'Jiangsu Yunsha Clean Energy Investment Shareholding Co. Ltd. [80%]; Jiangsu Dongjin Holdings Co. Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dafeng District',
                'Yancheng',
                'Jiangsu Yancheng Dafeng SPIC Tidal Flat solar farm',
                'State Power Investment Group Yancheng Dafeng Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Jiangsu Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dongtai',
                'Yancheng',
                'Jiangsu Yancheng Dongtai Suyangda solar farm',
                'Dongtai Coastal Suyangda Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu SUMEC Group Co., Ltd.[90.5%]; Jiangsu SUMEC New Energy Development Co., Ltd.[9.5%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Jianyang Town',
                'Jianhu County',
                'Yancheng',
                'Jiangsu Yancheng Jianhu solar farm',
                'China Power Investment Jianhu Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Jiangsu Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sunyuan Town',
                'Sihong County',
                'Suqian Municipality',
                'Jiangsu Sihong Sunyuan Zhen distributed "fisheries" Photovoltaic solar farm',
                'Sihong County Huale New Energy Technology Co. Ltd.',
                'Jiangsu Linyang New Energy Technology Co. Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Liuji',
                'Shuyang',
                'Suqian',
                'Jiangsu Shuyang Liuji Qingshuihe solar farm',
                'Muyang Qingshuihe Photovoltaic Power Generation Co., Ltd.',
                'East Group Co.,Ltd',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Sheyang County',
                'Yancheng',
                'Jiangsu Sheyang Tidal Flat solar farm',
                'Jiangsu Jiyang Electric Power Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sheyang Salt Field',
                'Sheyang County',
                'Yancheng Municipality',
                'Jiangsu Sheyang Salt Field "Fisheries" Photovoltaic solar farm',
                'Yancheng Qianneng Solar Power Generation Co. Ltd.',
                'Jiangsu Yinbao Eneterprises Investment Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Lvsi Port',
                'Qidong',
                'Nantong',
                'Jiangsu Province Qidong Lvsi Port solar farm',
                'Jiangsu Datang International Lvsigang Power Generation Co., Ltd.',
                'Datang International Power Generation Co., Ltd.[55%]; Datang Jiangsu Power Generation Co., Ltd.[35%]; Nantong State-owned Assets Investment Holding Co., Ltd.[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuanggou Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Shuanggou Town Farming and Light Complementary solar farm',
                'CGN Linyang New Energy Sihong Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.[90%]; Jiangsu Linyang Energy Co., Ltd.[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuanggou Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Shuanggou Town Fishing and Light Complementary solar farm',
                'CGN Linyang New Energy Sihong Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.[90%]; Jiangsu Linyang Energy Co., Ltd.[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shuanggou Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Shuanggou Town Herding and Light Complementary solar farm',
                'Three Gorges New Energy Sihong Co., Ltd.',
                "China Three Gorges New Energy (Group) Co., Ltd. [75%]; Xi'an LONGi Clean Energy Co., Ltd. [25%]",
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'Sihong Tongli New Energy Co., Ltd.',
                'Hengfeng County Jingxin Power Co., Ltd.[80%]; Huludao City Lianshan District Tongwei New Energy Co., Ltd.[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'CGN New Energy Holdings Co., Ltd.',
                'CGN New Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'Sihong Tongli New Energy Co., Ltd.',
                'Hengfeng County Jingxin Power Co., Ltd.[80%]; Huludao City Lianshan District Tongwei New Energy Co., Ltd.[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'CGN New Energy Holdings Co., Ltd.',
                'CGN New Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yanzibu Town',
                'Pizhou Shi',
                'Xuzhou',
                'Jiangsu Province Pizhou Shenneng solar farm',
                'Shenzhen Energy Group Co., Ltd.',
                'Shenzhen Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'State Power Investment Corporation Sihong Photovoltaic Power Co. Ltd.',
                'State Power Investment Group Jiangsu Power Co. Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Tianganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishpond solar farm',
                'Sihong Tianganghu Photovoltaic Power Generation Co., Ltd.',
                'CLP China Solar Power Project Co., Ltd.[90%]; CLP Sichuan [Jiangbian] Power Generation Co., Ltd.[10%]',
              ],
              [
                'China',
                80,
                'Asia',
                'ShagouTown',
                'Xinghua',
                'Taizhou',
                'Jiangsu Province Taizhou Xinghua Fishpond Watersurface solar farm',
                'Huadian Xinghua Solar Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Townshui Coastal Economic Development Zone',
                'Xiangshui Xian Coastal Economic Development Zone',
                'Yancheng',
                'Jiangsu Province Xiangshui Xuqiang solar farm',
                'Jiangsu Xuqiang New Energy Technology Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yancheng',
                'Xiangshui County',
                'Yancheng',
                'Jiangsu Province Yancheng Xiangshui County Hengneng solar farm',
                'Xiangshui Hengneng Solar Power Generation Co., Ltd.',
                'SDIC Power Holdings Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Pukou District',
                'Nanjing',
                'Jiangsu Pukou Xingdian GCL solar farm',
                'Jiangsu GCL Haibin New Energy Technology Development Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd. [60%]; Jiangsu Haibin New Energy Investment Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Lingang Industrial Park',
                'Rudong County',
                'Nantong',
                'Jiangsu Rudong Yangkougang Photovoltaic solar farm',
                'Zhongtian Science and Technology Group Rudong Electric Co. Ltd.',
                'Zhogntian Photovoltaic Technology Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sheyang',
                'Yancheng',
                'Jiangsu Sheyang Jiyang solar farm',
                'Jiangsu Jiyang Electric Power Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Tiangganghu Town',
                'Sihong Xian',
                'Suqian',
                'Jiangsu Province Sihong Tianganghu Fishing and Light Complementary solar farm',
                'Huaneng Sihong New Energy Co. Ltd.',
                'Huaneng International Power Jiangsu Energy Development Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Meigang Township',
                'Yugan County',
                'Shangrao',
                'Jiangxi Yugan Meigang Forestry and Light Complementary solar farm',
                'Yugan Guoneng New Energy Co., Ltd.',
                'Jiangxi Guobang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Meigang Township',
                'Yugan County',
                'Shangrao',
                'Jiangxi Yugan Meigang solar farm',
                'Yugan Guoneng New Energy Co., Ltd.',
                'Jiangxi Guobang New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Santang Township',
                'Yugan County',
                'Shangrao',
                'Jiangxi Yugang Taike solar farm',
                'Shangrao Taike Photovoltaic Power Co., Ltd.',
                'Shanghai Aerospace Automobile Electromechanical Co., Ltd. [51.00%]; Yugan County Yufa Photovoltaic Development Co., Ltd. [49.00%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Jingneng solar farm',
                'Ningxia Jingneng Zhongwei New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Shengyu solar farm',
                'Ningxia Shengyu Solar Power Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Xiangshan',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Xiangshan SPIC solar farm',
                'State Power Investment Group Ningxia Energy Aluminum Zhongwei New Energy Co., Ltd.',
                'State Power Investment Group Ningxia Energy Aluminum Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Yingshuiqiao',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Yingshuiqiao Hengyang solar farm',
                'Ningxia Hengyang New Energy Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Power Co., Ltd. [80%]; Suzhou Poly GCL Photovoltaic Power Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Yingshuiqiao Suobao solar farm',
                'Ningxia Suo Bao New Energy Technology Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yingshuiqiao',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Yingshuiqiao Zhengtai solar farm',
                'Zhongwei Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhenluo',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Zhenluo Qingyin solar farm',
                'Zhongwei Qingyin Yuanxing Solar Energy Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd. [51%]; Zhejiang Chint New Energy Development Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Pingluo County',
                'Shizuishan',
                'Ningxia Shizuishan CECEP solar farm',
                'CECEP Ningxia Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shizuishan',
                'Ningxia Shizuishan Huinong CECEP solar farm',
                'CECEP (Shizuishan) Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shizuishan',
                'Ningxia Shizuishan Huinong SDIC solar farm',
                'SDIC Shizuishan Photovoltaic Power Generation Co., Ltd.',
                'SDIC New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Jianquan Farm',
                'Huinong District',
                'Shizuishan',
                'Ningxia Shizuishan Huinong Xinken Jianquan solar farm',
                'Ningxia Xinken Jianquan Photovoltaic Power Co., Ltd.',
                'Hunan Xinhua Water Conservancy and Electric Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Luoshitan',
                'Huinong Qu',
                'Shizuishan',
                'Ningxia Shizuishan Huinong Zhongli Tenghui solar farm',
                'Ningxia Zhongli Tenghui New Energy Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo CECEP solar farm',
                'CECEP Pingluo Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Pingluo',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo Guodian solar farm',
                'Ningxia Guodian Atlas New Energy Development Co., Ltd.',
                'Guodian Power Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Gaoren Town',
                'Pingluo Xian',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo Zhongdian Techbology solar farm',
                'Pingluo Zhongdian Technology Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Gaoren Town',
                'Pingluo Xian',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo Zhongdian Techbology solar farm',
                'Pingluo Zhongdian Technology Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Gaoren Town',
                'Pingluo Xian',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo Zhongdian Technology solar farm',
                'Pingluo Zhongdian Technology Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Hengji Weiye solar farm',
                'Zhongwei Hengji Weiye Photovoltaic Power Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shapotou',
                'Zhongwei',
                'Ningxia Shapotou Changhe solar farm',
                'Ningxia Zhongwei Changhe New Energy Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.[86%]; Ningxia Haoneng New Energy Co., Ltd.[14%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Qingtongxia',
                'Wuzhong',
                'Ningxia Qingtongxia Huaneng solar farm',
                'Huaneng Qingtongxia New Energy Power Generation Co., Ltd.',
                'Huaneng Renewables Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ningxia Qingtongxia Feisike Xuyuan solar farm',
                'Ningxia Fiske Xuyuan New Energy Technology Co., Ltd.',
                'Ningxia Haoyang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Baitugang Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Lingwu Baitugang Jingke Grid-Connected solar farm',
                'Ningxia Jingke Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baitugang Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Lingwu Baitugang Jingneng Grid-Connected solar farm',
                'Ningxia Jingneng Lingwu Wind Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Baitugang',
                'Lingwu',
                'Yinchuan',
                'Ningxia Lingwu Baitugang Three Gorges solar farm',
                'Three Gorges New Energy Angli (Lingwu) Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Lingwu',
                'Ningxia Lingwu Datang Angli solar farm',
                'Datang Angli (Lingwu) New Energy Co., Ltd.',
                "China Datang Corporation Renewable Power Co.,Limited[51%]; Jing'ao Solar Energy Investment [China] Co., Ltd.[29.16%]; Ningxia Angli Photovoltaic Technology Co., Ltd.[19.84%]",
              ],
              [
                'China',
                390,
                'Asia',
                'Hongdunzi Mining Area',
                'Xingqing Qu',
                'Yinchuan',
                'Ningxia Lingwu Hongdunzi Mining Area Baofeng solar farm',
                'Ningxia Baofeng Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Baofeng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                228,
                'Asia',
                'Majiatan Town',
                'Lingwu',
                'Yinchuan',
                'Ningxia Lingwu Longqiao solar farm',
                'Lingwu Longqiao Photovoltaic New Energy Co., Ltd.',
                'Huaneng Ningxia Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Majiatan Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Lingwu Majiatan Jingke Grid-Connected solar farm',
                'Ningxia Jingke Photovoltaic Power Generation Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shagou',
                'Lingwu',
                'Yinchuan',
                'Ningxia Lingwu Shagou Angli solar farm',
                'Lingwu Baitugang Angli Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Gaoren Town',
                'Pingluo Xian',
                'Shizuishan',
                'Ningxia Shizuishan Pingluo Zhongdian Technology solar farm',
                'Pingluo Zhongdian Technology Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Baitugang Town',
                'Lingwu',
                'Yinchuan',
                'Ningxia Lingwu Shengtang solar farm',
                'Ningxia Shengtang Solar Energy Technology Co., Ltd.',
                'Beijing Yicai Lighting Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Majiatan Town',
                'Lingwu',
                'Yinchuan',
                'Ningxia Lingwu Zhenwu solar farm',
                'Ningxia Zhenwu Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Aluminum Electric New Energy Technology Development Co., Ltd. [96%]; Jiangsu Zhenfa New Energy Technology Development Co., Ltd. [4%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Longkengzi',
                'Litong',
                'Wuzhong',
                'Ningxia Litong Longkengzi Three Gorges solar farm',
                'Three Gorges New Energy Taiyangshan Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Yonglicun',
                'Lingwu',
                'Yinchuan',
                'Ningxia Ningdong Guoxing solar farm',
                'Ningxia Ningdong Guoxing Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Guxin New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                300,
                'Asia',
                'Ningdong Town',
                'Lingwu',
                'Yinchuan',
                'Ningxia Ningdong Xinrun solar farm',
                'Ningxia Ningdong Xinrun Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Guxin Electric Power Investment Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Majiatan Town',
                'Lingwu',
                'Yinchuan',
                'Ningxia Ningwu Huadian solar farm',
                'Huadian (Ningxia) Energy Co., Ltd. Lingwu Branch',
                'Huadian (Ningxia) Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Gaozhuang Town',
                'Pingluo County',
                'Shizuishan',
                'Ningxia Pingluo CECEP solar farm',
                'CECEP Pingluo Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                190,
                'Asia',
                'Gaoren Town',
                'Pingluo Xian',
                'Shizuishan',
                'Ningxia Pingluo Gaoren Artes Jiayang solar farm',
                'Pingluo Artes Jiayang New Energy Co., Ltd.',
                'Ningxia Jiayang Energy Co., Ltd. [49%]; Wuling Electric Power Co., Ltd. [48%]; Hunan Zhongshui Investment Co., Ltd. [3%]',
              ],
              [
                'China',
                190,
                'Asia',
                'Gaoren Town',
                'Pingluo County',
                'Shizuishan',
                'Ningxia Pingluo Gaoren Atesi solar farm',
                'Pingluo Atesi Jiayang New Energy Co., Ltd.',
                'Ningxia Jiayang Energy Co., Ltd. [49%]; Wuling Electric Power Co., Ltd. [48%]; Hunan Zhongshui Investment Co., Ltd. [3%]',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Lingwu',
                'Ningxia Lingwu Xingsheng solar farm',
                'Ningxia Xingsheng New Energy Co., Ltd.',
                'Shanghai Guxin Asset Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Shikong Town',
                'Zhongning County',
                'Zhongwei',
                'Ningxia Lineng Zhongning solar farm',
                'Ningxia Li Neng Photovoltaic Power Development Co., Ltd.',
                'CDB New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shizuishan',
                'Ningxia Shizuishan Shanyang solar farm',
                'Ningxia Shanyang New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Luoshitan',
                'Huinong District',
                'Shizuishan',
                'Ningxia Shuishan Luoshitan Zhongli Xianghui solar farm',
                'Ningxia Zhongli Xianghui New Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Dingtang Town',
                'Tongxin Xian',
                'Wuzhong',
                'Ningxia Wuzhong Tonxin Zhongmin solar farm',
                'Zhongmin Xinneng Ningxia Tongxin Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wanglejing Town',
                'Yanchi Xian',
                'Wuzhong',
                'Ningxia Wuzhong Yanchi Guoxin solar farm',
                'Ningxia Guoxin Photovoltaic Energy Co., Ltd.',
                'Shandong Dade Energy Co., Ltd.',
              ],
              [
                'China',
                250,
                'Asia',
                'Hongdunzi Town',
                'Xingqing District',
                'Yinchuan',
                'Ningxia Xingqing District Baofeng solar farm',
                'Ningxia Baofeng New Energy Development Co., Ltd.',
                'Ningxia Baofengyuan Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongdunzi Mining Area',
                'Xingqing Qu',
                'Yinchuan',
                'Ningxia Xingqing Hongdunzi Mining Area Zhongdiantou solar farm',
                'State Power Investment Group Ningxia Energy Aluminum Yinchuan New Energy Co., Ltd.',
                'State Power Investment Corporation Ningxia Electric Power Distribution Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongdunzi',
                'Xingqing',
                'Yinchuan',
                'Ningxia Xingqing Hongdunzi Xuning solar farm',
                'Ningxia Xuning New Energy Technology Co., Ltd.',
                'RISEN (Ningbo) Electric POWER Development Co., Ltd.',
              ],
              [
                'China',
                380,
                'Asia',
                'Gaoshawo Town',
                'Yanchi Xian',
                'Wuzhong',
                'Ningxia Yanchi Gaoshawo Zhongmintou solar farm',
                'Zhongmin Xinneng Ningxia Yanchi Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yanchi County',
                'Wuzhong',
                'Ningxia Yanchi Huaqin solar farm',
                'Yanchi Huaqin Solar Power Generation Co., Ltd.',
                'Wolong Electric Yinchuan Transformer Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yanchi County',
                'Wuzhong',
                "Ningxia Yanchi Jing'ao Proverty Alleviation solar farm",
                'Yanchi County JA Solar Power Generation Co., Ltd.',
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                180,
                'Asia',
                'Unavailable',
                'Yanchi County',
                'Wuzhong',
                'Ningxia Yanchi Zhongmin Guangfu solar farm',
                'Zhongmin Guangfu Ningxia Yanchi Co., Ltd.',
                'Xinjiang Silk Road Runyuan New Energy Co., Ltd. [65%]; China Mining Energy Control Co., Ltd. [35%]',
              ],
              [
                'China',
                200,
                'Asia',
                'Gaoshawo Town',
                'Yanchi County',
                'Wuzhong',
                'Ningxia Yanchi Zhongmin Xinneng Compound solar farm',
                'Zhongmin Xinneng Ningxia Yanchi Photoelectric Energy Co., Ltd.',
                'East China Xinhua Energy Investment Co., Ltd.',
              ],
              [
                'China',
                380,
                'Asia',
                'Gaoshawo Town',
                'Yanchi County',
                'Wuzhong',
                'Ningxia Yanchi Zhongmingtou solar farm',
                'Zhongmin Xinneng Ningxia Yanchi Co., Ltd.',
                'Zhongmin Xinneng Investment Group Co., Ltd.',
              ],
              [
                'China',
                234,
                'Asia',
                'Gaoshawo Town',
                'Yanchi Xian',
                'Wuzhong',
                'Ningxia Yanchi Zhongmintou Poverty Alleviation solar farm',
                'Zhongmin Guangfu Ningxia Yanchi Co., Ltd.',
                'Zhongmin Energy Control Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Gaoshawo Town',
                'Yanchi Xian',
                'Wuzhong',
                'Ningxia Yanchi Zhongmintou solar farm',
                'Zhongmin Guangfu (Ningxia) Investment Co., Ltd.',
                'Zhongmin Energy Control Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Binggou',
                'Xingqing District',
                'Yinchuan',
                'Ningxia Yinchuan Binggou Jingneng solar farm',
                'Northwest Branch of Beijing Jingneng Clean Energy Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Limited',
              ],
              [
                'China',
                200,
                'Asia',
                'Binggou',
                'Xingqing District',
                'Yinchuan',
                'Ningxia Yinchuan Binggou Shanxi Shentou solar farm',
                'Unknown',
                "Shanxi Shentou Power Co., Ltd.; Xi'an LONGi Clean Energy Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Majiatan Town',
                'Lingwu Shi',
                'Yinchuan',
                'Ningxia Yinchuan Lingwu Huadian Grid-Connected solar farm',
                'Huadian International Ningxia New Energy Power Generation Co., Ltd.',
                'Huadian (Ningxia) Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yuxin Town',
                'Unavailable',
                'Tianmen',
                'Guangdong Tianmen Yuxin Zhuiri solar farm',
                'Tianmen Zhuiri Energy Development Co., Ltd.',
                'Tianjin Fuyi Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Tongxin Xian',
                'Wuzhong',
                'Ningxia Wuzhong Tonxin Longi solar farm',
                'Tongxin County Longi New Energy Co., Ltd.',
                'CDB New Energy Technology Co., Ltd. [51%]; XI`AN Longi Clean ENERGY Co., Ltd. [47%]; Others [2%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Tongxin Xian',
                'Wuzhong',
                'Ningxia Wuzhong Tonxin Longi solar farm',
                'Tongxin County Longi New Energy Co., Ltd.',
                'CDB New Energy Technology Co., Ltd. [51%]; XI`AN Longi Clean ENERGY Co., Ltd. [47%]; Others [2%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Hexi Town',
                'Tongxin Xian',
                'Wuzhong',
                'Ningxia Wuzhong Tonxin CNNC Huineng solar farm',
                'CNNC (Ningxia) Tongxin New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan Three Gorges solar farm',
                'Three Gorges New Energy Wuzhong Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                180,
                'Asia',
                'Taiyangshan Town',
                'Hongsibu District',
                'Wuzhong',
                'Ningxia Taiyangshan Jingnneg solar farm',
                'Ningxia Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Tongxin County',
                'Wuzhong',
                'Ningxia Tongxin CNNC solar farm',
                'CNNC (Ningxia) Tongxin New Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Tongxin',
                'Wuzhong',
                'Ningxia Tongxin Dadi Risheng solar farm',
                'Ningxia Tongxin Earth Risheng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Tongxin',
                'Wuzhong',
                'Ningxia Tongxin Longji solar farm',
                'Tongxin County Longi New Energy Co., Ltd.',
                'CDB New Energy Technology Co., Ltd. [51%]; XI`AN Longi Clean ENERGY Co., Ltd. [47%]; Others [2%]',
              ],
              [
                'China',
                95,
                'Asia',
                'Taoshancun',
                'Tongxin County',
                'Wuzhong',
                'Ningxia Tongxin Zhongli Muhui solar farm',
                'Ningxia Zhongli Muhui New Energy Co., Ltd.',
                'CECEP Solar Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Tongxin County',
                'Wuzhong',
                'Ningxia Tongxin Zhongli Qihui solar farm',
                'Ningxia Zhongli Qihui New Energy Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Unavailable',
                'Tongxin',
                'Wuzhong',
                'Ningxia Tongxin Zhongzi Clean Energy solar farm',
                'Ningxia Zhongzi Clean Energy Co., Ltd.',
                'CPI Xinjiang Energy and Chemical Group Hami Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Hongsibu District',
                'Wuzhong',
                'Ningxia Wuzhong Hongsibu solar farm',
                'Ningxia Power Generation Group Hongsibao Photovoltaic Power Plant',
                'China Aluminum Ningxia Energy Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huinong District',
                'Shizuishan',
                'Ningxia Shizuishan Zhongli Minghui solar farm',
                'Ningxia Zhongli Minghui New Energy Co., Ltd.',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Litong Qu',
                'Wuzhong',
                'Ningxia Wuzhong Litong District Three Gorges solar farm',
                'Three Gorges New Energy Litong Wulipo Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qingtongxia',
                'Wuzhong',
                'Ningxia Wuzhong Qingtongxia Datang International solar farm',
                'Ningxia Datang International Qingtongxia Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Datang International New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Taiyangshan District',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan CECEP solar farm',
                'CECEP Wuzhong Taiyangshan Photovoltaic Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Taiyangshan District',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan CECEP solar farm',
                'CECEP Wuzhong Taiyangshan Photovoltaic Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan China Aluminum solar farm',
                'China Aluminum Ningxia Energy Group Co., Ltd.',
                'Aluminum Corporation of China Limited[71%];Ningxia Huimin Investment and Financing Co., Ltd. [18%]; Beijing Energy Group Co., Ltd.[6%];Ningxia Power Investment Corporation[6%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan Guangyuan solar farm',
                'Ningxia Guangyuan Power Co. Ltd.',
                'Hunan Gongchuang Photovoltaic Science & Technology Co., Ltd.[51%]; Hunan Gongchuang Industrial Group Hengyang Real Estate Development Co., Ltd. [25%]; Hengyang Hengyun Real Estate Investment Co., Ltd.[24%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan Hanneng solar farm',
                'Hanneng Wuzhong Taiyangshan Photovoltaic Power Generation Co., Ltd.',
                'Beijing Zhilan Photovoltaic Power Generation Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Taiyangshan District',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan SDIC solar farm',
                'State Power Investment Group Ningxia Energy Aluminum Wuzhong New Energy Co., Ltd.',
                'State Power Investment Group Ningxia Energy Aluminum Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Wuzhong',
                'Ningxia Wuzhong Taiyangshan Three Gorges solar farm',
                'Three Gorges New Energy Wuzhong Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Qingtongxia City',
                'Qingtongxia Shi',
                'Wuzhong',
                'Ningxia Wuzhong Qingtongxia CGN solar farm',
                'CGN Solar Energy (Qingtongxia) Development Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dongtai',
                'Yancheng',
                'Jiangsu Dongtai Sumida solar farm',
                'Sumida Dongtai Power Generation Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [68%]; Sumec Energy Development Co., Ltd. [32%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Jinfeng',
                'Yinchuan',
                'Ningxia Jinfeng Zhenqi solar farm',
                'Ningxia Zhenqi Photovoltaic Power Generation Co., Ltd.',
                'China Foma (Group) Co., Ltd. [70%]; Foma Traidng Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Taiyangshan',
                'Hongsibu',
                'Wuzhong',
                'Ningxia Hongsibu Taiyangshan Power Investment solar farm',
                'Ningxia Power Investment Taiyangshan Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Power Investment Corporation',
              ],
              [
                'China',
                100,
                'Asia',
                'Hongxing Town',
                'Tongyu Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'China Huaneng Group Co., Ltd.',
                'China Huaneng Group',
              ],
              [
                'China',
                100,
                'Asia',
                'Townhai Town',
                'Tongyu Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'CECEP Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Co.,Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Baicaogou Town',
                'Wangqing Xian',
                'Yanbian',
                'Jilin Province Yanbian Wangqing Poverty Alleviation solar farm',
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Baicaogou Town',
                'Wangqing Xian',
                'Yanbian',
                'Jilin Province Yanbian Wangqing Poverty Alleviation solar farm',
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
                'Tunghsu Azure Renewable Energy Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Qian Gorlos',
                'Songyuan',
                'Jilin Qian Gorlos Fuxin solar farm',
                'Huadian Fuxin Songyuan Photovoltaic Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Shuangliao',
                'Siping',
                'Jilin Shuangliao Qingda Animal Husbandry solar farm',
                'Shuangliao Qingda Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd. [90%]; Jilin Qingda New Energy Electric Power Co., Ltd. [10%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Fuxian',
                'Shuangliao',
                'Siping',
                'Jilin Shuangliao Qingda Mushroom Greenhouse solar farm',
                'Shuangliao Qingda Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd. [90%]; Jilin Qingda New Energy Electric Power Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shuangliao',
                'Siping',
                'Jilin Shuangliao Qingda solar farm',
                'Shuangliao Qingda Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd. [90%]; Jilin Qingda New Energy Electric Power Co., Ltd. [10%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Shuangliao',
                'Siping',
                'Jilin Shuangliao Qingda solar farm',
                'Shuangliao Qingda Photovoltaic Power Generation Co., Ltd.',
                'China Three Gorges Renewables (Group) Co., Ltd. [90%]; Jilin Qingda New Energy Electric Power Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shuangliao',
                'Siping',
                'Jilin Shuangliao Tianhe solar farm',
                'Shuangliao Tianhe Solar Power Development Co., Ltd.',
                'Jiangsu Trina Solar Power Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Songyuan',
                'Jilin Songyuan Jingke solar farm',
                'Jilin Jingke New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Taonan',
                'Baicheng',
                'Jilin Taonan Fubang solar farm',
                'Jilin Fubang Energy Technology Service Co., Ltd.',
                'Liaoning Zhitong Dongguan Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Taonan',
                'Baicheng',
                'Jilin Taonan Quansheng solar farm',
                'Taonan Quansheng Solar Power Co., Ltd.',
                'Inner Mongolia Shanlu Energy Company Limited [95%]; NiHaiGuang [5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Tongyu County',
                'Baicheng',
                'Jilin Tongyu CECEP solar farm',
                'CECEP Solar Energy Technology (Tongyu) Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hongxing',
                'Tongyu',
                'Baicheng',
                'Jilin Tongyu Hongxing Jinghong solar farm',
                'Tongyu Jinghong Solar Power Generation Co., Ltd.',
                'Changchun Shengbu Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wulanhua',
                'Tongyu',
                'Baicheng',
                'Jilin Tongyu Wulanhua Tianhong Honghui solar farm',
                'Tongyu Tianhong Honghui Solar Power Technology Co., Ltd.',
                'Tianjin Fuhuan Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xianghai',
                'Tongyu',
                'Baicheng',
                'Jilin Tongyu Xianghai Cecep solar farm',
                'CECEP Solar Energy Technology (Tongyu) Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Hongxing Town',
                'Tongyu Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'Jinko Power Technology Co., Ltd.',
                'Jinko Power Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jiaoliuhe Town',
                'Taonan Shi',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'Zhejiang Chint New Energy Development Co., Ltd.',
                'Zhejiang Chint Electrics Co., Ltd.[92%]; other[8%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jiaoliuhe Town',
                'Taonan Shi',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'China Guangdong Nuclear Solar Development Co. Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.[66.4%]; Shenzhen CGN Fengtai Investment Co., Ltd.[33.6%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping Town',
                'Zhenlai Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'China Guangdong Nuclear Solar Development Co. Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.[66.4%]; Shenzhen CGN Fengtai Investment Co., Ltd.[33.6%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangxi Town',
                'Yujiang County',
                'Yingtan',
                'Jiangxi Yujiang Huangxizhen solar farm',
                'Yujiang Xinyang New Energy Co., Ltd.',
                'Yujiang Changpu New Electric Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huangxi Town',
                'Yujiang County',
                'Yingtan',
                'Jiangxi Yujiang Huangxizhen solar farm',
                'Yujiang Xinyang New Energy Co., Ltd.',
                'Yujiang County Changpu New Electric Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Liugongmiao Town',
                'Zhangshu County',
                'Yichun',
                'Jiangxi Zhangshu Liugongmiao Zhongli Tenghui solar farm',
                'Zhangshu Zhongli Tenghui Photovoltaic Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                21,
                'Asia',
                'Unavailable',
                'Leping',
                'Jingdezhen',
                'Jiangxi Zhongse Guolian Legang solar farm',
                'Jingdezhen Zhongshe Guolian New Energy Co., Ltd.',
                'CMEC Guolian Wuxi New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Baicheng',
                'Jilin Baicheng CGN solar farm',
                'CGN New Energy (Taonan) Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anguang Town',
                "Da'an",
                'Baicheng',
                'Jilin Baicheng Front Runner solar farm',
                "Da'an Zhengtai Photovoltaic Power Generation Co., Ltd.",
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Anguang Town',
                "Da'an",
                'Baicheng',
                'Jilin Baicheng Front Runner solar farm',
                "Da'an Jidian New Energy Co., Ltd.",
                'Jilin Electric Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Baicheng',
                'Jilin Baicheng Hangtai solar farm',
                'Taonan HangTai Solar Power Generation Co., Ltd.',
                'Changchun Zhetai Solar Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xianghai',
                'Tongyu',
                'Baicheng',
                'Jilin Tongyu Xianghai Jinyuan solar farm',
                'Tongyu Jinyuan Photovoltaic Power Co., Ltd.',
                'Jilin Zhongzhaoheng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Changling',
                'Changling',
                'Songyuan',
                'Jilin Changling Changling Qiulin solar farm',
                'Changling Qiulin Photovoltaic Power Generation Development Co., Ltd.',
                'Shanghai Aineng Power Engineering Co., Ltd.',
              ],
              [
                'China',
                38,
                'Asia',
                'Unavailable',
                'Daan',
                'Baicheng',
                'Jilin Daan Changsheng solar farm',
                "Da'an Changsheng Solar Technology Co., Ltd.",
                'Qingdao Changsheng Electric Solar Polytron Technologies Inc',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Longjing',
                'Yanbian',
                'Jilin Longjing Zhongji solar farm',
                'Longjing Zhongji Energy Technology Co., Ltd.',
                'Zhejiang Jiahua Energy Chemical Industry Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Meihekou',
                'Tonghua',
                'Jilin Meihekou Zhongcheng Yinxin solar farm',
                'Meihekou Zhongcheng Yinxin Photovoltaic Agricultural Technology Co., Ltd.',
                'Zhongcheng Yinxin Holding Group Co., Ltd. [60%]; Zhang Zhongyong [10%]; Others [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Nongan',
                'Changchun',
                'Jilin Nongan Liuyuan solar farm',
                'Nongan Liuyuan Photovoltaic Power Generation Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Lesheng Town',
                "Da'an Shi",
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'Zhejiang Chint New Energy Development Co., Ltd.',
                'Zhejiang Chint Electrics Co., Ltd.[92%]; other[8%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Lesheng Town',
                "Da'an Shi",
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping Xang',
                'Zhenlai Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping Town',
                'Zhenlai Xian',
                'Baicheng',
                'Jilin Province Baicheng Front Runner solar farm',
                'China Guangdong Nuclear Solar Development Co. Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.[66.4%]; Shenzhen CGN Fengtai Investment Co., Ltd.[33.6%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Changling',
                'Songyuan',
                'Jilin Changling Shijing solar farm',
                'Changling Shijing New Energy Co., Ltd.',
                'Jilin Jidian New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Hongsibu District',
                'Wuzhong',
                'Ningxia Hongsibu Zhongzi solar farm',
                'Wuzhong Hongsibao Xinke Energy Co., Ltd.',
                'Huaneng Ningxia Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Baicaogou',
                'Wangqing',
                'Yanbian',
                'Jilin Wangqing Baicaogou Zhenfa solar farm',
                'Wangqing Zhenfa Investment Co., Ltd.',
                'Jilin Jidian New Energy Co., Ltd. [70%]; Wangqing County Finance Bureau [20%]; Tunghsu New Energy Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yitong',
                'Siping',
                'Jilin Yitong Changsheng solar farm',
                'Yitong Changsheng Solar Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yuhong',
                'Shenyang',
                'Liaoning Yuhong GCL solar farm',
                'Shenyang Yuhong District GCL Photovoltaic Power Co., Ltd.',
                'Suzhou Xiexin New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Lizifang',
                'Zhuanghe',
                'Dalian',
                'Liaoning Zhuanghe Lizifang Taishan Hongri solar farm',
                'Dalian Taishan Hongri Photovoltaic Power Generation Co., Ltd.',
                'Dalian Taishan Thermal Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zhuanghe',
                'Dalian',
                'Liaoning Zhuanghe Taishan Hongri solar farm',
                'Dalian Taishan Hongri Photovoltaic Power Generation Co., Ltd.',
                'Dalian Taishan Thermal Power Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                "Xi'an Town",
                'Haiyuan County',
                'Zhongwei',
                'Ningxia Haiyuan Fantaicun solar farm',
                'China Resources Wind Power (Haiyuan) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Futao',
                'Haiyuan County',
                'Zhongwei',
                'Ningxia Haiyuan Futaocun solar farm',
                'China Resources Wind Power (Haiyuan) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Haiyuan Xian',
                'Zhongwei',
                'Ningxia Haiyuan Ganyanchi Zhenfa solar farm',
                'Zhenfa Solar Energy Technology Co., Ltd.',
                'Zha Zhengyou[80%]; Zha Zhengfa[20%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Haiyuan County',
                'Wuzhong',
                'Ningxia Haiyuan Ganyanchi Zhenfa solar farm',
                'Haiyuan Zhenfa Photovoltaic Power Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Ganyanchi',
                'Haiyuan County',
                'Zhongwei',
                'Ningxia Haiyuan Ganyanchi Zhenxing solar farm',
                'Haiyuan Zhenxing Photovoltaic Power Generation Co., Ltd.',
                'Ningxia Hanguang New Energy Co., Ltd. [80%]; Jiangsu Zhongdian Electric Power Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                "Xi'an Town",
                'Haiyuan County',
                'Zhongwei',
                'Ningxia Haiyuan Jianjianshan solar farm',
                'China Resources Wind Power (Haiyuan) Co., Ltd.',
                'China Resources Power New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Sanhe',
                'Haiyuan',
                'Zhongwei',
                'Ningxia Haiyuan Sanhe Zhenyuan solar farm',
                'Haiyuan Zhenyuan Photovoltaic Power Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Ligang Town',
                'Helan County',
                'Yinchuan',
                "Ningxia Helan Aiyou'en solar farm",
                "Yinchuan Aiyou'en Energy Power Co., Ltd.",
                'JA Solar Investment (China) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Changxin Town',
                'Helan County',
                'Yinchuan',
                'Ningxia Helan Changxinxiang Jingneng solar farm',
                'Ningxia Helan Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng Clean Energy Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dahe Town',
                'Hongsibao Qu',
                'Wuzhong',
                'Ningxia Hongsibao Dahexiang Jiaze Grid-Connected solar farm',
                'Ningxia Jiaze Renewables Corporation Limited',
                'Ningxia Jiaze Renewables Corporation Limited',
              ],
              [
                'China',
                30,
                'Asia',
                'Dahe Town',
                'Hongsibao Qu',
                'Wuzhong',
                'Ningxia Hongsibao Dahexiang Jiaze Grid-Connected solar farm',
                'Ningxia Jiaze Renewables Corporation Limited',
                'Ningxia Jiaze Renewables Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Taiyangshan Town',
                'Hongsibao Qu',
                'Wuzhong',
                'Ningxia Hongsibao Drug Rehabilitation Center Yuanshen Grid-Connected solar farm',
                'Beijing Yuanshen Energy Conservation Technology Co., Ltd. Ningxia Branch',
                'Beijing Jingneng Technology Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Hongsibu District',
                'Wuzhong',
                'Ningxia Hongsibao Zhongzi solar farm',
                'Ningxia Zhongzi Solar Photovoltaic Power Generation Co., Ltd.',
                'Tibet Zhongzi New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dahe',
                'Hongsibu',
                'Wuzhong',
                'Ningxia Hongsibu Dahe Datang solar farm',
                'Ningxia Datang International Hongsibao New Energy Co., Ltd.',
                'Datang International Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yi',
                'Jinzhou',
                'Liaoning Yi Jiayu solar farm',
                'Yixian Jiayu Photovoltaic Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Corporation Limited',
              ],
              [
                'China',
                24,
                'Asia',
                'Unavailable',
                'Yi',
                'Jinzhou',
                'Liaoning Yi Jiayu solar farm',
                'Yixian Jiayu Photovoltaic Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Corporation Limited',
              ],
              [
                'China',
                26,
                'Asia',
                'Xipingshan',
                'Pingdingshan',
                'Dalian',
                'Liaoning Tuoshanxiang Dalian Runri solar farm',
                'Dalian Runri Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Corporation Northeast Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baiqizhai',
                'Tieling',
                'Tieling',
                'Liaoning Tieling Baiqizhai Zhonghui solar farm',
                'Tieling Zhonghui New Energy Co., Ltd.',
                'Changshu Tuojia Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping',
                'Zhenlai',
                'Baicheng',
                'Jilin Zhenlai Jianping CGN solar farm',
                'Zhenlai CGN New Energy Co., Ltd.',
                'CGN Chuangyi Wind Power (Beijing) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping',
                'Zhenlai',
                'Baicheng',
                'Jilin Zhenlai Jianping CGN solar farm',
                'Zhenlai CGN New Energy Co., Ltd.',
                'CGN Chuangyi Wind Power (Beijing) Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jianping',
                'Zhenlai',
                'Baicheng',
                'Jilin Zhenlai Jianping Jidian solar farm',
                'Zhenlai Jidian New Energy Co., Ltd.',
                'Jilin Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zhenlai',
                'Baicheng',
                'Jilin Zhenlai Jinyang solar farm',
                'Zhenlai Jinyang New Energy Co., Ltd.',
                'Beijing Xuanji New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shanyuan Town',
                'Beipiao',
                'Chaoyang',
                'Liaoning Beipiao solar farm',
                'China Water Resources and Hydropower Tenth Engineering Bureau Co., Ltd.',
                'China Electric Power Construction Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Chaoyang',
                'Chaoyang',
                'Liaoning Chaoyang Jingao solar farm',
                'Chaoyang Jingao Solar Power Generation Co., Ltd.',
                "Jing'ao Solar Energy Investment (China) Co., Ltd.",
              ],
              [
                'China',
                20,
                'Asia',
                'Lianjiaba Reservoir',
                'Donggang',
                'Dandong',
                'Liaoning Donggang Lianjiaba Reservior Shenneng solar farm',
                'Donggang Shenneng New Energy Co., Ltd.',
                'Liaoning Anyu Electric Power Construction Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Lianjiaba Reservoir',
                'Donggang',
                'Dandong',
                'Liaoning Donggang Lianjiaba Reservior Xinnong solar farm',
                'Donggang Xinnong Photovoltaic Power Generation Co., Ltd.',
                'Liaoning Anyu Electric Power Construction Co., Ltd.',
              ],
              [
                'China',
                23,
                'Asia',
                'Unavailable',
                'Wangqing',
                'Yanbian',
                'Jilin Wangqing Zhenfa solar farm',
                'Wangqing Zhenfa Investment Co., Ltd.',
                'Jilin Jidian New Energy Co., Ltd. [70%]; Wangqing County Finance Bureau [20%]; Tunghsu New Energy Investment Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Fushun',
                'Fushun',
                'Liaoning Fushun Rituo solar farm',
                'Liaoning Rituo Xinneng Technology Development Co., Ltd.',
                'Fushun Mining Group Co., Ltd. [81%]; Liaoning Liaoneng Sunshine Power Co., Ltd. [19%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xintaimen Town',
                'Lianshan District',
                'Huludao',
                'Liaoning Huludao Dalian Runri solar farm',
                'Huludao Lianshan GCL Photovoltaic Power Co., Ltd.',
                'Suzhou GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bashihan Town',
                'Jianchang County',
                'Huludao',
                'Liaoning Huludao Jianchang Bashihan solar farm',
                'Huaneng Jianchang Photovoltaic Power Generation Co., Ltd.',
                'Huaneng International Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jiangchang County',
                'Huludao',
                'Liaoning Jianchang Bashihan Yushudi solar farm',
                'Huaneng Jianchang Photovoltaic Power Generation Co., Ltd.',
                'Huaneng International Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Kangping',
                'Shenyang',
                'Liaoning Kangping Tenglong solar farm',
                'Shenyang Tenglong New Energy Co., Ltd.',
                'State Power Investment Group Northeast Power Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Lingyuan',
                'Chaoyang',
                'Liaoning Lingyuan CLP solar farm',
                'Clp (Lingyuan) Hejiagou New Energy Company Limited',
                'CLP Power China Wind Projects (Heilongjiang) Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Lizefang Town',
                'Zhuangheshi',
                'Dalian',
                'Liaoning Province Dalian Zhuanghe Yongji Fisheries solar farm',
                'Dalian Taishan Hongri Photovoltaic Power Generation Co., Ltd.',
                'Dalian Taishan Thermal Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shuangta',
                'Chaoyang',
                'Liaoning Shuangta Beipiao solar farm',
                'Beipiao Thermoelectricity Co., Ltd.',
                'CPI Northeast Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinkaihe Town',
                "Tai'an County",
                'Anshan',
                "Liaoning Tai'an Taisheng solar farm",
                'Tai\u2018an Taisheng Photovoltaic Agricultural Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                25,
                'Asia',
                'Unavailable',
                'Haicheng',
                'Anshan',
                'Liaoning Haicheng Aikang solar farm',
                'Haicheng Aikang Power Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Shangdang Town',
                'Dantu District',
                'Zhenjiang Municipality',
                'Jiangsu Dantu "fisheries" Photovoltaic solar power plant',
                'Zhenjiang Xinneng Photovoltaic Power Co. Ltd.',
                'Nanjing Ruisen New Energy Co. Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Gangkou Town',
                'Jiujiang',
                'Jiujiang',
                'Jiangxi Province Jiujiang Jinko solar farm',
                'Jiujiang Balihu New District Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                45,
                'Asia',
                'Fushantang Ash Pond of Changshu Power Generating Company',
                'Changshu Municipality',
                'Suzhou Municipality',
                'Jiangsu Changshu Fushan Photovoltaic solar plant',
                'Changshu Fushan Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu Changshu Power Generation Co. Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Linxiang',
                'Yueyang',
                'Hunan Linxiang Mingyu solar farm',
                'Linxiang Mingyu New Energy Development Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Miluo',
                'Miluo',
                'Yueyang',
                'Hunan Miluo Miluo Xianghe solar farm',
                'Xianghe New Energy Co., Ltd.',
                'Hunan Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Sanxianhu',
                'Nan',
                'Yiyang',
                'Hunan Nan Sanxianhu Shengbu solar farm',
                'Nanxian Shengbu Photovoltaic Power Generation Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                49,
                'Asia',
                'Wushi',
                'Pingjiang',
                'Yueyang',
                'Hunan Pingjiang Wushi Jiaxiang solar farm',
                'Pingjiang Jiaxiang City Investment Development Co., Ltd.',
                'Yu Xiaoqiang [50%]; Zhang Zhiwen [35%]; Pan Jiantuan [15%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wushi',
                'Pingjiang',
                'Yueyang',
                'Hunan Pingjiang Wushi Yueshui solar farm',
                'Pingjiang Guangdong Hydropower Energy Development Co., Ltd.',
                'Zhongnan Yueshui Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Rudong Town',
                'Li County',
                'Changde',
                'Hunan Province Changde Lixian Fishing and Light Complementary solar farm',
                'Lixian Gufeng New Energy Technology Co., Ltd.',
                'CGN (Hunan) New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Leiyang',
                'Hengyang',
                'Hunan Province Leiyang solar farm',
                'National Energy Group Hunan Electric Power New Energy Co., Ltd.',
                'National Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Guanjiazui Town',
                'Qidong',
                'Hengyang',
                'Hunan Province Qidong Guanjiazui solar farm',
                'National Energy Group Hunan Electric Power New Energy Co., Ltd.',
                'National Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'WenmingpuTown',
                'Qiyang',
                'Yongzhou',
                'Hunan Province Qiyang Bitong solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'China',
                50,
                'Asia',
                'Sifen',
                'Liling',
                'Zhuzhou',
                'Hunan Province Sifen Yatang Reservoir solar farm',
                'Datang Huayin Zhuzhou Electricity Generate Co., Ltd.',
                'Datang Huayin Electric Power Co.,Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Taizimiao Town',
                'Hanshou Xian',
                'Changde',
                'Hunan Province Taizimiao Jiqingcun Haohui solar farm',
                'HanShou HaoHui Solar Power Co., Ltd.',
                'Changzhou Zhaolian Lvrui New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Taizimiao Town',
                'Hanshou Xian',
                'Changde',
                'Hunan Province Taizimiao Jiqingcun Haohui solar farm',
                'HanShou HaoHui Solar Power Co., Ltd.',
                'Changzhou Zhaolian Lvrui New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Sihushan Town',
                'Yuanjiang Shi',
                'Yiyang',
                'Hunan Province Yiyang Beigang Changhe Fishing and Light Complementary solar farm',
                'China Datang Corporation',
                'China Datang Corporation',
              ],
              [
                'China',
                100,
                'Asia',
                'Nianyuxu Town',
                'Huarong Xian',
                'Yueyang',
                'Hunan Province Yueyang Taxi Lake CGN solar farm',
                'China Guangdong Nuclear Power Group Co., Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangtupu',
                'Qidong',
                'Hengyang',
                'Hunan Qidong Huangtupu Dasheng Lunzhao solar farm',
                'Qidong Lunzhao New Energy Technology Co., Ltd.',
                'Hunan Feihua Power Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huangtupu',
                'Qidong',
                'Hengyang',
                'Hunan Qidong Huangtupu Yongde Lunzhao solar farm',
                'Qidong Lunzhao New Energy Technology Co., Ltd.',
                'Hunan Feihua Power Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Shitingzi',
                'Qidong',
                'Hengyang',
                'Hunan Qidong Shitingzi Qiutang Shangyi solar farm',
                'Qidong Yongguang Solar Energy Technology Co., Ltd.',
                'Luo Yongjun',
              ],
              [
                'China',
                20,
                'Asia',
                'Hekou',
                'Linli',
                'Changde',
                'Hunan Linli Hekou Jianxin solar farm',
                'Linli Jianxin Photovoltaic Power Co., Ltd.',
                'Anhui New Energy Venture \uff06 Investment Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Lingling',
                'Yongzhou',
                'Hunan Lingling Huawei solar farm',
                'Yongzhou Huawei Solar Technology Co., Ltd.',
                'Huan Huawei Solar Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Longtang',
                'Lianyuan',
                'Loudi',
                'Hunan Lianyuan Longtang Tongxing solar farm',
                'Lianyuan Tongxing New Energy Technology Co., Ltd.',
                'Shanghai Shangdian Xinda New Energy Technology Co., Ltd. [80%]; Hunan Shuifa Xingye Green Energy Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangjiachang',
                'Li County',
                'Changde',
                'Hunan Li Wangjiachang Zehui solar farm',
                'Lixian Zehui Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yudepu',
                'Hanshou',
                'Changde',
                'Hunan Hanshou Yudepu Zhonghui solar farm',
                'Hanshou Zhonghui Solar Power Co., Ltd.',
                'Changshu Hongfeng Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Quanjiaohe',
                'Heshan',
                'Yiyang',
                'Hunan Heshan Quanjiaohe Lingjiaocha solar farm',
                'Yiyang Lingjiaocha Photovoltaic Power Development Co., Ltd.',
                'Hunan Xingyi New Energy Development Co., Ltd. [70%]; Hunan Changhui Electric Power Technology Development Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Beijinggang',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Beijinggang Chaoyang Fusheng solar farm',
                'Huarong Fusheng New Energy Co., Ltd.',
                'Hunan Jingrui New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beijinggang',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Beijinggang Heping Jingyao solar farm',
                'Huarong Jingyao Electric Power Co., Ltd.',
                'Hunan Jingyao Distributed Energy Service Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beijinggang',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Beijinggang Shanghengzhou Jingyao solar farm',
                'Huarong Jingyao Electric Power Co., Ltd.',
                'Hunan Jingyao Distributed Energy Service Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Beijinggang',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Beijinggang Xiangyang Fusheng solar farm',
                'Huarong Fusheng New Energy Co., Ltd.',
                'Hunan Jingrui New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dongshan',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Dongshan Xianghe solar farm',
                'Xianghe New Energy Co., Ltd.',
                'Hunan Nuclear Power Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Nianyuxu',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Nianyuxu GCL solar farm',
                'Huarong GCL Photovoltaic Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd. [80%]; Suzhou Xiexin New Energy Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Shitingzi',
                'Qidong',
                'Hengyang',
                'Hunan Qidong Shitingzi Yangmei Baofeng solar farm',
                'Qidong Yongguang Solar Energy Technology Co., Ltd.',
                'Luo Yongjun',
              ],
              [
                'China',
                40,
                'Asia',
                'Nianyuxu',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Nianyuxu GCL solar farm',
                'Huarong GCL Photovoltaic Power Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd. [80%]; Suzhou Xiexin New Energy Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanyu',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Wanyu Huaxin solar farm',
                'Huarong Huaxin New Energy Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanyu',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Wanyu Jingsheng solar farm',
                'Huarong Jingsheng New Energy Co., Ltd.',
                'Anhui New Energy Venture \uff06 Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Tanping',
                'Jiahe',
                'Chenzhou',
                'Hunan Jiahe Tanping Jingke solar farm',
                'Jiahe Jingke Electric Power Co., Ltd.',
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Cennan',
                'Li County',
                'Changde',
                'Hunan Li Cennan Dehui solar farm',
                'Lixian Dehui Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayandang',
                'Li County',
                'Changde',
                'Hunan Li Dayandang Dehui solar farm',
                'Lixian Dehui Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dayandang',
                'Li County',
                'Changde',
                'Hunan Li Dayandang Dehui solar farm',
                'Lixian Dehui Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Rudong',
                'Li County',
                'Changde',
                'Hunan Li Rudong Gufeng solar farm',
                'Lixian Gufeng New Energy Technology Co., Ltd.',
                'CGN (Hunan) New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Rudong',
                'Li County',
                'Changde',
                'Hunan Li Rudong Xieguang solar farm',
                'Lixian XieGuang New Energy Development Co., Ltd.',
                'Hunan Wanneng New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanyu',
                'Huarong',
                'Yueyang',
                'Hunan Huarong Wanyu Alos solar farm',
                'Alos (Huarong) Photovoltaic Power Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yudepu',
                'Hanshou',
                'Changde',
                'Hunan Hanshou Yudepu Zhonghui solar farm',
                'Hanshou Zhonghui Solar Power Co., Ltd.',
                'Changshu Hongfeng Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xinpu',
                'Shimen',
                'Changde',
                'Hunan Shimen Xinpu Wuling solar farm',
                'Wuling Shimen Electric Power Co., Ltd.',
                'Wuling Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengshu',
                'Taoyuan',
                'Changde',
                'Hunan Taoyuan Fengshu Xiangcheng solar farm',
                'Taoyuan Xiangcheng Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                "Baiyun'ebo Mining Area",
                'Baotou',
                "Inner Mongolia Baiyun'ebo Mining Area solar farm",
                'Baotou Zhongli Tenghui Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Balagong Town',
                'Hangjin Banner',
                'Ordos',
                'Inner Mongolia Balagong Hongda Zhongyuan solar farm',
                'Hongda Zhongyuan Hangjinqi Solar Power Generation Co., Ltd.',
                'Inner Mongolia Shengyue New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Balin Right Banner',
                'Chifeng',
                "Inner Mongolia Balin Right Banner Jing'ao solar farm",
                "Chifeng Jing'ao Photovoltaic Power Generation Co., Ltd.",
                'CPI Northeast New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                "Baiyinnuo'er Town",
                'Bairin Left Banner',
                'Chifeng',
                'Inner Mongolia Balin Right Banner Lishuo solar farm',
                'Inner Mongolia Lishuo Photovoltaic Power Generation Co., Ltd. \uff08',
                'Shanghai Zhijian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Guoqing Town',
                'Shiguai District',
                'Baotou',
                'Inner Mongolia Baotou Shiguai District Area 2 solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Guoqing Town',
                'Shiguai District',
                'Baotou',
                'Inner Mongolia Baotou Shiguai District Area 9 solar farm',
                'Shiguai Mengsheng Solar Technology Co., Ltd.',
                'Qingdao Mengsheng Solar Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wudangshao Town',
                'Shiguai District',
                'Baotou',
                'Inner Mongolia Baotou Shiguai District Mined Area 1 solar farm',
                'Baotou Guangyi Solar Power Co., Ltd.',
                'Inner Mongolia Guangxin Solar Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Shiguai District',
                'Baotou',
                'Inner Mongolia Baotou Shiguai District Mined Area 8 solar farm',
                'Baotou Qingshan Electrical Equipment Co., Ltd.',
                'Baotou Huadian Borui Electric Power Automation Engineering Technology Co., Ltd.[80%]; Others[20%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jiufengshan Eco-Management Commission Area',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Gongshanwan solar farm',
                'Baotou North Xihe Liri New Energy Co., Ltd.',
                'Beifang Lianhe Power Co. Ltd. [Huaneng Group]',
              ],
              [
                'China',
                40,
                'Asia',
                'Jiangjunyao Town',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Jiangjunyao solar farm',
                'Tumed Right Banner Guodian Power Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Zhejing Energy Development Co., Ltd. [86.7%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd. [13.3%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Jiufengshan Eco-Management Commission Area',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Mao Ergeqing solar farm',
                'Tumote Right Banner Tianhui New Energy Power Generation Co., Ltd.',
                'Trina Solar Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'New Technology Industrial Estate',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Shengming solar farm',
                'Inner Mongolia Shengming Solar Power Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                65,
                'Asia',
                'Subogai Town',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Subogaixiang solar farm',
                'Inner Mongolia Xiangdao Yuneng Agriculture Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jiufengshan Eco-Management Commission Area',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia Baotou Tuyou Banner Zhengtai solar farm',
                'Baotou Chint Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Mingshanao Town',
                'Tumoteyou Banner',
                'Baotou',
                'Inner Mongolia BaotouTuyou Banner Miaoliuyingcun solar farm',
                'China Power Investment Mengxi Tuyou New Energy Co., Ltd.',
                'CPI (Western Inner Mongolia) New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'West side of industrial park',
                'Dengkou Xian',
                'Bayannaoer',
                'Inner Mongolia Bayannaoer Dengkou County solar farm',
                'Dengkou County Guodian Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Zhejing Energy Development Co., Ltd.[86.7%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd.[13.3%]',
              ],
              [
                'China',
                50,
                'Asia',
                "E'erdengbulage Sumu",
                'Wulateqian Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaoer Wulateqian Banner Guangda solar farm',
                'Guodian Urad Qianqi Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia No.3 Electric Power Construction Engineering Co., Ltd.[98.9%]; other [1.1%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                "Baiyun'ebo Mining Area",
                'Baotou',
                "Inner Mongolia Baiyun'ebo Mining Area solar farm",
                'Baotou Zhongli Tenghui Photovoltaic Power Co., Ltd.',
                'Huaneng Gongrong No. 1 (Tianjin) Equity Investment Fund Partnership [60%]; Huaneng Gongrong No. 2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Bailingmiao',
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Bailingmiao SPIC solar farm',
                'State Power Investment Corporation Damaoqi New Energy Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bailingmiao',
                'Darhan Muminggan United Banner',
                'Baotou',
                'Inner Mongolia Bailingmiao Baoyin Aobao SPIC solar farm',
                'State Power Investment Group Damaoqi New Energy Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Anqing Town',
                'Songshan District',
                'Chifeng',
                'Inner Mongolia Anqingzheng Haoqing solar farm',
                'Inner Mongolia Haoqing New Energy Technology Co., Ltd. \uff08',
                'Huarun Shenguotou Trust Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Taoyuan',
                'Changde',
                'Hunan Taoyuan Jiposhan Xinneng solar farm',
                'Taoyuan Xinneng Photovoltaic Power Co., Ltd.',
                'Hubei GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Taoyuan',
                'Changde',
                'Hunan Taoyuan Qikou Xinneng solar farm',
                'Taoyuan Xinneng Photovoltaic Power Co., Ltd.',
                'Hubei GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Taoyuan',
                'Changde',
                'Hunan Taoyuan Xinhui solar farm',
                'Taoyuan Xinhui Photovoltaic Power Co., Ltd.',
                'Hubei GCL New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xintian',
                'Yongzhou',
                'Hunan Xintian Wuling solar farm',
                'Wuling Xintian Power Co., Ltd.',
                'Wuling Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Yuanjiang',
                'Yiyang',
                'Hunan Yuanjiang Datang solar farm',
                'Datang Huayin Yuanjiang New Energy Co., Ltd.',
                'Datang Huayin Electric Power Co.,Ltd. [51%]; State Grid Hunan Comprehensive Energy Service Co., Ltd. [49%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Barunbieli Town',
                'Alxa Left Banner',
                'Alxa Banner',
                'Inner Mongolia Alashan Barunbieli Guodian solar farm',
                'Alxa Left Banner Guodian Xinyang Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Zhejing Energy Development Co., Ltd. [86.7%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd. [13.3%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashan Bayanhaote Luanjingtan CECEP solar farm',
                'CECEP Alxa Solar Power Generation Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashan Bayanhaote Luanjingtan CECEP solar farm',
                'CECEP Tengri Solar Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Fengshu',
                'Taoyuan',
                'Changde',
                'Hunan Taoyuan Fengshu Xiangcheng solar farm',
                'Taoyuan Xiangcheng Photovoltaic Power Co., Ltd.',
                'Sichuan Shengtian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashan Bayanhaote Luanjingtan solar farm',
                'Alxa League Fengwei Optoelectronics Co., Ltd.',
                'Shanghai Juren Energy Technology Co., Ltd.[95%]; Inner Mongolia Fengwei New Energy Group Co., Ltd.[5%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan League',
                'Inner Mongolia Alashan Chenghui solar farm',
                'Alxa League Shenghui Energy Technology Co., Ltd.',
                'Shanghai Mengyang Energy Technology Co., Ltd.[98.75%], other[1.25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan League',
                'Inner Mongolia Alashan Chenghui solar farm',
                'Alxa League Shenghui Energy Technology Co., Ltd.',
                'Shanghai Mengyang Energy Technology Co., Ltd.[98.75%], other[1.25%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Dalaihubu',
                'Ejina Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashan Ejina Banner solar farm',
                'Inner Mongolia Qinghua Group Xinneng Photovoltaic Co., Ltd.',
                'Shanghai Juren Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Alashan Left Banner',
                'Inner Mongolia Alashan Left Banner Guodian solar farm',
                'Alashan Zuoqi Guodian Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Zhongyue Electric Power Co., Ltd. [80%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashanzuo Banner Grid-Connected solar farm',
                'GD Power Inner Mongolia New Energy Azuoqi Branch',
                'GD Power Inner Mongolia New Energy Azuoqi Branch',
              ],
              [
                'China',
                20,
                'Asia',
                'Bayanhaote',
                'Alxa Left Banner',
                'Alxa League',
                'Inner Mongolia Alxa Left Banner Bayanhaote Guodian solar farm',
                'Guodian Alxa Left Banner No.2 Photovoltaic Power Generation Co., Ltd.',
                'Guoneng Inner Mongolia New Energy Investment Co., Ltd. [60%]; Wuxi Heguang New Energy Power Co., Ltd. [40%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Wusitai',
                'Alxa Left Banner',
                'Alxa League',
                'Inner Mongolia Alxa Left Banner Wusitai Datang solar farm',
                'Datang Alashan Economic Development Zone Photovoltaic Power Generation Co., Ltd.',
                'Datang Shandong Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yike',
                'Alxa Left Banner',
                'Alxa League',
                'Inner Mongolia Alxa Left Banner Yike Guodian solar farm',
                'Guodian Alxa Zuoqi Photovoltaic Power Generation Co., Ltd.',
                'Guoneng Inner Mongolia New Energy Investment Co., Ltd. [60%]; Beijing Guodian KEHUAN New Energy Technology Co., Ltd. [40%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Bayanhaote Town',
                'Alashanzuo Banner',
                'Alashan Leauge',
                'Inner Mongolia Alashan Bayanhaote solar farm',
                'Inner Mongolia Halun Energy Co., Ltd.',
                'Niu Huijun[65%];Alxa Fuquan Coal Co., Ltd.[19%]; Zhang Yuling[16%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Hailiutu Town',
                'Wulatezhong Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaoer Wulatezhong Banner solar farm',
                'Inner Mongolia China Nuclear Power Longteng New Energy Co., Ltd.',
                'Nanjing China Nuclear Solar Technology Co., Ltd.[51%]; Changzhou Longteng Urad Power Station Development Co., Ltd.[49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Yudepu',
                'Hanshou',
                'Changde',
                'Hunan Hanshou Yudepu Zhonghui solar farm',
                'Hanshou Zhonghui Solar Power Co., Ltd.',
                'Changshu Hongfeng Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Guiyang',
                'Chenzhou',
                'Hunan Guiyang Hecheng solar farm',
                'Guiyang Hecheng Photovoltaic Engineering Co., Ltd.',
                'Anhui New Energy Venture \uff06 Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiliping Town',
                'Hongan Xian',
                'Huanggang',
                "Hubei Province Hong'an Xinyi solar farm",
                'Hongan Xinyi New Energy Co., Ltd.',
                'MEGA GAIN INVESTMENTS LIMITED',
              ],
              [
                'China',
                100,
                'Asia',
                'Huanghu State Farm Administration Area',
                'Jianli Xian',
                'Jingzhou',
                'Hubei Province Jingzhou Jianli Huanghu Fishing and Light Complementary solar farm',
                'CECEP (Jianli) Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Yanjiahe Town',
                'Macheng Shi',
                'Huanggang',
                'Hubei Province Macheng Yanjiahe solar farm',
                'Hubei Energy Group Macheng Yanjiahe Photovoltaic Power Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                55,
                'Asia',
                'Zhongguanyi Town',
                'Macheng',
                'Huanggang',
                'Hubei Province Macheng Zhongguanyi Fuxu solar farm',
                'Macheng Fuxu Electric Power Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd.[66.5%], Shanghai Dingyong Energy Technology Co., Ltd.[33.5%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhongguanyi Town',
                'Macheng Shi',
                'Huanggang',
                'Hubei Province Macheng Zhongguanyi solar farm',
                'Hubei Macheng Jinfu Solar Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Zhongguanyi Town',
                'Macheng Shi',
                'Huanggang',
                'Hubei Province Macheng Zhongguanyi solar farm',
                'Hubei Macheng Jinfu Solar Power Co., Ltd.',
                'Huaneng Gongrong No.1 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [60%]; Huaneng Gongrong No.2 (Tianjin) Equity Investment Fund Partnership (Limited Partnership) [40%]',
              ],
              [
                'China',
                150,
                'Asia',
                'Sui County',
                'Sui Xian',
                'Suizhou',
                'Hubei Province Suixian Yindian solar farm',
                'Hubei Huadian Suixian Yindian Photovoltaic Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Qihe Town',
                'Zengdu Qu',
                'Suizhou',
                'Hubei Province Suizhou Jingxing Xihe solar farm',
                'Hubei Jingtai Photovoltaic Power Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Qihe Town',
                'Zengdu Qu',
                'Suizhou',
                'Hubei Province Suizhou Jingxing Xihe solar farm',
                'Hubei Jingtai Photovoltaic Power Co., Ltd.',
                'Lianhe Photovoltaic (Changzhou) Investment Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Wanhe Town',
                'Zengdu Qu',
                'Suizhou',
                'Hubei Province Suizhou Longgang Qixing Agriculture-light Complementary solar farm',
                'Hubei Wantai New Energy Development Co., Ltd.',
                'Hubei Qixing Automobile Body Co., Ltd.',
              ],
              [
                'China',
                325,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Suizhou',
                'Hubei Province Suizhou Poverty Alleviation Distributed solar farm',
                'not found',
                'not found',
              ],
              [
                'China',
                50,
                'Asia',
                'Wandian',
                'Zengdu Qu',
                'Suizhou',
                'Hubei Province Suizhou Wandian CGN solar farm',
                'CGN Solar Suizhou Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhixi Town',
                'Jintan District',
                'Changzhouy Municipality',
                'Jiangsu Changzhou Yijing Photovoltaic solar farm',
                'Changzhou Jintan District Zhixi Yijing Photovoltaic Power Co. Ltd.',
                'Changzhou Yijing Photovoltaic Power Technology Co. Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Zougang Town',
                'Xiaochang Xian',
                'Xiaogan',
                'Hubei Province Xiaochang Zougang solar farm',
                'Xinyi Light Energy (Xiaochang) Co., Ltd.',
                'New Wisdom International Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhuwa',
                'Xishui',
                'Huanggang',
                'Hubei Province Xishui Zhuwa China Power solar farm',
                'China Power International Development Co., Ltd.',
                'China Power International Development Limited',
              ],
              [
                'China',
                50,
                'Asia',
                'Zhuwa',
                'Xishui',
                'Huanggang',
                'Hubei Province Xishui Zhuwa Dabieshan solar farm',
                'Huanggang Dabieshan Power Company Limited',
                'China Power International Development Limited[51%];Huainan Mining [Group] Co., Ltd.[42%]; other[7%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Qifang Town',
                'Zaoyang Shi',
                'Xiangyang',
                'Hubei Province Zaoyang Qifangzhen Agriculture-Light Complementary solar farm',
                'CGN New Energy Holdings Co., Ltd.',
                'CGN New Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qiliping Town',
                'Hongan Xian',
                'Huanggang',
                "Hubei Province Hong'an Xinyi solar farm",
                'Hongan Xinyi New Energy Co., Ltd.',
                'MEGA GAIN INVESTMENTS LIMITED',
              ],
              [
                'China',
                50,
                'Asia',
                'Ercheng Town',
                "Hong'an Xian",
                'Huanggang',
                "Hubei Province Hong'an Erchengzhen Jinko solar farm",
                "Hong'an Jingke Electric Power Co., Ltd.",
                'Jinko Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Tiemengang',
                'Macheng',
                'Huanggang',
                'Hubei Macheng Tiemengang Gaotou solar farm',
                'Macheng Gaotou Optoelectronics Co., Ltd.',
                'Hubei New Energy Investment Co., Ltd. [51%]; Macheng Energy Investment Development Co., Ltd. [49%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Tiemengang',
                'Macheng',
                'Huanggang',
                'Hubei Macheng Tiemengang CLP solar farm',
                'Hubei Zhongdian Zhiguang New Energy Co., Ltd.',
                'CLP Dabieshan (Hubei) Power Sales Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dawu',
                'Xiaogan',
                'Hubei Dawu Wuxin solar farm',
                'Hubei Wuxin New Energy Development Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Chenxiang',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Chenxiang Lvdong solar farm',
                'Guangshui Lvdong Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Guangshui Wangzishan solar farm',
                'Hubei Energy Group Guangshui Wangzishan Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Lidian',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Lidian Fuyang solar farm',
                'Guangshui Fuyang Electric Power Co., Ltd.',
                'Huarun Shenguotou Trust Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shili',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Shili CLP solar farm',
                'CLP Hubei Guangshui New Energy Power Development Co., Ltd.',
                'Hubei Hongyuan Power Engineering Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Wudian',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Wudian Hubei Energy Group solar farm',
                'Hubei Energy Group Guangshui Wangzishan Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Wudian',
                'Guangshui',
                'Suizhou',
                'Hubei Guangshui Wudian Hubei Energy Group solar farm',
                'Hubei Energy Group Guangshui Wangzishan Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Hanchuan',
                'Xiaogan',
                'Hubei Hanchuan Shenghe solar farm',
                'Hanchuan Shenghe New Energy Development Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Taiping Town',
                'Zaoyang Shi',
                'Xiangyang',
                'Hubei Province Zaoyang Taiping Ground solar farm',
                'Hubei Huadian Zaoyang Photovoltaic Power Generation Co., Ltd.',
                'Huadian New Energy Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Sanhu',
                'Jiangling',
                'Jingzhou',
                'Hubei Jiangling Sanhu GCL solar farm',
                'Jiangling GCL Photovoltaic Power Co., Ltd.',
                'Wuling Power Corporation [55%]; Suzhou Xiexin New Energy Investment Co., Ltd. [45%]',
              ],
              [
                'China',
                70,
                'Asia',
                'Unavailable',
                'Jingshan',
                'Jingmen',
                'Hubei Jingshan Datang solar farm',
                'Datang Solar Energy Industry Jingmen Co., Ltd.',
                'Datang Hubei Energy Development Co., Ltd. [95%]; Others [5%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Hongshanzui',
                'Laohekou',
                'Xiangyang',
                'Hubei Laohekou Hongshanzui Hubei Energy Group solar farm',
                'Hubei Energy Group Laohekou Sanjianshan Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Hongshanzui',
                'Laohekou',
                'Xiangyang',
                'Hubei Laohekou Hongshanzui Hubei Energy Group solar farm',
                'Hubei Energy Group Laohekou Sanjianshan Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xianrendu',
                'Laohekou',
                'Xiangyang',
                'Hubei Laohekou Xianrendu Zhuiri solar farm',
                'Laohekou Zhuiri Photovoltaic Power Generation Co., Ltd.',
                'Ninghai Zhongji Guoneng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xianrendu',
                'Laohekou',
                'Xiangyang',
                'Hubei Laohekou Xianrendu Zhuiri solar farm',
                'Laohekou Zhuiri Photovoltaic Power Generation Co., Ltd.',
                'Ninghai Zhongji Guoneng New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Kuanghe',
                'Luotian',
                'Huanggang',
                'Hubei Luotian Kuanghe Datang solar farm',
                'Datang Solar Energy Industry Luotian Co., Ltd.',
                'China Datang Group Solar Energy Industry Co., Ltd. [90%]; Zhejiang Chint New Energy Development Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Macheng',
                'Huanggang',
                'Hubei Macheng CLP solar farm',
                'Hubei Zhongdian Zhiguang New Energy Co., Ltd.',
                'CLP Dabieshan (Hubei) Power Sales Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Songbu',
                'Macheng',
                'Huanggang',
                'Hubei Macheng Songbu Jindi solar farm',
                'Macheng Jindi Solar Power Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Jianli',
                'Jingzhou',
                'Hubei Jianli Cecep solar farm',
                'CECEP (Jianli) Solar Energy Technology Co., Ltd.',
                'Cecep Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Yudepu',
                'Hanshou',
                'Changde',
                'Hunan Hanshou Yudepu Zhonghui solar farm',
                'Hanshou Zhonghui Solar Power Co., Ltd.',
                'Changshu Hongfeng Photovoltaic Power Station Development Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Xinshi Town',
                'Zaoyang Shi',
                'Xiangyang',
                'Hubei Province Zaoyang Xinshi Huaneng solar farm',
                'Hubei Wind Power Branch of Huaneng International Power Co., Ltd.',
                'Huaneng Power International, Inc.',
              ],
              [
                'China',
                30,
                'Asia',
                'Guandang',
                'Shayang',
                'Jingmen',
                'Hubei Shayang Guandang Lvdong solar farm',
                'Shayang Lvdong Photovoltaic Power Generation Co., Ltd.',
                'State Power Investment Group Hubei Power Sales Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Wangdian',
                'Xiaochang',
                'Xiaogan',
                'Hubei Xiaochang Wangdian Jinfu solar farm',
                'Xiaochang Jinfu Solar Power Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd. [70%]; Wuhan Rixin Energy Co., Ltd. [30%]',
              ],
              [
                'China',
                150,
                'Asia',
                'Zougang',
                'Xiaochang',
                'Xiaogan',
                'Hubei Xiaochang Zougang Xinyi solar farm',
                'Xinyi Light Energy (Xiaochang) Co., Ltd.',
                'New Wisdom International Limited',
              ],
              [
                'China',
                40,
                'Asia',
                'Zougang',
                'Xiaochang',
                'Xiaogan',
                'Hubei Xiaochang Zougang Xinyi solar farm',
                'Xinyi Solar Energy (Xiaochang) Co., Ltd.',
                'New Wisdom International Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xiaoting',
                'Yichang',
                'Hubei Xiaoting Jingneng solar farm',
                'Yichang Jingneng Photovoltaic Power Co., Ltd.',
                'Shanghai Jingke Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Futu',
                'Yangxin',
                'Huangshi',
                'Hubei Yangxin Futu SPIC solar farm',
                'State Power Investment Group Huangshi New Energy Co., Ltd.',
                'State Power Investment Group Jiangxi Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Yangxin',
                'Huangshi',
                'Hubei Yangxin Xingang solar farm',
                'Huangshi Xingang Photovoltaic Power Generation Co., Ltd.',
                'Huangshi Jinggang New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Yangxin',
                'Huangshi',
                'Hubei Yangxin Xingang solar farm',
                'Huangshi Xingang Photovoltaic Power Generation Co., Ltd.',
                'Huangshi Jinggang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Liushui',
                'Yicheng',
                'Xiangyang',
                'Hubei Yicheng Liushui Mengshi solar farm',
                'Yicheng Mengshi Clean Energy Technology Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wangji',
                'Yicheng',
                'Xiangyang',
                'Hubei Yicheng Wangji Tongjing solar farm',
                'Yicheng Tongjing New Energy Co., Ltd.',
                'Jiangshan Xiaokang Photovoltaic Co., Ltd.',
              ],
              [
                'China',
                70,
                'Asia',
                'Towngji Town',
                'Yicheng',
                'Xiangyang',
                'Hubei Yicheng Zhengji solar farm',
                'Sungrow Renewables Development Co., Ltd.',
                'Sungrow Power Supply Co., Ltd.[77%]; other[23%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Shangjin Town',
                'Yunxi County',
                'Shiyan',
                'Hubei Yunxi Shangjinzhen Runfeng solar farm',
                'Runfeng Power (Yunxi) Co., Ltd.',
                'Beijing Beikong Suyin Equity Investment Management Center [Limited Partnership]',
              ],
              [
                'China',
                30,
                'Asia',
                'Tumen',
                'Yunxi',
                'Shiyan',
                'Hubei Yunxi Tumen Xinye solar farm',
                'Hubei Xinye Green Energy Technology Co., Ltd.',
                'Beijing Jingyuntong Technology Co., Ltd. [73.3%]; Hunan Shuifa Xingye Green Energy Co., Ltd. [26.7%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Liubei Town',
                'Yun County',
                'Shiyan',
                'Hubei Yunxian Zhongguang Risheng solar farm',
                'Zhongguang Risheng (Yunxian) New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Qifang',
                'Zaoyang',
                'Xiangyang',
                'Hubei Zaoyang Qifang CNG solar farm',
                'CGN New Energy Zaoyang Co., Ltd.',
                'CGN New Energy Investment (Shenzhen) Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Zengdu',
                'Suizhou',
                'Hubei Zengdu CGN solar farm',
                'CGN Suizhou Solar Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baiyang',
                'Zhijiang',
                'Yichang',
                'Hubei Zhijiang Baiyang Fuyao solar farm',
                'Yichang Fuyao Green Power Co., Ltd.',
                'Charisma Energy Services Limited [80%]; Fuyao Energy Technology (Shanghai) Co., Ltd. [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Chunhua',
                'Changsha',
                'Changsha',
                'Hunan Changsha Chunhua Huanran solar farm',
                'Hunan Huanran Energy Development Co., Ltd.',
                'Jiangxi Shuitou Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Baisha',
                'Xiaochang',
                'Xiaogan',
                'Hubei Xiaochang Baisha Xinyi solar farm',
                'Xinyi Solar Energy (Xiaochang) Co., Ltd.',
                'New Wisdom International Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Pengchang',
                'Xiantao',
                'Unavailable',
                'Hubei Xiantao Pengchang Hansheng solar farm',
                'Xiantao Hansheng Solar Energy Technology Co., Ltd.',
                'Qingdao Chengtou New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Xiantao',
                'Hubei Xiantao Linyang solar farm',
                'Hubei Linyang New Energy Technology Co., Ltd.',
                'Jiangsu Linyang Renewable Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xiantao',
                'Unavailable',
                'Hubei Xiantao Dongxu solar farm',
                'Xiantao Dongxu New Energy Technology Co., Ltd.',
                'Tunghsu New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                55,
                'Asia',
                'Unavailable',
                'Shayang',
                'Jingmen',
                'Hubei Shayang Jinfu solar farm',
                'Shayang Jinfu Solar Power Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd. [70%]; Wuhan Rixin Energy Co., Ltd. [30%]',
              ],
              [
                'China',
                46,
                'Asia',
                'Unavailable',
                'Shayang',
                'Jingmen',
                'Hubei Shayang Jinyuan solar farm',
                'Shayang Jinyuan New Energy Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd. [70%]; Wuhan Rixin Energy Co., Ltd. [30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Shihuiqiao',
                'Shayang',
                'Jingmen',
                'Hubei Shayang Shihuiqiao Chufu solar farm',
                'Shayang Chufu New Energy Co., Ltd.',
                'Shenneng New Energy (Inner Mongolia) Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Changgang',
                'Sui',
                'Suizhou',
                'Hubei Sui Changgang Hubei Energy Group solar farm',
                'Hubei Energy Group Suizhou Changgang New Energy Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Wanfudian',
                'Sui',
                'Suizhou',
                'Hubei Sui Wanfudian Aikang solar farm',
                'Suixian Aikang New Energy Investment Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wanhe',
                'Sui',
                'Suizhou',
                'Hubei Sui Wanhe Waitai solar farm',
                'Hubei Wantai New Energy Development Co., Ltd.',
                'Hubei Qixing Automobile Body Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Wanhe',
                'Sui',
                'Suizhou',
                'Hubei Sui Wanhe Wantai solar farm',
                'Hubei Wantai New Energy Development Co., Ltd.',
                'Hubei Qixing Automobile Body Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sui',
                'Suizhou',
                'Hubei Sui Wantai solar farm',
                'Hubei Wantai New Energy Development Co., Ltd.',
                'Hubei Qixing Automobile Body Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xinshi Town',
                'Zaoyang Shi',
                'Xiangyang',
                'Hubei Province Zaoyang Xinshi Huaneng solar farm',
                'Hubei Wind Power Branch of Huaneng International Power Co., Ltd.',
                'Huaneng Power International, Inc.',
              ],
              [
                'China',
                50,
                'Asia',
                'Yindian',
                'Sui',
                'Suizhou',
                'Hubei Suixian Jiangtoudian solar farm',
                'Hubei Energy Group Suixian Yanzihe Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tianmen',
                'Unavailable',
                'Hubei Tianmen Zhuiri solar farm',
                'Tianmen Zhuiri Energy Development Co., Ltd.',
                'Tianjin Fuyi Enterprise Management Consulting Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Tongshan',
                'Xianning',
                'Hubei Tongshan CLP solar farm',
                'Tongshan Zhongdian Photovoltaic Power Generation Co., Ltd.',
                'SDIC Changjiang Ecological Energy Co., Ltd.',
              ],
              [
                'China',
                68,
                'Asia',
                'Unavailable',
                'Tuanfeng',
                'Huanggang',
                'Hubei Tuanfeng Shengyang solar farm',
                'Tuanfeng Shengyang New Energy Power Generation Co., Ltd.',
                'Hefei Simu New Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huaqiao',
                'Wuxue',
                'Huanggang',
                'Hubei Wuxue Huaqiao Jixin solar farm',
                'Wuxue Jixin New Energy Co., Ltd.',
                'Wuxue Jinhe New Energy Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Unavailable',
                'Wuxue',
                'Huanggang',
                'Hubei Wuxue Jincan solar farm',
                'Wuxue Jincan New Energy Co., Ltd.',
                'State Power Investment Group Hubei Lvdong New Energy Co., Ltd. [70%]; Wuhan Rixin Energy Co., Ltd. [30%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xiantao',
                'Unavailable',
                'Hubei Xiantao Chuneng solar farm',
                'Xiantao Chuneng New Energy Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Xiantao',
                'Unavailable',
                'Hubei Xiantao Chuneng solar farm',
                'Xiantao Chuneng New Energy Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                49,
                'Asia',
                'Unavailable',
                'Xiantao',
                'Unavailable',
                'Hubei Xiantao Chuneng solar farm',
                'Xiantao Chuneng New Energy Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Yindian',
                'Sui',
                'Suizhou',
                'Hubei Suixian Yanzihe solar farm',
                'Hubei Energy Group Suixian Yanzihe Photovoltaic Power Generation Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Longxingchang',
                'Wuyuan Xian',
                'Bayannaoer',
                'Inner Mongolia Bayannaoer Wuyuan County solar farm',
                'Inner Mongolia Taihua Agricultural Development Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Xihe Town',
                'Zengdu District',
                'Suizhou',
                'Hubei Province Suizhou Xihe Qixing solar farm',
                'Hubei Sanyo Photovoltaic Power Co., Ltd.',
                'Hubei Qixing Automobile Body Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huhewenduer Town',
                'Wulatehou Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaouer Wulatehou Banner Ecosolar Project',
                'Wulate Houqi Yuanhai New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chaoge',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Chaoge Huadian solar farm',
                'Inner Mongolia Huadian Chaoge New Energy Co., Ltd.',
                'Huadian Inner Mongolia Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Huadian solar farm',
                'Inner Mongolia Huadian Chaoge New Energy Co., Ltd.',
                'Huadian Inner Mongolia Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huhewenduer',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Huhewenduer GCL solar farm',
                'Inner Mongolia Yuanhai New Energy Co., Ltd.',
                'Inner Mongolia GCL Photovoltaic Power Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Qingshan',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Qingshan Guodian solar farm',
                'Guodian Urad Houqi Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Jingneng New Energy Technology Co., Ltd.[96%];Guoneng Inner Mongolia New Energy Investment Co., Ltd.[4%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Saiwusu',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Saiwusu Guodian solar farm',
                'Guodian Hengguan Wulate Houqi New Energy Co., Ltd.',
                'Hebei Hengguan Electric Power Development Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Wudan Town',
                'Wengniute Banner',
                'Chifeng',
                'Inner Mongolia Wengniuteqi Xinlongdi Village solar farm',
                'Chifeng Yongneng New Energy Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [51%]; Jumao Optoelectronics [Xiamen] Co., Ltd. [49%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Wengongwula Town',
                'Xianghuang Banner',
                'Xilingol League',
                'Inner Mongolia Wengongwula Jingneng solar farm',
                'Inner Mongolia Jingneng Wengong Wula Wind Power Generation Co., Ltd.',
                'Beijing Jingneng Clean Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xiwulanbulang Town',
                'Wuchuan County',
                'Hohhot',
                'Inner Mongolia Wuchuan Wulanbulang Huaneng solar farm',
                'Huaneng Huhhot Wind Power Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinshawan',
                'Haibowan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Atesi solar farm',
                "Wuhai Zhuo'er New Energy Development Co., Ltd.",
                'Wuhai Atesi New Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Haibowan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Beikong solar farm',
                'Beijing Enterprises Clean Energy (Wuhai) Power Co., Ltd.',
                'Beijing Enterprises Clean Energy Company Limited[90%]; Wuhai Yijia Water Environmental Protection Co., Ltd.[10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Haibowan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Beikong solar farm',
                'Beijing Enterprises Clean Energy (Wuhai) Power Co., Ltd.',
                'Beijing Enterprises Clean Energy Company Limited[90%]; Wuhai Yijia Water Environmental Protection Co., Ltd.[10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Qianlishan Town',
                'Haibowan District',
                'Intersection of Wuhai and Ordos',
                'Inner Mongolia Wuhai Municipality Ningsheng solar farm',
                'Wuhai Ningsheng Power Development Co., Ltd.',
                'Three Gorges Clean Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Gongwusu Mining Area',
                'Hainan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Wuling solar farm',
                'Wuling Wuhai Power Co., Ltd.',
                'Wuling Power Co., Ltd. [70%]; Lashan Riverside Sands Development Co., Ltd. [30%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Kushui Gully',
                'Hainan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Xiexin solar farm',
                'Wuhai GCL Photovoltaic Power Co., Ltd.',
                'Inner Mongolia Beirong Solar Power Generation Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Gongwusu Mining Area',
                'Hainan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Yingneng solar farm',
                'Wuhai Yingneng New Energy Technology Co., Ltd.',
                'Wuhai Yingyuan New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Qianlishan Town',
                'Haibowan District',
                'Wuhai',
                'Inner Mongolia Wuhai Municipality Zhongguanghe solar farm',
                'CGN Wuhai New Energy Co., Ltd.',
                'CGN New Energy Investment (Shenzhen)Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Tuguiwula Town',
                'Chayouqian Banner',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Chayouqian Banner Tianneng solar farm',
                'Inner Mongolia Guorun (Chayouqianqi) Power Generation Co., Ltd.',
                'Chayouqianqi United Photovoltaic Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chaoge',
                'Urad Rear Banner',
                'Bayannur',
                'Inner Mongolia Urad Rear Banner Chaoge Datang solar farm',
                'Datang Wulate Houqi New Energy Co., Ltd.',
                'Datang Hebei Power Generation Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hongpan Town',
                'Chayouzhong Banner',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Chayouzhong Banner Yuanhua solar farm',
                'Inner Mongolia Yuanhua Agricultural Development Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chuanjing Sumu',
                'Urad Middle Banner',
                'Bayannur',
                'Inner Mongolia Urad Middle Banner Chuanjing Sumu SPIC solar farm',
                'State Power Investment Group Wulate Zhongqi New Energy Power Generation Co., Ltd.',
                'Inner Mongolia Jinghe New Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Ulanhot',
                'Inner Mongolia Ulanhot Zhongdian solar farm',
                'CLP Electric (Ulanhot) Photovoltaic Power Generation Co., Ltd.',
                'Shanxi Jingtai New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dorbod Banner',
                'Wulanchabu',
                'Inner Mongolia Siziwangqi Huaneng solar farm',
                'Huaneng Siziwangqi New Energy Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Sonid Right Banner',
                'Xilingol League',
                'Inner Mongolia Sonid Right Banner Jingneng solar farm',
                'Jingneng New Energy (Sunite Right Banner) Wind Power Co., Ltd.',
                'Beijing Jingneng Clean Energy Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Saihan',
                'Sonid Right Banner',
                'Xilingol League',
                'Inner Mongolia Sonid Right Banner Saihan Jingneng solar farm',
                'Saihan Wind Power Branch of Beijing Jingneng New Energy Co., Ltd.',
                'Beijing Jingneng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dalin Town',
                "Ke'erqin District",
                'Tongliao',
                'Inner Mongolia Tongliao Dalinzhen 11 solar farm',
                'Tongliao Sunshine Power Photoelectric Technology Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dalin Town',
                "Ke'erqin District",
                'Tongliao',
                'Inner Mongolia Tongliao Dalinzhen 25 solar farm',
                'Tongliao Sunshine Power Photoelectric Technology Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dalin Town',
                "Ke'erqin District",
                'Tongliao',
                'Inner Mongolia Tongliao Dalinzhen solar farm',
                'Tongliao Sunshine Power Photoelectric Technology Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Kailu County',
                'Kailu County',
                'Tongliao',
                'Inner Mongolia Tongliao Kailu County solar farm',
                'Kailu Shengda Photoelectric Co., Ltd.',
                'Inner Mongolia Xinsheng Photovoltaic Technology Co., Ltd.',
              ],
              [
                'China',
                55,
                'Asia',
                'Guribanhua Sumu',
                'Naiman Banner',
                'Tongliao',
                'Inner Mongolia Tongliao Naiman Banner solar farm',
                'Inner Mongolia Naiman Electric Power Co., Ltd.',
                'Naiman Banner Dingxin Investment Group Co., Ltd.',
              ],
              [
                'China',
                150,
                'Asia',
                'Tongliao Coal Power Plant Ash Site',
                'Keerqin District',
                'Tongliao',
                'Inner Mongolia Tongliao Power Plant Ash Site solar farm',
                'Tongliao Tongfa New Energy Co., Ltd.',
                'Inner Mongolia Power Investment Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Naiman Banner',
                'Tongliao',
                'Inner Mongolia Tongliao Tianbao solar farm',
                'Tongliao Tianbao Energy Environmental Protection Technology Co., Ltd.',
                'Shenneng North Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Naiman Banner',
                'Tongliao',
                'Inner Mongolia Tongliao Tianbao solar farm',
                'Tongliao Tianbao Energy Environmental Protection Technology Co., Ltd.',
                'Shenneng North Energy Holdings Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Industrial Park',
                'Tumd Right Banner',
                'Baotou',
                'Inner Mongolia Tumd Right Banner Industrial Park Minghua solar farm',
                'Inner Mongolia Minghua New Energy Co., Ltd.',
                'Gongqingcheng Boang Investment Partnership (Limited Partnership) [28.6%]; Inner Mongolia Weiheng Industry and Trade Co., Ltd. [28.6%]; Beijing United Rongbang New Energy Technology Co., Ltd. [28.6%]; ZhangXiaoMing [11.2%]; others [3%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tumd Right Banner',
                'Baotou',
                'Inner Mongolia Tumd Right Banner Minghua solar farm',
                'Inner Mongolia Minghua New Energy Co., Ltd.',
                'Gongqingcheng Boang Investment Partnership (Limited Partnership) [28.6%];Beijing United Rongbang New Energy Technology Co., Ltd. [28.6%]; Inner Mongolia Weiheng Industry and Trade Co., Ltd. [28.6%]; Zhang Xiaoming [11.2%]; Others [3%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Tumd Right Banner',
                'Baotou',
                'Inner Mongolia Tumd Right Banner SPIC solar farm',
                'State Power Investment Group Damaoqi New Energy Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Wushijia Town',
                'Tuoketuo County',
                'Hohhot',
                'Inner Mongolia Tuoketuo Guodian solar farm',
                'Guodian Tuoketuo Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Jingneng New Energy Technology Co., Ltd. [92.7%]; Guoneng Inner Mongolia New Energy Investment Co., Ltd. [7.3%]',
              ],
              [
                'China',
                39,
                'Asia',
                'Tuquan Town',
                'Tuquan County',
                "Xing'an League",
                'Inner Mongolia Tuquan Fusheng solar farm',
                'Tuquan Fusheng Solar Energy Technology Co., Ltd.',
                'Tuquan Guangsheng New Energy Co., Ltd. [67%]; Tuquan Mengdong Urban Development Investment Management Co., Ltd. [33%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Jiangjunyao Town',
                'Tumute Right Banner',
                'Baotou',
                'Inner Mongolia Tuyou Banner Jiangjunyao solar farm',
                'Tumed Right Banner Guodian Power Photovoltaic Power Generation Co., Ltd.',
                'Zhejiang Zhejing Energy Development Co., Ltd. [86.7%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd. [13.3%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Eerdengbulage',
                'Urad Front Banner',
                'Bayannur',
                'Inner Mongolia Urad Front Banner Eerdengbulage Three Gorges solar farm',
                'Three Gorges New Energy Wulateqianqi Power Generation Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Hongpan Town',
                'Chayouzhong Banner',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Chayouzhong Banner Yuanhua solar farm',
                'Inner Mongolia Yuanhua Agricultural Development Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Jining Qu',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Jining solar farm',
                'Inner Mongolia Sanxin New Energy Co., Ltd.',
                'Zhenfa New Energy Group Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liusumi Town',
                'Liangcheng Xian',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Liangcheng solar farm',
                'Inner Mongolia Shengda Solar Technology Co., Ltd.',
                'Inner Mongolia Green Giant New Energy Investment Co., Ltd. [89%]; Research and Innovation Applied Materials (Ganzhou) Co., Ltd. [11%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Amugulang Town',
                "Xinba'erhu Left Banner",
                'Hulunbuir',
                "Inner Mongolia Xinba'erhu Zuoqi Mengli solar farm",
                'New Balhu Zuoqi Mengli New Energy Technology Co., Ltd.',
                'Asika[30%]; Tian Liqing[30%]; Zhou Jing[30%]; Niu Benxu[10%]',
              ],
              [
                'China',
                50,
                'Asia',
                'Debosi Town',
                'Keyouqian Banner',
                "Xing'an Leauge",
                "Inner Mongolia Xing'an Keerqinyouyiqian Banner Jiehe Forestry solar farm",
                'Inner Mongolia Xingsheng Solar Power Co., Ltd.',
                'Inner Mongolia Libo Qiming Technology Center',
              ],
              [
                'China',
                20,
                'Asia',
                "Yingde'er Town",
                'Zhalaite Banner',
                "Xing'an League",
                'Inner Mongolia Xinhe Sunshine solar farm',
                'Xinhe Sunshine (zalaite Banner) Energy Co., Ltd.',
                'Jiangsu SUMEC Group Co., Ltd. [96%]; Jiangsu SUMEC New Energy Development Co., Ltd. [4%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Baligenhua Sumu',
                'Zhalaite Banner',
                "Xing'an League",
                'Inner Mongolia Zhalai Banner Huaneng solar farm',
                'Huaneng Zhalai Banner Solar Photovoltaic Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Arikundu Leng',
                'Zhalute Banner',
                'Tongliao',
                'Inner Mongolia Zhalute Banner Huachun solar farm',
                'Inner Mongolia Huachun Agricultural Development Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Wulijimuren Sumu',
                'Jialute Banner',
                'Inner Mongolia Zhalute Banner JA solar farm',
                "Zhalute Jing'ao Photovoltaic Power Generation Co., Ltd.",
                'CPI Northeast New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Zhalute Banner Tongneng solar farm',
                'Zhalute Tongneng Photovoltaic Power Development Co., Ltd.',
                'Henan Zhongyuan Golden Sun Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Zhalute Banner',
                'Tongliao',
                'Inner Mongolia Zhalute Banner Zhahanaoer solar farm',
                'Zhalute Banner Zhahanaoer Coal Industry Limited Company',
                'Inner Mongolia Power Investment Co., Ltd. [98%]; other[2%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Zhaqi Donghu solar farm',
                'Tongliao Simeng Electric Power Co., Ltd.',
                'Inner Mongolia Simeng New Energy Technology Co., Ltd. [99%]; others [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Kailu Town',
                'Kailu County',
                'Tongliao',
                'Inner Mongolia Zhaqi Minzu solar farm',
                'Tongliao Juneng Photovoltaic Co., Ltd.',
                'Shunyu Jieneng Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Zhaqi Nanhu solar farm',
                'Tongliao Simeng Electric Power Co., Ltd.',
                'Inner Mongolia Simeng New Energy Technology Co., Ltd. [99%]; other [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Zhaqi Xihu solar farm',
                'Tongliao Simeng Electric Power Co., Ltd.',
                'Inner Mongolia Simeng New Energy Technology Co., Ltd. [99%]; other [1%]',
              ],
              [
                'China',
                35,
                'Asia',
                'Unavailable',
                'Zhuozi County',
                'Wulanchabu',
                'Inner Mongolia Zhuozi Bayin solar farm',
                'Zhuozi Xinyuan Solar Power Generation Co., Ltd.',
                'Inner Mongolia Xinyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Zhuozi County',
                'Wulanchabu',
                'Inner Mongolia Zhuozi Xinyuan solar farm',
                'Zhuozi Xinyuan Solar Power Generation Co., Ltd.',
                'Inner Mongolia Xinyuan Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Xilinhot',
                'Xilingol League',
                'Inner Mongolioa Xilinhot Xinyuan solar farm',
                'Xilinhot Xinyuan Solar Power Generation Co., Ltd.',
                'Inner Mongolia Xinyuan Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Sheyang',
                'Baoying',
                'Jiangsu Baoying Sheyang Guangshuo solar farm',
                'Yangzhou Guangshuo New Energy Co., Ltd.',
                'Jiangsu Langhenong Light Polymerization Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Huhewenduer Town',
                'Wulatehou Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaouer Wulatehou Banner Ecosolar Project',
                'Wulate Houqi Yuanhai New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Xilingol League',
                'Inner Mongolia Xilinhot North Longyuan solar farm',
                'Inner Mongolia North Longyuan Wind Power Company',
                'Inner Mongolia Mengdian Huaneng Thermal Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Xilinhot',
                'Inner Mongolia Xilinhot Huadian solar farm',
                'Inner Mongolia Huadian Xilinhot New Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Unavailable',
                'Zhenglan Banner',
                'Xilinguole Leauge',
                'Inner Mongolia Xilinguole Zhenglan Banner Three Gorges solar farm',
                'Three Gorges Zhenglanqi Clean Energy Co., Ltd.',
                'China Three Gorges New Energy (Group) Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shangdu Town',
                'Zhenglan Banner',
                'Xilinguole Leauge',
                'Inner Mongolia Xilinguole Zhenglan Banner Guodian solar farm',
                'Guodian Power Inner Mongolia New Energy Development Co., Ltd.',
                'Guodian Power Development Co. Ltd',
              ],
              [
                'China',
                50,
                'Asia',
                'Shibaqing Town',
                'Shangdu Xian',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Shangdu County solar farm',
                'Guodian Shangdu Photovoltaic Power Generation Co., Ltd.',
                'Guodian Inner Mongolia Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shibaqing Town',
                'Shangdu Xian',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Shangdu County solar farm',
                'Guodian Shangdu County Second Photovoltaic Power Co., Ltd.',
                'Nanjing Silk Road New Energy Co., Ltd. [99.3%]; Guoneng Inner Mongolia New Energy Investment Co., Ltd.[0.7%]',
              ],
              [
                'China',
                40,
                'Asia',
                'Wulanhua Town',
                'Siziwang Banner',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Siziwang Banner Grid-Connected solar farm',
                'Guodian Siziwangqi Photovoltaic Power Generation Co., Ltd.',
                'Guodian Inner Mongolia Power Co., Ltd.[70%]; Jilin New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Wulanhua Town',
                'Siziwang Banner',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Siziwang Banner Grid-Connected solar farm',
                'Guodian Siziwangqi Photovoltaic Power Generation Co., Ltd.',
                'Guodian Inner Mongolia Power Co., Ltd.[70%]; Jilin New Energy Investment Co., Ltd.[30%]',
              ],
              [
                'China',
                50,
                'Asia',
                "Hongge'er Sumu",
                'Siziwang Banner',
                'Wulanchabu',
                "Inner Mongolia Wulanchabu Siziwang Banner Huadian Hongge'er solar farm",
                'Inner Mongolia Huadian Hongge\u2018er New Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                "Jiang'an Sumu",
                'Siziwang Banner',
                'Wulanchabu',
                "Inner Mongolia Wulanchabu Siziwang Banner Jiang'ansumu solar farm",
                'Inner Mongolia Siziwangqi Shenguang Energy Development Co., Ltd.',
                'Zhejiang Qingneng Energy Development Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Xinghe Xian',
                'Wulanchabu',
                'Inner Mongolia Wulanchabu Xinghe County Eco-Herding solar farm',
                'Xinghe County Chaer Lake Hairun Ecological Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia MengDian Huaneng Thermal Power Corporation Limited',
              ],
              [
                'China',
                45,
                'Asia',
                'Unavailable',
                'Ulanhot',
                "Xing'an League",
                'Inner Mongolia Wulanhaote Juneng solar farm',
                'Wulanhaote Wisdom Juneng New Energy Co., Ltd.',
                'Shanghai Shangdian Xinda New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Siwangzi Banner',
                'Wulanchabu',
                'Inner Mongolia Siwangziqi SPIC solar farm',
                'State Power Investment Group Siziwangqi Wind Power Heating Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Wulanmulun Town',
                'Ejin Horo Banner',
                'Ordos',
                'Inner Mongolia Wulanmulun Guodiantou solar farm',
                'Yijinhuoluo Banner Narentai Energy Co., Ltd.',
                'Inner Mongolia Power Investment Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                "E'erdengbulagesumu",
                'Wulate Front Banner',
                'Bayannur',
                'Inner Mongolia Wulate Front Banner Xiehe solar farm',
                'Wulateqianqi Xiehe Photovoltaic Power Generation Co., Ltd.',
                'Information Industry Electronics Eleventh Design and Research Institute Technology Engineering Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Chuanjing Town',
                'Wulate Middle Banner',
                'Bayannur',
                'Inner Mongolia Wulate Middle Banner Chuanjing Huadian solar farm',
                'Chuanjing Wind Power Branch of Huadian New Energy Development Co., Ltd.',
                'Huadian New Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wulate Middle Banner',
                'Bayannur',
                'Inner Mongolia Wulate Middle Banner Chuanjing solar farm',
                'State Power Investment Corporation Wulate Zhongqi New Energy Power Generation Co., Ltd.',
                'Inner Mongolia Jinghe New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Hailiutu Town',
                'Wulate Middle Banner',
                'Bayannur',
                'Inner Mongolia Wulate Middle Banner Jianli Zhaosheng solar farm',
                'Inner Mongolia Jianli Zhaosheng Energy Co., Ltd.',
                'Inner Mongolia Zhongyue Electric Power Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wulate Middle Banner',
                'Bayannur',
                'Inner Mongolia Wulate Middle Banner Wulanyiligeng Huaneng solar farm',
                'Huaneng Wulate Zhongqi New Energy Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wuyuan',
                'Bayannur',
                'Inner Mongolia Wuyuan Datang solar farm',
                'Datang Wuyuan New Energy Co., Ltd.',
                'Datang Hebei Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Wuyuan',
                'Bayannur',
                'Inner Mongolia Wuyuan Shengyu solar farm',
                'Inner Mongolia Shengyu Solar Power Co., Ltd.',
                'Shanghai Mengyang Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Narenwulasumu',
                'Xianghuang Banner',
                'Xilingol League',
                'Inner Mongolia Xianghuangqi Shenneng solar farm',
                'Shenneng North (Xilinguole) Energy Development Co., Ltd.',
                'Shenneng North Energy Holding Co., Ltd.',
              ],
              [
                'China',
                500,
                'Asia',
                'Wulanmulun Town',
                'Ejin Horo Banner',
                'Ordos',
                'Inner Mongolia Wulanmulun Tianjiao Lvneng solar farm',
                'State Power Investment Group Inner Mongolia Energy Co., Ltd.',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Shangdu County',
                'Wulanchabu',
                'Inner Mongolia Shangdu Tianhui solar farm',
                'Shangdu Tianhui Solar Energy Co., Ltd.',
                'Three Gorges Asset Management Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Zhenglan Banner',
                'Xilingol League',
                'Inner Mongolia Xilingol League Zhenglan Banner Huaneng solar farm',
                'Huaneng Zhenglanqi New Energy Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Kulun',
                'Qahar Right Middle Banner',
                'Ulanqab',
                'Inner Mongolia Qahar Right Middle Banner Kulun Huadian solar farm',
                'Inner Mongolia Huadian Huiteng Xile Wind Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dengkou County',
                'Bayannur',
                "Inner Mongolia Dengkou Bao'ergai Farm solar farm",
                'Bayannaoer Nongken Shenzhou Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bayangaole Town',
                'Dengkou County',
                'Bayannur',
                'Inner Mongolia Dengkou Bayangaole Guohua solar farm',
                'Guohua Bayannaoer(Wulatezhongqi) Wind Power Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dengkou Xian',
                'Bayannaoer',
                'Inner Mongolia Dengkou China Power Investment solar farm',
                'China Power Investment Dengkou Solar PV Power Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Industrial Park',
                'Dengkou',
                'Bayannur',
                'Inner Mongolia Dengkou Industrial Park Guohua solar farm',
                'Guohua Bayannaoer(wulatezhongqi) Wind Power Co., Ltd.',
                'National Energy Group New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Dengkou',
                'Bayannur',
                'Inner Mongolia Dengkou SPIC 20MW solar farm',
                'State Power Investment Group Dengkou Photovoltaic Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Unavailable',
                'Dengkou',
                'Bayannur',
                'Inner Mongolia Dengkou SPIC 50MW solar farm',
                'State Power Investment Group Dengkou Photovoltaic Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'CECEP Dalate Banner Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'China Guangdong Nuclear Solar Development Co. Ltd.',
                'China Guangdong Nuclear Power Group Co., Ltd.[66.4%]; Shenzhen CGN Fengtai Investment Co., Ltd.[33.6%]',
              ],
              [
                'China',
                200,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'State Power Investment Corporation Limited',
                'State Power Investment Corporation Limited',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'CGN (Dalate Banner) New Energy Co., Ltd.',
                'CGN Solar Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'Three Gorges New Energy Dalate Banner Co., Ltd.',
                'China Three Gorges Renewables (Group) Co.,Ltd.[95%]; Sungrow Power Supply Co., Ltd.[5%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'Zhejiang Chint New Energy Development Co., Ltd.',
                'Zhejiang Chint Electrics Co., Ltd.[92%]; other[8%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'State Power Investment Group Co., Ltd.',
                'State Power Investment Group Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Banner "Lead from the Front" solar farm',
                'China Huaneng Group',
                'China Huaneng Group',
              ],
              [
                'China',
                100,
                'Asia',
                'Zhaojun Town',
                'Dalate Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Dalate Hengda solar farm',
                'nner Mongolia Energy Construction Hengda New Energy Co., Ltd.',
                'Inner Mongolia Energy Construction Investment (Group) Co., Ltd. [51%]; Ordos Cultural Industry Investment Co., Ltd.[49%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Balagong Town',
                'West part of Hangjin Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Hangjin Banner Balagong solar farm',
                'Ordos Fengwei Photoelectric Co., Ltd',
                'Inner Mongolia Mining(Group) Limited Liability Company',
              ],
              [
                'China',
                20,
                'Asia',
                'Bailingmiao',
                'Darhan Muminggan United Banner',
                'Baotou',
                'Inner Mongolia Darhan Muminggan United Banner Bailingmiao SPIC solar farm',
                'State Power Investment Group Damaoqi New Energy Power Generation Co., Ltd.',
                'Beijing Jingkai Integrated Smart Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Damao Banner Zhurihe solar farm',
                'Damao Tianrun Solar Energy Co., Ltd.',
                'Tianrun Muyang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Zhaohe',
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Damao Banner Zhaohe solar farm',
                'Damao Banner Datang Tianhong Solar Power Technology Co., Ltd.',
                'Hubei Energy Group New Energy Development Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                "Ming'an Town",
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Damao Banner Huaneng 30MW solar farm',
                'Huaneng Baotou Wind Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Huhewenduer Town',
                'Wulatehou Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaouer Wulatehou Banner Ecosolar Project',
                'Wulate Houqi Yuanhai New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Xile',
                'Qahar Right Rear Banner',
                'Ulanqab',
                'Inner Mongolia Qahar Right Rear Banner Xile Datang solar farm',
                'Inner Mongolia Datang International Hongmu New Energy Co., Ltd.',
                'Inner Mongolia Datang International New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huhewenduer Town',
                'Wulatehou Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaouer Wulatehou Banner Ecosolar Project',
                'Wulate Houqi Yuanhai New Energy Co., Ltd.',
                'Beijing United Rongbang New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Chaluowenduer Town',
                'Wulatehou Banner',
                'Bayannaoer',
                'Inner Mongolia Bayannaouer Wulatehou Banner Ecosolar Project',
                "Inner Mongolia Dun'an Photovoltaic Power Co., Ltd.",
                "Zhejiang Dun'an New Energy Development Co., Ltd.",
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Bayannur',
                'Inner Mongolia Bayannur Guodian solar farm',
                'Guodian Henghua Urad Houqi New Energy Co., Ltd.',
                'Jiangsu Dahai New Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Kulunsumu',
                'Qahar Right Middle Banner',
                'Wulanchabu',
                'Inner Mongolia Chayou Middle Banner CPI solar farm',
                'CPI Zhongqi Photovoltaic Power Generation Co., Ltd.',
                'Shanghai Electric Power New Energy Development Co., Ltd. [75%]; Shanghai Xinfu New Energy Technology Development Co., Ltd. [25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'XileTown',
                'Chayouhouqi Baiyinchagan County',
                'Wulanchabu City',
                'Inner Mongolia Chayouhouqi Hongmu Datang solar farm',
                'Inner Mongolia Datang International New Energy Co.,Ltd.',
                'Datang International Power Generation Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Inner Mongolia Chayouhouqi Hongmu Datang solar farm',
                'Chahar Right Wing Rear Banner Hongmu Xinyuan Solar Power Co., Ltd.',
                'Inner Mongolia Xinyuan Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Duguitala Town',
                'Hangjin Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Hangjin Banner Duguitala solar farm',
                'Ordos Zhengli New Energy Power Generation Co., Ltd.',
                'Zhejiang Chint New Energy Development Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Mutouyingzi Town',
                'Aohan Banner',
                'Chifeng',
                'Inner Mongolia Chifeng Aohan Banner solar farm',
                'Aohan Banner Xinhuo New Energy Co., Ltd.',
                'Aohan Tongwei New Energy Co., Ltd.[80%]; Aohan Banner State-owned Assets Management Co., Ltd.[20%]',
              ],
              [
                'China',
                45,
                'Asia',
                'Unavailable',
                'Wengniute Banner',
                'Chifeng',
                'Inner Mongolia Chifeng Golden Energy solar farm',
                'Chifeng Golden Energy Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Wengniute Banner',
                'Chifeng',
                'Inner Mongolia Chifeng Golden Energy Wengqi solar farm',
                'Chifeng Golden Energy Co., Ltd.',
                'Chongqing Qianxin New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jianchangying Town',
                'Yuanbaoshan District',
                'Chifeng',
                'Inner Mongolia Chifeng Jianchangying Mengneng solar farm',
                'Chifeng Mengneng Photovoltaic Power Generation Co., Ltd.',
                'Chisheng Energy Technology [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Jianchangying Town',
                'Yuanbaoshan District',
                'Chifeng',
                'Inner Mongolia Chifeng Jianchangying solar farm',
                'Guodian Inner Mongolia Power Co., Ltd.',
                'National Energy Investment Group Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Unavailable',
                'Linxi County',
                'Chifeng',
                'Inner Mongolia Chifeng Linxi County Zhongneng solar farm',
                'Inner Mongolia Zhongneng Guodian New Energy Technology Co., Ltd.',
                'State Power Investment Group Northeast Power Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Chifeng',
                'Inner Mongolia Chifeng Songshan Dayuying solar farm',
                'Guodian Technology Environmental Protection Group Co., Ltd. Chifeng Wind Power Company',
                'Guodian Technology Environmental Protection Group Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Damao Banner Bayin Huadian solar farm',
                'Inner Mongolia Huadian Bayin Wind Power Generation Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                "Ming'an Town",
                'Damao Banner',
                'Baotou',
                'Inner Mongolia Damao Banner Huaneng 20MW solar farm',
                'Huaneng Baotou Wind Power Generation Co., Ltd.',
                'Huaneng New Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Changsheng',
                'Chifeng',
                'Chifeng',
                'Inner Mongolia Chifeng Changsheng Guodian solar farm',
                'Aohanqi ShuoKe Photovoltaic Power Generation Co., Ltd.',
                'Guodian Inner Mongolia Energy Co., Ltd.; State Power Investment Group Inner Mongolia New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Balagong Town',
                'West part of Hangjin Banner',
                'Erduosi (Ordos)',
                'Inner Mongolia Erdos Hangjin Banner Guodian solar farm',
                'Hangjinqi Guodian Photovoltaic Power Co., Ltd.',
                'Inner Mongolia Zhongyue Power Co., Ltd.[93.75%]; Guodian Power Inner Mongolia New Energy Development Co., Ltd.[6.25%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Fushantang Ash Pond of Changshu Power Generating Company',
                'Changshu Municipality',
                'Suzhou Municipality',
                'Jiangsu Changshu Fushan Photovoltaic solar plant',
                'Changshu Fushan Photovoltaic Power Generation Co., Ltd.',
                'Jiangsu Changshu Power Generation Co. Ltd.',
              ],
              [
                'China',
                48,
                'Asia',
                'Gerileaodu',
                'Erenhot',
                'Xilingol League',
                'Inner Mongolia Erenhot Gerileaodu Huadian solar farm',
                'Inner Mongolia Huadian Erlianhaote New Energy Co., Ltd.',
                'Huadian Fuxin Energy Development Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Manzhouli',
                'Hulunbuir',
                'Inner Mongolia Hulunbuir Yuhan solar farm',
                'Hulunbuir Yuhan New Energy Development Co., Ltd.',
                'Wuling Electric Power Co., Ltd. [55%]; Sichuan Jiuyuan Electric Power Development Co., Ltd. [25%]; Hunan Zhongshui Investment Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huolinguole',
                'Tongliao',
                'Inner Mongolia Huolinguole Jingri solar farm',
                'Huolinguole Jingri Energy Co., Ltd.',
                'Xinhua Power Development Investment Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Huolinguole',
                'Tongliao',
                'Inner Mongolia Huolinguole Zhenfa solar farm',
                'Huolinguole Zhenfa Photovoltaic Technology Co., Ltd.',
                'Huaneng International Power Development Corporation',
              ],
              [
                'China',
                20,
                'Asia',
                'Arikunduleng',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Jarud Banner Arikunduleng Xiehe solar farm',
                'Inner Mongolia Xiehe Zhalute Banner Wind Power Generation Co., Ltd.',
                'Mengdong Xiehe New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Jarud Banner',
                'Tongliao',
                'Inner Mongolia Jarud Banner Changhua Agricultural solar farm',
                'Inner Mongolia Changhua Agricultural Development Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Liaohe Farm',
                'Kailu County',
                'Tongliao',
                'Inner Mongolia Kailu Rongda Rooftop solar farm',
                'Kailu Rongda Electric Power Co., Ltd.',
                'Nanjing Fu Zhao New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shebotu Town',
                'Kezuozhong (Keerqinzuoyizhong) Banner',
                'Tongliao',
                'Inner Mongolia Kezuozhong Banner Beixinaile solar farm',
                'Kezuo Zhongqi Xinsheng Photoelectric Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Shebotu Town',
                'Kezuozhong (Keerqinzuoyizhong) Banner',
                'Tongliao',
                'Inner Mongolia Kezuozhong Banner Beixinaile solar farm',
                'Kezuo Zhongqi Xinsheng Photoelectric Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Hailutu',
                'Horqin Left Rear Banner',
                'Tongliao',
                'Inner Mongolia Horqin Left Rear Banner Hailutu Guodian solar farm',
                'China Electric Power Research Zuohouqi Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd. [96.68%]; other [3.32%]',
              ],
              [
                'China',
                60,
                'Asia',
                'Baixingtu Sumi',
                'Kezuozhong (Keerqinzuoyizhong) Banner',
                'Tongliao',
                'Inner Mongolia Kezuozhong Banner Sunitugacha solar farm',
                'Guodian Kezuozhongqi Photovoltaic Power Co., Ltd',
                'Nanjing Silk Road New Energy Co., Ltd. [99.4%]; other[0.6%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Daihai Town',
                'Liangcheng County',
                'Wulanchabu',
                'Inner Mongolia Liangcheng Daihai Jingzhaolai solar farm',
                'Inner Mongolia Jingzhaolai Photovoltaic Power Co., Ltd.',
                'Changzhou Zhiyuan New Energy Co., Ltd.[80%]; Li Yongjia[10%]; Xu Wanting[10%]',
              ],
              [
                'China',
                49,
                'Asia',
                'Unavailable',
                'Morin Dawa Daur Autonomous Banner',
                'Hulunbuir',
                'Inner Mongolia Moli Jiuzhou Poverty Alleviation solar farm',
                'Morin Dawa Daur Autonomous Banner Jiuzhou Nare Photovoltaic Poverty Relief Co., Ltd.',
                'Harbin Jiuzhou Energy Investment Co., Ltd. [65%]; Moridawa Daur Autonomous Banner Urban Infrastructure Investment and Development Co., Ltd. [35%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Naiman Banner',
                'Tongliao',
                'Inner Mongolia Naiman Banner Huite solar farm',
                'Naiman Banner Huite Photovoltaic Power Generation Co., Ltd.',
                'TBEA Xinjiang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Daqintala Town',
                'Naiman Banner',
                'Tongliao',
                'Inner Mongolia Naiman Banner Longsheng solar farm',
                'Inner Mongolia Longsheng New Energy Co., Ltd.',
                'Tibet Baohui Energy Technology Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Dashuangmiao Town',
                'Ningcheng County',
                'Chifeng',
                'Inner Mongolia Ningcheng CECEP solar farm',
                'CECEP Ningcheng Solar Energy Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Tuguiwula',
                'Qahar Right Front Banner',
                'Ulanqab',
                'Inner Mongolia Qahar Right Front Banner Tuguiwula Guodian solar farm',
                'Guodian Chahar Youyiqianqi No.2 Photovoltaic Power Generation Co., Ltd.',
                'Nanjing Silk Road New Energy Co., Ltd. [99%]; other [1%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Erenhot',
                'Xilingol League',
                'Inner Mongolia Erenhot Energy Power solar farm',
                'Inner Mongolia Energy Power Generation Erlian Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Energy Power Generation Investment Group New Energy Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Tuguiwula',
                'Qahar Right Front Banner',
                'Ulanqab',
                'Inner Mongolia Qahar Right Front Banner Tuguiwula Guodian solar farm',
                'Guodian Chahar Youyouqianqi Photovoltaic Power Generation Co., Ltd.',
                'Inner Mongolia Jingneng New Energy Technology Co., Ltd. [90.07%]; Guoneng Inner Mongolia New Energy Investment Co., Ltd. [9.93%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Kulun Town',
                'Kulun Banner',
                'Tongliao',
                'Inner Mongolia Kulun Banner Zhenfa solar farm',
                'Kulunqi Zhenfa Energy Co., Ltd.',
                'China Nuclear Exchange Energy Co., Ltd.',
              ],
              [
                'China',
                40,
                'Asia',
                'Ganqika',
                'Horqin Left Rear Banner',
                'Tongliao',
                'Inner Mongolia Horqin Left Rear Banner Ganqika Guodian solar farm',
                'Guodian Kezuohouqi Photovoltaic Power Generation Co., Ltd.',
                'Xinjiang Silk Road Kunyuan Energy Co., Ltd. [96.68%]; other [3.32%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Longxingchang Town',
                'Wuyuan County',
                'Bayannaoer City',
                'Inner Mongolia Longxingchang Town Shengyu solar farm',
                'Inner Mongolia Shengyu Solar Power Co., Ltd.',
                'Shanghai Mengyang Energy Technology Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Beixinaile',
                'Horqin Left Middle Banner',
                'Tongliao',
                'Inner Mongolia Horqin Left Middle Banner Xinsheng solar farm',
                'Kezuo Zhongqi Xinsheng Photoelectric Co., Ltd.',
                'Changzhou Ranchen Photovoltaic Investment Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Huaishuo',
                'Guyang',
                'Baotou',
                'Inner Mongolia Guyang Huaishuo Guodian solar farm',
                'Guodian Henghua Guyang New Energy Co., Ltd.',
                'Henghua Energy Technology Group Co., Ltd. [80%]; XuDeXian [20%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Erenhot',
                'Xilingol League',
                'Inner Mongolia Erenhot Guodian solar farm',
                'Inner Mongolia Energy Power Generation Investment Group New Energy Co., Ltd.',
                'Inner Mongolia Guodian Energy Investment Co., Ltd. [52.25%]; Inner Mongolia Mengcheng Gongrong Green Private Fund Management Center(L.P.) [47.75%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Jinshan Town',
                'Guyang Xian',
                'Baotou',
                'Inner Mongolia Guyang Meilingshan solar farm',
                'Inner Mongolia Energy Power Generation Investment Group Co., Ltd.',
                'Inner Mongolia Autonomous Region State-owned Assets Supervision and Administration Commission [90%]; Inner Mongolia State-owned Capital Operation Co., Ltd. [10%]',
              ],
              [
                'China',
                20,
                'Asia',
                'Xingshunxi Town',
                'Guyang County',
                'Baotou',
                'Inner Mongolia Guyang Xinshunxi solar farm',
                'Guyang Fengyuan Power Generation Co., Ltd.',
                'TBEA Xinjiang New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Bayintaohai Town',
                'Hainan District',
                'Wuhai',
                'Inner Mongolia Hainan Bayintaohai Guohua solar farm',
                'Guohua (Wuhai) New Energy Co., Ltd.',
                'Guohua Energy Investment Co., Ltd.',
              ],
              [
                'China',
                50,
                'Asia',
                'Xini',
                'Hanggin Banner',
                'Ordos',
                'Inner Mongolia Hanggin Banner Xini Hangjinqi solar farm',
                'Hangjinqi Huasheng Photovoltaic Energy Co., Ltd.',
                'Inner Mongolia Jinghe New Energy Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Unavailable',
                'Hangjin Rear Banner',
                'Bayannur',
                'Inner Mongolia Hangjin Houqi Taiyangmiao Farm solar farm',
                'Hangjin Houqi Guodian Photovoltaic Power Generation Co., Ltd.',
                'Chayouqianqi United Photovoltaic Power Generation Co., Ltd. [80%];Guodian Power Inner Mongolia New Energy Development Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Hangjin Rear Banner',
                'Bayannur',
                'Inner Mongolia Hangjin Houqi Taiyangmiao Farm solar farm',
                'Hangjin Houqi Guodian Photovoltaic Power Generation Co., Ltd.',
                'Chayouqianqi United Photovoltaic Power Generation Co., Ltd. [80%];Guodian Power Inner Mongolia New Energy Development Co., Ltd. [20%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Heitutai Town',
                'Fengzhen',
                'Wulanchabu',
                'Inner Mongolia Fengzhen CECEP solar farm',
                'CECEP Fengzhen Photovoltaic Agricultural Technology Co., Ltd.',
                'CECEP Solar Energy Technology Co., Ltd.',
              ],
              [
                'China',
                60,
                'Asia',
                'Shebiya Town',
                "Helinge'er Xian",
                'Huhehaote',
                'Inner Mongolia Hohhot Helin Shenzhou solar farm',
                'Hohhot Shenzhou Photovoltaic Power Co., Ltd.',
                'Shangshi Aerospace Xinghe Energy [Shanghai] Co., Ltd.',
              ],
              [
                'China',
                20,
                'Asia',
                'Holingol Industrial Park',
                'Holingol',
                'Tongliao',
                'Inner Mongolia Holingol Holingol Industrial Park Xinsheng solar farm',
                'Inner Mongolia Xinsheng Photovoltaic Technology Co., Ltd.',
                'Cai Huixin [85%]; Tongliao Jinxiu Wood Industry Co., Ltd. [15%]',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Horinger County',
                'Hohhot',
                'Inner Mongolia Hohhot Dayou solar farm',
                'Inner Mongolia Dayou Solar Energy Co., Ltd.',
                'Lv Zonghan[90%]; Ni Chenggang[10%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Shangtuhai Town',
                'Wuchuan Xian',
                'Huhehaote',
                'Inner Mongolia Hohhot Wuchuan County solar farm',
                'Huhehaote Huanju New Energy Development Co., Ltd.',
                'Zhonghuan Energy (Inner Mongolia) Co., Ltd.[66%]; APPLE OPERATIONS[34.2%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Wushenjia Town',
                'Tuoketuo Xian',
                'Huhehaote',
                'Inner Mongolia Hohhot Tuoketuo County solar farm',
                'Inner Mongolia Qianhua Agricultural Development Co., Ltd.',
                'Jiangsu Linyang Energy Co., Ltd.',
              ],
              [
                'China',
                100,
                'Asia',
                'Shangtuhai Town',
                'Wuchuan Xian',
                'Huhehaote',
                'Inner Mongolia Hohhot Wuchuan County solar farm',
                'Huhehaote Huanju New Energy Development Co., Ltd.',
                'Zhonghuan Energy (Inner Mongolia) Co., Ltd.[66%]; APPLE OPERATIONS[34.2%]',
              ],
              [
                'China',
                100,
                'Asia',
                'Wushenjia Town',
                'Tuoketuo Xian',
                'Huhehaote',
                'Inner Mongolia Hohhot Tuoketuo County solar farm',
                'Inner Mongolia Qianhua Agricultural Development Co., Ltd.',
                'Jiangsu Linyang Energy Co., Ltd.',
              ],
              [
                'China',
                30,
                'Asia',
                'Unavailable',
                'Ruyi Development District',
                'Hohhot',
                'Inner Mongolia Hohhot Shanlu solar farm',
                'Inner Mongolia Shanlu Agriculture Co., Ltd.',
                'Qinghai Shanyizhong Tritium Solar Power Co., Ltd.',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Oca\u00f1a',
                'Oca\u00f1a',
                'Perales Solar Park',
                'Fotovoltaico Perales',
                'Unknown',
              ],
              [
                'Colombia',
                90,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'Quimar\u00ed Solar Project',
                'Urr\u00e1 S.A. E.S.P.',
                'Unknown',
              ],
              [
                'Colombia',
                35,
                'South America',
                'Unavailable',
                'Unavailable',
                'Sabana de Torres',
                'Sabana De Torres solar farm',
                'Colombia Solar Corporation International',
                'Unknown',
              ],
              [
                'Colombia',
                500,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Puertos De Santander Solar Project',
                'Andes Solar III SAS',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Puerto Boyac\u00e1',
                'Puerto Boyac\u00e1 Solar Park',
                'EBSA',
                'Unknown',
              ],
              [
                'Colombia',
                300,
                'South America',
                'Unavailable',
                'Unavailable',
                'Guaduas',
                'Puerta De Oro Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                102,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centrosur',
                'Port\u00f3n Del Sol PV Solar Park',
                'Parque Solara Port\u00f3n del Sol SA',
                'Unknown',
              ],
              [
                'Colombia',
                27,
                'South America',
                'Unavailable',
                'Planeta Rica',
                'Planeta Rica',
                'Planeta Rica Solar Park',
                'Solarpack',
                'MPC Energy Solutions; Akuo Energy',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'P\u00e9talo De Cesar PV Solar Plant',
                'Black Orchid Solar',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Perales Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Puerto Berrio',
                'Refineria Sebastopol Solar Park',
                'Refiner\u00eda Colombiana Sebastopol',
                'VIP Group International',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Rinc\u00f3n Solar Project',
                'Solar Projects Developers S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Sinc\u00e9',
                'Tol\u00fa Viejo',
                'Morrosquillos Solar Plant',
                'Los Morrosqullos Solar S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                28,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centro',
                'Palmaseca solar farm',
                'Energ\u00edas Renovables del Valle',
                'Unknown',
              ],
              [
                'Colombia',
                72,
                'South America',
                'Unavailable',
                'Marip\u00ed',
                'Occidente',
                'Paipa PV Solar Project',
                'PSR4',
                'Unknown',
              ],
              [
                'Colombia',
                88,
                'South America',
                'Unavailable',
                'Marip\u00ed',
                'Occidente',
                'Paipa PV Solar Project',
                'PSR3',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Natagaima',
                'Pacande Solar Park',
                'Martifer MPC Renewable Energies Development',
                'Martifer MPC Renewable Energies Development',
              ],
              [
                'Colombia',
                130,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Ori\u00f3n Solar Park',
                'Mainstream Colombia S.A.',
                'Mainstream Colombia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Sinc\u00e9',
                'Tol\u00fa Viejo',
                'Morrosquillos Solar Plant',
                'Los Morrosqullos Solar S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                300,
                'South America',
                'Unavailable',
                'Unavailable',
                'Natagaima',
                'Magdalena Sol Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                25,
                'South America',
                'Unavailable',
                'Marip\u00ed',
                'Occidente',
                'Mata Redonda Solar Generation Park',
                'Martifer MPC Renewable Energies Development',
                'MPC Capital; Martifer Renewables',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Manzanillo Solar Plant',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Turbo',
                'Manglares Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Maleiwa PV Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed',
                'Malambo solar farm',
                'EGAL',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Natagaima',
                'Magdalena PV Solar Project',
                'Prodiel',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Tubar\u00e1',
                'Sabanlarga',
                'Sabana Larga Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Pasacaballo Solar Park',
                'Colge\u00f3lica S.A.',
                'Colge\u00f3lica S.A.',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Sahag\u00fan',
                'Sahag\u00fan',
                'Sahag\u00fan Solar Plant',
                'Colge\u00f3lica S.A.',
                'Colge\u00f3lica S.A.',
              ],
              [
                'Colombia',
                99,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Suria Solar Park',
                'Elawan Energy',
                'Elawan Energy',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'Flandes',
                'San Alejo Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Yarigu\u00edes PV Solar Plant',
                'Yarigu\u00edes Solar',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Wimke PV Solar Park',
                'Sowitec Energ\u00edas Renovables de Colombia S.A.S',
                'Sowitec Energ\u00edas Renovables de Colombia S.A.S',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Warrattui PV Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Varenna Solar Project',
                'Grenergy Colombia',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valledupar',
                'Valledupar PV Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Montelibano',
                'Valle Negro solar farm',
                'Due Capital and Services',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Marip\u00ed',
                'Occidente',
                'Valle Del Sol Solar Park',
                'Martifer MPC Renewable Energies Development',
                'MPC Capital; Martifer Renewables',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Urr\u00e1 Solar Park',
                'Urr\u00e1 S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                400,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Uriana PV Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                28,
                'South America',
                'Unavailable',
                'Unavailable',
                'Bajo Magdalena',
                'Ubat\u00e9 Solar Generation Park',
                'PSR1',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centro',
                'Totumo Solar Plant',
                'Operadora Rayo Energ\u00eda Colombia',
                'Unknown',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Majagual',
                'La Mojana',
                'Toluviejo Solar Plant',
                'Elawan Energy',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Armero',
                'Tolima Norte Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'San Jorge',
                'Tierra Alta Solar Plant',
                'Invenergy',
                'Unknown',
              ],
              [
                'Colombia',
                99,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caucasia',
                'Samanes PV Solar Park',
                'Fotovoltaico El Alcaravan S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Macaregua PV Solar Project',
                'HMV',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Sahag\u00fan',
                'Sahag\u00fan',
                'Summa Solar Project',
                'Proelectrica',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Sol Santander Solar Plant',
                'Grenergy Colombia',
                'Grenergy Colombia',
              ],
              [
                'Colombia',
                160,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Shangrila PV Solar Park',
                'Operador Rayo Energ\u00eda Colombia',
                'Operador Rayo Energ\u00eda Colombia',
              ],
              [
                'Colombia',
                700,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'Sebastosol PV Solar Project',
                'Sebastosol',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Riohacha',
                'Santa Teresa PV Solar Park',
                'Parque Solar Colombia VIII',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Santa Rosa Solar Park',
                'Solar Pack Colombia',
                'Solar Pack',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'San Silvestre Solar Park',
                'Solar Projects Developers S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                300,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'San Mart\u00edn solar farm',
                'SC Solar',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'San Juan del Cesar',
                'San Juan del Cesar',
                'San Juan Solar Plant',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'San Juan del Cesar',
                'San Juan del Cesar',
                'San Juan Solar Plant',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'San Juan PV Solar Project',
                'PSF San Juan',
                'Unknown',
              ],
              [
                'Colombia',
                99,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'San Isidro Solar Park',
                'Parque Solar San Isidro S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                59,
                'South America',
                'Unavailable',
                'Unavailable',
                'Castilla La Nueva',
                'San Fernando Solar Park',
                'Ecopetrol S.A.',
                'Ecopetrol S.A.',
              ],
              [
                'Colombia',
                90,
                'South America',
                'Unavailable',
                'San Felipe',
                'Armero Guayabal',
                'San Felipe Tolima Solar Park',
                'Trina Solar Ltd.',
                'Continua Energia Positiva',
              ],
              [
                'Colombia',
                35,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Sunnorte Solar Plant',
                'Genersol Sas',
                'Genersol Sas',
              ],
              [
                'Colombia',
                300,
                'South America',
                'Unavailable',
                'Sahag\u00fan',
                'Sahag\u00fan',
                'Los Tulipanes Solar Project',
                'Univergy',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'La Pradera PV Solar Generation Plant',
                'Solar Projects Developers Sas',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Los Llanos Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Fundaci\u00f3n',
                'Fundaci\u00f3n',
                'Fundaci\u00f3n Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Magdalena Caldense',
                'Fundaci\u00f3n Del Verano Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Fotonorte Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Flandes PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Escobal PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Escobal PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Escobal PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Escobal PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'Escobal PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Mulalo',
                'Yumbo',
                'Emcali Solar Park',
                'Empresas Municipales de Cali (Emcali)',
                'Empresas Municipales de Cali (Emcali)',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Emcali Solar Park',
                'Empresas Municipales de Cali (Emcali)',
                'Empresas Municipales de Cali (Emcali)',
              ],
              [
                'Colombia',
                170,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cali',
                'El Zarzal Solar Park',
                'Lica Energ\u00eda Renovables',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Capital',
                'El Trebol Solar Plant',
                'Granja Solar CSCI Sas',
                'Unknown',
              ],
              [
                'Colombia',
                83,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'El Tepuy PV Solar Park',
                'EPM',
                'Unknown',
              ],
              [
                'Colombia',
                99,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'El Rocio solar farm',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'El Roble solar farm',
                'Castellana de Proyectos Solares',
                'Unknown',
              ],
              [
                'Colombia',
                86,
                'South America',
                'Unavailable',
                'El Paso',
                'El Paso',
                'El Paso PV Solar Park',
                'Enel Green Power Colombia',
                'Enel',
              ],
              [
                'Colombia',
                120,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'El Gab\u00e1n PV solar farm',
                'ABO Wind Renovables Colombia S.A.S.',
                'ABO Wind Renovables',
              ],
              [
                'Colombia',
                500,
                'South America',
                'Unavailable',
                'Unavailable',
                'Obando',
                'El Futuro Solar Project',
                'CSF Continua',
                'CSF Continua',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'El Colibr\u00ed Solar Project',
                'Massive Solar Energy Colombia',
                'Unknown',
              ],
              [
                'Colombia',
                36,
                'South America',
                'Unavailable',
                'Fundaci\u00f3n',
                'Fundacion',
                'El Campano Solar Park',
                'Trina Solar Ltd.',
                'Trina Solar Ltd.',
              ],
              [
                'Colombia',
                180,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cimitarra',
                'El Balso Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'El Atillo solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Dulima PV Solar Plant',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                300,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centro',
                'Delphi Helios Solar Park',
                'Delphi Capital Partners S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cuesitas',
                'Cuestecitas Solar Park',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cuesitas',
                'Cuestecitas Solar Park',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed',
                'Almendro PV Solar Plant',
                'Grenergy Colombia',
                'Grenergy Colombia',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Marip\u00ed',
                'Occidente',
                'Alejandri\u0301A Solar Project',
                'Prodiel',
                'Prodiel',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cartagena',
                'Girasol Planta Solar',
                'Enerfin Servicios S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Los Ocobos PV Solar Project',
                'TW Solar',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Gualanday PV Solar Park',
                'Fotovoltaico Gualanday S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'Guayacanes Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Los Llanos Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Los Llanos Solar Forest',
                'Trina Solar Ltd.',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Los Llanos Solar Forest',
                'Trina Solar Ltd.',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Los Llanos Solar Forest',
                'Trina Solar Ltd.',
                'Solargreen',
              ],
              [
                'Colombia',
                70,
                'South America',
                'Unavailable',
                'Hobo',
                'Hobo',
                'Los Cauchos Solar Plant',
                'Generadora Solar El Hobo S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Lizama PV Solar Project',
                'Solar Projects Developers S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'San Jorge',
                'Ligustro Solar Plant',
                'Green Energy DS&E S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'San Jorge',
                'Ligustro Solar Plant',
                'Green Energy DS&E S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Piedemonte',
                'Las Mesetas Solar Park',
                'IC Asesor\u00edas y Proyectos S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Popay\u00e1n',
                'Centro',
                'Las Mar\u00edas Solar Plant',
                'Promotora y Generadora de Energ\u00edas Sostenibles Sas',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Zarzal',
                'Las Coloradas Solar Plant',
                'San Antonio Botero S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centro',
                'La Victoria solar farm',
                'Celsia Colombia',
                'Celsia Colombia',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'San Jorge',
                'La Uni\u00f3n Solar Park',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'La Tolua PV Solar Park',
                'Parque Fotovoltaico La Toluca S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'La Sierra PV Solar Park',
                'Invenergy',
                'Invenergy',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'La Sierpe PV Solar Plant',
                'Parque Fotovoltaico La Sierpe S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Centrosur',
                'La Ponderosa Solar Park',
                'Eagle Energy S.L.',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Santa Rosa',
                'La Orqu\u00eddea Solar Project',
                'La Orqu\u00eddea Solar',
                'Unknown',
              ],
              [
                'Colombia',
                40,
                'South America',
                'Unavailable',
                'Unavailable',
                'Puerto Wilches',
                'La Manguita Solar Project',
                'Ferminac International S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                173,
                'South America',
                'Unavailable',
                'Becerril',
                'La Loma',
                'La Loma Solar Park',
                'Enel Green Power Colombia',
                'Enel',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'La Iguana solar farm',
                'Castellana de Proyectos Solares',
                'Unknown',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'Victoria',
                'La Estrella Solar Project',
                'ABO Wind Renovables Colombia S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'La Cayena Solar Park',
                'La Cayena Solar S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Kairo Solar Plant',
                'Obras e Interventor\u00eda Colombiana Sas',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Kairo Solar Plant',
                'Obras e Interventor\u00eda Colombiana Sas',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Kai PV Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Oca\u00f1a',
                'Oca\u00f1a',
                'Helios Cesaroca\u00f1a Solar Park',
                'Delphi Capital Partners S.A.',
                'Delphi Capital Partners S.A.',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Unavailable',
                'Heliconia',
                'Heliconia PV Solar Park',
                'Voltalia',
                'Voltalia',
              ],
              [
                'Colombia',
                491,
                'South America',
                'Unavailable',
                'Ponedera',
                'Ponedera',
                'Guayepo PV Solar Park',
                'Enel Green Power Colombia',
                'Enel',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed',
                'Guayac\u00e1n Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'Ibague',
                'Flamenco Solar Park',
                'Parque Solar Flamenco S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                80,
                'South America',
                'Unavailable',
                'Unavailable',
                'Buenaventura',
                'Aguaclara solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                90,
                'South America',
                'Unavailable',
                'Unavailable',
                'Sampu\u00e9s',
                'Altamira Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Colombia',
                'Norte',
                'Cattleya Del Huila Solar Project',
                'Black Orchid Solar',
                'Black Orchid Solar',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed',
                'Cedro Solar Plant',
                'Cedro Desarrollos Solares S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Celsia Solar Park',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cartago',
                'Centauro PV solar farm',
                'Mainstream Colombia S.A.',
                'Mainstream Colombia S.A.',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Charcos Solar Project',
                'Solar Projects Developers S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Los Santos',
                'Chicamocha Solar Project',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Los Santos',
                'Chicamocha Solar Project',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Los Santos',
                'Chicamocha Solar Project',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'San Jorge',
                'Chinu Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                350,
                'South America',
                'Unavailable',
                'Unavailable',
                'Chin\u00fa',
                'Chinu Solar Park',
                'LatamSolar Energias Renovables',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Cimitarra Solar Project',
                'Termotasajero',
                'Unknown',
              ],
              [
                'Colombia',
                51,
                'South America',
                'Unavailable',
                'Yotoco',
                'Yotoco',
                'Clip Solar Park',
                'Smart Consulting Group',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Codazzi PV Solar Project',
                'Fonroche Colombia',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Codazzi PV Solar Project',
                'Fonroche Colombia',
                'Unknown',
              ],
              [
                'Colombia',
                193,
                'South America',
                'Unavailable',
                'Unavailable',
                'Montel\u00edbano',
                'Colombia Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Valle de Aburr\u00e1',
                'Compostela PV Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Copey Del Verano Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Copey',
                'Copey Solar Project',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                60,
                'South America',
                'Unavailable',
                'Majagual',
                'La Mojana',
                'Cove\u00f1as Solar Park',
                'Elawan Energy',
                'Unknown',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cuesitas',
                'Cuestecitas Solar Park',
                'Colombia Solar Corporation International',
                'Colombia Solar Corporation International',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Altamira',
                'Altamira',
                'Altamira PV Solar Park',
                'Parque Solar Colombia III',
                'Unknown',
              ],
              [
                'Colombia',
                21,
                'South America',
                'Unavailable',
                'Castilla La Nueva',
                'Piedemonte',
                'Castilla Solar Park',
                'Ecopetrol S.A.',
                'Ecopetrol S.A.',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed',
                'Casco De Vaca Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Los Santos',
                'Chicamocha Solar Project',
                'Celsia Colombia',
                'Celsia S.A.',
              ],
              [
                'Colombia',
                250,
                'South America',
                'Unavailable',
                'Unavailable',
                'Magdalena Caldense',
                'Carreto Solar Park',
                'Solano S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Amanecer PV Solar Park',
                'Voltalia',
                'Voltalia',
              ],
              [
                'Colombia',
                140,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Andes Solar Project',
                'Andes Solar',
                'Andes Solar',
              ],
              [
                'Colombia',
                85,
                'South America',
                'Unavailable',
                'Unavailable',
                'Oriental',
                'Andes Solares PV Solar Plant',
                'Andes Solar',
                'Andes Solar',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Sinc\u00e9',
                'Tol\u00fa Viejo',
                'Andr\u00f3meda Solar Project',
                'Mainstream Colombia S.A.',
                'Mainstream Colombia S.A.',
              ],
              [
                'Colombia',
                99,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cartago',
                'Cartago Solar Park',
                'Trina Solar Ltd.',
                'Continua Energia Positiva',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Atl\u00e1ntico Solar Park',
                'Colomener VI S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                240,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Atl\u00e1ntico Solar Project',
                'Diverxia Infrastructure',
                'Diverxia Infrastructure',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Awarala solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Colombia',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'R\u00edo de Oro',
                'Azucenos Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Baranoa PV Solar Park',
                'Fotovoltaica El Yarumo S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Candelaria',
                'Becharry Solar Park',
                'Colomener III S.A.',
                'Unknown',
              ],
              [
                'Colombia',
                150,
                'South America',
                'Unavailable',
                'Unavailable',
                'Chin\u00fa',
                'Antares Solar Park',
                'Mainstream Colombia S.A.',
                'Mainstream Colombia S.A.',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolivar PV Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Cimitarra',
                'Carare PV Solar Park',
                'ABO Wind Renovables Colombia S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Rio Meta',
                'Bochica Solar Plant',
                'ABO Wind Renovables Colombia S.A.S.',
                'Unknown',
              ],
              [
                'Colombia',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Caracol\u00ed Solar Plant',
                'Ralos & Blaud Energy Colombia Sas',
                'Unknown',
              ],
              [
                'Colombia',
                121,
                'South America',
                'Unavailable',
                'Unavailable',
                'Chin\u00fa',
                'Campano Solar Park',
                'Univergy International',
                'Univergy International',
              ],
              [
                'Colombia',
                400,
                'South America',
                'Unavailable',
                'Tubar\u00e1',
                'Sabanlarga',
                'Buenavista Solar Park',
                'TW Solar',
                'TW Solar',
              ],
              [
                'Colombia',
                200,
                'South America',
                'Unavailable',
                'Unavailable',
                'Soacha',
                'Canoas PV Solar Park',
                'Due Capital and Services',
                'Unknown',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolivar PV Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolivar PV Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolivar PV Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Colombia',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolivar PV Solar Forest',
                'Solargreen',
                'Solargreen',
              ],
              [
                'Croatia',
                50,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Pometeno Brdo (ENCRO ZD2) solar farm',
                'Unknown',
                'ENCRO ZD2',
              ],
              [
                'Croatia',
                41,
                'Europe',
                'Benkovac',
                'Benkovac',
                'Zadar County',
                'Ra\u0161tevi\u0107 solar farm',
                'Unknown',
                'SE Ra\u0161tevi\u0107',
              ],
              [
                'Croatia',
                96,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Pometeno Brdo (Kon\u010dar) solar farm',
                'Unknown',
                'Kon\u010dar',
              ],
              [
                'Croatia',
                25,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Prolo\u017eac solar farm',
                'Unknown',
                'EnergoVizija d.o.o',
              ],
              [
                'Croatia',
                150,
                'Europe',
                'Unavailable',
                'Promina',
                '\u0160ibenik-Knin County',
                'Promina Solar Farm',
                'Unknown',
                'Acconia Energia',
              ],
              [
                'Croatia',
                24,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Runjik Solar Farm',
                'Unknown',
                'VSB Obnovljiva Energija Hrvatska d.o.o.',
              ],
              [
                'Croatia',
                20,
                'Europe',
                'Unavailable',
                'Bjelovar-Bilogora County',
                'Splitsko-Podravska County',
                'Tijarica solar farm',
                'Unknown',
                'Vrta\u010da',
              ],
              [
                'Croatia',
                45,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Sutina solar farm',
                'Unknown',
                'Bilo Polje d.o.o',
              ],
              [
                'Croatia',
                50,
                'Europe',
                'Sveti Petar Ludbreski',
                'Vara\u017edin',
                'Vara\u017edin County',
                'Sveti Petar Ludbreski Solar Farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Croatia',
                30,
                'Europe',
                'Unavailable',
                'Bjelovar-Bilogora County',
                'Splitsko-Podravska County',
                'Tarabnik solar farm',
                'Unknown',
                'Vrta\u010da',
              ],
              [
                'Croatia',
                63,
                'Europe',
                'Pako\u0161tane',
                'Pako\u0161tane',
                'Zadar County',
                'Vlaka solar farm',
                'Unknown',
                'Neoen Renewables Croatia',
              ],
              [
                'Croatia',
                60,
                'Europe',
                'Zadar County',
                'Zadar County',
                'Unavailable',
                'Zaton Obrova\u010dki Solar Farm',
                'Unknown',
                'EnergoVizija d.o.o',
              ],
              [
                'Croatia',
                20,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Zona Izlazak Solar Farm',
                'Unknown',
                'Bilo Polje d.o.o',
              ],
              [
                'Croatia',
                43,
                'Europe',
                'Zadar County',
                'Zadar County',
                'Unavailable',
                'Poli\u010dnik (Sun Investment) solar farm',
                'Unknown',
                'Sun Investment Group',
              ],
              [
                'Croatia',
                26,
                'Europe',
                'Jasenice',
                'Jasenice',
                'Zadar County',
                'Rupine solar farm',
                'Unknown',
                'Vidukin Gaj',
              ],
              [
                'Croatia',
                39,
                'Europe',
                'Zadar County',
                'Zadar County',
                'Unavailable',
                'Poli\u010dnik (Neoen Renewables) solar farm',
                'Unknown',
                'Neoen Renewables',
              ],
              [
                'Croatia',
                50,
                'Europe',
                'Rasinja',
                'Koprivnica',
                'Koprivnica-Kri\u017eevci county',
                'Rasinja solar farm',
                'Unknown',
                'Sun\u010dane elektrane Me\u0111imurja',
              ],
              [
                'Croatia',
                60,
                'Europe',
                'Obrovac Sinjski',
                'Sinj',
                'Split-Dalmatia County',
                'Obrovac Sinjski solar farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Croatia',
                26,
                'Europe',
                'Zadar County',
                'Zadar County',
                'Unavailable',
                'Poli\u010dnik (HEP) solar farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Croatia',
                60,
                'Europe',
                'Benkovac',
                'Benkovac',
                'Zadar County',
                'Benkovac solar farm',
                'Unknown',
                'Aureus Solis',
              ],
              [
                'Croatia',
                60,
                'Europe',
                'Bibinje',
                'Bibinje',
                'Zadar County',
                'Bibinje solar farm',
                'Unknown',
                'Kr\u0161',
              ],
              [
                'Croatia',
                50,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Bisko solar farm',
                'Unknown',
                'EnergoVizija d.o.o',
              ],
              [
                'Croatia',
                44,
                'Europe',
                'Zadar County',
                'Zadar County',
                'Unavailable',
                'Bravar solar farm',
                'Unknown',
                'EnergoVizija d.o.o',
              ],
              [
                'Croatia',
                60,
                'Europe',
                'Lika-Senj County',
                'Lika-Senj County',
                'Unavailable',
                'Gospi\u0107 1 solar farm',
                'Unknown',
                'EnergoVizija d.o.o',
              ],
              [
                'Croatia',
                30,
                'Europe',
                'Katuni',
                '\u0160estanovac',
                'Split-Dalmatia County',
                'Katuni solar farm',
                'Unknown',
                'Wpb Adria',
              ],
              [
                'Croatia',
                38,
                'Europe',
                'Benkovac',
                'Benkovac',
                'Zadar County',
                'Kolarina solar farm',
                'Unknown',
                'SE Kolarina',
              ],
              [
                'Croatia',
                41,
                'Europe',
                'Unavailable',
                'Dubrova\u010dko Primorje',
                'Dubrovnik\u2013Neretva County',
                'Rudine solar farm',
                'Unknown',
                'RP Global',
              ],
              [
                'Croatia',
                75,
                'Europe',
                'Benkovac',
                'Benkovac',
                'Zadar County',
                'Korlat solar farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Croatia',
                44,
                'Europe',
                'Koprivnica-Kri\u017eevci County',
                'Koprivnica-Kri\u017eevci County',
                'Unavailable',
                'Legrad Hybrid Power Project solar farm',
                'Unknown',
                'EEG Energy-Gas d.o.o',
              ],
              [
                'Croatia',
                42,
                'Europe',
                'Koprivnica-Kri\u017eevci County',
                'Koprivnica-Kri\u017eevci County',
                'Unavailable',
                'Legrad Hybrid Power Project solar farm',
                'Unknown',
                'EEG Energy-Gas d.o.o',
              ],
              [
                'Croatia',
                50,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Ljubitovica solar farm',
                'Unknown',
                'Neoen Renewables',
              ],
              [
                'Croatia',
                26,
                'Europe',
                'Jasenice',
                'Jasenice',
                'Zadar County',
                'Lu\u017eine solar farm',
                'Unknown',
                'Vidukin Gaj',
              ],
              [
                'Croatia',
                99,
                'Europe',
                'Split-Dalmatia County',
                'Split-Dalmatia County',
                'Unavailable',
                'Movran solar farm',
                'Unknown',
                'M.G.G.M. Green Energy d.o.o.',
              ],
              [
                'Croatia',
                77,
                'Europe',
                'Sisak-Moslavina County',
                'Sisak-Moslavina County',
                'Unavailable',
                'MVES 60 solar farm',
                'Unknown',
                'Photo Volt',
              ],
              [
                'Croatia',
                25,
                'Europe',
                'Nova Vas',
                'Kr\u0161an',
                'Istria County',
                'Nova Vas solar farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Croatia',
                35,
                'Europe',
                'Ugljane',
                'Trilj',
                'Split-Dalmatia County',
                'Kona\u010dnik solar farm',
                'Unknown',
                'Hrvatska Elektroprivreda (HEP)',
              ],
              [
                'Cuba',
                39,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Mariel',
                'Mariel solar farm',
                'Unknown',
                'Hive Energy',
              ],
              [
                'Cuba',
                75,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Exim solar farm',
                'Unknown',
                'Export-Import Bank of India (Exim Bank); Banco Exterior de Cuba',
              ],
              [
                'Czech Republic',
                22,
                'Europe',
                'Brno',
                'Jihomoravsk\u00fd kraj',
                'Unavailable',
                'Brno Tu\u0159any Solar Farm',
                'Unknown',
                'Jufa',
              ],
              [
                'Czech Republic',
                30,
                'Europe',
                'Jiho\u010desk\u00fd kraj',
                'Jiho\u010desk\u00fd kraj',
                'Unavailable',
                '\u0160ev\u011bt\u00edn solar farm',
                'Unknown',
                'CEZ Group',
              ],
              [
                'Czech Republic',
                35,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Veprek Solar Farm',
                'Unknown',
                'DECCI',
              ],
              [
                "C\u00f4te d'Ivoire",
                30,
                'Africa',
                'Laboa',
                'Unavailable',
                'Worodougou',
                'Touba- Laboa Scailing solar farm',
                'Unknown',
                "C\u00f4te d'Ivorie Ministry of Mines; Oil and Energy",
              ],
              [
                "C\u00f4te d'Ivoire",
                30,
                'Africa',
                'Touba',
                'Touba Department',
                'Bafing Region',
                'Touba- Laboa Scailing solar farm',
                'Unknown',
                "C\u00f4te d'Ivorie Ministry of Mines; Oil and Energy",
              ],
              [
                "C\u00f4te d'Ivoire",
                38,
                'Africa',
                'Boundiali',
                'Boundiali Department',
                'Bagou\u00e9 Region',
                'Boundiali solar farm',
                'Unknown',
                'KfW Entwicklungsbank',
              ],
              [
                "C\u00f4te d'Ivoire",
                20,
                'Africa',
                'Unavailable',
                'Yamoussoukro Department',
                'Marahou\u00e9',
                'Kossou Floaring solar farm',
                'Unknown',
                'CI-Energies',
              ],
              [
                "C\u00f4te d'Ivoire",
                25,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Poro',
                'Korhogo Solar Farm',
                'Unknown',
                'Nova Power',
              ],
              [
                "C\u00f4te d'Ivoire",
                25,
                'Africa',
                'Ferkess\u00e9dougou',
                'Ferkess\u00e9dougou',
                'Tchologo',
                'Ferk\u00e9ss\u00e9dougou solar farm',
                'Unknown',
                'Biotherm Energy',
              ],
              [
                "C\u00f4te d'Ivoire",
                66,
                'Africa',
                'Korhogo',
                'Korhogo',
                'Poro Region',
                'Poro solar farm',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'DR Congo',
                300,
                'Africa',
                'Menkao',
                'Maluku Commune',
                'Tshangu District',
                'Kinshasa Solar City solar farm',
                'Sun Plus',
                'Sun Plus',
              ],
              [
                'DR Congo',
                300,
                'Africa',
                'Menkao',
                'Maluku Commune',
                'Tshangu District',
                'Kinshasa Solar City solar farm',
                'Sun Plus',
                'Sun Plus',
              ],
              [
                'DR Congo',
                100,
                'Africa',
                'Kolwezi',
                'Mutshatsha',
                'Unavailable',
                'Kolwezi solar farm',
                'Unknown',
                'International Finance Corporation; Globeleq',
              ],
              [
                'DR Congo',
                40,
                'Africa',
                'Kisangani',
                'Unavailable',
                'Unavailable',
                'Tshopo solar farm',
                'Unknown',
                'Cat Projects Africa',
              ],
              [
                'Denmark',
                50,
                'Europe',
                'Unavailable',
                'Thisted',
                'Unavailable',
                'Viborg solar farm',
                'European Energy',
                'LHI Group',
              ],
              [
                'Denmark',
                75,
                'Europe',
                'Vandel',
                'Vejle',
                'Unavailable',
                'Vandel solar farm',
                'Energi-Innovation',
                'Allianz Global Investors [60%]; European Energy [40%]',
              ],
              [
                'Denmark',
                25,
                'Europe',
                'Vollerup',
                'S\u00f8nderborg',
                'Unavailable',
                'Vollerup solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                26,
                'Europe',
                'Salgelse',
                'Unavailable',
                'Unavailable',
                'Slagelse solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                22,
                'Europe',
                'Albaek',
                'Frederikshavn',
                'Unavailable',
                'Albaek solar farm',
                'European Energy',
                'European Energy',
              ],
              [
                'Denmark',
                62,
                'Europe',
                'Ebberup',
                'Assens',
                'Unavailable',
                'Arla solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                62,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arla solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                62,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arla solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                62,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arla solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                34,
                'Europe',
                'Svinnage',
                'Holb\u00e6k',
                'Unavailable',
                'Svinningegarden solar farm',
                'European Energy',
                'Encavis AG',
              ],
              [
                'Denmark',
                34,
                'Europe',
                'Unavailable',
                'Guldborgsund',
                'Unavailable',
                'Guldborg solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                207,
                'Europe',
                'Unavailable',
                'Holstebro',
                'Unavailable',
                'Heartland solar farm',
                'Better Energy',
                'Heartland',
              ],
              [
                'Denmark',
                61,
                'Europe',
                'Kalundborg',
                'Kalundborg',
                'Unavailable',
                'Lerchenborg solar farm',
                'SMA Solar Technology',
                'Wircon',
              ],
              [
                'Denmark',
                206,
                'Europe',
                'Bur',
                'Holstebro',
                'Unavailable',
                'Bur solar farm',
                'Unknown',
                'Better Energy',
              ],
              [
                'Denmark',
                38,
                'Europe',
                'Skive',
                'Skive',
                'Unavailable',
                'Skive solar farm',
                'Unknown',
                'European Energy',
              ],
              [
                'Denmark',
                71,
                'Europe',
                'Unavailable',
                'Lolland',
                'Unavailable',
                'R\u00f8dby Fjord solar farm',
                'European Energy',
                'Encavis AG',
              ],
              [
                'Denmark',
                28,
                'Europe',
                'Rejstrup',
                'Unavailable',
                'Randers',
                'Rejstrup solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Denmark',
                250,
                'Europe',
                'Unavailable',
                'Br\u00f8nderslev',
                'Unavailable',
                'Project M30 solar farm',
                'GreenGo',
                'Encavis AG',
              ],
              [
                'Denmark',
                45,
                'Europe',
                'Nees',
                'Unavailable',
                'Unavailable',
                'Nees solar farm',
                'Better Energy',
                'Better Energy; NRGi',
              ],
              [
                'Denmark',
                51,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Naestved solar farm',
                'Better Energy',
                'Better Energy',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                30,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Engie Grand Bara Solar PV',
                'Engie',
                'Engie',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Unavailable',
                'Skypower solar farm',
                'Unknown',
                'Republic of Djibouti; SkyPower Global',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Unavailable',
                'Skypower solar farm',
                'Unknown',
                'Republic of Djibouti; SkyPower Global',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Unavailable',
                'Skypower solar farm',
                'Unknown',
                'Republic of Djibouti; SkyPower Global',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Grand Bara',
                'Enesys Grand Bara solar farm',
                'Unknown',
                'Republic of Djibouti; Green Enesys',
              ],
              [
                'Djibouti',
                50,
                'Africa',
                'Unavailable',
                'Tadjoura',
                'Unavailable',
                'Skypower solar farm',
                'Unknown',
                'Republic of Djibouti; SkyPower Global',
              ],
              [
                'Dominican Republic',
                50,
                'Central America and the Caribbean',
                'Ban\u00ed',
                'Las Charcas',
                'Matanzas',
                'Bayasol Photovoltaic solar farm',
                'AES Dominicana',
                'AES Group',
              ],
              [
                'Dominican Republic',
                25,
                'Central America and the Caribbean',
                'Vicente Noble',
                'Jaquimeyes',
                'Barahona',
                'Canoa Solar Park',
                'Emerald Solar Energy',
                'Unknown',
              ],
              [
                'Dominican Republic',
                120,
                'Central America and the Caribbean',
                'Yaguate',
                'Yaguate',
                'Yaguate',
                'Girasol Solar Park',
                'Haina Electricity Generating Company',
                'Haina Electricity Generating Company',
              ],
              [
                'Dominican Republic',
                51,
                'Central America and the Caribbean',
                'Unavailable',
                'Santo Domingo Norte',
                'La Victoria',
                'La Victoria Solar Facility',
                'Isofoton',
                'Isofoton',
              ],
              [
                'Dominican Republic',
                50,
                'Central America and the Caribbean',
                'Unavailable',
                'San Antonio de Guerra',
                'Unavailable',
                'Mata De Palma Washington Solar Park',
                'Gamesa Electric',
                'Gamesa Electric',
              ],
              [
                'Dominican Republic',
                33,
                'Central America and the Caribbean',
                'Monte Plata',
                'Monte Plata',
                'Unavailable',
                'Monte Plata Solar Plant',
                'MPC - Caribbean Clean Energy',
                'MPC - Caribbean Clean Energy',
              ],
              [
                'Dominican Republic',
                73,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mata De Palma Washington Solar Park',
                'Energia Renovable BAS',
                'Unknown',
              ],
              [
                'Dominican Republic',
                40,
                'Central America and the Caribbean',
                'Unavailable',
                'Monte Plata',
                'Unavailable',
                'Monte Plata Solar Plant',
                'MPC - Caribbean Clean Energy',
                'MPC - Caribbean Clean Energy',
              ],
              [
                'Dominican Republic',
                58,
                'Central America and the Caribbean',
                'Guayub\u00edn',
                'Guayub\u00edn',
                'Unavailable',
                'Montecristi Solar Park',
                'Blue Elephant AG (BEE)',
                'Blue Elephant AG (BEE)',
              ],
              [
                'Dominican Republic',
                58,
                'Central America and the Caribbean',
                'Unavailable',
                'Guayub\u00edn',
                'Guayub\u00edn',
                'Montecristi Solar Park',
                'Blue Elephant AG (BEE)',
                'Blue Elephant AG (BEE)',
              ],
              [
                'Dominican Republic',
                75,
                'Central America and the Caribbean',
                'Unavailable',
                'Fantino',
                'Unavailable',
                'MPC Energy Solutions solar farm',
                'MPC Energy Solutions (MPCES)',
                'MPC Energy Solutions (MPCES) [51%]; Soventix Caribbean',
              ],
              [
                'Dominican Republic',
                67,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mata De Palma Washington Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Dominican Republic',
                65,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Santanasol Solar Park',
                'AES Dominicana',
                'AES Group',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Ibarra',
                'Chota',
                'Chota-Pim\u00e1n solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                50,
                'South America',
                'Unavailable',
                'Cotacachi',
                'Unavailable',
                'Illapa solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Cerecita',
                'Unavailable',
                'Vaiana solar farm',
                'Guitarsa S.A.',
                'Unknown',
              ],
              [
                'Ecuador',
                29,
                'South America',
                'Unavailable',
                'Tonchigue',
                'Unavailable',
                'Tonchigue solar farm',
                'Atlantic Wind and Solar',
                'Atlantic Wind and Solar',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Cayambe',
                'Tacabundo',
                'Solar Connection PV Plant',
                'Unknown',
                'Sunwize Technologies; Solexica Energy; JCM Capital; Radical Energy',
              ],
              [
                'Ecuador',
                25,
                'South America',
                'Unavailable',
                'Elena Canton',
                'Unavailable',
                'Santa Elena solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Cayambe',
                'Unavailable',
                'Rancho Solar Villa Cayambe solar farm',
                'Sun Energy Ecuador S.A.',
                'Unknown',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rancho Solar Catamayo',
                'Ecuador Energ\u00e9tico S.A.',
                'Unknown',
              ],
              [
                'Ecuador',
                54,
                'South America',
                'Calder\u00f3n',
                'Quito',
                'Unavailable',
                'Calderon solar farm',
                'Isofoton',
                'Isofoton',
              ],
              [
                'Ecuador',
                80,
                'South America',
                'Unavailable',
                'Chong\u00f3n',
                'Unavailable',
                'Chong\u00f3n solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                30,
                'South America',
                'Unavailable',
                'Cayambe',
                'Tacabundo',
                'Condor Solar PV Plant',
                'Unknown',
                'Sunwize Technologies; Solexica Energy; JCM Capital; Radical Energy',
              ],
              [
                'Ecuador',
                50,
                'South America',
                'Calder\u00f3n',
                'Quito',
                'Unavailable',
                'Shyri solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                50,
                'South America',
                'Unavailable',
                'Ventanas',
                'Unavailable',
                'Enersol solar farm (Ecuador)',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Paltas',
                'Sapotillo',
                'Gpsa PV Solar Project',
                'Energia Solar SA',
                'Unknown',
              ],
              [
                'Ecuador',
                25,
                'South America',
                'Unavailable',
                'Huaquillas',
                'Unavailable',
                'Imbabura-Pim\u00e1n solar farm',
                'Ecuador Energ\u00e9tico S.A.',
                'Unknown',
              ],
              [
                'Ecuador',
                29,
                'South America',
                'Unavailable',
                'Lagarto',
                'Unavailable',
                'Lagarto solar farm',
                'Atlantic Wind and Solar',
                'Atlantic Wind and Solar',
              ],
              [
                'Ecuador',
                30,
                'South America',
                'Unavailable',
                'Montecristi',
                'Montecristi',
                'Los Bajos solar farm',
                'Energias Manabitas S.A.',
                'Unknown',
              ],
              [
                'Ecuador',
                30,
                'South America',
                'Unavailable',
                'Esmeraldas',
                'Unavailable',
                'Los Bajos Solar Project',
                'Solar Energy Ecuador SA',
                'Unknown',
              ],
              [
                'Ecuador',
                50,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Marifer solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Milenio solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ecuador',
                25,
                'South America',
                'Unavailable',
                'Cayambe',
                'Unavailable',
                'Mitad Del Mundo solar farm',
                'Cayamba Ca Enercay',
                'Unknown',
              ],
              [
                'Ecuador',
                258,
                'South America',
                'El Aromo',
                'Jaramij\u00f3',
                'Unavailable',
                'El Aromo Solar Project',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Alcazar solar farm',
                'Alcazar Energy; Samcrete Egypt Engineers and Contractors',
                'Alcazar Energy',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Alfanar solar farm',
                'Alfanar Energy',
                'Alfanar Group',
              ],
              [
                'Egypt',
                66,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Arc Renwable solar farm',
                'Unknown',
                'Globeleq',
              ],
              [
                'Egypt',
                25,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Arinna solar farm',
                'Enerray S.p.A.',
                'Al Bilal Group; Enerray S.p.A., Desert Technologies Co. Ltd; Tech\nProject Development Group Incorporated',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Bea solar farm',
                'Unknown',
                'Building Energy; New and Renewable Energy Authority (NREA)',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Bea solar farm',
                'Unknown',
                'Building Energy; New and Renewable Energy Authority (NREA)',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Lekela solar farm',
                'Lekela Power',
                'Actis; Mainstream Renewable Power',
              ],
              [
                'Egypt',
                47,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Enel solar farm',
                'Unknown',
                'Enel S.p.A.',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Fas solar farm',
                'Unknown',
                'Fas Energy',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Infinity 50 solar farm',
                'Infinity Energy S.A.E.',
                'Masdar Clean Energy; New and Renewable Energy Authority',
              ],
              [
                'Egypt',
                38,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban MMID 30 solar farm',
                'ib vogt GmbH',
                'Infinity Solar Energy SAE; Ib Vogt; BPE Partners',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Pallonji solar farm',
                'Sterling and Wilson Pvt. Limited',
                'Shapoorji Pallonji Infrastructure Capital Company Private Limited',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Alcazar solar farm',
                'Alcazar Energy; Cabli Power Cables Manufacturing',
                'Alcazar Energy',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban BESP 50 solar farm',
                'ib vogt GmbH',
                'Infinity Solar Energy SAE; Ib Vogt; BPE Partners',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Alcazar solar farm',
                'Alcazar Energy',
                'Alcazar Energy',
              ],
              [
                'Egypt',
                100,
                'Africa',
                'Bahariya Oasis',
                'Bahariya Oasis',
                'Western Desert',
                'Bahariya Oasis solar farm',
                'KarmSolar',
                'KarmSolar',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Adenium solar farm',
                'Unknown',
                'Adenium Energy; Electrical Services; Bengoah',
              ],
              [
                'Egypt',
                28,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban ACWA solar farm',
                'ACWA Power',
                'ACWA Power; Chint; Tawakol Electric',
              ],
              [
                'Egypt',
                70,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban ACWA solar farm',
                'ACWA Power',
                'ACWA Power; Chint; Tawakol Electric',
              ],
              [
                'Egypt',
                68,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban ACWA solar farm',
                'ACWA Power',
                'ACWA Power; Chint; Tawakol Electric',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Acciona/Enara solar farm',
                'Unknown',
                'Acciona Energ\u00eda Global; Enara Bahrain',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Acciona/Enara solar farm',
                'Unknown',
                'Acciona Energ\u00eda Global [50%]; Enara Bahrain [50%]',
              ],
              [
                'Egypt',
                63,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Access/Eren solar farm',
                'Access Building Energy Solar One (ABESO)',
                'Total Eren; Access Infra Africa',
              ],
              [
                'Egypt',
                63,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Access/Eren solar farm',
                'Access Energy Solar One (AESO)',
                'Total Eren; Access Infra Africa',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Phoenix 50 solar farm',
                'ib vogt GmbH',
                'Infinity Solar Energy SAE; Ib Vogt; BPE Partners',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'ARC Benban Solar PV Plant',
                'ARC for Renewable Energy SAE',
                'ARC for Renewable Energy SAE',
              ],
              [
                'Egypt',
                20,
                'Africa',
                'New Administrative Capital',
                'Unavailable',
                'Unavailable',
                'Aoi/Madkour Nac Military Complex Rooftop Solar',
                'Arab Industrialization Organization (AOI); Madkour Group',
                'Administrative Capital For Urban Development',
              ],
              [
                'Egypt',
                100,
                'Africa',
                'Ain Sokhna',
                'Ain Sokhna',
                'Unavailable',
                'Ain Sokhna Solar',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Egypt',
                200,
                'Africa',
                'Com Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'ACWA Kom Ombo solar farm',
                'ACWA Power',
                'ACWA Power',
              ],
              [
                'Egypt',
                500,
                'Africa',
                'Kom Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'Abyodos Kom Ombo solar farm',
                'Abyodos Solar Power Company',
                'Amea Power',
              ],
              [
                'Egypt',
                64,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Alcazar solar farm',
                'Alcazar Energy; Enerpal',
                'Alcazar Energy; Enerpal',
              ],
              [
                'Egypt',
                32,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Ra solar farm',
                'Voltalia',
                'Voltalia',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Acciona/Enara solar farm',
                'Unknown',
                'Acciona Energ\u00eda Global; Enara Bahrain',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Zafarana',
                'Ras Gharib',
                'Unavailable',
                'Zafarana solar farm',
                'Belectric',
                'Belectric; New and Renewable Energy Authority (NREA)',
              ],
              [
                'Egypt',
                200,
                'Africa',
                'Unavailable',
                'West Nile',
                'Unavailable',
                'West Nile Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Egypt',
                600,
                'Africa',
                'Unavailable',
                'West Nile',
                'Unavailable',
                'West Nile Delta Power Plant solar farm',
                'Unknown',
                'International Finance Corporation (IFC); The Egyptian Electricity Transmission Company (EETC)',
              ],
              [
                'Egypt',
                36,
                'Africa',
                'Marsa Alam',
                'Eastern Desert',
                'Unavailable',
                'Sukari Gold Mine Solar Power Plant',
                'juwi AG; Centamin plc',
                'Centamin plc; Modernization of Mining Sector in Egypt',
              ],
              [
                'Egypt',
                10,
                'Africa',
                'Siwa Oasis',
                'Qattara Depression',
                'Western Desert',
                'Siwa Solar PV Plant',
                'Al Behira Electrical Distribution Company',
                'Egyptian Electricity Holding Company',
              ],
              [
                'Egypt',
                26,
                'Africa',
                'Kom Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'Kom Ombo Solar Plant',
                'Unknown',
                'New and Renewable Energy Authority (NREA)',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Com Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'Kom Ombo Elsewedy/EDF solar farm',
                'Elsewedy Electric; EDF Renewables',
                'Elsewedy Electric; EDF Renewables; Newcand Renewable Energy Authority',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Com Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'Kom Ombo ECSED solar farm',
                'Egyptian Company for Solar Energy (ECSED)',
                'Elsewedy Electric; New and Renewable Energy Authority',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Com Ombo',
                'Markaz Com Ombo',
                'Unavailable',
                'Kom Ombo Elsewedy/EDF solar farm',
                'Elsewedy Electric; EDF Renewables',
                'Elsewedy Electric; EDF Renewables',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ge solar farm',
                'Unknown',
                'Fas Energy',
              ],
              [
                'Egypt',
                18,
                'Africa',
                'New Administrative Capital',
                'Unavailable',
                'Unavailable',
                'Benha/Suntech NAC Rooftop Solar',
                'Benha Electronics; Suntech Electronics',
                'Administrative Capital For Urban Development',
              ],
              [
                'Egypt',
                25,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Winnergy solar farm',
                'Enerray S.p.A.',
                'Al Tawakol Electrical (Gila) S.A.E.; Enerray S.p.A.; Desert Technologies\nIndustries Co. Ltd.; Spectrum International for Renewable Energy LLC; New and renewable Energy Agency',
              ],
              [
                'Egypt',
                50,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Taqa solar farm',
                'ib vogt GmbH',
                'Infinity Solar Energy SAE; ib vogt GmbH',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'Egypt',
                20,
                'Africa',
                'Hurghada',
                'Hurghada',
                'Unavailable',
                'Hurghada North solar farm',
                'Unknown',
                'New and Renewable Energy Authority (NREA)',
              ],
              [
                'Egypt',
                65,
                'Africa',
                'Benban',
                'Markaz Deraw',
                'Unavailable',
                'Benban Scatec solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; Africa 50',
              ],
              [
                'El Salvador',
                25,
                'Central America and the Caribbean',
                'El Rosario',
                'Unavailable',
                'Unavailable',
                'Providencia Solar Park',
                'Unknown',
                'IIC; Neoen; Proparco',
              ],
              [
                'El Salvador',
                70,
                'Central America and the Caribbean',
                'Usulut\u00e1n',
                'Unavailable',
                'Unavailable',
                'Capella Solar Park',
                'Neoen El Salvador',
                'Neoen',
              ],
              [
                'El Salvador',
                70,
                'Central America and the Caribbean',
                'Usulut\u00e1n',
                'Unavailable',
                'Unavailable',
                'Capella Solar Park',
                'Neoen El Salvador',
                'Neoen',
              ],
              [
                'El Salvador',
                25,
                'Central America and the Caribbean',
                'Municipio de Acajutla',
                'Unavailable',
                'Unavailable',
                'Los Remedios solar farm',
                'Unknown',
                'REAL Infrastructure Capital Partners',
              ],
              [
                'El Salvador',
                75,
                'Central America and the Caribbean',
                'El Rosario',
                'Unavailable',
                'Unavailable',
                'Providencia Solar Park',
                'Unknown',
                'IIC; Neoen; Proparco',
              ],
              [
                'Eswatini',
                100,
                'Africa',
                'Edwaleni',
                'Inkhundla Lobamba Lomdzala',
                'Unavailable',
                'Edwaleni solar farm',
                'Unknown',
                'Frazium Energy',
              ],
              [
                'Ethiopia',
                100,
                'Africa',
                'Metehara',
                'Unavailable',
                'Unavailable',
                'Metehara solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'Ethiopia',
                125,
                'Africa',
                'Dicheto',
                'Unavailable',
                'Zone 1',
                'ACWA Dicheto solar farm',
                'ACWA Power',
                'ACWA Power',
              ],
              [
                'Ethiopia',
                500,
                'Africa',
                'Unavailable',
                'Unavailable',
                'North Shewa (Oromia Region)',
                'Masdar solar farm (Ethiopia)',
                'Masdar Clean Energy',
                'Masdar Clean Energy',
              ],
              [
                'Ethiopia',
                500,
                'Africa',
                'Tigray',
                'Unavailable',
                'Eastern Tigray',
                'Tigray Effort solar farm',
                'Lotus Energy Cooperative',
                'Lotus Energy Cooperative',
              ],
              [
                'Ethiopia',
                125,
                'Africa',
                'Gad',
                'Unavailable',
                'Korahe',
                'ACWA Gad solar farm',
                'ACWA Power',
                'ACWA Power',
              ],
              [
                'Finland',
                80,
                'Europe',
                'Lapua',
                'Lapua Municipality',
                'Sein\u00e4joki sub-region',
                'Lapua solar farm',
                'Unknown',
                'EPV Energy',
              ],
              [
                'Finland',
                500,
                'Europe',
                'Palloneva',
                'Central Finland',
                'Western and Central Finland',
                'Palloneva solar farm',
                'Unknown',
                'De Vrije Wind; Kaskisten Tuulivoima Oy; Kauhanummi Oy',
              ],
              [
                'France',
                50,
                'Europe',
                'Valenciennes',
                'Nord',
                'Unavailable',
                'Valenciennes solar farm',
                'Total Quadran',
                'Total SE',
              ],
              [
                'France',
                39,
                'Europe',
                'Unavailable',
                'Sarthe',
                'Unavailable',
                'Loirecopark solar farm',
                'Neoen',
                'Neoen Renewables',
              ],
              [
                'France',
                75,
                'Europe',
                'Meuse',
                'Meuse',
                'Unavailable',
                'Marville PV Solar Plant',
                'Unknown',
                'Enerparc AG',
              ],
              [
                'France',
                40,
                'Europe',
                'Meuse',
                'Meuse',
                'Unavailable',
                'Marville PV Solar Plant',
                'Unknown',
                'Enerparc AG',
              ],
              [
                'France',
                56,
                'Europe',
                'Yonne',
                'Yonne',
                'Unavailable',
                'Massangis Solar Power Plant',
                'EDF Services',
                'EDF Energies Nouvelles',
              ],
              [
                'France',
                20,
                'Europe',
                'Var',
                'Var',
                'Unavailable',
                'Olli\u00e8res solar farm',
                'Tenergie',
                'Tenergie',
              ],
              [
                'France',
                25,
                'Europe',
                'Ortaffa',
                'Pyr\u00e9n\u00e9es-Orientales',
                'Unavailable',
                'Ortaffa solar farm',
                'Juwi Enr',
                '123Ventures',
              ],
              [
                'France',
                28,
                'Europe',
                'Picarreau',
                'Jura',
                'Unavailable',
                'Picarreau solar farm',
                'CS Solaire',
                'Corsica Sole',
              ],
              [
                'France',
                43,
                'Europe',
                'Ni\u00e8vre',
                'Ni\u00e8vre',
                'Unavailable',
                'Verneuil - Charrin PV Solar Plant',
                'Photom Services',
                'Photosol Group',
              ],
              [
                'France',
                40,
                'Europe',
                'Pompogne',
                'Lot-et-Garonne',
                'Nouvelle-Aquitaine',
                'Pompogne Solar Park',
                'GP Joule',
                'Aquila Capital',
              ],
              [
                'France',
                20,
                'Europe',
                'Doubs',
                'Doubs',
                'Unavailable',
                'Psa Sochaux solar farm',
                'Engie Green',
                'Engie',
              ],
              [
                'France',
                32,
                'Europe',
                'Landes',
                'Landes',
                'Unavailable',
                'Rion-Des-Landes Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'France',
                23,
                'Europe',
                'Gironde',
                'Gironde',
                'Unavailable',
                'Saint-Symphorien solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'France',
                73,
                'Europe',
                'Gironde',
                'Gironde',
                'Unavailable',
                'Salaunes solar farm',
                'Engie Green',
                'Engie',
              ],
              [
                'France',
                55,
                'Europe',
                'Meurthe-et-Moselle',
                'Meurthe-et-Moselle',
                'Unavailable',
                'Toul-Rosi\u00e8res Solar Park',
                'EDF Services',
                'Mitsubishi',
              ],
              [
                'France',
                24,
                'Europe',
                'Meurthe-et-Moselle',
                'Meurthe-et-Moselle',
                'Unavailable',
                'Toul-Rosi\u00e8res Solar Park',
                'Sonnedix',
                'Sonnedix',
              ],
              [
                'France',
                36,
                'Europe',
                'Meurthe-et-Moselle',
                'Meurthe-et-Moselle',
                'Unavailable',
                'Toul-Rosi\u00e8res Solar Park',
                'EDF Services',
                'EDF Energies Nouvelles',
              ],
              [
                'France',
                43,
                'Europe',
                'Ychoux',
                'Landes',
                'Nouvelle-Aquitaine',
                'Ychoux - Parentis PV Solar Park',
                'Photom Services',
                'Photosol Group',
              ],
              [
                'France',
                20,
                'Europe',
                'Lazer',
                'Hautes-Alpes',
                'Unavailable',
                'Lazer Solar Power Facility',
                'EDF Services',
                'EDF Energies Nouvelles',
              ],
              [
                'France',
                1000,
                'Europe',
                'Saucats',
                'Gironde',
                'Nouvelle-Aquitaine',
                'Horizeo solar farm',
                'Engie; Neoen',
                'Engie; Neoen',
              ],
              [
                'France',
                25,
                'Europe',
                'Istres',
                'Bouches-du-Rh\u00f4ne',
                'Unavailable',
                'Istres solar farm',
                'EDF Services',
                'Sonnedix',
              ],
              [
                'France',
                82,
                'Europe',
                'Alpes-de-Haute-Provence',
                'Alpes-de-Haute-Provence',
                'Unavailable',
                'Gr\u00e9oux-Les-Bains solar farm',
                'Solairedirect',
                'Engie',
              ],
              [
                'France',
                28,
                'Europe',
                'Seine-et-Marne',
                'Seine-et-Marne',
                'Unavailable',
                'Grandpuits solar farm',
                'TotalEnergies',
                'Total SE',
              ],
              [
                'France',
                24,
                'Europe',
                'Yvelines',
                'Yvelines',
                'Unavailable',
                'Gargenville solar farm',
                'TotalEnergies',
                'Total SE',
              ],
              [
                'France',
                65,
                'Europe',
                'Landes',
                'Landes',
                'Unavailable',
                'Gabardan Solar Power Plant',
                'EDF Services',
                'EDF Energies Nouvelles',
              ],
              [
                'France',
                24,
                'Europe',
                'Alpes-de-Haute-Provence',
                'Alpes-de-Haute-Provence',
                'Unavailable',
                'Curbans Solar Power Plant',
                'Engie Green Renewables',
                'Engie',
              ],
              [
                'France',
                60,
                'Europe',
                'Eure-et-Loir',
                'Eure-et-Loir',
                'Unavailable',
                'Crucey Solar Power Plant',
                'EDF Services',
                'EDF Energies Nouvelles',
              ],
              [
                'France',
                300,
                'Europe',
                'Gironde',
                'Gironde',
                'Unavailable',
                'Cestas solar farm',
                'Neoen',
                'Neoen Renewables',
              ],
              [
                'France',
                25,
                'Europe',
                'S\u00e9ranvillers-Forenville',
                'Nord',
                'Unavailable',
                'Cambrai-Niergnies solar farm',
                "Sun'R Power",
                "Sun'R",
              ],
              [
                'France',
                25,
                'Europe',
                'S\u00e9ranvillers-Forenville',
                'Nord',
                'Unavailable',
                'Cambrai-Niergnies solar farm',
                "Sun'R Power",
                "Sun'R",
              ],
              [
                'France',
                30,
                'Europe',
                'Aups',
                'Var',
                "Provence-Alpes-C\u00f4te d'Azur",
                'Aups solar farm',
                'Tenergie',
                'Tenergie',
              ],
              [
                'France',
                59,
                'Europe',
                'Bordeaux',
                'Gironde',
                'Nouvelle-Aquitaine',
                'Labarde Solar Power Plant',
                'JP Energie Environment',
                'JP Energie Environment',
              ],
              [
                'French Guiana',
                55,
                'South America',
                'Mana',
                'Saint-Laurent-du-Maron',
                'Unavailable',
                "Centrale \u00c9lectrique De L'Ouest Guyanais (Ceog) solar farm",
                'Unknown',
                'Meridiam [60%]; SARA [30%]; Hydrogene de France (HDF) [10%]',
              ],
              [
                'Gabon',
                60,
                'Africa',
                'Ay\u00e9m\u00e9 Plaine',
                'Komo-Mondah Department',
                'Komo Department',
                'Ay\u00e9m\u00e9 Plaine solar farm',
                'Soci\u00e9t\u00e9 d\u2019\u00e9nergie et d\u2019eau du Gabon',
                'Solen',
              ],
              [
                'Gabon',
                60,
                'Africa',
                'Ay\u00e9m\u00e9 Plaine',
                'Komo-Mondah Department',
                'Komo Department',
                'Ay\u00e9m\u00e9 Plaine solar farm',
                'Soci\u00e9t\u00e9 d\u2019\u00e9nergie et d\u2019eau du Gabon',
                'Solen',
              ],
              [
                'Gabon',
                50,
                'Africa',
                'Oyem',
                'Woleu',
                'Woleu Department',
                'Oyem solar farm',
                'Amea Power',
                'Amea Power',
              ],
              [
                'Gabon',
                50,
                'Africa',
                'Libreville',
                'Libreville District',
                'Unavailable',
                'Libreville solar farm',
                'Unknown',
                'Total Eren',
              ],
              [
                'Gabon',
                150,
                'Africa',
                'Franceville',
                'Unavailable',
                'Mapassa Department',
                'Franceville solar farm',
                'Unknown',
                'Moroccan Agency for Sustainable Energy; Islamic Development Bank',
              ],
              [
                'Georgia',
                100,
                'Eurasia',
                'Unavailable',
                'Borjomi Municipality',
                'Unavailable',
                'Masdar solar farm (Georgia)',
                'Unknown',
                'Masdar; Georgian Energy Development Fund (GEDF)',
              ],
              [
                'Germany',
                32,
                'Europe',
                'Nordsachsen',
                'Nordsachsen',
                'Unavailable',
                'Delitzsch solar farm',
                'Enerparc',
                'Enerparc AG',
              ],
              [
                'Germany',
                55,
                'Europe',
                'Unavailable',
                'Gr\u00fcnheide',
                'Dettmannsdorf',
                'Dettmannsdorf-Gr\u00fcnheide solar farm',
                'Unknown',
                'Energiekontor',
              ],
              [
                'Germany',
                35,
                'Europe',
                'Unavailable',
                'S\u00fcd',
                'Dettmannsdorf',
                'Dettmannsdorf-S\u00fcd solar farm',
                'Unknown',
                'Energiekontor',
              ],
              [
                'Germany',
                30,
                'Europe',
                'Unavailable',
                'W\u00f6pkendorf',
                'Dettmannsdorf',
                'Dettmannsdorf-W\u00f6pkendorf solar farm',
                'Unknown',
                'Energiekontor',
              ],
              [
                'Germany',
                30,
                'Europe',
                'Spree-Nei\u00dfe',
                'Spree-Nei\u00dfe',
                'Unavailable',
                'Drewitz Solarpark',
                'RCP Solarpark Drewitz GmbH & Co. KG',
                'Altira AG',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Havelland',
                'Havelland',
                'Unavailable',
                'Dallgow-Doberitz solar farm',
                'Dallgow Infrastruktur GmbH',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'M\u00fcncheberg',
                'M\u00e4rkisch-Oderland',
                'Unavailable',
                'Eggersdorf solar farm',
                'CEE PVF Eggersdorf GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                26,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Eiche solar farm',
                'SP Eiche GmbH & Co. KG C/o SOPA Verwaltungs GmbH',
                'Unknown',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Herzogtum Lauenburg',
                'Herzogtum Lauenburg',
                'Unavailable',
                'Elmenhorst Solarpark',
                'Juwi Group',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Spreetal - Sprjewiny Do\u0142',
                'Bautzen',
                'Unavailable',
                'Elsterheide solar farm',
                'CEE PVF Elsterheide GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Main-Tauber-Kreis',
                'Main-Tauber-Kreis',
                'Unavailable',
                'Ernsthof Solar Power Plant',
                'PI Pro.Investor 1 Solarkraftwerk',
                'Unknown',
              ],
              [
                'Germany',
                84,
                'Europe',
                'Eggebek',
                'Schleswig-Flensburg',
                'Unavailable',
                'Eggebek Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Germany',
                31,
                'Europe',
                'Potsdam-Mittelmark',
                'Potsdam-Mittelmark',
                'Unavailable',
                'Briest - Havelsee solar farm',
                'Briest Solar 1 GmbH',
                'MCG Group',
              ],
              [
                'Germany',
                67,
                'Europe',
                'Unavailable',
                'Unstrut-Hainich-Kreis',
                'Unavailable',
                'AMPYR - KlimaVest solar farm',
                'AMPYR Solar Europe',
                'Commerz Real KilmaVest',
              ],
              [
                'Germany',
                31,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Brandenburg-Briest Solar Power Plant',
                'Lux Briest BO GmbH & Co. KG',
                'Luxcara',
              ],
              [
                'Germany',
                400,
                'Europe',
                'Spree-Nei\u00dfe',
                'Spree-Nei\u00dfe',
                'Unavailable',
                'Bohrau Energy Park solar farm',
                'Lausitz Energie Bergbau AG (LEAG)',
                'Lausitz Energie Bergbau AG (LEAG)',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Gro\u00df Kreutz (Havel)',
                'Potsdam-Mittelmark',
                'Unavailable',
                'Bochow solar farm',
                'Belectric',
                'Commerz Real',
              ],
              [
                'Germany',
                32,
                'Europe',
                'Vorpommern-R\u00fcgen',
                'Vorpommern-R\u00fcgen',
                'Unavailable',
                'Barth Solarpark',
                'Solarpark Delphinus GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                300,
                'Europe',
                'Anklam',
                'Vorpommern-Greifswald',
                'Pomerania',
                'Anklam solar farm',
                'Unknown',
                'Anumar',
              ],
              [
                'Germany',
                28,
                'Europe',
                'Anhalt-Bitterfeld',
                'Anhalt-Bitterfeld',
                'Unavailable',
                'Amsdorf solar farm',
                'Unknown',
                'GETEC green energy; ROMONTA group',
              ],
              [
                'Germany',
                67,
                'Europe',
                'Unavailable',
                'Unstrut-Hainich-Kreis',
                'Unavailable',
                'AMPYR - KlimaVest solar farm',
                'AMPYR Solar Europe',
                'Commerz Real KilmaVest',
              ],
              [
                'Germany',
                67,
                'Europe',
                'Unavailable',
                'Unstrut-Hainich-Kreis',
                'Unavailable',
                'AMPYR - KlimaVest solar farm',
                'AMPYR Solar Europe',
                'Commerz Real KilmaVest',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Landkreis Ammerland',
                'Landkreis Ammerland',
                'Unavailable',
                'Ammerland Solarpark',
                'GP Joule',
                'Aquila Capital',
              ],
              [
                'Germany',
                149,
                'Europe',
                'M\u00e4rkisch-Oderland',
                'M\u00e4rkisch-Oderland',
                'Markih-Oderland',
                'Alttrebin Solarpark',
                'EnBW Solar GmbH',
                'EnBW',
              ],
              [
                'Germany',
                68,
                'Europe',
                'Ostprignitz-Ruppin',
                'Ostprignitz-Ruppin',
                'Unavailable',
                'Alt Daber solar farm',
                'Belectric',
                'Unknown',
              ],
              [
                'Germany',
                34,
                'Europe',
                'Landkreis Oldenburg',
                'Landkreis Oldenburg',
                'Unavailable',
                'Ahlhorn Solar Power Plant',
                'CEE group',
                'Unknown',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Finow Solarpark',
                'Unknown',
                'Suntech Power Holdings Co; Solarhybrid AG',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Brandenburg-Briest Solar Power Plant',
                'Lux Briest BO GmbH & Co. KG',
                'Luxcara',
              ],
              [
                'Germany',
                60,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Finow Solarpark',
                'RCP Solarpark Finow GmbH & Co. KG',
                'Suntech Power Holdings Co; Solarhybrid AG',
              ],
              [
                'Germany',
                32,
                'Europe',
                'B\u00fcttel',
                'Kreis Steinburg',
                'Unavailable',
                'B\u00fcttel Solar Power Plant',
                'PV B\u00fcttel GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Finsterwalde',
                'Elbe-Elster',
                'Elbe-Elster',
                'Finsterwalde Solarpark',
                'Q-Cells',
                'DIF Infrastructure (DIF); NIBC European Infrastructure Fund',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Landkreis Bad Kreuznach',
                'Landkreis Bad Kreuznach',
                'Unavailable',
                'Pferdsfeld solar farm',
                'SP Pferdsfeld GmbH&Co.KG; C/o SOPA Verwaltungs GmbH',
                'Unknown',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Ribnitz-Damgarten',
                'Vorpommern-R\u00fcgen',
                'Unavailable',
                'Pugnitz solar farm',
                'WOC Solarparc Puetnitz',
                'Unknown',
              ],
              [
                'Germany',
                23,
                'Europe',
                'Kloster Lehnin',
                'Potsdam-Mittelmark',
                'Unavailable',
                'Reckahn Solar Power Plant',
                'Solarkraftwerk Reckahn I GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Thuringia',
                'Landkreis Schmalkalden-Meiningen',
                'Unavailable',
                'Ronneburg solar farm',
                'German Utility Stawag Energie GmbH',
                'Juwi Group',
              ],
              [
                'Germany',
                20,
                'Europe',
                'G\u00f6rlitz',
                'G\u00f6rlitz',
                'Unavailable',
                'Rothenburg solar farm',
                'Gehrlicher GmbH&Co. Solarpark Rothenburg KG',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Landkreis Neuburg-Schrobenhausen',
                'Landkreis Neuburg-Schrobenhausen',
                'Unavailable',
                'Schornhof Solar',
                'Anumar',
                'Anumar',
              ],
              [
                'Germany',
                22,
                'Europe',
                'Landkreis Neuburg-Schrobenhausen',
                'Landkreis Neuburg-Schrobenhausen',
                'Unavailable',
                'Schornhof Solar',
                'Anumar',
                'Anumar',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Landkreis Neuburg-Schrobenhausen',
                'Landkreis Neuburg-Schrobenhausen',
                'Unavailable',
                'Schornhof Solar',
                'Anumar',
                'Anumar',
              ],
              [
                'Germany',
                57,
                'Europe',
                'Unavailable',
                'Berg im Gau',
                'Unavailable',
                'Schornhof Solar',
                'Anumar',
                'Anumar',
              ],
              [
                'Germany',
                70,
                'Europe',
                'Oberspreewald-Lausitz',
                'Oberspreewald-Lausitz',
                'Unavailable',
                'Senftenberg Joule solar farm',
                'GP Joule',
                'HSH Nordbank; Unlimited Energy GmbH; Luxcara',
              ],
              [
                'Germany',
                39,
                'Europe',
                'Oberspreewald-Lausitz',
                'Oberspreewald-Lausitz',
                'Unavailable',
                'Senftenberg Saferay solar farm',
                'Saferay',
                'Saferay GmbH [66%]',
              ],
              [
                'Germany',
                39,
                'Europe',
                'Oberspreewald-Lausitz',
                'Oberspreewald-Lausitz',
                'Unavailable',
                'Senftenberg Saferay solar farm',
                'Saferay',
                'Saferay GmbH [66%]',
              ],
              [
                'Germany',
                34,
                'Europe',
                'Prignitz',
                'Prignitz',
                'Unavailable',
                'Perleberg Solar',
                'PV Perleberg GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                54,
                'Europe',
                'Landkreis Straubing-Bogen',
                'Landkreis Straubing-Bogen',
                'Unavailable',
                'Strasskirchen solar farm',
                'Umspannwerk Stra\u00dfkirchen GmbH& Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                172,
                'Europe',
                'Ludwigslust-Parchim',
                'Ludwigslust-Parchim',
                'Unavailable',
                'Tramm-G\u00f6then solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Germany',
                51,
                'Europe',
                'Turnow-Preilack',
                'Spree-Nei\u00dfe',
                'Unavailable',
                'Turnow-Preilack Solarpark',
                'Juwi Group',
                'Juwi Group',
              ],
              [
                'Germany',
                25,
                'Europe',
                'Vorpommern-Greifswald',
                'Vorpommern-Greifswald',
                'Unavailable',
                'Tutow Solarpark',
                'Juwi Group',
                'Juwi Group',
              ],
              [
                'Germany',
                52,
                'Europe',
                'Unavailable',
                'Dahme-Spreewald',
                'Dahme-Spreewald',
                'Walddrehna solar farm',
                'Enerparc',
                'Enerparc AG',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Landkreis Leipzig',
                'Landkreis Leipzig',
                'Unavailable',
                'Waldpolenz solar farm',
                'Juwi Group',
                'Juwi Group',
              ],
              [
                'Germany',
                42,
                'Europe',
                'Wasbek',
                'Rendsburg-Eckernf\u00f6rde',
                'Unavailable',
                'Wasbek solar farm',
                'Unknown',
                'Deutsche Bahn; Enerparc AG',
              ],
              [
                'Germany',
                62,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Weesow-Willmersdorf solar farm',
                'EnBW Solarpark Weesow-Willmersdorf GmbH',
                'EnBW',
              ],
              [
                'Germany',
                62,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Weesow-Willmersdorf solar farm',
                'EnBW Solarpark Weesow-Willmersdorf GmbH',
                'EnBW',
              ],
              [
                'Germany',
                63,
                'Europe',
                'Barnim',
                'Barnim',
                'Unavailable',
                'Weesow-Willmersdorf solar farm',
                'EnBW Solarpark Weesow-Willmersdorf GmbH',
                'EnBW',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Mei\u00dfen',
                'Mei\u00dfen',
                'Unavailable',
                'Zeithain solar farm',
                'ENERPARC Solar Invest 120 GmbH',
                'Unknown',
              ],
              [
                'Germany',
                83,
                'Europe',
                'Schwerin',
                'Zietlitz',
                'Unavailable',
                'Zietlitz solar farm',
                'Wemag',
                'Wemag',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Finsterwalde',
                'Elbe-Elster',
                'Elbe-Elster',
                'Finsterwalde Solarpark',
                'Q-Cells',
                'DIF Infrastructure (DIF); NIBC European Infrastructure Fund',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Bautzen',
                'Bautzen',
                'Unavailable',
                'Torno solar farm',
                'Wattner SunAsset Solarkraftwerk 024 GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                145,
                'Europe',
                'M\u00e4rkisch-Oderland',
                'M\u00e4rkisch-Oderland',
                'Unavailable',
                'Neuhardenberg solar farm',
                'Enerparc',
                'Enerparc; Ecos-energy; BaySolar; MEP Asset Management',
              ],
              [
                'Germany',
                128,
                'Europe',
                'Templin',
                'Uckermark',
                'Unavailable',
                'Templin Solarpark',
                'Photovoltaikkraftwerk Gro\u00df D\u00f6lln 1 GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                42,
                'Europe',
                'Mulfingen',
                'Hohenlohekreis',
                'Baden',
                'Mulfingen Solarpark',
                'Unknown',
                'LHI Group',
              ],
              [
                'Germany',
                22,
                'Europe',
                'Lichterfeld-Schacksdorf',
                'Elbe-Elster',
                'Unavailable',
                'Finsterwalde Solarpark',
                'LHI PV SILVINO 1820 GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                22,
                'Europe',
                'Nei\u00dfe-Malxetal',
                'Spree-Nei\u00dfe',
                'Unavailable',
                'Nei\u00dfe-Malxetal Solarpark',
                'Preschen PB Photovoltaik und Grundst\u00fccke GmbH',
                'Unknown',
              ],
              [
                'Germany',
                20,
                'Europe',
                'Finsterwalde',
                'Elbe-Elster',
                'Unavailable',
                'Finsterwalde Solarpark',
                'LHI PV MITAB 1785 GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                35,
                'Europe',
                'Oder-Spree',
                'Oder-Spree',
                'Unavailable',
                'Furstenwalde Solarpark',
                'RCP Solarpark F\u00fcrstenwalde GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                71,
                'Europe',
                'Plau am See',
                'Ludwigslust-Parchim',
                'Unavailable',
                'Gaarz Sunnic solar farm',
                'Enerparc Solar Invest 150 GmbH',
                'Enerparc AG',
              ],
              [
                'Germany',
                27,
                'Europe',
                'Heideblick',
                'Dahme-Spreewald',
                'Unavailable',
                'Gahro Solar Power Plant',
                'Enerparc Solar Invest 150 GmbH',
                'Enerparc AG',
              ],
              [
                'Germany',
                64,
                'Europe',
                'Ludwigslust-Parchim',
                'Ludwigslust-Parchim',
                'Unavailable',
                'Ganzlin Solar Park',
                'MES Solar XXXII GmbH & Co. KG',
                'Clenergy Global Projects Hamburg',
              ],
              [
                'Germany',
                25,
                'Europe',
                'Georgsdorf',
                'Landkreis Grafschaft Bentheim',
                'Unavailable',
                'Georgsdorf Solar',
                'LHI PV Georgsdorf 1986 GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                151,
                'Europe',
                'M\u00e4rkisch-Oderland',
                'M\u00e4rkisch-Oderland',
                'Markih-Oderland',
                'Gottesgabe Solar',
                'EnBW Solar GmbH',
                'Unknown',
              ],
              [
                'Germany',
                31,
                'Europe',
                'G\u00fcstrow',
                'Landkreis Rostock',
                'Unavailable',
                'Gustrow Wirsol solar farm',
                'FP Lux Solar GmbH & Co. G\u00fcstrow KG',
                'Unknown',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Oder-Spree',
                'Oder-Spree',
                'Unavailable',
                'Hyperion Solarpark',
                'Solarpark Hyperion GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                26,
                'Europe',
                'Marienflie\u00df',
                'Prignitz',
                'Unavailable',
                'Jannersdorf Solarpark South',
                'FP Lux Solar GmbH & Co. J\u00e4nnersdorf KG',
                'Unknown',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Landkreis Lichtenfels',
                'Landkreis Lichtenfels',
                'Unavailable',
                'Jura Solarpark',
                'Unknown',
                'IBC Solar',
              ],
              [
                'Germany',
                40,
                'Europe',
                'G\u00f6da',
                'Bautzen',
                'Bautzen',
                'G\u00f6da Solarpark',
                'Anumar',
                'Unknown',
              ],
              [
                'Germany',
                38,
                'Europe',
                'Bautzen',
                'Bautzen',
                'Unavailable',
                'Litten solar farm',
                'Enerparc Solarpark Litten',
                'Unknown',
              ],
              [
                'Germany',
                42,
                'Europe',
                'Unavailable',
                'Landkreis Rostock',
                'Unavailable',
                'Mecklenburg-Vorpommern solar farm',
                'Unknown',
                'Engie; Energiekontor',
              ],
              [
                'Germany',
                50,
                'Europe',
                'Unavailable',
                'Marlow',
                'Vorpommern-R\u00fcgen',
                'Marlow solar farm',
                'Unknown',
                'Energiekontor',
              ],
              [
                'Germany',
                21,
                'Europe',
                'Dahme-Spreewald',
                'Dahme-Spreewald',
                'Unavailable',
                'Luckau Solar Power Plant',
                'FP Lux Solar GmbH & Co. Luckau KG',
                'FP Lux Solar GmbH & Co. Luckau KG',
              ],
              [
                'Germany',
                22,
                'Europe',
                'Elbe-Elster',
                'Elbe-Elster',
                'Unavailable',
                'L\u00f6nnewitz Solarpark',
                'RCP Solarpark L\u00f6nnewitz GmbH & Co. KG',
                'Unknown',
              ],
              [
                'Germany',
                39,
                'Europe',
                'Unavailable',
                'Letschin',
                'M\u00e4rkisch-Oderland',
                'Letschin solar farm',
                'Unknown',
                'Energiekontor',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Walow',
                'Mecklenburgische Seenplatte',
                'Unavailable',
                'Leizen solar farm',
                'Vattenfall Kogel Leizen Solar GmbH',
                'Unknown',
              ],
              [
                'Germany',
                22,
                'Europe',
                'Landkreis Dingolfing-Landau',
                'Landkreis Dingolfing-Landau',
                'Unavailable',
                'Mengkofen Solarpark',
                'Solarparc Deutschland I GmbH & Co. KG',
                'Solarparc Deutschland I GmbH & Co. KG',
              ],
              [
                'Germany',
                25,
                'Europe',
                'Lauta',
                'Bautzen',
                'Bautzen',
                'Lauta Moser solar farm',
                'Moser Baer Clean Energy Limited',
                'Moser Baer Clean Energy Limited',
              ],
              [
                'Germany',
                29,
                'Europe',
                'Lutherstadt Eisleben',
                'Mansfeld-S\u00fcdharz',
                'Unavailable',
                'Krugh\u00fctte solar farm',
                'EPC 42 GmbH & Co. KG',
                'NORD/LB Norddeutsche Landesbank Girozentrale',
              ],
              [
                'Germany',
                24,
                'Europe',
                'Marienflie\u00df',
                'Prignitz',
                'Unavailable',
                'Krempendorf Solarpark',
                'FP Lux Solar GmbH & Co. Krempendorf KG',
                'Unknown',
              ],
              [
                'Germany',
                43,
                'Europe',
                'Anhalt-Bitterfeld',
                'Anhalt-Bitterfeld',
                'Unavailable',
                'K\u00f6then Solar Power Plant',
                'FP Lux Solar GmbH & Co. J\u00e4nnersdorf KG',
                'Unknown',
              ],
              [
                'Germany',
                90,
                'Europe',
                'Klettwitz',
                'Schipkau',
                'Oberspreewald-Lausitz',
                'Klettwitz Solar Park',
                'Unknown',
                'GP Joule; Steinbock EE; Terravent Investments',
              ],
              [
                'Ghana',
                20,
                'Africa',
                'Nante',
                'Kintampo South District',
                'Unavailable',
                'Nante Solar Energy Project',
                'Unknown',
                'Avior Energy Ltd',
              ],
              [
                'Ghana',
                70,
                'Africa',
                'Jema',
                'Kintampo South District',
                'Unavailable',
                'Jema solar farm',
                'Unknown',
                'Avior Energy Ltd',
              ],
              [
                'Ghana',
                400,
                'Africa',
                'Kusawgu',
                'Central Gonja District',
                'Unavailable',
                'Kusawgu solar farm',
                'Unknown',
                'Savanna Solar Ltd.',
              ],
              [
                'Ghana',
                30,
                'Africa',
                'Unavailable',
                'East Gonja Municipal District',
                'Unavailable',
                'Mahe-Obomshai solar farm',
                'Unknown',
                'TFI Company Ltd',
              ],
              [
                'Ghana',
                40,
                'Africa',
                'Nabogu',
                'Savelugu Municipal District',
                'Unavailable',
                'Nabogu solar farm',
                'Unknown',
                'Sada Solargiga Power Company Ltd',
              ],
              [
                'Ghana',
                20,
                'Africa',
                'Gomoa Central District',
                'Gomoa Central District',
                'Unavailable',
                'Gomoa Onyadze solar farm',
                'Beijing Xiaocheng Tech',
                'Meinergy Ghana',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'East Mamprusi Municipal District',
                'East Mamprusi Municipal District',
                'Unavailable',
                'Pwalugu Solar Component',
                'Volta River Authority',
                'Volta River Authority',
              ],
              [
                'Ghana',
                100,
                'Africa',
                'Unavailable',
                'East Gonja Municipal District',
                'Unavailable',
                'Sede solar farm',
                'Unknown',
                'Sun Investment Ltd.',
              ],
              [
                'Ghana',
                100,
                'Africa',
                'Tampion',
                'Nanton District',
                'Unavailable',
                'Tampion solar farm',
                'Unknown',
                'WhiteCap Development Ltd',
              ],
              [
                'Ghana',
                20,
                'Africa',
                'Tamale',
                'Bolgatanga Municipal District',
                'Unavailable',
                'Tamale solar farm',
                'Unknown',
                'Eni',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole',
                'Bole District',
                'Unavailable',
                'Siginik Solar PV Farm',
                'Unknown',
                'Signik Energy Ltd.',
              ],
              [
                'Ghana',
                157,
                'Africa',
                'Prampram',
                'Ningo-Prampram District',
                'Unavailable',
                'Prampram solar farm',
                'Unknown',
                'Energy One Ghana Ltd',
              ],
              [
                'Ghana',
                20,
                'Africa',
                'Gomoa Central District',
                'Gomoa Central District',
                'Unavailable',
                'Bxc Solar Power Station',
                'BXC Ghana Ltd',
                'BXC Ghana Ltd',
              ],
              [
                'Ghana',
                20,
                'Africa',
                'Tilli',
                'Bawku West District',
                'Unavailable',
                'Tilli solar farm',
                'Unknown',
                'Windiga IDC Energy Ltd',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole District',
                'Bole District',
                'Unavailable',
                'Bui Floating solar farm',
                'Bui Power Authority (BPA)',
                'Sinohydro',
              ],
              [
                'Ghana',
                100,
                'Africa',
                'Sankana',
                'East Gonja Municipal District',
                'Unavailable',
                'Nyimbale-Sankana Solar Power Farm',
                'Unknown',
                'Home Energy Africa, Ltd. (HEAfrica)',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole District',
                'Bole District',
                'Unavailable',
                'Bui Floating solar farm',
                'Bui Power Authority (BPA)',
                'Sinohydro',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole District',
                'Bole District',
                'Unavailable',
                'Bui Floating solar farm',
                'Bui Power Authority (BPA)',
                'Sinohydro',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole District',
                'Bole District',
                'Unavailable',
                'Bui Floating solar farm',
                'Bui Power Authority (BPA)',
                'Sinohydro',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Unavailable',
                'Bodi',
                'Unavailable',
                'Bodi solar farm',
                'Unknown',
                'Signik Energy Ltd.',
              ],
              [
                'Ghana',
                100,
                'Africa',
                'Bolgatanga',
                'Bolgatanga Municipal District',
                'Unavailable',
                'Blue Power Energy solar farm',
                'UBI Energy Corporation',
                'UBI Energy Corporation',
              ],
              [
                'Ghana',
                155,
                'Africa',
                'Ellembelle District',
                'Ellembelle District',
                'Unavailable',
                'Nzema solar farm',
                'Unknown',
                'Blue Energy',
              ],
              [
                'Ghana',
                50,
                'Africa',
                'Bole District',
                'Bole District',
                'Unavailable',
                'Bui Floating solar farm',
                'Bui Power Authority (BPA)',
                'Sinohydro',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Umbriaki',
                'Domokos',
                'Phthiotis',
                'Golines (ABO Wind) solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Umbriaki',
                'Domokos',
                'Phthiotis',
                'Golines (ABO Wind) solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                87,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Gelesler Neochorakiou solar farm',
                'Unknown',
                'Palatia Solar Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Municipal Unit of Desfina',
                'Regional Unit of Phocis',
                'Central Greece',
                'Gastres solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                152,
                'Europe',
                'Unavailable',
                'Florina',
                'Florina',
                'Florina Solar Farm',
                'Unknown',
                'Hellenic Petroleum (ELPE)',
              ],
              [
                'Greece',
                152,
                'Europe',
                'Unavailable',
                'Florina',
                'Florina',
                'Florina Solar Farm',
                'Unknown',
                'Hellenic Petroleum (ELPE)',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Exoche solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Exoche solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                44,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Ergane-Amaranta solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                137,
                'Europe',
                'Kozani',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Galaniou solar farm',
                'Unknown',
                'Sole Greko LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Gekas & Mikre Velanidia solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                102,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Damasi solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                47,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Eretria solar farm',
                'Unknown',
                'Idea Phos LLC (Light Idea LLC)',
              ],
              [
                'Greece',
                250,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Chloe solar farm',
                'Unknown',
                'Iviskos Energy Single Member Private Company',
              ],
              [
                'Greece',
                120,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Chromio solar farm',
                'Unknown',
                'Rensol Energy PV Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Umbriaki',
                'Domokos',
                'Phthiotis',
                'Golines (ABO Wind) solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Damasi solar farm',
                'Unknown',
                'Rensol Energy PV Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Daouslar solar farm',
                'Unknown',
                'Exalko LLC Aluminum Industry',
              ],
              [
                'Greece',
                37,
                'Europe',
                'Pella Regional Unit',
                'Pella Regional Unit',
                'Central Macedonia',
                'Dasoktema Rodochoriou solar farm',
                'Unknown',
                'Anax Energy Single Member Private Company',
              ],
              [
                'Greece',
                420,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Dasyllio solar farm',
                'Unknown',
                'Topeiroe Solar Avtheron Single Member Private Company',
              ],
              [
                'Greece',
                249,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kotyli solar farm',
                'Unknown',
                'Idea Phos LLC (Light Idea LLC)',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Demetriou Epselante solar farm',
                'Unknown',
                'Lux North Greece S.A.',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Demetriou Epselante solar farm',
                'Unknown',
                'Lux North Greece S.A.',
              ],
              [
                'Greece',
                21,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Denthra-Chorio solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Eretria solar farm',
                'Unknown',
                'Idea Phos LLC (Light Idea LLC)',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Diakos solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                43,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Chersotopi (Wattcrop ) solar farm',
                'Unknown',
                'Wattcrop Hellas Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kotyle-Vaphiochori solar farm',
                'Unknown',
                'Isitha Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Kotroni solar farm',
                'Unknown',
                'Heliothema Energy LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Kotroni solar farm',
                'Unknown',
                'Heliothema Energy LLC',
              ],
              [
                'Greece',
                67,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Kotroni Kai Amolia solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Domokou Aknas solar farm',
                'Unknown',
                'Consortium Solar Power Systems LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Domouz Dere solar farm',
                'Unknown',
                'Savvas Zapheiratos and Co. Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Dovroutsi solar farm',
                'Unknown',
                'Tyrnavos Power Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Elassona solar farm',
                'Unknown',
                'Airenergy PV Private Company',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Endekaria solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Epereia solar farm',
                'Unknown',
                'Eynatia Group LLC',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Dilopho solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Umbriaki',
                'Domokos',
                'Phthiotis',
                'Golines (ABO Wind) solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Kapnophyto Farm solar farm',
                'Unknown',
                'Metallo Energy Private Company',
              ],
              [
                'Greece',
                22,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Golio Euangelismou solar farm',
                'Unknown',
                'Aetos PV Parayoye 1 Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Kastraki solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Kastraki solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Kastraki solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Municipal Unit of Amphilohia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Kastrakia solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kastro (East Photovoltaics) solar farm',
                'Unknown',
                'East Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kastro (Energy Ventures) solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Kastro Skinos solar farm',
                'Unknown',
                'Vulturnus Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                146,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Kataphyto solar farm',
                'Unknown',
                'Helios Serron LLC',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Municipal Unit of Megalopoli',
                'Arcadia Regional Unit',
                'Peloponnese Region',
                'Katarrachia solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Kato Papadopouli solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                44,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kato Vasilika solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Preveza Regional Unit',
                'Preveza Regional Unit',
                'Epirus',
                'Kato Vlacha solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Kavala-Madria solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                22,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Karliyka (KI Solar 1) solar farm',
                'Unknown',
                'Kl Solar 1 Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kephalovryso solar farm',
                'Unknown',
                'Airenergy PV Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Kleithion solar farm',
                'Unknown',
                'ABO Wind Energy Greece',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Ioannina Regional Unit',
                'Ioannina Regional Unit',
                'Epirus',
                'Klematia Kai Katsouli-Tsoeka solar farm',
                'Unknown',
                'G.E. Perivallontike Energy Engineering',
              ],
              [
                'Greece',
                70,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0398\u03af\u03c3\u03b2\u03b7\u03c2',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Kodeleza solar farm',
                'Unknown',
                'NC Energy Hellas LLC; Intersun Energy; Co. Oe',
              ],
              [
                'Greece',
                70,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0398\u03af\u03c3\u03b2\u03b7\u03c2',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Kodeleza solar farm',
                'Unknown',
                'NC Energy Hellas LLC; Intersun Energy; Co. Oe',
              ],
              [
                'Greece',
                433,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kokartza solar farm',
                'Unknown',
                'Iliako Power 7 Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Koltsida solar farm',
                'Unknown',
                'Solar Exochi Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Kormista solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                255,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Koryphe solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                21,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Koryphodromos Kossou solar farm',
                'Unknown',
                'Idea Epentheseon LLC (Idea Investments LLC)',
              ],
              [
                'Greece',
                72,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Kossos solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                28,
                'Europe',
                'Kastoria Regional Unit',
                'Kastoria Regional Unit',
                'Western Macedonia',
                'Kostaraziou solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kostarazi',
                'Kastoria Regional Unit',
                'Argos Orestiko',
                'Kostaraziou solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Koukodiares solar farm',
                'Unknown',
                'Saison Solair Ena (1) LLC',
              ],
              [
                'Greece',
                55,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Kleithi solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Karliyka (Akuo) solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Karantanale solar farm',
                'Unknown',
                'Epharmoges Peritiou LLC (Silicon Applications LLC)',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Karantanale solar farm',
                'Unknown',
                'Epharmoges Peritiou LLC (Silicon Applications LLC)',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Pieria Regional Unit',
                'Pieria Regional Unit',
                'Central Macedonia',
                'Gomaria solar farm',
                'Unknown',
                'Georgios Ch. Photiou; Co. Ee',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Go\u03cdrnes solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                90,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Gymne Rache solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Gyrtone solar farm',
                'Unknown',
                'EDPR Renewable Energy Sources Greece 2 LLC',
              ],
              [
                'Greece',
                90,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Heliophoto Farm solar farm',
                'Unknown',
                'Survey Belsolar 21 Private Company',
              ],
              [
                'Greece',
                71,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Herakles solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Hersotopi Kilkis solar farm',
                'Unknown',
                'Etaireia Axiopoieses Eliothermikon Sestematon LLC',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Isiomata solar farm',
                'Unknown',
                'Chris PV Private Company',
              ],
              [
                'Greece',
                22,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Isoma - Rothiane solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                62,
                'Europe',
                'Preveza Regional Unit',
                'Preveza Regional Unit',
                'Epirus',
                'Isomata solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                61,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Isomata-Vlachoyiannoe solar farm',
                'Unknown',
                'Vasilikon Solar Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Kabe solar farm',
                'Unknown',
                'Airenergy PV Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Kabes solar farm',
                'Unknown',
                'Proselion Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kabos solar farm',
                'Unknown',
                'Gaiacomm Geotechnical Projects and Measurement Systems LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Kabouria solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Kadephas Vares solar farm',
                'Unknown',
                'Ib Vogt Greece 5 Single Member Private Company',
              ],
              [
                'Greece',
                48,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kalindria solar farm',
                'Unknown',
                'Isitha Energy LLC',
              ],
              [
                'Greece',
                89,
                'Europe',
                'Komotini',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Kalliste solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                250,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kallithea solar farm',
                'Unknown',
                'Qair International',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kalogradiko solar farm',
                'Unknown',
                'Heliothema Energy Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Kaloudi-Paliabela solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kaloyeros Stephani solar farm',
                'Unknown',
                'Central Greece Development 2 Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Kalyvia solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kamara solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Ioannina Regional Unit',
                'Ioannina Regional Unit',
                'Epirus',
                'Kaminia solar farm',
                'Unknown',
                'Aetos PV Parayoye 5 Single Member Private Company',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Municipal Unit of Amfissa',
                'Regional Unit of Phocis',
                'Central Greece',
                'Kanapitsa solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kapnos solar farm',
                'Unknown',
                'Trikala Solar Power Single Member Private Company',
              ],
              [
                'Greece',
                333,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Karachasan-Proselia solar farm',
                'Unknown',
                'M Star Single Member Private Company',
              ],
              [
                'Greece',
                90,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Karakopholia solar farm',
                'Unknown',
                'Metikas Energy Single Member Private Company',
              ],
              [
                'Greece',
                39,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Golines (Voltalia) solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Koukouli solar farm',
                'Unknown',
                'Anthochori Energy Single Member Private Company',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Laconia Regional Unit',
                'Laconia Regional Unit',
                'Peloponnese Region',
                'Xerokabi solar farm',
                'Unknown',
                'Photonotos Energy Monoprosope LLC',
              ],
              [
                'Greece',
                54,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Koulouri solar farm',
                'Unknown',
                'Kastraki Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Municipal Unit of Megara',
                'Regional Unit of West Attica',
                'Attica',
                'Pyrgari solar farm',
                'Unknown',
                'Greece Regional Development for Renewable Energy LLC',
              ],
              [
                'Greece',
                250,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Pylaia solar farm',
                'Unknown',
                'Solar Project Staat Vast I Single Member Private Company',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Ptolemaida Liveron solar farm',
                'Unknown',
                'Lux North Greece S.A.',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Ptelea solar farm',
                'Unknown',
                'North Solar LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Ptelea solar farm',
                'Unknown',
                'North Solar LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Psorotopos solar farm',
                'Unknown',
                'Gilda Energy Private Company',
              ],
              [
                'Greece',
                257,
                'Europe',
                'Phthiotis Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Pselorrache (Voltalia Greece Energy) solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Pyrgoi solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Pselorrache (Baliaga) solar farm',
                'Unknown',
                'Baliaga Private Company',
              ],
              [
                'Greece',
                145,
                'Europe',
                'Municipal Unit of Medeon',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Provatinos Koklyva solar farm',
                'Unknown',
                'Solar Bot Industrial Energy Construction and Trading Company',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Proselion solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Proselio Stethos solar farm',
                'Unknown',
                'Ampelia Solar Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Proselia solar farm',
                'Unknown',
                'Tyrnavos Power Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Pella Regional Unit',
                'Pella Regional Unit',
                'Central Macedonia',
                'Prophetes Helias (Elamar) solar farm',
                'Unknown',
                'Elamar Private Company',
              ],
              [
                'Greece',
                39,
                'Europe',
                'Ioannina Regional Unit',
                'Ioannina Regional Unit',
                'Epirus',
                'Prophetes Helias (Akarnanika Photovoltaika) solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                49,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Prasinada Dasyllio solar farm',
                'Unknown',
                'Meyalo Enethreio Solar Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Pselorrache (Avlagades Energy) solar farm',
                'Unknown',
                'Avlagades Energy Single Member Energy Generation and Sales',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Pournari solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Pyrgoi solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Thesprotia Regional Unit',
                'Thesprotia Regional Unit',
                'Epirus',
                'Rache Stermou solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                700,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Skopia Kallithea solar farm',
                'Unknown',
                'Enipeas Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Arta',
                'Arta Regional Unit',
                'Epirus',
                'Skamnia solar farm',
                'Unknown',
                'Apothekeetike Energy Storage LLC',
              ],
              [
                'Greece',
                42,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0398\u03af\u03c3\u03b2\u03b7\u03c2',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Skala Korynes solar farm',
                'Unknown',
                'Iliovi LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Siatista solar farm',
                'Unknown',
                'EDPR Renewable Energy Sources Greece 2 LLC',
              ],
              [
                'Greece',
                365,
                'Europe',
                'Chalkida',
                'Euboea Regional Unit',
                'Central Greece',
                'Schematari solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                90,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Sapes solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Municipal Unit of Anaktorio',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Saltine solar farm',
                'Unknown',
                'Dalast LLC',
              ],
              [
                'Greece',
                118,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Rache solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Roumanaki Zoothochos Peye solar farm',
                'Unknown',
                'Roemanaki Solar Single Member Private Company',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Rodopole solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                56,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Rodonas solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                59,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Rodina (Voltalia Greece Energy) solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Rodina (Dispatch Renewable) solar farm',
                'Unknown',
                'Dispatch Renewable Energy LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Municipal Unit of Thebes',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Revenia solar farm',
                'Unknown',
                'Thevaikos Helios Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Rachidi solar farm',
                'Unknown',
                'Idea Epentheseon LLC (Idea Investments LLC)',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Thesprotia Regional Unit',
                'Thesprotia Regional Unit',
                'Epirus',
                'Rache Stermou solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                46,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0394\u03b5\u03c1\u03b2\u03b5\u03bd\u03bf\u03c7\u03c9\u03c1\u03af\u03c9\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Rokani solar farm',
                'Unknown',
                'Ecosolar Single Member Private Company',
              ],
              [
                'Greece',
                56,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Skopos (Heliake Autodynamia) solar farm',
                'Unknown',
                'Solar Autonomy of Kozani Single Member Private Company',
              ],
              [
                'Greece',
                52,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u03a0\u03bb\u03b1\u03c4\u03b1\u03b9\u03ce\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Potami Kapareli solar farm',
                'Unknown',
                'Smart Energy Solutions Single Member Private Company',
              ],
              [
                'Greece',
                95,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Polyzaiika (Power Ventures) solar farm',
                'Unknown',
                'Power Ventures 1 Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Pheliki solar farm',
                'Unknown',
                'Energy Stenon Private Company',
              ],
              [
                'Greece',
                55,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Pharangi (Teichio) solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Pharangi (Green Repower) solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Pexari solar farm',
                'Unknown',
                'Ib Vogt Greece 5 Single Member Private Company',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Petroto solar farm',
                'Unknown',
                'Aioliki Desfinas Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Petroto Abelia solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Petrorrache (SkGrPV20) solar farm',
                'Unknown',
                'SKGR PV 20 Private Company',
              ],
              [
                'Greece',
                277,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Phelli solar farm',
                'Unknown',
                'M Star M. Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Petrorrache (Philippiada Energy) solar farm',
                'Unknown',
                'Philippiada Energy Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Petrokalyva solar farm',
                'Unknown',
                'Polethameioe Solar Single Member Private Company',
              ],
              [
                'Greece',
                99,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Petrino (Skouderi Energy) solar farm',
                'Unknown',
                'Skouderi Energy Private Company',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Petrino (Pleiades Energy) solar farm',
                'Unknown',
                'Pleiades Energy Private Company',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Perivlepto solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Perdikkas solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                135,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Perdikkas solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Pente Adelphia (Noctura) solar farm',
                'Unknown',
                'Noctura Single Member Private Company',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Petrorrache (Helio Invest Alpha) solar farm',
                'Unknown',
                'Helios Invest Alpha Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Pontoirakleia',
                'Paionia',
                'Kilkis',
                'Pontoirakleia solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                277,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Phelli solar farm',
                'Unknown',
                'M Star M. Private Company',
              ],
              [
                'Greece',
                78,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Philikia solar farm',
                'Unknown',
                'Solar Rigo Single Member Private Company',
              ],
              [
                'Greece',
                235,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Polyzaiika (Akuo Energy) solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Polyphytos solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Polymylos solar farm',
                'Unknown',
                'North Solar LLC',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Polla Litharia solar farm',
                'Unknown',
                'Heliothema Energy Single Member Private Company',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Podariko solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Plous solar farm',
                'Unknown',
                'Heliothema Energy LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Municipal Unit of Medeon',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Platos (Giga Solar) solar farm',
                'Unknown',
                'Giga Solar Greece LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Pheres solar farm',
                'Unknown',
                'Damco Energy LLC',
              ],
              [
                'Greece',
                90,
                'Europe',
                'Municipal Unit of Amphilohia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Platos (Ch. Rokas) solar farm',
                'Unknown',
                'Ch. Rokas Commercial LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Platanakos Sphaka Kolove solar farm',
                'Unknown',
                'Consortium Solar Power Systems LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Pisokabos solar farm',
                'Unknown',
                'Gaiacomm Geotechnical Projects and Measurement Systems LLC',
              ],
              [
                'Greece',
                309,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Pilalistra solar farm',
                'Unknown',
                'Prasine Heliake Energy Athenas Single Member Private Company (Greene Sun Energy Athens)',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Municipal Unit of Astakos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Phyteies solar farm',
                'Unknown',
                'Eternity Energy Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Phylleion solar farm',
                'Unknown',
                'Sakellariou Vasilike and Co.',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Municipal Unit of Epidavros',
                'Argolis Regional Unit',
                'Peloponnese Region',
                'Phrengkera solar farm',
                'Unknown',
                'Ionike A.T.E.K.E.',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Phonesi solar farm',
                'Unknown',
                'Phoneyi Energy Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Platanos solar farm',
                'Unknown',
                'Enel Green Power Greece',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Skopos (Teichio) solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                77,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Skotoussa solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Solar Arrow solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                250,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Vermio Teke solar farm',
                'Unknown',
                'Iliako Power 5 Single Member Private Company',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Regional Unit of East Attica',
                'Regional Unit of East Attica',
                'Attica',
                'Vatzeli solar farm',
                'Unknown',
                'Ecosolar Single Member Private Company',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Vatsinia Pontines solar farm',
                'Unknown',
                'Aurum 3 Energy Single Member Private Company',
              ],
              [
                'Greece',
                79,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Vathylakkos solar farm',
                'Unknown',
                'Vakoefia Solar Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Vatheia Lakka solar farm',
                'Unknown',
                'Heliothema Energy LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Vasilike solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Vasilika solar farm',
                'Unknown',
                'Vasilikon Solar Single Member Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Vlachas Mnema solar farm',
                'Unknown',
                'Helios Invest Beta Single Member Private Company',
              ],
              [
                'Greece',
                246,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Valanidia solar farm',
                'Unknown',
                'Anax Energy Single Member Private Company',
              ],
              [
                'Greece',
                755,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Vafeiochoriou Farm solar farm',
                'Unknown',
                'Envalue Hellas Sp1 Single Member Private Company',
              ],
              [
                'Greece',
                396,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Tybana solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Tsoukari (Nemesis Energy) solar farm',
                'Unknown',
                'Nemesis Energy Single Member Private Company',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Tsoukari (Enkons Energy) solar farm',
                'Unknown',
                'Enkons Energy Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Tseros solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Tsatali solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Tsairia solar farm',
                'Unknown',
                'Rothopes Apodose Private Company',
              ],
              [
                'Greece',
                241,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Vakouphi solar farm',
                'Unknown',
                'Vakoefia Solar Single Member Private Company',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Trypa solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Volaka Farms solar farm',
                'Unknown',
                'Aurum 4 Energy Single Member Private Company',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Voskesima solar farm',
                'Unknown',
                'SKGR PV 17 Private Company',
              ],
              [
                'Greece',
                51,
                'Europe',
                'Municipal Unit of Amfissa',
                'Regional Unit of Phocis',
                'Central Greece',
                'Xastreria solar farm',
                'Unknown',
                'Phokithas Solar Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Tyrnavos',
                'Tyrnavos',
                'Larissa',
                'Vytha solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Tyrnavos',
                'Tyrnavos',
                'Larissa',
                'Vytha solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                95,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Vrysia solar farm',
                'Unknown',
                'Cp & Mes Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                92,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Vrasteres solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                58,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Vrachos solar farm',
                'Unknown',
                'Roussas LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Vrachos & Manthra solar farm',
                'Unknown',
                'Gaiacomm Geotechnical Projects and Measurement Systems LLC',
              ],
              [
                'Greece',
                84,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Voreios Platanos solar farm',
                'Unknown',
                'Enel Green Power Greece',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Vrachos - Mikre Petra solar farm',
                'Unknown',
                'Gaiacomm Geotechnical Projects and Measurement Systems LLC',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Preveza Regional Unit',
                'Preveza Regional Unit',
                'Epirus',
                'Voydi solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                180,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Vouzi-Dilopho solar farm',
                'Unknown',
                'Elzet Solar Single Member Private Company',
              ],
              [
                'Greece',
                255,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Vouzi (Sustainable Ventures) solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Vouzi (Blue Sky 300) solar farm',
                'Unknown',
                'Blue Sky 300 Energy Single Member Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Vounichora solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Votanochori solar farm',
                'Unknown',
                'Iliako Power 2 Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Voskotopi solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Chalkidiki Regional Unit',
                'Chalkidiki Regional Unit',
                'Central Macedonia',
                'Vrachiolas solar farm',
                'Unknown',
                'Bozonio Real Estate Development LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Municipal Unit of Megalopoli',
                'Arcadia Regional Unit',
                'Peloponnese Region',
                'Tripotamos solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                105,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Trigono Spelaio Krios solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                48,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Trano solar farm',
                'Unknown',
                'Notias Energy Single Member Private Company',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Municipal Unit of Amphilohia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Staikou solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Regional Unit of East Attica',
                'Regional Unit of East Attica',
                'Attica',
                'Spithari solar farm',
                'Unknown',
                'Pleiades Energy Private Company',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Spitha solar farm',
                'Unknown',
                'Skouderi Energy Private Company',
              ],
              [
                'Greece',
                33,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Spelia (Juwi Hellas) solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Spelia (Geiacomm) solar farm',
                'Unknown',
                'Gaiacomm Geotechnical Projects and Measurement Systems LLC',
              ],
              [
                'Greece',
                101,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Spartias solar farm',
                'Unknown',
                'Energy MayneCo.s Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Soultoyiannaiika solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Stauros-Veryiatoudi solar farm',
                'Unknown',
                'Helios Invest Beta Single Member Private Company',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Municipal Unit of Thebes',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Soula Thevon solar farm',
                'Unknown',
                'Icon Energy Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Soteras solar farm',
                'Unknown',
                'PV Soteras',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Municipal Unit of Thebes',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Soros Elaiona solar farm',
                'Unknown',
                'Aeiforos Meletetike Technike Private Company',
              ],
              [
                'Greece',
                217,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Sopho (Sustainable Ventures) solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                285,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Sopho (Sustainable Ventures) solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                251,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Sopho (Sustainable Ventures) solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                106,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Sopho (Green Ventures) solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Sophades solar farm',
                'Unknown',
                'Baliaga Private Company',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Municipal Unit of Thebes',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Soula Thevon solar farm',
                'Unknown',
                'Icon Energy Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Stenolakka solar farm',
                'Unknown',
                'Roussas LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0394\u03b5\u03c1\u03b2\u03b5\u03bd\u03bf\u03c7\u03c9\u03c1\u03af\u03c9\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Stephane solar farm',
                'Unknown',
                'Armonia Energy Single Member Private Company',
              ],
              [
                'Greece',
                215,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Strevadia - Ano Argilochori solar farm',
                'Unknown',
                'Iliako Parko Almiros Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Tragasia solar farm',
                'Unknown',
                'Asa 1 Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Touba solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Touba - Kokkinobara solar farm',
                'Unknown',
                'SKGR PV 14 Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Thymaria-Sykies solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Thiva',
                'Thiva',
                'Boeotia',
                'Thiva solar farm',
                'Unknown',
                'Heliothema Energy SA',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Thetidio solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Thetidio solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Tephlos solar farm',
                'Unknown',
                'Trikala Solar Power Single Member Private Company',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Municipal Unit of Stratos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Technete Limne Stratos solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                103,
                'Europe',
                'Arta Regional Unit',
                'Arta Regional Unit',
                'Epirus',
                'Technete Limne Pournair solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                120,
                'Europe',
                'Municipal Unit of Parakampylia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Technete Limne Kastraki solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Municipal Unit of Parakampylia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Technete Limne (Irida 5) solar farm',
                'Unknown',
                'Irida 5 Private Company',
              ],
              [
                'Greece',
                195,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Tabouri Labrou solar farm',
                'Unknown',
                'Velestino Solar',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Florina',
                'Florina Regional Unit',
                'Western Macedonia',
                'T.K. Protes & T.K. Klathoraches solar farm',
                'Unknown',
                'Kaviros North Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Sykies solar farm',
                'Unknown',
                'Kler Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Municipal Unit of Anaktorio',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Stroses solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Strevadia - Ano Argilochori solar farm',
                'Unknown',
                'Kaviros Central Single Member Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Pente Adelphia (Juwi Hellas) solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Peneiada solar farm',
                'Unknown',
                'EJT Energy Private Company',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Evrotas',
                'Laconia Regional Unit',
                'Laconia',
                'Peloponnese South solar farm',
                'Unknown',
                'EMV Energy Investments SA',
              ],
              [
                'Greece',
                255,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Pegadoulia solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mandria (PV Systems) solar farm',
                'Unknown',
                'PV Systems Single Member Private Company',
              ],
              [
                'Greece',
                128,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Mandres solar farm',
                'Unknown',
                'Pear Agrophotovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mandra (Kastraki Heliake Energy) solar farm',
                'Unknown',
                'Kastraki Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mandra (Iliako Power) solar farm',
                'Unknown',
                'Iliako Power I Single Member Private Company',
              ],
              [
                'Greece',
                24,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0394\u03b5\u03c1\u03b2\u03b5\u03bd\u03bf\u03c7\u03c9\u03c1\u03af\u03c9\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Mallia Kotzia (PV Park) solar farm',
                'Unknown',
                'PV Park Single Member Private Company',
              ],
              [
                'Greece',
                28,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0394\u03b5\u03c1\u03b2\u03b5\u03bd\u03bf\u03c7\u03c9\u03c1\u03af\u03c9\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Mallia Kotzia (Armonia Energy) solar farm',
                'Unknown',
                'Armonia Energy Single Member Private Company',
              ],
              [
                'Greece',
                107,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Makryrrache solar farm',
                'Unknown',
                'Eynatia Group LLC',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mandria (Skouderi Energy ) solar farm',
                'Unknown',
                'Skouderi Energy Private Company',
              ],
              [
                'Greece',
                230,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Makrylakka solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                175,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Magoula-Stathmos solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Magoula Mesiane solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Magoula (Voltalia Greece) solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Magoula (Noctura) solar farm',
                'Unknown',
                'Noctura Single Member Private Company',
              ],
              [
                'Greece',
                43,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Lykorema (Periphereiake) solar farm',
                'Unknown',
                'Greece Regional Development for Renewable Energy LLC',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Lykorema (Energy Ventures) solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Lykopholia solar farm',
                'Unknown',
                'Heliothema Energy LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Municipal Unit of Amphilohia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Makrechoria Amphilochias solar farm',
                'Unknown',
                'Amvrakia Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Municipal Unit of Nafpaktos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Louzes solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mandria Proselio solar farm',
                'Unknown',
                'SKGR PV 19 Private Company',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Maniaki solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Megale Touba (Helios Invest) solar farm',
                'Unknown',
                'Helios Invest Beta Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Grevena Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Megale Europole Pontines solar farm',
                'Unknown',
                'Aurum 3 Energy Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Megala Kalyvia solar farm',
                'Unknown',
                'Blue Elephant Energy',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Pella Regional Unit',
                'Pella Regional Unit',
                'Central Macedonia',
                'Mavrovouni solar farm',
                'Unknown',
                'Prometheas Investments of N. Papathopoelos Co.',
              ],
              [
                'Greece',
                253,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mauroyeies-Pikatouria solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                120,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Maurovouni-Persouphle solar farm',
                'Unknown',
                'Velestino Solar',
              ],
              [
                'Greece',
                181,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Maurovouni (Sustainable Ventures 7) solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                144,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mandria-Karamouzi solar farm',
                'Unknown',
                'North Solar LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Maurovouni (Heliothema Energy) solar farm',
                'Unknown',
                'Heliothema Energy Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Mauroneri solar farm',
                'Unknown',
                'Heliothema Energy Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Maurodendri solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mastos (SkGr PV 13) solar farm',
                'Unknown',
                'SKGR PV 13 Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Mastos (Juwi Hellas) solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Martino solar farm',
                'Unknown',
                'Eynatia Group LLC',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Martino solar farm',
                'Unknown',
                'Eynatia Group LLC',
              ],
              [
                'Greece',
                252,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Mantasia Karachasan solar farm',
                'Unknown',
                'MantaCo. Energy Single Member Private Company',
              ],
              [
                'Greece',
                129,
                'Europe',
                'Pella Regional Unit',
                'Pella Regional Unit',
                'Central Macedonia',
                'Mauropouli solar farm',
                'Unknown',
                'Pellas Solar Single Member Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Loutsi solar farm',
                'Unknown',
                'Elmya Greece 2 Single Member Private Company',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Loutsa solar farm',
                'Unknown',
                'Helioelxis Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Lophoi solar farm',
                'Unknown',
                'Heliothema Energy Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kritsilar solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kritsilar solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kritsilar solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                49,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Krideri solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                109,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Krasia solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kranova-Karadema solar farm',
                'Unknown',
                'Key Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                204,
                'Europe',
                'Unavailable',
                'Kozani (\u039a\u03bf\u03b6\u03ac\u03bd\u03b7)',
                'Kozani (\u039a\u03bf\u03b6\u03ac\u03bd\u03b7)',
                'Kozani (ELPE) solar farm',
                'Unknown',
                'Hellenic Petroleum (ELPE)',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kritsilar solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Koutsocherou & Mandra solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Drama',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Kouthounia solar farm',
                'Unknown',
                'Bozonio Real Estate Development LLC',
              ],
              [
                'Greece',
                300,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kourkoute\u03caka solar farm',
                'Unknown',
                'Baliaga Private Company',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kouphopetra (Smart Energy Solutions) solar farm',
                'Unknown',
                'Smart Energy Solutions Single Member Private Company',
              ],
              [
                'Greece',
                28,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Kouphopetra (North Solar) solar farm',
                'Unknown',
                'North Solar LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larissa',
                'Larisa Regional Unit',
                'Thessaly',
                'Koume solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Zouparno Kabouria solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Preveza Regional Unit',
                'Preveza Regional Unit',
                'Epirus',
                'Xerovaltos solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Municipal Unit of Amfissa',
                'Regional Unit of Phocis',
                'Central Greece',
                'Koutroule Rache solar farm',
                'Unknown',
                'Mes Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kritsilar solar farm',
                'Unknown',
                'Karatzi Industrial and Hotel Enterprises LLC',
              ],
              [
                'Greece',
                55,
                'Europe',
                'Municipal Unit of Megalopoli',
                'Arcadia Regional Unit',
                'Peloponnese Region',
                'Kyparissia solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                255,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Kyparissos solar farm',
                'Unknown',
                'Sunstar Private Company',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Lophario solar farm',
                'Unknown',
                'Otium Energy Private Company',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Ioannina Regional Unit',
                'Ioannina Regional Unit',
                'Epirus',
                'Longouda-Omorphades solar farm',
                'Unknown',
                'Ellaktor LLC',
              ],
              [
                'Greece',
                252,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Longos (Ilos New Energy) solar farm',
                'Unknown',
                'Ilos New Energy Greece Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Longos (Helios Invest Alpha) solar farm',
                'Unknown',
                'Helios Invest Alpha Single Member Private Company',
              ],
              [
                'Greece',
                44,
                'Europe',
                'Larissa',
                'Larisa Regional Unit',
                'Thessaly',
                'Livadeia solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Thesprotia Regional Unit',
                'Thesprotia Regional Unit',
                'Epirus',
                'Lithari-Phlamouria solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Leuka solar farm',
                'Unknown',
                'Nt En Si Energy LLC (DNC Energy LLC)',
              ],
              [
                'Greece',
                42,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Lesterina solar farm',
                'Unknown',
                'Ecosolar Single Member Private Company',
              ],
              [
                'Greece',
                282,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Lekane & Perama solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                44,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Lefkara solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Karditsa Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Lazarina solar farm',
                'Unknown',
                'ABO Wind AG',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Kastoria Regional Unit',
                'Kastoria Regional Unit',
                'Western Macedonia',
                'Lazarakia solar farm',
                'Unknown',
                'Damco Energy LLC',
              ],
              [
                'Greece',
                84,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Lagos solar farm (Greece)',
                'Unknown',
                'Sunfield Solar Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kyriakeika solar farm',
                'Unknown',
                'Spower Energy Projects Single Member Private Company',
              ],
              [
                'Greece',
                31,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kyriakeika solar farm',
                'Unknown',
                'Spower Energy Projects Single Member Private Company',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kyriakeika solar farm',
                'Unknown',
                'Spower Ksirolakos Single Member Private Company',
              ],
              [
                'Greece',
                37,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Kyriakeika solar farm',
                'Unknown',
                'Spower Ksirolakos Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Megale Touba (Juwi Hellas) solar farm',
                'Unknown',
                'Juwi Hellas Energy S.A',
              ],
              [
                'Greece',
                31,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Koukourelia solar farm',
                'Unknown',
                'St. Konstantinos 1 Private Company',
              ],
              [
                'Greece',
                275,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Megalo Monasteri solar farm',
                'Unknown',
                'Central Greece Development 1 Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Merotopos solar farm',
                'Unknown',
                'Topaz Energy 2 Single Member Private Company',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Palatia solar farm',
                'Unknown',
                'New SPES Concept LLC',
              ],
              [
                'Greece',
                85,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Palaiotourko solar farm',
                'Unknown',
                'Iliako Power 6 Single Member Private Company',
              ],
              [
                'Greece',
                72,
                'Europe',
                'Municipal Unit of Galaxidi',
                'Regional Unit of Phocis',
                'Central Greece',
                'Palaiopournara solar farm',
                'Unknown',
                'Phokithas Solar Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Palaiomonasteron solar farm',
                'Unknown',
                'Helios Invest Alpha Single Member Private Company',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Palaiochoria solar farm',
                'Unknown',
                'Savvas Zapheiratos and Co. Energy LLC',
              ],
              [
                'Greece',
                241,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Pachnia solar farm',
                'Unknown',
                'Ecosolar Single Member Private Company',
              ],
              [
                'Greece',
                340,
                'Europe',
                'Municipal Unit of Megalopoli',
                'Arcadia Regional Unit',
                'Peloponnese Region',
                'Orycheio solar farm',
                'Unknown',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                213,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Paliabela Saradaria solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                72,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Orycheio solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                450,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Orycheio solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                311,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Oros Menoikio solar farm',
                'Unknown',
                'Magkna Enerykia Ae',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ntomoez Ntere solar farm',
                'Unknown',
                'Savvas Zapheiratos and Co. Energy LLC',
              ],
              [
                'Greece',
                175,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Notero solar farm',
                'Unknown',
                'Power Ventures 4 Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Chalkidiki Regional Unit',
                'Chalkidiki Regional Unit',
                'Central Macedonia',
                'Nomes solar farm',
                'Unknown',
                'Idea Epentheseon LLC (Idea Investments LLC)',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Nikopole solar farm',
                'Unknown',
                'EDPR Renewable Energy Sources Greece 2 LLC',
              ],
              [
                'Greece',
                82,
                'Europe',
                'Municipal Unit of Astakos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Neradzoula solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                550,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Orycheio solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                460,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Neo Syrakio solar farm',
                'Unknown',
                'Idea Phos LLC (Light Idea LLC)',
              ],
              [
                'Greece',
                130,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Paliabela Vasilorema solar farm',
                'Unknown',
                'Lgr Energy Private Company',
              ],
              [
                'Greece',
                145,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Paliochori solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Pella Regional Unit',
                'Pella Regional Unit',
                'Central Macedonia',
                'Pegadia solar farm',
                'Unknown',
                'Damco Energy LLC',
              ],
              [
                'Greece',
                68,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Patoma solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                48,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Patoma Kai Voulyara solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                54,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Partsaki (Kastraki Heliake Energy) solar farm',
                'Unknown',
                'Kastraki Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Partsaki (Greece Petroleum Renewable) solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kavala Regional Unit',
                'Kavala Regional Unit',
                'Eastern Macedonia and Thrace',
                'Paratereterion solar farm',
                'Unknown',
                'Silicon Construction Works LLC. Of Greece',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Municipal Unit of Medeon',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Paraplago Aetos solar farm',
                'Unknown',
                'Aetos PV Parayoye 1 Single Member Private Company',
              ],
              [
                'Greece',
                56,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Paliabelo Bougazi solar farm',
                'Unknown',
                'Smart Energy Solutions Single Member Private Company',
              ],
              [
                'Greece',
                51,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Papayianne (New Spes Concept) solar farm',
                'Unknown',
                'New SPES Concept LLC',
              ],
              [
                'Greece',
                437,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Panayia-Paliabela solar farm',
                'Unknown',
                'Z Star Single Member Private Company',
              ],
              [
                'Greece',
                39,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Palioyalatas solar farm',
                'Unknown',
                'Roussas LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Paliouroxylo solar farm',
                'Unknown',
                'Meteor Energy Park LLC',
              ],
              [
                'Greece',
                54,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Paliotabouro solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Paliotabouro solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                34,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Paliophtelia solar farm',
                'Unknown',
                'Lgr Energy Private Company',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Paliochoria solar farm',
                'Unknown',
                'Ampelia Solar Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Papayianne (Greece Petroleum Renewable) solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Xerovoeni Psele Rache solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Xerovoeni solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Municipal Unit of Alyzia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Xiromeros solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                45,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Modio solar farm',
                'Unknown',
                'Xanthes Apothose Private Company',
              ],
              [
                'Greece',
                85,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mnhmata solar farm',
                'Unknown',
                'Ampelia Solar Single Member Private Company',
              ],
              [
                'Greece',
                180,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0398\u03af\u03c3\u03b2\u03b7\u03c2',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Misorrache - Ktemata solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Mikrovouni solar farm',
                'Unknown',
                'Helioelxis LLC',
              ],
              [
                'Greece',
                28,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikrotheves Anatolika solar farm',
                'Unknown',
                'Power Ventures 6 Single Member Private Company',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikrotheves Anatolika solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikrotheves Anatolika solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                23,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Monasterakion solar farm',
                'Unknown',
                'Interphoton LLC',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikrotheves Anatolika solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                75,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mikre Yodzalaka solar farm',
                'Unknown',
                'Enel Green Power Greece',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mikre Yodzalaka Kai Petromadria solar farm',
                'Unknown',
                'Enel Green Power Greece',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikra Spitia solar farm',
                'Unknown',
                'Power Ventures 5 Single Member Private Company',
              ],
              [
                'Greece',
                219,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Michalitsi solar farm',
                'Unknown',
                'Kilkis Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Metochi solar farm',
                'Unknown',
                'Nt En Si Energy LLC (DNC Energy LLC)',
              ],
              [
                'Greece',
                115,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Messaio solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Mesiako-Phournia solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                123,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Mikrotheves Anatolika solar farm',
                'Unknown',
                'Green Ventures Single Member Private Company',
              ],
              [
                'Greece',
                92,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Monh Zavordas solar farm',
                'Unknown',
                'Iliako Power 4 Single Member Private Company',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Monopati solar farm',
                'Unknown',
                'Anemopeeko Energy LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Thesprotia Regional Unit',
                'Thesprotia Regional Unit',
                'Epirus',
                'Moutzoura solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Municipal Unit of Alyzia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Xiromeros solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Municipal Unit of Alyzia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Xiromeros solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Municipal Unit of Alyzia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Xiromeros solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                54,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Yeladostroma solar farm',
                'Unknown',
                'Fensol Single Member Private Company',
              ],
              [
                'Greece',
                275,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Yerakli solar farm',
                'Unknown',
                'Sustainable Ventures Single Member Private Company',
              ],
              [
                'Greece',
                103,
                'Europe',
                'Chalkidiki Regional Unit',
                'Chalkidiki Regional Unit',
                'Central Macedonia',
                'Yiangkova solar farm',
                'Unknown',
                'Survey Belsolar 21 Private Company',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Yiarbasi solar farm',
                'Unknown',
                'Kastraki Solar Energy Single Member Private Company',
              ],
              [
                'Greece',
                56,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Yournes Tsoemagias solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                28,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Zagori solar farm',
                'Unknown',
                'Aion Energy 2 Single Member Private Company',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Zarkou solar farm',
                'Unknown',
                'Akarnanika Photovoltaic Systems Private Company',
              ],
              [
                'Greece',
                220,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Zeli (Elmyra Greece 1) solar farm',
                'Unknown',
                'Elmya Greece 1 Single Member Private Company',
              ],
              [
                'Greece',
                120,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Zeli (Geoenergy) solar farm',
                'Unknown',
                'Geoenergy Single Member Private Company',
              ],
              [
                'Greece',
                260,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Zeli (Geoenergy) solar farm',
                'Unknown',
                'Geoenergy Single Member Private Company',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Neo Gynaikokastro solar farm',
                'Unknown',
                'Isitha Energy LLC',
              ],
              [
                'Greece',
                47,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Nees Karyes solar farm',
                'Unknown',
                'Elmya Greece 3 Single Member Private Company',
              ],
              [
                'Greece',
                220,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Nea Nikopole solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                74,
                'Europe',
                'Regional Unit of East Attica',
                'Regional Unit of East Attica',
                'Attica',
                'Mytikas solar farm',
                'Unknown',
                'Smart Energy Solutions Single Member Private Company',
              ],
              [
                'Greece',
                21,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0394\u03b5\u03c1\u03b2\u03b5\u03bd\u03bf\u03c7\u03c9\u03c1\u03af\u03c9\u03bd',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Melies solar farm',
                'Unknown',
                'Smart Energy Solutions Single Member Private Company',
              ],
              [
                'Greece',
                182,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Chersotopi (Isitha Energy) solar farm',
                'Unknown',
                'Isitha Energy LLC',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Bekrevenikos Solar 1 solar farm',
                'Unknown',
                'Solar Project Staat Vast I Single Member Private Company',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Charauye 5 solar farm',
                'Unknown',
                'Diacheirises Ananeosimon Peyon Energy LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Alataria solar farm',
                'Unknown',
                'Intrakat',
              ],
              [
                'Greece',
                280,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Alchani solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Alepotrepes solar farm',
                'Unknown',
                'Anax Energy Single Member Private Company',
              ],
              [
                'Greece',
                120,
                'Europe',
                'Karditsa Regional Unit',
                'Karditsa Regional Unit',
                'Thessaly',
                'Alepotrepes Yelatharia solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Alia solar farm',
                'Unknown',
                'Artemis Solar Farm Single Member LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Alia solar farm',
                'Unknown',
                'Aqmyros Solar Farm Single Member LLC',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Alistrate solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Alistrate solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                58,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Alistrate-Petroto solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Alistrate-Petroto solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Kavala Regional Unit',
                'Kavala Regional Unit',
                'Eastern Macedonia and Thrace',
                'Altinia solar farm',
                'Unknown',
                'Kavalas Apodose Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Municipal Unit of Anaktorio',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Amaderos solar farm',
                'Unknown',
                'Stathmos Amphilochias Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                74,
                'Europe',
                'Larissa',
                'Larisa Regional Unit',
                'Thessaly',
                'Amphithea solar farm',
                'Unknown',
                'Power Ventures 2 Single Member Private Company',
              ],
              [
                'Greece',
                105,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Amydaio solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Anatolikos Kapnos solar farm',
                'Unknown',
                'Trikala Solar Power Single Member Private Company',
              ],
              [
                'Greece',
                69,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Angelochori solar farm',
                'Unknown',
                'Topaz Energy 3 Single Member Private Company',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Ano Aryilochori solar farm',
                'Unknown',
                'Ecosolar Single Member Private Company',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Ano Aryilochori solar farm',
                'Unknown',
                'PV Systems Single Member Private Company',
              ],
              [
                'Greece',
                28,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0391\u03bb\u03b9\u03ac\u03c1\u03c4\u03bf\u03c5',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Ano Dendra solar farm',
                'Unknown',
                'SPES Solaris - Solar Concept LLC',
              ],
              [
                'Greece',
                26,
                'Europe',
                '\u0394\u03b7\u03bc\u03bf\u03c4\u03b9\u03ba\u03ae \u0395\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1 \u0391\u03bb\u03b9\u03ac\u03c1\u03c4\u03bf\u03c5',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Ano Dendra solar farm',
                'Unknown',
                'SPES Solaris - Solar Concept LLC',
              ],
              [
                'Greece',
                69,
                'Europe',
                'Regional Unit of Boeotia',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Cherovouno solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Alataria solar farm',
                'Unknown',
                'Intrakat',
              ],
              [
                'Greece',
                38,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Anthophyto solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Alamana - Vampa - Potamakia solar farm',
                'Unknown',
                'Konsortsioem Solar Power Technical Systems LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Akalypta solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                59,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Abeleia solar farm',
                'Unknown',
                'Idea Phos LLC (Light Idea LLC)',
              ],
              [
                'Greece',
                110,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Abelia - Kokkinochoma solar farm',
                'Unknown',
                'Intrakat',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Abelia solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Thessaloniki Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Abelones solar farm',
                'Unknown',
                'Stathmos Akropotamos Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Thessaloniki Regional Unit',
                'Thessaloniki Regional Unit',
                'Central Macedonia',
                'Abelones solar farm',
                'Unknown',
                'Stathmos Akropotamos Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                234,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Achladochori solar farm',
                'Unknown',
                'Helios Serron LLC',
              ],
              [
                'Greece',
                252,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Achlathia solar farm',
                'Unknown',
                'Eneryeia Eperionas LLC',
              ],
              [
                'Greece',
                200,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Achlathias And Payonerioe Farms solar farm',
                'Unknown',
                'Aurum 4 Energy Single Member Private Company',
              ],
              [
                'Greece',
                32,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Ae Lias solar farm',
                'Unknown',
                'Anthochori Energy Single Member Private Company',
              ],
              [
                'Greece',
                485,
                'Europe',
                'Rodopi Regional Unit',
                'Rodopi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Aetolophos-Chamelo solar farm',
                'Unknown',
                'Rytion Nearchos Single Member Private Company',
              ],
              [
                'Greece',
                43,
                'Europe',
                'Municipal Unit of Amfissa',
                'Regional Unit of Phocis',
                'Central Greece',
                'Aetopholia solar farm',
                'Unknown',
                'Saison Solair Ena (1) LLC',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Aetorache solar farm',
                'Unknown',
                'Iliako Power 3 Single Member Private Company',
              ],
              [
                'Greece',
                135,
                'Europe',
                'Municipal Unit of Astakos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Aetos 5 solar farm',
                'Unknown',
                'Ch. Rokas Commercial LLC',
              ],
              [
                'Greece',
                48,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Aetos solar farm',
                'Unknown',
                'GWEC Vector Voiotia LLC',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Agonon solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Agrelia solar farm',
                'Unknown',
                'Domein Engineering and Construction LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Agrielia solar farm',
                'Unknown',
                'Interphoton LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Agroi (Akuo Energy) solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Agroi (Akuo Energy) solar farm',
                'Unknown',
                'Akuo Energy Greece LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Agroi (Votalia) solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Evros Regional Unit',
                'Evros Regional Unit',
                'Eastern Macedonia and Thrace',
                'Aisyme solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                80,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Akrine solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Anthotopos Achladochorio solar farm',
                'Unknown',
                'SKGR PV 7 Single Member Private Company',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ano Vasilika solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                50,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Anthotopos Kozanis solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                100,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Anthotopos Cha\u03cathemene solar farm',
                'Unknown',
                'Pear Agrophotovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Ayios Christophoros solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayios Konstantinos solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                29,
                'Europe',
                'Drama Regional Unit',
                'Drama Regional Unit',
                'Eastern Macedonia and Thrace',
                'Ayios Lazaros Ayroktematos Petroesas solar farm',
                'Unknown',
                'Idea Phos 2 LLC (Light Idea 2 LLC)',
              ],
              [
                'Greece',
                217,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayios Nikolaos Kai Koryphe solar farm',
                'Unknown',
                'Voltalia Greece Reneable Energy Company LLC',
              ],
              [
                'Greece',
                37,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Ayios Panteleemon-Soteros solar farm',
                'Unknown',
                'Perenas Photovoltaics Single Member Private Company',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Kilkis Regional Unit',
                'Kilkis Regional Unit',
                'Central Macedonia',
                'Bagi solar farm',
                'Unknown',
                'Ellaktor LLC',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Basit solar farm',
                'Unknown',
                'Roussas LLC',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Regional Unit of Magnesia',
                'Regional Unit of Magnesia',
                'Thessaly',
                'Batzia Bechloule solar farm',
                'Unknown',
                'Enel Green Power Greece',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Bekrevenikos solar farm',
                'Unknown',
                'Teichio Private Company',
              ],
              [
                'Greece',
                21,
                'Europe',
                'Phthiotis Regional Unit',
                'Phthiotis Regional Unit',
                'Central Greece',
                'Bisbiloula solar farm',
                'Unknown',
                'Avlaki Ii Solar Farm Single Member LLC',
              ],
              [
                'Greece',
                51,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Bouba solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Bouba solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Trikala Regional Unit',
                'Trikala Regional Unit',
                'Thessaly',
                'Bouba solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                30,
                'Europe',
                'Municipal Unit of Astakos',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Boustria Aetos solar farm',
                'Unknown',
                'Aetos PV Parayoye 3 Single Member Private Company',
              ],
              [
                'Greece',
                55,
                'Europe',
                'Grevena Regional Unit',
                'Grevena Regional Unit',
                'Western Macedonia',
                'Boyia Petra & Chalikia solar farm',
                'Unknown',
                'Windkraft Energy Single Member Private Company',
              ],
              [
                'Greece',
                70,
                'Europe',
                'Imathia Regional Unit',
                'Imathia Regional Unit',
                'Central Macedonia',
                'Castets solar farm',
                'Unknown',
                'Aiolos Makethonias Energy LLC',
              ],
              [
                'Greece',
                27,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Chalikia (Elpe Larko) solar farm',
                'Unknown',
                'Elpe Larko Energy Service LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Chalikia (Greece Petroleum Renewable) solar farm',
                'Unknown',
                'Greece Petroleum Renewable Energy LLC',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Chara - Ayios Konstantinos solar farm',
                'Unknown',
                'Renewables Valorem Hellas LLC',
              ],
              [
                'Greece',
                36,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Charauye 1 solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Ayioi Anaryeroi solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Ayioi Anaryeroi solar farm',
                'Unknown',
                'D.E.H. Renewable Public Power Corporation LLC',
              ],
              [
                'Greece',
                52,
                'Europe',
                'Municipal Unit of Inofyta',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Ayios Athanasios solar farm',
                'Unknown',
                'Armonia Energy Single Member Private Company',
              ],
              [
                'Greece',
                55,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                53,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Apla solar farm',
                'Unknown',
                'Green Repower Photovoltaic Single Member Private Company',
              ],
              [
                'Greece',
                115,
                'Europe',
                'Municipal Unit of Alyzia',
                'Aetolia-Acarnania Regional Unit',
                'Western Greece',
                'Archontochori solar farm',
                'Unknown',
                'Kler Private Company',
              ],
              [
                'Greece',
                39,
                'Europe',
                'Municipal Unit of Megalopoli',
                'Arcadia Regional Unit',
                'Peloponnese Region',
                'Arkadikos Helios solar farm',
                'GEK Terna',
                'PPC Renewables SA',
              ],
              [
                'Greece',
                390,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Aryeromelos solar farm',
                'Unknown',
                'Energy Ventures Single Member Private Company',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Aryeropoeleio solar farm',
                'Unknown',
                'Rensol Energy PV Private Company',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Kozani Regional Unit',
                'Kozani Regional Unit',
                'Western Macedonia',
                'Aryilos solar farm',
                'Unknown',
                'Cantreva Renewable Energy Sources LLC',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Municipal Unit of Inofyta',
                'Regional Unit of Boeotia',
                'Central Greece',
                'Asopia solar farm',
                'Masdar-Taaleri Generation (MTG)',
                'Masdar-Taaleri Generation (MTG)',
              ],
              [
                'Greece',
                60,
                'Europe',
                'Florina Regional Unit',
                'Florina Regional Unit',
                'Western Macedonia',
                'Aspre Petra solar farm',
                'Unknown',
                'Green Repower Single Member Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                24,
                'Europe',
                'Serres Regional Unit',
                'Serres Regional Unit',
                'Central Macedonia',
                'Asvestorema solar farm',
                'Unknown',
                'Notias Energy Single Member Private Company',
              ],
              [
                'Greece',
                65,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Astare solar farm',
                'Unknown',
                'Asa Energy Investments Private Company',
              ],
              [
                'Greece',
                28,
                'Europe',
                'Xanthi Regional Unit',
                'Xanthi Regional Unit',
                'Eastern Macedonia and Thrace',
                'Ayele solar farm',
                'Unknown',
                'Idea Epentheseon LLC (Idea Investments LLC)',
              ],
              [
                'Greece',
                46,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Paraskeve solar farm',
                'Unknown',
                'Renpro Private Company',
              ],
              [
                'Greece',
                20,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                150,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                26,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                64,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                25,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                35,
                'Europe',
                'Larisa Regional Unit',
                'Larisa Regional Unit',
                'Thessaly',
                'Ayia Triada solar farm',
                'Unknown',
                'Terna Energy Commercial Technical Company LLC',
              ],
              [
                'Greece',
                40,
                'Europe',
                'Kastoria Regional Unit',
                'Kastoria Regional Unit',
                'Western Macedonia',
                'Aulos solar farm',
                'Unknown',
                'SKGR PV 11 Single Member Private Company',
              ],
              [
                'Guam',
                60,
                'Oceania',
                'Malojloj-Dandan',
                'Inal\u00e5han',
                'Unavailable',
                'Malojloj Solar Farm',
                'Unknown',
                'Hanwha Energy',
              ],
              [
                'Guam',
                60,
                'Oceania',
                'Mangilao Municipality',
                'Mangilao Municipality',
                'Unavailable',
                'Mangilao solar farm',
                'Unknown',
                'Korea Electric Power Corp. (KEPCO)',
              ],
              [
                'Guam',
                25,
                'Oceania',
                'S\u00e5nta Rita-Sumai Municipality',
                'S\u00e5nta Rita-Sumai Municipality',
                'Unavailable',
                'Navy Base Guam Solar Farm',
                'Unknown',
                'Engie',
              ],
              [
                'Guam',
                25,
                'Oceania',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'South Finegayan solar farm',
                'Unknown',
                'Engie',
              ],
              [
                'Guam',
                40,
                'Oceania',
                'Inal\u00e5han Municipality',
                'Inal\u00e5han Municipality',
                'Unavailable',
                'Dandan Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Guam',
                26,
                'Oceania',
                'Inal\u00e5han Municipality',
                'Inal\u00e5han Municipality',
                'Unavailable',
                'Dandan Solar Farm',
                'GlidePath Power Solutions LLC',
                'GlidePath Power Solutions LLC',
              ],
              [
                'Guatemala',
                58,
                'Central America and the Caribbean',
                'Chiquimulilla',
                'Chiquimulilla',
                'Unavailable',
                'Horus Energy PV Solar Plant',
                'Enertis Solar',
                'Enertis Solar',
              ],
              [
                'Guatemala',
                35,
                'Central America and the Caribbean',
                'Chiquimulilla',
                'Chiquimulilla',
                'Unavailable',
                'Horus Energy PV Solar Plant',
                'Enertis Solar',
                'Enertis Solar',
              ],
              [
                'Guinea',
                41,
                'Africa',
                'Bok\u00e9',
                'Unavailable',
                'Bok\u00e9 Prefecture',
                'Kamsar solar farm',
                'Unknown',
                'ClearnPower Generation; Frontier Investment Management ApS',
              ],
              [
                'Guinea',
                41,
                'Africa',
                'Kamsar',
                'Unavailable',
                'Bok\u00e9 Prefecture',
                'Kamsar solar farm',
                'Unknown',
                'ClearnPower Generation; Frontier Investment Management ApS',
              ],
              [
                'Guinea',
                40,
                'Africa',
                'Linsan',
                'Unavailable',
                'Unavailable',
                'Khoumagueli solar farm',
                'InfraCo Africa; Solv\u00e9o Energie S.A.S; Solv\u00e9o International Investments SARL',
                'InfraCo Africa; Solv\u00e9o Energie S.A.S; Solv\u00e9o International Investments SARL',
              ],
              [
                'Guinea-Bissau',
                20,
                'Africa',
                'Gardete',
                'Unavailable',
                'Unavailable',
                'Gardete solar farm',
                'Unknown',
                'Sinohydro',
              ],
              [
                'Haiti',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Cap Haitien',
                'Arrondissement de Cap-Ha\u00eftien',
                'Cap-Ha\u00eftien solar farm',
                'General Electricity of Haiti (EDH)',
                'Unknown',
              ],
              [
                'Haiti',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Gonaives',
                'Gona\u00efves solar farm',
                'General Electricity of Haiti (EDH)',
                'Unknown',
              ],
              [
                'Haiti',
                50,
                'Central America and the Caribbean',
                'Unavailable',
                'Port-au-Prince',
                'Unavailable',
                'Port-Au-Prince solar farm',
                'General Electricity of Haiti (EDH)',
                'Unknown',
              ],
              [
                'Holy See',
                100,
                'Europe',
                'Santa Maria di Galeria',
                'Roma Capitale',
                'Unavailable',
                'Vatican solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Holy See',
                100,
                'Europe',
                'Rome',
                'Roma Capitale',
                'Unavailable',
                'S Maria Di Galeria solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Honduras',
                60,
                'Central America and the Caribbean',
                'Nacaome',
                'Nacaome',
                'Nacaome',
                'Agua Fr\u00eda Solar Power Plant',
                'Scatec',
                'Scatec',
              ],
              [
                'Honduras',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Quimist\u00e1n',
                'Naco',
                'Los Pollitos solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Honduras',
                35,
                'Central America and the Caribbean',
                'Choluteca',
                'Unavailable',
                'Unavailable',
                'Choluteca Solar Plant',
                'Multi Investment Corporation (CMI)',
                'Multi Investment Corporation (CMI)',
              ],
              [
                'Honduras',
                42,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Marcovia Solar Plant',
                'Gestamp Solar',
                'Gestamp Solar',
              ],
              [
                'Honduras',
                25,
                'Central America and the Caribbean',
                'Unavailable',
                'Santa Luc\u00eda',
                'Santa Lucia',
                'Mecanismos De Energia Renovable (Mecer) Solar PV Plant',
                'Grupo Terra',
                'Grupo Terra',
              ],
              [
                'Honduras',
                61,
                'Central America and the Caribbean',
                'Choluteca',
                'Unavailable',
                'El Carrizo',
                'Aura Solar Project',
                'Isolux Cors\u00e1n',
                'Gauss Energia',
              ],
              [
                'Honduras',
                70,
                'Central America and the Caribbean',
                'Nacaome',
                'Nacaome',
                'Nacaome',
                'Nacaome Photovoltaic Solar Power Plant',
                'Compa\u00f1\u00eda Hondure\u00f1a de Energ\u00eda Solar (COHESSA)',
                'Compa\u00f1\u00eda Hondure\u00f1a de Energ\u00eda Solar (COHESSA); Solar Power',
              ],
              [
                'Honduras',
                70,
                'Central America and the Caribbean',
                'Nacaome',
                'Nacaome',
                'Nacaome',
                'Nacaome Photovoltaic Solar Power Plant',
                'Compa\u00f1\u00eda Hondure\u00f1a de Energ\u00eda Solar (COHESSA)',
                'Compa\u00f1\u00eda Hondure\u00f1a de Energ\u00eda Solar (COHESSA); Solar Power',
              ],
              [
                'Honduras',
                25,
                'Central America and the Caribbean',
                'Nacaome',
                'Nacaome',
                'Unavailable',
                'Pacific Solar Energy PV Plant',
                'Pacific Solar Energy; S.A. de C.V.',
                'Pacific Solar Energy; S.A. de C.V.',
              ],
              [
                'Honduras',
                35,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Namasigue',
                'Los Prados Solar Project',
                'Scatec',
                'Scatec',
              ],
              [
                'Honduras',
                25,
                'Central America and the Caribbean',
                'Nacaome',
                'Nacaome',
                'Unavailable',
                'Pacific Solar Energy PV Plant',
                'Pacific Solar Energy; S.A. de C.V.',
                'Pacific Solar Energy; S.A. de C.V.',
              ],
              [
                'Honduras',
                24,
                'Central America and the Caribbean',
                'San Lorenzo',
                'San Lorenzo',
                'Unavailable',
                'Pavana Solar Park',
                'Energia Basica S.A.',
                'Energia Basica S.A.',
              ],
              [
                'Honduras',
                20,
                'Central America and the Caribbean',
                'Choluteca',
                'Unavailable',
                'Unavailable',
                'El Pacifico Solar Plant',
                'Sistemas Fotovoltaicos de Honduras (Fotersa)',
                'Multi Investment Corporation (CMI)',
              ],
              [
                'Honduras',
                25,
                'Central America and the Caribbean',
                'Choluteca',
                'Unavailable',
                'Unavailable',
                'Del Sur solar farm',
                'First Solar',
                'Grupo Terra',
              ],
              [
                'Honduras',
                35,
                'Central America and the Caribbean',
                'Choluteca',
                'Unavailable',
                'Unavailable',
                'Choluteca Solar Plant',
                'Multi Investment Corporation (CMI)',
                'Multi Investment Corporation (CMI)',
              ],
              [
                'Hong Kong',
                116,
                'Asia',
                'Chok Ko Wan Tsui',
                'Tsuen Wan District',
                'Tuen Mun',
                "Penny's Bay solar farm",
                'Impact Energy Development Limited',
                'Impact Electrons Siam Co., Ltd',
              ],
              [
                'Hong Kong',
                85,
                'Asia',
                'Lung Kwu Sheung Tan',
                'Tuen Mun District',
                'Tuen Mun',
                'Black Point solar farm',
                'Impact Energy Development Limited',
                'Impact Electrons Siam Co., Ltd',
              ],
              [
                'Hong Kong',
                29,
                'Asia',
                'Lung Tsai',
                'Tuen Mun District',
                'Tuen Mun',
                'Castle Peak solar farm',
                'Impact Energy Development Limited',
                'Impact Electrons Siam Co., Ltd',
              ],
              [
                'Hungary',
                21,
                'Europe',
                'Paks',
                'Tolna',
                'Unavailable',
                'Paks solar farm',
                'Unknown',
                'MVM Group',
              ],
              [
                'Hungary',
                20,
                'Europe',
                'M\u00e1travereb\u00e9ly',
                'N\u00f3gr\u00e1d',
                'Unavailable',
                'M\u00e1travereb\u00e9ly solar farm',
                'Unknown',
                'Greentechnic Hungary Kft.',
              ],
              [
                'Hungary',
                25,
                'Europe',
                'Kapuv\u00e1r',
                'Gyor-Moson-Sopron',
                'Unavailable',
                'Kapuv\u00e1r solar farm',
                'Unknown',
                'Enlight Renewable Energy',
              ],
              [
                'Hungary',
                100,
                'Europe',
                'Kaposv\u00e1r',
                'Somogy',
                'Unavailable',
                'Kaposv\u00e1r solar farm',
                'Unknown',
                'Genertec',
              ],
              [
                'Hungary',
                43,
                'Europe',
                'Kaba',
                'Hajd\u00fa-Bihar',
                'Unavailable',
                'Kabai solar farm',
                'IBC Solar',
                'MET Group',
              ],
              [
                'Hungary',
                20,
                'Europe',
                'Halmajugra',
                'Heves',
                'Unavailable',
                'Halmajugra solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Hungary',
                20,
                'Europe',
                'Fels\u0151zsolca',
                'Borsod-Aba\u00faj-Zempl\u00e9n',
                'Unavailable',
                'Fels\u0151zsolca solar farm',
                'Unknown',
                'MVM Group',
              ],
              [
                'Hungary',
                20,
                'Europe',
                'B\u00e1tonyterenye',
                'Nograd',
                'Unavailable',
                'B\u00e1tonyterenye solar farm',
                'Unknown',
                'Greentechnic Hungary Kft.',
              ],
              [
                'Hungary',
                20,
                'Europe',
                'B\u00fckk\u00e1br\u00e1ny',
                'Borsod-Aba\u00faj-Zempl\u00e9n',
                'Unavailable',
                'B\u00fckk\u00e1br\u00e1ny solar farm',
                'Unknown',
                'MVM Matra Energia Zrt.',
              ],
              [
                'Hungary',
                24,
                'Europe',
                'Bocf\u00f6lde',
                'Zala',
                'Unavailable',
                'Bocf\u00f6lde solar farm',
                'Unknown',
                'Greentechnic Hungary Kft.',
              ],
              [
                'Hungary',
                21,
                'Europe',
                'Sz\u00e1zhalombatta',
                'Pest',
                'Unavailable',
                'Dunai solar farm',
                'Unknown',
                'MOL Energy Trade (MET) Group',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                250,
                'Asia',
                'Gurh Tahsil',
                'Gurh Tahsil',
                'Rewa',
                'Rewa Ultra Mega Solar Power Project',
                'Unknown',
                'Mahindra Renewables',
              ],
              [
                'India',
                250,
                'Asia',
                'Gurh Tahsil',
                'Gurh Tahsil',
                'Rewa',
                'Rewa Ultra Mega Solar Power Project',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Rajgarh',
                'Rajgarh',
                'Rajgarh solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                162,
                'Asia',
                'Unavailable',
                'Manasa Tehsil',
                'Neemuch',
                'Neemuch solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                250,
                'Asia',
                'Gurh Tahsil',
                'Gurh Tahsil',
                'Rewa',
                'Rewa Ultra Mega Solar Power Project',
                'Unknown',
                'Arinsun Clean Energy',
              ],
              [
                'India',
                51,
                'Asia',
                'Unavailable',
                'Ashoknagar',
                'Ashok Nagar',
                'MP Solar 2 solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                450,
                'Asia',
                'Unavailable',
                'Harsud Tahsil',
                'Khandwa',
                'Masaya solar farm',
                'Unknown',
                'UPC Renewables; AC Energy',
              ],
              [
                'India',
                24,
                'Asia',
                'Mandsaur',
                'Shamgarh Tahsil',
                'Mandsaur',
                'Mandsaur (Virescent) II solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                22,
                'Asia',
                'Mandsaur',
                'Shamgarh Tahsil',
                'Mandsaur',
                'Mandsaur (Virescent) I solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Mandsaur',
                'Mandsaur',
                'Mandsaur (NTPC) solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                100,
                'Asia',
                'Mandhata',
                'Shamshabad Tahsil',
                'Khnadwa',
                'Omkareshwar Floating Solar Park',
                'Unknown',
                'RUMSL',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Sheopur',
                'Sheopur',
                'Sheopur solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                38,
                'Asia',
                'Unavailable',
                'Talwandi Sabo',
                'Bathinda',
                'Talwandi Sabo solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                130,
                'Asia',
                'Jawad Tehsil',
                'Jawad Tehsil',
                'Neemuch',
                'Welspun Solar Plant',
                'Unknown',
                'Welspun Energy',
              ],
              [
                'India',
                169,
                'Asia',
                'Muktainagar',
                'Muktainagar (Edlabad)',
                'Jalgaon',
                'Muktainagar solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Maan',
                'Satara',
                'Palaswade (Tata) I solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Maan',
                'Satara',
                'Palaswade (Tata) II solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Manwath',
                'Parbhani',
                'Parbhani (Essel) I solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Manwath',
                'Parbhani',
                'Parbhani (Essel) II solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                58,
                'Asia',
                'Unavailable',
                'Manwath',
                'Parbhani',
                'Parbhani (Renew) solar farm',
                'Renew Power',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Mhasale',
                'Dhule',
                'Mhasale solar farm',
                'Unknown',
                'Orange Renewable',
              ],
              [
                'India',
                27,
                'Asia',
                'Parbhani',
                'Manwath',
                'Parbhani',
                'Parbhani (Technique) solar farm',
                'Unknown',
                'Technique Solaire',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Holenaras',
                'Bangalore Urban',
                'Holenaras solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Hiriyur',
                'Hiriyuru taluk',
                'Chitradurga district',
                'Hiriyur solar farm',
                'Siemens',
                'Atria Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Hanegol',
                'Bangalore Urban',
                'Hanegol solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                20,
                'Asia',
                'Gubbi',
                'Gubbi taluk',
                'Tumkur district',
                'Gubbi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Gokak',
                'Belgaum district',
                'Gokak solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Gadag',
                'Gadag district',
                'Gadag solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Honnali',
                'Davanagere District',
                'Honnali solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Solapur South',
                'Solapur South',
                'Solapur',
                'Mandrup solar farm',
                'Unknown',
                'Enrich Energy',
              ],
              [
                'India',
                195,
                'Asia',
                'Unavailable',
                'Haveli',
                'Unavailable',
                'Maharashtra 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Kombhalne',
                'Ahmednagar',
                'Kombhalne solar farm',
                'Unknown',
                'Bhageria Industries Limited',
              ],
              [
                'India',
                350,
                'Asia',
                'Unavailable',
                'Haveli',
                'Unavailable',
                'Avaada Maharashtra Solar Park',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                52,
                'Asia',
                'Unavailable',
                'Baramati',
                'Unavailable',
                'Baramati solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Khuldabad',
                'Beed',
                'Beed solar farm',
                'Unknown',
                'Solar Edge Power and Energy',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Khuldabad',
                'Beed',
                'Beed solar farm',
                'Unknown',
                'Solar Edge Power and Energy',
              ],
              [
                'India',
                80,
                'Asia',
                'Unavailable',
                'Jalgaon',
                'Jalgaon',
                'Chalisgaon (Avaada) solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                67,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Beed',
                'Chatgaon Maharashtra 1 solar farm',
                'Unknown',
                'SolarArise',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Sakri',
                'Dhule',
                'Dhule solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                42,
                'Asia',
                'Dongargaon',
                'Bhiwapur Taluka',
                'Nagpur',
                'Dongargaon solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Bhamer',
                'Sakri',
                'Dhule',
                'Gale (CLP) solar farm',
                'Unknown',
                'CLP [60%]; CDPQ [40%]',
              ],
              [
                'India',
                108,
                'Asia',
                'Unavailable',
                'Jalgaon',
                'Jalgaon',
                'Jalgaon (Avaada) solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Jalgaon',
                'Jalgaon',
                'Jalgaon (Solar Edge) solar farm',
                'Unknown',
                'Solar Edge Power and Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Akkalkot',
                'Akkalkot',
                'Solapur',
                'Karajagi solar farm',
                'Unknown',
                'Enrich Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Katol',
                'Nagpur',
                'Katol (Vector) I solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Katol',
                'Nagpur',
                'Katol (Vector) II solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Kilaj',
                'Haveli',
                'Unavailable',
                'Kilaj solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                180,
                'Asia',
                'Unavailable',
                'Huzur Tahsil',
                'Bhopal',
                'Shivapuri solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                135,
                'Asia',
                'Chalisgaon',
                'Khuldabad',
                'Aurangabad',
                'Chalisgaon (Jbm) solar farm',
                'Unknown',
                'JBM Group',
              ],
              [
                'India',
                56,
                'Asia',
                'Bhander',
                'Bhander Tahsil',
                'Datia',
                'Bhander solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                200,
                'Asia',
                'Shajapur Tahsil',
                'Shajapur Tahsil',
                'Shajapur',
                'Madhya Pradesh I solar farm',
                'Unknown',
                'SolarArise',
              ],
              [
                'India',
                250,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Fortum) solar farm',
                'Unknown',
                'Fortum Solar',
              ],
              [
                'India',
                100,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Fortum) solar farm',
                'Unknown',
                'Fortum Solar',
              ],
              [
                'India',
                300,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Ayana) solar farm',
                'Unknown',
                'Ayana Renewable Power',
              ],
              [
                'India',
                300,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Avaada) solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                125,
                'Asia',
                'Sakri',
                'Sakri',
                'Dhule',
                'Sakri solar farm',
                'Unknown',
                'MAHAGENCO',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Satara',
                'Satara',
                'Satara solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                100,
                'Asia',
                'Solapur',
                'Solapur North',
                'Solapur',
                'Solapur Netmagic solar farm',
                'Unknown',
                'Netmagic; TATA Power',
              ],
              [
                'India',
                23,
                'Asia',
                'Unavailable',
                'Solapur',
                'Solapur',
                'Solapur solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                138,
                'Asia',
                'Unavailable',
                'Haveli',
                'Unavailable',
                'Suvaan solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                20,
                'Asia',
                'Bhamer',
                'Sakri',
                'Dhule',
                'Tornado (CLP) solar farm',
                'Unknown',
                'CLP [60%]; CDPQ [40%]',
              ],
              [
                'India',
                30,
                'Asia',
                'Tuljapur',
                'Tuljapur',
                'Osmanabad',
                'Tuljapur solar farm',
                'Unknown',
                'AMP Energy India; Cipla',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Solapur North',
                'Solapur',
                'Wagdari solar farm',
                'Lightsource Renewable Energy',
                'Lightsource Renewable Energy',
              ],
              [
                'India',
                22,
                'Asia',
                'Unavailable',
                'Haveli',
                'Unavailable',
                'Welspun Energy Maharashtra solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Saltek',
                'Mawal',
                'Unavailable',
                'Gale (UPC) solar farm',
                'Unknown',
                'UPC Renewables',
              ],
              [
                'India',
                20,
                'Asia',
                'Saltek',
                'Mawal',
                'Unavailable',
                'Tornado (UPC) solar farm',
                'Unknown',
                'UPC Renewables',
              ],
              [
                'India',
                20,
                'Asia',
                'Jalukie',
                'Jalukie',
                'Peren',
                'Jalukie (Halo) solar farm',
                'Unknown',
                'Halo Energie',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Balangir',
                'Balangir',
                'Balangir solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Junagarh',
                'Kalahandi',
                'Kalahandi solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Manamunda',
                'Baudh Sadar',
                'Boudh',
                'Manamunda solar farm',
                'Unknown',
                'Green Energy Development Corporation of Odisha',
              ],
              [
                'India',
                27,
                'Asia',
                'Unavailable',
                'Kesinga',
                'Kalahandi',
                'Sadipalli solar farm',
                'Unknown',
                'IBC Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Dhenkanal Sadar',
                'Sambalpur',
                'Sambalpur solar farm',
                'Unknown',
                'Mahanadi Coalfields',
              ],
              [
                'India',
                30,
                'Asia',
                'Sikuan',
                'Khariar',
                'Nuapada',
                'Sikuan solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                25,
                'Asia',
                'Balran',
                'Moonak Tahsil',
                'Sangrur',
                'Balran solar farm',
                'Mytrah Energy',
                'Mytrah Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Bareta',
                'Budhlada Tahsil',
                'Mansa',
                'Bareta solar farm',
                'Mytrah Energy',
                'Mytrah Energy',
              ],
              [
                'India',
                100,
                'Asia',
                'Bhatinda',
                'Bathinda Tahsil',
                'Bathinda',
                'Bhatinda (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                32,
                'Asia',
                'Bhatinda',
                'Bathinda Tahsil',
                'Bathinda',
                'Bhatinda (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                34,
                'Asia',
                'Lambi',
                'Malout Tahsil',
                'Sri Muktsar Sahib District',
                'Lambi solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Budhlada Tahsil',
                'Mansa',
                'Mansa (Vector) I solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Budhlada Tahsil',
                'Mansa',
                'Mansa (Vector) II solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                300,
                'Asia',
                'Pavagada taluk',
                'Pavagada taluk',
                'Tumkur district',
                'Pavagada (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Shamgarh Tahsil',
                'Agar',
                'Malwa (Vector) solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                150,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Yarrow) solar farm',
                'Unknown',
                'Yarrow Infrastructure',
              ],
              [
                'India',
                25,
                'Asia',
                'Khilchipur',
                'Khilchipur Tahsil',
                'Rajgarh',
                'Khilchipur Solar Power Plant',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Ichhawar',
                'Ichhawar Tahsil',
                'Sehore',
                'Ichhawar solar farm',
                'Unknown',
                'Waree Renewables',
              ],
              [
                'India',
                32,
                'Asia',
                'Goyalkhedi',
                'Huzur Tahsil',
                'Bhopal',
                'Goyalkhedi solar farm',
                'Unknown',
                'Hero Future Energies',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Eklara',
                'Bangalore Urban',
                'Eklara solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                34,
                'Asia',
                'Bhander',
                'Bhander Tahsil',
                'Datia',
                'Bhander solar farm',
                'Unknown',
                'Essel Green Energy',
              ],
              [
                'India',
                24,
                'Asia',
                'Alot',
                'Alot Tahsil',
                'Nagda',
                'Alot solar farm',
                'Unknown',
                'Juwi',
              ],
              [
                'India',
                20,
                'Asia',
                'Phyang',
                'Leh Tehsil',
                'Leh district',
                'Phyang Solar Farrm',
                'Unknown',
                'SECI',
              ],
              [
                'India',
                10000,
                'Asia',
                'Leh',
                'Nubra',
                'Ladakh',
                'Ladakh Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'India',
                92,
                'Asia',
                'Unavailable',
                'Kayamkulam',
                'Alappuzha',
                'Kayamkulam solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Kannur',
                'Kasargod',
                'Kasargod solar farm',
                'Unknown',
                'THDC',
              ],
              [
                'India',
                80,
                'Asia',
                'Unavailable',
                'Jetsar',
                'Kollam',
                'Jetsar solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Yadgir',
                'Yadagiri district',
                'Yadgir solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                350,
                'Asia',
                'Yetnal',
                'Bangalore East',
                'Bangalore Urban',
                'Wardha solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Wadgera',
                'Yadagiri district',
                'Wadgera solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Hindaun Tehsil',
                'Vijaypura',
                'Vijaypura (Adani) III solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Hindaun Tehsil',
                'Vijaypura',
                'Vijaypura (Adani) II solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Hindaun Tehsil',
                'Vijaypura',
                'Vijaypura (Adani) I solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Turuvekere',
                'Tumkur district',
                'Turuvekere solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Tipatturu',
                'Bangalore East',
                'Bangalore Urban',
                'Tipatturu solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Siruguppa',
                'Bellary district',
                'Siruguppa solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Siddapur',
                'Vijayapura taluk',
                'Vijayapura',
                'Siddapur PSEPL solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Ramnagar',
                'Bangalore East',
                'Bangalore Urban',
                'Ramnagar solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Ramakoppa solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                36,
                'Asia',
                'Unavailable',
                'Rayachuru taluku',
                'Raichur',
                'Raichur solar farm',
                'Unknown',
                'Oriano',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Raichur',
                'Raichur district',
                'Raichur (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                29,
                'Asia',
                'Unavailable',
                'Rayachuru taluku',
                'Raichur',
                'Raichur (Hero) solar farm',
                'Unknown',
                'Hero Future Energies',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Rayachuru taluku',
                'Raichur',
                'Raichur (Acma) solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Periyapatti',
                'Bangalore Urban',
                'Periyapatti solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                90,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavgada (Greenko) solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                50,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (Vector) solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Duvdurga',
                'Bangalore Urban',
                'Devdurga solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                150,
                'Asia',
                'Tadpatri',
                'Tadpatri',
                'Ananthapuramu',
                'Ananthapuramu (APGENCO) Ultra Mega Solar Park',
                'Unknown',
                'APGENCO',
              ],
              [
                'India',
                23,
                'Asia',
                'Unavailable',
                'Chitradurga taluku',
                'Chitradurga',
                'Chitradurga (Atria) solar farm',
                'Unknown',
                'Atria Power',
              ],
              [
                'India',
                363,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'Gujarat 2 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                87,
                'Asia',
                'Surat',
                'Majura Taluka',
                'Surat',
                'Gensu Solar Power Plant',
                'Unknown',
                'Torrent Power',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Dhuvaran',
                'Anand District',
                'Dhuvaran solar farm',
                'Unknown',
                'Gujarat State Electricity Corporation Limited',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Dhuvaran',
                'Anand District',
                'Dhuvaran solar farm',
                'Unknown',
                'Gujarat State Electricity Corporation Limited',
              ],
              [
                'India',
                4000,
                'Asia',
                'Dholera',
                'Dholera Taluka',
                'Ahmedabad District',
                'Dholera Solar Park',
                'Unknown',
                'SECI',
              ],
              [
                'India',
                1000,
                'Asia',
                'Dholera',
                'Dholera Taluka',
                'Ahmedabad District',
                'Dholera Solar Park',
                'Unknown',
                'GUVN',
              ],
              [
                'India',
                20,
                'Asia',
                'Daisar',
                'Patan Veraval Taluka',
                'Patan',
                'Daisar solar farm',
                'PLG',
                'PLG',
              ],
              [
                'India',
                20,
                'Asia',
                'Dahisar',
                'Halol Taluka',
                'Panch Mahal District',
                'Dahisar solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                51,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Torrent) Solar Park',
                'Torrent Power',
                'Torrent Power',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (SEI Solar) Solar Park',
                'SEI Solar Power',
                'SEI Solar Power',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Roha) Solar Park',
                'Roha Dychem Pvt Ltd',
                'Roha Dychem',
              ],
              [
                'India',
                40,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Orange) Solar Park',
                'Orange Charanka Solar Energy Pvt Ltd',
                'Orange Renewable',
              ],
              [
                'India',
                50,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Kindle) Solar Park',
                'Kindle Energy & Construction Pvt Ltd',
                'Kindle Energy & Construction Pvt Ltd',
              ],
              [
                'India',
                20,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Hinduja) Solar Park',
                'Hinduja Renewables',
                'Hinduja Renewables',
              ],
              [
                'India',
                53,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'Charanka (Greenko) solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (GMR) Solar Park',
                'GMR',
                'GMR',
              ],
              [
                'India',
                75,
                'Asia',
                'Charanka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (GIPCL) Solar Park',
                'Unknown',
                'Gujarat Industrial Power Corporation Limited',
              ],
              [
                'India',
                40,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (GIPCL) Solar Park',
                'Gujarat Industrial Power Corporation Limited',
                'Gujarat Industrial Power Corporation Limited',
              ],
              [
                'India',
                40,
                'Asia',
                'Charanka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (GIPCL) Solar Park',
                'Gujarat Industrial Power Corporation Limited',
                'Gujarat Industrial Power Corporation Limited',
              ],
              [
                'India',
                20,
                'Asia',
                'Charanka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Gacl) Solar Park',
                'Gujarat Alkaline and Chemicals Limited',
                'Gujarat Alkaline and Chemicals Limited',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Astra) Solar Park',
                'Astra Solren Pvt Ltd',
                'Astra Solren Pvt Ltd',
              ],
              [
                'India',
                40,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Astra) Solar Park',
                'Astra Solren Pvt Ltd',
                'Astra Solren Pvt Ltd',
              ],
              [
                'India',
                25,
                'Asia',
                'Santalpur Taluka',
                'Santalpur Taluka',
                'Patan',
                'Charanka (Alex Astral) Solar Park',
                'Alex Astral Power Pvt Ltd',
                'Alex Astral Power Pvt Ltd',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Chandarva',
                'Botad',
                'Chandarva solar farm',
                'Unknown',
                'Gujarat State Electricity Corporation Limited',
              ],
              [
                'India',
                40,
                'Asia',
                'Bitta',
                'Abdasa Taluka',
                'Kutch District',
                'Bitta solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Amreshwar',
                'Panch Mahal District',
                'Amreshwar solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Durg Tahsil',
                'Durg',
                'Tata Chhattisgarh solar farm',
                'Unknown',
                'SECi',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'Gujarat Mizuho solar farm',
                'Unknown',
                'Mizuho Financial',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'GUVNL Dholera solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                105,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'GUVNL solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Jhanor Gandhar',
                'Bharuch District',
                'Jhanor Gandhar solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Vav Taluka',
                'Banaskantha',
                'Raghanesda (Satluj Jal Vidyut) Solar Park',
                'Unknown',
                'Satluj Jal Vidyut Nigam Limited',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Vav Taluka',
                'Banaskantha',
                'Raghanesda (Tata) Solar Park',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                120,
                'Asia',
                'Unavailable',
                'Palanpur Taluka',
                'Banaskantha',
                'Sprng Ujjvala Energy solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Surendranagar',
                'Surendranagar District',
                'Surendranagar (Avaada) solar farm',
                'Avaada',
                'Avaada',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Dhrangadhra Taluka',
                'Surendranagar',
                'Surendranagar (Samta) solar farm',
                'Unknown',
                'Samta Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Dhrangadhra Taluka',
                'Surendranagar',
                'Surendranagar (Talma) solar farm',
                'Unknown',
                'Talma Chemical Industries',
              ],
              [
                'India',
                150,
                'Asia',
                'Unavailable',
                'Halol Taluka',
                'Panch Mahal District',
                'Torrent Gujarat solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                22,
                'Asia',
                'Unavailable',
                'Golmuri-Cum-Jugsalai',
                'Jamshedpur',
                'Jamshedpur solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Aland',
                'Kalaburagi district',
                'Aland solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Babaleshwar',
                'Vijayapura district',
                'Babaleshwar solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bagewadi',
                'Vujayapura',
                'Bagewadi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bailhongal',
                'Belgaum district',
                'Bailhongal solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                90,
                'Asia',
                'Unavailable',
                'Banavikal',
                'Bangalore Urban',
                'Banavikal solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                40,
                'Asia',
                'Basavana Bagewadi',
                'Bijapur',
                'Vijayapura district',
                'Basavana Bagewadi solar farm',
                'Unknown',
                'Atria Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Raigarh',
                'Raigarh District',
                'Raigarh solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bhalki',
                'Bidar district',
                'Bhalki solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                42,
                'Asia',
                'Vijayapura taluk',
                'Vijayapura taluk',
                'Bijapur district',
                'Bijapur solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bilagi',
                'Bagalkote district',
                'Bilagi solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Byadagi',
                'Byadagi taluk',
                'Haveri district',
                'Byadagi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Chandragutti solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                20,
                'Asia',
                'Channapatanna',
                'Bangalore East',
                'Bangalore Urban',
                'Channapatanna solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Vav Taluka',
                'Banaskantha',
                'Raghanesda (GSECL) Solar Park',
                'Unknown',
                'Gujarat State Electricity Corporation Limited',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Vav Taluka',
                'Banaskantha',
                'Raghanesda (GIPCL) Solar Park',
                'Unknown',
                'Gujarat Industrial Power Corporation Limited',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Vav Taluka',
                'Banaskantha',
                'Raghanesda (Electro Solaire) Solar Park',
                'Unknown',
                'Electro Solaire Private Limited',
              ],
              [
                'India',
                70,
                'Asia',
                'Unavailable',
                'Kodinar Taluka',
                'Amreli',
                'Paryapt solar farm',
                'Unknown',
                'UPC Renewables; AC Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Mithapur',
                'Okhamandal Taluka',
                'Devbhumi Dwaraka District',
                'Mithapur solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                4750,
                'Asia',
                'Khavada',
                'Bhuj Taluka',
                'Kutch',
                'Kutch (NTPC) Solar Park',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                150,
                'Asia',
                'Unavailable',
                'Bhuj Taluka',
                'Kutch',
                'Kutch (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                100,
                'Asia',
                'Khirasara',
                'Bhuj',
                'Jutch',
                'Khirasara solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                56,
                'Asia',
                'Unavailable',
                'Kawas',
                'Surat',
                'Kawas solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Koppala taluku',
                'Bidar',
                'Bidar solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Durga',
                'Balod',
                'Durga PSEPL solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                44,
                'Asia',
                'Unavailable',
                'Gaya Town C.D.Block',
                'Gaya',
                'Gaya solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                65,
                'Asia',
                'Unavailable',
                'Golaghat',
                'Golaghat',
                'Assam 1 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Inkollu',
                'Chhitoor',
                'Chhittoor solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                39,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Arushi solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                150,
                'Asia',
                'Tadipatri',
                'Tadpatri',
                'Ananthapuramu',
                'APGENCO solar farm',
                'Vikram Solar',
                'APGENCO',
              ],
              [
                'India',
                50,
                'Asia',
                'Tadipatri',
                'Tadpatri',
                'Ananthapuramu',
                'APGENCO solar farm',
                'Vikram Solar',
                'APGENCO',
              ],
              [
                'India',
                59,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Andhra Pradesh 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                130,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Andhra Pradesh 2 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Andhra Pradesh 1 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Galiveedu',
                'Galiveedu',
                'YSR District',
                'Ananthapuramu (Tata) Ultra Mega Solar Park',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                54,
                'Asia',
                'NP Kunta',
                'Nambulipulikunta',
                'Ananthpuramu',
                'Ananthapuramu (Sprng) Ultra Mega Solar Park',
                'Sprng Energy',
                'Sprng Energy',
              ],
              [
                'India',
                76,
                'Asia',
                'NP Kunta',
                'Nambulipulikunta',
                'Ananthpuramu',
                'Ananthapuramu (Sprng) Ultra Mega Solar Park',
                'Sprng Energy',
                'Sprng Energy',
              ],
              [
                'India',
                98,
                'Asia',
                'NP Kunta',
                'Nambulipulikunta',
                'Ananthpuramu',
                'Ananthapuramu (Sprng) Ultra Mega Solar Park',
                'Sprng Energy',
                'Sprng Energy',
              ],
              [
                'India',
                238,
                'Asia',
                'NP Kunta',
                'Nambulipulikunta',
                'Ananthpuramu',
                'Ananthapuramu (SB Energy) Ultra Mega Solar Park',
                'SB Energy',
                'SB Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Galiveedu',
                'Galiveedu',
                'YSR District',
                'Ananthapuramu (FRV) Ultra Mega Solar Park',
                'Unknown',
                'FRV',
              ],
              [
                'India',
                50,
                'Asia',
                'Galiveedu',
                'Galiveedu',
                'YSR District',
                'Ananthapuramu (FRV) Ultra Mega Solar Park',
                'Unknown',
                'FRV',
              ],
              [
                'India',
                21,
                'Asia',
                'Unavailable',
                'Cumbum',
                'Prakasam',
                'Cumbum solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Nambulipulikunta',
                'Nambulipulikunta',
                'Sri Sathya Sai',
                'Ananthapuramu (Azure) Ultra Mega Solar Park',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Nambulipulikunta',
                'Nambulipulikunta',
                'Sri Sathya Sai',
                'Ananthapuramu (Ayana) Ultra Mega Solar Park',
                'Ayana Renewable Power',
                'Ayana Renewable Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Nambulipulikunta',
                'Nambulipulikunta',
                'Sri Sathya Sai',
                'Ananthapuramu (Ayana) Ultra Mega Solar Park',
                'Ayana Renewable Power',
                'Ayana Renewable Power',
              ],
              [
                'India',
                21,
                'Asia',
                'Budhlada Tahsil',
                'Budhlada Tahsil',
                'Mansa',
                'Mansa solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                250,
                'Asia',
                'Tadpatri',
                'Tadpatri',
                'Ananthapuramu',
                'Ananthapuramu (APGENCO) Ultra Mega Solar Park',
                'Unknown',
                'APGENCO',
              ],
              [
                'India',
                50,
                'Asia',
                'Galiveedu',
                'Galiveedu',
                'YSR District',
                'Ananthapuramu (ACME) Ultra Mega Solar Park',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Galiveedu',
                'Galiveedu',
                'YSR District',
                'Ananthapuramu (ACME) Ultra Mega Solar Park',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Ananthapuram',
                'Chittoor',
                'Ananthapuram solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Chittoor',
                'Ananthapuram',
                'Anantapur Solar Park',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Madanapalle',
                'Anantpur',
                'Anantapur solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                39,
                'Asia',
                'Unavailable',
                'Adoni',
                'Kurnool',
                'Adoni solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Attampahad',
                'Port Blair Tehsil',
                'South Andaman District',
                'Attampahad solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                40,
                'Asia',
                'Yelaburga taluku',
                'Yelaburga taluku',
                'Koppal district',
                'Chikkoppa Karnataka 1 solar farm',
                'Unknown',
                'SolarArise',
              ],
              [
                'India',
                20,
                'Asia',
                'Chincholi',
                'Kalaburagi taluku',
                'Gulbarga',
                'Chincholi (Ekilaide) solar farm',
                'Unknown',
                'Ekialde Solar Private Limited',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Chincholi',
                'Kalaburagi district',
                'Chincholi (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Nambulipulikunta',
                'Nambulipulikunta',
                'Sri Sathya Sai',
                'Ananthapuramu (Ayana) Ultra Mega Solar Park',
                'Ayana Renewable Power',
                'Ayana Renewable Power',
              ],
              [
                'India',
                66,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Chitradurga (Greenko) solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                350,
                'Asia',
                'Unavailable',
                'Kurnool',
                'Kurnool',
                'Ghani Sakunala Solar Park',
                'Unknown',
                'SB Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Guramkonda',
                'Jammalamadugu',
                'YSR',
                'Guramkonda solar farm',
                'Unknown',
                'Waree Renewables',
              ],
              [
                'India',
                32,
                'Asia',
                'Unavailable',
                'Golaghat',
                'Golaghat',
                'Assam 1 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Tugguparthy',
                'Pamidi',
                'Anantapur',
                'Tugguparthy (Energon) solar farm',
                'Unknown',
                'Energon Power Resources',
              ],
              [
                'India',
                23,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Sriram solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Chinthakommadinne',
                'Kadapa',
                'Sprng Soura Kiran solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                250,
                'Asia',
                'NP Kunta',
                'Bathalapalle',
                'Ananthapuram',
                'Sprng Agnitra solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Paravada',
                'Paravada',
                'Anakapalli',
                'Simhadri solar farm',
                'Unknown',
                'BHEL',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Simhadri Floating',
                'YSR',
                'Simhadri Floating solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                1000,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Rudrasamudram Ultra Mega Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'India',
                33,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Rain Coke solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Pungunuru',
                'YSR',
                'Pungunuru solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Pattikonda',
                'Pattikonda',
                'Pattikonda (ACME) III solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Pattikonda',
                'Pattikonda',
                'Pattikonda (ACME) II solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Pattikonda',
                'Pattikonda',
                'Pattikonda (ACME) I solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Pamidi',
                'Madanapalle',
                'Anantpur',
                'Pamidi solar farm',
                'Unknown',
                'MEIL Green Power Limited',
              ],
              [
                'India',
                41,
                'Asia',
                'Unavailable',
                'Jammalamadugu',
                'YSR',
                'Greenflash solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                25,
                'Asia',
                'Nagari',
                'Nagari',
                'Chittoor',
                'Nagari solar farm',
                'Unknown',
                'Waree Renewables',
              ],
              [
                'India',
                100,
                'Asia',
                'Orvakal',
                'Gadivemula',
                'Nandyal',
                'Kurnool (SBG Cleantech) Ultra Mega Solar Park',
                'Unknown',
                'SBG Cleantech ProjectCo Private Limited',
              ],
              [
                'India',
                182,
                'Asia',
                'Orvakal',
                'Gadivemula',
                'Nandyal',
                'Kurnool (SBG Cleantech) Ultra Mega Solar Park',
                'Unknown',
                'SBG Cleantech ProjectCo Private Limited',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Kurnool',
                'Kurnool',
                'Kurnool (Renew) solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Orvakal',
                'Kurnool',
                'Kurnool (Prayatna) Ultra Mega Solar Park',
                'Unknown',
                'Prayatna Developers Private Limited',
              ],
              [
                'India',
                816,
                'Asia',
                'Orvakal',
                'Orvakal',
                'Kurnool District',
                'Kurnool (Greenko) Ultra Mega Solar Park',
                'Greenko Group',
                'Greenko Group',
              ],
              [
                'India',
                50,
                'Asia',
                'Gadivemula',
                'Gadivemula',
                'Nandyal',
                'Kurnool (Azure) Ultra Mega Solar Park',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Gadivemula',
                'Gadivemula',
                'Nandyal',
                'Kurnool (Azure) Ultra Mega Solar Park',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Gadivemula',
                'Gadivemula',
                'Nandyal',
                'Kurnool (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Mylavaram',
                'Kadapa',
                'Kadapa (Sprng) Ultra Mega Solar Park',
                'Unknown',
                'Sprng Soura Kiran Vidyut',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Mylavaram',
                'Kadapa',
                'Kadapa (SB Energy) Ultra Mega Solar Park',
                'Unknown',
                'SB Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Mylavaram',
                'Kadapa',
                'Kadapa (Engie) Ultra Mega Solar Park',
                'Unknown',
                'Engie',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Mylavaram',
                'Kadapa',
                'Kadapa (Engie) Ultra Mega Solar Park',
                'Unknown',
                'Engie',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Mylavaram',
                'Kadapa',
                'Kadapa (Ayana) Ultra Mega Solar Park',
                'Unknown',
                'Ayana Renewable Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Hindupur',
                'Anantpur',
                'Hundupur Solar Park',
                'Unknown',
                'First Solar',
              ],
              [
                'India',
                68,
                'Asia',
                'Unavailable',
                'Orvakal',
                'Kurnool',
                'Kurnool (SBG Cleantech) Ultra Mega Solar Park',
                'Unknown',
                'SBG Cleantech ProjectCo Private Limited',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sahibzada Ajit Singh Nagar',
                'Punjab 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Phalodi',
                'Jaisalmer Tehsil',
                'Jaisalmer',
                'Phalodi (Corporate Ispat) solar farm',
                'Unknown',
                'Corporate Ispat Alloys',
              ],
              [
                'India',
                52,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sahibzada Ajit Singh Nagar',
                'Punjab 4 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Sadasivpet',
                'Medak',
                'Sadashivpet (ACME) solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                24,
                'Asia',
                'Kondapur mandal',
                'Kondapur mandal',
                'Sangareddy',
                'Sadashivpet (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Siddipet',
                'Siddipet',
                'Siddipet (Hero) solar farm',
                'Unknown',
                'Hero Future Energies',
              ],
              [
                'India',
                50,
                'Asia',
                'Siddipet',
                'Medak mandal',
                'Medak',
                'Siddipet (Skypower) solar farm',
                'Unknown',
                'Skypower Holdings',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Skypower Telengana solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                34,
                'Asia',
                'Unavailable',
                'Chittiyala',
                'Kamareddy',
                'Sprng Suryoday Energy solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Muthyalampally',
                'Mahabubnagar',
                'Sprng Transform Sun Energy solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                22,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Sriram - Telangana solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                50,
                'Asia',
                'Marpalle mandal',
                'Sadasivpet mandal',
                'Sangareddy',
                'Sterling & Wilson (Adani) I solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Marpalle mandal',
                'Sadasivpet mandal',
                'Sangareddy',
                'Sterling & Wilson (Adani) II solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                45,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Sunbrone solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Gandipet mandal',
                'Rangareddy South',
                'Rangareddy solar farm',
                'CLP [60%]; CDPQ [40%]',
                'CLP [60%]; CDPQ [40%]',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Tandur',
                'Kamareddy',
                'Tandur solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                65,
                'Asia',
                'Pulkal mandal',
                'Pulkal mandal',
                'Sangareddy',
                'TS Minpoor solar farm',
                'Unknown',
                'Vena Energy',
              ],
              [
                'India',
                130,
                'Asia',
                'Munipally mandal',
                'Munipally mandal',
                'Sangareddy',
                'TS solar farm',
                'Unknown',
                'Vena Energy',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Veltoor solar farm',
                'Unknown',
                'CLP [60%]; CDPQ [40%]',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Narmetta mandal',
                'Wanarparthy',
                'Wanarparthy (Sprng) solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                39,
                'Asia',
                'Yellandu',
                'Yellandu mandal',
                'Bhadradri Kothagudem',
                'Yellandu solar farm',
                'Unknown',
                'Singareni Collieries Company Limited',
              ],
              [
                'India',
                100,
                'Asia',
                'Zahirabad mandal',
                'Zahirabad mandal',
                'Sangareddy',
                'Zaheerabad solar farm',
                'Unknown',
                'Enrich Energy',
              ],
              [
                'India',
                74,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Zuka solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Auraiya',
                'Auraiya',
                'Auraiya I solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Auraiya',
                'Auraiya',
                'Auraiya II solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                225,
                'Asia',
                'Unavailable',
                'Bilhaur',
                'Kanpur Nagar',
                'Bilhaur solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Chitrakoot',
                'Chitrakoot',
                'Chitrakoot (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                128,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Telangana 1 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Ramagundam',
                'Ramagundam mandal',
                'Peddapalli',
                'Ramagundam (Singareni) solar farm',
                'Unknown',
                'Singareni Collieries Company Limited',
              ],
              [
                'India',
                52,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sahibzada Ajit Singh Nagar',
                'Punjab 4 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                38,
                'Asia',
                'Unavailable',
                'Ramagundam Floating',
                'Medchal\u2013Malkajgiri',
                'Ramagundam (NTPC) I solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Tiruchchir\u0101ppalli',
                'Trichy',
                'Trichy solar farm',
                'Walwhan Renewable Energy Limited',
                'TATA Power',
              ],
              [
                'India',
                28,
                'Asia',
                'Unavailable',
                'Virudhunagar',
                'Virudhunagar District',
                'Virudhunagar (TN Solar) solar farm',
                'TN Solar Power-Energy',
                'TN Solar Power Energy',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Virudhunagar',
                'Virudhunagar District',
                'Virudhunagar (Universal) solar farm',
                'Universal Mine Developers and Service Providers',
                'Universal Mine Developers and Service Providers',
              ],
              [
                'India',
                143,
                'Asia',
                'Unavailable',
                'Dichipally',
                'Mahabubnagar',
                'Dichipally solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Mahbubnagar',
                'Mahabubnagar',
                'Mahbubnagar (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Mahbubnagar',
                'Mahabubnagar',
                'Mahbubnagar (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                48,
                'Asia',
                'Unavailable',
                'Mandamarri',
                'Mahabubnagar',
                'Mandamarri (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                65,
                'Asia',
                'Unavailable',
                'Minpur',
                'Mahabubnagar',
                'Minpur solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Mulkanoor',
                'Mahabubnagar',
                'Mulkanoor solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Wanaparthy',
                'Mahabubnagar',
                'Wanarpathy (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Ipparturu',
                'Medchal\u2013Malkajgiri',
                'Ipparturu solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                70,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Jilesh solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                22,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Karvy solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                37,
                'Asia',
                'Kothagudern',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'Kothagudern solar farm',
                'Unknown',
                'Singareni Collieries Company Limited',
              ],
              [
                'India',
                22,
                'Asia',
                'Kalwakurthy mandal',
                'Kalwakurthy mandal',
                'Nagarkurnool',
                'Mahbubnagar (Rays) solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                50,
                'Asia',
                'Mallapur',
                'Uppal mandal',
                'Medchal\u2013Malkajgiri',
                'Mallapur solar farm',
                'CLP [60%]; CDPQ [40%]',
                'CLP [60%]; CDPQ [40%]',
              ],
              [
                'India',
                28,
                'Asia',
                'Mandamarri',
                'Mandamarri mandal',
                'Mancherial',
                'Mandamarri (Singareni) solar farm',
                'Unknown',
                'Singareni Collieries Company Limited',
              ],
              [
                'India',
                30,
                'Asia',
                'Manuguru',
                'Manuguru mandal',
                'Bhadradri Kothagudem',
                'Manuguru solar farm',
                'Unknown',
                'Singareni Collieries Company Limited',
              ],
              [
                'India',
                22,
                'Asia',
                'Dubbak mandal',
                'Dubbak mandal',
                'Siddipet',
                'Medak solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Nalgonda mandal',
                'Nalgonda',
                'Nalgonda solar farm',
                'Unknown',
                'Mytrah Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Narketpalli',
                'Nalgonda',
                'Narketpalli (Adani) I solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Narketpalli',
                'Nalgonda',
                'Narketpalli (Adani) II solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                77,
                'Asia',
                'Unavailable',
                'Medipally mandal',
                'Medchal\u2013Malkajgiri',
                'NTPC - Karvy solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                50,
                'Asia',
                'Pasnoor',
                'Nalgonda mandal',
                'Nalgonda',
                'Pasnoor solar farm',
                'Unknown',
                'Skypower Holdings',
              ],
              [
                'India',
                25,
                'Asia',
                'Unavailable',
                'Ippaturu Nawabpet Mandal',
                'Mahbubnagar',
                'Polepally Solar Park',
                'Unknown',
                'First Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Gujrai',
                'Derapur',
                'Kanpur Dehat',
                'Gujrai solar farm',
                'Unknown',
                'Satluj Jal Vidyut Nigam Limited',
              ],
              [
                'India',
                75,
                'Asia',
                'Gurha',
                'Jalaun',
                'Jalaun',
                'Gurha solar farm',
                'Unknown',
                'Satluj Jal Vidyut Nigam Limited',
              ],
              [
                'India',
                50,
                'Asia',
                'Jalalabad',
                'Jalalabad',
                'Shahjahanpur',
                'Jalalabad (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Jalaun',
                'Jalaun',
                'Jalaun (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Narasipur',
                'Bangalore Urban',
                'Narasipur solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                21,
                'Asia',
                'Vijayapura taluk',
                'Vijayapura taluk',
                'Bijapur district',
                'Mamadapur solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Magadi',
                'Bangalore Urban',
                'Magadi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Maalru',
                'Bangalore Urban',
                'Maalru solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Ladha solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                63,
                'Asia',
                'Kushtagi taluk',
                'Kushtagi taluk',
                'Koppal district',
                'Kustagi solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'KR Pet',
                'Bangalore Urban',
                'Kr Pet solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                30,
                'Asia',
                'Kogali',
                'Hagari Bommanahalli taluk',
                'Vijayanagara district',
                'Kogali solar farm',
                'Siemens',
                'Atria Power',
              ],
              [
                'India',
                135,
                'Asia',
                'Bilagi',
                'Bilagi',
                'Bagalkote district',
                'KN solar farm',
                'Unknown',
                'Vena Energy',
              ],
              [
                'India',
                27,
                'Asia',
                'Koppala taluku',
                'Koppala taluku',
                'Koppal district',
                'Kerehalli Karnataka 2 solar farm',
                'Unknown',
                'SolarArise',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 4 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 4 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                42,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                42,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                54,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                37,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 2 solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                140,
                'Asia',
                'Unavailable',
                'Bangalore East',
                'Bangalore Urban',
                'Karnataka 140 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                30,
                'Asia',
                'Unavailable',
                'Kanahoshalli',
                'Bangalore Urban',
                'Kanahoshalli solar farm',
                'Unknown',
                'Avaada',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Humnabad',
                'Bidar district',
                'Humnabad solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Ittigi',
                'Bangalore Urban',
                'Ittigi (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                56,
                'Asia',
                'Jamakhandi taluku',
                'Jamakhandi taluku',
                'Bagalkote district',
                'Jamkhandi solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Jevargi',
                'Kalaburagi district',
                'Jevargi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                30,
                'Asia',
                'Kabahalli',
                'Bangalore East',
                'Bangalore Urban',
                'Kabahalli solar farm',
                'Siemens',
                'Atria Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Unavailable',
                'Yadagiri taluku',
                'Kalaburgi',
                'Kalaburgi solar farm',
                'ACME Cleantech Solutions',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Kalaghati',
                'Bangalore Urban',
                'Kalaghati solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Navalgund',
                'Dharwad district',
                'Navalgund solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                36,
                'Asia',
                'Tiruvannamalai',
                'Chengam',
                'Tiruvanamalai District',
                'Tiruvannamalai solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Nirna',
                'Bidar district',
                'Nirna solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur district',
                'Pavagada (Adani) I solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Jalaun',
                'Jalaun',
                'Jalaun (Essel) solar farm',
                'Unknown',
                'Essel Urja',
              ],
              [
                'India',
                55,
                'Asia',
                'Kalpi',
                'Kalpi',
                'Jalaun',
                'Jalaun (Rays) solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                102,
                'Asia',
                'Jewala',
                'Saharanpur',
                'Saharanpur',
                'Jewala solar farm',
                'Unknown',
                'Fourth Partner Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Jhansi',
                'Jhansi',
                'Jhansi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Kalpi',
                'Jalaun',
                'Kalpi solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                37,
                'Asia',
                'Kankua',
                'Charkhari',
                'Mahoba',
                'Kankua (Universal) solar farm',
                'Universal Saur Urja',
                'Universal Saur Urja',
              ],
              [
                'India',
                37,
                'Asia',
                'Kankua',
                'Prayagraj',
                'Prayagraj',
                'Kankua (Virescent) solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                75,
                'Asia',
                'Unavailable',
                'Kheda',
                'Badaun',
                'Kheda solar farm',
                'Jackson Limited',
                'SolarArise',
              ],
              [
                'India',
                75,
                'Asia',
                'Bilsi',
                'Bilsi',
                'Budaun',
                'Kheda Uttar Pradesh 1 solar farm',
                'Unknown',
                'SolarArise',
              ],
              [
                'India',
                34,
                'Asia',
                'Mahoba',
                'Charkhari',
                'Mahoba',
                'Mahiba solar farm',
                'Unknown',
                'Technique Solaire',
              ],
              [
                'India',
                50,
                'Asia',
                'Mahoba',
                'Charkhari',
                'Mahoba',
                'Mahoba (Adani) I solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Mahoba',
                'Charkhari',
                'Mahoba',
                'Mahoba (Adani) II solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Prayagraj',
                'Prayagraj',
                'Prayagraj solar farm',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Rihand',
                'Sonbhadra',
                'Rihand solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Sahaswan',
                'Sahaswan',
                'Budaun',
                'Sahaswan solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Prayagraj',
                'Prayagraj',
                'SECI Rihand solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                59,
                'Asia',
                'Unavailable',
                'Prayagraj',
                'Prayagraj',
                'Uttar Pradesh 2 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                51,
                'Asia',
                'Unavailable',
                'Prayagraj',
                'Prayagraj',
                'Uttar Pradesh 3 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                75,
                'Asia',
                'Mirzapur',
                'Mirzapur',
                'Mirzapur District',
                'Vijaypura (Engie) solar farm',
                'Unknown',
                'Engie',
              ],
              [
                'India',
                65,
                'Asia',
                'Bhagwanapur',
                'Dharchula',
                'Pithoragarh district',
                'Bhagwanpur solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                30,
                'Asia',
                'Roorkee',
                'Roorkee',
                'Haridwar',
                'Haridwar I solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                24,
                'Asia',
                'Roorkee',
                'Roorkee',
                'Haridwar',
                'Haridwar II solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                120,
                'Asia',
                'Dadanpatrabar',
                'Midnapore',
                'East Midnapore',
                'Dadanpatrabar solar farm',
                'Unknown',
                'WBSEDCL',
              ],
              [
                'India',
                80,
                'Asia',
                'Dadanpatrabar',
                'Midnapore',
                'East Midnapore',
                'Dadanpatrabar solar farm',
                'Unknown',
                'WBSEDCL',
              ],
              [
                'India',
                50,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur district',
                'Pavagada (Adani) II solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                71,
                'Asia',
                'Pavagada',
                'Pavagada taluk',
                'Tumkur',
                'Pavagada (ACME) IV solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Tirunelvelli',
                'Dindigul District',
                'Tirunelvelli solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                62,
                'Asia',
                'Unavailable',
                'Ramagundam',
                'Peddapalli',
                'Ramagundam (NTPC) II solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                36,
                'Asia',
                'Unavailable',
                'Gingee',
                'Thiruvannamalai',
                'Thiruvannamalai solar farm',
                'Terralight Kanji Solar',
                'Terralight Kanji Solar',
              ],
              [
                'India',
                100,
                'Asia',
                'Thoppalaakkarai',
                'Virudhunagar',
                'Virudhunagar',
                'Thoppalaakkarai solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Bikaner',
                'Bikaner',
                'Bikaner (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                150,
                'Asia',
                'Unavailable',
                'Chhattargarh',
                'Kota District',
                'Chhattargarh solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                240,
                'Asia',
                'Unavailable',
                'Devikot',
                'Jaisalmer',
                'Devikot solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Fatehgarh',
                'Bundi',
                'Fatehgarh I solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                246,
                'Asia',
                'Unavailable',
                'Fatehgarh',
                'Bundi',
                'Fatehgarh II solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                23,
                'Asia',
                'Gajner',
                'Kolayat Tehsil',
                'Bikaner',
                'Gajner solar farm',
                'Unknown',
                'Hinduja Renewables',
              ],
              [
                'India',
                50,
                'Asia',
                'Naukh',
                'Pokaran Tehsil',
                'Jaisalmer',
                'Jaisalemer (Hira) solar farm',
                'Unknown',
                'Hira Group',
              ],
              [
                'India',
                600,
                'Asia',
                'Unavailable',
                'Jaisalmer Tehsil',
                'Jaisalmer',
                'Jaisalmer (Adani) I Solar Hybrid Farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                600,
                'Asia',
                'Unavailable',
                'Jaisalmer Tehsil',
                'Jaisalmer',
                'Jaisalmer (Adani) II Solar Hybrid Farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                360,
                'Asia',
                'Unavailable',
                'Jaisalmer Tehsil',
                'Jaisalmer',
                'Jaisalmer (Adani) III Solar Hybrid Farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                125,
                'Asia',
                'Pokaran Tehsil',
                'Pokaran Tehsil',
                'Jaisalmer',
                'Jaisalmer (Reliance) I solar farm',
                'Unknown',
                'Reliance Power',
              ],
              [
                'India',
                40,
                'Asia',
                'Pokaran Tehsil',
                'Pokaran Tehsil',
                'Jaisalmer',
                'Jaisalmer (Reliance) II solar farm',
                'Unknown',
                'Reliance Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Jaisalmer Tehsil',
                'Jaisalmer',
                'Jaisalmer (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Mundwa Tehsil',
                'Jaiselmer',
                'Jaiselmer (Fortum) solar farm',
                'Unknown',
                'Fortum Solar',
              ],
              [
                'India',
                24,
                'Asia',
                'Unavailable',
                'Jodhpur Tehsil',
                'Jodhpur',
                'Jodhpur (LNB) solar farm',
                'Unknown',
                'LNB Renewable Energy',
              ],
              [
                'India',
                145,
                'Asia',
                'Unavailable',
                'Jodhpur Tehsil',
                'Jodhpur',
                'Jodhpur (Mahindra) solar farm',
                'Unknown',
                'Mahindra Susten',
              ],
              [
                'India',
                217,
                'Asia',
                'Unavailable',
                'Jodhpur Tehsil',
                'Jodhpur',
                'Jodhpur (Mahindra) solar farm',
                'Unknown',
                'Mahindra Susten',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Kanasar',
                'Bikaner',
                'Kanasar (Adani) solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Kanasar',
                'Bikaner',
                'Kanasar (Renew) solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Khetusar',
                'Jodhpur',
                'Khetusar solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Mah Ph 2 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                35,
                'Asia',
                'Nagaur',
                'Nagaur Tehsil',
                'Nagaur',
                'Nagaur solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                320,
                'Asia',
                'Unavailable',
                'Bhensada',
                'Kota District',
                'Bhensada solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Pokaran Tehsil',
                'Pokaran Tehsil',
                'Jaisalmer',
                'Nokh solar farm',
                'Unknown',
                'Godawari Green Energy',
              ],
              [
                'India',
                70,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Vector) Solar Park',
                'Unknown',
                'Vector Green Energy',
              ],
              [
                'India',
                25,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Roha) Solar Park',
                'Unknown',
                'Roha Dychem',
              ],
              [
                'India',
                52,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sahibzada Ajit Singh Nagar',
                'Punjab 4 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Sahibzada Ajit Singh Nagar',
                'Punjab SJVN solar farm',
                'Satluj Jal Vidyut Nigam Limited',
                'Satluj Jal Vidyut Nigam Limited',
              ],
              [
                'India',
                90,
                'Asia',
                'Unavailable',
                'Anta',
                'Barmer',
                'Anta solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Askandra',
                'Pokaran Tehsil',
                'Jaisalmer',
                'Askandra solar farm',
                'Unknown',
                'KVK Energy Ventures Ltd; Lanco',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Badisid',
                'Kota District',
                'Badisid solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bap',
                'Jodhpur',
                'Bap solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bap',
                'Jodhpur',
                'Bap solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bap',
                'Jodhpur',
                'Bap solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bap',
                'Jodhpur',
                'Bap solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Unavailable',
                'Bap',
                'Jodhpur',
                'Bap solar farm',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                56,
                'Asia',
                'Unavailable',
                'Pachpadra Tehsil',
                'Barmer',
                'Barmer solar farm',
                'Unknown',
                'LNB Renewable Energy',
              ],
              [
                'India',
                200,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (ACME) Solar Park',
                'Unknown',
                'ACME Solar',
              ],
              [
                'India',
                20,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Aditya Birla) Solar Park',
                'Unknown',
                'Aditya Birla Group',
              ],
              [
                'India',
                100,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Avaada) Solar Park',
                'Avaada',
                'Avaada',
              ],
              [
                'India',
                200,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Azure) Solar Park',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                70,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Charisma) Solar Park',
                'Charisma Energy / Sunseap',
                'Charisma Energy / Sunseap',
              ],
              [
                'India',
                70,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Charisma) Solar Park',
                'Charisma Energy / Sunseap',
                'Charisma Energy / Sunseap',
              ],
              [
                'India',
                190,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Engie) Solar Park',
                'Unknown',
                'Engie',
              ],
              [
                'India',
                70,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Fortum) Solar Park',
                'Unknown',
                'Fortum Solar',
              ],
              [
                'India',
                300,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Hero) Solar Park',
                'Unknown',
                'Hero Future Energies',
              ],
              [
                'India',
                260,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (NTPC) Solar Park',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                50,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Phelan) Solar Park',
                'Unknown',
                'Phelan Eneregy',
              ],
              [
                'India',
                60,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (Renew) Solar Park',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                600,
                'Asia',
                'Bhadla',
                'Bap Tehsil',
                'Jodhpur',
                'Bhadla (SB Energy) Solar Park',
                'Unknown',
                'SB Energy',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Nokhra',
                'Bikaner',
                'Nokhra solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Bikaner Tehsil',
                'Bikaner',
                'Bikaner (Ayaana) solar farm',
                'Unknown',
                'Ayana Renewable Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Sellaiya Sezhiyanallur',
                'Palayamkottai',
                'Tirunelveli',
                'Sellaiya Sezhiyanallur solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                24,
                'Asia',
                'Ugrass',
                'Jodhpur Tehsil',
                'Jodhpur',
                'Ugrass solar farm',
                'Unknown',
                'Juwi',
              ],
              [
                'India',
                60,
                'Asia',
                'Unavailable',
                'Dindigul',
                'Dindigul District',
                'Adhavan solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                28,
                'Asia',
                'Dindigul',
                'Dindigul',
                'Dindigul District',
                'Dindigul solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                230,
                'Asia',
                'Unavailable',
                'Ettayapuram',
                'Thoothukkudi District',
                'Ettayapuram solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                61,
                'Asia',
                'Iyermalai',
                'Dindigul',
                'Dindigul District',
                'Iyermalai solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                216,
                'Asia',
                'Kamuthi',
                'Kamuthi',
                'Ramanathapuram District',
                'Kamuthi (Adani) solar farm',
                'Adani Power',
                'Adani Green Energy',
              ],
              [
                'India',
                72,
                'Asia',
                'Kamuthi',
                'Kamuthi',
                'Ramanathapuram District',
                'Kamuthi (Adani) solar farm',
                'Adani Power',
                'Adani Green Energy',
              ],
              [
                'India',
                72,
                'Asia',
                'Kamuthi',
                'Kamuthi',
                'Ramanathapuram District',
                'Kamuthi (Adani) solar farm',
                'Adani Power',
                'Adani Green Energy',
              ],
              [
                'India',
                216,
                'Asia',
                'Kamuthi',
                'Kamuthi',
                'Ramanathapuram District',
                'Kamuthi (Adani) solar farm',
                'Adani Power',
                'Adani Green Energy',
              ],
              [
                'India',
                72,
                'Asia',
                'Kamuthi',
                'Kamuthi',
                'Ramanathapuram District',
                'Kamuthi (Adani) solar farm',
                'Adani Power',
                'Adani Green Energy',
              ],
              [
                'India',
                60,
                'Asia',
                'Unavailable',
                'Dindigul',
                'Dindigul District',
                'Kathiravan solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                100,
                'Asia',
                'Ottapidaram',
                'Ottapidaram',
                'Thoothukkudi District',
                'Kayathar (Rays) solar farm',
                'Unknown',
                'Rays Power Infra',
              ],
              [
                'India',
                60,
                'Asia',
                'Kayathar',
                'Kovilpatti',
                'Thoothukkudi District',
                'Kayathar (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                30,
                'Asia',
                'Kovilpatti',
                'Krishnarayapuram',
                'Virudhnagar',
                'Kovilpatti solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                100,
                'Asia',
                'Maranthai',
                'Palayamkottai',
                'Tirunelveli',
                'Maranthai - Pudur solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                65,
                'Asia',
                'Unavailable',
                'Panruti',
                'Neyveli',
                'Neyvelli solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                65,
                'Asia',
                'Unavailable',
                'Panruti',
                'Neyveli',
                'Neyvelli solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Periyakulam',
                'Theni District',
                'NHPC solar farm',
                'Unknown',
                'NHPC Ltd',
              ],
              [
                'India',
                61,
                'Asia',
                'Panchpatti',
                'Dindigul',
                'Dindigul District',
                'Panchpatti solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                60,
                'Asia',
                'Unavailable',
                'Dindigul',
                'Dindigul District',
                'Phoebus solar farm',
                'Unknown',
                'Greenko Group',
              ],
              [
                'India',
                54,
                'Asia',
                'Unavailable',
                'Rajapalayam',
                'Virudhunagar District',
                'Rajapalayam (Terralight) solar farm',
                'Terralight Rajapalayam Solar',
                'Terralight Rajapalayam Solar',
              ],
              [
                'India',
                54,
                'Asia',
                'Rajapalayam',
                'Rajapalayam',
                'Virudhunagar District',
                'Rajapalayam (Virescent) solar farm',
                'Unknown',
                'Virescent Renewables Energy Trust',
              ],
              [
                'India',
                100,
                'Asia',
                'Unavailable',
                'Ramanathapuram',
                'Ramanathapuram',
                'Ramanathapuram solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                60,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Ostro Rajasthn solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                100,
                'Asia',
                'Sethupuram',
                'Virudhunagar',
                'Virudhunagar',
                'Sethupuram solar farm',
                'Unknown',
                'NLC India',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Bhivji Ka Gaon',
                'Jodhpur',
                'Sprng Photovoltaic solar farm',
                'Unknown',
                'Sprng Energy',
              ],
              [
                'India',
                140,
                'Asia',
                'Unavailable',
                'Jodhpur Tehsil',
                'Jodhpur',
                'Sitara solar farm',
                'Unknown',
                'UPC Renewables; AC Energy',
              ],
              [
                'India',
                500,
                'Asia',
                'Unavailable',
                'Dindigul',
                'Dindigul District',
                'Kadaldi solar farm',
                'Unknown',
                'TANGEDCO',
              ],
              [
                'India',
                220,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan 6 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                900,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan solar farm',
                'Unknown',
                'ACME Solar; Scatec',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Rawra',
                'Jodhpur',
                'Rawra Kilaj solar farm',
                'Unknown',
                'Adani Green Energy',
              ],
              [
                'India',
                30,
                'Asia',
                'Rawra',
                'Bap Tehsil',
                'Jodhpur',
                'Rawra solar farm',
                'Unknown',
                'Mahindra Solar One',
              ],
              [
                'India',
                55,
                'Asia',
                'Rawra',
                'Phalodi Tehsil',
                'Phalodi',
                'Phalodi (Hinduja) solar farm',
                'Unknown',
                'Hinduja Renewables',
              ],
              [
                'India',
                400,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 9 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                450,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan 6 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                262,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan 5 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                126,
                'Asia',
                'Unavailable',
                'Pratapgarh Tehsil',
                'Pratapgarh',
                'Pratapgarh solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan 9 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Pokhran',
                'Jaisalmer',
                'Pokhran solar farm',
                'Unknown',
                'Renew Power',
              ],
              [
                'India',
                22,
                'Asia',
                'Unavailable',
                'Phalodi Tehsil',
                'Phalodi',
                'Phalodi (LNB) solar farm',
                'Unknown',
                'LNB Renewable Energy',
              ],
              [
                'India',
                550,
                'Asia',
                'Unavailable',
                'Sambhu Ki Bhurj',
                'Kota District',
                'Sambhu Ki Bhurj solar farm',
                'Unknown',
                'NTPC Ltd',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 3 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                250,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 4 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                50,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 4 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 6 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                200,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'SECI 8 solar farm',
                'Unknown',
                'Renew Power; Hareon Solar',
              ],
              [
                'India',
                55,
                'Asia',
                'Unavailable',
                'Phalodi',
                'Jodhpur',
                'Phalodi (Tata) solar farm',
                'Unknown',
                'TATA Power',
              ],
              [
                'India',
                300,
                'Asia',
                'Unavailable',
                'Ladpura Tehsil',
                'Kota District',
                'Rajasthan 8 solar farm',
                'Unknown',
                'Azure Power',
              ],
              [
                'Indonesia',
                25,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bali-2 solar farm',
                'Unknown',
                'PT Medco Power Indonesia; Solar PPA Philippines',
              ],
              [
                'Indonesia',
                2200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Batam Island',
                'Batam solar farm',
                'Unknown',
                'Sunseap Group',
              ],
              [
                'Indonesia',
                145,
                'Asia',
                'Unavailable',
                'Cirata Resevoir',
                'Unavailable',
                'Cirata Resevoir solar farm',
                'Unknown',
                'Pembangkitan Jawa Bali Masdar Solar Energy (PMSE)',
              ],
              [
                'Indonesia',
                50,
                'Asia',
                'Unavailable',
                'Jombang',
                'Unavailable',
                'East Java solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Indonesia',
                70,
                'Asia',
                'Unavailable',
                'Manggarai Timur',
                'Unavailable',
                'Labaun Bajo solar farm',
                'Unknown',
                'Scatec Solar [95%]',
              ],
              [
                'Indonesia',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lampung solar farm',
                'Unknown',
                'ACWA Power',
              ],
              [
                'Indonesia',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ombilin solar farm',
                'Unknown',
                'PT Bukit Asam Tbk',
              ],
              [
                'Indonesia',
                60,
                'Asia',
                'Unavailable',
                'Indramayu Regency',
                'Unavailable',
                'Saguling solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Indonesia',
                90,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Singkarak solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Indonesia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Central Java solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Indonesia',
                25,
                'Asia',
                'Unavailable',
                'Jembrana',
                'Jembrana',
                'Bali-2 solar farm',
                'Unknown',
                'PT Medco Power Indonesia; Solar PPA Philippines',
              ],
              [
                'Indonesia',
                50,
                'Asia',
                'Unavailable',
                'Indramayu Regency',
                'Unavailable',
                'West Java solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Indonesia',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'West Kalimantan solar farm',
                'Unknown',
                'ACWA Power',
              ],
              [
                'Indonesia',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Tanjung Enim solar farm',
                'Unknown',
                'PT Bukit Asam Tbk',
              ],
              [
                'Indonesia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kubu',
                'Bali-1 solar farm',
                'Unknown',
                'Equis Energy Indonesia; PT Infrastruktur Tebarukan Fortuna',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                20,
                'Middle East',
                'Shushtar',
                'Shushtar County',
                'Unavailable',
                'Shushtar solar farm',
                'Unknown',
                'Medio Energy Invest GmbH & Co. KG',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                1000,
                'Middle East',
                'Saveh',
                'Saveh County',
                'Unavailable',
                'Markazi solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Iran',
                20,
                'Middle East',
                'Kerman County',
                'Kerman County',
                'Unavailable',
                'Mokran 1 solar farm',
                'Unknown',
                'Durion AG',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Mokran 2 solar farm',
                'Unknown',
                'Durion AG',
              ],
              [
                'Iran',
                30,
                'Middle East',
                'Jajaram',
                'Jajaram County',
                'Unavailable',
                'North Khorasan solar farm',
                'Unknown',
                'Ecofinance SA',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Damghan',
                'Damghan County',
                'Unavailable',
                'Damghan solar farm',
                'Unknown',
                'Carlo Maresca Spa',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Kashan',
                'Aran va Bidgol',
                'Unavailable',
                'Kashan solar farm',
                'Unknown',
                'ABP International',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Unavailable',
                'Kerman County',
                'Unavailable',
                'Central Iran solar farm',
                'Quercus Invest Partners Ltd.',
                'Quercus Invest Partners Ltd.',
              ],
              [
                'Iran',
                100,
                'Middle East',
                'Gamsar',
                'Gamsar County',
                'Unavailable',
                'Gamsar solar farm',
                'Unknown',
                'Carlo Maresca Spa',
              ],
              [
                'Iraq',
                250,
                'Middle East',
                'Ramadi',
                'Unavailable',
                'Unavailable',
                'Ramadi Solar PV 2',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                1000,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Masdar Solar Power Plant',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                100,
                'Middle East',
                'Mosul',
                'Unavailable',
                'Unavailable',
                'Masdar Mousl Solar',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                100,
                'Middle East',
                'Amarah',
                'Unavailable',
                'Unavailable',
                'Masdar Amarah Solar',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Khidir Solar',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                300,
                'Middle East',
                'Karbala City',
                'Unavailable',
                'Unavailable',
                'Karbala Solar Plant',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts[33.33%]; Orascom Construction Industries [33.33%]; Scatec [33.33%]',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Jissan Solar',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                225,
                'Middle East',
                'Iskandariya',
                'Unavailable',
                'Unavailable',
                'Iskandariya Solar',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                450,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dhi Qar Solar',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                100,
                'Middle East',
                'Najaf',
                'Unavailable',
                'Unavailable',
                'Dana Haydariyia solar farm',
                'Unknown',
                'Al Dana International Company',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Al Diwaniyah',
                'Unavailable',
                'Unavailable',
                'Al Diwaniyah solar farm',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                100,
                'Middle East',
                'Ramadi',
                'Unavailable',
                'Unavailable',
                'Ramadi Solar PV1',
                'Masdar',
                'Masdar',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Shehabi',
                'Unavailable',
                'Unavailable',
                'Sama Al Shehabi solar farm',
                'Unknown',
                'Sama Baghdad Company',
              ],
              [
                'Iraq',
                2000,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Power China Solar PV Park',
                'China Power',
                'China Power',
              ],
              [
                'Iraq',
                40,
                'Middle East',
                'Faluja',
                'Unavailable',
                'Unavailable',
                'Sama Faluja Solar Station',
                'Sama Baghdad Company; Blue Sky Corporation',
                'Sama Baghdad Company; Blue Sky Corporation',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Karma',
                'Unavailable',
                'Unavailable',
                'Sama Karma Solar Station',
                'Sama Baghdad Company; Blue Sky Corporation',
                'Sama Baghdad Company; Blue Sky Corporation',
              ],
              [
                'Iraq',
                30,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sawa 1 Solar',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sawa 2 Solar',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
                'Al Bilal Group for General Contracts; Orascom Construction Industries; Scatec',
              ],
              [
                'Iraq',
                1000,
                'Middle East',
                'Basra',
                'Unavailable',
                'Unavailable',
                'Total Basra Solar PV Park',
                'Total Energies',
                'TotalEnergies',
              ],
              [
                'Iraq',
                50,
                'Middle East',
                'Amriya',
                'Unavailable',
                'Unavailable',
                'Sama Amriya Al Samoud Solar Station',
                'Sama Baghdad Company; Blue Sky Corporation',
                'Sama Baghdad Company; Blue Sky Corporation',
              ],
              [
                'Ireland',
                95,
                'Europe',
                'Rosspile',
                'Wexford',
                'Unavailable',
                'Rosspile solar farm',
                'Unknown',
                'Highfield Energy',
              ],
              [
                'Ireland',
                24,
                'Europe',
                'Cahir',
                'Tipperary',
                'Unavailable',
                'Monaraha solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Ireland',
                95,
                'Europe',
                'Gillinstown',
                'Meath',
                'Unavailable',
                'Gillinstown solar farm',
                'Unknown',
                'Highfield Energy',
              ],
              [
                'Ireland',
                198,
                'Europe',
                'Ballymacarney',
                'Meath',
                'Unavailable',
                'Gallanstown solar farm',
                'Statkraft',
                'Statkraft',
              ],
              [
                'Ireland',
                20,
                'Europe',
                'Unavailable',
                'Tipperary',
                'Unavailable',
                'Doonane solar farm',
                'Unknown',
                'Entrust Ltd',
              ],
              [
                'Ireland',
                78,
                'Europe',
                'Unavailable',
                'Meath',
                'Unavailable',
                'Blundelstown solar farm',
                'Unknown',
                'Statkraft',
              ],
              [
                'Ireland',
                50,
                'Europe',
                'Limerick',
                'Limerick',
                'Unavailable',
                'Ballinknockane solar farm',
                'Unknown',
                'Solas Eireann',
              ],
              [
                'Israel',
                120,
                'Middle East',
                'Ze\u00e9lim',
                'Unavailable',
                'Southern District',
                'Ze\u00e9lim solar farm',
                'Shikun & Binui Energy',
                'Shikun & Binui Energy',
              ],
              [
                'Israel',
                38,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Beersheba Subdistrict',
                'Neot Hovav solar farm',
                'Unknown',
                'Energix Renewable Energies Ltd.',
              ],
              [
                'Israel',
                27,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Ashkelon Subdistrict',
                'Shoresh solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'Israel',
                60,
                'Middle East',
                'Ramat Negev Regional Council',
                'Unavailable',
                'Beersheba Subdistrict',
                'Mashabai Sadeh solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Israel',
                40,
                'Middle East',
                'Hevel Eilot Regional Council',
                'Unavailable',
                'Beersheba Subdistrict',
                'Ketura Solar',
                'Arava Power',
                'Enlight Renewable Energy Ltd.',
              ],
              [
                'Israel',
                55,
                'Middle East',
                'Eshkol Regional Council',
                'Unavailable',
                'Beersheba Subdistrict',
                'Halutziot solar farm',
                'M+W Group; Enlight Renewable Energy Ltd.',
                'Enlight Renewable Energy Ltd.; Noy Fund',
              ],
              [
                'Israel',
                330,
                'Middle East',
                'Dimona',
                'Unavailable',
                'Southern District',
                'Dimona solar farm',
                'M+W Group; Enlight Renewable Energy Ltd.',
                'Shikun & Binui Energy',
              ],
              [
                'Israel',
                42,
                'Middle East',
                'Ramat Negev Regional Council',
                'Unavailable',
                'Beersheba Subdistrict',
                'Ashalim 2 solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'Israel',
                35,
                'Middle East',
                'Ramat Negev Regional Council',
                'Unavailable',
                'Beersheba Subdistrict',
                'Ashalim 1 solar farm',
                'Unknown',
                'EDF Renewables [50%]; Clal Sun Ltd. [50%]',
              ],
              [
                'Israel',
                60,
                'Middle East',
                'Timna Park',
                'Eliat',
                'Southern District',
                'Timna solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Israel',
                50,
                'Middle East',
                'Beer Sheva',
                'Unavailable',
                'Beersheba Subdistrict',
                'Zmorot solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'Italy',
                20,
                'Europe',
                'Cagliari',
                'Cagliari',
                'Unavailable',
                'Su Scioffu solar farm',
                'Unknown',
                'EPC GES Global Energy Services; Moser Baer Clean Energy Limited; General Electric',
              ],
              [
                'Italy',
                70,
                'Europe',
                'Rovigo',
                'Rovigo',
                'Unavailable',
                'Emmezeta Solar Park Rovigo',
                'Sun Edison',
                'First Reserve; Sun Edsion',
              ],
              [
                'Italy',
                31,
                'Europe',
                'Alfonsine',
                'Ravenna',
                'Ravenna',
                'Alfonsine Solar Park',
                'Unknown',
                'Tozzi Sud',
              ],
              [
                'Italy',
                25,
                'Europe',
                'Napoli',
                'Napoli',
                'Unavailable',
                'Nola Cis solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'Italy',
                25,
                'Europe',
                'Unavailable',
                'Bolotana',
                'Nuoro',
                'Ottana Solar',
                'O&M plus',
                'Graziella Energy Service',
              ],
              [
                'Italy',
                31,
                'Europe',
                'Sassari',
                'Sassari',
                'Unavailable',
                'Porto Torres solar farm',
                'Eni',
                'Unknown',
              ],
              [
                'Italy',
                29,
                'Europe',
                'Unavailable',
                'Bari',
                'Unavailable',
                'Puglia solar farm',
                'OHL Industrial [70%]; Proener Renovables [30%]',
                'GSF Capital',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Catanzaro',
                'Catanzaro',
                'Unavailable',
                'San Floro solar farm',
                'ERG',
                'ERG',
              ],
              [
                'Italy',
                25,
                'Europe',
                'Alfonsine',
                'Ravenna',
                'Ravenna',
                'Alfonsine Solar Park',
                'Unknown',
                'Tozzi Sud',
              ],
              [
                'Italy',
                28,
                'Europe',
                'Ravenna',
                'Ravenna',
                'Unavailable',
                "Sant'Alberto solar farm",
                'Unknown',
                'Tozzi Sud',
              ],
              [
                'Italy',
                54,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sardinia solar farm',
                'Unknown',
                'KGAL',
              ],
              [
                'Italy',
                690,
                'Europe',
                'Unavailable',
                'Messina',
                'Unavailable',
                'Seag Solar Project',
                'Unknown',
                'STEAG SENS; KGAL',
              ],
              [
                'Italy',
                48,
                'Europe',
                'Rovigo',
                'Rovigo',
                'Unavailable',
                'Serenissima solar farm',
                'BNZ',
                'Nuveen',
              ],
              [
                'Italy',
                78,
                'Europe',
                'Unavailable',
                'Messina',
                'Unavailable',
                'Sicily Lightsource solar farm',
                'Unknown',
                'Lightsource BP; EGI',
              ],
              [
                'Italy',
                22,
                'Europe',
                'Montalto Di Castro',
                'Viterbo',
                'Viterbo',
                'Montalto Di Castro Solar Farm',
                'ERG [78.5%]; Perseo [21.5]',
                'ERG [78.5%]; Perseo [21.5]',
              ],
              [
                'Italy',
                60,
                'Europe',
                'Unavailable',
                'Asti',
                'Unavailable',
                'Trino Solar',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'Italy',
                25,
                'Europe',
                'Ravenna',
                'Ravenna',
                'Unavailable',
                "Sant'Alberto solar farm",
                'Unknown',
                'Tozzi Sud',
              ],
              [
                'Italy',
                26,
                'Europe',
                'Assemini',
                'Pisa',
                'Cagliari',
                'Assemini solar farm',
                'Eni; GSE',
                'Eni; GSE',
              ],
              [
                'Italy',
                24,
                'Europe',
                'San Floro',
                'Catanzaro',
                'Unavailable',
                'Calabria Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Italy',
                22,
                'Europe',
                'Bari',
                'Bari',
                'Unavailable',
                'Caserma solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Italy',
                20,
                'Europe',
                'Montalto Di Castro',
                'Viterbo',
                'Viterbo',
                'Montalto Di Castro Solar Farm',
                'Perseo S.r.l',
                'Perseo S.r.l',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Unavailable',
                'Terni',
                'Unavailable',
                'Montalto Cassiopea solar farm',
                'Ultor S.p.A',
                'Ultor S.p.A',
              ],
              [
                'Italy',
                420,
                'Europe',
                'Unavailable',
                'Terni',
                'Unavailable',
                'Matrix solar farm',
                'Matrix Renewables',
                'Matrix Renewables; Horus Green Energy Investment',
              ],
              [
                'Italy',
                45,
                'Europe',
                'Macchiareddu',
                'Cagliari',
                'Unavailable',
                'Macchiareddu Solar',
                'Comoil SA',
                'Comoil SA',
              ],
              [
                'Italy',
                62,
                'Europe',
                'Macchiareddu',
                'Cagliari',
                'Unavailable',
                'Macchiareddu Solar',
                'Comoil SA',
                'Comoil SA',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Unavailable',
                'Roma Capitale',
                'Unavailable',
                'Lazio Phenix solar farm',
                'Unknown',
                'Tages Capital',
              ],
              [
                'Italy',
                23,
                'Europe',
                'Roma Capitale',
                'Roma Capitale',
                'Unavailable',
                'Lanuvio solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Viterbo',
                'Viterbo',
                'Unavailable',
                'La Sugarella solar farm',
                'REC; ABB',
                'CER Energia BV [70%]; MedEnergy Group [30%]',
              ],
              [
                'Italy',
                20,
                'Europe',
                'Unavailable',
                'Napoli',
                'Unavailable',
                'Giugliano Coser solar farm',
                'Eurofinsa',
                'IBT group',
              ],
              [
                'Italy',
                29,
                'Europe',
                'Sassari',
                'Sassari',
                'Unavailable',
                'Fiume Santo solar farm',
                'E.ON',
                'E.ON',
              ],
              [
                'Italy',
                48,
                'Europe',
                'Enersol',
                'Roma Capitale',
                'Unavailable',
                'Enersol solar farm (Italy)',
                'Unknown',
                'Tages Capital',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Naples',
                'Salerno',
                'Salerno',
                'Monte Di Eboli solar farm',
                'Toto Holding',
                'F2i',
              ],
              [
                'Italy',
                43,
                'Europe',
                'Brindisi',
                'Brindisi',
                'Unavailable',
                'Cellino San Marco solar farm',
                'BFP',
                'AES Corporation; Riverstone Holdings',
              ],
              [
                'Italy',
                20,
                'Europe',
                'Celano',
                "L'Aquila",
                'Unavailable',
                'Celano solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Italy',
                24,
                'Europe',
                'Viterbo',
                'Viterbo',
                'Unavailable',
                'Cassiopea solar farm',
                'EF Solare',
                'Unknown',
              ],
              [
                'Italy',
                63,
                'Europe',
                'Troia',
                'Foggia',
                'Foggia',
                'Troia Euro solar farm',
                'EPC Contractor European Energy',
                'EPC Contractor European Energy',
              ],
              [
                'Italy',
                40,
                'Europe',
                'Foggia',
                'Foggia',
                'Unavailable',
                'Troia Euro solar farm',
                'EPC Contractor European Energy',
                'EPC Contractor European Energy',
              ],
              [
                'Italy',
                86,
                'Europe',
                'Unavailable',
                'San Severo',
                'Foggia',
                'Torre Antonacci solar farm',
                'Trina Solar',
                'Margherita',
              ],
              [
                'Italy',
                22,
                'Europe',
                'Montalto Di Castro',
                'Viterbo',
                'Viterbo',
                'Montalto Di Castro Solar Farm',
                'ERG [78.5%]; Perseo [21.5]',
                'ERG [78.5%]; Perseo [21.5]',
              ],
              [
                'Italy',
                50,
                'Europe',
                'Unavailable',
                'Bari',
                'Unavailable',
                'Tudia Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Jamaica',
                20,
                'Central America and the Caribbean',
                'Clarendon',
                'Clarendon',
                'Middlesex County',
                'Content solar farm',
                'WRB Enterprises',
                'WRB Enterprises',
              ],
              [
                'Jamaica',
                33,
                'Central America and the Caribbean',
                'Unavailable',
                'Clarendon',
                'Middlesex County',
                'Jamaica Public Service Solar Plant',
                'Jamaica Public Service',
                'Jamaica Public Service',
              ],
              [
                'Jamaica',
                33,
                'Central America and the Caribbean',
                'Unavailable',
                'Clarendon',
                'Middlesex County',
                'Jamaica Public Service Solar Plant',
                'Jamaica Public Service',
                'Jamaica Public Service',
              ],
              [
                'Jamaica',
                33,
                'Central America and the Caribbean',
                'Unavailable',
                'Clarendon',
                'Middlesex County',
                'Jamaica Public Service Solar Plant',
                'Jamaica Public Service',
                'Jamaica Public Service',
              ],
              [
                'Jamaica',
                72,
                'Central America and the Caribbean',
                'Unavailable',
                'Clarendon',
                'Middlesex County',
                'Mpc Solar Plant',
                'MPC Energy Solutions (MPCES)',
                'MPC Energy Solutions (MPCES)',
              ],
              [
                'Jamaica',
                52,
                'Central America and the Caribbean',
                'Westmoreland',
                'Westmoreland',
                'Cornwall County',
                'Paradise Park solar farm',
                'MPC Energy Solutions (MPCES)',
                'MPC Energy Solutions (MPCES)',
              ],
              [
                'Jamaica',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Clarendon',
                'Middlesex County',
                'Clarendon solar farm',
                'Jamaica Public Service',
                'Unknown',
              ],
              [
                'Japan',
                65,
                'Asia',
                'Yufutsu County',
                'Yufutsu County',
                'Unavailable',
                'Softbank Toma East Anping Solar Park 2',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Chitose',
                'Unavailable',
                'Unavailable',
                'Shin Chitose Kashiwadai Solar Power Plant',
                'Unknown',
                "Japan's Energy Products Corporation; Korea Electric Power Corporation",
              ],
              [
                'Japan',
                27,
                'Asia',
                'Schichinohe',
                'Kamikita',
                'Aomori',
                'Shichinohe 1 Solar Power Plant',
                'Equis Energy',
                'Equis Energy',
              ],
              [
                'Japan',
                46,
                'Asia',
                'Tomakomai',
                'Unavailable',
                'Unavailable',
                'Sharp Tomatoh No Mori Solar Power Station',
                'Tomakomai Solar Energy LLC',
                'Orix Corporation [70%]; Sharp Corporation[30%]',
              ],
              [
                'Japan',
                50,
                'Asia',
                'Usa',
                'Unavailable',
                'Unavailable',
                'SGET Usa Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Ohtawara',
                'Unavailable',
                'Unavailable',
                'SGET Tochigi Mega Solar',
                'SGET Tochigi Mega Solar GK',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Shirakawa City',
                'Unavailable',
                'Fukushima',
                'SGET Shin Shirakawa Mega Solar Power Plant',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                37,
                'Asia',
                'Okayama',
                'Unavailable',
                'Unavailable',
                'Shin-Okayama Solar Power Plant Mega Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Ohtawara',
                'Unavailable',
                'Unavailable',
                'SGET Otawara Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Sakai City',
                'Unavailable',
                'Fukui',
                'SGET Mikuni Mega Solar Power Plant',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Kushiro',
                'Unavailable',
                'Unavailable',
                'SGET Kushiro Mega Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Kisarazu',
                'Unavailable',
                'Unavailable',
                'SGET Kisarazu Mega Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                55,
                'Asia',
                'Tone County',
                'Tone County',
                'Unavailable',
                'SGET Katashina Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Kamisu',
                'Unavailable',
                'Unavailable',
                'SGET Kamisu Mega Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Hitachiomiya',
                'Unavailable',
                'Unavailable',
                'SGET Hitachiomiya Mega Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                36,
                'Asia',
                'Minamisoma',
                'Unavailable',
                'Unavailable',
                'SGET Minamisoma Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                74,
                'Asia',
                'Shirakawa',
                'Unavailable',
                'Unavailable',
                'Shirakawa Solar Park',
                'GK Shirakawa Solar Park',
                'Unknown',
              ],
              [
                'Japan',
                35,
                'Asia',
                'Shiraoi',
                'Shiraoi County',
                'Hokkaido',
                'Shiraoi Town Takeura Solar Power Plant',
                'afterFIT Co., Ltd.',
                'Daiwa Energy & Infrastructure Co., Ltd.; afterFIT Co., Ltd.',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Shiriuchi',
                'Yunosato',
                'Hokkaido',
                'Shiriuchi Mega Solar 20M Power Plant',
                'Orix Corporation',
                'Orix Corporation',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Higashimorokata County',
                'Higashimorokata County',
                'Unavailable',
                'Softbank Miyazaki Kunitomi Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Arao',
                'Unavailable',
                'Unavailable',
                'Softbank Kumamoto Arao Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Aira County',
                'Aira County',
                'Unavailable',
                'Softbank Kagoshima Yusui Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                43,
                'Asia',
                'Hamamatsu',
                'Unavailable',
                'Unavailable',
                'Softbank Hamamatsu Chukai Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Yamaguchi',
                'Unavailable',
                'Unavailable',
                'Smart Solar Yamaguchi Aio Power Plant',
                'Canadian Solar',
                'Canadian Solar Group',
              ],
              [
                'Japan',
                31,
                'Asia',
                'Shirakawa',
                'Unavailable',
                'Unavailable',
                'Sk Shirakawa Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                43,
                'Asia',
                'Yonago',
                'Unavailable',
                'Unavailable',
                'Softbank Tottori Yonago Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                102,
                'Asia',
                'Futami County',
                'Futami County',
                'Unavailable',
                'Softbank Yakumo Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Omura',
                'Unavailable',
                'Unavailable',
                'SOL De Omura Minojima Solar Power Plant',
                'Unknown',
                'Solar Frontier; Chopro',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Oita City',
                'Unavailable',
                'Oita',
                'Blue Power Oita Shuki Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                40,
                'Asia',
                'Takasaki City',
                'Agatsuma County',
                'Gunma',
                'Solar Friendly City solar farm',
                'Unknown',
                'ITOCHU Enex Co., Ltd. [100%]',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Minamisoma City',
                'Haramachi-higashi',
                'Fukushima',
                'Solar Power Minami-Souma Haramachi solar farm',
                'Unknown',
                'Sumitomo Corporation',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Saijo',
                'Unavailable',
                'Unavailable',
                'Solar Power Saijo solar farm',
                'Unknown',
                'Sumitomo Corporation',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Iwate County',
                'Iwate County',
                'Unavailable',
                'Shizukuishi solar farm',
                'Unknown',
                'Etorion; Hitachi High-Technologies',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Shiroishi City',
                'Tohoku',
                'Miyagi',
                'Shiroishi solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                111,
                'Asia',
                'Yufutsu County',
                'Yufutsu County',
                'Unavailable',
                'Softbank Tomatoh Abira Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                40,
                'Asia',
                'Soma',
                'Unavailable',
                'Unavailable',
                'Soma solar farm (Japan)',
                'Daiwa House',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Aizu City',
                'Unavailable',
                'Kushima',
                'Nari Aizu solar farm',
                'Unknown',
                'Prime Renewable Energy Company Limited [25%]; Banpu Power Public Company Limited [75%]',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Soma',
                'Unavailable',
                'Unavailable',
                'Soma Yamakami solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                111,
                'Asia',
                'Unavailable',
                'Nishimuro',
                'Wakayama',
                'Wakayama Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Takizawa',
                'Unavailable',
                'Unavailable',
                'VITEC Isaribikan Takizawa City Mega Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                67,
                'Asia',
                'Utzunomiya City',
                'Unavailable',
                'Tochigi',
                'Utsunomiya solar farm',
                'Unknown',
                'Gunkul International (Maruitius) (GIM) [100%]',
              ],
              [
                'Japan',
                400,
                'Asia',
                'Ukushima',
                'Sasebo City',
                'Nagasaki',
                'Ukujima Mega Solar Project',
                'Unknown',
                'Kyocera Corporation; SPCG Public Company Limited; Kyudenko Corporation; Tokyo Century Co., Ltd.; Furukawa Electric Co., Ltd.; Tsuboi Industry Co., Ltd.; other',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Ube',
                'Unavailable',
                'Unavailable',
                'Ube City solar farm',
                'US Power Co., Ltd.',
                'US Power Co., Ltd.',
              ],
              [
                'Japan',
                51,
                'Asia',
                'Tsu City',
                'Minamimuro County',
                'Mie',
                'Tsu Haze Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                47,
                'Asia',
                'Tono',
                'Unavailable',
                'Unavailable',
                'Tono solar farm',
                'Sonnedix Japan Co., Ltd.',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Futaba County',
                'Futaba County',
                'Unavailable',
                'Tomioka Sugiuchi Solar Power Plant',
                'Unknown',
                'Fuyo General Lease Co., Ltd.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Futaba County',
                'Futaba County',
                'Unavailable',
                'Tomioka Revitalization Mega Solar Power Plant',
                'Tomioka Recovery Energy',
                'JR East Energy Development Co., Ltd.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Tomakomai',
                'Unavailable',
                'Unavailable',
                'Tomakomai Yufutsu Mega Solar',
                'SB Energy',
                'Unknown',
              ],
              [
                'Japan',
                38,
                'Asia',
                'Tomakomai',
                'Unavailable',
                'Unavailable',
                'Tomakomai solar farm',
                'Unknown',
                'Aquila Capital Concepts GmbH Aquila Capital',
              ],
              [
                'Japan',
                33,
                'Asia',
                'Shobara',
                'Unavailable',
                'Unavailable',
                'Tojo solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Kitakyushu',
                'Unavailable',
                'Unavailable',
                'Energy Seed Hibiki Solar Power Plant',
                'Unknown',
                'Energy Seed Co., Ltd. [51%]; AGC [49%]',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Wakayama',
                'Unavailable',
                'Unavailable',
                'Dream Solar Wakayama City',
                'Daiwa Lease Co., Ltd.',
                'Unknown',
              ],
              [
                'Japan',
                46,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Ibaraki',
                'Daigo Solar Power Project',
                'Unknown',
                'JR East Energy Development Co., Ltd.',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Oita',
                'Unavailable',
                'Unavailable',
                'Daigas Oita Mirai Solar Power Plant',
                'Daigas Oita Mirai Solar Co., Ltd.',
                'Daigas G&P Solution',
              ],
              [
                'Japan',
                56,
                'Asia',
                'Mine',
                'Unavailable',
                'Unavailable',
                'Csj Yamaguchi Shin Mine solar farm',
                'Unknown',
                'Hana Financial Group',
              ],
              [
                'Japan',
                48,
                'Asia',
                'Kamimashiki County',
                'Kamimashiki County',
                'Unavailable',
                'Cs Mashiki-Machi solar farm',
                'CSOM Japan',
                'Canadian Solar Project Co., Ltd.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Maniwa City',
                'Unavailable',
                'Okayama',
                'Cs Maniwa solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                53,
                'Asia',
                'Hayami County',
                'Hayami County',
                'Unavailable',
                'Cs Hiji Town No. 2 solar farm',
                'CSOM Japan',
                'Canadian Solar Project Co., Ltd.',
              ],
              [
                'Japan',
                67,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Chiba',
                'Chiba solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                99,
                'Asia',
                'Matsusaka City',
                'Unavailable',
                'Mie',
                'Cherry Lake solar farm',
                'Maetel',
                'Unknown',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Kannami',
                'Tagata',
                'Shizuoka',
                'Blue Power Shizuoka Kannami Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Wakayama',
                'Unavailable',
                'Unavailable',
                'Wakayama solar farm',
                'Unknown',
                'SKI Corporation',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Wakutani',
                'Unavailable',
                'Miyagi',
                'Wakuya Solar Project',
                'Vena Energy',
                'Vena Energy',
              ],
              [
                'Japan',
                49,
                'Asia',
                'Yoshida',
                'Watari',
                'Miyagi',
                'Watari Solar Power Plant',
                'Unknown',
                'Yamasa',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Kikuchi County',
                'Kikuchi County',
                'Unavailable',
                'Yagoyama solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                34,
                'Asia',
                'Schichinohe',
                'Kamikita County',
                'Aomori',
                'Sotsukozawa Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Sukagawa City',
                'Unavailable',
                'Fukushima',
                'Sukawaga solar farm',
                'SPI Solar',
                'SPI Solar Japan G.K. [100%]',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Sukagawa',
                'Unavailable',
                'Unavailable',
                'Sunny Solar Fukushima Central Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Aira County',
                'Aira County',
                'Unavailable',
                'Sunshine Energy Yusui solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                92,
                'Asia',
                'Kushiro County',
                'Kushiro County',
                'Unavailable',
                'Suzuran Kushiro Town Solar Power Plant',
                'Unknown',
                'Tokyu Land Corporation; Mitsubishi UFJ Lease; Japan Green Power Development',
              ],
              [
                'Japan',
                40,
                'Asia',
                'Tahara',
                'Unavailable',
                'Unavailable',
                'Tahara solar farm',
                'Unknown',
                'Diamon Solar Japan [50%]; Seatech [35%]; Mitsubishi UFJ Lease [15%]',
              ],
              [
                'Japan',
                41,
                'Asia',
                'Tahara',
                'Unavailable',
                'Unavailable',
                'Tahara solar farm',
                'Unknown',
                'Diamon Solar Japan [50%]; Seatech [35%]; Mitsubishi UFJ Lease [15%]',
              ],
              [
                'Japan',
                50,
                'Asia',
                'Tahara',
                'Unavailable',
                'Unavailable',
                'Tahara Solar Wind Power Station',
                'Unknown',
                'Mitsui Chemicals, Inc.; Mitsui & Co., Ltd.; Seatech Co., Ltd.; Toa Synthetic Co., Ltd.; Toshiba Co., Ltd.; Toray Industries, Inc.; Mitsui Engineering & Shipbuilding Co., Ltd.; Trans Value Trust Co., Ltd.',
              ],
              [
                'Japan',
                51,
                'Asia',
                'Sendai City',
                'Unavailable',
                'Miyagi',
                'Taihaku Cc Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Kurokawa County',
                'Kurokawa County',
                'Unavailable',
                'Taiwa solar farm',
                'Kyocera TCL Solar LLC',
                'Tokyo Century Corporation [81%]; Kyocera Corporation [19%]',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Takahagi',
                'Unavailable',
                'Unavailable',
                'Takahagi Arakawa Solar Power Plant',
                'Sojitz Mirai Power',
                'Sojitz Mirai Power',
              ],
              [
                'Japan',
                36,
                'Asia',
                'Yamagata County',
                'Yamagata County',
                'Unavailable',
                'SGET Hiroshima Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'Unknown',
              ],
              [
                'Japan',
                43,
                'Asia',
                'Kitakyushu',
                'Unavailable',
                'Unavailable',
                'Takataya Hibiki solar farm',
                'Unknown',
                'Takataya Co., Ltd.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Yoshino County',
                'Yoshino County',
                'Unavailable',
                'Yoshino Town Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                29,
                'Asia',
                'Yonago',
                'Unavailable',
                'Unavailable',
                'Yonago solar farm',
                'Kyocera TCL Solar LLC',
                'Tokyo Century Corporation [81%]; Kyocera Corporation [19%]',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Yokkaichi',
                'Unavailable',
                'Unavailable',
                'Yokkaichi Solar Power Plant',
                'Yokkaichi Solar G.K.',
                'RENOVA, Inc.',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Yatsubo',
                'Nasushiobara City',
                'Tochigi',
                'Yatsubo Solar Power Plant',
                'Unknown',
                'First Solar',
              ],
              [
                'Japan',
                38,
                'Asia',
                'Tomiya',
                'Unavailable',
                'Unavailable',
                'Yamato Tomiya Mega Solar Power Plant',
                'Unknown',
                'X-Elio Japan',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Hagi City',
                'Unavailable',
                'Yamaguchi',
                'Yamaguchi Hagi Mega Solar Power Plant',
                'Unknown',
                'Tokyo Century Leasing Corporation [81%]; Kyocera Corporation [19%]',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Higashiokitama County',
                'Higashiokitama County',
                'Unavailable',
                'Yamagata Kawanishi solar farm',
                'Grupo Ortiz',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kumamoto',
                'Yamaga solar farm',
                'GSSE G.K.',
                'Surge Energy Corporation Limited',
              ],
              [
                'Japan',
                33,
                'Asia',
                'Shimohei County',
                'Shimohei County',
                'Unavailable',
                'Yamadamachi solar farm',
                'Unknown',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Yaita City',
                'Shioya County',
                'Tochigi',
                'Yaita solar farm',
                'Vena Energy',
                'Unknown',
              ],
              [
                'Japan',
                41,
                'Asia',
                'Sakura',
                'Unavailable',
                'Unavailable',
                'Yaita solar farm',
                'Vena Energy',
                'Vena Energy',
              ],
              [
                'Japan',
                31,
                'Asia',
                'Agatsuma County',
                'Agatsuma County',
                'Unavailable',
                'Takayama Village Solar Power Plant',
                'Unknown',
                'Isolux Cors\u00e1n',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Nasushiobara',
                'Unavailable',
                'Unavailable',
                'Nasu Shiobara Solar Power Plant',
                'Nasu-Shiobara Solar GK',
                'Unknown',
              ],
              [
                'Japan',
                36,
                'Asia',
                'Minamisoma',
                'Unavailable',
                'Unavailable',
                'SGET Haramachi Minami Mega Solar',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
                'SPARX Green Energy & Technology Co., Ltd. (SGET)',
              ],
              [
                'Japan',
                38,
                'Asia',
                'Sendai City',
                'Unavailable',
                'Miyagi',
                'Sendai Okurayama solar farm',
                'GK Sendai',
                'Gunkul International (Maruitius)(GIM) [100%]',
              ],
              [
                'Japan',
                48,
                'Asia',
                'Kunohe County',
                'Kunohe County',
                'Unavailable',
                'Karumai West Solar Power Plant',
                'Karumai West Solar G.K.',
                'Unknown',
              ],
              [
                'Japan',
                41,
                'Asia',
                'Kunohe County',
                'Kunohe County',
                'Unavailable',
                'Karumai Sonbou Solar Power Plant',
                'Karumai Sonbou Solar G.K.',
                'RENOVA, Inc.; The Dai-ichi Life Insurance Company, Limited',
              ],
              [
                'Japan',
                81,
                'Asia',
                'Karumai',
                'Kunohe',
                'Iwate',
                'Karumai East Solar Power Plant',
                'Karumai East Solar G.K.',
                'Unknown',
              ],
              [
                'Japan',
                100,
                'Asia',
                'Kanoya City',
                'Unavailable',
                'Kagoshima',
                'Kanoya Osaki Solar Hills Solar Power Plant',
                'Kanoya Osaki Solar Hills LLC',
                'GF Corporation [72.7%]; Kyocera Corporation [9.1%]; Kyudenko Corporation [9.1%]; Tokyo Century Corporation [9.1%]',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Kanegasaki',
                'Isawa',
                'Iwate',
                'Kanegasaki GC Solar Power Plant',
                'Unknown',
                'Comsys Create Co., Ltd.',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Nakagawa',
                'Nasu',
                'Tochigi',
                'Kanagawa Electric Power Tochigi Solar Power Plant',
                'Unknown',
                'Kanagawa Electric Power Co., Ltd',
              ],
              [
                'Japan',
                31,
                'Asia',
                'Kamogawa',
                'Unavailable',
                'Unavailable',
                'Kamogawa Solar Power Plant',
                'JGC Holdings Corporation',
                'JGC Holdings Corporation',
              ],
              [
                'Japan',
                71,
                'Asia',
                'Rokkasho',
                'Kamikita',
                'Aomori',
                'Kamikita Rokkasho solar farm',
                'Mirai Power Corporation',
                'Sojitz Corporation [100%]',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Toyota',
                'Unavailable',
                'Unavailable',
                'Kamatsuchi Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                70,
                'Asia',
                'Kagoshima',
                'Unavailable',
                'Unavailable',
                'Kagoshima Nanatsujima Mega Solar Power Plant',
                'Kyocera Solar Corporation; Kyudenko Corporation',
                'Kyocera Corporation; KDDI Corporation; IHI Corporation; Kyudenko Corporation; Kagoshima Bank, Ltd.; Bank of Kyoto, Ltd.; Takenaka Corporation',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Kirishima',
                'Unavailable',
                'Unavailable',
                'Kagoshima Kirishima solar farm',
                'juwi Shizen Energy Operation Co., Ltd.',
                'Unknown',
              ],
              [
                'Japan',
                80,
                'Asia',
                'Kamimashiki County',
                'Kamimashiki County',
                'Unavailable',
                'Jre Yamato Takamori Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Tsuchiura',
                'Unavailable',
                'Unavailable',
                'Jre Tsuchiura Solar Power Plant',
                'GK JRE Tsuchiura',
                'Unknown',
              ],
              [
                'Japan',
                54,
                'Asia',
                'Satsuma',
                'Satsuma-gun',
                'Kagoshima',
                'Jre Satsuma Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                37,
                'Asia',
                'Kawakami',
                'Minamisaku',
                'Nagano',
                'Kawakami Solar Project',
                'Unknown',
                'Vena Energy',
              ],
              [
                'Japan',
                63,
                'Asia',
                'Aso County',
                'Aso County',
                'Unavailable',
                'Jre Aso Takamori Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Iwanuma',
                'Unavailable',
                'Unavailable',
                'Iwanuma Rinku Mega Solar Power Plant',
                'Marubeni Corporation',
                'Marubeni Corporation',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Iwakuni',
                'Unavailable',
                'Unavailable',
                'Iwakuni Yuu Solar Power Plant',
                'juwi Shizen Energy Operation Co., Ltd.',
                'Shizen Energy Inc.',
              ],
              [
                'Japan',
                98,
                'Asia',
                'Iwakuni City',
                'Unavailable',
                'Yamaguchi',
                'Iwakuni solar farm',
                'East Japan Solar 13 Godo Kaisha',
                'Unknown',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Iwaki',
                'Unavailable',
                'Unavailable',
                'Iwaki solar farm',
                'Unknown',
                'Ratchaburi Electricity Generation [60%]; Chow Steel Industries [40%]',
              ],
              [
                'Japan',
                35,
                'Asia',
                'Kita-Ibaraki City',
                'Unavailable',
                'Ibaraki',
                'Isohara solar farm',
                'Unknown',
                'D&D Solar GK',
              ],
              [
                'Japan',
                60,
                'Asia',
                'Takaoka City',
                'Unavailable',
                'Toyama',
                'Ishikawa Sogo Solar Power Plant',
                'First Solar',
                'Sumitomo Mitsui Finance & Leasing Co., Ltd. (SMFL)',
              ],
              [
                'Japan',
                29,
                'Asia',
                'Tamura County',
                'Tamura County',
                'Unavailable',
                'Ip Fukushima Ono Town solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Takakuhei',
                'Nasu',
                'Tochigi',
                'Ikeda Solar Power Plant',
                'Unknown',
                'First Solar',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Ichinoseki',
                'Unavailable',
                'Unavailable',
                'Ichinoseki solar farm',
                'Unknown',
                'Global Power Synergy Public Company Limited',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Sakuho',
                'Minamisaku County',
                'Nagano',
                'Ichijo Mega Solar Nagano Sakuho Ohinata Daiichi Power Station',
                'Unknown',
                'Ichigo Inc.',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Sakuho',
                'Minamisaku',
                'Nagano',
                'Ichijo Mega Solar Nagano Sakuho Ohinata Daiichi Power Station',
                'Unknown',
                'Ichigo Inc.',
              ],
              [
                'Japan',
                58,
                'Asia',
                'Sakuho',
                'Minamisaku',
                'Nagano',
                'Ichijo Mega Solar Nagano Sakuho Ohinata Daiichi Power Station',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                43,
                'Asia',
                'Numata',
                'Tone County',
                'Unavailable',
                'Ichigo Showamura Ogose ECO solar farm',
                'Ichigo ECO Energy',
                'ECO Energy Co., Ltd.',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Hyuga City',
                'Unavailable',
                'Miyazaki',
                'Hyugahichiya Solar Power Station',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                40,
                'Asia',
                'Izu City',
                'Unavailable',
                'Shizuoka',
                'Izu Skyline Cc Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                56,
                'Asia',
                'Kawasaki',
                'Shibata',
                'Miyagi',
                'Kawasaki Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Miyagi',
                'Kesennuma solar farm',
                'BRE Singapore Pte.',
                'Banpu Group',
              ],
              [
                'Japan',
                38,
                'Asia',
                'Kimitsu',
                'Unavailable',
                'Unavailable',
                'Kimitsu Mega Solar',
                'Kimitsu Mega Solar Goda Kaisha (GK Kimitsu)',
                'Gunkul International (Maruitius) (GIM) [100%]',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Nanao',
                'Noto Peninsula',
                'Ishikawa',
                'Nanao Solar Park',
                'Total Solar International',
                'Unknown',
              ],
              [
                'Japan',
                28,
                'Asia',
                'Namekata',
                'Unavailable',
                'Unavailable',
                'Namegata Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                47,
                'Asia',
                'Suwa',
                'Unavailable',
                'Unavailable',
                'Nagano Suwa Golf Mega Solar Power Plant',
                'Sonnedix Japan Co., Ltd.',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                50,
                'Asia',
                'Morioka',
                'Unavailable',
                'Iwate',
                'Morioka Solar Power Plant',
                'Taiyama Mega Nikko; LSIS Japan',
                'Unknown',
              ],
              [
                'Japan',
                67,
                'Asia',
                'Mobara City',
                'Unavailable',
                'Chiba',
                'Mobara City solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                33,
                'Asia',
                'Higashimorokata County',
                'Higashimorokata County',
                'Unavailable',
                'Miyazaki Tortoise Shell Solar Power Plant',
                'Unknown',
                'NTT Facilities, Inc.',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Hyuga City',
                'Unavailable',
                'Miyazaki',
                'Miyazaki Hyuga No.2 Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                44,
                'Asia',
                'Ebino City',
                'Unavailable',
                'Miyazaki',
                'Miyazaki Ebino Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Miyama',
                'Unavailable',
                'Unavailable',
                'Miyama Solar Power Plant',
                'Unknown',
                'Shibaura Group Holdings',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Miyako',
                'Unavailable',
                'Iwate',
                'Miyako Solar Park',
                'Total Solar International',
                'Total Solar International; Chubu Electric Power Co., Inc.',
              ],
              [
                'Japan',
                52,
                'Asia',
                'Kurokawa County',
                'Kurokawa County',
                'Unavailable',
                'Miyagi Osato Solar Park',
                'Miyagi Osato Solar',
                'Total Solar International [90%]; SB Energy Corp. [10%]',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Tomakomai',
                'Unavailable',
                'Unavailable',
                'Mitsui Fudosan Tomakomai Solar Power Plant',
                'Unknown',
                'Mitsui Fudosan Co., Ltd.',
              ],
              [
                'Japan',
                36,
                'Asia',
                'Kasama',
                'Unavailable',
                'Unavailable',
                'Mito Solar Power Plant',
                'Schneider Electric',
                'Unknown',
              ],
              [
                'Japan',
                44,
                'Asia',
                'Higashiibaraki County',
                'Higashiibaraki County',
                'Unavailable',
                'Mito New Town Mega Solar Park',
                'MITO New Town Mega Solar Park Godo Kaisha',
                'Unknown',
              ],
              [
                'Japan',
                60,
                'Asia',
                'Minamisoma',
                'Unavailable',
                'Unavailable',
                'Minamisoma Mano Umeda Ebi Solar Power Plant',
                'Solar Power Minamisoma Kashima Co., Ltd.',
                'Sumitomo Corporation; Sumitomo Corporation Tohoku Co., Ltd.',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Shimoshibusa',
                'Haramachi-ku',
                'Fukushima',
                'Minamisoma Haramachi Higashi Solar Power Plant',
                'Sumitomo Corporation',
                'Sumitomo Corporation',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Unavailable',
                'Minamimuro County',
                'Mie',
                'Mie Kintetsu solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Kirishima',
                'Unavailable',
                'Unavailable',
                'Kirishima City Solar Power Plant',
                'juwi Shizen Energy Operation Co., Ltd.',
                'juwi Shizen Energy Inc.',
              ],
              [
                'Japan',
                41,
                'Asia',
                'Kirishima',
                'Unavailable',
                'Unavailable',
                'Kirishima solar farm',
                'Tokyo Energy & Systems',
                'Solariant Portfolio Two GK',
              ],
              [
                'Japan',
                49,
                'Asia',
                'Kuwana County',
                'Kuwana County',
                'Unavailable',
                'Kisosaki Reclaimed Land Mega Solar',
                'Marubeni Corporation',
                'Unknown',
              ],
              [
                'Japan',
                98,
                'Asia',
                'Kitamurayama County',
                'Kitamurayama County',
                'Unavailable',
                'Kitamurayama solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Kusu County',
                'Kusu County',
                'Unavailable',
                'Kokonoe Solar Power Plant',
                'Kokonoe Solar GK',
                'Unknown',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Komatsushima',
                'Unavailable',
                'Unavailable',
                'Komatsushima Solar Power Plant',
                'Nippon Paper Mega Solar Komatsushima Limited Liability Company',
                'Nippon Paper Industries [50%]; Mitsubishi Corporation [50%]',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Hokota',
                'Unavailable',
                'Unavailable',
                'Hokota Solar Power Plant',
                'Unknown',
                'Enex Infrastructure Inv Corporatio',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kagawa',
                'Konpira Lakeside Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                36,
                'Asia',
                'Kurayoshi',
                'Unavailable',
                'Unavailable',
                'Kurayoshi solar farm',
                'Unknown',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Kushiro',
                'Unavailable',
                'Unavailable',
                'Kushiro Otobetsu Solar Power Plant',
                'Ecopower JP Co., Ltd.',
                'Ecopower JP Co., Ltd.',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Uji',
                'Unavailable',
                'Unavailable',
                'Kyoto Fushimi Mega Solar Power Plant',
                'Unknown',
                'Tokyo Century Leasing Corporation; Kyocera Corporation',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Katsuura',
                'Unavailable',
                'Unavailable',
                'Ls Chiba Katsuura solar farm',
                'Takara Leben',
                'KS Power 1',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Minamikyushu City',
                'Unavailable',
                'Kagoshima',
                'Makinouchi Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                50,
                'Asia',
                'Matsushima',
                'Miyagi County',
                'Miyagi',
                'Matsushima Donguri Solar Power Plant',
                'Unknown',
                'Japan Land Development',
              ],
              [
                'Japan',
                45,
                'Asia',
                'Koriyama',
                'Unavailable',
                'Unavailable',
                'Koriyama solar farm',
                'Unknown',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                235,
                'Asia',
                'Setouchi',
                'Unavailable',
                'Unavailable',
                'Setouchi Kirei Mega Solar Power Plant',
                'Setouchi Future Creations LLC',
                'Unknown',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Hitoyoshi City',
                'Unavailable',
                'Kumamoto',
                'Hitoyoshi Solar Power Plant',
                'Hitoyoshi Solar G.K.',
                'RENOVA, Inc.; Fuyo General Lease Co., Ltd.',
              ],
              [
                'Japan',
                56,
                'Asia',
                'Hitachi',
                'Unavailable',
                'Unavailable',
                'Hitachi Juo solar farm',
                'Unknown',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                96,
                'Asia',
                'Miyazaki City',
                'Unavailable',
                'Miyazaki',
                'Pacifico Energy Hosoe Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                42,
                'Asia',
                'Iwaki City',
                'Unavailable',
                'Fukushima',
                'Pacifico Energy Iwaki Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Kume County',
                'Kume County',
                'Unavailable',
                'Pacifico Energy Kumenan Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                42,
                'Asia',
                'Mimasaka',
                'Unavailable',
                'Unavailable',
                'Pacifico Energy Mimasaka Musashi Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                55,
                'Asia',
                'Gujyo City',
                'Unavailable',
                'Gifu',
                'Pacifico Energy Minami Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                258,
                'Asia',
                'Mimasaka City',
                'Unavailable',
                'Okayama',
                'Pacifico Energy Sakuto Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                62,
                'Asia',
                'Toyota City',
                'Unavailable',
                'Aichi',
                'Pacifico Energy Toyota Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                72,
                'Asia',
                'Himeji City',
                'Unavailable',
                'Hyogo',
                'Pacifico Energy Yumesaki Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Chosei',
                'Chosei',
                'Unavailable',
                'Reene Chonan Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                44,
                'Asia',
                'Soma',
                'Unavailable',
                'Unavailable',
                'Renatos Soma Solar Park',
                'GK Renatos Soma Solar Park',
                'Kyudenko Corporation [40%]; ORIX Corporation [30%]; Bell Techno Energy Co., Ltd. [19.8%]; Kyuden Mirai Energy Co., Ltd. [10%]; other',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Kesennuma',
                'Unavailable',
                'Unavailable',
                'Riene RJ Izumisawa Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Eichokori',
                'Minamikyushu City',
                'Kaogshima',
                'Riene RJ South Kyushu Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Kesennuma',
                'Unavailable',
                'Unavailable',
                'Riene RJ Urushihara Solar Power Plant',
                'Unknown',
                'Tokyu Land Corporation',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Kamikita County',
                'Kamikita County',
                'Unavailable',
                'Rokunohe Solar Park',
                'GK Rokunohe Solar Park',
                'Unknown',
              ],
              [
                'Japan',
                57,
                'Asia',
                'Kami County',
                'Kami County',
                'Unavailable',
                'Pacifico Energy Furukawa Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Karatsu',
                'Unavailable',
                'Unavailable',
                'Saga Ochi Solar Power Plant',
                'Kyudenko Corporation',
                'ITOCHU Corporation [50%]; Kyudenko Corporation [50%]',
              ],
              [
                'Japan',
                29,
                'Asia',
                'Sakata',
                'Unavailable',
                'Unavailable',
                'Saka Port Mega Solar Park',
                'Sakata Port Mega Solar Park G.K.',
                'Unknown',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Saku',
                'Saku City Mega Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                121,
                'Asia',
                'Sanda City',
                'Unavailable',
                'Hyogo',
                'Sanda Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Sanda City',
                'Unavailable',
                'Hyogo',
                'Sanda solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                54,
                'Asia',
                'Takasaki City',
                'Agatsuma County',
                'Gunma',
                'Sanko 72 Country Club solar farm',
                'Unknown',
                'ITOCHU Enex Co., Ltd. [100%]',
              ],
              [
                'Japan',
                54,
                'Asia',
                'Sano City',
                'Unavailable',
                'Tochigi',
                'Sano Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                42,
                'Asia',
                'Sano',
                'Unavailable',
                'Unavailable',
                'Sano solar farm',
                'juwi Shizen Energy Operation Inc.',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Kowa',
                'Kasai',
                'Hokkaido',
                'Sarabetsu/Tokachi Mega Solar Speedway Power Plant',
                'Unknown',
                'Orix Corporation',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Kamikita City',
                'Kamikita County',
                'Aomori',
                'Schichinohe solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Schichinohe',
                'Kamikita County',
                'Aomori',
                'Schichinohe solar farm',
                'Equis Energy',
                'Equis Energy',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Schichinohe',
                'Kamikita County',
                'Aomori',
                'Schichinohe solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Schichinohe',
                'Kamikita County',
                'Aomori',
                'Schichinohe solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Kamikita City',
                'Unavailable',
                'Aomori',
                'Schichinohe solar farm',
                'Equis Energy',
                'Equis Energy',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Sendai',
                'Unavailable',
                'Unavailable',
                'Sendai Imozawa Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                34,
                'Asia',
                'Saijo',
                'Unavailable',
                'Unavailable',
                'Saijo Komatsu Solar Power Station',
                'ITOCHU Corporation',
                'ITOCHU Corporation',
              ],
              [
                'Japan',
                102,
                'Asia',
                'Unavailable',
                'Ako',
                'Hyogo',
                'Pacifico Energy Ako Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                29,
                'Asia',
                'Omatsuzawa',
                'Kurokawa',
                'Miyagi',
                'Osata Solar Park',
                'juwi Shizen Energy Inc.; juwi Shizen Energy Operation Inc.; Trina Solar Japan Energy Co., Ltd.',
                'Banpu Power Public Company Limited',
              ],
              [
                'Japan',
                51,
                'Asia',
                'Tsu',
                'Unavailable',
                'Unavailable',
                'Orix 51M Tsu Mega Solar Power Plant',
                'Toenec',
                'Orix Corporation',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Kunohe County',
                'Kunohe County',
                'Unavailable',
                'Hirono Solar Power Plant',
                'Unknown',
                'X-Elio Japan',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Hirono',
                'Kunohe County',
                'Iwate',
                'Hirono solar farm',
                'Orix Corporation',
                'Orix Corporation',
              ],
              [
                'Japan',
                29,
                'Asia',
                'Hioki',
                'Unavailable',
                'Unavailable',
                'Hioki Foster Mother Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Kitsuki',
                'Unavailable',
                'Unavailable',
                'Hanwha Solar Power Kitsuki',
                'Unknown',
                'Hanwha Q Cells Japan',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Hagi',
                'Unavailable',
                'Unavailable',
                'Hagi solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                26,
                'Asia',
                'Natori City',
                'Unavailable',
                'Miyagi',
                'Natori Solarway',
                'Unknown',
                'JAG International Energy Co., Ltd.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Nihonmatsu',
                'Unavailable',
                'Unavailable',
                'Nihonmatsu Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                56,
                'Asia',
                'Niigata',
                'Unavailable',
                'Unavailable',
                'Niigata Yotsugoya solar farm',
                'Orix Corporation',
                'Orix Corporation',
              ],
              [
                'Japan',
                44,
                'Asia',
                'Nishishirakawa County',
                'Nishishirakawa County',
                'Unavailable',
                'Nishinosata Solar Park',
                'GK Nishinosato Solar Park',
                'Unknown',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Nishishirakawa County',
                'Nishishirakawa County',
                'Unavailable',
                'Nishiogohabuto Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Nogata',
                'Unavailable',
                'Unavailable',
                'Nogata Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                42,
                'Asia',
                'Futtsu',
                'Unavailable',
                'Unavailable',
                'Green Power Futtsu Solar Power Plan',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                40,
                'Asia',
                'Futtsu',
                'Unavailable',
                'Unavailable',
                'Futtsu Solar Power Plant',
                'Futtsu Solar Co., Ltd.',
                'RENOVA, Inc.; Mitsuuroko Green Energy Co., Ltd.',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Uji',
                'Unavailable',
                'Unavailable',
                'Fushimi solar farm',
                'Kyocera TCL Solar LLC',
                'Unknown',
              ],
              [
                'Japan',
                33,
                'Asia',
                'Omotegokomatsu',
                'Unavailable',
                'Fukushima',
                'Fukushima S13 Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Ishikawa City',
                'Unavailable',
                'Fukushima',
                'Fukushima Ishikawa Solar Power Plant',
                'Unknown',
                'Resol Renewable Energy Co., Ltd.',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Kuji County',
                'Kuji County',
                'Unavailable',
                'Fukuroda Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                56,
                'Asia',
                'Nishiatsucho',
                'Unavailable',
                'Yamaguchi',
                'Or Yamaguchi Mine Solar Power Plant',
                'Orix Corporation',
                'Orix Corporation',
              ],
              [
                'Japan',
                35,
                'Asia',
                'Tamura County',
                'Tamura County',
                'Unavailable',
                'Ono Solar Power Plant',
                'NRE Operations Co., Ltd. (NREO)',
                'Vena Energy',
              ],
              [
                'Japan',
                147,
                'Asia',
                'Osaki City',
                'Naruko-onsen',
                'Miyagi',
                'Onikoube Solar Power Plant',
                'PurpleSol G.K',
                'PurpleSol G.K',
              ],
              [
                'Japan',
                33,
                'Asia',
                'Agano City',
                'Unavailable',
                'Niigata',
                'Omuro Mega Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                82,
                'Asia',
                'Oita',
                'Unavailable',
                'Unavailable',
                'Oita Solar Power',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                39,
                'Asia',
                'Kusu County',
                'Kusu County',
                'Unavailable',
                'Oita solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                41,
                'Asia',
                'Hitachiomiya City',
                'Unavailable',
                'Ibaraki',
                'Hitachi Omiya solar farm',
                'NRE Operations Co., Ltd. (NREO)',
                'Unknown',
              ],
              [
                'Japan',
                45,
                'Asia',
                'Oita',
                'Unavailable',
                'Unavailable',
                'Oita Hiyoshibaru Solar Power Plant',
                'Kyudenko Corporation',
                'ITOCHU Corporation [50%]; Kyudenko Corporation [30%]; Mitsui Engineering & Shipbuilding Co., Ltd. [20%]',
              ],
              [
                'Japan',
                115,
                'Asia',
                'Kamikita County',
                'Kamikita County',
                'Unavailable',
                'Eurus Rokkasho Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Shiranuka County',
                'Shiranuka County',
                'Unavailable',
                'Eurus Shiranuka Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Nakagawa County',
                'Nakagawa County',
                'Unavailable',
                'Eurus Toyokoro Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                34,
                'Asia',
                'Awaji',
                'Unavailable',
                'Unavailable',
                'Eurus Tsunahigashi Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Soma County',
                'Soma County',
                'Unavailable',
                'F Litate Solar Power Plant',
                'Unknown',
                'NTT Facilities, Inc.',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Saku City',
                'Unavailable',
                'Nagano',
                'Fsps Happo Solar Power Plant, Saku City',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                21,
                'Asia',
                'Kitakyushu',
                'Unavailable',
                'Unavailable',
                'Energy Seed Kitakyushu Solar Power Plan',
                'Unknown',
                'Energy Seed Co., Ltd. [51%]; AGC [49%]',
              ],
              [
                'Japan',
                25,
                'Asia',
                'Ibawashiro',
                'Yama',
                'Fukushima',
                'Blue Power Bandai Inawashiro Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                27,
                'Asia',
                'Shimohei County',
                'Shimohei County',
                'Unavailable',
                'Tanabu solar farm',
                'juwi Shizen Energy Operation Inc.',
                'Sonnedix Japan Co., Ltd.',
              ],
              [
                'Japan',
                77,
                'Asia',
                'Unavailable',
                'Ako',
                'Hyogo',
                'Banshu Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                23,
                'Asia',
                'Tenri',
                'Unavailable',
                'Unavailable',
                'Tenri City Solar Park No.1 Power Plant',
                'Unknown',
                'Orix Corporation [70%]; Kyudenko Corporation [30%]',
              ],
              [
                'Japan',
                112,
                'Asia',
                'Wake',
                'Wake',
                'Okayama',
                'Bizen Mega-Solar Project',
                'Unknown',
                'Pacifico Energy K.K.',
              ],
              [
                'Japan',
                24,
                'Asia',
                'Agona City',
                'Unavailable',
                'Niigata',
                'Agano Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                32,
                'Asia',
                'Akkeshi County',
                'Akkeshi County',
                'Unavailable',
                'Akkeshi Mega Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Toyota City',
                'Unavailable',
                'Tohoku',
                'Amazon solar farm',
                'Unknown',
                'Amazon Web Services Inc. (AWS)',
              ],
              [
                'Japan',
                63,
                'Asia',
                'Annaka City',
                'Unavailable',
                'Gunma',
                'Annaka Solar Power Plant',
                'Unknown',
                'Tokyo Gas Co., Ltd.',
              ],
              [
                'Japan',
                162,
                'Asia',
                'Shiroishi City',
                'Unavailable',
                'Miyagi',
                'Amaterasu Shiroishi solar farm',
                'Unknown',
                'Vena Energy',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Arida',
                'Unavailable',
                'Unavailable',
                'Arita Solar Power Station',
                'Kansai Electric Power Group',
                'Kansai Electric Power Group',
              ],
              [
                'Japan',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Shizuoka',
                'Ashia solar farm',
                'Unknown',
                'Surge Energy Corporation Limited',
              ],
              [
                'Japan',
                22,
                'Asia',
                'Ashikita County',
                'Ashikita County',
                'Unavailable',
                'Ashikita Solar Power Stations',
                'OCE Ashikita Mega Solar',
                'Obayashi Gumi Co., Ltd.',
              ],
              [
                'Japan',
                35,
                'Asia',
                'Awaji',
                'Unavailable',
                'Unavailable',
                'Awaji Kibune Solar Power Plant',
                'Kanden Energy Solutions',
                'Yorigami Maritime Construction Group',
              ],
              [
                'Japan',
                100,
                'Asia',
                'Fyukushima City',
                'Unavailable',
                'Fukushima',
                'Azuma Kofuji Solar Power Plant',
                'Unknown',
                'Canadian Solar Group',
              ],
              [
                'Japan',
                30,
                'Asia',
                'Aomori City',
                'Unavailable',
                'Aomori',
                'Aomori Solar Power Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Jordan',
                600,
                'Middle East',
                'Unavailable',
                'Al-Jafr Sub-District',
                "Ma'an Qasabah District",
                'Masdar-Jordan Solar',
                'Masdar',
                'Masdar',
              ],
              [
                'Jordan',
                50,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Jordan Solar Two Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Jordan',
                23,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                "Ma'An Falcon solar farm",
                'Modern Arabia for Solar Energy (MASE)',
                'Catalyst Investment Management [50%]; Desert Technologies [25%]; Enerray [24%]; Seci Energia [1%]',
              ],
              [
                'Jordan',
                67,
                'Middle East',
                'Mafraq',
                'Mafraq Sub-District',
                'Mafraq Qasabah District',
                'Mafraq 1 Power Station solar farm',
                'Unknown',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Jordan',
                50,
                'Middle East',
                'Mafraq',
                'Badiah Shamaliyah Gharbiyah Sub-District',
                'Badiah Shamaliyah Gharbiyah District',
                'Mafraq Sunrise solar farm',
                'Central Electricity Generating Company (CEGCO)',
                'ACWA Power',
              ],
              [
                'Jordan',
                10,
                'Middle East',
                "Ma'an City",
                'Ayl Sub-District',
                "Ma'an Qasabah District",
                'Oryx solar farm',
                'Unknown',
                'Scatec Solar [90%]; Quest Energy Investments [10%]',
              ],
              [
                'Jordan',
                16,
                'Middle East',
                'Amman City',
                "Al-Jami'ah Sub-District",
                "Al-Jami'ah District",
                'Univ Jordan Solar Rooftop PV',
                'Jordan Electric Power Company (JEPCO); The University of Jordan',
                'Jordan Electric Power Company (JEPCO); The University of Jordan',
              ],
              [
                'Jordan',
                50,
                'Middle East',
                'Risheh',
                'Risheh',
                'Rwaished District',
                'Risha Solar Plant',
                'Central Electricity Generating Company (CEGCO)',
                'ACWA Power [51%]',
              ],
              [
                'Jordan',
                53,
                'Middle East',
                'Maan',
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                "Shams Ma'An solar farm",
                'First Solar',
                'Diamond Generating Europe Ltd.; Nebras Power Q.S.C.; Kawar Group',
              ],
              [
                'Jordan',
                10,
                'Middle East',
                'Aqaba',
                'Area A',
                'Unavailable',
                'Shamsuna Solar Plant',
                'Modern Arabia for Solar Energy (MASE)',
                'Catalyst Investment Management (CIM)',
              ],
              [
                'Jordan',
                13,
                'Middle East',
                'District 9',
                'Badiah Shamaliyah Gharbiyah Sub-District',
                'Badiah Shamaliyah Gharbiyah District',
                'UNHCR Zaatari Camp solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Jordan',
                24,
                'Middle East',
                'Mafraq',
                'Hosha Sub-District',
                'Badiah Shamaliyah Gharbiyah District',
                'Jordan Solar One Plant',
                'Unknown',
                'Kingdom for Energy Investments Company; RAI Energy International',
              ],
              [
                'Jordan',
                103,
                'Middle East',
                'Quwayrah',
                'Al Quairah Sub-District',
                'Quairah District',
                'Quweira Solar PV Plant',
                'Enviromena',
                'Jordanian Ministry of Energy and Mineral Resources (MEMR)',
              ],
              [
                'Jordan',
                20,
                'Middle East',
                'Hosha',
                'Hosha Sub-District',
                'Badiah Shamaliyah Gharbiyah District',
                'Hosha Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'Jordan',
                10,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Glae Solar Power Plant',
                'Scatec',
                'Greenland Alternative Energy (GLAE); European Jordanian Renewable Energy Projects LLC; Scatec Solar AS [40%]',
              ],
              [
                'Jordan',
                67,
                'Middle East',
                'Mafraq',
                'Mafraq Sub-District',
                'Mafraq Qasabah District',
                'Empire Solar Power Station',
                'Al Ambaratouria Li Taka Al Shamsia',
                'Fotowatio Renewable Ventures',
              ],
              [
                'Jordan',
                16,
                'Middle East',
                'Busayra Sub-District',
                'Busayra Sub-District',
                'Busayra District',
                'Adenium Rashadiya solar farm',
                'Adenium Energy Capital',
                'Lafarge Cement Jordan',
              ],
              [
                'Jordan',
                11,
                'Middle East',
                'Al Badia',
                'Bierain Sub-District',
                'Zarqa Qasabah',
                'Al Badiya solar farm',
                'Al Badiya Power Generation',
                'Philadelphia Solar',
              ],
              [
                'Jordan',
                50,
                'Middle East',
                "Ma'an City",
                'Al Husainiyah',
                'Huseiniya District',
                'Al Husainiyah solar farm',
                'AMEA Power; Philadelphia Solar',
                'AMEA Power [70%]; Philadelphia Solar [30%]',
              ],
              [
                'Jordan',
                12,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Al Safawi Arabia One Solar',
                'Alectris; Modern Arabia for Solar Energy (MASE)',
                'Arabia Trading & Consulting Company',
              ],
              [
                'Jordan',
                67,
                'Middle East',
                'Safawi',
                'Salhiya Sub-District',
                'Badiah Shamaliyah District',
                'Al Safawi Power Station solar farm',
                'Fotowatio Renewable Ventures; Modern Arabia for Solar Energy (MASE)',
                'Al-Safawi for Green Energy PSC',
              ],
              [
                'Jordan',
                12,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Al Ward Al Joury solar farm',
                'Martifer Solar',
                'Kingdom for Energy Investments Company; RAI Energy International',
              ],
              [
                'Jordan',
                12,
                'Middle East',
                'Al Badia',
                'Bierain Sub-District',
                'Zarqa Qasabah',
                'Al Badiya solar farm',
                'Al Badiya Power Generation',
                'Philadelphia Solar',
              ],
              [
                'Jordan',
                11,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Al Zanbaq solar farm',
                'Martifer Solar',
                'Voltalia [70%]; Kingdom Electricity [30%]',
              ],
              [
                'Jordan',
                21,
                'Middle East',
                "Ma'an",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                "Alcazar Ma'An solar farm",
                'Alcazar Energy Partners Jordan',
                'Alcazar Energy',
              ],
              [
                'Jordan',
                40,
                'Middle East',
                'Al-Manakher',
                'Marka Sub-District',
                'Marka District',
                'Am Solar Power Plant',
                'Nebras Power',
                'Nebras Power; AES Corporation; Mitsui & Co.',
              ],
              [
                'Jordan',
                248,
                'Middle East',
                'Amman City',
                'Muaqqar Sub-District',
                'Muaqqar District',
                'Baynouna Solar Plant',
                'Baynouna Solar Energy Company',
                'Masdar Clean Energy [70%]; Taaleri Energia [30%]',
              ],
              [
                'Jordan',
                33,
                'Middle East',
                'Unavailable',
                'Al-Jafr Sub-District',
                "Ma'an Qasabah District",
                'Disi Water solar farm',
                'The Ministry of Water and Irrigation',
                'The Ministry of Water and Irrigation',
              ],
              [
                'Jordan',
                20,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Qasabit Ma'an District",
                'Ejre Solar Plant',
                'Unknown',
                'Scatec Solar [50.1%]; European Jordanian Renewable Energy [49.9%]',
              ],
              [
                'Jordan',
                12,
                'Middle East',
                "Ma'an City",
                "Ma'an Sub-District",
                "Ma'an Qasabah District",
                'Al Zahrat Al Salam solar farm',
                'Martifer Solar',
                'Voltalia [70%]; Kingdom Electricity [30%]',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Otrar',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Otrar (Eni) solar farm',
                'Unknown',
                'Arm Wind Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                35,
                'Asia',
                'Unavailable',
                'Saryagash District',
                'Otrar',
                'Otrar (Promondis Kazakhstan) solar farm',
                'Unknown',
                'Promondis Kazakhstan Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                30,
                'Asia',
                'Unavailable',
                'Saryagash District',
                'Sairam',
                'Sairam solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Saran solar farm',
                'Goldbeck Solar GmbH',
                'Solarnet Investment GmbH',
              ],
              [
                'Kazakhstan',
                20,
                'Asia',
                'Unavailable',
                'Saryagash',
                'Unavailable',
                'Saryagash solar farm',
                'Unknown',
                'EcoProTech-Astana Limited Liability Partnership; DERA GmbH',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                'Mangystau District',
                'Tupkaragan',
                'Tupkaragan solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Shoktas solar farm',
                'Unknown',
                'Hevel Group',
              ],
              [
                'Kazakhstan',
                63,
                'Asia',
                'Unavailable',
                'Sozak District',
                'Sozak',
                'Suzak solar farm',
                'Unknown',
                'YUKSES (Risen Energy) Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                30,
                'Asia',
                'Zharma District',
                'Zharma District',
                'Unavailable',
                'Zhangiz-Tobe solar farm',
                'Unknown',
                'Universal Energy Company Limited (UE)',
              ],
              [
                'Kazakhstan',
                28,
                'Asia',
                'Unavailable',
                'Zhuldyz',
                'Unavailable',
                'Zhuldyz solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                100,
                'Asia',
                'Kapshagay',
                'Ulytau District',
                'Unavailable',
                'Nurgisa solar farm',
                'Unknown',
                'Universal Energy Company Limited (UE)',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                'Shaulder',
                'Unavailable',
                'Shaulder solar farm',
                'Unknown',
                'Arm Wind Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nura solar farm',
                'Unknown',
                'Hevel Group',
              ],
              [
                'Kazakhstan',
                24,
                'Asia',
                'Unavailable',
                '\u0422\u0430\u0440\u0430\u0437 \u0413.\u0410.',
                'Zhambyl',
                'Zhambyl solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                100,
                'Asia',
                'Unavailable',
                'Shu',
                'Unavailable',
                'M-Kat solar farm',
                'Unknown',
                'Total Eren',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Akadyr',
                'Shet District',
                'Unavailable',
                'Akadyr solar farm',
                'Goldbeck Solar GmbH',
                'Goldbeck Solar GmbH',
              ],
              [
                'Kazakhstan',
                26,
                'Asia',
                'Akadyr',
                'Shet District',
                'Unavailable',
                'Akadyr solar farm',
                'Goldbeck Solar GmbH',
                'Goldbeck Solar GmbH',
              ],
              [
                'Kazakhstan',
                35,
                'Asia',
                'Unavailable',
                'Kurmangazy district',
                'Unavailable',
                'Atyrau solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Baikonur',
                'Unavailable',
                'Unavailable',
                'Baikonur solar farm',
                'Unknown',
                'Samruk Kazyna - United Green Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                40,
                'Asia',
                'Unavailable',
                'Saryagash District',
                'Baydikbeck',
                'Baydikbek solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Zhualy District',
                '\u0416\u0443\u0430\u043b\u044b\u043d\u0441\u043a\u0438\u0439 \u0440\u0430\u0439\u043e\u043d',
                'Unavailable',
                'Burnoye solar farm',
                'Unknown',
                'Samruk Kazyna - United Green Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Zhualy District',
                '\u0416\u0443\u0430\u043b\u044b\u043d\u0441\u043a\u0438\u0439 \u0440\u0430\u0439\u043e\u043d',
                'Unavailable',
                'Burnoye solar farm',
                'Unknown',
                'Samruk Kazyna - United Green Limited Liability Partnership',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Chulakkurgan',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Chulakkurgan solar farm',
                'Unknown',
                'Risen Energy Company',
              ],
              [
                'Kazakhstan',
                28,
                'Asia',
                'Unavailable',
                'Zhalagash',
                'Unavailable',
                'Nomad solar farm',
                'Unknown',
                'Total Eren',
              ],
              [
                'Kazakhstan',
                40,
                'Asia',
                'Aktogay District',
                'Aktogay District',
                'Unavailable',
                'Gulshat solar farm',
                'Unknown',
                'Risen Energy Company',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Kentau (Jiangsu Zhengfa) solar farm',
                'Unknown',
                'Jiangsu Zhenfa Holdings Group Company Limited',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Globalia Kft solar farm',
                'Unknown',
                'Globalia Kft Company',
              ],
              [
                'Kazakhstan',
                29,
                'Asia',
                'Unavailable',
                'Akzhaik District',
                'Unavailable',
                'Kulan solar farm',
                'Unknown',
                'ACME Cleantech Solutions Private Limited Company',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                '\u0422\u0443\u0440\u043a\u0435\u0441\u0442\u0430\u043d \u0413.\u0410. - Turkestan \u049a.\u04d8.',
                'Unavailable',
                'Kentau (Hevel) solar farm',
                'Unknown',
                'Hevel Group',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                'Aral District',
                'Unavailable',
                'Kyzylorda solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Kazakhstan',
                50,
                'Asia',
                'Unavailable',
                'Ulytau District',
                'Unavailable',
                'Kaskelen solar farm',
                'Unknown',
                'Universal Energy Company Limited (UE)',
              ],
              [
                'Kazakhstan',
                75,
                'Asia',
                'Unavailable',
                'Saryagash District',
                'Unavailable',
                'Kapshagay solar farm',
                'Unknown',
                'Promondis Kazakhstan Limited Liability Partnership',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Radiant solar farm',
                'Unknown',
                'Frontier Investment Management; Selenkei Investmennt; Cedate; Paramount Universal Bank',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Mbeere South Constituency',
                'Unavailable',
                'Unavailable',
                'Seven Forks solar farm',
                'Unknown',
                'Kenya Electricity Generation Company',
              ],
              [
                'Kenya',
                30,
                'Africa',
                'Mwale Medical and Technology City',
                'Unavailable',
                'Butere Sub-county',
                'Mwale Mtc solar farm',
                'Unknown',
                'Mcx Environmental Energy Corp',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Malindi solar farm',
                'Unknown',
                'Africa Energy Development Corporation [10%]; Globeleq [90%]',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Lamu',
                'Unavailable',
                'Unavailable',
                'Lamu Kensen solar farm',
                'Unknown',
                'Kenya Solar Energy Limited',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kitui solar farm',
                'Unknown',
                'Looop Inc.',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Siaya County solar farm',
                'Unknown',
                'Xago Africa',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Rumuruti',
                'Unavailable',
                'Unavailable',
                'Rumuruti solar farm',
                'Unknown',
                'Kenergy Renewable',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Kagati',
                'Unavailable',
                'Unavailable',
                'Nyeri solar farm',
                'Unknown',
                'Kumar and Associates',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Kisumu',
                'Unavailable',
                'Unavailable',
                'Kisumu Solar Farm',
                'Unknown',
                'Ergon Solair',
              ],
              [
                'Kenya',
                55,
                'Africa',
                'Eldoret',
                'Unavailable',
                'Unavailable',
                'Kesses 2 solar farm',
                'Unknown',
                'Alten Energ\u00edas Renovables',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Isiolo solar farm',
                'Unknown',
                'Greenmillenia Energy',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Kopera Village',
                'Unavailable',
                'Unavailable',
                'Voltalia Kopere Solar Farm',
                'Unknown',
                'Voltalia',
              ],
              [
                'Kenya',
                54,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Garissa solar farm',
                'Kenya Electricity Generating Company',
                'Rural Energy Authority',
              ],
              [
                'Kenya',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cedata solar farm',
                'Unknown',
                'Frontier Investment Management; Selenkei Investmennt; Cedate; Paramount Universal Bank',
              ],
              [
                'Kenya',
                55,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kesses solar farm',
                'Unknown',
                'Alten Energ\u00edas Renovables',
              ],
              [
                'Kosovo',
                30,
                'Europe',
                'Unavailable',
                'Kamenica Municipality',
                'Gjilan District',
                'Ps Kamenica-3 solar farm',
                'Air Energy 2',
                'Unknown',
              ],
              [
                'Kosovo',
                150,
                'Europe',
                'Unavailable',
                'Gjakova Municipality',
                'Gjakova District',
                'Gjakova solar farm',
                'KOSTT',
                'Solar Energy Group Europe',
              ],
              [
                'Kuwait',
                300,
                'Middle East',
                'Unavailable',
                'Shagaya Renewable Energy Park',
                'Unavailable',
                'Al Shagaya Solar Energy Ii',
                'Kuwait National Petroleum Company (KNPC)',
                'Kuwait Institute for Scientific Research (KISR); Kuwait National Petroleum Company (KNPC)',
              ],
              [
                'Kuwait',
                1500,
                'Middle East',
                'Dabdaba',
                'Shagaya Renewable Energy Park',
                'West Kuwait',
                'Al-Dibdibah PV Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Kuwait',
                10,
                'Middle East',
                'Umm Gudair',
                'Unavailable',
                'West Kuwait',
                'Sidrah 500 solar farm',
                'Gestamp Solar',
                'Kuwait Oil Company (KOC)',
              ],
              [
                'Kuwait',
                5000,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'North Kuwait Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Kuwait',
                1500,
                'Middle East',
                'Unavailable',
                'Shagaya Renewable Energy Park',
                'Unavailable',
                'Al Shagaya Solar Energy Ii',
                'Kuwait National Petroleum Company (KNPC)',
                'Kuwait Institute for Scientific Research (KISR); Kuwait National Petroleum Company (KNPC)',
              ],
              [
                'Kuwait',
                1500,
                'Middle East',
                'Unavailable',
                'Shagaya Renewable Energy Park',
                'Unavailable',
                'Al Shagaya Solar Energy Ii',
                'Kuwait National Petroleum Company (KNPC)',
                'Kuwait Institute for Scientific Research (KISR); Kuwait National Petroleum Company (KNPC)',
              ],
              [
                'Kuwait',
                10,
                'Middle East',
                'Unavailable',
                'Shagaya Renewable Energy Park',
                'Unavailable',
                'Al Shagaya Solar Energy I',
                'Unknown',
                'Kuwait Institute for Scientific Research (KISR)',
              ],
              [
                'Kuwait',
                300,
                'Middle East',
                'Unavailable',
                'Shagaya Renewable Energy Park',
                'Unavailable',
                'Al Shagaya Solar Energy Ii',
                'Kuwait National Petroleum Company (KNPC)',
                'Kuwait Institute for Scientific Research (KISR); Kuwait National Petroleum Company (KNPC)',
              ],
              [
                'Kyrgyzstan',
                30,
                'Asia',
                'Unavailable',
                '\u041f\u0430\u043d\u0444\u0438\u043b\u043e\u0432\u0441\u043a\u0438\u0439 \u0440\u0430\u0439\u043e\u043d - \u041f\u0430\u043d\u0444\u0438\u043b\u043e\u0432 \u0440\u0430\u0439\u043e\u043d\u0443',
                'Panfilov',
                'Panfilov solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Laos',
                64,
                'Asia',
                'Unavailable',
                'Sanamxay District',
                'Unavailable',
                'SAPP solar farm',
                'Unknown',
                'nValid Precision Engineering Private Limited',
              ],
              [
                'Laos',
                240,
                'Asia',
                'Unavailable',
                'Khamkeut District',
                'Unavailable',
                'Nam Theun 2 solar farm',
                'Unknown',
                'Electricit\u00e9 De France (EDF); Lao Holding State Enterprise (LHSE); Eletricity Generating Public Company (EGCO)',
              ],
              [
                'Lesotho',
                40,
                'Africa',
                'Ha Ramarothole',
                'Mafeteng district',
                'Unavailable',
                'Ha Ramarothole solar farm',
                'Unknown',
                'Government of Lesotho',
              ],
              [
                'Lesotho',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Neo 1 solar farm',
                'Scatec Solar',
                'Scatec Solar; KLP Norfund Investments AS; One Power Lesotho; Lesotho Pension Fund; Izuba Energy',
              ],
              [
                'Lesotho',
                30,
                'Africa',
                'Ha Ramarothole',
                'Mafeteng district',
                'Unavailable',
                'Ha Ramarothole solar farm',
                'Unknown',
                'Government of Lesotho',
              ],
              [
                'Liberia',
                20,
                'Africa',
                'Careysburg',
                'Careysburg',
                'Unavailable',
                'Mount Coffee solar farm',
                'Gigawatt Global',
                'Gigawatt Global',
              ],
              [
                'Libya',
                500,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Total Solar',
                'TotalEnergies; General Electricity Company of Libya',
                'TotalEnergies; General Electricity Company of Libya',
              ],
              [
                'Libya',
                100,
                'Africa',
                'Kufra',
                'Al Jawf Oasis',
                'Cufra distric',
                'Kufra Solar',
                'Unknown',
                'General Authority for Electricity and Renewable Energy (GAERE)',
              ],
              [
                'Madagascar',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ambatolampy solar farm',
                'Axian [51%]; GreenYellow [49%]',
                'Axian [51%]; GreenYellow [49%]',
              ],
              [
                'Madagascar',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ambatolampy solar farm',
                'Axian [51%]; GreenYellow [49%]',
                'Axian [51%]; GreenYellow [49%]',
              ],
              [
                'Malawi',
                21,
                'Africa',
                'Nkhotakota',
                'Nkhotakota District',
                'Unavailable',
                'Nkhotakota solar farm',
                'Unknown',
                'Phanes Group; responsAbility Renewable Energy Holding (rAREH)',
              ],
              [
                'Malawi',
                50,
                'Africa',
                'Nkhoma',
                'Lilongwe District',
                'Unavailable',
                'Nkhoma Deka solar farm',
                'Unknown',
                'Solarcentury Africa (SOCA); Renewable Energy Services Africa (RESA)',
              ],
              [
                'Malawi',
                20,
                'Africa',
                'Monkey Bay',
                'Mangochi District',
                'Unavailable',
                'Monkey Bay solar farm',
                'Unknown',
                'Droege Energy',
              ],
              [
                'Malawi',
                20,
                'Africa',
                'Golomoti',
                'Dedza District',
                'Unavailable',
                'Golomoti solar farm',
                'Unknown',
                'InfraCo Africa; JCM Power (JCM)',
              ],
              [
                'Malawi',
                60,
                'Africa',
                'Kanzimbe',
                'Salima District',
                'Unavailable',
                'Salima solar farm',
                'InfraCo Africa; JCM Power (JCM)',
                'InfraCo Africa; JCM Power (JCM); Matswani',
              ],
              [
                'Malawi',
                50,
                'Africa',
                'Bwengu',
                'Mzimba District',
                'Unavailable',
                'Bwengu solar farm',
                'Unknown',
                'Quantel Renewable Energy; Frontier Energy; Vidullanka Plc.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mukim Bebar solar farm',
                'Unknown',
                'Perbadanan Kemajuan Negeri Pahang; KPower Berhad (Kumpulan Powernet Berhad)',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mukim Tanjung solar farm',
                'Unknown',
                'TNB Sepang Solar Sdn. Bhd.',
              ],
              [
                'Malaysia',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Pekan',
                'Pekan (Hanwha Energy) solar farm',
                'Unknown',
                'Hanwha Energy Corporation',
              ],
              [
                'Malaysia',
                29,
                'Asia',
                'Lumut',
                'Unavailable',
                'Unavailable',
                'Lumut solar farm',
                'Unknown',
                'JAG Renewable Energy Sdn. Bhd. (JRESB)',
              ],
              [
                'Malaysia',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lse II solar farm',
                'Leader Solar Energy Sdn. Bhd.',
                'Leader Solar Energy Sdn. Bhd.',
              ],
              [
                'Malaysia',
                21,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kulim',
                'Kulim solar farm',
                'Unknown',
                'Energy ES Sdn Bhd',
              ],
              [
                'Malaysia',
                25,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Manjung',
                'Manjung solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Malaysia',
                66,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Merchang solar farm',
                'Scatec Solar',
                'Scatec Solar [49%]; Itramas Corp. Sdn Bhd',
              ],
              [
                'Malaysia',
                45,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Pekan',
                'Pekan (ReNIKOLA) solar farm',
                'Unknown',
                'reNIKOLA Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Sungai Petani',
                'Unavailable',
                'Unavailable',
                'Uzma Environergy solar farm',
                'Unknown',
                'Uzma Environergy Sdn. Bhd.',
              ],
              [
                'Malaysia',
                31,
                'Asia',
                'Pasir Gudang',
                'Unavailable',
                'Unavailable',
                'UiTM II solar farm',
                'UiTM Solar Power Dua Sdn Bhd (USP2SB)',
                'UiTM Energy & Facilities',
              ],
              [
                'Malaysia',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Seberang Perai',
                'Pulau Burung solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Malaysia',
                116,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Suria Sungai Petani solar farm',
                'Unknown',
                'Solarpack Corporaci\u00f3n Tecnol\u00f3gica, S.A.',
              ],
              [
                'Malaysia',
                49,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sungai Siput solar farm',
                'Sinar Kamiri Sdn. Bhd.',
                'Mudajaya Group Berhad',
              ],
              [
                'Malaysia',
                29,
                'Asia',
                'Sungai Petani',
                'Unavailable',
                'Unavailable',
                'Sungai Petani solar farm',
                'Leader Solar Energy Sdn. Bhd.',
                'Leader Solar Energy Sdn. Bhd.',
              ],
              [
                'Malaysia',
                450,
                'Asia',
                'Pengerang',
                'Unavailable',
                'Kota Tinggi',
                'Sultan Ibrahim solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Malaysia',
                30,
                'Asia',
                'Unavailable',
                'Sik',
                'Unavailable',
                'Sik solar farm',
                'Unknown',
                'Cypark Resources Berhad (Cypark)',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sabah solar farm',
                'Unknown',
                'JAKS Solar Power Sdn. Bhd.; Qhazanah Sabah Sdn. Bhd. (QSSB)',
              ],
              [
                'Malaysia',
                47,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Redsol solar farm',
                'Unknown',
                'Scatec Solar; Fumase (Malaysia) Sdn Bhd',
              ],
              [
                'Malaysia',
                29,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Zec solar farm',
                'Teknik Janakuasa Sdn Bhd (TJSB)',
                'Unknown',
              ],
              [
                'Malaysia',
                61,
                'Asia',
                'Gambang',
                'Unavailable',
                'Kuantan',
                'UiTM I solar farm',
                'UiTM Solar Power Sdn Bhd (USPSB)',
                'UiTM Energy & Facilities',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Pekan (Ragawang) solar farm',
                'Unknown',
                'Ragawang Corporation Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kuala Muda',
                'Kuala Muda solar farm',
                'Unknown',
                'Tenaga Nasional Berhad (TNB)',
              ],
              [
                'Malaysia',
                48,
                'Asia',
                'Kudat',
                'Unavailable',
                'Unavailable',
                'Kudat solar farm',
                'Unknown',
                'Tadau Energy Sdn. Bhd.',
              ],
              [
                'Malaysia',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bukit Selambau solar farm',
                'Tenaga',
                'Tenaga Nasional Berhad (TNB)',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Bukit Selambau',
                'Unavailable',
                'Unavailable',
                'Bukit Selambau solar farm',
                'Unknown',
                'Tenaga Nasional Berhad (TNB)',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Batang Padang',
                'Batang Padang solar farm',
                'Ranhill Utilities Berhad',
                'Ranhill Utilities Berhad',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Chuping',
                'Unavailable',
                'Unavailable',
                'Chuping (Classic) solar farm',
                'Unknown',
                'Classic Solar Farm Sdn. Bhd.',
              ],
              [
                'Malaysia',
                30,
                'Asia',
                'Chuping',
                'Unavailable',
                'Unavailable',
                'Chuping (Hanwha) solar farm',
                'Unknown',
                'Hanwha Energy Corporation; Beseri Jaya Sdn. Bhd. (KBJ)',
              ],
              [
                'Malaysia',
                116,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Marang',
                'Coara Marang solar farm',
                'Unknown',
                'Coara Solar sdn. Bhd.; ibvogt GmbH',
              ],
              [
                'Malaysia',
                30,
                'Asia',
                'Unavailable',
                'Danau Tok Uban',
                'Unavailable',
                'Danau Tok Uban (Cove Suria) solar farm',
                'Cypark Resources',
                'Cove Suria (CSSB); Kelantan Utilities Mubaarakan Holdings Sdn Bhd (KUM)',
              ],
              [
                'Malaysia',
                30,
                'Asia',
                'Unavailable',
                'Danau Tok Uban',
                'Unavailable',
                'Danau Tok Uban (Cypark) solar farm',
                'Unknown',
                'Cypark Resources Berhad (Cypark); Kelantan Utilities Mubaarakan Holdings Sdn Bhd (KUM)',
              ],
              [
                'Malaysia',
                38,
                'Asia',
                'Gebeng',
                'Unavailable',
                'Kuantan',
                'Gebeng solar farm',
                'reNIKOLA Sdn. Bhd.',
                'reNIKOLA Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Gopeng',
                'Unavailable',
                'Unavailable',
                'Gopeng solar farm',
                'Unknown',
                'Gopeng Bhd.',
              ],
              [
                'Malaysia',
                100,
                'Asia',
                'Bukit Tagar',
                'Unavailable',
                'Unavailable',
                'Bukit Tagar solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Malaysia',
                330,
                'Asia',
                'Bukit Kayu Hitam',
                'Unavailable',
                'Unavailable',
                'Kedah solar farm',
                'Unknown',
                'reNIKOLA Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Klang',
                'Klang solar farm',
                'Sharp Solar Ventures Sdn. Bhd.',
                'Sharp Ventures Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kevian',
                'Kevian solar farm',
                'Unknown',
                'Asiabina Properties Sdn. Bhd.',
              ],
              [
                'Malaysia',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kuala Ketil solar farm',
                'CGN Energy International Holdings Company Limited',
                'Edra Power',
              ],
              [
                'Malaysia',
                20,
                'Asia',
                'Unavailable',
                'Kawasan Kolam Takungan Air Serendah',
                'Daerah Ulu Selangor',
                'Kawasan Kolam Takungan Air Serendah Floating solar farm',
                'Unknown',
                'Tan Chong Motor Assemblies Sdn. Bhd.[51%]; APM Shock Absorbers Sdn. Bhd.[40%]; TCIM Sdn. Bhd.[9%]',
              ],
              [
                'Malaysia',
                65,
                'Asia',
                'Jasin',
                'Unavailable',
                'Unavailable',
                'Jasin solar farm',
                'Scatec Solar',
                'Scatec Solar [49%]; Itramas Corp. Sdn Bhd',
              ],
              [
                'Malaysia',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Hulu Selangor',
                'Hulu Selangor solar farm',
                'Unknown',
                'Tan Chong Motor Assemblies Sdn. Bhd.; APM Shock Absorbers Sdn. Bhd.; TCIM Sdn. Bhd.',
              ],
              [
                'Malaysia',
                65,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gurun solar farm',
                'Scatec Solar',
                'Scatec Solar [49%]; Itramas Corp. Sdn Bhd',
              ],
              [
                'Malaysia',
                26,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Kuala Langat',
                'Kuala Langat (Advancecon) solar farm',
                'Advancecon Solar Sdn. Bhd.',
                'Advancecon Solar Sdn. Bhd.',
              ],
              [
                'Maldives',
                36,
                'Asia',
                'Mal\u00e9',
                'Unavailable',
                'Unavailable',
                "Sinamale' Bridge solar farm",
                'Unknown',
                'Unknown',
              ],
              [
                'Mali',
                100,
                'Africa',
                'Di\u00e9ma',
                'Di\u00e9ma Cercle',
                'Di\u00e9ma',
                'Di\u00e9ma solar farm',
                'Pal 4 \u00c9nergie Solaire',
                'Mali Ministry of Energy and Water',
              ],
              [
                'Mali',
                50,
                'Africa',
                'Kita',
                'Kita Cercle',
                'Unavailable',
                'Akuo Kita solar farm',
                'Akuo Kita Solar',
                'Akuo Energy',
              ],
              [
                'Mali',
                30,
                'Africa',
                'Bafoulab\u00e9 Cercle',
                'Bafoulab\u00e9 Cercle',
                'Unavailable',
                'Fekola Gold Mine solar farm',
                'B2Gold',
                'Suntrace; BayWa r. e.',
              ],
              [
                'Mali',
                50,
                'Africa',
                'Tiakadougou-Dialakoro',
                'Kati Cercle',
                'Kati',
                'Amea Kati solar farm',
                'Amea Power',
                'Amea Power',
              ],
              [
                'Mali',
                93,
                'Africa',
                'Touna',
                'Bla Cercle',
                'Bla Cercle',
                'Touna solar farm',
                'Unknown',
                'Phanes Energy Mali-SA',
              ],
              [
                'Mali',
                20,
                'Africa',
                'Kadiolo Cercle',
                'Kadiolo Cercle',
                'Unavailable',
                'Syama Hybrid solar farm',
                'Aggreko',
                'Resolute Mining',
              ],
              [
                'Mali',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Sikasso Cercle',
                'Sikasso solar farm',
                'PowerPro',
                'PowerPro',
              ],
              [
                'Mali',
                30,
                'Africa',
                'Sikasso',
                'Unavailable',
                'Sikasso Cercle',
                'Sikasso solar farm',
                'PowerPro',
                'PowerPro',
              ],
              [
                'Mali',
                33,
                'Africa',
                'P\u00e9lengana',
                'S\u00e9gou Cercle',
                'S\u00e9gou Cercle',
                'Segou solar farm',
                'Scatec Solar',
                'Scatec Solar; IFC InfraVentures; Africa Power',
              ],
              [
                'Mauritania',
                15,
                'Africa',
                'Nouakchott',
                'Unavailable',
                'Unavailable',
                'Sheikh Zayed Solar Power Plant',
                'Soci\u00e9t\u00e9 Mauritanienne de l\u2019\u00e9lectricit\u00e9 (SOMELEC)',
                'Soci\u00e9t\u00e9 Mauritanienne de l\u2019\u00e9lectricit\u00e9 (SOMELEC)',
              ],
              [
                'Mauritania',
                50,
                'Africa',
                'Nouakchott',
                'Toujounine',
                'Unavailable',
                'Toujounine solar farm',
                'Unknown',
                'Soci\u00e9t\u00e9 Mauritanienne de l\u2019\u00e9lectricit\u00e9 (SOMELEC)',
              ],
              [
                'Mauritania',
                30,
                'Africa',
                'Nouakchott',
                'Unavailable',
                'Unavailable',
                'Nouakchott solar farm',
                'Unknown',
                'Soci\u00e9t\u00e9 Mauritanienne de l\u2019\u00e9lectricit\u00e9 (SOMELEC)',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Quintol Sol Chihuahua solar farm',
                'Quinto Sol Energ\u00eda 5',
                'Quinto Sol Energ\u00eda 5',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Los Cabos Municipality',
                'Unavailable',
                'Rho Comondu solar farm',
                'Rho Solar S De Rl De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                117,
                'North America',
                'Unavailable',
                'Canatl\u00e1n',
                'Canatlan',
                'Risen Energy solar farm',
                'Risen Energy',
                'Unknown',
              ],
              [
                'Mexico',
                1000,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Puerto Pe\u00f1asco Solar Project',
                'CFE (Comisi\u00f3n Federal de Electricidad)',
                'CFE (Comisi\u00f3n Federal de Electricidad)',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'RMCS Comercio Y Altair solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mexico',
                41,
                'North America',
                'Unavailable',
                'Municipio de Tecate',
                'La Rumorosa',
                'Rumorosa Solar Project',
                'Ienova',
                'Sempra Energy',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Villa de Arista',
                'Villa de Arista',
                'Unavailable',
                'Salsipuedes PV solar farm',
                'Gransolar',
                'Balam Fund; Gransolar',
              ],
              [
                'Mexico',
                112,
                'North America',
                'Unavailable',
                'Saltillo',
                'Saltillo',
                'Saltillo Aljaval solar farm',
                'Desarrollos Solares PV de M\u00e9xico V S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Benjam\u00edn Hill',
                'Benjamin Hill',
                'San Fernando PV solar farm',
                'Fisterra Energy',
                'Fisterra Energy',
              ],
              [
                'Mexico',
                39,
                'North America',
                'Unavailable',
                'Villa de Arista',
                'Villa de Arista',
                'San Luis Potos\u00ed PV solar farm',
                'Balam Fund',
                'Balam Fund',
              ],
              [
                'Mexico',
                138,
                'North America',
                'Pitiquito',
                'Pitiquito',
                'Unavailable',
                'Puerto Libertad Solar Park Project',
                'Acciona Mexico',
                'Acciona; Biofields',
              ],
              [
                'Mexico',
                25,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Hermosillo',
                'Ranchito Sur solar farm',
                'Fotovoltaica ENH, S.A. de C.V.',
                'Unknown',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Camargo',
                'Camargo',
                'Rancho El Trece PV solar farm',
                'Rancho El Trece Solar PV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                28,
                'North America',
                'Unavailable',
                'Municipio de Ju\u00e1rez',
                'Ciudad Juarez',
                'Sol De San Jer\u00f3nimo solar farm',
                'Sol De San Jer\u00f3nimo I, S. De R. L. De C. V.',
                'Sol De San Jer\u00f3nimo I, S. De R. L. De C. V.',
              ],
              [
                'Mexico',
                33,
                'North America',
                'San Pedro',
                'Municipio de La Paz',
                'La Paz',
                'San Marcos PV solar farm',
                'EPC Gea System',
                'EPC Gea System',
              ],
              [
                'Mexico',
                35,
                'North America',
                'Unavailable',
                'Irapuato',
                'Rancho Guadalupe',
                'San Miguel De Allende Solar Photovoltaic Plant',
                'Grenergy Guanajuato',
                'Grenergy',
              ],
              [
                'Mexico',
                182,
                'North America',
                'Unavailable',
                'Galeana',
                'Galeana',
                'Santa Mar\u00eda PV solar farm',
                'Zuma Energia',
                'State Power Investment Co.',
              ],
              [
                'Mexico',
                170,
                'North America',
                'Unavailable',
                'Villa de Arriaga',
                'Villa de Arriaga',
                'Santiago Arriaga PV Solar Park',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Mexico',
                27,
                'North America',
                'Unavailable',
                'Municipio de Comond\u00fa',
                'Comond\u00fa',
                'Sol De Insurgentes solar farm',
                'Engie Mexico',
                'Engie',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Cuauht\u00e9moc',
                'Cuauhtemoc',
                'Sol De Los Manzanos solar farm',
                'Sol De Los Manzanos S De Rl',
                'Sol De Los Manzanos S De Rl',
              ],
              [
                'Mexico',
                36,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Hermosillo',
                'Solar Energy Of Hermosillo solar farm',
                'Energ\u00eda Solar de Hermosillo S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                36,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Hermosillo',
                'Solar Energy Of Hermosillo solar farm',
                'Energ\u00eda Solar de Hermosillo S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                130,
                'North America',
                'Unavailable',
                'Zacoalco de Torres',
                'Unavailable',
                'Solar Park Viborillas',
                'White River Renewables',
                'Riverstone',
              ],
              [
                'Mexico',
                150,
                'North America',
                'El Llano',
                'El Llano',
                'Unavailable',
                'Solem Solar Power Plant',
                'Cubico Sustainable Investments',
                'Cubico Sustainable Investments',
              ],
              [
                'Mexico',
                140,
                'North America',
                'El Llano',
                'El Llano',
                'Unavailable',
                'Solem Solar Power Plant',
                'Cubico Sustainable Investments',
                'Cubico Sustainable Investments',
              ],
              [
                'Mexico',
                180,
                'North America',
                'Pitiquito',
                'Pitiquito',
                'Unavailable',
                'Puerto Libertad Solar Park Project',
                'Acciona Mexico',
                'Acciona; Biofields',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapil',
                'Solenergize Zacatecas Solar Project',
                'Solenergize Zacatecas',
                'Unknown',
              ],
              [
                'Mexico',
                400,
                'North America',
                'Unavailable',
                'Mexquitic de Carmona',
                'Unavailable',
                'San Luis Potos\u00ed PV solar farm',
                'Dhamma Energy',
                'Dhamma Energy',
              ],
              [
                'Mexico',
                342,
                'North America',
                'Unavailable',
                'Villa de Ramos',
                'Villa de Ramos',
                'Potosi solar farm',
                'Fotowatio Renewable Vent (FRV)',
                'Fotowatio Renewable Vent (FRV)',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Ensenada',
                'Ensenada',
                'Los Vallecitos Solar Park',
                'Tecnoambiente-Aljaval S.A. de C.V.',
                'Energ\u00eda Aljaval; Tecnoambiente',
              ],
              [
                'Mexico',
                296,
                'North America',
                'Unavailable',
                'Lagos de Moreno',
                'Lagos de Moreno',
                'Portero solar farm',
                'Fotowatio Renewable Vent (FRV)',
                'Fotowatio Renewable Vent (FRV)',
              ],
              [
                'Mexico',
                500,
                'North America',
                'Unavailable',
                'Papalotla de Xicoht\u00e9ncatl',
                'Unavailable',
                'La Magdalena solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mexico',
                220,
                'North America',
                'Hueyotlipan',
                'Benito Ju\u00e1rez',
                'Unavailable',
                'La Magdalena solar farm',
                'Enel',
                'Enel',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Los Cabos Municipality',
                'La Paz',
                'La Pasi\u00f3n PV solar farm',
                'Saferay Solar S. A. P. I. de C. V.',
                'Saferay Solar S. A. P. I. de C. V.',
              ],
              [
                'Mexico',
                50,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'La Trinidad solar farm',
                'Eosol Energy De Mexico Sapi De',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                58,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'La Trinidad solar farm',
                'Eosol Energy De Mexico Sapi De',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                118,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'La Trinidad solar farm',
                'Eosol Energy De Mexico Sapi De',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                100,
                'North America',
                'Matamoros',
                'Matamoros',
                'Torre\u00f3n',
                'Laguna Solar Park',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'Mexico',
                58,
                'North America',
                'Unavailable',
                'Rodeo',
                'Rodeo',
                'Las Animas Solar Power Plant',
                'Eosol Energy',
                'Eosol Energy',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Frontera',
                'Frontera',
                'Las Lomas De Ocampo solar farm',
                'Parque Solar Las Lomas Ocampo',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Frontera',
                'Frontera',
                'Las Lomas De Ocampo solar farm',
                'Parque Solar Las Lomas Ocampo',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Frontera',
                'Frontera',
                'Las Lomas De Ocampo solar farm',
                'Parque Solar Las Lomas Ocampo',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                130,
                'North America',
                'Ojuelos de Jalisco',
                'Ojuelos de Jalisco',
                'Unavailable',
                'Las Viborillas solar farm',
                'Solar Park Viborillas S De Rl',
                'White River Renewables',
              ],
              [
                'Mexico',
                38,
                'North America',
                'Unavailable',
                'Peto',
                'Peto',
                'L\u00e1zaro C\u00e1rdenas solar farm',
                'Alter EnerSun',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Ensenada',
                'Ensenada',
                'Los Vallecitos Solar Park',
                'Tecnoambiente-Aljaval S.A. de C.V.',
                'Energ\u00eda Aljaval; Tecnoambiente',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapil',
                'Solenergize Zacatecas Solar Project',
                'Solenergize Zacatecas',
                'Unknown',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'M\u00e9rida',
                'Unavailable',
                'Merida Isofoton solar farm',
                'Isofoton',
                'Isofoton',
              ],
              [
                'Mexico',
                82,
                'North America',
                'Unavailable',
                'Frontera',
                'Frontera',
                'M\u00e9xico Lindo solar farm',
                'M\u00e9xico Lindo Solar PV I S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                175,
                'North America',
                'Unavailable',
                'General Cepeda',
                'General Cepeda',
                'M\u00e9xico Lindo solar farm',
                'M\u00e9xico Lindo Solar PV II S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                22,
                'North America',
                'Hermosillo',
                'Hermosillo',
                'Unavailable',
                'Munisol Solar Park',
                'Unknown',
                'Sonora80M; GES',
              ],
              [
                'Mexico',
                22,
                'North America',
                'Matamoros',
                'Matamoros',
                'Unavailable',
                'Noacan solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mexico',
                200,
                'North America',
                'Calpulalpan',
                'Calpulalpan',
                'Unavailable',
                'Nueva Xcala PV Solar Park',
                'Engie',
                'Engie',
              ],
              [
                'Mexico',
                103,
                'North America',
                'Unavailable',
                'Ojocaliente',
                'Ojocaliente',
                'Ojocaliente solar farm',
                'Canadian Solar',
                'Canadian Solar',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Lagos de Moreno',
                'Unavailable',
                'Ojuelos Solar Park',
                'Parque Solar Ojuelos Sa De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                162,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Hermosillo',
                'Orejana PV solar farm',
                'Zuma Energia',
                'State Power Investment Co.',
              ],
              [
                'Mexico',
                191,
                'North America',
                'Unavailable',
                'Jes\u00fas Mar\u00eda',
                'Pachamama',
                'Pachamama PV Solar Power Plant',
                'Neoen',
                'Groupe Direct Energie',
              ],
              [
                'Mexico',
                467,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapi',
                'Palma Loca solar farm',
                'Desarrollo Fuerzas Renovables',
                'Desarrollo Fuerzas Renovables',
              ],
              [
                'Mexico',
                119,
                'North America',
                'Unavailable',
                'Perote',
                'Perote',
                'Perote Solar Photovoltaic Project',
                'X-Elio',
                'X-Elio',
              ],
              [
                'Mexico',
                110,
                'North America',
                'Caborca',
                'Caborca',
                'Unavailable',
                'Pima Solar Project',
                'Ienova - Infrae Ener Nova',
                'Unknown',
              ],
              [
                'Mexico',
                38,
                'North America',
                'Unavailable',
                'Galeana',
                'Galeana',
                'Pollux Solar Plant',
                'Pollux Energy Project Sa De Cv',
                'Reden Solar',
              ],
              [
                'Mexico',
                63,
                'North America',
                'Unavailable',
                'San Jos\u00e9 de Gracia',
                'Unavailable',
                'Potencia Photovoltaic Solar Power Plant',
                'Unknown',
                'Comisi\u00f3n Federal de Electricidad (CFE)',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapil',
                'Solenergize Zacatecas Solar Project',
                'Solenergize Zacatecas',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'San Fernando',
                'Unavailable',
                'Swb Guemez solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapil',
                'Solenergize Zacatecas Solar Project',
                'Solenergize Zacatecas',
                'Unknown',
              ],
              [
                'Mexico',
                29,
                'North America',
                'Municipio de Durango',
                'Municipio de Durango',
                'Unavailable',
                'Tai Durango solar farm',
                'Eosol Energy',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Municipio de Durango',
                'Municipio de Durango',
                'Unavailable',
                'Tai Durango solar farm',
                'Eosol Energy',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                60,
                'North America',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Unavailable',
                'Tampico Proteus Solar Plant',
                'Prana Power',
                'Artha Capital; Prana Gas',
              ],
              [
                'Mexico',
                30,
                'North America',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Unavailable',
                'Tampico PV solar farm',
                'Prana Power',
                'Artha Capital; Prana Gas',
              ],
              [
                'Mexico',
                125,
                'North America',
                'Unavailable',
                'Tastiota',
                'Hermosillo',
                'Tastiota Photovoltaic solar farm',
                'Korea Electric Power Co. (KEPCO)',
                'Korea Electric Power Co. (KEPCO); Sprott Korea',
              ],
              [
                'Mexico',
                50,
                'North America',
                'Unavailable',
                'Municipio de Muleg\u00e9',
                'Tecate',
                'Tecate solar farm',
                'SolMex Energy S.A. de C.V.',
                'Grupo Musa',
              ],
              [
                'Mexico',
                133,
                'North America',
                'Unavailable',
                'Tepezal\u00e1',
                'Tepezal\u00e1',
                'Tepezal\u00e1 Solar Project',
                'Tepezal\u00e1 Solar PV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                100,
                'North America',
                'Unavailable',
                'Tepezal\u00e1',
                'Tepezal\u00e1',
                'Tepezal\u00e1 Solar Project',
                'Ienova',
                'Sempra Energy',
              ],
              [
                'Mexico',
                120,
                'North America',
                'Unavailable',
                'Nuevo Urecho',
                'Jiqilp\u00e1n',
                'Tequila Solar PV Park',
                'Tequila Solar PV I S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                350,
                'North America',
                'Unavailable',
                'Saltillo',
                'Saltillo',
                'Tequila Solar PV Park',
                'Tequila Solar PV II S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                350,
                'North America',
                'Unavailable',
                'Champot\u00f3n',
                'Cuidad del Carmen',
                'Tequila Solar PV Park',
                'Tequila Solar PV III S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                80,
                'North America',
                'Unavailable',
                'Municipio de Ju\u00e1rez',
                'Ciudad Juarez',
                'Terranova-Conejos Medaros solar farm',
                'X-Elio',
                'X-Elio',
              ],
              [
                'Mexico',
                207,
                'North America',
                'Unavailable',
                'Ticul',
                'Ticul',
                'Ticul Solar Park',
                'Vega Solar',
                'Sun Power',
              ],
              [
                'Mexico',
                104,
                'North America',
                'Unavailable',
                'Ticul',
                'Ticul',
                'Ticul Solar Park',
                'Vega Solar',
                'Sun Power',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Unavailable',
                'Jimenez',
                'Torreoncitos PV solar farm',
                'Torreoncitos Solar PV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                159,
                'North America',
                'Unavailable',
                'Jes\u00fas Mar\u00eda',
                'Trompez\u00f3n',
                'Trompez\u00f3n Aljaval solar farm',
                'Recursos Solares PV de M\u00e9xico IV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                126,
                'North America',
                'Unavailable',
                'El Llano',
                'El Llano',
                'Trompez\u00f3n solar farm',
                'Heolios',
                'Engie; Tokyo Gas Co.',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Mazapil',
                'Unavailable',
                'Tuli solar farm',
                'Helios Generacion S De Rl De',
                'Cemex Energia; Pattern Energy',
              ],
              [
                'Mexico',
                118,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Versailles de las Cuatas',
                'Versailles Cuatas solar farm',
                'Eosol Energy',
                'Eosol Energy',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Ahumada',
                'Ahumada',
                'Unavailable',
                'Villa Ahumada solar farm',
                'BNB Renewables',
                'Engie',
              ],
              [
                'Mexico',
                200,
                'North America',
                'Unavailable',
                'Ahumada',
                'Moctezeuma',
                'Villa Ahumada solar farm',
                'BNB Renewables',
                'Engie',
              ],
              [
                'Mexico',
                36,
                'North America',
                'Unavailable',
                'Villa Comaltitl\u00e1n',
                'Villa Comaltitl\u00e1n',
                'Villa Comaltitl\u00e1n solar farm',
                'Villa Comaltitl\u00e1n Solar PV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Reyes',
                'Villa de Reyes',
                'Villa De Reyes San Luis Potos\u00ed solar farm',
                'Prosolia Internacional De Mexico',
                'Sunia Energy Solutions',
              ],
              [
                'Mexico',
                427,
                'North America',
                'Viesca',
                'Viesca',
                'Unavailable',
                'Villanueva Solar Park',
                'Enel Green Power (EGP)',
                'Unknown',
              ],
              [
                'Mexico',
                327,
                'North America',
                'Viesca',
                'Viesca',
                'Unavailable',
                'Villanueva Solar Park',
                'Enel Green Power (EGP)',
                'Unknown',
              ],
              [
                'Mexico',
                86,
                'North America',
                'Unavailable',
                'Puente de Ixtla',
                'Xoxocotla',
                'Xoxocotla solar farm',
                'X-Elio Fv Mexsolar',
                'X-Elio Fv Mexsolar',
              ],
              [
                'Mexico',
                158,
                'North America',
                'Unavailable',
                'Mapim\u00ed',
                'Mapim\u00ed',
                'Yermo Solar Park',
                'M\u00e9xico Lindo Solar PV IV, S.A. de C.V.',
                'M\u00e9xico Lindo Solar PV IV, S.A. de C.V.',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Guadalupe',
                'Guadalupe',
                'Zacsol Project solar farm',
                'Vertex Cos. Inc.',
                'Vertex Cos. Inc.',
              ],
              [
                'Mexico',
                130,
                'North America',
                'Unavailable',
                'Mapim\u00ed',
                'Torre\u00f3n',
                'La Lucha Solar Project',
                'Northland Power',
                'Northland Power',
              ],
              [
                'Mexico',
                23,
                'North America',
                'Municipio de Durango',
                'Municipio de Durango',
                'Unavailable',
                'Tai Durango solar farm',
                'Eosol Energy',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mazapil',
                'Mazapil',
                'Solenergize Zacatecas Solar Project',
                'Solenergize Zacatecas',
                'Unknown',
              ],
              [
                'Mexico',
                50,
                'North America',
                'Municipio de Durango',
                'Municipio de Durango',
                'Unavailable',
                'Tai Durango solar farm',
                'Eosol Energy',
                'Eosol Energy Sl',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Torreon solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Lagos de Moreno',
                'Unavailable',
                'Swb Acatlan solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Lagos de Moreno',
                'Unavailable',
                'Swb Altamira solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Swb Amozoc solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'Swb Arriaga solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Cos',
                'Unavailable',
                'Swb Calpulalpan solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Camargo solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Swb Campeche solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Chihuahua solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Swb Chilpancingo solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Ciudad Juarez solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Cos',
                'Unavailable',
                'Swb Costa Rica solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'Swb Durango solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Culiac\u00e1n',
                'Unavailable',
                'Swb Guamuchil solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Culiac\u00e1n',
                'Unavailable',
                'Swb Guasave solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Swb Hermosillo solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'Swb Macultepec solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'San Fernando',
                'Unavailable',
                'Swb Mante solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Zacoalco de Torres',
                'Unavailable',
                'Swb Manzanillo solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Cos',
                'Unavailable',
                'Swb Mazatlan solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Culiac\u00e1n',
                'Unavailable',
                'Swb Mochis solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Monclova solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Swb Navojoa solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'San Fernando',
                'Unavailable',
                'Swb Reynosa solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Sabinas solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Saltillo solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Janos',
                'Unavailable',
                'Swb Samalayuca solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mexquitic de Carmona',
                'Unavailable',
                'Swb San Luis Potosi solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Zacoalco de Torres',
                'Unavailable',
                'Swb Tecoman solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Lagos de Moreno',
                'Unavailable',
                'Swb Tonala solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Vetagrande',
                'Unavailable',
                'Swb Zacatecas solar farm',
                'Solar Wind Baja',
                'Solar Wind Baja',
              ],
              [
                'Mexico',
                98,
                'North America',
                'Unavailable',
                'Allende',
                'Allende',
                'Kronos Solar Park One Bufalo',
                'Kronos Mexico',
                'Kronos Solar Projects Gmbh',
              ],
              [
                'Mexico',
                73,
                'North America',
                'Unavailable',
                'Los Rodriguez',
                'San Miguel Allende',
                'Guanajuato Mexsolar solar farm',
                'X-Elio Fv Mexsolar',
                'X-Elio Fv Mexsolar',
              ],
              [
                'Mexico',
                55,
                'North America',
                'Unavailable',
                'Mar\u00edn',
                'Marin',
                'Koala solar farm',
                'Koala Solar, S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                90,
                'North America',
                'Unavailable',
                'Almoloya de Ju\u00e1rez',
                'Almoloya de Ju\u00e1rez',
                'Atlacomulco Solar Project',
                'Atlacomulco Solar S. A. de C. V.',
                'Atlacomulco Solar S. A. de C. V.',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Municipio de La Paz',
                'La Paz',
                'Aura Solar',
                'Gauss Energia',
                'Gauss Energia',
              ],
              [
                'Mexico',
                36,
                'North America',
                'Unavailable',
                'Camargo',
                'Camargo',
                'Avant Energ\u00edas Renovables solar farm',
                'Balam Fund',
                'Balam Fund',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Izamal',
                'Unavailable',
                'Baca solar farm',
                'ASI Energia Verde Internacional',
                'ASI Energia Verde Internacional',
              ],
              [
                'Mexico',
                250,
                'North America',
                'Unavailable',
                'Navojoa',
                'Bacabachi',
                'Bacabachi Photovoltaic solar farm',
                'X-Elio',
                'X-Elio',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de La Paz',
                'La Paz',
                'Baja California Sur Grupotec PV solar farm',
                'Grupotec Tecnologia Solar Sl',
                'Grupotec Tecnologia Solar Sl',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Los Cabos Municipality',
                'La Paz',
                'Baja California Sur solar farm',
                'SEGC Sonora Energy Group Caborca, S. A. de C. V.',
                'SEGC Sonora Energy Group Caborca, S. A. de C. V.',
              ],
              [
                'Mexico',
                63,
                'North America',
                'Unavailable',
                'Unavailable',
                'Penjamo',
                'Betria PV solar farm',
                'Natco Energy',
                'Natco Energy',
              ],
              [
                'Mexico',
                100,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Hermosillo',
                'Bizani Solar Field',
                'Unknown',
                'Unknown',
              ],
              [
                'Mexico',
                120,
                'North America',
                'Empalme',
                'Empalme',
                'Unavailable',
                'Bluemex Power Solar Project',
                'EDF Renewables Mexico',
                'EDF Renewables Mexico',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Pitiquito',
                'Pitiquito',
                'Bocas Solar Plant Central Sonora',
                'Bocas Planta, S. A. P. I. de C. V. Central Sonora',
                'Unknown',
              ],
              [
                'Mexico',
                138,
                'North America',
                'Unavailable',
                'Pitiquito',
                'Pitiquito',
                'AT Solar Park',
                'At Solar-V S De Rl De Cv',
                'BioFields; Acciona',
              ],
              [
                'Mexico',
                31,
                'North America',
                'Unavailable',
                'Cuencam\u00e9',
                'Cuencam\u00e9',
                'Bocas Solar Plant Durango',
                'Bocas Planta, S. A. P. I. de C. V. Central Durango',
                'Unknown',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Municipio de Ju\u00e1rez',
                'Juarez',
                'Border Solar Norte solar farm',
                'Central Fotovoltaica Border Solar Norte; SA de CV',
                'Unknown',
              ],
              [
                'Mexico',
                104,
                'North America',
                'Unavailable',
                'Calera',
                'Calera de Victor Rosales',
                'Calera solar farm',
                'Recursos Solares PV de M\u00e9xico III S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Santa Rosalia De Camargo',
                'Camargo',
                'Camargo solar farm',
                'Astilo 1 Solar',
                'Gransolar',
              ],
              [
                'Mexico',
                36,
                'North America',
                'Camargo',
                'Camargo',
                'Unavailable',
                'Camargo solar farm',
                'Balam Fund',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Doctor Mora',
                'Doctor Mora',
                'Carbonera De Guadalupe solar farm',
                'Tampico Solar Sa De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                60,
                'North America',
                'Unavailable',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Carbonera Ojo De Agua solar farm',
                'Proteus Solar, S. A. De C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                223,
                'North America',
                'Unavailable',
                'Carmen',
                'Carmen',
                'Carmen Aljaval solar farm',
                'Recursos Solares PV de M\u00e9xico V S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                340,
                'North America',
                'Unavailable',
                'Casta\u00f1os',
                'Casta\u00f1os',
                'Casta\u00f1os Aljaval solar farm',
                'Desarrollos Solares PV de M\u00e9xico III S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Cos',
                'Unavailable',
                'Central Estado De M\u00e9xico solar farm',
                'Nueve Solar',
                'Nueve Solar',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mexquitic de Carmona',
                'Unavailable',
                'Central Quer\u00e9taro solar farm',
                'Quer\u00e9taro Solar, S. A. P. I. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mexquitic de Carmona',
                'Unavailable',
                'Central San Luis Potos\u00ed solar farm',
                'Quer\u00e9taro Solar, S. A. P. I. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de San Luis Potos\u00ed',
                'Bocas',
                'Bocas Solar Plant San Luis Potos\u00ed',
                'Bocas Planta, S. A. P. I. de C. V. Central San Luis Potos\u00ed',
                'Unknown',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Silao de la Victoria',
                'Unavailable',
                'Arenugal PV Solar Park',
                'Arenugal Solar; S. A. P. I. de C. V',
                'Unknown',
              ],
              [
                'Mexico',
                190,
                'North America',
                'Unavailable',
                'Hueypoxtla',
                'Hueypoxtla',
                'Apaxco solar farm',
                'Iberdrola S.A.',
                'Iberdrola S.A.',
              ],
              [
                'Mexico',
                24,
                'North America',
                'Unavailable',
                'Municipio de Agua Prieta',
                'Agua Prieta',
                'Aparse Sonora solar farm',
                'Aparse, S. A. de C. V',
                'Unknown',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Santa B\u00e1rbara',
                'Santa Barbara',
                'Kronos Santa Barbara solar farm',
                'Kronos Mexico',
                'Kronos Solar Projects Gmbh',
              ],
              [
                'Mexico',
                99,
                'North America',
                'Unavailable',
                'Caborca',
                'Unavailable',
                'Abril Photovoltaic Solar Project',
                'Heolios EnTG S.A.P.I. de CV',
                'Engie M\u00e9xico; Tokyo Gas Co Ltd',
              ],
              [
                'Mexico',
                33,
                'North America',
                'Unavailable',
                'Galeana',
                'Galeana',
                'Adanarg PV solar farm',
                'Promociones Fotovoltaicas Adanarg',
                'Promociones Fotovoltaicas Adanarg',
              ],
              [
                'Mexico',
                68,
                'North America',
                'Municipio de Aguascalientes',
                'Municipio de Aguascalientes',
                'Unavailable',
                'Aguascalientes Potencia PV Solar Park',
                'BlackRock Infrastructure',
                'BlackRock Infrastructure',
              ],
              [
                'Mexico',
                38,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'Aguascalientes Sur Photovoltaic Solar Power Plant',
                'Unknown',
                'Grupo Opde',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Topolabampo',
                'Unavailable',
                'Ahome solar farm',
                'AEE Energia Renovable de Mexico SA de CV',
                'AEE Energia Renovable de Mexico SA de CV',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahumada',
                'Ahumada',
                'Ahumada solar farm',
                'Energia Aljaval',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahumada',
                'Ahumada',
                'Ahumada solar farm',
                'Energia Aljaval',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahumada',
                'Ahumada',
                'Ahumada solar farm',
                'Energia Aljaval',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahumada',
                'Ahumada',
                'Ahumada solar farm',
                'Energia Aljaval',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahumada',
                'Ahumada',
                'Ahumada solar farm',
                'Energia Aljaval',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Ascension',
                'Alaia Solar Park',
                'Energia Solar Alaia Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Ascension',
                'Alaia Solar Park',
                'Energia Solar Alaia Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Ascension',
                'Alaia Solar Park',
                'Energia Solar Alaia Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                32,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Ascension',
                'Alaia Solar Park',
                'Energia Solar Alaia Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                333,
                'North America',
                'San Antonio Lim\u00f3n',
                'Perote',
                'Perote',
                'Alchichica Solar Plant',
                'Planta Solar Villa de Reyes SA de CV',
                'Planta Solar Villa de Reyes SA de CV',
              ],
              [
                'Mexico',
                180,
                'North America',
                'Unavailable',
                'Pitiquito',
                'Unavailable',
                'Aleph Sonora solar farm',
                'Aleph Solar Fields',
                'Aleph Capital; Biofields',
              ],
              [
                'Mexico',
                180,
                'North America',
                'Unavailable',
                'Jes\u00fas Mar\u00eda',
                'Unavailable',
                'Alten Solem solar farm',
                'Alten Energias Renovable Mex',
                'Alten Energias Renovable Mex',
              ],
              [
                'Mexico',
                168,
                'North America',
                'Unavailable',
                'Jes\u00fas Mar\u00eda',
                'Unavailable',
                'Alten Solem solar farm',
                'Alten Energias Renovable Mex',
                'Alten Energias Renovable Mex',
              ],
              [
                'Mexico',
                106,
                'North America',
                'Unavailable',
                'Matamoros',
                'Matamoros',
                'Andaluc\u00eda Solar Plant',
                'Unknown',
                'Grupo Opde',
              ],
              [
                'Mexico',
                59,
                'North America',
                'Unavailable',
                'Bacalar',
                'Bacalar',
                'Andr\u00e9s Quintana Roo Solar Park',
                'Energ\u00eda del Sureste el Ramonal S. de RL de CV',
                'Energ\u00eda del Sureste el Ramonal S. de RL de CV',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Anivacachi PV Solar Park',
                'Parque Fotovoltaico Anivacachi S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Anivacachi PV Solar Park',
                'Parque Fotovoltaico Anivacachi S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Anivacachi PV Solar Park',
                'Parque Fotovoltaico Anivacachi S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Anivacachi PV Solar Park',
                'Parque Fotovoltaico Anivacachi S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                298,
                'North America',
                'Unavailable',
                'Pinos',
                'Pinos',
                'Central Solar Pinos solar farm',
                'Desarrollos Solares PV de M\u00e9xico',
                'Desarrollos Solares PV de M\u00e9xico',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Central Sonora solar farm',
                'Nueve Solar',
                'Nueve Solar',
              ],
              [
                'Mexico',
                42,
                'North America',
                'Unavailable',
                'Municipio de La Paz',
                'La Paz',
                'Aura Solar',
                'Gauss Energia',
                'Gauss Energia',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Vetagrande',
                'Unavailable',
                'Central Zacatecas solar farm',
                'Nueve Solar',
                'Nueve Solar',
              ],
              [
                'Mexico',
                21,
                'North America',
                'Unavailable',
                'Jocotitl\u00e1n',
                'Jocotitl\u00e1n',
                'Don Alejo Central Photovoltaic Solar Plant',
                'Iusasol',
                'Unknown',
              ],
              [
                'Mexico',
                125,
                'North America',
                'Benjam\u00edn Hill',
                'Benjam\u00edn Hill',
                'Unavailable',
                'Don Diego solar farm',
                'Infraestructura Energ\u00e9tica Nova, S.A.B. de C.V. (IEnova)',
                'Infraestructura Energ\u00e9tica Nova, S.A.B. de C.V. (IEnova)',
              ],
              [
                'Mexico',
                238,
                'North America',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Unavailable',
                'Don Jose Solar Plant',
                'Enel Green Power (EGP)',
                'Unknown',
              ],
              [
                'Mexico',
                22,
                'North America',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Unavailable',
                'Don Jose Solar Plant',
                'Enel Green Power (EGP)',
                'Unknown',
              ],
              [
                'Mexico',
                21,
                'North America',
                'Unavailable',
                'El Salto',
                'San Jose Del Castillo',
                'El Castillo PV Solar Park',
                'Parque Solar Fotovoltaico El Castillo, S. A.',
                'Parque Solar Fotovoltaico El Castillo, S. A.',
              ],
              [
                'Mexico',
                375,
                'North America',
                'Unavailable',
                'Jes\u00fas Mar\u00eda',
                'Unavailable',
                'El Llano PV Solar Installation',
                'Neoen',
                'Neoen',
              ],
              [
                'Mexico',
                126,
                'North America',
                'Unavailable',
                'El Mayo',
                'Hermosillo',
                'El Mayo Photovoltaic solar farm',
                'Korea Electric Power Co. (KEPCO)',
                'Korea Electric Power Co. (KEPCO); Sprott Korea',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Ascension',
                'El Rollo solar farm',
                'El Rollo Solar, S. A. P. I. de C. V.',
                'El Rollo Solar, S. A. P. I. de C. V.',
              ],
              [
                'Mexico',
                35,
                'North America',
                'Unavailable',
                'Tlahualilo',
                'Tlahualilo De Zaragoza',
                'Energ\u00eda Limpia De La Laguna solar farm',
                'Balam Fund',
                'Unknown',
              ],
              [
                'Mexico',
                103,
                'North America',
                'Unavailable',
                'Unavailable',
                'Jimenez',
                'F\u00e1tima PV solar farm',
                'Kronos Mexico',
                'Kronos Solar Projects Gmbh',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'Gal\u00e1pago Solar Park',
                'Parque Solar Galapago I Sapi',
                'Unknown',
              ],
              [
                'Mexico',
                50,
                'North America',
                'Unavailable',
                'Galeana',
                'Galeana',
                'Galeana PV solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Galeana',
                'Galeana',
                'Galeana solar farm',
                'Neoen',
                'Neoen',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Magdalena',
                'Garambullo',
                'Garambullo solar farm',
                'Garambullo Solar, S. de R. L. de C. V.',
                'Garambullo Solar, S. de R. L. de C. V.',
              ],
              [
                'Mexico',
                99,
                'North America',
                'Unavailable',
                'Saltillo',
                'Saltillo',
                'Gomez Farias Solar Park',
                'Desarrollos Solares PV de M\u00e9xico, S.A. de C.V.',
                'Desarrollos Solares PV de M\u00e9xico, S.A. de C.V.',
              ],
              [
                'Mexico',
                20,
                'North America',
                'Unavailable',
                'Tlajomulco de Zu\u00f1iga',
                'Tlajomulco De Zuniga',
                'Gransolar Jalisco solar farm',
                'Gransolar Jalisco, S. A. de C. V.',
                'Gransolar',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Jamay',
                'Gransolar Ocotlan solar farm',
                'Gransolar Ocotlan S.A. de C.V.',
                'Gransolar',
              ],
              [
                'Mexico',
                130,
                'North America',
                'Unavailable',
                'Nopala de Villagr\u00e1n',
                'Nopala de Villagran',
                'Guajiro Solar Plant',
                'Atlas Renewable Energy',
                'Atlas Renewable Energy',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Mazapil',
                'Unavailable',
                'Helios solar farm',
                'Helios Generacion S De Rl De',
                'Cemex Energia; Pattern Energy',
              ],
              [
                'Mexico',
                100,
                'North America',
                'Hermosillo',
                'Hermosillo',
                'Unavailable',
                'Hermosillo PV Solar Park',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Mexico',
                39,
                'North America',
                'Unavailable',
                'Pitiquito',
                'Puerto Libertad',
                'Hermosillo solar farm',
                'SEGC Sonora Energy Group Hermosillo, S. A. de C. V.',
                'SEGC Sonora Energy Group Hermosillo, S. A. de C. V.',
              ],
              [
                'Mexico',
                119,
                'North America',
                'Unavailable',
                'Pabell\u00f3n de Arteaga',
                'Pabellon De Arteaga',
                'Horus Photovoltaic solar farm',
                'Korea Electric Power Co. (KEPCO)',
                'Korea Electric Power Co. (KEPCO); Sprott Korea',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Torre\u00f3n',
                'Torre\u00f3n',
                'Central Torre\u00f3n solar farm',
                'XIII Colima, S. A. P. I. de C. V.',
                'XIII Colima, S. A. P. I. de C. V.',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Los Cabos Municipality',
                'La Fortuna',
                'Isolbaja PV solar farm',
                'Isolbaja, S. A. de C. V.',
                'Grupo Isolux Corsan Sa',
              ],
              [
                'Mexico',
                65,
                'North America',
                'Unavailable',
                'Municipio de Ju\u00e1rez',
                'Ciudad Juarez',
                'Kaixo Solar Park',
                'Dominion Global',
                'Dominion Global',
              ],
              [
                'Mexico',
                35,
                'North America',
                'Unavailable',
                'Delicias',
                'Delicias',
                'Delicias Solar PV Plant',
                'SDC Energreen-Aljaval',
                'Unknown',
              ],
              [
                'Mexico',
                384,
                'North America',
                'Unavailable',
                'Degollado',
                'Degollado',
                'Degollado Aljaval solar farm',
                'Desarrollos Solares PV de M\u00e9xico II S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de Durango',
                'Unavailable',
                'Independencia Solar Park',
                'Parque Solar Independencia, S. A. P. I. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                200,
                'North America',
                'Cuyoaco',
                'Cuyoaco',
                'Unavailable',
                'Cuyoaco solar farm',
                'Iberdrola M\u00e9xico',
                'Iberdrola M\u00e9xico',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Municipio de Mexicali',
                'Mexicali',
                'Cerro Prieto Solar Project',
                'Comisi\u00f3n Federal de Electricidad (CFE)',
                'Comisi\u00f3n Federal de Electricidad (CFE)',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hermosillo',
                'Unavailable',
                'DCC Photovoltaic solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mexico',
                200,
                'North America',
                'Unavailable',
                'Municipio de Mexicali',
                'Mexicali',
                'Cerro Prieto Solar Project',
                'Comisi\u00f3n Federal de Electricidad (CFE)',
                'Comisi\u00f3n Federal de Electricidad (CFE)',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Suchiate',
                'Suchiate',
                'Ciudad Hidalgo',
                'Ciudad Hidalgo PV solar farm',
                'Ciudad Hidalgo Solar PV S.A. de C.V.',
                'Energia Aljaval',
              ],
              [
                'Mexico',
                22,
                'North America',
                'Unavailable',
                'Torre\u00f3n',
                'Matamoros',
                'Coahuila Solar Park',
                'Macquerie Infrastructure Fund',
                'Macquerie Infrastructure Fund',
              ],
              [
                'Mexico',
                150,
                'North America',
                'Unavailable',
                'Parras',
                'Parras De La Fuente',
                'Cola De Le\u00f3n PV solar farm',
                'Fisterra Energy',
                'Fisterra Energy',
              ],
              [
                'Mexico',
                70,
                'North America',
                'Unavailable',
                'Valladolid',
                'Concunul',
                'Concunul Yucatan Solar Park',
                'JinkoSolar Investment Pte Ltd',
                'JinkoSolar Investment Pte Ltd',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Iztapalapa de Cuitl\u00e1huac',
                'Controladora De Renovables solar farm',
                'Controladora de Renovables, S. A. de C. V.',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Unavailable',
                'Jimenez',
                'Crison Jimenez solar farm',
                'Crison 2 Solar, S. A. de C. V.',
                'Crison 2 Solar, S. A. de C. V.',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'San Luis de la Paz',
                'San Luis de la Paz',
                'Crison San Luis De La Paz solar farm',
                'Crison 2 Solar, S. A. de C. V.',
                'Crison 2 Solar, S. A. de C. V.',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Caborca',
                'Caborca',
                'Cuatro Caborca solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ascensi\u00f3n',
                'Casas Grandes',
                'Cuatro Casas Grandes solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Cajeme',
                'Ciudad Obreg\u00f3n',
                'Cuatro Ciudad Obregon solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                172,
                'North America',
                'Unavailable',
                'Encarnaci\u00f3n de D\u00edaz',
                'Encarnaci\u00f3n de D\u00edaz',
                'Chona solar farm',
                'Chona Solar PV S.A. de C.V.',
                'Energ\u00eda Aljaval',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Fresnillo',
                'Fresnillo',
                'Cuatro Fresnillo solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Central Hermosillo',
                'Unavailable',
                'Cuatro Hermosillo solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ahome',
                'Los Mochis',
                'Cuatro Los Mochis solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Villa de Cos',
                'Unavailable',
                'Cuatro Mexicali solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Hidalgo del Parral',
                'Parral',
                'Cuatro Parral solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Municipio de San Luis Potos\u00ed',
                'Pe\u00f1asco',
                'Cuatro Penasco solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'San Juan del R\u00edo',
                'San Juan del R\u00edo',
                'Cuatro San Juan Del Rio solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Mexquitic de Carmona',
                'Unavailable',
                'Cuatro San Luis Potosi solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Tepeji del R\u00edo de Ocampo',
                'Tepeji del R\u00edo',
                'Cuatro Tepeji Del Rio solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mexico',
                70,
                'North America',
                'Unavailable',
                'Valladolid',
                'Unavailable',
                'Cuncunul Solar Project',
                'JinkoSolar',
                'JinkoSolar; Solarcentury',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Cuer\u00e1maro',
                'Cuer\u00e1maro',
                'Cuer\u00e1maro solar farm',
                'Astilo 1 Solar',
                'Unknown',
              ],
              [
                'Mexico',
                30,
                'North America',
                'Unavailable',
                'Ezequiel Montes',
                'Ezequiel Montes',
                'Cuatro Ezequiel Montes solar farm',
                'Cuatro Solar Sapi De Cv',
                'Unknown',
              ],
              [
                'Mongolia',
                20,
                'Asia',
                'Darkhan City',
                'Hongor',
                'Khongor',
                'Darkhan solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mongolia',
                20,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Baganuur',
                'Baganuur solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mongolia',
                30,
                'Asia',
                'Unavailable',
                'Saynshand',
                'Sainshand',
                'Desert solar farm',
                'Desert Solar Power One LLC',
                'United Green Group (UGG)',
              ],
              [
                'Montenegro',
                50,
                'Europe',
                'Velje brdo',
                'Podgorica Municipality',
                'Unavailable',
                'Veljie Brdo solar farm',
                'Unknown',
                'S&Z Energie Systeme',
              ],
              [
                'Montenegro',
                50,
                'Europe',
                'Unavailable',
                'Ulcinj Municipality',
                'Unavailable',
                'Briska Gora solar farm',
                'Unknown',
                'Fortum; EGPC',
              ],
              [
                'Montenegro',
                212,
                'Europe',
                'Unavailable',
                'Ulcinj Municipality',
                'Unavailable',
                'Briska Gora solar farm',
                'Unknown',
                'Fortum; EGPC',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Tan Tan',
                "cercle de M'Sied",
                'Guelmim-Oued Noun',
                'Noor Atlas Tan Tan solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Tahla (Bouizakarne)',
                "cercle d'Amerzgane \u062f\u0627\u0626\u0631\u0629 \u0623\u0645\u0631\u0632\u0643\u0627\u0646",
                'Ouarzazate Province',
                'Noor Atlas Tahla (Bouizakarne) solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Outat El Haj',
                "cercle d'Amerzgane \u062f\u0627\u0626\u0631\u0629 \u0623\u0645\u0631\u0632\u0643\u0627\u0646",
                'Ouarzazate Province',
                'Noor Atlas Outat El Haj solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Boulmane (Enjil)',
                "cercle d'Outat El Hadj",
                'F\u00e8s-Mekn\u00e8s',
                'Noor Atlas Boulmane (Enjil) solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Boudnib',
                "cercle d'Asni",
                'Atlas mountains',
                'Noor Atlas Boudnib solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Tata',
                'Tata City',
                'Tata Province',
                'Noor Atlas Tata solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Bouanane',
                'cercle de Bni Tadjite \u062f\u0627\u0626\u0631\u0629 \u0628\u0646\u064a \u062a\u062c\u064a\u062a',
                'Oriental',
                'Noor Atlas Bouanane solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                184,
                'Africa',
                'Unavailable',
                'Ain Beni Mathar Solar Farm',
                'Jerada Province',
                'Ain Beni Mathar Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                200,
                'Africa',
                'Argana',
                "cercle d'Ouled Teima",
                'Taroudant Province',
                'Noor Argana solar farm',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                7000,
                'Africa',
                'Unavailable',
                'Cercle de Guelmim \u062f\u0627\u0626\u0631\u0629 \u0643\u0644\u0645\u064a\u0645',
                'Guelmim Province',
                'Morocco-UK Solar Power',
                'Xlinks',
                'Xlinks',
              ],
              [
                'Morocco',
                48,
                'Africa',
                'Kelaa Sraghna',
                'Marrakesh-Safi',
                'Kelaat Sraghna Province',
                'Kelaa Sraghna Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                30,
                'Africa',
                'Unavailable',
                "Pachalik d'Assilah \u0628\u0627\u0634\u0648\u064a\u0629 \u0623\u0635\u064a\u0644\u0629",
                'Prefecture of Tangier - Assilah',
                'Green Power PV Plant solar farm',
                'Unknown',
                'Green Power Morocco 1 SA',
              ],
              [
                'Morocco',
                36,
                'Africa',
                'El Hajeb',
                'F\u00e8s-Mekn\u00e8s',
                'El Hajeb Province',
                'El Hajeb Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                48,
                'Africa',
                'Bejaad',
                'Boujad',
                'Khouribga Province',
                'Bejaad Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                25,
                'Africa',
                'Ain Beni Mathar',
                'Pachalik de Ain Bni Mathar',
                'Jerada Province',
                'Noor Atlas Ain Beni Mathar solar farm',
                'Unknown',
                'Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                800,
                'Africa',
                'Midelt',
                'cercle de Midelt \u062f\u0627\u0626\u0631\u0629 \u0645\u064a\u062f\u0644\u062a',
                'Midelt Province',
                'Noor Midelt solar farm',
                'Unknown',
                'Masdar Clean Energy; EDF Renewables; Green of Africa; MASEN',
              ],
              [
                'Morocco',
                5000,
                'Africa',
                'Unavailable',
                'Pachalik de Guelmim \u0628\u0627\u0634\u0648\u064a\u0629 \u0643\u0644\u0645\u064a\u0645',
                'Guelmim-Oued Noun Solar',
                'Total Eren-Guelmim-Oued Noun Solar',
                'Total Eren',
                'Total Eren',
              ],
              [
                'Morocco',
                160,
                'Africa',
                'Ouarzazate',
                "cercle d'Ouarzazate",
                'Ouarzazate Province',
                'Noor Ouarzazate solar farm',
                'NOMAC',
                'ACWA Power; MASEN; Aries; TSk; ASRA',
              ],
              [
                'Morocco',
                200,
                'Africa',
                'Ouarzazate',
                "cercle d'Ouarzazate",
                'Ouarzazate Province',
                'Noor Ouarzazate solar farm',
                'NOMAC; MASEN',
                'ACWA Power; SENER',
              ],
              [
                'Morocco',
                150,
                'Africa',
                'Ouarzazate',
                "cercle d'Ouarzazate",
                'Ouarzazate Province',
                'Noor Ouarzazate solar farm',
                'NOMAC; MASEN',
                'ACWA Power; SENER',
              ],
              [
                'Morocco',
                72,
                'Africa',
                'Ouarzazate',
                "cercle d'Ouarzazate",
                'Ouarzazate Province',
                'Noor Ouarzazate solar farm',
                'ACWA Power',
                'ACWA Power; MASEN',
              ],
              [
                'Morocco',
                40,
                'Africa',
                'Erfoud',
                'Souss-Massa-Dra\u00e2',
                'Agadir Ida-Outanane Prefecture',
                'Noor Tafilalt Erfoud Solar',
                "Office National de l'Electricite (ONE)",
                'MASEN; Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                40,
                'Africa',
                'Missour',
                'Fez-Bouleman',
                'Ouarzazate Province',
                'Noor Tafilalt Missour Solar',
                "Office National de l'Electricite (ONE)",
                'MASEN; Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                40,
                'Africa',
                'Zagora',
                'Guelmin-Semara',
                'Ouarzazate Province',
                'Noor Tafilalt Zagora Solar',
                "Office National de l'Electricite (ONE)",
                'MASEN; Electricity Branch of the Moroccan Water Conservancy and Electricity Bureau (ONEE-BE)',
              ],
              [
                'Morocco',
                48,
                'Africa',
                'Sidi Bennour',
                'Casablanca-Settat',
                'Sidi Bennour Province',
                'Sidi Bennour Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                36,
                'Africa',
                'Taroudant',
                'Sous Valley',
                'Taroudant Province',
                'Taroudant Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Morocco',
                230,
                'Africa',
                'Draa-Tafilalet',
                'Atlas Mountains',
                'Midelt Province',
                'Noor Midelt solar farm',
                'Unknown',
                'EDF Renewables [35%]; Abu Dhabi Future Energy [30%]; Moroccan Agency for Sustainable Energy [25%]; Green Of Africa [10%]',
              ],
              [
                'Mozambique',
                40,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Mocuba',
                'Scatec Mocuba solar farm',
                'Unknown',
                'Scatec Solar; EDM; KLP Norfund Investments',
              ],
              [
                'Mozambique',
                100,
                'Africa',
                'Nacala',
                'Unavailable',
                'Unavailable',
                'Nacala solar farm',
                'Unknown',
                'WHN Solar',
              ],
              [
                'Mozambique',
                41,
                'Africa',
                'Metoro',
                'Ancuabe District',
                'Cidade de Pemba',
                'Metoro Substation solar farm',
                'Unknown',
                'Neon; EDM',
              ],
              [
                'Mozambique',
                25,
                'Africa',
                'Unavailable',
                'Marrupa District',
                'Majune',
                'Marrupa Moz solar farm',
                'Unknown',
                'Phanes Group; Reputa\u00e7\u00e3o Moz',
              ],
              [
                'Mozambique',
                40,
                'Africa',
                'Manje',
                'Chiuta District',
                'Unavailable',
                'Manje solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Mozambique',
                100,
                'Africa',
                'Lichinga',
                'Unavailable',
                'Cidade de Lichinga',
                'Lichinga Moz solar farm',
                'Unknown',
                'Phanes Group; Reputa\u00e7\u00e3o Moz',
              ],
              [
                'Mozambique',
                50,
                'Africa',
                'Lichinga',
                'Unavailable',
                'Cidade de Lichinga',
                'Lichinga Gigawatt solar farm',
                'Unknown',
                'EDM; Gigawatt Global; Anglican Church of Niassa',
              ],
              [
                'Mozambique',
                40,
                'Africa',
                'Dondo',
                'Dondo District',
                'Cidade da Beira',
                'Dondo solar farm',
                'Unknown',
                'MIRIME',
              ],
              [
                'Mozambique',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Cuamba',
                'Cuamba solar farm',
                'Unknown',
                'Globeleq; Source Capital',
              ],
              [
                'Mozambique',
                25,
                'Africa',
                'Unavailable',
                'Mandimba District',
                'Majune',
                'Mandimba Moz solar farm',
                'Unknown',
                'Phanes Group; Reputa\u00e7\u00e3o Moz',
              ],
              [
                'Myanmar',
                50,
                'Asia',
                'Minbu District',
                'Minbu District',
                'Unavailable',
                'Minbu solar farm',
                'Green Earth Power (Thailand) (GEP)',
                'Green Earth Power (Thailand) (GEP)',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Athoke solar farm',
                'China Machinery Engineering Corporation',
                'China Machinery Engineering Corporation',
              ],
              [
                'Myanmar',
                1000,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Batam Bintan and Karimum (BBK)',
                'Bbk solar farm',
                'Unknown',
                'Semcorp Industries (Sembcorp); PT PLN Batam; PT Trisurya Mitra Bersama (Suryagen)',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Pakokku District',
                'Unavailable',
                'Chaungku solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Pyay District',
                'West Bago Region',
                'Kamarnat solar farm',
                'China Machinery Engineering Corporation',
                'China Machinery Engineering Corporation',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kyaiklat solar farm',
                'China Machinery Engineering Corporation',
                'China Machinery Engineering Corporation',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Kyunchaung',
                'Unavailable',
                'Kyunchaung solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Letpanhla',
                'Unavailable',
                'Letpanhla solar farm',
                'IB Vogt GmbH; Kyaw Su Thway Group of Company Limited',
                'IB Voght GmbH; Kyaw Su Thway Group of Company Limited',
              ],
              [
                'Myanmar',
                50,
                'Asia',
                'Minbu',
                'Minbu District',
                'Unavailable',
                'Minbu solar farm',
                'Green Earth Power (Thailand) (GEP)',
                'Green Earth Power (Thailand) (GEP)',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Thephyu',
                'Unavailable',
                'Thephyu solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                70,
                'Asia',
                'Minbu',
                'Minbu District',
                'Unavailable',
                'Minbu solar farm',
                'Green Earth Power (Thailand) (GEP)',
                'Green Earth Power (Thailand) (GEP)',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Shwedaung',
                'West Bago Region',
                'Shwedaung solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'ShweMyo',
                'Unavailable',
                'Shwemyo solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'South Sumatra solar farm',
                'Unknown',
                'PT Bukit Asam Tbk',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Taungoo',
                'East Bago Region',
                'Taungoo solar farm',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Thapyaywa',
                'Unavailable',
                'Thapyaywa solar farm',
                'Gold Energy Company Limited; Universal Energy Company Limited',
                'Gold Energy Company Limited; Universal Energy Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Tharyargone',
                'Unavailable',
                'Tharyargone solar farm',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Mandalay District',
                'Unavailable',
                'Tharzi solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Wartaya',
                'Unavailable',
                'Wartaya solar farm',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
              ],
              [
                'Myanmar',
                150,
                'Asia',
                'Unavailable',
                'Wundwin',
                'Unavailable',
                'Wundwin solar farm',
                'Unknown',
                'Convalt Energy',
              ],
              [
                'Myanmar',
                50,
                'Asia',
                'Minbu',
                'Minbu District',
                'Unavailable',
                'Minbu solar farm',
                'Green Earth Power (Thailand) (GEP)',
                'Green Earth Power (Thailand) (GEP)',
              ],
              [
                'Myanmar',
                4800,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Riau Islands solar farm',
                'Unknown',
                'Sunseap Group',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Pathein solar farm',
                'China Machinery Engineering Corporation',
                'China Machinery Engineering Corporation',
              ],
              [
                'Myanmar',
                150,
                'Asia',
                'Unavailable',
                'Mandalay District',
                'Unavailable',
                'Myotha solar farm',
                'Unknown',
                'ACO Investment Group',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Nyaungpingyi',
                'Unavailable',
                'Nyaungpingyi solar farm',
                'Shwe Taung Development Company Limited; GCL System Integration Technology',
                'Shwe Taung Development Company Limited; GCL System Integration Technology',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Ngapyawdine',
                'Unavailable',
                'Ngapyawdine solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Naypyitaw',
                'Unavailable',
                'Naypyitaw 1 solar farm',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
                'SPIC Yunnan International Power Investment Company Limited; Khaing Lon Gems Company Limited',
              ],
              [
                'Myanmar',
                150,
                'Asia',
                'Unavailable',
                'Nabuiang',
                'Unavailable',
                'Nabuaing solar farm',
                'Unknown',
                'Convalt Energy',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Ohntaw',
                'Unavailable',
                'Ohntaw solar farm',
                "China Gezhouba Group Oversea Investment Company Limited; Future Energy Company Limited; Xi'an LONGI Clean Energy Company Limited",
                "China Gezhouba Group Overseas Investment Company Limited; Future Energy Company Limited; Xi'an LONGI Clean Energy Company Limited",
              ],
              [
                'Myanmar',
                150,
                'Asia',
                'Unavailable',
                'Mandalay District',
                'Unavailable',
                'Myotha solar farm',
                'Unknown',
                'ACO Investment Group',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Oakshitpin',
                'West Bago Region',
                'Oakshitpin solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Myanaung solar farm',
                'China Machinery Engineering Corporation',
                'China Machinery Engineering Corporation',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Minhla',
                'Unavailable',
                'Minhla solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Myanmar',
                30,
                'Asia',
                'Unavailable',
                'Myingyan',
                'Unavailable',
                'Myingyan solar farm',
                'Sungrow Power Supply Company Limited',
                'Sungrow Power Supply Company Limited',
              ],
              [
                'Namibia',
                81,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arandis solar farm',
                'Unknown',
                'Natura Energy; Globeleq',
              ],
              [
                'Namibia',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Khan solar farm',
                'Unknown',
                'Access Aussenkehr Solar One Namibia',
              ],
              [
                'Namibia',
                46,
                'Africa',
                'Unavailable',
                'Mariental District',
                'Unavailable',
                'Mariental solar farm',
                'Unknown',
                'Alten Energ\u00edas Renovables; NamPower; Mangrove; Talyeni; First Place Investment',
              ],
              [
                'Namibia',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Omburu solar farm',
                'Nampower',
                'Nampower',
              ],
              [
                'Namibia',
                25,
                'Africa',
                'Windhoek',
                'Unavailable',
                'Unavailable',
                'Windhoek solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Namibia',
                80,
                'Africa',
                'Tses',
                'Unavailable',
                'Unavailable',
                'Tses solar farm',
                'Unknown',
                'Groot Glass Limited',
              ],
              [
                'Nepal',
                25,
                'Asia',
                'Nuwakot',
                'Nuwakot',
                'Unavailable',
                'Devighat solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Netherlands',
                103,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Midden-Groningen solar farm',
                'Unknown',
                'Blue Elephant Energy',
              ],
              [
                'Netherlands',
                25,
                'Europe',
                'Unavailable',
                'Hoogeveen Municipality',
                'Unavailable',
                'Hollandscheveld solar farm',
                'Unknown',
                'Powerfield',
              ],
              [
                'Netherlands',
                29,
                'Europe',
                'Leek',
                'Westerkwartier Municipality',
                'Unavailable',
                'Leek solar farm',
                'Unknown',
                'Blue Elephant Energy',
              ],
              [
                'Netherlands',
                22,
                'Europe',
                'IJmuiden',
                'Velson Municipality',
                'Unavailable',
                'Ijmuiden Works solar farm',
                'Unknown',
                'Tata Steel Europe',
              ],
              [
                'Netherlands',
                120,
                'Europe',
                'Nieuw-Buinen',
                'Borger-Odoorn Municpality',
                'Unavailable',
                'Hollandia Nieuw-Buinen solar farm',
                'Unknown',
                'Solarfields; Green-Invest; Rabobank',
              ],
              [
                'Netherlands',
                35,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Hendrik Reindersweg solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Netherlands',
                38,
                'Europe',
                'Haringvliet',
                'Goeree-Overflakkee',
                'Unavailable',
                'Haringvliet Zuid solar farm',
                'Belectric',
                'Vattenfall',
              ],
              [
                'Netherlands',
                22,
                'Europe',
                'Eelde',
                'Tynaarlo Municipality',
                'Unavailable',
                'Groningen Airport Eelde solar farm',
                'Unknown',
                'Encavis AG',
              ],
              [
                'Netherlands',
                25,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Fluitenberg solar farm',
                'Unknown',
                'Powerfield',
              ],
              [
                'Netherlands',
                40,
                'Europe',
                'Unavailable',
                'Hoogeveen Municipality',
                'Unavailable',
                'East Of N48 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Netherlands',
                45,
                'Europe',
                'Buinerveen',
                'Borger-Odoorn Municipality',
                'Unavailable',
                'Buinerveen solar farm',
                'Enexis; Tennet',
                'Powerfield; Chint Solar',
              ],
              [
                'Netherlands',
                21,
                'Europe',
                'Borssele',
                'Borssele Municipality',
                'Unavailable',
                'Borssele solar farm',
                'Unknown',
                'EPZ',
              ],
              [
                'Netherlands',
                27,
                'Europe',
                'Zwolle',
                'Unavailable',
                'Unavailable',
                'Bomhofsplas solar farm',
                'Unknown',
                'Energiefonds Overijssel; Blauwvinger Energie; Private Investor',
              ],
              [
                'Netherlands',
                20,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Assen-Zuid solar farm',
                'Unknown',
                'Engie [50%]; Energieco\u00f6peratie duurzaam Assen [50%]',
              ],
              [
                'Netherlands',
                21,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lochem Solar Farm',
                'Belectric',
                'Kronos Solar',
              ],
              [
                'Netherlands',
                49,
                'Europe',
                'Unavailable',
                'Borger-Odoorn Municipality',
                'Unavailable',
                'Exloo solar farm',
                'Unknown',
                'FP Lux Investments',
              ],
              [
                'Netherlands',
                27,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Losser Solar Farm',
                'Belectric',
                'Kronos Solar',
              ],
              [
                'Netherlands',
                50,
                'Europe',
                'Pottendijk',
                'Emmen Municipality',
                'Unavailable',
                'Pottendijk solar farm',
                'Unknown',
                'Shell',
              ],
              [
                'Netherlands',
                110,
                'Europe',
                'Vlagtwedde',
                'Westerwolde Municipality',
                'Unavailable',
                'Vlagtwedde solar farm',
                'Unknown',
                'Encavis AG',
              ],
              [
                'Netherlands',
                30,
                'Europe',
                'Deest',
                'Druten Municipality',
                'Unavailable',
                'Uivermeertjes solar farm',
                'Unknown',
                'Groenleven',
              ],
              [
                'Netherlands',
                30,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sunport Delfzijl solar farm',
                'Eneco',
                'Wirsol Energy',
              ],
              [
                'Netherlands',
                101,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Stadskanaal solar farm',
                'Enexis; Tennet',
                'Powerfield; Chint Solar',
              ],
              [
                'Netherlands',
                41,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sellingen solar farm',
                'Unknown',
                'Groenleven',
              ],
              [
                'Netherlands',
                55,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Scaldia Solar Farm',
                'Unknown',
                'ib vogt gmbH',
              ],
              [
                'Netherlands',
                35,
                'Europe',
                'Roosendaal',
                'Roosendaal',
                'Unavailable',
                'Roosendaal solar farm',
                'Unknown',
                'CEE Group',
              ],
              [
                'Netherlands',
                25,
                'Europe',
                'Pesse',
                'Hoogeveen Municipality',
                'Unavailable',
                'Pesse - Zwarte Water solar farm',
                'Unknown',
                'Powerfield',
              ],
              [
                'Netherlands',
                40,
                'Europe',
                'Ooltgensplaat',
                'Goeree-Overflakkee Municipality',
                'Unavailable',
                'Ooltgensplaat solar farm',
                'Unknown',
                'Encavis AG',
              ],
              [
                'Netherlands',
                44,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nrystar Budel solar farm',
                'Unknown',
                'Encavis AG; Solarcentury',
              ],
              [
                'Netherlands',
                27,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Moerdijk solar farm',
                'Unknown',
                'Shell',
              ],
              [
                'Netherlands',
                101,
                'Europe',
                'Vlagtwedde',
                'Westerwolde Municipality',
                'Unavailable',
                'Vlagtwedde solar farm',
                'Unknown',
                'Powerfield',
              ],
              [
                'Netherlands',
                34,
                'Europe',
                'Almere',
                'Unavailable',
                'Unavailable',
                'Zuyderzon Almere solar farm',
                'Zuyderzon Almere',
                'HVC; Sunwatt',
              ],
              [
                'New Caledonia',
                30,
                'Oceania',
                'Unavailable',
                'South Province',
                'Grand Sud',
                'Grand Sud solar farm',
                'Unknown',
                'TotalEnergies SE',
              ],
              [
                'New Zealand',
                69,
                'Oceania',
                'Dargaville',
                'Kaipara District',
                'Northland Region',
                'Dargaville solar farm',
                'Unknown',
                'Lodestone Energy Ltd (LEL)',
              ],
              [
                'New Zealand',
                35,
                'Oceania',
                'Edgecumbe',
                'Whakat\u0101ne District',
                'Bay of Plenty Region',
                'Edgecumbe Solar Farm',
                'Unknown',
                'Lodestone Energy Ltd (LEL)',
              ],
              [
                'New Zealand',
                70,
                'Oceania',
                'Helensville',
                'Rodney Ward',
                'Auckland Region',
                'Helensville solar farm',
                'Unknown',
                'HES Aoteroa',
              ],
              [
                'New Zealand',
                39,
                'Oceania',
                'Kaitaia',
                'Far North District',
                'Northland Region',
                'Kaitaia solar farm',
                'Unknown',
                'Lodestone Energy Ltd (LEL)',
              ],
              [
                'New Zealand',
                150,
                'Oceania',
                'Harewood',
                'Christchurch',
                'Unavailable',
                'K\u014dwhai solar farm',
                'Unknown',
                'Solar Bey',
              ],
              [
                'New Zealand',
                27,
                'Oceania',
                'Marsden Point',
                'Whangarei',
                'Northland Region',
                'Marsden Point solar farm',
                'Unknown',
                'Refinery NZ',
              ],
              [
                'New Zealand',
                75,
                'Oceania',
                'Marsden Point',
                'Whangarei',
                'Northland Region',
                'Ruakaka solar farm',
                'Unknown',
                'Meridian Energy',
              ],
              [
                'New Zealand',
                187,
                'Oceania',
                'Matamata Piako District',
                'Matamata Piako District',
                'Unavailable',
                'Tauhei solar farm',
                'Unknown',
                'Harmony Energy NZ Limited',
              ],
              [
                'New Zealand',
                49,
                'Oceania',
                'Waiotahe',
                '\u014cp\u014dtiki District',
                'Bay of Plenty Region',
                'Waiotahe solar farm',
                'Unknown',
                'Lodestone Energy Ltd (LEL)',
              ],
              [
                'New Zealand',
                200,
                'Oceania',
                'Waiterimu',
                'Waikato District',
                'Waikato Region',
                'Waiterimu solar farm',
                'Unknown',
                'Island Green Power Ltd.',
              ],
              [
                'New Zealand',
                37,
                'Oceania',
                'Whitianga',
                'Thames-Coromandel District',
                'Waikato Region',
                'Whitianga solar farm',
                'Unknown',
                'Lodestone Energy Ltd (LEL)',
              ],
              [
                'New Zealand',
                300,
                'Oceania',
                'Unavailable',
                'Waikato District',
                'Waikato Region',
                'Waikato solar farm',
                'Unknown',
                'Genesis',
              ],
              [
                'Nicaragua',
                36,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Government Solar Project Nicaragua 3',
                'Unknown',
                'Unknown',
              ],
              [
                'Nicaragua',
                36,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Government Solar Project Nicaragua 4',
                'Unknown',
                'Unknown',
              ],
              [
                'Nicaragua',
                50,
                'Central America and the Caribbean',
                'Unavailable',
                'San Benito',
                'Unavailable',
                'San Benito solar farm',
                'Empresa Nacional de Transmisi\u00f3n El\u00e9ctrica (ENATREL)',
                'EPR Solar; Unnamed',
              ],
              [
                'Nicaragua',
                50,
                'Central America and the Caribbean',
                'Unavailable',
                'San Benito',
                'Unavailable',
                'San Benito solar farm',
                'Empresa Nacional de Transmisi\u00f3n El\u00e9ctrica (ENATREL)',
                'EPR Solar; Unnamed',
              ],
              [
                'Nicaragua',
                36,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ass\u00fa Solar Farm (Nicaragua)',
                'Unknown',
                'Unknown',
              ],
              [
                'Nicaragua',
                36,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Government Solar Project Nicaragua 1',
                'Unknown',
                'Unknown',
              ],
              [
                'Nicaragua',
                36,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Government Solar Project Nicaragua 2',
                'Unknown',
                'Unknown',
              ],
              [
                'Niger',
                30,
                'Africa',
                'Gu\u00e9ss\u00e9lbodi',
                'Tillab\u00e9ri',
                'Unavailable',
                'Gu\u00e9ss\u00e9lbodi solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Niger',
                50,
                'Africa',
                'Gorou Banda',
                'Commune V',
                'Unavailable',
                'Gorou Banda solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Nigeria',
                80,
                'Africa',
                'Dutse',
                'Kachia',
                'Unavailable',
                'Jigawe (Scatec) solar farm',
                'Unknown',
                'Scatec Solar; CPCS Development International Ltd (CDIL); Business Process Solutions Consult Ltd (BPS)',
              ],
              [
                'Nigeria',
                50,
                'Africa',
                'Garaku',
                'Doma',
                'Unavailable',
                'Garaku solar farm',
                'Unknown',
                'Afrinergia Power Ltd',
              ],
              [
                'Nigeria',
                50,
                'Africa',
                'Unavailable',
                'Kachia',
                'Unavailable',
                'Jigawe (Oriental) solar farm',
                'Unknown',
                'Oriental Renewable Solutions; GreenWish Partners',
              ],
              [
                'Nigeria',
                100,
                'Africa',
                'Kano',
                'Wudil',
                'Unavailable',
                'Kano solar farm',
                'Unknown',
                'Dangote Industries Ltd; Black Rhino Group',
              ],
              [
                'Nigeria',
                30,
                'Africa',
                'Unavailable',
                'Kajuru',
                'Unavailable',
                'Kaduna (DLO) solar farm',
                'Unknown',
                'DLO Energy Resources Group',
              ],
              [
                'Nigeria',
                50,
                'Africa',
                'Unavailable',
                'Kajuru',
                'Unavailable',
                'Kaduna (Greenwish) solar farm',
                'Unknown',
                'Greenwish Partners',
              ],
              [
                'Nigeria',
                100,
                'Africa',
                'Ganjuwa',
                'Unavailable',
                'Unavailable',
                'Ganjuwa solar farm',
                'Unknown',
                'Nigeria Solar Capital Partners; Globeleq; ARM-Harith Infrastructure Fund',
              ],
              [
                'Nigeria',
                157,
                'Africa',
                'Lokoja',
                'Kachia',
                'Unavailable',
                'Lokoja solar farm',
                'Unknown',
                'Alten Renewable Developments Africa; Green Continent Partners Holding; Nemoante',
              ],
              [
                'Nigeria',
                100,
                'Africa',
                'Unavailable',
                'Udi',
                'Unavailable',
                'Enugu solar farm',
                'Unknown',
                'Greenwish Partners',
              ],
              [
                'Nigeria',
                50,
                'Africa',
                'Kokona',
                'Kokona',
                'Unavailable',
                'Onyi solar farm',
                'Unknown',
                'Afrinergia Power Ltd',
              ],
              [
                'Nigeria',
                50,
                'Africa',
                'Manchok',
                'Asholyio (Moroa) Chiefdom',
                'Kaura LGA',
                'Abiba solar farm',
                'Unknown',
                'Access Quaint Solar Nigeria Ltd.; InfraCo Africa',
              ],
              [
                'Nigeria',
                75,
                'Africa',
                'Galadima A',
                'Kankia',
                'Unavailable',
                'Katsina solar farm',
                'Unknown',
                'JCM Capital; Pan Africa Solar Limited (PAS)',
              ],
              [
                'Nigeria',
                70,
                'Africa',
                'Panyam',
                'Jos North',
                'Unavailable',
                'Panyam solar farm',
                'Unknown',
                'CT Nigeria; Siemens',
              ],
              [
                'Nigeria',
                55,
                'Africa',
                'Unavailable',
                'Wamako',
                'Unavailable',
                'Sokoto solar farm',
                'Unknown',
                'Africa Finance Corporation [80%]; Phanes FZ LLC and Other [20%]',
              ],
              [
                'Nigeria',
                200,
                'Africa',
                'Ashama',
                'Warri South',
                'Unavailable',
                'Ashama solar farm',
                'Unknown',
                'Sunnyfred Global; B&S Power Holding PTE',
              ],
              [
                'Nigeria',
                360,
                'Africa',
                'Unavailable',
                'Ojo',
                'Unavailable',
                'Lagos solar farm (Nigeria)',
                'Unknown',
                'FalCore Power & Energy; Gezhouba Group',
              ],
              [
                'North Korea',
                2500,
                'Asia',
                'Pyongyang',
                'Unavailable',
                'Unavailable',
                'Pyongyang solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'North Macedonia',
                70,
                'Europe',
                'Unavailable',
                'Peh\u010devo Municipality',
                'Unavailable',
                'Peh\u010devo solar farm',
                'Unknown',
                'Hek Solar MK',
              ],
              [
                'North Macedonia',
                375,
                'Europe',
                '\u0160tip',
                '\u0160tip Municipality',
                'Unavailable',
                'Stipion solar farm',
                'Unknown',
                'Akuo Energy SAS',
              ],
              [
                'North Macedonia',
                60,
                'Europe',
                'Bitola',
                'Bitola Municipality',
                'Unavailable',
                'Bitola solar farm',
                'Unknown',
                'Elektrani na Severna Makedonija (ESM)',
              ],
              [
                'North Macedonia',
                50,
                'Europe',
                'Oslomej',
                'Ki\u010devo Municipality',
                'Unavailable',
                'Oslomej solar farm',
                'Unknown',
                'Turkish Fortis Energy Electric',
              ],
              [
                'North Macedonia',
                50,
                'Europe',
                'Oslomej',
                'Ki\u010devo Municipality',
                'Unavailable',
                'Oslomej solar farm',
                'Unknown',
                'Solarpro Holding',
              ],
              [
                'North Macedonia',
                50,
                'Europe',
                'Unavailable',
                'Novaci Municipality',
                'Unavailable',
                'Novaci solar farm',
                'Unknown',
                'DTPU Mej grup',
              ],
              [
                'North Macedonia',
                85,
                'Europe',
                'Unavailable',
                'Karbinci Municipality',
                'Unavailable',
                'Karbinci solar farm',
                'Unknown',
                'Renewable Power International',
              ],
              [
                'North Macedonia',
                100,
                'Europe',
                'Bitola',
                'Bitola Municipality',
                'Unavailable',
                'Bitola solar farm',
                'Unknown',
                'Elektrani na Severna Makedonija (ESM)',
              ],
              [
                'North Macedonia',
                20,
                'Europe',
                'Bitola',
                'Bitola Municipality',
                'Unavailable',
                'Bitola solar farm',
                'Unknown',
                'Elektrani na Severna Makedonija (ESM)',
              ],
              [
                'Oman',
                500,
                'Middle East',
                'Duqm',
                'Unavailable',
                'Unavailable',
                'Scatec-Duqm Solar',
                'Scatec; Acme',
                'Scatec; Acme',
              ],
              [
                'Oman',
                100,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Northern Block 6',
                'Paew Solar',
                'Unknown',
                'Petroleum Development Oman (PDO); Energy Development Oman (EDO)',
              ],
              [
                'Oman',
                550,
                'Middle East',
                'Manah',
                'Unavailable',
                'Unavailable',
                'Manah solar farm',
                'Unknown',
                'The Oman Power and Water Procurement Company (OPWP)',
              ],
              [
                'Oman',
                550,
                'Middle East',
                'Manah',
                'Unavailable',
                'Unavailable',
                'Manah solar farm',
                'Unknown',
                'The Oman Power and Water Procurement Company (OPWP)',
              ],
              [
                'Oman',
                400,
                'Middle East',
                'Duqm',
                'Unavailable',
                'Unavailable',
                'Duqm Solar',
                'Ningxia Zhongke Jiaye New Energy and Technology Management Co',
                'Ningxia Zhongke Jiaye New Energy and Technology Management Co',
              ],
              [
                'Oman',
                500,
                'Middle East',
                'Ibri',
                'Unavailable',
                'Unavailable',
                'Ibri 2 Solar',
                'NOMAC',
                'ACWA Power [70%]; AlGihaz Renewable Energy Company [30%]',
              ],
              [
                'Oman',
                105,
                'Middle East',
                'Nimir',
                'Unavailable',
                'Unavailable',
                'Amin Solar PV Power Plant',
                'Amin Renewable Energy Company',
                'Marubeni Corporation [50.1%]; Oman Gas Company [30%]; Bahwan Renewable Energy Company [10%]; Nebras Power [9.9%]',
              ],
              [
                'Oman',
                12500,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Al Wusta Solar Plant',
                'OQ; InterContinental Energy; Enertech',
                'OQ; InterContinental Energy; Enertech',
              ],
              [
                'Oman',
                500,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Solar 2022 IPP',
                'Unknown',
                'Oman Power and Water Procurement Company (OPWP)',
              ],
              [
                'Oman',
                100,
                'Middle East',
                'Suhar Industrial City',
                'Unavailable',
                'Unavailable',
                'Madayn-Suhar Solar',
                'Madayn; Solar Wadi',
                'Madayn; Wadi Solar; Mubadrah',
              ],
              [
                'Oman',
                25,
                'Middle East',
                'Sohar Freezone',
                'Unavailable',
                'Unavailable',
                'Sohar Solar Qabas',
                'Unknown',
                'Shell Development Oman (SDO)',
              ],
              [
                'Pakistan',
                350,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Manjhand solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                30,
                'Asia',
                'Bahalwalnager',
                'Unavailable',
                'Unavailable',
                'Bahalwalnager (Asia Petroleum) solar farm',
                'Unknown',
                'Asia Petroleum Limited',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nooriabad solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nooriabad solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Panjgoor',
                'Gwadar District',
                'Unavailable',
                'Panjgoor solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Pishin',
                'Unavailable',
                'Unavailable',
                'Pishin solar farm',
                'Unknown',
                'Boston Solar (Private) Limited',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Quaid-E-Azam solar farm',
                'Unknown',
                'Quaid-e-Azam Solar Power Ltd.',
              ],
              [
                'Pakistan',
                300,
                'Asia',
                'Unavailable',
                'Bah\u0101walpur District',
                'Unavailable',
                'Quaid-E-Azam solar farm',
                'Unknown',
                'Zonergy Company Limited',
              ],
              [
                'Pakistan',
                600,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Quaid-E-Azam solar farm',
                'Unknown',
                'Zonergy Company Limited',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Saleh Pat',
                'Unavailable',
                'Sukkur',
                'Saleh Pat solar farm',
                'Unknown',
                'Artistic Milliners (Private Limited)',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Sukkur',
                'Unavailable',
                'Unavailable',
                'Sukkur solar farm',
                'Scatec ASA',
                'Scatec ASA [75%]; Nizam Energy [25%]',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Sukkur',
                'Unavailable',
                'Unavailable',
                'Sukkur solar farm',
                'Scatec ASA',
                'Scatec ASA [75%]; Nizam Energy [25%]',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Sukkur',
                'Unavailable',
                'Unavailable',
                'Sukkur solar farm',
                'Scatec ASA',
                'Scatec ASA [75%]; Nizam Energy [25%]',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Suraj solar farm',
                'Unknown',
                'Suraj Textile Mills Limited',
              ],
              [
                'Pakistan',
                20,
                'Asia',
                'Unavailable',
                'Tarbela Dam',
                'Unavailable',
                'Tarbela solar farm',
                'Unknown',
                'Water and Power Development Authority (WAPDA)',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Thatta',
                'Unavailable',
                'Unavailable',
                'Thatta (ACT) solar farm',
                'Unknown',
                'ACT Solar (Pvt.) Ltd.',
              ],
              [
                'Pakistan',
                25,
                'Asia',
                'Thatta',
                'Unavailable',
                'Unavailable',
                'Thatta (ET) solar farm',
                'Unknown',
                'ET Solar (Pvt.) Ltd.',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Unavailable',
                'Bah\u0101walpur District',
                'Unavailable',
                'Zorlu solar farm',
                'Zorlu Solar Pakistan (Pvt.) Limited (ZSPL)',
                'Zorlu Enerji',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Unavailable',
                'Quaid-e-Azam solar park',
                'Bahawalpur',
                'Zorlu solar farm',
                'Unknown',
                'Zorlu Sun Power Limited; Zorlu Renewable Pakistan Limited',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Unavailable',
                'Quaid-e-Azam solar park',
                'Bahawalpur',
                'Zorlu solar farm',
                'Unknown',
                'Zorlu Sun Power Limited; Zorlu Renewable Pakistan Limited',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Fateh Jang',
                'Unavailable',
                'Attock',
                'Attock solar farm',
                'Unknown',
                'ET Solar (Pvt.) Ltd.',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Manjhand',
                'Unavailable',
                'Jamshoro',
                'Manjhand solar farm',
                'Unknown',
                'Bridge Factor; Tractebel Engie',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Lasbela',
                'Unavailable',
                'Lasbela District',
                'Lasbela solar farm',
                'Unknown',
                'IB Voght GmbH',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nooriabad solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Unavailable',
                'Kuchlak (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Bostan',
                'Unavailable',
                'Pishin',
                'Bostan solar farm',
                'Unknown',
                'Ener Tec Holding Company',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Bostan',
                'Unavailable',
                'Pishin',
                'Bostan solar farm',
                'Unknown',
                'Ener Tec Holding Company',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kalar Kahar',
                'Unavailable',
                'Chakwal',
                'Chakwal solar farm',
                'Unknown',
                'Siddiqsons Solar Ltd.',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Chaubara solar farm',
                'Unknown',
                'Zhenga Energy Group Company Limited',
              ],
              [
                'Pakistan',
                100,
                'Asia',
                'Dahranwala',
                'Unavailable',
                'Chishtian',
                'Chishtian solar farm',
                'Unknown',
                'Crescent Steel; MdeCC',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Quaid-e-Azam solar park',
                'Bahawalpur',
                'Cholistan solar farm',
                'CTGI-WK Cholistan Solar Power Project (Pvt) Ltd',
                'China Three Gorges; Welt Konnect Pvt. Ltd.',
              ],
              [
                'Pakistan',
                20,
                'Asia',
                'Dadu',
                'Unavailable',
                'Unavailable',
                'Dadu solar farm',
                'Unknown',
                'R.E Solar Pvt. Ltd',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Lal Sohanra',
                'Lal Sohanra solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Din Garh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Mirpur Sakro',
                'Unavailable',
                'Unavailable',
                'Gharo Mirpur Sakro solar farm',
                'Gharo Solar Private Limited (GSPL)',
                'Rana Nasim Ahmed; Windforce (Private) Limited; Norsk Solar AS',
              ],
              [
                'Pakistan',
                20,
                'Asia',
                'Dadu',
                'Unavailable',
                'Unavailable',
                'Dadu solar farm',
                'Unknown',
                'R.E Solar Pvt. Ltd',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Khuzdar',
                'Khuzdar District',
                'Unavailable',
                'Khuzdar (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Khuzdar',
                'Khuzdar District',
                'Unavailable',
                'Khuzdar (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Khuzdar',
                'Khuzdar District',
                'Unavailable',
                'Khuzdar (IB Voght) solar farm',
                'Unknown',
                'IB Voght GmbH',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Quetta',
                'Kuchlak (El Passo Technology) solar farm',
                'Unknown',
                'El Passo Technology; AJS Group Company Karachi',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Quetta',
                'Kuchlak (El Passo Technology) solar farm',
                'Unknown',
                'El Passo Technology; AJS Group Company Karachi',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Unavailable',
                'Kuchlak (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Unavailable',
                'Kuchlak (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Kuchlak',
                'Unavailable',
                'Unavailable',
                'Kuchlak (Engro Energy) solar farm',
                'Unknown',
                'Engro Energy',
              ],
              [
                'Pakistan',
                50,
                'Asia',
                'Gwadar',
                'Gwadar District',
                'Unavailable',
                'Gwadar solar farm',
                'Unknown',
                'IB Voght GmbH',
              ],
              [
                'Panama',
                26,
                'Central America and the Caribbean',
                'Unavailable',
                'Progreso',
                'Bar\u00fa',
                'Esperanza solar farm',
                'Enel Green Power Panama (EGPP)',
                'Enel',
              ],
              [
                'Panama',
                31,
                'Central America and the Caribbean',
                'Unavailable',
                'Distrito Tol\u00e9',
                'Unavailable',
                'Madre Vieja PV Solar Plant',
                'Enel Green Power Panama (EGPP)',
                'Enel',
              ],
              [
                'Panama',
                120,
                'Central America and the Caribbean',
                'Unavailable',
                'Distrito Penonom\u00e9',
                'Penonom\u00e9',
                'Penonome PV Solar Plant',
                'Avanzalia Solar',
                'Avanzalia Solar',
              ],
              [
                'Peru',
                60,
                'South America',
                'Unavailable',
                'Unavailable',
                'La Joya',
                'Pichu Pichu PV Solar Plant',
                'Continua Energ\u00edas Positivas',
                'Continua Energ\u00edas Positiva',
              ],
              [
                'Peru',
                180,
                'South America',
                'Moquegua',
                'Unavailable',
                'Moquegua',
                'Rub\u00ed Solar Photovoltaic Plant',
                'Enel Per\u00fa',
                'Enel Green Power',
              ],
              [
                'Peru',
                22,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Repartici\u00f3n Solar Power Plant',
                'Grupo T-Solar Global, S.A',
                'Grupo T-Solar Global, S.A',
              ],
              [
                'Peru',
                22,
                'South America',
                'Moquegua',
                'Unavailable',
                'Unavailable',
                'Panamericana Solar PV Plant',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Peru',
                22,
                'South America',
                'Tacna',
                'Unavailable',
                'Unavailable',
                'Tacna Solar PV Plant',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Peru',
                300,
                'South America',
                'Unavailable',
                'Mollendo',
                'Islay',
                'Misti PV Solar Plant',
                'Continua Energ\u00edas Positivas',
                'Continua Energ\u00edas Positiva',
              ],
              [
                'Peru',
                22,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Majes Solar Power Plant',
                'Grupo T-Solar Global, S.A',
                'Grupo T-Solar Global, S.A',
              ],
              [
                'Peru',
                40,
                'South America',
                'Moquegua',
                'Unavailable',
                'Unavailable',
                'Intipampa Solar Plant',
                'Engie Energ\u00eda Per\u00fa',
                'Engie',
              ],
              [
                'Peru',
                116,
                'South America',
                'Unavailable',
                'Unavailable',
                'Mariscal Nieto',
                'Clemes\u00ed Solar Plant',
                'Enel Per\u00fa',
                'Enel Green Power',
              ],
              [
                'Peru',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Moquegua',
                'Moquegua PV Solar Plant',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Peru',
                100,
                'South America',
                'Unavailable',
                'Unavailable',
                'La Joya',
                'Chachani PV Solar Plant',
                'Continua Energ\u00edas Positivas',
                'Continua Energ\u00edas Positivas',
              ],
              [
                'Philippines',
                85,
                'Asia',
                'Pililla',
                'Unavailable',
                'Unavailable',
                'Pililla Solar Power Project',
                'Metro Solar Power Solutions, Inc.; Green Atom Renewable Energy Corporation; AC Energy',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Baras',
                'Unavailable',
                'Unavailable',
                'Pinugay Solar Power Project',
                'H&WB Asia Pacific (Pte Ltd) Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                150,
                'Asia',
                'Laguna de Bay and Pililla',
                'Unavailable',
                'Unavailable',
                'Rizal Floating Solar Project',
                'AC Laguna Solar, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                52,
                'Asia',
                'Rizal',
                'Unavailable',
                'Unavailable',
                'Rizal Occ. Mindoro Hybrid Solar Power Project',
                'One Renewable Energy Enterprise, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                140,
                'Asia',
                'San Ildefonso',
                'Unavailable',
                'Unavailable',
                'San Ildefonso (Solar Philippines) solar farm',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                23,
                'Asia',
                'San Carlos City',
                'Unavailable',
                'Unavailable',
                'San Carlos Solar Power Project',
                'San Carlos Solar Energy Inc.\n(SACASOL)',
                'San Carlos Solar Energy Inc. (SACASOL); Bronzeoak Philippines; ThomasLloyd',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Tarlac City',
                'Unavailable',
                'Unavailable',
                'Petrosolar',
                'PetroSolar Corporation',
                'PetroSolar Corporation',
              ],
              [
                'Philippines',
                55,
                'Asia',
                'San Ildefonso',
                'Unavailable',
                'Unavailable',
                'San Ildefonso (Team Philippines) solar farm',
                'Team (Philippines) Renewable Energy Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                151,
                'Asia',
                'San Isidro and Calubian',
                'Unavailable',
                'Leyte 5th District',
                'San Isidro Solar Power Project',
                'TotalPower, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'San Juan',
                'Unavailable',
                'Unavailable',
                'San Juan Solar Power Project',
                'Scion Sustainable Power Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                59,
                'Asia',
                'San Carlos',
                'Unavailable',
                'Unavailable',
                'Sacasun Solar Power Project',
                'San Carlos Sun Power, Inc.',
                'San Carlos Sun Power, Inc.',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Burgos and Pasuquin',
                'Unavailable',
                'Unavailable',
                'Pasuquin solar farm',
                'Energy Logics Philippines, Inc. (ELPI)',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Leyte 1st District',
                'Palo Solar Power Project',
                'Sulu Electric Power and Light\n(Phils.), Inc. (SEPALCO)',
                'Sulu Electric Power and Light (Phils.), Inc. (SEPALCO); MRC',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Rizal and Pantabangan',
                'Unavailable',
                'Unavailable',
                'Pantabangan Solar Power Project',
                'Firmgreen Phils. Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Roxas and San Vicente',
                'Unavailable',
                'Unavailable',
                'Palawan Solar Power Project',
                'Global Clean Hybrid Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Iba-Palauig',
                'Unavailable',
                'Unavailable',
                'Palauig Solar Power Project',
                'Shizen, Inc.',
                'Mabalacat Solar Philippines; Sindicatum',
              ],
              [
                'Philippines',
                45,
                'Asia',
                'Lipa City and Padre Garcia',
                'Unavailable',
                'Unavailable',
                'Padre Garcia Solar Power Project',
                'Phinma Energy Corp; Solar Philippines Batangas Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                30,
                'Asia',
                'Ormoc',
                'Unavailable',
                'Leyte 4th District',
                'Ormoc Solar Power Project',
                'First Soleq Energy Corporation',
                'First Soleq Energy Corporation',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Opol',
                'Unavailable',
                'Unavailable',
                'Opol Solar Power Project',
                'Electra Ecoenergy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                190,
                'Asia',
                'Lumban and Cavinti',
                'Unavailable',
                'Unavailable',
                'Nks Solar One Floating Power Project',
                'NKS Solar One, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                30,
                'Asia',
                'Nasugbu and Tuy',
                'Unavailable',
                'Unavailable',
                'Nasugbu Solar Power Project',
                'Roxas Green Energy Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Naic',
                'Unavailable',
                'Unavailable',
                'Naic Solar Farm',
                'Solar Philippines Tagoloan Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Himalayan',
                'Unavailable',
                'Unavailable',
                'Nabali-An Solar Power Project',
                'Greencane Sugarfields Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                115,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mitsui solar farm',
                'PH Renewables, Inc.',
                'Philippine Communications Satellite Corporation (Philcomsat); Mitsui & Co.; China Energy Engineering Corporation',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'Paoay',
                'Unavailable',
                'Unavailable',
                'Paoay III Solar Energy Project',
                'Del Sol Energy Tercera, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                70,
                'Asia',
                'San Manuel',
                'Unavailable',
                'Unavailable',
                'San Maunel Solar Power Project',
                'Pilipinas Newton Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                250,
                'Asia',
                'Muntinlupa',
                'Unavailable',
                'Unavailable',
                'San Pedro Floating Solar Power Project',
                'Nortesol Incorporated',
                'Unknown',
              ],
              [
                'Philippines',
                130,
                'Asia',
                'San Pablo',
                'Unavailable',
                'Unavailable',
                'San Pablo Solar Power Project',
                'Solar Valley Energy Solutions Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Medellin',
                'Unavailable',
                'Unavailable',
                'Medellin Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Bacolod City',
                'Unavailable',
                'Unavailable',
                'Vista Alegre Solar Power Project',
                'Amatera Renewable Energy Corporation',
                'TPC Construction Corporation',
              ],
              [
                'Philippines',
                31,
                'Asia',
                'Victorias City',
                'Unavailable',
                'Unavailable',
                'Victorias Solar Power Project',
                'VictoriaSolar Energy Corp.; SunAsia Energy, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                62,
                'Asia',
                'Tuy',
                'Unavailable',
                'Unavailable',
                'Tuy Batangas 4 Solar Power Project',
                'Greencore Power Solutions 2, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                80,
                'Asia',
                'Alabel',
                'Unavailable',
                'Unavailable',
                'Tpi Sarangani Solar Power Project',
                'TotalPower, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                34,
                'Asia',
                'Tigbauan',
                'Unavailable',
                'Unavailable',
                'Tigbauan Solar Power Project',
                'Solexar Energy International, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Tarlac City',
                'Unavailable',
                'Unavailable',
                'Tarlac Solar Power Project',
                'PetroSolar Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Tarlac City',
                'Unavailable',
                'Unavailable',
                'Tarlac Solar Power Project',
                'PetroSolar Corporation; Conergy',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Tantangan',
                'Unavailable',
                'Unavailable',
                'Tantangan Solar Power Project',
                'nv vogt Philippines Solar Energy One, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Tanauan',
                'Unavailable',
                'Unavailable',
                'Tanauan solar farm',
                'Solar Philippine Tanauan Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                125,
                'Asia',
                'Mu\u00f1oz and Lupao',
                'Unavailable',
                'Unavailable',
                'Talugtug Solar Power Project',
                'Greenergy Solutions Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                120,
                'Asia',
                'Binangonan and Cardona',
                'Unavailable',
                'Unavailable',
                'Talim Floating Solar Power Project',
                'Island Wind Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                120,
                'Asia',
                'Binangonan and Cardona',
                'Unavailable',
                'Unavailable',
                'Talim Floating Solar Power Project',
                'Island Wind Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                45,
                'Asia',
                'Tagoloan',
                'Unavailable',
                'Unavailable',
                'Tagoloan Solar Power Project',
                'Solar Philippines Tagoloan Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Narvacan',
                'Unavailable',
                'Unavailable',
                'Sulvec Solar Power Project',
                'Neoenergy Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Subic New Pv Solar Power Plant Project',
                'Jobin-Sqm Inc.',
                'Emerging Power, Inc. (EPI)',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Silay',
                'Unavailable',
                'Unavailable',
                'Silay Solar Power Project',
                'Citicore Solar Negros Occidental, Inc.; Silay Solar Power, Inc.',
                'Silay Solar Power Inc.',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'General Santos City',
                'Unavailable',
                'Unavailable',
                'Santos Solar Power Project',
                'Astronergy Development GenSan Inc.',
                'Astronergy Development Gensan, Inc. (ADGI); Harbor Star Energy Corp (HSEC)',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Santa',
                'Unavailable',
                'Unavailable',
                'Santa Solar Power Project',
                'Satrap Power Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'Concepcion',
                'Concepcion',
                'Unavailable',
                'Santa Rosa Solar Power Project',
                'Terasu Energy Inc.',
                'Mabalacat Solar Philippines; Sindicatum',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Santa Rosa and Pe\u00f1aranda',
                'Unavailable',
                'Unavailable',
                'Santa Rosa Nueva Ecija Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                30,
                'Asia',
                'Sta. Maria',
                'Unavailable',
                'Unavailable',
                'Santa Maria Solar Power Project',
                'East Coast FAS Renewable Energy and Industrial Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Sta. Maria',
                'Unavailable',
                'Unavailable',
                'Santa Maria Solar Power Project',
                'Greenenergy Solutions Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Mapandan and Santa Barbara',
                'Unavailable',
                'Unavailable',
                'Santa Barbara Solar Power Project',
                'SunAsia Energy, Inc.; OneManaoag Solar Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                140,
                'Asia',
                'San Rafael',
                'Unavailable',
                'Unavailable',
                'San Rafael Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                70,
                'Asia',
                'San Manuel',
                'Unavailable',
                'Unavailable',
                'San Maunel Solar Power Project',
                'Pilipinas Newton Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                200,
                'Asia',
                'Naic',
                'Unavailable',
                'Unavailable',
                'Maragondon-Naic-Tanza 2 Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                22,
                'Asia',
                'San Carlos',
                'Unavailable',
                'Unavailable',
                'San Carlos Solar Power Project',
                'San Carlos Solar Energy Inc.\n(SACASOL)',
                'San Carlos Solar Energy Inc. (SACASOL); Bronzeoak Philippines; ThomasLloyd',
              ],
              [
                'Philippines',
                140,
                'Asia',
                'Maragondon',
                'Unavailable',
                'Unavailable',
                'Maragondon Solar Power Project',
                'Solar Philippines Tanauan Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Calamba and Tanauan City',
                'Unavailable',
                'Unavailable',
                'Calamba-Tanauan Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                63,
                'Asia',
                'Unavailable',
                'Calatagan',
                'Unavailable',
                'Calatagan Solar Power Project',
                'Solar Philippines Calatagan Corporation',
                'Solar Philippines Calatagan Corporation',
              ],
              [
                'Philippines',
                28,
                'Asia',
                'Capas',
                'Capas',
                'Unavailable',
                'Capas Solar Power Project',
                'Sindicatum C-Solar Power Inc.; Climate Investor One',
                'Unknown',
              ],
              [
                'Philippines',
                41,
                'Asia',
                'Unavailable',
                'Rosario',
                'Unavailable',
                'Cavite Special Economic Zone Solar Power Project,',
                'Majestic Power Corporation',
                'Majestic Power Corporation',
              ],
              [
                'Philippines',
                75,
                'Asia',
                'Labrador',
                'Unavailable',
                'Unavailable',
                'Cayanga-Bugallon Solar Power Project',
                'PV Sinag Power Inc.; Aboitiz Power',
                'AboitizPower',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Clark Green City',
                'Capas',
                'Unavailable',
                'Clark Green City solar farm',
                'Unknown',
                'The Bases Conversion and Development Authority; Sunray Power Inc.; Menlo Renewable Energy Corp.',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Calamba and Tanauan',
                'Unavailable',
                'Unavailable',
                'Calamba-Tanauan Solar Power Project',
                'Solar Philippines Tanauan Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                22,
                'Asia',
                'Mabalacat',
                'Unavailable',
                'Unavailable',
                'Clark Solar Power Project',
                'Citicore Solar Clark, Inc.; Enfinity Philippines Renewable Resources Inc.',
                'Enfinity Philippines Renewable Resources Inc.; Mabalacat Solar Philippines Inc. (MSPI); Sindicatum Renewable Energy Company; Armstrong Asset Management',
              ],
              [
                'Philippines',
                61,
                'Asia',
                'Claveria',
                'Unavailable',
                'Unavailable',
                'Claveria Solar Power Project',
                'The Ark Green Dynamic Resources Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                21,
                'Asia',
                'Concepcion',
                'Concepcion',
                'Unavailable',
                'Concepcion solar farm',
                'Solar Philippines Tarlac Corporation',
                'Solar Philippines Tarlac Corporation',
              ],
              [
                'Philippines',
                71,
                'Asia',
                'Concepcion',
                'Concepcion',
                'Unavailable',
                'Concepcion solar farm',
                'Solar Philippines Tarlac Corporation',
                'Solar Philippines Tarlac Corporation',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Cordon',
                'Unavailable',
                'Unavailable',
                'Cordon Solar Power Project',
                'Greenenergy Solutions Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                150,
                'Asia',
                'Cordon',
                'Unavailable',
                'Unavailable',
                'Cordon Solar Power Project',
                'Greenenergy Solutions Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Batac',
                'Unavailable',
                'Unavailable',
                'Currimao Solar Power Project',
                'Mirae Asia Energy Corporation',
                'Mirae Asia Energy Corporation',
              ],
              [
                'Philippines',
                38,
                'Asia',
                'Clark Freeport Zone',
                'Unavailable',
                'Unavailable',
                'Clark Solar Power Project',
                'Energence Renewable Energy Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                48,
                'Asia',
                'Currimao',
                'Unavailable',
                'Unavailable',
                'Currimao Solar Power Project',
                'Nuevo Solar Energy Corp',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Cauayan',
                'Unavailable',
                'Unavailable',
                'Cagayan Valley Solar Power Project',
                'GRM Cagayan Valley, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                600,
                'Asia',
                'Cabatang',
                'Unavailable',
                '2nd District',
                'Cabatang Tiaong Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                120,
                'Asia',
                'Alaminos',
                'Unavailable',
                'Unavailable',
                'Alaminos Solar Power Project',
                'Solarace1 Energy Corp.; AC Energy',
                'AC Energy',
              ],
              [
                'Philippines',
                22,
                'Asia',
                'San Ildefonso',
                'Unavailable',
                'Unavailable',
                'Bulacan 2 Solar Power Project',
                'CleanTech Global Renewables, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Naic',
                'Unavailable',
                'Unavailable',
                'Maragondon-Naic 1 Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                45,
                'Asia',
                'Bugallon',
                'Unavailable',
                'Unavailable',
                'Bugallon solar farm',
                'Phinma Energy Corp',
                'Phinma Energy Corp',
              ],
              [
                'Philippines',
                46,
                'Asia',
                'Sison & Binalonan',
                'Unavailable',
                'Unavailable',
                'Binalonan Solar Power Project',
                'PV Sinag Power Inc.; Aboitiz Power',
                'Unknown',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Biliran',
                'Unavailable',
                'Unavailable',
                'Biliran Solar Power Project',
                'E & P Green Energy, Inc',
                'META Corporation',
              ],
              [
                'Philippines',
                132,
                'Asia',
                'Unavailable',
                'Cadiz',
                'Unavailable',
                'Cadiz Solar Power Project',
                'Helios Solar Energy Corporation\n(HSEC)',
                'Helios Solar Energy Corporation\n(HSEC)',
              ],
              [
                'Philippines',
                36,
                'Asia',
                'Palauig',
                'Unavailable',
                'Unavailable',
                'Bato Solar Power Project',
                'Solar Power Utilities Generator Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                34,
                'Asia',
                'Hermosa',
                'Unavailable',
                'Unavailable',
                'Bataan Solar Power Project',
                'Jobin-Sqm Inc.',
                'Provincial government of Bataan; The Global Green Growth Institute (GGGI)',
              ],
              [
                'Philippines',
                32,
                'Asia',
                'Hermosa',
                'Unavailable',
                'Unavailable',
                'Bataan Solar Power Project',
                'Jobin-Sqm Inc.',
                'Provincial government of Bataan; The Global Green Growth Institute (GGGI)',
              ],
              [
                'Philippines',
                600,
                'Asia',
                'Balayan and Calaca',
                'Unavailable',
                'Unavailable',
                'Balayan Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Badoc',
                'Unavailable',
                'Unavailable',
                'Badoc/Vintar solar farm',
                'EC Covuy Philippines, Inc.',
                'EC Covuy Philippines, Inc.',
              ],
              [
                'Philippines',
                39,
                'Asia',
                'Tarlac City and San Jose',
                'Capas',
                'Unavailable',
                'Armenia Solar Power Project',
                'AP Renewables Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'San Miguel',
                'Unavailable',
                'Unavailable',
                'Bulacansol solar farm',
                'Powersource First Bulacan Solar, Inc.',
                'MGen Renewable Energy, Inc. (MGreen); PowerSource Energy Holdings Corporation',
              ],
              [
                'Philippines',
                34,
                'Asia',
                'Hermosa',
                'Unavailable',
                'Unavailable',
                'Bataan Solar Power Project',
                'Jobin-Sqm Inc.',
                'Provincial government of Bataan; The Global Green Growth Institute (GGGI)',
              ],
              [
                'Philippines',
                74,
                'Asia',
                'Calabanga',
                'Unavailable',
                'Unavailable',
                '74.131 Mwp / 51.555 Mw Calabanga Solar Power Project',
                'Calabanga Renewable Energy (CARE), Inc.',
                'Nexif Energy',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'Daanbantayan',
                'Unavailable',
                'Unavailable',
                'Daanbantayan Solar Farm',
                'CEKO Solar Farm System Corp',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Mati City',
                'Unavailable',
                'Unavailable',
                'Davao Oriental Solar Power Project',
                'Sun Option for Livelihood Alternative Resources Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                166,
                'Asia',
                'Quezon City',
                'Unavailable',
                'Eastern Manila District',
                'La Mesa Solar Power Project',
                'AC La Mesa Solar, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'Laguindingan',
                'Unavailable',
                'Unavailable',
                'Laguindingan Solar Power Project',
                'Centro Solar Energy, Inc.',
                'Michigan Power Inc (MPI); Diamond Generating Asia Ltd (DGA)',
              ],
              [
                'Philippines',
                110,
                'Asia',
                'Laguna de Bay',
                'Unavailable',
                'Unavailable',
                'Laguna Lake Solar Floating Project',
                'NORTESOLIII, Inc. (subsidiary of SunAsia Energy, Inc.); Meralco SolarGen Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                111,
                'Asia',
                'Lal-lo',
                'Unavailable',
                'Unavailable',
                'Lal-Lo Solar Power Project',
                'GM Energy Construction Philippines, Inc.',
                'CleanTech Renewable Energy 4 Corp',
              ],
              [
                'Philippines',
                98,
                'Asia',
                'Aguilar',
                'Unavailable',
                'Unavailable',
                'Laoag Solar Power Project',
                'PV Sinag Power Inc.; Aboitiz Power',
                'Unknown',
              ],
              [
                'Philippines',
                25,
                'Asia',
                'San Pablo and Cabagan',
                'Unavailable',
                'Unavailable',
                'Limbauan Solar Power Project',
                'BKS Green Energy Corp',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'La Carlota City',
                'Unavailable',
                'Unavailable',
                'La Carlota Solar Power Project',
                'Megawatt Clean Energy, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Lipa City and Santo Tomas',
                'Unavailable',
                'Unavailable',
                'Lumbang Solar Power Project',
                'SBR Clean Energy Corp.; GG Renewable Energy Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                62,
                'Asia',
                'Tuy',
                'Unavailable',
                'Unavailable',
                'Luntal-Bayudbod Solar Power Project',
                'Verdecore Power Solutions, Inc',
                'Unknown',
              ],
              [
                'Philippines',
                44,
                'Asia',
                'General Santos City',
                'Unavailable',
                'Unavailable',
                'Mabuhay Solar Power Project',
                'Embrace Nature Power1 Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                30,
                'Asia',
                'Macabud',
                'Unavailable',
                'Unavailable',
                'Macabud solar farm',
                'ATN Philippines Solar Energy Group, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Sultan Kudarat',
                'Unavailable',
                'Unavailable',
                'Maguindinao Solar Power Project',
                'Salamat Mindanao Light & Power Corporation P',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Manolo Fortich',
                'Unavailable',
                'Unavailable',
                'Manolo Fortich Solar Power Project',
                'Pilipinas Crosthwait Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Maragondon and General Emilio Aguinaldo',
                'Unavailable',
                'Unavailable',
                'Maragondon Solar Power Project',
                'Solar Philippines Tanauan Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                125,
                'Asia',
                'Lumbangan',
                'Unavailable',
                'Unavailable',
                'Lumbangan Ground Mounted Solar Power Project',
                'Citicore Renewable Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                35,
                'Asia',
                'Santa Cruz',
                'Unavailable',
                'Unavailable',
                'Darong Solar Power Project',
                'PhilNewEnergy, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                1200,
                'Asia',
                'Kananga and Ormoc',
                'Unavailable',
                'Leyte 5th District',
                'Kananga-Ormoc Solar Power Project',
                'Solar Philippines Visayas Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                32,
                'Asia',
                'La Carlota',
                'Unavailable',
                'Unavailable',
                'Islasol Solar Power Project',
                'Negros Island Solar Power Inc.\n(ISLASOL)',
                'Negros Island Solar Power Inc. (ISLASOL); Ronzeoak Philippines; Philippine Investment Alliance for Infrastructure (PINAI)',
              ],
              [
                'Philippines',
                29,
                'Asia',
                'Digos',
                'Unavailable',
                'Unavailable',
                'Digos solar farm',
                'Alterpower Digos Solar, Inc.',
                'Alterpower Digos Solar, Inc.',
              ],
              [
                'Philippines',
                30,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Eb Magalona solar farm',
                'Youil Renewable Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                60,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'First Toledo Solar',
                'Citicore Solar Cebu, Inc.; First Toledo Solar Energy Corporation (FTSEC)',
                'First Toledo Solar Energy Corporation (FTSEC)',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Gamu and Naguilian',
                'Unavailable',
                'Unavailable',
                'Gamu Solar Power Project',
                'Pilipinas Faraday Energy Corp.',
                'Unknown',
              ],
              [
                'Philippines',
                70,
                'Asia',
                'Gamu',
                'Unavailable',
                'Unavailable',
                'Gamu Solar Power Project',
                'PV Sinag Power Inc.; Aboitiz Power',
                'Unknown',
              ],
              [
                'Philippines',
                1200,
                'Asia',
                'General Santos City',
                'Unavailable',
                'Unavailable',
                'General Santos Solar Power Project',
                'Solar Philippines Commercial Rooftop Projects, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                48,
                'Asia',
                'La Carlota',
                'Unavailable',
                'Unavailable',
                'Islasol Solar Power Project',
                'Negros Island Solar Power Inc.\n(ISLASOL)',
                'Negros Island Solar Power Inc. (ISLASOL); Ronzeoak Philippines; Philippine Investment Alliance for Infrastructure (PINAI)',
              ],
              [
                'Philippines',
                63,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Gigasol3 Solar Power Project',
                'AC Energy',
                'AC Energy',
              ],
              [
                'Philippines',
                35,
                'Asia',
                'Islamic City of Marawi',
                'Unavailable',
                'Unavailable',
                'ICOM solar farm',
                'Lim Solar Philippines',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Ilagan City',
                'Unavailable',
                'Unavailable',
                'Ilagan City Solar Power Project',
                'Greenergy Solutions Inc.',
                'Living Project 4 People Philippines Inc.',
              ],
              [
                'Philippines',
                72,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arayat-Mexico solar farm',
                'Citicore Renewable Energy Corp.; AC Energy',
                'Citicore Renewable Energy Corporation; AC Energy',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'Paoay',
                'Unavailable',
                'Unavailable',
                'Ilocos Norte Phase Solar Power Project',
                'Del Sol Energy Primera, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                40,
                'Asia',
                'Paoay',
                'Unavailable',
                'Unavailable',
                'Ilocos Norte Phase Solar Power Project',
                'Del Sol Energy Primera, Inc.',
                'Unknown',
              ],
              [
                'Philippines',
                100,
                'Asia',
                'Burgos',
                'Unavailable',
                'Unavailable',
                'Ilocos Norte Solar Power Project',
                'Energy Logics Philippines, Inc. (ELPI)',
                'Unknown',
              ],
              [
                'Philippines',
                20,
                'Asia',
                'Villanueva',
                'Unavailable',
                'Unavailable',
                'Hayes Solar Power Project',
                'Hayes Solar Energy Corporation',
                'Unknown',
              ],
              [
                'Philippines',
                50,
                'Asia',
                'Batangas City',
                'Unavailable',
                'Unavailable',
                '50 Mw Mabacong Solar Power Project',
                'Lumin Solar Energy Inc.',
                'Unknown',
              ],
              [
                'Poland',
                20,
                'Europe',
                'Przykona',
                'Przykona Gmina',
                'Przykona County',
                'Gryf solar farm',
                'Unknown',
                'Energa OZE',
              ],
              [
                'Poland',
                30,
                'Europe',
                '\u0141\u0119czna',
                '\u0141\u0119czna Gmina',
                '\u0141\u0119czna County',
                'Bogdanka solar farm',
                'Unknown',
                'Enea',
              ],
              [
                'Poland',
                60,
                'Europe',
                'Be\u0142chat\u00f3w',
                'Be\u0142chat\u00f3w Gmina',
                'Be\u0142chat\u00f3w County',
                'Be\u0142chat\u00f3w solar farm',
                'Unknown',
                'PGE Energia Odnawialna; PGE G\u00f3rnictwo i Energetyka Konwencjonalna',
              ],
              [
                'Poland',
                50,
                'Europe',
                'Gr\u0119b\u00f3w',
                'Gr\u0119b\u00f3w Gmina',
                'Tarnobrzeg County',
                'Jezi\u00f3rko solar farm',
                'Unknown',
                'PGE Energia Odnawialna',
              ],
              [
                'Poland',
                250,
                'Europe',
                'Unavailable',
                'Zielona G\u00f3ra County',
                'Unavailable',
                'Lubuskie solar farm',
                'Unknown',
                'PGE Energia Odnawialna',
              ],
              [
                'Poland',
                70,
                'Europe',
                'Unavailable',
                'Pisz County',
                'Unavailable',
                'Northwest Poland solar farm',
                'Unknown',
                'Greencells GmbH',
              ],
              [
                'Poland',
                36,
                'Europe',
                'Resko',
                'Resko Gmina',
                '\u0141obez County',
                'Resko solar farm',
                'Unknown',
                'Better Energy; Statkraft',
              ],
              [
                'Poland',
                125,
                'Europe',
                'Unavailable',
                'Wroc\u0142aw County',
                'Unavailable',
                'Southeast Poland solar farm',
                'Unknown',
                'Greencells GmbH',
              ],
              [
                'Poland',
                50,
                'Europe',
                'Gr\u0119b\u00f3w',
                'Gr\u0119b\u00f3w Gmina',
                'Tarnobrzeg County',
                'Jezi\u00f3rko solar farm',
                'Unknown',
                'PGE Energia Odnawialna',
              ],
              [
                'Poland',
                64,
                'Europe',
                'Witnica',
                'Witnica Gmina',
                'Gorz\u00f3w County',
                'Witnica solar farm',
                'Unknown',
                'Alternus Energy Group Plc',
              ],
              [
                'Poland',
                203,
                'Europe',
                'Zwartowo',
                'Choczewo Gmina',
                'Wejherowo County',
                'Zwartowo solar farm',
                'Unknown',
                'Respect Energy Sa; GOLDBECK SOLAR',
              ],
              [
                'Poland',
                70,
                'Europe',
                'Brudzew',
                'Brudzew Gmina',
                'Turek County',
                'Brudzew solar farm',
                'Unknown',
                'ZE PAK SA',
              ],
              [
                'Poland',
                125,
                'Europe',
                'Nowe Czarnowo',
                'Gryfino Gmina',
                'Gryfino County',
                'Dolna Odra solar farm',
                'Unknown',
                'Pge Gornictwo I Energetyka Sa',
              ],
              [
                'Portugal',
                24,
                'Europe',
                'Unavailable',
                'Beja',
                'Unavailable',
                'Mendo Marco solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Bensafrim e Bar\u00e3o de S\u00e3o Jo\u00e3o',
                'Faro',
                'Unavailable',
                'Lagos Solar',
                'WiNRG',
                'Unknown',
              ],
              [
                'Portugal',
                109,
                'Europe',
                'Ourique',
                'Beja',
                'Beja',
                'Hanwha Ourique solar farm',
                'Unknown',
                'Hanwha Q Cells',
              ],
              [
                'Portugal',
                50,
                'Europe',
                'Unavailable',
                'Beja',
                'Ferreira do Alentejo',
                'Hanwha Alantejo solar farm',
                'Unknown',
                'Hanwha Q Cells',
              ],
              [
                'Portugal',
                46,
                'Europe',
                'Beja',
                'Beja',
                'Unavailable',
                'Ferreira Do Alentejo solar farm',
                'WiNRG',
                'Wirtgen Invest',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Portim\u00e3o',
                'Faro',
                'Unavailable',
                'Cotovio Solar',
                'Unknown',
                'Smartenergy; EKZ',
              ],
              [
                'Portugal',
                20,
                'Europe',
                'Castelo Branco',
                'Castelo Branco',
                'Unavailable',
                'Castelo Branco solar farm',
                'Unknown',
                'R.Power',
              ],
              [
                'Portugal',
                23,
                'Europe',
                'Mogadouro',
                'Bragan\u00e7a',
                'Unavailable',
                'Betty solar farm',
                'Unknown',
                'Edisun Power; Smartenergy',
              ],
              [
                'Portugal',
                46,
                'Europe',
                'Amareleja',
                'Beja',
                'Unavailable',
                'Amareleja Solar Park',
                'Amper Central Solar',
                'ACCIONA [66%]; Mitsubishi Corporation [34%]',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Mogadouro',
                'Bragan\u00e7a District',
                'Unavailable',
                'Mogadouro Solar',
                'Unknown',
                'Edisun Power; Smartenergy',
              ],
              [
                'Portugal',
                99,
                'Europe',
                'Unavailable',
                'Beja',
                'Ferreira do Alentejo',
                'Algarve solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'Portugal',
                28,
                'Europe',
                'Alcoutim',
                'Faro',
                'Unavailable',
                'Albercas solar farm',
                'Unknown',
                'Galp; European Investment Bank',
              ],
              [
                'Portugal',
                257,
                'Europe',
                '\u00c9vora',
                '\u00c9vora',
                'Unavailable',
                'Divor Solar',
                'Unknown',
                'Endesa; Hyperion Renewables',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Moura',
                'Beja',
                'Unavailable',
                'Moura Solar',
                'WiNRG',
                'Wirtgen Invest',
              ],
              [
                'Portugal',
                99,
                'Europe',
                'Ourique',
                'Beja',
                'Beja',
                'Hanwha Ourique solar farm',
                'Unknown',
                'Hanwha Q Cells',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Unavailable',
                'Lisbon',
                'Palmela',
                'Poceirao Solar Plant',
                'Voltalia',
                'Edisun Power; Smartenergy',
              ],
              [
                'Portugal',
                46,
                'Europe',
                'Ourique',
                'Beja',
                'Unavailable',
                'Ourika Solar',
                'Unknown',
                'Allianz Capital Partners',
              ],
              [
                'Portugal',
                48,
                'Europe',
                'Alcoutim',
                'Faro',
                'Unavailable',
                'Vicoso solar farm',
                'Unknown',
                'Galp; European Investment Bank',
              ],
              [
                'Portugal',
                29,
                'Europe',
                'Unavailable',
                'Beja',
                'Unavailable',
                'Vale De Moura solar farm',
                'Unknown',
                'Hyperion Renewables',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Alcoutim',
                'Faro',
                'Unavailable',
                'Sao Marcos solar farm',
                'Unknown',
                'Galp; European Investment Bank',
              ],
              [
                'Portugal',
                285,
                'Europe',
                'Satiago do Caem',
                'Lisbon',
                'Unavailable',
                'Santiago Do Cacem solar farm',
                'Unknown',
                'Iberdrola [50%]; Prosolia [50%]',
              ],
              [
                'Portugal',
                285,
                'Europe',
                'Satiago do Caem',
                'Lisbon',
                'Unavailable',
                'Santiago Do Cacem solar farm',
                'Unknown',
                'Iberdrola [50%]; Prosolia [50%]',
              ],
              [
                'Portugal',
                285,
                'Europe',
                'Satiago do Caem',
                'Lisbon',
                'Unavailable',
                'Santiago Do Cacem solar farm',
                'Unknown',
                'Iberdrola [50%]; Prosolia [50%]',
              ],
              [
                'Portugal',
                20,
                'Europe',
                'Santarem',
                'Santar\u00e9m',
                'Unavailable',
                'Santar\u00e9m solar farm',
                'Unknown',
                'R.Power',
              ],
              [
                'Portugal',
                285,
                'Europe',
                'Satiago do Caem',
                'Lisbon',
                'Unavailable',
                'Santiago Do Cacem solar farm',
                'Unknown',
                'Iberdrola [50%]; Prosolia [50%]',
              ],
              [
                'Portugal',
                30,
                'Europe',
                'Mexeiro',
                'Santar\u00e9m',
                'Santarem',
                'Salvaterra De Magos (Rosseti) Solar Farm',
                'Unknown',
                'Rosseti Engenharia',
              ],
              [
                'Portugal',
                24,
                'Europe',
                'Salvaterra de Magos',
                'Santar\u00e9m',
                'Unavailable',
                'Salvaterra De Magos (Exus) Solar Farm',
                'Efacec',
                'Blackrock Real Assests; Exus Management Partners',
              ],
              [
                'Portugal',
                49,
                'Europe',
                'Unavailable',
                'Castelo Branco',
                'Unavailable',
                'Sabuguriro solar farm',
                'Voltalia',
                'Edisun Power; Smartenergy',
              ],
              [
                'Portugal',
                219,
                'Europe',
                'Vaqueiros',
                'Faro',
                'Unavailable',
                'Riccardo Totta Solar Plant',
                'Unknown',
                'WElink Energy; China Triumph International Engineering Company (CTIEC)',
              ],
              [
                'Portugal',
                142,
                'Europe',
                'Ribatejo',
                'Set\u00fabal',
                'Unavailable',
                'Ribatejo Solar',
                'Unknown',
                'EDP Renewables',
              ],
              [
                'Portugal',
                34,
                'Europe',
                'Unavailable',
                'Castelo Branco',
                'Unavailable',
                'Quinta Da Sexia solar farm',
                'Voltalia',
                'Edisun Power; Smartenergy',
              ],
              [
                'Portugal',
                20,
                'Europe',
                'Portalegre',
                'Portalegre',
                'Unavailable',
                'Portalegre solar farm',
                'Unknown',
                'R.Power',
              ],
              [
                'Portugal',
                23,
                'Europe',
                'Alcanh\u00f5es',
                'Santar\u00e9m',
                'Unavailable',
                'Santarem Solar',
                'WiNRG',
                'Wirtgen Invest',
              ],
              [
                'Puerto Rico',
                25,
                'Central America and the Caribbean',
                'San German',
                'Unavailable',
                'Unavailable',
                'San German solar farm',
                'Unknown',
                'Solaner Puerto Rico One, LLC',
              ],
              [
                'Puerto Rico',
                160,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Lajas',
                'Montalva Solar',
                'PBJL Energy Corporation',
                'Greenbriar Capital Corp',
              ],
              [
                'Puerto Rico',
                34,
                'Central America and the Caribbean',
                'Morovis',
                'Unavailable',
                'Unavailable',
                'Morovis Solar',
                'Unknown',
                'X-Elio',
              ],
              [
                'Puerto Rico',
                45,
                'Central America and the Caribbean',
                'Isabela',
                'Unavailable',
                'Unavailable',
                'Oriana solar farm',
                'Unknown',
                'ArcLight Capital Partners',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Quebradillas',
                'Unavailable',
                'Unavailable',
                'Quebradillas solar farm',
                'Unknown',
                'North Coast Solar',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Lozia',
                'Unavailable',
                'Unavailable',
                'San Fermin Solar Project',
                'Unknown',
                'Uriel Renewables',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Yauco-Guayanilla',
                'Unavailable',
                'Unavailable',
                'Santa Rosa Solar',
                'Unknown',
                'Windmar Renewable Energy',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Moca',
                'Unavailable',
                'Unavailable',
                'Moca solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Hatillo',
                'A\u00f1asco',
                'Unavailable',
                'Xzerta-Tec Solar',
                'Unknown',
                'Grupotec',
              ],
              [
                'Puerto Rico',
                30,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Yabucoa Solar',
                'Unknown',
                'Western Wind Energy Corp.',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Barceloneta',
                'Unavailable',
                'Unavailable',
                'Bareloneta solar farm',
                'Unknown',
                'ReSun',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Barceloneta',
                'Unavailable',
                'Arecibo',
                'Blue Beetle solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Puerto Rico',
                77,
                'Central America and the Caribbean',
                'Unavailable',
                'Orocovis',
                'Unavailable',
                'Ciro One solar farm',
                'Unknown',
                'CIRO One Salinas LLC',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Dorado',
                'Unavailable',
                'Unavailable',
                'Dorado solar farm',
                'Unknown',
                'SolarBlue',
              ],
              [
                'Puerto Rico',
                20,
                'Central America and the Caribbean',
                'Vega Baja',
                'Unavailable',
                'Unavailable',
                'Vega Serena Solar Plant',
                'Unknown',
                'Renewable Energy Authority',
              ],
              [
                'Puerto Rico',
                40,
                'Central America and the Caribbean',
                'Cata\u00f1o',
                'Humacao',
                'Unavailable',
                'Fonroche Humacao solar farm',
                'Lord Electric Company',
                'Fonroche',
              ],
              [
                'Qatar',
                350,
                'Middle East',
                'Al-Kharsaah',
                'Unavailable',
                'Unavailable',
                'Al Kharsaah Solar',
                'Siraj 1 SPV',
                'TotalEnergies & Marubeni [40%]; Siraj Energy [60%]',
              ],
              [
                'Qatar',
                15,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Duhail',
                'Kahramaa Solar Facility',
                'Qatar General Electricity & Water Corporation (Kahramaa)',
                'Qatar General Electricity & Water Corporation (Kahramaa)',
              ],
              [
                'Qatar',
                450,
                'Middle East',
                'Al-Kharsaah',
                'Unavailable',
                'Unavailable',
                'Al Kharsaah Solar',
                'Siraj 1 SPV',
                'TotalEnergies & Marubeni [40%]; Siraj Energy [60%]',
              ],
              [
                'Romania',
                63,
                'Europe',
                'C\u0103lugareni',
                'Giurgiu County',
                'Unavailable',
                'C\u0103lugareni solar farm',
                'Unknown',
                'Enel Green Power',
              ],
              [
                'Romania',
                46,
                'Europe',
                'Uzunu - Calugareni',
                'Giurgiu County',
                'Unavailable',
                'Uzunu solar farm',
                'Unknown',
                'MBG Energie Rinnovabili SRL',
              ],
              [
                'Romania',
                55,
                'Europe',
                'Bra\u0219ov',
                'Bra\u0219ov',
                'Unavailable',
                'Ucea De Sus solar farm',
                'Green Vision Seven SR',
                'Sunshine Group',
              ],
              [
                'Romania',
                80,
                'Europe',
                'Tucerni',
                'Gorj County',
                'Unavailable',
                'Turceni solar farm',
                'Complexul Energetic Oltenia (CE Oltenia)',
                'Complexul Energetic Oltenia (CE Oltenia)',
              ],
              [
                'Romania',
                95,
                'Europe',
                'Tismana',
                'Gorj County',
                'Unavailable',
                'Tismana solar farm',
                'Complexul Energetic Oltenia (CE Oltenia)',
                'Complexul Energetic Oltenia (CE Oltenia)',
              ],
              [
                'Romania',
                45,
                'Europe',
                'Teiu\u0219',
                'Alba County',
                'Unavailable',
                'Teiu\u0219 solar farm',
                'Unknown',
                'EGC Solar Cuj',
              ],
              [
                'Romania',
                38,
                'Europe',
                'Giurgiu',
                'Giurgiu',
                'Unavailable',
                'Slobozia solar farm',
                'Unknown',
                'LJG Green Source Energy Alpha; Samsung',
              ],
              [
                'Romania',
                50,
                'Europe',
                'S\u0103rm\u0103\u0219ag',
                'S\u0103laj County',
                'Unavailable',
                'S\u0103rm\u0103\u0219ag solar farm',
                'Unknown',
                'Restart Energy; Interlink Capital Strategies',
              ],
              [
                'Romania',
                60,
                'Europe',
                'Rovinari',
                'Gorj County',
                'Unavailable',
                'Rovinari solar farm',
                'Complexul Energetic Oltenia (CE Oltenia)',
                'Complexul Energetic Oltenia (CE Oltenia)',
              ],
              [
                'Romania',
                153,
                'Europe',
                'Ratesti',
                'Arge\u0219 County',
                'Unavailable',
                'Ratesti solar farm',
                'Ecoenergy',
                'Econergy [50%]; Nofar Energy [50%]',
              ],
              [
                'Romania',
                26,
                'Europe',
                'Mo\u0219teni',
                'Teleorman County',
                'Unavailable',
                'Mo\u0219teni solar farm',
                'Unknown',
                'Enel Green Power',
              ],
              [
                'Romania',
                23,
                'Europe',
                'Sibiu',
                'Sibiu',
                'Unavailable',
                'Miercurea Sibiului solar farm',
                'Unknown',
                'XPV',
              ],
              [
                'Romania',
                56,
                'Europe',
                'Satu Mare',
                'Satu Mare',
                'Unavailable',
                'Livada solar farm',
                'Unknown',
                'Bester Generacion; Energiaprima; Stargreen Consulting',
              ],
              [
                'Romania',
                43,
                'Europe',
                'Giurgiu',
                'Giurgiu',
                'Unavailable',
                'Izvoarele solar farm',
                'Unknown',
                'LJG Green Source Energy Gamma S.R.L.',
              ],
              [
                'Romania',
                75,
                'Europe',
                'I\u015falni\u0163a',
                'Dolj County',
                'Unavailable',
                'Isalnita (SE Oltenia) solar farm',
                'Complexul Energetic Oltenia (CE Oltenia)',
                'Complexul Energetic Oltenia (CE Oltenia)',
              ],
              [
                'Romania',
                111,
                'Europe',
                'I\u015falni\u0163a',
                'Dolj County',
                'Unavailable',
                'Isalnita (Omv) solar farm',
                'Unknown',
                'OMV Petrom',
              ],
              [
                'Romania',
                48,
                'Europe',
                'Iaz',
                'Cara\u0219-Severin County',
                'Unavailable',
                'Iaz solar farm',
                'Unknown',
                'SC Metalluk Srl',
              ],
              [
                'Romania',
                50,
                'Europe',
                'Halanga',
                'Mehedinti County',
                'Unavailable',
                'Halanga solar farm',
                'GSP Power',
                'GSP Power',
              ],
              [
                'Romania',
                40,
                'Europe',
                'Unavailable',
                'Giurgiu County',
                'Unavailable',
                'Giurgiu (Simtel) solar farm',
                'Unknown',
                'Simtel Team',
              ],
              [
                'Romania',
                50,
                'Europe',
                'Unavailable',
                'Giurgiu County',
                'Unavailable',
                'Giurgiu (Core Value Capital) solar farm',
                'Unknown',
                'Core Value Capital',
              ],
              [
                'Romania',
                56,
                'Europe',
                'Ciuperceni',
                'Satu Mare County',
                'Unavailable',
                'Ciuperceni solar farm',
                'Unknown',
                'GPSB Solaris 48 S.R.L',
              ],
              [
                'Romania',
                45,
                'Europe',
                'Parau',
                'Brasov County',
                'Unavailable',
                'Brasov Solar Park',
                'Unknown',
                'Unknown',
              ],
              [
                'Romania',
                45,
                'Europe',
                'Unavailable',
                'Braila County',
                'Unavailable',
                'Braila solar farm',
                'Unknown',
                'Hidroelectrica',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Sol-Iletsky District',
                'Sol-Iletsky District',
                'Unavailable',
                'Sol-Iletsk solar farm',
                'Hevel Solar',
                'Hevel Solar',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Gorodishchensky District',
                'Gorodishchensky District',
                'Unavailable',
                'Ray-1 solar farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Orsk',
                'Orsk',
                'Unavailable',
                'Sakmara solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                30,
                'Eurasia',
                'Unavailable',
                'Russko-Polyanskaya District',
                'Omsk Oblast',
                'Russko-Polyanskaya solar farm',
                'Unknown',
                'Hevel Solar',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Orsk',
                'Orsk',
                'Unavailable',
                'Orskaya solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                45,
                'Eurasia',
                'Akbulaksky District',
                'Akbulaksky District',
                'Unavailable',
                'Novosergievka solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                44,
                'Eurasia',
                'Mostovsky District',
                'Mostovsky District',
                'Unavailable',
                'Mostovskaya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Medveditsa',
                'Zhirnovsky District',
                'Volgograd Oblast',
                'Medveditsa solar farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Mayminsky Rayon',
                'Mayminsky Rayon',
                'Unavailable',
                'Mayminskaya solar farm',
                'Hevel Solar',
                'Hevel Solar',
              ],
              [
                'Russia',
                45,
                'Eurasia',
                'Maloderbetovsky District',
                'Maloderbetovsky District',
                'Unavailable',
                'Maloderbetovskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041d\u043e\u0432\u043e\u043a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u0441\u043a',
                'Duma Gorodskogo Okruga Novokuybyshevsk',
                'Unavailable',
                'Samara (Solar Systems) Solar Farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                30,
                'Eurasia',
                'Liman',
                'Limansky District',
                'Astrakhan Oblast',
                'Limanskaya solar farm (Russia)',
                'Hevel Solar',
                'Hevel Solar',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Komsomolsky',
                'Chernozemelsky District',
                'Republic of Kalmykia',
                'Komsomolsky solar farm',
                'Solar Systems LLC',
                'Ministry of Energy - Russian Federation',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Kislovodsk',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041a\u0438\u0441\u043b\u043e\u0432\u043e\u0434\u0441\u043a',
                'Stavropol Krai',
                'Kislovodsk solar farm',
                'Unknown',
                'Sphinx-9',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Kislovodsk',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041a\u0438\u0441\u043b\u043e\u0432\u043e\u0434\u0441\u043a',
                'Stavropol Krai',
                'Kislovodsk solar farm',
                'Unknown',
                'Sphinx-9',
              ],
              [
                'Russia',
                38,
                'Eurasia',
                'Unavailable',
                'Ketchenerovsky District',
                'Republic of Kalmykia',
                'Kalmykia solar farm',
                'Unknown',
                'Fortum Oyj; Russian Direct Investment Fund (RDIF)',
              ],
              [
                'Russia',
                78,
                'Eurasia',
                'Unavailable',
                'Ketchenerovsky District',
                'Republic of Kalmykia',
                'Kalmykia solar farm',
                'Unknown',
                'Fortum Oyj; Russian Direct Investment Fund (RDIF)',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Inya',
                'Ongudaysky District',
                'Altai Republic',
                'Ininskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                '\u0414\u043e\u043c\u0431\u0430\u0440\u043e\u0432\u0441\u043a\u0438\u0439 \u0440\u0430\u0439\u043e\u043d',
                'Dombarovsky District',
                'Unavailable',
                'Dombarovskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                60,
                'Eurasia',
                'Privolzhsky District',
                'Privolzhsky District',
                'Unavailable',
                'Funtovo solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                44,
                'Eurasia',
                'Kurganinsky District',
                'Kurganinsky District',
                'Unavailable',
                'Labinskaya solar farm',
                'Unknown',
                'Hevel Solar',
              ],
              [
                'Russia',
                35,
                'Eurasia',
                'Unavailable',
                'Dzhidinsky District',
                'Republic of Buryatia',
                'Dzhidinskaya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041d\u043e\u0432\u043e\u043a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u0441\u043a',
                'Duma Gorodskogo Okruga Novokuybyshevsk',
                'Unavailable',
                'Samara (Solar Systems) Solar Farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                30,
                'Eurasia',
                'Unavailable',
                'Bezenchuksky District',
                'Samara Oblast',
                'Samara (T Plus) solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Yashkulsky District',
                'Yashkulsky District',
                'Unavailable',
                'Yashkul solar farm',
                'Hevel Solar',
                'Hevel Solar',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Svetloyarsky District',
                'Svetloyarsky District',
                'Unavailable',
                'Volgograd (Solar Systems) Solar Farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                20,
                'Eurasia',
                'Volgograd',
                'Volgograd',
                'Volgograd Oblast',
                'Volgograd (Lukoil) solar farm',
                'Unknown',
                'Lukoil',
              ],
              [
                'Russia',
                40,
                'Eurasia',
                'Ust-Koksinsky Rayon',
                'Ust-Koksinsky Rayon',
                'Unavailable',
                'Ust-Koksinskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                45,
                'Eurasia',
                'Dzhidinsky Rayon',
                'Dzhidinsky Rayon',
                'Unavailable',
                'Torey solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Svetlinsky District',
                'Svetlinsky District',
                'Unavailable',
                'Svetlinskaya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Staromaryevskaya',
                'Grachevsky distric',
                'Stavropol Krai',
                'Staromaryevskaya solar farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                60,
                'Eurasia',
                'Sol-Iletsky District',
                'Sol-Iletsky District',
                'Unavailable',
                'Sorochinsk solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041d\u043e\u0432\u043e\u043a\u0443\u0439\u0431\u044b\u0448\u0435\u0432\u0441\u043a',
                'Duma Gorodskogo Okruga Novokuybyshevsk',
                'Unavailable',
                'Samara (Solar Systems) Solar Farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                44,
                'Eurasia',
                'Seversky District',
                'Seversky District',
                'Unavailable',
                'Severskaya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Unavailable',
                'Marksovsky District',
                'Saratov Oblast',
                'Satatov solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                60,
                'Eurasia',
                'Akhtubinsky District',
                'Akhtubinsky District',
                'Unavailable',
                'Akhtubinsky solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Unavailable',
                'Volgograd',
                'Volgograd Oblast',
                'Bear solar farm',
                'Unknown',
                'Solar Systems LLC',
              ],
              [
                'Russia',
                45,
                'Eurasia',
                'Unavailable',
                'Orenburgsky District',
                'Orenburg Oblast',
                'Chebenkovskaya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Russia',
                30,
                'Eurasia',
                '\u0433\u043e\u0440\u043e\u0434\u0441\u043a\u043e\u0439 \u043e\u043a\u0440\u0443\u0433 \u041e\u0440\u0435\u043d\u0431\u0443\u0440\u0433',
                'Orenburgsky District',
                'Unavailable',
                'Chkalovskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Dergachyovsky District',
                'Dergachyovsky District',
                'Unavailable',
                'Dergachevskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                20,
                'Eurasia',
                'Dergachyovsky District',
                'Dergachyovsky District',
                'Unavailable',
                'Dergachevskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Russia',
                30,
                'Eurasia',
                'Unavailable',
                'Svetlinsky district',
                'Orenburg Oblast',
                'Saturn solar farm',
                'Unknown',
                'T Plus',
              ],
              [
                'Russia',
                25,
                'Eurasia',
                'Sol-Iletsky District',
                'Sol-Iletsky District',
                'Unavailable',
                'Elshanskaya solar farm',
                'Hevel Solar',
                'Unknown',
              ],
              [
                'Saint Kitts and Nevis',
                38,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Basseterre Valley solar farm',
                'Leclanch\u00e9',
                'Leclanch\u00e9',
              ],
              [
                'Saudi Arabia',
                50,
                'Middle East',
                'Al Jouf',
                'Unavailable',
                'Unavailable',
                'Al Jouf Solar Plant',
                'Unknown',
                'Total Energy',
              ],
              [
                'Saudi Arabia',
                600,
                'Middle East',
                'Al Faisaliah',
                'Unavailable',
                'Unavailable',
                'Al-Faisaliah (Shuaibah) Solar',
                'Unknown',
                'ACWA Power; Al-Babtain Holding Investment Company; Gulf Investment Corporation',
              ],
              [
                'Saudi Arabia',
                15,
                'Middle East',
                'Al Khafji',
                'Unavailable',
                'Unavailable',
                'Ras Al-Khafji Desalination Solar Facility',
                'Unknown',
                'Rawafid Industrial; Advanced Water Technology (AWT)',
              ],
              [
                'Saudi Arabia',
                50,
                'Middle East',
                'Al Madinah',
                'Madinah',
                'Unavailable',
                'Madinah PV IPP solar farm',
                'Al-Balagha; Alfanar Construction; Desert Technologies',
                'Al-Balagha; Alfanar Construction; Desert Technologies',
              ],
              [
                'Saudi Arabia',
                80,
                'Middle East',
                'Layla',
                'Alaflaj',
                'Unavailable',
                'Layla Solar PV Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Saudi Arabia',
                30,
                'Middle East',
                'NADEC City',
                'Haradh',
                'Unavailable',
                'Nadec Solar PV IPP',
                'Engie SA',
                'Engie SA; National Agricultural Development Company (NADEC)',
              ],
              [
                'Saudi Arabia',
                200,
                'Middle East',
                'Qurayyat',
                'Unavailable',
                'Unavailable',
                'Qurayyat PV IPP solar farm',
                'Unknown',
                'ACWA Power; Al-Babtain Holding Investment Company; Gulf Investment Corporation',
              ],
              [
                'Saudi Arabia',
                300,
                'Middle East',
                'Rabigh Industrial City',
                'Unavailable',
                'Unavailable',
                'Rabigh Solar PV',
                'China Energy Engineering Group (CEEC)',
                'China Energy Engineering Group (CEEC)',
              ],
              [
                'Saudi Arabia',
                20,
                'Middle East',
                'Rafha',
                'Unavailable',
                'Unavailable',
                'Rafha PV IPP solar farm',
                'Unknown',
                'Tamasuk Holding Company; Alfanar Construction; Desert Technologies',
              ],
              [
                'Saudi Arabia',
                50,
                'Middle East',
                'Rafha',
                'Unavailable',
                'Unavailable',
                'Rafha solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Saudi Arabia',
                340,
                'Middle East',
                'Unavailable',
                'Read Sea Coast',
                'Unavailable',
                'Red Sea Solar Plant',
                'ACWA Power; SPIC Huanghe Hydropower Development Company; Saudi Tabreed Cooling Company',
                'ACWA Power; SPIC Huanghe Hydropower Development Company; Saudi Tabreed Cooling Company',
              ],
              [
                'Saudi Arabia',
                100,
                'Middle East',
                'Makkah',
                'Unavailable',
                'Unavailable',
                'Mecca Solar',
                'Unknown',
                'Holy Makkah Municipality (HMM)',
              ],
              [
                'Saudi Arabia',
                300,
                'Middle East',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Saad Solar PV Plant',
                'JinkoPower',
                'JinkoPower',
              ],
              [
                'Saudi Arabia',
                1500,
                'Middle East',
                'Sudair Industrial City',
                'Unavailable',
                'Unavailable',
                'Sudair Solar PV Project',
                'Unknown',
                'ACWA Power; Badeel; Saudi Aramco Power Company',
              ],
              [
                'Saudi Arabia',
                120,
                'Middle East',
                'Wadi Ad Dawasir',
                'Najd',
                'Unavailable',
                'Wadi Ad Dawasir Solar PV Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Saudi Arabia',
                20,
                'Middle East',
                'Yanbu',
                'Unavailable',
                'Ar Rayyis',
                'Yanbu 4 Iwp solar farm',
                'Engie SA',
                'France-headquartered ENGIE [40%]; Saudi based Nesma [30%]; Mowah [30%]',
              ],
              [
                'Saudi Arabia',
                10,
                'Middle East',
                'Layla',
                'Alaflaj',
                'Unavailable',
                'Layla Solar Plant',
                'Unknown',
                'Taqnia Energy; King Abdulaziz City for Science and Technology; Saudi Electric Company',
              ],
              [
                'Saudi Arabia',
                10,
                'Middle East',
                'Al Khafji',
                'Unavailable',
                'Eastern region',
                'Kacst Solar',
                'Unknown',
                'King Abdulaziz City for Science and Technology (KACST)',
              ],
              [
                'Saudi Arabia',
                60,
                'Middle East',
                'Jubail',
                'Unavailable',
                'Unavailable',
                'Jubail 3B Solar PV Plant',
                'Engie [40%]; Nesma Company Limited [30%]; Abdulaziz Al Ajlan Sons for Commercial and Real Estate Investment Ajlan And Bros Company [30%]',
                'Engie [40%]; Nesma Company Limited [30%]; Abdulaziz Al Ajlan Sons for Commercial and Real Estate Investment Ajlan And Bros Company [30%]',
              ],
              [
                'Saudi Arabia',
                300,
                'Middle East',
                'Third Jeddah Industrial City',
                'Unavailable',
                'Unavailable',
                'Jeddah Solar Project',
                'Masdar; EDF Renewables; Nesma Holding Company',
                'Masdar; EDF Renewables; Nesma Holding Company',
              ],
              [
                'Saudi Arabia',
                11,
                'Middle East',
                'Dhahran',
                'Unavailable',
                'Unavailable',
                'Dhahran Solar Cark Park',
                'Unknown',
                'Saudi Aramco',
              ],
              [
                'Saudi Arabia',
                700,
                'Middle East',
                'Ar Rass',
                'Unavailable',
                'Unavailable',
                'Ar Rass Solar PV',
                'ACWA Power',
                'ACWA Power [40.1%]; Water and Electricity Holding Company (Badeel) [20%]; State Power Investment Corporation [39.9%]',
              ],
              [
                'Saudi Arabia',
                300,
                'Middle East',
                'Sakaka',
                'Unavailable',
                'Unavailable',
                'Sakaka Solar',
                'NOMAC',
                'ACWA Power; Al Gihaz Holding',
              ],
              [
                'Senegal',
                44,
                'Africa',
                'Kahone',
                'Unavailable',
                'D\u00e9partement de Kaffrine',
                'Kahone Solaire Sa solar farm',
                'Unknown',
                "Engie [40%]; Meridiam [40%]; Fonds Souverain d'investissements Strat\u00e9giques [20%]",
              ],
              [
                'Senegal',
                25,
                'Africa',
                'Touba',
                'Unavailable',
                'D\u00e9partement de Mback\u00e9',
                'Ka\u00e9l solar farm',
                'Unknown',
                "Engie [40%]; Meridiam [40%]; Fonds Souverain d'investissements Strat\u00e9giques [20%]",
              ],
              [
                'Senegal',
                30,
                'Africa',
                'Niakhar',
                'Unavailable',
                'D\u00e9partement de Fatick',
                'Niakhar solar farm',
                'Energy Resources Senegal (ERS); Climate Fund Managers (CFM)',
                'Energy Resources Senegal (ERS); Climate Fund Managers (CFM)',
              ],
              [
                'Senegal',
                21,
                'Africa',
                'Communaut\u00e9 rurale de Dya',
                'Unavailable',
                'D\u00e9partement de Kaolack',
                'Kahone solar farm',
                'Energy Resources Senegal (ERS)',
                'Energy Resources Senegal (ERS)',
              ],
              [
                'Senegal',
                20,
                'Africa',
                'Communaut\u00e9 rurale de Bokhol',
                'Unavailable',
                'D\u00e9partement de Dagana',
                'Bokhol solar farm',
                'Unknown',
                'Denham Capital; GreenWish',
              ],
              [
                'Senegal',
                22,
                'Africa',
                'Communaut\u00e9 rurale de Malicounda',
                'Unavailable',
                "D\u00e9partement de M'bour",
                'Malicounda solar farm',
                'Unknown',
                'Senelec; Solaria Group',
              ],
              [
                'Senegal',
                30,
                'Africa',
                'Santhiou M\u00e9kh\u00e9',
                'Unavailable',
                'D\u00e9partement de Koumpentoum',
                'Santhiou M\u00e9kh\u00e9 solar farm',
                'Unknown',
                'Meridiam; Solairedirect; Schneider Electric',
              ],
              [
                'Senegal',
                20,
                'Africa',
                'Sakal',
                'Unavailable',
                'Louga Department',
                'Sakal solar farm',
                'Unknown',
                'Innovent',
              ],
              [
                'Senegal',
                30,
                'Africa',
                'Merina Dakhar',
                'Unavailable',
                'D\u00e9partement de Tivaouane',
                'Ten Merina solar farm',
                'Eiffage; Solairedirect',
                'Solairedirect',
              ],
              [
                'Serbia',
                660,
                'Europe',
                'Unavailable',
                'Kula Municipality',
                'West Ba\u010dka District',
                'Kula Solar Farm',
                'Unknown',
                'Fintel Energija; MK Group',
              ],
              [
                'Serbia',
                50,
                'Europe',
                'Sjenica',
                'Sjenica Municipality',
                'Zlatibor District',
                'Kima Solar Farm',
                'Unknown',
                'CWP Global',
              ],
              [
                'Serbia',
                80,
                'Europe',
                'Unavailable',
                'Zabalj Municipality',
                'South Ba\u010dka District',
                'Zabalj solar farm',
                'Unknown',
                'WV International Energy',
              ],
              [
                'Serbia',
                97,
                'Europe',
                'Kostolac',
                'Kostolac Municipality',
                'Brani\u010devo District',
                'Srednje Kostola\u010dko Ostrvo solar farm',
                'Unknown',
                'Elektroprivreda Srbije (EPS)',
              ],
              [
                'Serbia',
                50,
                'Europe',
                'Sala\u0161',
                'Zaje\u010dar Municipality',
                'Zaje\u010dar District',
                'Solarina solar farm',
                'Unknown',
                'CWP Global',
              ],
              [
                'Serbia',
                1000,
                'Europe',
                'Unavailable',
                'Sumadija Administrative District',
                'Unavailable',
                'Onegiga solar farm',
                'Unknown',
                'Securum Equity Partners & Associates',
              ],
              [
                'Serbia',
                50,
                'Europe',
                'Sala\u0161',
                'Zaje\u010dar Municipality',
                'Zaje\u010dar District',
                'Solarina solar farm',
                'Unknown',
                'CWP Global',
              ],
              [
                'Serbia',
                50,
                'Europe',
                'Sala\u0161',
                'Zaje\u010dar Municipality',
                'Zaje\u010dar District',
                'Solarina solar farm',
                'Unknown',
                'CWP Global',
              ],
              [
                'Sierra Leone',
                20,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Bo District',
                'Bo-Kenema solar farm',
                'Unknown',
                'responseAbility; Africa Growth and Energy Solutions',
              ],
              [
                'Sierra Leone',
                50,
                'Africa',
                'Freetwon',
                'Unavailable',
                'Western Area Urban District',
                'Freetown Solar Farm',
                'Unknown',
                'Sunon Asogli Power',
              ],
              [
                'Sierra Leone',
                25,
                'Africa',
                'Makarie Gbanti Chiefdom',
                'Unavailable',
                'Bombali District',
                'Makasie solar farm',
                'Unknown',
                'Planet Solar Energy',
              ],
              [
                'Singapore',
                40,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Unknown',
                'Million Lightning Co. Pte. Ltd.',
              ],
              [
                'Singapore',
                76,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Unknown',
                'Sunseap Leasing Pte. Ltd.',
              ],
              [
                'Singapore',
                100,
                'Asia',
                'Unavailable',
                'Lower Seletar Reservoir',
                'Unavailable',
                'Seletar Reservoir solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Singapore',
                60,
                'Asia',
                'Unavailable',
                'Tengeh Resevoir',
                'Unavailable',
                'Tengeh Resevoir solar farm',
                'Sembcorp Solar',
                'Sembcorp Solar',
              ],
              [
                'Singapore',
                60,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Sembcorp Solar Singapore Pte. Ltd.',
                'Sembcorp Solar Singapore Pte. Ltd.',
              ],
              [
                'Singapore',
                44,
                'Asia',
                'Unavailable',
                'Pandan Reservoir',
                'Unavailable',
                'Pandan Reservoir solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Singapore',
                39,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Unknown',
                'Sembcorp Solar Singapore Pte. Ltd; Kurihara Kogyo Co., Ltd.',
              ],
              [
                'Singapore',
                70,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Singapore',
                70,
                'Asia',
                'Unavailable',
                'Central',
                'Unavailable',
                'Solarnova solar farm',
                'Unknown',
                'Sunseap Group Pte. Ltd.',
              ],
              [
                'Slovakia',
                25,
                'Europe',
                'Tom\u00e1\u0161ovce',
                'District of Lu\u010denec',
                'Unavailable',
                'Ladovo solar farm',
                'Unknown',
                'Solartec',
              ],
              [
                'Slovakia',
                58,
                'Europe',
                'Jaslovsk\u00e9 Bohunice',
                'District of Trnava',
                'Trnava District',
                'Jaslovensk\u00e9 Bohunice solar farm',
                'Unknown',
                'Jadrov\u00e1 Energetick\u00e1 Spolo\u010dnos\u0165 Slovenska (JESS)',
              ],
              [
                'Somalia',
                10,
                'Africa',
                'Jabad-Gelle',
                'Afgooye District',
                'Unavailable',
                'BECO Jabad-Gelle Solar PV',
                'Unknown',
                'Banadir Electrical Company (BECO)',
              ],
              [
                'South Africa',
                100,
                'Africa',
                'Kh\u00e2i-Ma Local Municipality',
                'Namakwa District Municipality',
                'Unavailable',
                'KaXu Solar One Thermosolar Plant',
                'Abengoa Solar',
                'Abengoa Solar [51%]; Industrial Development Corporation [29%]; Broad-Based Black Economic Empowerment [20%]',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'Ramotshere Moiloa Local Municipality',
                'Ngaka Modiri Molema District Municipality',
                'Unavailable',
                'Zeerust Solar Field',
                'Istofon Pty Ltd',
                'African Infrastructure Investment Managers; Phakwe Group; Reatile Group; AREP; Cicada Community Trust',
              ],
              [
                'South Africa',
                180,
                'Africa',
                'Kenhardt',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Kenhardt solar farm',
                'Scatec Solar',
                'Scatec Solar [51%]; H1 Holdings [49%]',
              ],
              [
                'South Africa',
                100,
                'Africa',
                'Kh\u00e2i-Ma Local Municipality',
                'Namakwa District Municipality',
                'Unavailable',
                'Xina Solar One Thermosolar Plant',
                'Abengoa Solar',
                'Abengoa Solar [40%]; Industrial Development Corporation [20%]; Public Investment Corporation [20%]; KaXu Community Trust [20%]',
              ],
              [
                'South Africa',
                30,
                'Africa',
                'Polokwane Local Municipality',
                'Capricorn District Municipality',
                'Unavailable',
                'Witkop Solar Park',
                'Unknown',
                'Phakwe Group',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Naledi Local Municipality',
                'Dr Ruth Segomotsi Mompati District Municipality',
                'Unavailable',
                'Waterloo solar farm',
                'Juwi Renewables South Africa',
                'Old Mutual; Reatile Solar Power (RF) (Pty) Ltd; Phakwe Solar (RF) (Pty) Ltd; AREP (African Rainbow Energy & Power); Cicada Community Trust',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Kai !Garib Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Upington solar farm',
                'Unknown',
                'Scatec Solar [42%]; Norfund [18%]; H1 Holdings [35%]; Upington Community [5%]',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Kai !Garib Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Upington solar farm',
                'Unknown',
                'Scatec Solar [42%]; Norfund [18%]; H1 Holdings [35%]; Upington Community [5%]',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Kai !Garib Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Upington solar farm',
                'Unknown',
                'Scatec Solar [42%]; Norfund [18%]; H1 Holdings [35%]; Upington Community [5%]',
              ],
              [
                'South Africa',
                40,
                'Africa',
                'Emthanjeni Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Linde solar farm',
                'Scatec Solar',
                'Scatec Solar; Stanlib; Old Mutual; Simacel; Community Trust',
              ],
              [
                'South Africa',
                180,
                'Africa',
                'Kenhardt',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Kenhardt solar farm',
                'Scatec Solar',
                'Scatec Solar [51%]; H1 Holdings [49%]',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Loeriesfonstein',
                'Namakwa District Municipality',
                'Unavailable',
                'Loeriesfonstein - Project 3 solar farm',
                'Unknown',
                'Solar Capital',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Copperton',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Mulilo Prieska solar farm',
                'SunPower',
                'Mulilo Renewable Energy',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'Mangaung Metropolitan Municipality',
                'Mangaung Metropolitan Municipality',
                'Unavailable',
                'Letsatsi Solar Plant',
                'GRS Energy',
                'Solar Reserve; Kensani Capital Investments; Intikon Energy',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'Kgatelopele Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Lesedi solar farm',
                'GRS Energy',
                'Solar Reserve; Kensani Capital Investments; Intikon Energy',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Kh\u00e2i-Ma Local Municipality',
                'Namakwa District Municipality',
                'Unavailable',
                'Konkoonsies solar farm',
                'Besamandla Pty Ltd',
                'Biotherm Energy',
              ],
              [
                'South Africa',
                1000,
                'Africa',
                'Upington',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Klipkraal Upington solar farm',
                'SA Solar Park Authority',
                'SA Solar Park Authority',
              ],
              [
                'South Africa',
                50,
                'Africa',
                'Kai !Garib Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Khi Solar One Thermosolar Plant',
                'Abengoa Solar',
                'Abengoa Solar [51%]; Industrial Development Corporation [29%]; Khi Community Trust [20%]',
              ],
              [
                'South Africa',
                180,
                'Africa',
                'Kenhardt',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Kenhardt solar farm',
                'Scatec Solar',
                'Scatec Solar [51%]; H1 Holdings [49%]',
              ],
              [
                'South Africa',
                66,
                'Africa',
                'Lephalale Local Municipality',
                'Waterberg District Municipality',
                'Unavailable',
                'Tom Burke Solar Park',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'South Africa',
                20,
                'Africa',
                'Siyathemba Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Mulilo Prieska 20MW solar farm',
                'ABB',
                'Mulilo Renewable Energy',
              ],
              [
                'South Africa',
                44,
                'Africa',
                'Breede Valley Local Municipality',
                'Cape Winelands District Municipality',
                'Unavailable',
                'Touwsrivier Cpv Solar Project',
                'Juwi Renewables South Africa',
                'South African Government [40%]; Pele Energy Group [35%]; Soitec [20%]; Local Community [5%]',
              ],
              [
                'South Africa',
                100,
                'Africa',
                'Gamagara Local Municipality',
                'John Taolo Gaetsewe District Municipality',
                'Unavailable',
                'Kathu CSP Solar Park',
                'Mott MacDonald',
                'Engie Africa [48.5%]; Public Investment Corporation [17.5%]; SIOC Community Development Trust [12.5%]; Development Bank of South Africa; Investec Bank [7.5%]; Lereko Metier [11.5%]; Kathu Trust [2.5%]',
              ],
              [
                'South Africa',
                94,
                'Africa',
                'Gamagara Local Municipality',
                'John Taolo Gaetsewe District Municipality',
                'Unavailable',
                'Sishen Solar Plant',
                'Besamandla Pty Ltd',
                'Acciona [55%]; Royal Bafokeng Holdings [25%]; Soul City [10%]; Dibeng Community Solar Energy Trust [10%]',
              ],
              [
                'South Africa',
                40,
                'Africa',
                'Westonaria',
                'West Rand District Municipality',
                'Unavailable',
                'South Deep Mine solar farm',
                'Karoshoek Solar One Pty Ltd',
                'Gold Fields Ltd',
              ],
              [
                'South Africa',
                68,
                'Africa',
                'Maquassi Hills Local Municipality',
                'Dr Kenneth Kaunda District Municipality',
                'Unavailable',
                'Bokamoso Solar Field',
                'Juwi Renewables South Africa',
                'Old Mutual; Reatile Solar Power; Phakwe Solar; Business Venture Investments 1984; Cicada Community Trust',
              ],
              [
                'South Africa',
                50,
                'Africa',
                '!Kheis Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Bokpoort Concentrated Solar Project',
                'NOMAC; Invest In Africa Energy Services',
                'ACWA Power',
              ],
              [
                'South Africa',
                66,
                'Africa',
                'Tokologo Local Municipality',
                'Lejweleputswa District Municipality',
                'Unavailable',
                'Boshof Solar Power Plant',
                'Globeleq',
                'Globeleq',
              ],
              [
                'South Africa',
                85,
                'Africa',
                'Emthanjeni Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'De Aar - Project 1 (Solar Capital) solar farm',
                'Solar Capital',
                'Solar Capital',
              ],
              [
                'South Africa',
                50,
                'Africa',
                'Emthanjeni Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'De Aar (Globaleq) solar farm',
                'Globaleq',
                'Globaleq; Old Mutual; Thebe Investment Corporation; Sibona Ilanga Trust; Enzani Technologies; Usizo Engineering',
              ],
              [
                'South Africa',
                90,
                'Africa',
                'Emthanjeni Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'De Aar 3 - Project 2 (Solar Capital) solar farm',
                'Solar Capital',
                'Solar Capital',
              ],
              [
                'South Africa',
                50,
                'Africa',
                'Madibeng Local Municipality',
                'Bojanala Platinum District Municipality',
                'Unavailable',
                'De Wildt Solar Park',
                'Ingwepath Pty Ltd',
                'African Infrastructure Investment Managers; Phakwe Group; Reatile Group; AREP; Cicada Community Trust',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'Gariep Local Municipality',
                'Joe Gqabi District Municipality',
                'Unavailable',
                'Dreunberg solar farm',
                'Scatec Solar',
                'Scatec Solar; Stanlib; Old Mutual; Simacel; Community Trust',
              ],
              [
                'South Africa',
                50,
                'Africa',
                'Sol Plaatje Local Municipality',
                'Frances Baard District Municipality',
                'Unavailable',
                'Droogfontein solar farm',
                'Globaleq',
                'Globeleq; Thebe Investment Corp.; Enzani Technologies; Usizo Engineering; Droogfontein Communal Property Association',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Sol Plaatje Local Municipality',
                'Frances Baard District Municipality',
                'Unavailable',
                'Droogfontein solar farm',
                'Juwi Renewables South Africa',
                'African Infrastructure Investment Managers; Phakwe Group; Reatile Group; AREP',
              ],
              [
                'South Africa',
                63,
                'Africa',
                'Siyancuma Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Greefspan solar farm',
                'GRS Energy; TKS; Umbono Energy',
                'African Infrastructure Investment Managers',
              ],
              [
                'South Africa',
                30,
                'Africa',
                'Welkom',
                'Lejweleputswa District Municipality',
                'Unavailable',
                'Harmony Free State Solar Plant',
                'Unknown',
                'Harmony Gold',
              ],
              [
                'South Africa',
                20,
                'Africa',
                'Siyancuma Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Herbert solar farm',
                'SunPower',
                'African Infrastructure Investment Managers',
              ],
              [
                'South Africa',
                100,
                'Africa',
                '\u01c1Khara Hais Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Ilanga 1 Solar Thermal Power Plant',
                'SENER',
                'Karoshoek Solar One Pty Ltd',
              ],
              [
                'South Africa',
                96,
                'Africa',
                'Tsantsabane Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Jasper Solar Power Plant',
                'GranSolar; Umbono Energy Group',
                'Solar Reserve; Kensani Capital Investments; Intikon Energy',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'Renosterberg Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Kalkbult solar farm',
                'Scatec Solar',
                'Scatec Solar; Stanlib; Old Mutual; Simacel; Community Trust',
              ],
              [
                'South Africa',
                50,
                'Africa',
                'Ubuntu Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Karoo solar farm',
                'Unknown',
                'South Africa Renewable Green Energy',
              ],
              [
                'South Africa',
                83,
                'Africa',
                'Joe Morolong Local Municipality',
                'John Taolo Gaetsewe District Municipality',
                'Unavailable',
                'Adams Aurora solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'South Africa',
                46,
                'Africa',
                'Kh\u00e2i-Ma Local Municipality',
                'Namakwa District Municipality',
                'Unavailable',
                'Aggeneys solar farm',
                'Unknown',
                'Biotherm Energy',
              ],
              [
                'South Africa',
                75,
                'Africa',
                'John Taolo Gaetsewe District Municipality',
                'John Taolo Gaetsewe District Municipality',
                'Unavailable',
                'Reisa solar farm',
                'REISA Managment Co',
                'Old Mutual; African Infrastructure Investment Managers; BuiltAfrica Kathu Pty Ltd; Local Community Trust',
              ],
              [
                'South Africa',
                100,
                'Africa',
                'Tsantsabane Local Municipality',
                'ZF Mgcawu District Municipality',
                'Unavailable',
                'Redstone Concentrated Solar Project',
                'NOMAC',
                'SolarReserve; ACWA Power [45%]',
              ],
              [
                'South Africa',
                31,
                'Africa',
                'Blouberg Local Municipality',
                'Capricorn District Municipality',
                'Unavailable',
                'Soutpan solar farm',
                'Globaleq',
                'Globaleq',
              ],
              [
                'South Africa',
                83,
                'Africa',
                'Cederberg Local Municipality',
                'West Coast District Municipality',
                'Unavailable',
                'Paleisheuwel Solar Power Plant',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'South Africa',
                86,
                'Africa',
                'Siyathemba Local Municipality',
                'Pixley ka Seme District Municipality',
                'Unavailable',
                'Mulilo Sonnedix Prieska solar farm',
                'Juwi Renewables South Africa',
                'Mulilo Renewable Energy',
              ],
              [
                'South Africa',
                83,
                'Africa',
                'Letsemeng Local Municipality',
                'Xhariep District Municipality',
                'Unavailable',
                'Pulida Solar Park',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'South Korea',
                96,
                'Asia',
                'Unavailable',
                'Anjwado',
                'Sinan-gun',
                'Anjwa-Do solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Korea',
                38,
                'Asia',
                'Anjwa-myeon',
                'Sinan-gun',
                'Sinan-gun',
                'Anjwa-Myeon solar farm',
                'Unknown',
                'Korea Hydro and Nuclear Power (KHNP); Pacifico Energy Korea',
              ],
              [
                'South Korea',
                80,
                'Asia',
                'Dangjin',
                'Unavailable',
                'Unavailable',
                'Dangjin solar farm',
                'Unknown',
                'SK Gas Company; SK D&D Company; Dangjin Eco Power Corporation; Korea East-West Power Company',
              ],
              [
                'South Korea',
                75,
                'Asia',
                'Saseong-ri',
                'Unavailable',
                'Unavailable',
                'Dangjin Yeomhae Farmland solar farm',
                'Ido Co., Ltd.',
                'SK D&D; Plaspo; Ido Co., Ltd.',
              ],
              [
                'South Korea',
                75,
                'Asia',
                'Jeokseo-ri',
                'Unavailable',
                'Unavailable',
                'Dangjin Yeomhae Farmland solar farm',
                'Ido Co., Ltd.',
                'SK D&D; Plaspo; Ido Co., Ltd.',
              ],
              [
                'South Korea',
                75,
                'Asia',
                'Daehoji-myeon',
                'Unavailable',
                'Unavailable',
                'Dangjin Yeomhae Farmland solar farm',
                'Ido Co., Ltd.',
                'SK D&D; Plaspo; Ido Co., Ltd.',
              ],
              [
                'South Korea',
                75,
                'Asia',
                'Dangjin-si',
                'Unavailable',
                'Unavailable',
                'Dangjin Yeomhae Farmland solar farm',
                'Ido Co., Ltd.',
                'SK D&D; Plaspo; Ido Co., Ltd.',
              ],
              [
                'South Korea',
                24,
                'Asia',
                'Sinan-gun',
                'Sinan-gun',
                'Unavailable',
                'Dong Yang solar farm',
                'Unknown',
                'Conergy',
              ],
              [
                'South Korea',
                41,
                'Asia',
                'Unavailable',
                'Hapcheon Dam',
                'Unavailable',
                "Hapch'On Reservoir solar farm",
                'Unknown',
                'Scotra Company Limited',
              ],
              [
                'South Korea',
                200,
                'Asia',
                'Unavailable',
                'Saemangeum tidal flats',
                'Unavailable',
                'Saemangeum Floating solar farm',
                'Unknown',
                'SK Group',
              ],
              [
                'South Korea',
                150,
                'Asia',
                'Unavailable',
                'Yeongam-gun',
                'Unavailable',
                'Santeado solar farm',
                'Unknown',
                'Pacifico Energy Korea',
              ],
              [
                'South Korea',
                1900,
                'Asia',
                'Unavailable',
                'Saemangeum tidal flats',
                'Unavailable',
                'Saemangeum Floating solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Korea',
                65,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Seosan (Hyundai) solar farm',
                'Hyundai Engineering and Construction',
                'Hyundai Engineering and Construction',
              ],
              [
                'South Korea',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Seosan (Pacifico Energy) solar farm',
                'Unknown',
                'Pacifico Energy Solar Fund',
              ],
              [
                'South Korea',
                200,
                'Asia',
                'Sinui-myeon',
                'Sinan-gun',
                'Sinan-gun',
                'Sinui-Myeon solar farm',
                'Unknown',
                'Korea Hydro and Nuclear Power (KHNP); Pacifico Energy Korea',
              ],
              [
                'South Korea',
                93,
                'Asia',
                'Unavailable',
                'Yeongam-gun',
                'Yeongam',
                'Yeongam solar farm',
                'Daemyoung Energy',
                'Unknown',
              ],
              [
                'South Korea',
                39,
                'Asia',
                'Yeongwol-gun',
                'Yeongwol-gun',
                'Unavailable',
                'Yeongwol solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Korea',
                24,
                'Asia',
                'Jalado',
                'Sinan-gun',
                'Sinan-gun',
                'Zara solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Korea',
                80,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Seokmum Lake Floating solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Korea',
                67,
                'Asia',
                'Jalado',
                'Anjwado',
                'Sinan-gun',
                'Zarado solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'South Sudan',
                20,
                'Africa',
                'Juba',
                'Juba Payam',
                'Juba County',
                'Juba solar farm',
                'Unknown',
                'Asunim Solar; I-kWh Company; Elsewedy Selectric T&D',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Reinoso de Cerrato',
                'Unavailable',
                'Palencia',
                'Sigma (Solaria) solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Sanl\u00facar la Mayor',
                'Unavailable',
                'Sevilla',
                'Sol De Casaquemada solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Merida',
                'Unavailable',
                'Badajoz',
                'Spex Solar Power Plant solar farm',
                'Solar Parks of Extremadura SL',
                'GrupoEco',
              ],
              [
                'Spain',
                26,
                'Europe',
                'Castuera',
                'Unavailable',
                'Badajoz',
                'La Verilleja solar farm',
                'Fotones',
                'SolEs Badajoz',
              ],
              [
                'Spain',
                300,
                'Europe',
                'Talavan',
                'Tajo-Salor',
                'Extremadura',
                'Talasol solar farm',
                'Metka EGN',
                'Ellomay Capital LTD',
              ],
              [
                'Spain',
                28,
                'Europe',
                'Talav\u00e1n',
                'Tajo-Salor',
                'C\u00e1ceres',
                'Talav\u00e1n solar farm',
                'Metka',
                'Ellomay Solar',
              ],
              [
                'Spain',
                204,
                'Europe',
                'Unavailable',
                'Northwest Coast',
                'C\u00e1diz',
                'Sigma (Reposal) solar farm',
                'Repsol Electricidad y Gas',
                'Repsol',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Valdelosa',
                'Unavailable',
                'Salamanca',
                'Santiz solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                45,
                'Europe',
                'Manzanares',
                'La Mancha',
                'Ciudad Real',
                'Perseo Fot\u00f3n solar farm',
                'Repsol Electricidad y Gas',
                'Repsol',
              ],
              [
                'Spain',
                40,
                'Europe',
                'Salteras',
                'Unavailable',
                'Sevilla',
                'Salteras solar farm',
                'Grupo Ence',
                'Grupo Ence',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Fuentes de Andalucia',
                'Unavailable',
                'Sevilla',
                'Monclova solar farm',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Ca\u00f1ada Vellida',
                'Comunidad de Teruel',
                'Unavailable',
                'Montesol solar farm',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Andorra',
                'Andorra-Sierra de Arcos',
                'Unavailable',
                'Mudejar solar farm',
                'Renovables SAMCA',
                'Grupo SAMCA',
              ],
              [
                'Spain',
                494,
                'Europe',
                'Mula',
                'R\u00edo Mula',
                'Region of Murcia',
                'Mula Solar Photovoltaic Power Plant',
                'Cobra Group',
                'Northleaf Capital Partners',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Fregenal de la Sierra',
                'Sierra Suroeste',
                'Badajoz',
                'Nert\u00f3briga solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Cuenca',
                'Nobesol solar farm',
                'Entoria Energy',
                'Entoria Energy',
              ],
              [
                'Spain',
                500,
                'Europe',
                'Usagre',
                'Tierra de Barros',
                'Badajoz',
                'Nunez De Balboa solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                500,
                'Europe',
                'Tierra de Barros',
                'Tierra de Barros',
                'Badajoz',
                'N\u00fa\u00f1ez De Balboa solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Olmedilla de Alarc\u00f3n',
                'Unavailable',
                'Cuenca',
                'Olmedilla solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Osa De La Vega',
                'Unavailable',
                'Cuenca',
                'Osa De La Vega solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Palacios del Arzobispo',
                'Unavailable',
                'Salamanca',
                'Palacios Del Arzobispo solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                138,
                'Europe',
                'Solana De Los Barros',
                'Tierra de Barros',
                'Badajoz',
                'San Serv\u00e1n solar farm',
                'FRV',
                'Abdul Latif Jameel Energy',
              ],
              [
                'Spain',
                40,
                'Europe',
                'N\u00edjar',
                'Unavailable',
                'Almeria',
                'Parcas solar farm',
                'Eiffage Energy',
                'X-Elio',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Tena solar farm',
                'Everwood Renewable Energy',
                'Everwood Capital',
              ],
              [
                'Spain',
                36,
                'Europe',
                'Manzanares',
                'La Mancha',
                'Ciudad Real',
                'Perseo Fot\u00f3n solar farm',
                'Repsol Electricidad y Gas',
                'Repsol',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Porzuna',
                'Campo de Calatrava',
                'Ciudad Real',
                'Pic\u00f3n solar farm',
                'Naturgy',
                'Naturgy',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Porzuna',
                'Campo de Calatrava',
                'Ciudad Real',
                'Pic\u00f3n solar farm',
                'Naturgy',
                'Naturgy',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Porzuna',
                'Campo de Calatrava',
                'Ciudad Real',
                'Pic\u00f3n solar farm',
                'Naturgy',
                'Naturgy',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Pole\u00f1ino',
                'Los Monegros',
                'Unavailable',
                'Pole\u00f1ino solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                200,
                'Europe',
                'Cofrentes',
                'Unavailable',
                'Valencia',
                'PSF Ayora solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'M\u00e9rida',
                'Tierra de Barros',
                'Badajoz',
                'Puerta Palma solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                100,
                'Europe',
                'Puertollano',
                'Campo de Calatrava',
                'Ciudad Real',
                'Puertollano Green Hydrogen Solar Plant',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Puertollano',
                'Campo de Calatrava',
                'Ciudad Real',
                'Puertollano solar farm',
                'Renovalia Energy Group',
                'Cerebus Capital Management LP',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Quinto',
                'Ribera Baja del Ebro',
                'Unavailable',
                'Quinto De Ebro solar farm',
                'EDP Renewables',
                'EDP',
              ],
              [
                'Spain',
                45,
                'Europe',
                'Manzanares',
                'La Mancha',
                'Ciudad Real',
                'Perseo Fot\u00f3n solar farm',
                'Repsol Electricidad y Gas',
                'Repsol',
              ],
              [
                'Spain',
                25,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Tena solar farm',
                'Everwood Renewable Energy',
                'Everwood Capital',
              ],
              [
                'Spain',
                36,
                'Europe',
                'Teba',
                'Guadalteba',
                'Malaga',
                'La Vega solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                235,
                'Europe',
                'Andorra-Sierra de Arcos',
                'Andorra-Sierra de Arcos',
                'Unavailable',
                'Teruel solar farm',
                'Endesa',
                'Endesa',
              ],
              [
                'Spain',
                138,
                'Europe',
                'Trillo',
                'Unavailable',
                'Castilla-La Mancha',
                'Trillo Node solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                150,
                'Europe',
                'Trillo',
                'Unavailable',
                'Castilla-La Mancha',
                'Trillo Node solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Valdelosa',
                'Unavailable',
                'Salamanca',
                'Valdelosa solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                264,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Valdesolar solar farm',
                'Repsol Electricidad y Gas',
                'Repsol',
              ],
              [
                'Spain',
                400,
                'Europe',
                'Velilla del R\u00edo Carri\u00f3n',
                'Unavailable',
                'Palencia',
                'Velilla PV solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Almochuel',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Vendimia solar farm',
                'Prodiel SL',
                'Lightsource BP',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Almochuel',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Vendimia solar farm',
                'Prodiel SL',
                'Lightsource BP',
              ],
              [
                'Spain',
                338,
                'Europe',
                'Trillo',
                'Unavailable',
                'Castilla-La Mancha',
                'Trillo Node solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Almochuel',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Vendimia solar farm',
                'Prodiel SL',
                'Lightsource BP',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Almochuel',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Vendimia solar farm',
                'Prodiel SL',
                'Lightsource BP',
              ],
              [
                'Spain',
                50,
                'Europe',
                'M\u00e9rida',
                'Tierra de Barros',
                'Badajoz',
                'Veracruz solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Cuenca',
                'Unavailable',
                'Cuenca',
                'Villanueva De Los Escuderos solar farm',
                'Eni',
                'Eni',
              ],
              [
                'Spain',
                200,
                'Europe',
                'Villarino de los Aires',
                'Unavailable',
                'Salamanca',
                'Villarino solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Villarino de los Aires',
                'Unavailable',
                'Salamanca',
                'Villarino solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                932,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Toledo',
                'Villaviciosa solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Zafra solar farm',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Almochuel',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Vendimia solar farm',
                'Prodiel SL',
                'Lightsource BP',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Andorra-Sierra de Arcos',
                'Andorra-Sierra de Arcos',
                'Unavailable',
                'Teruel solar farm',
                'Endesa',
                'Endesa',
              ],
              [
                'Spain',
                85,
                'Europe',
                'Totana',
                'Bajo Guadalent\u00edn',
                'Region of Murcia',
                'Totana solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Las Torres de Cotillas',
                'Vega Media del Segura',
                'Region of Murcia',
                'Torre De Cotillas solar farm',
                'Eiffage Energy',
                'X-Elio',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Puerto Real',
                'Bay of C\u00e1diz',
                'C\u00e1diz',
                'Miramundo solar farm',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                22,
                'Europe',
                'Sevilla',
                'Unavailable',
                'Sevilla',
                'Torrepalma solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                42,
                'Europe',
                'Tordesillas',
                'Unavailable',
                'Badajoz',
                'Tordesillas (Baywa R.E.) solar farm',
                'Baywa r.e.',
                'Commerz Real',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Tordesillas',
                'Unavailable',
                'Valladolid',
                'Tordesillas (Solaria) solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Tordesillas',
                'Unavailable',
                'Valladolid',
                'Tordesillas (Solaria) solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                54,
                'Europe',
                'Santiz',
                'Unavailable',
                'Salamanca',
                'Topas solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Medina del Campo',
                'Unavailable',
                'Valladolid',
                'Medina solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                300,
                'Europe',
                'Talayuela',
                'Campo Ara\u00f1uelo',
                'Extremadura',
                'Talayuela solar farm',
                'Solarcentury',
                'Encavis AG',
              ],
              [
                'Spain',
                42,
                'Europe',
                'Manzanares',
                'La Mancha',
                'Ciudad Real',
                'Manzanares solar farm',
                'Sunco Capital',
                'Banco Santander',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Bodonal de la Sierra',
                'Sierra Suroeste',
                'Badajoz',
                'Cincinato solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                300,
                'Europe',
                'Ciudad Rodrigo',
                'Unavailable',
                'Salamanca',
                'Ciudad Rodrigo solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Castille La Mancha',
                'Clm-Hue solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Toledo',
                'Clm-To solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Toledo',
                'Cyl-An solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Campo de Calatrava',
                'Ciudad Real',
                'Cyl-Hi solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Cerrado Cabrera solar farm',
                'Solarcentury',
                'Encavis AG',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Segovia',
                'Cyl-Las solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                25,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Palencia',
                'Cyl-Ma solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Valladolid',
                'Cyl-Me solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                80,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Valladolid',
                'Cyl-Mu solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Palencia',
                'Cyl-Pa solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                45,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Palencia',
                'Cyl-Pa solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                20,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Palencia',
                'Cyl-So solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                90,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Le\u00f3n',
                'Cyl-Lu solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                328,
                'Europe',
                'Ceclav\u00edn',
                'Vegas del Alag\u00f3n',
                'C\u00e1ceres',
                'Ceclav\u00edn solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                225,
                'Europe',
                'Unavailable',
                'Unavailable',
                '\u00c1vila',
                'Castilla Y Le\u00f3n solar farm',
                'Unknown',
                'Grupo Ibere\u00f3lica',
              ],
              [
                'Spain',
                360,
                'Europe',
                'Unavailable',
                'Unavailable',
                '\u00c1vila',
                'Castilla Y Le\u00f3n solar farm',
                'Unknown',
                'Grupo Ibere\u00f3lica',
              ],
              [
                'Spain',
                40,
                'Europe',
                'Lucainena de las Torres',
                'Unavailable',
                'Almeria',
                'Cadima solar farm',
                'Eiffage Energy',
                'X-Elio',
              ],
              [
                'Spain',
                21,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Cuenca',
                'Calaveron Solar solar farm',
                'Eiffage Energy',
                'EPURON',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Calzadilla de los Barros',
                'Zafra - R\u00edo Bodi\u00f3n',
                'Badajoz',
                'Calzadilla solar farm',
                'Valsolar',
                'S.A.G. Solarstorm',
              ],
              [
                'Spain',
                120,
                'Europe',
                'Calzadilla de los Barros',
                'Zafra - R\u00edo Bodi\u00f3n',
                'Badajoz',
                'Calzadilla solar farm',
                'Valsolar',
                'S.A.G. Solarstorm',
              ],
              [
                'Spain',
                75,
                'Europe',
                'Calzadilla de los Barros',
                'Zafra - R\u00edo Bodi\u00f3n',
                'Badajoz',
                'Calzadilla solar farm',
                'Valsolar',
                'S.A.G. Solarstorm',
              ],
              [
                'Spain',
                350,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Toledo',
                'Camino Fregacedos solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almaraz',
                'Campo Ara\u00f1uelo',
                'C\u00e1ceres',
                'Campo Ara\u00f1uelo solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almaraz',
                'Campo Ara\u00f1uelo',
                'C\u00e1ceres',
                'Campo Ara\u00f1uelo solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                40,
                'Europe',
                'Romangordo',
                'Campo Ara\u00f1uelo',
                'C\u00e1ceres',
                'Campo Ara\u00f1uelo solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                110,
                'Europe',
                'Chiva',
                'Unavailable',
                'Valencia',
                'Campos De Levante solar farm',
                'Unknown',
                'Falck Renewables',
              ],
              [
                'Spain',
                25,
                'Europe',
                'Magaz de Pisuerga',
                'Unavailable',
                'Palencia',
                'Capricornius solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Carpio de Tajo',
                'Torrijos',
                'Toledo',
                'Carpio De Tajo solar farm',
                'Naturgy',
                'Naturgy',
              ],
              [
                'Spain',
                400,
                'Europe',
                'Puerto Lumbreras',
                'Alto Guadalent\u00edn',
                'Region of Murcia',
                'Carril Solar solar farm',
                'RP Global',
                'RP Global',
              ],
              [
                'Spain',
                100,
                'Europe',
                'Cartagena',
                'Campo de Cartagena y Mar Menor',
                'Region of Murcia',
                'Cartagena solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                42,
                'Europe',
                'Manzanares',
                'La Mancha',
                'Ciudad Real',
                'Manzanares solar farm',
                'Sunco Capital',
                'Banco Santander',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Le\u00f3n',
                'Cyl-Vi solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                100,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Budweiser solar farm',
                'BayWa r.e.',
                'BayWa r.e.',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Zamora',
                'Cyl-Za-1 solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Sevilla',
                'Don Rodrigo solar farm',
                'BayWa r.e.',
                'Talanx Group',
              ],
              [
                'Spain',
                62,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Sevilla',
                'Grullas solar farm',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Spain',
                1000,
                'Europe',
                'Fuente de Cantos',
                'Unavailable',
                'Badajoz',
                'Guadalupe solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Hazas De Lo Sesenta solar farm',
                'Solarcentury',
                'Encavis AG',
              ],
              [
                'Spain',
                23,
                'Europe',
                'Jumilla',
                'Altiplano',
                'Region of Murcia',
                'Hoya De Los Vicentes solar farm',
                'Elecnor',
                'Luzentia',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Gibrale\u00f3n',
                'Comarca Metropolitana de Huelva',
                'Huelva',
                'Huelva 2021 solar farm',
                'Global Energy Services',
                'Alter Enersun',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Huelva',
                'Gibrale\u00f3n',
                'Huelva',
                'Huelva solar farm',
                'Alter Enersun',
                'Bruc Iberia Energy Investments',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Posadas',
                'Unavailable',
                'Cordova',
                'Gamonarejo 36 solar farm',
                'Endesa',
                'Endesa',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Huelva',
                'Comarca Metropolitana de Huelva',
                'Huelva',
                'Huelva solar farm',
                'Alter Enersun',
                'Bruc Iberia Energy Investments',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Jerez de los Caballeros',
                'Sierra Suroeste',
                'Badajoz',
                'Jerez De Los Caballeros solar farm',
                'Unknown',
                'REEF Development',
              ],
              [
                'Spain',
                45,
                'Europe',
                'Merida',
                'Unavailable',
                'Badajoz',
                'La Fernandina solar farm',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Spain',
                23,
                'Europe',
                'Trujillo',
                'Trujillo',
                'C\u00e1ceres',
                'La Magascona solar farm',
                'Elecnor',
                'FSL Solar',
              ],
              [
                'Spain',
                48,
                'Europe',
                'Valle de Alcudia',
                'Valle de Alcudia',
                'Ciudad Real',
                'La Nava solar farm',
                'Naturgy',
                'Naturgy',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Trujillo',
                'Trujillo',
                'C\u00e1ceres',
                'La Solanilla solar farm',
                'FRV',
                'Abdul Latif Jameel Energy',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Teba',
                'Guadalteba',
                'Malaga',
                'La Vega solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                22,
                'Europe',
                'Almaraz',
                'Campo Ara\u00f1uelo',
                'C\u00e1ceres',
                'Huerta Solar Almaraz solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Spain',
                200,
                'Europe',
                'Cofrentes',
                'Unavailable',
                'Valencia',
                'FV Cofrentes solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'La Encina',
                'Vilena',
                'Alacant / Alicante',
                'FV Alhorines solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                590,
                'Europe',
                'Torrecillas de la Tiesa',
                'Trujillo',
                'C\u00e1ceres',
                'Francisco Pizarro solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                30,
                'Europe',
                'Osa de la Vega',
                'Unavailable',
                'Cuenca',
                'Dulcinea Solar solar farm',
                'Avanzalia Solar',
                'Avanzalia',
              ],
              [
                'Spain',
                20,
                'Europe',
                'Casatejada',
                'Campo Ara\u00f1uelo',
                'C\u00e1ceres',
                'El Bald\u00edo solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                80,
                'Europe',
                'Puertollano',
                'Campo de Calatrava',
                'Ciudad Real',
                'El Bonal solar farm',
                'Renovalia Energy Group',
                'Cerebus Capital Management LP',
              ],
              [
                'Spain',
                20,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Albacete',
                'El Bonillo solar farm',
                'Abaste Group',
                'Deutsche Bank',
              ],
              [
                'Spain',
                50,
                'Europe',
                'M\u00e9rida',
                'Tierra de Barros',
                'Badajoz',
                'El Dobl\u00f3n solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'El Primo Aleman solar farm',
                'Solarcentury',
                'Encavis AG',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almonte',
                'El Condado',
                'Huelva',
                'El Roc\u00edo solar farm',
                'Rolwind',
                'Matrix Renewables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almonte',
                'El Condado',
                'Huelva',
                'El Roc\u00edo solar farm',
                'Rolwind',
                'Matrix Renewables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almonte',
                'El Condado',
                'Huelva',
                'El Roc\u00edo solar farm',
                'Rolwind',
                'Matrix Renewables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alarc\u00f3n',
                'Unavailable',
                'Cuenca',
                'El Romeral solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                45,
                'Europe',
                'Espejo',
                'Unavailable',
                'Cordova',
                'El Salobral solar farm',
                'Unknown',
                'Luxcara',
              ],
              [
                'Spain',
                1000,
                'Europe',
                'Saceruela',
                'Valle de Alcudia',
                'Ciudad Real',
                'Erasmo solar farm',
                'Soto Solar',
                'COFRA',
              ],
              [
                'Spain',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Euder solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Euder solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Euder solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                175,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Sevilla',
                'Don Rodrigo solar farm',
                'BayWa r.e.',
                'MEAG',
              ],
              [
                'Spain',
                100,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Budweiser solar farm',
                'BayWa r.e.',
                'BayWa r.e.',
              ],
              [
                'Spain',
                28,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Cuenca',
                'Casas De Los Pinos solar farm',
                'Unknown',
                'Renovalia',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Fregenal de la Sierra',
                'Sierra Suroeste',
                'Badajoz',
                'Beturia solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                70,
                'Europe',
                'Alicante',
                'el Baix Segura / La Vega Baja del Segura',
                'Alacant / Alicante',
                'Alicante solar farm',
                'Unknown',
                'BayWa r.e.',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Almansa',
                'Unavailable',
                'Albacete',
                'Almansa solar farm',
                'Eiffage Energy',
                'X-Elio',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alvarado-La Risca',
                'Tierra de Badajoz',
                'Extremadura',
                'Alvarado solar farm',
                'Solarpack',
                'Bruc Iberia Energy Investments',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alvarado-La Risca',
                'Tierra de Badajoz',
                'Extremadura',
                'Alvarado solar farm',
                'Solarpack',
                'Bruc Iberia Energy Investments',
              ],
              [
                'Spain',
                85,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Badajoz',
                'Amazon Solar Farm - Andalucia',
                'Amazon',
                'Amazon',
              ],
              [
                'Spain',
                85,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Sevilla',
                'Amazon Solar Farm - Extremadura',
                'Amazon',
                'Amazon',
              ],
              [
                'Spain',
                180,
                'Europe',
                'Bienvenida',
                'Unavailable',
                'Badajoz',
                'Bienvenida solar farm',
                'ib vogt',
                'Talanx Group',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Puebla de Guzm\u00e1n',
                'And\u00e9valo',
                'Huelva',
                'And\u00e9valo solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                100,
                'Europe',
                'And\u00fajar',
                'Unavailable',
                'Ja\u00e9n',
                'Andujar solar farm',
                'Grupo Ence',
                'Grupo Ence',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Fregenal de la Sierra',
                'Sierra Suroeste',
                'Badajoz',
                'Apicio solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                25,
                'Europe',
                'Unavailable',
                'Somontano de Barbastro',
                'Unavailable',
                'Ar-Hue solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Olmedo de Camaces',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Cerralbo',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Bermellar',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Saldeana',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Barruecopardo',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                60,
                'Europe',
                'Saucelle',
                'Unavailable',
                'Salamanca',
                'Ara solar farm',
                'Unknown',
                'Solaria',
              ],
              [
                'Spain',
                49,
                'Europe',
                'Ba\u00f1os y Mendigo',
                'Campo de Cartagena y Mar Menor',
                'Region of Murcia',
                'Algibicos solar farm',
                'EKZ Renewables',
                'EKZ',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Fregenal de la Sierra',
                'Sierra Suroeste',
                'Badajoz',
                'Ardila solar farm',
                'Enel Green Power',
                'Endesa',
              ],
              [
                'Spain',
                40,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Sevilla',
                'Alcores solar farm',
                'X-Elio',
                'X-Elio',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Poblete',
                'Campo de Calatrava',
                'Ciudad Real',
                'Alarcos solar farm',
                'RWE',
                'RWE',
              ],
              [
                'Spain',
                180,
                'Europe',
                'Alcarr\u00e0s',
                'Segri\u00e0',
                'Lleida',
                'Mangraners & Albatarrec solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                23,
                'Europe',
                'Jumilla',
                'Altiplano',
                'Region of Murcia',
                'Luzentia solar farm',
                'Unknown',
                'Cubico Sustainable Investments',
              ],
              [
                'Spain',
                50,
                'Europe',
                'La Rinconada',
                'Unavailable',
                'Sevilla',
                'Los Naranjos solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Medina de las Torres',
                'Unavailable',
                'Badajoz',
                'Los Llanos solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Medina de las Torres',
                'Unavailable',
                'Badajoz',
                'Los Llanos solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Medina de las Torres',
                'Unavailable',
                'Badajoz',
                'Los Llanos solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Los Gonzalez solar farm',
                'Solarcentury',
                'Encavis AG',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Poveda de la Obispal\u00eda',
                'Alterejos',
                'Cuenca',
                'Los Escuderos solar farm',
                'Grenergy Renovables',
                'Grenergy Renovables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Poveda de la Obispal\u00eda',
                'Alterejos',
                'Cuenca',
                'Los Escuderos solar farm',
                'Grenergy Renovables',
                'Grenergy Renovables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Poveda de la Obispal\u00eda',
                'Alterejos',
                'Cuenca',
                'Los Escuderos solar farm',
                'Grenergy Renovables',
                'Grenergy Renovables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Poveda de la Obispal\u00eda',
                'Alterejos',
                'Cuenca',
                'Los Escuderos solar farm',
                'Grenergy Renovables',
                'Grenergy Renovables',
              ],
              [
                'Spain',
                50,
                'Europe',
                'La Muela',
                'Valdejal\u00f3n',
                'Unavailable',
                'Los Belos solar farm',
                'Opdenergy',
                'Opdenergy',
              ],
              [
                'Spain',
                356,
                'Europe',
                'Lorca',
                'Alto Guadalent\u00edn',
                'Zarcilla de Ramos',
                'Lorca solar farm',
                'X-Elio',
                'Brookfield; KKR',
              ],
              [
                'Spain',
                90,
                'Europe',
                'Lepe',
                'Costa Occidental',
                'Huelva',
                'Lepe solar farm',
                'Grupo Ence',
                'Grupo Ence',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Carmona',
                'Unavailable',
                'Sevilla',
                'Las Naranjillas solar farm',
                'GRS',
                'Amarenco',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Carmona',
                'Unavailable',
                'Sevilla',
                'Las Corchas solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                23,
                'Europe',
                'Abertura',
                'Miajadas',
                'C\u00e1ceres',
                'Abertura solar farm',
                'Iberdrola',
                'LongSol',
              ],
              [
                'Spain',
                149,
                'Europe',
                'Alcal\u00e1 de Guadaira',
                'Unavailable',
                'Sevilla',
                'Alcal\u00e1 De Guadaira Solar Park',
                'Amazon',
                'Amazon',
              ],
              [
                'Spain',
                150,
                'Europe',
                'Caceres',
                'Unavailable',
                'C\u00e1ceres',
                'Arenales solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Unavailable',
                'Zaragoza',
                'Unavailable',
                'Amazon Zaragoza solar farm',
                'Amazon',
                'Amazon',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Badajoz',
                'Tierra de Badajoz',
                'Badajoz',
                'Augusto solar farm',
                'Enel Green Power Espana',
                'Endesa',
              ],
              [
                'Spain',
                20,
                'Europe',
                'Beneixama',
                'Unavailable',
                'Alacant / Alicante',
                'Beneixama Solar PV Park',
                'City Solar',
                'Eolia',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Cuevas de Almud\u00e9n',
                'Cuencas Mineras',
                'Unavailable',
                'Barrica solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Spain',
                75,
                'Europe',
                'Calamocha',
                'Jiloca',
                'Unavailable',
                'Barrica solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'Spain',
                34,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Arnedo solar farm',
                'T-Solar',
                'Cubico Sustainable Investments',
              ],
              [
                'Spain',
                280,
                'Europe',
                'Unavailable',
                'Montes de Toledo',
                'Toledo',
                'Parla solar farm',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Bargas',
                'La Sagra',
                'Toledo',
                'Bargas solar farm',
                'Solarpack',
                'Aventron',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Azaila',
                'Bajo Mart\u00edn',
                'Unavailable',
                'Azaila solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Spain',
                695,
                'Europe',
                'Santa Mar\u00eda de Garo\u00f1a',
                'Unavailable',
                'Burgos',
                'Barcina-Garo\u00f1a Solar PV Complex',
                'Solaria Energia y Medio Ambiente',
                'Solaria Energia y Medio Ambiente',
              ],
              [
                'Spain',
                50,
                'Europe',
                'Bargas',
                'La Sagra',
                'Toledo',
                'Barcience solar farm',
                'Iberdrola Renovables',
                'Iberdrola',
              ],
              [
                'Sri Lanka',
                800,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Matale District',
                'Soorya Bala Sangramaya Distributed solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Sri Lanka',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Matale District',
                'Soorya Bala Sangramaya Distributed solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Sri Lanka',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Monaragala District',
                'Siyambalanduwa solar farm',
                'Unknown',
                'State Ministry of Solar; Wind and Hydro Power Generation Projects Development',
              ],
              [
                'Sri Lanka',
                100,
                'Asia',
                'Pooneryn',
                'Unavailable',
                'Kilinochchi',
                'Pooneryn solar farm',
                'Unknown',
                'Sri Lanka Sustainability Energy Authority (SLSEA)',
              ],
              [
                'Sri Lanka',
                20,
                'Asia',
                'Hambantota',
                'Unavailable',
                'Hambantota District',
                'Laugfs solar farm',
                'LAUGFS Power PLC',
                'Unknown',
              ],
              [
                'Sri Lanka',
                50,
                'Asia',
                'Pooneryn',
                'Unavailable',
                'Kilinochchi',
                'Pooneryn solar farm',
                'Unknown',
                'Sri Lanka Sustainability Energy Authority (SLSEA)',
              ],
              [
                'Sudan',
                10,
                'Africa',
                'Khartoum',
                'Unavailable',
                'Omdurman',
                'Khartoum Solar Power Project',
                'Unknown',
                'Ministry of Water Resources and Electricity',
              ],
              [
                'Sweden',
                23,
                'Europe',
                'Unavailable',
                'Sk\u00e5ne County',
                'Unavailable',
                'Skane 2 solar farm',
                'Unknown',
                'OX2',
              ],
              [
                'Sweden',
                23,
                'Europe',
                'Unavailable',
                'Sk\u00e5ne County',
                'Unavailable',
                'Skane 1 solar farm',
                'Unknown',
                'OX2',
              ],
              [
                'Syria',
                42,
                'Middle East',
                'Aleppo',
                'Unavailable',
                'Ayn Al-Arab (Kobani) District',
                'Aleppo solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Syria',
                300,
                'Middle East',
                'Widyan al-Rabie',
                'Unavailable',
                'Unavailable',
                'Damascus Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'Syria',
                24,
                'Middle East',
                'Jandar',
                'Unavailable',
                'Unavailable',
                'Jandar Solar',
                'Unknown',
                'Public Establishment of Electricity for Generation (PEEG)',
              ],
              [
                'Syria',
                14,
                'Middle East',
                'Jandar',
                'Unavailable',
                'Unavailable',
                'Jandar Solar Plant',
                'Unknown',
                'Public Establishment of Electricity for Generation (PEEG)',
              ],
              [
                'Syria',
                110,
                'Middle East',
                'Adra Industrial City',
                'Fealat Sharqiyeh',
                'Al Mazzah',
                'Adra solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Taiwan',
                70,
                'Asia',
                'Budai',
                'Chiayi County',
                'Unavailable',
                'Vena Mingus solar farm',
                'Vena Energy',
                '\u661f\u5c55\u9280\u884c; Vena Energy',
              ],
              [
                'Taiwan',
                35,
                'Asia',
                'Unavailable',
                'Nantou County',
                'Qigu',
                'Taisugar Cigu Optoelectronics solar farm',
                'Unknown',
                '\u53f0\u6e7e\u7cd6\u696d\u516c\u53f8',
              ],
              [
                'Taiwan',
                181,
                'Asia',
                'Unavailable',
                'Nantou County',
                'Qigu',
                'Taisugar Cigu Optoelectronics solar farm',
                'Unknown',
                '\u53f0\u6e7e\u7cd6\u696d\u516c\u53f8',
              ],
              [
                'Taiwan',
                260,
                'Asia',
                'Tainan',
                'Nantou County',
                'Unavailable',
                'Tainan Solar Power City solar farm',
                'Unknown',
                'Tainan City Government',
              ],
              [
                'Taiwan',
                252,
                'Asia',
                'Tainan',
                'Nantou County',
                'Unavailable',
                'Tainan Solar Power City solar farm',
                'Unknown',
                'Tainan City Government',
              ],
              [
                'Taiwan',
                150,
                'Asia',
                'Unavailable',
                'Nantou County',
                'Qigu',
                'Tainan Salt Fields solar farm',
                '\u53f0\u7063\u96fb\u529b\u516c\u53f8',
                '\u53f0\u7063\u96fb\u529b\u516c\u53f8',
              ],
              [
                'Taiwan',
                75,
                'Asia',
                'Unavailable',
                'Nantou County',
                'Syuejia',
                'Syuejia solar farm',
                '\u5fc3\u5fe0\u96fb\u696d\u80a1\u4efd\u6709\u9650\u516c\u53f8',
                '\u5927\u4e9e\u96c6\u5718',
              ],
              [
                'Taiwan',
                99,
                'Asia',
                'Jiadong',
                'Unavailable',
                'Unavailable',
                'Pingtung solar farm',
                '\u529b\u63da\u80fd\u6e90 (Ysolar Co. ltd\uff09',
                'Unknown',
              ],
              [
                'Taiwan',
                86,
                'Asia',
                'Lukang',
                'Changhua County',
                'Lunwei',
                'Changhua Coastal solar farm',
                '\u53f0\u7063\u96fb\u529b\u516c\u53f8',
                '\u53f0\u7063\u96fb\u529b\u516c\u53f8',
              ],
              [
                'Taiwan',
                43,
                'Asia',
                'Yizhu',
                'Chiayi County',
                'Unavailable',
                'Chiayi Fishery solar farm',
                '\u53f0\u7063\u6c34\u6ce5',
                '\u53f0\u7063\u6c34\u6ce5',
              ],
              [
                'Taiwan',
                40,
                'Asia',
                'Unavailable',
                'Changhua County',
                'Unavailable',
                'Changhua General Energy solar farm',
                '\u6c38\u65fa\u80fd\u6e90; \u6c38\u582f\u80fd\u6e90',
                '\u53f0\u65b0\u570b\u969b\u5546\u696d\u9280\u884c; \u661f\u5c55\u9280\u884c',
              ],
              [
                'Taiwan',
                181,
                'Asia',
                'Lukang',
                'Changhua County',
                'Lunwei',
                'Changbin Lunwei East solar farm',
                'Chengya Energy Co Ltd.',
                'Chengya Energy Co Ltd.',
              ],
              [
                'Taiwan',
                50,
                'Asia',
                'Jiadong',
                'Unavailable',
                'Unavailable',
                'Pingtung solar farm',
                '\u529b\u63da\u80fd\u6e90 (Ysolar Co. ltd\uff09',
                'Unknown',
              ],
              [
                'Taiwan',
                193,
                'Asia',
                'Unavailable',
                'Nantou County',
                'Unavailable',
                'URE solar farm',
                '\u806f\u5408\u518d\u751f\u80fd\u6e90',
                'Unknown',
              ],
              [
                'Tanzania',
                60,
                'Africa',
                'Shinyanga',
                'Unavailable',
                'Shinyanga Urban District',
                'Shinyanga solar farm',
                'Unknown',
                'NextGen Solawazi',
              ],
              [
                'Tanzania',
                100,
                'Africa',
                'Kishapy',
                'Unavailable',
                'Kishapu District',
                'Kishapu solar farm',
                'Unknown',
                'TANESCO',
              ],
              [
                'Tanzania',
                50,
                'Africa',
                'Kishapy',
                'Unavailable',
                'Kishapu District',
                'Kishapu solar farm',
                'Unknown',
                'TANESCO',
              ],
              [
                'Thailand',
                60,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Amphur Banglen solar farm',
                'Unknown',
                'EGCO Group; Yanhee Solar Power',
              ],
              [
                'Thailand',
                38,
                'Asia',
                'Unavailable',
                'Bang Pa-in District',
                'Bang Pa-in',
                'Bang Pa-In solar farm',
                'Unknown',
                'BCPG Public Company Limited (BCPG)',
              ],
              [
                'Thailand',
                778,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bhumibol Dam solar farm',
                'Unknown',
                'Electricity Generating Authority of Thailand',
              ],
              [
                'Thailand',
                49,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sa Kaeo solar farm',
                'Unknown',
                'Super Energy Company Limited',
              ],
              [
                'Thailand',
                36,
                'Asia',
                'Unavailable',
                'Hansai',
                'Aranyaprathet',
                'Srinaga solar farm',
                'Solnique Solar Power Company Limited',
                'Super Energy Company Limited [49%]',
              ],
              [
                'Thailand',
                24,
                'Asia',
                'Unavailable',
                'Ubol Ratana Dam',
                'Unavailable',
                'Ubol Ratana Reservoir solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Thailand',
                59,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ubon Ratchathani solar farm',
                'Unknown',
                'Electricity Generating Authority of Thailand',
              ],
              [
                'Thailand',
                300,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Vajiralongkorn Dam solar farm',
                'Unknown',
                'Electricity Generating Authority of Thailand',
              ],
              [
                'Thailand',
                25,
                'Asia',
                'Chiang Rak Noi Subdistrict',
                'Bang Pa-in District',
                'Unavailable',
                'Bangchak solar farm',
                'Unknown',
                'Bangchak Solar Energy (Nakhonratchasima) Company Limited ("BSE-NMA"); Bangchak Solar Energy (Chaiyaphum 1) Company Limited (BSE-CPM1)',
              ],
              [
                'Thailand',
                40,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sermsang solar farm',
                'Unknown',
                'Sermsang Power (SSP)',
              ],
              [
                'Thailand',
                36,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'S2P Energy solar farm',
                'Solnique Solar Power Company Limited',
                'Super Energy Company Limited [49%]',
              ],
              [
                'Thailand',
                45,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Sirindhorn Reservoir solar farm',
                'Unknown',
                'Electricity Generating Authority of Thailand',
              ],
              [
                'Thailand',
                101,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Phitsanulok solar farm',
                'Unknown',
                'Energy Absolute Public Company Limited (Energy Absolute)',
              ],
              [
                'Thailand',
                128,
                'Asia',
                'Lampang',
                'Unavailable',
                'Unavailable',
                'Lampang solar farm',
                'Unknown',
                'Energy Absolute Public Company Limited (Energy Absolute)',
              ],
              [
                'Thailand',
                126,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nakornsawan solar farm',
                'Unknown',
                'Energy Absolute Public Company Limited (Energy Absolute)',
              ],
              [
                'Thailand',
                24,
                'Asia',
                'Unavailable',
                'Rojana Industrial Park',
                'U-Tai',
                'Rojana solar farm',
                'Unknown',
                'Sumikin Bussan Corporation; Rojana Power Company',
              ],
              [
                'Thailand',
                41,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lopburi (Super Energy) solar farm',
                'Super Energy Corporation Limited',
                'Super Energy Company Limited',
              ],
              [
                'Thailand',
                63,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lopburi (EGCO) solar farm',
                'Unknown',
                'EGCO Group',
              ],
              [
                'Thailand',
                55,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Khok Samrong',
                'Lopburi (NED) solar farm',
                'Natural Energy Development (NED)',
                'Natural Energy Development (NED)',
              ],
              [
                'Thailand',
                37,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Lopburi (EGCO) solar farm',
                'Unknown',
                'EGCO Group',
              ],
              [
                'The Gambia',
                70,
                'Africa',
                'Soma',
                'Kiang Central',
                'Mansakonko',
                'Soma solar farm (The Gambia)',
                'Unknown',
                'The Government Of The Gambia; ECOWAS',
              ],
              [
                'The Gambia',
                20,
                'Africa',
                'Kombo North/Saint Mary',
                'Kombo North/Saint Mary',
                'Brikama',
                'Jambur Solar Farm',
                'Unknown',
                'The Government Of The Gambia; ECOWAS',
              ],
              [
                'The Gambia',
                80,
                'Africa',
                'Soma',
                'Kiang Central',
                'Mansakonko',
                'Soma solar farm (The Gambia)',
                'Unknown',
                'The Government Of The Gambia',
              ],
              [
                'Togo',
                390,
                'Africa',
                'Unavailable',
                'Sotouboua',
                'Unavailable',
                'ARISE IIP solar farm',
                'Unknown',
                'ARISE IIP',
              ],
              [
                'Togo',
                30,
                'Africa',
                'Dapaong',
                'T\u00f4ne Prefecture',
                'Unavailable',
                'Dapaong solar farm',
                'Unknown',
                'Amea Power',
              ],
              [
                'Togo',
                30,
                'Africa',
                'Sotouboua',
                'Blitta',
                'Unavailable',
                'Sheikh Mohamed Bin Zayed solar farm',
                'Amea Togo Solar',
                'Amea Power',
              ],
              [
                'Togo',
                20,
                'Africa',
                'Sotouboua',
                'Blitta',
                'Unavailable',
                'Sheikh Mohamed Bin Zayed solar farm',
                'Amea Togo Solar',
                'Amea Power',
              ],
              [
                'Trinidad and Tobago',
                92,
                'Central America and the Caribbean',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Brechin Castle Solar Project',
                'Lightsource BP',
                'Lightsource BP; Shell',
              ],
              [
                'Trinidad and Tobago',
                20,
                'Central America and the Caribbean',
                'Unavailable',
                'Orange Grove',
                'Unavailable',
                'Orange Grove solar farm (Trinidad and Tobago)',
                'Lightsource BP',
                'Lightsource BP; Shell',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Medenine',
                '\u0645\u062f\u0646\u064a\u0646 \u0627\u0644\u0634\u0631\u0642\u064a\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0645\u062f\u0646\u064a\u0646 \u0627\u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Medenine Solar Plant',
                'Unknown',
                'Ecodelta; Hatem Mabrouk; Bot Energy',
              ],
              [
                'Tunisia',
                100,
                'Africa',
                'Kairouan',
                '\u0627\u0644\u062c\u0628\u0644\u064a\u0629 \u0627\u0644\u0634\u0645\u0627\u0644\u064a\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0627\u0644\u0642\u064a\u0631\u0648\u0627\u0646 \u0627\u0644\u0634\u0645\u0627\u0644\u064a\u0629',
                'Kairouan Solar Plant',
                'Amea Power; TBEA Xinjiang New Energy Co.',
                'Amea Power; TBEA Xinjiang New Energy Co',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Kasserine',
                '\u0628\u0648\u0634\u0628\u0643\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0641\u0631\u064a\u0627\u0646\u0629',
                'Mazarine Feriana solar farm',
                'Unknown',
                'Mazarine Energy',
              ],
              [
                'Tunisia',
                120,
                'Africa',
                'Gafsa City',
                '\u062d\u064a \u0627\u0644\u0634\u0628\u0627\u0628',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0642\u0641\u0635\u0629 \u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Gafsa Solar Plant',
                'Engie; Nareva',
                'Engie; Nareva',
              ],
              [
                'Tunisia',
                100,
                'Africa',
                'Gafsa City',
                '\u062d\u064a \u0627\u0644\u0634\u0628\u0627\u0628',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0642\u0641\u0635\u0629 \u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Gafsa Solar Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Tunisia',
                60,
                'Africa',
                'Tozeur',
                '\u0627\u0644\u0634\u0627\u0628\u064a\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u062a\u0648\u0632\u0631',
                'Tozeur Solar PV Plant',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Tunisia',
                240,
                'Africa',
                'Tataouine',
                '\u0628\u0646\u064a \u0628\u0631\u0643\u0629 - \u062a\u0648\u0646\u0643\u062a',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u062a\u0637\u0627\u0648\u064a\u0646 \u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Tataouine Solar Plant',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Tozeur',
                '\u0627\u0644\u0634\u0627\u0641\u0639\u064a \u0627\u0644\u0634\u0631\u064a\u0641',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0646\u0641\u0637\u0629',
                'Tozeur (Tunisian Electicity And Gas Co) solar farm',
                'Unknown',
                'Tunisian Electricity and Gas Company (Steg)',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Tozeur',
                '\u0627\u0644\u0634\u0627\u0641\u0639\u064a \u0627\u0644\u0634\u0631\u064a\u0641',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0646\u0641\u0637\u0629',
                'Tozeur (Tunisian Electicity And Gas Co) solar farm',
                'Scatec Solar',
                'Tunisian Company of Electricity and Gas; Kreditanstalt f\u00fcr Wiederaufbau',
              ],
              [
                'Tunisia',
                50,
                'Africa',
                'Tozeur',
                '\u0627\u0644\u0634\u0627\u0628\u064a\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u062a\u0648\u0632\u0631',
                'Tozeur solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Gabes Sud',
                '\u0627\u0644\u0645\u062f\u0648',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0642\u0627\u0628\u0633 \u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Gabes Sud Solar Plant',
                'TuNur',
                'TuNur',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Gabes',
                '\u0627\u0644\u0645\u0646\u0637\u0642\u0629 \u0627\u0644\u0631\u0627\u0628\u0639\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0642\u0627\u0628\u0633 \u0627\u0644\u0645\u062f\u064a\u0646\u0629',
                'Gabes Solar Plant',
                'Unknown',
                'Akuo Energy; Hedi Bouchamaoui Group (HBG) Holding; Nour Energy',
              ],
              [
                'Tunisia',
                200,
                'Africa',
                'Borj Bourguiba',
                '\u0628\u0646\u064a \u0628\u0631\u0643\u0629 - \u062a\u0648\u0646\u0643\u062a',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u062a\u0637\u0627\u0648\u064a\u0646 \u0627\u0644\u062c\u0646\u0648\u0628\u064a\u0629',
                'Borj Bourguiba Solar PV Plant',
                'Unknown',
                'Unknown',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Sidi Bouzid',
                '\u0633\u064a\u062f\u064a \u0628\u0648\u0632\u064a\u062f \u0627\u0644\u063a\u0631\u0628\u064a\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0633\u064a\u062f\u064a \u0628\u0648\u0632\u064a\u062f \u0627\u0644\u063a\u0631\u0628\u064a\u0629',
                'Sidi Bouzid Solar Plant 1',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Tunisia',
                50,
                'Africa',
                'Sidi Bouzid',
                '\u0627\u0644\u0623\u062d\u0648\u0627\u0632',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0633\u064a\u062f\u064a \u0628\u0648\u0632\u064a\u062f \u0627\u0644\u0634\u0631\u0642\u064a\u0629',
                'Sidi Bouzid Solar Plant 2',
                'Unknown',
                'Unknown',
              ],
              [
                'Tunisia',
                10,
                'Africa',
                'Feriana',
                '\u0628\u0648\u0634\u0628\u0643\u0629',
                '\u0645\u0639\u062a\u0645\u062f\u064a\u0629 \u0641\u0631\u064a\u0627\u0646\u0629',
                'Qudran Feriana solar farm',
                'Unknown',
                'Qair',
              ],
              [
                'Turkey',
                33,
                'Eurasia',
                'B\u00fcy\u00fckalan',
                'Unavailable',
                'Akseki',
                'G\u00fcn G\u00fcne\u015f Antalya Akseki B\u00fcy\u00fckalan 1 solar farm',
                'G\u00fcn G\u00fcne\u015f Enerjisi Elektrik \u00dcretim Sanayi Ticaret Anonim \u015eirketi',
                'Erciyes Anadolu Holding',
              ],
              [
                'Turkey',
                55,
                'Eurasia',
                'Unavailable',
                'Hac\u0131lar',
                'Unavailable',
                'Kayseri Osb solar farm',
                'Efektif Enerji',
                'Sefero\u011flu Elektrik',
              ],
              [
                'Turkey',
                40,
                'Eurasia',
                'Karaman',
                'Karaman Merkez',
                'Unavailable',
                'Teksin solar farm',
                'Teksin Enerji \u00dcretimi Sanayi Ve Ticaret Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                20,
                'Eurasia',
                'Milas',
                'Milas',
                'Unavailable',
                '\u00d6zmen-1 solar farm',
                'Erg\u00fcn Enerji \u00dcretim Sanayi Ve Ticaret Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                31,
                'Eurasia',
                'Unavailable',
                'Uzunoluk',
                'Korkuteli',
                'K\u00fc\u00e7\u00fckk\u00f6y solar farm',
                'Antges Enerji \u00dcretim Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                52,
                'Eurasia',
                'Mut',
                'Mut',
                'Unavailable',
                'Kivan\u00e7 2 solar farm',
                'Ilgaz Elektrik \u00dcretim Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                1348,
                'Eurasia',
                'Unavailable',
                'Unavailable',
                'Karapinar',
                'Karap\u0131nar YEKA-1 solar farm',
                'Kalyon G\u00fcne\u015f Enerjisi \u00dcretim Anonim \u015eirketi',
                'Kalyon Holding',
              ],
              [
                'Turkey',
                50,
                'Eurasia',
                'Ma\u011fara',
                'Kangal',
                'G\u00fcr\u00fcn',
                'Kangal solar farm',
                'Kangal Elektrik Enerji \u00dcretim Ve Ticaret A.\u015e.',
                'Ece Tur \u015eirketler Grubu',
              ],
              [
                'Turkey',
                25,
                'Eurasia',
                'Islahiye',
                'Unavailable',
                'Islahiye',
                'Islahiye solar farm',
                'Inosolar G\u00fcne\u015f Enerji Sistemleri; Wagner Solar',
                'Inosolar G\u00fcne\u015f Enerji Sistemleri; Wagner Solar',
              ],
              [
                'Turkey',
                32,
                'Eurasia',
                'Unavailable',
                'Hilvan',
                'Unavailable',
                'Hilvan solar farm',
                'Hilvan GES',
                'Denge Yap\u0131 A\u015e',
              ],
              [
                'Turkey',
                35,
                'Eurasia',
                'Unavailable',
                'Unavailable',
                '\u00c7avd\u0131r',
                'Fernas-4 solar farm',
                'Ferg\u00fcn Enerji Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                26,
                'Eurasia',
                'Unavailable',
                'Unavailable',
                'Bor',
                'Cingilli solar farm',
                '\u015eua Elektrik \u00dcretim Anonim \u015eirketi',
                'Polat Enerji',
              ],
              [
                'Turkey',
                56,
                'Eurasia',
                'Unavailable',
                'Unavailable',
                'Tu\u015fba',
                'G\u00fcn G\u00fcne\u015f Van Arisu solar farm',
                'G\u00fcn G\u00fcne\u015f Enerjisi Elektrik \u00dcretim Sanayi Ticaret Anonim \u015eirketi',
                'Erciyes Anadolu Holding',
              ],
              [
                'Turkey',
                24,
                'Eurasia',
                'Unavailable',
                'Cihangir',
                'Adilcevaz',
                'Alages Adilcevaz solar farm',
                'G\u00fclbahar Elektrik \u00dcretim Anonim \u015eirketi',
                'Unknown',
              ],
              [
                'Turkey',
                80,
                'Eurasia',
                'Unavailable',
                'G\u00f6zeler',
                'Merkez',
                'Asagi solar farm',
                'Kalehan Enerji',
                'Cengiz \u0130n\u015faat: \u00d6zalt\u0131n \u0130n\u015faat',
              ],
              [
                'Uganda',
                250,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ceec solar farm',
                'Unknown',
                'China Energy Engineering Corporation (CEEC)',
              ],
              [
                'Uganda',
                250,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ceec solar farm',
                'Unknown',
                'China Energy Engineering Corporation (CEEC)',
              ],
              [
                'Uganda',
                125,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ergon Solair solar farm',
                'Unknown',
                'Ergon Solair',
              ],
              [
                'Uganda',
                125,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ergon Solair solar farm',
                'Unknown',
                'Ergon Solair',
              ],
              [
                'Uganda',
                125,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ergon Solair solar farm',
                'Unknown',
                'Ergon Solair',
              ],
              [
                'Uganda',
                34,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Kabulasoke solar farm',
                'Unknown',
                'Xsabo Group; Great Lakes Africa Energy (GLAE)',
              ],
              [
                'Uganda',
                50,
                'Africa',
                'Erute',
                'Erute',
                'Unavailable',
                'Lira solar farm',
                'Unknown',
                'Xsabo Group',
              ],
              [
                'Uganda',
                23,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nkonge solar farm',
                'Unknown',
                'Xsabo Group',
              ],
              [
                'Uganda',
                125,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ergon Solair solar farm',
                'Unknown',
                'Ergon Solair',
              ],
              [
                'Ukraine',
                21,
                'Europe',
                '\u041f\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Perovo Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                47,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Rengy solar farm',
                'Scatec Solar',
                'Scatec Solar [51%]; Rengy Development Group [49%]',
              ],
              [
                'Ukraine',
                240,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                "Pokrovs'Ka solar farm",
                'DTEK Renewables',
                'DTEK Renewables',
              ],
              [
                'Ukraine',
                28,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Priozernaya solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                28,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Priozernaya solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                148,
                'Europe',
                'Prohresivka',
                'Berezanka District',
                'Unavailable',
                'Progressovka solar farm',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Ukraine',
                33,
                'Europe',
                'Melitopol',
                'Melitopol District',
                'Unavailable',
                'Scythia-Solar',
                'Unknown',
                'UDP Renewables',
              ],
              [
                'Ukraine',
                35,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Solar Capital solar farm',
                'Unknown',
                'VR Capital Group',
              ],
              [
                'Ukraine',
                52,
                'Europe',
                'Tokmak',
                'Polohy District',
                'Unavailable',
                'Tokmak Solar',
                'Unknown',
                'Tokmak Solar Energy',
              ],
              [
                'Ukraine',
                30,
                'Europe',
                'Velyka Blahovishchenka',
                "Hornostaivs'kyi District",
                'Unavailable',
                'Velyka Blahovishchenka solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                53,
                'Europe',
                'Berezanskaya',
                'Berezanskyi District',
                'Unavailable',
                'Voshod solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                29,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Voznesensk solar farm',
                'Neptune Solar LLC; Neptun Solar',
                'CNBM International',
              ],
              [
                'Ukraine',
                36,
                'Europe',
                'Ternovitsa',
                'Yavoriv district',
                'Unavailable',
                'Yavoriv solar farm',
                'Energopark Yavoriv LLC',
                'EcoOptima LLC',
              ],
              [
                'Ukraine',
                36,
                'Europe',
                'Ternovitsa',
                'Yavoriv district',
                'Unavailable',
                'Yavoriv solar farm',
                'Energopark Yavoriv LLC',
                'EcoOptima LLC',
              ],
              [
                'Ukraine',
                21,
                'Europe',
                '\u041f\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Perovo Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Starokozache solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                21,
                'Europe',
                '\u041f\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Perovo Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                43,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Limanskaya solar farm (Ukraine)',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                21,
                'Europe',
                '\u041f\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Perovo Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                54,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Boguslav solar farm',
                'Scatec Solar',
                'Scatec Solar',
              ],
              [
                'Ukraine',
                34,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bolgrad solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                55,
                'Europe',
                'Unavailable',
                'Chigirin district',
                'Unavailable',
                'Chigirin solar farm',
                'Unknown',
                'Scatec Solar [60%]; FMO [40%]',
              ],
              [
                'Ukraine',
                33,
                'Europe',
                'Chudniv',
                'Zhytomyr District',
                'Unavailable',
                'Chudniv Solar Farm',
                'Unknown',
                'Naftogaz of Ukraine',
              ],
              [
                'Ukraine',
                22,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dunayskaya solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                21,
                'Europe',
                '\u041f\u0435\u0440\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Perovo Solar Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                32,
                'Europe',
                'Kamianka',
                'Cherkasy District',
                'Unavailable',
                'Kamianka solar farm',
                'Unknown',
                'Scatec Solar [60%]; Others [40%]',
              ],
              [
                'Ukraine',
                22,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Dunayskaya solar farm',
                'Unknown',
                'CNBM International',
              ],
              [
                'Ukraine',
                54,
                'Europe',
                'Kozhukhiv',
                'Lityn district',
                'Unavailable',
                'Lityn solar farm',
                'Unknown',
                'Ekotechnik Ukraine',
              ],
              [
                'Ukraine',
                32,
                'Europe',
                'Saky Raion',
                'Saky Raion',
                'Unavailable',
                'Mityaevo solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                70,
                'Europe',
                '\u041a\u043e\u043b\u044c\u0447\u0443\u0433\u0438\u043d\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Simferopol District',
                'Unavailable',
                'Nikolayevka solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                246,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Nikopol solar farm',
                'Unknown',
                'DTEK Renewables',
              ],
              [
                'Ukraine',
                83,
                'Europe',
                '\u041e\u0445\u043e\u0442\u043d\u0438\u043a\u043e\u0432\u0441\u043a\u043e\u0435 \u0441\u0435\u043b\u044c\u0441\u043a\u043e\u0435 \u043f\u043e\u0441\u0435\u043b\u0435\u043d\u0438\u0435',
                'Saky Raion',
                'Unavailable',
                'Ohotnikovo solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Ukraine',
                64,
                'Europe',
                'Panovtsy',
                'Kamianets-Podilskyi District',
                'Unavailable',
                'Panovtsy solar farm',
                'Unknown',
                'VR Capital Group',
              ],
              [
                'Ukraine',
                50,
                'Europe',
                'Unavailable',
                'Holoprystansky district',
                'Unavailable',
                'Kherson solar farm',
                'Unknown',
                'Atlas Capital Energy LLC',
              ],
              [
                'United Arab Emirates',
                2000,
                'Middle East',
                'Unavailable',
                'Abu Dhabi',
                'Al Dhafra',
                'Al Dhafra solar farm',
                'Abu Dhabi National Energy Company (TAQA); Masdar; EDF Renewables; Jinko Power',
                'Abu Dhabi National Energy Company (TAQA); Masdar;( 60% both) EDF Renewables; Jinko Power (40% both)',
              ],
              [
                'United Arab Emirates',
                200,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Shuaa Energy 1',
                'Dubai Electricity and Water Authority (DEWA); ACWA Power',
              ],
              [
                'United Arab Emirates',
                40,
                'Middle East',
                'Sharjah',
                'Unavailable',
                'Unavailable',
                'Al Saja Landfill solar farm',
                'Emirates Waste to Energy Company',
                "Bee'ah; Masdar Clean Energy",
              ],
              [
                'United Arab Emirates',
                40,
                'Middle East',
                'Sharjah',
                'Unavailable',
                'Unavailable',
                'Al Saja Landfill solar farm',
                'Emirates Waste to Energy Company',
                "Bee'ah; Masdar Clean Energy",
              ],
              [
                'United Arab Emirates',
                40,
                'Middle East',
                'Sharjah',
                'Unavailable',
                'Unavailable',
                'Al Saja Landfill solar farm',
                'Emirates Waste to Energy Company',
                "Bee'ah; Masdar Clean Energy",
              ],
              [
                'United Arab Emirates',
                10,
                'Middle East',
                'Abu Dhabi',
                'Abu Dhabi',
                'Unavailable',
                'Masdar City solar farm',
                'Masdar Clean Energy',
                'Masdar Clean Energy',
              ],
              [
                'United Arab Emirates',
                13,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Dubai Electricity and Water Authority (DEWA)',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                900,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'ACWA Power; Gulf Investment Corporation',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                200,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Shuaa Energy 2',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                300,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Shuaa Energy 2',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                600,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Dubai Electricity and Water Authority (DEWA); ACWA Power; Silk Road Fund',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                100,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Dubai Electricity and Water Authority (DEWA); ACWA Power; Silk Road Fund',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                250,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Dubai Electricity and Water Authority (DEWA); ACWA Power; Silk Road Fund',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                300,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'ACWA Power; Gulf Investment Corporation',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Arab Emirates',
                1177,
                'Middle East',
                "Al 'Ajban",
                'Al Ain',
                'Unavailable',
                'Noor Abu Dhabi solar farm',
                'Sweihan PV Power Company',
                'Abu Dhabi National Energy Company (TAQA) [60 %]; Marubeni Corporation [20%]; JinkoPower [20 %]',
              ],
              [
                'United Arab Emirates',
                100,
                'Middle East',
                'Al Dhafra Region',
                'Al Dhafra Region',
                'Unavailable',
                'Shams 1 solar farm',
                'Shams Power Company',
                'Masdar Clean Energy; TotalEnergies SE',
              ],
              [
                'United Arab Emirates',
                300,
                'Middle East',
                'Unavailable',
                'Saih Al-Dahal',
                'Unavailable',
                'Mohammed Bin Rashid Al Maktoum Solar Park',
                'Shuaa Energy 2',
                'Dubai Electricity and Water Authority (DEWA)',
              ],
              [
                'United Kingdom',
                48,
                'Europe',
                'North Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Scopwick solar farm',
                'Unknown',
                'Hazel Capital LLP',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Essex',
                'Essex',
                'East of England',
                'Periwinkle Hall solar farm',
                'Unknown',
                'Links Solar Farm Ltd.',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'Essex',
                'Essex',
                'East of England',
                'Pentlow Hill solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                33,
                'Europe',
                'Doncaster',
                'South Yorkshire',
                'Yorkshire and the Humber',
                'Partridge Hill solar farm',
                'Unknown',
                'Green Switch Solutions',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Christchurch',
                'Bournemouth, Christchurch and Poole',
                'Unavailable',
                'Parley Court solar farm',
                'RES / Isolux Corsan',
                'TRIG',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Thurrock',
                'Thurrock',
                'East of England',
                'Ockendon Landfill solar farm',
                'Unknown',
                'REG Solarpower Ltd.; Veolia ES',
              ],
              [
                'United Kingdom',
                48,
                'Europe',
                'Canterbury',
                'Kent',
                'South East England',
                "Owl's Hatch Solar Park",
                'British Solar Renewables',
                'Cubico Sustainable Investments',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Merseyside',
                'Merseyside',
                'North West England',
                'Orrell Hill Solar Park',
                'Unknown',
                'Hive Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Gloucestershire',
                'South Gloucestershire',
                'South West England',
                'Perrinpit Road solar farm',
                'Unknown',
                'BayWa r.e.; Gr\u03cbne Energien Solar',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Oxfordshire',
                'Oxfordshire',
                'South East England',
                'Nuneham Courtenay solar farm',
                'Unknown',
                'Cowley Baldon Green Limited',
              ],
              [
                'United Kingdom',
                28,
                'Europe',
                'Hambleton',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'Northallerton solar farm',
                'Unknown',
                'Big60Million Ltd.',
              ],
              [
                'United Kingdom',
                65,
                'Europe',
                'Vale of Glamorgan',
                'Vale of Glamorgan',
                'Unavailable',
                'Parc Dyffryn Solar Park',
                'Unknown',
                'Cenin Renewables; Coedarhydyglyn Estate',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Wiltshire',
                'Swindon',
                'South West England',
                'Port solar farm',
                'Unknown',
                'Foresight Solar Fund; Vogt solar',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Rampisham Down Transmitting Station solar farm',
                'Unknown',
                'British Solar Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'North Northamptonshire',
                'North Northamptonshire',
                'East Midlands',
                'RAF Desborough Solar Park',
                'Unknown',
                'Northfield Solar UK',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'West Lindsey',
                'Lincolnshire',
                'East Midlands',
                'RAF Faldingworth solar farm',
                'Lunar Energy Power',
                'Unknown',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Gloucestershire',
                'South Gloucestershire',
                'South West England',
                'Rag Lane solar farm',
                'Unknown',
                'BayWa r.e.; Gr\u03cbne Energien Solar',
              ],
              [
                'United Kingdom',
                28,
                'Europe',
                'Rutland',
                'Rutland',
                'East Midlands',
                'Ranksborough Solar PV',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'North Lincolnshire',
                'North Lincolnshire',
                'Yorkshire and the Humber',
                'Raventhorpe Lodge solar farm',
                'Unknown',
                'Wirsol Energy; Elgar Middleton',
              ],
              [
                'United Kingdom',
                38,
                'Europe',
                'North Lincolnshire',
                'North Lincolnshire',
                'Yorkshire and the Humber',
                'Raventhorpe solar farm',
                'WElink Group',
                'Fengate Capital',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Vale of White Horse',
                'Oxfordshire',
                'South East England',
                'Reading Road solar farm',
                'Unknown',
                'Orta East Hendred Solar Ltd',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                'Selby',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'Redmoor solar farm',
                'Unknown',
                'TGC Renewables',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                "King's Lynn and West Norfolk",
                'Norfolk',
                'East of England',
                'Rose And Crown solar farm',
                'Unknown',
                'Elgin Energy; Greencoat Solar',
              ],
              [
                'United Kingdom',
                43,
                'Europe',
                'Central Bedfordshire',
                'Central Bedfordshire',
                'East of England',
                'Samphill solar farm',
                'Unknown',
                'Anesco Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Sandridge',
                'Wiltshire',
                'Unavailable',
                'Sandridge Solar',
                'Unknown',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'West Devon',
                'Devon',
                'South West England',
                'North Tawton Solar',
                'Unknown',
                'Kinetica Energy',
              ],
              [
                'United Kingdom',
                23,
                'Europe',
                'Stratford-on-Avon',
                'Warwickshire',
                'West Midlands',
                'Radbrook Pastures solar farm',
                'Unknown',
                'TGC Renewables; NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'North Fossil solar farm',
                'Unknown',
                'Spring Dev 03 Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Newark and Sherwood',
                'Nottinghamshire',
                'East Midlands',
                'Winkburn Estate solar farm',
                'Unknown',
                'Lightsource SPV 154 Limited',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Isle of Anglesey',
                'Isle of Anglesey',
                'Unavailable',
                'North Anglesey Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'Norwich',
                'Norfolk',
                'East of England',
                'Scottow Moor - RAF Coltishall solar farm',
                'Enerparc',
                'Greencoat Capital',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'North East Lincolnshire',
                'North East Lincolnshire',
                'Yorkshire and the Humber',
                'Low Farm Solar Array',
                'Unknown',
                'Wirsol Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'East Lindsey',
                'Lincolnshire',
                'East Midlands',
                'Low Farm solar farm',
                'Anesco',
                'Gresham House',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Buckinghamshire',
                'Buckinghamshire',
                'South East England',
                'Lower Waldridge solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'Swindon',
                'Swindon',
                'South West England',
                'Lynt solar farm',
                'BayWa r.e.',
                'MEAG',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Kilkenny',
                'Gloucestershire',
                'Unavailable',
                'Macosquin Solar',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'North Lincolnshire',
                'North Lincolnshire',
                'Yorkshire and the Humber',
                'Manton Manor solar farm',
                'Martifer Solar UK',
                'Pegasus Group',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Mapperton solar farm',
                'Unknown',
                'Good Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Meadow solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Melksham solar farm',
                'Unknown',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Melksham Substation solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'West Lindsey',
                'Lincolnshire',
                'East Midlands',
                'Middle Street Solar',
                'Unknown',
                'RGE Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Moray',
                'Moray',
                'Unavailable',
                'Milltown Airfield solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Minety solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                70,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'MOD Lyneham solar farm',
                'Defence Infrastructure Organisation',
                'Bluefield Solar',
              ],
              [
                'United Kingdom',
                42,
                'Europe',
                'Torridge District',
                'Devon',
                'South West England',
                'Monks Solar Farm And Trelana',
                'Unknown',
                'Renewable Energy Systems (RES)',
              ],
              [
                'United Kingdom',
                42,
                'Europe',
                'Angus',
                'Angus',
                'Unavailable',
                'Montreathmont Moor Forest solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'City of Peterborough',
                'City of Peterborough',
                'East of England',
                'Morris Fen PV solar farm',
                'Unknown',
                'Peterborough City Council',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'Wychavon',
                'Worcestershire',
                'West Midlands',
                'Mount solar farm',
                'Unknown',
                'INRG Solar Ltd.',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Munceys solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                36,
                'Europe',
                'Buckinghamshire',
                'Buckinghamshire',
                'South East England',
                'Mursley Road solar farm',
                'Unknown',
                'RPS Group',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Telford and Wrekin',
                'Telford and Wrekin',
                'West Midlands',
                'Myttons solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Unavailable',
                'North East Lincolnshire',
                'North East Lincolnshire',
                'Nel Energy Park solar farm',
                'Unknown',
                'Engie',
              ],
              [
                'United Kingdom',
                49,
                'Europe',
                'Hampshire',
                'Hampshire',
                'South East England',
                'Newlands Farm Solar',
                'Unknown',
                'Sunsave 10; Vogt Solar',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'Fareham',
                'Hampshire',
                'Unavailable',
                'Newlands Solar',
                'ib vogt GmbH',
                'ib vogt GmbH',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Sunderland',
                'Unavailable',
                'North East',
                'Nissan Sunderland Solar',
                'Unknown',
                'Nissan',
              ],
              [
                'United Kingdom',
                29,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'North Angle solar farm',
                'Cambridgeshire County Council',
                'Cambridgeshire County Council',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'North Norfolk',
                'Norfolk',
                'East of England',
                'North Creake Airfield Solar',
                'Unknown',
                'British Solar Renewables',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Argyll and Bute',
                'Argyll and Bute',
                'Unavailable',
                'Sheirdrim Renewable Energy Development - Solar',
                'Unknown',
                'ScottishPower Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Bramford',
                'Mid Suffolk',
                'Unavailable',
                'Tye Lane Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Shropshire',
                'Shropshire',
                'West Midlands',
                'Sheriffhales solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                34,
                'Europe',
                'Treviscoe',
                'Cornwall',
                'Unavailable',
                'Treviscoe solar farm',
                'Unknown',
                'Statkraft',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Gloucestershire',
                'Gloucestershire',
                'South West England',
                'Troughton solar farm',
                'Unknown',
                'Hive Energy',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Buckinghamshire',
                'Buckinghamshire',
                'South East England',
                'Tuckey solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Carmarthenshire',
                'Carmarthenshire',
                'Unavailable',
                'Tycroes solar farm',
                'Unknown',
                'Spring Dev 2 Ltd',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Newport',
                'Unavailable',
                'Unavailable',
                'Llanwern Solar',
                'Unknown',
                'Gwent Farmers\u2019 Community Solar Scheme Ltd.',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Verwood solar farm',
                'Unknown',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                46,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Vine Farm Solar Park',
                'BayWa r.e.',
                'Allianz Global Investors',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'Bassetlaw',
                'Nottinghamshire',
                'East Midlands',
                'Walkers Wood Solar Park',
                'Unknown',
                'Magnetar Solar',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Caerphilly County Borough',
                'Caerphilly County Borough',
                'Unavailable',
                'Wauntysswg solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                63,
                'Europe',
                'Newport',
                'Unavailable',
                'Unavailable',
                'Wentlooge Renewable Energy Hub solar farm',
                'Unknown',
                "Wentlooge Farmers' Solar Scheme Ltd.",
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Sevenoaks',
                'Kent',
                'South East England',
                'West Kingdown solar farm',
                'Unknown',
                'Hive Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'North Norfolk',
                'Norfolk',
                'East of England',
                'West Raynham Airfield solar farm',
                'Unknown',
                'Bluefield Solar Income Fund',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'Borough of Swale',
                'Kent',
                'South East England',
                'Tonge Corner solar farm',
                'Unknown',
                'Martifer Solar (Voltalia)',
              ],
              [
                'United Kingdom',
                29,
                'Europe',
                'West Suffolk',
                'Suffolk',
                'East of England',
                'West solar farm',
                'Unknown',
                'Elveden Farms Ltd',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'North Kesteven',
                'Lincolnshire',
                'East Midlands',
                'White Cross Lane solar farm',
                'Intelligent Alternatives',
                'Unknown',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'White Cross',
                'Cornwall',
                'Unavailable',
                'White Cross solar farm',
                'Unknown',
                'Statkraft',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Gloucester',
                'Gloucestershire',
                'South West England',
                'Whitminster solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Bassetlaw',
                'Nottinghamshire',
                'East Midlands',
                'Wood Lane solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                45,
                'Europe',
                'Malvern Hills District',
                'Worcestershire',
                'West Midlands',
                'Woodhall solar farm',
                'Unknown',
                'Kronos Solar',
              ],
              [
                'United Kingdom',
                46,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Woodington solar farm',
                'Unknown',
                'Hive Energy',
              ],
              [
                'United Kingdom',
                37,
                'Europe',
                'Rutland',
                'Rutland',
                'East Midlands',
                'Woolfox Quarry solar farm',
                'Unknown',
                'Renewable Energy Systems (RES)',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Gloucestershire',
                'Gloucestershire',
                'South West England',
                "World'S End Solar Park",
                'Unknown',
                'British Solar Renewables',
              ],
              [
                'United Kingdom',
                61,
                'Europe',
                'Swindon',
                'Swindon',
                'South West England',
                'Wroughton Airfield Solar Park',
                'Unknown',
                'Rockfire Capital',
              ],
              [
                'United Kingdom',
                34,
                'Europe',
                'Borough of Charnwood',
                'Leicestershire',
                'East Midlands',
                'Wymeswold Airfield solar farm',
                'Lark Energy',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Yellowham Solar Park',
                'Unknown',
                'Wessex Solar Energy',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Hambleton',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'York solar farm',
                'Gridserve',
                'Gridserve',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Whaddon Lane solar farm',
                'Unknown',
                'INRG Solar Ltd.',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Central Bedfordshire',
                'Central Bedfordshire',
                'East of England',
                'Tilsworth solar farm',
                'Unknown',
                'A Rosen Invest APS',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Bassetlaw',
                'Nottinghamshire',
                'East Midlands',
                'Tiln Farm solar farm',
                'Unknown',
                'Lightsource SPV 154 Limited',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Pembrokeshire',
                'Pembrokeshire',
                'Unavailable',
                'Tiers Cross solar farm',
                'Unknown',
                'Good Energy',
              ],
              [
                'United Kingdom',
                72,
                'Europe',
                'Flintshire',
                'Flintshire',
                'Unavailable',
                'Shotwick solar farm',
                'Unknown',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                49,
                'Europe',
                'Peterborough',
                'City of Peterborough',
                'East of England',
                'Solar Farms Of Newborough',
                'Unknown',
                'Peterborough City Council',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                "King's Lynn and West Norfolk",
                'Norfolk',
                'East of England',
                'South Creake solar farm',
                'Metka EGN',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Essex',
                'Essex',
                'East of England',
                'South Fambridge Solar Park',
                'Unknown',
                'British Solar Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hambleton',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'South Lowfields solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                48,
                'Europe',
                'Winchester',
                'Hampshire',
                'South East England',
                'Southwick Estate solar farm',
                'Unknown',
                'Bluefield Solar Income Fund',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'West Northamptonshire',
                'Buckinghamshire',
                'South East England',
                'Sparrow Lodge solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Moray',
                'Moray',
                'Unavailable',
                'Speyslaw solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Chelmsford',
                'Essex',
                'East of England',
                'St Cleres Hall Pit Solar Array',
                'Danbury Aggregates Ltd.',
                'Danbury Aggregates Ltd.',
              ],
              [
                'United Kingdom',
                51,
                'Europe',
                'Huntingdonshire',
                'Cambridgeshire',
                'East of England',
                'Staughton Airfield solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'County Antrim',
                'County Antrim',
                'Unavailable',
                'Steeple Road solar farm',
                'Unknown',
                'Elgin Energy EsCo Ltd.',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Stowbridge solar farm',
                'Unknown',
                'Magnetar Solar',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Strensham',
                'Worcestershire',
                'Unavailable',
                'Strensham Solar',
                'NextEnergy Solar Fund',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hinckley and Bosworth',
                'Leicestershire',
                'East Midlands',
                'Stretton Baskerville solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Newark and Sherwood',
                'Nottinghamshire',
                'East Midlands',
                'Stud solar farm',
                'Unknown',
                'Martifer Solar (Voltalia)',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Shropshire',
                'Shropshire',
                'West Midlands',
                'Sundorne Grove solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                250,
                'Europe',
                'Chippenham',
                'Unavailable',
                'Cambridgeshire and Peterborough',
                'Sunnica Energy Farm Solar',
                'Unknown',
                'Tribus Energy; PS Renewables',
              ],
              [
                'United Kingdom',
                250,
                'Europe',
                'Worlington',
                'Suffolk',
                'Unavailable',
                'Sunnica Energy Farm Solar',
                'Unknown',
                'Tribus Energy; PS Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Spalding',
                'Lincolnshire',
                'Unavailable',
                'Sutton Bridge solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Vale of White Horse',
                'Oxfordshire',
                'South East England',
                'Sutton Courtenay Landfill solar farm',
                'Unknown',
                'Infinis Solar Developments Ltd.',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Harborough District',
                'Leicestershire',
                'East Midlands',
                'Swinford Wind Farm solar farm',
                'Unknown',
                'Vattenfall',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Folkestone and Hythe District',
                'Kent',
                'South East England',
                'Sycamore solar farm',
                'Unknown',
                'BNRG Renewables; Lightsource Renewable Energy; Octopus Investments',
              ],
              [
                'United Kingdom',
                31,
                'Europe',
                'Angus',
                'Angus',
                'Unavailable',
                'Tealing Airfield PV solar farm',
                'Green Cat Renewables',
                'Unknown',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Uttlesford',
                'Essex',
                'East of England',
                'Terriers solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                23,
                'Europe',
                'Thurrock',
                'Thurrock',
                'East of England',
                'The Place solar farm',
                'Unknown',
                'Be Renewables',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'Harborough District',
                'Leicestershire',
                'East Midlands',
                'Theddingworth solar farm',
                'Abbey Renewables',
                'Unknown',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Winchester',
                'Hampshire',
                'South East England',
                'Three Maids Hill solar farm',
                'Unknown',
                'Environmental Asset Management',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'County Durham',
                'County Durham',
                'North East England',
                'Sheraton Hall solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                75,
                'Europe',
                'Newport',
                'Gwent Levels',
                'Unavailable',
                'Llanwern (Nextenergy) Solar Farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hambleton',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'Os Field 6800 Fence Dike Lane solar farm',
                'Unknown',
                'Lightrock Power',
              ],
              [
                'United Kingdom',
                31,
                'Europe',
                'Wychavon',
                'Worcestershire',
                'West Midlands',
                'Littleton solar farm',
                'Unknown',
                'Littleton Pastures Solar Ltd.',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Huntingdonshire',
                'Cambridgeshire',
                'East of England',
                'Caldecote Manor solar farm',
                'Unknown',
                'Inazin Power Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Cambridge solar farm',
                'Unknown',
                'Big60Million Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Chelmsford',
                'Essex',
                'East of England',
                'Canon Barns Road solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                41,
                'Europe',
                'Cornwall',
                'Cornwall',
                'South West England',
                'Canworthy Water solar farm',
                'PS Renewables',
                'Equitix Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Harrogate',
                'North Yorkshire',
                'Yorkshire and the Humber',
                'Cayton solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Vale of White Horse',
                'Oxfordshire',
                'South East England',
                'Chadwicks Solar Farms',
                'Unknown',
                'Kronos Solar',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'South Oxfordshire',
                'Oxfordshire',
                'South East England',
                'Chalgrove Solar',
                'Unknown',
                'Armstrong Energy',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Bournemouth, Christchurch and Poole',
                'Bournemouth',
                'South West England',
                'Chapel Lane Parley solar farm',
                'Unknown',
                'Solar Power Generation Limited',
              ],
              [
                'United Kingdom',
                36,
                'Europe',
                'Bournemouth, Christchurch and Poole',
                'Bournemouth',
                'South West England',
                'Chapel Lane Parley solar farm',
                'Unknown',
                'Eco Sustainable Solutions',
              ],
              [
                'United Kingdom',
                60,
                'Europe',
                'North Northamptonshire',
                'North Northamptonshire',
                'East Midlands',
                'Chelveston Renewable Energy Park solar farm',
                'Unknown',
                'Wykes Engineering',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Childerley solar farm',
                'Unknown',
                'Solarcentury Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hart',
                'Hampshire',
                'South East England',
                'Chosley Farm Solar Park',
                'Unknown',
                'Clearstone Energy',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                'Cotswold District',
                'Gloucestershire',
                'South West England',
                'Cirencester solar farm',
                'Unknown',
                'Warrington Borough Council',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'London',
                'Thurrock',
                'Greater London',
                'Clay Tye Road solar farm',
                'Unknown',
                'REG Windpower Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Gloucestershire',
                'Gloucestershire',
                'South West England',
                'Claydon solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                350,
                'Europe',
                'Borough of Swale',
                'Kent',
                'South East England',
                'Cleve Hill Solar Project',
                'Unknown',
                'Hive Energy; Wirsol Energy Ltd.',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Clifton Farm Solar Park',
                'Unknown',
                'Voltalia UK',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Leicestershire',
                'Leicestershire',
                'East Midlands',
                'Desford Road solar farm',
                'Unknown',
                'Elgin Energy EsCo Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wychavon',
                'Worcestershire',
                'West Midlands',
                'Defford Aerodrome solar farm',
                'Unknown',
                'Solar Planning Ltd.',
              ],
              [
                'United Kingdom',
                38,
                'Europe',
                'Pembrokeshire',
                'Pembrokeshire',
                'Unavailable',
                'Crundale Solar Field',
                'ib vogt GmbH',
                'ib vogt GmbH; Solafields Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'West Northamptonshire',
                'West Northamptonshire',
                'East Midlands',
                'Crick Road solar farm',
                'Unknown',
                'Lightrock Power',
              ],
              [
                'United Kingdom',
                45,
                'Europe',
                'Astwood',
                'Milton Keynes',
                'Unavailable',
                'Cranfield Road Solar Park',
                'Unknown',
                'Renewable Connections',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'County Durham',
                'County Durham',
                'North East England',
                'Cowley House solar farm',
                'Lightsource BP',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Bypass solar farm',
                'Unknown',
                'By-Pass Farm Solar Ltd.',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Cowdown Lane solar farm',
                'EMS',
                'Equitix Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Newark and Sherwood',
                'Nottinghamshire',
                'East Midlands',
                'Cotmoor Lane solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Swindon',
                'Swindon',
                'South West England',
                'Corner Copse solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'South Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Copley solar farm',
                'Unknown',
                'TGC Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Lichfield',
                'Staffordshire',
                'West Midlands',
                'Colton Mill Solar Farm & Cawarden Springs solar farm',
                'Unknown',
                'Spring Dev 07 Ltd.',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Uttlesford',
                'Essex',
                'East of England',
                'Cole End solar farm',
                'Unknown',
                'Long Meadow Solar Farm Ltd.',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Cockhill solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                46,
                'Europe',
                'Antrim',
                'Dublin Road',
                'Unavailable',
                'County Antrim solar farm',
                'Unknown',
                'Rad Energy Three Ltd.; Hadstone Energy',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'County Antrim',
                'County Antrim',
                'Unavailable',
                'Dobbs Estate solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Bury Lane Fruit Farm Solar',
                'Vortex',
                'Unknown',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hart',
                'Hampshire',
                'South East England',
                'Bunkers Hill solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                37,
                'Europe',
                'Bournemouth',
                'Dorset',
                'Unavailable',
                'Bournemouth Airport solar farm',
                'Silverstone Green Energy',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                29,
                'Europe',
                'Vale of White Horse',
                'Oxfordshire',
                'South East England',
                'Bluefield Elms Farm Solar',
                'Unknown',
                'Bluefield Solar',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'Pembrokeshire',
                'Pembrokeshire',
                'Unavailable',
                'Blackberry Lane Solar Park',
                'Unknown',
                'Wessex Solar Energy',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Black Peak solar farm',
                'Lightsource Renewable Energy',
                'Unknown',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'West Lindsey',
                'Lincolnshire',
                'East Midlands',
                'Birch Holt solar farm',
                'Unknown',
                'AEE Renewables',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Aberdeenshire',
                'Aberdeenshire',
                'Unavailable',
                'Bilbo solar farm',
                'Unknown',
                'Green Energy International',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Leeds',
                'West Yorkshire',
                'Yorkshire and the Humber',
                'Barnsdale Road Solar Park',
                'Unknown',
                'Banks Group',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Rushcliffe',
                'Nottinghamshire',
                'East Midlands',
                'Barn solar farm',
                'Unknown',
                'Northfield UK Solar',
              ],
              [
                'United Kingdom',
                33,
                'Europe',
                'Borough of Wokingham',
                'Borough of Wokingham',
                'South East England',
                'Barkham solar farm',
                'Unknown',
                'Wokingham Borough Council',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Bann Road solar farm',
                'BayWa r.e.',
                'Greencoat Solar Assets II Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Forest of Dean District',
                'Gloucestershire',
                'South West England',
                "Awre Penisular Farmer'S Community Solar Scheme",
                'Unknown',
                "Awre Penisular Farmer's Community Solar Group",
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'Bristol',
                'South Gloucestershire',
                'South West England',
                'Avon Grange solar farm',
                'Unknown',
                'Solar Power South',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'West Oxfordshire',
                'Oxfordshire',
                'South East England',
                'Aurora solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                'Attleborough',
                'Norfolk',
                'Unavailable',
                'Attleborough Solar Park',
                'Unknown',
                'Pathfinder Clean Energy (PACE)',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Derbyshire Dales',
                'Derbyshire',
                'East Midlands',
                'Aston House solar farm',
                'Unknown',
                'Solarcentury Ltd.',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Aylesbury',
                'Buckinghamshire',
                'South East England',
                'Aston Clinton Solar Park',
                'BayWa r.e.',
                'CEE Group',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Huntingdonshire',
                'Cambridgeshire',
                'East of England',
                'Abbots Ripton solar farm',
                'Unknown',
                'Octopus Investments',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'London',
                'Thurrock',
                'Greater London',
                'Bulphan Fen solar farm',
                'Unknown',
                'Enso Energy',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Shropshire',
                'Shropshire',
                'West Midlands',
                'Bubney solar farm',
                'Unknown',
                'Renewable Connections',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'Vale of Glamorgan',
                'Vale of Glamorgan',
                'Unavailable',
                'Brynwell Farm Solar Park',
                'Unknown',
                'Brynwell Farm Solar Ltd.',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Powys',
                'Powys',
                'Unavailable',
                'Bryn Henllys solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'West Suffolk',
                'Suffolk',
                'East of England',
                'Broxted solar farm',
                'Unknown',
                'Santander',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Cherwell District',
                'Oxfordshire',
                'South East England',
                'Brook solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Burwell solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'North Northamptonshire',
                'North Northamptonshire',
                'East Midlands',
                'Brigstock solar farm',
                'Unknown',
                'ScottishPower Renewables; Buccleuch',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'North Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Branston Solar Park Extension',
                'Unknown',
                'Ethical Power',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Basingstoke and Deane',
                'Hampshire',
                'South East England',
                'Bramley Frith solar farm',
                'Unknown',
                'Enso Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Mid Suffolk',
                'Suffolk',
                'East of England',
                'Bramford solar farm',
                'Unknown',
                'Enso Energy',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'South Norfolk',
                'Norfolk',
                'East of England',
                'Bracon Ash solar farm',
                'Unknown',
                'Luminous Energy Ltd',
              ],
              [
                'United Kingdom',
                28,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Bracks Solar Park',
                'Unknown',
                'British Solar Renewables',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Carmarthenshire',
                'Carmarthenshire',
                'Unavailable',
                'Llangennech Solar',
                'Unknown',
                'Voltalia UK',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Breach solar farm',
                'Unknown',
                'Burwell 11 Solar Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wychavon',
                'Worcestershire',
                'West Midlands',
                'Doverdale solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'Central Bedfordshire',
                'Central Bedfordshire',
                'East of England',
                'Chalgrave Manor solar farm',
                'Unknown',
                'Aton Energy',
              ],
              [
                'United Kingdom',
                53,
                'Europe',
                'Stratford-on-Avon',
                'Warwickshire',
                'West Midlands',
                'Drayton Manor solar farm',
                'Anesco',
                'Unknown',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Kent',
                'Kent',
                'South East England',
                'Herne Bay solar farm',
                'Unknown',
                'Vattenfall',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Basildon',
                'Essex',
                'East of England',
                'Herongate Solar PV Farm',
                'Unknown',
                'Private Developer',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Gloucestershire',
                'Gloucestershire',
                'South West England',
                'High Green solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Carlisle',
                'Cumbria',
                'North West England',
                'High Parkfoot solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Dorset',
                'Dorset',
                'South West England',
                'Higher Stockbridge Solar Park',
                'Unknown',
                'Voltalia UK',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Hertsmere',
                'Hertfordshire',
                'East of England',
                'Hilfield solar farm',
                'Unknown',
                'Elstree Green Ltd.',
              ],
              [
                'United Kingdom',
                42,
                'Europe',
                'Chelmsford',
                'Essex',
                'East of England',
                'Hill Farm Solar Park',
                'Unknown',
                'Cell Energy Ltd.',
              ],
              [
                'United Kingdom',
                29,
                'Europe',
                'Gloucestershire',
                'Gloucestershire',
                'South West England',
                'Hillhouse solar farm',
                'ib vogt',
                'Renewable Power; EnvironGauge; Vogt Solar',
              ],
              [
                'United Kingdom',
                29,
                'Europe',
                'Cornwall',
                'Cornwall',
                'South West England',
                'Hornacott Solar Park',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'County Durham',
                'County Durham',
                'North East England',
                'Hulam solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                'East Riding of Yorkshire',
                'East Riding of Yorkshire',
                'Yorkshire and the Humber',
                'Hull solar farm',
                'Gridserve',
                'Gridserve',
              ],
              [
                'United Kingdom',
                26,
                'Europe',
                'West Suffolk',
                'Suffolk',
                'East of England',
                'Ingham solar farm',
                'Unknown',
                'Gamma Solar Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Down Barn solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Newark and Sherwood',
                'Nottinghamshire',
                'East Midlands',
                'Inkersall Grange solar farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Borough of Melton',
                'Leicestershire',
                'East Midlands',
                'Jericho Covert solar farm',
                'Unknown',
                'Green Farm Solar Ltd.',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'County Londonderry',
                'County Londonderry',
                'Unavailable',
                'Kells solar farm',
                'Unknown',
                'Elgin Energy EsCo Ltd.',
              ],
              [
                'United Kingdom',
                37,
                'Europe',
                'West Oxfordshire',
                'Oxfordshire',
                'South East England',
                'Kencot Hill solar farm',
                'Conergy',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                150,
                'Europe',
                'Scunthorpe',
                'North Lincolnshire',
                'North Lincolnshire',
                'Little Crow Solar',
                'Unknown',
                'INRG Solar Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'North Devon',
                'Devon',
                'South West England',
                'Litchardon Cross solar farm',
                'Unknown',
                'Aura Power',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Leigh Delamere solar farm',
                'Unknown',
                'Eden Renewables',
              ],
              [
                'United Kingdom',
                49,
                'Europe',
                'Essex',
                'Essex',
                'East of England',
                'Layer solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'South Gloucestershire',
                'South Gloucestershire',
                'South West England',
                'Larks Green solar farm',
                'Unknown',
                'Enso Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Mid Devon',
                'Devon',
                'South West England',
                'Langford solar farm',
                'Unknown',
                'JBM Solar',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Lichfield',
                'Staffordshire',
                'West Midlands',
                'Haunton Manor solar farm',
                'Unknown',
                'Haunton Farmers Solar Limited',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'Essex',
                'Essex',
                'East of England',
                'Langenhoe solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Sedgemoor',
                'Somerset',
                'South West England',
                'Land To The South West Of Horsey Lane solar farm',
                'Solar Power South',
                'Unknown',
              ],
              [
                'United Kingdom',
                28,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Land North Of Dales Manor Business Park solar farm',
                'Unknown',
                'Sawston Solar Farm Ltd.',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'West Suffolk',
                'Suffolk',
                'East of England',
                'Lackford Estate Solar Park',
                'Low Carbon',
                'Lackford Estate Solar Park Ltd.',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'North East Lincolnshire',
                'North East Lincolnshire',
                'Yorkshire and the Humber',
                'Laceby solar farm',
                'Conergy',
                'Unknown',
              ],
              [
                'United Kingdom',
                24,
                'Europe',
                'Unavailable',
                'Conwy',
                'Kinmel Bay',
                'Kinmel Solar',
                'Unknown',
                'Haymaker Energy',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Dumfries and Galloway',
                'Dumfries and Galloway',
                'Unavailable',
                'Kilgallioch Windfarm Solar Extension',
                'Unknown',
                'ScottishPower Renewables',
              ],
              [
                'United Kingdom',
                46,
                'Europe',
                'Vale of White Horse',
                'Oxfordshire',
                'South East England',
                'Landmead solar farm',
                'Unknown',
                'Foresight Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Hatherden solar farm',
                'Unknown',
                'Intelligent Alternatives',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Lisburn',
                'County Antrim',
                'Unavailable',
                'Hillside solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                35,
                'Europe',
                'Hinckley and Bosworth',
                'Leicestershire',
                'East Midlands',
                'Hangmans Hall solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                28,
                'Europe',
                'Boston',
                'Lincolnshire',
                'East Midlands',
                'Friths solar farm',
                'Unknown',
                'Friths Solar Limited',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'Buckinghamshire',
                'Buckinghamshire',
                'South East England',
                'Fox Covert solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'County Antrim',
                'County Antrim',
                'Unavailable',
                'Former Maghaberry Airfield Solar Farm',
                'Unknown',
                'Lightsource BP',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'Warwickshire',
                'Warwickshire',
                'West Midlands',
                'Harborough Fields solar farm',
                'Unknown',
                'Warwickshire Solar 1',
              ],
              [
                'United Kingdom',
                21,
                'Europe',
                'North Northamptonshire',
                'North Northamptonshire',
                'East Midlands',
                'Gaultney Solar Park',
                'Unknown',
                'United Photovoltaics',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Forest Gate solar farm',
                'Unknown',
                'Eden Renewables',
              ],
              [
                'United Kingdom',
                34,
                'Europe',
                'Unavailable',
                'Central Bedfordshire',
                'Unavailable',
                'Glebe solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Wiltshire',
                'Wiltshire',
                'South West England',
                'Five Lanes Solar Project',
                'Unknown',
                'Five Lanes Solar Ltd.',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'West Lindsey',
                'Lincolnshire',
                'East Midlands',
                'Fiskerton West solar farm',
                'Unknown',
                'Grey Street Solar Ltd.',
              ],
              [
                'United Kingdom',
                22,
                'Europe',
                'West Lindsey',
                'Lincolnshire',
                'East Midlands',
                'Fiskerton Airfield solar farm',
                'Unknown',
                'Lark Energy',
              ],
              [
                'United Kingdom',
                31,
                'Europe',
                'Pembrokeshire',
                'Pembrokeshire',
                'Unavailable',
                'Fenton Home solar farm',
                'Unknown',
                'Sunsave',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Cambridge',
                'Unavailable',
                'Cambridgeshire and Peterborough',
                'Fenland Farm Solar',
                'AGR',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Stratford-on-Avon',
                'Warwickshire',
                'West Midlands',
                'Feldon Vale solar farm',
                'Unknown',
                'Low Carbon',
              ],
              [
                'United Kingdom',
                30,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Exning Solar',
                'Unknown',
                'Vortex (formerly Sun Edison)',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Lincolnshire',
                'Lincolnshire',
                'East Midlands',
                'Ewerby Thorpe solar farm',
                'Unknown',
                'Estover Energy',
              ],
              [
                'United Kingdom',
                50,
                'Europe',
                'Test Valley',
                'Hampshire',
                'South East England',
                'Eveley Farm Solar',
                'PS Renewables',
                'Greencoat Solar',
              ],
              [
                'United Kingdom',
                27,
                'Europe',
                'Kent',
                'Kent',
                'South East England',
                'Guston Court solar farm',
                'Unknown',
                'Guston Solar Farm Ltd.',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'East Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Goosehall solar farm',
                'Unknown',
                'Lightsource Renewable Energy',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'North Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Gorse Lane solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                38,
                'Europe',
                'South Cambridgeshire',
                'Cambridgeshire',
                'East of England',
                'Great Wilbraham solar farm',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'Unavailable',
                'Cambridgeshire',
                'Cambridgeshire and Peterborough',
                'Green End Solar',
                'Unknown',
                'NextEnergy Solar Fund',
              ],
              [
                'United Kingdom',
                62,
                'Europe',
                'St Asaph',
                'Denbighshire',
                'Unavailable',
                'Elwy solar farm',
                'Unknown',
                'Solarcentury Ltd.',
              ],
              [
                'United Kingdom',
                42,
                'Europe',
                'Bramford',
                'south of Tye Lane',
                'Unavailable',
                'Greybarn solar farm',
                'Unknown',
                'Statkraft',
              ],
              [
                'United Kingdom',
                20,
                'Europe',
                'Central Bedfordshire',
                'Central Bedfordshire',
                'East of England',
                'Grounds Farm Solar Park',
                'Unknown',
                'Chiltern Renewables',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Angus',
                'Angus',
                'Unavailable',
                'East Ballochy solar farm',
                'Unknown',
                'ScottishPower Renewables; Stracathro Estates',
              ],
              [
                'United Kingdom',
                32,
                'Europe',
                'North Kesteven',
                'Lincolnshire',
                'East Midlands',
                'Ermine Street Farm Solar Park',
                'Unknown',
                'Octopus Investments',
              ],
              [
                'United Kingdom',
                36,
                'Europe',
                'West Oxfordshire',
                'Oxfordshire',
                'South East England',
                'Ducklington solar farm',
                'Unknown',
                'Corylus Planning and Environmental Ltd.',
              ],
              [
                'United Kingdom',
                25,
                'Europe',
                'East Suffolk',
                'Suffolk',
                'East of England',
                'Hacheston solar farm',
                'Unknown',
                'Hive Energy',
              ],
              [
                'United Kingdom',
                40,
                'Europe',
                'Buckinghamshire',
                'Buckinghamshire',
                'South East England',
                'Hale solar farm',
                'Unknown',
                'Elgin Energy',
              ],
              [
                'United Kingdom',
                34,
                'Europe',
                'Breckland District',
                'Norfolk',
                'East of England',
                'Hall Solar Farm And Field Barn solar farm',
                'Unknown',
                'Rethink Energy Ltd.',
              ],
              [
                'United Kingdom',
                23,
                'Europe',
                'New Forest',
                'Hampshire',
                'South East England',
                'Hamer Warren solar farm',
                'Unknown',
                'Somerley Estate',
              ],
              [
                'United States',
                20,
                'North America',
                'Decatur County',
                'Decatur County',
                'Unavailable',
                'Decatur County Solar Project',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                74,
                'North America',
                'Volusia County',
                'Volusia County',
                'Unavailable',
                'Debary Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Decatur County',
                'Decatur County',
                'Unavailable',
                'Decatur Parkway Solar Project',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                25,
                'North America',
                'Unavailable',
                'Shawangunk County',
                'Unavailable',
                'Daybreak Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                70,
                'North America',
                'Society Hill',
                'Darlington County',
                'Unavailable',
                'Culpepper Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Selma County',
                'Unavailable',
                'Dallas Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                58,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Cove Mountain Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                122,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Cove Mountain Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                191,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Cottontail Solar',
                'Unknown',
                'Lightsource bp',
              ],
              [
                'United States',
                300,
                'North America',
                'Bogota',
                'Red River County',
                'Unavailable',
                'Delilah Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                140,
                'North America',
                'Lewis',
                'Montezuma County',
                'Unavailable',
                'Coyote Gulch Solar',
                'Juwi Inc',
                'Juwi Inc',
              ],
              [
                'United States',
                175,
                'North America',
                'Garrett County',
                'Garrett County',
                'Unavailable',
                'CPV Backbone Solar',
                'Unknown',
                'Competitive Power Ventures',
              ],
              [
                'United States',
                100,
                'North America',
                'Portage',
                'Cambria County',
                'Unavailable',
                'CPV Maple Hill Solar',
                'Unknown',
                'Competitive Power Ventures',
              ],
              [
                'United States',
                150,
                'North America',
                'Crane County',
                'Crane County',
                'Unavailable',
                'Crane Solar',
                'Consolidated Edison Development Inc.',
                'Starwood Energy Group',
              ],
              [
                'United States',
                75,
                'North America',
                'Jefferson',
                'Jefferson County',
                'Unavailable',
                'Crawfish River solar farm',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                149,
                'North America',
                'Crescent Valley',
                'Lander County',
                'Unavailable',
                'Crescent Valley Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                200,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Crimson Solar Project',
                'Recurrent Energy',
                'Axium Infrastucture [80%]; Recurrent Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Crimson Solar Project',
                'Recurrent Energy',
                'Axium Infrastucture [80%]; Recurrent Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'Pender County',
                'Pender County',
                'Unavailable',
                'Crooked Run solar farm',
                'Cypress Creek Renewables',
                'Cubico USA',
              ],
              [
                'United States',
                50,
                'North America',
                'Lurgan',
                'Franklin County',
                'Unavailable',
                'Crossroads (North Carolina) solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                68,
                'North America',
                'Elko',
                'Barnwell County',
                'Unavailable',
                'Crossroads (Pennsylvania) solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Cumberland County',
                'Unavailable',
                'Cumberland Co Solar',
                'Unknown',
                'NTE Carolina Solar',
              ],
              [
                'United States',
                40,
                'North America',
                'Santa Barbara County',
                'Santa Barbara County',
                'Unavailable',
                'Cuyama Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                182,
                'North America',
                'Daggett',
                'San Bernardino County',
                'Unavailable',
                'Daggett solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Daggett',
                'San Bernardino County',
                'Unavailable',
                'Daggett solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Darien',
                'Rock County',
                'Unavailable',
                'Darien Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                310,
                'North America',
                'Bogota',
                'Red River County',
                'Unavailable',
                'Delilah Solar Energy II',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                30,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                28,
                'North America',
                'Lapeer County',
                'Lapeer County',
                'Unavailable',
                'Demille solar farm',
                'DTE Electric Company',
                'DTE Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Escambia County',
                'Unavailable',
                'Cotton Creek Solar',
                'Gulf Power',
                'Gulf Power',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Oconee County',
                'Unavailable',
                'Dials Mills solar farm',
                'Unknown',
                'Rural Green Power',
              ],
              [
                'United States',
                25,
                'North America',
                'DeSoto County',
                'DeSoto County',
                'Unavailable',
                'Desoto Next Generation Solar Energy',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                165,
                'North America',
                'DeSoto',
                'Lee County',
                'Unavailable',
                'Desoto I solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                25,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                25,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                29,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                29,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                23,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                26,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                39,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                39,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                23,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                25,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                25,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                30,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                40,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                40,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                40,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Sunlight solar farm',
                'NextEra Energy',
                'Clearway [25.0%]; Harbert Power Fund V [24.9%]; NextEra Energy Partners LP [49.9%]; Other [0.2%]',
              ],
              [
                'United States',
                480,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Desert Quartzite solar farm',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                70,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Harvest solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Desert Harvest solar farm',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'DePue',
                'Bureau County',
                'Unavailable',
                'Depue Holdings solar farm',
                'Ameresco',
                'Ameresco',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Greenwood County',
                'Unavailable',
                "Delta's Edge Solar",
                'Unknown',
                'Cubico USA',
              ],
              [
                'United States',
                20,
                'North America',
                'Cottage Grove',
                'Dane County',
                'Unavailable',
                'Cottage Grove Solar',
                'SunVest',
                'SunVest',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'CID Solar',
                'Dominion Energy',
                'Dominion Energy [67.0%]; SunEdison LLC [33.0%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Coronal Lost Hills solar farm',
                'Coronal Group',
                'Coronal Energy; Panasonic Corp',
              ],
              [
                'United States',
                52,
                'North America',
                'Orange County',
                'Orange County',
                'Unavailable',
                'Citrus Ridge Solar',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'DeSoto County',
                'DeSoto County',
                'Unavailable',
                'Citrus Solar Energy Center Hybrid',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Bloom Township',
                'Clearfield County',
                'Unavailable',
                'CL-Viaduct solar farm',
                'BCD Project Holdings 1, LLC',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Claremont',
                'Sullivan County',
                'Unavailable',
                'Claremont Solar',
                'Freepoint',
                'Energy Resources Group',
              ],
              [
                'United States',
                71,
                'North America',
                'Unavailable',
                'Elmore County',
                'Unavailable',
                'Clark Solar',
                'Unknown',
                'Sunenergy; Intermountain Energy Partners',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Elmore County',
                'Unavailable',
                'Clark Solar',
                'Unknown',
                'Sunenergy; Intermountain Energy Partners',
              ],
              [
                'United States',
                30,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Citizens Imperial Solar',
                'DEPCOM Power',
                'Citizens Solar Holdings',
              ],
              [
                'United States',
                106,
                'North America',
                'Fort Gaines',
                'Clay County',
                'Unavailable',
                'Clay (Silicon Ranch Corporation) solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                55,
                'North America',
                'Waterflow',
                'San Juan County',
                'Unavailable',
                'Clean Path Energy Center solar farm',
                'Western Energy Partners',
                'Western Energy Partners',
              ],
              [
                'United States',
                144,
                'North America',
                'Columbus',
                'Champaign County',
                'Adams',
                'Clearview Solar',
                'Unknown',
                'Open Road Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Mona',
                'Juab County',
                'Unavailable',
                'Clover Creek Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                48,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'CM48 solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                480,
                'North America',
                'Flagstaff',
                'Coconino County',
                'Unavailable',
                'Co Bar solar farm',
                'Clenera',
                'Clenera',
              ],
              [
                'United States',
                44,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Coffeen solar farm',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Clay',
                'Onondaga County',
                'Unavailable',
                'Clay (Suneast) Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Storey County',
                'Unavailable',
                'Citadel solar farm',
                'Unknown',
                'Capital Dynamics',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Storey County',
                'Unavailable',
                'Citadel solar farm',
                'Unknown',
                'Capital Dynamics',
              ],
              [
                'United States',
                31,
                'North America',
                'Colfax County',
                'Colfax County',
                'Unavailable',
                'Cimarron Solar Facility',
                'First Solar',
                'Southern Company; Turner Renewable Energy',
              ],
              [
                'United States',
                240,
                'North America',
                'Casper',
                'Natrona County',
                'Unavailable',
                'Dinosolar',
                'Unknown',
                'Enyo Renewable Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Wauchula',
                'Hardee County',
                'Unavailable',
                'Charlie Creek Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Walton County',
                'Walton County',
                'Unavailable',
                'Chautauqua Solar',
                'Unknown',
                'Gulf Power',
              ],
              [
                'United States',
                70,
                'North America',
                'Roswell',
                'Chaves County',
                'Unavailable',
                'Chaves Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Northampton County',
                'Northampton County',
                'Unavailable',
                'Cherrydale solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                118,
                'North America',
                'Unavailable',
                'Berkeley County',
                'Unavailable',
                'Chesapeake solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Aiken County',
                'Unavailable',
                'Chester White solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Halifax County',
                'Halifax County',
                'Unavailable',
                'Chestnut Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Chicot County',
                'Chicot County',
                'Unavailable',
                'Chicot Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Fitzwilliam',
                'Cheshire County',
                'Unavailable',
                'Chinook Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Unavailable',
                'Pickaway County',
                'Unavailable',
                'Chipmunk Solar',
                'Unknown',
                'EDF Renewables; Geenex',
              ],
              [
                'United States',
                50,
                'North America',
                'Chocolate Mountains',
                'Imperial County',
                'Unavailable',
                'Chocolate Mountains solar farm',
                'Unknown',
                '8minute Solar; Gestamp Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'North las Vegas',
                'Clark County',
                'Unavailable',
                'Chuckwalla Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Estancia',
                'Torrance County',
                'Unavailable',
                'Cibola Greenworks solar farm',
                'Unknown',
                'Silverado Power',
              ],
              [
                'United States',
                500,
                'North America',
                'Elba',
                'Genesee County',
                'Unavailable',
                'Cider Solar',
                'Hecate Energy',
                'Hecate Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Alamosa County',
                'Alamosa County',
                'Unavailable',
                'Cogentrix Of Alamosa solar farm',
                'KEPCO',
                'KEPCO',
              ],
              [
                'United States',
                75,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Colgreen North Shore solar farm',
                'Sunpin Holdings, LLC',
                'Sunpin Holdings',
              ],
              [
                'United States',
                75,
                'North America',
                'Smoaks',
                'Colleton County',
                'Unavailable',
                'Colleton Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                142,
                'North America',
                'Surry County',
                'Surry County',
                'Unavailable',
                'Colonial Trail West solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                25,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                24,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                52,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 4',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                42,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 4',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                252,
                'North America',
                'Boulder City',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 5',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                700,
                'North America',
                'Pahrump Valley',
                'Nye County',
                'Unavailable',
                'Copper Rays Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Putnam County',
                'Putnam County',
                'Unavailable',
                'Coral Farms Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Rachito Las Lomas',
                'Webb County',
                'Unavailable',
                'Corazon Energy solar farm',
                'Unknown',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Corcoran Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Corcoran Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Halifax County',
                'Halifax County',
                'Unavailable',
                'Cork Oak Solar',
                'Bay Wa.r.e',
                'PSEG Solar Source',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'New Kent County',
                'New Kent County',
                'Unavailable',
                'Correctional Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                27,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                75,
                'North America',
                'Columbia County',
                'Columbia County',
                'Unavailable',
                'Columbia (Duke Energy) Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                350,
                'North America',
                'Unavailable',
                'Herkimer County',
                'Columbia',
                'Columbia (EDF Renewables) solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                60,
                'North America',
                'Craryville',
                'Columbia County',
                'Unavailable',
                'Columbia County (Hecate Energy) solar farm',
                'Hecate Energy',
                'Hecate Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Franklin County',
                'Unavailable',
                'Columbus Park (BQ Energy Development) solar farm',
                'BQ Energy',
                'BQ Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Pueblo',
                'Pueblo County',
                'Unavailable',
                'Comanche Solar',
                'Onward Energy',
                'Novatus Energy',
              ],
              [
                'United States',
                160,
                'North America',
                'San Angelo',
                'Tom Green County',
                'Unavailable',
                'Concho Valley Solar',
                'Unknown',
                'Merit SI; Komipo America, Inc.',
              ],
              [
                'United States',
                80,
                'North America',
                'Edgecombe County',
                'Edgecombe County',
                'Unavailable',
                'Conetoe II Solar',
                'Conetoe II Solar, LLC',
                'Duke Energy',
              ],
              [
                'United States',
                124,
                'North America',
                '956 County Road 3745',
                'Fannin County',
                'Unavailable',
                'Coniglio Solar',
                'Q Cells',
                'Q Cells',
              ],
              [
                'United States',
                213,
                'North America',
                'Bainbridge',
                'Decatur County',
                'Unavailable',
                'Cool Springs Solar',
                'Unknown',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'Copper Crossing solar farm',
                'Axium',
                'Avangrid Renewables LLC [50.0%]; Axium US Solar Holdings LLC [50.0%]',
              ],
              [
                'United States',
                30,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 2',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                30,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 2',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                34,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 2',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                30,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 2',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                30,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 2',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                21,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Copper Mountain Solar 3',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                74,
                'North America',
                'Titusville',
                'Brevard County',
                'Unavailable',
                'Discovery Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                71,
                'North America',
                'Prineville',
                'Crook County',
                'Unavailable',
                'Millican Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                117,
                'North America',
                'Unavailable',
                'Highland County',
                'Unavailable',
                'Dodson Creek solar farm',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Prince George County',
                'Unavailable',
                'Fort Powhatan solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Liberty County',
                'Liberty County',
                'Unavailable',
                'Fort Stewart Solar Facility',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                63,
                'North America',
                'Kemmerer',
                'Lincoln County',
                'Unavailable',
                'Fossil Solar',
                'Unknown',
                'Strata Solar',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Greensville County',
                'Unavailable',
                'Fountain Creek Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Unavailable',
                'Farmington County',
                'Unavailable',
                'Four Corners Solar',
                'Unknown',
                'Photosol US',
              ],
              [
                'United States',
                50,
                'North America',
                'Franklin County',
                'Franklin County',
                'Unavailable',
                'Fox Creek Solar',
                'John Laing US Solar Corp.',
                'Unknown',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Fort Mojave Reservation County',
                'Unavailable',
                'Fort Mojave solar farm',
                'Unknown',
                'First Solar',
              ],
              [
                'United States',
                577,
                'North America',
                'Madison County',
                'Madison County',
                'Unavailable',
                'Fox Squirrel Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                75,
                'North America',
                'Laurinburg',
                'Scotland County',
                'Unavailable',
                'Friesian Holdings solar farm',
                'Birch Creek Development',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Stanislaus County',
                'Stanislaus County',
                'Unavailable',
                'Frontier Solar',
                'Unknown',
                'Boralex',
              ],
              [
                'United States',
                20,
                'North America',
                'New London County',
                'New London County',
                'Unavailable',
                'Fusion Solar Center',
                'DEPCOM Power',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                400,
                'North America',
                'Unavailable',
                'Gadsen County',
                'Unavailable',
                'Gadsden Co Solar',
                'Hensel Phelps',
                'National Solar Power',
              ],
              [
                'United States',
                46,
                'North America',
                'Unavailable',
                'Horry County',
                'Unavailable',
                'Gallivant Ferry Solar',
                'Unknown',
                'Southern Current',
              ],
              [
                'United States',
                46,
                'North America',
                'Unavailable',
                'Horry County',
                'Unavailable',
                'Gallivant Ferry Solar',
                'Unknown',
                'Southern Current',
              ],
              [
                'United States',
                20,
                'North America',
                'Franklin',
                'Franklin County',
                'Unavailable',
                'Franklin solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Fort Irwin County',
                'Unavailable',
                'Fort Irwin solar farm',
                'Unknown',
                'Clark Energy Group; Acciona',
              ],
              [
                'United States',
                75,
                'North America',
                'Bowling Green',
                'Hardee County',
                'Unavailable',
                'Fort Green Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Augusta',
                'Richmond County',
                'Unavailable',
                'Fort Gordon Solar Facility',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                350,
                'North America',
                'Needville',
                'Fort Bend County',
                'Unavailable',
                'Fighting Jays Solar Project',
                'Miller Bros',
                'Copenhagen Infrastructure Partners',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Pittsylvania County',
                'Unavailable',
                'Firefly Energy Solar Project',
                'Unknown',
                'Recurrent Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Reno',
                'Washoe County',
                'Unavailable',
                'Fish Springs Ranch solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Warren County',
                'Warren County',
                'Unavailable',
                'Five Forks Solar',
                'Bay Wa.r.e',
                'PSEG Solar Source',
              ],
              [
                'United States',
                60,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Five Points Solar Park',
                'Clenera',
                'Clenera',
              ],
              [
                'United States',
                20,
                'North America',
                'Tallahassee',
                'Leon County',
                'Unavailable',
                'FL Solar 1',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                42,
                'North America',
                'Wakulla County',
                'Wakulla County',
                'Unavailable',
                'Fl Solar 4',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Little Falls',
                'Herkimer County',
                'Unavailable',
                'Flat Hill Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                100,
                'North America',
                'Greene County',
                'Greene County',
                'Unavailable',
                'Flint Mine solar farm',
                'Unknown',
                'Hudson Energy Development; Amber Infrastructure',
              ],
              [
                'United States',
                200,
                'North America',
                'Athens',
                'Henderson County',
                'Unavailable',
                'Forest Grove - Dodd solar farm',
                'Renewable Energy Ventures LLC',
                'Vistra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Athens',
                'Henderson County',
                'Unavailable',
                'Forest Grove - Dodd solar farm',
                'Renewable Energy Ventures LLC',
                'Vistra Energy',
              ],
              [
                'United States',
                240,
                'North America',
                'East Bernard',
                'Fort Bend County',
                'Unavailable',
                'Fort Bend Solar',
                'Acciona Energy USA Global, LLC',
                'Acciona Energy USA Global',
              ],
              [
                'United States',
                30,
                'North America',
                'Chattahoochee County',
                'Chattahoochee County',
                'Unavailable',
                'Fort Benning Solar Facility',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'El Paso County',
                'Unavailable',
                'Fort Bliss Solar',
                'Unknown',
                'El Paso Electric',
              ],
              [
                'United States',
                74,
                'North America',
                'Vero Beach',
                'Okeechobee County',
                'Unavailable',
                'Fort Drum Energy Center solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                46,
                'North America',
                'Unavailable',
                'Horry County',
                'Unavailable',
                'Gallivant Ferry Solar',
                'Unknown',
                'Southern Current',
              ],
              [
                'United States',
                250,
                'North America',
                'Paint Rock',
                'Concho County',
                'Unavailable',
                'Galloway 1 solar farm',
                'Unknown',
                'Skyline Renewables',
              ],
              [
                'United States',
                110,
                'North America',
                'Paint Rock',
                'Concho County',
                'Unavailable',
                'Galloway 2 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                30,
                'North America',
                'Ashland',
                'Aroostook County',
                'Unavailable',
                'Garfield Plantation solar farm',
                'Unknown',
                'North Light Energy; D.E Shaw Renewables',
              ],
              [
                'United States',
                1500,
                'North America',
                'Tonopah',
                'Esmeralda County',
                'Unavailable',
                'Gold Dust Solar',
                'Arevia Power',
                'Arevia Power',
              ],
              [
                'United States',
                21,
                'North America',
                'Cranston',
                'Providence County',
                'Unavailable',
                'Gold Meadow solar farm',
                'Unknown',
                'Southern Sky Renewable Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Brazoria',
                'Brazoria County',
                'Unavailable',
                'Golden Buckle Solar',
                'Unknown',
                'Savion Energy',
              ],
              [
                'United States',
                54,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Golden Field Solar',
                'Unknown',
                'New Energy Turlock',
              ],
              [
                'United States',
                192,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Golden Field Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Chilton',
                'Falls County',
                'Unavailable',
                'Golinda Solar',
                'OCI Solar Power',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'LaSalle County',
                'LaSalle County',
                'Unavailable',
                'Grand Ridge solar farm',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                60,
                'North America',
                'Owyhee County',
                'Owyhee County',
                'Unavailable',
                'Grand View Solar Two',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                20,
                'North America',
                'Owyhee County',
                'Owyhee County',
                'Unavailable',
                'Grand View Solar Two',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Polk County',
                'Unavailable',
                'Grandview Wellfield Solar',
                'Unknown',
                'Muscaline Power and Water',
              ],
              [
                'United States',
                20,
                'North America',
                'Currituck County',
                'Currituck County',
                'Unavailable',
                'Grandy solar farm',
                'Ecoplexus',
                'Ecoplexus',
              ],
              [
                'United States',
                61,
                'North America',
                'Hillsborough County',
                'Hillsborough County',
                'Unavailable',
                'Grange Hall Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                80,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Granite Mountain Solar',
                'Dominion Energy; SunEdison',
                'Clearway Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Granite Mountain Solar',
                'Dominion Energy; SunEdison',
                'Clearway Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Unavailable',
                'Refugio County',
                'Unavailable',
                'Charger Solar',
                'Unknown',
                'J-Power USA; AP Solar Holdings',
              ],
              [
                'United States',
                55,
                'North America',
                'Unavailable',
                'Metcalfe County',
                'Unavailable',
                'Glover Creek solar farm',
                'Unknown',
                'Carolina Solar Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Huron',
                'Fresno County',
                'Unavailable',
                'Fifth Standard Solar',
                'RWE Renewables Americas LLC',
                'Unknown',
              ],
              [
                'United States',
                32,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Gila Bend Hybrid solar farm',
                'Arizona Public Service',
                'Arizona Public Service',
              ],
              [
                'United States',
                280,
                'North America',
                'Unavailable',
                'Gibson County',
                'Unavailable',
                'Gibson solar farm',
                'Unknown',
                'Capital Dynamics; Tenaska',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Garland solar farm',
                'Southern Power Co',
                'Southern Power [51%]; Recurrent Energy [49%]',
              ],
              [
                'United States',
                185,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Garland solar farm',
                'Southern Power Co',
                'Southern Power [51%]; Recurrent Energy [49%]',
              ],
              [
                'United States',
                200,
                'North America',
                'Conquest',
                'Cayuga County',
                'Unavailable',
                'Garnet Energy Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Gaskell West 1 Solar Facility',
                'First Solar',
                'Southern Power',
              ],
              [
                'United States',
                45,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Gaskell West 2 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Gaskell West 3 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Gaskell West 4 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Gaskell West 5 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                25,
                'North America',
                'Gaston County',
                'Gaston County',
                'Unavailable',
                'Gaston Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Kings County',
                'Unavailable',
                'Gates Solar Station',
                'Pacific Gas & Electric Co.',
                'Pacific Gas & Electric Co.',
              ],
              [
                'United States',
                60,
                'North America',
                'North Hartsville',
                'Darlington County',
                'Unavailable',
                'GEB Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Coeymans',
                'Albany County',
                'Unavailable',
                'Gedney Hill solar farm',
                'Hecate Energy',
                'Hecate Energy',
              ],
              [
                'United States',
                690,
                'North America',
                'Unincorporated',
                'Clark County',
                'Unavailable',
                'Gemini Solar',
                'Valley of Fire',
                'Arevia Power; Quinbrook Infrastructure Partners',
              ],
              [
                'United States',
                350,
                'North America',
                'Sardiana',
                'Erie County',
                'Unavailable',
                'Genesee Road solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Midlothian',
                'Ellis County',
                'Unavailable',
                'Gerdau solar farm',
                '174 Power Global',
                '174 Power Global [50%]; TotalEnergies [50%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Giffen Solar Park',
                'Clenera',
                'Clenera',
              ],
              [
                'United States',
                200,
                'North America',
                'Reno',
                'Washoe County',
                'Unavailable',
                'Dodge Flat solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Edgecombe County',
                'Edgecombe County',
                'Unavailable',
                'Fern Solar',
                'Bay Wa.r.e',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                48,
                'North America',
                'Unavailable',
                'Perry County',
                'Unavailable',
                'Fayette Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                60,
                'North America',
                'Mulberry',
                'Polk County',
                'Unavailable',
                'Durrance solar farm',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                37,
                'North America',
                'Middlesex County',
                'Middlesex County',
                'Unavailable',
                'Dww Solar Ll',
                'Deepwater Wind',
                'Deepwater Wind',
              ],
              [
                'United States',
                300,
                'North America',
                'Moapa River Indian Re',
                'Clark County',
                'Unavailable',
                'Eagle Shadow Mountain solar farm',
                '8minute Solar',
                '8minute Solar; Captial Dynamics',
              ],
              [
                'United States',
                144,
                'North America',
                'Manor',
                'Travis County',
                'Unavailable',
                'East Blackland Solar Project 1',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'East Line Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Spring Hope',
                'Nash County',
                'Unavailable',
                'East Nash Solar',
                'Ecoplexus',
                'Fresh Air Energy XXIII',
              ],
              [
                'United States',
                435,
                'North America',
                'Jasper County',
                'Jasper County',
                'Unavailable',
                'Dunns Bridge solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                23,
                'North America',
                'Spring Hope',
                'Nash County',
                'Unavailable',
                'East Nash Solar',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                118,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'East Pecos Solar',
                'First Solar',
                'Southern Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Sharon County',
                'Unavailable',
                'East Point Energy solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Accomack County',
                'Accomack County',
                'Unavailable',
                'Eastern Shore Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Suwannee County',
                'Suwannee County',
                'Unavailable',
                'Echo River Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                48,
                'North America',
                'Richmond County',
                'Richmond County',
                'Unavailable',
                'Eden Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Orange County',
                'Wawayanda',
                'Edora C solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                26,
                'North America',
                'Spring Hope',
                'Nash County',
                'Unavailable',
                'East Nash Solar',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                265,
                'North America',
                'Jasper County',
                'Jasper County',
                'Unavailable',
                'Dunns Bridge solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Loudoun County',
                'Loudoun County',
                'Unavailable',
                'Dulles solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Parrish',
                'Manatee County',
                'Unavailable',
                'Duette Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Ledyard',
                'Cayuga County',
                'Unavailable',
                'Dog Corners Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                20,
                'North America',
                'Halifax County',
                'Halifax County',
                'Unavailable',
                'Dogwood Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Washington County',
                'Unavailable',
                'Dolan Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                110,
                'North America',
                'Cahone',
                'Montezuma County',
                'Unavailable',
                'Dolores Canyon Solar',
                'Juwi Inc',
                'Juwi Inc',
              ],
              [
                'United States',
                117,
                'North America',
                'Unavailable',
                'Highland County',
                'Unavailable',
                'Donson Creek Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Houston County',
                'Unavailable',
                'Dothan Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                593,
                'North America',
                'Unavailable',
                'Sangamon County',
                'Unavailable',
                'Double Black Diamond Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Dougherty County',
                'Dougherty County',
                'Unavailable',
                'Dougherty County Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                99,
                'North America',
                'Herrick',
                'Fayette County',
                'Unavailable',
                'Dressor Plains Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Calexico',
                'Imperial County',
                'Unavailable',
                'Drew Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Navajo County',
                'Navajo County',
                'Unavailable',
                'Dry Lake (Avangrid Renewables) solar farm',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Moapa',
                'Clark County',
                'Unavailable',
                'Dry Lake (Invenergy) Solar Energy Center',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Line County',
                'Unavailable',
                'Duane Arnold Solar',
                'Alliant Energy',
                'Alliant Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Line County',
                'Unavailable',
                'Duane Arnold Solar',
                'Alliant Energy',
                'Alliant Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Duck Creek solar farm',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                201,
                'North America',
                'Mendota',
                'Fresno County',
                'Unavailable',
                'EDPR CA Solar Park VI Hybrid solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                760,
                'North America',
                'Unavailable',
                'Kern County',
                'Unavailable',
                'Edwards Sanborn solar farm',
                'Terra-Gen',
                'Terra-Gen',
              ],
              [
                'United States',
                39,
                'North America',
                'Mililani',
                'Honolulu County',
                'Unavailable',
                'Mililani South solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                118,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Edwards Sanborn solar farm',
                'Terra-Gen',
                'Terra-Gen',
              ],
              [
                'United States',
                80,
                'North America',
                'Beaver County',
                'Beaver County',
                'Unavailable',
                'Enterprise (Milford) solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Millard County',
                'Beaver County',
                'Unavailable',
                'Enterprise (Milford) solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Enterprise (New Castle) solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Prewitt County',
                'Unavailable',
                'Escalante (Tri-State Generation) solar farm',
                'Unknown',
                'Tri-State Generation',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Esmeralda County',
                'Unavailable',
                'Esmeralda (NextEra) Solar Energy Center Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                650,
                'North America',
                'Unavailable',
                'Esmeralda County',
                'Unavailable',
                'Esmeralda (US Solar Assests) Solar Project',
                'US Solar Assets',
                'US Solar Assets',
              ],
              [
                'United States',
                20,
                'North America',
                'Essex County',
                'Essex County',
                'Unavailable',
                'Essex Solar Center',
                'Coronal Energy',
                'Coronal Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Estill',
                'Hampton County',
                'Unavailable',
                'Estill Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                280,
                'North America',
                'Unavailable',
                'Genesee County',
                'Unavailable',
                'Excelsior Energy solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Sullivan County',
                'Unavailable',
                'Fairbanks Solar',
                'Unknown',
                'Invenergy; Northern Indiana Public Service Co (NIPSCO)',
              ],
              [
                'United States',
                20,
                'North America',
                'Fairfield',
                'Somerset County',
                'Unavailable',
                'Fairfield Route 201 solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Harford County',
                'Unavailable',
                'Fairview Farms Solar',
                'Pro-Tech Energy Solutions',
                'Pro-Tech Energy Solutions',
              ],
              [
                'United States',
                20,
                'North America',
                'Ogdensburg',
                'St Lawrence County',
                'Unavailable',
                'Fairway Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Fall River County',
                'Unavailable',
                'Fall River Solar',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                77,
                'North America',
                'Farmington',
                'Franklin County',
                'Unavailable',
                'Farmington Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Beaver County',
                'Beaver County',
                'Unavailable',
                'Enterprise (Milford) solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                23,
                'North America',
                'Bladen County',
                'Bladen County',
                'Unavailable',
                'Fayetteville Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                55,
                'North America',
                'Sandoval County',
                'Sandoval County',
                'Unavailable',
                'Encino Solar Energy Center',
                'PNM',
                'PNM',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Eloy County',
                'Unavailable',
                'Eloy Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                24,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Edwards Sanborn solar farm',
                'Terra-Gen',
                'Terra-Gen',
              ],
              [
                'United States',
                74,
                'North America',
                'Baker County',
                'Baker County',
                'Unavailable',
                'Egret Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Lamar County',
                'Unavailable',
                'Eiffel Solar',
                'Unknown',
                'SoftBank Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Eland Solar & Storage Center',
                '8minute Solar',
                'Capital Dynamics',
              ],
              [
                'United States',
                200,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Eland Solar & Storage Center',
                '8minute Solar',
                'Capital Dynamics',
              ],
              [
                'United States',
                132,
                'North America',
                'Pearsall',
                'Frio County',
                'Unavailable',
                'Elara Solar',
                'Swinerton Renewables',
                'Korea Midland Power',
              ],
              [
                'United States',
                175,
                'North America',
                'Eldena',
                'Lee County',
                'Unavailable',
                'Eldena Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Grantsville',
                'Tooele County',
                'Unavailable',
                'Elektron Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                40,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Elevation Solar C',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                80,
                'North America',
                'Magnolia',
                'Rock County',
                'Unavailable',
                'Elk Creek Solar',
                'National Grid Renewables',
                'National Grid Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Charlestown',
                'Franklin County',
                'Unavailable',
                'Elk Hill Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Gibson County',
                'Unavailable',
                'Elliott solar farm',
                'Unknown',
                'Capital Dynamics; Northern Indiana Public Service Company',
              ],
              [
                'United States',
                135,
                'North America',
                'Bardwell',
                'Ellis County',
                'Unavailable',
                'Elm Branch Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                40,
                'North America',
                'Wilson County',
                'Wilson County',
                'Unavailable',
                'Elm City Solar Facility',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Elora',
                'Lincoln County',
                'Unavailable',
                'Elora Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                108,
                'North America',
                'Crane',
                'Pecos County',
                'Unavailable',
                'Emerald Grove solar farm',
                'Luminant Generation Company LLC',
                'Vistra Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Chaparral Springs solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Martinsburg',
                'Berkeley County',
                'Unavailable',
                'Bedington solar farm',
                'Unknown',
                'Torch Clean Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Calhoun County',
                'Unavailable',
                'Cereal City Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Hertford County',
                'Hertford County',
                'Unavailable',
                'Aulander Holloman Solar',
                'Unknown',
                'Fifth Third Bancorp',
              ],
              [
                'United States',
                253,
                'North America',
                'Los Angeles County',
                'Los Angeles County',
                'Unavailable',
                'Av Solar Ranch One solar farm',
                'First Solar',
                'Exelon Power',
              ],
              [
                'United States',
                29,
                'North America',
                'Pima County',
                'Pima County',
                'Unavailable',
                'Avalon (Coronal Group) solar farm',
                'Panasonic Eco Solutions',
                'Coronal Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Avalon (EDF Renewables) solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                25,
                'North America',
                'Pima County',
                'Pima County',
                'Unavailable',
                'Avra Valley Solar',
                'NRG Solar Avra Valley',
                'Clearway Energy',
              ],
              [
                'United States',
                145,
                'North America',
                'Unavailable',
                'Moffatt County',
                'Unavailable',
                'Axial Basin Solar',
                'Juwi Inc',
                'Juwi Inc',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'Atwell Island solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                25,
                'North America',
                'Stanislaus County',
                'Stanislaus County',
                'Unavailable',
                'Axium Modesto Solar',
                'Axium',
                'Unknown',
              ],
              [
                'United States',
                63,
                'North America',
                'North Hartsville',
                'Darlington County',
                'Unavailable',
                'B & K Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                80,
                'North America',
                'Huachuca City',
                'Cochise County',
                'Unavailable',
                'Babacomari North solar farm',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                80,
                'North America',
                'Huachuca City',
                'Cochise County',
                'Unavailable',
                'Babacomari South solar farm',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Coconico County',
                'Unavailable',
                'Babbitt Ranch Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Charlotte County',
                'Charlotte County',
                'Unavailable',
                'Babcock Preserve solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Charlotte County',
                'Charlotte County',
                'Unavailable',
                'Babcock Solar Energy Center Hybrid',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                225,
                'North America',
                'Haskell',
                'Haskell County',
                'Unavailable',
                'Azure Sky Solar',
                'Unknown',
                'Engie',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'Atwell Island solar farm',
                'SPS Atwell',
                'SunEdison',
              ],
              [
                'United States',
                300,
                'North America',
                'Greenfield',
                'La Paz County',
                'Unavailable',
                'Atlas solar farm',
                'Hanwha Energy',
                'Hanwha Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Williamsport',
                'Morrow County',
                'Unavailable',
                'Atlanta Farms Solar',
                'Unknown',
                'Savion Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Arlington Valley Solar Energy II',
                'CD Arevon USA, Inc.',
                'Capital Dynamics',
              ],
              [
                'United States',
                26,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Arlington Valley Solar Energy II',
                'CD Arevon USA, Inc.',
                'Capital Dynamics',
              ],
              [
                'United States',
                28,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Arlington Valley Solar Energy II',
                'CD Arevon USA, Inc.',
                'Capital Dynamics',
              ],
              [
                'United States',
                175,
                'North America',
                'Corsicana',
                'Navarro County',
                'Unavailable',
                'Armadillo Solar Center',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                200,
                'North America',
                'Moapa',
                'Clark County',
                'Unavailable',
                'Arrow Canyon Solar Hybrid',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Pueblo Pintado',
                'McKinley County',
                'Unavailable',
                'Arroyo Solar Energy Storage Hybrid',
                'D.E Shaw Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                86,
                'North America',
                'Unavailable',
                'Lyon County',
                'Unavailable',
                'Ashwood Solar',
                'Unknown',
                'RWE Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Shiawassee County',
                'Shiawassee County',
                'Unavailable',
                'Assembly Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                110,
                'North America',
                'Lennon',
                'Shiawassee County',
                'Unavailable',
                'Assembly Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                79,
                'North America',
                'Lennon',
                'Shiawassee County',
                'Unavailable',
                'Assembly Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                100,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Astoria solar farm',
                'Recurrent Energy',
                'KEPCO',
              ],
              [
                'United States',
                75,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Astoria solar farm',
                'Recurrent Energy',
                'KEPCO',
              ],
              [
                'United States',
                313,
                'North America',
                'Unavailable',
                'Riverside County',
                'Unavailable',
                'Athos Solar',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                200,
                'North America',
                'Desert Center',
                'Riverside County',
                'Unavailable',
                'Athos solar farm',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                250,
                'North America',
                'Desert Center',
                'Riverside County',
                'Unavailable',
                'Athos Solar Project',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                150,
                'North America',
                'Montfort',
                'Iowa County',
                'Unavailable',
                'Badger Hollow solar farm',
                'Wisconsin Public Service Corp',
                'Madison Gas & Electric Co [33.3%]; Wisconsin Public Service Corp [66.7%]',
              ],
              [
                'United States',
                150,
                'North America',
                'Montfort',
                'Iowa County',
                'Unavailable',
                'Badger Hollow solar farm',
                'Wisconsin Electric Power Co',
                'Madison Gas & Electric Co [33.3%]; Wisconsin Public Service Corp [66.7%]',
              ],
              [
                'United States',
                149,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Unavailable',
                'Badger State solar farm',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                60,
                'North America',
                'Maupin',
                'Wasco County',
                'Unavailable',
                'Bakeoven Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                56,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Beacon Solar',
                'Sustainable Power Group; Hecate Energy',
                'Sustainable Power Group, LLC; Hecate Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Beacon Solar',
                'Sustainable Power Group; Hecate Energy',
                'Sustainable Power Group, LLC; Hecate Energy',
              ],
              [
                'United States',
                47,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Beacon Solar Plant',
                'CD Global Solar Holdings, LLC',
                'TortoiseEcofin [49.5%]; S&B USA Energy [49.5%]; Capital Dynamics [1%]',
              ],
              [
                'United States',
                38,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Beacon Solar Plant',
                'CD Global Solar Holdings, LLC',
                'TortoiseEcofin [49.5%]; S&B USA Energy [49.5%]; Capital Dynamics [1%]',
              ],
              [
                'United States',
                35,
                'North America',
                'Walnut Cove',
                'Stokes County',
                'Unavailable',
                'Bear Branch Solar',
                'Unknown',
                'Capital Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Richland County',
                'Unavailable',
                'Bear Creek Solar',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Niagara County',
                'Unavailable',
                'Bear Ridge Solar',
                'Unknown',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Beaver Dam',
                'Dodge County',
                'Unavailable',
                'Beaver Dam solar farm',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'Chesapeake',
                'Unavailable',
                'Unavailable',
                'Bedford solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Potsoi',
                'Grant County',
                'Unavailable',
                'Grant County solar farm',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                88,
                'North America',
                'Louisa',
                'Louisa County',
                'Unavailable',
                'Belcher solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                500,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Bellefield 2 Solar & Energy Storage Farm',
                '8minute Solar',
                'Unknown',
              ],
              [
                'United States',
                500,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Bellefield Solar And Energy Storage Farm',
                '8minute Solar',
                'Unknown',
              ],
              [
                'United States',
                152,
                'North America',
                'Unavailable',
                'Henry County',
                'Unavailable',
                'Bellflower Solar',
                'Unknown',
                'Lightsource bp',
              ],
              [
                'United States',
                26,
                'North America',
                'Unavailable',
                'Stanislaus County',
                'Unavailable',
                'Beltran Ranch Solar Facility',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                56,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Beacon Solar',
                'Sustainable Power Group; Hecate Energy',
                'Sustainable Power Group, LLC; Hecate Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Arlington Valley Solar Energy II',
                'CD Arevon USA, Inc.',
                'Capital Dynamics',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Bayshore Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Bayshore Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                140,
                'North America',
                'Maupin',
                'Wasco County',
                'Unavailable',
                'Bakeoven Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Bakersfield Solar',
                'Algonquin Power Co',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Franklinville',
                'Cattaraugus County',
                'Unavailable',
                'Bakerstand Solar',
                'Unknown',
                'Empire Renewables, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Greenwich',
                'Washington County',
                'Unavailable',
                'Bald Mountain Solar',
                'Boralex',
                'Boralex',
              ],
              [
                'United States',
                68,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Baldwin solar farm',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Hillsborough County',
                'Hillsborough County',
                'Unavailable',
                'Balm Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                74,
                'North America',
                'Brevard County',
                'Brevard County',
                'Unavailable',
                'Barefoot Bay Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                22,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Barilla Solar',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                60,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Barren Ridge solar farm',
                'Recurrent Energy',
                'KEPCO',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Fredrick County',
                'Unavailable',
                'Bartonsville solar farm',
                'Unknown',
                'Torch Clean Energy',
              ],
              [
                'United States',
                850,
                'North America',
                'Las Vegas',
                'Clark County',
                'Mormon Mesa',
                'Battle Born Solar Project',
                'Unknown',
                'Arevia Power',
              ],
              [
                'United States',
                101,
                'North America',
                'Battle Mountain',
                'Humboldt County',
                'Unavailable',
                'Battle Mountain Solar Project',
                'Consolidated Edison Development Inc.',
                'NV Energy',
              ],
              [
                'United States',
                25,
                'North America',
                'Appling County',
                'Appling County',
                'Unavailable',
                'Baxley solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                75,
                'North America',
                'Crystal River',
                'Citrus County',
                'Unavailable',
                'Bay Trail Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'Harrells',
                'Bladen County',
                'Unavailable',
                'Bay Tree solar farm',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Bayshore Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                40,
                'North America',
                'Unavailable',
                'Stanislaus County',
                'Unavailable',
                'Beltran Ranch Solar Facility',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                127,
                'North America',
                'Arlington',
                'Maricopa County',
                'Unavailable',
                'Arlington Valley Solar Energy I',
                'Consolidated Edison Development Inc.',
                'Unknown',
              ],
              [
                'United States',
                133,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Arlington Energy Center (NextEra) solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                79,
                'North America',
                'Chambers County',
                'Chambers County',
                'Unavailable',
                'Al Solar',
                'Boise',
                'Alabama Power',
              ],
              [
                'United States',
                80,
                'North America',
                'Cusseta',
                'Chambers County',
                'Unavailable',
                'AL Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Mulberry',
                'Polk County',
                'Unavailable',
                'Alafia Solar',
                'Tampa Electric Co',
                'Tampa Electric Co.',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Alamo (California) solar farm',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                41,
                'North America',
                'San Antonio',
                'Bexar County',
                'Unavailable',
                'Alamo (Texas) solar farm',
                'OCI Solar Power',
                'OCI Solar Power',
              ],
              [
                'United States',
                40,
                'North America',
                'Brackettville',
                'Kinney County',
                'Unavailable',
                'Alamo (Texas) solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc. [80%]; OCI Solar Power [20%]',
              ],
              [
                'United States',
                100,
                'North America',
                'Moapa',
                'Clark County',
                'Unavailable',
                'Aiya Solar Project',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Uvalde',
                'Uvalde County',
                'Unavailable',
                'Alamo (Texas) solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                100,
                'North America',
                'Haskell County',
                'Haskell County',
                'Unavailable',
                'Alamo (Texas) solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Coeymans',
                'Albany County',
                'Unavailable',
                'Albany County solar farm',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Coeymans',
                'Albany County',
                'Unavailable',
                'Albany County solar farm',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Washington County',
                'Washington County',
                'Unavailable',
                'Albemarle Beach Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Alfred',
                'York County',
                'Unavailable',
                'Alfred Solar',
                'Freepoint',
                'Unknown',
              ],
              [
                'United States',
                223,
                'North America',
                'Andrews',
                'Andrews County',
                'Unavailable',
                'Alira solar farm',
                'Luminant Generation Company LLC',
                'Unknown',
              ],
              [
                'United States',
                105,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Alamo (Texas) solar farm',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                47,
                'North America',
                'Lake County',
                'Lake County',
                'Unavailable',
                'Airport Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                290,
                'North America',
                'Yuma County',
                'Yuma County',
                'Unavailable',
                'Agua Caliente Solar Project',
                'Unknown',
                'Clearway Energy [51%]; Berkshire Hathaway Energy [49%]',
              ],
              [
                'United States',
                121,
                'North America',
                'Yuma County',
                'Yuma County',
                'Unavailable',
                'Agua Caliente Solar Project',
                'Unknown',
                'Clearway Energy [51%]; Berkshire Hathaway Energy [49%]',
              ],
              [
                'United States',
                420,
                'North America',
                'Andrews',
                'Andrews County',
                'Unavailable',
                '2W Permian Solar Project Hybrid',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                26,
                'North America',
                'Unavailable',
                'Berkeley County',
                'Unavailable',
                '360-1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                26,
                'North America',
                'Unavailable',
                'Berkeley County',
                'Unavailable',
                '360-2 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                240,
                'North America',
                'Muldoon',
                'Fayette County',
                'Unavailable',
                '7V Solar Ranch',
                'Unknown',
                'Candela Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Adelanto Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Madera County',
                'Madera County',
                'Unavailable',
                'Adera Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Adobe Solar',
                'SunEdison',
                'Southern Power; Turner Renewable Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kaua\u02bbi County',
                'Kaua\u02bbi County',
                'Unavailable',
                'AES Lawai Solar Hybrid',
                'AES Corporation',
                'Unknown',
              ],
              [
                'United States',
                60,
                'North America',
                'Waikapu',
                'Maui County',
                'Unavailable',
                'Aes Maui Kuihelani Solar Hybrid',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                30,
                'North America',
                'Waikoloa Village',
                'Hawaii County',
                'Unavailable',
                'Aes Waikoloa Solar Hybrid',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                188,
                'North America',
                'Fleming',
                'Fleming County',
                'Unavailable',
                'AEUG Fleming Solar',
                'Acciona Energy USA Global, LLC',
                'Acciona Energy USA Global',
              ],
              [
                'United States',
                100,
                'North America',
                'Richmond',
                'Madison County',
                'Unavailable',
                'AEUG Madison Solar',
                'Acciona Energy USA Global, LLC',
                'Acciona Energy USA Global',
              ],
              [
                'United States',
                325,
                'North America',
                'West Mansfield',
                'Union County',
                'Unavailable',
                'AEUG Union Solar',
                'Acciona Energy USA Global, LLC',
                'Acciona Energy USA Global',
              ],
              [
                'United States',
                91,
                'North America',
                'Yuma County',
                'Yuma County',
                'Unavailable',
                'Agua Caliente Solar Project',
                'Unknown',
                'Clearway Energy [51%]; Berkshire Hathaway Energy [49%]',
              ],
              [
                'United States',
                136,
                'North America',
                'Yuma County',
                'Yuma County',
                'Unavailable',
                'Agua Caliente Solar Project',
                'Unknown',
                'Clearway Energy [51%]; Berkshire Hathaway Energy [49%]',
              ],
              [
                'United States',
                50,
                'North America',
                'Decatur',
                'Green County',
                'Unavailable',
                'Alliant Albany solar farm',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Fulton',
                'Rock County',
                'Unavailable',
                'Alliant North Rock solar farm',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Gilbert',
                'Lexington County',
                'Unavailable',
                'Allora Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'Alpaugh solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'North Las Vegas',
                'Clark County',
                'Unavailable',
                'Apex Solar Power Project',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                21,
                'North America',
                'Catawba County',
                'Lincoln County',
                'Unavailable',
                'Apple Data Center solar farm',
                'Apple, Inc',
                'Apple, Inc',
              ],
              [
                'United States',
                20,
                'North America',
                'Catawba County',
                'Catawba County',
                'Unavailable',
                'Apple Data Center solar farm',
                'Apple, Inc',
                'Apple, Inc',
              ],
              [
                'United States',
                180,
                'North America',
                'Van Horn',
                'Culberson County',
                'Unavailable',
                'Aragorn Solar Project',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                138,
                'North America',
                'Alameda County',
                'Alameda County',
                'Unavailable',
                'Aramis Solar',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                200,
                'North America',
                'Boron',
                'San Bernardino County',
                'Unavailable',
                'Aratina Solar Center',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Aratina Solar Center',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                25,
                'North America',
                'Greenfield',
                'Adair County',
                'Unavailable',
                'Arbor Hill Solar',
                'MidAmerican Energy Co',
                'MidAmerican Energy Co',
              ],
              [
                'United States',
                75,
                'North America',
                'Gainsville',
                'Alachua County',
                'Unavailable',
                'Archer solar farm',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Unavailable',
                'Lake County',
                'Unavailable',
                'Archway Solar',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                265,
                'North America',
                'Unavailable',
                'Riverside County County',
                'Unavailable',
                'Arica Solar',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                370,
                'North America',
                'Laughlin',
                'Clark County',
                'Unavailable',
                'Arida Solar',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Arlington',
                'Early County',
                'Unavailable',
                'Arlington (Silicon Ranch) solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                102,
                'North America',
                'Early County',
                'Early County',
                'Unavailable',
                'Arlington (Silicon Ranch) solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                100,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Arlington Energy Center (NextEra) solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Cochise County',
                'Cochise County',
                'Unavailable',
                'Apache Solar 1',
                'Arizona Electric Pwr Coop Inc',
                'Sierra Southwest Cooperative [100%]',
              ],
              [
                'United States',
                131,
                'North America',
                'Blythe',
                'Riverside County',
                'Unavailable',
                'Arlington Energy Center (NextEra) solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Ap North Lake I solar farm',
                'Unknown',
                'SunEdison',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Antelope Dsr solar farm',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'Alpaugh solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                66,
                'North America',
                'Los Angeles County',
                'Los Angeles County',
                'Unavailable',
                'Alpine Solar',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                66,
                'North America',
                'Los Angeles County',
                'Los Angeles County',
                'Unavailable',
                'Alpine Solar',
                'NRG Solar Alpine',
                'Unknown',
              ],
              [
                'United States',
                28,
                'North America',
                'Luna County',
                'Luna County',
                'Unavailable',
                'Alta Luna solar farm',
                'DEPCOM Power',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Lynch Station',
                'Campbell County',
                'Unavailable',
                'Altavista Solar',
                'Unknown',
                'Apex Clean Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Arlington County',
                'Unavailable',
                'Amazon Arlington Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                110,
                'North America',
                'Scotland Neck',
                'Halifax County',
                'Unavailable',
                'American Beech Solar',
                'Unknown',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                20,
                'North America',
                'Power County',
                'Power County',
                'Unavailable',
                'American Falls Solar',
                'Unknown',
                'Capital Dynamics',
              ],
              [
                'United States',
                20,
                'North America',
                'Power County',
                'Power County',
                'Unavailable',
                'American Falls Solar',
                'Unknown',
                'Capital Dynamics',
              ],
              [
                'United States',
                128,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'American Kings Solar',
                'Goldman Sachs Renewable Power Group',
                'Goldman Sachs Renewable Power Group',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Barren County',
                'Unavailable',
                'American Robin Solar Project',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Anderson County',
                'Unavailable',
                'Anderson County Cypress Creek solar farm',
                'Unknown',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                200,
                'North America',
                'Anson',
                'Jones County',
                'Unavailable',
                'ANSON Solar Center',
                'Engie',
                'Engie',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Antelope Big Sky Ranch solar farm',
                'Sustainable Power Group, LLC',
                'FTP Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Antelope Dsr solar farm',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                105,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Antelope Dsr solar farm',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                125,
                'North America',
                'Unavailable',
                'Escanada County',
                'Unavailable',
                'Chandler Solar',
                'Unknown',
                'Orion Energy; MAP Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Unavailable',
                'Stanislaus County',
                'Unavailable',
                'Beltran Ranch Solar Facility',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                165,
                'North America',
                'Kern',
                'Kern County',
                'Unavailable',
                'Big Beau Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Nye County',
                'Unavailable',
                'Cactus Springs Solar Project',
                'Unknown',
                'Avangrid Renewables',
              ],
              [
                'United States',
                275,
                'North America',
                'Unavailable',
                'York County',
                'Unavailable',
                'Cadence Solar Energy Center',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                100,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Calcite Solar',
                'Unknown',
                'Vesper Energy',
              ],
              [
                'United States',
                125,
                'North America',
                'Sheridan Township',
                'Calhoun County',
                'Unavailable',
                'Calhoun County Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                200,
                'North America',
                'Battle Creek',
                'Calhoun County',
                'Unavailable',
                'Calhoun Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                750,
                'North America',
                'Barstow',
                'San Bernardino County',
                'Unavailable',
                'Calico Solar One',
                'Unknown',
                'K Road Power Holdings',
              ],
              [
                'United States',
                75,
                'North America',
                'Sussex County',
                'Sussex County',
                'Unavailable',
                'Cabin Point Solar Center',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                100,
                'North America',
                'Barstow',
                'San Bernardino County',
                'Unavailable',
                'Calico Solar One',
                'Unknown',
                'K Road Power Holdings',
              ],
              [
                'United States',
                32,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'California Valley Solar Ranch',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                86,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'California Valley Solar Ranch',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'California Valley Solar Ranch',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'California Valley Solar Ranch',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Calipatria',
                'Imperial County',
                'Unavailable',
                'Calipatria solar farm',
                'First Solar',
                'Southern Power',
              ],
              [
                'United States',
                20,
                'North America',
                'South Camden',
                'Camden County',
                'Unavailable',
                'Camden Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                21,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'California Valley Solar Ranch',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Fallon',
                'Fallon County',
                'Unavailable',
                'Cabin Creek Solar',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                75,
                'North America',
                'Fallon',
                'Fallon County',
                'Unavailable',
                'Cabin Creek Solar',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Cabarrus County',
                'Unavailable',
                'Cabarrus County solar farm',
                'Unknown',
                'McBride Place Energy LLC',
              ],
              [
                'United States',
                80,
                'North America',
                'Billings',
                'Yellowstone County',
                'Unavailable',
                'Broadview Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                250,
                'North America',
                'Billings',
                'Yellowstone County',
                'Unavailable',
                'Broadview Solar',
                'Unknown',
                'Broad Reach Power',
              ],
              [
                'United States',
                177,
                'North America',
                'San Angelo',
                'Tom Green County',
                'Unavailable',
                'Brushy Creek Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Cumberland',
                'Buckingham County',
                'Unavailable',
                'Buckingham solar farm',
                'Unknown',
                'Energix Renewable Energy',
              ],
              [
                'United States',
                52,
                'North America',
                'Pitt County',
                'Pitt County',
                'Unavailable',
                'Buckleberry Solar',
                'Cypress Creek Renewables',
                'John Laing Group PLC',
              ],
              [
                'United States',
                154,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Buckthorn Westex solar farm',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Otero County',
                'Unavailable',
                'Buena Vista Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                170,
                'North America',
                'Unavailable',
                'Clinton County',
                'Unavailable',
                'Bull Run Solar',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                50,
                'North America',
                'Vance County',
                'Vance County',
                'Unavailable',
                'Bullock Solar',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                22,
                'North America',
                'Taylor County',
                'Taylor County',
                'Unavailable',
                'Butler Solar Farm 20',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                104,
                'North America',
                'Taylor County',
                'Taylor County',
                'Unavailable',
                'Butler Solar Project 103',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Dodge County',
                'Unavailable',
                'Byron Solar Project',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Lakeland',
                'Polk County',
                'Unavailable',
                'C D Mcintosh Jr solar farm',
                'City of Lakeland - (FL)',
                'City of Lakeland - (FL) [60.0%]; Orlando Utilities Comm [40.0%]',
              ],
              [
                'United States',
                130,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Ca Flats Solar',
                'California Flats Solar',
                'Capital Dynamics',
              ],
              [
                'United States',
                150,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Ca Flats Solar',
                'CD Arevon USA, Inc.',
                'Capital Dynamics',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Gloucester County',
                'Unavailable',
                'Camellia Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                45,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Camelot solar farm',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Calhoun County',
                'Calhoun County',
                'Unavailable',
                'Cameron Solar',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                171,
                'North America',
                'Mitchell County',
                'Mitchell County',
                'Unavailable',
                'Camilla Solar Energy Project',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'CED Ducor solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'CED Ducor solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'CED Ducor solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                114,
                'North America',
                'Smyrna',
                'New Castle County',
                'Unavailable',
                'Cedar Creek Solar',
                'Unknown',
                'Freepoint',
              ],
              [
                'United States',
                70,
                'North America',
                'Blakely',
                'Early County',
                'Unavailable',
                'Cedar Springs solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Cement City',
                'Lenawee County',
                'Unavailable',
                'Cement City Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                75,
                'North America',
                'Chesterfield County',
                'Chesterfield County',
                'Unavailable',
                'Centerfield Cooper Solar',
                'Pine Gate Renewables',
                'Pine Gate Renewables',
              ],
              [
                'United States',
                34,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Centinela Solar Energy',
                'LS Power',
                'LS Power',
              ],
              [
                'United States',
                27,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Centinela Solar Energy',
                'LS Power',
                'LS Power',
              ],
              [
                'United States',
                34,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Centinela Solar Energy',
                'LS Power',
                'LS Power',
              ],
              [
                'United States',
                34,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Centinela Solar Energy',
                'LS Power',
                'LS Power',
              ],
              [
                'United States',
                27,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Centinela Solar Energy',
                'LS Power',
                'LS Power',
              ],
              [
                'United States',
                40,
                'North America',
                'Newman',
                'Stanislaus County',
                'Unavailable',
                'Central 40 solar farm',
                'Idemitsu Renewables',
                'Idemitsu Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Central Antelope Dry Ranch solar farm',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                100,
                'North America',
                'Coolidge',
                'Pinal County',
                'Unavailable',
                'Central Line Solar',
                'AES Corporation',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Cayuga County',
                'Unavailable',
                'Cayuga Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Billings',
                'Yellowstone County',
                'Unavailable',
                'Broadview Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'White County',
                'Unavailable',
                'Cavalry Solar',
                'Northern Indiana Public Service Company LLC (NIPSCO)',
                'NextEra Energy; Northern Indiana Public Service Company LLC (NIPSCO)',
              ],
              [
                'United States',
                74,
                'North America',
                'DeSoto County',
                'DeSoto County',
                'Unavailable',
                'Cattle Ranch solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                44,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Camino Solar Hybrid',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                147,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Campo Verde Solar',
                'First Solar',
                'Southern Company; Turner Renewable Energy',
              ],
              [
                'United States',
                25,
                'North America',
                'Litchfield County',
                'Litchfield County',
                'Unavailable',
                'Candlewood Solar',
                'Ameresco',
                'Unknown',
              ],
              [
                'United States',
                79,
                'North America',
                'Unavailable',
                'Clarke County',
                'Unavailable',
                'Cane Creek Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Cantua Solar Station',
                'Pacific Gas & Electric Co.',
                'Pacific Gas & Electric Co.',
              ],
              [
                'United States',
                20,
                'North America',
                'Pasquotank County',
                'Pasquotank County',
                'Unavailable',
                'Capital Partners Solar Project',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                32,
                'North America',
                'Unavailable',
                'Watauga County',
                'Unavailable',
                'Capital Partners Solar Project',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                25,
                'North America',
                'Quay County',
                'Quay County',
                'Unavailable',
                'Caprock Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Quay County',
                'Quay County',
                'Unavailable',
                'Caprock Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Cassville',
                'Grant County',
                'Unavailable',
                'Cassvile Solar',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                180,
                'North America',
                'Upton County',
                'Upton County',
                'Unavailable',
                'Castle Gap Solar Hybrid',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'Huntington',
                'Emery County',
                'Unavailable',
                'Castle Solar',
                'D.E Shaw Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                24,
                'North America',
                'Unavailable',
                'Kern County',
                'Unavailable',
                'Catalina Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                110,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Catalina Solar',
                'EDF Renewables',
                'GE Energy Financial Services; MetLife; Union Bank; Citi',
              ],
              [
                'United States',
                110,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Catalina Solar',
                'EDF Renewables',
                'GE Energy Financial Services; MetLife; Union Bank; Citi',
              ],
              [
                'United States',
                170,
                'North America',
                'Unavailable',
                'Surry County',
                'Unavailable',
                'Cavalier Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Monmouth County',
                'Monmouth County',
                'Unavailable',
                'Ben Moreell solar farm',
                'Conductive Power',
                'Ben Moreel Solar Farm',
              ],
              [
                'United States',
                80,
                'North America',
                'Billings',
                'Yellowstone County',
                'Unavailable',
                'Broadview Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Torrance County',
                'Torrance County',
                'Unavailable',
                'Britton Solar Energy Center',
                'PNM',
                'PNM',
              ],
              [
                'United States',
                50,
                'North America',
                'Bladen County',
                'Bladen County',
                'Unavailable',
                'Bladen Solar',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Indian River County',
                'Indian River County',
                'Unavailable',
                'Blue Cypress Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Hendry County',
                'Hendry County',
                'Unavailable',
                'Blue Heron Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Jackson County',
                'Jackson County',
                'Unavailable',
                'Blue Indigo Energy solar farm',
                'Gulf Power',
                'Gulf Power',
              ],
              [
                'United States',
                210,
                'North America',
                'Iola',
                'Grimes County',
                'Unavailable',
                'Blue Jay Solar',
                'Unknown',
                'Enel Green Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Lakeveiw',
                'Lake County',
                'Unavailable',
                'Blue Marmot Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Blackwell Solar Park',
                'Consolidated Edison Development Inc.',
                'Unknown',
              ],
              [
                'United States',
                70,
                'North America',
                'Unavailable',
                'Harrison County',
                'Unavailable',
                'Blue Moon Solar',
                'Unknown',
                'Recurrent Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Marianna',
                'Jackson County',
                'Unavailable',
                'Blue Springs solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Sterling County',
                'Sterling County',
                'Unavailable',
                'Bluebell Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                115,
                'North America',
                'Sterling County',
                'Sterling County',
                'Unavailable',
                'Bluebell Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Leesburg',
                'Harrison County',
                'Unavailable',
                'Bluebird Solar',
                'Bay Wa.r.e',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                40,
                'North America',
                'Unavailable',
                'Lake County',
                'Unavailable',
                'Bluechip solar farm',
                'Unknown',
                'BlueChip Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Church Hill',
                'Queen Annes County',
                'Unavailable',
                'Bluegrass Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                369,
                'North America',
                'Unavailable',
                'Grundy County',
                'Unavailable',
                'Blue Sky solar farm',
                'Unknown',
                'Scout Clean Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Barnwell County',
                'Barnwell County',
                'Unavailable',
                'Blackville Solar II',
                'DEPCOM Power',
                'C2 Energy Capital',
              ],
              [
                'United States',
                100,
                'North America',
                'Montgomery',
                'Montgomery County',
                'Unavailable',
                'Blackbear Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                100,
                'North America',
                'Moxee',
                'Yakima County',
                'Unavailable',
                'Black Rock Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                25,
                'North America',
                'Hillsborough',
                'Hillsborough County',
                'Unavailable',
                'Big Bend Solar',
                'Tampa Electric Co',
                'Unknown',
              ],
              [
                'United States',
                400,
                'North America',
                'Wheatley',
                'Lee County',
                'Unavailable',
                'Big Creek Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Barnwell',
                'Barnwell County',
                'Unavailable',
                'Big Fork Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                196,
                'North America',
                'London',
                'Madison County',
                'Unavailable',
                'Big Plain Solar',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                149,
                'North America',
                'Norris City',
                'White County',
                'Unavailable',
                'Big River Solar',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                200,
                'North America',
                'El Centro',
                'Imperial County',
                'Unavailable',
                'Big Rock solar farm',
                '8minute Solar',
                'Unknown',
              ],
              [
                'United States',
                200,
                'North America',
                'Rosanky',
                'Bastrop County',
                'Unavailable',
                'Big Star Solar',
                'RWE Renewables Americas LLC',
                'RWE Renewables',
              ],
              [
                'United States',
                240,
                'North America',
                'Pueblo',
                'Pueblo County',
                'Unavailable',
                'Bighorn Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                20,
                'North America',
                'Clinton County',
                'Clinton County',
                'Unavailable',
                'Bingham Solar',
                'National Grid Renewables',
                'National Grid Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Toledo',
                'Allen County',
                'Unavailable',
                'Birch Solar',
                'Unknown',
                'Lightsource bp',
              ],
              [
                'United States',
                50,
                'North America',
                'King George',
                'King George County',
                'Unavailable',
                'Birchwood Solar',
                'Unknown',
                'J-Power USA',
              ],
              [
                'United States',
                30,
                'North America',
                'Larimer County',
                'Larimer County',
                'Unavailable',
                'Bison Solar',
                'JSI O&M Group',
                'PSEG Solar Source',
              ],
              [
                'United States',
                130,
                'North America',
                'Unavailable',
                'Montgomery County',
                'Unavailable',
                'Black Bear Solar',
                'Unknown',
                'Lightsource bp',
              ],
              [
                'United States',
                299,
                'North America',
                'Unavailable',
                'Christian County',
                'Unavailable',
                'Black Diamond Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Auit',
                'Pueblo County',
                'Unavailable',
                'Black Hollow Sun solar farm',
                '174 Power Global',
                'Hanwha Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Chase City',
                'Mecklenburg County',
                'Unavailable',
                'Bluestone Solar',
                'Unknown',
                'Engie',
              ],
              [
                'United States',
                21,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (Clearway) solar farm',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (Clearway) solar farm',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                137,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Boulder City',
                'Clark County',
                'Unavailable',
                'Boulder Solar',
                'Unknown',
                '174 Power Global; KOMIPO',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Kramer Junction County',
                'Unavailable',
                'Boulevard Associates solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                127,
                'North America',
                'Unavailable',
                'Montezuma County',
                'Unavailable',
                'Boutique Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                20,
                'North America',
                'Wood County',
                'Wood County',
                'Unavailable',
                'Bowling Green Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Multnomah County',
                'Unavailable',
                'Boza solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Penobscot County',
                'Unavailable',
                'Bradley Solar Project',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Nash County',
                'Nash County',
                'Unavailable',
                'Brantley Solar',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                200,
                'North America',
                'San Angelo',
                'Tom Green County',
                'Unavailable',
                'Bravepost solar farm',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Damon',
                'Brazoria County',
                'Unavailable',
                'Brazoria West solar farm',
                'Unknown',
                'CIT Group Inc.',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Macon County',
                'Unavailable',
                'Brenneman Solar',
                'Unknown',
                'Doral Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Orangeburg County',
                'Unavailable',
                'Brewer Solar',
                'Unknown',
                'Seahorse Capital',
              ],
              [
                'United States',
                127,
                'North America',
                'Corsicana',
                'Navarro County',
                'Unavailable',
                'Briar Creek Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Boone County',
                'Unavailable',
                'Brickyard Solar Project',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Henrico County',
                'Unavailable',
                'Briel Farm solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                51,
                'North America',
                'Beeville',
                'Bee County',
                'Unavailable',
                'Brightside solar farm',
                'Luminant Generation Company LLC',
                'Vistra Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Boulder Solar',
                'AEP Renewables',
                'AEP Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Mooresboro',
                'Cleveland County',
                'Unavailable',
                'Broad River Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Boulder Solar',
                'Southern Power Co',
                'Southern Power Company; SunPower',
              ],
              [
                'United States',
                26,
                'North America',
                'San Diego County',
                'San Diego County',
                'Unavailable',
                'Borrego solar farm',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                39,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                36,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                33,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                34,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                32,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                32,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                69,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                69,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Blythe (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Coke County',
                'Unavailable',
                'Bnb Tennyson Solar',
                'Unknown',
                'BNB Renewable Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Klamath County',
                'Klamath County',
                'Unavailable',
                'Bonanza solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                38,
                'North America',
                'Polk County',
                'Polk County',
                'Unavailable',
                'Bonnie Mine Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                50,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'Bonnybrooke Pv solar farm',
                'Apple, Inc',
                'Apple, Inc',
              ],
              [
                'United States',
                64,
                'North America',
                'Unavailable',
                'Boone County',
                'Unavailable',
                'Boone Stephens Solar',
                'Unknown',
                'Boone Stephens',
              ],
              [
                'United States',
                50,
                'North America',
                'Madera County',
                'Madera County',
                'Unavailable',
                'Borden solar farm',
                '8minute Solar',
                'Allainz SE',
              ],
              [
                'United States',
                200,
                'North America',
                'Wadsworth',
                'Washoe County',
                'Unavailable',
                'Boulder Flats Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                82,
                'North America',
                'Wellington',
                'Carbon County',
                'Unavailable',
                'Graphite Solar I',
                'Greenbacker Energy',
                'Greenbacker Energy',
              ],
              [
                'United States',
                130,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Edwards Sanborn solar farm',
                'Terra-Gen',
                'Terra-Gen',
              ],
              [
                'United States',
                80,
                'North America',
                'Mecklenburg County',
                'Mecklenburg County',
                'Unavailable',
                'Grasshopper Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                52,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power North',
                'Unknown',
                'Enbridge',
              ],
              [
                'United States',
                80,
                'North America',
                'Sigurd',
                'Sevier County',
                'Unavailable',
                'Sigurd Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Sierra Solar Greenworks',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                200,
                'North America',
                'Lucerne Valley',
                'San Bernardino County',
                'Unavailable',
                'Sienna solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                33,
                'North America',
                'Unavailable',
                'Charles County',
                'Unavailable',
                'Shugart Valley solar farm',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Bishopville',
                'Lee County',
                'Unavailable',
                'Shorthorn Solar',
                'Shorthorn Solar',
                'Unknown',
              ],
              [
                'United States',
                25,
                'North America',
                'Suffolk County',
                'Suffolk County',
                'Unavailable',
                'Shoreham Solar Commons',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                65,
                'North America',
                'Scotland County',
                'Scotland County',
                'Unavailable',
                'Shoe Creek Solar',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                60,
                'North America',
                'Chatham',
                'Pittsylvania County',
                'Unavailable',
                'Shockoe Solar Project',
                '174 Power Global',
                'Hanwha Energy',
              ],
              [
                'United States',
                37,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                360,
                'North America',
                'Unavailable',
                'San Juan County',
                'Unavailable',
                'Shiprock Solar',
                'Unknown',
                'Photosol US',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Sheridan County',
                'Unavailable',
                'Sheridan Solar',
                'Unknown',
                'Sheridan Solar',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Shelby County',
                'Unavailable',
                'Shelbyville solar farm',
                'Unknown',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Currituck County',
                'Camden County',
                'Unavailable',
                'Shawboro solar farm',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Aiken County',
                'Aiken County',
                'Unavailable',
                'Shaw Creek Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                270,
                'North America',
                'Unavailable',
                'Dimmit County',
                'Unavailable',
                'Shakes solar farm',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Shaftsbury',
                'Bennington County',
                'Unavailable',
                'Shaftsbury Solar',
                'Freepoint',
                'Freepoint',
              ],
              [
                'United States',
                20,
                'North America',
                'Bakersfield',
                'Kern County',
                'Unavailable',
                'Shafter Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Seville solar farm',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Seville solar farm',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'SEPV Mojave West solar farm',
                'Unknown',
                'Solar Electric Solutions',
              ],
              [
                'United States',
                100,
                'North America',
                'Searcy',
                'White County',
                'Unavailable',
                'Searcy Solar Hybrid',
                'Unknown',
                'Entergy',
              ],
              [
                'United States',
                40,
                'North America',
                'Elloree',
                'Orangeburg County',
                'Unavailable',
                'Shining Sun Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                72,
                'North America',
                'Beaufort County',
                'Beaufort County',
                'Unavailable',
                'Seabrook Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                36,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                37,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                54,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Solar Gen 2 Solar Facility',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                54,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Solar Gen 2 Solar Facility',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                50,
                'North America',
                'Brewster County',
                'Brewster County',
                'Unavailable',
                'Solaire Holman Solar Project',
                'Engie',
                'Engie',
              ],
              [
                'United States',
                20,
                'North America',
                'El Centro',
                'Imperial County',
                'Unavailable',
                'Sol Orchard El Centro solar farm',
                'Unknown',
                'Excelsior Energy',
              ],
              [
                'United States',
                287,
                'North America',
                'Unavailable',
                'San Bernadino County',
                'Unavailable',
                'Soda Mountain Solar Project',
                'Unknown',
                'Regenerate Power',
              ],
              [
                'United States',
                100,
                'North America',
                'Las Vegas',
                'Clark County',
                'Unavailable',
                'Snow Mountain Solar',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Chesapeake',
                'Chesapeake City County',
                'Unavailable',
                'Grassfield Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                1000,
                'North America',
                'Silver Peak',
                'Esmeralda County',
                'Unavailable',
                'Smoky Valley Solar Project',
                'ConnectGen',
                'ConnectGen',
              ],
              [
                'United States',
                63,
                'North America',
                'Stratford',
                'Kings County',
                'Unavailable',
                'Slate Hybrid solar farm',
                'Unknown',
                'Goldman Sachs Renewables',
              ],
              [
                'United States',
                26,
                'North America',
                'Stratford',
                'Kings County',
                'Unavailable',
                'Slate Hybrid solar farm',
                'Unknown',
                'Goldman Sachs Renewables',
              ],
              [
                'United States',
                68,
                'North America',
                'Stratford',
                'Kings County',
                'Unavailable',
                'Slate Hybrid solar farm',
                'Unknown',
                'Goldman Sachs Renewables',
              ],
              [
                'United States',
                35,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                93,
                'North America',
                'Stratford',
                'Kings County',
                'Unavailable',
                'Slate Hybrid solar farm',
                'Unknown',
                'Goldman Sachs Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Westmoreland',
                'Oneida County',
                'Unavailable',
                'Skyline Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Tully County',
                'Unavailable',
                'Sky High Solar',
                'Unknown',
                'Delaware River Solar',
              ],
              [
                'United States',
                175,
                'North America',
                'Wayside',
                'Charles City County',
                'Unavailable',
                'Skipjack Solar Center',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                250,
                'North America',
                'Carrier',
                'Garfield County',
                'Unavailable',
                'Skeleton Creek solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'St.James Parish County',
                'Unavailable',
                'SJ Louisiana Solar Project',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Unavailable',
                'Sinnissippi solar farm',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                30,
                'North America',
                'Walton County',
                'Walton County',
                'Unavailable',
                'Simon solar farm',
                'Phoenix Solar',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Elmore County',
                'Elmore County',
                'Unavailable',
                'Simcoe Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Newberry Springs County',
                'Unavailable',
                'Silver Valley solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                26,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Silver State Solar Power South',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Stratford',
                'Kings County',
                'Unavailable',
                'Slate Hybrid solar farm',
                'Unknown',
                'Goldman Sachs Renewables',
              ],
              [
                'United States',
                54,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Solar Gen 2 Solar Facility',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                20,
                'North America',
                'Powhatan County',
                'Powhatan County',
                'Unavailable',
                'Scott-II Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Sussex County',
                'Sussex County',
                'Unavailable',
                'Sappony Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                173,
                'North America',
                'Unavailable',
                'Logan County',
                'Unavailable',
                'Russellville Solar',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                80,
                'North America',
                'Boulevard',
                'San Diego County',
                'Unavailable',
                'Rugged Solar',
                'Clean Focus Renewables, Inc.',
                'Hamann Company; Clean Focus Renewables',
              ],
              [
                'United States',
                22,
                'North America',
                'Rutherford County',
                'Rutherford County',
                'Unavailable',
                'Ruff Solar',
                'Sol Systems',
                'FLS Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Kramer Junction County',
                'Unavailable',
                'Rubita Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                55,
                'North America',
                'Roxbury',
                'Oxford County',
                'Unavailable',
                'Roxbury Solar',
                'Unknown',
                'Granite Apollo',
              ],
              [
                'United States',
                50,
                'North America',
                'San Fidel',
                'Cibola County',
                'Unavailable',
                'Route 66 Energy Center solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Pahrump',
                'Nye County',
                'Unavailable',
                'Rough Hat solar farm',
                'Candela Renewables, LLC',
                'Hamel Renewables, LLC',
              ],
              [
                'United States',
                400,
                'North America',
                'Pahrump',
                'Clark County',
                'Unavailable',
                'Rough Hat solar farm',
                'Candela Renewables, LLC',
                'Hamel Renewables, LLC',
              ],
              [
                'United States',
                70,
                'North America',
                'Roswell',
                'Chaves County',
                'Unavailable',
                'Roswell Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Soceity Hill',
                'Darlington County',
                'Unavailable',
                'Ross Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Ross County',
                'Unavailable',
                'Ross County Solar Project',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Warrick County',
                'Unavailable',
                'Rustic Hills solar farm',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                160,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Roserock solar farm',
                'Southern Power Co',
                'Southern Power; Canadian Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Bastrop County',
                'Unavailable',
                'Rosanky Solar',
                'Unknown',
                'RWE Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Rosamond Two solar farm',
                'Gamma Genco CV II LLC',
                'Recurrent Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Rosamond One solar farm',
                'Gamma Genco CV II LLC',
                'Recurrent Energy',
              ],
              [
                'United States',
                350,
                'North America',
                'Unavailable',
                'Wayne County',
                'Rose',
                'Rosalen solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                63,
                'North America',
                'Hartsville',
                'Darlington County',
                'Unavailable',
                'Rollins Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Arcadia',
                'DeSoto County',
                'Unavailable',
                'Rodeo Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Kirtland',
                'San Juan County',
                'Unavailable',
                'Rockmont Solar And Storage Project',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                80,
                'North America',
                'Corinne',
                'Box Elder County',
                'Unavailable',
                'Rocket Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'James City County',
                'Unavailable',
                'Rochambeau solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                128,
                'North America',
                'Macon',
                'Bibb County',
                'Unavailable',
                'Robins Air Force Base Solar',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                200,
                'North America',
                'Upton County',
                'Upton County',
                'Unavailable',
                'Roadrunner (Enel) solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Falls County',
                'Unavailable',
                'Roseland solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                1000,
                'North America',
                'Unavailable',
                'Esmeralda County',
                'Unavailable',
                'Sawtooth Solar Energy Center',
                'Unknown',
                'Quantum Energy Partners',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Rutherford County County',
                'Unavailable',
                'Rutherford (Strata Solar) solar farm',
                'Unknown',
                'Strata Solar',
              ],
              [
                'United States',
                110,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Unavailable',
                'Rutland Center Solar-1',
                'Borrego',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Santa Teresa',
                'Do\u00f1a Ana County',
                'Unavailable',
                'Santa Teresa solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Santa Teresa County',
                'Unavailable',
                'Santa Teresa Solar',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Archer',
                'Alachua County',
                'Unavailable',
                'Santa Fe Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                49,
                'North America',
                'Sanford',
                'York County',
                'Unavailable',
                'Sanford Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Panama City',
                'Bay County',
                'Unavailable',
                'Sandy Creek Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                45,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'Sandstone Solar',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Bakersfield County',
                'Unavailable',
                'Sandrini Solar Project',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Bakersfield County',
                'Unavailable',
                'Sandrini Solar Project',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Jones County',
                'Unavailable',
                'Sand Fork Solar',
                'Engie',
                'Engie',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Alachua County',
                'Unavailable',
                'Sand Bluff solar farm',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'San Pablo Raceway solar farm',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                75,
                'North America',
                'Rutherford County',
                'Rutherford County',
                'Unavailable',
                'Rutherford Farm (Southern Power) solar farm',
                'Cypress Creek Renewables',
                'Southern Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Cadwell County',
                'Unavailable',
                'San Marcos-Hays Solar',
                'Unknown',
                'Chem-Energy Corp',
              ],
              [
                'United States',
                598,
                'North America',
                'Unavailable',
                'Farmington County',
                'Unavailable',
                'San Juan Solar',
                'Unknown',
                'Photosol US',
              ],
              [
                'United States',
                30,
                'North America',
                'Las Animas County',
                'Las Animas County',
                'Unavailable',
                'San Isabel Solar',
                'JSI O&M Group',
                'PSEG Solar Source',
              ],
              [
                'United States',
                250,
                'North America',
                'Cunningham',
                'Lamar County',
                'Unavailable',
                'Samson Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                200,
                'North America',
                'Cunningham',
                'Lamar County',
                'Unavailable',
                'Samson Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                250,
                'North America',
                'Cunningham',
                'Franklin County',
                'Unavailable',
                'Samson Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                100,
                'North America',
                'Coolidge',
                'Pinal County',
                'Unavailable',
                'Saint Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                58,
                'North America',
                'Rich County',
                'Rich County',
                'Unavailable',
                'Sage Solar I-III',
                'First Solar',
                'Copenhagen Infrastructure Partners',
              ],
              [
                'United States',
                100,
                'North America',
                'Emporia',
                'Greensville County',
                'Unavailable',
                'Sadler Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                220,
                'North America',
                'Unavailable',
                'Clark County',
                'Unavailable',
                'Saddlebred Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                110,
                'North America',
                'Conway',
                'Carroll County',
                'Unavailable',
                'Saco River Solar',
                'Unknown',
                'Olivewood Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Loxahatchee',
                'Palm Beach County',
                'Unavailable',
                'Sabal Palm Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Alamosa County',
                'Alamosa County',
                'Unavailable',
                'San Luis Valley Solar Ranch',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                200,
                'North America',
                'Upton County',
                'Upton County',
                'Unavailable',
                'Roadrunner (Enel) solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Palmdale',
                'Los Angeles County',
                'Unavailable',
                'Solar Oasis',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                54,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Marquette County',
                'Unavailable',
                'Superior Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                104,
                'North America',
                'Nye County',
                'Nye County',
                'Unavailable',
                'Sunshine Valley Solar',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Columbia County',
                'Columbia County',
                'Unavailable',
                'Sunshine Gateway Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Sunray 2 solar farm',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Daggett County',
                'Unavailable',
                'Sunpower Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Washingston Parish County',
                'Unavailable',
                'Sunlight Road Solar Project',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Ruleville',
                'Sunflower County',
                'Unavailable',
                'Sunflower County solar farm',
                'Unknown',
                'Entergy',
              ],
              [
                'United States',
                20,
                'North America',
                'Sunbury',
                'Northumberland County',
                'Unavailable',
                'Sunbury Solar',
                'BQ Energy',
                'BQ Energy; Talen Energy',
              ],
              [
                'United States',
                330,
                'North America',
                'Unavailable',
                'Maricopa County',
                'Unavailable',
                'Sun Valley solar farm',
                'Unknown',
                'Capital Power',
              ],
              [
                'United States',
                160,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Sun Streams solar farm',
                'First Solar',
                'EDP Renewables',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Pima County',
                'Unavailable',
                'Sun Streams 5 solar farm',
                'Unknown',
                'Longroad Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Surry County',
                'Unavailable',
                'Surry solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Pima County',
                'Unavailable',
                'Sun Streams 4 solar farm',
                'Unknown',
                'Longroad Energy',
              ],
              [
                'United States',
                298,
                'North America',
                'Unavailable',
                'Pueblo County',
                'Unavailable',
                'Sun Mountain Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Sun City Project solar farm',
                'Eurus Energy',
                'Eurus Energy; Clearway',
              ],
              [
                'United States',
                52,
                'North America',
                'Lamar County',
                'Lamar County',
                'Unavailable',
                'Sumrall solar farm',
                'DEPCOM Power',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                52,
                'North America',
                'Lamar County',
                'Lamar County',
                'Unavailable',
                'Sumrall solar farm',
                'DEPCOM Power',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                62,
                'North America',
                'Currituck County',
                'Currituck County',
                'Unavailable',
                'Summit Farms Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Summer Solar',
                'Sustainable Power Group, LLC',
                'FTP Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Cochise County',
                'Cochise County',
                'Unavailable',
                'Sulphur Springs solar farm',
                'SunPower',
                'SunPower',
              ],
              [
                'United States',
                60,
                'North America',
                'Yadkinville',
                'Yadkin County',
                'Unavailable',
                'Sugar Solar',
                'Pine Gate Renewables',
                'Pine Gate Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Seneca County',
                'Seneca Falls',
                'Suffragette solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                81,
                'North America',
                'Arkansas County',
                'Arkansas County',
                'Unavailable',
                'Stuttgart Solar',
                'Entergy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Stroud Solar Station',
                'Pacific Gas & Electric Co.',
                'Pacific Gas & Electric Co.',
              ],
              [
                'United States',
                150,
                'North America',
                'Hassayampa',
                'Maricopa County',
                'Unavailable',
                'Sun Streams 2 solar farm',
                'Longroad Energy',
                'Longroad Energy',
              ],
              [
                'United States',
                88,
                'North America',
                'Coolidge',
                'Pinal County',
                'Unavailable',
                'Storey Solar Energy',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'King William County',
                'Unavailable',
                'Sweet Sue Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                92,
                'North America',
                'Sweetwater County',
                'Sweetwater County',
                'Unavailable',
                'Sweetwater Solar',
                'Unknown',
                '174 Power Global',
              ],
              [
                'United States',
                109,
                'North America',
                'Unavailable',
                'Kennebec County',
                'Unavailable',
                'Three Corners Solar',
                'Longroad Energy',
                'Longroad Energy',
              ],
              [
                'United States',
                24,
                'North America',
                'Storey County',
                'Storey County',
                'Unavailable',
                'Tesla Gigafactory Rooftop Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Terrell County',
                'Terrell County',
                'Unavailable',
                'Terrell solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                160,
                'North America',
                'El Centro',
                'Imperial County',
                'Unavailable',
                'Tenaska Silverleaf Solar Energy Center',
                'Unknown',
                'Tenaska',
              ],
              [
                'United States',
                149,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Tenaska Imperial Solar Energy Center',
                'First Solar',
                'Tenaska',
              ],
              [
                'United States',
                129,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Tenaska Imperial Solar Energy Center',
                'First Solar',
                'Tenaska',
              ],
              [
                'United States',
                28,
                'North America',
                'Chappells',
                'Newberry County',
                'Unavailable',
                'Ten Governors Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Monroe County',
                'Monroe County',
                'Unavailable',
                'Temperance Solar',
                'National Grid Renewables',
                'National Grid Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Boulder City',
                'Clark County',
                'Unavailable',
                'Techren Solar',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                25,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Techren Solar',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                25,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Techren Solar',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                74,
                'North America',
                'Martin County',
                'Martin County',
                'Unavailable',
                'Sweetbay Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Techren Solar',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                75,
                'North America',
                'Cle Elum',
                'Kittitas County',
                'Unavailable',
                'Teanaway Solar Reserve',
                'Unknown',
                'Teanaway Solar Reserve',
              ],
              [
                'United States',
                74,
                'North America',
                'Orange County',
                'Orange County',
                'Unavailable',
                'Taylor Creek Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                148,
                'North America',
                'Taylor County',
                'Taylor County',
                'Unavailable',
                'Taylor County Solar',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                204,
                'North America',
                'Coyanosa',
                'Pecos County',
                'Unavailable',
                'Taygete Energy Project solar farm',
                '7X Energy, Inc.',
                '7X Energy',
              ],
              [
                'United States',
                255,
                'North America',
                'Coyanosa',
                'Pecos County',
                'Unavailable',
                'Taygete Energy Project solar farm',
                '7X Energy, Inc.',
                '7X Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Talladega County',
                'Unavailable',
                'Talladega Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Fort Plain',
                'Montgomery County',
                'Unavailable',
                'Tabletop Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'TA-High Desert solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Los Angeles County',
                'Los Angeles County',
                'Unavailable',
                'Ta-Acacia solar farm',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                42,
                'North America',
                'Gretna',
                'Pittsylvania County',
                'Unavailable',
                'Sycamore Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                117,
                'North America',
                'Unavailable',
                'Canberry County',
                'Unavailable',
                'Sycamore Creek Solar Project',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Techren Solar',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                39,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                23,
                'North America',
                'Rockford',
                'Surry County',
                'Unavailable',
                'Stony Knoll Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                112,
                'North America',
                'Unavailable',
                'Polk County',
                'Unavailable',
                'Stockton Lake solar farm',
                'Scout Clean Energy',
                'Scout Clean Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Inyo County',
                'Inyo County',
                'Unavailable',
                'Southern Owens Valley Solar Ranch',
                'Los Angeles Department of Water & Power',
                'Los Angeles Department of Water & Power',
              ],
              [
                'United States',
                300,
                'North America',
                'Moapa River Indian Re',
                'Clark County',
                'Unavailable',
                'Southern Bighorn Solar Hybrid',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Southampton County',
                'Southampton County',
                'Unavailable',
                'Southampton Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Clark County',
                'Unavailable',
                'South Ridge Solar',
                'Unknown',
                'First Solar',
              ],
              [
                'United States',
                500,
                'North America',
                'Lee County',
                'Lee County',
                'Unavailable',
                'South Dixon Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                500,
                'North America',
                'Elgin',
                'Comanche County',
                'Unavailable',
                'Sooner solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Fresno',
                'Fresno County',
                'Unavailable',
                'Sonrisa Solar',
                'Unknown',
                'EDP Renewables',
              ],
              [
                'United States',
                260,
                'North America',
                'Buckeye',
                'Maricopa County',
                'Unavailable',
                'Sonoran Energy Center solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Washington County',
                'Unavailable',
                'Somers Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                85,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Solverde 1 solar farm',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Isle of Wight County',
                'Unavailable',
                'Solidago Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Manatee County',
                'Manatee County',
                'Unavailable',
                'Southfork Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Sulfur Springs',
                'Hopkins County',
                'Unavailable',
                'Solemio solar farm',
                'Pattern Operators LP',
                'Pattern Energy',
              ],
              [
                'United States',
                56,
                'North America',
                'Crook County',
                'Crook County',
                'Unavailable',
                'Solar Star Oregon II',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                54,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star California',
                'SunPower',
                'SunPower',
              ],
              [
                'United States',
                52,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 2',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                44,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 2',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                48,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 2',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                56,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 2',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                60,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 2',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                64,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                33,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                58,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                54,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Solar Star 1',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                24,
                'North America',
                'Honolulu',
                'Honolulu',
                'Unavailable',
                'Solar Strong',
                'Unknown',
                'Forest City Military Communites; SolarCity',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Lyon County',
                'Unavailable',
                'Stonecrop Solar',
                'Unknown',
                'Copmetitive Power Ventures',
              ],
              [
                'United States',
                345,
                'North America',
                'Unavailable',
                'Wharton County',
                'Unavailable',
                'Space City Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                140,
                'North America',
                'Trinidad',
                'Las Animas County',
                'Unavailable',
                'Spanish Peaks Solar',
                'Juwi Inc',
                'Juwi Inc',
              ],
              [
                'United States',
                20,
                'North America',
                'Churchill County',
                'Churchill County',
                'Unavailable',
                'Stillwater Facility solar farm',
                'EGP Stillwater Solar PV II, LLC',
                'Enel Green Power',
              ],
              [
                'United States',
                22,
                'North America',
                'Churchill County',
                'Churchill County',
                'Unavailable',
                'Stillwater Facility solar farm',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'United States',
                600,
                'North America',
                'Lee County',
                'Lee County',
                'Unavailable',
                'Steward Creek Solar',
                'Unknown',
                'Hexagon Energy',
              ],
              [
                'United States',
                38,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                38,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                38,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                38,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                38,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                34,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                76,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Stateline Solar',
                'First Solar',
                'Southern Power; Capital Dynamics',
              ],
              [
                'United States',
                290,
                'North America',
                'Harquahala Valley',
                'Maricopa County',
                'Unavailable',
                'Starwood Solar',
                'Unknown',
                'Starwood Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Chilton',
                'Falls County',
                'Unavailable',
                'Spanish Crown solar farm',
                'OCI Solar Power',
                'OCI Solar Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Albemarle',
                'Stanly County',
                'Unavailable',
                'Stanly Solar',
                'Unknown',
                'Pine Gate Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Vacherie',
                'St James County',
                'Unavailable',
                'St. James Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Lancaster',
                'Garrard County',
                'Unavailable',
                'Sr Turkey Creek Solar',
                'Unknown',
                'Carolina Solar Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Jeff Davis County',
                'Jeff Davis County',
                'Unavailable',
                'Sr Hazlehurst solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Lomira',
                'Dodge County',
                'Unavailable',
                'Springfield Solar Project',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                90,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Springbok solar farm',
                'Unknown',
                'Capital Dynamics; 8minute Energy',
              ],
              [
                'United States',
                155,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Springbok solar farm',
                '8minute Solar',
                'Capital Dynamics; 8minute Energy',
              ],
              [
                'United States',
                105,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Springbok solar farm',
                '8minute Solar',
                'Capital Dynamics; 8minute Energy',
              ],
              [
                'United States',
                98,
                'North America',
                'Surry County',
                'Surry County',
                'Unavailable',
                'Spring Grove I solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                23,
                'North America',
                'Midland',
                'Cabarrus County',
                'Unavailable',
                'Speedway Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Spectrum Solar Power Project',
                'Southern Power Co',
                'Southern Power; Turner Renewable Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Pawnee',
                'Bee County',
                'Unavailable',
                'Sparta Solar',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                20,
                'North America',
                'Granger',
                'St Joseph County',
                'Unavailable',
                'St. Joseph Solar',
                'Indiana Michigan Power Co',
                'Indiana Michigan Power Co',
              ],
              [
                'United States',
                20,
                'North America',
                'Do\u00f1a Ana County',
                'Do\u00f1a Ana County',
                'Unavailable',
                'Roadrunner (Clearway) solar farm',
                'First Solar',
                'Clearway Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Riverton',
                'Fremont County',
                'Unavailable',
                'Riverton Legend solar farm',
                'Unknown',
                'Legend Inc',
              ],
              [
                'United States',
                200,
                'North America',
                'Modoc',
                'Randolph County',
                'Unavailable',
                'Riverstart Solar Park',
                'EDP Renewables',
                'Connor Clark & Lunn Infrastructure [80%]; EDP Renewables [20%]',
              ],
              [
                'United States',
                40,
                'North America',
                'Oakboro',
                'Stanly County',
                'Unavailable',
                'Oakboro solar farm',
                'Ecoplexus',
                'Ecoplexus',
              ],
              [
                'United States',
                104,
                'North America',
                'Moyock',
                'Currituck County',
                'Unavailable',
                'Oak Trail Solar',
                'Unknown',
                'First Solar',
              ],
              [
                'United States',
                391,
                'North America',
                'Henderson',
                'Rusk County',
                'Unavailable',
                'Oak Hill - Dry Creek solar farm',
                'Renewable Energy Ventures LLC',
                'Vistra Energy',
              ],
              [
                'United States',
                24,
                'North America',
                'Fitchburg',
                'Dane County',
                'Unavailable',
                "O'Brien solar farm",
                'Unknown',
                'Madison Gas & Electric Co',
              ],
              [
                'United States',
                30,
                'North America',
                'Unavailable',
                'Montrose County',
                'Unavailable',
                'Nucla Substation solar farm',
                'Unknown',
                'Ute Peak Solar; Standard Solar',
              ],
              [
                'United States',
                324,
                'North America',
                'Lynndyl',
                'Millard County',
                'Unavailable',
                'Notch Peak Solar',
                'Bay Wa.r.e',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                125,
                'North America',
                'Bronte',
                'Runnels County',
                'Unavailable',
                'Norton solar farm (United States)',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Baker County',
                'Baker County',
                'Unavailable',
                'Northern Preserve Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                96,
                'North America',
                'Unavailable',
                'Marion County',
                'Unavailable',
                'Northern Bobwhite Solar Project',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                62,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'North Star (Southern Power) solar farm',
                'First Solar',
                'Southern Power; First Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Chisago County',
                'Chisago County',
                'Unavailable',
                'North Star (D.E. Shaw) Solar Project',
                'D.E Shaw Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Ector County',
                'Ector County',
                'Unavailable',
                'Oberon (174 Power) solar farm',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                151,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'North Rosamond Solar',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                27,
                'North America',
                'Unavailable',
                'Halifax County',
                'Unavailable',
                'North Halifax solar farm',
                'Unknown',
                'PSEG Solar Source',
              ],
              [
                'United States',
                20,
                'North America',
                'Halifax County',
                'Halifax County',
                'Unavailable',
                'North 301 Solar',
                'Unknown',
                'O2 emc',
              ],
              [
                'United States',
                20,
                'North America',
                'Williamsburg',
                'James City County',
                'Unavailable',
                'Norge solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Pendleton',
                'Umatilla County',
                'Unavailable',
                'Nolin Hills solar farm',
                'Capital Power',
                'Capital Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Nokesville',
                'Prince William County',
                'Unavailable',
                'Nokesville solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                500,
                'North America',
                'Esmeralda County',
                'Esmeralda County',
                'Unavailable',
                'Nivtoc Solar Energy Project',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                55,
                'North America',
                'Niland',
                'Imperial County',
                'Unavailable',
                'Niland solar farm',
                'Unknown',
                'Los Angeles Department of Water & Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'Nicolis Solar Pv Plant',
                'Coronal Group',
                'Coronal Energy',
              ],
              [
                'United States',
                52,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Newton solar farm',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                29,
                'North America',
                'Unavailable',
                'Baker County',
                'Unavailable',
                'Newton Solar',
                'Unknown',
                'Capital Power',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Pulaski County',
                'Unavailable',
                'New River Valley Solar Project',
                'Hecate Energy',
                'Hecate Energy; AgriSun Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'North Lancaster Ranch solar farm',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'New Orleans',
                'Orleans Parish',
                'Unavailable',
                'New Orleans Solar Station',
                'Entergy New Orleans, LLC',
                'Entergy',
              ],
              [
                'United States',
                30,
                'North America',
                'Ector County',
                'Ector County',
                'Unavailable',
                'Oberon (174 Power) solar farm',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                100,
                'North America',
                'Obion',
                'Obion County',
                'Unavailable',
                'Obion County solar farm',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                65,
                'North America',
                'Beloit',
                'Rock County',
                'Unavailable',
                'Paddock Solar Project',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Mountrail County',
                'Unavailable',
                'Otter Tail solar farm',
                'Unknown',
                'Otter Tail Power Company',
              ],
              [
                'United States',
                60,
                'North America',
                'Chase City',
                'Mecklenburg County',
                'Unavailable',
                'Otter Creek Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Merced County',
                'Unavailable',
                'Oro Loma solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Orleans County',
                'Unavailable',
                'Orleans Solar',
                'Unknown',
                'AES Corporation',
              ],
              [
                'United States',
                60,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Ord Mountain Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Ada County',
                'Ada County',
                'Unavailable',
                'Orchard Ranch Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Orangeburg County',
                'Unavailable',
                'Orangeburg South Solar Project',
                'Unknown',
                'Macquarie Group',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Orangeburg County',
                'Unavailable',
                'Orange County Solar Project',
                'Unknown',
                'Macquarie Group',
              ],
              [
                'United States',
                74,
                'North America',
                'Vero Beach',
                'Indian River County',
                'Unavailable',
                'Orange Blossom Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Holland',
                'Sheboygan County',
                'Unavailable',
                'Onion River Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                500,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Oberon (Intersect) solar farm',
                'Unknown',
                'Intersect Power',
              ],
              [
                'United States',
                35,
                'North America',
                'Statesville',
                'Iredell County',
                'Unavailable',
                'Olin Creek Farm Solar',
                'Ecoplexus',
                'Carolina Solar Energy; Ecoplexus',
              ],
              [
                'United States',
                206,
                'North America',
                'Unavailable',
                'Jackson County',
                'Unavailable',
                'Old Hickory Solar',
                'Unknown',
                'Pattern Energy',
              ],
              [
                'United States',
                430,
                'North America',
                'Needville',
                'Fort Bend County',
                'Unavailable',
                'Old 300 Solar Center',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                59,
                'North America',
                'Vernon',
                'Franklin County',
                'Unavailable',
                'Oklaunion solar farm',
                'Unknown',
                'Fontier Solar Holdings',
              ],
              [
                'United States',
                74,
                'North America',
                'Indian River County',
                'Okeechobee County',
                'Unavailable',
                'Okeechobee Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Lowndes',
                'Lowndes County',
                'Unavailable',
                'OE_MS5 solar farm',
                'Unknown',
                'Origis Energy; Tennessee Valley Authority',
              ],
              [
                'United States',
                58,
                'North America',
                'Mitchell County',
                'Mitchell County',
                'Unavailable',
                'Oe_Ga3 solar farm',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                32,
                'North America',
                'La Paz County',
                'La Paz County',
                'Unavailable',
                'Oe_Az1 solar farm',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Wing',
                'Covington County',
                'Unavailable',
                'OE_ALD solar farm',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Colquitt County',
                'Colquitt County',
                'Unavailable',
                'Odom solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                200,
                'North America',
                'Knippa',
                'Uvalde County',
                'Unavailable',
                'Oci Sunray solar farm',
                'OCI Solar Power',
                'OCI Solar Power',
              ],
              [
                'United States',
                400,
                'North America',
                'Fort Rock',
                'Lake County',
                'Unavailable',
                'Obsidian Solar Center',
                'Obsidian Solar Center LLC',
                'Obsidian Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Old River One solar farm',
                'Dominion Energy',
                'Dominion Energy [67.0%]; SunEdison LLC [33.0%]',
              ],
              [
                'United States',
                74,
                'North America',
                'Palm Bay',
                'Brevard County',
                'Unavailable',
                'Palm Bay Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Sardinia',
                'Highland County',
                'Unavailable',
                'New Market (Ohio) solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Dorchester County',
                'Dorchester County',
                'Unavailable',
                'New Market (Maryland) solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                247,
                'North America',
                'McCamey',
                'Upton County',
                'Unavailable',
                'Morada Del Sol solar farm',
                'First Solar',
                'Unknown',
              ],
              [
                'United States',
                79,
                'North America',
                'Unavailable',
                'Hancock County',
                'Unavailable',
                'Moonshot Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                127,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Moonlight Flats Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Richmond County',
                'Unavailable',
                'Moon Center solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Lowndes County',
                'Lowndes County',
                'Unavailable',
                'Moody Air Force Base Solar',
                'Georgia Power',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Westmoreland County',
                'Westmoreland County',
                'Unavailable',
                'Montross Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Columbia County',
                'Columbia County',
                'Unavailable',
                'Montour Solar One',
                'BQ Energy',
                'BQ Energy; Talen Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Montgomery County',
                'Montgomery County',
                'Unavailable',
                'Montgomery Solar',
                'Unknown',
                'O2 emc',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Yellowstone County',
                'Unavailable',
                'Montana Sun Solar',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                162,
                'North America',
                'Arlington',
                'Gilliam County',
                'Unavailable',
                'Montague Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                55,
                'North America',
                'Monroe',
                'Union County',
                'Unavailable',
                'Monroe Solar Facility',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                94,
                'North America',
                'Unavailable',
                'Burns County',
                'Allegany',
                'Moraine solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                90,
                'North America',
                'Canajoharie',
                'Montgomery County',
                'Unavailable',
                'Mohawk Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                360,
                'North America',
                'Unavailable',
                'Clarke County',
                'Unavailable',
                'Mohave Green Center solar farm',
                'Unknown',
                'ENN Group',
              ],
              [
                'United States',
                71,
                'North America',
                'Jasper County',
                'Jasper County',
                'Unavailable',
                'Moffett Solar Project',
                'Strata Solar',
                'Dominion Energy',
              ],
              [
                'United States',
                400,
                'North America',
                'Brookston',
                'Lamar County',
                'Unavailable',
                'Mockingbird Solar Center',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                250,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Moapa Southern Paiute solar farm',
                'First Solar',
                'Capital Dynamics; Goldman Sachs',
              ],
              [
                'United States',
                25,
                'North America',
                'Tracy',
                'Lyon County',
                'Unavailable',
                'Mn (Tracy) solar farm',
                'Unknown',
                'Xcel Energy',
              ],
              [
                'United States',
                517,
                'North America',
                'Childress County',
                'Childress County',
                'Unavailable',
                'Misae Solar',
                'Unknown',
                'Copenhagen Infrastructure Partners',
              ],
              [
                'United States',
                240,
                'North America',
                'Childress County',
                'Childress County',
                'Unavailable',
                'Misae Solar',
                'Unknown',
                'Copenhagen Infrastructure Partners',
              ],
              [
                'United States',
                402,
                'North America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Mineral Basin Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Milo',
                'Piscataquis County',
                'Unavailable',
                'Milo solar farm',
                'Unknown',
                'BNRG Renewables',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Kent County',
                'Unavailable',
                'Mills Branch solar farm',
                'Unknown',
                'Apex Clean Energy',
              ],
              [
                'United States',
                53,
                'North America',
                'Millington',
                'Shelby County',
                'Unavailable',
                'Millington solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                360,
                'North America',
                'Unavailable',
                'Clarke County',
                'Unavailable',
                'Mohave Green Center solar farm',
                'Unknown',
                'ENN Group',
              ],
              [
                'United States',
                65,
                'North America',
                'Sardinia',
                'Highland County',
                'Unavailable',
                'New Market (Ohio) solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Pasquotank County',
                'Pasquotank County',
                'Unavailable',
                "Morgan'S Corner solar farm",
                'Virginia Electric & Power Co',
                'Dominion Energy',
              ],
              [
                'United States',
                177,
                'North America',
                'Unavailable',
                'Livingston County',
                'Mount Morris',
                'Morris Ridge solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Providence Forge',
                'New Kent County',
                'Unavailable',
                'New Kent solar farm',
                'Energix Renewable Energy',
                'Energix Renewable Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Brown County',
                'Unavailable',
                'Nestlewood Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                250,
                'North America',
                'Boone',
                'Pueblo County',
                'Unavailable',
                'Neptune Energy Center Hybrid solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Cabarrus County',
                'Cabarrus County',
                'Unavailable',
                'Nc 102 Solar',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Swisher County',
                'Unavailable',
                'Nazareth Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                21,
                'North America',
                'Middletown',
                'Newport County',
                'Unavailable',
                'Naval Station Newport solar farm',
                'Navy and Solar Breakers',
                'Navy and Solar Breakers',
              ],
              [
                'United States',
                74,
                'North America',
                'Nassau County',
                'Nassau County',
                'Unavailable',
                'Nassau Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Millvile County',
                'Unavailable',
                'Nabb Solar',
                'Unknown',
                'Dakota Power Partners',
              ],
              [
                'United States',
                50,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Mustang Two solar farm',
                'Idemitsu Renewables',
                'Idemitsu Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Mustang Two solar farm',
                'Idemitsu Renewables',
                'Idemitsu Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Mustang solar farm',
                'Goldman Sachs Renewable Power Group',
                'Goldman Sachs Renewable Power Group',
              ],
              [
                'United States',
                45,
                'North America',
                'Unavailable',
                'Kent County',
                'Unavailable',
                'Morgnec Road Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                227,
                'North America',
                'Cherokee',
                'Colbert County',
                'Unavailable',
                'Muscle Shoals solar farm',
                '\u00d8rsted',
                '\u00d8rsted',
              ],
              [
                'United States',
                80,
                'North America',
                'Billings',
                'Yellowstone County',
                'Unavailable',
                'Mt. Sun solar farm',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                26,
                'North America',
                'Mount Olive',
                'Morris County',
                'Unavailable',
                'Mt. Olive Solar Field',
                'Unknown',
                'CEP Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Elmore County',
                'Elmore County',
                'Unavailable',
                'Mt. Home Solar',
                'Standard Solar',
                'Standard Solar',
              ],
              [
                'United States',
                52,
                'North America',
                'Dade City',
                'Pasco County',
                'Unavailable',
                'Mountain View (Tampa) solar farm',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                20,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Mountain View (NextEra) solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                34,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Mount Solar Farm',
                'Unknown',
                'Silver Ridge Power',
              ],
              [
                'United States',
                65,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Mount Solar Farm',
                'Unknown',
                'Silver Ridge Power',
              ],
              [
                'United States',
                101,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Mount Solar Farm',
                'Unknown',
                'Silver Ridge Power',
              ],
              [
                'United States',
                252,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Mount Solar Farm',
                'Unknown',
                'Silver Ridge Power',
              ],
              [
                'United States',
                154,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Mount Solar Farm',
                'Unknown',
                'Silver Ridge Power',
              ],
              [
                'United States',
                504,
                'North America',
                'Unavailable',
                'Maricopa County',
                'Unavailable',
                'Moss Solar',
                'Unknown',
                'FTC Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Owyhee County',
                'Owyhee County',
                'Unavailable',
                'Murphy Flat Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                60,
                'North America',
                'El Paso County',
                'El Paso County',
                'Unavailable',
                'Palmer Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Orangeburg County',
                'Orangeburg County',
                'Unavailable',
                'Palmetto Plains solar farm',
                'Cypress Creek Renewables',
                'Cubico USA',
              ],
              [
                'United States',
                200,
                'North America',
                'Dodsonville',
                'Highland County',
                'Unavailable',
                'Palomino Solar',
                'Unknown',
                'Innergex',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Clark County',
                'Unavailable',
                'Red Flats Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                500,
                'North America',
                'Page',
                'Coconino County',
                'Unavailable',
                'Red Antelope Solar & Energy Storage Farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                135,
                'North America',
                'La Feria',
                'Cameron County',
                'Unavailable',
                'Rayos Del Sol Solar Project',
                '174 Power Global',
                '174 Power Global [50%]; TotalEnergies [50%]',
              ],
              [
                'United States',
                22,
                'North America',
                'Wellington',
                'Larimer County',
                'Unavailable',
                'Rawhide Prairie Solar Hybrid',
                'Greenbacker Energy',
                'Greenbacker Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Knox County',
                'Unavailable',
                'Ratts solar farm',
                'Unknown',
                'Arevon; Tenaska',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Pike County',
                'Unavailable',
                'Ratts solar farm',
                'Unknown',
                'Arevon; Tenaska',
              ],
              [
                'United States',
                80,
                'North America',
                'Dillon',
                'Beaverhead County',
                'Unavailable',
                'Rattlesnake Solar',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Brooksville County',
                'Unavailable',
                'Rattler Solar Power Plant',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                160,
                'North America',
                'Twin Cities',
                'Sacramento County',
                'Unavailable',
                'Rancho Seco Solar II',
                'SMUD',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                60,
                'North America',
                'Currituck County',
                'Currituck County',
                'Unavailable',
                'Ranchland Solar',
                'Unknown',
                'Sunenergy',
              ],
              [
                'United States',
                500,
                'North America',
                'Danevang',
                'Wharton County',
                'Unavailable',
                'Ramsey solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                51,
                'North America',
                'Cochise County',
                'Cochise County',
                'Unavailable',
                'Red Horse solar farm',
                'Unknown',
                'Renewable Energy Asset [50%]; Flera Infra [50%]',
              ],
              [
                'United States',
                200,
                'North America',
                'Tom Green County',
                'Tom Green County',
                'Unavailable',
                'Rambler solar farm',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Harrington',
                'Kent County',
                'Unavailable',
                'Raceway Solar',
                'Freepoint',
                'Freepoint',
              ],
              [
                'United States',
                100,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Rabbitbrush Solar',
                'First Solar',
                'Leeward Renewable Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Quitman',
                'Brooks County',
                'Unavailable',
                'Quitman Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                150,
                'North America',
                'Brooks County',
                'Brooks County',
                'Unavailable',
                'Quitman Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                108,
                'North America',
                'Merced County',
                'Merced County',
                'Unavailable',
                'Quinto Solar Pv Project',
                'SunPower',
                'SunPower',
              ],
              [
                'United States',
                49,
                'North America',
                'Canterbury',
                'Windham County',
                'Unavailable',
                'Quinebaug Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'Fairfax',
                'Allendale County',
                'Unavailable',
                'Quest Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                25,
                'North America',
                'Mocksville',
                'Davie County',
                'Unavailable',
                'Quail Holdings solar farm',
                'Unknown',
                'Birdseye Renewable Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'Sterling',
                'Windham County',
                'Unavailable',
                'Pure Hedge solar farm',
                'Unknown',
                'ReEnergy Holdings LLC [100%]',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Greensville County',
                'Unavailable',
                'Pumpkinseed Solar Project',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Pumpjack Solar I',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Brookesmith',
                'Brown County',
                'Unavailable',
                'Radian solar farm',
                'Intersect Power',
                'Intersect Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Lee Township',
                'Allegan County',
                'Unavailable',
                'Pullman Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                30,
                'North America',
                'Cochise County',
                'Cochise County',
                'Unavailable',
                'Red Horse solar farm',
                'Unknown',
                'Renewable Energy Asset [50%]; Flera Infra [50%]',
              ],
              [
                'United States',
                40,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'Red Rock solar farm',
                'Unknown',
                'Arizona Public Service',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Unavailable',
                'Riverside Solar Project',
                'Unknown',
                'AES Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Suffolk County',
                'Suffolk County',
                'Unavailable',
                'Riverhead solar farm',
                'Sustainable Power Group, LLC',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                75,
                'North America',
                'Lauderdale County',
                'Lauderdale County',
                'Unavailable',
                'River Bend Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                59,
                'North America',
                'Cooke County',
                'Cooke County',
                'Unavailable',
                'Rippey Solar',
                'Adapture Renewables, Inc.',
                'Adapture Renewables',
              ],
              [
                'United States',
                28,
                'North America',
                'Charles',
                'Charles County',
                'Unavailable',
                'Ripley Road solar farm',
                'Unknown',
                'Origis Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Rio Bravo Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Rio Bravo Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                500,
                'North America',
                'Oil City',
                'Carter County',
                'Unavailable',
                'Ringling solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                177,
                'North America',
                'Lake County',
                'Lake County',
                'Unavailable',
                'Ridgely Solar',
                'Unknown',
                'First Solar',
              ],
              [
                'United States',
                350,
                'North America',
                'Unavailable',
                'Niagara County',
                'Hartland',
                'Ridge View solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Spotsylvania County',
                'Spotsylvania County',
                'Unavailable',
                'Richmond Spider Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Humbolt County',
                'Unavailable',
                'Red House Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Twiggs County',
                'Twiggs County',
                'Unavailable',
                'Richland Solar Center',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                600,
                'North America',
                'Tonopah',
                'Esmeralda County',
                'Unavailable',
                'Rhyolite Ridge Solar Project',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                600,
                'North America',
                'Unavailable',
                'Esmeralda County',
                'Unavailable',
                'Rhyolite Ridge Solar Project',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Hardin County',
                'Unavailable',
                'Rhudes Creek Solar',
                'Unknown',
                'ibV Energy Partners',
              ],
              [
                'United States',
                20,
                'North America',
                'Marion',
                'Marion County',
                'Unavailable',
                'Rhubarb One solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                300,
                'North America',
                'Ducor',
                'Tulare County',
                'Unavailable',
                'Rexford solar farm',
                '8minute Solar',
                '8minute Solar',
              ],
              [
                'United States',
                138,
                'North America',
                'Boron',
                'San Bernardino County',
                'Unavailable',
                'Resurgence Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Fauquier County',
                'Fauquier County',
                'Unavailable',
                'Remington Solar Facility',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Regulus Solar Project',
                'TerraForm Power',
                'TerraForm Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Redwood 4 solar farm',
                '8minute Solar',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Clark County',
                'Unavailable',
                'Red Valley Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                350,
                'North America',
                'El Campo',
                'Wharton County',
                'Unavailable',
                'Red Tailed Hawk Solar',
                'Unknown',
                'J-Power USA; AP Solar Holdings',
              ],
              [
                'United States',
                240,
                'North America',
                'Unavailable',
                'St. Lawrence County',
                'Canton',
                'Rich Road solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                40,
                'North America',
                'Maui County',
                'Maui County',
                'Unavailable',
                'Pulehu Solar',
                'Longroad Energy',
                'Longroad Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                "Hawai'i County",
                'Unavailable',
                'Puako Solar',
                'Unknown',
                'Engie',
              ],
              [
                'United States',
                250,
                'North America',
                'Andrews',
                'Andrews County',
                'Unavailable',
                'Prospero Solar',
                'Longroad Energy',
                'Longroad Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Gladys',
                'Campbell County',
                'Unavailable',
                'Pigeon Run Solar Project',
                '174 Power Global',
                'Hanwha Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Wharton County',
                'Unavailable',
                'Pierce Ranch Solar',
                'Unknown',
                'AP Solar Holdings',
              ],
              [
                'United States',
                20,
                'North America',
                'Pima County',
                'Pima County',
                'Unavailable',
                'Picture Rocks Solar',
                'Goldman Sachs Renewable Power Group',
                'SunEdison',
              ],
              [
                'United States',
                83,
                'North America',
                'Bonham',
                'Fannin County',
                'Unavailable',
                'Phoenix Solar',
                'Pattern Operators LP',
                'Pattern Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Winkler County',
                'Winkler County',
                'Unavailable',
                'Phoebe Solar',
                'First Solar',
                'Innergex',
              ],
              [
                'United States',
                29,
                'North America',
                'Unavailable',
                'Pershing County',
                'Unavailable',
                'Pershing Solar',
                'Unknown',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                211,
                'North America',
                'Unavailable',
                'Pershing County',
                'Unavailable',
                'Pershing Solar',
                'Unknown',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                68,
                'North America',
                'Perry',
                'Houston County',
                'Unavailable',
                'Perry solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                39,
                'North America',
                'Orangeburg County',
                'Orangeburg County',
                'Unavailable',
                'Peony (Pine Gate) solar farm',
                'Pine Gate Renewables',
                'Pine Gates Renewables',
              ],
              [
                'United States',
                315,
                'North America',
                'Unavailable',
                'Greene County',
                'Unavailable',
                'Peony (Lightsource) solar farm',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                74,
                'North America',
                'Ft. Pierce',
                'St Lucie County',
                'Unavailable',
                'Pelican Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                175,
                'North America',
                'Fountain',
                'El Paso County',
                'Unavailable',
                'Pike Solar Project',
                'Unknown',
                'Juwi Inc',
              ],
              [
                'United States',
                75,
                'North America',
                'Northampton County',
                'Northampton County',
                'Unavailable',
                'Pecan Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Kramer Junction County',
                'Unavailable',
                'Peak Valley solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                55,
                'North America',
                'Polk County',
                'Polk County',
                'Unavailable',
                'Peace Creek Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                70,
                'North America',
                'Polk County',
                'Polk County',
                'Unavailable',
                'Payne Creek Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                30,
                'North America',
                'Taylor County',
                'Taylor County',
                'Unavailable',
                'Pawpaw Solar Plant',
                'Southern Power Co',
                'Southern Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Millard County',
                'Millard County',
                'Unavailable',
                'Pavant Solar 3',
                'AEP Renewables',
                'AEP Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Millard County',
                'Millard County',
                'Unavailable',
                'Pavant Solar 2',
                'PSEG Solar Source',
                'PSEG Solar Source',
              ],
              [
                'United States',
                50,
                'North America',
                'Millard County',
                'Millard County',
                'Unavailable',
                'Pavant Solar 1',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                50,
                'North America',
                'Elkin',
                'Surry County',
                'Unavailable',
                'Partin Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Kenosha County',
                'Unavailable',
                'Paris solar farm',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                1000,
                'North America',
                'Unavailable',
                'White Pine County',
                'Unavailable',
                'Pantheon Solar Project',
                'Unknown',
                'Arevia Power',
              ],
              [
                'United States',
                140,
                'North America',
                'San Benito County',
                'San Benito County',
                'Unavailable',
                'Panoche Valley solar farm',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                50,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Pearl Solar',
                'BHE Solar',
                'BHE Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Pinal County',
                'Pinal County',
                'Unavailable',
                'Pinal Central Energy Center Hybrid solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                85,
                'North America',
                'Pinckard',
                'Dale County',
                'Unavailable',
                'Pinckard Solar',
                'RWE Renewables Americas LLC',
                'Unknown',
              ],
              [
                'United States',
                80,
                'North America',
                'Clover',
                'Halifax County',
                'Unavailable',
                'Piney Creek Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Andrews County',
                'Andrews County',
                'Unavailable',
                'Prospero Solar',
                'Longroad Energy',
                'Longroad Energy; 7X Energy',
              ],
              [
                'United States',
                26,
                'North America',
                'Stuttgart',
                'Arkansas County',
                'Unavailable',
                'Producers Rice Mill solar farm',
                'Unknown',
                'Scenic Hill Solar',
              ],
              [
                'United States',
                46,
                'North America',
                'Prineville',
                'Crook County',
                'Unavailable',
                'Prineville Solar Energy',
                'Invenergy',
                'Cobank',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Cumberland County',
                'Unavailable',
                'Principal Sunrise Iv solar farm',
                'Unknown',
                'Principal Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Ashmore Township',
                'Coles County',
                'Unavailable',
                'Prairie Wolf Solar',
                'National Grid Renewables',
                'National Grid Renewables',
              ],
              [
                'United States',
                99,
                'North America',
                'Swanwick Township',
                'Perry County',
                'Unavailable',
                'Prairie State Solar Project',
                'Unknown',
                'Ranger Power',
              ],
              [
                'United States',
                150,
                'North America',
                'Sidney',
                'Champaign County',
                'Unavailable',
                'Prairie Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                360,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Prairie Dock Solar',
                'Unknown',
                'Competitive Power Ventures',
              ],
              [
                'United States',
                150,
                'North America',
                'Putnam County',
                'Putnam County',
                'Unavailable',
                'Powell Creek Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Posey County',
                'Unavailable',
                'Posey solar farm',
                'Unknown',
                'Arevon; Tenaska',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Portal Ridge Solar B',
                'D.E Shaw Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Sacramento',
                'Sacramento County',
                'Unavailable',
                'Port Of Sacramento solar farm',
                'Unknown',
                'OPDE Group',
              ],
              [
                'United States',
                40,
                'North America',
                'Unavailable',
                'Cape May County',
                'Unavailable',
                'Pole Top Solar',
                'Unknown',
                "Public Service Electric and Gas Company's (PSE&G)",
              ],
              [
                'United States',
                100,
                'North America',
                'Two Creeks',
                'Manitowoc County',
                'Unavailable',
                'Point Beach Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Osceola County',
                'Unavailable',
                'Poinsett Solar Facility',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Pocatello',
                'Power County',
                'Unavailable',
                'Pocatello Airport solar farm',
                'Unknown',
                'Solar One',
              ],
              [
                'United States',
                240,
                'North America',
                'Spotsylvania',
                'Spotsylvania County',
                'Unavailable',
                'Pleinmont Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                75,
                'North America',
                'Spotsylvania County',
                'Spotsylvania County',
                'Unavailable',
                'Pleinmont Solar',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Franklin County',
                'Unavailable',
                'Pleasant Prairie Solar Energy Center',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                20,
                'North America',
                'Pleasant Hill',
                'Northampton County',
                'Unavailable',
                'Pleasant Hill solar farm',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Playa Solar 2',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                79,
                'North America',
                'Clark County',
                'Clark County',
                'Unavailable',
                'Playa Solar 1',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Volusia County',
                'Volusia County',
                'Unavailable',
                'Pioneer Trail Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Bennett',
                'Adams County',
                'Unavailable',
                'Pioneer Solar',
                'Unknown',
                'CIT Group Inc.; Idemitsu Renewables',
              ],
              [
                'United States',
                26,
                'North America',
                'Woodruff',
                'Spartanburg County',
                'Unavailable',
                'Pinson solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                80,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Three Peaks Power solar farm',
                'Unknown',
                'Clenera',
              ],
              [
                'United States',
                100,
                'North America',
                'Cherryfield',
                'Hancock County',
                'Unavailable',
                'Three Rivers Solar Power',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                86,
                'North America',
                'Jeff Davis County',
                'Jeff Davis County',
                'Unavailable',
                'Snipesville solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                22,
                'North America',
                'Palmdale',
                'Los Angeles County',
                'Unavailable',
                'Tierra Bonita Solar',
                'Unknown',
                'Soitec Solar Development',
              ],
              [
                'United States',
                20,
                'North America',
                'San Diego County',
                'San Diego County',
                'Unavailable',
                'Jacumba solar farm',
                'AEP Renewables',
                'AEP Renewables',
              ],
              [
                'United States',
                75,
                'North America',
                'Mulberry',
                'Polk County',
                'Unavailable',
                'Jamison Solar',
                'Tampa Electric Co',
                'Ecoplexus',
              ],
              [
                'United States',
                49,
                'North America',
                'Unavailable',
                'Jarratt County',
                'Unavailable',
                'Jarratt Solar',
                'Unknown',
                'Torch Clean Energy',
              ],
              [
                'United States',
                101,
                'North America',
                'Colorado City',
                'Mitchell County',
                'Unavailable',
                'Jayhawk solar farm',
                'Luminant Generation Company LLC',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Jicarilla Apache',
                'Rio Arriba County',
                'Unavailable',
                'Jicarilla Solar',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Rio Arriba County',
                'Unavailable',
                'Jicarilla Solar',
                'Unknown',
                'PNM',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Northampton County',
                'Unavailable',
                'Johannes Gutenberg solar farm',
                'Unknown',
                'Geenex Energy LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Stanton County',
                'Stanton County',
                'Unavailable',
                'Johnson Corner Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Joshua Tree County',
                'Unavailable',
                'Joshua Tree solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                101,
                'North America',
                'Unavailable',
                'Weston County',
                'Unavailable',
                'Juliet Solar Energy',
                'Unknown',
                '7X Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Lee County',
                'Unavailable',
                'Junction Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Jacksonville',
                'Duval County',
                'Unavailable',
                'Jacksonville 5 Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                66,
                'North America',
                'Cheraw',
                'Chesterfield County',
                'Unavailable',
                'Juniper Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                141,
                'North America',
                'Lamesa',
                'Borden County',
                'Unavailable',
                'Juno Solar Project',
                'SOLV',
                'SoftBank Energy',
              ],
              [
                'United States',
                90,
                'North America',
                'Jacumba Hot Springs',
                'San Diego County',
                'Unavailable',
                'Jvr Energy Park solar farm',
                'Unknown',
                'Bay Wa.r.e',
              ],
              [
                'United States',
                310,
                'North America',
                'Unavailable',
                'Merrick County',
                'Unavailable',
                'K-Junction Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Maui',
                'Maui County',
                'Unavailable',
                'Kahana Solar',
                'Unknown',
                'Innergex',
              ],
              [
                'United States',
                40,
                'North America',
                'Maui County',
                'Maui County',
                'Unavailable',
                'Kamaole Solar',
                'Unknown',
                'Potentia Renewable Development; Peg Gen Holdings',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Kansas Solar',
                'Dominion Energy',
                'Dominion Energy [67.0%]; SunEdison LLC [33.0%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Kansas South solar farm',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                49,
                'North America',
                'Honolulu County',
                'Honolulu County',
                'Unavailable',
                'Kawailoa Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                27,
                'North America',
                'Coconino County',
                'Navajo County',
                'Unavailable',
                'Kayenta Solar Project',
                'Navajo Tribal Utility Authority',
                'Navajo Tribal Utility Authority',
              ],
              [
                'United States',
                28,
                'North America',
                'Coconino County',
                'Navajo County',
                'Unavailable',
                'Kayenta Solar Project',
                'Navajo Tribal Utility Authority',
                'Navajo Tribal Utility Authority',
              ],
              [
                'United States',
                20,
                'North America',
                'Bertie County',
                'Bertie County',
                'Unavailable',
                'Kelford solar farm',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                159,
                'North America',
                'Lamesa',
                'Borden County',
                'Unavailable',
                'Juno Solar Project',
                'SOLV',
                'SoftBank Energy',
              ],
              [
                'United States',
                59,
                'North America',
                'Van Zandt County',
                'Van Zandt County',
                'Unavailable',
                'Kellam Solar',
                'Unknown',
                'Hanwha Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Jacksonville',
                'Duval County',
                'Unavailable',
                'Jacksonville 5 Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Jacksonville',
                'Duval County',
                'Unavailable',
                'Jacksonville 5 Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                35,
                'North America',
                'Moorseburg',
                'Cleveland County',
                'Unavailable',
                'Innovative Solar 33',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Jackson Springs',
                'Richmond County',
                'Unavailable',
                'Innovative Solar 34',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Unavailable',
                'Brunswick County',
                'Unavailable',
                'Innovative Solar 36',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Anson County',
                'Anson County',
                'Unavailable',
                'Innovative Solar 37',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Unavailable',
                'Duplin County',
                'Unavailable',
                'Innovative Solar 38',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                48,
                'North America',
                'Unavailable',
                'Bladen County',
                'Unavailable',
                'Innovative Solar 41',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                71,
                'North America',
                'Cumberland County',
                'Cumberland County',
                'Unavailable',
                'Innovative Solar 42',
                'Unknown',
                'Falck Renewables',
              ],
              [
                'United States',
                51,
                'North America',
                'Bladen County',
                'Bladen County',
                'Unavailable',
                'Innovative Solar 43',
                'Cypress Creek Renewables',
                'Unknown',
              ],
              [
                'United States',
                78,
                'North America',
                'Cumberland County',
                'Cumberland County',
                'Unavailable',
                'Innovative Solar 46',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                34,
                'North America',
                'Robeson County',
                'Robeson County',
                'Unavailable',
                'Innovative Solar 47',
                'Innovative Solar 47, LLC',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Lenoir County',
                'Lenoir County',
                'Unavailable',
                'Innovative Solar 54',
                'John Laing US Solar Corp.',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Jacksonville',
                'Duval County',
                'Unavailable',
                'Jacksonville 5 Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                33,
                'North America',
                'Pender County',
                'Pender County',
                'Unavailable',
                'Innovative Solar 67',
                'John Laing US Solar Corp.',
                'Unknown',
              ],
              [
                'United States',
                50,
                'North America',
                'Franklinton',
                'Washington County',
                'Unavailable',
                'Iris Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Humboldt County',
                'Unavailable',
                'Iron Point Solar Porject',
                'Primergy',
                'Avangrid Renewables; Primergy Solar',
              ],
              [
                'United States',
                80,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Iron Springs Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Jones County',
                'Unavailable',
                'Is206 solar farm',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                125,
                'North America',
                'Unavailable',
                'Fisher County',
                'Unavailable',
                'Is245 solar farm',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                85,
                'North America',
                'Unavailable',
                'Medina County',
                'Unavailable',
                'Is408 solar farm',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                180,
                'North America',
                'Unavailable',
                'Castro County',
                'Unavailable',
                'Is416 solar farm',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                50,
                'North America',
                'Dawson County',
                'Dawson County',
                'Unavailable',
                'Ivory solar farm',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                120,
                'North America',
                'Twin Falls',
                'Twin Falls County',
                'Unavailable',
                'Jackpot Solar',
                'Unknown',
                'Jackpot Holdings',
              ],
              [
                'United States',
                125,
                'North America',
                'Jackson',
                'Jackson County',
                'Unavailable',
                'Jackson Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Jacksonville',
                'Duval County',
                'Unavailable',
                'Jacksonville 5 Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Saint Lucie County',
                'Saint Lucie County',
                'Unavailable',
                'Interstate Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Bladen County',
                'Bladen County',
                'Unavailable',
                'Innovative Solar 31',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                135,
                'North America',
                'Summitville',
                'Franklin County',
                'Franklin',
                'Kensington Solar Project',
                'Unknown',
                'Liberty Power',
              ],
              [
                'United States',
                22,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Kettleman (Avangrid) solar farm',
                'Avangrid Renewables',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Axton',
                'Henry County',
                'Unavailable',
                'Leatherwood solar farm',
                'Unknown',
                'Energix Renewable Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Keymar',
                'Frederick County',
                'Unavailable',
                'Legore Bridge Solar Center',
                'Unknown',
                'Coronal Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Montgomery',
                'Montgomery County',
                'Unavailable',
                'Letohatchee solar farm',
                'Unknown',
                'Alabama Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Lewiston',
                'Androscoggin County',
                'Unavailable',
                'Lewiston Solar',
                'Unknown',
                'North Light Energy; D.E Shaw Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Berlin',
                'Worcester County',
                'Unavailable',
                'Libertytown Road solar farm',
                'Unknown',
                'Longveiw Solar',
              ],
              [
                'United States',
                700,
                'North America',
                'Unavailable',
                'Mineral County',
                'Unavailable',
                'Libra Solar',
                'Unknown',
                'Arevia Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Walnut Cove',
                'Stokes County',
                'Unavailable',
                'Lick Creek Solar',
                'FLS Energy',
                'FLS Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Petersburg',
                'Dinwiddie County',
                'Unavailable',
                'Lily Pond Solar',
                'Energix Renewable Energy',
                'Energix Renewable Energy',
              ],
              [
                'United States',
                70,
                'North America',
                'Allendale County',
                'Allendale County',
                'Unavailable',
                'Lily Solar',
                'X-Elio North America Inc',
                'X-Elio',
              ],
              [
                'United States',
                181,
                'North America',
                'Scurry',
                'Kaufman County',
                'Unavailable',
                'Lily Solar Hybrid',
                'Enel Green Power',
                'Enel Green Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Johnstown',
                'Fulton County',
                'Unavailable',
                'Limestone Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                100,
                'North America',
                'Andrews County',
                'Andrews County',
                'Unavailable',
                'Lapetus solar farm',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Hillsborough County',
                'Hillsborough County',
                'Unavailable',
                'Lithia Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Little Bear solar farm',
                'First Solar',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Little Bear solar farm',
                'Longroad Energy',
                'Longroad Energy [50%]; PKA [25%]; PenSam [25%]',
              ],
              [
                'United States',
                50,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Little Bear solar farm',
                'Longroad Energy',
                'Longroad Energy [50%]; PKA [25%]; PenSam [25%]',
              ],
              [
                'United States',
                50,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Little Bear solar farm',
                'Longroad Energy',
                'Longroad Energy [50%]; PKA [25%]; PenSam [25%]',
              ],
              [
                'United States',
                74,
                'North America',
                'Hillsborough County',
                'Hillsborough County',
                'Unavailable',
                'Little Manatee River Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                51,
                'North America',
                'Candler County',
                'Candler County',
                'Unavailable',
                'Live Oak Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'Ashland',
                'Aroostook County',
                'Unavailable',
                'Livermore Falls Solar',
                'Unknown',
                'North Light Energy; D.E Shaw Renewables',
              ],
              [
                'United States',
                160,
                'North America',
                'Unavailable',
                'Hinkley County',
                'Unavailable',
                'Lockhart Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Hinkley County',
                'San Bernadino',
                'Lockhart Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Saint Lucie County',
                'Saint Lucie County',
                'Unavailable',
                'Loggerhead Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Madison County',
                'Unavailable',
                'Lone Oak solar farm',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                40,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Little Bear solar farm',
                'Longroad Energy',
                'Longroad Energy [50%]; PKA [25%]; PenSam [25%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Kent South solar farm',
                'Dominion Energy',
                'Dominion Energy [67.0%]; SunEdison LLC [33.0%]',
              ],
              [
                'United States',
                22,
                'North America',
                'San Diego County',
                'San Diego County',
                'Unavailable',
                'Laneast solar farm',
                'Unknown',
                'Soitec Solar Development',
              ],
              [
                'United States',
                100,
                'North America',
                'Dawson County',
                'Dawson County',
                'Unavailable',
                'Lamesa Solar',
                'Southern Power Co',
                'BNB Lamesa Solar LLC',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Kettleman (Clenera) solar farm',
                'Clenera',
                'Clenera',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Kincaid Solar Fam',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Los Angeles County',
                'Unavailable',
                'Kingbird Solar',
                'CD Arevon USA, Inc.',
                '8point3 Operating Company LLC [70.0%]; State Street Bank and Trust Company [30.0%]',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Kingbird Solar',
                'CD Arevon USA, Inc.',
                '8point3 Operating Company LLC [70.0%]; State Street Bank and Trust Company [30.0%]',
              ],
              [
                'United States',
                30,
                'North America',
                'Camden County',
                'Camden County',
                'Unavailable',
                'Kings Bay Solar Facility',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                360,
                'North America',
                'El Centro',
                'Imperial County',
                'Unavailable',
                'Kingsley solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                175,
                'North America',
                'Unavailable',
                'Xenia County',
                'Unavailable',
                'Kingswood Solar',
                'Unknown',
                'Vesper Energy',
              ],
              [
                'United States',
                35,
                'North America',
                'Kittitas',
                'Kittitas County',
                'Unavailable',
                'Kittitas solar farm',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Christoval',
                'Tom Green County',
                'Unavailable',
                'Knickerbocker Solar',
                'Knickerbocker Solar LLC',
                'Knickerbocker Solar',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Dane County',
                'Unavailable',
                'Koshkonong Solar',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                70,
                'North America',
                'Unavailable',
                'Kramer Junction County',
                'San Bernardino',
                'Kramer North solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                80,
                'North America',
                'Arlington',
                'Randolph County',
                'Unavailable',
                'Lancaster Solar',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                130,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Kramer South solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                60,
                'North America',
                'Honolulu',
                'Honolulu County',
                'Unavailable',
                'Kupehau solar farm',
                '174 Power Global',
                'Hanwha Energy',
              ],
              [
                'United States',
                42,
                'North America',
                'Waipahu',
                'Honolulu County',
                'Unavailable',
                'Kupono Solar',
                'Pinnacle West Capital',
                'Pinnacle West Capital',
              ],
              [
                'United States',
                50,
                'North America',
                'West Baton Rouge Parish',
                'West Baton Rouge Parish',
                'Unavailable',
                'LA3 West Baton Rouge Solar Facility',
                'DEPCOM Power',
                'Helios Infrastructure',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Eagle Creek County',
                'Unavailable',
                'Lake County solar farm',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                50,
                'North America',
                'Polk County',
                'Polk County',
                'Unavailable',
                'Lake Hancock Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                45,
                'North America',
                'Highlands County',
                'Highlands County',
                'Unavailable',
                'Lake Placid Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                245,
                'North America',
                'Unavailable',
                'Blackford County',
                'Unavailable',
                'Lake Trout Solar Project',
                'Unknown',
                'EDF Renewables; Geenex',
              ],
              [
                'United States',
                74,
                'North America',
                'Okeechobee County',
                'Okeechobee County',
                'Unavailable',
                'Lakeside Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Georgetown County',
                'Unavailable',
                'Lambert solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Georgetown County',
                'Unavailable',
                'Lambert solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                102,
                'North America',
                'Dawson County',
                'Dawson County',
                'Unavailable',
                'Lamesa Solar',
                'Renewable Energy Systems',
                'Southern Power',
              ],
              [
                'United States',
                60,
                'North America',
                'Surry',
                'Surry County',
                'Unavailable',
                'Kruger Energy Mantura Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                66,
                'North America',
                'Cameron',
                'Calhoun County',
                'Unavailable',
                'Lone Star Solar',
                'Southern Current',
                'Southern Current',
              ],
              [
                'United States',
                125,
                'North America',
                'Unavailable',
                'Fisher County',
                'Unavailable',
                'Indigo Solar',
                'Unknown',
                'Innovative Solar',
              ],
              [
                'United States',
                74,
                'North America',
                'Indian River County',
                'Indian River County',
                'Unavailable',
                'Indian River Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Halifax County',
                'Halifax County',
                'Unavailable',
                'Halifax solar farm',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                42,
                'North America',
                'Greenville',
                'Hunt County',
                'Unavailable',
                'Hallmark solar farm',
                'Luminant Generation Company LLC',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Hamilton County',
                'Hamilton County',
                'Unavailable',
                'Hamilton Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Hendry County',
                'Hendry County',
                'Unavailable',
                'Hammock Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Hampton County',
                'Hampton County',
                'Unavailable',
                'Hampton Solar',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Hancock County',
                'Unavailable',
                'Hancock Co Solar',
                'Unknown',
                'Carlyle Group',
              ],
              [
                'United States',
                20,
                'North America',
                'Richland',
                'Benton County',
                'Unavailable',
                'Hanford 300 North solar farm',
                'Unknown',
                'Neoen',
              ],
              [
                'United States',
                75,
                'North America',
                'Washington',
                'Wilkes County',
                'Unavailable',
                'Happy Hollow Solar Center',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                95,
                'North America',
                'Searcy',
                'White County',
                'Unavailable',
                'Happy Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Hardee County',
                'Unavailable',
                'Hardee Solar',
                'Unknown',
                'National Solar Power',
              ],
              [
                'United States',
                150,
                'North America',
                'Alger',
                'Hardin County',
                'Unavailable',
                'Hardin Solar Energy',
                'Invenergy',
                'Dominion Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Waimea',
                'Hawaii County',
                'Unavailable',
                'Hale Kuawehi Solar Hybrid',
                'Unknown',
                'Innergex',
              ],
              [
                'United States',
                170,
                'North America',
                'Belle Center',
                'Hardin County',
                'Unavailable',
                'Hardin Solar Energy',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                195,
                'North America',
                'Unavailable',
                'Clinton County',
                'Unavailable',
                'Hardy Hills solar farm',
                'Unknown',
                'AES Corporation',
              ],
              [
                'United States',
                200,
                'North America',
                'Fargo',
                'Cass County',
                'Unavailable',
                'Harmony Plains Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Osceola County',
                'Osceola County',
                'Unavailable',
                'Harmony Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                65,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Harper Lake Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Apex',
                'Clark County',
                'Unavailable',
                'Harry Allen Solar Energy',
                'Invenergy',
                'AEP Renewables [75%]; Invenergy Renewables [25%]',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Oceana County',
                'Unavailable',
                'Hart Solar',
                'Unknown',
                'CMS Enterprises',
              ],
              [
                'United States',
                80,
                'North America',
                'Tarboro',
                'Edgecombe County',
                'Unavailable',
                'Harts Mill Solar',
                'Pine Gate Renewables',
                'CIT Group Inc.',
              ],
              [
                'United States',
                350,
                'North America',
                'Unavailable',
                'Licking County',
                'Unavailable',
                'Harvey Solar Project',
                'Unknown',
                'Open Road Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Navajo County',
                'Unavailable',
                'Hashknife Solar Energy Center',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                50,
                'North America',
                'Hattiesburg',
                'Forrest County',
                'Unavailable',
                'Hattiesburg solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                65,
                'North America',
                'Warrenton',
                'Warren County',
                'Unavailable',
                'Hawtree Solar',
                'Unknown',
                'Carolina Solar Energy',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Hardin County',
                'Unavailable',
                'Hardin Solar Energy',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                27,
                'North America',
                'Bakersfield',
                'Kern County',
                'Unavailable',
                'Hayworth Solar',
                '8minute Solar',
                'Sustainable Power Group, LLC',
              ],
              [
                'United States',
                80,
                'North America',
                'Northampton County',
                'Northampton County',
                'Unavailable',
                'Gutenberg Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Overstreet County',
                'Unavailable',
                'Gulf County solar farm',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Little Falls',
                'Herkimer County',
                'Unavailable',
                'Grassy Knoll Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                120,
                'North America',
                'Hartford County',
                'Hartford County',
                'Unavailable',
                'Gravel Pit Solar',
                'D.E Shaw Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                55,
                'North America',
                'Mohave County',
                'Mohave County',
                'Unavailable',
                'Gray Hawk Solar',
                'Swinerton Renewable Energy',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                35,
                'North America',
                'El Paso County',
                'El Paso County',
                'Unavailable',
                'Grazing Yak Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                255,
                'North America',
                'Girvin',
                'Pecos County',
                'Unavailable',
                'Greasewood solar farm',
                'Unknown',
                'Copenhagen Infrastructure Partners',
              ],
              [
                'United States',
                75,
                'North America',
                'Somerset County',
                'Somerset County',
                'Unavailable',
                'Great Bay Solar 1',
                'Unknown',
                'Pioneer Green Solar',
              ],
              [
                'United States',
                46,
                'North America',
                'Van Wert',
                'Van Wert County',
                'Unavailable',
                'Great Bear Solar',
                'Avangrid Renewables',
                'Unknown',
              ],
              [
                'United States',
                60,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Great Valley Solar Portfolio Holdings',
                'Sempra Energy',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Great Valley Solar Portfolio Holdings',
                'Sempra Energy',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Great Valley Solar Portfolio Holdings',
                'Sempra Energy',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                102,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Great Valley Solar Portfolio Holdings',
                'Sempra Energy',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                75,
                'North America',
                'Swansea',
                'Lexington County',
                'Unavailable',
                'Gunsight Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Andrscoggin County',
                'Unavailable',
                'Greene Apple Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                120,
                'North America',
                'Watertown',
                'Jefferson County',
                'Unavailable',
                'Greens Corners Solar',
                'Boralex',
                'Boralex',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Henry County',
                'Unavailable',
                'Greensboro Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                80,
                'North America',
                'Greensville County',
                'Greensville County',
                'Unavailable',
                'Greensville County Solar Project',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Culpeper County',
                'Unavailable',
                'Greenwood Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Greenwood County',
                'Unavailable',
                'Greenwood Township solar farm',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                56,
                'North America',
                'Grifton',
                'Pitt County',
                'Unavailable',
                'Grifton solar farm',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Guadalupe County',
                'Unavailable',
                'Guadalupe County solar farm',
                'Unknown',
                'Corporacion Gestamp',
              ],
              [
                'United States',
                20,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Guernsey Solar Station',
                'Pacific Gas & Electric Co.',
                'Pacific Gas & Electric Co.',
              ],
              [
                'United States',
                30,
                'North America',
                'Okaloosa County',
                'Okaloosa County',
                'Unavailable',
                'Gulf Coast Solar Center',
                'Unknown',
                'Panasonic; Gulf Power',
              ],
              [
                'United States',
                40,
                'North America',
                'Santa Rosa County',
                'Santa Rosa County',
                'Unavailable',
                'Gulf Coast Solar Center',
                'Unknown',
                'Panasonic; Gulf Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Escambia County',
                'Escambia County',
                'Unavailable',
                'Gulf Coast Solar Center',
                'Unknown',
                'Panasonic; Gulf Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Coxsackie',
                'Greene County',
                'Unavailable',
                'Greene County Solar Facility',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'White County',
                'Unavailable',
                'Indiana Crossroads solar farm',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                52,
                'North America',
                'Jeff Davis County',
                'Jeff Davis County',
                'Unavailable',
                'Hazlehurst solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                41,
                'North America',
                'Unavailable',
                'Manistee County',
                'Unavailable',
                'Heatherlands solar farm',
                'Unknown',
                'Greenbacker Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Fort Dodge',
                'Webster County',
                'Unavailable',
                'Holliday Creek Solar',
                'MidAmerican Energy Co',
                'EDF Renewables',
              ],
              [
                'United States',
                75,
                'North America',
                'Galivants Ferry',
                'Horry County',
                'Unavailable',
                'Holliday Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                200,
                'North America',
                'Nolan County',
                'Nolan County',
                'Unavailable',
                'Holstein 1 (Duke) solar farm',
                '8minute Solar',
                'Duke Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Scotland County',
                'Scotland County',
                'Unavailable',
                'Holstein Plant (Strata) solar farm',
                'Strata Solar',
                'Strata Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Holtwood',
                'Lancaster County',
                'Unavailable',
                'Holtwood Solar',
                'BQ Energy',
                'BQ Energy; Talen Energy',
              ],
              [
                'United States',
                90,
                'North America',
                'Homer',
                'Cortland County',
                'Unavailable',
                'Homer solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                52,
                'North America',
                'Alamosa County',
                'Alamosa County',
                'Unavailable',
                'Hooper Solar',
                'SunPower',
                'SunPower',
              ],
              [
                'United States',
                50,
                'North America',
                'Fergus Falls',
                'Otter Tail County',
                'Unavailable',
                'Hoot Lake Solar Project',
                'Unknown',
                'Otter Tail Power Company',
              ],
              [
                'United States',
                21,
                'North America',
                'Mitchell County',
                'Mitchell County',
                'Unavailable',
                'Hopeful Solar',
                'Capital Power',
                'Capital Power',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Hopkins County',
                'Unavailable',
                'Hopkins solar farm',
                'Engie',
                'Engie',
              ],
              [
                'United States',
                74,
                'North America',
                'Putnam County',
                'Putnam County',
                'Unavailable',
                'Horizon Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Holley',
                'Orleans County',
                'Unavailable',
                'Holley Road Solar',
                'Empire Community Solar LLC',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Gaston',
                'Gaston County',
                'Unavailable',
                'Hornet Solar',
                'Unknown',
                'Capital Power',
              ],
              [
                'United States',
                180,
                'North America',
                'Caledonia',
                'Livingston County',
                'Unavailable',
                'Horseshoe (Invenergy) solar farm',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                350,
                'North America',
                'Unavailable',
                'Humboldt County',
                'Unavailable',
                'Hot Pot Solar Project',
                'Primergy',
                'Avangrid Renewables; Primergy Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Clawson',
                'Emery County',
                'Unavailable',
                'Hunter Solar',
                'Swinerton Renewables',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Logan Store',
                'Rutherford County',
                'Unavailable',
                'Hunters Cove Solar',
                'Unknown',
                'Capital Power',
              ],
              [
                'United States',
                75,
                'North America',
                'Orangeburg County',
                'Orangeburg County',
                'Unavailable',
                'Huntley solar farm',
                'Cypress Creek Renewables',
                'Cubico USA',
              ],
              [
                'United States',
                200,
                'North America',
                'Avondale',
                'Pueblo County',
                'Unavailable',
                'Thunder Wolf Energy Center Hybrid solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'Ada County',
                'Ada County',
                'Unavailable',
                'Id Solar',
                'Sustainable Power Group, LLC',
                'Origis Energy',
              ],
              [
                'United States',
                198,
                'North America',
                'Lamar County',
                'Lamar County',
                'Unavailable',
                'Impact Solar 1',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                400,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Imperial Valley Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                23,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Imperial Valley Solar Company 1',
                'SunPeak Solar',
                'SunPeak Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Imperial Valley Solar Company 2',
                'Dominion Energy',
                'Dominion Energy [67.0%]; Onward Energy [33.0%]',
              ],
              [
                'United States',
                75,
                'North America',
                'Tooele',
                'Tooele County',
                'Unavailable',
                'Horseshoe (D.E Shaw) solar farm',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                40,
                'North America',
                'Jeff Davis County',
                'Jeff Davis County',
                'Unavailable',
                'Hazlehurst solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Holden',
                'Millard County',
                'Unavailable',
                'Holden Solar',
                'Unknown',
                'Rocky Mountain Power',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Berkeley County',
                'Unavailable',
                'Ho-Fel solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Buford',
                'Highland County',
                'Unavailable',
                'Hecate Cincinnati Solar',
                'Unknown',
                'Hecate Energy',
              ],
              [
                'United States',
                500,
                'North America',
                'Kress',
                'Swisher County',
                'Unavailable',
                'Hecate Energy Frye Solar',
                'Hecate Energy',
                'Unknown',
              ],
              [
                'United States',
                500,
                'North America',
                'Trent',
                'Nolan County',
                'Unavailable',
                'Hecate Energy Harley Hand Solar',
                'Hecate Energy',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Williamsburg County',
                'Unavailable',
                'Hemingway solar farm',
                'Unknown',
                'Ecoplexus',
              ],
              [
                'United States',
                50,
                'North America',
                'Henderson County',
                'Henderson County',
                'Unavailable',
                'Henderson County Solar',
                'Unknown',
                'AES Corporation',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Hennepin solar farm',
                'Unknown',
                'Vistra Energy',
              ],
              [
                'United States',
                102,
                'North America',
                'Kings County',
                'Kings County',
                'Unavailable',
                'Henrietta Solar Project',
                'SunPower',
                'Southern Power; SunPower',
              ],
              [
                'United States',
                74,
                'North America',
                'Palm Beach County',
                'Palm Beach County',
                'Unavailable',
                'Hibiscus Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                196,
                'North America',
                'Camilla',
                'Mitchell County',
                'Unavailable',
                'Hickory Park Solar Hybrid',
                'RWE Renewables Americas LLC',
                'RWE Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Chesapeake',
                'Unavailable',
                'Unavailable',
                'Hickory solar farm',
                'Energix Renewable Energy',
                'Energix Renewable Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Victorville',
                'San Bernardino County',
                'Unavailable',
                'High Desert Hybrid solar farm',
                'Goldman Sachs Renewable Power Group',
                'Goldman Sachs Renewable Power Group',
              ],
              [
                'United States',
                52,
                'North America',
                'Waipahu',
                'Honolulu County',
                'Unavailable',
                "Ho'Ohana Solar",
                'Hanwha Energy',
                'Hanwha Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'San Luis Obispo County',
                'Unavailable',
                'High Plains Solar Ranch',
                'Unknown',
                'SunPower',
              ],
              [
                'United States',
                90,
                'North America',
                'Amsterdam',
                'Montgomery County',
                'Unavailable',
                'High River Energy solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                49,
                'North America',
                'Louisburg',
                'Franklin County',
                'Unavailable',
                'Highest Power Solar',
                'Unknown',
                'Solterra',
              ],
              [
                'United States',
                75,
                'North America',
                'Lake Placid',
                'Highlands County',
                'Unavailable',
                'Highland (Flordia) solar farm',
                'Placid Solar, LLC',
                'Unknown',
              ],
              [
                'United States',
                75,
                'North America',
                'Lake Placid',
                'Highlands County',
                'Unavailable',
                'Highland (Flordia) solar farm',
                'Placid Solar, LLC',
                'Unknown',
              ],
              [
                'United States',
                300,
                'North America',
                'Buford',
                'Highland County',
                'Unavailable',
                'Highland (Hecate) solar farm',
                'Hecate Energy',
                'Hecate Energy',
              ],
              [
                'United States',
                165,
                'North America',
                'Spotsylvania County',
                'Spotsylvania County',
                'Unavailable',
                'Highlander Solar Energy Station 1',
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Dickenson County',
                'Unavailable',
                'Highlands (Dominion) Solar Project',
                'Unknown',
                'Nature Conservancy; Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Perry',
                'Wyoming County',
                'Unavailable',
                'Highview Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                200,
                'North America',
                'Mt. Orab',
                'Brown County',
                'Unavailable',
                'Hillcrest Solar',
                'Unknown',
                'Innergex',
              ],
              [
                'United States',
                20,
                'North America',
                'Little Falls',
                'Herkimer County',
                'Unavailable',
                'Hills Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                20,
                'North America',
                'Troy',
                'Rensselaer County',
                'Unavailable',
                'Hilltop Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                100,
                'North America',
                'Lena',
                'Stephenson County',
                'Unavailable',
                'High Point Solar',
                'Acciona Energy USA Global, LLC',
                'Acciona Energy USA Global',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Lone Valley Solar Park',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Huron Solar Station',
                'Pacific Gas & Electric Co.',
                'Pacific Gas & Electric Co.',
              ],
              [
                'United States',
                32,
                'North America',
                'Suffolk County',
                'Suffolk County',
                'Unavailable',
                'Long Island solar farm',
                'Unknown',
                'BP Solar; Department of Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Travis County',
                'Travis County',
                'Unavailable',
                'Webberville Solar Project',
                'FRV AE Solar LLC',
                'FRV AE Solar LLC',
              ],
              [
                'United States',
                99,
                'North America',
                'Wautoma',
                'Dakota County',
                'Unavailable',
                'Wautoma Solar Project',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Nash County',
                'Nash County',
                'Unavailable',
                'Watson Seed Farm solar farm',
                'Ecoplexus',
                'Ecoplexus',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Dorchester County',
                'Unavailable',
                'Watson Hill Solar',
                'Unknown',
                'Johnson Development',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Berkeley County',
                'Unavailable',
                'Watlington solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Schuyler',
                'Herkimer County',
                'Unavailable',
                'Watkins Road Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                80,
                'North America',
                'Nathalie',
                'Halifax County',
                'Unavailable',
                'Water Strider Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                150,
                'North America',
                'Ann Arbor',
                'Washtenaw County',
                'Unavailable',
                'Washtenaw Solar Energy',
                'Consumers Energy',
                'Consumers Energy',
              ],
              [
                'United States',
                65,
                'North America',
                'Duplin County',
                'Duplin County',
                'Unavailable',
                'Warsaw Farm solar farm',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Wapello',
                'Louisa County',
                'Unavailable',
                'Wapello Solar',
                'Clenera',
                'Clenera',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'King County',
                'Unavailable',
                'Walnut Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Hermiston',
                'Umatilla County',
                'Unavailable',
                'West End Solar',
                'Unknown',
                'Eurus Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Lee County',
                'Unavailable',
                'Walnut Bend Solar',
                'Unknown',
                'Energy Arkansas',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Hawai\u02bbi County',
                'South Kohala',
                'Waikoloa Village Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                30,
                'North America',
                'Mililani',
                'Honolulu County',
                'Unavailable',
                'Waiawa Solar',
                'Unknown',
                'AES Clean Energy',
              ],
              [
                'United States',
                36,
                'North America',
                "O'ahu",
                'Honolulu County',
                'Unavailable',
                'Waiawa Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'Honolulu County',
                'Honolulu County',
                'Unavailable',
                'Waianae Solar Project',
                'Eurus Energy',
                'Eurus Energy; Toyota Tsusho America Inc',
              ],
              [
                'United States',
                120,
                'North America',
                'Brazoria County',
                'Brazoria County',
                'Unavailable',
                'Wagyu solar farm',
                'Cypress Creek Renewables',
                'Cubico USA',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Morrow County',
                'Unavailable',
                'Wagon Trail Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Andrews County',
                'Unavailable',
                'Vistra Andrews solar farm',
                'Unknown',
                'Luminant Energy',
              ],
              [
                'United States',
                125,
                'North America',
                'Unavailable',
                'Vinton County',
                'Unavailable',
                'Vinton County Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Riverside County County',
                'Unavailable',
                'Victory Pass Solar',
                'Clearway Energy',
                'Clearway Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Victor Phelan Solar One',
                'Gamma Genco CV II LLC',
                'Recurrent Energy',
              ],
              [
                'United States',
                250,
                'North America',
                'Verona',
                'Oneida County',
                'Unavailable',
                'Verona Town Solar',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                46,
                'North America',
                'Mililani',
                'Honolulu County',
                'Unavailable',
                'Waipio Solar',
                'Unknown',
                'Clearway Energy',
              ],
              [
                'United States',
                345,
                'North America',
                'Baton Rouge',
                'Pointe Coupee County',
                'Unavailable',
                'Ventress Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                320,
                'North America',
                'Unavailable',
                'Johnson County',
                'Unavailable',
                'West Gardner Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Honolulu County',
                'Honolulu County',
                'Unavailable',
                'West Loch Solar One',
                'Hawaiian Electric Co Inc',
                'Hawaiian Electric Co Inc',
              ],
              [
                'United States',
                50,
                'North America',
                'Gretna',
                'Pittsylvania County',
                'Unavailable',
                'Whitehorn Solar',
                'Unknown',
                'Engie',
              ],
              [
                'United States',
                200,
                'North America',
                'Yuma',
                'Yuma County',
                'Unavailable',
                'White Wing Solar',
                'First Solar',
                'First Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Tulare County',
                'Tulare County',
                'Unavailable',
                'White River Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                101,
                'North America',
                'Taylor County',
                'Taylor County',
                'Unavailable',
                'White Pine Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                76,
                'North America',
                'Burke County',
                'Burke County',
                'Unavailable',
                'White Oak Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Kent County',
                'Kent County',
                'Unavailable',
                'White Camp Solar',
                'White Camp Solar LLC',
                'White Camp Energy',
              ],
              [
                'United States',
                125,
                'North America',
                'Unavailable',
                'Erie County',
                'Unavailable',
                'Wheatsborough Solar',
                'Apex Clean Energy',
                'Apex Clean Energy',
              ],
              [
                'United States',
                22,
                'North America',
                'San Joaquin',
                'San Joaquin County',
                'Unavailable',
                'Wheats Solar',
                'Unknown',
                'Hanwha Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Morrow',
                'Morrow County',
                'Unavailable',
                'Wheatridge Hybrid solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                25,
                'North America',
                'Stanislaus',
                'Stanislaus County',
                'Unavailable',
                'Westside (Scatec) Solar Ranch',
                'Unknown',
                'Scatec Solar',
              ],
              [
                'United States',
                25,
                'North America',
                'Stanislaus',
                'Stanislaus County',
                'Unavailable',
                'Westside (Scatec) Solar Ranch',
                'Unknown',
                'Scatec Solar',
              ],
              [
                'United States',
                35,
                'North America',
                'Kaua\u02bbi County',
                'Kaua\u02bbi County',
                'Unavailable',
                "West Kaua'I Energy Project solar farm",
                'AES Corporation',
                'AES Corporation',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Westside (NextEra) solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Rutherfordton',
                'Rutherford County',
                'Unavailable',
                'Westminister solar farm',
                'Ecoplexus',
                'Ecoplexus',
              ],
              [
                'United States',
                246,
                'North America',
                'Lemoore',
                'Kings County',
                'Unavailable',
                'Westland solar farm',
                'Unknown',
                'CIM Group; Westland Holdings',
              ],
              [
                'United States',
                151,
                'North America',
                'Lemoore',
                'Kings County',
                'Unavailable',
                'Westland solar farm',
                'Unknown',
                'CIM Group; Westland Holdings',
              ],
              [
                'United States',
                250,
                'North America',
                'Lemoore',
                'Kings County',
                'Unavailable',
                'Westland solar farm',
                'Unknown',
                'CIM Group; Westland Holdings',
              ],
              [
                'United States',
                250,
                'North America',
                'Lemoore',
                'Kings County',
                'Unavailable',
                'Westland solar farm',
                'Unknown',
                'CIM Group; Westland Holdings',
              ],
              [
                'United States',
                250,
                'North America',
                'Lemoore',
                'Kings County',
                'Unavailable',
                'Westland solar farm',
                'CIM Group',
                'CIM Group',
              ],
              [
                'United States',
                27,
                'North America',
                'Unavailable',
                'Bexar County',
                'Unavailable',
                'Western Solar Ranch',
                'Unknown',
                'Tessera Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Western Antelope Blue Sky B solar farm',
                'Sustainable Power Group, LLC',
                'FTP Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Lancaster',
                'Los Angeles County',
                'Unavailable',
                'Western Antelope Blue Sky A solar farm',
                'Sustainable Power Group, LLC',
                'Unknown',
              ],
              [
                'United States',
                40,
                'North America',
                'McLeansville',
                'Guilford County',
                'Unavailable',
                'West River Solar',
                'Cypress Creek Renewables',
                'Cypress Creek Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Reeves County',
                'Reeves County',
                'Unavailable',
                'West Of The Pecos Solar',
                'RWE Renewables',
                'RWE Renewables',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Westmoreland County',
                'Unavailable',
                'Westmoreland Solar',
                'Unknown',
                'Falck Renewables North America, Inc. [51%]; Eni New Energy US [49%]',
              ],
              [
                'United States',
                130,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Topaz solar farm',
                'First Solar',
                'BHE Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Merced County',
                'Merced County',
                'Unavailable',
                'Vega (SunEdison) solar farm',
                'Unknown',
                'SunEdison',
              ],
              [
                'United States',
                20,
                'North America',
                'Hertford County',
                'Hertford County',
                'Unavailable',
                'Vaughn Creek solar farm',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                250,
                'North America',
                'Unavailable',
                'Williamson County',
                'Unavailable',
                'Triple Black Diamond solar farm',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                250,
                'North America',
                "O'Donnell",
                'Lynn County',
                'Unavailable',
                'Trex Us Red Holly solar farm',
                'Trex US',
                'Trex US',
              ],
              [
                'United States',
                400,
                'North America',
                "O'Donnell",
                'Lynn County',
                'Unavailable',
                'Trex Us Green Holly solar farm',
                'Trex US',
                'Trex US',
              ],
              [
                'United States',
                195,
                'North America',
                'Unavailable',
                'Bexar County',
                'Unavailable',
                'Tres Bahias Solar',
                'Unknown',
                'Swift Current Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Gilchrist County',
                'Gilchrist County',
                'Unavailable',
                'Trenton Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                79,
                'North America',
                'Pollocksville',
                'Jones County',
                'Unavailable',
                'Trent River Solar',
                'Pine Gate Renewables',
                'Pine Gate Renewables',
              ],
              [
                'United States',
                80,
                'North America',
                'Waterloo',
                'Seneca County',
                'Unavailable',
                'Trelina Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                205,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Tranquillity solar farm',
                'Southern Power Co',
                'Southern Power [51%]; Canada Solar [49%]',
              ],
              [
                'United States',
                74,
                'North America',
                'Saint Johns County',
                'Saint Johns County',
                'Unavailable',
                'Trailside Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                119,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Orleans',
                'Tracy solar farm',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                180,
                'North America',
                'Boulder City',
                'Clark County',
                'Unavailable',
                'Townsite Solar Project Hybrid',
                'Skylar Resources',
                'Capital Dynamics',
              ],
              [
                'United States',
                50,
                'North America',
                'Troy',
                'Spencer County',
                'Unavailable',
                'Troy Solar',
                'Ventren Energy',
                'Vectren Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Mesquite',
                'Clark County',
                'Unavailable',
                'Toquop Sithe solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                90,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Topaz solar farm',
                'First Solar',
                'BHE Solar',
              ],
              [
                'United States',
                102,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Topaz solar farm',
                'First Solar',
                'BHE Solar',
              ],
              [
                'United States',
                151,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Topaz solar farm',
                'First Solar',
                'BHE Solar',
              ],
              [
                'United States',
                220,
                'North America',
                'Jal',
                'Lea County',
                'Unavailable',
                'Tip Top Solar Energy Center',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                70,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Titan (California) solar farm',
                'Unknown',
                'Sunpin Solar',
              ],
              [
                'United States',
                50,
                'North America',
                'Arapahoe County',
                'Arapahoe County',
                'Unavailable',
                'Titan (Colorado) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                260,
                'North America',
                'Van Horn',
                'Culberson County',
                'Unavailable',
                'Titan (Texas) Solar Project',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Hurlock',
                'Dorchester County',
                'Unavailable',
                'Todd Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                35,
                'North America',
                'Chalotte',
                'Iredell County',
                'Unavailable',
                'Tomlin Mill Road solar farm',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                21,
                'North America',
                "Tom's River",
                'Ocean County',
                'Unavailable',
                'Toms River solar farm',
                'Goldman Sachs Renewable Power Group',
                'EDF Renewables; PVOne',
              ],
              [
                'United States',
                80,
                'North America',
                'Thurston County',
                'Thurston County',
                'Unavailable',
                'Tono Solar',
                'TransAlta Holdings U.S. Inc.',
                'TransAlta Holdings U.S. Inc.',
              ],
              [
                'United States',
                112,
                'North America',
                'San Luis Obispo County',
                'San Luis Obispo County',
                'Unavailable',
                'Topaz solar farm',
                'First Solar',
                'BHE Solar',
              ],
              [
                'United States',
                200,
                'North America',
                'Rio Grande City',
                'Starr County',
                'Unavailable',
                'Vega (Invenergy) solar farm',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Reno County',
                'Unavailable',
                'Ts Solar',
                'Barrick Gold Corporation',
                'Barrick [61.5%]; Newmont Corp. [38.5 %]',
              ],
              [
                'United States',
                200,
                'North America',
                'Ault',
                'Pueblo County',
                'Unavailable',
                'Turkey Creek Solar Project',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                25,
                'North America',
                'Santa Barbara County',
                'Santa Barbara County',
                'Unavailable',
                'Vandenberg Solar Project',
                'Goldman Sachs Renewable Power Group',
                'SunPower',
              ],
              [
                'United States',
                20,
                'North America',
                'Owega',
                'Tioga County',
                'Unavailable',
                'Valley Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                200,
                'North America',
                'Pinal',
                'Pinal County',
                'Unavailable',
                'Valley Farms Solar',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                111,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Valentine Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'St.James Parish County',
                'Unavailable',
                'Vacherie Solar Energy Center',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Delta',
                'Millard County',
                'Unavailable',
                'Utah Solar 1',
                'Unknown',
                'Energy Capital Group',
              ],
              [
                'United States',
                80,
                'North America',
                'Iron County',
                'Iron County',
                'Unavailable',
                'Utah Red Hills solar farm',
                'Swinerton Renewable Energy',
                'Scatec Solar',
              ],
              [
                'United States',
                150,
                'North America',
                'Upton County',
                'Upton County',
                'Unavailable',
                'Upton County Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                72,
                'North America',
                'Unavailable',
                'Upper Pittsgrove County',
                'Unavailable',
                'Upper Pittsgrove solar farm',
                'Unknown',
                'Atlantic Green Power',
              ],
              [
                'United States',
                24,
                'North America',
                'Kent County',
                'Kent County',
                'Unavailable',
                'University Solar',
                'AES Corporation',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'Union County',
                'Union County',
                'Unavailable',
                'Union Springs Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Reno County',
                'Unavailable',
                'Ts Solar',
                'Barrick Gold Corporation',
                'Barrick [61.5%]; Newmont Corp. [38.5 %]',
              ],
              [
                'United States',
                160,
                'North America',
                'Unavailable',
                'Henderson County',
                'Unavailable',
                'Unbridled Solar',
                'Unknown',
                'National Grid Renewables',
              ],
              [
                'United States',
                22,
                'North America',
                'Elloree',
                'Orangeburg County',
                'Unavailable',
                'Ulmer Solar',
                'Southern Current',
                'Southern Current',
              ],
              [
                'United States',
                118,
                'North America',
                'Bristol',
                'Pierce County',
                'Unavailable',
                'Tyre Bridge Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Wyandot County',
                'Unavailable',
                'Tymochtee Solar Project',
                'Unknown',
                'Apex Clean Energy',
              ],
              [
                'United States',
                22,
                'North America',
                'Unavailable',
                'Smithtown County',
                'Unavailable',
                'Two Hearted Solar',
                'Unknown',
                'Silver Creek Energy; Pine Gate Renewables',
              ],
              [
                'United States',
                150,
                'North America',
                'Manitowoc County',
                'Manitowoc County',
                'Unavailable',
                'Two Creeks Solar',
                'Wisconsin Public Service Corp',
                'Madison Gas & Electric Co [33.3%]; Wisconsin Public Service Corp [66.7%]',
              ],
              [
                'United States',
                75,
                'North America',
                'Jasper',
                'Hamilton County',
                'Unavailable',
                'Twin Rivers Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Putnam County',
                'Putnam County',
                'Unavailable',
                'Twin Lakes solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                204,
                'North America',
                'Twiggs County',
                'Twiggs County',
                'Unavailable',
                'Twiggs Solar',
                'Origis Energy',
                'Origis Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Orangeburg County',
                'Orangeburg County',
                'Unavailable',
                'TWE Bowman Solar Project',
                'Unknown',
                'Enel Green Power',
              ],
              [
                'United States',
                60,
                'North America',
                'Washoe County',
                'Washoe County',
                'Unavailable',
                'Turquoise solar farm',
                'Greenbacker Energy',
                'Greenbacker Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Zanesville',
                'Noble County',
                'Unavailable',
                'Turning Point Solar',
                'Unknown',
                'Agile Energy Inc; New Harvest Ventures',
              ],
              [
                'United States',
                20,
                'North America',
                'Morris Township',
                'Clearfield County',
                'Unavailable',
                'UN-School House solar farm',
                'BCD Project Holdings 1, LLC',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'St. Thomas Township',
                'Franklin County',
                'Unavailable',
                'Whitetail Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                20,
                'North America',
                'Louisa County',
                'Louisa County',
                'Unavailable',
                'Whitehouse solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Fresno County',
                'Fresno County',
                'Unavailable',
                'Whitney Point Solar',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                333,
                'North America',
                'Unavailable',
                'Starke County',
                'Unavailable',
                'Mammoth Solar',
                'Unknown',
                'Doral Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Manatee County',
                'Manatee County',
                'Unavailable',
                'Manatee Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Clifton Springs',
                'Ontario County',
                'Unavailable',
                'Manchester Solar Project',
                'SunEast',
                'SunEast',
              ],
              [
                'United States',
                222,
                'North America',
                'McCamey',
                'Pecos County',
                'Unavailable',
                'Maplewood (Candian Solar) solar farm',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'United States',
                120,
                'North America',
                'Unavailable',
                'Pittsylvania County',
                'Unavailable',
                'Maplewood (Dominion) solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                28,
                'North America',
                'McCamey',
                'Pecos County',
                'Unavailable',
                'Maplewood solar farm',
                'Unknown',
                'Canadian Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Portage Township',
                'Cambria County',
                'Unavailable',
                'Mapple Hill Solar',
                'Unknown',
                'Competitive Power Ventures',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Lucerne Valley County',
                'Unavailable',
                'Marathon Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Maricopa West Solar Pv',
                'Dominion Energy',
                'E.ON SE',
              ],
              [
                'United States',
                31,
                'North America',
                'Dougherty County',
                'Dougherty County',
                'Unavailable',
                'Marine Corps Logistics Base Solar',
                'Georgia Power',
                'Georgia Power',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Marion County',
                'Unavailable',
                'Marion County Solar Project',
                'Unknown',
                'Savion Energy',
              ],
              [
                'United States',
                333,
                'North America',
                'Unavailable',
                'Starke County',
                'Unavailable',
                'Mammoth Solar',
                'Unknown',
                'Doral Renewables',
              ],
              [
                'United States',
                110,
                'North America',
                'Unavailable',
                'Definance County',
                'Unavailable',
                'Mark Center Solar',
                'Unknown',
                'Candela Renewables',
              ],
              [
                'United States',
                62,
                'North America',
                'Lyon County',
                'Lyon County',
                'Unavailable',
                'Marshall Solar Energy Project',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                200,
                'North America',
                'Unavailable',
                'Martin County',
                'Unavailable',
                'Martin County Solar Project',
                'Unknown',
                'Savion Energy',
              ],
              [
                'United States',
                27,
                'North America',
                'Washington County',
                'Washington County',
                'Unavailable',
                'Maryland Solar',
                'CD Arevon USA, Inc.',
                'First Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'Hagerstown',
                'Washington County',
                'Unavailable',
                'Mason Dixon Solar Center',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                125,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Maverick Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Maverick Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                100,
                'North America',
                'Desert Center',
                'Riverside County',
                'Unavailable',
                'Maverick Solar',
                'Unknown',
                'EDF Renewables [50%]; MEAG [50%]',
              ],
              [
                'United States',
                132,
                'North America',
                'Desert Center',
                'Riverside County',
                'Unavailable',
                'Maverick Solar',
                'Unknown',
                'EDF Renewables [50%]; MEAG [50%]',
              ],
              [
                'United States',
                42,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                21,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                40,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Culpeper County',
                'Unavailable',
                'Maroon Solar',
                'Unknown',
                'Strata Solar',
              ],
              [
                'United States',
                20,
                'North America',
                'St. Thomas Township',
                'Franklin County',
                'Unavailable',
                'Whitetail Solar',
                'Lightsource bp',
                'Lightsource bp',
              ],
              [
                'United States',
                333,
                'North America',
                'Unavailable',
                'Starke County',
                'Unavailable',
                'Mammoth Solar',
                'Unknown',
                'Doral Renewables',
              ],
              [
                'United States',
                120,
                'North America',
                'Waipahu',
                'Honolulu County',
                'Unavailable',
                'Mahi Solar',
                'Unknown',
                'Longroad Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'San Bernardino County',
                'San Bernardino County',
                'Unavailable',
                'Longboat Solar',
                'Unknown',
                'Duke Energy',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Greene County',
                'Unavailable',
                'Longview Solar',
                'Unknown',
                'Longview Power',
              ],
              [
                'United States',
                140,
                'North America',
                'Unavailable',
                'Oglala Lakota County',
                'Unavailable',
                'Lookout Solar',
                'Unknown',
                'Wirsol',
              ],
              [
                'United States',
                100,
                'North America',
                'Limestone',
                'Loring Commerce Centre County',
                'Unavailable',
                'Loring Commerce solar farm',
                'Unknown',
                'Loring Development Authority; Ranger Solar',
              ],
              [
                'United States',
                30,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Lost Hills Hybrid solar farm',
                'Goldman Sachs Renewable Power Group',
                'SunPower',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Lost Hills-Blackwell solar farm',
                'Southern Power Co',
                'Southern Power; First Solar',
              ],
              [
                'United States',
                50,
                'North America',
                'Unavailable',
                'Mower County',
                'Unavailable',
                'Louise Solar',
                'Unknown',
                'EDF Renewables',
              ],
              [
                'United States',
                190,
                'North America',
                'Crescent Valley',
                'Lander County',
                'Unavailable',
                'Lovelock Solar',
                'Invenergy',
                'Invenergy',
              ],
              [
                'United States',
                20,
                'North America',
                'Berlin',
                'Worcester County',
                'Unavailable',
                'Ls-Heron solar farm',
                'Unknown',
                'Longveiw Solar',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Lucerne Valley County',
                'Unavailable',
                'Lucerne Valley (Barstow Rd & Rabbit Springs Rd) Solar 1',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Lucerne Valley County',
                'Unavailable',
                'Lucerne Valley (Camp Rock Rd) Solar 1',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                69,
                'North America',
                'Maiden',
                'Catawba County',
                'Unavailable',
                'Maiden Creek Solar Power Plant',
                'Duke Energy',
                'Duke Energy',
              ],
              [
                'United States',
                45,
                'North America',
                'Unavailable',
                'San Bernadino County',
                'Unavailable',
                'Lucerne Valley (Chervon) solar farm',
                'Unknown',
                'Chervon Energy Solutions',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Lucerne Valley County',
                'Unavailable',
                'Lucerne Valley Desert View Ranch solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Lumpkin',
                'Stewart County',
                'Unavailable',
                'Lumpkin solar farm',
                'Unknown',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                150,
                'North America',
                'Bickleton',
                'Klickitat County',
                'Unavailable',
                'Lund Hill Solar',
                'Avangrid Renewables',
                'Avangrid Renewables',
              ],
              [
                'United States',
                50,
                'North America',
                'Mineral County',
                'Mineral County',
                'Unavailable',
                'Luning Energy solar farm',
                'Liberty Utilities',
                'Liberty Utilites',
              ],
              [
                'United States',
                20,
                'North America',
                'Flint',
                'Shiawassee County',
                'Unavailable',
                'Lyons Road Solar',
                'Unknown',
                'Pine Gate Renewables; Irradiant Partners',
              ],
              [
                'United States',
                20,
                'North America',
                'Grand Rapids',
                'Muskegon County',
                'Unavailable',
                'Macbeth Solar',
                'Unknown',
                'Pine Gate Renewables; Irradiant Partners',
              ],
              [
                'United States',
                55,
                'North America',
                'Luna County',
                'Luna County',
                'Unavailable',
                'Macho Springs solar farm',
                'Southern Power Co',
                'Southern Power; Turner Renewable Energy',
              ],
              [
                'United States',
                63,
                'North America',
                'Unavailable',
                'Orange County',
                'Unavailable',
                'Madison Solar',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Yolo County',
                'Unavailable',
                'Madison Yolo solar farm',
                'Unknown',
                'ReneSola',
              ],
              [
                'United States',
                74,
                'North America',
                'Mulberry',
                'Polk County',
                'Unavailable',
                'Magnolia Solar',
                'Tampa Electric Co',
                'NextEra Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Green Cove Springs',
                'Clay County',
                'Unavailable',
                'Magnolia Springs Solar Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                60,
                'North America',
                'Unavailable',
                'Lucerne Valley County',
                'Unavailable',
                'Lucerne Valley (NextEra) solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                31,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                31,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                42,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                100,
                'North America',
                '29 Palms',
                'San Bernardino County',
                'Unavailable',
                'Wonder Valley solar farm',
                'Unknown',
                'Sustainable Capital Energy Partners',
              ],
              [
                'United States',
                20,
                'North America',
                'Niland',
                'Imperial County',
                'Unavailable',
                'Wister Solar',
                'Unknown',
                'Ormat Technology',
              ],
              [
                'United States',
                107,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Wistaria Ranch Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Chesterfield County',
                'Unavailable',
                'Winterpock solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Gloucester County',
                'Unavailable',
                'Winterberry Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Clinton',
                'Kennebec County',
                'Unavailable',
                'Winslow solar farm',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Unavailable',
                'Lincoln County',
                'Unavailable',
                'Winfield Solar',
                'Unknown',
                'Cordelio Power',
              ],
              [
                'United States',
                20,
                'North America',
                'Mojave',
                'Kern County',
                'Unavailable',
                'Windhub Solar B',
                'First Solar',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Kern County',
                'Kern County',
                'Unavailable',
                'Windhub Solar A',
                'EDP Renewables',
                'EDP Renewables',
              ],
              [
                'United States',
                75,
                'North America',
                'Hillsborough County',
                'Hillsborough County',
                'Unavailable',
                'Wimauma Solar',
                'Tampa Electric Co',
                'Tampa Electric Co',
              ],
              [
                'United States',
                100,
                'North America',
                'Tucson',
                'Pima County',
                'Unavailable',
                'Wilmot Energy Center solar farm',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                27,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Morystown',
                'Highland County',
                'Unavailable',
                'Willowbrook Solar',
                'RWE Renewables Americas LLC',
                'Open Road Renewables',
              ],
              [
                'United States',
                108,
                'North America',
                'Kern County',
                'Los Angeles County',
                'Unavailable',
                'Willow Spring Solar',
                'Unknown',
                'D.E Shaw Renewables',
              ],
              [
                'United States',
                74,
                'North America',
                'Myakka City',
                'Manatee County',
                'Unavailable',
                'Willow Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Dunn',
                'Harnett County',
                'Unavailable',
                'Willoughby solar farm',
                'Ecoplexus',
                'Unknown',
              ],
              [
                'United States',
                20,
                'North America',
                'Jayton',
                'Kent County',
                'Unavailable',
                'Williams Solar',
                'Williams Solar, LLC',
                'White Camp Energy',
              ],
              [
                'United States',
                81,
                'North America',
                'Beaufort County',
                'Beaufort County',
                'Unavailable',
                'Wilkinson Solar',
                'Dominion Energy',
                'Invenergy',
              ],
              [
                'United States',
                75,
                'North America',
                'Wilkesboro',
                'Wilkes County',
                'Unavailable',
                'Wilkes Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                74,
                'North America',
                'DeSoto County',
                'DeSoto County',
                'Unavailable',
                'Wildflower Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                90,
                'North America',
                'Gallup',
                'McKinley County',
                'Unavailable',
                'Wildcat Solar Power Plant',
                'Solariant Capital, LLC',
                'Solariant Capital, LLC',
              ],
              [
                'United States',
                128,
                'North America',
                'Unavailable',
                'Pennington County',
                'Unavailable',
                'Wild Springs Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                93,
                'North America',
                'Unavailable',
                'Jefferson County',
                'Unavailable',
                'Wild Hill Solar',
                'EDF Renewables',
                'EDF Renewables',
              ],
              [
                'United States',
                75,
                'North America',
                'Unavailable',
                'Wilson County',
                'Unavailable',
                'Wiggins Mill Farm Solar',
                'Unknown',
                'Strata Solar',
              ],
              [
                'United States',
                75,
                'North America',
                'Rosamond',
                'Kern County',
                'Unavailable',
                'Willow Spring Solar',
                'Leeward Renewable Energy',
                'Leeward Renewable Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Windham County',
                'Windham County',
                'Unavailable',
                'Woods Hill Solar',
                'Renewable Energy Systems',
                'Renewable Energy Systems',
              ],
              [
                'United States',
                150,
                'North America',
                'Saratoga',
                'Walworth County',
                'Unavailable',
                'Wood County Solar Project',
                'Unknown',
                'Alliant Energy',
              ],
              [
                'United States',
                75,
                'North America',
                'Wythe County (Unincor',
                'Wythe County',
                'Unavailable',
                'Wythe County Solar',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                36,
                'North America',
                'Riverside County',
                'Riverside County',
                'Unavailable',
                'Mccoy Solar Energy Project Hybrid',
                'Unknown',
                'NextEra Energy',
              ],
              [
                'United States',
                30,
                'North America',
                'Galt',
                'Sacramento County',
                'Unavailable',
                'Mckenzie solar farm',
                'Unknown',
                'Recurrent Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Martin County',
                'Martin County',
                'Unavailable',
                'Meadows solar farm',
                'Ecoplexus',
                'PSEG Solar Source',
              ],
              [
                'United States',
                25,
                'North America',
                'Hanover County',
                'Hanover County',
                'Unavailable',
                'Mechanicsville Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                100,
                'North America',
                'Las Vegas',
                'Clark County',
                'Unavailable',
                'Mega Solar Array Project',
                'Unknown',
                'AEP Renewables [75%]; Invenergy Renewables [25%]',
              ],
              [
                'United States',
                60,
                'North America',
                'Emporia',
                'Greensville County',
                'Unavailable',
                'Meherrin Solar',
                'Dominion Energy',
                'Brookfield Renewable',
              ],
              [
                'United States',
                60,
                'North America',
                'Dillon',
                'Dillon County',
                'Unavailable',
                'Melsam Solar',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                52,
                'North America',
                'Lauderdale County',
                'Lauderdale County',
                'Unavailable',
                'Meridian solar farm',
                'Silicon Ranch Corporation',
                'Silicon Ranch Corporation',
              ],
              [
                'United States',
                100,
                'North America',
                'Unavailable',
                'Lancaster County',
                'Unavailable',
                'Merry Point solar farm',
                'Unknown',
                'Dominion Energy',
              ],
              [
                'United States',
                170,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Mesquite Solar',
                'Unknown',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                100,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Mesquite Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                200,
                'North America',
                'Merced County',
                'Merced County',
                'Unavailable',
                'Wright Solar Park',
                'Clenera',
                'Centaurus Renewable Energy',
              ],
              [
                'United States',
                150,
                'North America',
                'Maricopa County',
                'Maricopa County',
                'Unavailable',
                'Mesquite Solar',
                'Consolidated Edison Development Inc.',
                'Consolidated Edison Development Inc.',
              ],
              [
                'United States',
                20,
                'North America',
                'Unavailable',
                'Washtenaw County',
                'Unavailable',
                'Mi Green Power solar farm',
                'Unknown',
                'DTE Energy',
              ],
              [
                'United States',
                74,
                'North America',
                'Miami-Dade County',
                'Miami-Dade County',
                'Unavailable',
                'Miami Dade Solar Energy Center',
                'NextEra Energy',
                'NextEra Energy',
              ],
              [
                'United States',
                72,
                'North America',
                'Calhoun County',
                'Calhoun County',
                'Unavailable',
                'Midlands solar farm',
                'Cypress Creek Renewables',
                'Cubico USA',
              ],
              [
                'United States',
                182,
                'North America',
                'Pecos County',
                'Pecos County',
                'Unavailable',
                'Midway (174 Power Global) solar farm',
                '174 Power Global',
                '174 Power Global',
              ],
              [
                'United States',
                50,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Midway (California) solar farm',
                '8minute Solar',
                '8minute Solar; Gestamp Solar',
              ],
              [
                'United States',
                30,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Midway (California) solar farm',
                'Dominion Energy',
                'Dominion Energy',
              ],
              [
                'United States',
                20,
                'North America',
                'Imperial County',
                'Imperial County',
                'Unavailable',
                'Midway (California) solar farm',
                'Greenbacker Energy',
                'Greenbacker Energy',
              ],
              [
                'United States',
                99,
                'North America',
                'Beaver County',
                'Beaver County',
                'Unavailable',
                'Milford Solar 1',
                'First Solar',
                'US Solar Fund',
              ],
              [
                'United States',
                147,
                'North America',
                'Yum Yum',
                'Fayette County',
                'Unavailable',
                'Yum Yum Solar',
                'Invenergy',
                'Invenergy; NextEra Energy',
              ],
              [
                'United States',
                274,
                'North America',
                'Williamsport',
                'Ross County',
                'Unavailable',
                'Yellowbud Solar',
                'National Grid Renewables',
                'National Grid Renewables',
              ],
              [
                'United States',
                300,
                'North America',
                'Unavailable',
                'Clinton County',
                'Unavailable',
                'Yellow Wood Solar Project',
                'Unknown',
                'Invenergy',
              ],
              [
                'United States',
                500,
                'North America',
                'Unavailable',
                'Clarke County',
                'Unavailable',
                'Yellow Pine Solar Project',
                'Unknown',
                'Unknown',
              ],
              [
                'United States',
                225,
                'North America',
                'Borden County',
                'Borden County',
                'Unavailable',
                'Long Draw Solar',
                'Engie',
                'Engie',
              ],
              [
                'Uruguay',
                59,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'El Naranjal Solar Plant',
                'Atlas Renewable Energy',
                'Atlas Renewable Energy',
              ],
              [
                'Uruguay',
                26,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Alto Cielo PV Solar Plant',
                'Solarpack',
                'Solarpack',
              ],
              [
                'Uruguay',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Young',
                'Giacote PV Solar Project',
                'Sky Solar Holdings',
                'Sky Solar Holdings',
              ],
              [
                'Uruguay',
                20,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Menafra solar farm',
                'Giacote S.A.',
                'Unknown',
              ],
              [
                'Uruguay',
                65,
                'South America',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'La Jacinta Solar Plant',
                'Fotowatio Renewable Ventures (FRV)',
                'Invenergy',
              ],
              [
                'Uzbekistan',
                300,
                'Asia',
                'Unavailable',
                'Nishon Tumani',
                'Guzur',
                'Guzur solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Uzbekistan',
                131,
                'Asia',
                'Unavailable',
                'Mirzo Ulugbek district',
                'Unavailable',
                'Tutly solar farm',
                'Tutly Solar LLC',
                'Total Eren',
              ],
              [
                'Uzbekistan',
                457,
                'Asia',
                'Unavailable',
                'Sherabad District',
                'Sherabad',
                'Sherabad solar farm',
                'Unknown',
                'Masdar',
              ],
              [
                'Uzbekistan',
                220,
                'Asia',
                'Unavailable',
                'Mirzo Ulugbek district',
                'Unavailable',
                'Samarkand solar farm',
                'Unknown',
                'Masdar',
              ],
              [
                'Uzbekistan',
                100,
                'Asia',
                'Unavailable',
                'Shayhontohur Tumani',
                'Unavailable',
                'Nur Navoi solar farm',
                'Masdar',
                'Masdar',
              ],
              [
                'Uzbekistan',
                200,
                'Asia',
                'Unavailable',
                'Bektemir district',
                'Unavailable',
                'Fergana solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Uzbekistan',
                200,
                'Asia',
                'Unavailable',
                'Nishon Tumani',
                'Unavailable',
                'Kashkadarya solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Uzbekistan',
                220,
                'Asia',
                'Unavailable',
                'Mirzachul District',
                'Unavailable',
                'Jizzakh solar farm',
                'Unknown',
                'Masdar',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'H\u00e0m Thu\u1eadn Nam District',
                'H\u00e0m Thu\u1eadn Nam District',
                'Unavailable',
                'Ham Kiem solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                46,
                'Asia',
                'H\u00e0m Thu\u1eadn Nam District',
                'H\u00e0m Thu\u1eadn Nam District',
                'Unavailable',
                'Ha\u0300M Ki\u1eb9\u0302M 1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc Minh',
                'Thu\u1eadn Nam',
                'Hacom solar farm',
                'Unknown',
                'Hacom Energy Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc Minh',
                'Thu\u1eadn Nam',
                'Hacom solar farm',
                'Unknown',
                'Hacom Energy Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Gio Linh District',
                'Gio Linh',
                'Gio Th\u00e0nh 2 solar farm',
                'Unknown',
                'Seco Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Gio Linh District',
                'Gio Linh',
                'Gio Th\u00e0nh 1 solar farm',
                'Unknown',
                'Bamboo Capital Group (BCG)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Cam L\u1ed9 District',
                'Unavailable',
                'Gio Hai solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                35,
                'Asia',
                'Unavailable',
                'Qu\u1ea3ng Th\u00e0nh',
                'Ch\u00e2u \u0110\u1ee9c',
                'Gia Hoet Lake solar farm',
                'Unknown',
                'Natural Energy Investment DTD Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Quy Nh\u01a1n',
                'Fujiwara solar farm',
                'Unknown',
                'Fujiwara Binh Dinh Limited Company',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'ECO Seido solar farm',
                'Unknown',
                'Green Energy Eco Seido',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'ECO Seido solar farm',
                'Unknown',
                'Green Energy Eco Seido',
              ],
              [
                'Vietnam',
                40,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'ECO Seido solar farm',
                'Unknown',
                'Green Energy Eco Seido',
              ],
              [
                'Vietnam',
                1400,
                'Asia',
                'Unavailable',
                'Ia RV\u00ea',
                'Ea S\u00fap',
                'Ea S\u00fap Xu\u00e2n Thi\u1ec7n solar farm',
                'Unknown',
                'Xuan Thien Group',
              ],
              [
                'Vietnam',
                831,
                'Asia',
                'Ea S\u00fap District',
                'Ea S\u00fap District',
                'Unavailable',
                'Ea S\u00fap Xu\u00e2n Thi\u1ec7n solar farm',
                'Unknown',
                'Xuan Thien Group',
              ],
              [
                'Vietnam',
                165,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Duy\u00ean H\u1ea3i Tr\u00e0 Vinh solar farm',
                'Unknown',
                'Trungnam Group',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                '\u0110\u1ee9c Hu\u1ec7 District',
                '\u0110\u1ee9c Hu\u1ec7 District',
                'Unavailable',
                '\u0110\u1ee9c Hu\u1ec7 TTC solar farm',
                'Unknown',
                'Thanh Thanh Cong Group (TTC)',
              ],
              [
                'Vietnam',
                250,
                'Asia',
                'Unavailable',
                'Long Dien',
                'Dong Hai',
                'Dong Hai solar farm',
                'Unknown',
                'SY Group',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Long Dien',
                'Dong Hai',
                'Dong Hai solar farm',
                'Unknown',
                'SY Group',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'Ham Phu',
                'H\u00e0m Thu\u1eadn B\u1eafc',
                'Ham Phu solar farm',
                'Unknown',
                'Thanh Thanh Cong Group (TTC); Gia Lai Hydropower Joint Stock Company',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                150,
                'Asia',
                'Unavailable',
                'H\u1ed3ng Phong',
                'B\u1eafc B\u00ecnh',
                'Hong Phong 1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'H\u1ed3ng Li\u00eam',
                'H\u00e0m Thu\u1eadn B\u1eafc',
                'H\u1ed3ng Li\u00eam 3 solar farm',
                'Unknown',
                'T&T Group',
              ],
              [
                'Vietnam',
                200,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                150,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                200,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                200,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                350,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh (Sungrow) solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'L\u1ec7 Th\u1ee7y District',
                'L\u1ec7 Th\u1ee7y District',
                'Unavailable',
                'Le Thuy Dohwa solar farm',
                'Unknown',
                'Dohwa Quang Binh Green Energy Company',
              ],
              [
                'Vietnam',
                61,
                'Asia',
                'Unavailable',
                'Kr\u00f4ng Pa District',
                'Kr\u00f4ng Pa',
                'Kr\u00f4ng Pa solar farm',
                'Unknown',
                'Gia Lai Electricity Joint Stock Company',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'Kr\u00f4ng Pa District',
                'Krong Pa',
                'Kr\u00f4ng Pa 2 solar farm',
                'Unknown',
                'Bamboo Capital Group (BCG)',
              ],
              [
                'Vietnam',
                268,
                'Asia',
                'Ph\u00fa H\u00f2a District',
                'Ph\u00fa H\u00f2a District',
                'Unavailable',
                'Hoa Hoi solar farm',
                'Phu Yen TTP Joint Stock Company',
                'B.Grimm Power Public Company Limited',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Ea Phe and Krong Puk Commune',
                'Kr\u00f4ng P\u1eafk District',
                'Kr\u00f4ng P\u1eafc',
                'Kr\u00f4ng B\u00fak Ha Solar',
                'IPC Group',
                'AC Energy; AMI AC Renewables',
              ],
              [
                'Vietnam',
                200,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ki\u00ean Giang Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Cam An Nam',
                'Cam L\u00e2m',
                'Kh\u00e1nh H\u00f2a AMI solar farm',
                'AMI AC Renewables',
                'AC Energy; AMI AC Renewables',
              ],
              [
                'Vietnam',
                20,
                'Asia',
                'Unavailable',
                'Ea Huar',
                'Bu\u00f4n \u0110\u00f4n',
                'Jang P\u00f4ng solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                48,
                'Asia',
                'Unavailable',
                'B\u1eafc B\u00ecnh District',
                'B\u1eafc B\u00ecnh',
                'Hong Phong 5.2 solar farm',
                'Unknown',
                'Millennium Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                48,
                'Asia',
                'Unavailable',
                'H\u1ed3ng Phong',
                'B\u1eafc B\u00ecnh',
                'Hong Phong 4 solar farm',
                'Unknown',
                'Ha Do Group',
              ],
              [
                'Vietnam',
                40,
                'Asia',
                'Unavailable',
                'Cam L\u00e2m District',
                'Cam L\u00e2m',
                '\u0110i\u1ec7n L\u1ef1c Mi\u1ec1n Trung solar farm',
                'Unknown',
                'Central Power Corporation (EVNCPC)',
              ],
              [
                'Vietnam',
                150,
                'Asia',
                'Unavailable',
                'H\u1ed3ng Phong',
                'B\u1eafc B\u00ecnh',
                'Hong Phong 1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'H\u00e0m Thu\u1eadn B\u1eafc District',
                'H\u00e0m Thu\u1eadn B\u1eafc',
                'H\u1ed3ng Li\u00eam 6.1 solar farm',
                'Unknown',
                'Truong Loc - Binh Thuan Solar Power Company Limited',
              ],
              [
                'Vietnam',
                45,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ki\u00ean Th\u1ecd - Ng\u1ecdc L\u1eb7c solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                240,
                'Asia',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'Unavailable',
                'Dau Tieng solar farm',
                'Unknown',
                'B.Grimm Power Public Company Limited [96%]; Xuan Cau Group [4%]',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Kr\u00f4ng P\u1eafk District',
                'Kr\u00f4ng P\u1eafk District',
                'Unavailable',
                '\u0110\u1eafk L\u1eafk BMT solar farm',
                'Unknown',
                'AMI Joint Stock Company; AC Energy Group',
              ],
              [
                'Vietnam',
                90,
                'Asia',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'Unavailable',
                'Dau Tieng 3 solar farm',
                'Unknown',
                'Xuan Cau Holdings',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'B\u00ecnh \u0110\u1ea1i District',
                'B\u00ecnh \u0110\u1ea1i',
                'B\u1ebfn Tre solar farm',
                'Gulf International Holding Company Limited; Ms. Huynh Bich Ngoc',
                'Gulf International Holding Company Limited [49%]; Ms. Huynh Bich Ngoc [51%]',
              ],
              [
                'Vietnam',
                25,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc H\u1eefu',
                'Ninh Ph\u01b0\u1edbc',
                'B\u1ea7u Z\u00f4n solar farm',
                'Unknown',
                'Asia Industrial Technology Joint Stock Company',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'B\u00e1c \u00c1i District',
                'B\u1eafc \u00c1i',
                'B\u1ea7u Ng\u1ee9 Lake solar farm',
                'Unknown',
                'Truong Thanh Investment Construction and Development Joint Stock Company',
              ],
              [
                'Vietnam',
                41,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Th\u1ea1nh H\u00f3a',
                'B\u0103ng D\u01b0\u01a1ng Bcg solar farm',
                'Unknown',
                'Bamboo Capital Group (BCG)',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Suoi Day',
                'T\u00e2n Ch\u00e2u',
                'B\u00e1ch Khoa A Chua solar farm',
                'IPC Group',
                'Bright Green Power Company Limited',
              ],
              [
                'Vietnam',
                106,
                'Asia',
                'Unavailable',
                'An H\u1ea3o',
                'T\u1ecbnh Bi\u00ean',
                'An Giang Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                104,
                'Asia',
                'Unavailable',
                'An H\u1ea3o',
                'T\u1ecbnh Bi\u00ean',
                'An Giang Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                150,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u1eafc B\u00ecnh District',
                'B\u1eafc B\u00ecnh',
                'B\u00ecnh An solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'V\u0129nh H\u1ea3o',
                'Tuy Phong',
                'V\u0129nh H\u1ea3o 6 solar farm',
                'NOMAC Vietnam',
                'ACWA Power [60%]; FECON Corporation [40%]',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'C\u1ea7u Ngang District',
                'V\u0169ng Li\u00eam',
                'V\u0129nh Long VNECO solar farm',
                'Unknown',
                'Bamboo Capital Group Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                43,
                'Asia',
                'Tuy Phong District',
                'Tuy Phong District',
                'Unavailable',
                'V\u0129nh T\u00e2n 2 solar farm',
                'Unknown',
                'Power Generation Corporation 3 (EVNGENCO 3)',
              ],
              [
                'Vietnam',
                188,
                'Asia',
                'Unavailable',
                'Unavailable',
                'S\u00f4ng C\u1ea7u',
                'Xanh S\u00f4ng C\u1ea7u solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                250,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'Xinghai 4/5 solar farm',
                'Risen Energy Company Limited',
                'Xinghai Group',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Xu\u00e2n Th\u1ecd 1',
                'S\u00f4ng C\u1ea7u',
                'Xu\u00e2n Th\u1ecd solar farm',
                'Powercare Joint Stock Company',
                'BG Container Glass Public Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Xu\u00e2n Th\u1ecd 2',
                'S\u00f4ng C\u1ea7u',
                'Xu\u00e2n Th\u1ecd solar farm',
                'Powercare Joint Stock Company',
                'BG Container Glass Public Company Limited',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Y\u00ean Th\u00e1i',
                'Y\u00ean \u0110\u1ecbnh',
                'Y\u00ean \u0110\u1ecbnh solar farm',
                'Unknown',
                'Song Lam Son La Energy Joint Stock Company; Song Lam Investment & Construction Company Limited',
              ],
              [
                'Vietnam',
                125,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                180,
                'Asia',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'Unavailable',
                'Dau Tieng solar farm',
                'Unknown',
                'Xuan Cau Holdings',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'B\u00ecnh S\u01a1n District',
                'B\u00ecnh S\u01a1n District',
                'Unavailable',
                'B\u00ecnh Nguy\u00ean solar farm',
                'Unknown',
                'Troung Thanh Quang Ngain Power and High Technology Joint Stock Company (TTQN)',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'Phuoc Huu',
                'Ninh Phuoc',
                'Bp Solar 1 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                60,
                'Asia',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'D\u01b0\u01a1ng Minh Ch\u00e2u District',
                'Unavailable',
                'Dau Tieng 3 solar farm',
                'Unknown',
                'Xuan Cau Holdings',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Ph\u00f9 M\u1ef9 District',
                'Ph\u00f9 M\u1ef9 District',
                'Unavailable',
                'Dam Tra O solar farm',
                'Unknown',
                'Licogi 16 Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'L\u1ed9c Ninh District',
                'L\u1ed9c Ninh',
                'L\u1ed9c Ninh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                59,
                'Asia',
                'T\u00e1nh Linh District',
                'T\u00e1nh Linh District',
                'Unavailable',
                '\u0110a Mi solar farm',
                'Unknown',
                'Da Nhim - Ham Thuan - Da Mi Hydropower Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                '\u0110\u00e1 B\u1ea1c solar farm',
                'Unknown',
                'Tai Tien Company Limited; Dong A Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                '\u0110\u00e1 B\u1ea1c solar farm',
                'Unknown',
                'Tai Tien Company Limited; Dong A Joint Stock Company',
              ],
              [
                'Vietnam',
                60,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                '\u0110\u00e1 B\u1ea1c solar farm',
                'Unknown',
                'Tai Tien Company Limited; Dong A Joint Stock Company',
              ],
              [
                'Vietnam',
                60,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                '\u0110\u00e1 B\u1ea1c solar farm',
                'Unknown',
                'Tai Tien Company Limited; Dong A Joint Stock Company',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'B\u00ecnh Thu\u1eadn II solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                "Ea T'ling",
                'C\u01b0 Jut',
                'C\u01b0 Jut solar farm',
                'Unknown',
                'Central Hydropower Joint Stock Company (EVNCHP)',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Ch\u00e2u \u0110\u1ee9c',
                'Ch\u00e2u \u0110\u1ee9c solar farm',
                'Unknown',
                'Halla E&C company; Hyosung Group',
              ],
              [
                'Vietnam',
                70,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                'Ch\u00e2u \u0110\u1ee9c (SH Power) solar farm',
                'SH Solar Farm Vina Company Limited',
                'SH Solar Farm Vina Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ph\u00f9 C\u00e1t District',
                'Ph\u00f9 C\u00e1t',
                'Cat Hiep solar farm',
                'Binh Dinh TTP Energy & High Technology',
                'Binh Dinh TTP Energy & High Technology (BDE)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Cam Ranh city',
                'Unavailable',
                'Cam Ranh solar farm',
                'Waaree Energies',
                'Song Giang Solar Power Joint Stock Company',
              ],
              [
                'Vietnam',
                29,
                'Asia',
                'Unavailable',
                'C\u1ea9m Xuy\u00ean District',
                'C\u1ea9m Xuy\u00ean',
                'C\u1ea9m H\u01b0ng solar farm',
                'Powercare Joint Stock Company',
                'German ASEAN Power (GA Power)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'C\u1ea9m Xuy\u00ean District',
                'C\u1ea9m Xuy\u00ean',
                'C\u1ea9m H\u00f2a solar farm',
                'Unknown',
                'Hoanh Son Group Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Cam L\u00e2m District',
                'Cam L\u00e2m District',
                'Unavailable',
                'Cam An Bac Vn solar farm',
                'Hanwha Energy Vietnam',
                'Long Thanh Golf Investment & Trading Joint Stock Company; Hanwha Energy Group of Korea',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Cam L\u00e2m District',
                'Cam L\u00e2m District',
                'Unavailable',
                'Cam An Bac Kn solar farm',
                'Hanwha Energy Vietnam',
                'Long Thanh Golf Investment & Trading Joint Stock Company; Hanwha Energy Group of Korea',
              ],
              [
                'Vietnam',
                25,
                'Asia',
                'Unavailable',
                'Kr\u00f4ng Pa District',
                'Krong Pa',
                'Ch\u01b0 Ng\u1ecdc solar farm',
                'Unknown',
                'Licogi 16 Joint Stock Company',
              ],
              [
                'Vietnam',
                41,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Th\u1ea1nh H\u00f3a',
                'Long An BCG-CME solar farm',
                'Unknown',
                'Bamboo Capital Group Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                29,
                'Asia',
                'Ph\u1ee5ng Hi\u1ec7p District',
                'Ph\u1ee5ng Hi\u1ec7p District',
                'Unavailable',
                'H\u1eadu Giang solar farm',
                'Unknown',
                'Hacom Vietnam Joint Stock Company; Shizen Energy',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'M\u1ef9 Th\u1ea1nh B\u1eafc',
                '\u0110\u1ee9c Hu\u1ec7',
                'Long An Europlast solar farm',
                'Unknown',
                'Sao Mai Group (ASM) [77%]; Europe Plastics Joint Stock Company',
              ],
              [
                'Vietnam',
                126,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Th\u1ea1nh H\u00f3a',
                'Long An BCG-CME solar farm',
                'Unknown',
                'Hanwha \u2013 Bamboo Capital Group Bang Duong Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                256,
                'Asia',
                'Thu\u1eadn B\u1eafc District',
                'Thu\u1eadn B\u1eafc District',
                'Unavailable',
                'Thu\u1eadn B\u1eafc Xu\u00e2n Thi\u1ec7n solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                204,
                'Asia',
                'Thu\u1eadn B\u1eafc District',
                'Thu\u1eadn B\u1eafc District',
                'Unavailable',
                'Thu\u1eadn B\u1eafc solar farm',
                'Unknown',
                'Trungnam Group; A Chau Industrial Technology Joint Stock Company',
              ],
              [
                'Vietnam',
                48,
                'Asia',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam District',
                'Unavailable',
                'Th\u1eeba Thi\u00ean Hu\u1ebf (TTC) solar farm',
                'Unknown',
                'Sharp Energy Solutions Corporation; Thanh Thanh Cong Group (TTC); Gia Lai Electricity Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'T\u00e2y H\u00f2a District',
                'T\u00e2y H\u00f2a District',
                'Unavailable',
                'Th\u1ecbnh Long solar farm',
                'Thinh Long Phu Yen Solar Power Joint Stock Company',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Thi\u00ean T\u00e2n Ninh Thu\u1eadn solar farm',
                'Unknown',
                'Thi\u00ean T\u00e2n Group',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Th\u00e1p Ch\u00e0m solar farm',
                'Unknown',
                'Bitexco Group',
              ],
              [
                'Vietnam',
                160,
                'Asia',
                'Unavailable',
                'Ph\u00fa L\u00e2m',
                'T\u0129nh Gia',
                'Thanh H\u00f3a (Mt Vietnam Energy) solar farm',
                'Unknown',
                'MT Vietnam Energy Group Joint Stock Company',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Th\u1ea1nh H\u00f3a',
                'Thanh H\u00f3a (BCG) solar farm',
                'Unknown',
                'Bamboo Capital Group (BCG); Hanwha',
              ],
              [
                'Vietnam',
                450,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc Minh',
                'Thu\u1eadn Nam',
                'Thu\u1eadn Nam (Trung Nam) solar farm',
                'Unknown',
                'Trungnam Group',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Ph\u01b0\u1edbc Long',
                'Thac Mo solar farm',
                'Unknown',
                'Power Generation Corporation 2 (EVNGENCO 2)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Su\u1ed1i D\u00e2y',
                'T\u00e2n Ch\u00e2u',
                'Tan Chau solar farm',
                'Unknown',
                'A Chau Bach Khoa Joint Stock Company',
              ],
              [
                'Vietnam',
                35,
                'Asia',
                'Chau Duc District',
                'Chau Duc District',
                'Unavailable',
                'Tam Bo Lake solar farm',
                'Unknown',
                'Energy Development Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Surya Ninh Thu\u1eadn solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Bu\u00f4n \u0110\u00f4n District',
                'Bu\u00f4n \u0110\u00f4n',
                'Srepok 1 solar farm',
                'Unknown',
                'Dai Hai Investment Development Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc Th\u00e1i',
                'Ninh Ph\u01b0\u1edbc',
                'Sp Infra 1 solar farm',
                'Unknown',
                'Shapoorji Pallonji Infrastructure Capital Company Private Limited (SP Infra)',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'B\u1eafc B\u00ecnh District',
                'B\u1eafc B\u00ecnh',
                'S\u00f4ng L\u0169y 1 solar farm',
                'Unknown',
                'Binh Thuan Solar Power Investment JSC',
              ],
              [
                'Vietnam',
                188,
                'Asia',
                'Unavailable',
                'Ham Tan District',
                'S\u00f4ng B\u00ecnh',
                'S\u00f4ng B\u00ecnh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'Ham Tan District',
                'S\u00f4ng B\u00ecnh',
                'S\u00f4ng B\u00ecnh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                29,
                'Asia',
                'Unavailable',
                'C\u1ea9m Xuy\u00ean District',
                'C\u1ea9m Xuy\u00ean',
                'S\u01a1n Quang solar farm',
                'Unknown',
                'German ASEAN Power (GA Power)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ben Cau District',
                'B\u1ebfn C\u1ea7u',
                'T\u00e2y Ninh Hcg solar farm',
                'TTC Energy Development Investment Joint Stock Company',
                'Gulf Energy Development Public Company Limited [90%]',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Ham Tan District',
                'Ham Tan District',
                'Unavailable',
                'S\u01a1n M\u1ef9 solar farm',
                'Power Engineering Consulting Joint Stock Company 2 (PECC2)',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Thu\u1eadn Nam 12 solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Nha Trang',
                'Unavailable',
                'Unavailable',
                'Thu\u1eadn Nam \u0110\u1ee9c Long solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group); Solar Energy LA Joint Stock Company',
              ],
              [
                'Vietnam',
                150,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group); Vietnam Solar Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group); Long An Global Company Limited',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'V\u1ea1n H\u01b0ng',
                'V\u1ea1n Ninh',
                'V\u1ea1n Ninh KN solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'T\u1ecbnh Bi\u00ean District',
                'T\u1ecbnh Bi\u00ean',
                'V\u0103n Gi\u00e1o solar farm',
                'Van Giao Solar Energy Plant Joint Stock Company',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'T\u1ecbnh Bi\u00ean District',
                'T\u1ecbnh Bi\u00ean',
                'V\u0103n Gi\u00e1o solar farm',
                'Van Giao Solar Energy Plant Joint Stock Company',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Thu\u1eadn Nam 19 solar farm',
                'Unknown',
                'Tasco Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                38,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'Tuy Phong B\u00ecnh Thu\u1eadn solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                69,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'TTCIZ solar farm',
                'Gulf Energy Development Public Company Limited',
                'Gulf Energy Development Public Company Limited [90%]; Thanh Thanh Cong Group (TTC) [10%]',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'An H\u00f2a',
                'Tr\u1ea3ng B\u00e0ng',
                'TTC No. 2 solar farm',
                'Unknown',
                'Gulf Energy Development Public Company Limited',
              ],
              [
                'Vietnam',
                69,
                'Asia',
                'Unavailable',
                'An H\u00f2a',
                'Tr\u1ea3ng B\u00e0ng',
                'TTC No. 1 solar farm',
                'Unknown',
                'Gulf Energy Development Public Company Limited',
              ],
              [
                'Vietnam',
                35,
                'Asia',
                'Unavailable',
                'Cam L\u00e2m District',
                'Cam L\u00e2m',
                'Trung Son solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                255,
                'Asia',
                'Unavailable',
                'Thu\u1eadn B\u1eafc District',
                'Thu\u1eadn B\u1eafc',
                'Trung Nam solar farm',
                'Unknown',
                'A Chau Industrial Technology; Trungnam Group',
              ],
              [
                'Vietnam',
                44,
                'Asia',
                'Unavailable',
                'Tr\u00fac S\u01a1n',
                'C\u01b0 Jut',
                'Tr\u00fac S\u01a1n solar farm',
                'Unknown',
                'Univergy Solar; Thanh Nien Media Corporation; Europe Clean Energies',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'T\u00e2n Ch\u00e2u District',
                'T\u00e2n Ch\u00e2u',
                'Tri Viet solar farm',
                'IPC Group',
                'Bright Green Power Company Limited',
              ],
              [
                'Vietnam',
                106,
                'Asia',
                'Unavailable',
                'An H\u1ea3o',
                'T\u1ecbnh Bi\u00ean',
                'T\u1ecbnh Bi\u00ean Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                104,
                'Asia',
                'Unavailable',
                'An H\u1ea3o',
                'T\u1ecbnh Bi\u00ean',
                'T\u1ecbnh Bi\u00ean Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'TTCIZ solar farm',
                'Gulf Energy Development Public Company Limited',
                'Gulf Energy Development Public Company Limited [90%]; Thanh Thanh Cong Group (TTC) [10%]',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'M\u1ef9 T\u00fa District',
                'Unavailable',
                'Soc Trang solar farm',
                'Unknown',
                'Nam Viet Energy',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'H\u00e0m Thu\u1eadn B\u1eafc District',
                'H\u00e0m Thu\u1eadn B\u1eafc',
                'Thu\u1eadn Minh 2 solar farm',
                'Unknown',
                'SD Truong Thanh Joint Stock Company',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'Ia T\u01a1i',
                "Ya H' Drai",
                'S\u00ea San 4 solar farm',
                'Unknown',
                'Vietnam Electricity (EVN)',
              ],
              [
                'Vietnam',
                104,
                'Asia',
                'Unavailable',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Ninh Thu\u1eadn Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Ninh Thu\u1eadn Gelex solar farm',
                'Unknown',
                'Vietnam Electrical Equipment Joint Stock Company (GELEX); Power Solution Technologies PCL (BKK:PSTC)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Ninh Thu\u1eadn BIM solar farm',
                'Unknown',
                'BIM Energy; AC Energy',
              ],
              [
                'Vietnam',
                250,
                'Asia',
                'Unavailable',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Ninh Thu\u1eadn BIM solar farm',
                'Unknown',
                'BIM Energy; AC Energy',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Ninh Thu\u1eadn BIM solar farm',
                'Unknown',
                'BIM Energy; AC Energy',
              ],
              [
                'Vietnam',
                61,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Ninh Thu\u1eadn (Tasco) solar farm',
                'Unknown',
                'Tasco Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ph\u01b0\u1edbc Vinh',
                'Ninh Ph\u01b0\u1edbc',
                'Ninh Ph\u01b0\u1edbc Ha Do solar farm',
                'Unknown',
                'Ha Do Group',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ninh Ph\u01b0\u1edbc 6.2 solar farm',
                'Power Engineering Consulting Joint Stock Company 2 (PECC2)',
                'Ninh Thuan Agriculture & Renewable Energy Joint Stock Company',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'M\u1ef9 T\u00fa District',
                'Unavailable',
                'Soc Trang solar farm',
                'Unknown',
                'Nam Viet Energy',
              ],
              [
                'Vietnam',
                35,
                'Asia',
                'Ninh H\u1ea3i District',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Nh\u01a1n H\u1ea3i Solar Farm',
                'Unknown',
                'Licogi 16 Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Nh\u1ecb H\u00e0 solar farm',
                'Unknown',
                'Bitexco Group',
              ],
              [
                'Vietnam',
                90,
                'Asia',
                'Unavailable',
                'Ki\u00ean Th\u1ecd',
                'Ng\u1ecdc L\u1eb7c',
                'Ng\u1ecdc L\u1eb7c solar farm',
                'Unknown',
                'Hoanh Son Group Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh S\u01a1n District',
                'Ninh S\u01a1n',
                'M\u1ef9 S\u01a1n solar farm',
                'Powercare Joint Stock Company',
                'BB Group; BG Energy Solutions',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'Ninh S\u01a1n District',
                'Ninh S\u01a1n',
                'M\u1ef9 S\u01a1n solar farm',
                'Powercare Joint Stock Company',
                'BB Group; BG Energy Solutions',
              ],
              [
                'Vietnam',
                63,
                'Asia',
                'Unavailable',
                'Ninh S\u01a1n District',
                'Ninh S\u01a1n',
                'M\u1ef9 S\u01a1n - Ho\u00e0n L\u1ed9c Vi\u1ec7t solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'M\u1ef9 Hi\u1ec7p',
                'Ph\u00fa M\u1ef9',
                'M\u1ef9 Hi\u1ec7p solar farm',
                'Unknown',
                'Wealth Power Group; NSN Construction & Engineering Joint Stock Company',
              ],
              [
                'Vietnam',
                40,
                'Asia',
                'Phan Thi\u1ebft',
                'H\u00e0m Thu\u1eadn Nam District',
                'H\u00e0m Thu\u1eadn Nam',
                'M\u0169i N\u00e9 solar farm',
                'Unknown',
                'Dragon Capital Group; Pacifico Energy',
              ],
              [
                'Vietnam',
                24,
                'Asia',
                'Unavailable',
                'M\u1ed9 \u0110\u1ee9c District',
                'M\u1ed9 \u0110\u1ee9c',
                'M\u1ed9 \u0110\u1ee9c solar farm',
                'Unknown',
                'Thi\u00ean T\u00e2n Group',
              ],
              [
                'Vietnam',
                60,
                'Asia',
                'Unavailable',
                'Ea S\u00fap District',
                'Ea Sup',
                'Long Th\u00e0nh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                60,
                'Asia',
                'Unavailable',
                'Ea S\u00fap District',
                'Ea Sup',
                'Long Th\u00e0nh solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                170,
                'Asia',
                'Unavailable',
                'Ninh H\u00f2a District',
                'Ninh H\u00f2a',
                'Long S\u01a1n solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                106,
                'Asia',
                'Unavailable',
                'Ninh H\u1ea3i District',
                'Unavailable',
                'Ninh Thu\u1eadn Sao Mai solar farm',
                'Unknown',
                'Sao Mai Group (ASM)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ninh Thu\u1eadn Sinenergy solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'B\u00ecnh H\u00f2a Nam',
                '\u0110\u1ee9c Hu\u1ec7',
                'Vietnam Solar Park',
                'Unknown',
                'Vietnam Royal Investment Group (VRI Group); Long An Solar Park Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'N\u00fai M\u1ed9t Lake solar farm',
                'Unknown',
                'Truong Thanh Investment Construction and Development Joint Stock Company',
              ],
              [
                'Vietnam',
                168,
                'Asia',
                'Ninh S\u01a1n District',
                'Ninh S\u01a1n District',
                'Unavailable',
                'Ninh Thu\u1eadn Sunseap solar farm',
                'Unknown',
                'Sunseap Group; InfraCo Asia Development Private Limited (IAD)',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'S\u01a1n Th\u00e0nh \u0110\u00f4ng',
                'T\u00e2y H\u00f2a',
                'Ph\u00fa Y\u00ean Europlast solar farm',
                'Unknown',
                'Europe Plastics Joint Stock Company',
              ],
              [
                'Vietnam',
                114,
                'Asia',
                'Unavailable',
                'Ph\u00f9 M\u1ef9 District',
                'Ph\u00f9 M\u1ef9',
                'Ph\u00f9 M\u1ef9 solar farm',
                'Unknown',
                'Clean Energy Vision Development Joint Stock Company',
              ],
              [
                'Vietnam',
                257,
                'Asia',
                'Ph\u00fa H\u00f2a District',
                'Ph\u00fa H\u00f2a District',
                'Unavailable',
                'Ph\u00fa Y\u00ean solar farm',
                'Unknown',
                'B.Grimm Power Public Company Limited [50%]; Truong Thanh Viet Nam Group Joint Stock Company [50%]',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ph\u01b0\u1edbc H\u1eefu solar farm',
                'Unknown',
                'Nha Trang Bay Construction Investment Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Ph\u01b0\u1edbc Minh Adani solar farm',
                'Unknown',
                'TSV Investment and Development; Adani Group',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam',
                'Ph\u01b0\u1edbc Minh Adani solar farm',
                'Unknown',
                'TSV Investment and Development; Adani Group',
              ],
              [
                'Vietnam',
                45,
                'Asia',
                'Thu\u1eadn Nam District',
                'Thu\u1eadn Nam District',
                'Unavailable',
                'Ph\u01b0\u1edbc Ninh solar farm',
                'Unknown',
                'Ninh Thuan Energy Industry Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ph\u01b0\u1edbc Th\u00e1i solar farm',
                'Unknown',
                'Unknown',
              ],
              [
                'Vietnam',
                100,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ph\u01b0\u1edbc Th\u00e1i solar farm',
                'Unknown',
                'Vietnam Electricity (EVN)',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ph\u01b0\u1edbc H\u1eefu - \u0110i\u1ec7n L\u1ef1c solar farm',
                'Unknown',
                'Phuoc Huu Electricity Investment Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Bu\u00f4n \u0110\u00f4n District',
                'Bu\u00f4n \u0110\u00f4n District',
                'Unavailable',
                'Quang Minh solar farm',
                'Unknown',
                'Srepok Solar Power Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Gio Linh District',
                'Gio Linh',
                'Qu\u1ea3ng Tr\u1ecb Lig solar farm',
                'Unknown',
                'Licogi 13 Joint Stock Company',
              ],
              [
                'Vietnam',
                216,
                'Asia',
                'Unavailable',
                'Ph\u00f9 M\u1ef9 District',
                'Ph\u00f9 M\u1ef9',
                'Ph\u00f9 M\u1ef9 solar farm',
                'Unknown',
                'Clean Energy Vision Development Joint Stock Company',
              ],
              [
                'Vietnam',
                42,
                'Asia',
                'Unavailable',
                'Tuy Phong District',
                'Tuy Phong',
                'Phong Ph\u00fa solar farm',
                'Unknown',
                'Solarcom Joint Stock Company',
              ],
              [
                'Vietnam',
                48,
                'Asia',
                'Unavailable',
                'Unavailable',
                'Unavailable',
                'Phong \u0110i\u1ec1n solar farm',
                'Unknown',
                'Gia Lai Electricity Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Phong \u0110i\u1ec1n District',
                'Phong \u0110i\u1ec1n District',
                'Unavailable',
                'Phong \u0110i\u1ec1n 2 solar farm',
                'Unknown',
                'Gunkul Engineering Company',
              ],
              [
                'Vietnam',
                37,
                'Asia',
                'Unavailable',
                'Phan L\u00e2m',
                'B\u1eafc B\u00ecnh',
                'Phan L\u00e2m solar farm',
                'Unknown',
                'Super Energy Corporation Public Company Limited',
              ],
              [
                'Vietnam',
                30,
                'Asia',
                'Unavailable',
                'Ph\u00fa L\u1ed9c District',
                '\u0110i\u1ec1n L\u1ed9c',
                'Phong \u0110i\u1ec1n (TTC) solar farm',
                'Unknown',
                'Thanh Thanh Cong Group (TTC)',
              ],
              [
                'Vietnam',
                35,
                'Asia',
                'Unavailable',
                'Ph\u00fa L\u1ed9c District',
                '\u0110i\u1ec1n L\u1ed9c',
                'Phong \u0110i\u1ec1n (TTC) solar farm',
                'Unknown',
                'Thanh Thanh Cong Group (TTC)',
              ],
              [
                'Vietnam',
                49,
                'Asia',
                'Unavailable',
                'B\u1eafc B\u00ecnh District',
                'B\u1eafc B\u00ecnh',
                'Phan L\u00e2m solar farm',
                'Unknown',
                'BB Power Holdings Joint Stock Company',
              ],
              [
                'Vietnam',
                50,
                'Asia',
                'Unavailable',
                'Ninh Ph\u01b0\u1edbc District',
                'Ninh Ph\u01b0\u1edbc',
                'Ph\u01b0\u1edbc Th\u00e1i solar farm',
                'Unknown',
                'Vietnam Electricity (EVN)',
              ],
              [
                'Western Sahara',
                500,
                'Africa',
                'Sebkha Tah',
                'cercle de Daoura-El Hagounia \u062f\u0627\u0626\u0631\u0629 \u062f\u0648\u0631\u0629 \u0627\u0644\u062d\u0643\u0648\u0646\u064a\u0629',
                'Western Sahara',
                'Sebkha Tah solar farm',
                'Unknown',
                'MASEN',
              ],
              [
                'Western Sahara',
                85,
                'Africa',
                'Dcheira',
                'Cercle de La\u00e2youne \u062f\u0627\u0626\u0631\u0629 \u0627\u0644\u0639\u064a\u0648\u0646',
                'Laayoune Province',
                'Noor Solar PV 1',
                'NOMAC',
                'ACWA Power; MASEN',
              ],
              [
                'Western Sahara',
                500,
                'Africa',
                'Foum El Oued',
                'Unavailable',
                'Unavailable',
                'Foum El Oued Solar',
                'Unknown',
                'MASEN',
              ],
              [
                'Western Sahara',
                20,
                'Africa',
                'Boujdour',
                'Pachalik de Boujdour \u0625\u0642\u0644\u064a\u0645 \u0628\u0648\u062c\u062f\u0648\u0631',
                'Boujdour Province',
                'Noor Solar PV 1',
                'NOMAC',
                'ACWA Power; MASEN',
              ],
              [
                'Zambia',
                54,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Kafue District',
                'Bangweulu solar farm',
                'Unknown',
                'Bangweulu Power Company Limited; International Finance Corporation; Overseas Private Investment Corporation',
              ],
              [
                'Zambia',
                100,
                'Africa',
                'Ndola',
                'Unavailable',
                'Ndola District',
                'Bwana Mkubwa Tailings solar farm',
                'Unknown',
                'Zuwa Solar Limited',
              ],
              [
                'Zambia',
                200,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Chibombo',
                'Chibombo solar farm',
                'Unknown',
                'ZESCO Limited',
              ],
              [
                'Zambia',
                200,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Chirundu',
                'Chirundu solar farm',
                'Unknown',
                'ZESCO Limited',
              ],
              [
                'Zambia',
                50,
                'Africa',
                'Mongu',
                'Unavailable',
                'Mongu',
                'Mongu solar farm',
                'Unknown',
                'Elsewedy Electric Group; Toyota Tsusho Corporation',
              ],
              [
                'Zambia',
                34,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Kafue District',
                'Ngonye solar farm',
                'Enel Green Power',
                'Enel Green Power [80%]; Industrial Dvelopment Corporation [20%]',
              ],
              [
                'Zambia',
                100,
                'Africa',
                'Kosamu',
                'Unavailable',
                'Serenje District',
                'Serenje solar farm',
                'Unknown',
                'Ultra Green Corporation Zambia',
              ],
              [
                'Zambia',
                35,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Shangombo',
                'Shangombo solar farm',
                'Unknown',
                'Nocart',
              ],
              [
                'Zambia',
                100,
                'Africa',
                'Kosamu',
                'Unavailable',
                'Serenje District',
                'Serenje solar farm',
                'Unknown',
                'Ultra Green Corporation Zambia',
              ],
              [
                'Zambia',
                50,
                'Africa',
                'Sesheke',
                'Unavailable',
                'Sesheke',
                'Sesheke solar farm',
                'Unknown',
                'Elsewedy Electric Group; Toyota Tsusho Corporation',
              ],
              [
                'Zambia',
                200,
                'Africa',
                'Unavailable',
                'Unavailable',
                'Siavonga',
                'Siavonga solar farm',
                'Unknown',
                'ZESCO Limited',
              ],
              [
                'Zimbabwe',
                50,
                'Africa',
                'Chipinge',
                'Mutare',
                'Chipinge District',
                'Chipinge solar farm',
                'Unknown',
                'Old Mutual',
              ],
              [
                'Zimbabwe',
                60,
                'Africa',
                'Chegutu',
                'Hurungwe',
                'Chegutu District',
                'Cactus Hill solar farm',
                'Unknown',
                'Lunigar Solar',
              ],
              [
                'Zimbabwe',
                30,
                'Africa',
                'Makokoro',
                'Murehwa',
                'Seke District',
                'Zhenje Solar Farm',
                'Unknown',
                'Zhenje Solar Park',
              ],
              [
                'Zimbabwe',
                30,
                'Africa',
                'Vungu',
                'Gweru',
                'Unavailable',
                'Vungu solar farm',
                'Unknown',
                'Xago Africa; Energywise Equipment',
              ],
              [
                'Zimbabwe',
                125,
                'Africa',
                'Victoria Falls',
                'Hwange',
                'Hwange District',
                'Victoria Falls Sez solar farm',
                'Unknown',
                'Southpole Consulting Private',
              ],
              [
                'Zimbabwe',
                200,
                'Africa',
                'Unavailable',
                'Hwange',
                'Umguza District',
                'Umguza solar farm',
                'Unknown',
                'Af Power Pte',
              ],
              [
                'Zimbabwe',
                45,
                'Africa',
                'Chirezdi',
                'Chiredzi',
                'Chirezdi District',
                'Triangle Chiredzi solar farm',
                'Unknown',
                'Triangle Solar System',
              ],
              [
                'Zimbabwe',
                45,
                'Africa',
                'Chirezdi',
                'Chiredzi',
                'Chirezdi District',
                'Triangle Chiredzi solar farm',
                'Unknown',
                'Triangle Solar System',
              ],
              [
                'Zimbabwe',
                50,
                'Africa',
                'Kwekwe',
                'Kwekwe',
                'Unavailable',
                'Sable solar farm',
                'Unknown',
                'Tatanga Energy; Masawara',
              ],
              [
                'Zimbabwe',
                30,
                'Africa',
                'Colleen Bawn',
                'Gwanda',
                'Gwanda District',
                'Ppc Colleen Bawn solar farm',
                'Unknown',
                'Pretoria Portland Cement',
              ],
              [
                'Zimbabwe',
                225,
                'Africa',
                'Zvimba',
                'Zvimba',
                'Unavailable',
                'Nyabira solar farm',
                'Unknown',
                'National Social Security Authority; Old Mutual',
              ],
              [
                'Zimbabwe',
                25,
                'Africa',
                'Zvimba',
                'Zvimba',
                'Unavailable',
                'Nyabira solar farm',
                'Unknown',
                'National Social Security Authority; Old Mutual',
              ],
              [
                'Zimbabwe',
                100,
                'Africa',
                'Ntabazinduna Communal Land',
                'Umguza',
                'Unavailable',
                'Ntabazinduna Solar Farm',
                'Unknown',
                'Yellow Africa',
              ],
              [
                'Zimbabwe',
                100,
                'Africa',
                'Munyati',
                'Gweru',
                'Kwekwe District',
                'Munyati solar farm',
                'Unknown',
                'Zimbabwe Power Company',
              ],
              [
                'Zimbabwe',
                85,
                'Africa',
                'Seluos Village',
                'Hurungwe',
                'Unavailable',
                'Mhondoro-Ngezi solar farm',
                'Zimplats',
                'Zimplats',
              ],
              [
                'Zimbabwe',
                105,
                'Africa',
                'Ngezi',
                'Hurungwe',
                'Mhondoro-Ngezi District',
                'Mhondoro-Ngezi solar farm',
                'Zimplats',
                'Zimplats',
              ],
              [
                'Zimbabwe',
                400,
                'Africa',
                'Kwekwe',
                'Gweru',
                'Kwekwe Distrcit',
                'Katanga Kwekwe solar farm',
                'Unknown',
                'Katanga Solar Energy; Sable Chemicals',
              ],
              [
                'Zimbabwe',
                100,
                'Africa',
                'Insukamini',
                'Gweru',
                'Unavailable',
                'Insukamini solar farm',
                'Unknown',
                'Intratrek Zimbabwe; ZTE; JA Solar Holdings',
              ],
              [
                'Zimbabwe',
                20,
                'Africa',
                'Boni Village',
                'Murehwa',
                'Seke District',
                'Harava solar farm',
                'Unknown',
                'Harava Solar',
              ],
              [
                'Zimbabwe',
                20,
                'Africa',
                'Boni Village',
                'Murehwa',
                'Seke District',
                'Harava solar farm',
                'Unknown',
                'Harava Solar',
              ],
              [
                'Zimbabwe',
                50,
                'Africa',
                'Gwanda',
                'Gwanda',
                'Gwanda District',
                'Gwanda solar farm',
                'Unknown',
                'Old Mutual',
              ],
              [
                'Zimbabwe',
                100,
                'Africa',
                'Gwanda',
                'Gwanda',
                'Gwanda District',
                'Gwanda Intratrek solar farm',
                'Unknown',
                'Zimbabwe Power Company',
              ],
              [
                'Zimbabwe',
                30,
                'Africa',
                'Harare',
                'Harare',
                'Unavailable',
                'Ecosoft solar farm',
                'Unknown',
                'Td Energy',
              ],
              [
                'Zimbabwe',
                50,
                'Africa',
                'Bulawayo',
                'Bulawayo',
                'City of Bulawayo District',
                'Donnington West solar farm',
                'Parvalue Energy',
                'Parvalue Energy',
              ],
              [
                'Zimbabwe',
                50,
                'Africa',
                'Marondera',
                'Murehwa',
                'Marondera District',
                'De Green solar farm',
                'Unknown',
                'Green Rhino Energy; De Opper Trading',
              ],
              [
                'Zimbabwe',
                25,
                'Africa',
                'Unavailable',
                'Mizpah-Chidobe Ward',
                'Hwange District',
                'Chidobe-Mizpah solar farm',
                'Plum Solar',
                'Power Ventures',
              ],
              [
                'Zimbabwe',
                175,
                'Africa',
                'Beitbridge',
                'Kadoma',
                'Beitbridge District',
                'Chapfucheche solar farm',
                'Unknown',
                'Sinogy Power Zimbabwe',
              ],
              [
                'Zimbabwe',
                25,
                'Africa',
                'Bulawayo',
                'Bulawayo',
                'City of Bulawayo District',
                'Bulawayo City solar farm',
                'Unknown',
                'Bulawayo City Council',
              ],
              [
                'Zimbabwe',
                100,
                'Africa',
                'Norton',
                'Chegutu',
                'Unavailable',
                'Norton solar farm (Zimbabwe)',
                'Unknown',
                'Td Energy',
              ],
            ],
            hovertemplate:
              '<b>Project:</b> %{customdata[6]}<br>Operations are ran by %{customdata[7]}<br>Owned by %{customdata[8]}<br><br>Coordinates: %{lat},%{lon}<br>Capacity (MW): %{customdata[1]}<br>Country: %{customdata[0]}<br>City: %{customdata[3]}<br>Area (County|District): %{customdata[4]} | %{customdata[5]}<br>Region: %{customdata[2]}',
            lat: [
              36.7144, 34.3497, 34.0355, 34.314, 31.4648, 35.9542, 34.5686,
              33.768, 40.742, 41.4327, 40.742, 40.742, 40.742, 40.1542, 40.1542,
              40.8491, 28.0, 27.6718, 34.6922, 22.8489, 26.4888, 28.0, 36.2864,
              28.0, 28.0, 28.0, 28.0, 27.9077, 28.0, 32.9451, 33.7249, 33.7298,
              36.1629, 28.0, 21.3258, 31.2315, 35.5027, 28.0, 31.6864, 27.8743,
              34.532, 34.8597, 34.3447, 36.1611, 34.3433, 36.1893, 28.0, 28.0,
              28.0, 28.0, 33.2741, 28.0, 30.998, 36.2502, 35.9194, -9.6589,
              -14.9916, -12.4684, -14.9176, -11.779, -14.9176, -14.9916,
              -12.5786, -24.0915, -24.0393, -33.3282, -37.3758, -26.0323,
              -33.2972, -24.095, -24.0915, -24.0915, -32.9985, -30.3563,
              -30.3681, -29.3277, -28.162, -31.342, -31.3327, -31.3413,
              -34.9778, 40.2187, 40.3836, -32.4909, -33.1131, -35.0836,
              -27.4025, -31.346, -19.8516, -27.4025, -31.5632, -36.1593,
              -21.1894, -36.2098, -34.2983, -23.7686, -34.3621, -29.1021, -34.0,
              -33.9433, -24.2007, -24.3951, -19.0031, -19.4253, -35.4897,
              -22.1405, -34.4556, -24.7761, -30.744, -27.7096, -30.6211,
              -31.876, -22.1859, -32.4526, -37.9717, -31.5452, -30.4915,
              -22.8222, -21.1485, -23.3782, -36.1133, -33.0826, -27.0843,
              -35.9907, -20.729, -24.5187, -35.988, -32.7249, -30.7464,
              -25.8778, -27.6457, -29.0887, -30.2723, -31.831, -30.6381,
              -29.5722, -34.7467, -33.8738, -33.8738, -28.1831, -30.2248,
              -32.3745, -32.5207, -34.8026, -33.8771, -26.9578, -26.9362,
              -29.7628, -20.4949, -34.9282, -22.1647, -36.4997, -33.8738,
              -36.7373, -26.1119, -26.1103, -26.1103, -36.1429, -33.926,
              -19.2228, -27.7237, -23.7554, -34.3965, -32.9017, -26.6592,
              -29.7045, -36.356, -33.8738, -30.3402, -24.053, -33.7829,
              -24.7761, -32.2468, -19.3355, -34.8215, -26.9506, -26.9506,
              -26.9506, -32.5742, -25.4203, -35.2708, -31.1238, -35.5308,
              -36.4395, -25.6871, -24.9039, -24.9539, -23.0621, -20.9393,
              -30.5426, -35.0461, -17.0436, -30.0218, -26.2526, -33.1729,
              -36.3137, -31.876, -25.295, -24.9227, -17.0506, -28.7704,
              -26.6202, -33.8902, -26.661, -15.8979, -19.7969, -33.1825,
              -32.4078, -32.4229, -24.9376, -24.8326, -31.6021, -19.8398,
              -22.6671, -22.8137, -27.2076, -35.5308, -31.6098, -32.9563,
              -35.6967, -33.2971, -23.0315, -35.9863, -23.6004, -26.6329,
              -20.5411, -20.528, -34.7595, -35.8832, -22.8394, -24.9392,
              -34.4556, -28.0207, -28.0391, -36.1215, -36.9842, -23.5477,
              -23.5477, -24.1807, -34.6899, -26.6762, -36.7769, -32.4909,
              -12.8196, -25.6113, -23.8353, -23.8353, -33.0382, -33.8738,
              -27.149, -32.3475, -32.1264, -28.0089, -27.9972, -31.9889,
              -22.8114, -21.8846, -20.0739, -23.5272, -29.047, -35.0486,
              -23.6021, -23.6021, -19.165, -26.6864, -22.6969, -23.6893,
              -28.0397, -34.6448, -27.112, -20.4899, -34.8112, -35.9088,
              -33.3888, -38.1016, -24.8821, -34.8151, -27.5988, -20.875,
              -33.5281, -20.4877, -34.4744, -19.845, -19.7322, -19.845, -36.457,
              -14.5341, -20.376, -35.7337, -19.6087, -34.3228, -26.1422,
              -26.0988, -34.7755, -23.0875, -32.4515, -19.8278, -30.5518,
              -26.5384, -18.9052, -18.88, -34.4556, -35.0205, -35.716, -33.3854,
              -26.9745, -19.845, -33.3591, -32.2701, -33.3024, -35.6442,
              -26.9151, -30.489, -23.5088, -26.2548, -26.9365, -22.5147,
              -21.9724, -23.6511, -34.9628, -16.378, -26.6438, -22.5739,
              -20.5048, -35.7321, -34.2279, -30.9617, -19.8909, -22.6893,
              -34.3174, -23.1385, -23.8444, -28.4094, -35.2767, -28.9038,
              -32.2821, -33.1386, -27.7573, -36.4881, -36.464, -35.9289,
              -31.346, -34.8461, 48.7212, 39.3373, 39.9465, 26.0445, 24.0139,
              24.7589, 24.8831, 26.1407, 25.9399, 23.8252, 26.1307, 26.5156,
              26.3331, 26.123, 22.6501, 26.2387, 25.8559, 25.8553, 22.4504,
              24.399, 22.8806, 22.7911, 23.9422, 24.7069, 20.9917, 25.3195,
              22.5016, 21.4157, 23.7988, 24.9012, 23.9136, 23.6383, 23.2253,
              22.8926, 24.9188, 22.7901, 23.2279, 23.2279, 25.3288, 25.853,
              25.853, 25.1873, 24.2844, 23.7001, 24.9049, 22.5017, 22.8111,
              23.9669, 24.8378, 24.8378, 20.9805, 25.8093, 23.5983, 13.122,
              52.0807, 53.4251, 51.2001, 50.5904, 51.2711, 51.0962, 51.1805,
              7.1003, 7.1003, 27.4956, 27.1586, 27.5495, 27.6856, 27.5133,
              27.4928, -17.7717, -17.7717, -20.5766, 43.3438, 43.8261, 43.8261,
              44.5202, 44.7406, 44.7406, 43.8261, 43.3745, 44.5202, 43.2455,
              43.8261, 43.8261, 43.7169, 43.8261, -24.6004, -21.9785, -21.1732,
              -21.1732, -5.3259, -10.7736, -10.7759, -10.779, -10.7735,
              -10.7914, -10.7853, -10.7887, -10.7792, -10.784, -10.7659,
              -10.7621, -10.7678, -10.7588, -5.34, -10.7706, -5.3323, -10.787,
              -5.3348, -19.6854, -5.3457, -17.4086, -17.4087, -4.601, -18.6368,
              -18.6462, -7.6243, -7.5979, -7.6311, -7.6262, -7.6211, -7.6186,
              -7.6159, -7.6102, -7.6141, -7.6084, -6.1029, -6.0932, -10.6854,
              -10.6852, -10.6869, -10.6944, -10.6917, -7.6642, -7.67, -7.6758,
              -7.6738, -7.6811, -7.6752, -7.6879, -17.4068, -6.9098, -6.9169,
              -20.6089, -17.2174, -17.2174, -17.2174, -17.2174, -17.2134,
              -17.2201, -17.2201, -17.2239, -19.6869, -10.7624, -19.6812,
              -19.6801, -19.6685, -19.666, -5.339, -19.653, -19.6583, -19.6515,
              -19.6443, -12.8256, -12.8163, -12.8097, -12.8085, -20.1946,
              -20.193, -20.1985, -20.6278, -20.625, -20.6194, -20.6135,
              -19.6413, -10.7671, -8.0069, -8.1774, -4.1062, -4.1098, -4.0995,
              -4.1142, -4.1177, -4.1204, -4.1266, -4.1282, -4.0995, -4.1343,
              -4.1416, -7.3549, -7.3544, -7.3631, -7.3434, -7.3528, -7.4032,
              -7.4249, -4.1444, -5.6458, -14.124, -6.8319, -17.3352, -3.7924,
              -3.7951, -3.7979, -3.8006, -3.8033, -3.8061, -3.805, -6.8457,
              -3.7994, -8.0918, -8.1044, -13.3473, -13.3411, -13.3465, -13.3513,
              -13.3553, -13.3573, -8.0943, -10.7616, -5.6413, -5.6419, -5.4138,
              -16.31, -16.3024, -16.3089, -16.3024, -16.3101, -16.3057, -3.6374,
              -6.793, -3.6323, -3.6399, -7.6544, -8.2096, -8.2165, -8.1941,
              -8.1898, -8.18, -7.9272, -3.6362, -5.6371, -5.4204, -5.412,
              -5.633, -5.6262, -5.619, -5.6119, -5.625, -5.6196, -5.6318,
              -5.6182, -5.4185, -5.629, -7.3859, -7.389, -7.3842, -7.3906,
              -22.4667, -5.4361, -5.4271, -5.4168, -7.3818, -6.8015, -5.278,
              -16.4885, -12.3117, -12.325, -12.328, -12.3253, -12.3248,
              -12.3248, -12.3248, -15.9091, -15.9008, -15.8932, -15.8824,
              -15.913, -15.9038, -15.8958, -15.8917, -15.8873, -15.8658,
              -12.3188, -9.7558, -8.015, -3.9694, -15.3651, -15.3751, -15.3802,
              -15.388, -15.3909, -15.4002, -15.3965, -15.3981, -15.8826,
              -15.4027, -15.4132, -15.3977, -15.4255, -15.4292, -15.4297,
              -15.4377, -3.9553, -3.9621, -15.4082, -15.8734, -8.8204, -8.8196,
              -17.6358, -17.6268, -17.623, -17.5994, -17.5994, -7.9797, -7.9717,
              -7.9756, -17.629, -9.3531, -9.3523, -9.3721, -9.3772, -9.3853,
              -9.3806, -9.3889, -8.0028, -7.9908, -9.358, -15.3591, -12.3174,
              -8.343, -8.8126, -8.8069, -8.8016, -8.7966, -8.7912, -8.7859,
              -8.7804, -8.775, -12.3148, -8.7698, -8.7588, -8.7499, -8.7425,
              -7.0005, -6.9939, -6.9751, -6.9824, -6.9795, -8.7648, -3.691,
              -8.2889, -9.3812, -17.2403, -17.2439, -17.2456, -17.245, -17.2446,
              -17.2389, -7.8784, -7.89, -17.2323, -7.8956, -13.3227, -3.3192,
              -3.3147, -3.3192, -3.3147, -5.1216, -5.1218, -5.2568, -13.3227,
              -17.336, -10.0979, -10.119, -8.0804, -8.0855, -8.0834, -10.0916,
              -10.0965, -10.0991, -10.1205, -10.1077, -10.1058, -10.1146,
              -10.1234, -10.1129, -10.1235, -10.1203, -10.1109, -10.1117,
              -10.1161, -10.107, -10.1284, -15.3652, -5.2788, -8.025, -15.7833,
              -15.7889, -15.7953, -15.803, -15.81, -15.8013, -15.8143, -15.8067,
              -5.3494, -6.939, -6.952, -6.9576, -6.9718, -6.9779, -6.9774,
              -6.9692, -6.9607, -6.9523, -6.9458, -5.2834, -5.3474, -15.6542,
              -8.0238, -12.144, -8.5504, -15.7088, -15.701, -15.7093, -15.7037,
              -15.6949, -15.6513, -15.691, -15.6922, -15.6871, -15.6799,
              -15.6777, -15.6783, -15.7104, -15.6728, -15.6592, -15.691,
              -17.3482, -16.4772, -17.3611, -15.9012, -15.9, -15.9027, -15.9072,
              -15.9127, -15.9148, -15.9154, -15.9209, -15.9268, -22.4667,
              -18.8808, -18.8842, -18.8922, -18.8908, -18.8947, -20.7904,
              -20.7729, -20.7659, -20.7776, -15.8983, -15.8871, -15.8847,
              -15.8848, -17.1942, -17.2011, -13.3191, -13.3208, -13.3227,
              -13.3272, -6.3515, -6.3553, -6.3622, -7.9648, -6.3679, -6.3771,
              -7.8839, -7.8853, -7.979, -7.988, -7.9971, -8.0058, -7.8934,
              -7.898, -6.3729, -7.9539, -6.9567, -6.963, -8.8522, -8.8563,
              -8.8592, -8.8615, -8.8638, -8.8661, -8.8673, -8.8696, -8.8719,
              -8.8471, -21.4662, -21.4509, -9.217, -8.2785, -8.2801, -8.2686,
              -8.2664, -8.2733, -8.2803, -9.5831, -21.4599, -17.1956, -8.7607,
              -8.7556, -6.9472, -6.9571, -6.9523, -6.9592, -6.9498, -6.9498,
              -18.4197, -18.4166, -10.83, -8.7565, -16.6709, -16.0539, -16.0372,
              -8.7388, -8.7417, -8.7433, -8.745, -8.7488, -8.7388, -8.7388,
              -16.6689, -17.1971, -17.1985, -17.2009, -10.5807, -10.5859,
              -10.5909, -5.0413, -5.0521, -5.0445, -5.044, -7.3668, -7.3605,
              -10.5824, -7.3546, -7.345, -19.7573, -19.774, -15.9172, -15.7357,
              -15.7388, -15.7448, -15.742, -15.754, -7.3668, -15.7467, -10.5825,
              -10.5776, -17.3615, -6.2854, -19.8755, -19.8663, -5.2429, -5.2401,
              -5.2383, -5.2401, -5.2522, -10.5772, -5.2507, -5.2447, -5.2572,
              -10.5567, -10.5594, -10.5648, -10.5645, -10.5725, -10.5692,
              -10.572, -5.2516, -9.5833, -15.7504, -15.7379, -17.2174, -7.923,
              -7.9064, -7.8559, -7.8594, -7.8636, -7.8443, -7.856, -7.8517,
              -12.1832, -7.8516, -7.8757, -17.461, -17.4618, -17.4619, -14.8556,
              -19.873, -19.8847, -19.8811, -17.2034, -7.8638, -15.7441, -12.192,
              -12.1758, -15.7335, -15.7312, -15.7272, -15.7288, -15.7317,
              -15.7332, -15.7221, -15.7113, -15.7583, -12.1798, -15.7534,
              -5.546, -10.9902, -5.3046, -12.1421, -12.1478, -12.1489, -12.1574,
              -12.1634, -12.1697, -15.7425, -9.5877, -7.9474, -9.5946, -11.2241,
              -12.5873, -12.5926, -12.5934, -12.599, -12.6015, -12.6035,
              -9.5905, -15.3497, -11.222, -15.3419, -15.3232, -15.3107,
              -15.3169, -15.3181, -15.3322, -15.3217, -15.3321, -15.3072,
              -15.2983, -15.3514, -15.3032, -15.9212, -15.9141, -18.8166,
              -5.1924, -5.1859, -17.5356, -17.524, -17.5205, -17.5202, -17.5173,
              -17.5024, -15.9287, -17.4974, -17.4941, -17.4842, -12.609,
              -12.6141, -12.6394, -15.9438, -15.9528, -15.9341, -15.949,
              -17.4904, -18.8244, -15.3112, -15.3083, -15.9133, -9.5319,
              -9.5319, -9.5319, -9.5319, -9.5264, -9.5216, -9.536, -14.1713,
              -15.9176, -6.9338, -13.3187, -13.3201, -13.3002, -13.2978,
              -17.3766, -17.3763, -17.3758, -17.3778, -17.3606, -6.9422,
              -15.3142, -15.9229, -15.941, -15.3239, -15.3407, -15.33, -15.3418,
              -15.3285, -15.9211, -15.9248, -15.934, -15.9431, -15.919,
              -15.9488, -15.9705, -15.9728, -15.9612, -15.9607, -15.9642,
              -15.9368, -15.939, -15.9468, -15.9493, -15.9548, -21.8981,
              -12.6042, -21.891, -9.6922, -9.6911, -9.6866, -9.6812, -9.687,
              -9.6802, -9.6744, -21.8934, -9.6628, -9.695, -9.6592, -16.3023,
              -16.3096, -4.9756, -4.9617, -4.9643, -8.416, -9.5913, -9.5911,
              -9.5912, -16.2976, -9.6985, -9.6688, -9.6671, -9.6828, -9.6866,
              -9.6903, -9.6937, -9.6959, -7.2767, -7.2749, -7.2704, -9.6795,
              -7.2695, -8.2636, -8.2734, -8.2665, -17.6754, -17.6806, -17.6873,
              -21.8857, -9.7021, -8.2938, -9.6759, -21.8884, -9.6728, 4.9378,
              42.6074, 42.6074, 43.125, 42.588, 42.6074, 42.6074, 42.6074,
              42.6074, 42.1061, 42.672, 43.0214, 43.5196, 42.672, 42.6074,
              42.6074, 12.2521, 11.0941, 12.4752, 11.6581, 12.4245, 11.4646,
              11.4646, 12.0644, 12.4245, 11.0691, 11.7916, 11.8245, 11.8245,
              11.6506, 11.0488, 12.5287, 12.5287, 11.7916, 11.0691, 13.5066,
              13.6304, 13.2601, 4.6863, 8.7713, 9.3313, 42.2761, 49.5227,
              49.5227, 50.2887, 50.2774, 50.0992, 51.7308, 50.0992, 52.4071,
              51.5014, 51.9928, 42.8692, 42.8, 50.0253, 42.9378, 44.0909,
              46.5178, 46.5178, 42.7108, 44.1019, 49.2875, 45.4962, 51.0289,
              44.2948, 52.5781, 44.3423, 52.047, 42.8921, 42.9378, 53.3104,
              42.1658, 45.41, 49.8476, 49.8159, 49.9914, 50.1006, 50.0309,
              50.7514, 50.9507, 50.945, 51.0261, 44.8483, 50.6988, 51.5348,
              42.8922, 50.0865, 5.0727, 12.1192, 10.97, 12.1192, 12.3969,
              12.1787, 15.6134, 12.0813, 12.3969, 12.1787, 12.1192, -26.3853,
              -22.3445, -22.3445, -22.3445, -20.3328, -26.3853, -33.4665,
              -22.4559, -33.4361, -34.5878, -22.3217, -25.3953, -26.8802,
              -33.1078, -26.3106, -20.2581, -27.1561, -32.7204, -33.1039,
              -36.9447, -22.53, -34.4631, -27.1259, -31.7613, -23.0036,
              -23.0036, -22.4559, -25.536, -25.511, -20.2512, -32.9951,
              -33.1078, -32.9563, -29.4715, -20.268, -33.4665, -20.4909,
              -53.1502, -28.5746, -28.5746, -27.1561, -22.494, -23.559,
              -31.7613, -25.3953, -20.2448, -26.3131, -22.576, -26.27, -22.2225,
              -22.3391, -27.1561, -27.1561, -25.5121, -20.617, -23.1014,
              -23.1014, -26.3715, -22.7707, -22.7707, -27.0045, -33.4665,
              -28.5746, -28.5746, -23.4939, -53.1502, -20.4909, -34.267,
              -24.0091, -23.6918, -24.0091, -27.119, -20.4909, -24.5563,
              -33.4665, -33.4665, -26.27, -27.1561, -26.3711, -22.4559,
              -26.3709, -27.025, -26.3709, -27.8527, -53.1502, -33.0843,
              -27.1238, -22.4559, -25.1072, -25.1072, -20.2739, -22.3445,
              -20.4559, -20.4559, -20.903, -25.3953, -20.1386, -33.4361,
              -26.3865, -32.4598, -32.4787, -18.4859, -33.4665, -22.3429,
              -29.1126, -22.3429, -31.7613, -31.7613, -22.3445, -22.3445,
              -22.3445, 35.2272, 35.5062, 37.163, 37.3295, 37.3295, 35.4379,
              37.4611, 34.8363, 36.73, 36.73, 35.4214, 34.8362, 34.8415,
              34.8449, 35.8558, 35.7776, 37.4229, 34.6102, 35.4219, 35.2779,
              35.4032, 37.3634, 35.7986, 35.5106, 35.7405, 35.0023, 35.8633,
              37.7331, 35.3467, 37.5602, 36.3066, 36.3231, 37.0681, 34.913,
              37.561, 36.445, 35.8093, 35.1306, 36.1553, 36.126, 36.226,
              36.5076, 35.89, 35.472, 35.472, 35.1524, 35.1008, 35.1008,
              36.4238, 35.9738, 37.1326, 37.1303, 37.2685, 37.9317, 35.6876,
              35.7642, 35.7022, 35.2064, 34.8347, 36.0636, 36.8132, 37.8172,
              35.6788, 35.8416, 35.8416, 36.4593, 36.4593, 37.1822, 35.9422,
              35.9343, 35.9379, 36.126, 35.9816, 35.9707, 35.943, 35.945,
              35.9445, 36.0788, 36.2347, 34.8453, 37.0549, 35.9728, 35.2908,
              38.7761, 34.9225, 35.399, 34.9114, 34.9114, 35.1148, 35.1901,
              35.2032, 35.1378, 35.1502, 35.3017, 35.2409, 38.7749, 38.7749,
              35.1027, 38.0598, 38.0598, 38.0586, 38.0585, 35.399, 38.6721,
              39.1278, 38.6721, 38.6721, 38.6721, 38.7829, 38.8425, 38.8421,
              38.6721, 38.6721, 38.8421, 37.5931, 38.6721, 38.7216, 38.6721,
              38.6721, 38.6721, 38.8421, 38.5522, 39.1904, 39.1904, 38.7216,
              37.3914, 37.6166, 38.6356, 35.2695, 35.9136, 37.2616, 36.0295,
              38.0931, 37.4914, 36.0743, 36.0775, 36.9116, 36.8039, 36.6091,
              36.5758, 36.4321, 37.0185, 35.0409, 35.9292, 35.7788, 35.1344,
              35.9305, 34.9424, 38.0638, 38.5099, 38.6357, 38.5037, 38.6799,
              38.2776, 38.7749, 38.5037, 38.5913, 37.5374, 38.229, 36.2415,
              36.2912, 36.191, 36.4795, 37.8151, 34.6117, 34.612, 38.0101,
              38.7761, 37.0678, 34.7705, 37.3254, 40.0704, 37.2945, 35.6814,
              39.8898, 36.9824, 37.7308, 37.6322, 37.7067, 37.8241, 37.7535,
              39.3645, 40.01, 40.01, 38.0544, 40.4499, 40.4611, 40.1763,
              40.0899, 40.1763, 40.1071, 40.0088, 39.5162, 37.7707, 37.943,
              37.7944, 37.7367, 37.7367, 39.7619, 36.0599, 36.5782, 36.317,
              36.2053, 39.9793, 40.0755, 40.0757, 39.7858, 39.6845, 39.9661,
              40.1069, 38.5325, 38.5608, 40.4169, 40.0061, 39.9793, 35.6702,
              36.98, 34.6747, 34.741, 34.7611, 34.7661, 34.761, 34.669, 34.7509,
              34.7507, 39.5772, 39.4407, 39.2257, 38.8421, 37.1889, 39.8731,
              39.9572, 40.0068, 39.8893, 39.9963, 37.9591, 38.0454, 37.824,
              37.8867, 37.7881, 37.9, 37.9297, 39.4578, 38.0426, 35.6711,
              38.093, 38.093, 38.0965, 38.1214, 38.1627, 39.9936, 39.9829,
              38.1548, 39.9306, 36.3796, 36.3796, 36.0874, 36.1661, 36.9281,
              35.6002, 35.7272, 35.2023, 34.7247, 35.0036, 35.9556, 37.8222,
              37.1718, 36.5894, 37.2253, 36.6481, 35.2184, 35.4016, 35.0951,
              36.6373, 37.1465, 35.9687, 35.9574, 37.3254, 34.8315, 34.9382,
              34.8952, 35.1371, 35.0031, 34.8495, 34.8072, 37.2435, 34.8072,
              37.8609, 37.8609, 37.9736, 38.0258, 35.7439, 35.9395, 35.9825,
              35.8639, 37.3218, 37.0658, 31.5262, 36.3942, 36.467, 37.2927,
              35.7635, 36.2692, 35.5106, 39.2572, 37.3289, 35.5293, 37.5885,
              36.9906, 37.4752, 38.1664, 36.575, 36.2666, 39.1907, 39.4493,
              37.9452, 39.1897, 37.7164, 40.0991, 40.2569, 39.9812, 40.1087,
              40.1087, 40.1087, 40.1087, 40.1087, 40.1087, 40.1087, 39.0928,
              40.0133, 40.0133, 40.0133, 40.0133, 40.0133, 40.0133, 39.9711,
              40.4197, 40.0468, 39.9002, 38.6721, 39.0242, 34.3126, 36.0957,
              36.4326, 36.4727, 36.389, 36.4897, 36.2029, 36.2031, 36.2121,
              36.4138, 36.2848, 36.2761, 36.2761, 36.2761, 36.04, 36.04, 36.04,
              36.0762, 35.9757, 36.05, 36.283, 36.2096, 36.3927, 36.3798,
              36.2096, 36.2774, 36.2076, 36.7228, 36.2096, 36.2096, 36.2096,
              36.1875, 36.2096, 36.7228, 36.2096, 36.2096, 36.7228, 36.7228,
              36.2096, 36.7228, 36.05, 36.05, 36.1765, 37.3656, 37.3656,
              37.3656, 37.3656, 37.3544, 37.3757, 37.3757, 37.3764, 37.3695,
              37.3695, 37.3757, 37.3629, 37.3764, 37.3764, 36.3789, 36.3789,
              36.3789, 37.3656, 37.2987, 37.2987, 37.2809, 36.19, 36.0361,
              36.0361, 36.283, 36.2096, 36.2096, 37.3542, 36.2761, 36.3829,
              36.2761, 36.0957, 36.0954, 35.9757, 37.3191, 36.6108, 36.6108,
              35.8214, 37.2809, 37.3645, 36.3829, 36.3798, 36.3798, 37.5614,
              37.5686, 37.5867, 37.5331, 37.5633, 37.5739, 37.5708, 37.5298,
              37.5298, 37.5475, 37.564, 37.5317, 37.3389, 37.6389, 37.5355,
              37.5584, 37.5562, 37.5783, 37.5783, 37.3852, 37.5492, 37.1889,
              36.0883, 36.0037, 37.0941, 37.5637, 37.6479, 37.5433, 37.5123,
              37.5443, 37.5327, 37.4581, 37.5317, 37.6369, 37.5504, 37.6369,
              37.5541, 37.5541, 37.5492, 37.5628, 36.3789, 37.5562, 37.6134,
              37.3645, 37.3645, 37.3257, 36.361, 36.3798, 36.3798, 36.3798,
              36.3798, 36.3798, 36.3829, 36.3829, 36.3927, 36.3798, 36.3927,
              36.3829, 36.4037, 36.3927, 37.3748, 37.3645, 37.3645, 37.3645,
              36.1875, 36.1951, 37.3645, 35.7667, 37.3645, 37.3645, 37.3645,
              37.3645, 37.6325, 37.3645, 37.3645, 37.3691, 37.3645, 37.3645,
              37.3645, 37.3645, 37.3691, 37.3748, 37.3578, 36.3789, 36.3855,
              36.3855, 37.5374, 37.5374, 37.5138, 34.5233, 34.7738, 37.958,
              35.2358, 35.2358, 35.5845, 35.5842, 35.5843, 37.5307, 37.5307,
              37.6251, 37.5307, 37.6274, 34.6796, 37.5374, 37.5171, 37.5138,
              37.5374, 36.9193, 36.9193, 36.9257, 36.9072, 36.283, 35.1774,
              35.1774, 35.1785, 34.9136, 35.2223, 34.7925, 34.7925, 37.5806,
              37.5806, 37.5374, 37.5138, 37.7683, 37.5374, 34.8009, 36.9801,
              34.0836, 34.8951, 35.1172, 35.3419, 35.1438, 35.2407, 35.0851,
              35.1607, 34.2556, 34.6868, 38.3099, 38.4696, 38.45, 38.8032,
              38.5143, 38.2466, 38.648, 34.7512, 34.3228, 35.2079, 34.9467,
              35.1596, 35.3862, 37.5462, 37.6544, 37.547, 37.6299, 37.727,
              37.6544, 37.6473, 37.5471, 35.1647, 37.7239, 37.6268, 37.6421,
              37.6279, 37.6279, 37.6184, 38.7299, 38.6564, 38.6721, 37.7442,
              38.6721, 36.9801, 34.7403, 36.3366, 36.3366, 36.3538, 36.3538,
              36.3538, 36.3538, 36.3717, 36.3717, 36.3907, 36.3907, 36.3298,
              36.3293, 36.3293, 36.3293, 36.3894, 36.3364, 36.399, 36.3366,
              36.3366, 36.3765, 36.3765, 36.3855, 36.3798, 36.3641, 36.3641,
              36.3641, 36.3855, 36.3851, 36.3851, 36.399, 36.3765, 36.3293,
              36.3293, 36.3293, 36.3548, 36.3548, 36.3548, 36.3548, 36.3765,
              36.3293, 36.9801, 36.399, 36.3764, 37.3271, 37.3271, 36.2782,
              36.2782, 36.2017, 36.2017, 36.2017, 36.2017, 36.2017, 36.2017,
              36.2017, 36.2017, 36.2017, 36.2017, 36.2017, 36.2017, 36.2017,
              37.3271, 36.1875, 36.1875, 36.1875, 36.3764, 36.1875, 36.2017,
              36.1875, 36.1875, 36.1875, 36.1875, 36.1875, 36.3293, 36.2017,
              36.1875, 36.1875, 36.1875, 36.1764, 36.1875, 36.186, 36.1875,
              36.1875, 36.1957, 37.7071, 42.9425, 37.7342, 39.8695, 44.7063,
              39.0654, 39.8665, 39.8665, 39.8638, 39.8638, 39.8638, 43.1393,
              42.9425, 42.9425, 43.1365, 43.1283, 43.1301, 43.1299, 43.1299,
              43.1299, 39.755, 43.1276, 39.8629, 42.7806, 38.1443, 43.1504,
              44.0302, 44.7063, 42.8679, 45.1807, 45.1807, 45.1807, 44.2738,
              44.305, 39.3572, 39.3572, 39.3572, 44.7063, 43.7779, 41.8265,
              41.7681, 39.7748, 43.1196, 43.1196, 42.9561, 44.7183, 45.1159,
              45.2409, 45.2409, 45.2409, 44.7431, 44.4585, 44.4585, 44.4585,
              44.4585, 43.5875, 43.5875, 44.1641, 44.3478, 44.1641, 44.4937,
              39.6949, 44.4035, 44.4035, 44.4035, 43.7779, 42.9561, 42.2914,
              42.2914, 42.9858, 42.9654, 42.9727, 42.2914, 42.967, 37.7023,
              42.2914, 42.2914, 42.2914, 42.2914, 42.9763, 42.9425, 42.2447,
              42.2447, 36.0565, 42.9425, 37.678, 43.8332, 43.8332, 44.6009,
              42.4805, 42.3905, 43.835, 40.5076, 40.5076, 40.5076, 37.2688,
              44.767, 44.767, 45.9128, 37.8346, 39.8696, 39.8696, 38.9953,
              38.9951, 39.05, 47.4447, 44.0944, 39.6004, 44.1578, 37.0231,
              37.0231, 37.0231, 37.0231, 37.7023, 46.7954, 46.5187, 46.7933,
              39.3572, 46.5199, 44.7063, 34.8907, 34.8907, 34.8907, 42.2666,
              42.2666, 44.0552, 44.0552, 43.9576, 41.2126, 38.4159, 39.3545,
              44.4436, 44.7641, 37.0664, 37.0664, 37.0664, 37.0664, 38.8977,
              38.9006, 44.2898, 37.0642, 42.4805, 43.8318, 43.8332, 43.8332,
              43.8332, 43.8332, 43.8332, 41.7239, 39.393, 39.7165, 42.4805,
              39.401, 39.4022, 37.9945, 37.8465, 37.6757, 38.968, 38.968,
              38.7304, 39.3536, 39.0654, 37.7603, 46.0902, 40.5087, 40.5783,
              39.1352, 39.6641, 39.6641, 39.7605, 39.2124, 34.9772, 41.2155,
              43.0335, 29.0, 29.0, 29.0, 30.928, 30.3454, 30.7108, 30.7734,
              28.5261, 29.1571, 30.28, 30.28, 28.2642, 29.0697, 29.0447,
              27.9279, 30.3329, 28.1292, 29.0, 28.1541, 29.0, 29.0, 29.0, 29.0,
              30.628, 30.8605, 29.0, 28.681, 28.9105, 29.0, 29.0, 29.0, 29.3167,
              29.0, 29.0, 29.0, 29.0, 29.0, 29.0, 29.0, 28.1541, 29.0, 29.0,
              29.0, 40.5275, 38.7513, 39.0081, 38.9834, 38.9309, 39.0442,
              39.0442, 38.7135, 39.4991, 39.3462, 39.3462, 38.6181, 38.6181,
              38.8502, 38.8502, 38.8999, 30.021, 29.0, 29.0, 29.0, 29.0,
              28.8823, 29.0, 29.0, 28.8699, 29.0, 29.0, 29.0, 29.0, 29.0116,
              30.5754, 27.7905, 29.0, 29.0, 29.0, 29.0, 29.0, 29.0, 29.0, 29.0,
              30.8921, 29.0, 41.3442, 41.3442, 37.0882, 43.9672, 25.6898,
              25.8295, 25.7886, 25.7861, 25.8295, 25.8052, 26.1145, 23.6109,
              23.6714, 21.8092, 23.4991, 25.7661, 25.7661, 41.2902, 40.6544,
              39.1559, 39.238, 41.3497, 43.862, 42.0582, 37.4191, 43.5223,
              43.8407, 44.2776, 43.862, 26.1835, 43.2479, 38.968, 43.6273,
              42.359, 42.8234, 42.8234, 42.8234, 42.8234, 39.2358, 44.1578,
              44.4734, 26.1778, 25.4545, 25.7556, 25.7075, 23.4203, 29.0, 29.0,
              28.9932, 29.0, 29.0, 29.0, 29.0, 29.0, 30.0904, 30.0904, 30.9193,
              29.0, 29.3237, 28.5625, 23.6967, 26.0949, 26.0598, 25.9339,
              25.4545, 25.4545, 26.6546, 26.6976, 23.7284, 24.8427, 24.9804,
              24.8388, 26.0608, 24.8388, 25.937, 27.511, 24.7239, 24.6327,
              24.8262, 24.7672, 25.0, 25.0, 26.0939, 37.6812, 34.9772, 36.9643,
              31.3961, 30.056, 30.056, 28.4414, 29.7486, 29.8882, 30.0973,
              29.0414, 29.7758, 28.2734, 28.9703, 29.6978, 29.6978, 29.1118,
              28.7833, 28.4891, 29.8929, 27.5733, 29.2284, 27.5733, 27.4804,
              26.5875, 26.5382, 26.5075, 26.5956, 26.5311, 31.0257, 31.6259,
              31.3219, 26.1842, 26.1842, 26.599, 27.5728, 27.5728, 27.637,
              27.637, 27.637, 26.5769, 27.554, 29.0658, 29.454, 29.2257,
              40.5858, 40.5795, 44.7063, 40.5834, 40.5834, 44.7063, 44.7063,
              40.5866, 41.0461, 41.0461, 41.1386, 41.1386, 41.0521, 41.0521,
              41.1853, 41.1853, 41.5909, 40.5805, 40.5805, 41.1667, 41.7279,
              29.267, 29.267, 29.2746, 29.4353, 41.0461, 47.1106, 37.0231,
              37.0231, 28.1768, 37.161, 37.5387, 37.5387, 40.4933, 40.4933,
              40.4933, 40.4942, 40.4942, 40.4942, 37.161, 28.1768, 27.5463,
              27.5952, 40.1379, 38.1772, 38.0589, 38.0633, 37.9563, 39.4921,
              39.4921, 40.0022, 40.0523, 40.0523, 40.1338, 40.069, 37.0611,
              36.9285, 36.9285, 37.0506, 38.1565, 35.4883, 37.6423, 37.64,
              36.6279, 37.7316, 39.3243, 39.3904, 38.0149, 40.4616, 40.5295,
              40.5301, 40.5301, 38.0603, 40.3779, 35.3055, 39.1468, 36.5627,
              38.5407, 40.3504, 38.9159, 38.8175, 38.838, 40.2165, 41.2495,
              38.0148, 34.7634, 32.7948, 26.5765, 26.8585, 26.5241, 27.4014,
              27.3984, 27.4043, 26.5616, 26.5616, 26.2261, 27.4364, 27.4521,
              27.4521, 27.428, 28.1908, 28.1908, 27.6692, 30.9388, 29.1327,
              32.9799, 32.2688, 34.7404, 34.757, 34.7512, 34.7137, 34.7424,
              34.7398, 34.7062, 34.7522, 37.1068, 34.7403, 34.7428, 32.901,
              31.9016, 33.7614, 33.7614, 33.7614, 31.0277, 31.8065, 34.7586,
              37.2771, 41.2495, 41.2495, 42.864, 42.5649, 42.5689, 42.8604,
              42.5272, 42.5272, 42.5272, 42.8204, 42.8204, 42.8589, 43.0126,
              43.0193, 43.0192, 44.7063, 44.7063, 44.7063, 44.7063, 42.8535,
              44.7063, 44.7063, 43.0336, 43.1276, 43.1418, 43.149, 43.1359,
              42.6629, 44.7063, 44.7063, 44.7063, 44.7063, 43.0273, 43.0273,
              44.7063, 43.0222, 43.0222, 44.7063, 43.021, 43.0335, 43.0338,
              43.0549, 43.0549, 43.0549, 37.4558, 42.359, 44.7063, 42.7735,
              43.0237, 43.0237, 43.0237, 43.0231, 46.5187, 46.3439, 43.0421,
              43.0421, 42.2204, 37.1333, 36.9138, 43.7875, 43.7875, 43.0475,
              44.7063, 44.7063, 43.0293, 43.6273, 43.0061, 43.0061, 43.0335,
              42.8204, 44.7063, 43.0335, 43.0231, 46.9939, 43.0348, 43.0348,
              43.0348, 42.8234, 43.0366, 44.7063, 42.3905, 42.3905, 42.3905,
              43.0348, 44.2678, 47.1115, 46.3061, 40.6544, 41.8345, 41.757,
              41.7617, 41.8345, 42.3735, 42.3746, 42.3696, 42.3696, 42.3698,
              42.3715, 42.3754, 41.9292, 41.9293, 41.9335, 41.8818, 44.7063,
              40.6544, 44.7063, 40.6424, 46.1684, 41.5875, 42.4805, 39.0056,
              39.1487, 42.4805, 41.1158, 41.7492, 41.1688, 38.9456, 41.1158,
              40.7019, 40.6914, 40.7035, 46.3297, 47.0243, 47.0122, 46.3326,
              46.1684, 40.7019, 41.2495, 38.9456, 42.1206, 44.9303, 42.4805,
              43.8504, 44.0179, 44.0452, 43.8363, 43.8363, 43.8363, 43.8363,
              43.8363, 43.7941, 43.7941, 43.7876, 43.7876, 43.8076, 46.3061,
              46.3061, 44.9311, 42.4805, 44.5206, 44.6102, 42.1137, 42.108,
              41.313, 45.2409, 44.7063, 41.7404, 41.9798, 44.9062, 42.1125,
              44.7892, 44.8062, 44.7926, 44.7874, 44.7905, 42.4805, 44.6102,
              44.6102, 44.6102, 44.7863, 38.2756, 43.149, 38.1713, 40.8856,
              40.9986, 38.3218, 38.2119, 38.435, 38.3797, 38.1045, 41.0553,
              41.0606, 41.0606, 36.5336, 41.7158, 41.561, 38.1478, 38.1131,
              38.2102, 38.2102, 41.2209, 38.0354, 41.3491, 37.3105, 37.346,
              41.7922, 40.6533, 39.3552, 39.3333, 39.5105, 39.3674, 39.4135,
              37.5559, 37.4969, 37.4969, 38.5903, 41.6895, 40.9837, 41.1068,
              40.8861, 39.7397, 37.2907, 38.161, 39.3836, 37.458, 37.2883,
              40.4233, 40.4233, 40.1969, 40.2111, 40.0429, 42.2349, 39.9649,
              41.2572, 41.0701, 41.3332, 38.6895, 39.926, 40.1477, 37.1685,
              40.2292, 40.919, 37.2883, 38.5977, 37.0102, 37.188, 36.8775,
              37.3663, 38.6889, 38.6889, 38.6889, 38.6889, 38.6889, 38.6889,
              37.2844, 41.4443, 41.4431, 40.9465, 37.9299, 38.3849, 40.025,
              37.1958, 37.1958, 37.188, 41.516, 38.111, 38.057, 38.3667,
              21.7341, 21.0635, 20.802, 21.3192, 21.1851, 25.0974, 23.2209,
              21.3289, 22.0638, 22.0638, 22.0638, 22.0638, 21.7053, 24.781,
              23.1662, 22.5826, 22.1672, 21.7341, 21.573, 21.845, 24.2281,
              40.084, 22.232, 20.6821, 20.6821, 23.3985, 23.1799, 21.0592,
              21.7468, 24.0, 24.9841, 24.5962, 24.5962, 21.9293, 21.8275,
              21.9249, 21.9249, 21.8257, 24.2002, 23.0706, 36.8205, 24.0,
              26.9477, 41.2195, 41.799, 38.8956, 38.7396, 41.561, 38.1096,
              38.1801, 38.1801, 38.0866, 38.0407, 36.6501, 40.3753, 40.6909,
              40.5651, 40.5649, 38.9036, 38.4646, 36.2486, 36.4587, 40.858,
              40.7852, 26.9374, 25.9171, 25.9165, 25.7388, 25.4092, 25.4092,
              25.4092, 27.0637, 25.7494, 26.7081, 26.9001, 19.9495, 18.8267,
              19.9017, 38.0775, 41.7967, 41.0247, 41.0247, 25.7097, 35.7037,
              38.8072, 38.6202, 34.7075, 34.8179, 35.9518, 34.4711, 33.6673,
              33.7979, 33.68, 36.0758, 33.3044, 33.3079, 33.174, 33.4861,
              35.8136, 35.9954, 33.8049, 35.9958, 36.1992, 34.4713, 36.2006,
              34.1001, 35.5579, 47.3386, 46.1251, 45.6114, 45.6114, 36.2787,
              36.1024, 36.1024, 36.1024, 36.0533, 34.0, 35.103, 32.8416,
              34.0789, 34.6992, 31.818, 35.9926, 35.6777, 35.3047, 35.9674,
              36.1041, 33.9816, 35.9472, 35.9702, 33.5262, 33.4716, 34.1901,
              34.8562, 33.4164, 33.4164, 34.3806, 34.4676, 34.4676, 33.9462,
              34.395, 34.5864, 34.1932, 34.112, 33.5974, 33.1599, 33.1248,
              34.7393, 34.5862, 35.7049, 34.1932, 33.6, 34.7805, 35.5886,
              35.5191, 35.722, 35.7511, 48.0, 35.7881, 34.1924, 34.1057,
              34.2737, 34.0232, 34.6571, 34.7333, 33.3061, 34.5775, 32.7711,
              46.2865, 48.0, 46.7094, 38.8864, 38.9586, 42.2765, 41.9194,
              36.9563, 36.8739, 38.8619, 36.7973, 37.0617, 37.0617, 37.4866,
              37.0563, 37.129, 38.6547, 40.4056, 39.229, 39.2103, 38.7091,
              38.8908, 38.681, 38.9868, 38.7147, 38.6767, 38.6995, 38.6936,
              38.7286, 36.6133, 37.1736, 36.9623, 39.197, 40.7469, 41.5141,
              41.0881, 41.3363, 41.3363, 36.7131, 36.7588, 36.6295, 36.6295,
              41.4214, 38.8582, 39.2317, 39.9234, 48.0, 48.0, 48.0, 46.7604,
              46.0995, 45.8916, 47.9778, 46.3983, 46.3983, 47.2275, 48.4812,
              46.1732, 46.1732, 46.2985, 48.0, 46.6317, 46.7094, 48.0, 46.4114,
              46.4114, 46.4114, 39.9189, 37.6811, 40.9938, 41.3991, 41.1544,
              41.1841, 41.3124, 40.9165, 39.3238, 41.4237, 41.5038, 40.1041,
              36.6556, 37.4553, 37.4553, 46.4114, 46.2366, 46.4114, 41.4814,
              34.717, 39.2853, 39.7651, 33.4565, 32.6325, 32.6325, 32.6325,
              31.4281, 31.1481, 31.0094, 32.0, 32.8215, 30.8592, 30.843, 32.0,
              32.0, 32.0, 32.0, 32.1447, 32.1447, 33.8911, 32.0, 33.6883,
              32.1477, 31.4438, 31.9462, 31.903, 31.903, 33.6204, 33.8949,
              33.5336, 33.5336, 32.8392, 32.7051, 32.8117, 31.7207, 31.7834,
              31.4907, 31.7541, 31.765, 31.029, 32.1414, 32.4813, 32.0, 32.0,
              32.0, 32.0, 32.0, 32.0, 32.0, 31.82, 32.0, 32.0, 33.6883, 33.6883,
              32.0, 40.4045, 29.5319, 29.1077, 31.1215, 30.3485, 24.1671,
              32.7003, 32.0, 32.5815, 33.0342, 30.1954, 32.0, 32.0, 33.192,
              32.0, 32.0, 32.7992, 32.0, 31.3191, 31.0215, 30.1999, 32.0, 32.0,
              34.0033, 32.0, 32.0, 32.9284, 32.9082, 32.0, 31.9016, 31.3129,
              31.3129, 31.9967, 31.9415, 31.7321, 31.5555, 32.0, 32.0, 32.7777,
              32.0, 32.0, 32.9619, 32.6431, 30.6062, 32.0, 31.4469, 32.2949,
              31.9421, 32.277, 31.9969, 31.0561, 31.0608, 32.6028, 38.2842,
              33.0387, 33.044, 33.0309, 32.2546, 32.1418, 32.0, 32.345, 32.3099,
              32.345, 32.1422, 32.3458, 32.3091, 31.7221, 32.0, 31.7058,
              34.4732, 32.0, 32.3107, 24.0354, 31.9421, 32.5818, 33.6482, 32.0,
              32.0, 33.7023, 33.0167, 31.6262, 31.2215, 31.2592, 32.0, 32.0,
              31.2592, 32.0, 32.0, 31.0751, 33.4307, 32.7526, 32.7446, 33.7561,
              31.1186, 31.1186, 32.0, 32.0, 32.5638, 32.6118, 32.6886, 32.0,
              32.0, 32.0, 32.0, 31.9421, 32.0, 31.7352, 32.0, 32.0, 31.9124,
              32.0, 32.0, 32.0, 32.0, 32.0, 39.2853, 27.2384, 24.1467, 35.2739,
              39.9837, 40.5187, 40.0938, 40.098, 40.1122, 40.1122, 40.1057,
              40.1105, 40.1024, 40.1071, 40.0997, 40.4931, 39.9786, 39.9702,
              39.6213, 39.6213, 38.4586, 38.1033, 38.6072, 38.5714, 38.7582,
              38.5814, 38.5814, 38.5035, 38.597, 38.4602, 38.5462, 38.5462,
              38.5462, 38.4602, 38.5786, 38.5721, 38.5814, 38.5814, 38.5814,
              38.5814, 38.5814, 38.6072, 38.1033, 38.1033, 38.1033, 35.8469,
              39.1201, 38.7576, 34.8445, 39.7281, 39.8548, 39.6066, 39.5746,
              39.7445, 35.0341, 36.7235, 36.7235, 40.2844, 40.2844, 40.2917,
              39.8152, 40.2932, 40.3035, 40.3035, 40.3035, 40.3035, 38.0953,
              34.0157, 39.4537, 38.9823, 38.9831, 38.9728, 38.9652, 38.0935,
              38.5886, 38.1057, 38.1091, 38.0913, 38.0969, 38.3119, 38.0923,
              38.3133, 38.3193, 38.3193, 38.0892, 38.5886, 38.5018, 39.7376,
              41.1031, 38.944, 38.944, 37.6692, 39.7627, 39.7729, 39.7729,
              39.7602, 38.5869, 38.5869, 38.3223, 38.3223, 39.9631, 39.9849,
              39.9573, 37.4142, 39.9749, 39.3781, 39.3768, 38.9302, 40.1434,
              27.4193, 39.6329, 37.3743, 37.3743, 35.8465, 40.0919, 40.0919,
              40.1434, 39.5969, 40.1414, 40.1414, 40.1414, 40.1216, 40.0756,
              38.9365, 40.1188, 40.1414, 40.1414, 40.116, 27.5988, 39.5969,
              38.1014, 37.7575, 37.7575, 34.9728, 38.981, 39.0123, 38.9553,
              38.9778, 38.9881, 38.9796, 38.9519, 39.7524, 39.7524, 39.7128,
              39.8029, 39.7679, 39.7559, 39.7559, 37.7575, 39.2937, 39.2868,
              39.2868, 38.1035, 33.7557, 33.7557, 39.1496, 39.1496, 34.0063,
              38.4304, 38.7536, 38.3866, 39.8991, 35.5914, 35.0081, 35.1076,
              34.8496, 38.6918, 38.7555, 38.6935, 39.2868, 36.9906, 35.9956,
              38.1035, 31.3876, 26.7677, 28.8725, 28.8728, 28.3284, 28.2022,
              29.7015, 29.7015, 30.0337, 29.7007, 28.8869, 28.9951, 28.8836,
              28.8958, 27.6919, 28.303, 28.7927, 28.7927, 25.3433, 38.1713,
              28.4671, 28.2847, 33.0, 33.0, 34.4, 27.7643, 27.7813, 28.1342,
              28.1829, 29.2752, 29.2752, 28.6772, 28.6773, 28.212, 28.0,
              28.4492, 28.1966, 28.1866, 28.2277, 28.2847, 27.6209, 28.9492,
              29.384, 25.9288, 26.2901, 26.3998, 26.7103, 26.8931, 28.7936,
              28.2652, 28.7966, 29.3118, 28.3757, 28.1726, 27.7728, 27.6772,
              27.7693, 27.7693, 28.441, 24.8582, 28.5859, 29.3202, 29.619,
              29.6939, 29.3477, 28.4616, 28.394, 28.9623, 28.9623, 29.6907,
              27.1796, 28.9505, 33.0, 29.3012, 29.3124, 28.6937, 28.7828,
              26.4745, 28.3053, 28.1815, 28.2034, 29.5895, 28.3306, 33.0,
              34.2011, 33.7765, 34.6699, 34.4863, 33.2255, 33.2255, 33.1477,
              33.1477, 33.282, 33.282, 33.282, 33.178, 33.0364, 33.0364,
              33.0379, 33.0815, 32.9558, 32.9558, 31.8218, 33.0, 33.0, 31.2607,
              32.9014, 32.8706, 32.7775, 32.7775, 33.0, 33.0, 33.7574, 32.7875,
              32.6975, 34.6397, 33.0, 34.6463, 33.0, 33.4926, 33.0, 33.4668,
              33.4402, 33.0701, 33.1133, 32.5423, 27.0013, 31.5191, 34.494,
              33.0, 33.0, 33.0, 33.0, 33.8964, 33.0, 33.9486, 32.5624, 33.0,
              33.0, 33.0, 33.0, 34.4432, 33.0, 33.1297, 32.8536, 33.4942, 33.0,
              33.9994, 33.8259, 33.0, 32.0454, 33.2402, 33.2402, 33.2402,
              33.2434, 33.2434, 33.2434, 33.2434, 34.494, 33.2153, 33.231,
              33.2385, 33.1447, 34.4073, 34.3607, 31.9611, 32.334, 33.8035,
              33.2806, 28.5125, 28.5143, 28.7503, 37.6369, 37.6369, 37.0706,
              37.5092, 37.5092, 37.5092, 37.5183, 38.9137, 39.2024, 39.2024,
              39.1073, 39.1775, 39.2024, 38.8842, 38.6941, 38.6941, 38.6941,
              37.6369, 37.6369, 38.2154, 37.6369, 37.8011, 37.672, 37.9724,
              38.1997, 38.4001, 37.8707, 37.7689, 37.9724, 38.6941, 37.8323,
              37.7954, 37.9841, 37.9521, 38.1648, 37.7955, 38.986, 38.6864,
              38.6934, 38.1997, 37.6284, 39.2024, 39.3122, 37.1056, 37.9061,
              38.4249, 38.3993, 38.476, 37.9868, 37.8263, 37.8263, 37.8263,
              38.0016, 37.9872, 37.9787, 37.9816, 38.5143, 38.506, 37.845,
              30.6757, 37.0578, 37.0578, 37.1577, 37.5669, 37.4492, 37.1552,
              37.0497, 36.9631, 37.1273, 36.9631, 37.0497, 37.4252, 39.1154,
              37.9063, 38.2154, 37.4501, 37.4501, 37.4488, 37.4938, 37.4991,
              37.4501, 37.5669, 37.6536, 32.8706, 38.4816, 37.4252, 44.914,
              44.9239, 43.3381, 43.3381, 44.8517, 43.812, 43.812, 43.812,
              43.812, 43.812, 45.1335, 45.329, 45.6166, 44.8134, 44.9774,
              44.7182, 45.0405, 44.914, 45.4517, 45.4331, 45.8803, 28.3201,
              28.3228, 28.1092, 28.947, 45.6156, 45.5888, 45.5888, 45.6156,
              45.0405, 44.3438, 45.6156, 42.7641, 42.5358, 44.4337, 45.3871,
              45.3871, 45.8803, 45.8803, 44.3438, 37.4264, 43.2621, 43.3504,
              41.9124, 39.877, 39.6763, 36.6461, 36.6447, 36.6661, 37.9971,
              36.6603, 36.6461, 36.3687, 38.6496, 38.6736, 37.3192, 37.3192,
              37.4577, 37.4255, 37.4252, 41.7008, 41.7008, 39.8224, 42.0577,
              45.8841, 45.8841, 45.8841, 45.9646, 41.6309, 41.6404, 39.9679,
              39.9679, 43.3104, 41.8693, 40.8225, 40.8225, 40.7558, 42.7768,
              40.9718, 39.8615, 41.5857, 41.3201, 40.8515, 33.0, 29.7024, 33.0,
              29.477, 28.8171, 29.1638, 28.7809, 28.7809, 29.7269, 26.682,
              26.936, 26.7559, 27.5132, 28.7828, 28.7828, 28.9282, 29.5799,
              26.7716, 26.7716, 26.7716, 29.5233, 26.2255, 27.7382, 29.801,
              28.8668, 28.4829, 29.347, 29.347, 29.347, 29.347, 29.6194,
              29.5516, 26.7716, 29.5516, 29.573, 29.573, 25.6723, 29.7827,
              29.7827, 29.7827, 29.7827, 29.7827, 29.573, 28.8668, 29.8036,
              28.8896, 41.4357, 40.2728, 43.4446, 44.2525, 40.6755, 40.6755,
              40.6775, 40.6386, 40.7119, 40.2939, 40.714, 40.5687, 40.532,
              40.7149, 40.5256, 40.2171, 40.9192, 41.4357, 41.6602, 41.7005,
              42.4345, 28.8896, 28.8896, 28.8896, 25.9174, 29.0998, 38.5547,
              37.9243, 37.9243, 28.8896, 37.9285, 38.8861, 38.8861, 41.9711,
              38.8574, 38.8832, 38.8942, 39.3371, 38.8942, 38.8072, 41.5742,
              28.8668, 25.7562, 31.4153, 30.0772, 31.2372, 31.1244, 31.112,
              31.112, 32.105, 31.686, 31.686, 31.718, 31.6911, 31.8466, 33.0,
              31.1364, 30.594, 30.5957, 32.242, 31.4153, 31.2722, 31.0404,
              31.0404, 31.5628, 31.4798, 31.619, 31.5168, 31.6144, 31.9288,
              31.9288, 30.6563, 32.3552, 30.0446, 31.0161, 32.4557, 32.4557,
              32.4363, 32.4363, 30.7047, 31.1708, 31.074, 29.8132, 28.8668,
              32.2954, 30.6109, 31.3927, 31.085, 31.085, 30.5488, 29.8336,
              29.8336, 29.8336, 31.721, 31.721, 31.5979, 33.1427, 33.0528,
              32.8353, 32.1308, 31.718, 30.4284, 28.2798, 31.1352, 30.2536,
              30.1491, 30.3309, 30.7118, 30.7118, 30.5539, 31.5511, 31.878,
              32.2309, 32.2309, 31.878, 32.2954, 32.0715, 30.6636, 29.6082,
              30.7297, 30.0128, 30.0221, 30.3309, 30.3309, 30.3309, 32.0715,
              41.1139, 31.6786, 40.8178, 41.4373, 41.6046, 40.8128, 40.9133,
              41.4443, 42.9364, 42.4777, 41.1154, 39.7617, 39.3429, 39.3418,
              39.766, 39.3417, 39.0694, 39.3419, 39.7695, 40.7986, 41.4461,
              41.3656, 41.8865, 46.0708, 41.7262, 42.7409, 42.7234, 43.7259,
              43.7259, 43.7259, 43.5967, 42.99, 43.6653, 42.8663, 42.8663,
              40.5679, 40.5687, 41.6238, 40.4101, 45.376, 40.3794, 40.8578,
              41.3656, 41.031, 40.4969, 48.2206, 46.5302, 46.7345, 46.4952,
              40.3746, 44.0179, 44.5566, 44.5562, 44.5562, 43.6026, 44.5562,
              44.5562, 40.8939, 40.8939, 44.0086, 33.2165, 40.8178, 43.9328,
              43.9312, 42.256, 42.2604, 41.5141, 41.5141, 41.7217, 41.7217,
              41.5417, 41.5417, 40.9153, 46.0729, 41.533, 39.286, 40.8578,
              41.8895, 41.5679, 41.5678, 41.5694, 41.099, 41.099, 42.4274,
              39.3022, 41.4807, 42.2646, 41.9097, 40.513, 40.3292, 40.4004,
              40.2102, 40.3821, 40.3821, 40.4465, 40.4465, 40.4465, 40.4465,
              40.4465, 40.4465, 40.4465, 40.4465, 40.4465, 40.3035, 40.2403,
              41.7005, 41.8808, 40.6549, 40.6549, 40.8178, 41.2754, 40.8178,
              41.4418, 40.7727, 41.7274, 41.2679, 42.6305, 40.508, 42.6493,
              42.9353, 42.9353, 42.3571, 42.3547, 43.6174, 43.275, 41.6541,
              40.6549, 42.8475, 40.2353, 33.0, 43.2662, 49.6264, 45.5641,
              45.5242, 45.2541, 45.4118, 43.4493, 43.9819, 43.9819, 43.5874,
              43.9375, 40.5588, 48.4718, 42.8682, 42.8415, 41.4906, 44.0944,
              43.6849, 40.7915, 42.729, 42.9465, 41.1535, 43.9772, 41.2713,
              43.5667, 40.9641, 41.2817, 39.1812, 39.8204, 40.807, 40.807,
              40.5352, 40.3208, 45.464, 40.2383, 41.1927, 40.3751, 41.1927,
              40.3751, 40.546, 8.231, 6.2273, 7.3939, 8.2617, 5.9756, 5.0675,
              5.0618, 8.2265, 4.0999, 8.2617, 6.4975, 8.2617, 9.2118, 3.9015,
              5.5508, 5.5508, 3.6242, 4.0999, 9.2118, 3.6242, 5.5508, 4.0999,
              8.2757, 11.4354, 6.4098, 3.6242, 10.8891, 4.5158, 8.7974, 8.2617,
              4.2865, 8.2617, 4.0999, 4.0999, 4.0999, 10.4653, 7.9801, 5.5508,
              4.0999, 4.0999, 5.3372, 3.9015, 8.7409, 5.0279, 8.2705, 6.2442,
              4.0999, 8.7974, 8.2617, 4.0999, 6.2273, 11.0614, 4.0999, 8.2617,
              4.0999, 10.8148, 10.8148, 4.0999, 6.2273, 3.8132, 5.1275, 8.2617,
              8.7974, 8.2617, 3.464, 10.518, 5.4445, 8.2617, 4.0999, 4.5158,
              4.5158, 4.5158, 4.5158, 4.5158, 3.6359, 4.0999, 3.4488, 4.5158,
              4.0999, 4.0999, 4.0999, 9.7815, 4.0999, 4.5747, 4.0999, 10.498,
              6.3142, 3.464, 4.0999, 3.9015, 11.4354, 11.4354, 6.4098, 5.5508,
              10.3968, 4.0999, 4.0999, 6.2273, 3.464, 3.464, 3.464, 3.464,
              2.5655, 4.0999, 8.2705, 8.2705, 3.464, 2.4826, 4.3937, 3.9015,
              8.2705, 4.0999, 6.2273, 4.0999, 5.0618, 2.5085, 7.348, 9.7063,
              4.0999, 5.4445, 4.0999, 8.2617, 8.2617, 4.0999, 8.231, 6.2076,
              10.6054, 6.4098, 4.4487, 3.6707, 9.1846, 3.4257, 6.4098, 4.0999,
              4.7504, 8.2617, 7.8267, 7.8267, 7.8267, 8.2705, 9.1064, 4.0999,
              3.8977, 9.8169, 9.8169, 7.9801, 6.2273, 9.855, 10.1492, 8.7409,
              11.4354, 2.0634, 3.8901, 6.4098, 7.8267, 5.4445, 4.0999, 8.2617,
              8.2617, 9.2118, 4.7504, 4.0999, 10.6409, 4.0999, 8.2136, 4.0999,
              3.3973, 9.1064, 10.6409, 6.3142, 4.0999, 10.6409, 9.1064, 10.8891,
              4.5809, 10.6409, 10.6409, 10.6409, 10.6409, 43.618, 44.0117,
              43.6157, 43.4969, 43.9184, 43.5816, 45.5643, 43.7232, 46.2243,
              45.5643, 43.9083, 44.219, 43.6253, 44.1715, 44.2291, 44.1676,
              46.1884, 43.7297, 44.1779, 44.0117, 44.0813, 43.5818, 44.2175,
              44.5558, 43.4726, 44.0117, 42.7878, 44.0893, 46.2825, 46.2876,
              43.6269, 44.2291, 43.6911, 45.5791, 45.2443, 43.5718, 23.0059,
              23.0131, 49.1472, 49.0968, 50.3088, 8.3713, 8.2841, 9.8962,
              7.0278, 9.5346, 9.594, 9.451, -4.3217, -4.3217, -10.6224, 0.5184,
              57.0749, 55.7001, 54.9226, 55.4287, 57.5925, 55.2434, 55.6702,
              55.6702, 55.6702, 55.6887, 54.7596, 56.377, 55.6493, 56.3678,
              56.5612, 54.8289, 56.5199, 57.27, 56.387, 55.1666, 11.8146,
              11.8146, 11.8146, 11.8146, 11.8146, 11.8146, 11.8146, 11.8146,
              11.8146, 11.8146, 11.8146, 18.3272, 18.3442, 18.3354, 18.5906,
              18.6145, 18.82, 18.4711, 18.8101, 19.7094, 19.7094, 19.0974,
              18.4711, 18.331, 0.4718, 0.2998, -2.3346, 0.8056,
              0.0149892711590354, -2.217, 0.0401, -3.9834, -0.0595, -2.2362,
              0.0319199732942382, -0.0595, -1.3398, -4.0529, -3.4783, 1.0165,
              -1.2352, 0.9509, -3.9834, -3.9834, 0.0, -0.9755, 24.4477, 24.4477,
              24.4477, 24.4477, 24.4477, 24.4477, 24.0677, 24.0677, 24.4477,
              24.4477, 24.4477, 24.4477, 24.4477, 24.4477, 24.4477, 28.6891,
              24.0677, 24.416, 24.416, 24.416, 24.4477, 24.4477, 24.4477,
              24.4477, 24.4477, 24.4477, 30.0124, 29.6326, 24.4667, 24.4693,
              24.4477, 24.4477, 24.4477, 24.4477, 29.1153, 31.2971, 31.2971,
              24.9333, 29.1784, 23.1046, 24.4477, 23.1046, 24.4477, 26.254,
              30.0124, 24.4477, 24.4477, 24.4477, 24.4477, 24.4477, 24.4477,
              27.229, 24.4477, 13.451, 13.3111, 13.3111, 13.584, 13.455,
              -26.5272, 11.5892, 11.7559, 10.2117, 13.779, 6.0308, 65.5528,
              63.2468, 50.3704, 48.0269, 49.4554, 49.4554, 47.634, 43.5105,
              42.595, 46.7568, 46.8235, 44.25, 47.5106, 43.9388, 44.4609,
              44.913, 48.783, 48.783, 48.783, 44.3344, 44.346, 44.6331, 43.5842,
              43.776, 48.5904, 48.9741, 44.0586, 44.4024, 48.6425, 44.7262,
              50.1248, 50.1248, 43.6073, 44.9025, 5.4996, 0.2293, 0.2293, 1.295,
              0.2293, -1.639, 41.9409, 51.507, 54.1116, 53.7904, 54.1246,
              51.8915, 52.5325, 52.479, 52.5646, 53.5399, 51.473, 49.706,
              54.6224, 52.4347, 51.0834, 52.4386, 51.7805, 52.382, 54.3443,
              53.8561, 51.7647, 51.0834, 51.0834, 53.1812, 52.6937, 53.2001,
              52.8886, 52.822, 52.4337, 52.825, 53.9109, 51.6315, 49.8594,
              54.2653, 52.3446, 50.5825, 51.3561, 48.653, 48.6387, 48.6563,
              48.636, 51.5446, 51.5446, 51.5446, 53.0703, 48.8046, 53.5253,
              51.9241, 53.9273, 52.319, 51.3284, 54.0846, 52.6475, 52.6469,
              52.6511, 51.3585, 53.6329, 51.6315, 51.4547, 52.615, 53.031,
              49.3386, 51.5701, 51.6591, 51.5656, 52.3884, 53.4121, 51.729,
              53.3821, 52.5916, 52.6394, 53.7977, 52.2044, 53.3415, 50.012,
              51.1777, 51.1968, 53.9311, 54.1615, 51.8666, 51.5504, 52.6653,
              53.3929, 48.6999, 51.455, 51.527, 53.3371, 51.7234, 51.5435,
              7.9579, 7.9038, 9.1969, 8.03, 9.7446, 5.3413, 10.6006, 8.03,
              9.5826, 10.7854, 9.0299, 5.7105, 5.3728, 10.8814, 8.2794, 8.03,
              8.2794, 8.2794, 8.2794, 9.2358, 10.7854, 5.0152, 8.2794, 39.1273,
              39.1273, 39.2008, 38.3888, 40.8299, 40.8299, 40.4391, 40.4552,
              41.0076, 40.355, 39.3199, 39.6997, 39.3053, 39.3846, 40.1176,
              39.1273, 39.699, 39.8045, 40.7287, 41.0483, 40.9789, 40.412,
              40.399, 39.255, 39.2947, 39.8384, 40.9411, 40.9904, 38.2522,
              38.2504, 39.1799, 39.1564, 39.2733, 39.5638, 39.8587, 40.6025,
              39.4121, 39.2449, 39.1273, 41.3141, 39.8212, 39.1546, 39.151,
              39.147, 38.8446, 40.2971, 39.7661, 38.6441, 41.3505, 37.403,
              39.6576, 39.3458, 39.2366, 39.2805, 39.5157, 39.909, 40.7395,
              39.691, 38.2781, 38.2728, 40.9073, 41.0219, 40.999, 39.6089,
              41.0568, 41.0365, 40.4596, 40.4596, 38.4342, 40.7615, 39.5119,
              39.225, 39.2375, 40.0914, 40.6237, 40.3048, 39.7709, 41.1161,
              39.3676, 40.9123, 39.0519, 40.209, 39.2793, 39.7277, 39.2224,
              39.2275, 40.4051, 39.162, 40.1244, 41.1205, 41.0901, 39.2,
              40.1119, 40.101, 39.8197, 41.2156, 40.8145, 39.762, 38.4694,
              39.7505, 39.1144, 38.4138, 39.0994, 38.5755, 36.8785, 39.2697,
              38.0247, 40.8922, 40.4325, 40.347, 40.3361, 40.8318, 39.1913,
              40.6241, 39.0418, 38.7612, 40.5009, 39.2802, 39.5472, 40.8131,
              39.9007, 41.0483, 39.0394, 40.1893, 40.6612, 39.3519, 39.2146,
              39.186, 38.2233, 40.235, 38.379, 41.0311, 38.9156, 38.4647,
              39.3842, 41.2866, 40.6444, 40.697, 40.7839, 38.3807, 40.9459,
              39.3349, 38.23, 40.3546, 38.2305, 39.307, 39.0923, 40.7117,
              39.4333, 40.1125, 39.3226, 39.1786, 40.4234, 40.0325, 39.2632,
              39.3641, 39.5128, 39.5076, 39.2821, 40.5628, 40.5844, 38.9281,
              39.2475, 41.0426, 40.0325, 39.4237, 39.304, 40.1825, 40.3969,
              38.2235, 39.6946, 41.1084, 38.844, 40.8827, 38.8398, 39.2805,
              40.4225, 40.5038, 38.6856, 39.4163, 37.7158, 38.4409, 39.2196,
              40.8872, 39.3998, 40.4674, 40.5038, 38.175, 40.0892, 39.3907,
              38.2425, 39.6476, 38.6864, 40.3246, 41.0484, 40.9969, 39.5341,
              40.3428, 40.3417, 40.1048, 39.1892, 41.0343, 40.8772, 39.6885,
              41.3327, 41.0208, 38.4656, 39.6383, 39.6383, 39.2724, 39.5274,
              39.2298, 40.403, 39.2359, 40.4325, 39.2297, 39.2537, 39.1173,
              39.1471, 38.4449, 39.8109, 41.0511, 40.4736, 37.3578, 41.6642,
              40.3689, 38.8665, 38.1855, 38.5851, 40.4501, 40.443, 39.3945,
              41.0997, 41.057, 38.3436, 40.6589, 38.3292, 39.4812, 39.4643,
              39.4701, 39.4883, 39.332, 38.3436, 39.2444, 38.1824, 39.2087,
              39.3474, 40.1692, 40.3513, 40.3226, 38.3201, 39.3647, 39.3715,
              39.7537, 38.6828, 39.1969, 38.7987, 38.8876, 39.3482, 40.8409,
              39.5003, 38.8946, 39.2126, 39.9107, 39.6036, 37.0401, 39.5562,
              40.3365, 41.3096, 39.2752, 39.3657, 38.2015, 38.2236, 39.0948,
              40.3423, 39.4236, 40.341, 39.4807, 39.8717, 38.9364, 39.5552,
              39.5495, 39.6421, 38.8711, 38.4279, 40.4196, 40.6835, 41.1288,
              40.109, 39.4836, 40.7957, 39.4751, 39.3334, 39.5274, 40.3193,
              38.2204, 38.5464, 40.3715, 40.4825, 40.4888, 38.5257, 38.521,
              39.1069, 40.7317, 38.5478, 38.5465, 41.1006, 39.4661, 39.4674,
              39.4727, 39.3123, 39.4741, 39.2037, 40.2946, 39.4587, 39.6133,
              41.1154, 40.3769, 40.344, 40.3358, 39.7272, 39.1557, 39.1304,
              38.491, 39.4589, 37.4286, 39.4129, 41.0247, 39.7332, 39.16,
              41.0092, 39.6442, 39.3641, 39.0822, 38.5446, 41.0204, 40.3057,
              39.4684, 40.4218, 41.4271, 40.9652, 40.9653, 40.9738, 40.9771,
              41.1428, 39.3935, 39.4545, 41.0666, 38.41, 40.0107, 38.3766,
              39.4529, 39.3496, 39.6489, 37.394, 39.847, 40.6373, 40.5724,
              41.1824, 39.2736, 39.341, 40.2342, 40.3415, 38.6004, 40.439,
              40.8893, 38.9984, 40.3818, 40.7203, 39.8497, 39.6424, 39.2446,
              39.2455, 41.0537, 38.7376, 39.0457, 40.1044, 38.6538, 39.2343,
              39.7372, 39.2792, 39.2797, 38.9674, 39.3079, 40.1072, 39.0454,
              39.4898, 38.6487, 41.0622, 39.283, 38.2713, 38.5228, 39.2857,
              39.2836, 39.2885, 40.8526, 39.2944, 39.2705, 39.2632, 39.357,
              41.0946, 39.0424, 40.9499, 39.2647, 39.2992, 40.0014, 40.55,
              39.3807, 38.6487, 38.6487, 38.6487, 40.8821, 39.137, 40.5621,
              39.271, 40.4889, 39.7259, 39.6382, 38.6964, 38.654, 38.692,
              40.8802, 39.4981, 40.3562, 38.2437, 38.2185, 40.9189, 40.4221,
              40.4587, 40.6863, 39.3672, 39.5648, 39.2094, 39.1513, 39.1498,
              41.0667, 41.0297, 41.0326, 41.0397, 40.9587, 38.8865, 39.7325,
              40.6144, 39.7483, 40.6676, 39.2142, 39.226, 38.4409, 38.4521,
              38.2595, 40.692, 40.8636, 38.8152, 41.1977, 39.3056, 40.5856,
              39.1709, 40.8565, 40.8528, 41.3428, 39.1847, 41.4005, 38.6237,
              40.9598, 38.4633, 39.8287, 38.6985, 39.2594, 41.199, 39.1747,
              39.2301, 40.4221, 40.4183, 40.4282, 40.997, 40.4366, 41.3203,
              39.3429, 40.3492, 41.3094, 40.5048, 39.4118, 41.1783, 39.4931,
              40.7319, 41.0509, 39.2157, 39.3699, 40.424, 38.8883, 39.6716,
              39.6688, 39.662, 38.6799, 39.9381, 40.5478, 40.095, 40.1002,
              39.4206, 40.4552, 40.6004, 40.5903, 38.2408, 39.3816, 39.7576,
              38.6596, 37.3831, 39.539, 39.8133, 40.2784, 38.2775, 40.694,
              39.3801, 41.0588, 39.3457, 41.1078, 39.4242, 39.4078, 39.4048,
              39.3781, 39.3818, 39.3985, 39.3683, 39.3969, 39.3917, 40.531,
              13.4501, 13.4892, 13.4191, 13.5465, 13.3055, 13.3055, 14.0533,
              14.0533, 11.3407, 11.3407, 10.2803, 12.1, 19.7641, 19.4431,
              18.5431, 42.022, 41.9009, 13.4828, 15.3846, 13.2288, 13.2872,
              14.1171, 13.2368, 13.5167, 13.5167, 13.5222, 13.147, 13.5222,
              13.4058, 13.2638, 13.259, 13.2288, 22.3224, 22.4141, 22.3827,
              46.5683, 47.9821, 47.6275, 46.3775, 47.353, 47.7631, 48.1001,
              47.9823, 47.894, 46.7755, 47.333, 23.8143, 24.4771, 24.4803,
              23.8143, 23.8717, 24.6304, 23.8143, 23.8143, 23.8143, 24.4796,
              24.5762, 21.9779, 24.2651, 24.2651, 24.2651, 23.8143, 25.6657,
              29.9838, 24.6865, 21.086, 17.6361, 17.6361, 19.2903, 19.2903,
              19.2903, 21.078, 19.2903, 12.9753, 13.9443, 12.9753, 13.3086,
              16.1996, 15.4203, 14.239, 17.4983, 18.635, 19.1628, 18.635,
              18.218, 20.024, 20.024, 20.8435, 18.9617, 21.1305, 20.7957,
              21.0651, 20.8435, 20.8435, 17.456, 21.1776, 21.1776, 18.635,
              23.2806, 20.024, 25.7353, 23.2274, 14.2444, 14.2444, 14.2444,
              14.2444, 21.0856, 17.9529, 17.6578, 17.6578, 18.635, 21.0651,
              17.8774, 17.6578, 18.635, 18.7283, 18.7283, 25.6611, 20.701,
              19.75, 20.8416, 20.2015, 20.6611, 20.3618, 29.8413, 29.8616,
              30.2156, 30.2156, 30.0575, 29.877, 29.877, 14.284, 24.2363,
              14.2444, 14.2444, 24.0387, 23.0273, 23.2806, 12.9753, 25.7353,
              23.7633, 34.1909, 35.1147, 9.1697, 11.9086, 9.0128, 16.7476,
              12.9753, 16.5889, 26.8364, 26.8364, 26.8364, 13.1627, 12.9753,
              15.6317, 16.8331, 12.9753, 12.9753, 16.2077, 16.2077, 16.2077,
              16.2077, 12.9753, 14.2444, 14.2444, 12.9753, 14.9519, 14.2331,
              22.5415, 21.1654, 22.2352, 22.2352, 22.2496, 22.2496, 20.9072,
              22.5415, 23.893, 23.929, 23.9001, 23.9145, 23.909, 23.893, 23.903,
              23.901, 22.5415, 23.9027, 23.9021, 23.904, 23.9021, 23.9021,
              23.926, 23.9201, 23.915, 22.1686, 23.2674, 22.5415, 21.2051,
              22.5415, 22.5415, 22.5415, 21.8243, 24.5311, 24.5311, 24.1721,
              22.9896, 22.9896, 22.9896, 22.5415, 22.7987, 17.5677, 16.6671,
              14.5204, 15.8164, 12.9753, 16.8331, 22.5, 18.0652, 16.5601,
              16.3473, 14.672, 12.9753, 12.9753, 24.5311, 24.5311, 24.5311,
              20.8667, 22.4156, 23.8245, 23.0949, 22.385, 21.1699, 15.2955,
              20.4881, 24.7905, 26.5124, 15.9241, 14.8221, 14.952, 14.952,
              14.8221, 14.8221, 14.8221, 14.0902, 14.0321, 14.0321, 14.0321,
              14.0321, 14.0902, 14.0902, 15.564, 14.027, 14.0278, 14.0278,
              29.8515, 14.9519, 14.0902, 14.0902, 13.1673, 13.1673, 13.5996,
              15.6559, 11.6644, 15.6526, 17.3476, 17.4558, 14.0278, 12.9753,
              15.8185, 14.8221, 26.5124, 14.9557, 14.8221, 14.46, 14.52,
              17.5894, 14.8221, 14.8221, 14.8221, 14.8221, 15.3945, 15.3945,
              15.3945, 13.5996, 14.8221, 13.3122, 15.6765, 15.6765, 15.8185,
              15.6811, 15.6634, 15.655, 15.655, 15.658, 14.9185, 14.9185,
              14.9185, 14.9185, 14.9185, 13.5996, 15.6765, 30.7178, 26.8278,
              30.7178, 17.6167, 17.542, 18.1111, 18.1018, 17.4086, 18.2, 16.47,
              17.4086, 17.5897, 17.5897, 17.4086, 17.3329, 18.1008, 17.7265,
              17.7019, 17.4086, 17.8496, 17.5916, 17.6603, 17.4086, 26.6557,
              26.6557, 26.7481, 25.1869, 17.4086, 18.7481, 30.7178, 17.4086,
              10.7828, 9.5905, 9.5905, 16.7492, 16.7492, 16.7492, 16.7492,
              16.7492, 16.7492, 16.7492, 17.4086, 17.4086, 17.4086, 17.4086,
              16.7136, 17.4434, 18.9542, 17.9384, 18.1439, 17.0564, 17.1999,
              17.1999, 17.4086, 17.0564, 16.7435, 26.46, 26.1415, 27.6769,
              26.1055, 12.9753, 16.5222, 12.9811, 12.9753, 12.9753, 15.7707,
              12.9753, 14.9408, 16.2971, 15.3716, 12.9753, 12.9753, 12.9753,
              12.9753, 12.9753, 12.9753, 12.9753, 12.9753, 17.7744, 12.9753,
              16.5592, 17.3099, 12.9753, 16.7719, 12.9753, 15.5532, 12.2693,
              17.6814, 14.2341, 26.1055, 26.0977, 29.9881, 25.4531, 26.1154,
              25.3618, 25.4741, 28.1167, 28.1078, 25.3618, 25.3618, 25.3618,
              25.4741, 24.2033, 28.1119, 25.4741, 25.4741, 25.4741, 25.1001,
              30.2357, 29.8788, 29.8728, 22.4258, 22.4258, 14.2341, 14.2444,
              10.3261, 18.7481, 12.2532, 9.5905, 28.0159, 25.1862, 26.6999,
              25.5377, 25.5377, 27.9519, 27.5648, 26.9104, 26.9104, 26.9104,
              26.7845, 26.8028, 26.9104, 26.8106, 26.293, 26.293, 26.293,
              28.1341, 28.1341, 27.3319, 25.1862, 27.1999, 25.1862, 27.6009,
              27.5182, 27.5182, 30.7178, 30.7178, 25.7717, 27.3685, 25.1862,
              27.3748, 27.3748, 27.3748, 27.3748, 27.3748, 25.8254, 27.5182,
              27.5182, 27.5182, 27.5182, 27.5182, 27.5182, 27.5182, 27.5182,
              27.5182, 27.5182, 27.5182, 27.5182, 27.5182, 27.6355, 28.0159,
              8.7043, 26.293, 10.3261, 10.3261, 9.1806, 10.3261, 9.3457, 9.3457,
              9.3457, 9.3457, 9.3457, 10.3261, 8.9726, 8.9481, 10.9094, 8.7043,
              11.6125, 11.6125, 10.1105, 10.3261, 10.3261, 9.4032, 9.4032,
              9.3666, 25.1862, 9.5905, 27.3801, 26.293, 10.3261, 25.1862,
              25.1862, 27.4037, 27.4037, 27.1294, 25.1862, 25.1862, 25.1862,
              24.0333, 25.1862, 26.9199, 27.1294, 25.1862, 25.1862, 25.1862,
              25.1862, 25.1862, 25.1862, 27.1294, 25.1862, -8.456, 1.1329,
              -6.4511, -7.5389, -8.51, -2.9708, -0.9584, -6.4511, -0.9584,
              -7.6333, -8.3621, -6.4511, -0.0596, -2.9708, -8.7286, 30.2627,
              31.987, 30.2627, 30.2627, 30.2627, 35.0206, 29.9321, 30.2627,
              37.4668, 36.1675, 34.0542, 30.2627, 30.2627, 35.2232, 33.4206,
              33.0956, 36.3667, 31.8333, 31.1973, 32.616, 32.5012, 32.9, 31.621,
              32.0457, 33.0956, 33.4206, 33.3858, 33.0956, 34.0, 33.4054,
              31.1973, 31.1973, 30.5, 34.0, 52.3028, 52.3769, 53.6584, 53.4487,
              52.9871, 53.8743, 52.6759, 31.2018, 31.1469, 31.7579, 31.0119,
              29.9647, 31.2404, 31.0687, 30.9782, 30.9782, 29.7917, 31.2468,
              39.4129, 45.0367, 44.5712, 40.9622, 40.3258, 40.7233, 41.0233,
              38.847, 44.5712, 44.5101, 40.7185, 38.2065, 44.945, 38.2065,
              42.409, 45.0607, 44.5097, 43.7045, 38.838, 41.157, 42.409,
              42.6384, 42.6384, 39.2356, 39.2356, 41.9186, 41.658, 42.3918,
              40.8423, 40.825, 41.9186, 40.6301, 40.5171, 42.0843, 42.3775,
              41.3598, 41.3598, 41.6898, 42.409, 41.0731, 17.9441, 18.1851,
              18.1851, 18.1851, 18.1851, 18.2269, 17.9519, 42.7059, 42.8033,
              40.7901, 42.7013, 33.5107, 36.9196, 36.9502, 34.7299, 36.9196,
              36.1668, 43.0195, 35.377, 36.7673, 35.8511, 36.595, 37.5257,
              37.0946, 42.5547, 43.9865, 31.9672, 32.9979, 31.9253, 34.7415,
              34.016, 37.153, 35.4776, 42.3012, 32.914, 33.1844, 36.6, 36.9502,
              33.9263, 39.718, 38.3595, 42.7217, 37.7548, 31.465, 37.75,
              33.6247, 39.8331, 36.9628, 34.6636, 33.9531, 33.7581, 39.24,
              37.3695, 37.358, 42.6631, 42.765, 34.883, 33.9217, 34.2815, 34.84,
              33.2558, 34.2532, 32.7986, 35.0876, 33.3705, 35.653, 34.5767,
              35.1171, 34.281, 38.2681, 38.0075, 32.9213, 40.7312, 36.9502,
              37.2982, 31.9923, 43.0375, 34.7202, 34.6916, 34.7141, 38.256,
              38.374, 36.7026, 34.6358, 33.921, 34.375, 35.428, 34.9855,
              36.9628, 38.4056, 33.959, 37.909, 32.8532, 39.55, 36.7603, 36.78,
              36.611, 36.9379, 37.5813, 38.256, 40.2955, 40.2955, 40.3267,
              31.3783, 39.1957, 36.7364, 35.1513, 40.9671, 35.185, 31.4665,
              31.742, 32.7918, 36.0972, 31.9069, 36.0007, 32.8505, 38.1199,
              34.2181, 34.172, 36.986, 34.84, 35.6852, 37.3059, 37.0584,
              38.9361, 36.1604, 36.1374, 36.1374, 36.6391, 32.6115, 34.9791,
              38.1777, 38.2681, 35.2024, 36.4443, 36.0899, 36.0185, 39.702,
              35.4285, 32.011, 32.432, 32.6115, 33.0809, 39.6396, 38.5008,
              42.6556, 36.403, 36.4607, 37.6947, 36.9502, 33.7581, 31.89,
              31.652, 35.041, 38.59, 33.2267, 33.9887, 36.1646, 34.3425,
              35.4452, 42.9074, 34.9582, 35.165, 31.362, 38.3792, 37.454,
              34.643, 32.8532, 36.683, 31.8961, 36.9502, 34.9454, 35.0789,
              36.1524, 34.6324, 35.0834, 34.9128, 35.3896, 37.771, 38.7714,
              31.3256, 38.7892, 40.6557, 38.6713, 33.3358, 38.9646, 36.2817,
              34.6904, 34.6904, 36.6, 36.9628, 36.38, 42.8009, 40.763, 40.7714,
              40.7337, 40.7754, 40.8332, 38.3082, 33.9429, 34.7898, 38.503,
              34.6863, 40.2224, 40.4082, 31.7176, 33.4305, 34.455, 38.1737,
              37.531, 37.842, 37.1499, 37.1665, 33.7072, 35.2455, 35.2361,
              34.9582, 36.9502, 36.9502, 36.8113, 34.1273, 37.2547, 38.7435,
              37.8799, 33.261, 33.2271, 36.6095, 33.2469, 40.9243, 42.9935,
              42.7951, 34.4737, 37.6857, 36.2488, 33.9383, 37.6631, 39.4926,
              34.7898, 34.594, 34.8028, 37.8799, 43.019, 43.0504, 36.328,
              38.0024, 34.0882, 35.0073, 32.2099, 34.5868, 36.9502, 40.8417,
              31.1667, 30.1982, 30.1588, 32.3425, 32.3538, 30.216, 32.0083,
              31.1667, 30.1436, 32.3507, 32.2821, 32.4351, 29.8021, 32.438,
              30.1982, 32.3425, 30.6843, 32.1352, 30.5955, 30.1586, 32.1871,
              30.1588, 32.1352, 30.1588, 30.1589, 31.909, 31.7965, 31.1667,
              30.1588, 30.1588, 43.2874, 41.5034, 41.5034, 49.8101, 41.5034,
              43.7362, 43.2874, 45.1678, 49.225, 41.5034, 47.2286, 41.5034,
              51.1182, 42.9016, 43.6088, 48.2634, 48.2634, 46.2212, 45.6322,
              41.5034, 42.7112, 42.714, 43.2874, 45.0749, 46.67, 43.2874,
              43.2874, 50.0459, 43.2874, 46.798, 47.2286, 41.5034, 0.4211,
              -0.5377, 1.442, -3.2009, -0.4699, -1.5642, -0.0604, 0.2858,
              -0.436, -0.1971, -0.0057, 0.367, 0.2254, -0.3326, 0.4267, 0.4304,
              42.587, 42.587, 29.2285, 29.2285, 28.89, 29.2734, 29.2285,
              29.2285, 29.2285, 29.2285, 42.7892, 14.9457, 17.9974, -29.8195,
              -29.6039, -29.8195, 6.4745, 26.8234, 26.8234, -19.489, -19.489,
              -12.9209, -14.0423380295461, -14.482, -14.4226372509546, -13.761,
              -11.8988, 3.7224, 2.7814, 3.5429, 4.2087, 5.6723, 5.4872, 4.2087,
              4.934, 3.5429, 5.6213, 1.5283, 5.196, 5.6503, 4.8714, 5.6135,
              1.5672, 5.8189, 6.0384, 5.0477, 1.6711, 3.7136, 1.5068, 5.6213,
              6.9444, 5.6724, 5.683, 4.1129, 6.5415, 6.5415, 5.145, 6.1646,
              6.1646, 4.0028, 4.4672, 3.5008, 6.5067, 3.0095, 4.8122, 5.5888,
              3.5367, 2.34, 2.9241, 5.8642, 3.084, 4.677, 14.5418, 13.0287,
              13.43, 11.7141, 13.1159, 10.7938, 12.0649, 12.0649, 13.4187,
              18.1528, 18.093, 17.9912, 30.9908, 23.3719, 24.5227, 29.0903,
              30.9908, 32.5246, 22.6196, 25.412, 30.1694, 22.6408, 29.9773,
              29.0737, 27.694, 31.7341, 24.1267, 20.6618, 30.0078, 21.9086,
              25.1928, 28.3867, 29.0903, 29.0903, 20.145, 21.8942, 21.8942,
              29.9773, 24.6394, 22.2099, 22.8293, 31.8516, 21.3578, 19.1791,
              19.5521, 23.3719, 23.9904, 23.9904, 23.9904, 25.4311, 25.179,
              26.9263, 26.9263, 26.9263, 21.8432, 20.1303, 31.8516, 24.6394,
              20.8731, 26.9263, 25.5439, 28.9592, 25.39, 19.6271, 22.5699,
              21.5219, 29.0903, 22.0, 24.6387, 19.5614, 30.7943, 24.816, 22.03,
              24.6394, 24.8288, 24.6394, 24.158, 24.158, 21.1367, 21.1367,
              28.823, 27.3618, 22.2025, 22.2025, 19.2071, 25.412, 19.3302,
              31.7243, 20.3644, 20.3644, 27.1296, 22.0, 21.9287, 23.8583,
              24.0621, 30.1603, 30.1819, 15.2134, 21.81, 25.5607, 25.5607,
              18.6851, 26.3883, 22.7434, 26.4539, 24.158, 24.6394, 24.158,
              30.9908, 21.5219, 21.5219, 19.4072, 23.9902, 23.6585, 30.9908,
              19.5932, 30.9908, 19.4449, 30.9908, 23.6585, 23.9904, 24.7956,
              24.7956, 29.0903, 23.9914, 24.8288, 20.1584, 23.6585, 24.7956,
              30.9908, 29.0903, 24.8288, 30.9908, 30.9908, 30.9908, 22.2099,
              20.1584, 21.5219, 22.8447, 27.0347, 20.8978, 25.8781, 19.3703,
              24.0624, 27.6557, 20.8773, 26.8951, 24.03, 23.3719, 20.4321,
              28.546, 27.9973, 30.6772, 30.678, 24.87, 31.5915, 22.9414, 27.652,
              27.6516, 21.1427, 21.2955, 18.6534, 26.786, 23.6585, 22.2099,
              22.2099, 22.518, 20.9503, 19.9117, 31.3098, 26.8032, 30.7146,
              30.1133, 21.7638, 23.9922, 25.6029, 30.6207, 30.6207, 30.6207,
              30.6207, 30.6207, 31.1043, 31.1043, 31.1043, 31.1043, 19.5435,
              30.6782, 21.9422, 21.9422, 25.559, 19.0823, 29.0903, 29.0903,
              29.0903, 29.0903, 22.298, 29.0903, 24.0624, 22.8447, 19.7091,
              30.1509, 21.3433, 21.3433, 20.51, 21.9419, 28.4983, 31.0881,
              26.1054, 27.1296, 29.0903, 24.8205, 25.1801, 30.6071, 25.246,
              20.4316, 20.7426, 20.2482, 23.8583, 28.9622, 29.9063, 22.1529,
              25.5637, 23.1456, 31.5972, 28.1872, 20.4563, 23.9904, 19.5848,
              32.3918, 29.0903, 32.3918, 14.6784, 25.5325, 25.4444, 20.6325,
              19.3469, 27.1296, 21.2827, 30.7137, 31.5494, 27.4764, 21.5204,
              23.18, 29.0538, 25.7952, 23.6585, 26.9302, 22.3272, 20.3913,
              22.2099, 19.9083, 20.6325, 20.625, 20.6646, 49.3441, 47.7827,
              44.418, 42.4318, 41.9291, 41.9291, 28.2105, 31.1728, 31.1728,
              33.2476, 31.1402, 29.3862, 32.0392, 34.0097, 30.7793, 28.5274,
              32.0422, 35.4619, 33.6879, 32.7782, 34.0164, 32.8838, 28.9833,
              31.0106, 31.0377, 31.0623, 31.0218, 30.3884, 31.1728, 31.1728,
              32.6524, 30.4703, 32.8838, -16.8231, -14.4932, -13.0498, -13.0639,
              -16.1761, -13.2999, -13.2999, -19.8473, -14.8, -13.0639, 20.0494,
              16.8505, 17.175, 21.3336, 18.8181, 16.8505, 17.175, 19.1817,
              20.0501, 17.175, 20.0501, 18.7148, 17.175, 17.175, 19.1481,
              17.175, 14.0785, 21.9621, 17.175, 21.254, 20.0501, 17.175,
              16.8505, 21.9621, 17.175, 17.175, 19.7407, 21.9621, 17.175,
              21.9621, 18.6852, 16.8505, 19.9656, 21.4274, -22.43, -23.2335,
              -23.6528, -21.489, -22.5702, -25.8813, 27.86, 53.1761, 52.9068,
              53.2191, 52.4535, 52.9068, 52.7803, 51.7625, 50.937, 52.7472,
              52.9068, 52.9068, 51.4163, 52.5448, 52.9623, 52.1014, 52.9068,
              52.4254, 52.9068, 53.2191, 52.1014, 53.3016, 53.0097, 52.9449,
              51.4584, 51.5368, 52.9068, 51.9967, 51.2424, 51.687, 53.2191,
              52.4202, -22.2099, -38.0035, -41.5001, -37.0115, -38.0035,
              -43.4974, -41.2851, -41.2851, -37.5889, -41.5001, -41.5001,
              -41.5001, -41.5001, 12.609, 12.609, 12.3089, 12.3089, 12.609,
              12.609, 12.609, 14.206, 17.7356, 9.6, 8.4388, 9.6, 11.8055,
              10.3825, 10.3825, 10.4823, 9.6, 6.5536, 8.8432, 10.3825, 12.5683,
              9.8818, 13.0148, 5.5349, 6.4733, 39.0227, 41.7636, 41.7375,
              41.0316, 41.576, 41.576, 41.0418, 41.8164, 41.0316, 41.0316,
              19.6395, 21.0, 22.7903, 22.7903, 19.6395, 23.2174, 19.6793, 20.0,
              21.0, 24.3502, 24.4654, 24.8597, 33.0282, 25.32, 25.32, 25.1893,
              30.5829, 29.321, 29.3179, 29.3148, 24.8739, 24.8739, 24.8739,
              24.8739, 33.0282, 34.0826, 24.8553, 24.8553, 29.274, 29.3148,
              29.3148, 33.5691, 25.452, 25.0662, 25.32, 30.3628, 30.5829,
              30.5829, 32.9276, 30.9033, 29.746, 29.3148, 26.6749, 29.4445,
              29.115, 24.7109, 26.6749, 27.8202, 27.8202, 27.8202, 30.1909,
              30.1909, 30.3628, 30.3628, 30.3628, 25.1893, 8.4532, 8.1166,
              8.6792, -16.3441, -17.2582, -16.5741, -17.5439, -17.993, -17.0293,
              -16.437, -17.2267, -17.1981, -17.6292, -16.3441, 14.4812, 14.512,
              8.6566, 12.3532, 15.072, 10.481, 15.4467, 15.072, 10.7462, 13.899,
              10.5141, 16.3582, 11.1368, 15.4846, 11.9984, 15.3287, 14.109,
              11.0868, 8.5212, 14.1605, 14.109, 14.3318, 10.485, 8.6566,
              18.0726, 16.0644, 14.369, 17.4485, 11.1277, 10.777, 10.8829,
              13.9687, 6.1028, 10.6744, 15.5144, 15.5144, 6.6191, 14.14,
              15.7136, 14.4756, 14.4756, 8.5387, 17.4194, 14.8089, 10.8055,
              6.0839, 16.3229, 15.3403, 15.4846, 17.4691, 17.4691, 16.02,
              15.0258, 16.0644, 14.3318, 10.5161, 14.2755, 13.757, 13.9155,
              15.3673, 14.417, 16.0257, 15.3673, 13.757, 15.2439, 8.6119,
              15.335, 15.335, 16.674, 16.674, 18.051, 15.1955, 18.0604, 16.9223,
              14.0131, 14.065, 15.072, 14.3318, 16.136, 15.9373, 11.4666,
              10.9247, 15.4334, 14.8302, 14.8302, 14.109, 17.9267, 15.3673,
              15.1405, 14.8302, 13.7085, 11.2488, 6.9446, 14.6727, 8.5747,
              14.3574, 18.2001, 15.889, 16.7306, 10.485, 14.109, 13.9687,
              6.0839, 14.795, 7.271, 8.4777, 14.2171, 14.0518, 6.7564, 10.7462,
              10.4204, 6.7796, 10.485, 10.4157, 16.7306, 17.0473, 6.0839,
              10.4249, 15.4412, 8.009, 17.1284, 15.1655, 18.0726, 18.0726,
              18.511, 8.5837, 13.7761, 51.9737, 51.3003, 51.3547, 49.9927,
              52.1638, 53.6528, 53.7734, 50.884, 49.9927, 52.6729, 54.6939,
              52.0991, 53.1969, 37.9909, 37.156, 37.6511, 38.0371, 38.0635,
              37.1911, 40.2654, 41.3419, 38.2071, 41.3427, 38.0371, 37.471,
              38.393, 38.1977, 37.6511, 38.7193, 37.665, 37.471, 38.13, 37.471,
              38.7155, 38.7155, 38.7155, 39.4629, 38.7155, 39.4629, 39.025,
              40.0333, 37.365, 38.7136, 40.0333, 39.2968, 39.2767, 18.0814,
              18.0504, 18.3081, 18.5008, 18.4737, 18.4055, 18.0358, 18.3925,
              18.2999, 18.0464, 18.4379, 18.4606, 18.2259, 18.4594, 18.4445,
              18.1322, 25.3171, 25.3486, 25.3171, 44.7084, 44.7084, 45.706,
              44.4491, 44.4491, 45.9852, 43.876, 46.9672, 45.9852, 44.7084,
              44.7084, 45.895, 47.868, 43.9866, 44.4491, 44.4491, 45.7558,
              44.4491, 44.7084, 44.7084, 46.5972, 46.5972, 44.7084, 51.0711,
              48.7529, 51.2668, 56.0935, 51.266, 51.14, 44.4025, 51.0818,
              51.948, 47.958, 53.017, 45.7979, 45.417, 43.9129, 43.9129,
              46.9017, 46.9017, 50.4508, 50.8458, 46.2426, 44.7994, 50.8118,
              53.017, 53.1743, 46.1522, 48.5228, 48.6975, 50.2936, 50.5527,
              50.8465, 44.8633, 51.13, 53.017, 44.8334, 51.6521, 48.405,
              48.6975, 52.0269, 51.7073, 51.2217, 51.2217, 51.0694, 51.324,
              17.321, 25.6243, 25.6243, 28.487, 24.4709, 22.2833, 24.1456,
              31.3333, 22.8, 29.6324, 29.6324, 25.6243, 21.4837, 24.7117,
              25.7453, 20.5595, 25.6243, 22.2833, 28.487, 27.0112, 21.4837,
              26.3289, 25.8694, 29.727, 14.0979, 14.8612, 14.4809, 14.179,
              16.5172, 14.4736, 14.4751, 15.8561, 15.1031, 45.66, 43.8869,
              45.4095, 43.527, 43.527, 44.1534, 43.527, 43.527,
              7.95435735312826, 8.479, 8.8996, 1.3571, 1.3571, 1.4051, 1.3765,
              1.3571, 1.3153, 1.3571, 1.3571, 1.3571, 48.3522, 48.4759, 2.1179,
              -28.8793, -25.5748, -29.3595, -28.8906, -24.0419, -27.0322,
              -28.5707, -28.5707, -28.5493, -30.9986, -29.3595, -30.5012,
              -30.0335, -28.9134, -28.3154, -28.8872, -28.4588, -28.5364,
              -29.3595, -23.0716, -29.9669, -33.4103, -27.6095, -27.5778,
              -26.4151, -27.1583, -28.7333, -28.4628, -30.5955, -30.6234,
              -30.5892, -25.6332, -30.8373, -28.6133, -28.5677, -29.3857,
              -27.9843, -29.0019, -28.4819, -28.3133, -30.1607, -31.7212,
              -27.3656, -29.2374, -27.5975, -28.2974, -22.9935, -32.4148,
              -30.0215, -29.0438, 34.737, 34.7544, 36.9072, 36.7937, 36.7937,
              36.9025, 36.9072, 35.0222, 35.5648, 36.6384, 34.7352, 36.6384,
              36.7937, 36.7937, 34.5771, 34.7352, 37.179, 34.6944, 36.7937,
              34.737, 5.0, 41.9746, 37.4303, 38.8897, 38.7247, 39.7171, 39.7172,
              36.6343, 41.1718, 39.0048, 37.4156, 37.4744, 40.7088, 40.9829,
              38.0224, 38.257, 39.625, 38.453, 38.4533, 39.6153, 39.6506,
              41.1631, 38.7242, 36.9787, 37.3544, 39.0048, 39.03, 39.03, 39.03,
              41.8692, 39.2313, 38.7574, 38.6927, 38.6201, 41.4295, 39.0048,
              37.3544, 36.9898, 40.9959, 40.7048, 40.7048, 41.1723, 38.7986,
              42.8181, 41.2725, 41.2725, 40.7048, 41.2725, 41.2725, 38.7574,
              40.0433, 41.2732, 41.2732, 39.6209, 37.3063, 41.2725, 40.9959,
              37.7587, 38.0177, 41.2059, 41.2059, 36.5409, 41.2059, 41.2059,
              41.2059, 41.2059, 37.3558, 41.2059, 41.2059, 41.2059, 41.2059,
              41.2059, 39.3261, 41.4721, 41.4721, 41.2059, 41.3057, 39.9119,
              38.9964, 38.1694, 40.603, 39.6209, 39.6209, 39.6209, 39.0174,
              37.2507, 40.9502, 42.4096, 41.6521, 41.6521, 42.4096, 42.4096,
              42.4096, 42.5892, 39.8201, 40.6565, 40.6565, 37.042, 39.3269,
              38.3011, 38.3011, 38.3011, 39.6209, 39.8161, 39.8161, 39.7435,
              39.4726, 41.9813, 39.8457, 37.521, 37.7063, 38.9964, 42.5892,
              39.3261, 41.6858, 37.2209, 37.844, 38.2461, 37.2507, 38.3641,
              37.3696, 37.3828, 37.8074, 37.3828, 38.3266, 38.9492, 39.4329,
              38.6766, 39.431, 36.9898, 39.8358, 39.2238, 38.7624, 39.5731,
              39.6561, 39.9646, 38.6418, 38.9167, 38.7574, 37.2507, 37.2628,
              37.2628, 37.2628, 39.5687, 37.6832, 38.9434, 39.2441, 39.2441,
              39.2441, 37.2209, 39.3261, 39.275, 38.159, 37.9774, 38.8793,
              38.8098, 38.8098, 38.7986, 37.3943, 38.3002, 37.6102, 38.0593,
              38.1663, 42.1361, 40.8805, 40.9744, 40.9994, 41.0214, 41.0725,
              41.0482, 37.8628, 38.159, 37.3943, 38.936, 41.6131, 38.4715,
              37.4283, 38.7986, 38.7986, 38.7986, 37.2507, 39.9312, 39.9312,
              39.9312, 39.9312, 41.4936, 37.671, 37.3104, 37.4773, 37.4743,
              39.226, 37.3563, 39.4578, 41.6517, 38.8827, 38.7191, 40.7158,
              40.9238, 42.2748, 39.6209, 39.9178, 41.3456, 42.7749, 39.938,
              7.5555, 7.5555, 6.7525, 9.5043, 6.2312, 9.5043, 15.6441, 56.0216,
              56.0216, 36.5531, 33.3653, 34.4952, 34.4952, 33.4949, 23.3314,
              23.9739, 23.9739, 23.9739, 23.9739, 23.9739, 23.9739, 22.4177,
              24.0997, 23.3374, 24.0756, 24.1169, 22.4177, 23.9739, -6.5247,
              -6.5247, -6.5247, 13.9115, 14.2394, 16.7049, 18.7613, 15.6326,
              16.774, 14.4492, 14.0324, 14.169, 15.0265, 13.9169, 15.1997,
              17.0784, 18.3704, 15.3637, 14.3317, 15.011, 15.0265, 15.0497,
              15.0265, 13.3978, 13.2979, 13.3978, 8.78, 10.8514, 8.3078, 8.3078,
              10.4065, 10.6301, 33.355, 35.6781, 35.1703, 34.4311, 34.4311,
              33.9211, 32.9211, 33.9081, 33.9081, 33.9211, 33.7796, 33.8878,
              32.9211, 35.0388, 35.0333, 35.1703, 37.0115, 38.7072, 37.1878,
              37.2745, 37.0777, 36.5396, 37.756, 39.0162, 37.0225, 37.5102,
              37.1108, 37.8942, 38.6263, 38.9164, 38.8345, 1.5334, 1.5334,
              1.5334, 1.5334, 1.5334, 0.1501, 2.3555, 0.6209, 1.5334, 44.9567,
              47.8109, 47.6597, 45.467, 45.467, 47.8109, 47.8115, 46.166,
              47.8115, 46.166, 47.8109, 47.572, 49.2775, 49.2775, 44.9567,
              46.344, 44.9567, 45.468, 44.9567, 49.5603, 45.765, 49.4771, 50.76,
              45.9801, 44.9567, 49.4771, 45.9801, 49.2166, 45.2364, 44.967,
              47.6864, 45.2801, 48.678, 46.166, 24.1456, 24.767, 25.295, 25.295,
              25.295, 24.435, 24.767, 24.767, 24.767, 24.767, 24.767, 24.767,
              24.767, 25.347, 24.5361, 23.5719, 24.767, 53.1124, 51.865,
              52.0782, 53.4613, 50.7651, 51.5262, 51.3516, 53.5264, 51.5426,
              51.7036, 54.3501, 51.4626, 51.6433, 50.8088, 52.4687, 53.355,
              51.5927, 52.6898, 53.5574, 53.5604, 51.6088, 53.8394, 52.7121,
              51.9707, 51.3777, 50.7886, 52.128, 50.6672, 53.1194, 53.4057,
              52.7551, 53.5333, 53.099, 51.7659, 51.6625, 51.8663, 53.5181,
              50.7919, 51.2251, 51.3734, 51.4062, 53.2681, 57.6733, 51.6015,
              51.5066, 50.7913, 56.6675, 52.6401, 52.072, 52.0649, 51.9677,
              52.75, 53.5368, 50.8311, 50.8527, 54.9059, 52.3228, 52.9057,
              55.7633, 52.0754, 52.7075, 50.3672, 51.9592, 51.9335, 51.7738,
              51.5613, 50.8652, 52.1112, 53.3124, 51.7501, 51.5315, 51.351,
              52.7905, 51.3551, 52.3611, 52.9759, 50.4004, 51.7951, 53.3478,
              52.2198, 50.9876, 52.7076, 51.6747, 51.5104, 52.8033, 50.7348,
              54.1445, 51.3474, 51.9135, 53.3455, 51.7491, 53.2409, 52.6421,
              52.8619, 51.6275, 54.3447, 50.8844, 52.0377, 57.6824, 51.7214,
              52.2418, 54.7477, 52.329, 52.06, 52.5248, 53.1728, 52.7349,
              52.2905, 52.3328, 52.7875, 51.6401, 52.4113, 50.9924, 56.5199,
              51.9631, 51.4757, 52.4684, 51.1136, 54.7041, 54.7024, 54.3236,
              52.1158, 52.2104, 52.2381, 51.6615, 50.7034, 54.0683, 51.6507,
              51.6705, 50.7918, 50.7959, 52.2976, 52.2415, 51.2472, 51.7109,
              51.5408, 51.9817, 51.3388, 50.9076, 52.6036, 52.0884, 51.8195,
              52.3596, 52.043, 54.6341, 52.9725, 51.1961, 53.0604, 51.6148,
              53.0222, 52.7622, 52.0076, 51.3315, 54.6944, 54.7443, 52.0796,
              51.2996, 50.8674, 51.6051, 51.6928, 52.0782, 53.2624, 57.5894,
              53.7571, 52.8018, 51.3874, 54.9985, 51.7748, 51.5397, 51.781,
              52.518, 52.8817, 51.8106, 52.3787, 51.5412, 52.976, 51.4649,
              51.7967, 52.1314, 51.852, 52.284, 52.4419, 53.1837, 51.3388,
              52.0878, 52.5615, 52.319, 51.7224, 52.2919, 52.2926, 51.9348,
              52.2003, 51.3512, 51.59, 51.8076, 55.0551, 50.8985, 51.6573,
              51.6765, 51.7357, 50.7276, 54.7231, 53.7729, 52.3114, 51.1936,
              53.1284, 52.9179, 55.0795, 51.7601, 53.5922, 51.0452, 51.5088,
              51.8471, 51.5779, 50.8235, 52.6904, 51.8141, 51.1695, 52.1354,
              52.2888, 53.5251, 53.312, 54.9937, 51.644, 51.2483, 54.5601,
              52.591, 52.9607, 51.9626, 54.5058, 52.4215, 52.4488, 51.4429,
              52.064, 51.6103, 53.2387, 53.2439, 51.8195, 52.2055, 52.1973,
              52.2502, 53.0145, 51.1076, 51.1556, 52.2931, 52.9682, 52.1845,
              52.3333, 53.2645, 52.2148, 51.9326, 56.7469, 53.0152, 51.7645,
              52.1852, 51.8401, 52.4356, 50.8902, 30.965, 28.8996, 30.9919,
              41.6164, 34.4659, 32.4395, 37.6231, 37.6386, 38.8976, 33.2844,
              37.431, 39.4287, 40.3887, 31.2544, 43.184, 40.3351, 33.6117,
              33.6117, 34.677, 40.092, 33.3689, 35.0563, 34.901, 34.8609,
              34.8609, 42.62, 33.4816, 33.8231, 43.04, 30.4438, 33.8296,
              27.3232, 31.8865, 33.8055, 33.8055, 33.8055, 33.8055, 33.8055,
              33.8055, 33.8055, 33.8055, 33.8231, 33.8231, 33.8231, 33.8231,
              33.8231, 33.8231, 33.8231, 33.8231, 33.8231, 33.565, 33.8, 33.8,
              41.2009, 33.4254, 43.0832, 36.1381, 35.7267, 28.4008, 27.3209,
              41.0502, 43.4185, 43.36, 43.36, 33.1917, 31.5448, 36.7738,
              39.3207, 39.8406, 35.7814, 35.2165, 37.6632, 43.1926, 39.4572,
              39.4572, 36.4681, 42.9237, 27.6398, 30.8815, 33.45, 37.37,
              39.4564, 33.5723, 36.18, 33.479, 42.7748, 39.6725, 33.2996,
              36.5162, 34.7584, 43.104, 37.5986, 33.5401, 33.1238, 37.1389,
              35.8894, 35.8894, 35.8894, 35.8894, 35.8894, 35.8894, 35.7822,
              35.7822, 35.7763, 36.1477, 29.7569, 27.6347, 36.1383, 36.1504,
              36.371, 35.8894, 37.4715, 35.8894, 35.8894, 29.8826, 42.9112,
              42.175, 39.946, 38.2053, 31.4207, 35.822, 33.4045, 30.7479,
              33.1606, 35.7864, 35.7864, 35.7864, 35.7864, 35.7864, 35.8894,
              28.5289, 44.1541, 39.2446, 37.1815, 31.9047, 41.7925, 36.6406,
              36.7291, 36.1269, 36.0996, 39.7832, 34.7138, 37.3799, 41.6239,
              28.5241, 33.7452, 33.7452, 39.8934, 35.2628, 27.6411, 33.3866,
              29.3584, 36.8122, 40.0747, 36.5155, 36.3869, 30.3793, 30.2354,
              43.0444, 42.3146, 32.2515, 32.2515, 29.5603, 32.3524, 31.7601,
              27.6079, 33.7452, 31.4359, 31.4462, 46.6315, 37.6996, 41.781,
              29.1461, 34.839, 34.847, 31.3467, 41.1434, 42.9896, 42.9896,
              41.5875, 36.2336, 27.6813, 37.7751, 37.7989, 28.4668, 36.9767,
              36.1532, 32.9408, 41.6097, 34.8214, 34.8253, 43.1212, 34.8328,
              34.8349, 34.8349, 34.8279, 34.8349, 35.3224, 36.1764, 34.4124,
              42.4517, 36.4678, 42.8857, 32.42, 36.5447, 40.713, 36.0033,
              39.637, 27.78, 41.5416, 36.6298, 30.4214, 32.847, 35.9642,
              41.1939, 35.9556, 31.0009, 42.7569, 37.9439, 30.2962, 35.1485,
              41.393, 35.9623, 41.1939, 38.9527, 27.5858, 42.7443, 36.125,
              40.732, 37.705, 39.2446, 31.2307, 39.9538, 31.512, 39.1863,
              32.6872, 34.5133, 36.4273, 41.7172, 41.7172, 37.6632, 36.6254,
              35.3716, 21.46, 34.9415, 38.5008, 38.4978, 37.6411, 35.3803,
              37.8067, 37.8067, 37.8341, 32.7638, 43.0884, 39.0952, 44.5885,
              39.6825, 44.6352, 43.2265, 44.6547, 38.5242, 34.8344, 35.354,
              32.7552, 34.9463, 30.2825, 33.6105, 35.2237, 35.2167, 28.8832,
              41.7711, 40.8683, 34.7303, 43.7034, 39.8492, 41.6097, 32.2326,
              35.7811, 35.06, 31.0933, 34.8708, 39.5318, 42.2461, 36.2912,
              34.7803, 32.0014, 35.011, 32.3717, 37.4772, 35.815, 37.7342,
              34.4234, 31.397, 31.397, 32.0838, 26.8579, 26.8616, 32.999,
              35.895, 33.9434, 40.5674, 33.305, 33.305, 33.305, 32.0001,
              36.4593, 35.9704, 36.9707, 43.0227, 43.0437, 43.0227, 34.8442,
              34.8366, 33.4992, 33.7513, 33.7513, 42.9456, 42.9456, 43.184,
              45.1318, 35.2531, 35.2536, 35.2658, 35.2489, 36.3404, 43.3663,
              42.8876, 43.4578, 36.6878, 42.6896, 38.0157, 35.0178, 35.063,
              39.9295, 37.3669, 35.2694, 33.305, 34.6813, 34.6678, 45.1318,
              35.1261, 42.3442, 43.1352, 37.6632, 27.7697, 27.8658, 30.96,
              35.2047, 38.2732, 36.5122, 40.7184, 31.8777, 29.0, 34.7041,
              34.6783, 37.3669, 33.3217, 33.6909, 32.8763, 32.7486, 27.7191,
              34.6822, 29.2717, 29.3289, 36.685, 29.2167, 33.04, 42.5155,
              42.474, 35.9282, 43.4891, 32.3474, 30.9931, 42.1702, 32.9774,
              32.9774, 32.1164, 39.4564, 39.4564, 29.807, 34.5572, 37.1206,
              35.1028, 21.9082, 20.8439, 19.902, 38.4299, 37.822, 40.4375,
              32.9774, 32.9774, 42.6369, 42.8081, 33.8993, 35.8983, 36.39,
              35.5881, 35.7389, 31.72, 37.6091, 34.988, 35.063, 41.4669,
              29.6194, 42.5617, 33.4992, 35.092, 31.4029, 31.4155, 33.6909,
              32.0681, 33.6909, 33.74, 34.7369, 35.9025, 34.7892, 34.7892,
              32.572, 37.1482, 38.8686, 36.1448, 42.824, 42.824, 36.24, 37.019,
              34.522, 32.811, 34.6948, 34.6556, 34.745, 42.3304, 37.3669,
              35.3716, 36.9077, 40.2581, 34.5428, 42.254, 42.3385, 34.8958,
              37.0725, 34.8958, 35.3237, 35.3237, 35.3237, 35.3237, 33.1658,
              36.3079, 35.3237, 46.3895, 46.4098, 35.3238, 45.7776, 45.7776,
              31.5342, 37.5064, 35.3807, 30.5755, 32.8659, 44.5772, 36.4754,
              32.5755, 32.5619, 44.0175, 28.0801, 35.6156, 35.6156, 37.4452,
              35.0267, 33.574, 31.2696, 35.8563, 35.8442, 35.8504, 39.3726,
              31.2453, 42.0844, 34.7088, 32.6869, 32.6869, 32.6869, 32.6869,
              32.6869, 37.246, 34.7205, 32.8343, 42.7105, 45.7776, 40.6304,
              27.3219, 34.9303, 32.7533, 41.5725, 32.0394, 36.4251, 36.2647,
              36.2193, 34.9828, 34.9828, 42.7144, 31.255, 39.3344, 35.3716,
              34.9383, 34.9383, 37.1119, 40.28, 45.7776, 35.016, 34.8235,
              27.6095, 26.7016, 30.8773, 30.7115, 42.5617, 35.612, 38.5211,
              30.7829, 31.87, 31.888, 38.2999, 28.8202, 39.1788, 41.3696,
              33.3443, 32.197, 46.52, 27.782, 34.8704, 33.1353, 39.8557,
              38.0501, 32.7334, 29.894, 38.2075, 43.012, 41.6035, 38.2654,
              40.8638, 32.1609, 39.6173, 40.6167, 36.8115, 33.5917, 33.6187,
              33.656, 35.9788, 34.9923, 37.345, 41.396, 45.4965, 45.3623,
              35.8905, 31.5334, 29.191, 32.8151, 33.4055, 32.0675, 40.046,
              37.5961, 28.431, 35.85, 35.188, 35.348, 33.2989, 33.68, 33.68,
              33.68, 33.68, 33.68, 33.68, 33.68, 33.682, 33.682, 31.8695,
              42.1514, 27.8901, 33.053, 38.9532, 36.9411, 39.6342, 39.5484,
              34.9619, 36.85, 35.63, 35.63, 35.7931, 38.8505, 34.7036, 34.4937,
              38.6165, 34.247, 40.9344, 34.8449, 36.8178, 35.63, 36.9907,
              44.7948, 39.4935, 36.4333, 33.6747, 28.5137, 42.9646, 35.3933,
              33.1101, 33.1125, 35.0229, 35.233, 33.5425, 32.5644, 35.63, 35.63,
              33.08, 33.08, 30.4551, 32.8033, 34.566, 36.3425, 36.65, 37.7553,
              36.227, 36.227, 36.227, 35.63, 36.227, 43.0631, 42.7965, 37.4371,
              36.5214, 31.47, 43.184, 33.6781, 43.2884, 34.8272, 35.63, 35.63,
              36.227, 33.08, 37.5262, 36.9405, 36.8237, 32.6861, 35.3206,
              34.9923, 44.679, 35.0984, 36.089, 36.0991, 33.4529, 34.4448,
              39.4601, 38.0452, 30.9602, 29.9591, 34.9003, 34.9, 43.1569,
              34.3536, 27.3206, 36.7766, 41.6363, 37.276, 32.6812, 31.2194,
              31.2426, 37.8067, 35.3568, 44.286, 31.8693, 31.8693, 29.5215,
              43.4569, 30.1031, 33.0356, 35.3739, 35.3739, 32.6123, 29.6601,
              34.7238, 35.2578, 29.2827, 36.7291, 37.372, 33.4265, 33.251,
              33.251, 32.8663, 41.77, 36.6867, 37.9714, 44.0314, 26.7827,
              37.6945, 31.2194, 34.6489, 34.8181, 46.5033, 36.518, 30.29,
              34.8634, 34.8634, 31.47, 33.7578, 40.862, 33.4477, 33.3488,
              32.0838, 37.1119, 32.0838, 38.253, 35.9831, 31.3971, 31.4035,
              36.4765, 34.7147, 32.0628, 36.1607, 42.9092, 34.4397, 36.5314,
              33.3204, 32.9778, 37.7084, 41.6291, 44.3327, 39.5364, 31.8714,
              32.7933, 32.7722, 32.6633, 34.2278, 41.753, 35.8997, 35.8927,
              35.8441, 27.0601, 35.8673, 47.1946, 28.5035, 32.5831, 31.16,
              31.1652, 33.3967, 42.9595, 34.7089, 34.6892, 36.9426, 39.7822,
              35.8513, 34.8181, 36.288, 37.7942, 36.7977, 36.3048, 36.614,
              36.0996, 41.7817, 34.7803, 36.8511, 33.3703, 40.732, 34.6557,
              36.9834, 27.5732, 33.1003, 44.1843, 34.839, 34.8486, 34.8486,
              34.8486, 34.8486, 34.8486, 34.8181, 34.8181, 34.8181, 34.8181,
              21.4518, 36.9707, 29.5535, 37.378, 39.542, 39.5475, 41.814, 35.6,
              35.6, 35.6, 35.6, 35.6, 35.6, 35.6, 33.5374, 31.3467, 35.2897,
              29.9734, 37.593, 31.8103, 43.5914, 35.1712, 35.25, 35.2492,
              37.1739, 35.218, 36.23, 28.6553, 41.7311, 31.7928, 43.0243,
              40.0462, 35.2422, 36.5044, 32.2123, 43.0021, 38.425, 39.5201,
              31.5348, 30.2473, 37.5414, 36.73, 45.47, 31.7033, 34.862, 36.1291,
              36.213, 37.3656, 45.5546, 38.672, 38.0127, 33.2377, 35.8358,
              37.6632, 32.4272, 37.0581, 34.7195, 30.015, 31.6924, 36.3864,
              42.5159, 47.8619, 36.8071, 36.8768, 44.286, 34.5652, 43.467,
              33.4055, 33.4055, 27.5969, 43.5891, 33.7501, 35.9106, 32.975,
              29.3336, 33.1873, 27.6304, 33.4189, 31.1962, 33.7767, 31.0078,
              31.0699, 29.2918, 43.3122, 35.2233, 27.8421, 39.0718, 38.5825,
              31.1465, 30.3892, 38.8976, 37.544, 30.9574, 38.077, 41.0922,
              35.3444, 45.9254, 45.54, 34.93, 42.4298, 42.8871, 36.2778,
              32.6206, 33.3917, 36.53, 44.2333, 34.3691, 34.3805, 38.8976,
              45.267, 39.341, 35.3515, 36.2778, 39.0718, 36.4211, 42.7338,
              37.49, 38.8804, 38.3303, 35.2925, 34.4724, 41.5159, 30.5039,
              38.9443, 36.2168, 36.2168, 36.2217, 39.341, 34.7697, 45.856,
              40.8462, 43.129, 28.398, 36.3906, 32.6711, 32.6711, 32.6711,
              32.6788, 32.6685, 33.4477, 43.213, 38.6299, 33.3402, 39.2158,
              36.0996, 36.7, 26.1073, 40.858, 40.9346, 41.5895, 45.236, 28.5553,
              38.3468, 36.4726, 29.0575, 32.2861, 31.517, 38.91, 34.83, 30.862,
              30.849, 37.1303, 41.7499, 32.9765, 35.8653, 41.7124, 36.6406,
              35.3056, 31.5481, 42.4716, 32.136, 32.551, 44.286, 40.923,
              34.8315, 33.5493, 38.6165, 35.4225, 35.4161, 34.2745, 36.2991,
              43.2921, 38.2471, 40.7317, 32.638, 37.6996, 37.8067, 37.8832,
              34.1511, 35.8405, 35.0066, 38.5483, 35.3, 35.3142, 36.0996,
              29.1966, 44.5942, 20.7985, 21.4747, 32.2758, 37.1585, 29.5535,
              32.3697, 33.5004, 31.8434, 40.3914, 40.3914, 32.396, 33.502,
              39.0364, 27.522, 38.6217, 36.481, 34.9923, 27.9133, 27.6646,
              32.5729, 39.1545, 39.1625, 38.9605, 36.268, 42.5841, 39.2441,
              36.627, 30.9878, 32.8757, 31.297, 36.8186, 32.2879, 34.5004,
              44.1633, 35.0563, 39.5446, 38.2083, 40.0104, 37.6632, 41.0962,
              38.13, 34.7165, 38.5834, 38.9443, 44.2834, 28.0444, 42.9056,
              38.2471, 38.2471, 39.946, 36.5311, 36.408, 36.408, 29.08, 39.7616,
              34.72, 37.8271, 44.7116, 31.7158, 34.5794, 32.6212, 27.8066,
              36.8162, 32.2907, 36.9359, 36.0234, 36.4168, 37.549, 34.1265,
              41.3449, 41.7901, 30.3296, 34.6382, 32.7729, 33.6259, 41.1091,
              20.954, 20.7097, 36.2478, 36.2261, 21.624, 36.7719, 36.7719,
              36.1481, 32.7729, 32.4744, 30.3296, 30.3296, 35.2876, 35.0519,
              33.9195, 34.8383, 34.9465, 34.6267, 34.8476, 34.53, 34.9182,
              34.8019, 35.2137, 30.3296, 34.6233, 30.7818, 41.6853, 37.7212,
              32.6123, 32.7091, 29.3484, 34.4953, 32.7133, 42.5863, 42.2514,
              30.3296, 27.5, 34.5394, 39.946, 35.99, 36.6871, 39.5724, 32.1609,
              44.1023, 38.3226, 38.4815, 36.2831, 37.0727, 33.0949, 32.5333,
              43.0174, 32.46, 27.7533, 36.716, 36.716, 36.716, 36.716, 27.6799,
              32.4238, 46.6315, 34.9347, 34.9347, 27.2378, 40.1625, 36.716,
              36.2261, 32.666, 32.7156, 36.0508, 37.6632, 34.819, 34.8242,
              30.8276, 32.742, 39.6912, 47.1946, 31.2489, 42.8793, 34.9923,
              31.7665, 34.5167, 21.4264, 21.3343, 30.4651, 26.0495, 27.7191,
              27.3311, 40.4693, 27.2142, 33.4453, 33.4453, 32.7156, 37.1162,
              33.6488, 32.7091, 27.5733, 36.4419, 33.18, 30.4443, 26.6926,
              32.881, 44.1182, 46.274, 33.6846, 35.1677, 27.4856, 40.6595,
              19.9367, 40.6325, 36.2032, 46.8544, 28.1553, 35.0324, 36.4139,
              43.5278, 35.9, 40.0315, 35.182, 31.2758, 36.533, 40.7563, 35.3253,
              36.4864, 29.9983, 43.0654, 41.8846, 35.3635, 38.9778, 31.031,
              38.1689, 40.9397, 36.5812, 36.5812, 36.5812, 36.5812, 33.7611,
              45.5214, 43.9359, 39.9295, 36.64, 38.4912, 43.5278, 35.3751,
              34.8981, 36.1639, 30.5154, 30.4308, 30.4704, 42.3509, 40.6304,
              31.8194, 44.2617, 42.5687, 34.0541, 32.1041, 34.7742, 39.832,
              42.6391, 37.6919, 46.2826, 31.1263, 33.1225, 29.6656, 43.1741,
              35.387, 42.5708, 41.6853, 39.1422, 35.3977, 33.3356, 38.1899,
              43.444, 33.4678, 32.6711, 33.2458, 33.2522, 40.7183, 31.8325,
              39.3501, 39.4564, 39.0767, 34.4049, 32.4593, 33.7467, 37.7969,
              37.6632, 36.2188, 26.7601, 31.2697, 36.6241, 34.6365, 21.4188,
              35.7498, 42.9434, 36.12, 27.2821, 27.2664, 39.0835, 38.2471,
              37.1226, 42.7004, 39.077, 43.0683, 42.8086, 42.4329, 34.4083,
              36.1814, 40.8611, 30.2385, 44.0413, 36.1297, 33.0756, 39.4564,
              43.0613, 37.0164, 42.2682, 35.0056, 41.1537, 39.4564, 45.8404,
              34.7837, 19.5938, 21.4342, 21.3295, 21.452, 29.2423, 45.3609,
              32.2916, 39.2744, 33.4992, 34.5123, 43.1393, 21.456, 30.5891,
              38.8375, 21.3403, 36.9314, 32.9941, 35.8714, 32.506, 33.0368,
              33.3442, 39.1395, 37.9546, 45.5598, 37.6881, 37.6881, 22.0216,
              36.3818, 35.452, 36.1457, 36.1602, 36.1225, 36.174, 36.1897,
              29.4142, 34.7321, 34.6817, 36.0437, 31.4308, 38.1153, 35.4056,
              36.9258, 36.451, 37.6632, 32.952, 32.924, 29.4142, 29.635,
              34.9915, 42.896, 36.5814, 29.775, 44.286, 35.9373, 38.0154,
              36.8033, 35.4056, 35.4056, 35.4056, 32.1331, 33.1016, 39.6865,
              31.7004, 38.6133, 35.9569, 39.984, 46.78, 35.4056, 26.372,
              39.5215, 38.3821, 34.7497, 42.0838, 32.8966, 34.9042, 31.47,
              39.523, 37.8828, 31.2418, 39.6115, 41.6133, 29.974, 39.5215,
              37.804, 33.5164, 31.4398, 40.8278, 35.5219, 44.2496, 30.4664,
              29.6122, 32.605, 33.3162, 39.574, 39.9095, 40.9632, 39.895,
              38.023, 36.3769, 41.2753, 27.6075, 42.9583, 30.9766, 36.8122,
              30.9766, 40.3662, 34.4436, 35.1153, 31.5607, 40.4996, 41.2753,
              39.7822, 44.4753, 37.7713, 39.5631, 39.7168, 33.7, 33.7, 33.7,
              33.7, 33.6947, 33.6947, 33.6947, 38.4912, 39.8848, 41.2753,
              21.404, 34.541, 39.7322, 43.2977, 45.5214, 35.62, 35.62, 43.6832,
              40.3349, 38.3226, 34.4436, 34.4436, 35.593, 34.566, 34.4436,
              32.025, 45.888, 38.547, 42.9249, 43.3458, 32.57, 38.1714, 38.6784,
              26.8536, 29.8986, 34.4436, 33.6947, 33.6947, 33.6947, 34.1357,
              33.2694, 32.676, 37.4975, 37.4452, 44.6378, 39.0605, 35.0133,
              35.0199, 27.7364, 32.0435, 33.6947, 39.0218, 34.8267, 27.4481,
              35.3547, 33.2689, 35.5968, 36.1613, 27.3162, 35.5804, 44.0522,
              39.2955, 35.6354, 34.8455, 41.8318, 42.6184, 36.876, 33.6947,
              38.2546, 35.8369, 37.666, 36.0996, 36.59, 34.3449, 32.454,
              37.7673, 33.3418, 33.3328, 37.0094, 33.3476, 42.1278, 25.64,
              33.649, 30.9955, 33.1766, 33.1621, 33.1548, 38.4907, 35.2525,
              39.5025, 39.3224, 36.2778, 32.7414, -31.2603, -30.4214, -32.6848,
              -32.6083, -31.4315, 38.5639, 41.356, 37.6733, 41.356, 41.3189,
              41.2438, 38.5639, 40.7047, 10.905, 10.9056, 11.4509, 11.4509,
              16.9122, 16.9122, 16.7442, 10.8651, 10.698, 13.7761, 11.3405,
              11.3405, 11.3405, 13.1801, 13.2988, 9.59, 10.9147, 9.8433, 9.8433,
              11.0151, 10.8651, 11.2637, 11.1551, 11.8233, 11.8233, 11.8233,
              11.8233, 11.8233, 17.2275, 13.2348, 13.2348, 13.0698, 12.7098,
              10.2158, 12.0743, 12.8789, 11.2637, 11.2637, 12.0743, 11.2637,
              11.1551, 19.8423, 11.335, 12.779, 11.4493, 10.1647, 11.5624,
              11.8422, 10.9287, 11.5548, 10.5579, 10.5579, 10.8651, 11.2637,
              10.8651, 11.3109, 9.7705, 11.317, 13.4594, 11.8233, 13.4594,
              13.4594, 20.0077, 10.8651, 11.335, 15.333, 11.5624, 11.4493,
              14.2907, 11.8233, 11.2494, 10.5802, 10.5802, 10.5802, 10.5802,
              11.3405, 12.5796, 10.4963, 10.578, 14.0617, 11.892, 18.1901,
              18.1901, 11.988, 11.99, 13.2348, 10.9287, 9.7605, 10.9399,
              10.9287, 11.6866, 11.7, 11.446, 12.9682, 11.4509, 16.4648, 9.9665,
              10.9287, 11.4509, 11.8331, 11.5548, 10.7011, 16.4648, 12.8789,
              11.5624, 11.2637, 10.8745, 10.8745, 18.1901, 11.1288, 10.6587,
              11.4509, 12.2544, 10.8651, 10.8651, 10.8651, 10.8651, 10.8651,
              10.8651, 12.7157, 10.6025, 10.6025, 11.4509, 11.3405, 11.3765,
              11.0311, 11.0311, 12.0743, 11.7439, 12.6808, 11.5802, 10.5579,
              10.5579, 11.3765, 9.5664, 11.1551, 14.3615, 11.6063, 11.4509,
              11.6063, 11.6063, 11.6063, 16.4648, 11.5624, 11.5624, 9.5664,
              11.6054, 11.4509, 19.9665, 11.7107, 11.7107, 11.7107, 14.2449,
              10.8143, 14.9863, 13.0489, 13.0489, 12.5481, 11.6063, 11.5624,
              10.8651, 11.4509, 11.7, 12.9163, 14.2449, 13.0615, 11.5624,
              11.4509, 11.4509, 11.4517, 11.5624, 11.5624, 11.5624, 12.8139,
              16.9122, 14.2449, 11.3405, 16.4283, 16.6115, 11.411, 16.3011,
              16.3011, 11.2637, 11.5624, 27.537, 26.9941, 24.1682, 26.1649,
              -15.5138, -13.0219, -14.8249, -15.8294, -15.3051, -15.5169,
              -13.1126, -16.3217, -13.1473, -17.4711, -16.5111, -19.0188,
              -17.1449, -17.7927, -19.47, -18.9284, -18.9284, -20.7454,
              -20.7454, -18.798, -20.7365, -17.6702, -17.6702, -20.0143,
              -19.2785, -16.3709, -17.1449, -19.2785, -19.3902, -17.7927,
              -17.7927, -20.7365, -20.7365, -17.8261, -20.1561, -17.7927,
              -18.4555, -18.4555, -20.1561, -17.8822,
            ],
            lon: [
              67.12, 62.2178, 62.0387, 70.6507, 65.8863, 68.6991, 69.5837,
              66.2385, 19.5697, 19.5348, 19.5697, 19.5697, 19.5697, 19.7522,
              19.7522, 19.4535, 3.0, -8.1397, -0.601, 5.4511, -1.3582, 3.0,
              7.9511, 3.0, 3.0, 3.0, 3.0, -0.3174, 3.0, 0.5536, 2.8071, 2.8164,
              6.1665, 3.0, 0.9529, 8.5711, 6.1079, 3.0, 6.0651, -0.2939, 0.804,
              4.2026, 3.1636, 5.3321, 3.1696, 5.4035, 3.0, 3.0, 3.0, 3.0,
              -0.372, 3.0, 6.7665, 6.1652, 7.8711, 20.3981, 12.6654, 13.7437,
              13.4968, 19.9123, 13.4968, 12.6654, 13.4021, -66.7248, -66.8613,
              -68.9216, -70.2699, -65.9232, -66.388, -66.7237, -66.7248,
              -66.7248, -68.8713, -69.2856, -69.2913, -67.4261, -66.2212,
              -68.6706, -68.6685, -68.6734, -67.6903, 45.7664, 43.8736, 137.764,
              148.0764, 139.2135, 151.6426, 149.8286, 133.2303, 151.6426,
              147.0742, 145.4739, 149.1653, 144.2327, 146.0844, 150.8718,
              142.1691, 153.0345, 139.8, 139.1301, 151.5802, 148.4726, 146.3698,
              146.7157, 149.143, 147.9188, 142.1487, 134.755, 121.4776,
              151.5456, 151.6063, 147.2869, 147.9798, 148.9346, 145.1498,
              118.2281, 151.67, 148.7201, 148.8287, 150.5134, 144.774, 148.9001,
              153.0576, 149.1064, 139.4932, 150.0978, 146.0064, 149.05,
              121.4732, 152.4357, 114.2369, 152.9517, 149.7672, 147.7052,
              151.6001, 149.8669, 146.5529, 151.2096, 151.2096, 152.0717,
              149.444, 149.2211, 148.9675, 142.5433, 147.3908, 150.6776,
              150.7131, 151.5525, 147.7481, 138.5999, 144.5845, 146.1146,
              151.2096, 144.2872, 152.4332, 152.4696, 152.4696, 145.4235,
              147.2419, 145.6048, 151.5308, 151.1902, 142.1731, 137.587,
              150.1852, 151.4349, 146.325, 151.2096, 149.7551, 150.4081,
              138.2147, 134.755, 149.5814, 146.8885, 143.5092, 152.4154,
              152.4154, 152.4154, 148.8605, 152.742, 139.4924, 150.983, 144.965,
              145.3089, 152.2483, 152.4343, 152.4843, 148.4078, 148.4411,
              115.4292, 147.4714, 145.4495, 148.1171, 149.7921, 148.7169,
              145.0457, 147.2869, 152.4037, 152.2928, 145.3848, 114.6147,
              149.8097, 138.7549, 150.7931, 144.8621, 146.1855, 138.0876,
              137.8404, 137.841, 152.0135, 152.3308, 115.6884, 147.2106,
              149.336, 149.3582, 151.3075, 144.965, 117.1273, 137.5894, 146.973,
              138.2162, 148.3396, 146.3615, 148.79, 150.303, 147.8074, 147.8077,
              145.9298, 144.2366, 147.546, 152.08, 142.1487, 150.8751, 150.9147,
              146.8879, 143.9366, 145.3189, 145.3189, 149.8111, 142.7452,
              150.5619, 144.504, 137.764, 142.7878, 152.3215, 151.0713,
              151.0713, 137.5844, 151.2096, 150.8227, 149.4607, 149.5181,
              150.9015, 150.8808, 141.3915, 149.3886, 148.2892, 148.2213,
              150.4802, 151.277, 147.4439, 149.036, 149.036, 146.5362, 150.4972,
              147.5456, 148.7786, 150.876, 146.0358, 150.8819, 147.7713,
              147.5721, 146.8677, 147.6694, 144.0573, 152.4542, 147.7394,
              152.7028, 144.17, 145.523, 147.7449, 144.9057, 147.1364, 147.0761,
              147.1364, 142.0441, 132.4164, 148.5079, 143.9206, 146.9622,
              140.7293, 152.4928, 152.4498, 143.508, 148.439, 118.3082,
              147.5239, 136.8817, 151.8814, 144.1312, 144.151, 142.1487,
              142.3002, 143.9176, 148.0076, 152.3587, 147.1364, 116.1536,
              148.4719, 148.0462, 145.5086, 150.5903, 115.416, 148.128,
              149.9867, 150.5845, 148.5048, 147.9842, 149.3995, 145.5793,
              145.055, 150.2889, 148.4331, 147.7671, 143.7843, 142.2803,
              150.3398, 147.6657, 117.7975, 146.1207, 148.4495, 151.0466,
              150.3432, 147.7368, 115.1094, 150.1072, 148.1738, 153.2605,
              146.1469, 146.221, 146.9117, 149.8286, 149.1519, 16.2786, 45.4464,
              49.4032, 50.6045, 89.2505, 90.5975, 90.7277, 88.9336, 88.8469,
              89.6107, 88.7084, 88.4305, 88.5548, 88.7534, 89.7611, 88.6877,
              89.2214, 89.2225, 92.0077, 89.737, 91.3865, 91.3669, 89.4072,
              90.4567, 92.2208, 89.5441, 89.4781, 91.5308, 90.2497, 91.0122,
              90.2143, 88.8591, 90.9501, 91.5339, 89.9464, 91.3747, 91.3118,
              91.3118, 89.5417, 89.2204, 89.2204, 90.0953, 89.9179, 90.4227,
              89.717, 92.2119, 89.5604, 89.0349, 89.6906, 89.6906, 92.2525,
              89.6292, 89.9156, -59.6048, 29.2398, 27.6971, 5.2471, 3.89,
              4.2985, 4.1786, 3.8185, 2.6409, 2.6409, 90.9473, 91.483, 90.5119,
              90.8968, 89.6427, 90.6553, -67.4383, -67.4383, -66.7696, 17.8661,
              18.3576, 18.3576, 18.6061, 16.3517, 16.3517, 18.3576, 17.4758,
              18.6061, 17.7913, 18.3576, 18.3576, 17.2278, 18.3576, 24.7303,
              27.8374, 27.5163, 27.5163, -38.8232, -41.2562, -41.2645, -41.2708,
              -41.2702, -41.2521, -41.2624, -41.2688, -41.2573, -41.2692,
              -41.2646, -41.27, -41.2742, -41.2748, -38.8159, -41.2809,
              -38.8217, -41.255, -38.8144, -51.3858, -38.8069, -44.8736,
              -44.8854, -37.6421, -44.1018, -44.1035, -45.2247, -45.223,
              -45.2173, -45.2099, -45.2158, -45.2101, -45.2195, -45.2246,
              -45.2101, -45.2148, -36.5656, -36.5683, -44.6815, -44.7002,
              -44.6894, -44.6917, -44.6909, -45.1827, -45.1792, -45.179,
              -45.1701, -45.1769, -45.1655, -45.174, -44.9186, -37.5601,
              -37.5599, -51.2958, -46.8708, -46.8708, -46.8708, -46.8708,
              -47.0892, -47.0922, -47.0922, -47.0869, -51.3979, -41.2809,
              -51.3753, -51.3644, -51.3809, -51.3883, -38.8073, -51.394,
              -51.3936, -51.3943, -51.4023, -43.1016, -43.1003, -43.1009,
              -43.1092, -50.0407, -50.0484, -50.0345, -51.3029, -51.2915,
              -51.2958, -51.292, -51.4075, -41.2876, -38.5772, -42.5639,
              -41.4843, -41.4928, -41.4833, -41.4976, -41.4917, -41.435,
              -41.4455, -41.4543, -41.4833, -41.4528, -41.4453, -38.7662,
              -38.7485, -38.7655, -38.7333, -38.743, -38.8564, -38.8811,
              -41.4552, -37.0611, -47.5066, -36.9289, -44.6612, -38.9182,
              -38.9182, -38.9182, -38.9182, -38.9182, -38.9201, -38.9375,
              -36.9299, -38.9356, -39.3388, -39.3407, -43.2813, -43.2712,
              -43.2735, -43.2752, -43.2687, -43.2627, -39.3371, -41.2871,
              -37.0591, -37.0481, -36.2033, -47.6992, -47.7027, -47.7072,
              -47.7155, -47.7353, -47.7139, -38.9426, -38.484, -38.9279,
              -38.9283, -42.6182, -42.5394, -42.5382, -42.5596, -42.5643,
              -42.5609, -42.6127, -38.9287, -37.0623, -36.2029, -36.2311,
              -37.0316, -37.0286, -37.0259, -37.0241, -37.0555, -37.0673,
              -37.0567, -37.0408, -36.2311, -37.0476, -38.9882, -38.9903,
              -38.9768, -38.9811, -45.0, -36.2126, -36.2186, -36.2187, -38.9986,
              -38.474, -37.1272, -43.6846, -42.6191, -42.6281, -42.638,
              -42.6241, -42.6134, -42.6134, -42.6134, -43.3809, -43.3874,
              -43.3904, -43.3811, -43.3777, -43.3798, -43.3737, -43.3775,
              -43.3871, -43.3873, -42.6238, -41.0014, -40.6103, -38.3939,
              -43.7946, -43.7868, -43.8072, -43.7892, -43.8048, -43.8003,
              -43.8034, -43.8307, -43.3991, -43.8174, -43.79, -43.8485, -43.818,
              -43.8037, -43.79, -43.7888, -38.395, -38.3976, -43.8192, -43.3863,
              -38.2455, -38.2403, -44.899, -44.9077, -44.9138, -44.7145,
              -44.7145, -38.6225, -38.6192, -38.6089, -44.9211, -38.1891,
              -38.1758, -38.1603, -38.1653, -38.1656, -38.1826, -38.1759,
              -38.5643, -38.5698, -38.1843, -43.8072, -42.6054, -36.235,
              -38.2451, -38.2462, -38.2476, -38.2498, -38.2512, -38.2527,
              -38.2544, -38.2557, -42.6184, -38.2577, -38.2609, -38.2597,
              -38.2586, -37.9958, -37.9918, -37.9958, -37.9968, -37.9723,
              -38.2589, -40.2556, -42.3697, -41.8121, -47.0777, -47.0703,
              -47.0636, -47.0575, -47.0498, -47.0486, -37.9828, -37.9358,
              -47.0855, -37.9446, -43.2951, -39.3753, -39.394, -39.3753,
              -39.394, -37.0303, -37.0209, -37.1264, -43.2951, -44.6745,
              -45.263, -45.281, -39.3445, -39.3534, -39.3555, -45.2644,
              -45.2744, -45.2815, -45.2969, -45.2997, -45.2788, -45.3006,
              -45.2931, -45.2915, -45.2886, -45.2846, -45.2792, -45.2659,
              -45.2738, -45.27, -45.2986, -43.809, -37.1256, -39.3206, -45.9998,
              -45.9999, -45.9977, -45.9972, -45.9978, -45.929, -45.9055,
              -45.9064, -38.7964, -37.0834, -37.0854, -37.0879, -37.0931,
              -37.0927, -37.1024, -37.1021, -37.1022, -37.1022, -37.0829,
              -37.1196, -38.8011, -45.9432, -39.3289, -44.9967, -42.2927,
              -45.9475, -45.9461, -45.9537, -45.9578, -45.9536, -45.9399,
              -45.9509, -45.9431, -45.9566, -45.9536, -45.9507, -45.9595,
              -45.9571, -45.9602, -45.9463, -45.9475, -44.6694, -43.6841,
              -44.6698, -43.4118, -43.4118, -43.403, -43.4167, -43.3994,
              -43.4059, -43.3869, -43.4075, -43.3953, -45.0, -52.4454, -52.4537,
              -52.4566, -52.4422, -52.4655, -51.5293, -51.5285, -51.51,
              -51.5149, -43.4016, -43.4137, -43.4119, -43.4281, -46.6177,
              -46.6246, -43.3504, -43.3429, -43.354, -43.3572, -38.9539,
              -38.9578, -38.9591, -38.6307, -38.9636, -38.9504, -38.6947,
              -38.7054, -38.6642, -38.6747, -38.6853, -38.6905, -38.6964,
              -38.7032, -38.9561, -38.6296, -37.9978, -38.0019, -38.2299,
              -38.2285, -38.2355, -38.2333, -38.2342, -38.2314, -38.2409,
              -38.2395, -38.2425, -38.2283, -51.5917, -51.587, -41.1606,
              -42.1635, -42.1522, -42.1554, -42.1428, -42.1434, -42.1375,
              -40.8854, -51.5897, -46.61, -38.3241, -38.3242, -37.9938,
              -37.9897, -37.996, -37.9929, -37.9993, -38.0024, -47.0636,
              -47.0565, -42.67, -38.3135, -47.6446, -43.4497, -43.4443,
              -38.3174, -38.336, -38.3282, -38.3202, -38.3131, -38.3174,
              -38.3174, -47.6598, -46.6036, -46.5941, -46.6014, -44.4316,
              -44.4526, -44.4389, -37.7865, -37.7901, -37.7929, -37.7972,
              -38.9747, -38.9689, -44.4463, -38.9671, -38.9657, -47.0408,
              -47.0491, -46.1061, -45.9295, -45.9335, -45.9412, -45.944,
              -45.9522, -38.9747, -45.9547, -44.4346, -44.4316, -44.6584,
              -36.5215, -50.3777, -50.3788, -38.0011, -37.9899, -37.9854,
              -37.9785, -37.9896, -44.4422, -37.9844, -37.9742, -37.9729,
              -44.4196, -44.4194, -44.4232, -44.4346, -44.4269, -44.4377,
              -44.446, -37.9786, -40.8768, -45.9544, -45.9524, -46.8708,
              -38.8051, -38.8211, -38.8278, -38.8128, -38.8322, -38.833,
              -38.8454, -38.838, -44.7413, -38.8172, -38.8434, -44.8163,
              -44.8354, -44.8297, -43.9225, -50.8905, -50.3971, -50.3946,
              -46.6084, -38.8447, -45.9618, -44.7345, -44.7441, -45.9571,
              -45.942, -45.9473, -45.9653, -45.9986, -45.9928, -45.9983,
              -45.9802, -45.9799, -44.7349, -45.9801, -37.0264, -42.3607,
              -38.9198, -44.7411, -44.7448, -44.7352, -44.7376, -44.7338,
              -44.7443, -45.9721, -40.8777, -38.6228, -40.864, -41.581,
              -44.1069, -44.1046, -44.0995, -44.1038, -44.1041, -44.0933,
              -40.8702, -43.6301, -41.5858, -43.6272, -43.6288, -43.617,
              -43.6247, -43.6421, -43.6294, -43.6049, -43.6081, -43.6307,
              -43.6191, -43.6189, -43.6096, -43.5008, -43.4972, -46.6906,
              -37.4543, -37.453, -44.7767, -44.7936, -44.817, -44.8049,
              -44.7842, -44.8034, -43.5, -44.8179, -44.7928, -44.7905, -44.0852,
              -44.0896, -44.0848, -43.4673, -43.4797, -43.4929, -43.4739,
              -44.8084, -46.6745, -43.6006, -43.6407, -43.5076, -40.4878,
              -40.4878, -40.4878, -40.4878, -40.4811, -40.4655, -40.4861,
              -42.7762, -43.5217, -38.1089, -43.3593, -43.3682, -43.3235,
              -43.3241, -44.6656, -44.6735, -44.6829, -44.6911, -44.6843,
              -38.0917, -43.6518, -43.5345, -43.5398, -43.6488, -43.626,
              -43.6187, -43.6134, -43.64, -43.4768, -43.469, -43.4767, -43.492,
              -43.5465, -43.5018, -43.5052, -43.5143, -43.5183, -43.5309,
              -43.5469, -43.5036, -43.525, -43.5181, -43.5274, -43.5011,
              -49.8687, -44.1158, -49.876, -40.6731, -40.6622, -40.6644,
              -40.6608, -40.6731, -40.6747, -40.6758, -49.8619, -40.6771,
              -40.6648, -40.6782, -43.6654, -43.667, -36.9052, -36.9068,
              -36.9106, -35.958, -40.848, -40.8526, -40.857, -43.6634, -40.6713,
              -40.6758, -40.6894, -40.6911, -40.6878, -40.6863, -40.6914,
              -40.6829, -38.9824, -38.9722, -38.9766, -40.6883, -38.9753,
              -42.3566, -42.3494, -42.3276, -44.7478, -44.7519, -44.7555,
              -49.8696, -40.6713, -42.3565, -40.6899, -49.8729, -40.6873,
              114.9817, 25.4857, 25.4857, 25.5455, 25.484, 25.4857, 25.4857,
              25.4857, 25.4857, 25.3248, 25.2401, 25.8943, 24.5576, 25.2401,
              25.4857, 25.4857, -2.3598, -4.3934, -1.2022, -3.0541, -1.4835,
              -0.4089, -0.4089, -3.6333, -1.4835, 106.1436, 104.4047, 104.7411,
              104.7411, 102.9103, 105.8806, 104.21, 104.21, 104.4047, 106.1436,
              104.8694, 103.0717, 103.0876, 11.9415, 13.7804, 13.3723, -82.9445,
              -112.037, -112.037, -112.711, -111.277, -112.848, -113.275,
              -112.848, -110.497, -112.709, -110.588, -82.4211, -80.0503,
              -110.662, -82.3417, -80.1384, -84.4271, -84.4271, -82.4617,
              -80.7494, -113.16, -74.5232, -113.366, -76.6956, -110.313,
              -76.9765, -113.976, -81.114, -80.1447, -113.628, -83.0849,
              -76.271, -112.121, -111.543, -112.059, -112.116, -113.481,
              -111.128, -113.982, -113.964, -113.162, -76.0692, -110.013,
              -112.757, -79.8112, -111.78, 18.1718, 15.0503, 20.2539, 15.0503,
              15.0536, 15.1483, 19.0156, 15.1455, 15.0536, 15.1483, 15.0503,
              -70.0478, -69.6616, -69.6616, -69.6616, -69.6674, -70.0478,
              -70.673, -68.9275, -70.6096, -70.9792, -68.4627, -69.8573,
              -69.5049, -70.7798, -69.8674, -69.7572, -70.4979, -71.4095,
              -70.637, -73.0185, -68.77, -70.8946, -109.35, -71.3188, -69.1511,
              -69.1511, -68.9275, -70.178, -70.166, -70.0948, -71.1851,
              -70.7798, -70.5283, -71.2022, -69.425, -70.673, -69.3289,
              -70.9174, -70.7612, -70.7612, -70.4979, -68.8346, -70.214,
              -71.3188, -69.8573, -70.1253, -69.8675, -68.693, -69.96, -69.5764,
              -69.5273, -70.4979, -70.4979, -70.1683, -69.6163, -70.4687,
              -70.4687, -70.0679, -69.4792, -69.4792, -69.871, -70.673,
              -70.7612, -70.7612, -69.4187, -70.9174, -69.3289, -70.7936,
              -68.585, -70.4082, -68.585, -70.1715, -69.3289, -69.4226, -70.673,
              -70.673, -69.96, -70.4979, -70.0779, -68.9275, -70.0671, -69.894,
              -70.0671, -70.1778, -70.9174, -70.8583, -70.1633, -68.9275,
              -70.3131, -70.3131, -69.7541, -69.6616, -69.533, -69.533,
              -69.6173, -69.8573, -69.7548, -70.6096, -70.0313, -71.2544,
              -71.255, -70.1264, -70.673, -69.5233, -70.9113, -69.5233,
              -71.3188, -71.3188, -69.6616, -69.6616, -69.6616, 117.403,
              117.6392, 116.4455, 116.4641, 116.4641, 117.6018, 118.5078,
              117.0618, 121.0412, 121.0412, 116.5976, 117.0722, 117.2082,
              117.082, 116.8112, 116.3441, 118.6758, 115.6677, 115.6028,
              115.7441, 117.0017, 117.0061, 116.6009, 116.7971, 117.2796,
              116.38, 118.8849, 119.0213, 116.1934, 118.7269, 117.6231,
              117.8331, 119.6506, 117.9523, 118.7265, 118.4143, 117.8551,
              117.5979, 117.606, 117.6415, 115.6709, 115.4299, 118.9621,
              119.0472, 119.0472, 117.387, 117.4576, 117.4576, 116.7145,
              115.4854, 118.7415, 118.74, 118.856, 118.309, 117.4987, 117.3138,
              117.4353, 117.2648, 117.0716, 120.3329, 116.7548, 118.1754,
              118.2054, 118.1542, 118.1542, 120.3442, 120.3442, 118.7313,
              117.6774, 117.5612, 117.6802, 117.6415, 117.6721, 117.6221,
              117.6725, 117.6321, 117.6256, 117.5239, 119.0393, 117.0765,
              119.4946, 117.6192, 116.316, 109.6621, 117.0374, 109.1169,
              108.9817, 108.9817, 109.0993, 109.9318, 109.9692, 109.9738,
              110.0954, 110.0279, 110.012, 109.6586, 109.6586, 109.0962,
              109.6839, 109.6839, 109.4382, 109.4381, 109.1169, 110.3382,
              109.9974, 110.3382, 110.3382, 110.3382, 110.1922, 110.498,
              110.4981, 110.3382, 110.3382, 110.4981, 108.7955, 110.3382,
              110.1493, 110.3382, 110.3382, 110.3382, 110.4981, 110.2989,
              110.2569, 110.2569, 110.1493, 117.5543, 108.9171, 109.9974,
              115.9935, 117.6229, 116.721, 116.634, 118.4043, 118.8285, 116.769,
              116.6762, 116.2073, 116.2626, 115.5284, 115.4403, 115.3368,
              119.1588, 118.3375, 117.6544, 116.3356, 115.1703, 117.6187,
              115.8014, 117.8307, 110.1356, 109.9973, 110.1724, 109.9032,
              109.722, 109.6586, 110.1724, 109.6611, 107.6308, 109.2939,
              118.8139, 118.7883, 119.0502, 119.213, 117.9128, 115.6825,
              115.4872, 117.8969, 109.6621, 119.4831, 117.7531, 122.0443,
              113.1305, 111.81, 110.6722, 113.0115, 111.1829, 113.2198, 113.217,
              112.9192, 113.1594, 113.1213, 112.9881, 112.594, 112.594,
              112.9253, 113.9795, 113.9794, 113.1635, 113.081, 113.1635,
              113.098, 112.9771, 111.783, 113.529, 113.7255, 113.7522, 113.6562,
              113.6562, 112.1846, 113.4209, 113.39, 113.1209, 113.3266,
              113.4365, 112.9771, 113.0403, 113.6573, 113.6199, 112.9934,
              113.1111, 112.7482, 112.8267, 113.7591, 112.9067, 113.4365,
              112.511, 112.1673, 110.58, 110.5164, 110.6295, 110.6794, 110.6187,
              110.4306, 110.8675, 110.8678, 112.9108, 112.9361, 111.9238,
              110.4981, 110.7582, 112.9286, 112.9157, 112.8729, 112.7502,
              113.9187, 113.6089, 113.5705, 113.771, 113.7004, 113.7193,
              113.4744, 113.4964, 111.6691, 113.443, 110.9529, 113.5222,
              113.5222, 113.5245, 113.5861, 113.5441, 112.8923, 112.8726,
              113.5427, 113.0771, 113.066, 113.066, 117.9844, 118.2579,
              116.4834, 115.9435, 115.8246, 117.3418, 117.4676, 117.5508,
              117.6418, 118.1811, 117.826, 117.9188, 117.9215, 118.0392,
              116.8173, 116.8715, 117.669, 121.1005, 121.2063, 117.7162,
              117.5964, 122.0443, 117.0653, 116.9927, 117.0831, 116.735,
              116.9342, 117.0804, 117.1231, 116.4549, 117.1231, 117.8163,
              117.8163, 117.7528, 118.0289, 119.06, 117.5406, 117.6761,
              117.3213, 116.1173, 118.8113, 121.8282, 110.8627, 111.5913,
              111.8242, 112.8158, 111.9226, 110.6995, 111.2317, 113.5707,
              111.5677, 112.1579, 111.45, 112.528, 111.6552, 113.3984, 111.922,
              114.1883, 114.2076, 110.9975, 113.2337, 111.1394, 113.1248,
              113.1285, 112.9621, 113.093, 113.093, 113.093, 113.093, 113.093,
              113.093, 113.093, 112.8384, 112.7028, 112.7028, 112.7028,
              112.7028, 112.7028, 112.7028, 113.484, 114.0905, 113.484,
              112.7604, 110.3382, 88.1669, 107.6184, 102.2639, 102.5578,
              102.4085, 102.1439, 102.2886, 100.5982, 100.5838, 100.589,
              100.134, 100.6216, 100.6245, 100.6245, 100.6245, 100.3706,
              100.3706, 100.3706, 100.4711, 102.1453, 100.4167, 100.6193,
              100.5985, 95.0926, 95.0911, 100.5985, 100.6237, 100.61, 99.7833,
              100.5985, 100.5985, 100.5985, 100.5735, 100.5985, 99.7833,
              100.5985, 100.5985, 99.7833, 99.7833, 100.5985, 99.7833, 100.4167,
              100.4167, 100.6584, 97.1583, 97.1583, 97.1583, 97.1583, 97.1473,
              97.2067, 97.2067, 97.1916, 97.2247, 97.2247, 97.2067, 97.2058,
              97.1916, 97.1916, 95.1575, 95.1575, 95.1575, 97.1583, 95.4649,
              95.4649, 95.5154, 100.5563, 100.3908, 100.3908, 100.6193,
              100.5985, 100.5985, 97.2645, 100.6245, 94.9061, 100.6245,
              102.2639, 102.265, 102.1452, 95.5541, 102.0939, 102.0939,
              101.7777, 95.5154, 97.3023, 94.9061, 95.0911, 95.0911, 105.0271,
              105.0428, 105.0496, 105.0398, 105.049, 105.0373, 105.0426,
              105.3827, 105.3827, 105.0391, 105.0444, 105.0266, 105.4875,
              105.3192, 105.0317, 105.0316, 105.0657, 105.0471, 105.0471,
              105.4407, 105.0482, 110.7582, 106.1544, 106.2837, 105.5682,
              105.5087, 105.7685, 105.5379, 105.563, 105.0605, 105.569,
              105.1164, 105.0266, 105.3466, 105.0436, 105.3466, 105.0166,
              105.0166, 105.0482, 105.0347, 95.1575, 105.0657, 105.7576,
              97.3023, 97.3023, 100.1402, 95.1242, 95.0911, 95.0911, 95.0911,
              95.0911, 95.0911, 94.9061, 94.9061, 95.0926, 95.0911, 95.0926,
              94.9061, 95.0939, 95.0926, 97.1776, 97.3023, 97.3023, 97.3023,
              100.5735, 100.5681, 97.3023, 101.8671, 97.3023, 97.3023, 97.3023,
              97.3023, 105.7799, 97.3023, 97.3023, 97.3601, 97.3023, 97.3023,
              97.3023, 97.3023, 97.3601, 97.1776, 97.2626, 95.1575, 95.1382,
              95.1382, 107.6308, 107.6308, 107.8063, 107.392, 109.3108,
              109.2923, 110.1408, 110.1408, 109.8402, 109.8399, 109.8402,
              108.9163, 108.9163, 108.9149, 108.9163, 108.9939, 107.7887,
              107.6308, 108.0573, 107.8063, 107.6308, 98.3804, 98.3804, 98.478,
              93.1588, 100.6193, 109.5912, 109.5912, 109.5876, 106.851,
              109.8486, 109.9383, 109.9383, 107.5971, 107.5971, 107.6308,
              107.8063, 107.6354, 107.6308, 108.5756, 98.4345, 110.0286,
              108.4848, 110.0448, 110.0085, 109.9773, 110.008, 110.0416,
              110.0405, 108.9725, 108.1372, 109.4058, 109.9862, 109.9547,
              109.6794, 109.8678, 109.3926, 109.9784, 107.0273, 107.5985,
              109.9634, 108.978, 109.1129, 109.3893, 107.784, 107.6037,
              107.6823, 107.5046, 107.8634, 107.6037, 107.6004, 107.6571,
              109.7032, 107.5871, 107.4982, 108.6302, 109.2133, 109.2133,
              108.8838, 110.1339, 110.0531, 110.3382, 107.6832, 110.3382,
              98.4345, 101.6059, 95.2328, 95.2328, 95.115, 95.115, 95.115,
              95.115, 95.2628, 95.2628, 95.2486, 95.2486, 94.7972, 94.7993,
              94.7993, 94.7993, 95.1532, 95.2293, 95.1318, 95.2328, 95.2328,
              95.1371, 95.1371, 95.1382, 95.0911, 95.1128, 95.1128, 95.1128,
              95.1382, 95.1202, 95.1202, 95.1318, 95.1371, 94.7993, 94.7993,
              94.7993, 95.1428, 95.1428, 95.1428, 95.1428, 95.1371, 94.7993,
              98.4345, 95.1318, 95.2636, 100.1452, 100.1452, 100.6197, 100.6197,
              100.604, 100.604, 100.604, 100.604, 100.604, 100.604, 100.604,
              100.604, 100.604, 100.604, 100.604, 100.604, 100.604, 100.1452,
              100.5735, 100.5735, 100.5735, 95.2636, 100.5735, 100.604,
              100.5735, 100.5735, 100.5735, 100.5735, 100.5735, 94.7993,
              100.604, 100.5735, 100.5735, 100.5735, 100.528, 100.5735,
              100.5911, 100.5735, 100.5735, 100.6021, 112.9241, 89.1737,
              113.0134, 79.0726, 94.0963, 76.7786, 79.0724, 79.0724, 79.0693,
              79.0693, 79.0693, 89.3378, 89.1737, 89.1737, 89.3336, 89.3332,
              89.4685, 89.3842, 89.3842, 89.3842, 79.1588, 89.4648, 79.0738,
              88.636, 85.5273, 89.4806, 89.5846, 94.0963, 90.2086, 85.0548,
              85.0548, 85.0548, 86.0898, 86.0467, 75.7542, 75.7542, 75.7542,
              94.0963, 87.6159, 85.4993, 86.1546, 79.1081, 89.3573, 89.3573,
              90.0621, 86.5243, 90.5893, 90.5142, 90.5142, 90.5143, 86.5731,
              87.4694, 87.4694, 87.4694, 87.4694, 89.7863, 89.7863, 87.5404,
              86.687, 87.5404, 86.9179, 73.9258, 87.6517, 87.6517, 87.6517,
              87.6159, 90.0621, 90.6423, 90.6423, 89.9966, 90.0704, 90.0704,
              90.6423, 90.0022, 78.4491, 90.6423, 90.6423, 90.6423, 90.6423,
              90.0171, 89.1737, 88.3092, 88.3092, 106.2574, 89.1737, 78.4876,
              90.2839, 90.2839, 82.8894, 85.4633, 93.5794, 90.2953, 79.0444,
              79.0444, 79.0444, 79.7365, 84.8521, 84.8521, 85.3394, 77.4559,
              78.4848, 78.4848, 77.5295, 77.5251, 75.0833, 85.8597, 88.8619,
              77.2572, 80.4098, 79.7824, 79.7824, 79.7824, 79.7824, 78.4491,
              85.7282, 86.0171, 85.7299, 75.7542, 86.0177, 94.0963, 79.9631,
              79.9631, 79.9631, 86.8618, 86.8618, 80.8795, 80.8795, 80.6014,
              79.7085, 77.2455, 75.6646, 85.0605, 84.8579, 80.1779, 80.1779,
              80.1779, 80.1779, 77.6422, 77.6465, 86.2101, 82.6934, 85.4633,
              90.2871, 90.2839, 90.2839, 90.2839, 90.2839, 90.2839, 86.1735,
              73.5559, 75.2635, 85.4633, 76.0476, 76.0465, 75.139, 77.451,
              77.7718, 76.1618, 76.1618, 76.2677, 75.6715, 76.7786, 77.4112,
              85.6943, 79.0471, 79.6225, 75.9364, 75.8592, 75.8592, 75.8992,
              76.8485, 79.7947, 79.2337, 93.5884, 120.0, 120.0, 120.0, 119.8647,
              120.8225, 120.326, 120.1524, 118.5198, 121.5198, 121.1017,
              121.1017, 121.2351, 119.0139, 118.8689, 120.8777, 120.4947,
              121.0192, 120.0, 121.3237, 120.0, 120.0, 120.0, 120.0, 121.1442,
              120.7442, 120.0, 120.1175, 118.7837, 120.0, 120.0, 120.0,
              119.7333, 120.0, 120.0, 120.0, 120.0, 120.0, 120.0, 120.0,
              121.3237, 120.0, 120.0, 120.0, 116.0122, 117.1611, 117.7366,
              116.9972, 116.9226, 117.1148, 117.1148, 117.2515, 117.6708,
              117.4757, 117.4757, 117.3363, 117.3363, 117.1255, 117.1274,
              117.1605, 121.6222, 120.0, 120.0, 120.0, 120.0, 118.7819, 120.0,
              120.0, 118.9853, 120.0, 120.0, 120.0, 120.0, 121.6941, 120.3559,
              120.0871, 120.0, 120.0, 120.0, 120.0, 120.0, 120.0, 120.0, 120.0,
              120.8054, 120.0, 86.256, 86.256, 81.8122, 80.6078, 100.5164,
              100.5761, 100.463, 100.4627, 100.5761, 101.2554, 99.9499,
              103.2883, 103.3045, 100.3681, 103.4498, 100.3927, 100.3927,
              86.2711, 87.8061, 77.0671, 76.7683, 86.2503, 87.6127, 86.5724,
              77.4309, 81.9038, 81.1522, 80.4616, 83.1209, 101.6723, 81.8519,
              76.1618, 94.8775, 93.4493, 93.5052, 93.5052, 93.5052, 93.5052,
              76.7696, 80.4098, 84.2594, 101.6546, 102.6071, 101.773, 101.8732,
              101.8486, 120.0, 120.0, 118.5655, 120.0, 120.0, 120.0, 120.0,
              120.0, 121.6082, 121.6082, 119.9285, 120.0, 119.234, 118.4784,
              102.0041, 100.4953, 101.6683, 101.7042, 102.6071, 102.6071,
              101.4343, 101.1094, 102.8834, 103.4021, 99.3209, 103.6163,
              100.1358, 103.6163, 101.7629, 103.318, 99.1273, 99.194, 103.5094,
              101.8383, 102.0, 102.0, 101.7408, 113.2552, 79.7947, 82.6783,
              90.8308, 96.9178, 96.9178, 91.432, 91.4837, 90.3621, 90.5359,
              89.4303, 91.6465, 88.5115, 90.4013, 91.378, 91.378, 87.5776, 87.4,
              92.6289, 91.3476, 101.4061, 91.76, 101.4061, 101.6311, 101.6131,
              101.5699, 101.7335, 101.5499, 101.9295, 102.3758, 100.0217,
              100.8133, 102.0558, 102.0558, 101.8413, 101.4041, 101.4041,
              101.5158, 101.5158, 101.5158, 101.9617, 101.3128, 92.2014, 90.725,
              89.8471, 79.6255, 79.6202, 94.0963, 79.6158, 79.6158, 94.0963,
              94.0963, 79.6302, 80.1069, 80.1069, 82.8295, 82.8295, 80.1295,
              80.1295, 80.254, 80.254, 80.4733, 79.6145, 79.6145, 80.2603,
              81.6757, 88.8833, 88.8833, 91.9691, 88.2595, 80.1069, 87.4845,
              79.7824, 79.7824, 102.8851, 79.4707, 78.2512, 78.2512, 80.1687,
              80.1687, 80.1687, 80.176, 80.176, 80.176, 79.4707, 102.8851,
              101.2938, 101.5576, 113.7345, 112.7165, 112.6725, 113.5653,
              113.6111, 113.0695, 113.0695, 112.601, 112.536, 112.536, 112.2802,
              112.2814, 112.9725, 112.9394, 112.9394, 113.0204, 113.546,
              112.5533, 113.4228, 113.949, 111.1067, 113.2237, 112.1567,
              112.5774, 112.4423, 114.0314, 114.0969, 114.211, 114.211,
              113.5089, 114.006, 111.1692, 111.6863, 113.0871, 112.6516,
              113.2753, 112.2537, 112.2214, 113.3696, 114.2212, 79.2901,
              112.4423, 110.6771, 102.5597, 102.7016, 102.2206, 102.3218,
              102.7284, 102.7218, 102.1811, 102.4659, 102.4659, 102.1111,
              102.7098, 102.6853, 102.6853, 102.6395, 102.5057, 102.5057,
              101.4644, 100.3102, 99.5518, 98.101, 100.3319, 110.5109, 110.8789,
              110.8619, 110.7471, 110.593, 110.552, 110.6977, 110.6594,
              113.3053, 110.4892, 110.5973, 101.9129, 102.2229, 103.0166,
              103.0166, 103.0166, 102.3381, 98.5802, 110.6218, 79.7276, 79.2901,
              79.2901, 93.2125, 94.138, 94.1112, 93.2315, 94.0575, 94.0575,
              94.0575, 93.7151, 93.7151, 93.2477, 93.6436, 93.6224, 93.6282,
              94.0963, 94.0963, 94.0963, 94.0963, 93.1936, 94.0963, 94.0963,
              93.6353, 89.4648, 92.9055, 92.9074, 92.9071, 93.957, 94.0963,
              94.0963, 94.0963, 94.0963, 93.6005, 93.6005, 94.0963, 93.601,
              93.601, 94.0963, 93.6079, 93.5884, 93.6377, 92.8638, 92.8638,
              92.8638, 106.3042, 93.4493, 94.0963, 93.6023, 93.6357, 93.6357,
              93.6357, 93.6721, 86.0171, 86.242, 84.1849, 84.1849, 87.3039,
              79.9285, 79.5405, 87.6004, 87.6004, 92.8613, 94.0963, 94.0963,
              93.6497, 94.8775, 93.6423, 93.6423, 93.5884, 93.5146, 94.0963,
              93.5884, 93.6721, 89.524, 93.6374, 93.6374, 93.6374, 93.5052,
              93.6533, 94.0963, 93.5794, 93.5794, 93.5794, 93.6374, 88.4372,
              87.4837, 84.6623, 87.8061, 86.8883, 85.6278, 86.1441, 86.8883,
              86.2405, 86.2425, 86.2565, 86.2565, 86.252, 86.2527, 86.2516,
              85.5557, 85.5556, 85.5385, 83.986, 94.0963, 87.8061, 94.0963,
              80.3727, 90.4355, 82.2852, 85.4633, 75.557, 75.9458, 85.4633,
              80.218, 83.2388, 79.2868, 88.1956, 80.218, 81.2847, 81.2626,
              81.2759, 87.8968, 87.4798, 87.4831, 89.5441, 90.4355, 81.2847,
              79.2901, 88.1956, 86.1503, 82.5986, 85.4633, 81.1414, 88.9761,
              88.8077, 90.2888, 90.2888, 90.2888, 90.2888, 90.2888, 89.8523,
              89.8523, 89.8384, 89.8384, 89.8911, 84.6623, 84.6623, 81.2895,
              85.4633, 82.5461, 82.8847, 86.1377, 86.1182, 86.4621, 90.5143,
              94.0963, 86.9023, 86.6305, 82.0688, 86.1224, 82.0111, 82.0293,
              82.0201, 82.0148, 82.026, 85.4633, 82.8847, 82.8847, 82.8847,
              82.0117, 106.0855, 92.9074, 106.7582, 118.6334, 118.8753,
              114.0217, 114.0705, 114.0099, 117.5781, 117.6049, 117.4807,
              118.1675, 118.1675, 115.1442, 115.4983, 115.184, 117.541,
              117.3799, 117.5178, 117.5178, 118.7658, 117.4722, 118.7926,
              115.54, 114.9978, 114.562, 118.8311, 114.5238, 114.6064, 114.8714,
              114.6999, 114.6716, 114.4914, 114.3421, 114.3377, 114.2205,
              117.4332, 117.6826, 117.6984, 117.2717, 118.8544, 114.4051,
              117.5369, 114.7299, 114.308, 115.1577, 114.8151, 114.8151,
              114.4255, 114.4608, 114.0334, 116.9527, 117.6476, 114.4655,
              114.386, 114.604, 114.5291, 118.5028, 118.3209, 115.7281,
              119.2226, 118.706, 115.1577, 114.4016, 114.2886, 114.3709,
              115.5228, 114.3446, 114.5095, 114.5095, 114.5095, 114.5095,
              114.6475, 114.6475, 115.1973, 113.9644, 113.95, 114.2249, 114.739,
              113.7538, 114.5461, 114.3783, 114.3783, 114.3709, 114.05, 114.115,
              114.1749, 117.3333, 111.4804, 110.3189, 110.2783, 110.5019,
              110.1438, 113.6582, 116.5511, 109.9202, 112.7129, 112.7129,
              112.7129, 112.7129, 111.4787, 108.901, 107.6884, 108.2187, 109.95,
              111.4804, 111.521, 112.1483, 115.6554, 94.4356, 112.7887,
              109.8935, 109.8935, 114.5985, 114.46, 110.316, 110.8869, 109.0,
              112.6032, 113.5687, 113.5687, 112.4688, 112.4735, 112.4498,
              112.4498, 112.5589, 115.7354, 115.3789, 115.1757, 109.0, 104.2694,
              116.6341, 116.3316, 114.1354, 114.129, 115.1911, 117.5235,
              117.5895, 117.5895, 117.5892, 117.4743, 113.8882, 115.5967,
              114.2814, 114.6131, 114.6131, 117.1607, 117.3559, 115.2673,
              114.0601, 115.6157, 115.5734, 103.9441, 105.358, 105.346,
              105.5441, 104.6556, 104.6556, 104.6556, 103.6504, 105.5747,
              105.0545, 103.7668, 110.0354, 108.7256, 109.599, 116.7967,
              116.3386, 118.24, 118.24, 105.2048, 107.2407, 114.6661, 114.7168,
              114.4111, 114.8131, 113.8464, 112.1101, 113.1115, 112.9138,
              112.9958, 115.1994, 112.5395, 112.5399, 112.136, 112.641,
              114.7545, 114.934, 112.9776, 114.9432, 114.1612, 112.109,
              114.1448, 113.0918, 113.7022, 123.9724, 125.8662, 124.8379,
              124.8379, 114.0404, 114.3363, 114.3363, 114.3363, 114.1032, 114.0,
              114.7374, 111.9168, 114.3046, 113.0391, 114.8179, 114.1336,
              114.7723, 113.3909, 114.3179, 113.9916, 112.817, 115.7466,
              114.3177, 113.6671, 113.5251, 116.396, 112.2564, 113.2199,
              113.2199, 112.6457, 112.2639, 112.2639, 116.436, 115.847,
              115.7596, 113.1799, 113.3482, 114.3807, 113.8983, 113.6807,
              111.4248, 115.7595, 114.1254, 112.4054, 114.3754, 113.7885,
              115.3034, 115.1186, 114.1841, 114.2934, 128.0, 114.1651, 112.404,
              112.7352, 112.8329, 112.7914, 111.6826, 111.2667, 114.4238,
              115.7847, 113.6715, 123.5074, 128.0, 125.0578, 114.7066, 114.8701,
              117.0966, 117.1987, 115.4119, 115.2901, 116.2873, 114.019,
              114.4997, 114.4997, 114.9773, 114.5235, 114.2501, 114.4979,
              114.8348, 115.4433, 114.9978, 114.8056, 114.7767, 114.8235,
              114.8981, 114.5813, 114.6501, 114.5983, 114.6989, 114.6802,
              115.1766, 114.6665, 114.1734, 115.3364, 114.1311, 114.0314,
              113.99, 114.2136, 114.2136, 113.883, 113.8456, 113.687, 113.687,
              114.0672, 114.6145, 115.4529, 114.8265, 128.0, 128.0, 128.0,
              124.7953, 124.6979, 124.732, 123.8577, 124.8913, 124.8913,
              122.8665, 124.8768, 125.0801, 125.0801, 125.2529, 128.0, 124.8817,
              125.0578, 128.0, 125.3286, 125.3286, 125.3286, 114.8313, 114.2777,
              114.5404, 114.6807, 114.7537, 114.8472, 114.9923, 114.9528,
              115.2749, 114.0666, 114.6008, 114.1509, 113.6169, 114.3276,
              114.3276, 125.3286, 125.0048, 125.3286, 114.8774, 113.9743,
              100.6617, 98.0577, 116.9915, 119.1106, 119.1106, 119.1106,
              117.7462, 118.3251, 117.683, 117.0, 116.3025, 117.4807, 117.4876,
              117.0, 117.0, 117.0, 117.0, 116.785, 116.785, 117.6346, 117.0,
              117.1596, 116.7733, 118.7247, 117.5662, 117.6185, 117.6185,
              116.6182, 116.6663, 116.8888, 116.8888, 116.5456, 116.5274,
              116.8706, 116.0653, 115.8998, 115.8192, 116.0393, 115.9163,
              117.2994, 116.7866, 116.5321, 117.0, 117.0, 117.0, 117.0, 117.0,
              117.0, 117.0, 116.287, 117.0, 117.0, 117.1596, 117.1596, 117.0,
              116.7686, 108.7614, 108.6325, 109.9684, 107.9385, 117.6994,
              116.3285, 117.0, 116.5932, 115.8767, 116.3025, 117.0, 117.0,
              115.4366, 117.0, 117.0, 119.1238, 117.0, 117.5289, 117.9274,
              116.607, 117.0, 117.0, 116.0133, 117.0, 117.0, 116.0027, 115.8141,
              117.0, 117.7539, 117.585, 117.585, 117.5555, 117.5609, 116.9715,
              117.0424, 117.0, 117.0, 117.6071, 117.0, 117.0, 115.9285,
              116.1151, 117.2936, 117.0, 118.1172, 117.1056, 117.3718, 117.0954,
              117.5556, 118.3242, 118.343, 117.4217, 105.9656, 116.234,
              116.1251, 116.2956, 117.1501, 117.0614, 117.0, 117.3595, 117.1304,
              117.3595, 117.061, 117.1252, 117.2534, 117.1866, 117.0, 117.8311,
              116.2202, 117.0, 117.2516, 117.7873, 117.3799, 116.5956, 116.9588,
              117.0, 117.0, 118.8986, 116.1164, 116.3685, 117.397, 117.2828,
              117.0, 117.0, 117.2828, 117.0, 117.0, 117.3167, 116.6275, 116.871,
              116.8824, 117.5613, 119.0354, 119.0354, 117.0, 117.0, 116.8463,
              116.8794, 117.1385, 117.0, 117.0, 117.0, 117.0, 117.3799, 117.0,
              116.0019, 117.0, 117.0, 115.9196, 117.0, 117.0, 117.0, 117.0,
              117.0, 100.6617, 117.421, 117.7053, 107.3885, 98.9978, 95.781,
              94.4926, 94.4993, 94.4829, 94.4829, 94.4947, 94.5004, 94.5049,
              94.4987, 94.4827, 95.7045, 98.9798, 98.9659, 98.5184, 98.5184,
              102.4424, 102.3065, 102.1441, 102.1043, 100.8185, 102.1368,
              102.1368, 102.3274, 102.1969, 102.428, 102.2033, 102.2033,
              102.2033, 102.428, 102.1241, 102.1053, 102.1368, 102.1368,
              102.1368, 102.1368, 102.1368, 102.1441, 102.3065, 102.3065,
              102.3065, 104.1111, 100.0838, 100.8, 106.1774, 96.4552, 98.5664,
              98.5492, 98.5833, 98.5073, 104.9406, 103.6297, 103.6248, 97.0279,
              97.0279, 97.0449, 97.9201, 97.0447, 97.0537, 97.0537, 97.0537,
              97.0537, 102.2707, 102.0756, 99.5091, 102.4806, 102.4785, 102.47,
              102.4716, 102.2811, 102.1431, 102.3052, 102.3433, 102.2987,
              102.2814, 102.2178, 102.329, 102.2153, 102.2075, 102.2075,
              102.3193, 102.1431, 102.3831, 98.0975, 95.5012, 102.4667,
              102.4667, 103.1281, 98.1343, 98.2869, 98.2869, 98.1025, 102.1385,
              102.1385, 101.9674, 101.9674, 98.9548, 98.971, 98.9257, 104.0362,
              98.923, 99.8193, 99.8195, 100.4474, 94.6602, 118.6375, 94.3389,
              103.985, 103.985, 104.5734, 94.5007, 94.5007, 94.6602, 98.5792,
              94.6678, 94.6678, 94.6678, 94.4904, 94.4335, 100.4556, 94.493,
              94.6678, 94.6678, 94.4985, 118.8599, 98.5792, 102.3144, 103.1271,
              103.1271, 102.9097, 102.5198, 102.4994, 102.469, 102.4995,
              102.4974, 102.5023, 102.4944, 98.0751, 98.0751, 98.0307, 98.1701,
              98.1054, 98.0381, 98.0381, 103.1271, 99.5051, 99.4961, 99.4961,
              102.3263, 104.5344, 104.5344, 100.1662, 100.1662, 102.0617,
              100.8114, 103.1689, 102.8389, 93.5166, 104.6192, 104.6428,
              105.0244, 104.4694, 100.4047, 100.7943, 100.3979, 99.4961,
              105.1371, 113.9066, 102.3263, 114.1047, 114.8777, 115.4826,
              115.4833, 116.4335, 116.8498, 115.9231, 115.9231, 116.7136,
              115.7705, 117.3048, 117.3362, 117.3028, 117.3094, 114.133,
              116.0439, 116.1101, 116.1101, 115.7132, 106.7582, 117.7051,
              117.2024, 120.0, 120.0, 119.9, 116.0566, 116.1899, 116.3975,
              116.3678, 116.1308, 116.1308, 115.4755, 115.4762, 116.4247, 116.0,
              115.3622, 115.1689, 117.094, 117.2749, 117.2024, 113.948,
              116.8639, 116.8256, 114.2857, 116.2787, 114.5991, 114.8159,
              115.0315, 116.8294, 117.7541, 116.8188, 116.0183, 115.7169,
              115.4831, 114.6402, 114.9195, 114.6296, 114.6296, 114.9932,
              115.6931, 118.0932, 116.6484, 115.4189, 115.7053, 116.7421,
              117.9633, 117.2819, 117.1278, 117.1278, 115.7009, 113.9898,
              116.8598, 120.0, 116.6513, 116.6489, 116.5533, 116.4029, 114.8165,
              117.5638, 117.5523, 117.7541, 115.5534, 117.5485, 120.0, 119.5723,
              120.2562, 117.0109, 117.6503, 119.6718, 119.6718, 119.5892,
              119.5892, 119.6859, 119.6859, 119.6859, 119.5537, 120.7055,
              120.7055, 119.604, 119.2817, 119.2339, 119.2339, 119.5174, 120.0,
              120.0, 119.2943, 119.1747, 120.3473, 120.9167, 120.9167, 120.0,
              120.0, 119.6538, 119.4326, 119.4747, 119.1415, 120.0, 119.1124,
              120.0, 119.7513, 120.0, 119.794, 119.7843, 119.0907, 119.0008,
              120.5299, 114.191, 119.4613, 117.6545, 120.0, 120.0, 120.0, 120.0,
              117.9453, 120.0, 118.3258, 119.8713, 120.0, 120.0, 120.0, 120.0,
              117.4524, 120.0, 120.5795, 120.3122, 119.7503, 120.0, 118.6222,
              120.432, 120.0, 121.7093, 118.1798, 118.1798, 118.1798, 117.9493,
              117.9493, 117.9493, 117.9493, 117.6545, 117.9843, 117.9423,
              117.9753, 119.7235, 119.9545, 120.0673, 118.4053, 121.1803,
              120.2926, 117.9673, 116.8518, 116.847, 116.5553, 105.3466,
              105.3466, 105.0863, 105.1044, 105.1044, 105.1044, 105.3435,
              106.5217, 106.6466, 106.6466, 106.547, 106.6367, 106.6466,
              106.1682, 106.6804, 106.6804, 106.6804, 105.3466, 105.3466,
              105.7961, 105.3466, 106.3706, 106.5538, 106.5454, 106.7184,
              106.5477, 106.7917, 106.7287, 106.5454, 106.6804, 106.3423,
              106.8003, 106.2081, 106.6585, 106.586, 106.8005, 106.5948,
              106.6766, 106.6696, 106.7184, 105.782, 106.6466, 106.7096,
              105.7749, 107.1138, 106.541, 106.5343, 106.4798, 107.0125,
              107.5097, 107.5097, 107.5097, 107.0467, 107.0098, 107.0049,
              107.0175, 106.5883, 106.5862, 106.6401, 112.9905, 105.9069,
              105.9069, 105.8333, 106.43, 106.2141, 105.8437, 105.9171,
              106.2817, 105.7525, 106.2817, 105.9171, 106.0577, 106.5947,
              106.1256, 105.7961, 106.219, 106.219, 106.474, 106.5543, 106.5501,
              106.219, 106.43, 106.0695, 120.3473, 106.2273, 106.0577, 123.1035,
              123.0625, 129.6011, 129.6011, 124.6303, 123.7723, 123.7723,
              123.7723, 123.7723, 123.7723, 124.8165, 122.7832, 122.8516,
              123.0875, 123.0365, 122.6429, 122.3511, 123.1035, 122.3415,
              122.3589, 123.002, 116.9364, 116.938, 115.3177, 117.103, 122.8361,
              123.7647, 123.7647, 122.8361, 122.3511, 123.5873, 122.8361,
              129.4206, 125.6925, 125.154, 123.5918, 123.5918, 123.002, 123.002,
              123.5873, 106.0632, 129.6057, 125.2199, 123.2508, 123.4142,
              122.9639, 105.3933, 105.478, 105.2624, 106.1943, 105.2698,
              105.3933, 106.0867, 106.4363, 106.304, 105.993, 105.993, 106.3023,
              106.0622, 106.0577, 121.1919, 121.1919, 121.6483, 124.3052,
              123.156, 123.156, 123.156, 123.5476, 120.9713, 121.1406, 123.4989,
              123.4989, 129.7612, 123.9242, 120.3985, 120.0402, 120.0327,
              123.3313, 119.2696, 123.4315, 120.4504, 122.4934, 122.7476, 120.0,
              115.7691, 120.0, 113.4454, 113.0704, 112.3364, 113.2383, 113.2383,
              111.9801, 113.0678, 111.844, 111.7567, 113.4697, 111.9803,
              111.9803, 112.6965, 112.4627, 112.056, 112.056, 112.056, 111.5943,
              111.6245, 111.7777, 111.4859, 112.0302, 112.5219, 112.4849,
              112.4849, 112.4849, 112.4849, 112.768, 112.4061, 112.056,
              112.4061, 112.508, 112.508, 112.3703, 111.6777, 111.6777,
              111.6777, 111.6777, 111.6777, 112.508, 112.0302, 111.1225,
              111.2526, 109.5745, 107.0411, 119.0812, 118.9388, 110.3014,
              110.3014, 110.0941, 110.0893, 110.6568, 110.9262, 110.4881,
              110.631, 110.6351, 110.6186, 110.4109, 107.0908, 108.9266,
              109.5745, 110.4105, 110.4347, 119.3448, 111.2526, 111.2526,
              111.2526, 112.1916, 112.6698, 105.6484, 105.3725, 105.3725,
              111.2526, 105.3659, 105.6461, 105.6461, 101.0604, 105.6785,
              105.6509, 105.6528, 106.7307, 105.6528, 105.66, 108.5196,
              112.0302, 112.7296, 114.6452, 112.8823, 115.0782, 114.8936,
              114.8967, 114.8967, 113.4753, 113.5277, 113.5277, 113.3652,
              113.3775, 113.4761, 120.0, 113.9942, 115.1177, 115.1202, 112.5381,
              114.6452, 114.485, 114.8496, 114.8496, 114.1208, 113.7674,
              113.8204, 113.9501, 113.8835, 113.6447, 113.6447, 113.833,
              112.8455, 112.4188, 113.1281, 111.6486, 111.6486, 111.7564,
              111.7564, 115.5553, 115.0159, 114.803, 113.0092, 112.0302,
              112.9059, 112.5028, 113.9667, 114.0291, 114.0291, 111.447,
              115.117, 115.117, 115.117, 112.2527, 112.2527, 112.3485, 110.0431,
              110.3528, 110.7495, 112.7666, 113.3652, 111.7547, 113.2504,
              113.8939, 113.5156, 113.4926, 113.4369, 112.5832, 112.5832,
              112.273, 112.9716, 113.2878, 113.2785, 113.2785, 113.2878,
              112.9059, 113.5038, 113.1616, 114.4775, 114.9905, 115.7169,
              115.6238, 113.4369, 113.4369, 113.4369, 113.5038, 107.39,
              113.5319, 106.7016, 106.9991, 106.4544, 106.7009, 106.6784,
              106.9854, 118.9238, 114.2016, 110.9711, 106.8431, 106.7438,
              106.7431, 106.8377, 106.7471, 107.0011, 106.7428, 106.8192,
              113.0797, 106.9856, 112.6406, 108.226, 122.0698, 111.7579,
              112.6351, 112.6878, 122.8255, 122.8255, 122.8255, 121.3161,
              121.0477, 122.1078, 120.6582, 120.6582, 110.5738, 110.5181,
              110.3986, 111.259, 121.5862, 110.8317, 108.9195, 112.6406,
              113.0644, 112.5085, 118.2726, 121.3091, 122.9339, 122.0851,
              111.3576, 120.8487, 120.9125, 120.9115, 120.9112, 121.3054,
              120.9112, 120.9112, 112.5778, 112.5778, 116.1779, 119.4302,
              106.7016, 116.0482, 116.0789, 115.8418, 115.8161, 113.9443,
              113.9443, 111.7557, 111.7557, 111.7063, 111.7063, 113.9373,
              122.0927, 111.7061, 110.1789, 108.9198, 108.2366, 108.5256,
              108.5254, 108.5252, 108.0922, 108.0922, 114.5624, 110.2068,
              113.3049, 115.8597, 113.4697, 106.6153, 107.0068, 107.0132,
              107.0621, 107.0033, 107.0033, 108.8497, 108.8497, 108.8497,
              108.8497, 108.8497, 108.8497, 108.8497, 108.8497, 108.8497,
              109.7163, 107.0797, 110.4347, 110.0635, 109.8345, 109.8345,
              106.7016, 112.9324, 106.7016, 106.9845, 107.4126, 112.6889,
              113.0511, 109.9797, 108.7544, 120.2383, 119.0068, 119.0068,
              119.2712, 119.2723, 118.0557, 116.5146, 109.888, 109.8345,
              120.3797, 107.087, 120.0, 112.0619, 117.3773, 119.5963, 119.6559,
              119.9703, 119.6552, 121.5181, 121.8524, 121.8524, 123.618,
              122.7522, 112.5686, 124.489, 120.6572, 120.6698, 118.9976,
              126.4751, 111.9443, 113.208, 121.7842, 122.3478, 108.2998,
              121.8412, 110.236, 111.9449, 110.0293, 109.9844, 106.898,
              109.9529, 106.7013, 106.7013, 113.3844, 111.5334, 119.6162,
              112.2668, 111.2992, 111.3563, 111.2992, 111.3563, 111.7353,
              -73.355, -75.572, -73.4999, -72.4052, -74.5883, -74.5951,
              -75.5034, -75.7323, -72.9088, -72.4052, -74.401, -72.4052,
              -75.1916, -76.2967, -74.004, -74.004, -75.0931, -72.9088,
              -75.1916, -75.0931, -74.004, -72.9088, -76.4838, -72.9002,
              -74.7568, -75.0931, -74.9774, -75.6988, -75.4522, -72.4052,
              -74.8137, -72.4052, -72.9088, -72.9088, -72.9088, -73.2547,
              -75.4167, -74.004, -72.9088, -72.9088, -74.4893, -76.2967,
              -74.6457, -74.8892, -75.0095, -75.5731, -72.9088, -75.4522,
              -72.4052, -72.9088, -75.572, -73.0514, -72.9088, -72.4052,
              -72.9088, -73.0845, -73.0845, -72.9088, -75.572, -73.5499,
              -74.8981, -72.4052, -75.4522, -72.4052, -73.1386, -74.1821,
              -74.7614, -72.4052, -72.9088, -75.6988, -75.6988, -75.6988,
              -75.6988, -75.6988, -76.4841, -72.9088, -76.4995, -75.6988,
              -72.9088, -72.9088, -72.9088, -73.72, -72.9088, -75.9722,
              -72.9088, -74.1617, -73.9488, -73.1386, -72.9088, -76.2967,
              -72.9002, -72.9002, -74.7568, -74.004, -75.489, -72.9088,
              -72.9088, -75.572, -73.1386, -73.1386, -73.1386, -73.1386,
              -75.4458, -72.9088, -75.0095, -75.0095, -73.1386, -76.5682,
              -76.0717, -76.2967, -75.0095, -72.9088, -75.572, -72.9088,
              -75.5034, -68.1874, -73.898, -73.5222, -72.9088, -74.7614,
              -72.9088, -72.4052, -72.4052, -72.9088, -73.355, -75.734,
              -74.7826, -74.7568, -75.2425, -76.9808, -75.3802, -74.7008,
              -74.7568, -72.9088, -75.9141, -72.4052, -72.4719, -72.4719,
              -72.4719, -75.0095, -75.3989, -72.9088, -76.3879, -73.5021,
              -73.5021, -75.4167, -75.572, -73.4918, -73.9612, -74.6457,
              -72.9002, -75.7876, -73.6889, -74.7568, -72.4719, -74.7614,
              -72.9088, -72.4052, -72.4052, -75.1916, -75.9141, -72.9088,
              -75.0016, -72.9088, -73.4806, -72.9088, -76.3877, -75.3989,
              -75.0016, -73.9488, -72.9088, -75.0016, -75.3989, -74.9774,
              -74.2154, -75.0016, -75.0016, -75.0016, -75.0016, 16.4518, 15.584,
              16.4516, 17.1159, 16.1725, 16.7001, 17.0119, 16.5479, 16.1224,
              17.0119, 15.5061, 15.6634, 16.4494, 15.3512, 15.5766, 15.3655,
              16.7087, 16.6959, 15.3572, 15.584, 15.2777, 16.7002, 15.6556,
              15.4227, 16.9027, 15.584, 17.8897, 15.5903, 16.7823, 16.7825,
              16.1149, 15.5766, 16.4025, 16.4415, 14.1595, 16.7596, -82.7856,
              -80.8329, 16.6909, 14.5802, 14.3236, -6.7463, -7.6818, -6.4486,
              -5.4689, -5.8284, -5.1976, -5.651, 15.3126, 15.3126, 25.4701,
              25.2057, 8.6765, 9.195, 9.8511, 11.4452, 10.4116, 9.9735, 10.3333,
              10.3333, 10.3333, 11.706, 11.8166, 8.4734, 11.0705, 8.428, 9.0259,
              11.1373, 9.8487, 9.9449, 8.219, 11.9023, 42.8453, 42.8453,
              42.8453, 42.8453, 42.8453, 42.8453, 42.8453, 42.8453, 42.8453,
              42.8453, 42.8453, -70.4414, -71.1249, -70.1964, -69.8428,
              -69.6667, -69.79, -69.9057, -69.7875, -71.3809, -71.3809,
              -70.3028, -69.9057, -70.3712, -78.0647, -78.2655, -80.2716,
              -79.9403, -78.234, -80.862, -78.1378, -79.35, -78.4496, -80.0772,
              -78.237, -78.4496, -79.3667, -79.8053, -80.228, -79.2242, -80.815,
              -79.6517, -79.35, -79.35, -78.0284, -80.6556, 32.7433, 32.7433,
              32.7433, 32.7433, 32.7433, 32.7433, 32.8959, 32.8959, 32.7433,
              32.7433, 32.7433, 32.7433, 32.7433, 32.7433, 32.7433, 29.0576,
              32.8959, 32.7938, 32.7938, 32.7938, 32.7433, 32.7433, 32.7433,
              32.7433, 32.7433, 32.7433, 31.7456, 32.33, 32.95, 32.8401,
              32.7433, 32.7433, 32.7433, 32.7433, 32.6598, 30.6835, 30.6835,
              34.7075, 25.5154, 32.4239, 32.7433, 32.4239, 32.7433, 29.2675,
              31.7456, 32.7433, 32.7433, 32.7433, 32.7433, 32.7433, 32.7433,
              33.7608, 32.7433, -89.011, -88.5391, -88.5391, -89.814, -89.005,
              31.1882, 37.3883, 40.9612, 38.6521, 39.6002, 45.538, 28.1599,
              25.9209, 3.5269, 0.2538, 5.4135, 5.4135, 3.9655, 5.817, 2.9094,
              5.7439, 3.6166, 0.05, 6.8238, -0.9515, -0.0565, -0.871, 5.9826,
              5.9826, 5.9826, -0.9557, 5.8572, -0.6371, 4.9161, 5.822, 2.9463,
              1.8019, -0.0127, 6.0329, 1.1023, -0.8077, 3.2674, 3.2674, 6.1926,
              -0.5492, -53.7389, 9.5315, 9.5315, 11.8219, 9.5315, 13.5895,
              43.4193, 12.285, 12.5481, 12.1757, 12.5283, 14.5296, 13.1148,
              14.077, 13.6011, 10.5045, 14.305, 9.485, 9.3517, 12.4428, 10.4234,
              12.4662, 14.5299, 12.776, 12.7168, 13.6881, 11.9518, 10.4234,
              10.4234, 8.1552, 14.2391, 12.5167, 8.2334, 13.6975, 12.4571,
              13.7115, 9.2265, 13.7074, 7.5919, 12.45, 12.5445, 10.4127, 14.958,
              11.2762, 11.279, 11.2822, 11.2449, 13.9795, 13.9795, 13.9795,
              11.8308, 12.7574, 11.6569, 14.4084, 13.2125, 13.6721, 12.6526,
              9.8956, 13.6901, 13.7009, 13.6917, 13.3322, 12.3483, 13.7074,
              14.1133, 14.253, 13.532, 9.8019, 13.7501, 14.632, 13.7282,
              14.0935, 12.2438, 13.687, 12.2689, 7.082, 14.1894, 12.2371,
              14.3943, 12.0561, 11.2421, 14.3176, 14.5232, 12.3038, 12.4954,
              13.7903, 13.2225, 14.363, 12.4492, 12.385, 14.095, 11.5226, 12.2,
              11.9636, 13.8925, -1.7473, -1.7685, -1.0439, -1.08, -0.8227,
              -0.7024, -0.3306, -1.08, -0.6784, -0.848, -2.4881, 0.11, -0.6933,
              -0.559, -2.2363, -1.08, -2.2363, -2.2363, -2.2363, -2.4518,
              -0.8487, -2.4548, -2.2363, 22.3016, 22.3016, 22.6516, 22.5438,
              21.162, 21.162, 21.8758, 21.8692, 25.5184, 21.8684, 22.7967,
              22.1171, 22.6264, 22.7236, 21.7245, 22.3016, 22.187, 22.4106,
              22.0574, 24.824, 22.6685, 21.6754, 21.6779, 22.5104, 22.6259,
              22.157, 22.6951, 22.6562, 23.021, 23.0039, 22.3593, 22.4087,
              22.517, 22.1947, 22.0934, 22.1861, 22.272, 22.4541, 22.3016,
              23.4671, 22.1147, 22.6923, 22.6875, 22.693, 21.1347, 21.9055,
              22.4498, 23.1051, 23.6763, 22.0657, 21.9563, 22.5333, 20.7707,
              22.6896, 22.2205, 22.0573, 21.6505, 20.7182, 22.9537, 22.9599,
              22.7013, 24.8732, 24.0702, 22.199, 24.8117, 24.8221, 21.3653,
              21.3653, 22.3191, 21.6389, 22.2125, 22.6909, 22.6812, 22.5393,
              22.1842, 21.9369, 22.4397, 22.7274, 22.4986, 22.7, 22.489,
              21.7809, 20.8553, 22.0852, 20.8841, 20.9035, 21.68, 22.3914,
              21.6751, 22.7795, 25.3288, 22.5082, 22.0221, 21.6382, 22.1757,
              23.9209, 22.9322, 20.6772, 22.3424, 22.2233, 22.479, 22.376,
              22.3153, 22.789, 22.624, 22.4837, 23.3922, 26.1157, 21.6842,
              21.8793, 21.8862, 21.63, 22.4071, 21.806, 22.9249, 21.1065,
              21.8354, 22.5118, 22.1887, 22.1284, 20.6099, 24.8012, 22.9192,
              21.7522, 21.8313, 20.5125, 22.5459, 20.9591, 22.963, 21.5611,
              23.5604, 25.7125, 20.7663, 22.8232, 22.4193, 22.9708, 21.6508,
              22.1613, 21.6603, 23.3567, 25.6879, 20.5352, 23.541, 21.7682,
              23.2338, 22.7587, 21.0459, 21.8057, 22.6716, 21.6673, 22.6485,
              22.3859, 21.6781, 21.4964, 20.9051, 22.5735, 22.1369, 22.1541,
              22.6842, 21.6506, 21.6729, 22.6009, 20.9041, 22.552, 21.4964,
              22.3657, 22.7899, 21.9216, 22.0464, 23.38, 22.2656, 23.7184,
              21.1148, 26.1396, 21.1552, 22.3245, 21.6594, 21.9704, 21.116,
              22.2361, 23.0908, 22.3472, 22.5447, 21.6392, 22.5001, 21.7895,
              21.9254, 23.934, 21.6684, 22.3358, 23.0559, 21.7149, 22.7693,
              21.9689, 25.6495, 22.6881, 22.4552, 21.562, 21.5538, 21.6627,
              22.4244, 25.3841, 22.721, 22.2208, 23.9869, 22.7438, 22.3486,
              22.4161, 22.4161, 22.3289, 22.4336, 22.5953, 21.6376, 22.5303,
              21.6543, 20.7668, 22.4094, 22.3793, 22.4128, 22.3372, 22.2427,
              22.8835, 23.2575, 22.1107, 26.2832, 21.6902, 21.1242, 23.9508,
              23.2368, 21.6267, 21.6391, 22.8249, 22.684, 22.7639, 23.4131,
              21.6588, 23.3975, 22.4979, 22.4872, 22.5162, 22.5164, 22.1573,
              23.4131, 22.6368, 23.5964, 22.6058, 22.5541, 22.0232, 21.6192,
              21.9491, 23.3176, 22.4789, 22.5242, 22.2181, 21.3322, 21.0281,
              21.364, 21.5484, 22.7239, 21.4285, 22.2146, 20.8303, 22.6068,
              21.636, 22.1813, 22.4642, 22.4274, 21.5813, 23.4524, 22.5147,
              22.5566, 23.4877, 23.5055, 22.1736, 21.5807, 22.6756, 21.6951,
              22.5984, 22.1625, 22.4379, 22.1008, 22.0897, 22.1638, 21.2089,
              21.7982, 21.7056, 21.7726, 22.7993, 21.6999, 21.7618, 22.128,
              22.2436, 22.6828, 22.2472, 21.5726, 22.9641, 22.7913, 21.7827,
              21.8691, 21.8663, 23.2269, 23.222, 22.4573, 22.0639, 23.0764,
              22.7811, 22.575, 22.575, 22.5779, 22.572, 22.4087, 22.2784,
              22.4568, 21.7928, 22.5741, 22.2318, 24.116, 21.6333, 21.5901,
              21.5866, 22.5024, 22.3995, 20.6926, 22.3798, 22.5788, 22.0697,
              22.3182, 25.5781, 20.7707, 22.4303, 22.7505, 22.3413, 20.4953,
              22.3294, 23.0749, 25.5933, 21.9785, 21.7366, 21.3618, 26.4723,
              22.7797, 22.7715, 22.7881, 22.7828, 22.7831, 22.4814, 22.6497,
              22.7727, 22.2992, 21.7388, 22.3438, 21.6764, 22.5157, 22.2066,
              22.1096, 22.2231, 21.6777, 21.6655, 23.7353, 22.5012, 22.7434,
              23.3234, 21.7457, 21.0658, 21.858, 22.6774, 22.8756, 21.5919,
              21.8143, 22.1018, 22.2441, 22.5281, 22.5362, 24.7092, 21.0865,
              22.1836, 22.006, 22.7077, 22.6417, 21.611, 22.5449, 22.5362,
              22.5221, 22.5234, 22.0118, 22.2246, 22.6225, 21.0436, 24.8884,
              22.4912, 22.9785, 23.187, 22.7539, 22.7509, 22.7584, 26.0952,
              22.7547, 22.5978, 22.5874, 22.7708, 22.6962, 22.4351, 22.78,
              22.5288, 22.7618, 21.766, 21.8022, 20.4412, 21.0436, 21.0436,
              21.0436, 21.6635, 22.3548, 23.5356, 22.5393, 21.989, 22.0927,
              22.1194, 22.8172, 22.8346, 22.9013, 22.7393, 22.4195, 21.7408,
              23.7447, 23.56, 22.7026, 21.6226, 21.8538, 21.6524, 22.5495,
              22.2149, 22.0689, 22.745, 22.7385, 23.9288, 23.9806, 23.987,
              24.0058, 24.5494, 20.9442, 22.4984, 21.6665, 22.2325, 22.1965,
              22.6132, 22.5931, 23.0877, 23.0894, 22.8188, 21.6504, 22.71,
              22.5352, 23.9993, 22.5026, 21.5902, 22.3804, 22.6612, 22.6585,
              23.5096, 22.4337, 24.0189, 22.7991, 25.6678, 22.3358, 22.1962,
              21.0895, 22.6737, 24.0589, 22.4002, 22.2895, 21.9209, 21.9378,
              21.9213, 25.9732, 21.8892, 23.4947, 22.5583, 21.6823, 23.4822,
              21.7492, 22.4852, 24.0523, 22.2666, 21.745, 22.6066, 22.5575,
              22.7114, 21.6158, 22.5414, 21.9306, 21.9483, 21.9393, 21.128,
              21.6888, 22.0137, 21.978, 21.9795, 22.4523, 21.8582, 21.6207,
              21.6404, 23.5636, 22.5536, 22.2566, 21.0319, 22.133, 22.2494,
              22.2468, 21.7411, 23.5473, 21.6139, 22.5517, 23.9077, 22.5135,
              24.8014, 22.3458, 22.5694, 22.577, 22.5791, 22.5612, 22.5613,
              22.5949, 22.5824, 22.5612, 21.2278, 144.7576, 144.8615, 144.655,
              144.8338, 144.7487, 144.7487, -90.3544, -90.3544, -13.9441,
              -13.9441, -12.4399, -14.9, -72.1975, -72.6784, -72.3389, 12.3172,
              12.4548, -87.5523, -88.2027, -87.2141, -87.2676, -87.1096,
              -87.2534, -87.5544, -87.5544, -87.5503, -87.143, -87.5503,
              -87.3327, -87.2285, -87.2299, -87.2141, 114.0452, 113.917,
              113.9217, 18.8215, 19.798, 17.0229, 17.8432, 21.237, 20.063,
              20.8833, 19.8386, 20.707, 16.8338, 18.906, 77.5341, 81.56,
              81.5882, 77.5341, 76.7749, 75.1834, 77.5341, 77.5341, 77.5341,
              81.5613, 77.7303, 76.5688, 75.3872, 75.3872, 75.3872, 77.5341,
              76.6955, 75.0818, 75.1342, 76.0653, 74.2983, 74.2983, 76.6029,
              76.6029, 76.6029, 74.4423, 76.6029, 77.7258, 76.6167, 77.7258,
              76.9382, 74.7451, 75.6221, 75.6457, 75.7787, 73.849, 74.858,
              73.849, 74.6016, 75.1623, 75.1623, 75.5259, 76.2128, 74.4789,
              79.519, 74.3343, 75.5259, 75.5259, 76.0603, 79.0458, 79.0458,
              73.849, 77.4101, 75.1623, 78.7451, 76.2154, 77.4607, 77.4607,
              77.4607, 77.4607, 74.3529, 74.5873, 75.9141, 75.9141, 73.849,
              74.3343, 76.1032, 75.9141, 73.849, 73.6647, 73.6647, 93.6475,
              83.483, 83.0, 84.3213, 83.3035, 85.5974, 82.7889, 75.8485,
              75.6915, 74.9349, 74.9349, 74.6106, 75.489, 75.489, 77.3999,
              75.4943, 77.4607, 77.4607, 76.5779, 77.0197, 77.4101, 77.7258,
              78.7451, 75.5565, 77.4941, 78.1121, 76.5, 75.367, 76.9144,
              77.1321, 77.7258, 77.099, 77.0968, 77.0968, 77.0968, 76.6681,
              77.7258, 76.893, 75.6975, 77.7258, 77.7258, 77.3545, 77.3545,
              77.3545, 77.3545, 77.7258, 77.4607, 77.4607, 77.7258, 78.0543,
              76.4039, 73.4334, 72.776, 72.7603, 72.7603, 72.196, 72.196,
              70.3657, 73.4334, 71.211, 71.206, 71.2088, 71.189, 71.205, 71.197,
              71.233, 71.215, 73.4334, 71.1935, 71.1948, 71.184, 71.1948,
              71.1948, 71.214, 71.1812, 71.217, 71.6685, 69.0229, 73.4334,
              81.2892, 73.4334, 73.4334, 73.4334, 73.1137, 71.2815, 71.2815,
              72.4311, 71.4664, 71.4664, 71.4664, 73.4334, 86.1851, 76.5689,
              75.5798, 75.7224, 74.8569, 77.7258, 75.6975, 83.5, 77.1622,
              75.5778, 75.6215, 75.4858, 77.7258, 77.7258, 71.2815, 71.2815,
              71.2815, 70.75, 69.0112, 69.7298, 69.6126, 71.7453, 72.6869,
              76.3177, 81.0877, 84.9996, 93.9716, 80.1864, 78.2817, 78.0542,
              78.0542, 78.2817, 78.2817, 78.2817, 78.462, 78.4357, 78.4357,
              78.4357, 78.4357, 78.462, 78.462, 79.0521, 78.4427, 78.4281,
              78.4281, 75.402, 78.0543, 78.462, 78.462, 79.2128, 79.2128,
              78.5303, 77.2698, 92.7402, 75.992, 76.8404, 77.4209, 78.4281,
              77.7258, 78.0422, 78.2817, 93.9716, 77.5947, 78.2817, 78.78,
              77.71, 83.1151, 78.2817, 78.2817, 78.2817, 78.2817, 77.5006,
              77.5006, 77.5006, 78.5303, 78.2817, 79.5979, 78.2901, 78.2901,
              78.0422, 78.2823, 78.2573, 78.277, 78.277, 78.289, 78.2867,
              78.2867, 78.2867, 78.2867, 78.2867, 78.5303, 78.2901, 76.6985,
              70.9197, 76.6985, 77.95, 77.966, 78.9246, 78.8475, 78.5986, 78.3,
              77.93, 78.5986, 77.81, 77.81, 78.5986, 78.3951, 78.0757, 78.0066,
              77.8142, 78.5986, 79.1152, 80.3217, 77.5552, 78.5986, 79.515,
              79.515, 80.0546, 80.912, 78.5986, 79.5112, 76.6985, 78.5986,
              78.6884, 77.9523, 77.9523, 77.9988, 77.9988, 77.9988, 77.9988,
              77.9988, 77.9988, 77.9988, 78.5986, 78.5986, 78.5986, 78.5986,
              78.473, 78.5744, 79.4878, 80.818, 78.6501, 79.2677, 79.1796,
              79.1796, 78.5986, 79.2677, 77.9923, 79.8555, 79.3577, 79.5398,
              79.4277, 77.7258, 75.588, 77.5351, 77.7258, 77.7258, 76.2329,
              77.7258, 76.1582, 75.6676, 76.3073, 77.7258, 77.7258, 77.7258,
              77.7258, 77.7258, 77.7258, 77.7258, 77.7258, 77.1236, 77.7258,
              75.2333, 76.8192, 77.7258, 77.2337, 77.7258, 75.3549, 78.9418,
              77.3159, 77.4607, 79.4277, 79.6058, 77.5081, 78.6059, 79.6154,
              79.705, 81.8495, 78.9833, 79.0546, 79.705, 79.705, 79.705,
              81.8495, 83.0053, 78.7464, 81.8495, 81.8495, 81.8495, 82.3619,
              80.9485, 77.7364, 77.755, 87.3193, 87.3193, 77.4607, 77.4607,
              77.9851, 79.5112, 79.4135, 77.9523, 73.3171, 75.8589, 71.1983,
              75.3612, 75.3612, 73.059, 72.2547, 70.9104, 70.9104, 70.9104,
              72.0083, 72.0068, 70.9104, 73.7685, 73.0355, 73.0355, 73.0355,
              73.31, 73.31, 71.9965, 75.8589, 73.732, 75.8589, 72.224, 71.9306,
              71.9306, 76.6985, 76.6985, 71.0931, 71.7473, 75.8589, 72.3532,
              72.3532, 72.3532, 72.3532, 72.3532, 72.2459, 71.9306, 71.9306,
              71.9306, 71.9306, 71.9306, 71.9306, 71.9306, 71.9306, 71.9306,
              71.9306, 71.9306, 71.9306, 71.9306, 72.6464, 73.3171, 77.739,
              73.0355, 77.9851, 77.9851, 78.0231, 77.9851, 78.3939, 78.3939,
              78.3939, 78.3939, 78.3939, 77.9851, 77.9045, 77.7723, 78.3665,
              77.739, 79.4916, 79.4916, 77.5972, 77.9851, 77.9851, 77.5183,
              77.5183, 78.8293, 75.8589, 77.9523, 72.23, 73.0355, 77.9851,
              75.8589, 75.8589, 72.1623, 72.1623, 72.365, 75.8589, 75.8589,
              75.8589, 74.7801, 75.8589, 71.9198, 72.365, 75.8589, 75.8589,
              75.8589, 75.8589, 75.8589, 75.8589, 72.365, 75.8589, 115.2704,
              104.0631, 108.1781, 112.238, 120.5982, 104.7308, 100.3965,
              108.1781, 100.3965, 109.5734, 114.6488, 108.1781, 109.354,
              104.7308, 115.1732, 57.0477, 48.9986, 57.0477, 57.0477, 57.0477,
              50.3585, 57.4235, 57.0477, 57.3253, 54.338, 51.4833, 57.0477,
              57.0477, 52.2427, 43.3078, 44.175, 43.1167, 47.15, 45.5374,
              44.0249, 45.8243, 44.35, 45.933, 44.336, 44.175, 43.3078, 43.9105,
              44.175, 42.0, 43.9099, 45.5374, 45.5374, 47.8, 42.0, -6.7444,
              -7.9284, -6.4577, -6.3722, -8.1671, -6.8034, -8.5511, 34.5398,
              34.7548, 34.8353, 34.7594, 35.0595, 34.4556, 35.0366, 34.7475,
              34.7475, 35.0293, 34.7099, 8.968, 11.5706, 11.9884, 14.4885,
              8.9611, 8.561, 16.4027, 16.4789, 11.9884, 12.163, 9.0991, 15.3052,
              11.656, 15.3052, 11.5717, 7.9235, 12.1638, 10.6176, 16.5187,
              16.7659, 11.5717, 12.6743, 12.6743, 8.9855, 8.9855, 12.4733,
              12.6601, 11.7167, 14.2563, 8.321, 12.4733, 15.027, 17.932,
              13.5462, 11.5933, 15.3712, 15.3712, 15.3776, 11.5717, 16.3752,
              -77.3091, -77.3948, -77.3948, -77.3948, -77.3948, -78.1023,
              -77.2719, 141.8021, 141.6864, 141.1859, 141.7688, 131.3712,
              140.1676, 140.8967, 133.8508, 140.1676, 136.2317, 144.2964,
              140.0717, 139.2555, 140.7243, 140.3354, 141.0121, 140.1876,
              141.3601, 143.4258, 131.3193, 130.4209, 130.7624, 137.6075,
              131.411, 140.236, 133.2419, 140.2665, 129.912, 131.6793, 138.65,
              140.8967, 133.1248, 141.007, 140.8881, 141.7931, 140.8904,
              131.2283, 140.8301, 135.5136, 141.0808, 139.5913, 129.4387,
              131.2213, 135.9265, 141.4201, 140.9582, 140.982, 141.7209,
              141.643, 133.296, 130.7773, 135.0989, 135.5674, 131.7275,
              131.1769, 130.8664, 133.6914, 131.4735, 140.0491, 136.5259,
              138.9986, 135.099, 140.8796, 140.9094, 130.9403, 141.0782,
              140.8967, 140.4464, 130.7244, 144.4377, 137.2855, 137.244,
              137.2684, 140.8569, 140.842, 140.7134, 132.4053, 130.771, 135.843,
              133.445, 136.5125, 139.5913, 140.9169, 130.9484, 140.0001,
              130.7182, 141.9301, 139.9103, 139.9752, 138.971, 139.9548,
              141.017, 140.8569, 141.421, 141.421, 141.4608, 130.8522, 141.1161,
              140.1726, 140.2042, 141.3741, 137.225, 130.526, 130.701, 131.134,
              140.2622, 130.4527, 138.6947, 131.1813, 140.9231, 132.0891,
              132.2226, 140.818, 135.5674, 140.2875, 140.5614, 140.0501,
              141.3619, 138.4835, 138.5398, 138.5398, 139.1262, 131.7147,
              138.9504, 140.643, 140.8796, 140.0931, 136.5929, 140.4442,
              138.0586, 141.1386, 140.2876, 131.3762, 131.5929, 131.7147,
              130.4183, 141.9461, 140.9621, 141.6756, 140.353, 140.3832,
              141.0043, 140.8967, 135.9265, 130.809, 130.844, 136.7542,
              140.3201, 131.2453, 134.6144, 140.4504, 134.0483, 133.8254,
              143.9643, 135.8527, 140.291, 130.4361, 141.1001, 140.2541,
              134.159, 130.7182, 140.586, 131.4168, 140.8967, 133.9765,
              134.2688, 137.2515, 133.8994, 137.1564, 134.7348, 140.2587,
              140.9831, 141.4861, 130.4748, 141.4398, 141.3249, 140.7936,
              130.0102, 139.823, 138.3505, 135.1979, 135.1979, 138.65, 139.5913,
              139.61, 142.8881, 141.2167, 141.2124, 141.1464, 141.2202,
              140.7022, 140.7177, 133.1122, 134.3774, 140.9715, 136.36,
              141.6816, 141.7185, 130.4048, 131.5514, 131.445, 140.8838,
              140.536, 138.893, 140.0718, 140.1794, 130.7277, 139.8945,
              139.8916, 135.8527, 140.8967, 140.8967, 140.436, 131.1204,
              140.6156, 140.7161, 139.0579, 131.7196, 131.2202, 140.3706,
              131.7593, 141.353, 144.1894, 143.4746, 134.922, 140.7195,
              138.4768, 130.8156, 139.9781, 141.9345, 134.3774, 135.911,
              134.1574, 139.0579, 144.6639, 141.376, 138.8872, 140.6199,
              135.0989, 139.0119, 130.4762, 134.9789, 140.8967, 140.6688,
              36.9416, 35.7035, 35.8151, 36.202, 36.2928, 35.613, 35.8703,
              36.9416, 35.8262, 35.3498, 36.3242, 36.1001, 35.261, 36.0805,
              35.7035, 36.202, 35.628, 36.0, 35.7991, 35.8149, 37.1222, 35.8151,
              36.0, 35.8151, 35.8147, 36.1017, 36.1269, 36.9416, 35.8151,
              35.8151, 68.2738, 69.366, 69.366, 72.8722, 69.366, 53.1681,
              68.2738, 67.4951, 81.187, 69.366, 65.2093, 69.366, 71.4694,
              71.373, 73.7608, 72.8558, 72.8558, 49.4397, 63.3209, 69.366,
              70.8203, 70.823, 68.2738, 64.6775, 74.3351, 68.2738, 68.2738,
              50.5759, 68.2738, 61.6612, 65.2093, 69.366, 35.3537, 37.4584,
              38.4314, 39.7446, 39.6429, 38.3728, 34.2001, 36.8258, 36.9656,
              34.7779, 35.5644, 37.5888, 35.1245, 39.6065, 35.3601, 35.4032,
              20.9021, 20.9021, 47.0624, 47.0624, 47.71, 47.4979, 47.0624,
              47.0624, 47.0624, 47.0624, 73.6806, 106.4725, 104.9523, 27.2472,
              28.335, 27.2472, -10.6482, 18.1237, 18.1237, 47.445, 47.445,
              34.2771, 34.105092286969, 35.2651, 34.5966478998643, 34.4213,
              33.5843, 103.1229, 101.6111, 103.3984, 100.6718, 100.624,
              100.5981, 100.6718, 103.336, 103.3984, 100.4842, 103.876,
              100.4285, 100.6094, 101.0774, 100.4524, 103.8134, 100.7443,
              116.1213, 100.647, 103.7404, 103.0817, 103.5127, 100.4842,
              116.8309, 100.624, 100.6345, 101.2872, 100.2967, 100.2967,
              103.0819, 102.2829, 102.2829, 103.3596, 101.164, 101.5274,
              100.419, 101.4909, 100.9798, 100.6487, 101.5949, 102.3499,
              101.7812, 100.5352, 101.7442, 73.5012, -9.1913, -9.5178, -11.2058,
              -8.1615, -5.8328, -6.0699, -4.6659, -4.6659, -6.2176, -15.9842,
              -15.8907, -16.0214, -108.15, -109.468, -104.772, -110.987,
              -108.15, -116.057, -100.861, -101.001, -111.115, -100.848,
              -112.66, -110.811, -105.174, -106.44, -110.308, -101.305,
              -107.562, -101.386, -111.656, -106.853, -110.987, -110.987,
              -103.495, -102.076, -102.076, -112.66, -101.552, -101.045,
              -101.909, -116.594, -101.945, -98.1948, -98.3534, -109.468,
              -104.658, -104.658, -104.658, -103.299, -104.561, -101.45,
              -101.45, -101.45, -101.719, -88.9276, -116.594, -101.552,
              -89.5822, -101.45, -101.524, -111.243, -103.317, -98.5769,
              -102.254, -101.904, -110.987, -102.5, -101.554, -97.2428,
              -112.731, -100.074, -102.41, -101.552, -98.1701, -101.552,
              -104.462, -104.462, -100.468, -100.468, -111.943, -112.708,
              -102.134, -102.134, -101.878, -101.001, -89.9435, -106.752,
              -89.5543, -89.5543, -104.921, -102.5, -102.001, -101.715, -104.63,
              -106.452, -106.47, -92.5747, -100.931, -103.051, -103.051,
              -99.2472, -104.014, -102.517, -104.151, -104.462, -101.552,
              -104.462, -108.15, -101.904, -101.904, -99.0825, -104.657,
              -102.008, -108.15, -99.0135, -108.15, -99.1452, -108.15, -102.008,
              -104.658, -107.385, -107.385, -110.987, -104.657, -98.1701,
              -103.51, -102.008, -107.385, -108.15, -110.987, -98.1701, -108.15,
              -108.15, -108.15, -101.045, -103.51, -101.904, -102.563, -105.384,
              -100.727, -100.032, -99.7585, -110.326, -105.164, -88.8585,
              -109.393, -110.352, -109.468, -101.724, -111.44, -110.713,
              -112.055, -112.055, -103.704, -106.476, -102.705, -105.076,
              -105.073, -100.322, -100.52, -91.8403, -101.438, -102.008,
              -101.045, -101.045, -101.022, -101.438, -99.0742, -109.544,
              -105.819, -112.161, -107.615, -102.215, -104.657, -109.055,
              -106.514, -106.514, -106.514, -106.514, -106.514, -107.997,
              -107.997, -107.997, -107.997, -97.3242, -112.055, -102.317,
              -102.317, -103.171, -88.7937, -110.987, -110.987, -110.987,
              -110.987, -101.592, -110.987, -110.326, -102.563, -99.7884,
              -111.094, -100.592, -100.592, -103.239, -102.317, -111.386,
              -107.996, -103.442, -104.921, -110.987, -100.075, -100.71,
              -110.951, -101.131, -103.308, -103.444, -99.6545, -101.715,
              -111.503, -112.682, -102.273, -103.434, -109.505, -106.487,
              -105.46, -102.175, -104.658, -97.5922, -115.27, -110.987, -115.27,
              -92.1485, -103.38, -102.185, -88.1541, -99.0801, -104.921,
              -100.501, -112.157, -107.502, -109.94, -102.243, -102.874,
              -111.0394, -108.99, -102.008, -105.679, -100.949, -99.9772,
              -101.045, -99.3437, -88.1541, -101.674, -99.8978, 106.3328,
              108.3706, 109.7784, 19.2631, 19.2135, 19.2135, -11.0873, -7.3362,
              -7.3362, -3.9102, -7.9101, -8.0379, -3.0493, -2.0324, -9.1242,
              -10.0316, -7.405, -6.0365, -5.371, -6.3965, -2.0258, -4.7101,
              -10.0667, -6.8626, -6.8696, -6.8704, -6.8306, -9.5964, -7.3362,
              -7.3362, -8.4277, -8.877, -4.7101, 37.0318, 40.7061, 40.5294,
              36.467, 31.5573, 35.2459, 35.2459, 34.8655, 36.5062, 36.467,
              94.6828, 96.1284, 96.0, 95.083, 95.2405, 96.1284, 96.0, 95.305,
              94.6854, 96.0, 94.6854, 95.2577, 96.0, 96.0, 96.3476, 96.0,
              98.1603, 96.1103, 96.0, 95.847, 94.6854, 96.0, 96.1284, 96.1103,
              96.0, 96.0, 96.1179, 96.1103, 96.0, 96.1103, 95.0138, 96.1284,
              95.0367, 95.6641, 14.964, 17.3231, 18.0272, 16.0207, 17.087,
              18.0719, 85.1151, 6.7672, 6.6368, 6.568, 4.5649, 6.6368, 6.4701,
              4.2334, 5.9735, 6.4339, 6.6368, 6.6368, 3.7028, 6.1512, 6.5575,
              5.9516, 6.6368, 6.4611, 6.6368, 6.568, 5.9516, 6.9567, 6.942,
              7.0917, 3.71, 4.4571, 6.6368, 4.5597, 5.6075, 4.546, 6.568,
              5.2421, 166.4967, 175.9579, 172.8344, 174.8506, 175.9579,
              172.5597, 174.7742, 174.7742, 175.7244, 172.8344, 172.8344,
              172.8344, 172.8344, -85.2937, -85.2937, -86.0543, -86.0543,
              -85.2937, -85.2937, -85.2937, 1.4529, 9.3238, 8.0, 8.2383, 8.0,
              8.8545, 7.8533, 7.8533, 9.7474, 8.0, 7.4143, 7.9066, 7.8533,
              7.8115, 8.877, 5.2002, 5.7426, 3.1996, 125.7922, 22.8873, 22.1936,
              21.3303, 20.9977, 20.9977, 21.4578, 22.2371, 21.3303, 21.3303,
              57.6779, 57.0037, 57.6096, 57.6096, 57.6779, 56.4924, 56.5911,
              56.0, 57.0037, 56.7076, 56.5559, 67.022, 72.0575, 68.007, 68.007,
              64.6054, 66.9966, 71.823, 71.824, 71.8302, 67.0169, 67.0169,
              67.0169, 67.0169, 72.0575, 72.7317, 67.2129, 67.2129, 71.799,
              71.8301, 71.8301, 72.635, 68.2732, 66.8744, 68.007, 66.9497,
              66.9966, 66.9966, 72.8066, 71.56, 72.8315, 71.8301, 67.9868,
              71.9861, 72.265, 67.5593, 67.9868, 66.6578, 66.6578, 66.6578,
              66.9837, 66.9837, 66.9497, 66.9497, 66.9497, 64.6054, -82.8386,
              -81.6237, -80.2489, -71.6046, -71.1934, -71.8178, -71.0305,
              -70.3367, -72.0155, -72.2239, -70.8608, -70.9368, -71.3348,
              -71.6046, 121.3076, 121.2406, 123.4217, 121.071, 120.9496,
              123.4222, 120.618, 120.9496, 125.0091, 121.0559, 123.4255,
              120.3562, 124.9173, 120.9758, 120.2027, 119.9725, 121.1434,
              124.6342, 124.5748, 121.2426, 121.1434, 120.7703, 123.4199,
              123.4217, 120.5431, 120.6682, 121.0505, 121.7944, 123.9622,
              123.0149, 123.1083, 120.7276, 125.292, 122.3761, 120.5961,
              120.5961, 124.7489, 121.1, 120.9019, 121.2064, 121.2064, 124.7544,
              120.4769, 120.364, 122.9908, 125.1533, 120.3647, 120.6764,
              120.9758, 121.7528, 121.7528, 120.4301, 120.9334, 120.6682,
              120.7703, 123.4351, 120.7371, 121.093, 120.6498, 120.5042,
              120.875, 120.1465, 120.5042, 121.093, 120.5336, 124.8934, 120.695,
              120.695, 121.4662, 121.4662, 120.4858, 120.531, 120.5043,
              121.7645, 121.4236, 121.2464, 120.9496, 120.7703, 119.9951,
              120.5817, 124.4741, 123.2973, 119.91, 120.5086, 120.5086,
              121.1434, 120.4741, 120.5042, 120.9771, 120.5086, 123.2158,
              124.0006, 126.2409, 121.0811, 124.4409, 121.1509, 121.662,
              120.2384, 121.5407, 123.4199, 121.1434, 120.7276, 125.1533,
              121.145, 124.292, 124.8569, 121.0407, 120.6676, 125.3552,
              125.0091, 122.9366, 125.2838, 123.4199, 123.6738, 121.5407,
              121.8334, 125.1533, 122.9282, 119.9851, 124.2767, 121.8692,
              120.6822, 120.5431, 120.5431, 120.6436, 124.7699, 121.067,
              18.6144, 22.8868, 19.4094, 22.1771, 15.8428, 21.6932, 15.4056,
              16.91423, 22.1771, 14.8972, 17.8136, 18.6045, 14.4926, -8.263,
              -8.7073, -8.2237, -8.2869, -8.0508, -8.5123, -7.4795, -6.7122,
              -7.2264, -6.5611, -8.2869, -7.476, -7.9652, -7.4142, -8.2237,
              -9.1534, -8.192, -7.476, -7.255, -7.476, -9.1234, -9.1234,
              -9.1234, -8.1975, -9.1234, -8.1975, -8.7929, -7.8896, -7.665,
              -8.9762, -7.8896, -7.4284, -8.6507, -67.0532, -67.0596, -66.4093,
              -67.0243, -66.9382, -65.9077, -66.8322, -67.1077, -67.1894,
              -65.8824, -66.5425, -66.5407, -66.4761, -66.2615, -66.3876,
              -65.8243, 51.5122, 51.4568, 51.5122, 25.8888, 25.8888, 24.693,
              23.8688, 23.8688, 24.6859, 25.888, 22.0125, 24.6859, 25.8888,
              25.8888, 23.743, 23.054, 25.7689, 23.8688, 23.8688, 21.5522,
              23.8688, 25.8888, 25.8888, 24.374, 24.374, 25.8888, 55.0065,
              44.1877, 58.471, 73.51, 58.4747, 55.49, 40.7536, 44.8194, 85.832,
              44.8996, 49.814, 47.1727, 46.0798, 42.7192, 42.7192, 45.2492,
              45.2492, 86.6252, 59.3505, 48.1467, 40.7428, 105.1678, 49.814,
              49.2794, 45.3102, 44.381, 44.5136, 85.6233, 104.8316, 60.8851,
              43.4407, 55.4901, 49.814, 38.6969, 46.8632, 46.235, 44.5136,
              54.7277, 55.4056, 48.7866, 48.7866, 61.0105, 55.031, -62.7033,
              42.3528, 42.3528, 48.457, 39.6122, 46.7333, 49.0653, 37.3419,
              39.0333, 43.5179, 43.5179, 42.3528, 39.1729, 46.674, 45.6468,
              44.8657, 42.3528, 46.7333, 48.457, 49.6582, 39.1729, 50.1068,
              43.4973, 40.0974, -15.5526, -15.8719, -16.3972, -16.0277,
              -15.4692, -16.9354, -14.453, -16.2241, -16.5507, 19.4768, 20.4952,
              20.0834, 22.0395, 22.0395, 20.5514, 22.0395, 22.0395,
              -11.7359873410863, -13.268, -12.0387, 103.8195, 103.8195,
              103.8434, 103.6624, 103.8195, 103.7434, 103.8195, 103.8195,
              103.8195, 19.6312, 17.6491, 45.2383, 19.5929, 26.0718, 21.1504,
              19.5918, 29.3632, 24.7931, 21.0613, 21.0613, 21.1038, 24.6506,
              21.1504, 19.5705, 22.3232, 25.9199, 23.3501, 19.5529, 21.1037,
              21.0782, 21.1504, 27.9853, 22.3199, 19.9254, 23.0276, 22.9309,
              27.6625, 26.4009, 21.9955, 25.1891, 24.1035, 24.0283, 24.0926,
              27.9307, 26.2055, 24.7468, 24.7023, 23.3172, 26.8448, 23.8019,
              21.5204, 23.3751, 24.1349, 23.194, 23.0131, 18.8995, 22.9095,
              23.3656, 29.2501, 18.7379, 22.3553, 24.9256, 126.1238, 126.1254,
              126.6563, 127.1213, 127.1213, 126.5155, 126.6563, 126.248,
              128.1704, 127.6961, 126.4146, 127.6961, 127.1213, 127.1213,
              126.091, 126.4146, 128.401, 126.1856, 127.1213, 126.1238, 31.5,
              -4.3876, -6.2809, -6.2859, -5.5138, -6.2859, -6.2765, -6.3508,
              -5.7862, -3.3892, -6.115, -5.3375, -0.9188, -0.4421, -1.492,
              -6.6127, -2.0884, -6.2257, -6.226, -2.1077, -2.8, -5.8912,
              -6.5445, -2.157, -5.8173, -3.3892, -4.02, -4.02, -4.02, -0.3052,
              -1.0535, -6.3997, -4.097, -3.974, -0.4917, -3.3892, -5.8173,
              -4.913, -0.3814, -2.5909, -2.5909, -5.789, -6.2371, -4.8536,
              -0.5419, -0.5419, -2.5909, -0.5419, -0.5419, -6.3997, -2.3009,
              -6.4623, -6.4623, -4.4892, -5.8242, -0.5419, -0.3814, -1.4304,
              -1.2583, -5.896, -5.896, -6.0828, -5.896, -5.896, -5.896, -5.896,
              -6.0059, -5.896, -5.896, -5.896, -5.896, -5.896, -4.838, -5.0141,
              -5.0141, -5.896, -4.9299, -5.4088, -3.3847, -6.5588, -6.5214,
              -4.4892, -4.4892, -4.4892, -3.7491, -5.6827, -4.1241, -4.6161,
              -4.7286, -4.7286, -4.6161, -4.6161, -4.6161, -5.5633, -6.7798,
              -4.7002, -4.7002, -2.2023, -2.5292, -6.3167, -6.3167, -6.3167,
              -4.4892, -5.6831, -5.6831, -5.7018, -0.7178, -4.4237, -4.5275,
              -1.8351, -1.1009, -3.3847, -5.5633, -4.838, -5.9423, -5.8679,
              -5.7608, -6.3074, -5.6827, -1.2765, -6.9582, -6.9681, -5.1006,
              -6.9681, -6.7788, -6.3337, -5.9353, -4.1907, -5.9253, -4.913,
              -5.6604, -1.0591, -0.9537, -5.7051, -2.8036, -5.6986, -3.9575,
              -2.5505, -6.3997, -5.6827, -6.5348, -6.5348, -6.5348, -2.0884,
              -4.5629, -4.6083, -5.2922, -5.2922, -5.2922, -5.8679, -4.838,
              -2.4095, -6.5906, -0.6872, -1.0903, -6.7908, -6.7908, -6.2371,
              -5.9984, -6.2134, -7.2453, -4.0366, -6.66, -0.0298, -6.6236,
              -6.5868, -6.6711, -6.638, -6.6662, -6.7514, -1.0829, -6.5906,
              -5.9984, -3.9897, 0.5016, -1.4231, -5.8708, -6.2371, -6.2371,
              -6.2371, -5.6827, -2.4474, -2.4474, -2.4474, -2.4474, -1.0927,
              -1.6973, -7.2522, -5.6591, -5.7034, -5.7786, -5.8171, -6.4421,
              -0.7839, -6.8738, -0.7225, -0.831, -1.3044, -2.0446, -4.4892,
              -4.1168, -0.569, -3.207, -4.0315, 80.7138, 80.7138, 81.5012,
              80.2124, 81.0853, 80.2124, 32.484, 14.1839, 14.1839, 38.5934,
              36.1092, 36.778, 36.778, 36.248, 120.1854, 120.982, 120.982,
              120.982, 120.982, 120.982, 120.982, 120.5515, 120.3898, 120.2439,
              120.5445, 120.4257, 120.5515, 120.982, 35.7878, 35.7878, 35.7878,
              100.1664, 100.5845, 98.5462, 98.9367, 102.8807, 102.6189,
              105.0427, 99.5248, 100.553, 100.8089, 102.0157, 105.4437,
              100.1173, 99.4146, 100.3118, 100.6477, 100.693, 100.8089,
              100.8976, 100.8089, -15.7263, -16.6757, -15.7263, 1.02, 0.0094,
              1.0103, 1.0103, -61.4628, -61.4087, 10.5055, 10.0963, 8.4204,
              8.7757, 8.7757, 8.1253, 10.4509, 8.0467, 8.0467, 8.1253, 10.0525,
              10.1004, 10.4509, 9.4908, 9.5, 8.4204, 31.7478, 35.3346, 33.3159,
              27.667, 30.2382, 33.263, 33.5599, 37.2658, 36.6321, 38.8994,
              29.7229, 34.5628, 43.2042, 42.6117, 40.7062, 32.2167, 32.2167,
              32.2167, 32.2167, 32.2167, 31.7951, 32.927, 31.8287, 32.2167,
              33.932, 31.2194, 34.1539, 29.292, 29.292, 31.2194, 35.0489, 34.81,
              35.0489, 34.81, 31.2194, 31.396, 23.5044, 23.5044, 33.932, 30.004,
              33.932, 28.249, 33.932, 30.848, 28.599, 31.9955, 29.2393, 29.462,
              33.932, 31.9955, 29.462, 29.0383, 33.6776, 33.752, 34.2612,
              33.6011, 26.592, 34.81, 54.5139, 55.3679, 55.6536, 55.6536,
              55.6536, 54.6108, 55.3679, 55.3679, 55.3679, 55.3679, 55.3679,
              55.3679, 55.3679, 55.3906, 55.4321, 53.7146, 55.3679, -0.3668,
              0.6242, 0.6628, -1.0164, -1.8145, 0.3191, 1.0986, -3.042, -2.4998,
              -1.2021, -1.4415, -3.286, -1.8178, -2.6426, -0.7955, -0.4476,
              -2.4247, -0.7717, -0.6023, -0.5813, -1.3356, -0.9752, 0.1965,
              -0.4722, -2.0763, -3.9152, -1.7152, -2.2843, -0.9619, -4.4202,
              1.3569, -0.1336, 0.1807, -0.8686, -1.7004, -1.9935, -0.607,
              -2.1481, -1.6189, -2.0897, -2.1383, -0.548, -3.2353, -2.0074,
              -1.968, -4.4198, -2.6938, -0.1009, -1.9102, 0.011, -0.8449,
              -2.6534, -0.0937, -1.1971, -1.1783, -1.3829, 0.3158, 0.8302,
              -5.4852, 1.1006, -2.3747, -4.8937, -2.1215, -0.9087, -4.0502,
              -2.9032, -1.883, -0.0691, -0.9998, -3.2461, -3.0454, 0.2723,
              0.7448, 0.7808, 0.7048, -0.3655, -4.969, -2.3128, -0.8523,
              -2.3199, -1.5672, -0.5696, -2.5068, -1.8124, -1.1116, -2.404,
              -1.2281, -2.1835, -0.5864, -0.9423, -5.0407, -3.0227, -0.1703,
              0.7713, 0.6887, -1.5605, -1.0813, -0.9023, -3.1996, 0.5509,
              -0.3596, -6.2096, 0.2182, -2.1452, -1.3976, -0.833, -2.708,
              0.4373, 0.4844, -0.1516, -1.2775, -1.1659, 0.8762, -2.9711,
              0.3649, 0.3635, -1.037, -1.3471, -1.3327, -3.2766, -1.5379,
              -1.8514, -0.2071, -0.0179, 0.5335, -4.4906, -1.556, -1.4022,
              -1.0597, -1.8612, -1.8563, -0.5367, -0.0069, -0.9598, -1.9217,
              0.3222, -2.0998, 0.9139, -2.5998, -1.2444, -2.1556, -4.9189,
              -1.1357, -0.759, -1.403, -0.735, -1.4601, -0.9835, -1.7376,
              -0.7353, -1.908, 0.2855, -2.224, -6.2342, -5.7687, 0.002, -0.9562,
              -1.948, -1.4003, -4.8713, 0.0489, -0.5683, -1.9126, -1.3648,
              -1.2011, -0.8714, -6.4404, -2.4215, -2.5228, -1.4036, 1.0106,
              -1.743, -0.7338, -0.1982, 0.322, -2.726, -3.2307, -3.7924, 0.5172,
              -1.1272, 0.304, -0.6455, -0.4658, -1.0695, 1.0438, 1.2112, 0.319,
              -4.111, 0.3492, -2.2056, -0.5232, -1.7751, 1.0892, 0.3765,
              -2.3267, -2.7706, -2.5169, -0.3376, 0.5348, -2.3624, -4.4009,
              -1.3199, -0.2399, 0.7135, -1.6856, -1.066, -0.849, -6.6713,
              -1.6396, -0.6451, -4.121, -2.1716, 0.8463, -2.4774, -3.3723,
              -1.6551, 0.9368, -2.9505, 0.1816, 0.611, -0.1461, -3.5167,
              -4.7371, -1.3736, -1.5102, -6.1807, -1.3745, -0.0685, -0.9007,
              -6.1863, -1.2652, -0.7982, -2.0768, -0.4111, -2.0961, -0.4372,
              -0.4287, -4.9189, 0.1187, -1.4306, 0.3486, -0.3145, -1.5302,
              1.3382, 0.3098, -0.4133, 0.2699, 0.0833, -3.4634, 1.4922, -0.6026,
              -2.5406, -0.5214, -1.5042, 1.3628, -0.7538, 0.8645, -1.8115,
              -84.6261, -81.3309, -84.6339, -74.2331, -79.9604, -87.0597,
              -113.619, -113.637, -77.0344, -95.1636, -108.724, -79.1925,
              -78.6722, -102.312, -88.9925, -116.636, -114.595, -114.595,
              -77.9775, -77.614, -81.365, -78.8779, -119.596, -116.855,
              -116.855, -88.74, -95.2692, -115.394, -83.3332, -87.2156,
              -83.4276, -81.8019, -84.0216, -115.395, -115.395, -115.395,
              -115.395, -115.395, -115.395, -115.395, -115.395, -115.394,
              -115.394, -115.394, -115.394, -115.394, -115.394, -115.394,
              -115.394, -115.394, -114.753, -115.38, -115.38, -89.1822,
              -90.2057, -89.3215, -119.565, -119.906, -81.6163, -81.8069,
              -78.6519, -72.366, -115.87, -115.87, -115.434, -84.9006, -108.505,
              -84.5108, -111.888, -114.993, -111.634, -88.9841, -76.1736,
              -119.516, -119.516, -104.636, -106.384, -81.6544, -86.2162,
              -104.456, -75.9172, -77.9663, -81.6182, -77.712, -91.349,
              -72.1514, -83.0373, -115.293, -114.697, -106.056, -78.2346,
              -105.956, -115.975, -80.8425, -76.9022, -114.958, -114.958,
              -114.958, -114.958, -114.958, -114.958, -114.975, -114.975,
              -114.974, -116.069, -81.8972, -99.2583, -119.573, -119.585,
              -77.571, -114.958, -76.8446, -114.958, -114.958, -82.6961,
              -75.0704, -73.5904, -82.8934, -104.567, -100.489, -77.481,
              -96.0825, -84.6805, -111.484, -114.963, -114.963, -114.963,
              -114.963, -114.963, -114.958, -80.6789, -120.534, -83.7921,
              -77.2153, -81.5954, -110.538, -77.5768, -108.205, -78.2731,
              -115.147, -83.3451, -79.5429, -121.131, -72.0431, -81.3156,
              -78.8321, -78.8321, -77.7914, -116.685, -81.9416, -82.1401,
              -95.7464, -79.4364, -119.974, -78.0337, -120.237, -84.3539,
              -84.2233, -74.7963, -73.8565, -95.9568, -95.9568, -95.9804,
              -84.9688, -106.488, -80.7581, -78.8321, -99.7966, -99.903,
              -68.4064, -117.206, -71.4371, -95.6519, -118.387, -118.395,
              -97.0828, -88.7583, -116.093, -116.093, -93.6153, -75.8808,
              -82.1647, -113.226, -113.322, -97.1053, -85.6254, -120.104,
              -112.881, -87.451, -118.497, -118.525, -76.648, -118.564,
              -118.551, -118.551, -118.568, -118.551, -81.1343, -120.114,
              -80.0419, -73.8928, -114.806, -78.877, -97.02, -120.316, -119.467,
              -77.6964, -82.2044, -81.98, -72.475, -114.684, -97.4614, -111.565,
              -78.0981, -86.9847, -78.0936, -102.282, -74.4928, -75.5696,
              -82.8643, -79.6364, -74.4657, -78.096, -86.9847, -77.4565,
              -82.062, -76.6653, -77.4092, -73.9897, -108.755, -83.7921,
              -85.5347, -89.548, -84.0445, -89.0312, -115.666, -110.078,
              -114.891, -95.1511, -95.1511, -88.9841, -120.379, -117.633,
              -157.96, -118.129, -113.03, -112.987, -113.613, -108.537,
              -117.642, -117.642, -76.8, -81.2422, -75.257, -87.4056, -69.5991,
              -76.3726, -75.4412, -103.579, -70.1008, -113.034, -78.8436,
              -106.858, -111.554, -118.126, -82.1838, -95.4401, -117.977,
              -117.977, -99.1786, -89.4101, -112.703, -118.304, -96.0731,
              -77.9291, -87.451, -96.7061, -77.8469, -86.34, -102.36, -118.32,
              -77.8871, -85.0229, -77.0666, -118.424, -110.961, -118.19,
              -111.283, -105.884, -119.46, -120.996, -80.0621, -109.929,
              -109.929, -110.867, -81.7596, -81.751, -99.5985, -119.511,
              -113.792, -82.7488, -112.834, -112.834, -112.834, -96.2027,
              -114.844, -107.563, -88.1984, -83.9453, -83.96, -83.9427,
              -118.458, -118.48, -117.116, -115.355, -115.355, -90.3494,
              -90.3494, -88.9925, -120.881, -118.015, -118.027, -117.999,
              -118.034, -80.1297, -90.4557, -78.8784, -88.8373, -76.2299,
              -90.7115, -78.0431, -118.069, -118.088, -85.3692, -121.15,
              -118.014, -112.834, -118.314, -118.298, -120.881, -119.243,
              -78.4784, -73.5647, -88.9841, -82.234, -80.5211, -103.35,
              -118.069, -78.1376, -114.376, -117.061, -82.3339, -82.6722,
              -78.3934, -118.303, -121.15, -112.881, -114.775, -85.3882,
              -85.3108, -82.0339, -117.348, -98.4447, -100.384, -114.646,
              -99.7161, -99.5525, -73.8334, -73.7923, -76.6205, -70.7565,
              -102.968, -102.271, -120.402, -113.495, -113.495, -102.528,
              -77.9663, -77.9663, -97.0741, -117.378, -120.325, -118.954,
              -159.492, -156.485, -155.764, -83.7716, -84.3005, -83.4835,
              -113.495, -113.495, -89.4263, -89.1275, -81.4005, -119.435,
              -114.97, -81.252, -81.2078, -104.442, -121.899, -117.572,
              -118.088, -94.2627, -82.3601, -120.757, -117.116, -114.689,
              -84.8368, -84.8307, -114.775, -109.89, -114.775, -117.011,
              -118.304, -119.443, -118.505, -118.505, -107.486, -79.3475,
              -77.0665, -77.5095, -112.752, -112.752, -119.898, -86.0346,
              -82.6539, -99.9175, -118.288, -118.281, -118.309, -83.0492,
              -121.15, -117.633, -116.761, -80.8645, -116.948, -84.813, -85.049,
              -117.017, -77.179, -117.017, -119.917, -119.917, -119.917,
              -119.917, -115.532, -76.1445, -119.917, -104.318, -104.429,
              -80.6482, -108.554, -108.554, -100.323, -78.381, -77.406,
              -102.551, -105.967, -73.5164, -78.3151, -84.3165, -84.2758,
              -92.8678, -81.9229, -120.404, -120.404, -76.5594, -118.186,
              -80.707, -84.2287, -119.068, -119.068, -119.027, -75.5646,
              -85.087, -84.1353, -80.1188, -115.648, -115.648, -115.648,
              -115.648, -115.648, -121.104, -118.3, -111.568, -76.421, -108.554,
              -79.1446, -81.8091, -118.443, -115.726, -73.4539, -88.7278,
              -120.344, -76.3061, -81.6842, -103.378, -103.378, -90.9908,
              -102.272, -110.991, -117.633, -118.334, -118.334, -76.8959, -74.1,
              -108.554, -106.098, -78.6235, -80.5372, -81.1292, -85.4007,
              -96.0641, -120.757, -119.845, -84.384, -85.0787, -100.828,
              -100.825, -84.3835, -81.7741, -75.9609, -88.4214, -81.2618,
              -86.3273, -120.015, -82.3905, -117.966, -81.2391, -83.3284,
              -88.2955, -115.714, -97.2705, -104.597, -84.528, -83.3411,
              -77.3142, -105.011, -86.2711, -89.0093, -104.849, -78.4839,
              -114.744, -114.696, -114.742, -114.834, -117.542, -108.296,
              -83.582, -122.683, -68.5051, -78.1552, -100.337, -95.663,
              -83.7246, -80.7784, -96.5851, -86.4651, -77.6049, -97.8896,
              -114.944, -81.751, -114.97, -116.351, -114.742, -114.742,
              -114.742, -114.73, -114.73, -114.73, -114.73, -114.768, -114.768,
              -100.547, -121.376, -81.9872, -111.34, -92.3314, -119.96,
              -119.287, -110.712, -118.124, -78.45, -115.32, -115.32, -115.35,
              -112.005, -118.334, -116.915, -76.9027, -80.1578, -72.8885,
              -79.3847, -79.2333, -115.32, -109.045, -106.822, -85.8191,
              -76.0872, -81.7544, -99.8547, -73.1684, -119.128, -116.006,
              -116.014, -118.283, -91.69, -80.5722, -80.742, -115.32, -115.32,
              -115.47, -115.47, -103.475, -115.546, -117.371, -115.358, -76.35,
              -117.634, -119.895, -119.895, -119.895, -115.32, -119.895,
              -75.4519, -76.1141, -77.1587, -98.0344, -92.4385, -88.9925,
              -83.6758, -115.955, -116.688, -115.32, -115.32, -119.895, -115.47,
              -77.9446, -77.4178, -86.8834, -116.281, -81.7634, -117.542,
              -70.6145, -107.615, -115.904, -115.834, -104.461, -79.8517,
              -83.2674, -87.2629, -103.307, -97.4462, -118.238, -118.247,
              -77.0384, -80.0162, -81.8102, -108.375, -112.444, -76.7457,
              -83.6164, -102.192, -97.0541, -117.642, -81.9311, -76.0261,
              -106.678, -106.678, -82.4328, -70.7803, -85.4104, -111.43,
              -119.02, -119.02, -99.8208, -82.309, -118.28, -81.8306, -97.1458,
              -108.205, -104.843, -95.3574, -95.1934, -95.1934, -111.502,
              -111.06, -77.558, -84.155, -71.0353, -80.3526, -105.928, -102.192,
              -118.077, -118.404, -87.4986, -116.497, -82.75, -116.828,
              -116.888, -92.4385, -90.5365, -76.7936, -112.081, -112.835,
              -110.867, -76.8959, -110.867, -104.607, -120.11, -89.4859,
              -89.4976, -76.136, -118.311, -109.919, -80.6574, -76.7984, -91.44,
              -120.107, -112.817, -111.518, -77.1556, -109.683, -69.781,
              -119.441, -84.362, -115.572, -115.779, -115.658, -81.8852,
              -83.524, -114.926, -114.937, -114.971, -80.4745, -114.956,
              -120.934, -81.0483, -84.2972, -103.113, -103.126, -86.1597,
              -74.5668, -118.305, -118.325, -79.1928, -84.111, -114.974,
              -118.404, -80.656, -93.5786, -118.084, -114.473, -77.166,
              -115.147, -89.5012, -98.2923, -119.771, -112.584, -73.9897,
              -118.298, -76.6368, -82.1914, -95.6221, -120.918, -118.387,
              -118.353, -118.353, -118.353, -118.353, -118.353, -118.404,
              -118.404, -118.404, -118.404, -157.764, -88.1984, -96.2105,
              -104.475, -118.56, -118.556, -88.989, -115.4, -115.4, -115.4,
              -115.4, -115.4, -115.4, -115.4, -113.162, -97.0828, -80.2356,
              -90.7335, -84.568, -82.575, -88.4437, -118.002, -117.977,
              -117.955, -76.9192, -80.536, -114.87, -98.0014, -86.1083,
              -106.673, -108.385, -85.0451, -80.3058, -76.1887, -94.7363,
              -89.4238, -108.382, -112.66, -100.114, -82.2269, -85.265, -120.41,
              -92.91, -102.701, -118.38, -77.4219, -77.624, -76.7751, -119.114,
              -77.593, -117.758, -115.514, -119.056, -88.9841, -84.9449,
              -80.7297, -118.313, -89.92, -102.697, -88.9919, -88.9876,
              -101.8681, -78.5098, -120.668, -76.0261, -116.94, -116.285,
              -80.7784, -80.7784, -80.5707, -87.8474, -115.243, -80.8257,
              -96.8863, -95.8254, -95.2212, -80.7948, -88.6189, -84.1475,
              -113.656, -86.5919, -83.5962, -99.6124, -120.822, -119.089,
              -80.6316, -83.7961, -75.9021, -102.268, -89.4782, -77.0344,
              -77.4405, -83.2229, -76.786, -76.5829, -79.7683, -108.245,
              -120.18, -80.6256, -77.725, -74.6378, -115.125, -80.9802,
              -95.4252, -114.77, -95.6192, -100.072, -100.1, -77.0344, -68.991,
              -75.8828, -89.8547, -115.125, -83.7961, -76.3642, -77.8836,
              -77.0616, -83.784, -104.414, -80.4975, -101.712, -71.2992,
              -81.8841, -74.882, -119.896, -119.896, -119.903, -75.8828,
              -87.9045, -108.602, -74.7432, -115.752, -82.2204, -114.964,
              -115.587, -115.587, -115.587, -115.567, -115.629, -112.081,
              -116.439, -104.653, -80.6973, -83.7771, -115.147, -111.28,
              -97.8028, -105.016, -90.3407, -85.8395, -112.746, -82.3879,
              -121.12, -76.1541, -96.2075, -110.088, -100.6, -75.5882, -118.32,
              -83.6517, -83.6433, -121.052, -71.9325, -81.2268, -80.57,
              -71.8223, -77.5768, -119.623, -99.1872, -86.0969, -110.051,
              -111.289, -76.0261, -72.7645, -87.8422, -97.1798, -76.9027,
              -119.629, -119.683, -97.4184, -89.4701, -78.5686, -77.7862,
              -114.08, -83.3789, -117.206, -117.642, -85.9653, -79.41, -119.083,
              -117.545, -77.7764, -118.852, -118.812, -115.147, -96.2697,
              -75.1814, -156.38, -158.054, -102.845, -79.0556, -96.2105,
              -111.243, -96.1465, -102.868, -118.478, -118.478, -83.7629,
              -81.254, -86.9615, -80.5473, -104.581, -77.4812, -117.542,
              -81.8101, -81.9642, -84.2568, -112.36, -112.343, -112.363,
              -80.8219, -87.8217, -114.871, -120.879, -102.268, -111.551,
              -85.536, -78.7719, -102.84, -91.5526, -120.524, -78.8779, -87.972,
              -89.5792, -88.0579, -88.9841, -84.105, -87.9335, -118.282,
              -121.499, -74.882, -87.5553, -81.1438, -112.589, -77.7862,
              -77.7862, -82.8934, -77.5504, -114.908, -114.908, -81.1, -104.459,
              -82.06, -113.137, -68.11, -82.7495, -118.116, -116.129, -81.9557,
              -77.4724, -100.866, -107.0, -106.063, -77.3642, -101.796,
              -116.321, -83.7963, -88.9402, -81.6606, -79.8612, -101.391,
              -116.175, -98.0141, -156.654, -156.412, -119.834, -119.834,
              -158.055, -110.264, -110.264, -77.2119, -101.391, -95.7156,
              -81.6606, -81.6606, -81.5369, -79.7262, -78.0175, -79.9439,
              -77.932, -78.6056, -78.8774, -78.3048, -78.9436, -79.3324,
              -77.7124, -81.6606, -78.0054, -90.1954, -117.558, -113.152,
              -99.8208, -100.381, -98.8965, -102.259, -101.885, -114.464,
              -84.2112, -81.6606, -80.44, -78.7554, -82.8934, -120.12, -79.7095,
              -77.3079, -86.2711, -70.1449, -75.2177, -118.498, -80.1283,
              -77.4207, -81.4348, -96.429, -74.253, -102.673, -82.1647, -120.41,
              -120.415, -120.415, -120.415, -82.4106, -82.1028, -68.4064,
              -117.199, -117.199, -80.5414, -85.7261, -120.415, -119.905,
              -116.26, -101.927, -119.948, -88.9841, -118.432, -118.439,
              -81.5562, -115.735, -83.8926, -120.934, -100.599, -89.3593,
              -117.542, -84.7972, -117.573, -158.034, -158.0, -91.3319,
              -81.7075, -82.0339, -81.364, -85.3306, -80.7446, -79.124, -79.124,
              -101.927, -76.7886, -80.6391, -100.381, -80.5782, -77.7114,
              -96.0972, -83.1869, -81.325, -81.136, -68.3604, -119.278,
              -82.7989, -91.6603, -81.8197, -83.8137, -155.679, -83.7924,
              -115.05, -96.8148, -81.1083, -117.326, -114.929, -86.1195, -77.64,
              -82.441, -110.355, -89.3012, -78.105, -83.6344, -118.879,
              -77.5348, -85.3688, -74.8437, -72.5478, -113.898, -104.253,
              -102.488, -75.6975, -84.5828, -120.38, -120.38, -120.38, -120.38,
              -81.0667, -122.678, -75.9727, -85.3692, -77.57, -77.9618,
              -86.1195, -77.38, -104.828, -119.651, -86.5184, -86.8952,
              -87.3352, -73.8029, -79.1446, -82.6022, -86.0363, -94.1028,
              -79.2066, -100.162, -79.3408, -76.3275, -76.1847, -105.991,
              -96.0746, -84.3974, -95.733, -82.0583, -78.031, -81.029, -77.453,
              -117.558, -111.051, -81.914, -80.6342, -104.398, -116.333,
              -95.3709, -115.587, -115.497, -115.498, -112.666, -82.6021,
              -112.266, -77.9663, -83.8441, -101.611, -100.2, -80.0096,
              -87.6262, -88.9841, -119.806, -80.3065, -84.1763, -76.1943,
              -117.372, -158.033, -120.697, -74.185, -78.25, -81.4256, -81.4082,
              -83.8098, -77.7862, -82.3597, -77.9967, -83.906, -74.8492,
              -73.6405, -89.9069, -116.863, -120.031, -72.8478, -97.5088,
              -89.3039, -77.7214, -80.3431, -77.9663, -75.0558, -79.0271,
              -83.7312, -78.1258, -91.1771, -77.9663, -119.29, -90.776,
              -155.428, -157.982, -157.885, -158.188, -95.6581, -119.605,
              -102.537, -82.474, -117.116, -117.478, -75.5708, -157.982,
              -91.6028, -94.6712, -158.015, -79.3587, -113.509, -119.463,
              -84.257, -82.1113, -100.834, -84.4439, -121.343, -119.634,
              -120.956, -120.956, -159.762, -120.134, -81.919, -119.905,
              -119.905, -119.923, -119.904, -119.904, -98.4931, -118.314,
              -118.325, -79.6417, -103.729, -76.7567, -120.069, -120.82,
              -77.1206, -88.9841, -101.737, -101.717, -98.4931, -82.8431,
              -77.2514, -76.8544, -120.404, -81.4279, -76.0261, -114.884,
              -86.7916, -114.08, -120.069, -120.069, -120.069, -103.323,
              -116.01, -104.014, -104.458, -75.8352, -80.7714, -74.238, -122.86,
              -120.069, -98.7922, -119.81, -104.914, -120.51, -76.2477,
              -111.756, -118.384, -92.4385, -112.546, -112.904, -102.29,
              -75.1984, -71.6593, -82.301, -119.81, -87.6217, -80.5727,
              -82.1653, -83.2824, -76.6637, -87.5453, -82.9687, -81.8445,
              -83.4912, -80.6824, -119.524, -81.2329, -78.1792, -77.8061,
              -77.972, -120.138, -86.6458, -82.3553, -77.195, -102.258,
              -79.4364, -102.258, -78.6673, -116.946, -119.318, -84.0933,
              -82.8945, -86.6458, -84.111, -95.669, -82.646, -77.7203, -77.7494,
              -115.38, -115.38, -115.38, -115.38, -114.74, -114.74, -114.74,
              -77.9618, -77.7706, -86.6458, -158.058, -117.061, -80.0696,
              -102.564, -122.678, -119.69, -119.85, -92.7537, -116.635,
              -75.2177, -116.946, -116.946, -81.167, -117.371, -116.946,
              -84.7325, -120.355, -118.192, -83.9895, -86.2765, -107.48,
              -78.2787, -121.771, -80.0488, -81.6933, -116.946, -114.74,
              -114.74, -114.74, -116.054, -115.503, -115.619, -77.5663,
              -76.5594, -69.5031, -90.9594, -118.27, -118.288, -82.2717,
              -110.893, -114.74, -83.705, -118.335, -82.0807, -78.6451,
              -100.627, -76.7638, -81.1451, -81.7839, -108.902, -103.166,
              -77.8783, -77.9346, -118.318, -71.9199, -88.6158, -80.837,
              -114.74, -121.3, -77.1269, -77.2077, -115.147, -77.65, -79.3746,
              -88.5495, -76.4524, -112.904, -112.911, -120.957, -112.937,
              -83.6002, -80.49, -80.9428, -102.224, -115.573, -115.532,
              -115.545, -113.018, -89.2514, -83.0656, -83.6929, -115.125,
              -101.622, -57.8739, -57.4574, -57.6034, -57.4385, -57.9088,
              65.5311, 69.3689, 67.0194, 69.3689, 69.2542, 69.3394, 65.5311,
              67.9395, 108.016, 108.0087, 108.8861, 108.8861, 107.045, 107.045,
              106.9291, 106.2568, 107.2793, 109.2325, 108.7446, 108.7446,
              108.7446, 107.771, 107.7299, 106.5046, 106.27, 105.2531, 105.2531,
              108.1607, 106.2568, 108.3599, 108.1005, 106.6052, 106.6052,
              106.6052, 106.6052, 106.6052, 106.878, 108.6668, 108.6668,
              109.0998, 108.3093, 103.96, 109.073, 107.7124, 108.3599, 108.3599,
              109.073, 108.3599, 108.1005, 105.7676, 106.275, 108.368, 106.2328,
              106.6988, 108.8804, 108.9035, 106.8773, 106.2512, 104.9915,
              104.9915, 106.2568, 108.3599, 106.2568, 108.7613, 106.3564,
              108.8098, 109.2208, 106.6052, 109.2208, 109.2208, 105.5975,
              106.2568, 106.275, 108.708, 108.8804, 106.2328, 109.1276,
              106.6052, 107.8434, 107.277, 107.277, 107.277, 107.277, 108.7446,
              107.893, 107.1688, 107.186, 109.067, 109.088, 106.0101, 106.0101,
              109.081, 109.0801, 108.6668, 106.8773, 105.6199, 106.2528,
              106.8773, 109.0049, 109.03, 108.866, 109.0941, 108.8861, 107.5903,
              105.0972, 106.8773, 108.8861, 106.9873, 106.2512, 107.2687,
              107.5903, 107.7124, 108.8804, 108.3599, 107.7523, 107.7523,
              106.0101, 106.1413, 107.6686, 108.8861, 109.1953, 106.2568,
              106.2568, 106.2568, 106.2568, 106.2568, 106.2568, 109.1866,
              104.9312, 104.9312, 108.8861, 108.7446, 106.1286, 106.3618,
              106.3618, 109.073, 109.0589, 107.7708, 106.3028, 104.9915,
              104.9915, 106.1286, 105.8764, 108.1005, 108.0039, 109.1463,
              108.8861, 109.1463, 109.1463, 109.1463, 107.5903, 108.8804,
              108.8804, 105.8764, 109.0957, 108.8861, 105.3981, 108.8009,
              108.8009, 108.8009, 109.1018, 107.895, 108.8886, 107.8991,
              107.8991, 109.0621, 109.1463, 108.8804, 106.2568, 108.8861, 108.9,
              109.1637, 109.1018, 109.0961, 108.8804, 108.8861, 108.8861,
              108.891, 108.8804, 108.8804, 108.8804, 107.8269, 107.045,
              109.1018, 108.7446, 107.564, 107.3998, 108.3625, 107.7974,
              107.7974, 108.3599, 108.8804, -12.5761, -12.9543, -13.8921,
              -14.3636, 28.4329, 28.6574, 27.5714, 27.7804, 23.1489, 28.4286,
              30.4022, 22.0998, 30.3986, 24.2427, 28.7586, 32.3689, 29.829,
              31.7678, 29.7681, 27.4992, 27.4992, 31.3341, 31.3341, 29.7986,
              28.9396, 30.7849, 30.7849, 28.8446, 29.8791, 28.8568, 29.829,
              29.8791, 29.596, 31.7678, 31.7678, 28.9396, 28.9396, 31.0495,
              28.5887, 31.7678, 29.7468, 29.7468, 28.5887, 30.6675,
            ],
            name: '',
            radius: [
              5.1413820691034555, 5.087004350217511, 5.177633881694085,
              5.1413820691034555, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 15.871918595929797, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.54015200760038, 5.177633881694085, 5.177633881694085,
              5.50390019500975, 5.358892944647232, 5.0362518125906295,
              5.039876993849693, 5.043502175108755, 5.0362518125906295,
              19.49709985499275, 5.050752537626881, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.358892944647232, 5.079753987699385,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.050752537626881, 5.039876993849693, 5.032626631331566,
              5.050752537626881, 5.358892944647232, 5.032626631331566,
              5.188509425471274, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.116005800290014,
              5.050752537626881, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.050752537626881,
              5.050752537626881, 5.094254712735637, 5.087004350217511,
              5.681534076703835, 5.123256162808141, 5.094254712735637,
              5.123256162808141, 5.087004350217511, 5.348017400870043,
              5.377018850942547, 5.750412520626031, 5.072503625181259,
              5.0688784439221966, 5.358892944647232, 5.105130256512826,
              5.377018850942547, 5.377018850942547, 5.721411070553527,
              5.076128806440322, 5.2863893194659735, 5.420521026051302,
              5.148632431621581, 5.094254712735637, 5.087004350217511,
              5.087004350217511, 5.112380619030952, 5.358892944647232,
              5.1957597879894, 5.721411070553527, 5.384269213460673,
              5.1957597879894, 5.511150557527876, 5.1957597879894,
              5.395144757237862, 77.5, 5.087004350217511, 5.366143307165358,
              5.264638231911595, 5.0688784439221966, 5.866418320916046,
              5.1413820691034555, 6.083929196459823, 5.253762688134406,
              6.446447322366119, 6.1926846342317114, 6.808965448272414,
              6.083929196459823, 5.322641132056603, 5.395144757237862,
              5.460398019900995, 5.0688784439221966, 5.2972648632431625,
              5.913545677283865, 6.808965448272414, 5.094254712735637,
              5.1413820691034555, 6.808965448272414, 5.54015200760038,
              5.377018850942547, 5.576403820191009, 5.097879893994699,
              5.474898744937247, 5.413270663533177, 5.105130256512826,
              5.2138856942847145, 5.721411070553527, 5.105130256512826,
              5.126881344067203, 5.105130256512826, 5.358892944647232,
              5.2138856942847145, 5.395144757237862, 5.2863893194659735,
              5.431396569828491, 5.177633881694085, 5.431396569828491,
              14.059327966398321, 5.54015200760038, 5.54015200760038,
              5.474898744937247, 5.793914695734787, 5.250137506875344,
              5.358892944647232, 5.076128806440322, 5.391519575978799,
              5.279138956947848, 5.1957597879894, 6.446447322366119,
              5.779413970698535, 5.348017400870043, 5.384269213460673,
              6.663958197909896, 5.902670133506676, 5.0688784439221966,
              5.2030101505075255, 5.50390019500975, 5.105130256512826,
              5.304515225761288, 6.0476773838691935, 5.2138856942847145,
              5.250137506875344, 5.250137506875344, 5.250137506875344,
              5.344392219610981, 5.268263413170659, 5.387894394719736,
              5.358892944647232, 5.112380619030952, 5.3806440322016105,
              6.446447322366119, 5.721411070553527, 5.648907445372268,
              5.105130256512826, 6.1926846342317114, 5.431396569828491,
              6.9539726986349315, 5.177633881694085, 5.721411070553527,
              6.446447322366119, 5.420521026051302, 5.822916145807291,
              6.808965448272414, 6.808965448272414, 6.808965448272414,
              5.681534076703835, 5.304515225761288, 5.387894394719736,
              5.232011600580029, 5.250137506875344, 5.184884244212211,
              5.188509425471274, 5.1413820691034555, 5.126881344067203,
              5.344392219610981, 9.709110455522776, 5.1413820691034555,
              5.105130256512826, 5.25738786939347, 5.112380619030952,
              7.352742637131857, 5.087004350217511, 5.358892944647232,
              5.087004350217511, 5.228386419320966, 5.148632431621581,
              5.268263413170659, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.1957597879894,
              5.4640232011600585, 6.011425571278564, 5.496649832491625,
              5.496649832491625, 5.329891494574729, 5.206635331766588,
              5.105130256512826, 5.449522476123806, 6.446447322366119,
              6.138306915345767, 5.105130256512826, 5.630781539076954,
              5.460398019900995, 6.011425571278564, 6.26518825941297,
              5.395144757237862, 5.358892944647232, 5.105130256512826,
              6.116555827791389, 5.732286614330716, 5.148632431621581,
              5.54015200760038, 5.648907445372268, 5.1196309815490775,
              5.329891494574729, 5.391519575978799, 5.648907445372268,
              5.449522476123806, 5.721411070553527, 5.304515225761288,
              5.271888594429721, 5.177633881694085, 5.087004350217511,
              5.413270663533177, 5.177633881694085, 5.304515225761288,
              5.576403820191009, 5.250137506875344, 5.290014500725036,
              5.467648382419121, 6.029551477573879, 6.138306915345767,
              5.50390019500975, 5.884544227211361, 5.54015200760038,
              5.351642582129107, 7.171483574178708, 5.721411070553527,
              6.71833591679584, 5.094254712735637, 6.392069603480174,
              5.358892944647232, 5.2138856942847145, 6.011425571278564,
              5.721411070553527, 5.435021751087555, 5.449522476123806,
              5.449522476123806, 5.2863893194659735, 5.721411070553527,
              5.2138856942847145, 5.54015200760038, 5.721411070553527,
              6.170933546677334, 5.435021751087555, 5.28276413820691,
              5.105130256512826, 5.431396569828491, 5.1957597879894,
              5.0688784439221966, 5.087004350217511, 5.2863893194659735,
              5.177633881694085, 5.0688784439221966, 5.427771388569428,
              5.2030101505075255, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.467648382419121,
              5.1196309815490775, 5.177633881694085, 5.1413820691034555,
              5.721411070553527, 6.000550027501375, 7.8965198259913,
              6.26518825941297, 6.261563078153908, 5.449522476123806,
              5.177633881694085, 5.1957597879894, 5.431396569828491,
              5.1413820691034555, 5.9751737586879345, 5.177633881694085,
              5.69965998299915, 5.924421221061053, 5.50390019500975,
              5.358892944647232, 6.808965448272414, 5.721411070553527,
              5.0688784439221966, 5.431396569828491, 5.54015200760038,
              5.583654182709136, 5.54015200760038, 5.0688784439221966,
              5.315390769538477, 5.427771388569428, 5.73591179558978,
              5.511150557527876, 5.757662883144157, 5.304515225761288,
              9.527851392569628, 5.902670133506676, 5.358892944647232,
              5.358892944647232, 5.2030101505075255, 5.087004350217511,
              5.373393669683484, 5.518400920046003, 5.0688784439221966,
              5.1196309815490775, 5.094254712735637, 5.775788789439472,
              5.279138956947848, 5.358892944647232, 5.166758337916896,
              5.105130256512826, 6.8814690734536725, 5.300890044502225,
              5.116005800290014, 5.536526826341317, 5.50390019500975,
              5.721411070553527, 5.094254712735637, 5.793914695734787,
              5.083379168958448, 5.0688784439221966, 5.830166508325417,
              5.358892944647232, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.300890044502225, 5.177633881694085, 5.105130256512826,
              5.166758337916896, 5.0688784439221966, 5.358892944647232,
              5.105130256512826, 5.322641132056603, 5.105130256512826,
              5.177633881694085, 5.31901595079754, 5.395144757237862,
              5.177633881694085, 5.2138856942847145, 5.177633881694085,
              5.721411070553527, 6.011425571278564, 5.358892944647232,
              5.177633881694085, 5.123256162808141, 5.112380619030952,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.721411070553527,
              5.1413820691034555, 5.358892944647232, 5.261013050652533,
              5.177633881694085, 5.449522476123806, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.123256162808141,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.105130256512826, 5.358892944647232, 5.0688784439221966,
              5.1957597879894, 5.467648382419121, 5.358892944647232,
              5.0688784439221966, 5.1413820691034555, 5.079753987699385,
              5.177633881694085, 5.087004350217511, 5.087004350217511,
              5.105130256512826, 5.112380619030952, 5.232011600580029,
              5.329891494574729, 5.210260513025651, 5.148632431621581,
              5.177633881694085, 5.177633881694085, 5.2138856942847145,
              5.105130256512826, 5.2138856942847145, 5.232011600580029,
              5.097879893994699, 5.166758337916896, 5.31901595079754,
              5.2138856942847145, 5.087004350217511, 5.097879893994699,
              5.54015200760038, 5.1957597879894, 5.1957597879894,
              5.079753987699385, 5.253762688134406, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.1196309815490775, 5.1087554377718885,
              5.1087554377718885, 5.134131706585329, 5.134131706585329,
              5.134131706585329, 5.134131706585329, 5.1196309815490775,
              5.134131706585329, 5.134131706585329, 5.134131706585329,
              5.134131706585329, 5.134131706585329, 5.105130256512826,
              5.134131706585329, 5.105130256512826, 5.134131706585329,
              5.105130256512826, 5.177633881694085, 5.105130256512826,
              5.402395119755988, 5.329891494574729, 5.166758337916896,
              5.170383519175958, 5.170383519175958, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.170383519175958, 5.170383519175958, 5.232011600580029,
              5.163133156657833, 5.163133156657833, 5.090629531476574,
              5.155882794139707, 5.1305065253262665, 5.1305065253262665,
              5.0688784439221966, 5.1196309815490775, 5.1196309815490775,
              5.105130256512826, 5.105130256512826, 5.692409620481024,
              5.094254712735637, 5.094254712735637, 5.126881344067203,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.116005800290014, 5.177633881694085,
              5.134131706585329, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.1957597879894, 5.177633881694085,
              5.1957597879894, 5.1413820691034555, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.148632431621581,
              5.148632431621581, 5.148632431621581, 5.148632431621581,
              5.177633881694085, 5.134131706585329, 5.170383519175958,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.174008700435022, 5.087004350217511, 5.174008700435022,
              5.174008700435022, 5.174008700435022, 5.174008700435022,
              5.174008700435022, 5.105130256512826, 5.1305065253262665,
              7.534001700085004, 5.2138856942847145, 5.177633881694085,
              5.094254712735637, 5.094254712735637, 5.094254712735637,
              5.094254712735637, 5.094254712735637, 5.090629531476574,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.087004350217511,
              5.087004350217511, 5.087004350217511, 5.087004350217511,
              5.087004350217511, 5.076128806440322, 5.105130256512826,
              5.134131706585329, 5.112380619030952, 5.1305065253262665,
              5.1087554377718885, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.155882794139707, 5.116005800290014,
              5.163133156657833, 5.163133156657833, 6.054927746387319,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.163133156657833, 5.1305065253262665, 5.1305065253262665,
              5.177633881694085, 5.112380619030952, 5.112380619030952,
              5.112380619030952, 5.112380619030952, 5.1305065253262665,
              5.079753987699385, 5.1957597879894, 5.097879893994699,
              5.174008700435022, 5.1305065253262665, 5.116005800290014,
              5.116005800290014, 5.116005800290014, 5.116005800290014,
              5.547402370118506, 5.163133156657833, 5.177633881694085,
              5.1413820691034555, 5.116005800290014, 5.126881344067203,
              5.170383519175958, 5.105130256512826, 5.192134606730336,
              5.268263413170659, 5.0688784439221966, 5.094254712735637,
              5.145007250362518, 5.2863893194659735, 5.2863893194659735,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.1196309815490775, 5.170383519175958,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.340767038351918, 5.126881344067203,
              5.242887144357218, 5.094254712735637, 5.1413820691034555,
              5.1413820691034555, 5.134131706585329, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.177633881694085, 5.170383519175958, 5.1413820691034555,
              5.1413820691034555, 5.1196309815490775, 5.112380619030952,
              5.1413820691034555, 5.1413820691034555, 5.148632431621581,
              5.094254712735637, 5.094254712735637, 5.177633881694085,
              5.170383519175958, 5.1413820691034555, 5.1413820691034555,
              5.15950797539877, 5.15950797539877, 5.15950797539877,
              5.15950797539877, 5.15950797539877, 5.112380619030952,
              5.112380619030952, 5.112380619030952, 5.15950797539877,
              5.1087554377718885, 5.15950797539877, 5.170383519175958,
              5.1087554377718885, 5.087004350217511, 5.1305065253262665,
              5.148632431621581, 5.170383519175958, 5.105130256512826,
              5.087004350217511, 5.1196309815490775, 5.170383519175958,
              5.326266313315665, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.192134606730336, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.105130256512826, 5.076128806440322, 5.094254712735637,
              5.1305065253262665, 5.1413820691034555, 5.322641132056603,
              5.123256162808141, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.087004350217511,
              5.094254712735637, 5.105130256512826, 5.079753987699385,
              5.1196309815490775, 5.166758337916896, 5.145007250362518,
              5.166758337916896, 5.192134606730336, 5.2138856942847145,
              5.757662883144157, 5.170383519175958, 5.1196309815490775,
              5.177633881694085, 5.177633881694085, 5.152257612880644,
              5.134131706585329, 5.134131706585329, 5.134131706585329,
              5.163133156657833, 5.177633881694085, 5.163133156657833,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.163133156657833, 5.123256162808141, 5.177633881694085,
              5.123256162808141, 5.123256162808141, 5.152257612880644,
              5.152257612880644, 5.152257612880644, 5.152257612880644,
              5.123256162808141, 8.027026351317566, 5.170383519175958,
              5.105130256512826, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.097879893994699,
              5.087004350217511, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.170383519175958,
              5.087004350217511, 5.145007250362518, 5.105130256512826,
              5.420521026051302, 5.105130256512826, 5.145007250362518,
              5.145007250362518, 5.145007250362518, 5.145007250362518,
              5.145007250362518, 5.145007250362518, 5.145007250362518,
              5.145007250362518, 5.145007250362518, 5.145007250362518,
              5.145007250362518, 5.145007250362518, 5.134131706585329,
              5.145007250362518, 5.145007250362518, 5.145007250362518,
              5.177633881694085, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.087004350217511,
              6.1926846342317114, 5.174008700435022, 5.174008700435022,
              5.174008700435022, 5.174008700435022, 5.174008700435022,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.155882794139707,
              5.177633881694085, 5.177633881694085, 5.155882794139707,
              5.155882794139707, 5.083379168958448, 5.0688784439221966,
              5.083379168958448, 5.0688784439221966, 5.126881344067203,
              5.126881344067203, 5.123256162808141, 5.685159257962898,
              5.126881344067203, 5.126881344067203, 5.232011600580029,
              5.232011600580029, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.116005800290014, 5.1413820691034555,
              5.1413820691034555, 5.126881344067203, 5.217510875543777,
              5.1087554377718885, 5.1087554377718885, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.105130256512826, 5.105130256512826, 5.304515225761288,
              5.112380619030952, 5.112380619030952, 5.112380619030952,
              5.101505075253763, 5.101505075253763, 5.112380619030952,
              5.105130256512826, 5.105130256512826, 5.155882794139707,
              5.1413820691034555, 5.1413820691034555, 5.1087554377718885,
              5.094254712735637, 5.094254712735637, 5.094254712735637,
              5.094254712735637, 5.094254712735637, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.1413820691034555,
              5.177633881694085, 5.290014500725036, 6.116555827791389,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.177633881694085, 5.155882794139707,
              5.155882794139707, 5.155882794139707, 5.163133156657833,
              5.163133156657833, 5.163133156657833, 5.116005800290014,
              5.116005800290014, 5.116005800290014, 5.116005800290014,
              5.105130256512826, 5.105130256512826, 5.163133156657833,
              5.105130256512826, 5.105130256512826, 5.15950797539877,
              5.15950797539877, 6.218060903045153, 5.170383519175958,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.105130256512826, 5.170383519175958,
              5.163133156657833, 5.163133156657833, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.1087554377718885, 5.1087554377718885, 5.163133156657833,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.163133156657833, 5.163133156657833, 5.163133156657833,
              5.163133156657833, 5.163133156657833, 5.163133156657833,
              5.163133156657833, 5.1087554377718885, 5.105130256512826,
              5.170383519175958, 5.170383519175958, 5.105130256512826,
              5.087004350217511, 5.087004350217511, 5.232011600580029,
              5.232011600580029, 5.232011600580029, 5.232011600580029,
              5.232011600580029, 5.232011600580029, 5.116005800290014,
              5.232011600580029, 5.232011600580029, 5.15950797539877,
              5.15950797539877, 5.170383519175958, 25.65990799539977,
              5.079753987699385, 5.079753987699385, 5.079753987699385,
              5.155882794139707, 5.232011600580029, 5.170383519175958,
              5.116005800290014, 5.116005800290014, 5.170383519175958,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.170383519175958, 5.116005800290014,
              5.170383519175958, 5.1305065253262665, 5.1305065253262665,
              5.105130256512826, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.170383519175958, 5.105130256512826,
              5.217510875543777, 5.105130256512826, 5.2138856942847145,
              5.097879893994699, 5.097879893994699, 5.097879893994699,
              5.097879893994699, 5.097879893994699, 5.097879893994699,
              5.105130256512826, 5.116005800290014, 5.264638231911595,
              5.116005800290014, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.076128806440322, 5.1413820691034555,
              5.170383519175958, 5.170383519175958, 5.1087554377718885,
              5.105130256512826, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.170383519175958,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.101505075253763, 5.101505075253763, 5.0688784439221966,
              5.170383519175958, 5.170383519175958, 5.170383519175958,
              5.170383519175958, 5.177633881694085, 5.1087554377718885,
              5.1413820691034555, 5.1413820691034555, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.166758337916896, 5.166758337916896,
              5.166758337916896, 5.155882794139707, 5.177633881694085,
              5.116005800290014, 5.137756887844392, 5.137756887844392,
              5.1413820691034555, 5.1413820691034555, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.116005800290014, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.097879893994699, 5.105130256512826, 5.1087554377718885,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.105130256512826, 5.1087554377718885, 5.1087554377718885,
              5.1087554377718885, 5.116005800290014, 5.116005800290014,
              5.076128806440322, 5.112380619030952, 5.112380619030952,
              5.101505075253763, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.116005800290014, 5.1087554377718885,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.1087554377718885, 5.1087554377718885, 5.1087554377718885,
              5.1087554377718885, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.1087554377718885, 5.116005800290014,
              5.268263413170659, 5.268263413170659, 5.268263413170659,
              5.087004350217511, 5.087004350217511, 5.105130256512826,
              5.105130256512826, 5.1087554377718885, 5.268263413170659,
              5.1087554377718885, 5.105130256512826, 5.1087554377718885,
              5.105130256512826, 5.395144757237862, 5.54015200760038,
              5.072503625181259, 5.105130256512826, 5.232011600580029,
              5.232011600580029, 5.072503625181259, 6.446447322366119,
              5.2138856942847145, 5.087004350217511, 5.072503625181259,
              5.181259062953147, 5.090629531476574, 5.902670133506676,
              5.2863893194659735, 5.0688784439221966, 5.134131706585329,
              5.105130256512826, 5.105130256512826, 5.148632431621581,
              5.083379168958448, 5.083379168958448, 5.079753987699385,
              5.116005800290014, 5.0688784439221966, 5.1413820691034555,
              5.2863893194659735, 5.0688784439221966, 5.54015200760038,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.2138856942847145, 5.090629531476574, 5.2138856942847145,
              5.137756887844392, 5.2138856942847145, 5.25738786939347,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 6.68208410420521,
              5.079753987699385, 5.1957597879894, 5.087004350217511,
              5.076128806440322, 5.101505075253763, 5.087004350217511,
              5.181259062953147, 5.0688784439221966, 5.155882794139707,
              6.083929196459823, 5.2863893194659735, 5.087004350217511,
              5.079753987699385, 5.123256162808141, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.116005800290014,
              5.145007250362518, 5.358892944647232, 5.101505075253763,
              5.192134606730336, 5.087004350217511, 5.0688784439221966,
              5.0688784439221966, 5.431396569828491, 5.0688784439221966,
              5.079753987699385, 5.279138956947848, 5.137756887844392,
              5.087004350217511, 5.076128806440322, 5.474898744937247,
              5.1087554377718885, 5.094254712735637, 5.1305065253262665,
              5.072503625181259, 5.083379168958448, 5.177633881694085,
              5.268263413170659, 5.358892944647232, 5.1087554377718885,
              5.087004350217511, 5.2138856942847145, 5.105130256512826,
              5.2138856942847145, 5.112380619030952, 5.177633881694085,
              5.721411070553527, 5.721411070553527, 5.097879893994699,
              5.177633881694085, 5.112380619030952, 5.250137506875344,
              5.692409620481024, 6.62045602280114, 5.830166508325417,
              5.648907445372268, 5.373393669683484, 5.587279363968198,
              7.5593779688984455, 5.2030101505075255, 5.395144757237862,
              5.1957597879894, 6.145557277863893, 5.177633881694085,
              5.41689584479224, 5.242887144357218, 5.351642582129107,
              5.522026101305065, 5.1305065253262665, 5.456772838641932,
              5.522026101305065, 5.1957597879894, 5.630781539076954,
              5.460398019900995, 5.456772838641932, 6.410195509775489,
              5.757662883144157, 5.358892944647232, 5.308140407020351,
              5.2863893194659735, 5.15950797539877, 5.522026101305065,
              5.413270663533177, 5.576403820191009, 5.395144757237862,
              5.105130256512826, 5.261013050652533, 5.105130256512826,
              5.391519575978799, 5.105130256512826, 5.105130256512826,
              5.377018850942547, 5.228386419320966, 5.2030101505075255,
              5.54015200760038, 6.856092804640232, 5.431396569828491,
              5.250137506875344, 5.2030101505075255, 5.427771388569428,
              5.177633881694085, 5.467648382419121, 5.467648382419121,
              5.467648382419121, 5.438646932346617, 7.171483574178708,
              5.837416870843542, 5.837416870843542, 5.1413820691034555,
              5.395144757237862, 5.358892944647232, 5.348017400870043,
              5.348017400870043, 5.105130256512826, 5.166758337916896,
              5.525651282564128, 5.373393669683484, 5.612655632781639,
              5.576403820191009, 5.648907445372268, 5.2863893194659735,
              5.079753987699385, 5.358892944647232, 5.105130256512826,
              5.22113605680284, 5.112380619030952, 5.083379168958448,
              5.427771388569428, 6.3811940597029855, 5.126881344067203,
              5.217510875543777, 5.413270663533177, 5.507525376268814,
              5.413270663533177, 5.1957597879894, 5.377018850942547,
              5.333516675833792, 5.358892944647232, 7.171483574178708,
              5.652532626631332, 5.2138856942847145, 5.105130256512826,
              5.721411070553527, 5.105130256512826, 5.105130256512826,
              5.652532626631332, 5.090629531476574, 6.9430971548577425,
              5.322641132056603, 5.250137506875344, 5.166758337916896,
              5.1413820691034555, 5.105130256512826, 5.73591179558978,
              5.576403820191009, 5.888169408470423, 5.453147657382869,
              5.793914695734787, 7.56662833141657, 5.9642982149107455,
              6.112930646532327, 6.26518825941297, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.076128806440322, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.721411070553527, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.072503625181259, 5.1413820691034555, 5.105130256512826,
              5.0688784439221966, 5.431396569828491, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.2138856942847145, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.123256162808141, 5.174008700435022, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.2138856942847145,
              5.721411070553527, 5.358892944647232, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.431396569828491, 5.177633881694085,
              5.0688784439221966, 5.177633881694085, 5.2863893194659735,
              5.902670133506676, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.721411070553527, 6.083929196459823,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.902670133506676,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.076128806440322, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.087004350217511, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.2138856942847145, 5.0688784439221966,
              5.188509425471274, 5.1413820691034555, 5.087004350217511,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.721411070553527,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.152257612880644, 5.2863893194659735,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.079753987699385, 5.0688784439221966, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              6.083929196459823, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.232011600580029, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 7.171483574178708,
              5.177633881694085, 5.358892944647232, 5.105130256512826,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.902670133506676, 5.177633881694085,
              5.902670133506676, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 6.083929196459823,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.2138856942847145, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.2863893194659735,
              5.431396569828491, 5.358892944647232, 5.177633881694085,
              5.54015200760038, 5.54015200760038, 5.177633881694085,
              5.2863893194659735, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.250137506875344,
              5.358892944647232, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.072503625181259, 5.101505075253763, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.166758337916896, 5.079753987699385,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.101505075253763, 5.0688784439221966,
              5.087004350217511, 5.101505075253763, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.087004350217511, 5.395144757237862,
              5.0688784439221966, 5.358892944647232, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.123256162808141, 5.0688784439221966,
              5.105130256512826, 5.358892944647232, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.2138856942847145, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.123256162808141, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.1413820691034555, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.2138856942847145, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              8.621556077803891, 6.808965448272414, 6.808965448272414,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.1413820691034555, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.087004350217511, 5.087004350217511,
              5.0688784439221966, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.2138856942847145,
              5.105130256512826, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.087004350217511, 5.358892944647232, 5.105130256512826,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.2138856942847145,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.1413820691034555, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.358892944647232, 5.177633881694085,
              5.0688784439221966, 5.467648382419121, 5.721411070553527,
              5.358892944647232, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.155882794139707, 5.105130256512826, 5.105130256512826,
              5.721411070553527, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.105130256512826, 5.105130256512826, 5.358892944647232,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.2138856942847145, 5.177633881694085,
              5.232011600580029, 5.15950797539877, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.413270663533177, 6.808965448272414,
              5.0688784439221966, 5.105130256512826, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.250137506875344,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.105130256512826, 5.15950797539877,
              5.134131706585329, 5.1413820691034555, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.2138856942847145,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 8.621556077803891,
              5.721411070553527, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.076128806440322, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.721411070553527, 5.177633881694085,
              5.177633881694085, 6.083929196459823, 6.083929196459823,
              5.177633881694085, 5.177633881694085, 6.083929196459823,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.177633881694085, 5.902670133506676, 5.902670133506676,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              6.083929196459823, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.355267763388169,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.721411070553527, 5.177633881694085,
              5.395144757237862, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.1413820691034555, 5.2138856942847145, 5.072503625181259,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 6.808965448272414, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.1413820691034555, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.54015200760038, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.721411070553527, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.721411070553527,
              5.54015200760038, 5.721411070553527, 6.156432821641082,
              6.917720886044302, 5.0688784439221966, 5.177633881694085,
              5.105130256512826, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.358892944647232, 5.105130256512826,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.181259062953147,
              5.246512325616281, 5.25738786939347, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.322641132056603, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.087004350217511, 5.076128806440322,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.721411070553527, 5.355267763388169,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.15950797539877, 5.576403820191009, 6.990224511225561,
              5.293639681984099, 5.54015200760038, 5.177633881694085,
              5.2863893194659735, 5.087004350217511, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.105130256512826,
              5.105130256512826, 5.072503625181259, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.105130256512826, 5.1413820691034555, 5.087004350217511,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.431396569828491, 5.090629531476574, 5.105130256512826,
              5.116005800290014, 5.1087554377718885, 5.0688784439221966,
              5.627156357817891, 5.337141857092854, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.2863893194659735, 5.105130256512826, 5.0688784439221966,
              5.340767038351918, 5.232011600580029, 5.083379168958448,
              5.1087554377718885, 5.279138956947848, 5.2863893194659735,
              5.395144757237862, 5.105130256512826, 5.467648382419121,
              5.232011600580029, 5.163133156657833, 5.2863893194659735,
              5.0688784439221966, 5.105130256512826, 5.1413820691034555,
              5.123256162808141, 5.112380619030952, 5.250137506875344,
              5.112380619030952, 5.0688784439221966, 5.079753987699385,
              5.2138856942847145, 5.2863893194659735, 5.0688784439221966,
              5.0688784439221966, 5.087004350217511, 5.0688784439221966,
              5.087004350217511, 5.123256162808141, 5.123256162808141,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.116005800290014, 5.177633881694085,
              5.1413820691034555, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.123256162808141,
              5.177633881694085, 5.105130256512826, 5.072503625181259,
              5.105130256512826, 5.105130256512826, 5.250137506875344,
              5.28276413820691, 5.395144757237862, 5.395144757237862,
              5.250137506875344, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.2138856942847145,
              5.0688784439221966, 5.123256162808141, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              6.083929196459823, 5.235636781839092, 5.177633881694085,
              5.2138856942847145, 5.163133156657833, 5.250137506875344,
              5.177633881694085, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.1413820691034555, 5.094254712735637,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.123256162808141, 5.177633881694085,
              5.0688784439221966, 5.087004350217511, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.467648382419121, 5.105130256512826, 5.177633881694085,
              5.105130256512826, 5.250137506875344, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.123256162808141, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.358892944647232,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.431396569828491, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.1413820691034555,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.54015200760038, 5.54015200760038,
              5.177633881694085, 5.177633881694085, 5.54015200760038,
              5.2863893194659735, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.358892944647232,
              5.467648382419121, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.112380619030952, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.54015200760038, 5.177633881694085,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.2138856942847145,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.177633881694085,
              5.123256162808141, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.177633881694085,
              5.522026101305065, 5.105130256512826, 5.0688784439221966,
              5.2863893194659735, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.522026101305065, 5.413270663533177,
              5.467648382419121, 5.395144757237862, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.105130256512826,
              5.072503625181259, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.097879893994699,
              5.148632431621581, 5.148632431621581, 5.105130256512826,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.2138856942847145, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.174008700435022, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.721411070553527, 5.105130256512826, 5.0688784439221966,
              5.2138856942847145, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.123256162808141, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.174008700435022,
              5.105130256512826, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.087004350217511,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.2138856942847145, 5.431396569828491, 5.177633881694085,
              5.54015200760038, 6.446447322366119, 5.358892944647232,
              6.083929196459823, 5.177633881694085, 5.358892944647232,
              6.083929196459823, 5.0688784439221966, 5.358892944647232,
              5.2138856942847145, 5.177633881694085, 5.2138856942847145,
              5.232011600580029, 5.358892944647232, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.54015200760038,
              5.105130256512826, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.2138856942847145, 5.358892944647232,
              5.358892944647232, 5.721411070553527, 5.1305065253262665,
              5.079753987699385, 5.177633881694085, 5.177633881694085,
              6.083929196459823, 5.721411070553527, 5.721411070553527,
              5.721411070553527, 5.358892944647232, 5.0688784439221966,
              5.721411070553527, 5.177633881694085, 5.358892944647232,
              5.250137506875344, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.467648382419121, 5.395144757237862,
              5.413270663533177, 5.522026101305065, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.315390769538477,
              5.1413820691034555, 5.105130256512826, 5.087004350217511,
              5.0688784439221966, 5.0688784439221966, 5.2863893194659735,
              5.721411070553527, 5.612655632781639, 5.358892944647232,
              5.177633881694085, 5.105130256512826, 5.431396569828491,
              5.239261963098155, 5.358892944647232, 5.467648382419121,
              5.105130256512826, 5.1413820691034555, 5.087004350217511,
              5.358892944647232, 5.105130256512826, 5.612655632781639,
              5.2863893194659735, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.087004350217511, 5.0688784439221966, 5.250137506875344,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.105130256512826,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.1413820691034555, 5.177633881694085,
              5.0688784439221966, 5.1413820691034555, 5.177633881694085,
              5.358892944647232, 5.2138856942847145, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.1413820691034555, 5.2138856942847145, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.2863893194659735,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.0688784439221966,
              5.467648382419121, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.50390019500975, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.2863893194659735,
              5.112380619030952, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.54015200760038, 5.177633881694085,
              5.087004350217511, 5.0688784439221966, 5.083379168958448,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.315390769538477,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.105130256512826, 5.0688784439221966, 5.1413820691034555,
              5.1413820691034555, 5.105130256512826, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.1413820691034555, 6.808965448272414,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.097879893994699, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.1413820691034555, 6.808965448272414, 5.721411070553527,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.1413820691034555, 5.0688784439221966, 5.177633881694085,
              5.902670133506676, 5.105130256512826, 5.866418320916046,
              5.721411070553527, 5.177633881694085, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.358892944647232,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.2138856942847145, 5.105130256512826, 5.105130256512826,
              5.250137506875344, 5.2863893194659735, 5.250137506875344,
              5.54015200760038, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.105130256512826, 5.431396569828491,
              5.2863893194659735, 5.938921946097305, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.358892944647232, 5.358892944647232, 5.431396569828491,
              5.0688784439221966, 5.177633881694085, 5.358892944647232,
              5.938921946097305, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.177633881694085,
              5.1413820691034555, 5.2138856942847145, 5.54015200760038,
              5.358892944647232, 5.54015200760038, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.54015200760038, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.268263413170659, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.358892944647232, 5.703285164258213,
              5.358892944647232, 5.2863893194659735, 5.0688784439221966,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.1413820691034555, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.116005800290014,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.2863893194659735, 5.0688784439221966, 5.2138856942847145,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.250137506875344, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.250137506875344, 5.0688784439221966, 5.467648382419121,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.1413820691034555, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.105130256512826,
              5.358892944647232, 5.250137506875344, 5.2138856942847145,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.2863893194659735,
              5.358892944647232, 5.1413820691034555, 5.105130256512826,
              5.177633881694085, 5.1413820691034555, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.105130256512826, 5.2138856942847145, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.358892944647232, 5.177633881694085,
              5.721411070553527, 5.177633881694085, 5.250137506875344,
              5.087004350217511, 5.087004350217511, 5.087004350217511,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.105130256512826,
              5.721411070553527, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.087004350217511, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.721411070553527, 5.177633881694085,
              5.105130256512826, 5.177633881694085, 5.177633881694085,
              5.105130256512826, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.2863893194659735, 5.0688784439221966, 5.177633881694085,
              5.105130256512826, 5.250137506875344, 5.0688784439221966,
              5.358892944647232, 5.087004350217511, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.2863893194659735,
              5.2138856942847145, 5.105130256512826, 5.1413820691034555,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.105130256512826, 5.250137506875344, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.087004350217511, 5.1413820691034555, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.2138856942847145, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.174008700435022, 5.1413820691034555, 5.358892944647232,
              6.26518825941297, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.1413820691034555, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.105130256512826, 5.250137506875344, 5.177633881694085,
              5.177633881694085, 5.250137506875344, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.105130256512826,
              5.1413820691034555, 5.358892944647232, 5.721411070553527,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.322641132056603,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.250137506875344,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.123256162808141, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.105130256512826, 5.1413820691034555, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.1413820691034555,
              5.123256162808141, 5.0688784439221966, 5.2863893194659735,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.2138856942847145, 5.177633881694085, 5.087004350217511,
              5.0688784439221966, 5.431396569828491, 5.105130256512826,
              5.105130256512826, 5.2138856942847145, 5.072503625181259,
              5.105130256512826, 5.076128806440322, 5.123256162808141,
              5.2863893194659735, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.123256162808141,
              5.0688784439221966, 5.123256162808141, 5.112380619030952,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.902670133506676, 5.177633881694085, 5.105130256512826,
              5.2138856942847145, 5.2863893194659735, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.431396569828491, 5.311765588279414,
              5.2138856942847145, 5.902670133506676, 5.358892944647232,
              5.902670133506676, 5.358892944647232, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.123256162808141,
              5.177633881694085, 5.123256162808141, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.2030101505075255, 5.152257612880644, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.2138856942847145,
              5.358892944647232, 5.387894394719736, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.358892944647232,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.1413820691034555,
              5.105130256512826, 5.105130256512826, 5.358892944647232,
              5.2863893194659735, 5.083379168958448, 5.0688784439221966,
              5.087004350217511, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.1413820691034555,
              5.126881344067203, 5.105130256512826, 5.1087554377718885,
              5.105130256512826, 5.1087554377718885, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.090629531476574, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.087004350217511,
              5.105130256512826, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.105130256512826, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.2863893194659735,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.902670133506676, 5.0688784439221966, 5.1413820691034555,
              5.1413820691034555, 6.410195509775489, 5.822916145807291,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              6.083929196459823, 6.083929196459823, 5.250137506875344,
              5.0688784439221966, 5.685159257962898, 5.685159257962898,
              5.54015200760038, 5.105130256512826, 5.54015200760038,
              5.358892944647232, 5.721411070553527, 5.358892944647232,
              5.902670133506676, 5.105130256512826, 5.105130256512826,
              6.37394369718486, 5.0688784439221966, 5.0688784439221966,
              5.648907445372268, 5.721411070553527, 6.37394369718486,
              5.844667233361668, 5.721411070553527, 5.721411070553527,
              5.721411070553527, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.358892944647232,
              5.0688784439221966, 5.648907445372268, 5.358892944647232,
              5.177633881694085, 5.105130256512826, 5.340767038351918,
              5.177633881694085, 5.54015200760038, 5.177633881694085,
              5.105130256512826, 5.721411070553527, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.105130256512826,
              5.0688784439221966, 5.358892944647232, 5.250137506875344,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.072503625181259,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.134131706585329, 5.0688784439221966, 5.087004350217511,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.2138856942847145, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.721411070553527, 5.0688784439221966, 5.0688784439221966,
              5.083379168958448, 5.090629531476574, 5.0688784439221966,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.079753987699385,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.087004350217511, 5.2138856942847145, 5.250137506875344,
              5.15950797539877, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.174008700435022, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.2138856942847145,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.232011600580029,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.1413820691034555, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.358892944647232,
              5.105130256512826, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.1957597879894, 5.177633881694085, 5.2138856942847145,
              5.54015200760038, 5.250137506875344, 5.105130256512826,
              5.177633881694085, 6.174558727936397, 5.177633881694085,
              5.0688784439221966, 5.54015200760038, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.105130256512826,
              5.1413820691034555, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.250137506875344, 5.2138856942847145,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.1413820691034555,
              5.358892944647232, 5.0688784439221966, 5.721411070553527,
              5.105130256512826, 5.105130256512826, 5.54015200760038,
              5.1413820691034555, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.250137506875344, 5.105130256512826,
              5.105130256512826, 5.1413820691034555, 5.358892944647232,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.721411070553527,
              5.0688784439221966, 5.1957597879894, 5.163133156657833,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.105130256512826, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.0688784439221966,
              5.358892944647232, 5.242887144357218, 5.177633881694085,
              5.2138856942847145, 5.0688784439221966, 5.105130256512826,
              5.174008700435022, 5.1413820691034555, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.2138856942847145,
              5.1957597879894, 5.54015200760038, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.137756887844392,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.123256162808141,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.1413820691034555, 5.2138856942847145,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.15950797539877, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 6.808965448272414,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.721411070553527, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.1413820691034555, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 5.358892944647232,
              5.358892944647232, 5.15950797539877, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.177633881694085, 5.0688784439221966,
              5.170383519175958, 5.0688784439221966, 5.105130256512826,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.174008700435022, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.105130256512826, 5.1413820691034555,
              5.105130256512826, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.2138856942847145,
              5.0688784439221966, 5.105130256512826, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.105130256512826, 5.721411070553527, 5.322641132056603,
              5.123256162808141, 6.808965448272414, 5.1413820691034555,
              6.083929196459823, 5.366143307165358, 5.094254712735637,
              5.0688784439221966, 5.721411070553527, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.097879893994699,
              5.25738786939347, 5.315390769538477, 5.177633881694085,
              5.467648382419121, 5.0688784439221966, 6.083929196459823,
              5.087004350217511, 5.0688784439221966, 5.358892944647232,
              5.721411070553527, 5.177633881694085, 5.721411070553527,
              5.358892944647232, 5.358892944647232, 5.721411070553527,
              5.355267763388169, 5.2138856942847145, 5.721411070553527,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.721411070553527, 5.721411070553527, 5.177633881694085,
              5.0688784439221966, 6.446447322366119, 5.097879893994699,
              5.177633881694085, 5.54015200760038, 5.177633881694085,
              5.1413820691034555, 5.355267763388169, 5.0688784439221966,
              5.721411070553527, 5.1413820691034555, 5.576403820191009,
              7.534001700085004, 5.721411070553527, 5.358892944647232,
              5.2138856942847145, 6.083929196459823, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.355267763388169,
              5.210260513025651, 5.322641132056603, 5.123256162808141,
              6.083929196459823, 5.1413820691034555, 5.0688784439221966,
              5.721411070553527, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.0688784439221966, 5.612655632781639,
              5.0688784439221966, 5.2972648632431625, 5.355267763388169,
              5.0688784439221966, 5.308140407020351, 5.431396569828491,
              6.808965448272414, 5.0688784439221966, 5.126881344067203,
              5.648907445372268, 5.54015200760038, 5.0688784439221966,
              6.083929196459823, 5.721411070553527, 5.721411070553527,
              5.358892944647232, 5.54015200760038, 5.54015200760038,
              5.0688784439221966, 5.0688784439221966, 5.721411070553527,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.250137506875344, 5.1413820691034555,
              5.358892944647232, 5.358892944647232, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.1413820691034555,
              5.358892944647232, 5.0688784439221966, 5.721411070553527,
              5.0688784439221966, 5.358892944647232, 5.721411070553527,
              5.1413820691034555, 5.623531176558828, 5.0688784439221966,
              5.2138856942847145, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.721411070553527, 5.721411070553527,
              5.54015200760038, 6.776338816940847, 5.177633881694085,
              5.2138856942847145, 5.2863893194659735, 5.322641132056603,
              5.358892944647232, 5.177633881694085, 5.2138856942847145,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.358892944647232,
              6.26518825941297, 5.0688784439221966, 5.181259062953147,
              5.0688784439221966, 5.0688784439221966, 5.696034801740087,
              5.358892944647232, 5.358892944647232, 5.721411070553527,
              5.2138856942847145, 5.721411070553527, 5.721411070553527,
              5.072503625181259, 5.177633881694085, 5.0688784439221966,
              5.902670133506676, 5.54015200760038, 5.50390019500975,
              5.304515225761288, 5.358892944647232, 5.355267763388169,
              5.0688784439221966, 5.866418320916046, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.177633881694085,
              5.54015200760038, 5.0688784439221966, 5.721411070553527,
              5.0688784439221966, 5.177633881694085, 5.435021751087555,
              6.446447322366119, 5.721411070553527, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.145007250362518, 5.344392219610981,
              5.087004350217511, 5.54015200760038, 5.083379168958448,
              5.0688784439221966, 5.15950797539877, 5.177633881694085,
              5.105130256512826, 5.2247612380619035, 5.2138856942847145,
              5.0688784439221966, 5.152257612880644, 5.090629531476574,
              5.137756887844392, 5.177633881694085, 5.2138856942847145,
              5.090629531476574, 5.2138856942847145, 5.2138856942847145,
              5.177633881694085, 5.155882794139707, 5.2138856942847145,
              5.105130256512826, 5.134131706585329, 5.145007250362518,
              5.268263413170659, 5.155882794139707, 5.148632431621581,
              5.177633881694085, 5.090629531476574, 5.355267763388169,
              5.275513775688784, 5.087004350217511, 5.123256162808141,
              5.137756887844392, 5.268263413170659, 5.076128806440322,
              5.105130256512826, 5.123256162808141, 5.105130256512826,
              5.105130256512826, 5.134131706585329, 5.0688784439221966,
              5.087004350217511, 5.087004350217511, 5.235636781839092,
              6.083929196459823, 6.083929196459823, 5.358892944647232,
              5.1413820691034555, 5.177633881694085, 5.268263413170659,
              5.087004350217511, 5.090629531476574, 5.076128806440322,
              5.22113605680284, 5.22113605680284, 5.22113605680284,
              5.22113605680284, 5.1196309815490775, 5.1196309815490775,
              5.746787339366969, 5.217510875543777, 5.743162158107905,
              5.134131706585329, 5.253762688134406, 5.097879893994699,
              5.902670133506676, 5.15950797539877, 5.181259062953147,
              5.177633881694085, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.087004350217511, 5.431396569828491, 5.181259062953147,
              5.177633881694085, 5.116005800290014, 5.261013050652533,
              5.1413820691034555, 5.206635331766588, 5.206635331766588,
              5.268263413170659, 5.239261963098155, 5.232011600580029,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.101505075253763, 5.0688784439221966, 5.087004350217511,
              5.0688784439221966, 5.0688784439221966, 5.192134606730336,
              5.2863893194659735, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.087004350217511,
              5.101505075253763, 5.105130256512826, 5.105130256512826,
              5.177633881694085, 5.0688784439221966, 5.087004350217511,
              5.931671583579179, 5.228386419320966, 5.177633881694085,
              5.235636781839092, 5.087004350217511, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.166758337916896,
              5.177633881694085, 5.228386419320966, 5.134131706585329,
              5.177633881694085, 5.228386419320966, 5.228386419320966,
              5.228386419320966, 5.358892944647232, 5.177633881694085,
              5.097879893994699, 5.250137506875344, 5.242887144357218,
              5.177633881694085, 5.177633881694085, 5.2247612380619035,
              5.2247612380619035, 5.228386419320966, 5.177633881694085,
              5.0688784439221966, 5.358892944647232, 5.721411070553527,
              6.808965448272414, 5.228386419320966, 5.112380619030952,
              5.177633881694085, 5.232011600580029, 5.177633881694085,
              5.721411070553527, 7.171483574178708, 5.126881344067203,
              5.032626631331566, 5.090629531476574, 5.232011600580029,
              5.177633881694085, 5.232011600580029, 5.177633881694085,
              5.06162808140407, 5.087004350217511, 5.177633881694085,
              5.232011600580029, 5.232011600580029, 5.232011600580029,
              5.232011600580029, 5.0688784439221966, 5.232011600580029,
              5.087004350217511, 5.250137506875344, 5.250137506875344,
              5.087004350217511, 5.268263413170659, 5.358892944647232,
              5.358892944647232, 5.449522476123806, 6.808965448272414,
              6.808965448272414, 5.449522476123806, 5.2863893194659735,
              6.808965448272414, 5.177633881694085, 5.137756887844392,
              5.268263413170659, 5.1413820691034555, 5.199384969248462,
              5.0688784439221966, 5.087004350217511, 5.097879893994699,
              5.152257612880644, 5.1413820691034555, 5.0688784439221966,
              5.112380619030952, 5.079753987699385, 5.261013050652533,
              5.1957597879894, 5.083379168958448, 5.126881344067203,
              5.152257612880644, 5.0688784439221966, 8.621556077803891,
              5.087004350217511, 5.293639681984099, 5.097879893994699,
              5.083379168958448, 5.232011600580029, 5.083379168958448,
              5.2138856942847145, 6.083929196459823, 5.087004350217511,
              5.087004350217511, 5.105130256512826, 5.210260513025651,
              5.1957597879894, 5.2138856942847145, 5.2138856942847145,
              5.177633881694085, 5.177633881694085, 5.54015200760038,
              5.358892944647232, 5.112380619030952, 5.1957597879894,
              5.123256162808141, 5.105130256512826, 5.105130256512826,
              5.072503625181259, 5.0688784439221966, 5.090629531476574,
              5.083379168958448, 5.0688784439221966, 5.072503625181259,
              5.300890044502225, 5.1087554377718885, 5.239261963098155,
              5.1087554377718885, 6.446447322366119, 5.101505075253763,
              5.112380619030952, 6.083929196459823, 5.097879893994699,
              5.239261963098155, 5.239261963098155, 5.072503625181259,
              5.536526826341317, 5.242887144357218, 5.1196309815490775,
              5.083379168958448, 5.101505075253763, 5.2138856942847145,
              5.112380619030952, 5.0688784439221966, 5.101505075253763,
              5.072503625181259, 5.079753987699385, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.076128806440322,
              5.072503625181259, 5.2030101505075255, 5.250137506875344,
              5.137756887844392, 5.137756887844392, 5.1196309815490775,
              5.192134606730336, 5.619905995299765, 5.181259062953147,
              5.087004350217511, 5.184884244212211, 5.083379168958448,
              5.148632431621581, 5.22113605680284, 5.22113605680284,
              5.2247612380619035, 5.072503625181259, 5.2972648632431625,
              5.0688784439221966, 5.083379168958448, 5.522026101305065,
              5.460398019900995, 5.148632431621581, 5.076128806440322,
              5.076128806440322, 5.0688784439221966, 5.123256162808141,
              5.253762688134406, 5.094254712735637, 5.228386419320966,
              5.087004350217511, 5.543777188859443, 5.1087554377718885,
              5.083379168958448, 5.090629531476574, 5.101505075253763,
              5.1413820691034555, 5.134131706585329, 5.148632431621581,
              5.177633881694085, 5.072503625181259, 5.076128806440322,
              5.137756887844392, 5.101505075253763, 5.076128806440322,
              5.087004350217511, 5.101505075253763, 5.083379168958448,
              5.152257612880644, 5.322641132056603, 5.0688784439221966,
              5.250137506875344, 6.446447322366119, 5.105130256512826,
              5.1413820691034555, 5.0688784439221966, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.0688784439221966,
              5.177633881694085, 5.56552827641382, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.558277913895695,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.311765588279414, 5.1413820691034555, 5.547402370118506,
              5.547402370118506, 5.268263413170659, 5.2863893194659735,
              5.155882794139707, 5.493024651232561, 5.0688784439221966,
              5.366143307165358, 5.166758337916896, 5.902670133506676,
              5.431396569828491, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.1305065253262665, 6.518950947547378,
              5.899044952247612, 5.126881344067203, 5.090629531476574,
              5.072503625181259, 5.105130256512826, 5.177633881694085,
              5.152257612880644, 5.134131706585329, 5.0688784439221966,
              5.105130256512826, 5.239261963098155, 5.358892944647232,
              5.177633881694085, 5.0688784439221966, 5.134131706585329,
              5.268263413170659, 5.177633881694085, 5.094254712735637,
              5.0688784439221966, 5.2138856942847145, 5.076128806440322,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.105130256512826, 5.268263413170659,
              5.105130256512826, 5.525651282564128, 5.268263413170659,
              5.232011600580029, 5.155882794139707, 5.1413820691034555,
              5.123256162808141, 5.076128806440322, 5.105130256512826,
              5.105130256512826, 5.177633881694085, 5.250137506875344,
              5.250137506875344, 6.566078303915196, 5.105130256512826,
              5.2138856942847145, 5.92079603980199, 5.072503625181259,
              5.25738786939347, 5.097879893994699, 5.0688784439221966,
              5.123256162808141, 5.1957597879894, 5.177633881694085,
              5.083379168958448, 5.1413820691034555, 5.105130256512826,
              5.101505075253763, 5.322641132056603, 5.250137506875344,
              5.322641132056603, 5.253762688134406, 5.083379168958448,
              5.15950797539877, 5.076128806440322, 5.22113605680284,
              5.217510875543777, 5.177633881694085, 5.358892944647232,
              5.087004350217511, 5.177633881694085, 5.105130256512826,
              5.170383519175958, 5.31901595079754, 5.902670133506676,
              5.0688784439221966, 5.0688784439221966, 5.721411070553527,
              5.087004350217511, 5.126881344067203, 5.177633881694085,
              5.101505075253763, 5.0688784439221966, 6.2035601780089005,
              5.322641132056603, 5.137756887844392, 5.126881344067203,
              5.250137506875344, 5.192134606730336, 5.177633881694085,
              5.902670133506676, 5.112380619030952, 5.0688784439221966,
              5.105130256512826, 5.358892944647232, 5.928046402320116,
              5.123256162808141, 5.358892944647232, 5.522026101305065,
              5.2863893194659735, 5.2863893194659735, 5.0688784439221966,
              5.0688784439221966, 5.137756887844392, 5.174008700435022,
              5.105130256512826, 5.15950797539877, 5.087004350217511,
              5.0688784439221966, 7.534001700085004, 5.177633881694085,
              5.148632431621581, 5.105130256512826, 6.319565978298915,
              5.322641132056603, 5.2863893194659735, 5.424146207310366,
              5.268263413170659, 5.721411070553527, 5.199384969248462,
              5.210260513025651, 5.0688784439221966, 5.087004350217511,
              5.105130256512826, 5.087004350217511, 5.163133156657833,
              5.199384969248462, 5.184884244212211, 5.340767038351918,
              5.177633881694085, 5.1957597879894, 5.079753987699385,
              5.090629531476574, 5.083379168958448, 5.177633881694085,
              5.358892944647232, 6.000550027501375, 5.1413820691034555,
              5.2138856942847145, 5.355267763388169, 5.094254712735637,
              5.090629531476574, 5.1413820691034555, 5.485774288714436,
              5.0688784439221966, 5.184884244212211, 5.0688784439221966,
              6.000550027501375, 5.279138956947848, 5.848292414620731,
              5.087004350217511, 5.0688784439221966, 5.2138856942847145,
              5.148632431621581, 5.0688784439221966, 5.2863893194659735,
              5.177633881694085, 5.322641132056603, 5.1413820691034555,
              5.0688784439221966, 6.116555827791389, 5.358892944647232,
              5.1413820691034555, 5.2138856942847145, 5.250137506875344,
              5.177633881694085, 5.177633881694085, 5.275513775688784,
              5.721411070553527, 5.902670133506676, 5.094254712735637,
              5.148632431621581, 5.28276413820691, 5.0688784439221966,
              5.358892944647232, 5.2138856942847145, 5.358892944647232,
              5.888169408470423, 7.733386669333466, 6.431946597329866,
              5.083379168958448, 5.112380619030952, 5.0688784439221966,
              5.1413820691034555, 5.177633881694085, 5.8700435021751085,
              5.15950797539877, 5.2138856942847145, 5.250137506875344,
              5.181259062953147, 5.0688784439221966, 5.0688784439221966,
              5.340767038351918, 5.329891494574729, 5.206635331766588,
              5.358892944647232, 5.300890044502225, 5.358892944647232,
              5.250137506875344, 5.648907445372268, 5.92079603980199,
              5.721411070553527, 5.105130256512826, 5.184884244212211,
              5.105130256512826, 5.126881344067203, 5.0688784439221966,
              5.377018850942547, 5.170383519175958, 5.2863893194659735,
              5.087004350217511, 5.079753987699385, 5.116005800290014,
              5.0688784439221966, 5.362518125906296, 5.087004350217511,
              5.087004350217511, 5.395144757237862, 5.0688784439221966,
              5.101505075253763, 5.783039151957598, 6.029551477573879,
              5.906295314765738, 5.3806440322016105, 5.721411070553527,
              5.395144757237862, 5.134131706585329, 5.105130256512826,
              5.775788789439472, 5.177633881694085, 5.105130256512826,
              5.358892944647232, 5.2138856942847145, 5.148632431621581,
              5.123256162808141, 5.358892944647232, 5.177633881694085,
              5.148632431621581, 5.3697684884244214, 5.431396569828491,
              5.177633881694085, 5.703285164258213, 5.395144757237862,
              5.0688784439221966, 5.177633881694085, 5.2138856942847145,
              5.358892944647232, 5.087004350217511, 5.250137506875344,
              5.92079603980199, 5.112380619030952, 5.460398019900995,
              5.134131706585329, 5.134131706585329, 5.083379168958448,
              5.097879893994699, 5.384269213460673, 5.090629531476574,
              5.830166508325417, 5.630781539076954, 5.1413820691034555,
              5.1413820691034555, 5.177633881694085, 5.152257612880644,
              5.54015200760038, 5.250137506875344, 5.083379168958448,
              5.0688784439221966, 5.358892944647232, 5.15950797539877,
              5.232011600580029, 5.2138856942847145, 5.134131706585329,
              5.0688784439221966, 5.913545677283865, 5.431396569828491,
              5.652532626631332, 5.518400920046003, 5.105130256512826,
              5.2138856942847145, 5.2138856942847145, 5.2138856942847145,
              5.134131706585329, 5.087004350217511, 5.148632431621581,
              5.909920496024801, 5.4640232011600585, 5.1413820691034555,
              5.2138856942847145, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.174008700435022,
              5.391519575978799, 5.177633881694085, 5.73591179558978,
              5.0688784439221966, 5.0688784439221966, 5.184884244212211,
              6.083929196459823, 5.228386419320966, 5.097879893994699,
              5.0688784439221966, 5.1413820691034555, 5.2863893194659735,
              5.15950797539877, 5.0688784439221966, 5.1957597879894,
              5.92079603980199, 5.358892944647232, 5.395144757237862,
              5.909920496024801, 5.087004350217511, 5.155882794139707,
              5.087004350217511, 5.177633881694085, 5.148632431621581,
              6.01867593379669, 5.155882794139707, 5.1413820691034555,
              5.0688784439221966, 5.300890044502225, 5.087004350217511,
              5.1087554377718885, 5.083379168958448, 5.1305065253262665,
              5.105130256512826, 5.1087554377718885, 5.993299664983249,
              5.177633881694085, 5.123256162808141, 5.304515225761288,
              5.25738786939347, 5.105130256512826, 5.079753987699385,
              5.8700435021751085, 6.228936446822341, 5.768538426921346,
              5.25738786939347, 6.627706385319266, 6.123806190309516,
              5.079753987699385, 5.630781539076954, 5.134131706585329,
              5.105130256512826, 5.293639681984099, 6.990224511225561,
              6.663958197909896, 5.467648382419121, 5.522026101305065,
              5.087004350217511, 5.242887144357218, 5.170383519175958,
              5.192134606730336, 5.101505075253763, 5.105130256512826,
              5.1413820691034555, 5.199384969248462, 5.181259062953147,
              6.580579028951448, 5.137756887844392, 5.0688784439221966,
              5.192134606730336, 5.079753987699385, 5.1196309815490775,
              5.232011600580029, 5.105130256512826, 5.358892944647232,
              5.0688784439221966, 5.228386419320966, 5.15950797539877,
              5.304515225761288, 5.648907445372268, 5.0688784439221966,
              5.097879893994699, 5.134131706585329, 5.268263413170659,
              5.079753987699385, 5.228386419320966, 5.268263413170659,
              5.123256162808141, 5.395144757237862, 5.790289514475724,
              5.177633881694085, 5.413270663533177, 5.123256162808141,
              5.44227211360568, 5.329891494574729, 5.1413820691034555,
              5.177633881694085, 5.228386419320966, 5.228386419320966,
              5.228386419320966, 5.192134606730336, 5.993299664983249,
              5.3697684884244214, 5.094254712735637, 5.199384969248462,
              5.097879893994699, 5.177633881694085, 5.793914695734787,
              5.431396569828491, 5.938921946097305, 5.083379168958448,
              5.166758337916896, 5.793914695734787, 5.264638231911595,
              5.072503625181259, 5.656157807890395, 5.54015200760038,
              5.087004350217511, 5.0688784439221966, 6.011425571278564,
              5.090629531476574, 5.431396569828491, 5.083379168958448,
              5.105130256512826, 5.123256162808141, 5.1413820691034555,
              5.206635331766588, 5.112380619030952, 5.134131706585329,
              5.0688784439221966, 5.264638231911595, 5.377018850942547,
              5.0688784439221966, 5.246512325616281, 5.101505075253763,
              5.112380619030952, 5.097879893994699, 5.090629531476574,
              5.246512325616281, 5.0688784439221966, 5.134131706585329,
              5.177633881694085, 5.177633881694085, 5.210260513025651,
              5.395144757237862, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.844667233361668, 5.909920496024801,
              5.721411070553527, 5.112380619030952, 6.754587729386469,
              5.152257612880644, 5.126881344067203, 5.485774288714436,
              5.170383519175958, 5.126881344067203, 5.177633881694085,
              5.087004350217511, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.2863893194659735, 5.2863893194659735,
              5.358892944647232, 5.105130256512826, 5.177633881694085,
              5.358892944647232, 5.232011600580029, 5.0688784439221966,
              5.101505075253763, 5.783039151957598, 5.1305065253262665,
              5.094254712735637, 5.094254712735637, 5.184884244212211,
              5.54015200760038, 5.072503625181259, 5.181259062953147,
              5.184884244212211, 5.1413820691034555, 5.105130256512826,
              5.1957597879894, 5.250137506875344, 5.094254712735637,
              5.087004350217511, 5.123256162808141, 5.126881344067203,
              5.083379168958448, 5.1413820691034555, 5.184884244212211,
              5.1957597879894, 5.188509425471274, 5.413270663533177,
              5.137756887844392, 6.410195509775489, 5.54015200760038,
              5.54015200760038, 5.232011600580029, 5.2138856942847145,
              5.0688784439221966, 5.083379168958448, 5.232011600580029,
              5.097879893994699, 5.163133156657833, 5.0688784439221966,
              5.54015200760038, 5.090629531476574, 5.228386419320966,
              5.087004350217511, 5.087004350217511, 5.087004350217511,
              5.123256162808141, 5.1413820691034555, 5.2138856942847145,
              5.2138856942847145, 5.087004350217511, 5.087004350217511,
              5.1413820691034555, 5.090629531476574, 5.206635331766588,
              5.123256162808141, 5.145007250362518, 5.145007250362518,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.358892944647232,
              5.358892944647232, 5.2138856942847145, 5.0688784439221966,
              5.123256162808141, 5.148632431621581, 5.087004350217511,
              5.217510875543777, 5.250137506875344, 5.250137506875344,
              5.087004350217511, 5.123256162808141, 5.087004350217511,
              5.083379168958448, 5.0688784439221966, 5.087004350217511,
              5.123256162808141, 5.41689584479224, 5.304515225761288,
              5.101505075253763, 5.072503625181259, 5.0688784439221966,
              5.087004350217511, 5.358892944647232, 5.152257612880644,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.083379168958448, 5.072503625181259,
              5.358892944647232, 5.902670133506676, 5.902670133506676,
              5.358892944647232, 5.177633881694085, 5.583654182709136,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.902670133506676, 5.181259062953147, 6.627706385319266,
              5.083379168958448, 5.076128806440322, 5.902670133506676,
              5.358892944647232, 5.177633881694085, 5.134131706585329,
              5.467648382419121, 5.609030451522576, 5.087004350217511,
              5.105130256512826, 5.1413820691034555, 5.0688784439221966,
              5.206635331766588, 5.358892944647232, 5.094254712735637,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.177633881694085, 5.703285164258213,
              5.105130256512826, 6.26518825941297, 5.184884244212211,
              5.177633881694085, 5.105130256512826, 5.2863893194659735,
              5.239261963098155, 5.902670133506676, 5.148632431621581,
              5.177633881694085, 5.387894394719736, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.648907445372268, 5.485774288714436,
              5.199384969248462, 5.721411070553527, 5.902670133506676,
              5.358892944647232, 6.083929196459823, 6.083929196459823,
              5.449522476123806, 5.358892944647232, 5.358892944647232,
              5.079753987699385, 5.496649832491625, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.076128806440322,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.094254712735637, 5.177633881694085, 5.105130256512826,
              5.087004350217511, 5.087004350217511, 5.358892944647232,
              5.112380619030952, 5.1196309815490775, 5.0688784439221966,
              5.0688784439221966, 6.083929196459823, 5.0688784439221966,
              5.54015200760038, 5.177633881694085, 5.087004350217511,
              5.177633881694085, 5.112380619030952, 5.0688784439221966,
              5.1196309815490775, 5.083379168958448, 5.0688784439221966,
              41.24818740937047, 5.329891494574729, 5.177633881694085,
              5.2863893194659735, 5.0688784439221966, 6.26518825941297,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.126881344067203, 5.177633881694085,
              5.101505075253763, 5.1413820691034555, 5.0688784439221966,
              5.322641132056603, 5.177633881694085, 5.0688784439221966,
              5.54015200760038, 5.079753987699385, 6.312315615780789,
              5.311765588279414, 5.268263413170659, 5.268263413170659,
              19.49709985499275, 8.621556077803891, 5.0688784439221966,
              5.0688784439221966, 5.181259062953147, 5.087004350217511,
              5.087004350217511, 5.087004350217511, 5.1413820691034555,
              5.1413820691034555, 5.177633881694085, 5.0688784439221966,
              5.188509425471274, 5.087004350217511, 5.268263413170659,
              5.1413820691034555, 5.1413820691034555, 5.0688784439221966,
              5.087004350217511, 5.1413820691034555, 5.087004350217511,
              5.105130256512826, 5.1413820691034555, 5.721411070553527,
              5.358892944647232, 5.721411070553527, 5.721411070553527,
              5.377018850942547, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.431396569828491, 6.083929196459823,
              5.087004350217511, 5.087004350217511, 5.54015200760038,
              5.076128806440322, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.322641132056603,
              5.1413820691034555, 5.177633881694085, 5.0688784439221966,
              5.148632431621581, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.721411070553527,
              5.358892944647232, 5.721411070553527, 5.250137506875344,
              5.087004350217511, 22.215985799289964, 5.54015200760038,
              5.358892944647232, 5.199384969248462, 5.1413820691034555,
              5.358892944647232, 5.155882794139707, 5.232011600580029,
              5.1413820691034555, 5.137756887844392, 5.54015200760038,
              5.177633881694085, 5.210260513025651, 5.467648382419121,
              5.177633881694085, 5.358892944647232, 5.192134606730336,
              5.271888594429721, 5.351642582129107, 5.85916795839792,
              5.177633881694085, 5.177633881694085, 5.072503625181259,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.072503625181259, 5.902670133506676, 5.177633881694085,
              5.177633881694085, 5.902670133506676, 5.358892944647232,
              5.1413820691034555, 5.137756887844392, 5.0688784439221966,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.235636781839092, 6.26518825941297,
              5.087004350217511, 5.112380619030952, 5.358892944647232,
              5.079753987699385, 5.902670133506676, 5.902670133506676,
              5.087004350217511, 5.087004350217511, 8.621556077803891,
              5.116005800290014, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.177633881694085,
              5.145007250362518, 5.087004350217511, 5.358892944647232,
              5.656157807890395, 5.268263413170659, 5.105130256512826,
              7.954522726136307, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.902670133506676, 5.902670133506676,
              5.177633881694085, 5.721411070553527, 5.902670133506676,
              5.1413820691034555, 5.242887144357218, 5.087004350217511,
              5.177633881694085, 5.184884244212211, 5.177633881694085,
              5.083379168958448, 5.1413820691034555, 5.177633881694085,
              5.177633881694085, 5.1196309815490775, 5.358892944647232,
              5.076128806440322, 5.177633881694085, 5.087004350217511,
              5.15950797539877, 5.105130256512826, 5.177633881694085,
              5.232011600580029, 5.467648382419121, 5.358892944647232,
              5.358892944647232, 5.137756887844392, 5.358892944647232,
              5.264638231911595, 5.0688784439221966, 5.0688784439221966,
              5.812040602030102, 5.087004350217511, 5.460398019900995,
              5.105130256512826, 5.184884244212211, 5.134131706585329,
              5.358892944647232, 5.097879893994699, 5.105130256512826,
              5.514775738786939, 5.358892944647232, 5.358892944647232,
              5.170383519175958, 5.232011600580029, 5.105130256512826,
              5.177633881694085, 5.087004350217511, 5.250137506875344,
              5.076128806440322, 5.1305065253262665, 5.076128806440322,
              5.177633881694085, 5.097879893994699, 5.105130256512826,
              5.076128806440322, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.275513775688784, 5.177633881694085,
              5.087004350217511, 5.177633881694085, 5.268263413170659,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.072503625181259, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.2247612380619035, 5.0688784439221966,
              5.105130256512826, 5.485774288714436, 5.094254712735637,
              5.268263413170659, 5.268263413170659, 5.148632431621581,
              5.148632431621581, 5.192134606730336, 5.1305065253262665,
              5.50390019500975, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.199384969248462, 5.0688784439221966,
              5.105130256512826, 5.1413820691034555, 5.0688784439221966,
              5.0688784439221966, 5.126881344067203, 5.0688784439221966,
              5.358892944647232, 5.177633881694085, 5.1957597879894,
              5.366143307165358, 5.177633881694085, 5.177633881694085,
              5.1305065253262665, 5.1305065253262665, 5.268263413170659,
              5.268263413170659, 5.1196309815490775, 5.177633881694085,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.210260513025651,
              5.181259062953147, 5.268263413170659, 5.232011600580029,
              5.105130256512826, 5.083379168958448, 5.431396569828491,
              5.2863893194659735, 5.177633881694085, 5.253762688134406,
              5.358892944647232, 5.22113605680284, 5.126881344067203,
              5.358892944647232, 5.902670133506676, 5.54015200760038,
              5.866418320916046, 5.177633881694085, 5.888169408470423,
              5.079753987699385, 5.177633881694085, 7.171483574178708,
              7.171483574178708, 6.3014400720036, 5.449522476123806,
              5.1413820691034555, 5.0688784439221966, 5.902670133506676,
              5.083379168958448, 5.522026101305065, 5.783039151957598,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              6.083929196459823, 5.123256162808141, 6.156432821641082,
              5.177633881694085, 5.250137506875344, 5.087004350217511,
              5.184884244212211, 5.358892944647232, 5.322641132056603,
              5.177633881694085, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.199384969248462, 5.721411070553527,
              5.0688784439221966, 5.358892944647232, 5.721411070553527,
              5.250137506875344, 5.250137506875344, 5.685159257962898,
              5.250137506875344, 6.083929196459823, 5.938921946097305,
              5.177633881694085, 5.2138856942847145, 7.171483574178708,
              6.083929196459823, 6.083929196459823, 5.358892944647232,
              5.083379168958448, 5.2138856942847145, 5.097879893994699,
              5.830166508325417, 5.217510875543777, 5.779413970698535,
              5.25738786939347, 5.25738786939347, 5.779413970698535,
              5.25738786939347, 5.2138856942847145, 5.358892944647232,
              5.2138856942847145, 5.105130256512826, 5.358892944647232,
              5.232011600580029, 5.232011600580029, 5.177633881694085,
              5.217510875543777, 5.2138856942847145, 5.192134606730336,
              5.192134606730336, 5.358892944647232, 5.2138856942847145,
              5.358892944647232, 5.177633881694085, 5.50390019500975,
              6.808965448272414, 5.793914695734787, 8.259037951897595,
              5.177633881694085, 5.105130256512826, 5.1957597879894,
              6.446447322366119, 6.627706385319266, 5.946172308615431,
              5.453147657382869, 6.083929196459823, 5.177633881694085,
              5.076128806440322, 6.990224511225561, 6.083929196459823,
              5.902670133506676, 5.177633881694085, 6.083929196459823,
              5.721411070553527, 5.1957597879894, 6.083929196459823,
              5.087004350217511, 12.971773588679433, 5.522026101305065,
              5.177633881694085, 5.250137506875344, 5.358892944647232,
              5.358892944647232, 5.2138856942847145, 5.322641132056603,
              5.177633881694085, 5.087004350217511, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.177633881694085,
              5.358892944647232, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 8.621556077803891,
              5.0688784439221966, 5.358892944647232, 5.105130256512826,
              5.358892944647232, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.902670133506676,
              8.621556077803891, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 6.083929196459823, 5.177633881694085,
              5.812040602030102, 6.627706385319266, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              12.246737336866843, 5.1413820691034555, 5.177633881694085,
              5.105130256512826, 5.177633881694085, 8.621556077803891,
              5.177633881694085, 5.340767038351918, 5.083379168958448,
              5.340767038351918, 5.7141607080354015, 5.0688784439221966,
              5.279138956947848, 5.177633881694085, 5.431396569828491,
              5.134131706585329, 5.094254712735637, 5.2138856942847145,
              5.1413820691034555, 5.1957597879894, 6.1926846342317114,
              5.148632431621581, 5.123256162808141, 5.2138856942847145,
              5.177633881694085, 5.0688784439221966, 5.250137506875344,
              5.1087554377718885, 5.087004350217511, 5.087004350217511,
              5.1087554377718885, 5.101505075253763, 5.083379168958448,
              5.087004350217511, 5.097879893994699, 5.192134606730336,
              7.497749887494375, 5.170383519175958, 5.279138956947848,
              5.076128806440322, 5.2138856942847145, 5.087004350217511,
              5.090629531476574, 5.083379168958448, 5.076128806440322,
              5.0688784439221966, 5.083379168958448, 6.518950947547378,
              5.15950797539877, 5.22113605680284, 5.083379168958448,
              5.079753987699385, 5.083379168958448, 5.0688784439221966,
              5.101505075253763, 5.170383519175958, 5.083379168958448,
              5.152257612880644, 5.0688784439221966, 5.083379168958448,
              5.2247612380619035, 5.1413820691034555, 5.308140407020351,
              5.076128806440322, 5.177633881694085, 5.0688784439221966,
              5.116005800290014, 5.116005800290014, 5.116005800290014,
              5.25738786939347, 5.184884244212211, 5.0688784439221966,
              5.232011600580029, 5.097879893994699, 5.094254712735637,
              5.163133156657833, 5.177633881694085, 5.076128806440322,
              5.094254712735637, 5.1305065253262665, 5.087004350217511,
              5.097879893994699, 5.076128806440322, 5.112380619030952,
              5.1957597879894, 5.072503625181259, 5.072503625181259,
              5.126881344067203, 5.264638231911595, 5.123256162808141,
              5.083379168958448, 5.076128806440322, 5.076128806440322,
              5.112380619030952, 5.152257612880644, 5.083379168958448,
              5.1087554377718885, 5.152257612880644, 5.366143307165358,
              5.105130256512826, 5.090629531476574, 5.1413820691034555,
              5.112380619030952, 5.079753987699385, 5.087004350217511,
              5.097879893994699, 5.398769938496925, 5.1413820691034555,
              5.090629531476574, 5.087004350217511, 5.398769938496925,
              5.072503625181259, 5.239261963098155, 6.446447322366119,
              5.072503625181259, 5.181259062953147, 5.166758337916896,
              5.087004350217511, 5.105130256512826, 5.105130256512826,
              5.134131706585329, 5.116005800290014, 5.076128806440322,
              5.072503625181259, 5.163133156657833, 5.094254712735637,
              5.199384969248462, 5.170383519175958, 5.105130256512826,
              5.188509425471274, 5.239261963098155, 5.355267763388169,
              5.105130256512826, 5.083379168958448, 5.087004350217511,
              5.174008700435022, 5.079753987699385, 5.1196309815490775,
              5.076128806440322, 5.090629531476574, 5.090629531476574,
              5.329891494574729, 5.1413820691034555, 5.145007250362518,
              5.177633881694085, 5.181259062953147, 5.097879893994699,
              5.087004350217511, 5.126881344067203, 5.152257612880644,
              5.105130256512826, 5.101505075253763, 5.076128806440322,
              5.112380619030952, 5.134131706585329, 5.072503625181259,
              5.087004350217511, 5.094254712735637, 5.116005800290014,
              5.079753987699385, 5.145007250362518, 5.1087554377718885,
              5.090629531476574, 5.126881344067203, 5.134131706585329,
              5.170383519175958, 5.145007250362518, 5.290014500725036,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.1087554377718885, 5.253762688134406, 5.0688784439221966,
              5.250137506875344, 5.0688784439221966, 5.2863893194659735,
              5.079753987699385, 5.192134606730336, 5.1305065253262665,
              5.2247612380619035, 5.097879893994699, 5.083379168958448,
              5.351642582129107, 5.079753987699385, 5.123256162808141,
              5.2138856942847145, 5.101505075253763, 5.090629531476574,
              5.090629531476574, 5.105130256512826, 5.0688784439221966,
              5.206635331766588, 5.152257612880644, 5.087004350217511,
              5.1413820691034555, 5.199384969248462, 5.0688784439221966,
              5.134131706585329, 5.094254712735637, 5.097879893994699,
              5.166758337916896, 5.177633881694085, 5.239261963098155,
              5.116005800290014, 5.087004350217511, 5.155882794139707,
              5.079753987699385, 5.087004350217511, 5.184884244212211,
              5.079753987699385, 5.126881344067203, 5.155882794139707,
              5.2138856942847145, 5.112380619030952, 5.0688784439221966,
              5.0688784439221966, 5.145007250362518, 5.174008700435022,
              5.351642582129107, 5.087004350217511, 5.072503625181259,
              5.076128806440322, 5.094254712735637, 5.126881344067203,
              5.0688784439221966, 5.079753987699385, 5.112380619030952,
              5.079753987699385, 5.177633881694085, 5.15950797539877,
              5.848292414620731, 5.072503625181259, 5.199384969248462,
              5.344392219610981, 5.148632431621581, 5.112380619030952,
              5.148632431621581, 5.1957597879894, 5.931671583579179,
              5.22113605680284, 5.25738786939347, 5.083379168958448,
              5.155882794139707, 5.072503625181259, 5.090629531476574,
              5.112380619030952, 5.076128806440322, 5.2030101505075255,
              5.072503625181259, 5.101505075253763, 5.105130256512826,
              5.435021751087555, 5.083379168958448, 5.192134606730336,
              5.192134606730336, 5.148632431621581, 5.072503625181259,
              5.094254712735637, 5.094254712735637, 5.094254712735637,
              5.094254712735637, 5.094254712735637, 5.105130256512826,
              5.1196309815490775, 5.366143307165358, 5.101505075253763,
              5.181259062953147, 5.087004350217511, 5.083379168958448,
              5.101505075253763, 5.083379168958448, 5.072503625181259,
              5.090629531476574, 5.105130256512826, 5.199384969248462,
              5.155882794139707, 5.087004350217511, 5.079753987699385,
              5.148632431621581, 5.1413820691034555, 5.079753987699385,
              5.116005800290014, 5.072503625181259, 5.112380619030952,
              5.199384969248462, 5.123256162808141, 5.529276463823191,
              5.116005800290014, 5.293639681984099, 5.137756887844392,
              5.145007250362518, 5.15950797539877, 5.413270663533177,
              5.105130256512826, 5.076128806440322, 5.1196309815490775,
              5.079753987699385, 5.105130256512826, 5.072503625181259,
              5.087004350217511, 5.094254712735637, 5.275513775688784,
              5.079753987699385, 5.402395119755988, 5.083379168958448,
              5.112380619030952, 5.076128806440322, 5.2247612380619035,
              5.583654182709136, 5.105130256512826, 5.0688784439221966,
              5.076128806440322, 5.123256162808141, 5.358892944647232,
              5.105130256512826, 7.171483574178708, 5.177633881694085,
              5.079753987699385, 5.239261963098155, 5.177633881694085,
              5.032626631331566, 5.054377718885944, 5.177633881694085,
              5.188509425471274, 5.032626631331566, 5.043502175108755,
              5.083379168958448, 5.3697684884244214, 5.0688784439221966,
              5.032626631331566, 5.239261963098155, 5.054377718885944,
              5.0362518125906295, 5.177633881694085, 5.039876993849693,
              5.239261963098155, 5.039876993849693, 5.039876993849693,
              5.0362518125906295, 5.072503625181259, 5.1413820691034555,
              5.89541977098855, 5.116005800290014, 5.0688784439221966,
              5.039876993849693, 5.177633881694085, 5.123256162808141,
              5.105130256512826, 5.358892944647232, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.2247612380619035,
              5.105130256512826, 5.097879893994699, 5.358892944647232,
              5.177633881694085, 5.358892944647232, 5.083379168958448,
              5.358892944647232, 5.177633881694085, 5.090629531476574,
              5.123256162808141, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.097879893994699, 5.1413820691034555, 5.177633881694085,
              5.177633881694085, 5.101505075253763, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.268263413170659,
              5.1413820691034555, 5.1413820691034555, 5.105130256512826,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.1413820691034555, 5.1957597879894, 5.1413820691034555,
              5.1413820691034555, 5.192134606730336, 5.1413820691034555,
              5.1957597879894, 5.105130256512826, 5.54015200760038,
              6.083929196459823, 10.434146707335367, 5.032626631331566,
              23.122281114055703, 10.434146707335367, 10.434146707335367,
              5.032626631331566, 6.083929196459823, 5.105130256512826,
              5.228386419320966, 5.866418320916046, 5.1413820691034555,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              6.808965448272414, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.072503625181259, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.2138856942847145,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.101505075253763, 5.0688784439221966,
              5.072503625181259, 5.087004350217511, 5.235636781839092,
              5.15950797539877, 5.177633881694085, 5.1087554377718885,
              5.0688784439221966, 5.41689584479224, 5.174008700435022,
              5.101505075253763, 6.627706385319266, 5.105130256512826,
              5.177633881694085, 5.166758337916896, 5.101505075253763,
              5.217510875543777, 5.177633881694085, 5.177633881694085,
              5.170383519175958, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.41689584479224, 5.105130256512826, 5.105130256512826,
              5.134131706585329, 5.177633881694085, 5.358892944647232,
              6.1926846342317114, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.232011600580029,
              5.0688784439221966, 5.232011600580029, 5.090629531476574,
              5.126881344067203, 5.358892944647232, 5.177633881694085,
              5.105130256512826, 5.177633881694085, 5.333516675833792,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.116005800290014, 5.050752537626881, 5.177633881694085,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.420521026051302, 8.621556077803891, 5.112380619030952,
              5.145007250362518, 5.105130256512826, 5.402395119755988,
              5.54015200760038, 5.137756887844392, 5.496649832491625,
              5.087004350217511, 5.116005800290014, 5.097879893994699,
              5.116005800290014, 5.123256162808141, 5.656157807890395,
              5.612655632781639, 5.094254712735637, 5.105130256512826,
              5.126881344067203, 5.126881344067203, 5.467648382419121,
              5.54015200760038, 5.50390019500975, 5.648907445372268,
              5.105130256512826, 6.446447322366119, 6.236186809340467,
              5.105130256512826, 6.069428471423571, 6.808965448272414,
              5.793914695734787, 5.105130256512826, 5.177633881694085,
              5.206635331766588, 5.424146207310366, 5.358892944647232,
              5.206635331766588, 5.116005800290014, 5.116005800290014,
              5.116005800290014, 5.467648382419121, 5.134131706585329,
              5.105130256512826, 5.105130256512826, 5.54015200760038,
              5.293639681984099, 5.630781539076954, 5.076128806440322,
              5.076128806440322, 5.721411070553527, 5.3697684884244214,
              5.105130256512826, 5.583654182709136, 5.688784439221961,
              6.689334466723336, 5.427771388569428, 5.395144757237862,
              5.134131706585329, 5.2247612380619035, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.101505075253763,
              5.105130256512826, 5.2138856942847145, 5.105130256512826,
              5.449522476123806, 5.177633881694085, 5.47852392619631,
              5.358892944647232, 5.431396569828491, 6.26518825941297,
              6.26518825941297, 5.2863893194659735, 5.746787339366969,
              5.373393669683484, 5.116005800290014, 5.572778638931947,
              5.453147657382869, 5.54015200760038, 5.424146207310366,
              5.54015200760038, 5.721411070553527, 5.126881344067203,
              5.105130256512826, 6.544327216360818, 6.181809090454523,
              5.308140407020351, 5.569153457672884, 5.105130256512826,
              5.467648382419121, 5.079753987699385, 5.105130256512826,
              5.177633881694085, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.351642582129107,
              5.261013050652533, 5.1957597879894, 5.322641132056603,
              5.112380619030952, 5.126881344067203, 5.105130256512826,
              5.902670133506676, 5.105130256512826, 5.105130256512826,
              5.2247612380619035, 5.358892944647232, 5.431396569828491,
              5.105130256512826, 5.496649832491625, 5.1087554377718885,
              5.54015200760038, 5.373393669683484, 5.105130256512826,
              5.126881344067203, 5.105130256512826, 5.2138856942847145,
              5.804790239511975, 6.228936446822341, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.116005800290014, 5.685159257962898, 5.083379168958448,
              5.112380619030952, 5.355267763388169, 5.116005800290014,
              5.242887144357218, 5.134131706585329, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.112380619030952,
              5.112380619030952, 5.112380619030952, 5.112380619030952,
              6.2035601780089005, 5.648907445372268, 5.648907445372268,
              5.605405270263513, 5.3806440322016105, 5.210260513025651,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 6.076678833941697, 5.105130256512826,
              5.148632431621581, 5.105130256512826, 5.072503625181259,
              5.449522476123806, 5.85916795839792, 5.076128806440322,
              5.072503625181259, 6.355817790889544, 5.453147657382869,
              5.105130256512826, 5.123256162808141, 5.3697684884244214,
              5.105130256512826, 5.177633881694085, 5.105130256512826,
              5.105130256512826, 5.355267763388169, 5.0688784439221966,
              5.105130256512826, 5.467648382419121, 5.54015200760038,
              5.358892944647232, 5.137756887844392, 5.427771388569428,
              5.105130256512826, 5.105130256512826, 5.232011600580029,
              5.123256162808141, 6.388444422221111, 5.105130256512826,
              5.721411070553527, 5.54015200760038, 5.105130256512826,
              5.721411070553527, 5.105130256512826, 5.076128806440322,
              5.54015200760038, 5.250137506875344, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.619905995299765,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.250137506875344, 5.105130256512826, 5.105130256512826,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.764913245662283,
              5.087004350217511, 5.087004350217511, 5.087004350217511,
              5.087004350217511, 5.087004350217511, 5.087004350217511,
              5.087004350217511, 5.663408170408521, 5.721411070553527,
              30.37264363218161, 5.170383519175958, 5.105130256512826,
              5.126881344067203, 5.170383519175958, 5.087004350217511,
              7.8965198259913, 23.122281114055703, 5.576403820191009,
              5.721411070553527, 5.54015200760038, 5.25738786939347,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.170383519175958, 5.126881344067203, 5.830166508325417,
              5.1413820691034555, 5.358892944647232, 5.145007250362518,
              5.087004350217511, 5.1413820691034555, 5.358892944647232,
              5.177633881694085, 5.1413820691034555, 5.0688784439221966,
              5.087004350217511, 5.177633881694085, 5.1413820691034555,
              8.621556077803891, 5.1413820691034555, 5.105130256512826,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.177633881694085, 5.105130256512826, 5.250137506875344,
              5.105130256512826, 5.105130256512826, 5.721411070553527,
              5.105130256512826, 5.105130256512826, 5.105130256512826,
              5.105130256512826, 5.105130256512826, 5.54015200760038,
              5.177633881694085, 22.397244862243113, 5.1413820691034555,
              5.54015200760038, 5.105130256512826, 5.1413820691034555,
              5.105130256512826, 5.54015200760038, 5.1413820691034555,
              5.54015200760038, 5.1413820691034555, 5.1413820691034555,
              5.105130256512826, 5.105130256512826, 5.290014500725036,
              5.0688784439221966, 5.163133156657833, 5.0688784439221966,
              5.087004350217511, 5.2863893194659735, 5.087004350217511,
              5.3697684884244214, 5.087004350217511, 5.101505075253763,
              5.076128806440322, 5.431396569828491, 5.123256162808141,
              5.134131706585329, 5.076128806440322, 5.087004350217511,
              5.1413820691034555, 5.15950797539877, 5.072503625181259,
              5.094254712735637, 5.0688784439221966, 5.072503625181259,
              5.174008700435022, 5.094254712735637, 5.177633881694085,
              5.395144757237862, 5.105130256512826, 5.105130256512826,
              5.362518125906296, 5.145007250362518, 5.1957597879894,
              5.123256162808141, 5.087004350217511, 5.1413820691034555,
              5.155882794139707, 5.094254712735637, 5.362518125906296,
              5.1196309815490775, 5.105130256512826, 5.246512325616281,
              5.123256162808141, 5.250137506875344, 5.137756887844392,
              5.54015200760038, 5.094254712735637, 5.268263413170659,
              5.67428371418571, 5.174008700435022, 5.721411070553527,
              5.1305065253262665, 6.083929196459823, 5.126881344067203,
              5.126881344067203, 5.177633881694085, 5.177633881694085,
              5.126881344067203, 5.126881344067203, 5.126881344067203,
              5.105130256512826, 5.177633881694085, 5.2863893194659735,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.105130256512826, 5.177633881694085, 5.358892944647232,
              5.56552827641382, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.268263413170659, 5.250137506875344,
              5.1957597879894, 5.721411070553527, 6.3014400720036,
              14.059327966398321, 5.250137506875344, 6.355817790889544,
              5.2138856942847145, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.304515225761288, 5.358892944647232,
              5.0688784439221966, 6.808965448272414, 5.358892944647232,
              6.990224511225561, 6.990224511225561, 6.446447322366119,
              6.808965448272414, 5.377018850942547, 50.311140557027855,
              6.808965448272414, 5.358892944647232, 5.087004350217511,
              6.26518825941297, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 6.083929196459823, 7.171483574178708,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.087004350217511, 5.358892944647232,
              5.358892944647232, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.358892944647232,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.090629531476574, 5.1087554377718885, 5.431396569828491,
              5.2138856942847145, 5.648907445372268, 5.076128806440322,
              5.076128806440322, 5.076128806440322, 6.083929196459823,
              5.076128806440322, 5.1413820691034555, 5.41689584479224,
              5.0688784439221966, 5.358892944647232, 5.304515225761288,
              5.2138856942847145, 5.54015200760038, 5.184884244212211,
              5.50390019500975, 5.079753987699385, 5.177633881694085,
              5.1957597879894, 5.543777188859443, 5.1413820691034555,
              5.210260513025651, 5.358892944647232, 5.177633881694085,
              5.358892944647232, 5.087004350217511, 5.177633881694085,
              5.15950797539877, 5.105130256512826, 5.087004350217511,
              5.685159257962898, 5.105130256512826, 5.087004350217511,
              5.2138856942847145, 5.413270663533177, 5.1413820691034555,
              5.250137506875344, 5.902670133506676, 5.467648382419121,
              5.358892944647232, 5.177633881694085, 5.1087554377718885,
              5.22113605680284, 5.2863893194659735, 5.1196309815490775,
              5.0688784439221966, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.449522476123806, 5.431396569828491,
              5.431396569828491, 5.15950797539877, 5.0688784439221966,
              5.358892944647232, 5.087004350217511, 5.087004350217511,
              5.0688784439221966, 5.1413820691034555, 5.358892944647232,
              5.105130256512826, 5.358892944647232, 5.0688784439221966,
              5.50390019500975, 5.250137506875344, 5.721411070553527,
              5.076128806440322, 5.50390019500975, 5.358892944647232,
              5.2247612380619035, 5.097879893994699, 5.145007250362518,
              5.268263413170659, 5.358892944647232, 5.358892944647232,
              5.076128806440322, 5.217510875543777, 5.072503625181259,
              5.253762688134406, 5.177633881694085, 5.54015200760038,
              5.0688784439221966, 5.134131706585329, 5.170383519175958,
              5.177633881694085, 7.171483574178708, 5.431396569828491,
              5.076128806440322, 5.358892944647232, 5.15950797539877,
              5.163133156657833, 5.087004350217511, 5.474898744937247,
              5.126881344067203, 5.1196309815490775, 5.112380619030952,
              7.171483574178708, 5.0688784439221966, 5.137756887844392,
              5.177633881694085, 5.1196309815490775, 5.264638231911595,
              5.087004350217511, 5.2138856942847145, 5.598154907745387,
              5.1413820691034555, 5.395144757237862, 5.398769938496925,
              5.351642582129107, 5.087004350217511, 5.177633881694085,
              5.177633881694085, 5.22113605680284, 5.155882794139707,
              5.105130256512826, 5.0688784439221966, 5.2138856942847145,
              5.2138856942847145, 5.449522476123806, 5.123256162808141,
              9.346592329616481, 5.112380619030952, 5.101505075253763,
              5.105130256512826, 5.2138856942847145, 5.358892944647232,
              5.250137506875344, 9.346592329616481, 5.170383519175958,
              5.2247612380619035, 5.123256162808141, 5.358892944647232,
              5.25738786939347, 5.1413820691034555, 5.1413820691034555,
              5.358892944647232, 5.0688784439221966, 5.177633881694085,
              5.0688784439221966, 5.105130256512826, 5.2138856942847145,
              5.177633881694085, 5.902670133506676, 5.250137506875344,
              5.126881344067203, 5.449522476123806, 5.177633881694085,
              5.228386419320966, 5.732286614330716, 5.250137506875344,
              5.449522476123806, 5.083379168958448, 5.174008700435022,
              5.391519575978799, 5.177633881694085, 5.163133156657833,
              5.174008700435022, 5.0688784439221966, 5.079753987699385,
              5.163133156657833, 5.174008700435022, 5.355267763388169,
              5.097879893994699, 5.928046402320116, 5.174008700435022,
              5.355267763388169, 5.174008700435022, 5.163133156657833,
              5.170383519175958, 5.101505075253763, 5.174008700435022,
              6.029551477573879, 6.029551477573879, 6.029551477573879,
              5.0688784439221966, 6.029551477573879, 5.105130256512826,
              5.083379168958448, 5.174008700435022, 5.790289514475724,
              5.511150557527876, 5.1196309815490775, 5.0688784439221966,
              5.079753987699385, 5.087004350217511, 5.576403820191009,
              5.1196309815490775, 5.15950797539877, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.0688784439221966, 5.275513775688784, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 6.26518825941297,
              5.050752537626881, 6.627706385319266, 5.2247612380619035,
              5.163133156657833, 5.1957597879894, 5.2863893194659735,
              5.340767038351918, 5.15950797539877, 5.134131706585329,
              5.177633881694085, 5.2138856942847145, 5.551027551377569,
              5.090629531476574, 5.079753987699385, 5.199384969248462,
              5.152257612880644, 5.268263413170659, 5.398769938496925,
              5.170383519175958, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.199384969248462, 5.15950797539877,
              5.15950797539877, 5.087004350217511, 5.087004350217511,
              5.087004350217511, 5.105130256512826, 5.087004350217511,
              5.15950797539877, 5.155882794139707, 5.087004350217511,
              5.087004350217511, 5.15950797539877, 5.087004350217511,
              5.105130256512826, 5.087004350217511, 5.087004350217511,
              5.087004350217511, 5.134131706585329, 5.279138956947848,
              5.087004350217511, 5.087004350217511, 5.2138856942847145,
              5.155882794139707, 5.123256162808141, 5.087004350217511,
              5.105130256512826, 5.087004350217511, 5.087004350217511,
              5.0688784439221966, 5.1413820691034555, 5.15950797539877,
              5.087004350217511, 5.087004350217511, 5.2138856942847145,
              5.087004350217511, 5.155882794139707, 5.087004350217511,
              5.2138856942847145, 5.087004350217511, 5.15950797539877,
              5.105130256512826, 5.087004350217511, 5.0688784439221966,
              5.105130256512826, 5.087004350217511, 5.134131706585329,
              5.177633881694085, 7.171483574178708, 5.050752537626881,
              5.177633881694085, 5.2863893194659735, 5.105130256512826,
              5.721411070553527, 6.083929196459823, 5.0688784439221966,
              5.177633881694085, 6.228936446822341, 5.358892944647232,
              6.083929196459823, 10.434146707335367, 5.431396569828491,
              5.0688784439221966, 5.032626631331566, 5.032626631331566,
              5.2138856942847145, 6.083929196459823, 5.0362518125906295,
              7.534001700085004, 6.083929196459823, 5.155882794139707,
              5.087004350217511, 5.105130256512826, 5.072503625181259,
              5.0688784439221966, 5.076128806440322, 5.105130256512826,
              5.0688784439221966, 5.105130256512826, 7.388994449722486,
              5.177633881694085, 5.2863893194659735, 5.348017400870043,
              5.177633881694085, 8.621556077803891, 5.177633881694085,
              5.177633881694085, 5.0688784439221966, 5.177633881694085,
              5.087004350217511, 5.1413820691034555, 5.271888594429721,
              5.358892944647232, 5.2138856942847145, 5.2138856942847145,
              5.155882794139707, 5.137756887844392, 5.250137506875344,
              5.250137506875344, 5.087004350217511, 5.206635331766588,
              5.032626631331566, 5.358892944647232, 5.268263413170659,
              5.648907445372268, 5.358892944647232, 5.105130256512826,
              5.308140407020351, 5.308140407020351, 5.308140407020351,
              5.308140407020351, 5.1413820691034555, 5.648907445372268,
              5.308140407020351, 5.308140407020351, 5.268263413170659,
              5.268263413170659, 5.308140407020351, 8.621556077803891,
              5.177633881694085, 5.648907445372268, 5.235636781839092,
              5.0688784439221966, 5.155882794139707, 5.358892944647232,
              5.337141857092854, 5.1413820691034555, 5.242887144357218,
              5.177633881694085, 5.235636781839092, 5.304515225761288,
              5.177633881694085, 5.322641132056603, 5.177633881694085,
              5.268263413170659, 5.177633881694085, 5.308140407020351,
              5.2247612380619035, 5.105130256512826, 5.0688784439221966,
              5.358892944647232, 5.344392219610981, 5.268263413170659,
              5.177633881694085, 5.2972648632431625, 5.163133156657833,
              5.268263413170659, 5.358892944647232, 5.1087554377718885,
              5.2972648632431625, 5.308140407020351, 5.2972648632431625,
              5.344392219610981, 5.134131706585329, 5.2863893194659735,
              5.268263413170659, 5.268263413170659, 5.268263413170659,
              5.268263413170659, 5.083379168958448, 5.145007250362518,
              5.721411070553527, 5.54015200760038, 11.884219210960548,
              5.232011600580029, 5.721411070553527, 5.721411070553527,
              5.333516675833792, 5.137756887844392, 5.083379168958448,
              5.2863893194659735, 5.239261963098155, 5.0688784439221966,
              5.105130256512826, 5.177633881694085, 5.105130256512826,
              5.090629531476574, 6.083929196459823, 5.097879893994699,
              5.73591179558978, 5.177633881694085, 5.15950797539877,
              5.1413820691034555, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 6.7872143607180355, 5.177633881694085,
              5.2138856942847145, 6.808965448272414, 6.808965448272414,
              5.177633881694085, 5.105130256512826, 5.105130256512826,
              5.496649832491625, 5.1413820691034555, 5.177633881694085,
              5.126881344067203, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.721411070553527,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.15950797539877, 5.087004350217511,
              5.126881344067203, 5.848292414620731, 5.496649832491625,
              5.54015200760038, 5.105130256512826, 5.9534226711335565,
              6.446447322366119, 5.174008700435022, 5.174008700435022,
              6.221686084304215, 5.174008700435022, 5.174008700435022,
              5.177633881694085, 5.177633881694085, 5.721411070553527,
              5.177633881694085, 8.37504375218761, 5.177633881694085,
              5.174008700435022, 5.177633881694085, 5.304515225761288,
              5.177633881694085, 5.192134606730336, 5.192134606730336,
              5.177633881694085, 5.192134606730336, 5.192134606730336,
              5.192134606730336, 5.192134606730336, 5.076128806440322,
              5.192134606730336, 5.192134606730336, 5.192134606730336,
              5.192134606730336, 5.192134606730336, 5.148632431621581,
              5.105130256512826, 5.177633881694085, 5.192134606730336,
              5.105130256512826, 6.083929196459823, 5.148632431621581,
              5.177633881694085, 6.083929196459823, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.087004350217511,
              5.152257612880644, 5.2863893194659735, 5.177633881694085,
              5.15950797539877, 5.0688784439221966, 5.322641132056603,
              6.185434271713586, 5.812040602030102, 6.3014400720036,
              5.1413820691034555, 5.072503625181259, 5.177633881694085,
              5.431396569828491, 5.268263413170659, 6.26518825941297,
              5.177633881694085, 5.177633881694085, 5.1413820691034555,
              5.395144757237862, 5.087004350217511, 5.177633881694085,
              6.446447322366119, 5.358892944647232, 5.148632431621581,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.177633881694085, 5.22113605680284, 8.621556077803891,
              5.177633881694085, 5.079753987699385, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.15950797539877, 5.079753987699385,
              5.170383519175958, 5.177633881694085, 5.177633881694085,
              5.076128806440322, 5.721411070553527, 5.177633881694085,
              7.135231761588079, 5.105130256512826, 5.0688784439221966,
              5.2863893194659735, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.15950797539877,
              8.621556077803891, 5.152257612880644, 5.152257612880644,
              5.152257612880644, 5.630781539076954, 5.358892944647232,
              5.097879893994699, 5.177633881694085, 5.250137506875344,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.304515225761288, 5.304515225761288, 5.648907445372268,
              5.177633881694085, 5.358892944647232, 5.177633881694085,
              5.087004350217511, 5.2138856942847145, 5.2138856942847145,
              5.2138856942847145, 5.2138856942847145, 5.2138856942847145,
              5.2138856942847145, 5.174008700435022, 5.177633881694085,
              5.1413820691034555, 5.177633881694085, 5.648907445372268,
              5.079753987699385, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 6.2869393469673485,
              5.322641132056603, 5.177633881694085, 5.177633881694085,
              5.079753987699385, 5.536526826341317, 5.54015200760038,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.268263413170659, 5.1196309815490775,
              6.011425571278564, 5.177633881694085, 5.177633881694085,
              7.515875793789689, 5.177633881694085, 7.8965198259913,
              5.721411070553527, 5.358892944647232, 5.358892944647232,
              5.0688784439221966, 5.177633881694085, 5.032626631331566,
              5.079753987699385, 5.079753987699385, 5.148632431621581,
              6.083929196459823, 5.083379168958448, 5.0471273563678185,
              5.395144757237862, 5.250137506875344, 5.123256162808141,
              5.652532626631332, 5.938921946097305, 5.909920496024801,
              5.54015200760038, 5.268263413170659, 5.355267763388169,
              5.308140407020351, 5.152257612880644, 5.1413820691034555,
              5.652532626631332, 5.177633881694085, 5.696034801740087,
              5.2138856942847145, 5.358892944647232, 5.177633881694085,
              5.2138856942847145, 5.134131706585329, 7.816765838291914,
              5.174008700435022, 5.126881344067203, 5.083379168958448,
              5.210260513025651, 6.083929196459823, 5.087004350217511,
              5.1413820691034555, 5.126881344067203, 5.15950797539877,
              5.362518125906296, 5.460398019900995, 5.453147657382869,
              5.083379168958448, 5.145007250362518, 5.2247612380619035,
              5.1957597879894, 5.1305065253262665, 5.250137506875344,
              5.0688784439221966, 5.2863893194659735, 6.410195509775489,
              5.105130256512826, 5.105130256512826, 5.0688784439221966,
              5.329891494574729, 5.0688784439221966, 5.032626631331566,
              5.358892944647232, 5.032626631331566, 5.431396569828491,
              5.358892944647232, 5.2138856942847145, 5.866418320916046,
              5.032626631331566, 5.032626631331566, 5.177633881694085,
              5.032626631331566, 5.032626631331566, 5.721411070553527,
              5.032626631331566, 5.177633881694085, 5.032626631331566,
              5.116005800290014, 5.1957597879894, 5.1413820691034555,
              5.0688784439221966, 5.1087554377718885, 5.184884244212211,
              9.883119155957798, 5.177633881694085, 5.087004350217511,
              5.112380619030952, 5.123256162808141, 5.090629531476574,
              5.199384969248462, 5.083379168958448, 5.2863893194659735,
              5.902670133506676, 5.902670133506676, 5.449522476123806,
              5.449522476123806, 5.449522476123806, 5.1196309815490775,
              5.177633881694085, 5.079753987699385, 5.449522476123806,
              5.072503625181259, 5.166758337916896, 5.866418320916046,
              5.097879893994699, 5.097879893994699, 5.532901645082254,
              5.116005800290014, 5.123256162808141, 5.184884244212211,
              5.105130256512826, 5.188509425471274, 5.101505075253763,
              5.126881344067203, 5.126881344067203, 5.072503625181259,
              5.152257612880644, 5.072503625181259, 5.152257612880644,
              5.072503625181259, 5.192134606730336, 5.1196309815490775,
              5.1957597879894, 5.116005800290014, 5.076128806440322,
              5.072503625181259, 5.112380619030952, 5.076128806440322,
              5.192134606730336, 5.112380619030952, 5.250137506875344,
              5.888169408470423, 5.2972648632431625, 5.228386419320966,
              5.177633881694085, 12.246737336866843, 5.721411070553527,
              5.1413820691034555, 5.1413820691034555, 5.1413820691034555,
              5.032626631331566, 5.043502175108755, 8.259037951897595,
              5.721411070553527, 6.083929196459823, 7.171483574178708,
              5.358892944647232, 5.902670133506676, 6.083929196459823,
              9.263213160658033, 5.358892944647232, 6.083929196459823,
              5.170383519175958, 5.123256162808141, 5.076128806440322,
              5.116005800290014, 5.083379168958448, 5.177633881694085,
              5.170383519175958, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.097879893994699, 5.232011600580029,
              5.123256162808141, 5.083379168958448, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.097879893994699,
              5.087004350217511, 5.134131706585329, 5.087004350217511,
              5.090629531476574, 5.105130256512826, 5.152257612880644,
              5.177633881694085, 5.076128806440322, 5.079753987699385,
              5.1413820691034555, 5.177633881694085, 5.177633881694085,
              5.112380619030952, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.094254712735637, 5.087004350217511,
              5.094254712735637, 5.083379168958448, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.250137506875344,
              5.148632431621581, 5.148632431621581, 5.094254712735637,
              5.076128806440322, 5.112380619030952, 5.126881344067203,
              5.177633881694085, 5.105130256512826, 5.174008700435022,
              5.072503625181259, 5.0688784439221966, 5.101505075253763,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.087004350217511, 5.1196309815490775, 5.105130256512826,
              5.087004350217511, 5.1413820691034555, 5.177633881694085,
              5.0688784439221966, 5.163133156657833, 5.094254712735637,
              5.105130256512826, 5.2247612380619035, 5.0688784439221966,
              5.177633881694085, 5.076128806440322, 5.101505075253763,
              5.087004350217511, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.15950797539877, 5.163133156657833,
              5.1305065253262665, 5.177633881694085, 5.217510875543777,
              5.1196309815490775, 5.0688784439221966, 5.123256162808141,
              5.087004350217511, 5.0688784439221966, 5.177633881694085,
              5.083379168958448, 5.25738786939347, 5.174008700435022,
              5.090629531476574, 5.177633881694085, 5.177633881694085,
              5.170383519175958, 5.0688784439221966, 5.0688784439221966,
              5.087004350217511, 5.181259062953147, 5.087004350217511,
              5.083379168958448, 5.1413820691034555, 5.177633881694085,
              5.087004350217511, 5.0688784439221966, 5.902670133506676,
              5.902670133506676, 5.177633881694085, 5.083379168958448,
              5.0688784439221966, 5.0688784439221966, 5.1087554377718885,
              5.1413820691034555, 5.079753987699385, 5.094254712735637,
              5.087004350217511, 5.177633881694085, 5.268263413170659,
              5.177633881694085, 5.1087554377718885, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.145007250362518,
              5.177633881694085, 5.105130256512826, 5.072503625181259,
              5.0688784439221966, 5.126881344067203, 5.2138856942847145,
              5.177633881694085, 5.177633881694085, 5.090629531476574,
              5.177633881694085, 5.177633881694085, 6.26518825941297,
              5.123256162808141, 5.1413820691034555, 5.177633881694085,
              5.134131706585329, 5.177633881694085, 5.15950797539877,
              5.177633881694085, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.177633881694085, 5.105130256512826, 5.0688784439221966,
              5.163133156657833, 5.076128806440322, 5.083379168958448,
              5.177633881694085, 5.1305065253262665, 5.101505075253763,
              5.076128806440322, 5.112380619030952, 5.0688784439221966,
              5.087004350217511, 5.1413820691034555, 5.105130256512826,
              5.116005800290014, 5.087004350217511, 5.177633881694085,
              5.072503625181259, 5.112380619030952, 5.090629531476574,
              5.0688784439221966, 5.083379168958448, 5.087004350217511,
              5.177633881694085, 5.105130256512826, 5.072503625181259,
              5.105130256512826, 5.112380619030952, 5.087004350217511,
              5.177633881694085, 5.177633881694085, 5.1413820691034555,
              5.177633881694085, 5.177633881694085, 5.083379168958448,
              5.097879893994699, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.188509425471274,
              5.0688784439221966, 5.177633881694085, 5.087004350217511,
              5.0688784439221966, 5.123256162808141, 5.177633881694085,
              5.148632431621581, 5.101505075253763, 5.101505075253763,
              5.177633881694085, 5.090629531476574, 5.090629531476574,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.087004350217511, 5.1305065253262665, 5.54015200760038,
              5.177633881694085, 5.177633881694085, 5.174008700435022,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.072503625181259, 5.087004350217511, 5.097879893994699,
              5.072503625181259, 5.094254712735637, 5.083379168958448,
              5.0688784439221966, 5.163133156657833, 5.177633881694085,
              5.087004350217511, 5.123256162808141, 5.097879893994699,
              5.076128806440322, 5.094254712735637, 5.094254712735637,
              5.072503625181259, 5.177633881694085, 5.1196309815490775,
              5.177633881694085, 5.177633881694085, 5.076128806440322,
              5.1087554377718885, 5.0688784439221966, 5.177633881694085,
              5.105130256512826, 5.087004350217511, 5.177633881694085,
              5.094254712735637, 5.1413820691034555, 5.0688784439221966,
              5.134131706585329, 5.087004350217511, 5.22113605680284,
              5.148632431621581, 5.0688784439221966, 5.1413820691034555,
              5.112380619030952, 5.126881344067203, 5.087004350217511,
              5.1413820691034555, 5.1196309815490775, 5.079753987699385,
              5.0688784439221966, 5.264638231911595, 5.2863893194659735,
              5.087004350217511, 5.250137506875344, 5.2863893194659735,
              5.206635331766588, 5.438646932346617, 5.688784439221961,
              6.083929196459823, 5.50390019500975, 5.630781539076954,
              5.358892944647232, 5.54015200760038, 5.268263413170659,
              5.536526826341317, 5.721411070553527, 5.54015200760038,
              5.250137506875344, 5.177633881694085, 5.242887144357218,
              5.105130256512826, 5.1413820691034555, 5.656157807890395,
              6.083929196459823, 5.902670133506676, 6.1201810090504525,
              5.105130256512826, 5.097879893994699, 5.268263413170659,
              5.105130256512826, 5.087004350217511, 5.594529726486324,
              5.087004350217511, 5.087004350217511, 5.101505075253763,
              5.101505075253763, 5.079753987699385, 5.090629531476574,
              5.137756887844392, 5.137756887844392, 5.0688784439221966,
              5.079753987699385, 5.0688784439221966, 5.087004350217511,
              5.087004350217511, 5.105130256512826, 5.1413820691034555,
              5.1413820691034555, 5.1413820691034555, 6.736461823091155,
              5.250137506875344, 5.2863893194659735, 5.0688784439221966,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.184884244212211, 5.264638231911595,
              5.0688784439221966, 5.0688784439221966, 5.253762688134406,
              5.105130256512826, 5.105130256512826, 5.3806440322016105,
              5.1957597879894, 5.518400920046003, 5.2863893194659735,
              5.170383519175958, 6.736461823091155, 5.155882794139707,
              5.177633881694085, 5.54015200760038, 5.358892944647232,
              5.1087554377718885, 5.866418320916046, 5.268263413170659,
              5.268263413170659, 5.250137506875344, 5.0688784439221966,
              5.424146207310366, 5.268263413170659, 5.268263413170659,
              5.358892944647232, 5.105130256512826, 6.446447322366119,
              5.177633881694085, 5.721411070553527, 5.177633881694085,
              6.808965448272414, 5.105130256512826, 5.268263413170659,
              5.268263413170659, 5.511150557527876, 5.097879893994699,
              5.087004350217511, 5.090629531476574, 5.090629531476574,
              5.090629531476574, 5.083379168958448, 5.184884244212211,
              5.148632431621581, 5.909920496024801, 7.534001700085004,
              5.264638231911595, 5.721411070553527, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.090629531476574,
              5.0688784439221966, 5.094254712735637, 5.090629531476574,
              5.268263413170659, 6.26518825941297, 5.2138856942847145,
              5.177633881694085, 5.431396569828491, 5.576403820191009,
              5.2863893194659735, 5.445897294864743, 5.768538426921346,
              5.0688784439221966, 5.105130256512826, 5.105130256512826,
              5.1196309815490775, 5.105130256512826, 5.105130256512826,
              5.072503625181259, 5.264638231911595, 5.253762688134406,
              5.420521026051302, 5.54015200760038, 5.105130256512826,
              5.2247612380619035, 5.2863893194659735, 6.446447322366119,
              5.177633881694085, 6.083929196459823, 7.088104405220261,
              5.268263413170659, 5.0688784439221966, 5.0688784439221966,
              6.446447322366119, 5.163133156657833, 5.163133156657833,
              5.0688784439221966, 6.808965448272414, 5.268263413170659,
              5.105130256512826, 6.26518825941297, 5.54015200760038,
              5.358892944647232, 5.0688784439221966, 5.2138856942847145,
              5.0688784439221966, 5.148632431621581, 5.0688784439221966,
              5.358892944647232, 5.721411070553527, 5.721411070553527,
              5.866418320916046, 5.105130256512826, 5.0688784439221966,
              5.264638231911595, 5.163133156657833, 5.902670133506676,
              5.395144757237862, 5.105130256512826, 10.434146707335367,
              5.072503625181259, 5.721411070553527, 5.192134606730336,
              5.692409620481024, 5.358892944647232, 5.0688784439221966,
              5.2138856942847145, 5.0688784439221966, 5.105130256512826,
              5.0688784439221966, 5.217510875543777, 5.2863893194659735,
              5.177633881694085, 6.446447322366119, 5.1957597879894,
              5.54015200760038, 5.112380619030952, 6.011425571278564,
              5.0688784439221966, 5.667033351667583, 5.721411070553527,
              5.0688784439221966, 5.15950797539877, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.087004350217511,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              7.497749887494375, 6.26518825941297, 5.2863893194659735,
              5.0688784439221966, 5.721411070553527, 5.358892944647232,
              5.170383519175958, 5.2138856942847145, 5.1305065253262665,
              6.083929196459823, 5.518400920046003, 5.358892944647232,
              5.0688784439221966, 6.573328666433322, 5.079753987699385,
              5.424146207310366, 5.177633881694085, 5.2863893194659735,
              5.264638231911595, 5.170383519175958, 5.0688784439221966,
              5.090629531476574, 5.95704785239262, 5.358892944647232,
              5.264638231911595, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.395144757237862, 5.420521026051302,
              5.2863893194659735, 7.146107305365268, 5.431396569828491,
              5.355267763388169, 5.358892944647232, 5.177633881694085,
              5.54015200760038, 5.177633881694085, 5.54015200760038,
              5.0688784439221966, 5.725036251812591, 7.751512575628782,
              5.137756887844392, 5.424146207310366, 5.2863893194659735,
              5.2863893194659735, 5.2863893194659735, 5.721411070553527,
              6.808965448272414, 7.352742637131857, 5.0688784439221966,
              5.0688784439221966, 6.011425571278564, 5.902670133506676,
              5.0688784439221966, 5.105130256512826, 5.0688784439221966,
              5.2863893194659735, 5.275513775688784, 5.2863893194659735,
              5.079753987699385, 5.1957597879894, 5.358892944647232,
              5.083379168958448, 5.264638231911595, 5.721411070553527,
              5.721411070553527, 5.721411070553527, 5.474898744937247,
              5.630781539076954, 5.2863893194659735, 5.1413820691034555,
              5.2863893194659735, 5.0688784439221966, 5.721411070553527,
              5.485774288714436, 5.1413820691034555, 5.54015200760038,
              5.387894394719736, 5.902670133506676, 5.177633881694085,
              5.358892944647232, 5.2863893194659735, 5.913545677283865,
              5.101505075253763, 5.358892944647232, 5.087004350217511,
              5.522026101305065, 5.0688784439221966, 5.087004350217511,
              5.2247612380619035, 5.2863893194659735, 5.2863893194659735,
              5.2138856942847145, 5.264638231911595, 5.264638231911595,
              5.812040602030102, 5.0688784439221966, 6.083929196459823,
              5.721411070553527, 5.097879893994699, 5.090629531476574,
              5.097879893994699, 5.630781539076954, 5.721411070553527,
              6.083929196459823, 5.308140407020351, 5.177633881694085,
              5.395144757237862, 5.28276413820691, 5.358892944647232,
              5.268263413170659, 6.1310565528276415, 5.721411070553527,
              5.902670133506676, 5.54015200760038, 5.54015200760038,
              5.536526826341317, 5.2138856942847145, 5.199384969248462,
              5.177633881694085, 5.166758337916896, 5.134131706585329,
              5.123256162808141, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.250137506875344, 5.721411070553527,
              5.315390769538477, 6.808965448272414, 6.808965448272414,
              5.547402370118506, 5.090629531476574, 5.199384969248462,
              5.097879893994699, 5.0688784439221966, 5.0688784439221966,
              5.50390019500975, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.242887144357218, 5.264638231911595,
              5.264638231911595, 5.076128806440322, 5.2138856942847145,
              5.2863893194659735, 8.077778888944447, 5.362518125906296,
              5.087004350217511, 5.268263413170659, 5.250137506875344,
              5.0688784439221966, 5.1413820691034555, 5.456772838641932,
              5.47852392619631, 5.28276413820691, 5.2863893194659735,
              5.177633881694085, 5.0688784439221966, 5.145007250362518,
              5.1413820691034555, 5.358892944647232, 5.358892944647232,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.2863893194659735, 5.177633881694085, 5.804790239511975,
              5.377018850942547, 5.166758337916896, 6.0476773838691935,
              5.435021751087555, 6.518950947547378, 5.090629531476574,
              5.090629531476574, 5.866418320916046, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              5.2138856942847145, 5.105130256512826, 5.677908895444772,
              5.358892944647232, 6.174558727936397, 5.326266313315665,
              5.489399469973499, 5.177633881694085, 5.177633881694085,
              5.268263413170659, 5.177633881694085, 5.0688784439221966,
              5.072503625181259, 5.0688784439221966, 5.648907445372268,
              5.496649832491625, 5.721411070553527, 5.721411070553527,
              5.087004350217511, 5.268263413170659, 6.446447322366119,
              5.95704785239262, 6.33769188459423, 5.0688784439221966,
              5.366143307165358, 5.358892944647232, 5.0688784439221966,
              5.471273563678184, 5.0688784439221966, 5.0688784439221966,
              5.0688784439221966, 5.235636781839092, 5.235636781839092,
              5.097879893994699, 5.2863893194659735, 5.431396569828491,
              5.395144757237862, 5.0688784439221966, 5.0688784439221966,
              5.460398019900995, 5.431396569828491, 5.177633881694085,
              5.721411070553527, 5.0688784439221966, 5.177633881694085,
              5.377018850942547, 5.449522476123806, 5.264638231911595,
              5.594529726486324, 5.54015200760038, 5.993299664983249,
              5.358892944647232, 5.449522476123806, 5.721411070553527,
              7.7152607630381524, 5.268263413170659, 5.358892944647232,
              5.112380619030952, 5.308140407020351, 5.250137506875344,
              5.1413820691034555, 5.0688784439221966, 5.0688784439221966,
              5.072503625181259, 5.268263413170659, 5.268263413170659,
              5.2863893194659735, 5.2863893194659735, 5.902670133506676,
              5.638031901595079, 5.0688784439221966, 5.184884244212211,
              5.554652732636632, 5.431396569828491, 5.612655632781639,
              5.177633881694085, 5.076128806440322, 5.373393669683484,
              5.721411070553527, 5.177633881694085, 5.467648382419121,
              5.54015200760038, 5.0688784439221966, 5.15950797539877,
              5.0688784439221966, 5.616280814040702, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.409645482274113,
              5.250137506875344, 5.0688784439221966, 5.268263413170659,
              5.1196309815490775, 5.094254712735637, 5.1196309815490775,
              5.1196309815490775, 5.094254712735637, 5.1413820691034555,
              5.0688784439221966, 5.358892944647232, 5.721411070553527,
              6.083929196459823, 5.721411070553527, 5.264638231911595,
              5.155882794139707, 5.529276463823191, 5.087004350217511,
              5.28276413820691, 5.0688784439221966, 5.0688784439221966,
              5.112380619030952, 5.087004350217511, 5.105130256512826,
              5.177633881694085, 5.648907445372268, 5.1413820691034555,
              5.083379168958448, 5.395144757237862, 5.395144757237862,
              5.612655632781639, 5.0688784439221966, 5.2863893194659735,
              5.177633881694085, 5.177633881694085, 5.264638231911595,
              5.264638231911595, 5.264638231911595, 5.757662883144157,
              5.177633881694085, 5.0688784439221966, 5.250137506875344,
              5.264638231911595, 5.105130256512826, 5.413270663533177,
              5.2863893194659735, 5.1413820691034555, 5.2863893194659735,
              6.334066703335167, 5.0688784439221966, 5.358892944647232,
              5.358892944647232, 5.087004350217511, 6.446447322366119,
              5.268263413170659, 5.706910345517276, 5.536526826341317,
              5.721411070553527, 5.721411070553527, 5.866418320916046,
              5.0688784439221966, 6.083929196459823, 5.177633881694085,
              5.105130256512826, 5.467648382419121, 6.08030401520076,
              5.54015200760038, 5.177633881694085, 5.072503625181259,
              5.0688784439221966, 5.493024651232561, 5.177633881694085,
              5.0688784439221966, 5.456772838641932, 5.0688784439221966,
              5.54015200760038, 5.431396569828491, 5.177633881694085,
              5.721411070553527, 5.721411070553527, 5.54015200760038,
              5.358892944647232, 5.456772838641932, 5.721411070553527,
              5.0688784439221966, 5.181259062953147, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.090629531476574,
              5.137756887844392, 5.126881344067203, 5.123256162808141,
              5.116005800290014, 5.1196309815490775, 5.112380619030952,
              5.112380619030952, 5.246512325616281, 5.246512325616281,
              5.54015200760038, 6.083929196459823, 5.134131706585329,
              5.177633881694085, 5.228386419320966, 5.177633881694085,
              5.721411070553527, 5.293639681984099, 5.467648382419121,
              5.2863893194659735, 5.097879893994699, 5.090629531476574,
              5.184884244212211, 5.2863893194659735, 5.0688784439221966,
              5.721411070553527, 5.116005800290014, 5.2138856942847145,
              5.087004350217511, 5.232011600580029, 5.2138856942847145,
              5.1305065253262665, 6.3014400720036, 5.0688784439221966,
              5.902670133506676, 5.0688784439221966, 5.268263413170659,
              5.9751737586879345, 5.0688784439221966, 5.0688784439221966,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.358892944647232, 5.1413820691034555, 5.25738786939347,
              5.126881344067203, 5.1305065253262665, 5.192134606730336,
              5.192134606730336, 5.177633881694085, 5.0688784439221966,
              6.0368018400920045, 5.358892944647232, 5.0688784439221966,
              8.621556077803891, 5.2247612380619035, 5.090629531476574,
              5.242887144357218, 5.123256162808141, 5.333516675833792,
              5.0688784439221966, 5.0688784439221966, 5.630781539076954,
              5.902670133506676, 5.54015200760038, 5.721411070553527,
              5.105130256512826, 5.0688784439221966, 5.0688784439221966,
              5.090629531476574, 5.123256162808141, 5.177633881694085,
              5.192134606730336, 5.0688784439221966, 5.0688784439221966,
              5.623531176558828, 5.2863893194659735, 5.076128806440322,
              5.358892944647232, 5.1957597879894, 5.177633881694085,
              6.446447322366119, 6.446447322366119, 5.250137506875344,
              5.268263413170659, 5.431396569828491, 5.431396569828491,
              5.576403820191009, 5.721411070553527, 5.0688784439221966,
              5.0688784439221966, 6.26518825941297, 5.2247612380619035,
              5.264638231911595, 5.358892944647232, 5.2863893194659735,
              5.0688784439221966, 5.460398019900995, 5.721411070553527,
              6.808965448272414, 8.621556077803891, 5.268263413170659,
              5.395144757237862, 5.177633881694085, 5.358892944647232,
              5.268263413170659, 5.174008700435022, 5.268263413170659,
              5.15950797539877, 5.721411070553527, 5.358892944647232,
              5.721411070553527, 5.177633881694085, 5.358892944647232,
              5.268263413170659, 5.0688784439221966, 7.164233211660584,
              5.105130256512826, 5.902670133506676, 5.721411070553527,
              5.902670133506676, 5.358892944647232, 5.206635331766588,
              5.358892944647232, 5.793914695734787, 5.395144757237862,
              5.264638231911595, 5.123256162808141, 5.721411070553527,
              5.0688784439221966, 5.192134606730336, 5.54015200760038,
              5.373393669683484, 5.264638231911595, 5.0688784439221966,
              5.721411070553527, 5.177633881694085, 5.358892944647232,
              5.0688784439221966, 6.1926846342317114, 5.576403820191009,
              6.808965448272414, 5.0688784439221966, 5.721411070553527,
              6.076678833941697, 5.0688784439221966, 5.184884244212211,
              5.184884244212211, 5.22113605680284, 5.0688784439221966,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.290014500725036, 5.0688784439221966, 5.54015200760038,
              5.315390769538477, 5.268263413170659, 5.329891494574729,
              5.391519575978799, 5.083379168958448, 5.264638231911595,
              5.576403820191009, 5.536526826341317, 5.4640232011600585,
              5.097879893994699, 5.0688784439221966, 5.177633881694085,
              5.087004350217511, 5.087004350217511, 5.264638231911595,
              5.721411070553527, 5.268263413170659, 5.264638231911595,
              5.532901645082254, 5.73591179558978, 5.92079603980199,
              5.2863893194659735, 5.2863893194659735, 5.0688784439221966,
              5.0688784439221966, 5.148632431621581, 5.420521026051302,
              5.358892944647232, 5.137756887844392, 5.079753987699385,
              5.402395119755988, 5.721411070553527, 6.083929196459823,
              5.358892944647232, 5.721411070553527, 6.808965448272414,
              6.808965448272414, 5.721411070553527, 5.938921946097305,
              5.0688784439221966, 5.304515225761288, 5.0688784439221966,
              5.264638231911595, 5.2863893194659735, 5.199384969248462,
              5.192134606730336, 5.184884244212211, 5.155882794139707,
              5.170383519175958, 5.199384969248462, 5.2138856942847145,
              5.228386419320966, 5.116005800290014, 5.206635331766588,
              5.192134606730336, 5.083379168958448, 5.358892944647232,
              6.247062353117656, 5.50390019500975, 5.0688784439221966,
              5.076128806440322, 7.171483574178708, 5.134131706585329,
              5.134131706585329, 5.134131706585329, 5.134131706585329,
              5.134131706585329, 5.1196309815490775, 5.271888594429721,
              6.0476773838691935, 5.358892944647232, 5.177633881694085,
              5.0688784439221966, 5.177633881694085, 5.0688784439221966,
              5.358892944647232, 5.322641132056603, 5.558277913895695,
              5.377018850942547, 5.351642582129107, 5.079753987699385,
              5.105130256512826, 5.902670133506676, 5.0688784439221966,
              5.0688784439221966, 5.902670133506676, 5.721411070553527,
              5.1413820691034555, 5.373393669683484, 6.413820691034552,
              5.083379168958448, 5.105130256512826, 6.170933546677334,
              5.449522476123806, 5.264638231911595, 5.344392219610981,
              5.22113605680284, 5.358892944647232, 5.54015200760038,
              5.543777188859443, 5.094254712735637, 5.0688784439221966,
              5.0688784439221966, 5.902670133506676, 5.0688784439221966,
              6.808965448272414, 5.1957597879894, 5.0688784439221966,
              5.184884244212211, 5.101505075253763, 5.54015200760038,
              5.0688784439221966, 5.0688784439221966, 5.105130256512826,
              5.358892944647232, 5.232011600580029, 5.54015200760038,
              5.2138856942847145, 5.0688784439221966, 5.721411070553527,
              5.2138856942847145, 5.0688784439221966, 5.268263413170659,
              5.268263413170659, 5.264638231911595, 5.54015200760038,
              6.808965448272414, 5.123256162808141, 5.743162158107905,
              6.555202760138007, 5.210260513025651, 5.264638231911595,
              5.721411070553527, 5.206635331766588, 5.112380619030952,
              5.2863893194659735, 5.0688784439221966, 5.721411070553527,
              6.446447322366119, 5.0688784439221966, 5.264638231911595,
              5.123256162808141, 5.177633881694085, 5.8917945897294866,
              5.28276413820691, 5.456772838641932, 5.2138856942847145,
              5.177633881694085, 5.0688784439221966, 5.358892944647232,
              5.0688784439221966, 5.2863893194659735, 5.583654182709136,
              5.1957597879894, 5.337141857092854, 5.322641132056603,
              6.3014400720036, 5.253762688134406, 6.446447322366119,
              5.902670133506676, 5.087004350217511, 6.8705935296764835,
              5.866418320916046, 6.4536976848842444, 5.0688784439221966,
              5.2138856942847145, 5.188509425471274, 6.3014400720036,
              5.232011600580029, 5.0688784439221966, 5.638031901595079,
              5.0688784439221966, 5.2863893194659735, 5.902670133506676,
              5.268263413170659, 5.721411070553527, 5.072503625181259,
              5.264638231911595, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.358892944647232, 5.15950797539877,
              5.819290964548228, 5.2863893194659735, 5.090629531476574,
              5.0688784439221966, 5.184884244212211, 5.0688784439221966,
              5.1196309815490775, 5.232011600580029, 5.362518125906296,
              5.909920496024801, 5.554652732636632, 6.823466173308665,
              5.0688784439221966, 5.2138856942847145, 5.268263413170659,
              5.721411070553527, 6.808965448272414, 6.808965448272414,
              5.485774288714436, 5.076128806440322, 5.54015200760038,
              5.54015200760038, 5.2863893194659735, 5.268263413170659,
              5.576403820191009, 5.2138856942847145, 6.808965448272414,
              5.181259062953147, 5.721411070553527, 5.177633881694085,
              5.358892944647232, 5.54015200760038, 5.54015200760038,
              5.387894394719736, 5.174008700435022, 5.1413820691034555,
              5.087004350217511, 5.250137506875344, 5.2138856942847145,
              5.0688784439221966, 6.083929196459823, 5.0688784439221966,
              5.105130256512826, 5.1413820691034555, 5.358892944647232,
              5.0688784439221966, 5.268263413170659, 5.210260513025651,
              5.097879893994699, 5.0688784439221966, 5.0688784439221966,
              6.808965448272414, 5.638031901595079, 6.26518825941297,
              5.0688784439221966, 6.808965448272414, 5.0688784439221966,
              7.171483574178708, 7.171483574178708, 5.358892944647232,
              5.0688784439221966, 6.083929196459823, 5.496649832491625,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.721411070553527, 6.26518825941297, 5.866418320916046,
              5.1413820691034555, 5.2138856942847145, 5.902670133506676,
              5.2138856942847145, 5.902670133506676, 5.0688784439221966,
              5.2972648632431625, 5.902670133506676, 5.101505075253763,
              5.76128806440322, 5.242887144357218, 5.137756887844392,
              6.138306915345767, 5.264638231911595, 5.630781539076954,
              5.268263413170659, 6.083929196459823, 5.1957597879894,
              5.250137506875344, 5.105130256512826, 5.0688784439221966,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.721411070553527, 8.621556077803891, 5.50390019500975,
              5.177633881694085, 5.0688784439221966, 5.304515225761288,
              5.2863893194659735, 6.083929196459823, 5.090629531476574,
              5.163133156657833, 5.358892944647232, 5.721411070553527,
              5.355267763388169, 5.54015200760038, 6.3014400720036,
              5.54015200760038, 6.083929196459823, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.358892944647232,
              5.268263413170659, 5.0688784439221966, 5.866418320916046,
              5.268263413170659, 5.902670133506676, 5.0688784439221966,
              5.358892944647232, 5.28276413820691, 5.264638231911595,
              5.2863893194659735, 5.090629531476574, 5.2863893194659735,
              5.358892944647232, 5.308140407020351, 5.076128806440322,
              5.0688784439221966, 5.268263413170659, 5.174008700435022,
              5.362518125906296, 5.177633881694085, 5.177633881694085,
              5.268263413170659, 5.0688784439221966, 5.0688784439221966,
              5.362518125906296, 5.358892944647232, 5.177633881694085,
              5.235636781839092, 5.507525376268814, 5.322641132056603,
              6.1201810090504525, 5.0688784439221966, 5.1413820691034555,
              5.0688784439221966, 5.0688784439221966, 5.174008700435022,
              5.094254712735637, 5.097879893994699, 5.0688784439221966,
              5.572778638931947, 5.210260513025651, 5.177633881694085,
              5.177633881694085, 5.123256162808141, 5.177633881694085,
              5.2863893194659735, 5.358892944647232, 5.123256162808141,
              5.170383519175958, 5.253762688134406, 5.181259062953147,
              5.279138956947848, 5.1196309815490775, 5.177633881694085,
              5.177633881694085, 5.116005800290014, 5.177633881694085,
              5.902670133506676, 5.2863893194659735, 6.083929196459823,
              5.449522476123806, 5.304515225761288, 5.648907445372268,
              5.177633881694085, 5.431396569828491, 5.449522476123806,
              5.177633881694085, 5.264638231911595, 5.123256162808141,
              5.485774288714436, 5.076128806440322, 5.0688784439221966,
              5.0688784439221966, 5.2863893194659735, 5.0688784439221966,
              5.0688784439221966, 7.534001700085004, 5.177633881694085,
              5.2863893194659735, 5.250137506875344, 5.652532626631332,
              5.0688784439221966, 5.358892944647232, 5.264638231911595,
              5.0688784439221966, 5.0688784439221966, 5.177633881694085,
              5.177633881694085, 5.264638231911595, 5.181259062953147,
              5.1413820691034555, 5.576403820191009, 5.54015200760038,
              5.264638231911595, 5.431396569828491, 5.1413820691034555,
              5.0688784439221966, 5.076128806440322, 5.358892944647232,
              5.0688784439221966, 5.2138856942847145, 5.0688784439221966,
              5.0688784439221966, 5.105130256512826, 6.3014400720036,
              5.630781539076954, 5.123256162808141, 5.721411070553527,
              6.083929196459823, 5.250137506875344, 5.2863893194659735,
              5.467648382419121, 5.2138856942847145, 5.148632431621581,
              5.177633881694085, 5.721411070553527, 5.177633881694085,
              5.15950797539877, 5.884544227211361, 5.264638231911595,
              5.358892944647232, 5.358892944647232, 5.366143307165358,
              5.2138856942847145, 5.235636781839092, 5.449522476123806,
              5.264638231911595, 5.0688784439221966, 5.148632431621581,
              5.268263413170659, 5.264638231911595, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.268263413170659,
              5.340767038351918, 5.721411070553527, 5.54015200760038,
              5.105130256512826, 5.612655632781639, 5.703285164258213,
              5.721411070553527, 5.264638231911595, 5.232011600580029,
              5.358892944647232, 5.358892944647232, 5.2863893194659735,
              6.26518825941297, 6.083929196459823, 5.177633881694085,
              5.232011600580029, 6.083929196459823, 5.094254712735637,
              5.2863893194659735, 5.268263413170659, 5.0688784439221966,
              5.431396569828491, 5.1957597879894, 5.123256162808141,
              5.92079603980199, 5.268263413170659, 5.163133156657833,
              5.2138856942847145, 5.0688784439221966, 5.0688784439221966,
              5.366143307165358, 5.268263413170659, 5.431396569828491,
              5.431396569828491, 5.358892944647232, 5.2863893194659735,
              5.358892944647232, 5.0688784439221966, 5.199384969248462,
              6.083929196459823, 5.0688784439221966, 5.105130256512826,
              5.1413820691034555, 5.177633881694085, 5.177633881694085,
              5.721411070553527, 5.184884244212211, 5.145007250362518,
              5.358892944647232, 5.268263413170659, 5.721411070553527,
              5.0688784439221966, 5.0688784439221966, 5.322641132056603,
              5.184884244212211, 5.177633881694085, 5.072503625181259,
              5.902670133506676, 5.264638231911595, 5.0688784439221966,
              5.268263413170659, 5.648907445372268, 6.26518825941297,
              5.358892944647232, 5.177633881694085, 5.268263413170659,
              5.721411070553527, 5.1413820691034555, 5.7141607080354015,
              6.446447322366119, 5.079753987699385, 5.0688784439221966,
              5.268263413170659, 5.1413820691034555, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 6.808965448272414,
              6.808965448272414, 5.268263413170659, 5.177633881694085,
              5.177633881694085, 5.366143307165358, 5.264638231911595,
              5.706910345517276, 5.0688784439221966, 5.358892944647232,
              5.184884244212211, 5.902670133506676, 5.322641132056603,
              5.174008700435022, 5.268263413170659, 5.268263413170659,
              6.083929196459823, 5.594529726486324, 5.177633881694085,
              5.0688784439221966, 5.721411070553527, 5.0688784439221966,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.0688784439221966, 5.112380619030952, 5.105130256512826,
              5.355267763388169, 5.0688784439221966, 5.268263413170659,
              5.0688784439221966, 5.0688784439221966, 5.2863893194659735,
              5.54015200760038, 5.232011600580029, 5.358892944647232,
              5.54015200760038, 5.177633881694085, 5.358892944647232,
              5.2138856942847145, 5.105130256512826, 5.126881344067203,
              5.097879893994699, 5.431396569828491, 6.808965448272414,
              5.358892944647232, 5.449522476123806, 5.721411070553527,
              5.0688784439221966, 5.902670133506676, 5.163133156657833,
              6.247062353117656, 6.156432821641082, 5.0688784439221966,
              5.177633881694085, 5.721411070553527, 5.0688784439221966,
              5.362518125906296, 5.271888594429721, 5.358892944647232,
              5.449522476123806, 5.076128806440322, 5.177633881694085,
              5.087004350217511, 5.087004350217511, 5.123256162808141,
              5.0688784439221966, 5.268263413170659, 5.888169408470423,
              5.543777188859443, 5.902670133506676, 5.902670133506676,
              5.902670133506676, 5.094254712735637, 5.0688784439221966,
              5.0688784439221966, 5.1413820691034555, 5.358892944647232,
              5.0688784439221966, 5.467648382419121, 5.0688784439221966,
              5.0688784439221966, 5.902670133506676, 5.902670133506676,
              6.446447322366119, 5.703285164258213, 5.268263413170659,
              5.28276413820691, 5.2863893194659735, 5.739536976848843,
              5.264638231911595, 5.427771388569428, 5.648907445372268,
              5.177633881694085, 5.358892944647232, 5.322641132056603,
              5.366143307165358, 5.543777188859443, 5.793914695734787,
              5.250137506875344, 5.177633881694085, 5.938921946097305,
              5.0688784439221966, 5.123256162808141, 5.072503625181259,
              5.2863893194659735, 5.402395119755988, 5.721411070553527,
              5.358892944647232, 5.721411070553527, 5.087004350217511,
              5.0688784439221966, 5.721411070553527, 5.398769938496925,
              5.54015200760038, 6.083929196459823, 5.2863893194659735,
              5.54015200760038, 5.25738786939347, 5.083379168958448,
              5.264638231911595, 5.358892944647232, 5.576403820191009,
              5.076128806440322, 5.424146207310366, 5.431396569828491,
              5.076128806440322, 5.54015200760038, 5.268263413170659,
              5.264638231911595, 5.73591179558978, 5.268263413170659,
              5.2138856942847145, 5.177633881694085, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.0688784439221966,
              6.2035601780089005, 5.264638231911595, 5.0688784439221966,
              5.801165058252913, 5.431396569828491, 5.097879893994699,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.1087554377718885, 5.358892944647232, 6.2035601780089005,
              5.395144757237862, 5.22113605680284, 5.721411070553527,
              5.094254712735637, 5.0688784439221966, 5.449522476123806,
              5.358892944647232, 5.358892944647232, 5.474898744937247,
              5.148632431621581, 5.072503625181259, 5.1413820691034555,
              5.54015200760038, 5.0688784439221966, 6.2035601780089005,
              5.431396569828491, 5.0688784439221966, 5.177633881694085,
              5.50390019500975, 5.358892944647232, 5.105130256512826,
              5.0688784439221966, 5.177633881694085, 5.685159257962898,
              5.0688784439221966, 5.358892944647232, 5.0688784439221966,
              5.246512325616281, 5.15950797539877, 5.0688784439221966,
              5.358892944647232, 5.54015200760038, 5.177633881694085,
              5.0688784439221966, 5.0688784439221966, 5.1957597879894,
              5.2247612380619035, 5.0688784439221966, 5.264638231911595,
              5.264638231911595, 5.2138856942847145, 5.1087554377718885,
              5.1087554377718885, 5.148632431621581, 5.358892944647232,
              5.0688784439221966, 5.384269213460673, 5.0688784439221966,
              5.0688784439221966, 5.0688784439221966, 5.54015200760038,
              5.0688784439221966, 5.0688784439221966, 5.268263413170659,
              5.358892944647232, 5.094254712735637, 5.54015200760038,
              5.387894394719736, 5.264638231911595, 5.0688784439221966,
              5.0688784439221966, 5.290014500725036, 5.268263413170659,
              5.264638231911595, 5.322641132056603, 5.460398019900995,
              5.333516675833792, 5.268263413170659, 5.268263413170659,
              5.0688784439221966, 5.54015200760038, 5.268263413170659,
              5.126881344067203, 5.105130256512826, 5.0688784439221966,
              5.087004350217511, 5.358892944647232, 5.2138856942847145,
              5.2138856942847145, 5.184884244212211, 5.358892944647232,
              5.612655632781639, 5.358892944647232, 5.721411070553527,
              5.54015200760038, 5.0688784439221966, 5.264638231911595,
              5.25738786939347, 5.656157807890395, 5.177633881694085,
              5.105130256512826, 5.0688784439221966, 5.355267763388169,
              5.529276463823191, 5.989674483724186, 6.083929196459823,
              6.808965448272414, 5.812040602030102, 5.210260513025651,
              5.090629531476574, 5.0688784439221966, 5.0688784439221966,
              5.232011600580029, 6.083929196459823, 5.471273563678184,
              6.653082654132707, 5.793914695734787, 5.358892944647232,
              5.721411070553527, 5.721411070553527, 5.793914695734787,
              5.174008700435022, 5.163133156657833, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.358892944647232, 5.123256162808141,
              5.177633881694085, 5.105130256512826, 5.105130256512826,
              5.1413820691034555, 10.07162858142907, 8.00890044502225,
              5.594529726486324, 5.174008700435022, 5.902670133506676,
              5.177633881694085, 5.174008700435022, 5.358892944647232,
              5.54015200760038, 5.177633881694085, 5.721411070553527,
              5.54015200760038, 5.721411070553527, 5.721411070553527,
              6.26518825941297, 5.177633881694085, 5.217510875543777,
              5.174008700435022, 5.967923396169809, 5.105130256512826,
              5.721411070553527, 5.177633881694085, 5.0688784439221966,
              5.170383519175958, 5.170383519175958, 5.1413820691034555,
              5.54015200760038, 5.177633881694085, 5.15950797539877,
              5.866418320916046, 5.105130256512826, 5.322641132056603,
              5.105130256512826, 5.087004350217511, 5.2247612380619035,
              5.145007250362518, 5.105130256512826, 5.3806440322016105,
              5.373393669683484, 5.54015200760038, 5.177633881694085,
              5.358892944647232, 5.177633881694085, 5.174008700435022,
              5.152257612880644, 5.677908895444772, 5.902670133506676,
              5.177633881694085, 5.177633881694085, 5.105130256512826,
              5.449522476123806, 5.648907445372268, 5.177633881694085,
              5.174008700435022, 5.2138856942847145, 5.177633881694085,
              5.177633881694085, 5.210260513025651, 5.177633881694085,
              5.177633881694085, 5.2138856942847145, 5.2138856942847145,
              5.105130256512826, 5.2247612380619035, 5.358892944647232,
              5.250137506875344, 5.177633881694085, 5.177633881694085,
              5.101505075253763, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.087004350217511, 5.145007250362518,
              5.101505075253763, 5.177633881694085, 5.453147657382869,
              5.924421221061053, 5.73591179558978, 5.170383519175958,
              5.177633881694085, 5.2247612380619035, 5.177633881694085,
              5.576403820191009, 5.358892944647232, 6.627706385319266,
              5.177633881694085, 5.177633881694085, 5.123256162808141,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.174008700435022, 5.677908895444772, 5.2247612380619035,
              5.101505075253763, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.177633881694085, 5.54015200760038,
              5.177633881694085, 5.177633881694085, 5.358892944647232,
              5.177633881694085, 5.177633881694085, 5.2247612380619035,
              5.134131706585329, 5.246512325616281, 5.177633881694085,
              5.246512325616281, 5.123256162808141, 5.92079603980199,
              5.155882794139707, 5.105130256512826, 5.3806440322016105,
              5.373393669683484, 5.177633881694085, 5.177633881694085,
              5.177633881694085, 5.174008700435022, 5.373393669683484,
              5.177633881694085, 5.177633881694085, 5.902670133506676,
              5.105130256512826, 5.217510875543777, 5.177633881694085,
              5.177633881694085, 5.105130256512826, 5.123256162808141,
              5.177633881694085, 5.322641132056603, 5.177633881694085,
              5.2247612380619035, 5.2247612380619035, 5.177633881694085,
              5.1413820691034555, 5.083379168958448, 5.2138856942847145,
              5.2138856942847145, 5.612655632781639, 5.3806440322016105,
              5.177633881694085, 5.177633881694085, 5.177633881694085,
              5.605405270263513, 5.177633881694085, 5.409645482274113,
              5.928046402320116, 5.177633881694085, 5.177633881694085,
              5.358892944647232, 5.15950797539877, 5.177633881694085,
              5.358892944647232, 5.105130256512826, 5.177633881694085,
              5.177633881694085, 5.779413970698535, 5.148632431621581,
              5.170383519175958, 5.177633881694085, 5.1305065253262665,
              5.105130256512826, 5.123256162808141, 5.174008700435022,
              5.177633881694085, 6.808965448272414, 5.304515225761288,
              6.808965448272414, 5.0688784439221966, 5.192134606730336,
              5.358892944647232, 5.721411070553527, 5.721411070553527,
              5.177633881694085, 5.1196309815490775, 5.358892944647232,
              5.123256162808141, 5.358892944647232, 5.177633881694085,
              5.721411070553527, 5.177633881694085, 5.2138856942847145,
              5.105130256512826, 5.105130256512826, 5.449522476123806,
              5.721411070553527, 5.15950797539877, 5.15950797539877,
              5.177633881694085, 5.105130256512826, 5.812040602030102,
              5.087004350217511, 5.358892944647232, 5.358892944647232,
              5.304515225761288, 5.377018850942547, 6.446447322366119,
              5.358892944647232, 5.0688784439221966, 5.0688784439221966,
              5.177633881694085, 5.358892944647232, 5.105130256512826,
              5.177633881694085, 5.177633881694085, 5.087004350217511,
              5.630781539076954, 5.087004350217511, 5.358892944647232,
            ],
            subplot: 'mapbox',
            type: 'densitymapbox',
            opacity: 1,
            hoverlabel: { bgcolor: 'darkred', bordercolor: 'gold' },
          },
        ],
        {
          template: {
            data: {
              histogram2dcontour: [
                {
                  type: 'histogram2dcontour',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              choropleth: [
                {
                  type: 'choropleth',
                  colorbar: { outlinewidth: 0, ticks: '' },
                },
              ],
              histogram2d: [
                {
                  type: 'histogram2d',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              heatmap: [
                {
                  type: 'heatmap',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              heatmapgl: [
                {
                  type: 'heatmapgl',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              contourcarpet: [
                {
                  type: 'contourcarpet',
                  colorbar: { outlinewidth: 0, ticks: '' },
                },
              ],
              contour: [
                {
                  type: 'contour',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              surface: [
                {
                  type: 'surface',
                  colorbar: { outlinewidth: 0, ticks: '' },
                  colorscale: [
                    [0.0, '#0d0887'],
                    [0.1111111111111111, '#46039f'],
                    [0.2222222222222222, '#7201a8'],
                    [0.3333333333333333, '#9c179e'],
                    [0.4444444444444444, '#bd3786'],
                    [0.5555555555555556, '#d8576b'],
                    [0.6666666666666666, '#ed7953'],
                    [0.7777777777777778, '#fb9f3a'],
                    [0.8888888888888888, '#fdca26'],
                    [1.0, '#f0f921'],
                  ],
                },
              ],
              mesh3d: [
                { type: 'mesh3d', colorbar: { outlinewidth: 0, ticks: '' } },
              ],
              scatter: [
                {
                  fillpattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  type: 'scatter',
                },
              ],
              parcoords: [
                {
                  type: 'parcoords',
                  line: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scatterpolargl: [
                {
                  type: 'scatterpolargl',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              bar: [
                {
                  error_x: { color: '#2a3f5f' },
                  error_y: { color: '#2a3f5f' },
                  marker: {
                    line: { color: '#E5ECF6', width: 0.5 },
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'bar',
                },
              ],
              scattergeo: [
                {
                  type: 'scattergeo',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scatterpolar: [
                {
                  type: 'scatterpolar',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              histogram: [
                {
                  marker: {
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'histogram',
                },
              ],
              scattergl: [
                {
                  type: 'scattergl',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scatter3d: [
                {
                  type: 'scatter3d',
                  line: { colorbar: { outlinewidth: 0, ticks: '' } },
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scattermapbox: [
                {
                  type: 'scattermapbox',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scatterternary: [
                {
                  type: 'scatterternary',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              scattercarpet: [
                {
                  type: 'scattercarpet',
                  marker: { colorbar: { outlinewidth: 0, ticks: '' } },
                },
              ],
              carpet: [
                {
                  aaxis: {
                    endlinecolor: '#2a3f5f',
                    gridcolor: 'white',
                    linecolor: 'white',
                    minorgridcolor: 'white',
                    startlinecolor: '#2a3f5f',
                  },
                  baxis: {
                    endlinecolor: '#2a3f5f',
                    gridcolor: 'white',
                    linecolor: 'white',
                    minorgridcolor: 'white',
                    startlinecolor: '#2a3f5f',
                  },
                  type: 'carpet',
                },
              ],
              table: [
                {
                  cells: {
                    fill: { color: '#EBF0F8' },
                    line: { color: 'white' },
                  },
                  header: {
                    fill: { color: '#C8D4E3' },
                    line: { color: 'white' },
                  },
                  type: 'table',
                },
              ],
              barpolar: [
                {
                  marker: {
                    line: { color: '#E5ECF6', width: 0.5 },
                    pattern: { fillmode: 'overlay', size: 10, solidity: 0.2 },
                  },
                  type: 'barpolar',
                },
              ],
              pie: [{ automargin: true, type: 'pie' }],
            },
            layout: {
              autotypenumbers: 'strict',
              colorway: [
                '#636efa',
                '#EF553B',
                '#00cc96',
                '#ab63fa',
                '#FFA15A',
                '#19d3f3',
                '#FF6692',
                '#B6E880',
                '#FF97FF',
                '#FECB52',
              ],
              font: { color: '#2a3f5f' },
              hovermode: 'closest',
              hoverlabel: { align: 'left' },
              paper_bgcolor: 'white',
              plot_bgcolor: '#E5ECF6',
              polar: {
                bgcolor: '#E5ECF6',
                angularaxis: {
                  gridcolor: 'white',
                  linecolor: 'white',
                  ticks: '',
                },
                radialaxis: {
                  gridcolor: 'white',
                  linecolor: 'white',
                  ticks: '',
                },
              },
              ternary: {
                bgcolor: '#E5ECF6',
                aaxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
                baxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
                caxis: { gridcolor: 'white', linecolor: 'white', ticks: '' },
              },
              coloraxis: { colorbar: { outlinewidth: 0, ticks: '' } },
              colorscale: {
                sequential: [
                  [0.0, '#0d0887'],
                  [0.1111111111111111, '#46039f'],
                  [0.2222222222222222, '#7201a8'],
                  [0.3333333333333333, '#9c179e'],
                  [0.4444444444444444, '#bd3786'],
                  [0.5555555555555556, '#d8576b'],
                  [0.6666666666666666, '#ed7953'],
                  [0.7777777777777778, '#fb9f3a'],
                  [0.8888888888888888, '#fdca26'],
                  [1.0, '#f0f921'],
                ],
                sequentialminus: [
                  [0.0, '#0d0887'],
                  [0.1111111111111111, '#46039f'],
                  [0.2222222222222222, '#7201a8'],
                  [0.3333333333333333, '#9c179e'],
                  [0.4444444444444444, '#bd3786'],
                  [0.5555555555555556, '#d8576b'],
                  [0.6666666666666666, '#ed7953'],
                  [0.7777777777777778, '#fb9f3a'],
                  [0.8888888888888888, '#fdca26'],
                  [1.0, '#f0f921'],
                ],
                diverging: [
                  [0, '#8e0152'],
                  [0.1, '#c51b7d'],
                  [0.2, '#de77ae'],
                  [0.3, '#f1b6da'],
                  [0.4, '#fde0ef'],
                  [0.5, '#f7f7f7'],
                  [0.6, '#e6f5d0'],
                  [0.7, '#b8e186'],
                  [0.8, '#7fbc41'],
                  [0.9, '#4d9221'],
                  [1, '#276419'],
                ],
              },
              xaxis: {
                gridcolor: 'white',
                linecolor: 'white',
                ticks: '',
                title: { standoff: 15 },
                zerolinecolor: 'white',
                automargin: true,
                zerolinewidth: 2,
              },
              yaxis: {
                gridcolor: 'white',
                linecolor: 'white',
                ticks: '',
                title: { standoff: 15 },
                zerolinecolor: 'white',
                automargin: true,
                zerolinewidth: 2,
              },
              scene: {
                xaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                  gridwidth: 2,
                },
                yaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                  gridwidth: 2,
                },
                zaxis: {
                  backgroundcolor: '#E5ECF6',
                  gridcolor: 'white',
                  linecolor: 'white',
                  showbackground: true,
                  ticks: '',
                  zerolinecolor: 'white',
                  gridwidth: 2,
                },
              },
              shapedefaults: { line: { color: '#2a3f5f' } },
              annotationdefaults: {
                arrowcolor: '#2a3f5f',
                arrowhead: 0,
                arrowwidth: 1,
              },
              geo: {
                bgcolor: 'white',
                landcolor: '#E5ECF6',
                subunitcolor: 'white',
                showland: true,
                showlakes: true,
                lakecolor: 'white',
              },
              title: { x: 0.05 },
              mapbox: { style: 'light' },
            },
          },
          mapbox: {
            domain: { x: [0.0, 1.0], y: [0.0, 1.0] },
            center: { lat: 26.443932246417077, lon: 28.722986559087797 },
            zoom: 0.75,
            style: 'carto-darkmatter',
          },
          coloraxis: {
            colorscale: [
              [0.0, 'rgb(0,0,0)'],
              [0.3333333333333333, 'rgb(230,0,0)'],
              [0.6666666666666666, 'rgb(255,210,0)'],
              [1.0, 'rgb(255,255,255)'],
            ],
          },
          legend: { tracegroupgap: 0, title: { font: { size: 22 } } },
          margin: { t: 60 },
          height: 675,
          // width: 1000,
          title: { text: 'Global Energy Output', font: { size: 32 } },
        },
        { responsive: true },
      )
    }
  }, [])
  return (
    <div
      id='ddb7bfd3-dc2d-4842-be76-1982c0703c4d'
      className='plotly-graph-div'
      style={{ height: '675px', width: '100%' }}
    ></div>
  )
}
